/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots.externalapi || ($protobuf.roots.externalapi = {});

export const api = $root.api = (() => {

    /**
     * Namespace api.
     * @exports api
     * @namespace
     */
    const api = {};

    api.external = (function() {

        /**
         * Namespace external.
         * @memberof api
         * @namespace
         */
        const external = {};

        external.CreateLeadRequestBody = (function() {

            /**
             * Properties of a CreateLeadRequestBody.
             * @memberof api.external
             * @interface ICreateLeadRequestBody
             * @property {string|null} [first_name] CreateLeadRequestBody first_name
             * @property {string|null} [last_name] CreateLeadRequestBody last_name
             * @property {string|null} [phone_number] CreateLeadRequestBody phone_number
             * @property {string|null} [email_address] CreateLeadRequestBody email_address
             * @property {string|null} [fingerprint] CreateLeadRequestBody fingerprint
             * @property {string|null} [source] CreateLeadRequestBody source
             * @property {Product.Enum|null} [product_intent] CreateLeadRequestBody product_intent
             * @property {string|null} [campaign] CreateLeadRequestBody campaign
             */

            /**
             * Constructs a new CreateLeadRequestBody.
             * @memberof api.external
             * @classdesc Represents a CreateLeadRequestBody.
             * @implements ICreateLeadRequestBody
             * @constructor
             * @param {api.external.ICreateLeadRequestBody=} [properties] Properties to set
             */
            function CreateLeadRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateLeadRequestBody first_name.
             * @member {string} first_name
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             */
            CreateLeadRequestBody.prototype.first_name = "";

            /**
             * CreateLeadRequestBody last_name.
             * @member {string} last_name
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             */
            CreateLeadRequestBody.prototype.last_name = "";

            /**
             * CreateLeadRequestBody phone_number.
             * @member {string} phone_number
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             */
            CreateLeadRequestBody.prototype.phone_number = "";

            /**
             * CreateLeadRequestBody email_address.
             * @member {string} email_address
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             */
            CreateLeadRequestBody.prototype.email_address = "";

            /**
             * CreateLeadRequestBody fingerprint.
             * @member {string} fingerprint
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             */
            CreateLeadRequestBody.prototype.fingerprint = "";

            /**
             * CreateLeadRequestBody source.
             * @member {string} source
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             */
            CreateLeadRequestBody.prototype.source = "";

            /**
             * CreateLeadRequestBody product_intent.
             * @member {Product.Enum} product_intent
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             */
            CreateLeadRequestBody.prototype.product_intent = 0;

            /**
             * CreateLeadRequestBody campaign.
             * @member {string} campaign
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             */
            CreateLeadRequestBody.prototype.campaign = "";

            /**
             * Creates a new CreateLeadRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateLeadRequestBody
             * @static
             * @param {api.external.ICreateLeadRequestBody=} [properties] Properties to set
             * @returns {api.external.CreateLeadRequestBody} CreateLeadRequestBody instance
             */
            CreateLeadRequestBody.create = function create(properties) {
                return new CreateLeadRequestBody(properties);
            };

            /**
             * Encodes the specified CreateLeadRequestBody message. Does not implicitly {@link api.external.CreateLeadRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateLeadRequestBody
             * @static
             * @param {api.external.ICreateLeadRequestBody} message CreateLeadRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateLeadRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.first_name != null && message.hasOwnProperty("first_name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.first_name);
                if (message.last_name != null && message.hasOwnProperty("last_name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.last_name);
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.phone_number);
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.email_address);
                if (message.fingerprint != null && message.hasOwnProperty("fingerprint"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.fingerprint);
                if (message.source != null && message.hasOwnProperty("source"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.source);
                if (message.product_intent != null && message.hasOwnProperty("product_intent"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.product_intent);
                if (message.campaign != null && message.hasOwnProperty("campaign"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.campaign);
                return writer;
            };

            /**
             * Encodes the specified CreateLeadRequestBody message, length delimited. Does not implicitly {@link api.external.CreateLeadRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateLeadRequestBody
             * @static
             * @param {api.external.ICreateLeadRequestBody} message CreateLeadRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateLeadRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateLeadRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateLeadRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateLeadRequestBody} CreateLeadRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateLeadRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateLeadRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.first_name = reader.string();
                        break;
                    case 2:
                        message.last_name = reader.string();
                        break;
                    case 3:
                        message.phone_number = reader.string();
                        break;
                    case 4:
                        message.email_address = reader.string();
                        break;
                    case 5:
                        message.fingerprint = reader.string();
                        break;
                    case 6:
                        message.source = reader.string();
                        break;
                    case 7:
                        message.product_intent = reader.int32();
                        break;
                    case 8:
                        message.campaign = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateLeadRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateLeadRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateLeadRequestBody} CreateLeadRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateLeadRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateLeadRequestBody message.
             * @function verify
             * @memberof api.external.CreateLeadRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateLeadRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.first_name != null && message.hasOwnProperty("first_name"))
                    if (!$util.isString(message.first_name))
                        return "first_name: string expected";
                if (message.last_name != null && message.hasOwnProperty("last_name"))
                    if (!$util.isString(message.last_name))
                        return "last_name: string expected";
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    if (!$util.isString(message.phone_number))
                        return "phone_number: string expected";
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    if (!$util.isString(message.email_address))
                        return "email_address: string expected";
                if (message.fingerprint != null && message.hasOwnProperty("fingerprint"))
                    if (!$util.isString(message.fingerprint))
                        return "fingerprint: string expected";
                if (message.source != null && message.hasOwnProperty("source"))
                    if (!$util.isString(message.source))
                        return "source: string expected";
                if (message.product_intent != null && message.hasOwnProperty("product_intent"))
                    switch (message.product_intent) {
                    default:
                        return "product_intent: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.campaign != null && message.hasOwnProperty("campaign"))
                    if (!$util.isString(message.campaign))
                        return "campaign: string expected";
                return null;
            };

            /**
             * Creates a CreateLeadRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateLeadRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateLeadRequestBody} CreateLeadRequestBody
             */
            CreateLeadRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateLeadRequestBody)
                    return object;
                let message = new $root.api.external.CreateLeadRequestBody();
                if (object.first_name != null)
                    message.first_name = String(object.first_name);
                if (object.last_name != null)
                    message.last_name = String(object.last_name);
                if (object.phone_number != null)
                    message.phone_number = String(object.phone_number);
                if (object.email_address != null)
                    message.email_address = String(object.email_address);
                if (object.fingerprint != null)
                    message.fingerprint = String(object.fingerprint);
                if (object.source != null)
                    message.source = String(object.source);
                switch (object.product_intent) {
                case "UNKNOWN":
                case 0:
                    message.product_intent = 0;
                    break;
                case "SUPER":
                case 1:
                    message.product_intent = 1;
                    break;
                case "VOYAGER":
                case 2:
                    message.product_intent = 2;
                    break;
                case "NOVA":
                case 3:
                    message.product_intent = 3;
                    break;
                }
                if (object.campaign != null)
                    message.campaign = String(object.campaign);
                return message;
            };

            /**
             * Creates a plain object from a CreateLeadRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateLeadRequestBody
             * @static
             * @param {api.external.CreateLeadRequestBody} message CreateLeadRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateLeadRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.first_name = "";
                    object.last_name = "";
                    object.phone_number = "";
                    object.email_address = "";
                    object.fingerprint = "";
                    object.source = "";
                    object.product_intent = options.enums === String ? "UNKNOWN" : 0;
                    object.campaign = "";
                }
                if (message.first_name != null && message.hasOwnProperty("first_name"))
                    object.first_name = message.first_name;
                if (message.last_name != null && message.hasOwnProperty("last_name"))
                    object.last_name = message.last_name;
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    object.phone_number = message.phone_number;
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    object.email_address = message.email_address;
                if (message.fingerprint != null && message.hasOwnProperty("fingerprint"))
                    object.fingerprint = message.fingerprint;
                if (message.source != null && message.hasOwnProperty("source"))
                    object.source = message.source;
                if (message.product_intent != null && message.hasOwnProperty("product_intent"))
                    object.product_intent = options.enums === String ? $root.Product.Enum[message.product_intent] : message.product_intent;
                if (message.campaign != null && message.hasOwnProperty("campaign"))
                    object.campaign = message.campaign;
                return object;
            };

            /**
             * Converts this CreateLeadRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateLeadRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateLeadRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateLeadRequestBody;
        })();

        external.CreateLeadResponseBody = (function() {

            /**
             * Properties of a CreateLeadResponseBody.
             * @memberof api.external
             * @interface ICreateLeadResponseBody
             * @property {string|null} [contact_id] CreateLeadResponseBody contact_id
             */

            /**
             * Constructs a new CreateLeadResponseBody.
             * @memberof api.external
             * @classdesc Represents a CreateLeadResponseBody.
             * @implements ICreateLeadResponseBody
             * @constructor
             * @param {api.external.ICreateLeadResponseBody=} [properties] Properties to set
             */
            function CreateLeadResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateLeadResponseBody contact_id.
             * @member {string} contact_id
             * @memberof api.external.CreateLeadResponseBody
             * @instance
             */
            CreateLeadResponseBody.prototype.contact_id = "";

            /**
             * Creates a new CreateLeadResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateLeadResponseBody
             * @static
             * @param {api.external.ICreateLeadResponseBody=} [properties] Properties to set
             * @returns {api.external.CreateLeadResponseBody} CreateLeadResponseBody instance
             */
            CreateLeadResponseBody.create = function create(properties) {
                return new CreateLeadResponseBody(properties);
            };

            /**
             * Encodes the specified CreateLeadResponseBody message. Does not implicitly {@link api.external.CreateLeadResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateLeadResponseBody
             * @static
             * @param {api.external.ICreateLeadResponseBody} message CreateLeadResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateLeadResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.contact_id);
                return writer;
            };

            /**
             * Encodes the specified CreateLeadResponseBody message, length delimited. Does not implicitly {@link api.external.CreateLeadResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateLeadResponseBody
             * @static
             * @param {api.external.ICreateLeadResponseBody} message CreateLeadResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateLeadResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateLeadResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateLeadResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateLeadResponseBody} CreateLeadResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateLeadResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateLeadResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.contact_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateLeadResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateLeadResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateLeadResponseBody} CreateLeadResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateLeadResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateLeadResponseBody message.
             * @function verify
             * @memberof api.external.CreateLeadResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateLeadResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    if (!$util.isString(message.contact_id))
                        return "contact_id: string expected";
                return null;
            };

            /**
             * Creates a CreateLeadResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateLeadResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateLeadResponseBody} CreateLeadResponseBody
             */
            CreateLeadResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateLeadResponseBody)
                    return object;
                let message = new $root.api.external.CreateLeadResponseBody();
                if (object.contact_id != null)
                    message.contact_id = String(object.contact_id);
                return message;
            };

            /**
             * Creates a plain object from a CreateLeadResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateLeadResponseBody
             * @static
             * @param {api.external.CreateLeadResponseBody} message CreateLeadResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateLeadResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.contact_id = "";
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    object.contact_id = message.contact_id;
                return object;
            };

            /**
             * Converts this CreateLeadResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateLeadResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateLeadResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateLeadResponseBody;
        })();

        external.UpdateLeadRequestBody = (function() {

            /**
             * Properties of an UpdateLeadRequestBody.
             * @memberof api.external
             * @interface IUpdateLeadRequestBody
             * @property {string|null} [contact_id] UpdateLeadRequestBody contact_id
             * @property {string|null} [first_name] UpdateLeadRequestBody first_name
             * @property {string|null} [last_name] UpdateLeadRequestBody last_name
             * @property {string|null} [phone_number] UpdateLeadRequestBody phone_number
             * @property {string|null} [email_address] UpdateLeadRequestBody email_address
             * @property {string|null} [date_of_birth] UpdateLeadRequestBody date_of_birth
             * @property {IAddress|null} [address] UpdateLeadRequestBody address
             * @property {Product.Enum|null} [product_intent] UpdateLeadRequestBody product_intent
             * @property {string|null} [campaign] UpdateLeadRequestBody campaign
             */

            /**
             * Constructs a new UpdateLeadRequestBody.
             * @memberof api.external
             * @classdesc Represents an UpdateLeadRequestBody.
             * @implements IUpdateLeadRequestBody
             * @constructor
             * @param {api.external.IUpdateLeadRequestBody=} [properties] Properties to set
             */
            function UpdateLeadRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdateLeadRequestBody contact_id.
             * @member {string} contact_id
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.contact_id = "";

            /**
             * UpdateLeadRequestBody first_name.
             * @member {string} first_name
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.first_name = "";

            /**
             * UpdateLeadRequestBody last_name.
             * @member {string} last_name
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.last_name = "";

            /**
             * UpdateLeadRequestBody phone_number.
             * @member {string} phone_number
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.phone_number = "";

            /**
             * UpdateLeadRequestBody email_address.
             * @member {string} email_address
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.email_address = "";

            /**
             * UpdateLeadRequestBody date_of_birth.
             * @member {string} date_of_birth
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.date_of_birth = "";

            /**
             * UpdateLeadRequestBody address.
             * @member {IAddress|null|undefined} address
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.address = null;

            /**
             * UpdateLeadRequestBody product_intent.
             * @member {Product.Enum} product_intent
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.product_intent = 0;

            /**
             * UpdateLeadRequestBody campaign.
             * @member {string} campaign
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             */
            UpdateLeadRequestBody.prototype.campaign = "";

            /**
             * Creates a new UpdateLeadRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateLeadRequestBody
             * @static
             * @param {api.external.IUpdateLeadRequestBody=} [properties] Properties to set
             * @returns {api.external.UpdateLeadRequestBody} UpdateLeadRequestBody instance
             */
            UpdateLeadRequestBody.create = function create(properties) {
                return new UpdateLeadRequestBody(properties);
            };

            /**
             * Encodes the specified UpdateLeadRequestBody message. Does not implicitly {@link api.external.UpdateLeadRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateLeadRequestBody
             * @static
             * @param {api.external.IUpdateLeadRequestBody} message UpdateLeadRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateLeadRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.contact_id);
                if (message.first_name != null && message.hasOwnProperty("first_name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.first_name);
                if (message.last_name != null && message.hasOwnProperty("last_name"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.last_name);
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.phone_number);
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.email_address);
                if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.date_of_birth);
                if (message.address != null && message.hasOwnProperty("address"))
                    $root.Address.encode(message.address, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.product_intent != null && message.hasOwnProperty("product_intent"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.product_intent);
                if (message.campaign != null && message.hasOwnProperty("campaign"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.campaign);
                return writer;
            };

            /**
             * Encodes the specified UpdateLeadRequestBody message, length delimited. Does not implicitly {@link api.external.UpdateLeadRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateLeadRequestBody
             * @static
             * @param {api.external.IUpdateLeadRequestBody} message UpdateLeadRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateLeadRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateLeadRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateLeadRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateLeadRequestBody} UpdateLeadRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateLeadRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateLeadRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.contact_id = reader.string();
                        break;
                    case 2:
                        message.first_name = reader.string();
                        break;
                    case 3:
                        message.last_name = reader.string();
                        break;
                    case 4:
                        message.phone_number = reader.string();
                        break;
                    case 5:
                        message.email_address = reader.string();
                        break;
                    case 6:
                        message.date_of_birth = reader.string();
                        break;
                    case 7:
                        message.address = $root.Address.decode(reader, reader.uint32());
                        break;
                    case 8:
                        message.product_intent = reader.int32();
                        break;
                    case 9:
                        message.campaign = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateLeadRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateLeadRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateLeadRequestBody} UpdateLeadRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateLeadRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateLeadRequestBody message.
             * @function verify
             * @memberof api.external.UpdateLeadRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateLeadRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    if (!$util.isString(message.contact_id))
                        return "contact_id: string expected";
                if (message.first_name != null && message.hasOwnProperty("first_name"))
                    if (!$util.isString(message.first_name))
                        return "first_name: string expected";
                if (message.last_name != null && message.hasOwnProperty("last_name"))
                    if (!$util.isString(message.last_name))
                        return "last_name: string expected";
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    if (!$util.isString(message.phone_number))
                        return "phone_number: string expected";
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    if (!$util.isString(message.email_address))
                        return "email_address: string expected";
                if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
                    if (!$util.isString(message.date_of_birth))
                        return "date_of_birth: string expected";
                if (message.address != null && message.hasOwnProperty("address")) {
                    let error = $root.Address.verify(message.address);
                    if (error)
                        return "address." + error;
                }
                if (message.product_intent != null && message.hasOwnProperty("product_intent"))
                    switch (message.product_intent) {
                    default:
                        return "product_intent: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.campaign != null && message.hasOwnProperty("campaign"))
                    if (!$util.isString(message.campaign))
                        return "campaign: string expected";
                return null;
            };

            /**
             * Creates an UpdateLeadRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateLeadRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateLeadRequestBody} UpdateLeadRequestBody
             */
            UpdateLeadRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateLeadRequestBody)
                    return object;
                let message = new $root.api.external.UpdateLeadRequestBody();
                if (object.contact_id != null)
                    message.contact_id = String(object.contact_id);
                if (object.first_name != null)
                    message.first_name = String(object.first_name);
                if (object.last_name != null)
                    message.last_name = String(object.last_name);
                if (object.phone_number != null)
                    message.phone_number = String(object.phone_number);
                if (object.email_address != null)
                    message.email_address = String(object.email_address);
                if (object.date_of_birth != null)
                    message.date_of_birth = String(object.date_of_birth);
                if (object.address != null) {
                    if (typeof object.address !== "object")
                        throw TypeError(".api.external.UpdateLeadRequestBody.address: object expected");
                    message.address = $root.Address.fromObject(object.address);
                }
                switch (object.product_intent) {
                case "UNKNOWN":
                case 0:
                    message.product_intent = 0;
                    break;
                case "SUPER":
                case 1:
                    message.product_intent = 1;
                    break;
                case "VOYAGER":
                case 2:
                    message.product_intent = 2;
                    break;
                case "NOVA":
                case 3:
                    message.product_intent = 3;
                    break;
                }
                if (object.campaign != null)
                    message.campaign = String(object.campaign);
                return message;
            };

            /**
             * Creates a plain object from an UpdateLeadRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateLeadRequestBody
             * @static
             * @param {api.external.UpdateLeadRequestBody} message UpdateLeadRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateLeadRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.contact_id = "";
                    object.first_name = "";
                    object.last_name = "";
                    object.phone_number = "";
                    object.email_address = "";
                    object.date_of_birth = "";
                    object.address = null;
                    object.product_intent = options.enums === String ? "UNKNOWN" : 0;
                    object.campaign = "";
                }
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    object.contact_id = message.contact_id;
                if (message.first_name != null && message.hasOwnProperty("first_name"))
                    object.first_name = message.first_name;
                if (message.last_name != null && message.hasOwnProperty("last_name"))
                    object.last_name = message.last_name;
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    object.phone_number = message.phone_number;
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    object.email_address = message.email_address;
                if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
                    object.date_of_birth = message.date_of_birth;
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = $root.Address.toObject(message.address, options);
                if (message.product_intent != null && message.hasOwnProperty("product_intent"))
                    object.product_intent = options.enums === String ? $root.Product.Enum[message.product_intent] : message.product_intent;
                if (message.campaign != null && message.hasOwnProperty("campaign"))
                    object.campaign = message.campaign;
                return object;
            };

            /**
             * Converts this UpdateLeadRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateLeadRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateLeadRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateLeadRequestBody;
        })();

        external.UpdateLeadResponseBody = (function() {

            /**
             * Properties of an UpdateLeadResponseBody.
             * @memberof api.external
             * @interface IUpdateLeadResponseBody
             */

            /**
             * Constructs a new UpdateLeadResponseBody.
             * @memberof api.external
             * @classdesc Represents an UpdateLeadResponseBody.
             * @implements IUpdateLeadResponseBody
             * @constructor
             * @param {api.external.IUpdateLeadResponseBody=} [properties] Properties to set
             */
            function UpdateLeadResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateLeadResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateLeadResponseBody
             * @static
             * @param {api.external.IUpdateLeadResponseBody=} [properties] Properties to set
             * @returns {api.external.UpdateLeadResponseBody} UpdateLeadResponseBody instance
             */
            UpdateLeadResponseBody.create = function create(properties) {
                return new UpdateLeadResponseBody(properties);
            };

            /**
             * Encodes the specified UpdateLeadResponseBody message. Does not implicitly {@link api.external.UpdateLeadResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateLeadResponseBody
             * @static
             * @param {api.external.IUpdateLeadResponseBody} message UpdateLeadResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateLeadResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateLeadResponseBody message, length delimited. Does not implicitly {@link api.external.UpdateLeadResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateLeadResponseBody
             * @static
             * @param {api.external.IUpdateLeadResponseBody} message UpdateLeadResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateLeadResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateLeadResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateLeadResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateLeadResponseBody} UpdateLeadResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateLeadResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateLeadResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateLeadResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateLeadResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateLeadResponseBody} UpdateLeadResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateLeadResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateLeadResponseBody message.
             * @function verify
             * @memberof api.external.UpdateLeadResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateLeadResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateLeadResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateLeadResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateLeadResponseBody} UpdateLeadResponseBody
             */
            UpdateLeadResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateLeadResponseBody)
                    return object;
                return new $root.api.external.UpdateLeadResponseBody();
            };

            /**
             * Creates a plain object from an UpdateLeadResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateLeadResponseBody
             * @static
             * @param {api.external.UpdateLeadResponseBody} message UpdateLeadResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateLeadResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateLeadResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateLeadResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateLeadResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateLeadResponseBody;
        })();

        external.LoginRequestBody = (function() {

            /**
             * Properties of a LoginRequestBody.
             * @memberof api.external
             * @interface ILoginRequestBody
             */

            /**
             * Constructs a new LoginRequestBody.
             * @memberof api.external
             * @classdesc Represents a LoginRequestBody.
             * @implements ILoginRequestBody
             * @constructor
             * @param {api.external.ILoginRequestBody=} [properties] Properties to set
             */
            function LoginRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new LoginRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.LoginRequestBody
             * @static
             * @param {api.external.ILoginRequestBody=} [properties] Properties to set
             * @returns {api.external.LoginRequestBody} LoginRequestBody instance
             */
            LoginRequestBody.create = function create(properties) {
                return new LoginRequestBody(properties);
            };

            /**
             * Encodes the specified LoginRequestBody message. Does not implicitly {@link api.external.LoginRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.LoginRequestBody
             * @static
             * @param {api.external.ILoginRequestBody} message LoginRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LoginRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified LoginRequestBody message, length delimited. Does not implicitly {@link api.external.LoginRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.LoginRequestBody
             * @static
             * @param {api.external.ILoginRequestBody} message LoginRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LoginRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LoginRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.LoginRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.LoginRequestBody} LoginRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LoginRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.LoginRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LoginRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.LoginRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.LoginRequestBody} LoginRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LoginRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LoginRequestBody message.
             * @function verify
             * @memberof api.external.LoginRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LoginRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a LoginRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.LoginRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.LoginRequestBody} LoginRequestBody
             */
            LoginRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.LoginRequestBody)
                    return object;
                return new $root.api.external.LoginRequestBody();
            };

            /**
             * Creates a plain object from a LoginRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.LoginRequestBody
             * @static
             * @param {api.external.LoginRequestBody} message LoginRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LoginRequestBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this LoginRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.LoginRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LoginRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LoginRequestBody;
        })();

        external.LoginResponseBody = (function() {

            /**
             * Properties of a LoginResponseBody.
             * @memberof api.external
             * @interface ILoginResponseBody
             * @property {IAuth|null} [auth] LoginResponseBody auth
             * @property {IIntercomHashes|null} [intercom_hashes] LoginResponseBody intercom_hashes
             */

            /**
             * Constructs a new LoginResponseBody.
             * @memberof api.external
             * @classdesc Represents a LoginResponseBody.
             * @implements ILoginResponseBody
             * @constructor
             * @param {api.external.ILoginResponseBody=} [properties] Properties to set
             */
            function LoginResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LoginResponseBody auth.
             * @member {IAuth|null|undefined} auth
             * @memberof api.external.LoginResponseBody
             * @instance
             */
            LoginResponseBody.prototype.auth = null;

            /**
             * LoginResponseBody intercom_hashes.
             * @member {IIntercomHashes|null|undefined} intercom_hashes
             * @memberof api.external.LoginResponseBody
             * @instance
             */
            LoginResponseBody.prototype.intercom_hashes = null;

            /**
             * Creates a new LoginResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.LoginResponseBody
             * @static
             * @param {api.external.ILoginResponseBody=} [properties] Properties to set
             * @returns {api.external.LoginResponseBody} LoginResponseBody instance
             */
            LoginResponseBody.create = function create(properties) {
                return new LoginResponseBody(properties);
            };

            /**
             * Encodes the specified LoginResponseBody message. Does not implicitly {@link api.external.LoginResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.LoginResponseBody
             * @static
             * @param {api.external.ILoginResponseBody} message LoginResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LoginResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.auth != null && message.hasOwnProperty("auth"))
                    $root.Auth.encode(message.auth, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.intercom_hashes != null && message.hasOwnProperty("intercom_hashes"))
                    $root.IntercomHashes.encode(message.intercom_hashes, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LoginResponseBody message, length delimited. Does not implicitly {@link api.external.LoginResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.LoginResponseBody
             * @static
             * @param {api.external.ILoginResponseBody} message LoginResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LoginResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LoginResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.LoginResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.LoginResponseBody} LoginResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LoginResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.LoginResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.auth = $root.Auth.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.intercom_hashes = $root.IntercomHashes.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LoginResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.LoginResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.LoginResponseBody} LoginResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LoginResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LoginResponseBody message.
             * @function verify
             * @memberof api.external.LoginResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LoginResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.auth != null && message.hasOwnProperty("auth")) {
                    let error = $root.Auth.verify(message.auth);
                    if (error)
                        return "auth." + error;
                }
                if (message.intercom_hashes != null && message.hasOwnProperty("intercom_hashes")) {
                    let error = $root.IntercomHashes.verify(message.intercom_hashes);
                    if (error)
                        return "intercom_hashes." + error;
                }
                return null;
            };

            /**
             * Creates a LoginResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.LoginResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.LoginResponseBody} LoginResponseBody
             */
            LoginResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.LoginResponseBody)
                    return object;
                let message = new $root.api.external.LoginResponseBody();
                if (object.auth != null) {
                    if (typeof object.auth !== "object")
                        throw TypeError(".api.external.LoginResponseBody.auth: object expected");
                    message.auth = $root.Auth.fromObject(object.auth);
                }
                if (object.intercom_hashes != null) {
                    if (typeof object.intercom_hashes !== "object")
                        throw TypeError(".api.external.LoginResponseBody.intercom_hashes: object expected");
                    message.intercom_hashes = $root.IntercomHashes.fromObject(object.intercom_hashes);
                }
                return message;
            };

            /**
             * Creates a plain object from a LoginResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.LoginResponseBody
             * @static
             * @param {api.external.LoginResponseBody} message LoginResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LoginResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.auth = null;
                    object.intercom_hashes = null;
                }
                if (message.auth != null && message.hasOwnProperty("auth"))
                    object.auth = $root.Auth.toObject(message.auth, options);
                if (message.intercom_hashes != null && message.hasOwnProperty("intercom_hashes"))
                    object.intercom_hashes = $root.IntercomHashes.toObject(message.intercom_hashes, options);
                return object;
            };

            /**
             * Converts this LoginResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.LoginResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LoginResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LoginResponseBody;
        })();

        external.GetTokenRefreshResponseBody = (function() {

            /**
             * Properties of a GetTokenRefreshResponseBody.
             * @memberof api.external
             * @interface IGetTokenRefreshResponseBody
             * @property {IAuth|null} [auth] GetTokenRefreshResponseBody auth
             * @property {IIntercomHashes|null} [intercom_hashes] GetTokenRefreshResponseBody intercom_hashes
             */

            /**
             * Constructs a new GetTokenRefreshResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetTokenRefreshResponseBody.
             * @implements IGetTokenRefreshResponseBody
             * @constructor
             * @param {api.external.IGetTokenRefreshResponseBody=} [properties] Properties to set
             */
            function GetTokenRefreshResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTokenRefreshResponseBody auth.
             * @member {IAuth|null|undefined} auth
             * @memberof api.external.GetTokenRefreshResponseBody
             * @instance
             */
            GetTokenRefreshResponseBody.prototype.auth = null;

            /**
             * GetTokenRefreshResponseBody intercom_hashes.
             * @member {IIntercomHashes|null|undefined} intercom_hashes
             * @memberof api.external.GetTokenRefreshResponseBody
             * @instance
             */
            GetTokenRefreshResponseBody.prototype.intercom_hashes = null;

            /**
             * Creates a new GetTokenRefreshResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetTokenRefreshResponseBody
             * @static
             * @param {api.external.IGetTokenRefreshResponseBody=} [properties] Properties to set
             * @returns {api.external.GetTokenRefreshResponseBody} GetTokenRefreshResponseBody instance
             */
            GetTokenRefreshResponseBody.create = function create(properties) {
                return new GetTokenRefreshResponseBody(properties);
            };

            /**
             * Encodes the specified GetTokenRefreshResponseBody message. Does not implicitly {@link api.external.GetTokenRefreshResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetTokenRefreshResponseBody
             * @static
             * @param {api.external.IGetTokenRefreshResponseBody} message GetTokenRefreshResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTokenRefreshResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.auth != null && message.hasOwnProperty("auth"))
                    $root.Auth.encode(message.auth, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.intercom_hashes != null && message.hasOwnProperty("intercom_hashes"))
                    $root.IntercomHashes.encode(message.intercom_hashes, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetTokenRefreshResponseBody message, length delimited. Does not implicitly {@link api.external.GetTokenRefreshResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetTokenRefreshResponseBody
             * @static
             * @param {api.external.IGetTokenRefreshResponseBody} message GetTokenRefreshResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTokenRefreshResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTokenRefreshResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetTokenRefreshResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetTokenRefreshResponseBody} GetTokenRefreshResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTokenRefreshResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetTokenRefreshResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.auth = $root.Auth.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.intercom_hashes = $root.IntercomHashes.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTokenRefreshResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetTokenRefreshResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetTokenRefreshResponseBody} GetTokenRefreshResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTokenRefreshResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTokenRefreshResponseBody message.
             * @function verify
             * @memberof api.external.GetTokenRefreshResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTokenRefreshResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.auth != null && message.hasOwnProperty("auth")) {
                    let error = $root.Auth.verify(message.auth);
                    if (error)
                        return "auth." + error;
                }
                if (message.intercom_hashes != null && message.hasOwnProperty("intercom_hashes")) {
                    let error = $root.IntercomHashes.verify(message.intercom_hashes);
                    if (error)
                        return "intercom_hashes." + error;
                }
                return null;
            };

            /**
             * Creates a GetTokenRefreshResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetTokenRefreshResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetTokenRefreshResponseBody} GetTokenRefreshResponseBody
             */
            GetTokenRefreshResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetTokenRefreshResponseBody)
                    return object;
                let message = new $root.api.external.GetTokenRefreshResponseBody();
                if (object.auth != null) {
                    if (typeof object.auth !== "object")
                        throw TypeError(".api.external.GetTokenRefreshResponseBody.auth: object expected");
                    message.auth = $root.Auth.fromObject(object.auth);
                }
                if (object.intercom_hashes != null) {
                    if (typeof object.intercom_hashes !== "object")
                        throw TypeError(".api.external.GetTokenRefreshResponseBody.intercom_hashes: object expected");
                    message.intercom_hashes = $root.IntercomHashes.fromObject(object.intercom_hashes);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetTokenRefreshResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetTokenRefreshResponseBody
             * @static
             * @param {api.external.GetTokenRefreshResponseBody} message GetTokenRefreshResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTokenRefreshResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.auth = null;
                    object.intercom_hashes = null;
                }
                if (message.auth != null && message.hasOwnProperty("auth"))
                    object.auth = $root.Auth.toObject(message.auth, options);
                if (message.intercom_hashes != null && message.hasOwnProperty("intercom_hashes"))
                    object.intercom_hashes = $root.IntercomHashes.toObject(message.intercom_hashes, options);
                return object;
            };

            /**
             * Converts this GetTokenRefreshResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetTokenRefreshResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTokenRefreshResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTokenRefreshResponseBody;
        })();

        external.CreateUserRequestBody = (function() {

            /**
             * Properties of a CreateUserRequestBody.
             * @memberof api.external
             * @interface ICreateUserRequestBody
             * @property {string|null} [contact_id] CreateUserRequestBody contact_id
             * @property {string|null} [password] CreateUserRequestBody password
             */

            /**
             * Constructs a new CreateUserRequestBody.
             * @memberof api.external
             * @classdesc Represents a CreateUserRequestBody.
             * @implements ICreateUserRequestBody
             * @constructor
             * @param {api.external.ICreateUserRequestBody=} [properties] Properties to set
             */
            function CreateUserRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateUserRequestBody contact_id.
             * @member {string} contact_id
             * @memberof api.external.CreateUserRequestBody
             * @instance
             */
            CreateUserRequestBody.prototype.contact_id = "";

            /**
             * CreateUserRequestBody password.
             * @member {string} password
             * @memberof api.external.CreateUserRequestBody
             * @instance
             */
            CreateUserRequestBody.prototype.password = "";

            /**
             * Creates a new CreateUserRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateUserRequestBody
             * @static
             * @param {api.external.ICreateUserRequestBody=} [properties] Properties to set
             * @returns {api.external.CreateUserRequestBody} CreateUserRequestBody instance
             */
            CreateUserRequestBody.create = function create(properties) {
                return new CreateUserRequestBody(properties);
            };

            /**
             * Encodes the specified CreateUserRequestBody message. Does not implicitly {@link api.external.CreateUserRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateUserRequestBody
             * @static
             * @param {api.external.ICreateUserRequestBody} message CreateUserRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateUserRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.contact_id);
                if (message.password != null && message.hasOwnProperty("password"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
                return writer;
            };

            /**
             * Encodes the specified CreateUserRequestBody message, length delimited. Does not implicitly {@link api.external.CreateUserRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateUserRequestBody
             * @static
             * @param {api.external.ICreateUserRequestBody} message CreateUserRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateUserRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateUserRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateUserRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateUserRequestBody} CreateUserRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateUserRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateUserRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.contact_id = reader.string();
                        break;
                    case 2:
                        message.password = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateUserRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateUserRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateUserRequestBody} CreateUserRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateUserRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateUserRequestBody message.
             * @function verify
             * @memberof api.external.CreateUserRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateUserRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    if (!$util.isString(message.contact_id))
                        return "contact_id: string expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!$util.isString(message.password))
                        return "password: string expected";
                return null;
            };

            /**
             * Creates a CreateUserRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateUserRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateUserRequestBody} CreateUserRequestBody
             */
            CreateUserRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateUserRequestBody)
                    return object;
                let message = new $root.api.external.CreateUserRequestBody();
                if (object.contact_id != null)
                    message.contact_id = String(object.contact_id);
                if (object.password != null)
                    message.password = String(object.password);
                return message;
            };

            /**
             * Creates a plain object from a CreateUserRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateUserRequestBody
             * @static
             * @param {api.external.CreateUserRequestBody} message CreateUserRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateUserRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.contact_id = "";
                    object.password = "";
                }
                if (message.contact_id != null && message.hasOwnProperty("contact_id"))
                    object.contact_id = message.contact_id;
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = message.password;
                return object;
            };

            /**
             * Converts this CreateUserRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateUserRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateUserRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateUserRequestBody;
        })();

        external.CreateUserResponseBody = (function() {

            /**
             * Properties of a CreateUserResponseBody.
             * @memberof api.external
             * @interface ICreateUserResponseBody
             */

            /**
             * Constructs a new CreateUserResponseBody.
             * @memberof api.external
             * @classdesc Represents a CreateUserResponseBody.
             * @implements ICreateUserResponseBody
             * @constructor
             * @param {api.external.ICreateUserResponseBody=} [properties] Properties to set
             */
            function CreateUserResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateUserResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateUserResponseBody
             * @static
             * @param {api.external.ICreateUserResponseBody=} [properties] Properties to set
             * @returns {api.external.CreateUserResponseBody} CreateUserResponseBody instance
             */
            CreateUserResponseBody.create = function create(properties) {
                return new CreateUserResponseBody(properties);
            };

            /**
             * Encodes the specified CreateUserResponseBody message. Does not implicitly {@link api.external.CreateUserResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateUserResponseBody
             * @static
             * @param {api.external.ICreateUserResponseBody} message CreateUserResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateUserResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateUserResponseBody message, length delimited. Does not implicitly {@link api.external.CreateUserResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateUserResponseBody
             * @static
             * @param {api.external.ICreateUserResponseBody} message CreateUserResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateUserResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateUserResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateUserResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateUserResponseBody} CreateUserResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateUserResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateUserResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateUserResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateUserResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateUserResponseBody} CreateUserResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateUserResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateUserResponseBody message.
             * @function verify
             * @memberof api.external.CreateUserResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateUserResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateUserResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateUserResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateUserResponseBody} CreateUserResponseBody
             */
            CreateUserResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateUserResponseBody)
                    return object;
                return new $root.api.external.CreateUserResponseBody();
            };

            /**
             * Creates a plain object from a CreateUserResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateUserResponseBody
             * @static
             * @param {api.external.CreateUserResponseBody} message CreateUserResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateUserResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateUserResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateUserResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateUserResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateUserResponseBody;
        })();

        external.GetDocumentsByContactIdsRequestBody = (function() {

            /**
             * Properties of a GetDocumentsByContactIdsRequestBody.
             * @memberof api.external
             * @interface IGetDocumentsByContactIdsRequestBody
             * @property {Array.<string>|null} [contact_ids] GetDocumentsByContactIdsRequestBody contact_ids
             */

            /**
             * Constructs a new GetDocumentsByContactIdsRequestBody.
             * @memberof api.external
             * @classdesc Represents a GetDocumentsByContactIdsRequestBody.
             * @implements IGetDocumentsByContactIdsRequestBody
             * @constructor
             * @param {api.external.IGetDocumentsByContactIdsRequestBody=} [properties] Properties to set
             */
            function GetDocumentsByContactIdsRequestBody(properties) {
                this.contact_ids = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetDocumentsByContactIdsRequestBody contact_ids.
             * @member {Array.<string>} contact_ids
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @instance
             */
            GetDocumentsByContactIdsRequestBody.prototype.contact_ids = $util.emptyArray;

            /**
             * Creates a new GetDocumentsByContactIdsRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @static
             * @param {api.external.IGetDocumentsByContactIdsRequestBody=} [properties] Properties to set
             * @returns {api.external.GetDocumentsByContactIdsRequestBody} GetDocumentsByContactIdsRequestBody instance
             */
            GetDocumentsByContactIdsRequestBody.create = function create(properties) {
                return new GetDocumentsByContactIdsRequestBody(properties);
            };

            /**
             * Encodes the specified GetDocumentsByContactIdsRequestBody message. Does not implicitly {@link api.external.GetDocumentsByContactIdsRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @static
             * @param {api.external.IGetDocumentsByContactIdsRequestBody} message GetDocumentsByContactIdsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDocumentsByContactIdsRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contact_ids != null && message.contact_ids.length)
                    for (let i = 0; i < message.contact_ids.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.contact_ids[i]);
                return writer;
            };

            /**
             * Encodes the specified GetDocumentsByContactIdsRequestBody message, length delimited. Does not implicitly {@link api.external.GetDocumentsByContactIdsRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @static
             * @param {api.external.IGetDocumentsByContactIdsRequestBody} message GetDocumentsByContactIdsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDocumentsByContactIdsRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetDocumentsByContactIdsRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetDocumentsByContactIdsRequestBody} GetDocumentsByContactIdsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDocumentsByContactIdsRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetDocumentsByContactIdsRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.contact_ids && message.contact_ids.length))
                            message.contact_ids = [];
                        message.contact_ids.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetDocumentsByContactIdsRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetDocumentsByContactIdsRequestBody} GetDocumentsByContactIdsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDocumentsByContactIdsRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetDocumentsByContactIdsRequestBody message.
             * @function verify
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetDocumentsByContactIdsRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contact_ids != null && message.hasOwnProperty("contact_ids")) {
                    if (!Array.isArray(message.contact_ids))
                        return "contact_ids: array expected";
                    for (let i = 0; i < message.contact_ids.length; ++i)
                        if (!$util.isString(message.contact_ids[i]))
                            return "contact_ids: string[] expected";
                }
                return null;
            };

            /**
             * Creates a GetDocumentsByContactIdsRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetDocumentsByContactIdsRequestBody} GetDocumentsByContactIdsRequestBody
             */
            GetDocumentsByContactIdsRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetDocumentsByContactIdsRequestBody)
                    return object;
                let message = new $root.api.external.GetDocumentsByContactIdsRequestBody();
                if (object.contact_ids) {
                    if (!Array.isArray(object.contact_ids))
                        throw TypeError(".api.external.GetDocumentsByContactIdsRequestBody.contact_ids: array expected");
                    message.contact_ids = [];
                    for (let i = 0; i < object.contact_ids.length; ++i)
                        message.contact_ids[i] = String(object.contact_ids[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetDocumentsByContactIdsRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @static
             * @param {api.external.GetDocumentsByContactIdsRequestBody} message GetDocumentsByContactIdsRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetDocumentsByContactIdsRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.contact_ids = [];
                if (message.contact_ids && message.contact_ids.length) {
                    object.contact_ids = [];
                    for (let j = 0; j < message.contact_ids.length; ++j)
                        object.contact_ids[j] = message.contact_ids[j];
                }
                return object;
            };

            /**
             * Converts this GetDocumentsByContactIdsRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.GetDocumentsByContactIdsRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetDocumentsByContactIdsRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetDocumentsByContactIdsRequestBody;
        })();

        external.GetDocumentsByContactIdsResponseBody = (function() {

            /**
             * Properties of a GetDocumentsByContactIdsResponseBody.
             * @memberof api.external
             * @interface IGetDocumentsByContactIdsResponseBody
             * @property {Object.<string,IDocumentList>|null} [contact_id_to_documents] GetDocumentsByContactIdsResponseBody contact_id_to_documents
             */

            /**
             * Constructs a new GetDocumentsByContactIdsResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetDocumentsByContactIdsResponseBody.
             * @implements IGetDocumentsByContactIdsResponseBody
             * @constructor
             * @param {api.external.IGetDocumentsByContactIdsResponseBody=} [properties] Properties to set
             */
            function GetDocumentsByContactIdsResponseBody(properties) {
                this.contact_id_to_documents = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetDocumentsByContactIdsResponseBody contact_id_to_documents.
             * @member {Object.<string,IDocumentList>} contact_id_to_documents
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @instance
             */
            GetDocumentsByContactIdsResponseBody.prototype.contact_id_to_documents = $util.emptyObject;

            /**
             * Creates a new GetDocumentsByContactIdsResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @static
             * @param {api.external.IGetDocumentsByContactIdsResponseBody=} [properties] Properties to set
             * @returns {api.external.GetDocumentsByContactIdsResponseBody} GetDocumentsByContactIdsResponseBody instance
             */
            GetDocumentsByContactIdsResponseBody.create = function create(properties) {
                return new GetDocumentsByContactIdsResponseBody(properties);
            };

            /**
             * Encodes the specified GetDocumentsByContactIdsResponseBody message. Does not implicitly {@link api.external.GetDocumentsByContactIdsResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @static
             * @param {api.external.IGetDocumentsByContactIdsResponseBody} message GetDocumentsByContactIdsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDocumentsByContactIdsResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contact_id_to_documents != null && message.hasOwnProperty("contact_id_to_documents"))
                    for (let keys = Object.keys(message.contact_id_to_documents), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.DocumentList.encode(message.contact_id_to_documents[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified GetDocumentsByContactIdsResponseBody message, length delimited. Does not implicitly {@link api.external.GetDocumentsByContactIdsResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @static
             * @param {api.external.IGetDocumentsByContactIdsResponseBody} message GetDocumentsByContactIdsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDocumentsByContactIdsResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetDocumentsByContactIdsResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetDocumentsByContactIdsResponseBody} GetDocumentsByContactIdsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDocumentsByContactIdsResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetDocumentsByContactIdsResponseBody(), key;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        reader.skip().pos++;
                        if (message.contact_id_to_documents === $util.emptyObject)
                            message.contact_id_to_documents = {};
                        key = reader.string();
                        reader.pos++;
                        message.contact_id_to_documents[key] = $root.DocumentList.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetDocumentsByContactIdsResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetDocumentsByContactIdsResponseBody} GetDocumentsByContactIdsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDocumentsByContactIdsResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetDocumentsByContactIdsResponseBody message.
             * @function verify
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetDocumentsByContactIdsResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contact_id_to_documents != null && message.hasOwnProperty("contact_id_to_documents")) {
                    if (!$util.isObject(message.contact_id_to_documents))
                        return "contact_id_to_documents: object expected";
                    let key = Object.keys(message.contact_id_to_documents);
                    for (let i = 0; i < key.length; ++i) {
                        let error = $root.DocumentList.verify(message.contact_id_to_documents[key[i]]);
                        if (error)
                            return "contact_id_to_documents." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetDocumentsByContactIdsResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetDocumentsByContactIdsResponseBody} GetDocumentsByContactIdsResponseBody
             */
            GetDocumentsByContactIdsResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetDocumentsByContactIdsResponseBody)
                    return object;
                let message = new $root.api.external.GetDocumentsByContactIdsResponseBody();
                if (object.contact_id_to_documents) {
                    if (typeof object.contact_id_to_documents !== "object")
                        throw TypeError(".api.external.GetDocumentsByContactIdsResponseBody.contact_id_to_documents: object expected");
                    message.contact_id_to_documents = {};
                    for (let keys = Object.keys(object.contact_id_to_documents), i = 0; i < keys.length; ++i) {
                        if (typeof object.contact_id_to_documents[keys[i]] !== "object")
                            throw TypeError(".api.external.GetDocumentsByContactIdsResponseBody.contact_id_to_documents: object expected");
                        message.contact_id_to_documents[keys[i]] = $root.DocumentList.fromObject(object.contact_id_to_documents[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetDocumentsByContactIdsResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @static
             * @param {api.external.GetDocumentsByContactIdsResponseBody} message GetDocumentsByContactIdsResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetDocumentsByContactIdsResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.objects || options.defaults)
                    object.contact_id_to_documents = {};
                let keys2;
                if (message.contact_id_to_documents && (keys2 = Object.keys(message.contact_id_to_documents)).length) {
                    object.contact_id_to_documents = {};
                    for (let j = 0; j < keys2.length; ++j)
                        object.contact_id_to_documents[keys2[j]] = $root.DocumentList.toObject(message.contact_id_to_documents[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this GetDocumentsByContactIdsResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetDocumentsByContactIdsResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetDocumentsByContactIdsResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetDocumentsByContactIdsResponseBody;
        })();

        external.ResendDocumentRequestBody = (function() {

            /**
             * Properties of a ResendDocumentRequestBody.
             * @memberof api.external
             * @interface IResendDocumentRequestBody
             * @property {string|null} [document_id] ResendDocumentRequestBody document_id
             */

            /**
             * Constructs a new ResendDocumentRequestBody.
             * @memberof api.external
             * @classdesc Represents a ResendDocumentRequestBody.
             * @implements IResendDocumentRequestBody
             * @constructor
             * @param {api.external.IResendDocumentRequestBody=} [properties] Properties to set
             */
            function ResendDocumentRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ResendDocumentRequestBody document_id.
             * @member {string} document_id
             * @memberof api.external.ResendDocumentRequestBody
             * @instance
             */
            ResendDocumentRequestBody.prototype.document_id = "";

            /**
             * Creates a new ResendDocumentRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.ResendDocumentRequestBody
             * @static
             * @param {api.external.IResendDocumentRequestBody=} [properties] Properties to set
             * @returns {api.external.ResendDocumentRequestBody} ResendDocumentRequestBody instance
             */
            ResendDocumentRequestBody.create = function create(properties) {
                return new ResendDocumentRequestBody(properties);
            };

            /**
             * Encodes the specified ResendDocumentRequestBody message. Does not implicitly {@link api.external.ResendDocumentRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.ResendDocumentRequestBody
             * @static
             * @param {api.external.IResendDocumentRequestBody} message ResendDocumentRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResendDocumentRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.document_id != null && message.hasOwnProperty("document_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.document_id);
                return writer;
            };

            /**
             * Encodes the specified ResendDocumentRequestBody message, length delimited. Does not implicitly {@link api.external.ResendDocumentRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.ResendDocumentRequestBody
             * @static
             * @param {api.external.IResendDocumentRequestBody} message ResendDocumentRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResendDocumentRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ResendDocumentRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.ResendDocumentRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.ResendDocumentRequestBody} ResendDocumentRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResendDocumentRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.ResendDocumentRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.document_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ResendDocumentRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.ResendDocumentRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.ResendDocumentRequestBody} ResendDocumentRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResendDocumentRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ResendDocumentRequestBody message.
             * @function verify
             * @memberof api.external.ResendDocumentRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ResendDocumentRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.document_id != null && message.hasOwnProperty("document_id"))
                    if (!$util.isString(message.document_id))
                        return "document_id: string expected";
                return null;
            };

            /**
             * Creates a ResendDocumentRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.ResendDocumentRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.ResendDocumentRequestBody} ResendDocumentRequestBody
             */
            ResendDocumentRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.ResendDocumentRequestBody)
                    return object;
                let message = new $root.api.external.ResendDocumentRequestBody();
                if (object.document_id != null)
                    message.document_id = String(object.document_id);
                return message;
            };

            /**
             * Creates a plain object from a ResendDocumentRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.ResendDocumentRequestBody
             * @static
             * @param {api.external.ResendDocumentRequestBody} message ResendDocumentRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ResendDocumentRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.document_id = "";
                if (message.document_id != null && message.hasOwnProperty("document_id"))
                    object.document_id = message.document_id;
                return object;
            };

            /**
             * Converts this ResendDocumentRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.ResendDocumentRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ResendDocumentRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ResendDocumentRequestBody;
        })();

        external.ResendDocumentResponseBody = (function() {

            /**
             * Properties of a ResendDocumentResponseBody.
             * @memberof api.external
             * @interface IResendDocumentResponseBody
             */

            /**
             * Constructs a new ResendDocumentResponseBody.
             * @memberof api.external
             * @classdesc Represents a ResendDocumentResponseBody.
             * @implements IResendDocumentResponseBody
             * @constructor
             * @param {api.external.IResendDocumentResponseBody=} [properties] Properties to set
             */
            function ResendDocumentResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ResendDocumentResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.ResendDocumentResponseBody
             * @static
             * @param {api.external.IResendDocumentResponseBody=} [properties] Properties to set
             * @returns {api.external.ResendDocumentResponseBody} ResendDocumentResponseBody instance
             */
            ResendDocumentResponseBody.create = function create(properties) {
                return new ResendDocumentResponseBody(properties);
            };

            /**
             * Encodes the specified ResendDocumentResponseBody message. Does not implicitly {@link api.external.ResendDocumentResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.ResendDocumentResponseBody
             * @static
             * @param {api.external.IResendDocumentResponseBody} message ResendDocumentResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResendDocumentResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ResendDocumentResponseBody message, length delimited. Does not implicitly {@link api.external.ResendDocumentResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.ResendDocumentResponseBody
             * @static
             * @param {api.external.IResendDocumentResponseBody} message ResendDocumentResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResendDocumentResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ResendDocumentResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.ResendDocumentResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.ResendDocumentResponseBody} ResendDocumentResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResendDocumentResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.ResendDocumentResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ResendDocumentResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.ResendDocumentResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.ResendDocumentResponseBody} ResendDocumentResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResendDocumentResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ResendDocumentResponseBody message.
             * @function verify
             * @memberof api.external.ResendDocumentResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ResendDocumentResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a ResendDocumentResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.ResendDocumentResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.ResendDocumentResponseBody} ResendDocumentResponseBody
             */
            ResendDocumentResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.ResendDocumentResponseBody)
                    return object;
                return new $root.api.external.ResendDocumentResponseBody();
            };

            /**
             * Creates a plain object from a ResendDocumentResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.ResendDocumentResponseBody
             * @static
             * @param {api.external.ResendDocumentResponseBody} message ResendDocumentResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ResendDocumentResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ResendDocumentResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.ResendDocumentResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ResendDocumentResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ResendDocumentResponseBody;
        })();

        external.LodgeSupermatchRequestBody = (function() {

            /**
             * Properties of a LodgeSupermatchRequestBody.
             * @memberof api.external
             * @interface ILodgeSupermatchRequestBody
             */

            /**
             * Constructs a new LodgeSupermatchRequestBody.
             * @memberof api.external
             * @classdesc Represents a LodgeSupermatchRequestBody.
             * @implements ILodgeSupermatchRequestBody
             * @constructor
             * @param {api.external.ILodgeSupermatchRequestBody=} [properties] Properties to set
             */
            function LodgeSupermatchRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new LodgeSupermatchRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.LodgeSupermatchRequestBody
             * @static
             * @param {api.external.ILodgeSupermatchRequestBody=} [properties] Properties to set
             * @returns {api.external.LodgeSupermatchRequestBody} LodgeSupermatchRequestBody instance
             */
            LodgeSupermatchRequestBody.create = function create(properties) {
                return new LodgeSupermatchRequestBody(properties);
            };

            /**
             * Encodes the specified LodgeSupermatchRequestBody message. Does not implicitly {@link api.external.LodgeSupermatchRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.LodgeSupermatchRequestBody
             * @static
             * @param {api.external.ILodgeSupermatchRequestBody} message LodgeSupermatchRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LodgeSupermatchRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified LodgeSupermatchRequestBody message, length delimited. Does not implicitly {@link api.external.LodgeSupermatchRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.LodgeSupermatchRequestBody
             * @static
             * @param {api.external.ILodgeSupermatchRequestBody} message LodgeSupermatchRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LodgeSupermatchRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LodgeSupermatchRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.LodgeSupermatchRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.LodgeSupermatchRequestBody} LodgeSupermatchRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LodgeSupermatchRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.LodgeSupermatchRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LodgeSupermatchRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.LodgeSupermatchRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.LodgeSupermatchRequestBody} LodgeSupermatchRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LodgeSupermatchRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LodgeSupermatchRequestBody message.
             * @function verify
             * @memberof api.external.LodgeSupermatchRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LodgeSupermatchRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a LodgeSupermatchRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.LodgeSupermatchRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.LodgeSupermatchRequestBody} LodgeSupermatchRequestBody
             */
            LodgeSupermatchRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.LodgeSupermatchRequestBody)
                    return object;
                return new $root.api.external.LodgeSupermatchRequestBody();
            };

            /**
             * Creates a plain object from a LodgeSupermatchRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.LodgeSupermatchRequestBody
             * @static
             * @param {api.external.LodgeSupermatchRequestBody} message LodgeSupermatchRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LodgeSupermatchRequestBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this LodgeSupermatchRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.LodgeSupermatchRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LodgeSupermatchRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LodgeSupermatchRequestBody;
        })();

        external.LodgeSupermatchResponseBody = (function() {

            /**
             * Properties of a LodgeSupermatchResponseBody.
             * @memberof api.external
             * @interface ILodgeSupermatchResponseBody
             */

            /**
             * Constructs a new LodgeSupermatchResponseBody.
             * @memberof api.external
             * @classdesc Represents a LodgeSupermatchResponseBody.
             * @implements ILodgeSupermatchResponseBody
             * @constructor
             * @param {api.external.ILodgeSupermatchResponseBody=} [properties] Properties to set
             */
            function LodgeSupermatchResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new LodgeSupermatchResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.LodgeSupermatchResponseBody
             * @static
             * @param {api.external.ILodgeSupermatchResponseBody=} [properties] Properties to set
             * @returns {api.external.LodgeSupermatchResponseBody} LodgeSupermatchResponseBody instance
             */
            LodgeSupermatchResponseBody.create = function create(properties) {
                return new LodgeSupermatchResponseBody(properties);
            };

            /**
             * Encodes the specified LodgeSupermatchResponseBody message. Does not implicitly {@link api.external.LodgeSupermatchResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.LodgeSupermatchResponseBody
             * @static
             * @param {api.external.ILodgeSupermatchResponseBody} message LodgeSupermatchResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LodgeSupermatchResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified LodgeSupermatchResponseBody message, length delimited. Does not implicitly {@link api.external.LodgeSupermatchResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.LodgeSupermatchResponseBody
             * @static
             * @param {api.external.ILodgeSupermatchResponseBody} message LodgeSupermatchResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LodgeSupermatchResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LodgeSupermatchResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.LodgeSupermatchResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.LodgeSupermatchResponseBody} LodgeSupermatchResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LodgeSupermatchResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.LodgeSupermatchResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LodgeSupermatchResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.LodgeSupermatchResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.LodgeSupermatchResponseBody} LodgeSupermatchResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LodgeSupermatchResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LodgeSupermatchResponseBody message.
             * @function verify
             * @memberof api.external.LodgeSupermatchResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LodgeSupermatchResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a LodgeSupermatchResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.LodgeSupermatchResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.LodgeSupermatchResponseBody} LodgeSupermatchResponseBody
             */
            LodgeSupermatchResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.LodgeSupermatchResponseBody)
                    return object;
                return new $root.api.external.LodgeSupermatchResponseBody();
            };

            /**
             * Creates a plain object from a LodgeSupermatchResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.LodgeSupermatchResponseBody
             * @static
             * @param {api.external.LodgeSupermatchResponseBody} message LodgeSupermatchResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LodgeSupermatchResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this LodgeSupermatchResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.LodgeSupermatchResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LodgeSupermatchResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LodgeSupermatchResponseBody;
        })();

        external.GetBranchDetailsByBSBResponseBody = (function() {

            /**
             * Properties of a GetBranchDetailsByBSBResponseBody.
             * @memberof api.external
             * @interface IGetBranchDetailsByBSBResponseBody
             * @property {IBranchDetails|null} [branch_details] GetBranchDetailsByBSBResponseBody branch_details
             */

            /**
             * Constructs a new GetBranchDetailsByBSBResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetBranchDetailsByBSBResponseBody.
             * @implements IGetBranchDetailsByBSBResponseBody
             * @constructor
             * @param {api.external.IGetBranchDetailsByBSBResponseBody=} [properties] Properties to set
             */
            function GetBranchDetailsByBSBResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetBranchDetailsByBSBResponseBody branch_details.
             * @member {IBranchDetails|null|undefined} branch_details
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @instance
             */
            GetBranchDetailsByBSBResponseBody.prototype.branch_details = null;

            /**
             * Creates a new GetBranchDetailsByBSBResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @static
             * @param {api.external.IGetBranchDetailsByBSBResponseBody=} [properties] Properties to set
             * @returns {api.external.GetBranchDetailsByBSBResponseBody} GetBranchDetailsByBSBResponseBody instance
             */
            GetBranchDetailsByBSBResponseBody.create = function create(properties) {
                return new GetBranchDetailsByBSBResponseBody(properties);
            };

            /**
             * Encodes the specified GetBranchDetailsByBSBResponseBody message. Does not implicitly {@link api.external.GetBranchDetailsByBSBResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @static
             * @param {api.external.IGetBranchDetailsByBSBResponseBody} message GetBranchDetailsByBSBResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetBranchDetailsByBSBResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.branch_details != null && message.hasOwnProperty("branch_details"))
                    $root.BranchDetails.encode(message.branch_details, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetBranchDetailsByBSBResponseBody message, length delimited. Does not implicitly {@link api.external.GetBranchDetailsByBSBResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @static
             * @param {api.external.IGetBranchDetailsByBSBResponseBody} message GetBranchDetailsByBSBResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetBranchDetailsByBSBResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetBranchDetailsByBSBResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetBranchDetailsByBSBResponseBody} GetBranchDetailsByBSBResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetBranchDetailsByBSBResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetBranchDetailsByBSBResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.branch_details = $root.BranchDetails.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetBranchDetailsByBSBResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetBranchDetailsByBSBResponseBody} GetBranchDetailsByBSBResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetBranchDetailsByBSBResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetBranchDetailsByBSBResponseBody message.
             * @function verify
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetBranchDetailsByBSBResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.branch_details != null && message.hasOwnProperty("branch_details")) {
                    let error = $root.BranchDetails.verify(message.branch_details);
                    if (error)
                        return "branch_details." + error;
                }
                return null;
            };

            /**
             * Creates a GetBranchDetailsByBSBResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetBranchDetailsByBSBResponseBody} GetBranchDetailsByBSBResponseBody
             */
            GetBranchDetailsByBSBResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetBranchDetailsByBSBResponseBody)
                    return object;
                let message = new $root.api.external.GetBranchDetailsByBSBResponseBody();
                if (object.branch_details != null) {
                    if (typeof object.branch_details !== "object")
                        throw TypeError(".api.external.GetBranchDetailsByBSBResponseBody.branch_details: object expected");
                    message.branch_details = $root.BranchDetails.fromObject(object.branch_details);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetBranchDetailsByBSBResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @static
             * @param {api.external.GetBranchDetailsByBSBResponseBody} message GetBranchDetailsByBSBResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetBranchDetailsByBSBResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.branch_details = null;
                if (message.branch_details != null && message.hasOwnProperty("branch_details"))
                    object.branch_details = $root.BranchDetails.toObject(message.branch_details, options);
                return object;
            };

            /**
             * Converts this GetBranchDetailsByBSBResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetBranchDetailsByBSBResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetBranchDetailsByBSBResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetBranchDetailsByBSBResponseBody;
        })();

        external.GetSaverAccountPerformanceResponseBody = (function() {

            /**
             * Properties of a GetSaverAccountPerformanceResponseBody.
             * @memberof api.external
             * @interface IGetSaverAccountPerformanceResponseBody
             * @property {string|null} [balance] GetSaverAccountPerformanceResponseBody balance
             * @property {string|null} [performance_amount] GetSaverAccountPerformanceResponseBody performance_amount
             * @property {string|null} [performance_percentage] GetSaverAccountPerformanceResponseBody performance_percentage
             * @property {string|null} [pending_balance] GetSaverAccountPerformanceResponseBody pending_balance
             */

            /**
             * Constructs a new GetSaverAccountPerformanceResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetSaverAccountPerformanceResponseBody.
             * @implements IGetSaverAccountPerformanceResponseBody
             * @constructor
             * @param {api.external.IGetSaverAccountPerformanceResponseBody=} [properties] Properties to set
             */
            function GetSaverAccountPerformanceResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetSaverAccountPerformanceResponseBody balance.
             * @member {string} balance
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @instance
             */
            GetSaverAccountPerformanceResponseBody.prototype.balance = "";

            /**
             * GetSaverAccountPerformanceResponseBody performance_amount.
             * @member {string} performance_amount
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @instance
             */
            GetSaverAccountPerformanceResponseBody.prototype.performance_amount = "";

            /**
             * GetSaverAccountPerformanceResponseBody performance_percentage.
             * @member {string} performance_percentage
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @instance
             */
            GetSaverAccountPerformanceResponseBody.prototype.performance_percentage = "";

            /**
             * GetSaverAccountPerformanceResponseBody pending_balance.
             * @member {string} pending_balance
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @instance
             */
            GetSaverAccountPerformanceResponseBody.prototype.pending_balance = "";

            /**
             * Creates a new GetSaverAccountPerformanceResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @static
             * @param {api.external.IGetSaverAccountPerformanceResponseBody=} [properties] Properties to set
             * @returns {api.external.GetSaverAccountPerformanceResponseBody} GetSaverAccountPerformanceResponseBody instance
             */
            GetSaverAccountPerformanceResponseBody.create = function create(properties) {
                return new GetSaverAccountPerformanceResponseBody(properties);
            };

            /**
             * Encodes the specified GetSaverAccountPerformanceResponseBody message. Does not implicitly {@link api.external.GetSaverAccountPerformanceResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @static
             * @param {api.external.IGetSaverAccountPerformanceResponseBody} message GetSaverAccountPerformanceResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSaverAccountPerformanceResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.balance != null && message.hasOwnProperty("balance"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.balance);
                if (message.performance_amount != null && message.hasOwnProperty("performance_amount"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.performance_amount);
                if (message.performance_percentage != null && message.hasOwnProperty("performance_percentage"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.performance_percentage);
                if (message.pending_balance != null && message.hasOwnProperty("pending_balance"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.pending_balance);
                return writer;
            };

            /**
             * Encodes the specified GetSaverAccountPerformanceResponseBody message, length delimited. Does not implicitly {@link api.external.GetSaverAccountPerformanceResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @static
             * @param {api.external.IGetSaverAccountPerformanceResponseBody} message GetSaverAccountPerformanceResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSaverAccountPerformanceResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetSaverAccountPerformanceResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetSaverAccountPerformanceResponseBody} GetSaverAccountPerformanceResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSaverAccountPerformanceResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetSaverAccountPerformanceResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.balance = reader.string();
                        break;
                    case 2:
                        message.performance_amount = reader.string();
                        break;
                    case 3:
                        message.performance_percentage = reader.string();
                        break;
                    case 4:
                        message.pending_balance = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetSaverAccountPerformanceResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetSaverAccountPerformanceResponseBody} GetSaverAccountPerformanceResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSaverAccountPerformanceResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetSaverAccountPerformanceResponseBody message.
             * @function verify
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetSaverAccountPerformanceResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (!$util.isString(message.balance))
                        return "balance: string expected";
                if (message.performance_amount != null && message.hasOwnProperty("performance_amount"))
                    if (!$util.isString(message.performance_amount))
                        return "performance_amount: string expected";
                if (message.performance_percentage != null && message.hasOwnProperty("performance_percentage"))
                    if (!$util.isString(message.performance_percentage))
                        return "performance_percentage: string expected";
                if (message.pending_balance != null && message.hasOwnProperty("pending_balance"))
                    if (!$util.isString(message.pending_balance))
                        return "pending_balance: string expected";
                return null;
            };

            /**
             * Creates a GetSaverAccountPerformanceResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetSaverAccountPerformanceResponseBody} GetSaverAccountPerformanceResponseBody
             */
            GetSaverAccountPerformanceResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetSaverAccountPerformanceResponseBody)
                    return object;
                let message = new $root.api.external.GetSaverAccountPerformanceResponseBody();
                if (object.balance != null)
                    message.balance = String(object.balance);
                if (object.performance_amount != null)
                    message.performance_amount = String(object.performance_amount);
                if (object.performance_percentage != null)
                    message.performance_percentage = String(object.performance_percentage);
                if (object.pending_balance != null)
                    message.pending_balance = String(object.pending_balance);
                return message;
            };

            /**
             * Creates a plain object from a GetSaverAccountPerformanceResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @static
             * @param {api.external.GetSaverAccountPerformanceResponseBody} message GetSaverAccountPerformanceResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetSaverAccountPerformanceResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.balance = "";
                    object.performance_amount = "";
                    object.performance_percentage = "";
                    object.pending_balance = "";
                }
                if (message.balance != null && message.hasOwnProperty("balance"))
                    object.balance = message.balance;
                if (message.performance_amount != null && message.hasOwnProperty("performance_amount"))
                    object.performance_amount = message.performance_amount;
                if (message.performance_percentage != null && message.hasOwnProperty("performance_percentage"))
                    object.performance_percentage = message.performance_percentage;
                if (message.pending_balance != null && message.hasOwnProperty("pending_balance"))
                    object.pending_balance = message.pending_balance;
                return object;
            };

            /**
             * Converts this GetSaverAccountPerformanceResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetSaverAccountPerformanceResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetSaverAccountPerformanceResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetSaverAccountPerformanceResponseBody;
        })();

        external.CreatePaymentScheduleRequestBody = (function() {

            /**
             * Properties of a CreatePaymentScheduleRequestBody.
             * @memberof api.external
             * @interface ICreatePaymentScheduleRequestBody
             * @property {string|null} [source_account_id] CreatePaymentScheduleRequestBody source_account_id
             * @property {SchedulerFrequency.Enum|null} [frequency] CreatePaymentScheduleRequestBody frequency
             * @property {string|null} [amount] CreatePaymentScheduleRequestBody amount
             * @property {string|null} [start_date] CreatePaymentScheduleRequestBody start_date
             */

            /**
             * Constructs a new CreatePaymentScheduleRequestBody.
             * @memberof api.external
             * @classdesc Represents a CreatePaymentScheduleRequestBody.
             * @implements ICreatePaymentScheduleRequestBody
             * @constructor
             * @param {api.external.ICreatePaymentScheduleRequestBody=} [properties] Properties to set
             */
            function CreatePaymentScheduleRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreatePaymentScheduleRequestBody source_account_id.
             * @member {string} source_account_id
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @instance
             */
            CreatePaymentScheduleRequestBody.prototype.source_account_id = "";

            /**
             * CreatePaymentScheduleRequestBody frequency.
             * @member {SchedulerFrequency.Enum} frequency
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @instance
             */
            CreatePaymentScheduleRequestBody.prototype.frequency = 0;

            /**
             * CreatePaymentScheduleRequestBody amount.
             * @member {string} amount
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @instance
             */
            CreatePaymentScheduleRequestBody.prototype.amount = "";

            /**
             * CreatePaymentScheduleRequestBody start_date.
             * @member {string} start_date
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @instance
             */
            CreatePaymentScheduleRequestBody.prototype.start_date = "";

            /**
             * Creates a new CreatePaymentScheduleRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @static
             * @param {api.external.ICreatePaymentScheduleRequestBody=} [properties] Properties to set
             * @returns {api.external.CreatePaymentScheduleRequestBody} CreatePaymentScheduleRequestBody instance
             */
            CreatePaymentScheduleRequestBody.create = function create(properties) {
                return new CreatePaymentScheduleRequestBody(properties);
            };

            /**
             * Encodes the specified CreatePaymentScheduleRequestBody message. Does not implicitly {@link api.external.CreatePaymentScheduleRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @static
             * @param {api.external.ICreatePaymentScheduleRequestBody} message CreatePaymentScheduleRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreatePaymentScheduleRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.source_account_id != null && message.hasOwnProperty("source_account_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.source_account_id);
                if (message.frequency != null && message.hasOwnProperty("frequency"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.frequency);
                if (message.amount != null && message.hasOwnProperty("amount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.amount);
                if (message.start_date != null && message.hasOwnProperty("start_date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.start_date);
                return writer;
            };

            /**
             * Encodes the specified CreatePaymentScheduleRequestBody message, length delimited. Does not implicitly {@link api.external.CreatePaymentScheduleRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @static
             * @param {api.external.ICreatePaymentScheduleRequestBody} message CreatePaymentScheduleRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreatePaymentScheduleRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreatePaymentScheduleRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreatePaymentScheduleRequestBody} CreatePaymentScheduleRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreatePaymentScheduleRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreatePaymentScheduleRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.source_account_id = reader.string();
                        break;
                    case 2:
                        message.frequency = reader.int32();
                        break;
                    case 3:
                        message.amount = reader.string();
                        break;
                    case 4:
                        message.start_date = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreatePaymentScheduleRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreatePaymentScheduleRequestBody} CreatePaymentScheduleRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreatePaymentScheduleRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreatePaymentScheduleRequestBody message.
             * @function verify
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreatePaymentScheduleRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.source_account_id != null && message.hasOwnProperty("source_account_id"))
                    if (!$util.isString(message.source_account_id))
                        return "source_account_id: string expected";
                if (message.frequency != null && message.hasOwnProperty("frequency"))
                    switch (message.frequency) {
                    default:
                        return "frequency: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isString(message.amount))
                        return "amount: string expected";
                if (message.start_date != null && message.hasOwnProperty("start_date"))
                    if (!$util.isString(message.start_date))
                        return "start_date: string expected";
                return null;
            };

            /**
             * Creates a CreatePaymentScheduleRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreatePaymentScheduleRequestBody} CreatePaymentScheduleRequestBody
             */
            CreatePaymentScheduleRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreatePaymentScheduleRequestBody)
                    return object;
                let message = new $root.api.external.CreatePaymentScheduleRequestBody();
                if (object.source_account_id != null)
                    message.source_account_id = String(object.source_account_id);
                switch (object.frequency) {
                case "UNKNOWN":
                case 0:
                    message.frequency = 0;
                    break;
                case "ONE_TIME":
                case 1:
                    message.frequency = 1;
                    break;
                case "WEEKLY":
                case 2:
                    message.frequency = 2;
                    break;
                case "FORTNIGHTLY":
                case 3:
                    message.frequency = 3;
                    break;
                case "MONTHLY":
                case 4:
                    message.frequency = 4;
                    break;
                }
                if (object.amount != null)
                    message.amount = String(object.amount);
                if (object.start_date != null)
                    message.start_date = String(object.start_date);
                return message;
            };

            /**
             * Creates a plain object from a CreatePaymentScheduleRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @static
             * @param {api.external.CreatePaymentScheduleRequestBody} message CreatePaymentScheduleRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreatePaymentScheduleRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.source_account_id = "";
                    object.frequency = options.enums === String ? "UNKNOWN" : 0;
                    object.amount = "";
                    object.start_date = "";
                }
                if (message.source_account_id != null && message.hasOwnProperty("source_account_id"))
                    object.source_account_id = message.source_account_id;
                if (message.frequency != null && message.hasOwnProperty("frequency"))
                    object.frequency = options.enums === String ? $root.SchedulerFrequency.Enum[message.frequency] : message.frequency;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = message.amount;
                if (message.start_date != null && message.hasOwnProperty("start_date"))
                    object.start_date = message.start_date;
                return object;
            };

            /**
             * Converts this CreatePaymentScheduleRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.CreatePaymentScheduleRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreatePaymentScheduleRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreatePaymentScheduleRequestBody;
        })();

        external.CreatePaymentScheduleResponseBody = (function() {

            /**
             * Properties of a CreatePaymentScheduleResponseBody.
             * @memberof api.external
             * @interface ICreatePaymentScheduleResponseBody
             */

            /**
             * Constructs a new CreatePaymentScheduleResponseBody.
             * @memberof api.external
             * @classdesc Represents a CreatePaymentScheduleResponseBody.
             * @implements ICreatePaymentScheduleResponseBody
             * @constructor
             * @param {api.external.ICreatePaymentScheduleResponseBody=} [properties] Properties to set
             */
            function CreatePaymentScheduleResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreatePaymentScheduleResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @static
             * @param {api.external.ICreatePaymentScheduleResponseBody=} [properties] Properties to set
             * @returns {api.external.CreatePaymentScheduleResponseBody} CreatePaymentScheduleResponseBody instance
             */
            CreatePaymentScheduleResponseBody.create = function create(properties) {
                return new CreatePaymentScheduleResponseBody(properties);
            };

            /**
             * Encodes the specified CreatePaymentScheduleResponseBody message. Does not implicitly {@link api.external.CreatePaymentScheduleResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @static
             * @param {api.external.ICreatePaymentScheduleResponseBody} message CreatePaymentScheduleResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreatePaymentScheduleResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreatePaymentScheduleResponseBody message, length delimited. Does not implicitly {@link api.external.CreatePaymentScheduleResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @static
             * @param {api.external.ICreatePaymentScheduleResponseBody} message CreatePaymentScheduleResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreatePaymentScheduleResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreatePaymentScheduleResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreatePaymentScheduleResponseBody} CreatePaymentScheduleResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreatePaymentScheduleResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreatePaymentScheduleResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreatePaymentScheduleResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreatePaymentScheduleResponseBody} CreatePaymentScheduleResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreatePaymentScheduleResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreatePaymentScheduleResponseBody message.
             * @function verify
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreatePaymentScheduleResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreatePaymentScheduleResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreatePaymentScheduleResponseBody} CreatePaymentScheduleResponseBody
             */
            CreatePaymentScheduleResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreatePaymentScheduleResponseBody)
                    return object;
                return new $root.api.external.CreatePaymentScheduleResponseBody();
            };

            /**
             * Creates a plain object from a CreatePaymentScheduleResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @static
             * @param {api.external.CreatePaymentScheduleResponseBody} message CreatePaymentScheduleResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreatePaymentScheduleResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreatePaymentScheduleResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.CreatePaymentScheduleResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreatePaymentScheduleResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreatePaymentScheduleResponseBody;
        })();

        external.GetInvestmentHistoryResponseBody = (function() {

            /**
             * Properties of a GetInvestmentHistoryResponseBody.
             * @memberof api.external
             * @interface IGetInvestmentHistoryResponseBody
             * @property {Array.<api.external.IInvestmentHistoryDeposit>|null} [deposits] GetInvestmentHistoryResponseBody deposits
             * @property {Array.<api.external.IInvestmentHistoryWithdrawal>|null} [withdrawals] GetInvestmentHistoryResponseBody withdrawals
             * @property {Array.<IPromoOverview>|null} [promo_overviews] GetInvestmentHistoryResponseBody promo_overviews
             * @property {Array.<api.external.GetInvestmentHistoryResponseBody.IReferralOverview>|null} [referral_overviews] GetInvestmentHistoryResponseBody referral_overviews
             */

            /**
             * Constructs a new GetInvestmentHistoryResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetInvestmentHistoryResponseBody.
             * @implements IGetInvestmentHistoryResponseBody
             * @constructor
             * @param {api.external.IGetInvestmentHistoryResponseBody=} [properties] Properties to set
             */
            function GetInvestmentHistoryResponseBody(properties) {
                this.deposits = [];
                this.withdrawals = [];
                this.promo_overviews = [];
                this.referral_overviews = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetInvestmentHistoryResponseBody deposits.
             * @member {Array.<api.external.IInvestmentHistoryDeposit>} deposits
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @instance
             */
            GetInvestmentHistoryResponseBody.prototype.deposits = $util.emptyArray;

            /**
             * GetInvestmentHistoryResponseBody withdrawals.
             * @member {Array.<api.external.IInvestmentHistoryWithdrawal>} withdrawals
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @instance
             */
            GetInvestmentHistoryResponseBody.prototype.withdrawals = $util.emptyArray;

            /**
             * GetInvestmentHistoryResponseBody promo_overviews.
             * @member {Array.<IPromoOverview>} promo_overviews
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @instance
             */
            GetInvestmentHistoryResponseBody.prototype.promo_overviews = $util.emptyArray;

            /**
             * GetInvestmentHistoryResponseBody referral_overviews.
             * @member {Array.<api.external.GetInvestmentHistoryResponseBody.IReferralOverview>} referral_overviews
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @instance
             */
            GetInvestmentHistoryResponseBody.prototype.referral_overviews = $util.emptyArray;

            /**
             * Creates a new GetInvestmentHistoryResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @static
             * @param {api.external.IGetInvestmentHistoryResponseBody=} [properties] Properties to set
             * @returns {api.external.GetInvestmentHistoryResponseBody} GetInvestmentHistoryResponseBody instance
             */
            GetInvestmentHistoryResponseBody.create = function create(properties) {
                return new GetInvestmentHistoryResponseBody(properties);
            };

            /**
             * Encodes the specified GetInvestmentHistoryResponseBody message. Does not implicitly {@link api.external.GetInvestmentHistoryResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @static
             * @param {api.external.IGetInvestmentHistoryResponseBody} message GetInvestmentHistoryResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetInvestmentHistoryResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deposits != null && message.deposits.length)
                    for (let i = 0; i < message.deposits.length; ++i)
                        $root.api.external.InvestmentHistoryDeposit.encode(message.deposits[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.withdrawals != null && message.withdrawals.length)
                    for (let i = 0; i < message.withdrawals.length; ++i)
                        $root.api.external.InvestmentHistoryWithdrawal.encode(message.withdrawals[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.promo_overviews != null && message.promo_overviews.length)
                    for (let i = 0; i < message.promo_overviews.length; ++i)
                        $root.PromoOverview.encode(message.promo_overviews[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.referral_overviews != null && message.referral_overviews.length)
                    for (let i = 0; i < message.referral_overviews.length; ++i)
                        $root.api.external.GetInvestmentHistoryResponseBody.ReferralOverview.encode(message.referral_overviews[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetInvestmentHistoryResponseBody message, length delimited. Does not implicitly {@link api.external.GetInvestmentHistoryResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @static
             * @param {api.external.IGetInvestmentHistoryResponseBody} message GetInvestmentHistoryResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetInvestmentHistoryResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetInvestmentHistoryResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetInvestmentHistoryResponseBody} GetInvestmentHistoryResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetInvestmentHistoryResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetInvestmentHistoryResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 4:
                        if (!(message.deposits && message.deposits.length))
                            message.deposits = [];
                        message.deposits.push($root.api.external.InvestmentHistoryDeposit.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.withdrawals && message.withdrawals.length))
                            message.withdrawals = [];
                        message.withdrawals.push($root.api.external.InvestmentHistoryWithdrawal.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.promo_overviews && message.promo_overviews.length))
                            message.promo_overviews = [];
                        message.promo_overviews.push($root.PromoOverview.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        if (!(message.referral_overviews && message.referral_overviews.length))
                            message.referral_overviews = [];
                        message.referral_overviews.push($root.api.external.GetInvestmentHistoryResponseBody.ReferralOverview.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetInvestmentHistoryResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetInvestmentHistoryResponseBody} GetInvestmentHistoryResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetInvestmentHistoryResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetInvestmentHistoryResponseBody message.
             * @function verify
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetInvestmentHistoryResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deposits != null && message.hasOwnProperty("deposits")) {
                    if (!Array.isArray(message.deposits))
                        return "deposits: array expected";
                    for (let i = 0; i < message.deposits.length; ++i) {
                        let error = $root.api.external.InvestmentHistoryDeposit.verify(message.deposits[i]);
                        if (error)
                            return "deposits." + error;
                    }
                }
                if (message.withdrawals != null && message.hasOwnProperty("withdrawals")) {
                    if (!Array.isArray(message.withdrawals))
                        return "withdrawals: array expected";
                    for (let i = 0; i < message.withdrawals.length; ++i) {
                        let error = $root.api.external.InvestmentHistoryWithdrawal.verify(message.withdrawals[i]);
                        if (error)
                            return "withdrawals." + error;
                    }
                }
                if (message.promo_overviews != null && message.hasOwnProperty("promo_overviews")) {
                    if (!Array.isArray(message.promo_overviews))
                        return "promo_overviews: array expected";
                    for (let i = 0; i < message.promo_overviews.length; ++i) {
                        let error = $root.PromoOverview.verify(message.promo_overviews[i]);
                        if (error)
                            return "promo_overviews." + error;
                    }
                }
                if (message.referral_overviews != null && message.hasOwnProperty("referral_overviews")) {
                    if (!Array.isArray(message.referral_overviews))
                        return "referral_overviews: array expected";
                    for (let i = 0; i < message.referral_overviews.length; ++i) {
                        let error = $root.api.external.GetInvestmentHistoryResponseBody.ReferralOverview.verify(message.referral_overviews[i]);
                        if (error)
                            return "referral_overviews." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetInvestmentHistoryResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetInvestmentHistoryResponseBody} GetInvestmentHistoryResponseBody
             */
            GetInvestmentHistoryResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetInvestmentHistoryResponseBody)
                    return object;
                let message = new $root.api.external.GetInvestmentHistoryResponseBody();
                if (object.deposits) {
                    if (!Array.isArray(object.deposits))
                        throw TypeError(".api.external.GetInvestmentHistoryResponseBody.deposits: array expected");
                    message.deposits = [];
                    for (let i = 0; i < object.deposits.length; ++i) {
                        if (typeof object.deposits[i] !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.deposits: object expected");
                        message.deposits[i] = $root.api.external.InvestmentHistoryDeposit.fromObject(object.deposits[i]);
                    }
                }
                if (object.withdrawals) {
                    if (!Array.isArray(object.withdrawals))
                        throw TypeError(".api.external.GetInvestmentHistoryResponseBody.withdrawals: array expected");
                    message.withdrawals = [];
                    for (let i = 0; i < object.withdrawals.length; ++i) {
                        if (typeof object.withdrawals[i] !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.withdrawals: object expected");
                        message.withdrawals[i] = $root.api.external.InvestmentHistoryWithdrawal.fromObject(object.withdrawals[i]);
                    }
                }
                if (object.promo_overviews) {
                    if (!Array.isArray(object.promo_overviews))
                        throw TypeError(".api.external.GetInvestmentHistoryResponseBody.promo_overviews: array expected");
                    message.promo_overviews = [];
                    for (let i = 0; i < object.promo_overviews.length; ++i) {
                        if (typeof object.promo_overviews[i] !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.promo_overviews: object expected");
                        message.promo_overviews[i] = $root.PromoOverview.fromObject(object.promo_overviews[i]);
                    }
                }
                if (object.referral_overviews) {
                    if (!Array.isArray(object.referral_overviews))
                        throw TypeError(".api.external.GetInvestmentHistoryResponseBody.referral_overviews: array expected");
                    message.referral_overviews = [];
                    for (let i = 0; i < object.referral_overviews.length; ++i) {
                        if (typeof object.referral_overviews[i] !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.referral_overviews: object expected");
                        message.referral_overviews[i] = $root.api.external.GetInvestmentHistoryResponseBody.ReferralOverview.fromObject(object.referral_overviews[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetInvestmentHistoryResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @static
             * @param {api.external.GetInvestmentHistoryResponseBody} message GetInvestmentHistoryResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetInvestmentHistoryResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.deposits = [];
                    object.withdrawals = [];
                    object.promo_overviews = [];
                    object.referral_overviews = [];
                }
                if (message.deposits && message.deposits.length) {
                    object.deposits = [];
                    for (let j = 0; j < message.deposits.length; ++j)
                        object.deposits[j] = $root.api.external.InvestmentHistoryDeposit.toObject(message.deposits[j], options);
                }
                if (message.withdrawals && message.withdrawals.length) {
                    object.withdrawals = [];
                    for (let j = 0; j < message.withdrawals.length; ++j)
                        object.withdrawals[j] = $root.api.external.InvestmentHistoryWithdrawal.toObject(message.withdrawals[j], options);
                }
                if (message.promo_overviews && message.promo_overviews.length) {
                    object.promo_overviews = [];
                    for (let j = 0; j < message.promo_overviews.length; ++j)
                        object.promo_overviews[j] = $root.PromoOverview.toObject(message.promo_overviews[j], options);
                }
                if (message.referral_overviews && message.referral_overviews.length) {
                    object.referral_overviews = [];
                    for (let j = 0; j < message.referral_overviews.length; ++j)
                        object.referral_overviews[j] = $root.api.external.GetInvestmentHistoryResponseBody.ReferralOverview.toObject(message.referral_overviews[j], options);
                }
                return object;
            };

            /**
             * Converts this GetInvestmentHistoryResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetInvestmentHistoryResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetInvestmentHistoryResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            GetInvestmentHistoryResponseBody.ReferralOverview = (function() {

                /**
                 * Properties of a ReferralOverview.
                 * @memberof api.external.GetInvestmentHistoryResponseBody
                 * @interface IReferralOverview
                 * @property {IReferralCampaign|null} [campaign] ReferralOverview campaign
                 * @property {IReferralCode|null} [code] ReferralOverview code
                 * @property {IReferralCodeUsage|null} [usage] ReferralOverview usage
                 * @property {IFreebieIssuance|null} [referrer_issuance] ReferralOverview referrer_issuance
                 * @property {IFreebieIssuance|null} [referral_issuance] ReferralOverview referral_issuance
                 * @property {IUnitLedgerEntry|null} [referrer_unit_ledger_entry] ReferralOverview referrer_unit_ledger_entry
                 * @property {IUnitLedgerEntry|null} [referral_unit_ledger_entry] ReferralOverview referral_unit_ledger_entry
                 * @property {ILegacyFreebieIssuanceDetails|null} [referrer_legacy_issuance_details] ReferralOverview referrer_legacy_issuance_details
                 * @property {ILegacyFreebieIssuanceDetails|null} [referral_legacy_issuance_details] ReferralOverview referral_legacy_issuance_details
                 * @property {string|null} [referrer_short_name] ReferralOverview referrer_short_name
                 * @property {string|null} [referral_short_name] ReferralOverview referral_short_name
                 */

                /**
                 * Constructs a new ReferralOverview.
                 * @memberof api.external.GetInvestmentHistoryResponseBody
                 * @classdesc Represents a ReferralOverview.
                 * @implements IReferralOverview
                 * @constructor
                 * @param {api.external.GetInvestmentHistoryResponseBody.IReferralOverview=} [properties] Properties to set
                 */
                function ReferralOverview(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReferralOverview campaign.
                 * @member {IReferralCampaign|null|undefined} campaign
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.campaign = null;

                /**
                 * ReferralOverview code.
                 * @member {IReferralCode|null|undefined} code
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.code = null;

                /**
                 * ReferralOverview usage.
                 * @member {IReferralCodeUsage|null|undefined} usage
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.usage = null;

                /**
                 * ReferralOverview referrer_issuance.
                 * @member {IFreebieIssuance|null|undefined} referrer_issuance
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.referrer_issuance = null;

                /**
                 * ReferralOverview referral_issuance.
                 * @member {IFreebieIssuance|null|undefined} referral_issuance
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.referral_issuance = null;

                /**
                 * ReferralOverview referrer_unit_ledger_entry.
                 * @member {IUnitLedgerEntry|null|undefined} referrer_unit_ledger_entry
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.referrer_unit_ledger_entry = null;

                /**
                 * ReferralOverview referral_unit_ledger_entry.
                 * @member {IUnitLedgerEntry|null|undefined} referral_unit_ledger_entry
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.referral_unit_ledger_entry = null;

                /**
                 * ReferralOverview referrer_legacy_issuance_details.
                 * @member {ILegacyFreebieIssuanceDetails|null|undefined} referrer_legacy_issuance_details
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.referrer_legacy_issuance_details = null;

                /**
                 * ReferralOverview referral_legacy_issuance_details.
                 * @member {ILegacyFreebieIssuanceDetails|null|undefined} referral_legacy_issuance_details
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.referral_legacy_issuance_details = null;

                /**
                 * ReferralOverview referrer_short_name.
                 * @member {string} referrer_short_name
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.referrer_short_name = "";

                /**
                 * ReferralOverview referral_short_name.
                 * @member {string} referral_short_name
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 */
                ReferralOverview.prototype.referral_short_name = "";

                /**
                 * Creates a new ReferralOverview instance using the specified properties.
                 * @function create
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @static
                 * @param {api.external.GetInvestmentHistoryResponseBody.IReferralOverview=} [properties] Properties to set
                 * @returns {api.external.GetInvestmentHistoryResponseBody.ReferralOverview} ReferralOverview instance
                 */
                ReferralOverview.create = function create(properties) {
                    return new ReferralOverview(properties);
                };

                /**
                 * Encodes the specified ReferralOverview message. Does not implicitly {@link api.external.GetInvestmentHistoryResponseBody.ReferralOverview.verify|verify} messages.
                 * @function encode
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @static
                 * @param {api.external.GetInvestmentHistoryResponseBody.IReferralOverview} message ReferralOverview message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReferralOverview.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.campaign != null && message.hasOwnProperty("campaign"))
                        $root.ReferralCampaign.encode(message.campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.code != null && message.hasOwnProperty("code"))
                        $root.ReferralCode.encode(message.code, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.usage != null && message.hasOwnProperty("usage"))
                        $root.ReferralCodeUsage.encode(message.usage, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.referrer_issuance != null && message.hasOwnProperty("referrer_issuance"))
                        $root.FreebieIssuance.encode(message.referrer_issuance, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.referral_issuance != null && message.hasOwnProperty("referral_issuance"))
                        $root.FreebieIssuance.encode(message.referral_issuance, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.referrer_unit_ledger_entry != null && message.hasOwnProperty("referrer_unit_ledger_entry"))
                        $root.UnitLedgerEntry.encode(message.referrer_unit_ledger_entry, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.referral_unit_ledger_entry != null && message.hasOwnProperty("referral_unit_ledger_entry"))
                        $root.UnitLedgerEntry.encode(message.referral_unit_ledger_entry, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.referrer_legacy_issuance_details != null && message.hasOwnProperty("referrer_legacy_issuance_details"))
                        $root.LegacyFreebieIssuanceDetails.encode(message.referrer_legacy_issuance_details, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.referral_legacy_issuance_details != null && message.hasOwnProperty("referral_legacy_issuance_details"))
                        $root.LegacyFreebieIssuanceDetails.encode(message.referral_legacy_issuance_details, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.referrer_short_name != null && message.hasOwnProperty("referrer_short_name"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.referrer_short_name);
                    if (message.referral_short_name != null && message.hasOwnProperty("referral_short_name"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.referral_short_name);
                    return writer;
                };

                /**
                 * Encodes the specified ReferralOverview message, length delimited. Does not implicitly {@link api.external.GetInvestmentHistoryResponseBody.ReferralOverview.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @static
                 * @param {api.external.GetInvestmentHistoryResponseBody.IReferralOverview} message ReferralOverview message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReferralOverview.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReferralOverview message from the specified reader or buffer.
                 * @function decode
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {api.external.GetInvestmentHistoryResponseBody.ReferralOverview} ReferralOverview
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReferralOverview.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetInvestmentHistoryResponseBody.ReferralOverview();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.campaign = $root.ReferralCampaign.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.code = $root.ReferralCode.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.usage = $root.ReferralCodeUsage.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.referrer_issuance = $root.FreebieIssuance.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.referral_issuance = $root.FreebieIssuance.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.referrer_unit_ledger_entry = $root.UnitLedgerEntry.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.referral_unit_ledger_entry = $root.UnitLedgerEntry.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.referrer_legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.referral_legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.referrer_short_name = reader.string();
                            break;
                        case 11:
                            message.referral_short_name = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReferralOverview message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {api.external.GetInvestmentHistoryResponseBody.ReferralOverview} ReferralOverview
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReferralOverview.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReferralOverview message.
                 * @function verify
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReferralOverview.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.campaign != null && message.hasOwnProperty("campaign")) {
                        let error = $root.ReferralCampaign.verify(message.campaign);
                        if (error)
                            return "campaign." + error;
                    }
                    if (message.code != null && message.hasOwnProperty("code")) {
                        let error = $root.ReferralCode.verify(message.code);
                        if (error)
                            return "code." + error;
                    }
                    if (message.usage != null && message.hasOwnProperty("usage")) {
                        let error = $root.ReferralCodeUsage.verify(message.usage);
                        if (error)
                            return "usage." + error;
                    }
                    if (message.referrer_issuance != null && message.hasOwnProperty("referrer_issuance")) {
                        let error = $root.FreebieIssuance.verify(message.referrer_issuance);
                        if (error)
                            return "referrer_issuance." + error;
                    }
                    if (message.referral_issuance != null && message.hasOwnProperty("referral_issuance")) {
                        let error = $root.FreebieIssuance.verify(message.referral_issuance);
                        if (error)
                            return "referral_issuance." + error;
                    }
                    if (message.referrer_unit_ledger_entry != null && message.hasOwnProperty("referrer_unit_ledger_entry")) {
                        let error = $root.UnitLedgerEntry.verify(message.referrer_unit_ledger_entry);
                        if (error)
                            return "referrer_unit_ledger_entry." + error;
                    }
                    if (message.referral_unit_ledger_entry != null && message.hasOwnProperty("referral_unit_ledger_entry")) {
                        let error = $root.UnitLedgerEntry.verify(message.referral_unit_ledger_entry);
                        if (error)
                            return "referral_unit_ledger_entry." + error;
                    }
                    if (message.referrer_legacy_issuance_details != null && message.hasOwnProperty("referrer_legacy_issuance_details")) {
                        let error = $root.LegacyFreebieIssuanceDetails.verify(message.referrer_legacy_issuance_details);
                        if (error)
                            return "referrer_legacy_issuance_details." + error;
                    }
                    if (message.referral_legacy_issuance_details != null && message.hasOwnProperty("referral_legacy_issuance_details")) {
                        let error = $root.LegacyFreebieIssuanceDetails.verify(message.referral_legacy_issuance_details);
                        if (error)
                            return "referral_legacy_issuance_details." + error;
                    }
                    if (message.referrer_short_name != null && message.hasOwnProperty("referrer_short_name"))
                        if (!$util.isString(message.referrer_short_name))
                            return "referrer_short_name: string expected";
                    if (message.referral_short_name != null && message.hasOwnProperty("referral_short_name"))
                        if (!$util.isString(message.referral_short_name))
                            return "referral_short_name: string expected";
                    return null;
                };

                /**
                 * Creates a ReferralOverview message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {api.external.GetInvestmentHistoryResponseBody.ReferralOverview} ReferralOverview
                 */
                ReferralOverview.fromObject = function fromObject(object) {
                    if (object instanceof $root.api.external.GetInvestmentHistoryResponseBody.ReferralOverview)
                        return object;
                    let message = new $root.api.external.GetInvestmentHistoryResponseBody.ReferralOverview();
                    if (object.campaign != null) {
                        if (typeof object.campaign !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.campaign: object expected");
                        message.campaign = $root.ReferralCampaign.fromObject(object.campaign);
                    }
                    if (object.code != null) {
                        if (typeof object.code !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.code: object expected");
                        message.code = $root.ReferralCode.fromObject(object.code);
                    }
                    if (object.usage != null) {
                        if (typeof object.usage !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.usage: object expected");
                        message.usage = $root.ReferralCodeUsage.fromObject(object.usage);
                    }
                    if (object.referrer_issuance != null) {
                        if (typeof object.referrer_issuance !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.referrer_issuance: object expected");
                        message.referrer_issuance = $root.FreebieIssuance.fromObject(object.referrer_issuance);
                    }
                    if (object.referral_issuance != null) {
                        if (typeof object.referral_issuance !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.referral_issuance: object expected");
                        message.referral_issuance = $root.FreebieIssuance.fromObject(object.referral_issuance);
                    }
                    if (object.referrer_unit_ledger_entry != null) {
                        if (typeof object.referrer_unit_ledger_entry !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.referrer_unit_ledger_entry: object expected");
                        message.referrer_unit_ledger_entry = $root.UnitLedgerEntry.fromObject(object.referrer_unit_ledger_entry);
                    }
                    if (object.referral_unit_ledger_entry != null) {
                        if (typeof object.referral_unit_ledger_entry !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.referral_unit_ledger_entry: object expected");
                        message.referral_unit_ledger_entry = $root.UnitLedgerEntry.fromObject(object.referral_unit_ledger_entry);
                    }
                    if (object.referrer_legacy_issuance_details != null) {
                        if (typeof object.referrer_legacy_issuance_details !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.referrer_legacy_issuance_details: object expected");
                        message.referrer_legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.fromObject(object.referrer_legacy_issuance_details);
                    }
                    if (object.referral_legacy_issuance_details != null) {
                        if (typeof object.referral_legacy_issuance_details !== "object")
                            throw TypeError(".api.external.GetInvestmentHistoryResponseBody.ReferralOverview.referral_legacy_issuance_details: object expected");
                        message.referral_legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.fromObject(object.referral_legacy_issuance_details);
                    }
                    if (object.referrer_short_name != null)
                        message.referrer_short_name = String(object.referrer_short_name);
                    if (object.referral_short_name != null)
                        message.referral_short_name = String(object.referral_short_name);
                    return message;
                };

                /**
                 * Creates a plain object from a ReferralOverview message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @static
                 * @param {api.external.GetInvestmentHistoryResponseBody.ReferralOverview} message ReferralOverview
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReferralOverview.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.campaign = null;
                        object.code = null;
                        object.usage = null;
                        object.referrer_issuance = null;
                        object.referral_issuance = null;
                        object.referrer_unit_ledger_entry = null;
                        object.referral_unit_ledger_entry = null;
                        object.referrer_legacy_issuance_details = null;
                        object.referral_legacy_issuance_details = null;
                        object.referrer_short_name = "";
                        object.referral_short_name = "";
                    }
                    if (message.campaign != null && message.hasOwnProperty("campaign"))
                        object.campaign = $root.ReferralCampaign.toObject(message.campaign, options);
                    if (message.code != null && message.hasOwnProperty("code"))
                        object.code = $root.ReferralCode.toObject(message.code, options);
                    if (message.usage != null && message.hasOwnProperty("usage"))
                        object.usage = $root.ReferralCodeUsage.toObject(message.usage, options);
                    if (message.referrer_issuance != null && message.hasOwnProperty("referrer_issuance"))
                        object.referrer_issuance = $root.FreebieIssuance.toObject(message.referrer_issuance, options);
                    if (message.referral_issuance != null && message.hasOwnProperty("referral_issuance"))
                        object.referral_issuance = $root.FreebieIssuance.toObject(message.referral_issuance, options);
                    if (message.referrer_unit_ledger_entry != null && message.hasOwnProperty("referrer_unit_ledger_entry"))
                        object.referrer_unit_ledger_entry = $root.UnitLedgerEntry.toObject(message.referrer_unit_ledger_entry, options);
                    if (message.referral_unit_ledger_entry != null && message.hasOwnProperty("referral_unit_ledger_entry"))
                        object.referral_unit_ledger_entry = $root.UnitLedgerEntry.toObject(message.referral_unit_ledger_entry, options);
                    if (message.referrer_legacy_issuance_details != null && message.hasOwnProperty("referrer_legacy_issuance_details"))
                        object.referrer_legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.toObject(message.referrer_legacy_issuance_details, options);
                    if (message.referral_legacy_issuance_details != null && message.hasOwnProperty("referral_legacy_issuance_details"))
                        object.referral_legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.toObject(message.referral_legacy_issuance_details, options);
                    if (message.referrer_short_name != null && message.hasOwnProperty("referrer_short_name"))
                        object.referrer_short_name = message.referrer_short_name;
                    if (message.referral_short_name != null && message.hasOwnProperty("referral_short_name"))
                        object.referral_short_name = message.referral_short_name;
                    return object;
                };

                /**
                 * Converts this ReferralOverview to JSON.
                 * @function toJSON
                 * @memberof api.external.GetInvestmentHistoryResponseBody.ReferralOverview
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReferralOverview.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReferralOverview;
            })();

            return GetInvestmentHistoryResponseBody;
        })();

        external.GetInvestmentSummaryResponseBody = (function() {

            /**
             * Properties of a GetInvestmentSummaryResponseBody.
             * @memberof api.external
             * @interface IGetInvestmentSummaryResponseBody
             * @property {SaverPortfolio.Enum|null} [portfolio] GetInvestmentSummaryResponseBody portfolio
             * @property {string|null} [aud_balance] GetInvestmentSummaryResponseBody aud_balance
             * @property {string|null} [aud_total_invested] GetInvestmentSummaryResponseBody aud_total_invested
             * @property {string|null} [aud_total_withdrawn] GetInvestmentSummaryResponseBody aud_total_withdrawn
             * @property {string|null} [aud_total_referrals] GetInvestmentSummaryResponseBody aud_total_referrals
             * @property {string|null} [aud_total_promotions] GetInvestmentSummaryResponseBody aud_total_promotions
             * @property {string|null} [unit_balance] GetInvestmentSummaryResponseBody unit_balance
             * @property {string|null} [aud_market_return] GetInvestmentSummaryResponseBody aud_market_return
             */

            /**
             * Constructs a new GetInvestmentSummaryResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetInvestmentSummaryResponseBody.
             * @implements IGetInvestmentSummaryResponseBody
             * @constructor
             * @param {api.external.IGetInvestmentSummaryResponseBody=} [properties] Properties to set
             */
            function GetInvestmentSummaryResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetInvestmentSummaryResponseBody portfolio.
             * @member {SaverPortfolio.Enum} portfolio
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             */
            GetInvestmentSummaryResponseBody.prototype.portfolio = 0;

            /**
             * GetInvestmentSummaryResponseBody aud_balance.
             * @member {string} aud_balance
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             */
            GetInvestmentSummaryResponseBody.prototype.aud_balance = "";

            /**
             * GetInvestmentSummaryResponseBody aud_total_invested.
             * @member {string} aud_total_invested
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             */
            GetInvestmentSummaryResponseBody.prototype.aud_total_invested = "";

            /**
             * GetInvestmentSummaryResponseBody aud_total_withdrawn.
             * @member {string} aud_total_withdrawn
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             */
            GetInvestmentSummaryResponseBody.prototype.aud_total_withdrawn = "";

            /**
             * GetInvestmentSummaryResponseBody aud_total_referrals.
             * @member {string} aud_total_referrals
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             */
            GetInvestmentSummaryResponseBody.prototype.aud_total_referrals = "";

            /**
             * GetInvestmentSummaryResponseBody aud_total_promotions.
             * @member {string} aud_total_promotions
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             */
            GetInvestmentSummaryResponseBody.prototype.aud_total_promotions = "";

            /**
             * GetInvestmentSummaryResponseBody unit_balance.
             * @member {string} unit_balance
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             */
            GetInvestmentSummaryResponseBody.prototype.unit_balance = "";

            /**
             * GetInvestmentSummaryResponseBody aud_market_return.
             * @member {string} aud_market_return
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             */
            GetInvestmentSummaryResponseBody.prototype.aud_market_return = "";

            /**
             * Creates a new GetInvestmentSummaryResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @static
             * @param {api.external.IGetInvestmentSummaryResponseBody=} [properties] Properties to set
             * @returns {api.external.GetInvestmentSummaryResponseBody} GetInvestmentSummaryResponseBody instance
             */
            GetInvestmentSummaryResponseBody.create = function create(properties) {
                return new GetInvestmentSummaryResponseBody(properties);
            };

            /**
             * Encodes the specified GetInvestmentSummaryResponseBody message. Does not implicitly {@link api.external.GetInvestmentSummaryResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @static
             * @param {api.external.IGetInvestmentSummaryResponseBody} message GetInvestmentSummaryResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetInvestmentSummaryResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
                if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.aud_balance);
                if (message.aud_total_invested != null && message.hasOwnProperty("aud_total_invested"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.aud_total_invested);
                if (message.aud_total_withdrawn != null && message.hasOwnProperty("aud_total_withdrawn"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.aud_total_withdrawn);
                if (message.aud_total_referrals != null && message.hasOwnProperty("aud_total_referrals"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.aud_total_referrals);
                if (message.aud_total_promotions != null && message.hasOwnProperty("aud_total_promotions"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.aud_total_promotions);
                if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.unit_balance);
                if (message.aud_market_return != null && message.hasOwnProperty("aud_market_return"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.aud_market_return);
                return writer;
            };

            /**
             * Encodes the specified GetInvestmentSummaryResponseBody message, length delimited. Does not implicitly {@link api.external.GetInvestmentSummaryResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @static
             * @param {api.external.IGetInvestmentSummaryResponseBody} message GetInvestmentSummaryResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetInvestmentSummaryResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetInvestmentSummaryResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetInvestmentSummaryResponseBody} GetInvestmentSummaryResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetInvestmentSummaryResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetInvestmentSummaryResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.portfolio = reader.int32();
                        break;
                    case 2:
                        message.aud_balance = reader.string();
                        break;
                    case 4:
                        message.aud_total_invested = reader.string();
                        break;
                    case 5:
                        message.aud_total_withdrawn = reader.string();
                        break;
                    case 6:
                        message.aud_total_referrals = reader.string();
                        break;
                    case 7:
                        message.aud_total_promotions = reader.string();
                        break;
                    case 8:
                        message.unit_balance = reader.string();
                        break;
                    case 9:
                        message.aud_market_return = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetInvestmentSummaryResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetInvestmentSummaryResponseBody} GetInvestmentSummaryResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetInvestmentSummaryResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetInvestmentSummaryResponseBody message.
             * @function verify
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetInvestmentSummaryResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    switch (message.portfolio) {
                    default:
                        return "portfolio: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
                    if (!$util.isString(message.aud_balance))
                        return "aud_balance: string expected";
                if (message.aud_total_invested != null && message.hasOwnProperty("aud_total_invested"))
                    if (!$util.isString(message.aud_total_invested))
                        return "aud_total_invested: string expected";
                if (message.aud_total_withdrawn != null && message.hasOwnProperty("aud_total_withdrawn"))
                    if (!$util.isString(message.aud_total_withdrawn))
                        return "aud_total_withdrawn: string expected";
                if (message.aud_total_referrals != null && message.hasOwnProperty("aud_total_referrals"))
                    if (!$util.isString(message.aud_total_referrals))
                        return "aud_total_referrals: string expected";
                if (message.aud_total_promotions != null && message.hasOwnProperty("aud_total_promotions"))
                    if (!$util.isString(message.aud_total_promotions))
                        return "aud_total_promotions: string expected";
                if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
                    if (!$util.isString(message.unit_balance))
                        return "unit_balance: string expected";
                if (message.aud_market_return != null && message.hasOwnProperty("aud_market_return"))
                    if (!$util.isString(message.aud_market_return))
                        return "aud_market_return: string expected";
                return null;
            };

            /**
             * Creates a GetInvestmentSummaryResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetInvestmentSummaryResponseBody} GetInvestmentSummaryResponseBody
             */
            GetInvestmentSummaryResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetInvestmentSummaryResponseBody)
                    return object;
                let message = new $root.api.external.GetInvestmentSummaryResponseBody();
                switch (object.portfolio) {
                case "UNKNOWN":
                case 0:
                    message.portfolio = 0;
                    break;
                case "INDEX":
                case 1:
                    message.portfolio = 1;
                    break;
                case "UNIVERSE":
                case 2:
                    message.portfolio = 2;
                    break;
                case "EARTH":
                case 3:
                    message.portfolio = 3;
                    break;
                case "GALAXY":
                case 4:
                    message.portfolio = 4;
                    break;
                case "EXPLORER":
                case 5:
                    message.portfolio = 5;
                    break;
                }
                if (object.aud_balance != null)
                    message.aud_balance = String(object.aud_balance);
                if (object.aud_total_invested != null)
                    message.aud_total_invested = String(object.aud_total_invested);
                if (object.aud_total_withdrawn != null)
                    message.aud_total_withdrawn = String(object.aud_total_withdrawn);
                if (object.aud_total_referrals != null)
                    message.aud_total_referrals = String(object.aud_total_referrals);
                if (object.aud_total_promotions != null)
                    message.aud_total_promotions = String(object.aud_total_promotions);
                if (object.unit_balance != null)
                    message.unit_balance = String(object.unit_balance);
                if (object.aud_market_return != null)
                    message.aud_market_return = String(object.aud_market_return);
                return message;
            };

            /**
             * Creates a plain object from a GetInvestmentSummaryResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @static
             * @param {api.external.GetInvestmentSummaryResponseBody} message GetInvestmentSummaryResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetInvestmentSummaryResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.portfolio = options.enums === String ? "UNKNOWN" : 0;
                    object.aud_balance = "";
                    object.aud_total_invested = "";
                    object.aud_total_withdrawn = "";
                    object.aud_total_referrals = "";
                    object.aud_total_promotions = "";
                    object.unit_balance = "";
                    object.aud_market_return = "";
                }
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
                if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
                    object.aud_balance = message.aud_balance;
                if (message.aud_total_invested != null && message.hasOwnProperty("aud_total_invested"))
                    object.aud_total_invested = message.aud_total_invested;
                if (message.aud_total_withdrawn != null && message.hasOwnProperty("aud_total_withdrawn"))
                    object.aud_total_withdrawn = message.aud_total_withdrawn;
                if (message.aud_total_referrals != null && message.hasOwnProperty("aud_total_referrals"))
                    object.aud_total_referrals = message.aud_total_referrals;
                if (message.aud_total_promotions != null && message.hasOwnProperty("aud_total_promotions"))
                    object.aud_total_promotions = message.aud_total_promotions;
                if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
                    object.unit_balance = message.unit_balance;
                if (message.aud_market_return != null && message.hasOwnProperty("aud_market_return"))
                    object.aud_market_return = message.aud_market_return;
                return object;
            };

            /**
             * Converts this GetInvestmentSummaryResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetInvestmentSummaryResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetInvestmentSummaryResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetInvestmentSummaryResponseBody;
        })();

        external.InvestmentHistoryTransactionStatus = (function() {

            /**
             * Properties of an InvestmentHistoryTransactionStatus.
             * @memberof api.external
             * @interface IInvestmentHistoryTransactionStatus
             */

            /**
             * Constructs a new InvestmentHistoryTransactionStatus.
             * @memberof api.external
             * @classdesc Represents an InvestmentHistoryTransactionStatus.
             * @implements IInvestmentHistoryTransactionStatus
             * @constructor
             * @param {api.external.IInvestmentHistoryTransactionStatus=} [properties] Properties to set
             */
            function InvestmentHistoryTransactionStatus(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new InvestmentHistoryTransactionStatus instance using the specified properties.
             * @function create
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @static
             * @param {api.external.IInvestmentHistoryTransactionStatus=} [properties] Properties to set
             * @returns {api.external.InvestmentHistoryTransactionStatus} InvestmentHistoryTransactionStatus instance
             */
            InvestmentHistoryTransactionStatus.create = function create(properties) {
                return new InvestmentHistoryTransactionStatus(properties);
            };

            /**
             * Encodes the specified InvestmentHistoryTransactionStatus message. Does not implicitly {@link api.external.InvestmentHistoryTransactionStatus.verify|verify} messages.
             * @function encode
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @static
             * @param {api.external.IInvestmentHistoryTransactionStatus} message InvestmentHistoryTransactionStatus message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InvestmentHistoryTransactionStatus.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified InvestmentHistoryTransactionStatus message, length delimited. Does not implicitly {@link api.external.InvestmentHistoryTransactionStatus.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @static
             * @param {api.external.IInvestmentHistoryTransactionStatus} message InvestmentHistoryTransactionStatus message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InvestmentHistoryTransactionStatus.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an InvestmentHistoryTransactionStatus message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.InvestmentHistoryTransactionStatus} InvestmentHistoryTransactionStatus
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InvestmentHistoryTransactionStatus.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.InvestmentHistoryTransactionStatus();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an InvestmentHistoryTransactionStatus message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.InvestmentHistoryTransactionStatus} InvestmentHistoryTransactionStatus
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InvestmentHistoryTransactionStatus.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an InvestmentHistoryTransactionStatus message.
             * @function verify
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            InvestmentHistoryTransactionStatus.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an InvestmentHistoryTransactionStatus message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.InvestmentHistoryTransactionStatus} InvestmentHistoryTransactionStatus
             */
            InvestmentHistoryTransactionStatus.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.InvestmentHistoryTransactionStatus)
                    return object;
                return new $root.api.external.InvestmentHistoryTransactionStatus();
            };

            /**
             * Creates a plain object from an InvestmentHistoryTransactionStatus message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @static
             * @param {api.external.InvestmentHistoryTransactionStatus} message InvestmentHistoryTransactionStatus
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            InvestmentHistoryTransactionStatus.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this InvestmentHistoryTransactionStatus to JSON.
             * @function toJSON
             * @memberof api.external.InvestmentHistoryTransactionStatus
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            InvestmentHistoryTransactionStatus.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name api.external.InvestmentHistoryTransactionStatus.Enum
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} PENDING=1 PENDING value
             * @property {number} TRANSFERRING=2 TRANSFERRING value
             * @property {number} PAID=3 PAID value
             * @property {number} FAILED=4 FAILED value
             * @property {number} CANCELLED=5 CANCELLED value
             * @property {number} REJECTED=6 REJECTED value
             */
            InvestmentHistoryTransactionStatus.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "PENDING"] = 1;
                values[valuesById[2] = "TRANSFERRING"] = 2;
                values[valuesById[3] = "PAID"] = 3;
                values[valuesById[4] = "FAILED"] = 4;
                values[valuesById[5] = "CANCELLED"] = 5;
                values[valuesById[6] = "REJECTED"] = 6;
                return values;
            })();

            return InvestmentHistoryTransactionStatus;
        })();

        external.InvestmentHistoryDeposit = (function() {

            /**
             * Properties of an InvestmentHistoryDeposit.
             * @memberof api.external
             * @interface IInvestmentHistoryDeposit
             * @property {string|null} [transaction_reference] InvestmentHistoryDeposit transaction_reference
             * @property {IBankAccount|null} [bank_account] InvestmentHistoryDeposit bank_account
             * @property {string|null} [aud_amount] InvestmentHistoryDeposit aud_amount
             * @property {string|null} [unit_amount] InvestmentHistoryDeposit unit_amount
             * @property {string|null} [unit_price] InvestmentHistoryDeposit unit_price
             * @property {google.protobuf.ITimestamp|null} [units_granted_at] InvestmentHistoryDeposit units_granted_at
             * @property {api.external.InvestmentHistoryTransactionStatus.Enum|null} [status] InvestmentHistoryDeposit status
             * @property {SchedulerFrequency.Enum|null} [frequency] InvestmentHistoryDeposit frequency
             * @property {string|null} [estimated_execution_date] InvestmentHistoryDeposit estimated_execution_date
             * @property {google.protobuf.ITimestamp|null} [requested_at] InvestmentHistoryDeposit requested_at
             */

            /**
             * Constructs a new InvestmentHistoryDeposit.
             * @memberof api.external
             * @classdesc Represents an InvestmentHistoryDeposit.
             * @implements IInvestmentHistoryDeposit
             * @constructor
             * @param {api.external.IInvestmentHistoryDeposit=} [properties] Properties to set
             */
            function InvestmentHistoryDeposit(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * InvestmentHistoryDeposit transaction_reference.
             * @member {string} transaction_reference
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.transaction_reference = "";

            /**
             * InvestmentHistoryDeposit bank_account.
             * @member {IBankAccount|null|undefined} bank_account
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.bank_account = null;

            /**
             * InvestmentHistoryDeposit aud_amount.
             * @member {string} aud_amount
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.aud_amount = "";

            /**
             * InvestmentHistoryDeposit unit_amount.
             * @member {string} unit_amount
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.unit_amount = "";

            /**
             * InvestmentHistoryDeposit unit_price.
             * @member {string} unit_price
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.unit_price = "";

            /**
             * InvestmentHistoryDeposit units_granted_at.
             * @member {google.protobuf.ITimestamp|null|undefined} units_granted_at
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.units_granted_at = null;

            /**
             * InvestmentHistoryDeposit status.
             * @member {api.external.InvestmentHistoryTransactionStatus.Enum} status
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.status = 0;

            /**
             * InvestmentHistoryDeposit frequency.
             * @member {SchedulerFrequency.Enum} frequency
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.frequency = 0;

            /**
             * InvestmentHistoryDeposit estimated_execution_date.
             * @member {string} estimated_execution_date
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.estimated_execution_date = "";

            /**
             * InvestmentHistoryDeposit requested_at.
             * @member {google.protobuf.ITimestamp|null|undefined} requested_at
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             */
            InvestmentHistoryDeposit.prototype.requested_at = null;

            /**
             * Creates a new InvestmentHistoryDeposit instance using the specified properties.
             * @function create
             * @memberof api.external.InvestmentHistoryDeposit
             * @static
             * @param {api.external.IInvestmentHistoryDeposit=} [properties] Properties to set
             * @returns {api.external.InvestmentHistoryDeposit} InvestmentHistoryDeposit instance
             */
            InvestmentHistoryDeposit.create = function create(properties) {
                return new InvestmentHistoryDeposit(properties);
            };

            /**
             * Encodes the specified InvestmentHistoryDeposit message. Does not implicitly {@link api.external.InvestmentHistoryDeposit.verify|verify} messages.
             * @function encode
             * @memberof api.external.InvestmentHistoryDeposit
             * @static
             * @param {api.external.IInvestmentHistoryDeposit} message InvestmentHistoryDeposit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InvestmentHistoryDeposit.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
                if (message.bank_account != null && message.hasOwnProperty("bank_account"))
                    $root.BankAccount.encode(message.bank_account, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.aud_amount);
                if (message.unit_amount != null && message.hasOwnProperty("unit_amount"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.unit_amount);
                if (message.unit_price != null && message.hasOwnProperty("unit_price"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.unit_price);
                if (message.units_granted_at != null && message.hasOwnProperty("units_granted_at"))
                    $root.google.protobuf.Timestamp.encode(message.units_granted_at, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.status != null && message.hasOwnProperty("status"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
                if (message.frequency != null && message.hasOwnProperty("frequency"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.frequency);
                if (message.estimated_execution_date != null && message.hasOwnProperty("estimated_execution_date"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.estimated_execution_date);
                if (message.requested_at != null && message.hasOwnProperty("requested_at"))
                    $root.google.protobuf.Timestamp.encode(message.requested_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified InvestmentHistoryDeposit message, length delimited. Does not implicitly {@link api.external.InvestmentHistoryDeposit.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.InvestmentHistoryDeposit
             * @static
             * @param {api.external.IInvestmentHistoryDeposit} message InvestmentHistoryDeposit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InvestmentHistoryDeposit.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an InvestmentHistoryDeposit message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.InvestmentHistoryDeposit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.InvestmentHistoryDeposit} InvestmentHistoryDeposit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InvestmentHistoryDeposit.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.InvestmentHistoryDeposit();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction_reference = reader.string();
                        break;
                    case 2:
                        message.bank_account = $root.BankAccount.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.aud_amount = reader.string();
                        break;
                    case 4:
                        message.unit_amount = reader.string();
                        break;
                    case 5:
                        message.unit_price = reader.string();
                        break;
                    case 6:
                        message.units_granted_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 7:
                        message.status = reader.int32();
                        break;
                    case 8:
                        message.frequency = reader.int32();
                        break;
                    case 9:
                        message.estimated_execution_date = reader.string();
                        break;
                    case 99:
                        message.requested_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an InvestmentHistoryDeposit message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.InvestmentHistoryDeposit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.InvestmentHistoryDeposit} InvestmentHistoryDeposit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InvestmentHistoryDeposit.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an InvestmentHistoryDeposit message.
             * @function verify
             * @memberof api.external.InvestmentHistoryDeposit
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            InvestmentHistoryDeposit.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    if (!$util.isString(message.transaction_reference))
                        return "transaction_reference: string expected";
                if (message.bank_account != null && message.hasOwnProperty("bank_account")) {
                    let error = $root.BankAccount.verify(message.bank_account);
                    if (error)
                        return "bank_account." + error;
                }
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    if (!$util.isString(message.aud_amount))
                        return "aud_amount: string expected";
                if (message.unit_amount != null && message.hasOwnProperty("unit_amount"))
                    if (!$util.isString(message.unit_amount))
                        return "unit_amount: string expected";
                if (message.unit_price != null && message.hasOwnProperty("unit_price"))
                    if (!$util.isString(message.unit_price))
                        return "unit_price: string expected";
                if (message.units_granted_at != null && message.hasOwnProperty("units_granted_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.units_granted_at);
                    if (error)
                        return "units_granted_at." + error;
                }
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                        break;
                    }
                if (message.frequency != null && message.hasOwnProperty("frequency"))
                    switch (message.frequency) {
                    default:
                        return "frequency: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.estimated_execution_date != null && message.hasOwnProperty("estimated_execution_date"))
                    if (!$util.isString(message.estimated_execution_date))
                        return "estimated_execution_date: string expected";
                if (message.requested_at != null && message.hasOwnProperty("requested_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.requested_at);
                    if (error)
                        return "requested_at." + error;
                }
                return null;
            };

            /**
             * Creates an InvestmentHistoryDeposit message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.InvestmentHistoryDeposit
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.InvestmentHistoryDeposit} InvestmentHistoryDeposit
             */
            InvestmentHistoryDeposit.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.InvestmentHistoryDeposit)
                    return object;
                let message = new $root.api.external.InvestmentHistoryDeposit();
                if (object.transaction_reference != null)
                    message.transaction_reference = String(object.transaction_reference);
                if (object.bank_account != null) {
                    if (typeof object.bank_account !== "object")
                        throw TypeError(".api.external.InvestmentHistoryDeposit.bank_account: object expected");
                    message.bank_account = $root.BankAccount.fromObject(object.bank_account);
                }
                if (object.aud_amount != null)
                    message.aud_amount = String(object.aud_amount);
                if (object.unit_amount != null)
                    message.unit_amount = String(object.unit_amount);
                if (object.unit_price != null)
                    message.unit_price = String(object.unit_price);
                if (object.units_granted_at != null) {
                    if (typeof object.units_granted_at !== "object")
                        throw TypeError(".api.external.InvestmentHistoryDeposit.units_granted_at: object expected");
                    message.units_granted_at = $root.google.protobuf.Timestamp.fromObject(object.units_granted_at);
                }
                switch (object.status) {
                case "UNKNOWN":
                case 0:
                    message.status = 0;
                    break;
                case "PENDING":
                case 1:
                    message.status = 1;
                    break;
                case "TRANSFERRING":
                case 2:
                    message.status = 2;
                    break;
                case "PAID":
                case 3:
                    message.status = 3;
                    break;
                case "FAILED":
                case 4:
                    message.status = 4;
                    break;
                case "CANCELLED":
                case 5:
                    message.status = 5;
                    break;
                case "REJECTED":
                case 6:
                    message.status = 6;
                    break;
                }
                switch (object.frequency) {
                case "UNKNOWN":
                case 0:
                    message.frequency = 0;
                    break;
                case "ONE_TIME":
                case 1:
                    message.frequency = 1;
                    break;
                case "WEEKLY":
                case 2:
                    message.frequency = 2;
                    break;
                case "FORTNIGHTLY":
                case 3:
                    message.frequency = 3;
                    break;
                case "MONTHLY":
                case 4:
                    message.frequency = 4;
                    break;
                }
                if (object.estimated_execution_date != null)
                    message.estimated_execution_date = String(object.estimated_execution_date);
                if (object.requested_at != null) {
                    if (typeof object.requested_at !== "object")
                        throw TypeError(".api.external.InvestmentHistoryDeposit.requested_at: object expected");
                    message.requested_at = $root.google.protobuf.Timestamp.fromObject(object.requested_at);
                }
                return message;
            };

            /**
             * Creates a plain object from an InvestmentHistoryDeposit message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.InvestmentHistoryDeposit
             * @static
             * @param {api.external.InvestmentHistoryDeposit} message InvestmentHistoryDeposit
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            InvestmentHistoryDeposit.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.transaction_reference = "";
                    object.bank_account = null;
                    object.aud_amount = "";
                    object.unit_amount = "";
                    object.unit_price = "";
                    object.units_granted_at = null;
                    object.status = options.enums === String ? "UNKNOWN" : 0;
                    object.frequency = options.enums === String ? "UNKNOWN" : 0;
                    object.estimated_execution_date = "";
                    object.requested_at = null;
                }
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    object.transaction_reference = message.transaction_reference;
                if (message.bank_account != null && message.hasOwnProperty("bank_account"))
                    object.bank_account = $root.BankAccount.toObject(message.bank_account, options);
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    object.aud_amount = message.aud_amount;
                if (message.unit_amount != null && message.hasOwnProperty("unit_amount"))
                    object.unit_amount = message.unit_amount;
                if (message.unit_price != null && message.hasOwnProperty("unit_price"))
                    object.unit_price = message.unit_price;
                if (message.units_granted_at != null && message.hasOwnProperty("units_granted_at"))
                    object.units_granted_at = $root.google.protobuf.Timestamp.toObject(message.units_granted_at, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.api.external.InvestmentHistoryTransactionStatus.Enum[message.status] : message.status;
                if (message.frequency != null && message.hasOwnProperty("frequency"))
                    object.frequency = options.enums === String ? $root.SchedulerFrequency.Enum[message.frequency] : message.frequency;
                if (message.estimated_execution_date != null && message.hasOwnProperty("estimated_execution_date"))
                    object.estimated_execution_date = message.estimated_execution_date;
                if (message.requested_at != null && message.hasOwnProperty("requested_at"))
                    object.requested_at = $root.google.protobuf.Timestamp.toObject(message.requested_at, options);
                return object;
            };

            /**
             * Converts this InvestmentHistoryDeposit to JSON.
             * @function toJSON
             * @memberof api.external.InvestmentHistoryDeposit
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            InvestmentHistoryDeposit.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return InvestmentHistoryDeposit;
        })();

        external.InvestmentHistoryWithdrawal = (function() {

            /**
             * Properties of an InvestmentHistoryWithdrawal.
             * @memberof api.external
             * @interface IInvestmentHistoryWithdrawal
             * @property {string|null} [transaction_reference] InvestmentHistoryWithdrawal transaction_reference
             * @property {IBankAccount|null} [bank_account] InvestmentHistoryWithdrawal bank_account
             * @property {string|null} [aud_amount] InvestmentHistoryWithdrawal aud_amount
             * @property {string|null} [unit_amount] InvestmentHistoryWithdrawal unit_amount
             * @property {string|null} [unit_price] InvestmentHistoryWithdrawal unit_price
             * @property {google.protobuf.ITimestamp|null} [units_redeemed_at] InvestmentHistoryWithdrawal units_redeemed_at
             * @property {api.external.InvestmentHistoryTransactionStatus.Enum|null} [status] InvestmentHistoryWithdrawal status
             * @property {google.protobuf.ITimestamp|null} [requested_at] InvestmentHistoryWithdrawal requested_at
             */

            /**
             * Constructs a new InvestmentHistoryWithdrawal.
             * @memberof api.external
             * @classdesc Represents an InvestmentHistoryWithdrawal.
             * @implements IInvestmentHistoryWithdrawal
             * @constructor
             * @param {api.external.IInvestmentHistoryWithdrawal=} [properties] Properties to set
             */
            function InvestmentHistoryWithdrawal(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * InvestmentHistoryWithdrawal transaction_reference.
             * @member {string} transaction_reference
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             */
            InvestmentHistoryWithdrawal.prototype.transaction_reference = "";

            /**
             * InvestmentHistoryWithdrawal bank_account.
             * @member {IBankAccount|null|undefined} bank_account
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             */
            InvestmentHistoryWithdrawal.prototype.bank_account = null;

            /**
             * InvestmentHistoryWithdrawal aud_amount.
             * @member {string} aud_amount
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             */
            InvestmentHistoryWithdrawal.prototype.aud_amount = "";

            /**
             * InvestmentHistoryWithdrawal unit_amount.
             * @member {string} unit_amount
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             */
            InvestmentHistoryWithdrawal.prototype.unit_amount = "";

            /**
             * InvestmentHistoryWithdrawal unit_price.
             * @member {string} unit_price
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             */
            InvestmentHistoryWithdrawal.prototype.unit_price = "";

            /**
             * InvestmentHistoryWithdrawal units_redeemed_at.
             * @member {google.protobuf.ITimestamp|null|undefined} units_redeemed_at
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             */
            InvestmentHistoryWithdrawal.prototype.units_redeemed_at = null;

            /**
             * InvestmentHistoryWithdrawal status.
             * @member {api.external.InvestmentHistoryTransactionStatus.Enum} status
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             */
            InvestmentHistoryWithdrawal.prototype.status = 0;

            /**
             * InvestmentHistoryWithdrawal requested_at.
             * @member {google.protobuf.ITimestamp|null|undefined} requested_at
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             */
            InvestmentHistoryWithdrawal.prototype.requested_at = null;

            /**
             * Creates a new InvestmentHistoryWithdrawal instance using the specified properties.
             * @function create
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @static
             * @param {api.external.IInvestmentHistoryWithdrawal=} [properties] Properties to set
             * @returns {api.external.InvestmentHistoryWithdrawal} InvestmentHistoryWithdrawal instance
             */
            InvestmentHistoryWithdrawal.create = function create(properties) {
                return new InvestmentHistoryWithdrawal(properties);
            };

            /**
             * Encodes the specified InvestmentHistoryWithdrawal message. Does not implicitly {@link api.external.InvestmentHistoryWithdrawal.verify|verify} messages.
             * @function encode
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @static
             * @param {api.external.IInvestmentHistoryWithdrawal} message InvestmentHistoryWithdrawal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InvestmentHistoryWithdrawal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
                if (message.bank_account != null && message.hasOwnProperty("bank_account"))
                    $root.BankAccount.encode(message.bank_account, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.aud_amount);
                if (message.unit_amount != null && message.hasOwnProperty("unit_amount"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.unit_amount);
                if (message.unit_price != null && message.hasOwnProperty("unit_price"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.unit_price);
                if (message.units_redeemed_at != null && message.hasOwnProperty("units_redeemed_at"))
                    $root.google.protobuf.Timestamp.encode(message.units_redeemed_at, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.status != null && message.hasOwnProperty("status"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
                if (message.requested_at != null && message.hasOwnProperty("requested_at"))
                    $root.google.protobuf.Timestamp.encode(message.requested_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified InvestmentHistoryWithdrawal message, length delimited. Does not implicitly {@link api.external.InvestmentHistoryWithdrawal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @static
             * @param {api.external.IInvestmentHistoryWithdrawal} message InvestmentHistoryWithdrawal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InvestmentHistoryWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an InvestmentHistoryWithdrawal message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.InvestmentHistoryWithdrawal} InvestmentHistoryWithdrawal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InvestmentHistoryWithdrawal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.InvestmentHistoryWithdrawal();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction_reference = reader.string();
                        break;
                    case 2:
                        message.bank_account = $root.BankAccount.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.aud_amount = reader.string();
                        break;
                    case 4:
                        message.unit_amount = reader.string();
                        break;
                    case 5:
                        message.unit_price = reader.string();
                        break;
                    case 6:
                        message.units_redeemed_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 7:
                        message.status = reader.int32();
                        break;
                    case 99:
                        message.requested_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an InvestmentHistoryWithdrawal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.InvestmentHistoryWithdrawal} InvestmentHistoryWithdrawal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InvestmentHistoryWithdrawal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an InvestmentHistoryWithdrawal message.
             * @function verify
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            InvestmentHistoryWithdrawal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    if (!$util.isString(message.transaction_reference))
                        return "transaction_reference: string expected";
                if (message.bank_account != null && message.hasOwnProperty("bank_account")) {
                    let error = $root.BankAccount.verify(message.bank_account);
                    if (error)
                        return "bank_account." + error;
                }
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    if (!$util.isString(message.aud_amount))
                        return "aud_amount: string expected";
                if (message.unit_amount != null && message.hasOwnProperty("unit_amount"))
                    if (!$util.isString(message.unit_amount))
                        return "unit_amount: string expected";
                if (message.unit_price != null && message.hasOwnProperty("unit_price"))
                    if (!$util.isString(message.unit_price))
                        return "unit_price: string expected";
                if (message.units_redeemed_at != null && message.hasOwnProperty("units_redeemed_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.units_redeemed_at);
                    if (error)
                        return "units_redeemed_at." + error;
                }
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                        break;
                    }
                if (message.requested_at != null && message.hasOwnProperty("requested_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.requested_at);
                    if (error)
                        return "requested_at." + error;
                }
                return null;
            };

            /**
             * Creates an InvestmentHistoryWithdrawal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.InvestmentHistoryWithdrawal} InvestmentHistoryWithdrawal
             */
            InvestmentHistoryWithdrawal.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.InvestmentHistoryWithdrawal)
                    return object;
                let message = new $root.api.external.InvestmentHistoryWithdrawal();
                if (object.transaction_reference != null)
                    message.transaction_reference = String(object.transaction_reference);
                if (object.bank_account != null) {
                    if (typeof object.bank_account !== "object")
                        throw TypeError(".api.external.InvestmentHistoryWithdrawal.bank_account: object expected");
                    message.bank_account = $root.BankAccount.fromObject(object.bank_account);
                }
                if (object.aud_amount != null)
                    message.aud_amount = String(object.aud_amount);
                if (object.unit_amount != null)
                    message.unit_amount = String(object.unit_amount);
                if (object.unit_price != null)
                    message.unit_price = String(object.unit_price);
                if (object.units_redeemed_at != null) {
                    if (typeof object.units_redeemed_at !== "object")
                        throw TypeError(".api.external.InvestmentHistoryWithdrawal.units_redeemed_at: object expected");
                    message.units_redeemed_at = $root.google.protobuf.Timestamp.fromObject(object.units_redeemed_at);
                }
                switch (object.status) {
                case "UNKNOWN":
                case 0:
                    message.status = 0;
                    break;
                case "PENDING":
                case 1:
                    message.status = 1;
                    break;
                case "TRANSFERRING":
                case 2:
                    message.status = 2;
                    break;
                case "PAID":
                case 3:
                    message.status = 3;
                    break;
                case "FAILED":
                case 4:
                    message.status = 4;
                    break;
                case "CANCELLED":
                case 5:
                    message.status = 5;
                    break;
                case "REJECTED":
                case 6:
                    message.status = 6;
                    break;
                }
                if (object.requested_at != null) {
                    if (typeof object.requested_at !== "object")
                        throw TypeError(".api.external.InvestmentHistoryWithdrawal.requested_at: object expected");
                    message.requested_at = $root.google.protobuf.Timestamp.fromObject(object.requested_at);
                }
                return message;
            };

            /**
             * Creates a plain object from an InvestmentHistoryWithdrawal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @static
             * @param {api.external.InvestmentHistoryWithdrawal} message InvestmentHistoryWithdrawal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            InvestmentHistoryWithdrawal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.transaction_reference = "";
                    object.bank_account = null;
                    object.aud_amount = "";
                    object.unit_amount = "";
                    object.unit_price = "";
                    object.units_redeemed_at = null;
                    object.status = options.enums === String ? "UNKNOWN" : 0;
                    object.requested_at = null;
                }
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    object.transaction_reference = message.transaction_reference;
                if (message.bank_account != null && message.hasOwnProperty("bank_account"))
                    object.bank_account = $root.BankAccount.toObject(message.bank_account, options);
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    object.aud_amount = message.aud_amount;
                if (message.unit_amount != null && message.hasOwnProperty("unit_amount"))
                    object.unit_amount = message.unit_amount;
                if (message.unit_price != null && message.hasOwnProperty("unit_price"))
                    object.unit_price = message.unit_price;
                if (message.units_redeemed_at != null && message.hasOwnProperty("units_redeemed_at"))
                    object.units_redeemed_at = $root.google.protobuf.Timestamp.toObject(message.units_redeemed_at, options);
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.api.external.InvestmentHistoryTransactionStatus.Enum[message.status] : message.status;
                if (message.requested_at != null && message.hasOwnProperty("requested_at"))
                    object.requested_at = $root.google.protobuf.Timestamp.toObject(message.requested_at, options);
                return object;
            };

            /**
             * Converts this InvestmentHistoryWithdrawal to JSON.
             * @function toJSON
             * @memberof api.external.InvestmentHistoryWithdrawal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            InvestmentHistoryWithdrawal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return InvestmentHistoryWithdrawal;
        })();

        external.CreateSaverAccountRequestBody = (function() {

            /**
             * Properties of a CreateSaverAccountRequestBody.
             * @memberof api.external
             * @interface ICreateSaverAccountRequestBody
             * @property {SaverPortfolio.Enum|null} [portfolio] CreateSaverAccountRequestBody portfolio
             * @property {string|null} [source_bsb] CreateSaverAccountRequestBody source_bsb
             * @property {string|null} [source_account_number] CreateSaverAccountRequestBody source_account_number
             * @property {string|null} [source_account_friendly_name] CreateSaverAccountRequestBody source_account_friendly_name
             * @property {string|null} [bank_statements_user_token] CreateSaverAccountRequestBody bank_statements_user_token
             * @property {string|null} [source_account_name] CreateSaverAccountRequestBody source_account_name
             * @property {string|null} [documents_accepted_at] CreateSaverAccountRequestBody documents_accepted_at
             */

            /**
             * Constructs a new CreateSaverAccountRequestBody.
             * @memberof api.external
             * @classdesc Represents a CreateSaverAccountRequestBody.
             * @implements ICreateSaverAccountRequestBody
             * @constructor
             * @param {api.external.ICreateSaverAccountRequestBody=} [properties] Properties to set
             */
            function CreateSaverAccountRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateSaverAccountRequestBody portfolio.
             * @member {SaverPortfolio.Enum} portfolio
             * @memberof api.external.CreateSaverAccountRequestBody
             * @instance
             */
            CreateSaverAccountRequestBody.prototype.portfolio = 0;

            /**
             * CreateSaverAccountRequestBody source_bsb.
             * @member {string} source_bsb
             * @memberof api.external.CreateSaverAccountRequestBody
             * @instance
             */
            CreateSaverAccountRequestBody.prototype.source_bsb = "";

            /**
             * CreateSaverAccountRequestBody source_account_number.
             * @member {string} source_account_number
             * @memberof api.external.CreateSaverAccountRequestBody
             * @instance
             */
            CreateSaverAccountRequestBody.prototype.source_account_number = "";

            /**
             * CreateSaverAccountRequestBody source_account_friendly_name.
             * @member {string} source_account_friendly_name
             * @memberof api.external.CreateSaverAccountRequestBody
             * @instance
             */
            CreateSaverAccountRequestBody.prototype.source_account_friendly_name = "";

            /**
             * CreateSaverAccountRequestBody bank_statements_user_token.
             * @member {string} bank_statements_user_token
             * @memberof api.external.CreateSaverAccountRequestBody
             * @instance
             */
            CreateSaverAccountRequestBody.prototype.bank_statements_user_token = "";

            /**
             * CreateSaverAccountRequestBody source_account_name.
             * @member {string} source_account_name
             * @memberof api.external.CreateSaverAccountRequestBody
             * @instance
             */
            CreateSaverAccountRequestBody.prototype.source_account_name = "";

            /**
             * CreateSaverAccountRequestBody documents_accepted_at.
             * @member {string} documents_accepted_at
             * @memberof api.external.CreateSaverAccountRequestBody
             * @instance
             */
            CreateSaverAccountRequestBody.prototype.documents_accepted_at = "";

            /**
             * Creates a new CreateSaverAccountRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateSaverAccountRequestBody
             * @static
             * @param {api.external.ICreateSaverAccountRequestBody=} [properties] Properties to set
             * @returns {api.external.CreateSaverAccountRequestBody} CreateSaverAccountRequestBody instance
             */
            CreateSaverAccountRequestBody.create = function create(properties) {
                return new CreateSaverAccountRequestBody(properties);
            };

            /**
             * Encodes the specified CreateSaverAccountRequestBody message. Does not implicitly {@link api.external.CreateSaverAccountRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateSaverAccountRequestBody
             * @static
             * @param {api.external.ICreateSaverAccountRequestBody} message CreateSaverAccountRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSaverAccountRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
                if (message.source_bsb != null && message.hasOwnProperty("source_bsb"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.source_bsb);
                if (message.source_account_number != null && message.hasOwnProperty("source_account_number"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.source_account_number);
                if (message.source_account_friendly_name != null && message.hasOwnProperty("source_account_friendly_name"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.source_account_friendly_name);
                if (message.bank_statements_user_token != null && message.hasOwnProperty("bank_statements_user_token"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.bank_statements_user_token);
                if (message.source_account_name != null && message.hasOwnProperty("source_account_name"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.source_account_name);
                if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.documents_accepted_at);
                return writer;
            };

            /**
             * Encodes the specified CreateSaverAccountRequestBody message, length delimited. Does not implicitly {@link api.external.CreateSaverAccountRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateSaverAccountRequestBody
             * @static
             * @param {api.external.ICreateSaverAccountRequestBody} message CreateSaverAccountRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSaverAccountRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSaverAccountRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateSaverAccountRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateSaverAccountRequestBody} CreateSaverAccountRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSaverAccountRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateSaverAccountRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.portfolio = reader.int32();
                        break;
                    case 2:
                        message.source_bsb = reader.string();
                        break;
                    case 3:
                        message.source_account_number = reader.string();
                        break;
                    case 4:
                        message.source_account_friendly_name = reader.string();
                        break;
                    case 5:
                        message.bank_statements_user_token = reader.string();
                        break;
                    case 6:
                        message.source_account_name = reader.string();
                        break;
                    case 7:
                        message.documents_accepted_at = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSaverAccountRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateSaverAccountRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateSaverAccountRequestBody} CreateSaverAccountRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSaverAccountRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSaverAccountRequestBody message.
             * @function verify
             * @memberof api.external.CreateSaverAccountRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSaverAccountRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    switch (message.portfolio) {
                    default:
                        return "portfolio: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.source_bsb != null && message.hasOwnProperty("source_bsb"))
                    if (!$util.isString(message.source_bsb))
                        return "source_bsb: string expected";
                if (message.source_account_number != null && message.hasOwnProperty("source_account_number"))
                    if (!$util.isString(message.source_account_number))
                        return "source_account_number: string expected";
                if (message.source_account_friendly_name != null && message.hasOwnProperty("source_account_friendly_name"))
                    if (!$util.isString(message.source_account_friendly_name))
                        return "source_account_friendly_name: string expected";
                if (message.bank_statements_user_token != null && message.hasOwnProperty("bank_statements_user_token"))
                    if (!$util.isString(message.bank_statements_user_token))
                        return "bank_statements_user_token: string expected";
                if (message.source_account_name != null && message.hasOwnProperty("source_account_name"))
                    if (!$util.isString(message.source_account_name))
                        return "source_account_name: string expected";
                if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at"))
                    if (!$util.isString(message.documents_accepted_at))
                        return "documents_accepted_at: string expected";
                return null;
            };

            /**
             * Creates a CreateSaverAccountRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateSaverAccountRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateSaverAccountRequestBody} CreateSaverAccountRequestBody
             */
            CreateSaverAccountRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateSaverAccountRequestBody)
                    return object;
                let message = new $root.api.external.CreateSaverAccountRequestBody();
                switch (object.portfolio) {
                case "UNKNOWN":
                case 0:
                    message.portfolio = 0;
                    break;
                case "INDEX":
                case 1:
                    message.portfolio = 1;
                    break;
                case "UNIVERSE":
                case 2:
                    message.portfolio = 2;
                    break;
                case "EARTH":
                case 3:
                    message.portfolio = 3;
                    break;
                case "GALAXY":
                case 4:
                    message.portfolio = 4;
                    break;
                case "EXPLORER":
                case 5:
                    message.portfolio = 5;
                    break;
                }
                if (object.source_bsb != null)
                    message.source_bsb = String(object.source_bsb);
                if (object.source_account_number != null)
                    message.source_account_number = String(object.source_account_number);
                if (object.source_account_friendly_name != null)
                    message.source_account_friendly_name = String(object.source_account_friendly_name);
                if (object.bank_statements_user_token != null)
                    message.bank_statements_user_token = String(object.bank_statements_user_token);
                if (object.source_account_name != null)
                    message.source_account_name = String(object.source_account_name);
                if (object.documents_accepted_at != null)
                    message.documents_accepted_at = String(object.documents_accepted_at);
                return message;
            };

            /**
             * Creates a plain object from a CreateSaverAccountRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateSaverAccountRequestBody
             * @static
             * @param {api.external.CreateSaverAccountRequestBody} message CreateSaverAccountRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSaverAccountRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.portfolio = options.enums === String ? "UNKNOWN" : 0;
                    object.source_bsb = "";
                    object.source_account_number = "";
                    object.source_account_friendly_name = "";
                    object.bank_statements_user_token = "";
                    object.source_account_name = "";
                    object.documents_accepted_at = "";
                }
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
                if (message.source_bsb != null && message.hasOwnProperty("source_bsb"))
                    object.source_bsb = message.source_bsb;
                if (message.source_account_number != null && message.hasOwnProperty("source_account_number"))
                    object.source_account_number = message.source_account_number;
                if (message.source_account_friendly_name != null && message.hasOwnProperty("source_account_friendly_name"))
                    object.source_account_friendly_name = message.source_account_friendly_name;
                if (message.bank_statements_user_token != null && message.hasOwnProperty("bank_statements_user_token"))
                    object.bank_statements_user_token = message.bank_statements_user_token;
                if (message.source_account_name != null && message.hasOwnProperty("source_account_name"))
                    object.source_account_name = message.source_account_name;
                if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at"))
                    object.documents_accepted_at = message.documents_accepted_at;
                return object;
            };

            /**
             * Converts this CreateSaverAccountRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateSaverAccountRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSaverAccountRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateSaverAccountRequestBody;
        })();

        external.CreateSaverAccountResponseBody = (function() {

            /**
             * Properties of a CreateSaverAccountResponseBody.
             * @memberof api.external
             * @interface ICreateSaverAccountResponseBody
             */

            /**
             * Constructs a new CreateSaverAccountResponseBody.
             * @memberof api.external
             * @classdesc Represents a CreateSaverAccountResponseBody.
             * @implements ICreateSaverAccountResponseBody
             * @constructor
             * @param {api.external.ICreateSaverAccountResponseBody=} [properties] Properties to set
             */
            function CreateSaverAccountResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateSaverAccountResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateSaverAccountResponseBody
             * @static
             * @param {api.external.ICreateSaverAccountResponseBody=} [properties] Properties to set
             * @returns {api.external.CreateSaverAccountResponseBody} CreateSaverAccountResponseBody instance
             */
            CreateSaverAccountResponseBody.create = function create(properties) {
                return new CreateSaverAccountResponseBody(properties);
            };

            /**
             * Encodes the specified CreateSaverAccountResponseBody message. Does not implicitly {@link api.external.CreateSaverAccountResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateSaverAccountResponseBody
             * @static
             * @param {api.external.ICreateSaverAccountResponseBody} message CreateSaverAccountResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSaverAccountResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateSaverAccountResponseBody message, length delimited. Does not implicitly {@link api.external.CreateSaverAccountResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateSaverAccountResponseBody
             * @static
             * @param {api.external.ICreateSaverAccountResponseBody} message CreateSaverAccountResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSaverAccountResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSaverAccountResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateSaverAccountResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateSaverAccountResponseBody} CreateSaverAccountResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSaverAccountResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateSaverAccountResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSaverAccountResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateSaverAccountResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateSaverAccountResponseBody} CreateSaverAccountResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSaverAccountResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSaverAccountResponseBody message.
             * @function verify
             * @memberof api.external.CreateSaverAccountResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSaverAccountResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateSaverAccountResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateSaverAccountResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateSaverAccountResponseBody} CreateSaverAccountResponseBody
             */
            CreateSaverAccountResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateSaverAccountResponseBody)
                    return object;
                return new $root.api.external.CreateSaverAccountResponseBody();
            };

            /**
             * Creates a plain object from a CreateSaverAccountResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateSaverAccountResponseBody
             * @static
             * @param {api.external.CreateSaverAccountResponseBody} message CreateSaverAccountResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSaverAccountResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateSaverAccountResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateSaverAccountResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSaverAccountResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateSaverAccountResponseBody;
        })();

        external.UpdateSourceBankAccountRequestBody = (function() {

            /**
             * Properties of an UpdateSourceBankAccountRequestBody.
             * @memberof api.external
             * @interface IUpdateSourceBankAccountRequestBody
             * @property {string|null} [source_bsb] UpdateSourceBankAccountRequestBody source_bsb
             * @property {string|null} [source_account_number] UpdateSourceBankAccountRequestBody source_account_number
             * @property {string|null} [source_account_friendly_name] UpdateSourceBankAccountRequestBody source_account_friendly_name
             * @property {string|null} [bank_statements_user_token] UpdateSourceBankAccountRequestBody bank_statements_user_token
             * @property {string|null} [source_account_name] UpdateSourceBankAccountRequestBody source_account_name
             */

            /**
             * Constructs a new UpdateSourceBankAccountRequestBody.
             * @memberof api.external
             * @classdesc Represents an UpdateSourceBankAccountRequestBody.
             * @implements IUpdateSourceBankAccountRequestBody
             * @constructor
             * @param {api.external.IUpdateSourceBankAccountRequestBody=} [properties] Properties to set
             */
            function UpdateSourceBankAccountRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdateSourceBankAccountRequestBody source_bsb.
             * @member {string} source_bsb
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @instance
             */
            UpdateSourceBankAccountRequestBody.prototype.source_bsb = "";

            /**
             * UpdateSourceBankAccountRequestBody source_account_number.
             * @member {string} source_account_number
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @instance
             */
            UpdateSourceBankAccountRequestBody.prototype.source_account_number = "";

            /**
             * UpdateSourceBankAccountRequestBody source_account_friendly_name.
             * @member {string} source_account_friendly_name
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @instance
             */
            UpdateSourceBankAccountRequestBody.prototype.source_account_friendly_name = "";

            /**
             * UpdateSourceBankAccountRequestBody bank_statements_user_token.
             * @member {string} bank_statements_user_token
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @instance
             */
            UpdateSourceBankAccountRequestBody.prototype.bank_statements_user_token = "";

            /**
             * UpdateSourceBankAccountRequestBody source_account_name.
             * @member {string} source_account_name
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @instance
             */
            UpdateSourceBankAccountRequestBody.prototype.source_account_name = "";

            /**
             * Creates a new UpdateSourceBankAccountRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @static
             * @param {api.external.IUpdateSourceBankAccountRequestBody=} [properties] Properties to set
             * @returns {api.external.UpdateSourceBankAccountRequestBody} UpdateSourceBankAccountRequestBody instance
             */
            UpdateSourceBankAccountRequestBody.create = function create(properties) {
                return new UpdateSourceBankAccountRequestBody(properties);
            };

            /**
             * Encodes the specified UpdateSourceBankAccountRequestBody message. Does not implicitly {@link api.external.UpdateSourceBankAccountRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @static
             * @param {api.external.IUpdateSourceBankAccountRequestBody} message UpdateSourceBankAccountRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSourceBankAccountRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.source_bsb != null && message.hasOwnProperty("source_bsb"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.source_bsb);
                if (message.source_account_number != null && message.hasOwnProperty("source_account_number"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.source_account_number);
                if (message.source_account_friendly_name != null && message.hasOwnProperty("source_account_friendly_name"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.source_account_friendly_name);
                if (message.bank_statements_user_token != null && message.hasOwnProperty("bank_statements_user_token"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.bank_statements_user_token);
                if (message.source_account_name != null && message.hasOwnProperty("source_account_name"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.source_account_name);
                return writer;
            };

            /**
             * Encodes the specified UpdateSourceBankAccountRequestBody message, length delimited. Does not implicitly {@link api.external.UpdateSourceBankAccountRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @static
             * @param {api.external.IUpdateSourceBankAccountRequestBody} message UpdateSourceBankAccountRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSourceBankAccountRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateSourceBankAccountRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateSourceBankAccountRequestBody} UpdateSourceBankAccountRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSourceBankAccountRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateSourceBankAccountRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.source_bsb = reader.string();
                        break;
                    case 2:
                        message.source_account_number = reader.string();
                        break;
                    case 3:
                        message.source_account_friendly_name = reader.string();
                        break;
                    case 4:
                        message.bank_statements_user_token = reader.string();
                        break;
                    case 5:
                        message.source_account_name = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateSourceBankAccountRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateSourceBankAccountRequestBody} UpdateSourceBankAccountRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSourceBankAccountRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateSourceBankAccountRequestBody message.
             * @function verify
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateSourceBankAccountRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.source_bsb != null && message.hasOwnProperty("source_bsb"))
                    if (!$util.isString(message.source_bsb))
                        return "source_bsb: string expected";
                if (message.source_account_number != null && message.hasOwnProperty("source_account_number"))
                    if (!$util.isString(message.source_account_number))
                        return "source_account_number: string expected";
                if (message.source_account_friendly_name != null && message.hasOwnProperty("source_account_friendly_name"))
                    if (!$util.isString(message.source_account_friendly_name))
                        return "source_account_friendly_name: string expected";
                if (message.bank_statements_user_token != null && message.hasOwnProperty("bank_statements_user_token"))
                    if (!$util.isString(message.bank_statements_user_token))
                        return "bank_statements_user_token: string expected";
                if (message.source_account_name != null && message.hasOwnProperty("source_account_name"))
                    if (!$util.isString(message.source_account_name))
                        return "source_account_name: string expected";
                return null;
            };

            /**
             * Creates an UpdateSourceBankAccountRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateSourceBankAccountRequestBody} UpdateSourceBankAccountRequestBody
             */
            UpdateSourceBankAccountRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateSourceBankAccountRequestBody)
                    return object;
                let message = new $root.api.external.UpdateSourceBankAccountRequestBody();
                if (object.source_bsb != null)
                    message.source_bsb = String(object.source_bsb);
                if (object.source_account_number != null)
                    message.source_account_number = String(object.source_account_number);
                if (object.source_account_friendly_name != null)
                    message.source_account_friendly_name = String(object.source_account_friendly_name);
                if (object.bank_statements_user_token != null)
                    message.bank_statements_user_token = String(object.bank_statements_user_token);
                if (object.source_account_name != null)
                    message.source_account_name = String(object.source_account_name);
                return message;
            };

            /**
             * Creates a plain object from an UpdateSourceBankAccountRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @static
             * @param {api.external.UpdateSourceBankAccountRequestBody} message UpdateSourceBankAccountRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateSourceBankAccountRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.source_bsb = "";
                    object.source_account_number = "";
                    object.source_account_friendly_name = "";
                    object.bank_statements_user_token = "";
                    object.source_account_name = "";
                }
                if (message.source_bsb != null && message.hasOwnProperty("source_bsb"))
                    object.source_bsb = message.source_bsb;
                if (message.source_account_number != null && message.hasOwnProperty("source_account_number"))
                    object.source_account_number = message.source_account_number;
                if (message.source_account_friendly_name != null && message.hasOwnProperty("source_account_friendly_name"))
                    object.source_account_friendly_name = message.source_account_friendly_name;
                if (message.bank_statements_user_token != null && message.hasOwnProperty("bank_statements_user_token"))
                    object.bank_statements_user_token = message.bank_statements_user_token;
                if (message.source_account_name != null && message.hasOwnProperty("source_account_name"))
                    object.source_account_name = message.source_account_name;
                return object;
            };

            /**
             * Converts this UpdateSourceBankAccountRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateSourceBankAccountRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateSourceBankAccountRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateSourceBankAccountRequestBody;
        })();

        external.UpdateSourceBankAccountResponseBody = (function() {

            /**
             * Properties of an UpdateSourceBankAccountResponseBody.
             * @memberof api.external
             * @interface IUpdateSourceBankAccountResponseBody
             */

            /**
             * Constructs a new UpdateSourceBankAccountResponseBody.
             * @memberof api.external
             * @classdesc Represents an UpdateSourceBankAccountResponseBody.
             * @implements IUpdateSourceBankAccountResponseBody
             * @constructor
             * @param {api.external.IUpdateSourceBankAccountResponseBody=} [properties] Properties to set
             */
            function UpdateSourceBankAccountResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateSourceBankAccountResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @static
             * @param {api.external.IUpdateSourceBankAccountResponseBody=} [properties] Properties to set
             * @returns {api.external.UpdateSourceBankAccountResponseBody} UpdateSourceBankAccountResponseBody instance
             */
            UpdateSourceBankAccountResponseBody.create = function create(properties) {
                return new UpdateSourceBankAccountResponseBody(properties);
            };

            /**
             * Encodes the specified UpdateSourceBankAccountResponseBody message. Does not implicitly {@link api.external.UpdateSourceBankAccountResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @static
             * @param {api.external.IUpdateSourceBankAccountResponseBody} message UpdateSourceBankAccountResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSourceBankAccountResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateSourceBankAccountResponseBody message, length delimited. Does not implicitly {@link api.external.UpdateSourceBankAccountResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @static
             * @param {api.external.IUpdateSourceBankAccountResponseBody} message UpdateSourceBankAccountResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSourceBankAccountResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateSourceBankAccountResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateSourceBankAccountResponseBody} UpdateSourceBankAccountResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSourceBankAccountResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateSourceBankAccountResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateSourceBankAccountResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateSourceBankAccountResponseBody} UpdateSourceBankAccountResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSourceBankAccountResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateSourceBankAccountResponseBody message.
             * @function verify
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateSourceBankAccountResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateSourceBankAccountResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateSourceBankAccountResponseBody} UpdateSourceBankAccountResponseBody
             */
            UpdateSourceBankAccountResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateSourceBankAccountResponseBody)
                    return object;
                return new $root.api.external.UpdateSourceBankAccountResponseBody();
            };

            /**
             * Creates a plain object from an UpdateSourceBankAccountResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @static
             * @param {api.external.UpdateSourceBankAccountResponseBody} message UpdateSourceBankAccountResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateSourceBankAccountResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateSourceBankAccountResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateSourceBankAccountResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateSourceBankAccountResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateSourceBankAccountResponseBody;
        })();

        external.CancelAllPaymentSchedulesByPortfolioRequestBody = (function() {

            /**
             * Properties of a CancelAllPaymentSchedulesByPortfolioRequestBody.
             * @memberof api.external
             * @interface ICancelAllPaymentSchedulesByPortfolioRequestBody
             * @property {SaverPortfolio.Enum|null} [portfolio] CancelAllPaymentSchedulesByPortfolioRequestBody portfolio
             */

            /**
             * Constructs a new CancelAllPaymentSchedulesByPortfolioRequestBody.
             * @memberof api.external
             * @classdesc Represents a CancelAllPaymentSchedulesByPortfolioRequestBody.
             * @implements ICancelAllPaymentSchedulesByPortfolioRequestBody
             * @constructor
             * @param {api.external.ICancelAllPaymentSchedulesByPortfolioRequestBody=} [properties] Properties to set
             */
            function CancelAllPaymentSchedulesByPortfolioRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CancelAllPaymentSchedulesByPortfolioRequestBody portfolio.
             * @member {SaverPortfolio.Enum} portfolio
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @instance
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.prototype.portfolio = 0;

            /**
             * Creates a new CancelAllPaymentSchedulesByPortfolioRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @static
             * @param {api.external.ICancelAllPaymentSchedulesByPortfolioRequestBody=} [properties] Properties to set
             * @returns {api.external.CancelAllPaymentSchedulesByPortfolioRequestBody} CancelAllPaymentSchedulesByPortfolioRequestBody instance
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.create = function create(properties) {
                return new CancelAllPaymentSchedulesByPortfolioRequestBody(properties);
            };

            /**
             * Encodes the specified CancelAllPaymentSchedulesByPortfolioRequestBody message. Does not implicitly {@link api.external.CancelAllPaymentSchedulesByPortfolioRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @static
             * @param {api.external.ICancelAllPaymentSchedulesByPortfolioRequestBody} message CancelAllPaymentSchedulesByPortfolioRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
                return writer;
            };

            /**
             * Encodes the specified CancelAllPaymentSchedulesByPortfolioRequestBody message, length delimited. Does not implicitly {@link api.external.CancelAllPaymentSchedulesByPortfolioRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @static
             * @param {api.external.ICancelAllPaymentSchedulesByPortfolioRequestBody} message CancelAllPaymentSchedulesByPortfolioRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CancelAllPaymentSchedulesByPortfolioRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CancelAllPaymentSchedulesByPortfolioRequestBody} CancelAllPaymentSchedulesByPortfolioRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CancelAllPaymentSchedulesByPortfolioRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.portfolio = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CancelAllPaymentSchedulesByPortfolioRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CancelAllPaymentSchedulesByPortfolioRequestBody} CancelAllPaymentSchedulesByPortfolioRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CancelAllPaymentSchedulesByPortfolioRequestBody message.
             * @function verify
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    switch (message.portfolio) {
                    default:
                        return "portfolio: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                return null;
            };

            /**
             * Creates a CancelAllPaymentSchedulesByPortfolioRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CancelAllPaymentSchedulesByPortfolioRequestBody} CancelAllPaymentSchedulesByPortfolioRequestBody
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CancelAllPaymentSchedulesByPortfolioRequestBody)
                    return object;
                let message = new $root.api.external.CancelAllPaymentSchedulesByPortfolioRequestBody();
                switch (object.portfolio) {
                case "UNKNOWN":
                case 0:
                    message.portfolio = 0;
                    break;
                case "INDEX":
                case 1:
                    message.portfolio = 1;
                    break;
                case "UNIVERSE":
                case 2:
                    message.portfolio = 2;
                    break;
                case "EARTH":
                case 3:
                    message.portfolio = 3;
                    break;
                case "GALAXY":
                case 4:
                    message.portfolio = 4;
                    break;
                case "EXPLORER":
                case 5:
                    message.portfolio = 5;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a CancelAllPaymentSchedulesByPortfolioRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @static
             * @param {api.external.CancelAllPaymentSchedulesByPortfolioRequestBody} message CancelAllPaymentSchedulesByPortfolioRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.portfolio = options.enums === String ? "UNKNOWN" : 0;
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
                return object;
            };

            /**
             * Converts this CancelAllPaymentSchedulesByPortfolioRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CancelAllPaymentSchedulesByPortfolioRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CancelAllPaymentSchedulesByPortfolioRequestBody;
        })();

        external.CancelAllPaymentSchedulesByPortfolioResponseBody = (function() {

            /**
             * Properties of a CancelAllPaymentSchedulesByPortfolioResponseBody.
             * @memberof api.external
             * @interface ICancelAllPaymentSchedulesByPortfolioResponseBody
             */

            /**
             * Constructs a new CancelAllPaymentSchedulesByPortfolioResponseBody.
             * @memberof api.external
             * @classdesc Represents a CancelAllPaymentSchedulesByPortfolioResponseBody.
             * @implements ICancelAllPaymentSchedulesByPortfolioResponseBody
             * @constructor
             * @param {api.external.ICancelAllPaymentSchedulesByPortfolioResponseBody=} [properties] Properties to set
             */
            function CancelAllPaymentSchedulesByPortfolioResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CancelAllPaymentSchedulesByPortfolioResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @static
             * @param {api.external.ICancelAllPaymentSchedulesByPortfolioResponseBody=} [properties] Properties to set
             * @returns {api.external.CancelAllPaymentSchedulesByPortfolioResponseBody} CancelAllPaymentSchedulesByPortfolioResponseBody instance
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.create = function create(properties) {
                return new CancelAllPaymentSchedulesByPortfolioResponseBody(properties);
            };

            /**
             * Encodes the specified CancelAllPaymentSchedulesByPortfolioResponseBody message. Does not implicitly {@link api.external.CancelAllPaymentSchedulesByPortfolioResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @static
             * @param {api.external.ICancelAllPaymentSchedulesByPortfolioResponseBody} message CancelAllPaymentSchedulesByPortfolioResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CancelAllPaymentSchedulesByPortfolioResponseBody message, length delimited. Does not implicitly {@link api.external.CancelAllPaymentSchedulesByPortfolioResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @static
             * @param {api.external.ICancelAllPaymentSchedulesByPortfolioResponseBody} message CancelAllPaymentSchedulesByPortfolioResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CancelAllPaymentSchedulesByPortfolioResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CancelAllPaymentSchedulesByPortfolioResponseBody} CancelAllPaymentSchedulesByPortfolioResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CancelAllPaymentSchedulesByPortfolioResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CancelAllPaymentSchedulesByPortfolioResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CancelAllPaymentSchedulesByPortfolioResponseBody} CancelAllPaymentSchedulesByPortfolioResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CancelAllPaymentSchedulesByPortfolioResponseBody message.
             * @function verify
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CancelAllPaymentSchedulesByPortfolioResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CancelAllPaymentSchedulesByPortfolioResponseBody} CancelAllPaymentSchedulesByPortfolioResponseBody
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CancelAllPaymentSchedulesByPortfolioResponseBody)
                    return object;
                return new $root.api.external.CancelAllPaymentSchedulesByPortfolioResponseBody();
            };

            /**
             * Creates a plain object from a CancelAllPaymentSchedulesByPortfolioResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @static
             * @param {api.external.CancelAllPaymentSchedulesByPortfolioResponseBody} message CancelAllPaymentSchedulesByPortfolioResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CancelAllPaymentSchedulesByPortfolioResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.CancelAllPaymentSchedulesByPortfolioResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CancelAllPaymentSchedulesByPortfolioResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CancelAllPaymentSchedulesByPortfolioResponseBody;
        })();

        external.WithdrawalRequestBody = (function() {

            /**
             * Properties of a WithdrawalRequestBody.
             * @memberof api.external
             * @interface IWithdrawalRequestBody
             * @property {string|null} [aud_amount] WithdrawalRequestBody aud_amount
             */

            /**
             * Constructs a new WithdrawalRequestBody.
             * @memberof api.external
             * @classdesc Represents a WithdrawalRequestBody.
             * @implements IWithdrawalRequestBody
             * @constructor
             * @param {api.external.IWithdrawalRequestBody=} [properties] Properties to set
             */
            function WithdrawalRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * WithdrawalRequestBody aud_amount.
             * @member {string} aud_amount
             * @memberof api.external.WithdrawalRequestBody
             * @instance
             */
            WithdrawalRequestBody.prototype.aud_amount = "";

            /**
             * Creates a new WithdrawalRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.WithdrawalRequestBody
             * @static
             * @param {api.external.IWithdrawalRequestBody=} [properties] Properties to set
             * @returns {api.external.WithdrawalRequestBody} WithdrawalRequestBody instance
             */
            WithdrawalRequestBody.create = function create(properties) {
                return new WithdrawalRequestBody(properties);
            };

            /**
             * Encodes the specified WithdrawalRequestBody message. Does not implicitly {@link api.external.WithdrawalRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.WithdrawalRequestBody
             * @static
             * @param {api.external.IWithdrawalRequestBody} message WithdrawalRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WithdrawalRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.aud_amount);
                return writer;
            };

            /**
             * Encodes the specified WithdrawalRequestBody message, length delimited. Does not implicitly {@link api.external.WithdrawalRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.WithdrawalRequestBody
             * @static
             * @param {api.external.IWithdrawalRequestBody} message WithdrawalRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WithdrawalRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a WithdrawalRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.WithdrawalRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.WithdrawalRequestBody} WithdrawalRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WithdrawalRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.WithdrawalRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.aud_amount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a WithdrawalRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.WithdrawalRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.WithdrawalRequestBody} WithdrawalRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WithdrawalRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a WithdrawalRequestBody message.
             * @function verify
             * @memberof api.external.WithdrawalRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            WithdrawalRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    if (!$util.isString(message.aud_amount))
                        return "aud_amount: string expected";
                return null;
            };

            /**
             * Creates a WithdrawalRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.WithdrawalRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.WithdrawalRequestBody} WithdrawalRequestBody
             */
            WithdrawalRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.WithdrawalRequestBody)
                    return object;
                let message = new $root.api.external.WithdrawalRequestBody();
                if (object.aud_amount != null)
                    message.aud_amount = String(object.aud_amount);
                return message;
            };

            /**
             * Creates a plain object from a WithdrawalRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.WithdrawalRequestBody
             * @static
             * @param {api.external.WithdrawalRequestBody} message WithdrawalRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WithdrawalRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.aud_amount = "";
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    object.aud_amount = message.aud_amount;
                return object;
            };

            /**
             * Converts this WithdrawalRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.WithdrawalRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WithdrawalRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return WithdrawalRequestBody;
        })();

        external.WithdrawalResponseBody = (function() {

            /**
             * Properties of a WithdrawalResponseBody.
             * @memberof api.external
             * @interface IWithdrawalResponseBody
             */

            /**
             * Constructs a new WithdrawalResponseBody.
             * @memberof api.external
             * @classdesc Represents a WithdrawalResponseBody.
             * @implements IWithdrawalResponseBody
             * @constructor
             * @param {api.external.IWithdrawalResponseBody=} [properties] Properties to set
             */
            function WithdrawalResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new WithdrawalResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.WithdrawalResponseBody
             * @static
             * @param {api.external.IWithdrawalResponseBody=} [properties] Properties to set
             * @returns {api.external.WithdrawalResponseBody} WithdrawalResponseBody instance
             */
            WithdrawalResponseBody.create = function create(properties) {
                return new WithdrawalResponseBody(properties);
            };

            /**
             * Encodes the specified WithdrawalResponseBody message. Does not implicitly {@link api.external.WithdrawalResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.WithdrawalResponseBody
             * @static
             * @param {api.external.IWithdrawalResponseBody} message WithdrawalResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WithdrawalResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified WithdrawalResponseBody message, length delimited. Does not implicitly {@link api.external.WithdrawalResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.WithdrawalResponseBody
             * @static
             * @param {api.external.IWithdrawalResponseBody} message WithdrawalResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            WithdrawalResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a WithdrawalResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.WithdrawalResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.WithdrawalResponseBody} WithdrawalResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WithdrawalResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.WithdrawalResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a WithdrawalResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.WithdrawalResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.WithdrawalResponseBody} WithdrawalResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            WithdrawalResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a WithdrawalResponseBody message.
             * @function verify
             * @memberof api.external.WithdrawalResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            WithdrawalResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a WithdrawalResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.WithdrawalResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.WithdrawalResponseBody} WithdrawalResponseBody
             */
            WithdrawalResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.WithdrawalResponseBody)
                    return object;
                return new $root.api.external.WithdrawalResponseBody();
            };

            /**
             * Creates a plain object from a WithdrawalResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.WithdrawalResponseBody
             * @static
             * @param {api.external.WithdrawalResponseBody} message WithdrawalResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            WithdrawalResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this WithdrawalResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.WithdrawalResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            WithdrawalResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return WithdrawalResponseBody;
        })();

        external.GetGraphDataResponseBody = (function() {

            /**
             * Properties of a GetGraphDataResponseBody.
             * @memberof api.external
             * @interface IGetGraphDataResponseBody
             * @property {Array.<IUserBalanceGraphDataPoint>|null} [graph_data] GetGraphDataResponseBody graph_data
             */

            /**
             * Constructs a new GetGraphDataResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetGraphDataResponseBody.
             * @implements IGetGraphDataResponseBody
             * @constructor
             * @param {api.external.IGetGraphDataResponseBody=} [properties] Properties to set
             */
            function GetGraphDataResponseBody(properties) {
                this.graph_data = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetGraphDataResponseBody graph_data.
             * @member {Array.<IUserBalanceGraphDataPoint>} graph_data
             * @memberof api.external.GetGraphDataResponseBody
             * @instance
             */
            GetGraphDataResponseBody.prototype.graph_data = $util.emptyArray;

            /**
             * Creates a new GetGraphDataResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetGraphDataResponseBody
             * @static
             * @param {api.external.IGetGraphDataResponseBody=} [properties] Properties to set
             * @returns {api.external.GetGraphDataResponseBody} GetGraphDataResponseBody instance
             */
            GetGraphDataResponseBody.create = function create(properties) {
                return new GetGraphDataResponseBody(properties);
            };

            /**
             * Encodes the specified GetGraphDataResponseBody message. Does not implicitly {@link api.external.GetGraphDataResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetGraphDataResponseBody
             * @static
             * @param {api.external.IGetGraphDataResponseBody} message GetGraphDataResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetGraphDataResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.graph_data != null && message.graph_data.length)
                    for (let i = 0; i < message.graph_data.length; ++i)
                        $root.UserBalanceGraphDataPoint.encode(message.graph_data[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetGraphDataResponseBody message, length delimited. Does not implicitly {@link api.external.GetGraphDataResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetGraphDataResponseBody
             * @static
             * @param {api.external.IGetGraphDataResponseBody} message GetGraphDataResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetGraphDataResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetGraphDataResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetGraphDataResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetGraphDataResponseBody} GetGraphDataResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetGraphDataResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetGraphDataResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.graph_data && message.graph_data.length))
                            message.graph_data = [];
                        message.graph_data.push($root.UserBalanceGraphDataPoint.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetGraphDataResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetGraphDataResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetGraphDataResponseBody} GetGraphDataResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetGraphDataResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetGraphDataResponseBody message.
             * @function verify
             * @memberof api.external.GetGraphDataResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetGraphDataResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.graph_data != null && message.hasOwnProperty("graph_data")) {
                    if (!Array.isArray(message.graph_data))
                        return "graph_data: array expected";
                    for (let i = 0; i < message.graph_data.length; ++i) {
                        let error = $root.UserBalanceGraphDataPoint.verify(message.graph_data[i]);
                        if (error)
                            return "graph_data." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetGraphDataResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetGraphDataResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetGraphDataResponseBody} GetGraphDataResponseBody
             */
            GetGraphDataResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetGraphDataResponseBody)
                    return object;
                let message = new $root.api.external.GetGraphDataResponseBody();
                if (object.graph_data) {
                    if (!Array.isArray(object.graph_data))
                        throw TypeError(".api.external.GetGraphDataResponseBody.graph_data: array expected");
                    message.graph_data = [];
                    for (let i = 0; i < object.graph_data.length; ++i) {
                        if (typeof object.graph_data[i] !== "object")
                            throw TypeError(".api.external.GetGraphDataResponseBody.graph_data: object expected");
                        message.graph_data[i] = $root.UserBalanceGraphDataPoint.fromObject(object.graph_data[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetGraphDataResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetGraphDataResponseBody
             * @static
             * @param {api.external.GetGraphDataResponseBody} message GetGraphDataResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetGraphDataResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.graph_data = [];
                if (message.graph_data && message.graph_data.length) {
                    object.graph_data = [];
                    for (let j = 0; j < message.graph_data.length; ++j)
                        object.graph_data[j] = $root.UserBalanceGraphDataPoint.toObject(message.graph_data[j], options);
                }
                return object;
            };

            /**
             * Converts this GetGraphDataResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetGraphDataResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetGraphDataResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetGraphDataResponseBody;
        })();

        external.GetSaverAccountResponseBody = (function() {

            /**
             * Properties of a GetSaverAccountResponseBody.
             * @memberof api.external
             * @interface IGetSaverAccountResponseBody
             * @property {ISaverProductInstance|null} [product_instance] GetSaverAccountResponseBody product_instance
             * @property {Array.<IBankAccount>|null} [bank_accounts] GetSaverAccountResponseBody bank_accounts
             * @property {Array.<IPaymentSchedule>|null} [payment_schedules] GetSaverAccountResponseBody payment_schedules
             * @property {Array.<IPaymentSchedule>|null} [inactive_payment_schedules] GetSaverAccountResponseBody inactive_payment_schedules
             */

            /**
             * Constructs a new GetSaverAccountResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetSaverAccountResponseBody.
             * @implements IGetSaverAccountResponseBody
             * @constructor
             * @param {api.external.IGetSaverAccountResponseBody=} [properties] Properties to set
             */
            function GetSaverAccountResponseBody(properties) {
                this.bank_accounts = [];
                this.payment_schedules = [];
                this.inactive_payment_schedules = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetSaverAccountResponseBody product_instance.
             * @member {ISaverProductInstance|null|undefined} product_instance
             * @memberof api.external.GetSaverAccountResponseBody
             * @instance
             */
            GetSaverAccountResponseBody.prototype.product_instance = null;

            /**
             * GetSaverAccountResponseBody bank_accounts.
             * @member {Array.<IBankAccount>} bank_accounts
             * @memberof api.external.GetSaverAccountResponseBody
             * @instance
             */
            GetSaverAccountResponseBody.prototype.bank_accounts = $util.emptyArray;

            /**
             * GetSaverAccountResponseBody payment_schedules.
             * @member {Array.<IPaymentSchedule>} payment_schedules
             * @memberof api.external.GetSaverAccountResponseBody
             * @instance
             */
            GetSaverAccountResponseBody.prototype.payment_schedules = $util.emptyArray;

            /**
             * GetSaverAccountResponseBody inactive_payment_schedules.
             * @member {Array.<IPaymentSchedule>} inactive_payment_schedules
             * @memberof api.external.GetSaverAccountResponseBody
             * @instance
             */
            GetSaverAccountResponseBody.prototype.inactive_payment_schedules = $util.emptyArray;

            /**
             * Creates a new GetSaverAccountResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetSaverAccountResponseBody
             * @static
             * @param {api.external.IGetSaverAccountResponseBody=} [properties] Properties to set
             * @returns {api.external.GetSaverAccountResponseBody} GetSaverAccountResponseBody instance
             */
            GetSaverAccountResponseBody.create = function create(properties) {
                return new GetSaverAccountResponseBody(properties);
            };

            /**
             * Encodes the specified GetSaverAccountResponseBody message. Does not implicitly {@link api.external.GetSaverAccountResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetSaverAccountResponseBody
             * @static
             * @param {api.external.IGetSaverAccountResponseBody} message GetSaverAccountResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSaverAccountResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.product_instance != null && message.hasOwnProperty("product_instance"))
                    $root.SaverProductInstance.encode(message.product_instance, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.bank_accounts != null && message.bank_accounts.length)
                    for (let i = 0; i < message.bank_accounts.length; ++i)
                        $root.BankAccount.encode(message.bank_accounts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.payment_schedules != null && message.payment_schedules.length)
                    for (let i = 0; i < message.payment_schedules.length; ++i)
                        $root.PaymentSchedule.encode(message.payment_schedules[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.inactive_payment_schedules != null && message.inactive_payment_schedules.length)
                    for (let i = 0; i < message.inactive_payment_schedules.length; ++i)
                        $root.PaymentSchedule.encode(message.inactive_payment_schedules[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetSaverAccountResponseBody message, length delimited. Does not implicitly {@link api.external.GetSaverAccountResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetSaverAccountResponseBody
             * @static
             * @param {api.external.IGetSaverAccountResponseBody} message GetSaverAccountResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSaverAccountResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetSaverAccountResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetSaverAccountResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetSaverAccountResponseBody} GetSaverAccountResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSaverAccountResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetSaverAccountResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.product_instance = $root.SaverProductInstance.decode(reader, reader.uint32());
                        break;
                    case 2:
                        if (!(message.bank_accounts && message.bank_accounts.length))
                            message.bank_accounts = [];
                        message.bank_accounts.push($root.BankAccount.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        if (!(message.payment_schedules && message.payment_schedules.length))
                            message.payment_schedules = [];
                        message.payment_schedules.push($root.PaymentSchedule.decode(reader, reader.uint32()));
                        break;
                    case 4:
                        if (!(message.inactive_payment_schedules && message.inactive_payment_schedules.length))
                            message.inactive_payment_schedules = [];
                        message.inactive_payment_schedules.push($root.PaymentSchedule.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetSaverAccountResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetSaverAccountResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetSaverAccountResponseBody} GetSaverAccountResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSaverAccountResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetSaverAccountResponseBody message.
             * @function verify
             * @memberof api.external.GetSaverAccountResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetSaverAccountResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.product_instance != null && message.hasOwnProperty("product_instance")) {
                    let error = $root.SaverProductInstance.verify(message.product_instance);
                    if (error)
                        return "product_instance." + error;
                }
                if (message.bank_accounts != null && message.hasOwnProperty("bank_accounts")) {
                    if (!Array.isArray(message.bank_accounts))
                        return "bank_accounts: array expected";
                    for (let i = 0; i < message.bank_accounts.length; ++i) {
                        let error = $root.BankAccount.verify(message.bank_accounts[i]);
                        if (error)
                            return "bank_accounts." + error;
                    }
                }
                if (message.payment_schedules != null && message.hasOwnProperty("payment_schedules")) {
                    if (!Array.isArray(message.payment_schedules))
                        return "payment_schedules: array expected";
                    for (let i = 0; i < message.payment_schedules.length; ++i) {
                        let error = $root.PaymentSchedule.verify(message.payment_schedules[i]);
                        if (error)
                            return "payment_schedules." + error;
                    }
                }
                if (message.inactive_payment_schedules != null && message.hasOwnProperty("inactive_payment_schedules")) {
                    if (!Array.isArray(message.inactive_payment_schedules))
                        return "inactive_payment_schedules: array expected";
                    for (let i = 0; i < message.inactive_payment_schedules.length; ++i) {
                        let error = $root.PaymentSchedule.verify(message.inactive_payment_schedules[i]);
                        if (error)
                            return "inactive_payment_schedules." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetSaverAccountResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetSaverAccountResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetSaverAccountResponseBody} GetSaverAccountResponseBody
             */
            GetSaverAccountResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetSaverAccountResponseBody)
                    return object;
                let message = new $root.api.external.GetSaverAccountResponseBody();
                if (object.product_instance != null) {
                    if (typeof object.product_instance !== "object")
                        throw TypeError(".api.external.GetSaverAccountResponseBody.product_instance: object expected");
                    message.product_instance = $root.SaverProductInstance.fromObject(object.product_instance);
                }
                if (object.bank_accounts) {
                    if (!Array.isArray(object.bank_accounts))
                        throw TypeError(".api.external.GetSaverAccountResponseBody.bank_accounts: array expected");
                    message.bank_accounts = [];
                    for (let i = 0; i < object.bank_accounts.length; ++i) {
                        if (typeof object.bank_accounts[i] !== "object")
                            throw TypeError(".api.external.GetSaverAccountResponseBody.bank_accounts: object expected");
                        message.bank_accounts[i] = $root.BankAccount.fromObject(object.bank_accounts[i]);
                    }
                }
                if (object.payment_schedules) {
                    if (!Array.isArray(object.payment_schedules))
                        throw TypeError(".api.external.GetSaverAccountResponseBody.payment_schedules: array expected");
                    message.payment_schedules = [];
                    for (let i = 0; i < object.payment_schedules.length; ++i) {
                        if (typeof object.payment_schedules[i] !== "object")
                            throw TypeError(".api.external.GetSaverAccountResponseBody.payment_schedules: object expected");
                        message.payment_schedules[i] = $root.PaymentSchedule.fromObject(object.payment_schedules[i]);
                    }
                }
                if (object.inactive_payment_schedules) {
                    if (!Array.isArray(object.inactive_payment_schedules))
                        throw TypeError(".api.external.GetSaverAccountResponseBody.inactive_payment_schedules: array expected");
                    message.inactive_payment_schedules = [];
                    for (let i = 0; i < object.inactive_payment_schedules.length; ++i) {
                        if (typeof object.inactive_payment_schedules[i] !== "object")
                            throw TypeError(".api.external.GetSaverAccountResponseBody.inactive_payment_schedules: object expected");
                        message.inactive_payment_schedules[i] = $root.PaymentSchedule.fromObject(object.inactive_payment_schedules[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetSaverAccountResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetSaverAccountResponseBody
             * @static
             * @param {api.external.GetSaverAccountResponseBody} message GetSaverAccountResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetSaverAccountResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.bank_accounts = [];
                    object.payment_schedules = [];
                    object.inactive_payment_schedules = [];
                }
                if (options.defaults)
                    object.product_instance = null;
                if (message.product_instance != null && message.hasOwnProperty("product_instance"))
                    object.product_instance = $root.SaverProductInstance.toObject(message.product_instance, options);
                if (message.bank_accounts && message.bank_accounts.length) {
                    object.bank_accounts = [];
                    for (let j = 0; j < message.bank_accounts.length; ++j)
                        object.bank_accounts[j] = $root.BankAccount.toObject(message.bank_accounts[j], options);
                }
                if (message.payment_schedules && message.payment_schedules.length) {
                    object.payment_schedules = [];
                    for (let j = 0; j < message.payment_schedules.length; ++j)
                        object.payment_schedules[j] = $root.PaymentSchedule.toObject(message.payment_schedules[j], options);
                }
                if (message.inactive_payment_schedules && message.inactive_payment_schedules.length) {
                    object.inactive_payment_schedules = [];
                    for (let j = 0; j < message.inactive_payment_schedules.length; ++j)
                        object.inactive_payment_schedules[j] = $root.PaymentSchedule.toObject(message.inactive_payment_schedules[j], options);
                }
                return object;
            };

            /**
             * Converts this GetSaverAccountResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetSaverAccountResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetSaverAccountResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetSaverAccountResponseBody;
        })();

        external.GetUnitPriceGraphDataResponseBody = (function() {

            /**
             * Properties of a GetUnitPriceGraphDataResponseBody.
             * @memberof api.external
             * @interface IGetUnitPriceGraphDataResponseBody
             * @property {Array.<IUnitPriceGraphDataPoint>|null} [unit_prices] GetUnitPriceGraphDataResponseBody unit_prices
             */

            /**
             * Constructs a new GetUnitPriceGraphDataResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetUnitPriceGraphDataResponseBody.
             * @implements IGetUnitPriceGraphDataResponseBody
             * @constructor
             * @param {api.external.IGetUnitPriceGraphDataResponseBody=} [properties] Properties to set
             */
            function GetUnitPriceGraphDataResponseBody(properties) {
                this.unit_prices = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetUnitPriceGraphDataResponseBody unit_prices.
             * @member {Array.<IUnitPriceGraphDataPoint>} unit_prices
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @instance
             */
            GetUnitPriceGraphDataResponseBody.prototype.unit_prices = $util.emptyArray;

            /**
             * Creates a new GetUnitPriceGraphDataResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @static
             * @param {api.external.IGetUnitPriceGraphDataResponseBody=} [properties] Properties to set
             * @returns {api.external.GetUnitPriceGraphDataResponseBody} GetUnitPriceGraphDataResponseBody instance
             */
            GetUnitPriceGraphDataResponseBody.create = function create(properties) {
                return new GetUnitPriceGraphDataResponseBody(properties);
            };

            /**
             * Encodes the specified GetUnitPriceGraphDataResponseBody message. Does not implicitly {@link api.external.GetUnitPriceGraphDataResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @static
             * @param {api.external.IGetUnitPriceGraphDataResponseBody} message GetUnitPriceGraphDataResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUnitPriceGraphDataResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.unit_prices != null && message.unit_prices.length)
                    for (let i = 0; i < message.unit_prices.length; ++i)
                        $root.UnitPriceGraphDataPoint.encode(message.unit_prices[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetUnitPriceGraphDataResponseBody message, length delimited. Does not implicitly {@link api.external.GetUnitPriceGraphDataResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @static
             * @param {api.external.IGetUnitPriceGraphDataResponseBody} message GetUnitPriceGraphDataResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUnitPriceGraphDataResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetUnitPriceGraphDataResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetUnitPriceGraphDataResponseBody} GetUnitPriceGraphDataResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUnitPriceGraphDataResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetUnitPriceGraphDataResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.unit_prices && message.unit_prices.length))
                            message.unit_prices = [];
                        message.unit_prices.push($root.UnitPriceGraphDataPoint.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetUnitPriceGraphDataResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetUnitPriceGraphDataResponseBody} GetUnitPriceGraphDataResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUnitPriceGraphDataResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetUnitPriceGraphDataResponseBody message.
             * @function verify
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetUnitPriceGraphDataResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.unit_prices != null && message.hasOwnProperty("unit_prices")) {
                    if (!Array.isArray(message.unit_prices))
                        return "unit_prices: array expected";
                    for (let i = 0; i < message.unit_prices.length; ++i) {
                        let error = $root.UnitPriceGraphDataPoint.verify(message.unit_prices[i]);
                        if (error)
                            return "unit_prices." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetUnitPriceGraphDataResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetUnitPriceGraphDataResponseBody} GetUnitPriceGraphDataResponseBody
             */
            GetUnitPriceGraphDataResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetUnitPriceGraphDataResponseBody)
                    return object;
                let message = new $root.api.external.GetUnitPriceGraphDataResponseBody();
                if (object.unit_prices) {
                    if (!Array.isArray(object.unit_prices))
                        throw TypeError(".api.external.GetUnitPriceGraphDataResponseBody.unit_prices: array expected");
                    message.unit_prices = [];
                    for (let i = 0; i < object.unit_prices.length; ++i) {
                        if (typeof object.unit_prices[i] !== "object")
                            throw TypeError(".api.external.GetUnitPriceGraphDataResponseBody.unit_prices: object expected");
                        message.unit_prices[i] = $root.UnitPriceGraphDataPoint.fromObject(object.unit_prices[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetUnitPriceGraphDataResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @static
             * @param {api.external.GetUnitPriceGraphDataResponseBody} message GetUnitPriceGraphDataResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetUnitPriceGraphDataResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.unit_prices = [];
                if (message.unit_prices && message.unit_prices.length) {
                    object.unit_prices = [];
                    for (let j = 0; j < message.unit_prices.length; ++j)
                        object.unit_prices[j] = $root.UnitPriceGraphDataPoint.toObject(message.unit_prices[j], options);
                }
                return object;
            };

            /**
             * Converts this GetUnitPriceGraphDataResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetUnitPriceGraphDataResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetUnitPriceGraphDataResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetUnitPriceGraphDataResponseBody;
        })();

        external.SendResetPasswordCodeRequestBody = (function() {

            /**
             * Properties of a SendResetPasswordCodeRequestBody.
             * @memberof api.external
             * @interface ISendResetPasswordCodeRequestBody
             * @property {string|null} [email_address] SendResetPasswordCodeRequestBody email_address
             */

            /**
             * Constructs a new SendResetPasswordCodeRequestBody.
             * @memberof api.external
             * @classdesc Represents a SendResetPasswordCodeRequestBody.
             * @implements ISendResetPasswordCodeRequestBody
             * @constructor
             * @param {api.external.ISendResetPasswordCodeRequestBody=} [properties] Properties to set
             */
            function SendResetPasswordCodeRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SendResetPasswordCodeRequestBody email_address.
             * @member {string} email_address
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @instance
             */
            SendResetPasswordCodeRequestBody.prototype.email_address = "";

            /**
             * Creates a new SendResetPasswordCodeRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @static
             * @param {api.external.ISendResetPasswordCodeRequestBody=} [properties] Properties to set
             * @returns {api.external.SendResetPasswordCodeRequestBody} SendResetPasswordCodeRequestBody instance
             */
            SendResetPasswordCodeRequestBody.create = function create(properties) {
                return new SendResetPasswordCodeRequestBody(properties);
            };

            /**
             * Encodes the specified SendResetPasswordCodeRequestBody message. Does not implicitly {@link api.external.SendResetPasswordCodeRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @static
             * @param {api.external.ISendResetPasswordCodeRequestBody} message SendResetPasswordCodeRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendResetPasswordCodeRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.email_address);
                return writer;
            };

            /**
             * Encodes the specified SendResetPasswordCodeRequestBody message, length delimited. Does not implicitly {@link api.external.SendResetPasswordCodeRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @static
             * @param {api.external.ISendResetPasswordCodeRequestBody} message SendResetPasswordCodeRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendResetPasswordCodeRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SendResetPasswordCodeRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.SendResetPasswordCodeRequestBody} SendResetPasswordCodeRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendResetPasswordCodeRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.SendResetPasswordCodeRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.email_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SendResetPasswordCodeRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.SendResetPasswordCodeRequestBody} SendResetPasswordCodeRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendResetPasswordCodeRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SendResetPasswordCodeRequestBody message.
             * @function verify
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SendResetPasswordCodeRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    if (!$util.isString(message.email_address))
                        return "email_address: string expected";
                return null;
            };

            /**
             * Creates a SendResetPasswordCodeRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.SendResetPasswordCodeRequestBody} SendResetPasswordCodeRequestBody
             */
            SendResetPasswordCodeRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.SendResetPasswordCodeRequestBody)
                    return object;
                let message = new $root.api.external.SendResetPasswordCodeRequestBody();
                if (object.email_address != null)
                    message.email_address = String(object.email_address);
                return message;
            };

            /**
             * Creates a plain object from a SendResetPasswordCodeRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @static
             * @param {api.external.SendResetPasswordCodeRequestBody} message SendResetPasswordCodeRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SendResetPasswordCodeRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.email_address = "";
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    object.email_address = message.email_address;
                return object;
            };

            /**
             * Converts this SendResetPasswordCodeRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.SendResetPasswordCodeRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SendResetPasswordCodeRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SendResetPasswordCodeRequestBody;
        })();

        external.SendResetPasswordCodeResponseBody = (function() {

            /**
             * Properties of a SendResetPasswordCodeResponseBody.
             * @memberof api.external
             * @interface ISendResetPasswordCodeResponseBody
             * @property {string|null} [id] SendResetPasswordCodeResponseBody id
             */

            /**
             * Constructs a new SendResetPasswordCodeResponseBody.
             * @memberof api.external
             * @classdesc Represents a SendResetPasswordCodeResponseBody.
             * @implements ISendResetPasswordCodeResponseBody
             * @constructor
             * @param {api.external.ISendResetPasswordCodeResponseBody=} [properties] Properties to set
             */
            function SendResetPasswordCodeResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SendResetPasswordCodeResponseBody id.
             * @member {string} id
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @instance
             */
            SendResetPasswordCodeResponseBody.prototype.id = "";

            /**
             * Creates a new SendResetPasswordCodeResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @static
             * @param {api.external.ISendResetPasswordCodeResponseBody=} [properties] Properties to set
             * @returns {api.external.SendResetPasswordCodeResponseBody} SendResetPasswordCodeResponseBody instance
             */
            SendResetPasswordCodeResponseBody.create = function create(properties) {
                return new SendResetPasswordCodeResponseBody(properties);
            };

            /**
             * Encodes the specified SendResetPasswordCodeResponseBody message. Does not implicitly {@link api.external.SendResetPasswordCodeResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @static
             * @param {api.external.ISendResetPasswordCodeResponseBody} message SendResetPasswordCodeResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendResetPasswordCodeResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && message.hasOwnProperty("id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                return writer;
            };

            /**
             * Encodes the specified SendResetPasswordCodeResponseBody message, length delimited. Does not implicitly {@link api.external.SendResetPasswordCodeResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @static
             * @param {api.external.ISendResetPasswordCodeResponseBody} message SendResetPasswordCodeResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendResetPasswordCodeResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SendResetPasswordCodeResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.SendResetPasswordCodeResponseBody} SendResetPasswordCodeResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendResetPasswordCodeResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.SendResetPasswordCodeResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SendResetPasswordCodeResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.SendResetPasswordCodeResponseBody} SendResetPasswordCodeResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendResetPasswordCodeResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SendResetPasswordCodeResponseBody message.
             * @function verify
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SendResetPasswordCodeResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                return null;
            };

            /**
             * Creates a SendResetPasswordCodeResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.SendResetPasswordCodeResponseBody} SendResetPasswordCodeResponseBody
             */
            SendResetPasswordCodeResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.SendResetPasswordCodeResponseBody)
                    return object;
                let message = new $root.api.external.SendResetPasswordCodeResponseBody();
                if (object.id != null)
                    message.id = String(object.id);
                return message;
            };

            /**
             * Creates a plain object from a SendResetPasswordCodeResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @static
             * @param {api.external.SendResetPasswordCodeResponseBody} message SendResetPasswordCodeResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SendResetPasswordCodeResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.id = "";
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                return object;
            };

            /**
             * Converts this SendResetPasswordCodeResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.SendResetPasswordCodeResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SendResetPasswordCodeResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SendResetPasswordCodeResponseBody;
        })();

        external.VerifyResetPasswordCodeRequestBody = (function() {

            /**
             * Properties of a VerifyResetPasswordCodeRequestBody.
             * @memberof api.external
             * @interface IVerifyResetPasswordCodeRequestBody
             * @property {string|null} [id] VerifyResetPasswordCodeRequestBody id
             * @property {string|null} [code] VerifyResetPasswordCodeRequestBody code
             */

            /**
             * Constructs a new VerifyResetPasswordCodeRequestBody.
             * @memberof api.external
             * @classdesc Represents a VerifyResetPasswordCodeRequestBody.
             * @implements IVerifyResetPasswordCodeRequestBody
             * @constructor
             * @param {api.external.IVerifyResetPasswordCodeRequestBody=} [properties] Properties to set
             */
            function VerifyResetPasswordCodeRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * VerifyResetPasswordCodeRequestBody id.
             * @member {string} id
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @instance
             */
            VerifyResetPasswordCodeRequestBody.prototype.id = "";

            /**
             * VerifyResetPasswordCodeRequestBody code.
             * @member {string} code
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @instance
             */
            VerifyResetPasswordCodeRequestBody.prototype.code = "";

            /**
             * Creates a new VerifyResetPasswordCodeRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @static
             * @param {api.external.IVerifyResetPasswordCodeRequestBody=} [properties] Properties to set
             * @returns {api.external.VerifyResetPasswordCodeRequestBody} VerifyResetPasswordCodeRequestBody instance
             */
            VerifyResetPasswordCodeRequestBody.create = function create(properties) {
                return new VerifyResetPasswordCodeRequestBody(properties);
            };

            /**
             * Encodes the specified VerifyResetPasswordCodeRequestBody message. Does not implicitly {@link api.external.VerifyResetPasswordCodeRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @static
             * @param {api.external.IVerifyResetPasswordCodeRequestBody} message VerifyResetPasswordCodeRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyResetPasswordCodeRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && message.hasOwnProperty("id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.code != null && message.hasOwnProperty("code"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.code);
                return writer;
            };

            /**
             * Encodes the specified VerifyResetPasswordCodeRequestBody message, length delimited. Does not implicitly {@link api.external.VerifyResetPasswordCodeRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @static
             * @param {api.external.IVerifyResetPasswordCodeRequestBody} message VerifyResetPasswordCodeRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyResetPasswordCodeRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a VerifyResetPasswordCodeRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.VerifyResetPasswordCodeRequestBody} VerifyResetPasswordCodeRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyResetPasswordCodeRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.VerifyResetPasswordCodeRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.code = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a VerifyResetPasswordCodeRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.VerifyResetPasswordCodeRequestBody} VerifyResetPasswordCodeRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyResetPasswordCodeRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a VerifyResetPasswordCodeRequestBody message.
             * @function verify
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            VerifyResetPasswordCodeRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                return null;
            };

            /**
             * Creates a VerifyResetPasswordCodeRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.VerifyResetPasswordCodeRequestBody} VerifyResetPasswordCodeRequestBody
             */
            VerifyResetPasswordCodeRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.VerifyResetPasswordCodeRequestBody)
                    return object;
                let message = new $root.api.external.VerifyResetPasswordCodeRequestBody();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.code != null)
                    message.code = String(object.code);
                return message;
            };

            /**
             * Creates a plain object from a VerifyResetPasswordCodeRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @static
             * @param {api.external.VerifyResetPasswordCodeRequestBody} message VerifyResetPasswordCodeRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            VerifyResetPasswordCodeRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.id = "";
                    object.code = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                return object;
            };

            /**
             * Converts this VerifyResetPasswordCodeRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.VerifyResetPasswordCodeRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            VerifyResetPasswordCodeRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return VerifyResetPasswordCodeRequestBody;
        })();

        external.VerifyResetPasswordCodeResponseBody = (function() {

            /**
             * Properties of a VerifyResetPasswordCodeResponseBody.
             * @memberof api.external
             * @interface IVerifyResetPasswordCodeResponseBody
             * @property {ResetPasswordErrorReason.Enum|null} [reason] VerifyResetPasswordCodeResponseBody reason
             */

            /**
             * Constructs a new VerifyResetPasswordCodeResponseBody.
             * @memberof api.external
             * @classdesc Represents a VerifyResetPasswordCodeResponseBody.
             * @implements IVerifyResetPasswordCodeResponseBody
             * @constructor
             * @param {api.external.IVerifyResetPasswordCodeResponseBody=} [properties] Properties to set
             */
            function VerifyResetPasswordCodeResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * VerifyResetPasswordCodeResponseBody reason.
             * @member {ResetPasswordErrorReason.Enum} reason
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @instance
             */
            VerifyResetPasswordCodeResponseBody.prototype.reason = 0;

            /**
             * Creates a new VerifyResetPasswordCodeResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @static
             * @param {api.external.IVerifyResetPasswordCodeResponseBody=} [properties] Properties to set
             * @returns {api.external.VerifyResetPasswordCodeResponseBody} VerifyResetPasswordCodeResponseBody instance
             */
            VerifyResetPasswordCodeResponseBody.create = function create(properties) {
                return new VerifyResetPasswordCodeResponseBody(properties);
            };

            /**
             * Encodes the specified VerifyResetPasswordCodeResponseBody message. Does not implicitly {@link api.external.VerifyResetPasswordCodeResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @static
             * @param {api.external.IVerifyResetPasswordCodeResponseBody} message VerifyResetPasswordCodeResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyResetPasswordCodeResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.reason != null && message.hasOwnProperty("reason"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.reason);
                return writer;
            };

            /**
             * Encodes the specified VerifyResetPasswordCodeResponseBody message, length delimited. Does not implicitly {@link api.external.VerifyResetPasswordCodeResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @static
             * @param {api.external.IVerifyResetPasswordCodeResponseBody} message VerifyResetPasswordCodeResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyResetPasswordCodeResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a VerifyResetPasswordCodeResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.VerifyResetPasswordCodeResponseBody} VerifyResetPasswordCodeResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyResetPasswordCodeResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.VerifyResetPasswordCodeResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.reason = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a VerifyResetPasswordCodeResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.VerifyResetPasswordCodeResponseBody} VerifyResetPasswordCodeResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyResetPasswordCodeResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a VerifyResetPasswordCodeResponseBody message.
             * @function verify
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            VerifyResetPasswordCodeResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.reason != null && message.hasOwnProperty("reason"))
                    switch (message.reason) {
                    default:
                        return "reason: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a VerifyResetPasswordCodeResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.VerifyResetPasswordCodeResponseBody} VerifyResetPasswordCodeResponseBody
             */
            VerifyResetPasswordCodeResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.VerifyResetPasswordCodeResponseBody)
                    return object;
                let message = new $root.api.external.VerifyResetPasswordCodeResponseBody();
                switch (object.reason) {
                case "UNKNOWN":
                case 0:
                    message.reason = 0;
                    break;
                case "MISMATCH":
                case 1:
                    message.reason = 1;
                    break;
                case "USED":
                case 2:
                    message.reason = 2;
                    break;
                case "EXPIRED":
                case 3:
                    message.reason = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a VerifyResetPasswordCodeResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @static
             * @param {api.external.VerifyResetPasswordCodeResponseBody} message VerifyResetPasswordCodeResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            VerifyResetPasswordCodeResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.reason = options.enums === String ? "UNKNOWN" : 0;
                if (message.reason != null && message.hasOwnProperty("reason"))
                    object.reason = options.enums === String ? $root.ResetPasswordErrorReason.Enum[message.reason] : message.reason;
                return object;
            };

            /**
             * Converts this VerifyResetPasswordCodeResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.VerifyResetPasswordCodeResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            VerifyResetPasswordCodeResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return VerifyResetPasswordCodeResponseBody;
        })();

        external.UpdatePasswordByResetIDRequestBody = (function() {

            /**
             * Properties of an UpdatePasswordByResetIDRequestBody.
             * @memberof api.external
             * @interface IUpdatePasswordByResetIDRequestBody
             * @property {string|null} [id] UpdatePasswordByResetIDRequestBody id
             * @property {string|null} [new_password] UpdatePasswordByResetIDRequestBody new_password
             */

            /**
             * Constructs a new UpdatePasswordByResetIDRequestBody.
             * @memberof api.external
             * @classdesc Represents an UpdatePasswordByResetIDRequestBody.
             * @implements IUpdatePasswordByResetIDRequestBody
             * @constructor
             * @param {api.external.IUpdatePasswordByResetIDRequestBody=} [properties] Properties to set
             */
            function UpdatePasswordByResetIDRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdatePasswordByResetIDRequestBody id.
             * @member {string} id
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @instance
             */
            UpdatePasswordByResetIDRequestBody.prototype.id = "";

            /**
             * UpdatePasswordByResetIDRequestBody new_password.
             * @member {string} new_password
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @instance
             */
            UpdatePasswordByResetIDRequestBody.prototype.new_password = "";

            /**
             * Creates a new UpdatePasswordByResetIDRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @static
             * @param {api.external.IUpdatePasswordByResetIDRequestBody=} [properties] Properties to set
             * @returns {api.external.UpdatePasswordByResetIDRequestBody} UpdatePasswordByResetIDRequestBody instance
             */
            UpdatePasswordByResetIDRequestBody.create = function create(properties) {
                return new UpdatePasswordByResetIDRequestBody(properties);
            };

            /**
             * Encodes the specified UpdatePasswordByResetIDRequestBody message. Does not implicitly {@link api.external.UpdatePasswordByResetIDRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @static
             * @param {api.external.IUpdatePasswordByResetIDRequestBody} message UpdatePasswordByResetIDRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdatePasswordByResetIDRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && message.hasOwnProperty("id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.new_password != null && message.hasOwnProperty("new_password"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.new_password);
                return writer;
            };

            /**
             * Encodes the specified UpdatePasswordByResetIDRequestBody message, length delimited. Does not implicitly {@link api.external.UpdatePasswordByResetIDRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @static
             * @param {api.external.IUpdatePasswordByResetIDRequestBody} message UpdatePasswordByResetIDRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdatePasswordByResetIDRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdatePasswordByResetIDRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdatePasswordByResetIDRequestBody} UpdatePasswordByResetIDRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdatePasswordByResetIDRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdatePasswordByResetIDRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.new_password = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdatePasswordByResetIDRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdatePasswordByResetIDRequestBody} UpdatePasswordByResetIDRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdatePasswordByResetIDRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdatePasswordByResetIDRequestBody message.
             * @function verify
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdatePasswordByResetIDRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.new_password != null && message.hasOwnProperty("new_password"))
                    if (!$util.isString(message.new_password))
                        return "new_password: string expected";
                return null;
            };

            /**
             * Creates an UpdatePasswordByResetIDRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdatePasswordByResetIDRequestBody} UpdatePasswordByResetIDRequestBody
             */
            UpdatePasswordByResetIDRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdatePasswordByResetIDRequestBody)
                    return object;
                let message = new $root.api.external.UpdatePasswordByResetIDRequestBody();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.new_password != null)
                    message.new_password = String(object.new_password);
                return message;
            };

            /**
             * Creates a plain object from an UpdatePasswordByResetIDRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @static
             * @param {api.external.UpdatePasswordByResetIDRequestBody} message UpdatePasswordByResetIDRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdatePasswordByResetIDRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.id = "";
                    object.new_password = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.new_password != null && message.hasOwnProperty("new_password"))
                    object.new_password = message.new_password;
                return object;
            };

            /**
             * Converts this UpdatePasswordByResetIDRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdatePasswordByResetIDRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdatePasswordByResetIDRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdatePasswordByResetIDRequestBody;
        })();

        external.UpdatePasswordByResetIDResponseBody = (function() {

            /**
             * Properties of an UpdatePasswordByResetIDResponseBody.
             * @memberof api.external
             * @interface IUpdatePasswordByResetIDResponseBody
             */

            /**
             * Constructs a new UpdatePasswordByResetIDResponseBody.
             * @memberof api.external
             * @classdesc Represents an UpdatePasswordByResetIDResponseBody.
             * @implements IUpdatePasswordByResetIDResponseBody
             * @constructor
             * @param {api.external.IUpdatePasswordByResetIDResponseBody=} [properties] Properties to set
             */
            function UpdatePasswordByResetIDResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdatePasswordByResetIDResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @static
             * @param {api.external.IUpdatePasswordByResetIDResponseBody=} [properties] Properties to set
             * @returns {api.external.UpdatePasswordByResetIDResponseBody} UpdatePasswordByResetIDResponseBody instance
             */
            UpdatePasswordByResetIDResponseBody.create = function create(properties) {
                return new UpdatePasswordByResetIDResponseBody(properties);
            };

            /**
             * Encodes the specified UpdatePasswordByResetIDResponseBody message. Does not implicitly {@link api.external.UpdatePasswordByResetIDResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @static
             * @param {api.external.IUpdatePasswordByResetIDResponseBody} message UpdatePasswordByResetIDResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdatePasswordByResetIDResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdatePasswordByResetIDResponseBody message, length delimited. Does not implicitly {@link api.external.UpdatePasswordByResetIDResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @static
             * @param {api.external.IUpdatePasswordByResetIDResponseBody} message UpdatePasswordByResetIDResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdatePasswordByResetIDResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdatePasswordByResetIDResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdatePasswordByResetIDResponseBody} UpdatePasswordByResetIDResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdatePasswordByResetIDResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdatePasswordByResetIDResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdatePasswordByResetIDResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdatePasswordByResetIDResponseBody} UpdatePasswordByResetIDResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdatePasswordByResetIDResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdatePasswordByResetIDResponseBody message.
             * @function verify
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdatePasswordByResetIDResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdatePasswordByResetIDResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdatePasswordByResetIDResponseBody} UpdatePasswordByResetIDResponseBody
             */
            UpdatePasswordByResetIDResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdatePasswordByResetIDResponseBody)
                    return object;
                return new $root.api.external.UpdatePasswordByResetIDResponseBody();
            };

            /**
             * Creates a plain object from an UpdatePasswordByResetIDResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @static
             * @param {api.external.UpdatePasswordByResetIDResponseBody} message UpdatePasswordByResetIDResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdatePasswordByResetIDResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdatePasswordByResetIDResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdatePasswordByResetIDResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdatePasswordByResetIDResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdatePasswordByResetIDResponseBody;
        })();

        external.CreateTFNExemptionRequestBody = (function() {

            /**
             * Properties of a CreateTFNExemptionRequestBody.
             * @memberof api.external
             * @interface ICreateTFNExemptionRequestBody
             * @property {TFNExemptionCode.Enum|null} [code] CreateTFNExemptionRequestBody code
             */

            /**
             * Constructs a new CreateTFNExemptionRequestBody.
             * @memberof api.external
             * @classdesc Represents a CreateTFNExemptionRequestBody.
             * @implements ICreateTFNExemptionRequestBody
             * @constructor
             * @param {api.external.ICreateTFNExemptionRequestBody=} [properties] Properties to set
             */
            function CreateTFNExemptionRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateTFNExemptionRequestBody code.
             * @member {TFNExemptionCode.Enum} code
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @instance
             */
            CreateTFNExemptionRequestBody.prototype.code = 0;

            /**
             * Creates a new CreateTFNExemptionRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @static
             * @param {api.external.ICreateTFNExemptionRequestBody=} [properties] Properties to set
             * @returns {api.external.CreateTFNExemptionRequestBody} CreateTFNExemptionRequestBody instance
             */
            CreateTFNExemptionRequestBody.create = function create(properties) {
                return new CreateTFNExemptionRequestBody(properties);
            };

            /**
             * Encodes the specified CreateTFNExemptionRequestBody message. Does not implicitly {@link api.external.CreateTFNExemptionRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @static
             * @param {api.external.ICreateTFNExemptionRequestBody} message CreateTFNExemptionRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateTFNExemptionRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.code != null && message.hasOwnProperty("code"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                return writer;
            };

            /**
             * Encodes the specified CreateTFNExemptionRequestBody message, length delimited. Does not implicitly {@link api.external.CreateTFNExemptionRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @static
             * @param {api.external.ICreateTFNExemptionRequestBody} message CreateTFNExemptionRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateTFNExemptionRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateTFNExemptionRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateTFNExemptionRequestBody} CreateTFNExemptionRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateTFNExemptionRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateTFNExemptionRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.code = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateTFNExemptionRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateTFNExemptionRequestBody} CreateTFNExemptionRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateTFNExemptionRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateTFNExemptionRequestBody message.
             * @function verify
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateTFNExemptionRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    switch (message.code) {
                    default:
                        return "code: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        break;
                    }
                return null;
            };

            /**
             * Creates a CreateTFNExemptionRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateTFNExemptionRequestBody} CreateTFNExemptionRequestBody
             */
            CreateTFNExemptionRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateTFNExemptionRequestBody)
                    return object;
                let message = new $root.api.external.CreateTFNExemptionRequestBody();
                switch (object.code) {
                case "UNKNOWN":
                case 0:
                    message.code = 0;
                    break;
                case "PENSIONER":
                case 1:
                    message.code = 1;
                    break;
                case "CENTRELINK":
                case 2:
                    message.code = 2;
                    break;
                case "UNDER_16":
                case 3:
                    message.code = 3;
                    break;
                case "ENTITY_NOT_REQUIRED":
                case 4:
                    message.code = 4;
                    break;
                case "BUSINESS_INVESTOR":
                case 5:
                    message.code = 5;
                    break;
                case "NON_RESIDENT":
                case 6:
                    message.code = 6;
                    break;
                case "NOT_AN_ABN":
                case 7:
                    message.code = 7;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a CreateTFNExemptionRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @static
             * @param {api.external.CreateTFNExemptionRequestBody} message CreateTFNExemptionRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateTFNExemptionRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.code = options.enums === String ? "UNKNOWN" : 0;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = options.enums === String ? $root.TFNExemptionCode.Enum[message.code] : message.code;
                return object;
            };

            /**
             * Converts this CreateTFNExemptionRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateTFNExemptionRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateTFNExemptionRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateTFNExemptionRequestBody;
        })();

        external.CreateTFNExemptionResponseBody = (function() {

            /**
             * Properties of a CreateTFNExemptionResponseBody.
             * @memberof api.external
             * @interface ICreateTFNExemptionResponseBody
             */

            /**
             * Constructs a new CreateTFNExemptionResponseBody.
             * @memberof api.external
             * @classdesc Represents a CreateTFNExemptionResponseBody.
             * @implements ICreateTFNExemptionResponseBody
             * @constructor
             * @param {api.external.ICreateTFNExemptionResponseBody=} [properties] Properties to set
             */
            function CreateTFNExemptionResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateTFNExemptionResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @static
             * @param {api.external.ICreateTFNExemptionResponseBody=} [properties] Properties to set
             * @returns {api.external.CreateTFNExemptionResponseBody} CreateTFNExemptionResponseBody instance
             */
            CreateTFNExemptionResponseBody.create = function create(properties) {
                return new CreateTFNExemptionResponseBody(properties);
            };

            /**
             * Encodes the specified CreateTFNExemptionResponseBody message. Does not implicitly {@link api.external.CreateTFNExemptionResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @static
             * @param {api.external.ICreateTFNExemptionResponseBody} message CreateTFNExemptionResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateTFNExemptionResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateTFNExemptionResponseBody message, length delimited. Does not implicitly {@link api.external.CreateTFNExemptionResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @static
             * @param {api.external.ICreateTFNExemptionResponseBody} message CreateTFNExemptionResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateTFNExemptionResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateTFNExemptionResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateTFNExemptionResponseBody} CreateTFNExemptionResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateTFNExemptionResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateTFNExemptionResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateTFNExemptionResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateTFNExemptionResponseBody} CreateTFNExemptionResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateTFNExemptionResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateTFNExemptionResponseBody message.
             * @function verify
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateTFNExemptionResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateTFNExemptionResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateTFNExemptionResponseBody} CreateTFNExemptionResponseBody
             */
            CreateTFNExemptionResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateTFNExemptionResponseBody)
                    return object;
                return new $root.api.external.CreateTFNExemptionResponseBody();
            };

            /**
             * Creates a plain object from a CreateTFNExemptionResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @static
             * @param {api.external.CreateTFNExemptionResponseBody} message CreateTFNExemptionResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateTFNExemptionResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateTFNExemptionResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateTFNExemptionResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateTFNExemptionResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateTFNExemptionResponseBody;
        })();

        external.MarkTFNDeletedRequestBody = (function() {

            /**
             * Properties of a MarkTFNDeletedRequestBody.
             * @memberof api.external
             * @interface IMarkTFNDeletedRequestBody
             */

            /**
             * Constructs a new MarkTFNDeletedRequestBody.
             * @memberof api.external
             * @classdesc Represents a MarkTFNDeletedRequestBody.
             * @implements IMarkTFNDeletedRequestBody
             * @constructor
             * @param {api.external.IMarkTFNDeletedRequestBody=} [properties] Properties to set
             */
            function MarkTFNDeletedRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new MarkTFNDeletedRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @static
             * @param {api.external.IMarkTFNDeletedRequestBody=} [properties] Properties to set
             * @returns {api.external.MarkTFNDeletedRequestBody} MarkTFNDeletedRequestBody instance
             */
            MarkTFNDeletedRequestBody.create = function create(properties) {
                return new MarkTFNDeletedRequestBody(properties);
            };

            /**
             * Encodes the specified MarkTFNDeletedRequestBody message. Does not implicitly {@link api.external.MarkTFNDeletedRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @static
             * @param {api.external.IMarkTFNDeletedRequestBody} message MarkTFNDeletedRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkTFNDeletedRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified MarkTFNDeletedRequestBody message, length delimited. Does not implicitly {@link api.external.MarkTFNDeletedRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @static
             * @param {api.external.IMarkTFNDeletedRequestBody} message MarkTFNDeletedRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkTFNDeletedRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MarkTFNDeletedRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.MarkTFNDeletedRequestBody} MarkTFNDeletedRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkTFNDeletedRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.MarkTFNDeletedRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MarkTFNDeletedRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.MarkTFNDeletedRequestBody} MarkTFNDeletedRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkTFNDeletedRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MarkTFNDeletedRequestBody message.
             * @function verify
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MarkTFNDeletedRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a MarkTFNDeletedRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.MarkTFNDeletedRequestBody} MarkTFNDeletedRequestBody
             */
            MarkTFNDeletedRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.MarkTFNDeletedRequestBody)
                    return object;
                return new $root.api.external.MarkTFNDeletedRequestBody();
            };

            /**
             * Creates a plain object from a MarkTFNDeletedRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @static
             * @param {api.external.MarkTFNDeletedRequestBody} message MarkTFNDeletedRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MarkTFNDeletedRequestBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this MarkTFNDeletedRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.MarkTFNDeletedRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MarkTFNDeletedRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MarkTFNDeletedRequestBody;
        })();

        external.MarkTFNDeletedResponseBody = (function() {

            /**
             * Properties of a MarkTFNDeletedResponseBody.
             * @memberof api.external
             * @interface IMarkTFNDeletedResponseBody
             */

            /**
             * Constructs a new MarkTFNDeletedResponseBody.
             * @memberof api.external
             * @classdesc Represents a MarkTFNDeletedResponseBody.
             * @implements IMarkTFNDeletedResponseBody
             * @constructor
             * @param {api.external.IMarkTFNDeletedResponseBody=} [properties] Properties to set
             */
            function MarkTFNDeletedResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new MarkTFNDeletedResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @static
             * @param {api.external.IMarkTFNDeletedResponseBody=} [properties] Properties to set
             * @returns {api.external.MarkTFNDeletedResponseBody} MarkTFNDeletedResponseBody instance
             */
            MarkTFNDeletedResponseBody.create = function create(properties) {
                return new MarkTFNDeletedResponseBody(properties);
            };

            /**
             * Encodes the specified MarkTFNDeletedResponseBody message. Does not implicitly {@link api.external.MarkTFNDeletedResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @static
             * @param {api.external.IMarkTFNDeletedResponseBody} message MarkTFNDeletedResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkTFNDeletedResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified MarkTFNDeletedResponseBody message, length delimited. Does not implicitly {@link api.external.MarkTFNDeletedResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @static
             * @param {api.external.IMarkTFNDeletedResponseBody} message MarkTFNDeletedResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MarkTFNDeletedResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MarkTFNDeletedResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.MarkTFNDeletedResponseBody} MarkTFNDeletedResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkTFNDeletedResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.MarkTFNDeletedResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MarkTFNDeletedResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.MarkTFNDeletedResponseBody} MarkTFNDeletedResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MarkTFNDeletedResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MarkTFNDeletedResponseBody message.
             * @function verify
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MarkTFNDeletedResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a MarkTFNDeletedResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.MarkTFNDeletedResponseBody} MarkTFNDeletedResponseBody
             */
            MarkTFNDeletedResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.MarkTFNDeletedResponseBody)
                    return object;
                return new $root.api.external.MarkTFNDeletedResponseBody();
            };

            /**
             * Creates a plain object from a MarkTFNDeletedResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @static
             * @param {api.external.MarkTFNDeletedResponseBody} message MarkTFNDeletedResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MarkTFNDeletedResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this MarkTFNDeletedResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.MarkTFNDeletedResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MarkTFNDeletedResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MarkTFNDeletedResponseBody;
        })();

        external.InsertTFNRequestBody = (function() {

            /**
             * Properties of an InsertTFNRequestBody.
             * @memberof api.external
             * @interface IInsertTFNRequestBody
             * @property {string|null} [tfn] InsertTFNRequestBody tfn
             */

            /**
             * Constructs a new InsertTFNRequestBody.
             * @memberof api.external
             * @classdesc Represents an InsertTFNRequestBody.
             * @implements IInsertTFNRequestBody
             * @constructor
             * @param {api.external.IInsertTFNRequestBody=} [properties] Properties to set
             */
            function InsertTFNRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * InsertTFNRequestBody tfn.
             * @member {string} tfn
             * @memberof api.external.InsertTFNRequestBody
             * @instance
             */
            InsertTFNRequestBody.prototype.tfn = "";

            /**
             * Creates a new InsertTFNRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.InsertTFNRequestBody
             * @static
             * @param {api.external.IInsertTFNRequestBody=} [properties] Properties to set
             * @returns {api.external.InsertTFNRequestBody} InsertTFNRequestBody instance
             */
            InsertTFNRequestBody.create = function create(properties) {
                return new InsertTFNRequestBody(properties);
            };

            /**
             * Encodes the specified InsertTFNRequestBody message. Does not implicitly {@link api.external.InsertTFNRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.InsertTFNRequestBody
             * @static
             * @param {api.external.IInsertTFNRequestBody} message InsertTFNRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InsertTFNRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.tfn != null && message.hasOwnProperty("tfn"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.tfn);
                return writer;
            };

            /**
             * Encodes the specified InsertTFNRequestBody message, length delimited. Does not implicitly {@link api.external.InsertTFNRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.InsertTFNRequestBody
             * @static
             * @param {api.external.IInsertTFNRequestBody} message InsertTFNRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InsertTFNRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an InsertTFNRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.InsertTFNRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.InsertTFNRequestBody} InsertTFNRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InsertTFNRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.InsertTFNRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.tfn = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an InsertTFNRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.InsertTFNRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.InsertTFNRequestBody} InsertTFNRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InsertTFNRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an InsertTFNRequestBody message.
             * @function verify
             * @memberof api.external.InsertTFNRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            InsertTFNRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.tfn != null && message.hasOwnProperty("tfn"))
                    if (!$util.isString(message.tfn))
                        return "tfn: string expected";
                return null;
            };

            /**
             * Creates an InsertTFNRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.InsertTFNRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.InsertTFNRequestBody} InsertTFNRequestBody
             */
            InsertTFNRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.InsertTFNRequestBody)
                    return object;
                let message = new $root.api.external.InsertTFNRequestBody();
                if (object.tfn != null)
                    message.tfn = String(object.tfn);
                return message;
            };

            /**
             * Creates a plain object from an InsertTFNRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.InsertTFNRequestBody
             * @static
             * @param {api.external.InsertTFNRequestBody} message InsertTFNRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            InsertTFNRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.tfn = "";
                if (message.tfn != null && message.hasOwnProperty("tfn"))
                    object.tfn = message.tfn;
                return object;
            };

            /**
             * Converts this InsertTFNRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.InsertTFNRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            InsertTFNRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return InsertTFNRequestBody;
        })();

        external.InsertTFNResponseBody = (function() {

            /**
             * Properties of an InsertTFNResponseBody.
             * @memberof api.external
             * @interface IInsertTFNResponseBody
             */

            /**
             * Constructs a new InsertTFNResponseBody.
             * @memberof api.external
             * @classdesc Represents an InsertTFNResponseBody.
             * @implements IInsertTFNResponseBody
             * @constructor
             * @param {api.external.IInsertTFNResponseBody=} [properties] Properties to set
             */
            function InsertTFNResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new InsertTFNResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.InsertTFNResponseBody
             * @static
             * @param {api.external.IInsertTFNResponseBody=} [properties] Properties to set
             * @returns {api.external.InsertTFNResponseBody} InsertTFNResponseBody instance
             */
            InsertTFNResponseBody.create = function create(properties) {
                return new InsertTFNResponseBody(properties);
            };

            /**
             * Encodes the specified InsertTFNResponseBody message. Does not implicitly {@link api.external.InsertTFNResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.InsertTFNResponseBody
             * @static
             * @param {api.external.IInsertTFNResponseBody} message InsertTFNResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InsertTFNResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified InsertTFNResponseBody message, length delimited. Does not implicitly {@link api.external.InsertTFNResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.InsertTFNResponseBody
             * @static
             * @param {api.external.IInsertTFNResponseBody} message InsertTFNResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InsertTFNResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an InsertTFNResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.InsertTFNResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.InsertTFNResponseBody} InsertTFNResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InsertTFNResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.InsertTFNResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an InsertTFNResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.InsertTFNResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.InsertTFNResponseBody} InsertTFNResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InsertTFNResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an InsertTFNResponseBody message.
             * @function verify
             * @memberof api.external.InsertTFNResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            InsertTFNResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an InsertTFNResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.InsertTFNResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.InsertTFNResponseBody} InsertTFNResponseBody
             */
            InsertTFNResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.InsertTFNResponseBody)
                    return object;
                return new $root.api.external.InsertTFNResponseBody();
            };

            /**
             * Creates a plain object from an InsertTFNResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.InsertTFNResponseBody
             * @static
             * @param {api.external.InsertTFNResponseBody} message InsertTFNResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            InsertTFNResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this InsertTFNResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.InsertTFNResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            InsertTFNResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return InsertTFNResponseBody;
        })();

        external.GetUserVerificationResponseBody = (function() {

            /**
             * Properties of a GetUserVerificationResponseBody.
             * @memberof api.external
             * @interface IGetUserVerificationResponseBody
             * @property {boolean|null} [is_verified] GetUserVerificationResponseBody is_verified
             * @property {Array.<IFraudServiceCheck>|null} [service_checks] GetUserVerificationResponseBody service_checks
             * @property {IGreenIdSourceDetails|null} [green_id_source_details] GetUserVerificationResponseBody green_id_source_details
             */

            /**
             * Constructs a new GetUserVerificationResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetUserVerificationResponseBody.
             * @implements IGetUserVerificationResponseBody
             * @constructor
             * @param {api.external.IGetUserVerificationResponseBody=} [properties] Properties to set
             */
            function GetUserVerificationResponseBody(properties) {
                this.service_checks = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetUserVerificationResponseBody is_verified.
             * @member {boolean} is_verified
             * @memberof api.external.GetUserVerificationResponseBody
             * @instance
             */
            GetUserVerificationResponseBody.prototype.is_verified = false;

            /**
             * GetUserVerificationResponseBody service_checks.
             * @member {Array.<IFraudServiceCheck>} service_checks
             * @memberof api.external.GetUserVerificationResponseBody
             * @instance
             */
            GetUserVerificationResponseBody.prototype.service_checks = $util.emptyArray;

            /**
             * GetUserVerificationResponseBody green_id_source_details.
             * @member {IGreenIdSourceDetails|null|undefined} green_id_source_details
             * @memberof api.external.GetUserVerificationResponseBody
             * @instance
             */
            GetUserVerificationResponseBody.prototype.green_id_source_details = null;

            /**
             * Creates a new GetUserVerificationResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetUserVerificationResponseBody
             * @static
             * @param {api.external.IGetUserVerificationResponseBody=} [properties] Properties to set
             * @returns {api.external.GetUserVerificationResponseBody} GetUserVerificationResponseBody instance
             */
            GetUserVerificationResponseBody.create = function create(properties) {
                return new GetUserVerificationResponseBody(properties);
            };

            /**
             * Encodes the specified GetUserVerificationResponseBody message. Does not implicitly {@link api.external.GetUserVerificationResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetUserVerificationResponseBody
             * @static
             * @param {api.external.IGetUserVerificationResponseBody} message GetUserVerificationResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUserVerificationResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.is_verified != null && message.hasOwnProperty("is_verified"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.is_verified);
                if (message.service_checks != null && message.service_checks.length)
                    for (let i = 0; i < message.service_checks.length; ++i)
                        $root.FraudServiceCheck.encode(message.service_checks[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.green_id_source_details != null && message.hasOwnProperty("green_id_source_details"))
                    $root.GreenIdSourceDetails.encode(message.green_id_source_details, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetUserVerificationResponseBody message, length delimited. Does not implicitly {@link api.external.GetUserVerificationResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetUserVerificationResponseBody
             * @static
             * @param {api.external.IGetUserVerificationResponseBody} message GetUserVerificationResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUserVerificationResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetUserVerificationResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetUserVerificationResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetUserVerificationResponseBody} GetUserVerificationResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUserVerificationResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetUserVerificationResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.is_verified = reader.bool();
                        break;
                    case 2:
                        if (!(message.service_checks && message.service_checks.length))
                            message.service_checks = [];
                        message.service_checks.push($root.FraudServiceCheck.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.green_id_source_details = $root.GreenIdSourceDetails.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetUserVerificationResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetUserVerificationResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetUserVerificationResponseBody} GetUserVerificationResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUserVerificationResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetUserVerificationResponseBody message.
             * @function verify
             * @memberof api.external.GetUserVerificationResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetUserVerificationResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.is_verified != null && message.hasOwnProperty("is_verified"))
                    if (typeof message.is_verified !== "boolean")
                        return "is_verified: boolean expected";
                if (message.service_checks != null && message.hasOwnProperty("service_checks")) {
                    if (!Array.isArray(message.service_checks))
                        return "service_checks: array expected";
                    for (let i = 0; i < message.service_checks.length; ++i) {
                        let error = $root.FraudServiceCheck.verify(message.service_checks[i]);
                        if (error)
                            return "service_checks." + error;
                    }
                }
                if (message.green_id_source_details != null && message.hasOwnProperty("green_id_source_details")) {
                    let error = $root.GreenIdSourceDetails.verify(message.green_id_source_details);
                    if (error)
                        return "green_id_source_details." + error;
                }
                return null;
            };

            /**
             * Creates a GetUserVerificationResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetUserVerificationResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetUserVerificationResponseBody} GetUserVerificationResponseBody
             */
            GetUserVerificationResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetUserVerificationResponseBody)
                    return object;
                let message = new $root.api.external.GetUserVerificationResponseBody();
                if (object.is_verified != null)
                    message.is_verified = Boolean(object.is_verified);
                if (object.service_checks) {
                    if (!Array.isArray(object.service_checks))
                        throw TypeError(".api.external.GetUserVerificationResponseBody.service_checks: array expected");
                    message.service_checks = [];
                    for (let i = 0; i < object.service_checks.length; ++i) {
                        if (typeof object.service_checks[i] !== "object")
                            throw TypeError(".api.external.GetUserVerificationResponseBody.service_checks: object expected");
                        message.service_checks[i] = $root.FraudServiceCheck.fromObject(object.service_checks[i]);
                    }
                }
                if (object.green_id_source_details != null) {
                    if (typeof object.green_id_source_details !== "object")
                        throw TypeError(".api.external.GetUserVerificationResponseBody.green_id_source_details: object expected");
                    message.green_id_source_details = $root.GreenIdSourceDetails.fromObject(object.green_id_source_details);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetUserVerificationResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetUserVerificationResponseBody
             * @static
             * @param {api.external.GetUserVerificationResponseBody} message GetUserVerificationResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetUserVerificationResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.service_checks = [];
                if (options.defaults) {
                    object.is_verified = false;
                    object.green_id_source_details = null;
                }
                if (message.is_verified != null && message.hasOwnProperty("is_verified"))
                    object.is_verified = message.is_verified;
                if (message.service_checks && message.service_checks.length) {
                    object.service_checks = [];
                    for (let j = 0; j < message.service_checks.length; ++j)
                        object.service_checks[j] = $root.FraudServiceCheck.toObject(message.service_checks[j], options);
                }
                if (message.green_id_source_details != null && message.hasOwnProperty("green_id_source_details"))
                    object.green_id_source_details = $root.GreenIdSourceDetails.toObject(message.green_id_source_details, options);
                return object;
            };

            /**
             * Converts this GetUserVerificationResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetUserVerificationResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetUserVerificationResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetUserVerificationResponseBody;
        })();

        external.GetActiveArticlesRequestBody = (function() {

            /**
             * Properties of a GetActiveArticlesRequestBody.
             * @memberof api.external
             * @interface IGetActiveArticlesRequestBody
             */

            /**
             * Constructs a new GetActiveArticlesRequestBody.
             * @memberof api.external
             * @classdesc Represents a GetActiveArticlesRequestBody.
             * @implements IGetActiveArticlesRequestBody
             * @constructor
             * @param {api.external.IGetActiveArticlesRequestBody=} [properties] Properties to set
             */
            function GetActiveArticlesRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetActiveArticlesRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetActiveArticlesRequestBody
             * @static
             * @param {api.external.IGetActiveArticlesRequestBody=} [properties] Properties to set
             * @returns {api.external.GetActiveArticlesRequestBody} GetActiveArticlesRequestBody instance
             */
            GetActiveArticlesRequestBody.create = function create(properties) {
                return new GetActiveArticlesRequestBody(properties);
            };

            /**
             * Encodes the specified GetActiveArticlesRequestBody message. Does not implicitly {@link api.external.GetActiveArticlesRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetActiveArticlesRequestBody
             * @static
             * @param {api.external.IGetActiveArticlesRequestBody} message GetActiveArticlesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetActiveArticlesRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetActiveArticlesRequestBody message, length delimited. Does not implicitly {@link api.external.GetActiveArticlesRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetActiveArticlesRequestBody
             * @static
             * @param {api.external.IGetActiveArticlesRequestBody} message GetActiveArticlesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetActiveArticlesRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetActiveArticlesRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetActiveArticlesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetActiveArticlesRequestBody} GetActiveArticlesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetActiveArticlesRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetActiveArticlesRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetActiveArticlesRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetActiveArticlesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetActiveArticlesRequestBody} GetActiveArticlesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetActiveArticlesRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetActiveArticlesRequestBody message.
             * @function verify
             * @memberof api.external.GetActiveArticlesRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetActiveArticlesRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetActiveArticlesRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetActiveArticlesRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetActiveArticlesRequestBody} GetActiveArticlesRequestBody
             */
            GetActiveArticlesRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetActiveArticlesRequestBody)
                    return object;
                return new $root.api.external.GetActiveArticlesRequestBody();
            };

            /**
             * Creates a plain object from a GetActiveArticlesRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetActiveArticlesRequestBody
             * @static
             * @param {api.external.GetActiveArticlesRequestBody} message GetActiveArticlesRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetActiveArticlesRequestBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetActiveArticlesRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.GetActiveArticlesRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetActiveArticlesRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetActiveArticlesRequestBody;
        })();

        external.GetActiveArticlesResponseBody = (function() {

            /**
             * Properties of a GetActiveArticlesResponseBody.
             * @memberof api.external
             * @interface IGetActiveArticlesResponseBody
             * @property {Array.<IArticle>|null} [articles] GetActiveArticlesResponseBody articles
             */

            /**
             * Constructs a new GetActiveArticlesResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetActiveArticlesResponseBody.
             * @implements IGetActiveArticlesResponseBody
             * @constructor
             * @param {api.external.IGetActiveArticlesResponseBody=} [properties] Properties to set
             */
            function GetActiveArticlesResponseBody(properties) {
                this.articles = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetActiveArticlesResponseBody articles.
             * @member {Array.<IArticle>} articles
             * @memberof api.external.GetActiveArticlesResponseBody
             * @instance
             */
            GetActiveArticlesResponseBody.prototype.articles = $util.emptyArray;

            /**
             * Creates a new GetActiveArticlesResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetActiveArticlesResponseBody
             * @static
             * @param {api.external.IGetActiveArticlesResponseBody=} [properties] Properties to set
             * @returns {api.external.GetActiveArticlesResponseBody} GetActiveArticlesResponseBody instance
             */
            GetActiveArticlesResponseBody.create = function create(properties) {
                return new GetActiveArticlesResponseBody(properties);
            };

            /**
             * Encodes the specified GetActiveArticlesResponseBody message. Does not implicitly {@link api.external.GetActiveArticlesResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetActiveArticlesResponseBody
             * @static
             * @param {api.external.IGetActiveArticlesResponseBody} message GetActiveArticlesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetActiveArticlesResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.articles != null && message.articles.length)
                    for (let i = 0; i < message.articles.length; ++i)
                        $root.Article.encode(message.articles[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetActiveArticlesResponseBody message, length delimited. Does not implicitly {@link api.external.GetActiveArticlesResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetActiveArticlesResponseBody
             * @static
             * @param {api.external.IGetActiveArticlesResponseBody} message GetActiveArticlesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetActiveArticlesResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetActiveArticlesResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetActiveArticlesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetActiveArticlesResponseBody} GetActiveArticlesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetActiveArticlesResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetActiveArticlesResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.articles && message.articles.length))
                            message.articles = [];
                        message.articles.push($root.Article.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetActiveArticlesResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetActiveArticlesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetActiveArticlesResponseBody} GetActiveArticlesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetActiveArticlesResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetActiveArticlesResponseBody message.
             * @function verify
             * @memberof api.external.GetActiveArticlesResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetActiveArticlesResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.articles != null && message.hasOwnProperty("articles")) {
                    if (!Array.isArray(message.articles))
                        return "articles: array expected";
                    for (let i = 0; i < message.articles.length; ++i) {
                        let error = $root.Article.verify(message.articles[i]);
                        if (error)
                            return "articles." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetActiveArticlesResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetActiveArticlesResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetActiveArticlesResponseBody} GetActiveArticlesResponseBody
             */
            GetActiveArticlesResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetActiveArticlesResponseBody)
                    return object;
                let message = new $root.api.external.GetActiveArticlesResponseBody();
                if (object.articles) {
                    if (!Array.isArray(object.articles))
                        throw TypeError(".api.external.GetActiveArticlesResponseBody.articles: array expected");
                    message.articles = [];
                    for (let i = 0; i < object.articles.length; ++i) {
                        if (typeof object.articles[i] !== "object")
                            throw TypeError(".api.external.GetActiveArticlesResponseBody.articles: object expected");
                        message.articles[i] = $root.Article.fromObject(object.articles[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetActiveArticlesResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetActiveArticlesResponseBody
             * @static
             * @param {api.external.GetActiveArticlesResponseBody} message GetActiveArticlesResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetActiveArticlesResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.articles = [];
                if (message.articles && message.articles.length) {
                    object.articles = [];
                    for (let j = 0; j < message.articles.length; ++j)
                        object.articles[j] = $root.Article.toObject(message.articles[j], options);
                }
                return object;
            };

            /**
             * Converts this GetActiveArticlesResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetActiveArticlesResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetActiveArticlesResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetActiveArticlesResponseBody;
        })();

        external.GetInstrumentOverviewsByPortfolioRequestBody = (function() {

            /**
             * Properties of a GetInstrumentOverviewsByPortfolioRequestBody.
             * @memberof api.external
             * @interface IGetInstrumentOverviewsByPortfolioRequestBody
             * @property {SaverPortfolio.Enum|null} [portfolio] GetInstrumentOverviewsByPortfolioRequestBody portfolio
             */

            /**
             * Constructs a new GetInstrumentOverviewsByPortfolioRequestBody.
             * @memberof api.external
             * @classdesc Represents a GetInstrumentOverviewsByPortfolioRequestBody.
             * @implements IGetInstrumentOverviewsByPortfolioRequestBody
             * @constructor
             * @param {api.external.IGetInstrumentOverviewsByPortfolioRequestBody=} [properties] Properties to set
             */
            function GetInstrumentOverviewsByPortfolioRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetInstrumentOverviewsByPortfolioRequestBody portfolio.
             * @member {SaverPortfolio.Enum} portfolio
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @instance
             */
            GetInstrumentOverviewsByPortfolioRequestBody.prototype.portfolio = 0;

            /**
             * Creates a new GetInstrumentOverviewsByPortfolioRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @static
             * @param {api.external.IGetInstrumentOverviewsByPortfolioRequestBody=} [properties] Properties to set
             * @returns {api.external.GetInstrumentOverviewsByPortfolioRequestBody} GetInstrumentOverviewsByPortfolioRequestBody instance
             */
            GetInstrumentOverviewsByPortfolioRequestBody.create = function create(properties) {
                return new GetInstrumentOverviewsByPortfolioRequestBody(properties);
            };

            /**
             * Encodes the specified GetInstrumentOverviewsByPortfolioRequestBody message. Does not implicitly {@link api.external.GetInstrumentOverviewsByPortfolioRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @static
             * @param {api.external.IGetInstrumentOverviewsByPortfolioRequestBody} message GetInstrumentOverviewsByPortfolioRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetInstrumentOverviewsByPortfolioRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
                return writer;
            };

            /**
             * Encodes the specified GetInstrumentOverviewsByPortfolioRequestBody message, length delimited. Does not implicitly {@link api.external.GetInstrumentOverviewsByPortfolioRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @static
             * @param {api.external.IGetInstrumentOverviewsByPortfolioRequestBody} message GetInstrumentOverviewsByPortfolioRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetInstrumentOverviewsByPortfolioRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetInstrumentOverviewsByPortfolioRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetInstrumentOverviewsByPortfolioRequestBody} GetInstrumentOverviewsByPortfolioRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetInstrumentOverviewsByPortfolioRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetInstrumentOverviewsByPortfolioRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.portfolio = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetInstrumentOverviewsByPortfolioRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetInstrumentOverviewsByPortfolioRequestBody} GetInstrumentOverviewsByPortfolioRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetInstrumentOverviewsByPortfolioRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetInstrumentOverviewsByPortfolioRequestBody message.
             * @function verify
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetInstrumentOverviewsByPortfolioRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    switch (message.portfolio) {
                    default:
                        return "portfolio: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                return null;
            };

            /**
             * Creates a GetInstrumentOverviewsByPortfolioRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetInstrumentOverviewsByPortfolioRequestBody} GetInstrumentOverviewsByPortfolioRequestBody
             */
            GetInstrumentOverviewsByPortfolioRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetInstrumentOverviewsByPortfolioRequestBody)
                    return object;
                let message = new $root.api.external.GetInstrumentOverviewsByPortfolioRequestBody();
                switch (object.portfolio) {
                case "UNKNOWN":
                case 0:
                    message.portfolio = 0;
                    break;
                case "INDEX":
                case 1:
                    message.portfolio = 1;
                    break;
                case "UNIVERSE":
                case 2:
                    message.portfolio = 2;
                    break;
                case "EARTH":
                case 3:
                    message.portfolio = 3;
                    break;
                case "GALAXY":
                case 4:
                    message.portfolio = 4;
                    break;
                case "EXPLORER":
                case 5:
                    message.portfolio = 5;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a GetInstrumentOverviewsByPortfolioRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @static
             * @param {api.external.GetInstrumentOverviewsByPortfolioRequestBody} message GetInstrumentOverviewsByPortfolioRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetInstrumentOverviewsByPortfolioRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.portfolio = options.enums === String ? "UNKNOWN" : 0;
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
                return object;
            };

            /**
             * Converts this GetInstrumentOverviewsByPortfolioRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.GetInstrumentOverviewsByPortfolioRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetInstrumentOverviewsByPortfolioRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetInstrumentOverviewsByPortfolioRequestBody;
        })();

        external.GetInstrumentOverviewsByPortfolioResponseBody = (function() {

            /**
             * Properties of a GetInstrumentOverviewsByPortfolioResponseBody.
             * @memberof api.external
             * @interface IGetInstrumentOverviewsByPortfolioResponseBody
             * @property {Object.<string,IInstrumentOverview>|null} [instrument_id_to_overview] GetInstrumentOverviewsByPortfolioResponseBody instrument_id_to_overview
             */

            /**
             * Constructs a new GetInstrumentOverviewsByPortfolioResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetInstrumentOverviewsByPortfolioResponseBody.
             * @implements IGetInstrumentOverviewsByPortfolioResponseBody
             * @constructor
             * @param {api.external.IGetInstrumentOverviewsByPortfolioResponseBody=} [properties] Properties to set
             */
            function GetInstrumentOverviewsByPortfolioResponseBody(properties) {
                this.instrument_id_to_overview = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetInstrumentOverviewsByPortfolioResponseBody instrument_id_to_overview.
             * @member {Object.<string,IInstrumentOverview>} instrument_id_to_overview
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @instance
             */
            GetInstrumentOverviewsByPortfolioResponseBody.prototype.instrument_id_to_overview = $util.emptyObject;

            /**
             * Creates a new GetInstrumentOverviewsByPortfolioResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @static
             * @param {api.external.IGetInstrumentOverviewsByPortfolioResponseBody=} [properties] Properties to set
             * @returns {api.external.GetInstrumentOverviewsByPortfolioResponseBody} GetInstrumentOverviewsByPortfolioResponseBody instance
             */
            GetInstrumentOverviewsByPortfolioResponseBody.create = function create(properties) {
                return new GetInstrumentOverviewsByPortfolioResponseBody(properties);
            };

            /**
             * Encodes the specified GetInstrumentOverviewsByPortfolioResponseBody message. Does not implicitly {@link api.external.GetInstrumentOverviewsByPortfolioResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @static
             * @param {api.external.IGetInstrumentOverviewsByPortfolioResponseBody} message GetInstrumentOverviewsByPortfolioResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetInstrumentOverviewsByPortfolioResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.instrument_id_to_overview != null && message.hasOwnProperty("instrument_id_to_overview"))
                    for (let keys = Object.keys(message.instrument_id_to_overview), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.InstrumentOverview.encode(message.instrument_id_to_overview[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified GetInstrumentOverviewsByPortfolioResponseBody message, length delimited. Does not implicitly {@link api.external.GetInstrumentOverviewsByPortfolioResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @static
             * @param {api.external.IGetInstrumentOverviewsByPortfolioResponseBody} message GetInstrumentOverviewsByPortfolioResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetInstrumentOverviewsByPortfolioResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetInstrumentOverviewsByPortfolioResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetInstrumentOverviewsByPortfolioResponseBody} GetInstrumentOverviewsByPortfolioResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetInstrumentOverviewsByPortfolioResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetInstrumentOverviewsByPortfolioResponseBody(), key;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        reader.skip().pos++;
                        if (message.instrument_id_to_overview === $util.emptyObject)
                            message.instrument_id_to_overview = {};
                        key = reader.string();
                        reader.pos++;
                        message.instrument_id_to_overview[key] = $root.InstrumentOverview.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetInstrumentOverviewsByPortfolioResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetInstrumentOverviewsByPortfolioResponseBody} GetInstrumentOverviewsByPortfolioResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetInstrumentOverviewsByPortfolioResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetInstrumentOverviewsByPortfolioResponseBody message.
             * @function verify
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetInstrumentOverviewsByPortfolioResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.instrument_id_to_overview != null && message.hasOwnProperty("instrument_id_to_overview")) {
                    if (!$util.isObject(message.instrument_id_to_overview))
                        return "instrument_id_to_overview: object expected";
                    let key = Object.keys(message.instrument_id_to_overview);
                    for (let i = 0; i < key.length; ++i) {
                        let error = $root.InstrumentOverview.verify(message.instrument_id_to_overview[key[i]]);
                        if (error)
                            return "instrument_id_to_overview." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetInstrumentOverviewsByPortfolioResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetInstrumentOverviewsByPortfolioResponseBody} GetInstrumentOverviewsByPortfolioResponseBody
             */
            GetInstrumentOverviewsByPortfolioResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetInstrumentOverviewsByPortfolioResponseBody)
                    return object;
                let message = new $root.api.external.GetInstrumentOverviewsByPortfolioResponseBody();
                if (object.instrument_id_to_overview) {
                    if (typeof object.instrument_id_to_overview !== "object")
                        throw TypeError(".api.external.GetInstrumentOverviewsByPortfolioResponseBody.instrument_id_to_overview: object expected");
                    message.instrument_id_to_overview = {};
                    for (let keys = Object.keys(object.instrument_id_to_overview), i = 0; i < keys.length; ++i) {
                        if (typeof object.instrument_id_to_overview[keys[i]] !== "object")
                            throw TypeError(".api.external.GetInstrumentOverviewsByPortfolioResponseBody.instrument_id_to_overview: object expected");
                        message.instrument_id_to_overview[keys[i]] = $root.InstrumentOverview.fromObject(object.instrument_id_to_overview[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetInstrumentOverviewsByPortfolioResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @static
             * @param {api.external.GetInstrumentOverviewsByPortfolioResponseBody} message GetInstrumentOverviewsByPortfolioResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetInstrumentOverviewsByPortfolioResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.objects || options.defaults)
                    object.instrument_id_to_overview = {};
                let keys2;
                if (message.instrument_id_to_overview && (keys2 = Object.keys(message.instrument_id_to_overview)).length) {
                    object.instrument_id_to_overview = {};
                    for (let j = 0; j < keys2.length; ++j)
                        object.instrument_id_to_overview[keys2[j]] = $root.InstrumentOverview.toObject(message.instrument_id_to_overview[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this GetInstrumentOverviewsByPortfolioResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetInstrumentOverviewsByPortfolioResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetInstrumentOverviewsByPortfolioResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetInstrumentOverviewsByPortfolioResponseBody;
        })();

        external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody = (function() {

            /**
             * Properties of a GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.
             * @memberof api.external
             * @interface IGetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @property {SaverPortfolio.Enum|null} [portfolio] GetPortfolioCompanyProfilesByInstrumentIDsRequestBody portfolio
             * @property {Array.<string>|null} [instrument_ids] GetPortfolioCompanyProfilesByInstrumentIDsRequestBody instrument_ids
             */

            /**
             * Constructs a new GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.
             * @memberof api.external
             * @classdesc Represents a GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.
             * @implements IGetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @constructor
             * @param {api.external.IGetPortfolioCompanyProfilesByInstrumentIDsRequestBody=} [properties] Properties to set
             */
            function GetPortfolioCompanyProfilesByInstrumentIDsRequestBody(properties) {
                this.instrument_ids = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetPortfolioCompanyProfilesByInstrumentIDsRequestBody portfolio.
             * @member {SaverPortfolio.Enum} portfolio
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @instance
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.prototype.portfolio = 0;

            /**
             * GetPortfolioCompanyProfilesByInstrumentIDsRequestBody instrument_ids.
             * @member {Array.<string>} instrument_ids
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @instance
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.prototype.instrument_ids = $util.emptyArray;

            /**
             * Creates a new GetPortfolioCompanyProfilesByInstrumentIDsRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @static
             * @param {api.external.IGetPortfolioCompanyProfilesByInstrumentIDsRequestBody=} [properties] Properties to set
             * @returns {api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody} GetPortfolioCompanyProfilesByInstrumentIDsRequestBody instance
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.create = function create(properties) {
                return new GetPortfolioCompanyProfilesByInstrumentIDsRequestBody(properties);
            };

            /**
             * Encodes the specified GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message. Does not implicitly {@link api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @static
             * @param {api.external.IGetPortfolioCompanyProfilesByInstrumentIDsRequestBody} message GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
                if (message.instrument_ids != null && message.instrument_ids.length)
                    for (let i = 0; i < message.instrument_ids.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.instrument_ids[i]);
                return writer;
            };

            /**
             * Encodes the specified GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message, length delimited. Does not implicitly {@link api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @static
             * @param {api.external.IGetPortfolioCompanyProfilesByInstrumentIDsRequestBody} message GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody} GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.portfolio = reader.int32();
                        break;
                    case 2:
                        if (!(message.instrument_ids && message.instrument_ids.length))
                            message.instrument_ids = [];
                        message.instrument_ids.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody} GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message.
             * @function verify
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    switch (message.portfolio) {
                    default:
                        return "portfolio: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.instrument_ids != null && message.hasOwnProperty("instrument_ids")) {
                    if (!Array.isArray(message.instrument_ids))
                        return "instrument_ids: array expected";
                    for (let i = 0; i < message.instrument_ids.length; ++i)
                        if (!$util.isString(message.instrument_ids[i]))
                            return "instrument_ids: string[] expected";
                }
                return null;
            };

            /**
             * Creates a GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody} GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody)
                    return object;
                let message = new $root.api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody();
                switch (object.portfolio) {
                case "UNKNOWN":
                case 0:
                    message.portfolio = 0;
                    break;
                case "INDEX":
                case 1:
                    message.portfolio = 1;
                    break;
                case "UNIVERSE":
                case 2:
                    message.portfolio = 2;
                    break;
                case "EARTH":
                case 3:
                    message.portfolio = 3;
                    break;
                case "GALAXY":
                case 4:
                    message.portfolio = 4;
                    break;
                case "EXPLORER":
                case 5:
                    message.portfolio = 5;
                    break;
                }
                if (object.instrument_ids) {
                    if (!Array.isArray(object.instrument_ids))
                        throw TypeError(".api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.instrument_ids: array expected");
                    message.instrument_ids = [];
                    for (let i = 0; i < object.instrument_ids.length; ++i)
                        message.instrument_ids[i] = String(object.instrument_ids[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetPortfolioCompanyProfilesByInstrumentIDsRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @static
             * @param {api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody} message GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.instrument_ids = [];
                if (options.defaults)
                    object.portfolio = options.enums === String ? "UNKNOWN" : 0;
                if (message.portfolio != null && message.hasOwnProperty("portfolio"))
                    object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
                if (message.instrument_ids && message.instrument_ids.length) {
                    object.instrument_ids = [];
                    for (let j = 0; j < message.instrument_ids.length; ++j)
                        object.instrument_ids[j] = message.instrument_ids[j];
                }
                return object;
            };

            /**
             * Converts this GetPortfolioCompanyProfilesByInstrumentIDsRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetPortfolioCompanyProfilesByInstrumentIDsRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetPortfolioCompanyProfilesByInstrumentIDsRequestBody;
        })();

        external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody = (function() {

            /**
             * Properties of a GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.
             * @memberof api.external
             * @interface IGetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @property {Object.<string,ICompanyProfile>|null} [instrument_id_to_company_profile] GetPortfolioCompanyProfilesByInstrumentIDsResponseBody instrument_id_to_company_profile
             */

            /**
             * Constructs a new GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.
             * @implements IGetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @constructor
             * @param {api.external.IGetPortfolioCompanyProfilesByInstrumentIDsResponseBody=} [properties] Properties to set
             */
            function GetPortfolioCompanyProfilesByInstrumentIDsResponseBody(properties) {
                this.instrument_id_to_company_profile = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetPortfolioCompanyProfilesByInstrumentIDsResponseBody instrument_id_to_company_profile.
             * @member {Object.<string,ICompanyProfile>} instrument_id_to_company_profile
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @instance
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.prototype.instrument_id_to_company_profile = $util.emptyObject;

            /**
             * Creates a new GetPortfolioCompanyProfilesByInstrumentIDsResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @static
             * @param {api.external.IGetPortfolioCompanyProfilesByInstrumentIDsResponseBody=} [properties] Properties to set
             * @returns {api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody} GetPortfolioCompanyProfilesByInstrumentIDsResponseBody instance
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.create = function create(properties) {
                return new GetPortfolioCompanyProfilesByInstrumentIDsResponseBody(properties);
            };

            /**
             * Encodes the specified GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message. Does not implicitly {@link api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @static
             * @param {api.external.IGetPortfolioCompanyProfilesByInstrumentIDsResponseBody} message GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.instrument_id_to_company_profile != null && message.hasOwnProperty("instrument_id_to_company_profile"))
                    for (let keys = Object.keys(message.instrument_id_to_company_profile), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.CompanyProfile.encode(message.instrument_id_to_company_profile[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message, length delimited. Does not implicitly {@link api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @static
             * @param {api.external.IGetPortfolioCompanyProfilesByInstrumentIDsResponseBody} message GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody} GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody(), key;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        reader.skip().pos++;
                        if (message.instrument_id_to_company_profile === $util.emptyObject)
                            message.instrument_id_to_company_profile = {};
                        key = reader.string();
                        reader.pos++;
                        message.instrument_id_to_company_profile[key] = $root.CompanyProfile.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody} GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message.
             * @function verify
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.instrument_id_to_company_profile != null && message.hasOwnProperty("instrument_id_to_company_profile")) {
                    if (!$util.isObject(message.instrument_id_to_company_profile))
                        return "instrument_id_to_company_profile: object expected";
                    let key = Object.keys(message.instrument_id_to_company_profile);
                    for (let i = 0; i < key.length; ++i) {
                        let error = $root.CompanyProfile.verify(message.instrument_id_to_company_profile[key[i]]);
                        if (error)
                            return "instrument_id_to_company_profile." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody} GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody)
                    return object;
                let message = new $root.api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody();
                if (object.instrument_id_to_company_profile) {
                    if (typeof object.instrument_id_to_company_profile !== "object")
                        throw TypeError(".api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.instrument_id_to_company_profile: object expected");
                    message.instrument_id_to_company_profile = {};
                    for (let keys = Object.keys(object.instrument_id_to_company_profile), i = 0; i < keys.length; ++i) {
                        if (typeof object.instrument_id_to_company_profile[keys[i]] !== "object")
                            throw TypeError(".api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.instrument_id_to_company_profile: object expected");
                        message.instrument_id_to_company_profile[keys[i]] = $root.CompanyProfile.fromObject(object.instrument_id_to_company_profile[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetPortfolioCompanyProfilesByInstrumentIDsResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @static
             * @param {api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody} message GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.objects || options.defaults)
                    object.instrument_id_to_company_profile = {};
                let keys2;
                if (message.instrument_id_to_company_profile && (keys2 = Object.keys(message.instrument_id_to_company_profile)).length) {
                    object.instrument_id_to_company_profile = {};
                    for (let j = 0; j < keys2.length; ++j)
                        object.instrument_id_to_company_profile[keys2[j]] = $root.CompanyProfile.toObject(message.instrument_id_to_company_profile[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this GetPortfolioCompanyProfilesByInstrumentIDsResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetPortfolioCompanyProfilesByInstrumentIDsResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetPortfolioCompanyProfilesByInstrumentIDsResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetPortfolioCompanyProfilesByInstrumentIDsResponseBody;
        })();

        external.GetMarketPricesByInstrumentIDRequestBody = (function() {

            /**
             * Properties of a GetMarketPricesByInstrumentIDRequestBody.
             * @memberof api.external
             * @interface IGetMarketPricesByInstrumentIDRequestBody
             * @property {string|null} [instrument_id] GetMarketPricesByInstrumentIDRequestBody instrument_id
             */

            /**
             * Constructs a new GetMarketPricesByInstrumentIDRequestBody.
             * @memberof api.external
             * @classdesc Represents a GetMarketPricesByInstrumentIDRequestBody.
             * @implements IGetMarketPricesByInstrumentIDRequestBody
             * @constructor
             * @param {api.external.IGetMarketPricesByInstrumentIDRequestBody=} [properties] Properties to set
             */
            function GetMarketPricesByInstrumentIDRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetMarketPricesByInstrumentIDRequestBody instrument_id.
             * @member {string} instrument_id
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @instance
             */
            GetMarketPricesByInstrumentIDRequestBody.prototype.instrument_id = "";

            /**
             * Creates a new GetMarketPricesByInstrumentIDRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @static
             * @param {api.external.IGetMarketPricesByInstrumentIDRequestBody=} [properties] Properties to set
             * @returns {api.external.GetMarketPricesByInstrumentIDRequestBody} GetMarketPricesByInstrumentIDRequestBody instance
             */
            GetMarketPricesByInstrumentIDRequestBody.create = function create(properties) {
                return new GetMarketPricesByInstrumentIDRequestBody(properties);
            };

            /**
             * Encodes the specified GetMarketPricesByInstrumentIDRequestBody message. Does not implicitly {@link api.external.GetMarketPricesByInstrumentIDRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @static
             * @param {api.external.IGetMarketPricesByInstrumentIDRequestBody} message GetMarketPricesByInstrumentIDRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMarketPricesByInstrumentIDRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.instrument_id);
                return writer;
            };

            /**
             * Encodes the specified GetMarketPricesByInstrumentIDRequestBody message, length delimited. Does not implicitly {@link api.external.GetMarketPricesByInstrumentIDRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @static
             * @param {api.external.IGetMarketPricesByInstrumentIDRequestBody} message GetMarketPricesByInstrumentIDRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMarketPricesByInstrumentIDRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetMarketPricesByInstrumentIDRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetMarketPricesByInstrumentIDRequestBody} GetMarketPricesByInstrumentIDRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMarketPricesByInstrumentIDRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetMarketPricesByInstrumentIDRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.instrument_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetMarketPricesByInstrumentIDRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetMarketPricesByInstrumentIDRequestBody} GetMarketPricesByInstrumentIDRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMarketPricesByInstrumentIDRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetMarketPricesByInstrumentIDRequestBody message.
             * @function verify
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetMarketPricesByInstrumentIDRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
                    if (!$util.isString(message.instrument_id))
                        return "instrument_id: string expected";
                return null;
            };

            /**
             * Creates a GetMarketPricesByInstrumentIDRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetMarketPricesByInstrumentIDRequestBody} GetMarketPricesByInstrumentIDRequestBody
             */
            GetMarketPricesByInstrumentIDRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetMarketPricesByInstrumentIDRequestBody)
                    return object;
                let message = new $root.api.external.GetMarketPricesByInstrumentIDRequestBody();
                if (object.instrument_id != null)
                    message.instrument_id = String(object.instrument_id);
                return message;
            };

            /**
             * Creates a plain object from a GetMarketPricesByInstrumentIDRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @static
             * @param {api.external.GetMarketPricesByInstrumentIDRequestBody} message GetMarketPricesByInstrumentIDRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetMarketPricesByInstrumentIDRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.instrument_id = "";
                if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
                    object.instrument_id = message.instrument_id;
                return object;
            };

            /**
             * Converts this GetMarketPricesByInstrumentIDRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.GetMarketPricesByInstrumentIDRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetMarketPricesByInstrumentIDRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetMarketPricesByInstrumentIDRequestBody;
        })();

        external.GetMarketPricesByInstrumentIDResponseBody = (function() {

            /**
             * Properties of a GetMarketPricesByInstrumentIDResponseBody.
             * @memberof api.external
             * @interface IGetMarketPricesByInstrumentIDResponseBody
             * @property {Array.<IInstrumentPriceDataPoint>|null} [instrument_prices] GetMarketPricesByInstrumentIDResponseBody instrument_prices
             */

            /**
             * Constructs a new GetMarketPricesByInstrumentIDResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetMarketPricesByInstrumentIDResponseBody.
             * @implements IGetMarketPricesByInstrumentIDResponseBody
             * @constructor
             * @param {api.external.IGetMarketPricesByInstrumentIDResponseBody=} [properties] Properties to set
             */
            function GetMarketPricesByInstrumentIDResponseBody(properties) {
                this.instrument_prices = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetMarketPricesByInstrumentIDResponseBody instrument_prices.
             * @member {Array.<IInstrumentPriceDataPoint>} instrument_prices
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @instance
             */
            GetMarketPricesByInstrumentIDResponseBody.prototype.instrument_prices = $util.emptyArray;

            /**
             * Creates a new GetMarketPricesByInstrumentIDResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @static
             * @param {api.external.IGetMarketPricesByInstrumentIDResponseBody=} [properties] Properties to set
             * @returns {api.external.GetMarketPricesByInstrumentIDResponseBody} GetMarketPricesByInstrumentIDResponseBody instance
             */
            GetMarketPricesByInstrumentIDResponseBody.create = function create(properties) {
                return new GetMarketPricesByInstrumentIDResponseBody(properties);
            };

            /**
             * Encodes the specified GetMarketPricesByInstrumentIDResponseBody message. Does not implicitly {@link api.external.GetMarketPricesByInstrumentIDResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @static
             * @param {api.external.IGetMarketPricesByInstrumentIDResponseBody} message GetMarketPricesByInstrumentIDResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMarketPricesByInstrumentIDResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.instrument_prices != null && message.instrument_prices.length)
                    for (let i = 0; i < message.instrument_prices.length; ++i)
                        $root.InstrumentPriceDataPoint.encode(message.instrument_prices[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetMarketPricesByInstrumentIDResponseBody message, length delimited. Does not implicitly {@link api.external.GetMarketPricesByInstrumentIDResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @static
             * @param {api.external.IGetMarketPricesByInstrumentIDResponseBody} message GetMarketPricesByInstrumentIDResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMarketPricesByInstrumentIDResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetMarketPricesByInstrumentIDResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetMarketPricesByInstrumentIDResponseBody} GetMarketPricesByInstrumentIDResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMarketPricesByInstrumentIDResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetMarketPricesByInstrumentIDResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.instrument_prices && message.instrument_prices.length))
                            message.instrument_prices = [];
                        message.instrument_prices.push($root.InstrumentPriceDataPoint.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetMarketPricesByInstrumentIDResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetMarketPricesByInstrumentIDResponseBody} GetMarketPricesByInstrumentIDResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMarketPricesByInstrumentIDResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetMarketPricesByInstrumentIDResponseBody message.
             * @function verify
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetMarketPricesByInstrumentIDResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.instrument_prices != null && message.hasOwnProperty("instrument_prices")) {
                    if (!Array.isArray(message.instrument_prices))
                        return "instrument_prices: array expected";
                    for (let i = 0; i < message.instrument_prices.length; ++i) {
                        let error = $root.InstrumentPriceDataPoint.verify(message.instrument_prices[i]);
                        if (error)
                            return "instrument_prices." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetMarketPricesByInstrumentIDResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetMarketPricesByInstrumentIDResponseBody} GetMarketPricesByInstrumentIDResponseBody
             */
            GetMarketPricesByInstrumentIDResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetMarketPricesByInstrumentIDResponseBody)
                    return object;
                let message = new $root.api.external.GetMarketPricesByInstrumentIDResponseBody();
                if (object.instrument_prices) {
                    if (!Array.isArray(object.instrument_prices))
                        throw TypeError(".api.external.GetMarketPricesByInstrumentIDResponseBody.instrument_prices: array expected");
                    message.instrument_prices = [];
                    for (let i = 0; i < object.instrument_prices.length; ++i) {
                        if (typeof object.instrument_prices[i] !== "object")
                            throw TypeError(".api.external.GetMarketPricesByInstrumentIDResponseBody.instrument_prices: object expected");
                        message.instrument_prices[i] = $root.InstrumentPriceDataPoint.fromObject(object.instrument_prices[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetMarketPricesByInstrumentIDResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @static
             * @param {api.external.GetMarketPricesByInstrumentIDResponseBody} message GetMarketPricesByInstrumentIDResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetMarketPricesByInstrumentIDResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.instrument_prices = [];
                if (message.instrument_prices && message.instrument_prices.length) {
                    object.instrument_prices = [];
                    for (let j = 0; j < message.instrument_prices.length; ++j)
                        object.instrument_prices[j] = $root.InstrumentPriceDataPoint.toObject(message.instrument_prices[j], options);
                }
                return object;
            };

            /**
             * Converts this GetMarketPricesByInstrumentIDResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetMarketPricesByInstrumentIDResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetMarketPricesByInstrumentIDResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetMarketPricesByInstrumentIDResponseBody;
        })();

        external.GetUserResponseBody = (function() {

            /**
             * Properties of a GetUserResponseBody.
             * @memberof api.external
             * @interface IGetUserResponseBody
             * @property {IContact|null} [contact] GetUserResponseBody contact
             */

            /**
             * Constructs a new GetUserResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetUserResponseBody.
             * @implements IGetUserResponseBody
             * @constructor
             * @param {api.external.IGetUserResponseBody=} [properties] Properties to set
             */
            function GetUserResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetUserResponseBody contact.
             * @member {IContact|null|undefined} contact
             * @memberof api.external.GetUserResponseBody
             * @instance
             */
            GetUserResponseBody.prototype.contact = null;

            /**
             * Creates a new GetUserResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetUserResponseBody
             * @static
             * @param {api.external.IGetUserResponseBody=} [properties] Properties to set
             * @returns {api.external.GetUserResponseBody} GetUserResponseBody instance
             */
            GetUserResponseBody.create = function create(properties) {
                return new GetUserResponseBody(properties);
            };

            /**
             * Encodes the specified GetUserResponseBody message. Does not implicitly {@link api.external.GetUserResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetUserResponseBody
             * @static
             * @param {api.external.IGetUserResponseBody} message GetUserResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUserResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contact != null && message.hasOwnProperty("contact"))
                    $root.Contact.encode(message.contact, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetUserResponseBody message, length delimited. Does not implicitly {@link api.external.GetUserResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetUserResponseBody
             * @static
             * @param {api.external.IGetUserResponseBody} message GetUserResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetUserResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetUserResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetUserResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetUserResponseBody} GetUserResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUserResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetUserResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.contact = $root.Contact.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetUserResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetUserResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetUserResponseBody} GetUserResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetUserResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetUserResponseBody message.
             * @function verify
             * @memberof api.external.GetUserResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetUserResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contact != null && message.hasOwnProperty("contact")) {
                    let error = $root.Contact.verify(message.contact);
                    if (error)
                        return "contact." + error;
                }
                return null;
            };

            /**
             * Creates a GetUserResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetUserResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetUserResponseBody} GetUserResponseBody
             */
            GetUserResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetUserResponseBody)
                    return object;
                let message = new $root.api.external.GetUserResponseBody();
                if (object.contact != null) {
                    if (typeof object.contact !== "object")
                        throw TypeError(".api.external.GetUserResponseBody.contact: object expected");
                    message.contact = $root.Contact.fromObject(object.contact);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetUserResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetUserResponseBody
             * @static
             * @param {api.external.GetUserResponseBody} message GetUserResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetUserResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.contact = null;
                if (message.contact != null && message.hasOwnProperty("contact"))
                    object.contact = $root.Contact.toObject(message.contact, options);
                return object;
            };

            /**
             * Converts this GetUserResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetUserResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetUserResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetUserResponseBody;
        })();

        external.GetLiveReferralCampaignRequestBody = (function() {

            /**
             * Properties of a GetLiveReferralCampaignRequestBody.
             * @memberof api.external
             * @interface IGetLiveReferralCampaignRequestBody
             */

            /**
             * Constructs a new GetLiveReferralCampaignRequestBody.
             * @memberof api.external
             * @classdesc Represents a GetLiveReferralCampaignRequestBody.
             * @implements IGetLiveReferralCampaignRequestBody
             * @constructor
             * @param {api.external.IGetLiveReferralCampaignRequestBody=} [properties] Properties to set
             */
            function GetLiveReferralCampaignRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetLiveReferralCampaignRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @static
             * @param {api.external.IGetLiveReferralCampaignRequestBody=} [properties] Properties to set
             * @returns {api.external.GetLiveReferralCampaignRequestBody} GetLiveReferralCampaignRequestBody instance
             */
            GetLiveReferralCampaignRequestBody.create = function create(properties) {
                return new GetLiveReferralCampaignRequestBody(properties);
            };

            /**
             * Encodes the specified GetLiveReferralCampaignRequestBody message. Does not implicitly {@link api.external.GetLiveReferralCampaignRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @static
             * @param {api.external.IGetLiveReferralCampaignRequestBody} message GetLiveReferralCampaignRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLiveReferralCampaignRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetLiveReferralCampaignRequestBody message, length delimited. Does not implicitly {@link api.external.GetLiveReferralCampaignRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @static
             * @param {api.external.IGetLiveReferralCampaignRequestBody} message GetLiveReferralCampaignRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLiveReferralCampaignRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetLiveReferralCampaignRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetLiveReferralCampaignRequestBody} GetLiveReferralCampaignRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLiveReferralCampaignRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetLiveReferralCampaignRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetLiveReferralCampaignRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetLiveReferralCampaignRequestBody} GetLiveReferralCampaignRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLiveReferralCampaignRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetLiveReferralCampaignRequestBody message.
             * @function verify
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetLiveReferralCampaignRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetLiveReferralCampaignRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetLiveReferralCampaignRequestBody} GetLiveReferralCampaignRequestBody
             */
            GetLiveReferralCampaignRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetLiveReferralCampaignRequestBody)
                    return object;
                return new $root.api.external.GetLiveReferralCampaignRequestBody();
            };

            /**
             * Creates a plain object from a GetLiveReferralCampaignRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @static
             * @param {api.external.GetLiveReferralCampaignRequestBody} message GetLiveReferralCampaignRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetLiveReferralCampaignRequestBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetLiveReferralCampaignRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.GetLiveReferralCampaignRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetLiveReferralCampaignRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetLiveReferralCampaignRequestBody;
        })();

        external.GetLiveReferralCampaignResponseBody = (function() {

            /**
             * Properties of a GetLiveReferralCampaignResponseBody.
             * @memberof api.external
             * @interface IGetLiveReferralCampaignResponseBody
             * @property {IReferralCampaign|null} [referral_campaign] GetLiveReferralCampaignResponseBody referral_campaign
             * @property {IReferralCode|null} [referral_code] GetLiveReferralCampaignResponseBody referral_code
             */

            /**
             * Constructs a new GetLiveReferralCampaignResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetLiveReferralCampaignResponseBody.
             * @implements IGetLiveReferralCampaignResponseBody
             * @constructor
             * @param {api.external.IGetLiveReferralCampaignResponseBody=} [properties] Properties to set
             */
            function GetLiveReferralCampaignResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetLiveReferralCampaignResponseBody referral_campaign.
             * @member {IReferralCampaign|null|undefined} referral_campaign
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @instance
             */
            GetLiveReferralCampaignResponseBody.prototype.referral_campaign = null;

            /**
             * GetLiveReferralCampaignResponseBody referral_code.
             * @member {IReferralCode|null|undefined} referral_code
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @instance
             */
            GetLiveReferralCampaignResponseBody.prototype.referral_code = null;

            /**
             * Creates a new GetLiveReferralCampaignResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @static
             * @param {api.external.IGetLiveReferralCampaignResponseBody=} [properties] Properties to set
             * @returns {api.external.GetLiveReferralCampaignResponseBody} GetLiveReferralCampaignResponseBody instance
             */
            GetLiveReferralCampaignResponseBody.create = function create(properties) {
                return new GetLiveReferralCampaignResponseBody(properties);
            };

            /**
             * Encodes the specified GetLiveReferralCampaignResponseBody message. Does not implicitly {@link api.external.GetLiveReferralCampaignResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @static
             * @param {api.external.IGetLiveReferralCampaignResponseBody} message GetLiveReferralCampaignResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLiveReferralCampaignResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.referral_campaign != null && message.hasOwnProperty("referral_campaign"))
                    $root.ReferralCampaign.encode(message.referral_campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.referral_code != null && message.hasOwnProperty("referral_code"))
                    $root.ReferralCode.encode(message.referral_code, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetLiveReferralCampaignResponseBody message, length delimited. Does not implicitly {@link api.external.GetLiveReferralCampaignResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @static
             * @param {api.external.IGetLiveReferralCampaignResponseBody} message GetLiveReferralCampaignResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLiveReferralCampaignResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetLiveReferralCampaignResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetLiveReferralCampaignResponseBody} GetLiveReferralCampaignResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLiveReferralCampaignResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetLiveReferralCampaignResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.referral_campaign = $root.ReferralCampaign.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.referral_code = $root.ReferralCode.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetLiveReferralCampaignResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetLiveReferralCampaignResponseBody} GetLiveReferralCampaignResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLiveReferralCampaignResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetLiveReferralCampaignResponseBody message.
             * @function verify
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetLiveReferralCampaignResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.referral_campaign != null && message.hasOwnProperty("referral_campaign")) {
                    let error = $root.ReferralCampaign.verify(message.referral_campaign);
                    if (error)
                        return "referral_campaign." + error;
                }
                if (message.referral_code != null && message.hasOwnProperty("referral_code")) {
                    let error = $root.ReferralCode.verify(message.referral_code);
                    if (error)
                        return "referral_code." + error;
                }
                return null;
            };

            /**
             * Creates a GetLiveReferralCampaignResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetLiveReferralCampaignResponseBody} GetLiveReferralCampaignResponseBody
             */
            GetLiveReferralCampaignResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetLiveReferralCampaignResponseBody)
                    return object;
                let message = new $root.api.external.GetLiveReferralCampaignResponseBody();
                if (object.referral_campaign != null) {
                    if (typeof object.referral_campaign !== "object")
                        throw TypeError(".api.external.GetLiveReferralCampaignResponseBody.referral_campaign: object expected");
                    message.referral_campaign = $root.ReferralCampaign.fromObject(object.referral_campaign);
                }
                if (object.referral_code != null) {
                    if (typeof object.referral_code !== "object")
                        throw TypeError(".api.external.GetLiveReferralCampaignResponseBody.referral_code: object expected");
                    message.referral_code = $root.ReferralCode.fromObject(object.referral_code);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetLiveReferralCampaignResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @static
             * @param {api.external.GetLiveReferralCampaignResponseBody} message GetLiveReferralCampaignResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetLiveReferralCampaignResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.referral_campaign = null;
                    object.referral_code = null;
                }
                if (message.referral_campaign != null && message.hasOwnProperty("referral_campaign"))
                    object.referral_campaign = $root.ReferralCampaign.toObject(message.referral_campaign, options);
                if (message.referral_code != null && message.hasOwnProperty("referral_code"))
                    object.referral_code = $root.ReferralCode.toObject(message.referral_code, options);
                return object;
            };

            /**
             * Converts this GetLiveReferralCampaignResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetLiveReferralCampaignResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetLiveReferralCampaignResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetLiveReferralCampaignResponseBody;
        })();

        external.AddReferralCodeUsageRequestBody = (function() {

            /**
             * Properties of an AddReferralCodeUsageRequestBody.
             * @memberof api.external
             * @interface IAddReferralCodeUsageRequestBody
             * @property {string|null} [referral_code] AddReferralCodeUsageRequestBody referral_code
             */

            /**
             * Constructs a new AddReferralCodeUsageRequestBody.
             * @memberof api.external
             * @classdesc Represents an AddReferralCodeUsageRequestBody.
             * @implements IAddReferralCodeUsageRequestBody
             * @constructor
             * @param {api.external.IAddReferralCodeUsageRequestBody=} [properties] Properties to set
             */
            function AddReferralCodeUsageRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AddReferralCodeUsageRequestBody referral_code.
             * @member {string} referral_code
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @instance
             */
            AddReferralCodeUsageRequestBody.prototype.referral_code = "";

            /**
             * Creates a new AddReferralCodeUsageRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @static
             * @param {api.external.IAddReferralCodeUsageRequestBody=} [properties] Properties to set
             * @returns {api.external.AddReferralCodeUsageRequestBody} AddReferralCodeUsageRequestBody instance
             */
            AddReferralCodeUsageRequestBody.create = function create(properties) {
                return new AddReferralCodeUsageRequestBody(properties);
            };

            /**
             * Encodes the specified AddReferralCodeUsageRequestBody message. Does not implicitly {@link api.external.AddReferralCodeUsageRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @static
             * @param {api.external.IAddReferralCodeUsageRequestBody} message AddReferralCodeUsageRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddReferralCodeUsageRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.referral_code != null && message.hasOwnProperty("referral_code"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.referral_code);
                return writer;
            };

            /**
             * Encodes the specified AddReferralCodeUsageRequestBody message, length delimited. Does not implicitly {@link api.external.AddReferralCodeUsageRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @static
             * @param {api.external.IAddReferralCodeUsageRequestBody} message AddReferralCodeUsageRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddReferralCodeUsageRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddReferralCodeUsageRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.AddReferralCodeUsageRequestBody} AddReferralCodeUsageRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddReferralCodeUsageRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.AddReferralCodeUsageRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.referral_code = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddReferralCodeUsageRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.AddReferralCodeUsageRequestBody} AddReferralCodeUsageRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddReferralCodeUsageRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddReferralCodeUsageRequestBody message.
             * @function verify
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddReferralCodeUsageRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.referral_code != null && message.hasOwnProperty("referral_code"))
                    if (!$util.isString(message.referral_code))
                        return "referral_code: string expected";
                return null;
            };

            /**
             * Creates an AddReferralCodeUsageRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.AddReferralCodeUsageRequestBody} AddReferralCodeUsageRequestBody
             */
            AddReferralCodeUsageRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.AddReferralCodeUsageRequestBody)
                    return object;
                let message = new $root.api.external.AddReferralCodeUsageRequestBody();
                if (object.referral_code != null)
                    message.referral_code = String(object.referral_code);
                return message;
            };

            /**
             * Creates a plain object from an AddReferralCodeUsageRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @static
             * @param {api.external.AddReferralCodeUsageRequestBody} message AddReferralCodeUsageRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddReferralCodeUsageRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.referral_code = "";
                if (message.referral_code != null && message.hasOwnProperty("referral_code"))
                    object.referral_code = message.referral_code;
                return object;
            };

            /**
             * Converts this AddReferralCodeUsageRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.AddReferralCodeUsageRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddReferralCodeUsageRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AddReferralCodeUsageRequestBody;
        })();

        external.AddReferralCodeUsageResponseBody = (function() {

            /**
             * Properties of an AddReferralCodeUsageResponseBody.
             * @memberof api.external
             * @interface IAddReferralCodeUsageResponseBody
             * @property {api.external.AddReferralCodeUsageResponseBody.IReferrerContact|null} [referrer_contact] AddReferralCodeUsageResponseBody referrer_contact
             */

            /**
             * Constructs a new AddReferralCodeUsageResponseBody.
             * @memberof api.external
             * @classdesc Represents an AddReferralCodeUsageResponseBody.
             * @implements IAddReferralCodeUsageResponseBody
             * @constructor
             * @param {api.external.IAddReferralCodeUsageResponseBody=} [properties] Properties to set
             */
            function AddReferralCodeUsageResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AddReferralCodeUsageResponseBody referrer_contact.
             * @member {api.external.AddReferralCodeUsageResponseBody.IReferrerContact|null|undefined} referrer_contact
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @instance
             */
            AddReferralCodeUsageResponseBody.prototype.referrer_contact = null;

            /**
             * Creates a new AddReferralCodeUsageResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @static
             * @param {api.external.IAddReferralCodeUsageResponseBody=} [properties] Properties to set
             * @returns {api.external.AddReferralCodeUsageResponseBody} AddReferralCodeUsageResponseBody instance
             */
            AddReferralCodeUsageResponseBody.create = function create(properties) {
                return new AddReferralCodeUsageResponseBody(properties);
            };

            /**
             * Encodes the specified AddReferralCodeUsageResponseBody message. Does not implicitly {@link api.external.AddReferralCodeUsageResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @static
             * @param {api.external.IAddReferralCodeUsageResponseBody} message AddReferralCodeUsageResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddReferralCodeUsageResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.referrer_contact != null && message.hasOwnProperty("referrer_contact"))
                    $root.api.external.AddReferralCodeUsageResponseBody.ReferrerContact.encode(message.referrer_contact, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AddReferralCodeUsageResponseBody message, length delimited. Does not implicitly {@link api.external.AddReferralCodeUsageResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @static
             * @param {api.external.IAddReferralCodeUsageResponseBody} message AddReferralCodeUsageResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddReferralCodeUsageResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddReferralCodeUsageResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.AddReferralCodeUsageResponseBody} AddReferralCodeUsageResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddReferralCodeUsageResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.AddReferralCodeUsageResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.referrer_contact = $root.api.external.AddReferralCodeUsageResponseBody.ReferrerContact.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddReferralCodeUsageResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.AddReferralCodeUsageResponseBody} AddReferralCodeUsageResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddReferralCodeUsageResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddReferralCodeUsageResponseBody message.
             * @function verify
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddReferralCodeUsageResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.referrer_contact != null && message.hasOwnProperty("referrer_contact")) {
                    let error = $root.api.external.AddReferralCodeUsageResponseBody.ReferrerContact.verify(message.referrer_contact);
                    if (error)
                        return "referrer_contact." + error;
                }
                return null;
            };

            /**
             * Creates an AddReferralCodeUsageResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.AddReferralCodeUsageResponseBody} AddReferralCodeUsageResponseBody
             */
            AddReferralCodeUsageResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.AddReferralCodeUsageResponseBody)
                    return object;
                let message = new $root.api.external.AddReferralCodeUsageResponseBody();
                if (object.referrer_contact != null) {
                    if (typeof object.referrer_contact !== "object")
                        throw TypeError(".api.external.AddReferralCodeUsageResponseBody.referrer_contact: object expected");
                    message.referrer_contact = $root.api.external.AddReferralCodeUsageResponseBody.ReferrerContact.fromObject(object.referrer_contact);
                }
                return message;
            };

            /**
             * Creates a plain object from an AddReferralCodeUsageResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @static
             * @param {api.external.AddReferralCodeUsageResponseBody} message AddReferralCodeUsageResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddReferralCodeUsageResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.referrer_contact = null;
                if (message.referrer_contact != null && message.hasOwnProperty("referrer_contact"))
                    object.referrer_contact = $root.api.external.AddReferralCodeUsageResponseBody.ReferrerContact.toObject(message.referrer_contact, options);
                return object;
            };

            /**
             * Converts this AddReferralCodeUsageResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.AddReferralCodeUsageResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddReferralCodeUsageResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            AddReferralCodeUsageResponseBody.ReferrerContact = (function() {

                /**
                 * Properties of a ReferrerContact.
                 * @memberof api.external.AddReferralCodeUsageResponseBody
                 * @interface IReferrerContact
                 * @property {string|null} [first_name] ReferrerContact first_name
                 * @property {string|null} [last_name] ReferrerContact last_name
                 */

                /**
                 * Constructs a new ReferrerContact.
                 * @memberof api.external.AddReferralCodeUsageResponseBody
                 * @classdesc Represents a ReferrerContact.
                 * @implements IReferrerContact
                 * @constructor
                 * @param {api.external.AddReferralCodeUsageResponseBody.IReferrerContact=} [properties] Properties to set
                 */
                function ReferrerContact(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReferrerContact first_name.
                 * @member {string} first_name
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @instance
                 */
                ReferrerContact.prototype.first_name = "";

                /**
                 * ReferrerContact last_name.
                 * @member {string} last_name
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @instance
                 */
                ReferrerContact.prototype.last_name = "";

                /**
                 * Creates a new ReferrerContact instance using the specified properties.
                 * @function create
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @static
                 * @param {api.external.AddReferralCodeUsageResponseBody.IReferrerContact=} [properties] Properties to set
                 * @returns {api.external.AddReferralCodeUsageResponseBody.ReferrerContact} ReferrerContact instance
                 */
                ReferrerContact.create = function create(properties) {
                    return new ReferrerContact(properties);
                };

                /**
                 * Encodes the specified ReferrerContact message. Does not implicitly {@link api.external.AddReferralCodeUsageResponseBody.ReferrerContact.verify|verify} messages.
                 * @function encode
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @static
                 * @param {api.external.AddReferralCodeUsageResponseBody.IReferrerContact} message ReferrerContact message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReferrerContact.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.first_name != null && message.hasOwnProperty("first_name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.first_name);
                    if (message.last_name != null && message.hasOwnProperty("last_name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.last_name);
                    return writer;
                };

                /**
                 * Encodes the specified ReferrerContact message, length delimited. Does not implicitly {@link api.external.AddReferralCodeUsageResponseBody.ReferrerContact.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @static
                 * @param {api.external.AddReferralCodeUsageResponseBody.IReferrerContact} message ReferrerContact message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReferrerContact.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReferrerContact message from the specified reader or buffer.
                 * @function decode
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {api.external.AddReferralCodeUsageResponseBody.ReferrerContact} ReferrerContact
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReferrerContact.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.AddReferralCodeUsageResponseBody.ReferrerContact();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.first_name = reader.string();
                            break;
                        case 2:
                            message.last_name = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReferrerContact message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {api.external.AddReferralCodeUsageResponseBody.ReferrerContact} ReferrerContact
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReferrerContact.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReferrerContact message.
                 * @function verify
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReferrerContact.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.first_name != null && message.hasOwnProperty("first_name"))
                        if (!$util.isString(message.first_name))
                            return "first_name: string expected";
                    if (message.last_name != null && message.hasOwnProperty("last_name"))
                        if (!$util.isString(message.last_name))
                            return "last_name: string expected";
                    return null;
                };

                /**
                 * Creates a ReferrerContact message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {api.external.AddReferralCodeUsageResponseBody.ReferrerContact} ReferrerContact
                 */
                ReferrerContact.fromObject = function fromObject(object) {
                    if (object instanceof $root.api.external.AddReferralCodeUsageResponseBody.ReferrerContact)
                        return object;
                    let message = new $root.api.external.AddReferralCodeUsageResponseBody.ReferrerContact();
                    if (object.first_name != null)
                        message.first_name = String(object.first_name);
                    if (object.last_name != null)
                        message.last_name = String(object.last_name);
                    return message;
                };

                /**
                 * Creates a plain object from a ReferrerContact message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @static
                 * @param {api.external.AddReferralCodeUsageResponseBody.ReferrerContact} message ReferrerContact
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReferrerContact.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.first_name = "";
                        object.last_name = "";
                    }
                    if (message.first_name != null && message.hasOwnProperty("first_name"))
                        object.first_name = message.first_name;
                    if (message.last_name != null && message.hasOwnProperty("last_name"))
                        object.last_name = message.last_name;
                    return object;
                };

                /**
                 * Converts this ReferrerContact to JSON.
                 * @function toJSON
                 * @memberof api.external.AddReferralCodeUsageResponseBody.ReferrerContact
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReferrerContact.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReferrerContact;
            })();

            return AddReferralCodeUsageResponseBody;
        })();

        external.GetReferralCampaignAtJoinDateResponseBody = (function() {

            /**
             * Properties of a GetReferralCampaignAtJoinDateResponseBody.
             * @memberof api.external
             * @interface IGetReferralCampaignAtJoinDateResponseBody
             * @property {IReferralCampaign|null} [referral_campaign] GetReferralCampaignAtJoinDateResponseBody referral_campaign
             */

            /**
             * Constructs a new GetReferralCampaignAtJoinDateResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetReferralCampaignAtJoinDateResponseBody.
             * @implements IGetReferralCampaignAtJoinDateResponseBody
             * @constructor
             * @param {api.external.IGetReferralCampaignAtJoinDateResponseBody=} [properties] Properties to set
             */
            function GetReferralCampaignAtJoinDateResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetReferralCampaignAtJoinDateResponseBody referral_campaign.
             * @member {IReferralCampaign|null|undefined} referral_campaign
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @instance
             */
            GetReferralCampaignAtJoinDateResponseBody.prototype.referral_campaign = null;

            /**
             * Creates a new GetReferralCampaignAtJoinDateResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @static
             * @param {api.external.IGetReferralCampaignAtJoinDateResponseBody=} [properties] Properties to set
             * @returns {api.external.GetReferralCampaignAtJoinDateResponseBody} GetReferralCampaignAtJoinDateResponseBody instance
             */
            GetReferralCampaignAtJoinDateResponseBody.create = function create(properties) {
                return new GetReferralCampaignAtJoinDateResponseBody(properties);
            };

            /**
             * Encodes the specified GetReferralCampaignAtJoinDateResponseBody message. Does not implicitly {@link api.external.GetReferralCampaignAtJoinDateResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @static
             * @param {api.external.IGetReferralCampaignAtJoinDateResponseBody} message GetReferralCampaignAtJoinDateResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReferralCampaignAtJoinDateResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.referral_campaign != null && message.hasOwnProperty("referral_campaign"))
                    $root.ReferralCampaign.encode(message.referral_campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetReferralCampaignAtJoinDateResponseBody message, length delimited. Does not implicitly {@link api.external.GetReferralCampaignAtJoinDateResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @static
             * @param {api.external.IGetReferralCampaignAtJoinDateResponseBody} message GetReferralCampaignAtJoinDateResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReferralCampaignAtJoinDateResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetReferralCampaignAtJoinDateResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetReferralCampaignAtJoinDateResponseBody} GetReferralCampaignAtJoinDateResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReferralCampaignAtJoinDateResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetReferralCampaignAtJoinDateResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.referral_campaign = $root.ReferralCampaign.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetReferralCampaignAtJoinDateResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetReferralCampaignAtJoinDateResponseBody} GetReferralCampaignAtJoinDateResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReferralCampaignAtJoinDateResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetReferralCampaignAtJoinDateResponseBody message.
             * @function verify
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetReferralCampaignAtJoinDateResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.referral_campaign != null && message.hasOwnProperty("referral_campaign")) {
                    let error = $root.ReferralCampaign.verify(message.referral_campaign);
                    if (error)
                        return "referral_campaign." + error;
                }
                return null;
            };

            /**
             * Creates a GetReferralCampaignAtJoinDateResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetReferralCampaignAtJoinDateResponseBody} GetReferralCampaignAtJoinDateResponseBody
             */
            GetReferralCampaignAtJoinDateResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetReferralCampaignAtJoinDateResponseBody)
                    return object;
                let message = new $root.api.external.GetReferralCampaignAtJoinDateResponseBody();
                if (object.referral_campaign != null) {
                    if (typeof object.referral_campaign !== "object")
                        throw TypeError(".api.external.GetReferralCampaignAtJoinDateResponseBody.referral_campaign: object expected");
                    message.referral_campaign = $root.ReferralCampaign.fromObject(object.referral_campaign);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetReferralCampaignAtJoinDateResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @static
             * @param {api.external.GetReferralCampaignAtJoinDateResponseBody} message GetReferralCampaignAtJoinDateResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetReferralCampaignAtJoinDateResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.referral_campaign = null;
                if (message.referral_campaign != null && message.hasOwnProperty("referral_campaign"))
                    object.referral_campaign = $root.ReferralCampaign.toObject(message.referral_campaign, options);
                return object;
            };

            /**
             * Converts this GetReferralCampaignAtJoinDateResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetReferralCampaignAtJoinDateResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetReferralCampaignAtJoinDateResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetReferralCampaignAtJoinDateResponseBody;
        })();

        external.UpdateContactDetailsRequestBody = (function() {

            /**
             * Properties of an UpdateContactDetailsRequestBody.
             * @memberof api.external
             * @interface IUpdateContactDetailsRequestBody
             * @property {string|null} [phone_number] UpdateContactDetailsRequestBody phone_number
             * @property {string|null} [email_address] UpdateContactDetailsRequestBody email_address
             * @property {IAddress|null} [address] UpdateContactDetailsRequestBody address
             * @property {TaxResidenceStatus.Enum|null} [tax_residence_status] UpdateContactDetailsRequestBody tax_residence_status
             */

            /**
             * Constructs a new UpdateContactDetailsRequestBody.
             * @memberof api.external
             * @classdesc Represents an UpdateContactDetailsRequestBody.
             * @implements IUpdateContactDetailsRequestBody
             * @constructor
             * @param {api.external.IUpdateContactDetailsRequestBody=} [properties] Properties to set
             */
            function UpdateContactDetailsRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdateContactDetailsRequestBody phone_number.
             * @member {string} phone_number
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @instance
             */
            UpdateContactDetailsRequestBody.prototype.phone_number = "";

            /**
             * UpdateContactDetailsRequestBody email_address.
             * @member {string} email_address
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @instance
             */
            UpdateContactDetailsRequestBody.prototype.email_address = "";

            /**
             * UpdateContactDetailsRequestBody address.
             * @member {IAddress|null|undefined} address
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @instance
             */
            UpdateContactDetailsRequestBody.prototype.address = null;

            /**
             * UpdateContactDetailsRequestBody tax_residence_status.
             * @member {TaxResidenceStatus.Enum} tax_residence_status
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @instance
             */
            UpdateContactDetailsRequestBody.prototype.tax_residence_status = 0;

            /**
             * Creates a new UpdateContactDetailsRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @static
             * @param {api.external.IUpdateContactDetailsRequestBody=} [properties] Properties to set
             * @returns {api.external.UpdateContactDetailsRequestBody} UpdateContactDetailsRequestBody instance
             */
            UpdateContactDetailsRequestBody.create = function create(properties) {
                return new UpdateContactDetailsRequestBody(properties);
            };

            /**
             * Encodes the specified UpdateContactDetailsRequestBody message. Does not implicitly {@link api.external.UpdateContactDetailsRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @static
             * @param {api.external.IUpdateContactDetailsRequestBody} message UpdateContactDetailsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateContactDetailsRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.phone_number);
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.email_address);
                if (message.address != null && message.hasOwnProperty("address"))
                    $root.Address.encode(message.address, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.tax_residence_status != null && message.hasOwnProperty("tax_residence_status"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.tax_residence_status);
                return writer;
            };

            /**
             * Encodes the specified UpdateContactDetailsRequestBody message, length delimited. Does not implicitly {@link api.external.UpdateContactDetailsRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @static
             * @param {api.external.IUpdateContactDetailsRequestBody} message UpdateContactDetailsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateContactDetailsRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateContactDetailsRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateContactDetailsRequestBody} UpdateContactDetailsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateContactDetailsRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateContactDetailsRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.phone_number = reader.string();
                        break;
                    case 2:
                        message.email_address = reader.string();
                        break;
                    case 3:
                        message.address = $root.Address.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.tax_residence_status = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateContactDetailsRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateContactDetailsRequestBody} UpdateContactDetailsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateContactDetailsRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateContactDetailsRequestBody message.
             * @function verify
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateContactDetailsRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    if (!$util.isString(message.phone_number))
                        return "phone_number: string expected";
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    if (!$util.isString(message.email_address))
                        return "email_address: string expected";
                if (message.address != null && message.hasOwnProperty("address")) {
                    let error = $root.Address.verify(message.address);
                    if (error)
                        return "address." + error;
                }
                if (message.tax_residence_status != null && message.hasOwnProperty("tax_residence_status"))
                    switch (message.tax_residence_status) {
                    default:
                        return "tax_residence_status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                return null;
            };

            /**
             * Creates an UpdateContactDetailsRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateContactDetailsRequestBody} UpdateContactDetailsRequestBody
             */
            UpdateContactDetailsRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateContactDetailsRequestBody)
                    return object;
                let message = new $root.api.external.UpdateContactDetailsRequestBody();
                if (object.phone_number != null)
                    message.phone_number = String(object.phone_number);
                if (object.email_address != null)
                    message.email_address = String(object.email_address);
                if (object.address != null) {
                    if (typeof object.address !== "object")
                        throw TypeError(".api.external.UpdateContactDetailsRequestBody.address: object expected");
                    message.address = $root.Address.fromObject(object.address);
                }
                switch (object.tax_residence_status) {
                case "UNKNOWN":
                case 0:
                    message.tax_residence_status = 0;
                    break;
                case "SPECIFIED":
                case 1:
                    message.tax_residence_status = 1;
                    break;
                case "UNSPECIFIED":
                case 2:
                    message.tax_residence_status = 2;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from an UpdateContactDetailsRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @static
             * @param {api.external.UpdateContactDetailsRequestBody} message UpdateContactDetailsRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateContactDetailsRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.phone_number = "";
                    object.email_address = "";
                    object.address = null;
                    object.tax_residence_status = options.enums === String ? "UNKNOWN" : 0;
                }
                if (message.phone_number != null && message.hasOwnProperty("phone_number"))
                    object.phone_number = message.phone_number;
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    object.email_address = message.email_address;
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = $root.Address.toObject(message.address, options);
                if (message.tax_residence_status != null && message.hasOwnProperty("tax_residence_status"))
                    object.tax_residence_status = options.enums === String ? $root.TaxResidenceStatus.Enum[message.tax_residence_status] : message.tax_residence_status;
                return object;
            };

            /**
             * Converts this UpdateContactDetailsRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateContactDetailsRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateContactDetailsRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateContactDetailsRequestBody;
        })();

        external.UpdateContactDetailsResponseBody = (function() {

            /**
             * Properties of an UpdateContactDetailsResponseBody.
             * @memberof api.external
             * @interface IUpdateContactDetailsResponseBody
             */

            /**
             * Constructs a new UpdateContactDetailsResponseBody.
             * @memberof api.external
             * @classdesc Represents an UpdateContactDetailsResponseBody.
             * @implements IUpdateContactDetailsResponseBody
             * @constructor
             * @param {api.external.IUpdateContactDetailsResponseBody=} [properties] Properties to set
             */
            function UpdateContactDetailsResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateContactDetailsResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @static
             * @param {api.external.IUpdateContactDetailsResponseBody=} [properties] Properties to set
             * @returns {api.external.UpdateContactDetailsResponseBody} UpdateContactDetailsResponseBody instance
             */
            UpdateContactDetailsResponseBody.create = function create(properties) {
                return new UpdateContactDetailsResponseBody(properties);
            };

            /**
             * Encodes the specified UpdateContactDetailsResponseBody message. Does not implicitly {@link api.external.UpdateContactDetailsResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @static
             * @param {api.external.IUpdateContactDetailsResponseBody} message UpdateContactDetailsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateContactDetailsResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateContactDetailsResponseBody message, length delimited. Does not implicitly {@link api.external.UpdateContactDetailsResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @static
             * @param {api.external.IUpdateContactDetailsResponseBody} message UpdateContactDetailsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateContactDetailsResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateContactDetailsResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateContactDetailsResponseBody} UpdateContactDetailsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateContactDetailsResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateContactDetailsResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateContactDetailsResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateContactDetailsResponseBody} UpdateContactDetailsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateContactDetailsResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateContactDetailsResponseBody message.
             * @function verify
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateContactDetailsResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateContactDetailsResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateContactDetailsResponseBody} UpdateContactDetailsResponseBody
             */
            UpdateContactDetailsResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateContactDetailsResponseBody)
                    return object;
                return new $root.api.external.UpdateContactDetailsResponseBody();
            };

            /**
             * Creates a plain object from an UpdateContactDetailsResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @static
             * @param {api.external.UpdateContactDetailsResponseBody} message UpdateContactDetailsResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateContactDetailsResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateContactDetailsResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateContactDetailsResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateContactDetailsResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateContactDetailsResponseBody;
        })();

        external.SendVerifyEmailRequestBody = (function() {

            /**
             * Properties of a SendVerifyEmailRequestBody.
             * @memberof api.external
             * @interface ISendVerifyEmailRequestBody
             * @property {string|null} [email_address] SendVerifyEmailRequestBody email_address
             */

            /**
             * Constructs a new SendVerifyEmailRequestBody.
             * @memberof api.external
             * @classdesc Represents a SendVerifyEmailRequestBody.
             * @implements ISendVerifyEmailRequestBody
             * @constructor
             * @param {api.external.ISendVerifyEmailRequestBody=} [properties] Properties to set
             */
            function SendVerifyEmailRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SendVerifyEmailRequestBody email_address.
             * @member {string} email_address
             * @memberof api.external.SendVerifyEmailRequestBody
             * @instance
             */
            SendVerifyEmailRequestBody.prototype.email_address = "";

            /**
             * Creates a new SendVerifyEmailRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.SendVerifyEmailRequestBody
             * @static
             * @param {api.external.ISendVerifyEmailRequestBody=} [properties] Properties to set
             * @returns {api.external.SendVerifyEmailRequestBody} SendVerifyEmailRequestBody instance
             */
            SendVerifyEmailRequestBody.create = function create(properties) {
                return new SendVerifyEmailRequestBody(properties);
            };

            /**
             * Encodes the specified SendVerifyEmailRequestBody message. Does not implicitly {@link api.external.SendVerifyEmailRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.SendVerifyEmailRequestBody
             * @static
             * @param {api.external.ISendVerifyEmailRequestBody} message SendVerifyEmailRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendVerifyEmailRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.email_address);
                return writer;
            };

            /**
             * Encodes the specified SendVerifyEmailRequestBody message, length delimited. Does not implicitly {@link api.external.SendVerifyEmailRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.SendVerifyEmailRequestBody
             * @static
             * @param {api.external.ISendVerifyEmailRequestBody} message SendVerifyEmailRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendVerifyEmailRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SendVerifyEmailRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.SendVerifyEmailRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.SendVerifyEmailRequestBody} SendVerifyEmailRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendVerifyEmailRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.SendVerifyEmailRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.email_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SendVerifyEmailRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.SendVerifyEmailRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.SendVerifyEmailRequestBody} SendVerifyEmailRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendVerifyEmailRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SendVerifyEmailRequestBody message.
             * @function verify
             * @memberof api.external.SendVerifyEmailRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SendVerifyEmailRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    if (!$util.isString(message.email_address))
                        return "email_address: string expected";
                return null;
            };

            /**
             * Creates a SendVerifyEmailRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.SendVerifyEmailRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.SendVerifyEmailRequestBody} SendVerifyEmailRequestBody
             */
            SendVerifyEmailRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.SendVerifyEmailRequestBody)
                    return object;
                let message = new $root.api.external.SendVerifyEmailRequestBody();
                if (object.email_address != null)
                    message.email_address = String(object.email_address);
                return message;
            };

            /**
             * Creates a plain object from a SendVerifyEmailRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.SendVerifyEmailRequestBody
             * @static
             * @param {api.external.SendVerifyEmailRequestBody} message SendVerifyEmailRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SendVerifyEmailRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.email_address = "";
                if (message.email_address != null && message.hasOwnProperty("email_address"))
                    object.email_address = message.email_address;
                return object;
            };

            /**
             * Converts this SendVerifyEmailRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.SendVerifyEmailRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SendVerifyEmailRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SendVerifyEmailRequestBody;
        })();

        external.SendVerifyEmailResponseBody = (function() {

            /**
             * Properties of a SendVerifyEmailResponseBody.
             * @memberof api.external
             * @interface ISendVerifyEmailResponseBody
             */

            /**
             * Constructs a new SendVerifyEmailResponseBody.
             * @memberof api.external
             * @classdesc Represents a SendVerifyEmailResponseBody.
             * @implements ISendVerifyEmailResponseBody
             * @constructor
             * @param {api.external.ISendVerifyEmailResponseBody=} [properties] Properties to set
             */
            function SendVerifyEmailResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SendVerifyEmailResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.SendVerifyEmailResponseBody
             * @static
             * @param {api.external.ISendVerifyEmailResponseBody=} [properties] Properties to set
             * @returns {api.external.SendVerifyEmailResponseBody} SendVerifyEmailResponseBody instance
             */
            SendVerifyEmailResponseBody.create = function create(properties) {
                return new SendVerifyEmailResponseBody(properties);
            };

            /**
             * Encodes the specified SendVerifyEmailResponseBody message. Does not implicitly {@link api.external.SendVerifyEmailResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.SendVerifyEmailResponseBody
             * @static
             * @param {api.external.ISendVerifyEmailResponseBody} message SendVerifyEmailResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendVerifyEmailResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SendVerifyEmailResponseBody message, length delimited. Does not implicitly {@link api.external.SendVerifyEmailResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.SendVerifyEmailResponseBody
             * @static
             * @param {api.external.ISendVerifyEmailResponseBody} message SendVerifyEmailResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SendVerifyEmailResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SendVerifyEmailResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.SendVerifyEmailResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.SendVerifyEmailResponseBody} SendVerifyEmailResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendVerifyEmailResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.SendVerifyEmailResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SendVerifyEmailResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.SendVerifyEmailResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.SendVerifyEmailResponseBody} SendVerifyEmailResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SendVerifyEmailResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SendVerifyEmailResponseBody message.
             * @function verify
             * @memberof api.external.SendVerifyEmailResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SendVerifyEmailResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SendVerifyEmailResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.SendVerifyEmailResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.SendVerifyEmailResponseBody} SendVerifyEmailResponseBody
             */
            SendVerifyEmailResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.SendVerifyEmailResponseBody)
                    return object;
                return new $root.api.external.SendVerifyEmailResponseBody();
            };

            /**
             * Creates a plain object from a SendVerifyEmailResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.SendVerifyEmailResponseBody
             * @static
             * @param {api.external.SendVerifyEmailResponseBody} message SendVerifyEmailResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SendVerifyEmailResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SendVerifyEmailResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.SendVerifyEmailResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SendVerifyEmailResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SendVerifyEmailResponseBody;
        })();

        external.VerifyEmailRequestBody = (function() {

            /**
             * Properties of a VerifyEmailRequestBody.
             * @memberof api.external
             * @interface IVerifyEmailRequestBody
             * @property {string|null} [verification_id] VerifyEmailRequestBody verification_id
             */

            /**
             * Constructs a new VerifyEmailRequestBody.
             * @memberof api.external
             * @classdesc Represents a VerifyEmailRequestBody.
             * @implements IVerifyEmailRequestBody
             * @constructor
             * @param {api.external.IVerifyEmailRequestBody=} [properties] Properties to set
             */
            function VerifyEmailRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * VerifyEmailRequestBody verification_id.
             * @member {string} verification_id
             * @memberof api.external.VerifyEmailRequestBody
             * @instance
             */
            VerifyEmailRequestBody.prototype.verification_id = "";

            /**
             * Creates a new VerifyEmailRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.VerifyEmailRequestBody
             * @static
             * @param {api.external.IVerifyEmailRequestBody=} [properties] Properties to set
             * @returns {api.external.VerifyEmailRequestBody} VerifyEmailRequestBody instance
             */
            VerifyEmailRequestBody.create = function create(properties) {
                return new VerifyEmailRequestBody(properties);
            };

            /**
             * Encodes the specified VerifyEmailRequestBody message. Does not implicitly {@link api.external.VerifyEmailRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.VerifyEmailRequestBody
             * @static
             * @param {api.external.IVerifyEmailRequestBody} message VerifyEmailRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyEmailRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.verification_id != null && message.hasOwnProperty("verification_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.verification_id);
                return writer;
            };

            /**
             * Encodes the specified VerifyEmailRequestBody message, length delimited. Does not implicitly {@link api.external.VerifyEmailRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.VerifyEmailRequestBody
             * @static
             * @param {api.external.IVerifyEmailRequestBody} message VerifyEmailRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyEmailRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a VerifyEmailRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.VerifyEmailRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.VerifyEmailRequestBody} VerifyEmailRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyEmailRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.VerifyEmailRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.verification_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a VerifyEmailRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.VerifyEmailRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.VerifyEmailRequestBody} VerifyEmailRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyEmailRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a VerifyEmailRequestBody message.
             * @function verify
             * @memberof api.external.VerifyEmailRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            VerifyEmailRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.verification_id != null && message.hasOwnProperty("verification_id"))
                    if (!$util.isString(message.verification_id))
                        return "verification_id: string expected";
                return null;
            };

            /**
             * Creates a VerifyEmailRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.VerifyEmailRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.VerifyEmailRequestBody} VerifyEmailRequestBody
             */
            VerifyEmailRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.VerifyEmailRequestBody)
                    return object;
                let message = new $root.api.external.VerifyEmailRequestBody();
                if (object.verification_id != null)
                    message.verification_id = String(object.verification_id);
                return message;
            };

            /**
             * Creates a plain object from a VerifyEmailRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.VerifyEmailRequestBody
             * @static
             * @param {api.external.VerifyEmailRequestBody} message VerifyEmailRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            VerifyEmailRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.verification_id = "";
                if (message.verification_id != null && message.hasOwnProperty("verification_id"))
                    object.verification_id = message.verification_id;
                return object;
            };

            /**
             * Converts this VerifyEmailRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.VerifyEmailRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            VerifyEmailRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return VerifyEmailRequestBody;
        })();

        external.VerifyEmailResponseBody = (function() {

            /**
             * Properties of a VerifyEmailResponseBody.
             * @memberof api.external
             * @interface IVerifyEmailResponseBody
             */

            /**
             * Constructs a new VerifyEmailResponseBody.
             * @memberof api.external
             * @classdesc Represents a VerifyEmailResponseBody.
             * @implements IVerifyEmailResponseBody
             * @constructor
             * @param {api.external.IVerifyEmailResponseBody=} [properties] Properties to set
             */
            function VerifyEmailResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new VerifyEmailResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.VerifyEmailResponseBody
             * @static
             * @param {api.external.IVerifyEmailResponseBody=} [properties] Properties to set
             * @returns {api.external.VerifyEmailResponseBody} VerifyEmailResponseBody instance
             */
            VerifyEmailResponseBody.create = function create(properties) {
                return new VerifyEmailResponseBody(properties);
            };

            /**
             * Encodes the specified VerifyEmailResponseBody message. Does not implicitly {@link api.external.VerifyEmailResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.VerifyEmailResponseBody
             * @static
             * @param {api.external.IVerifyEmailResponseBody} message VerifyEmailResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyEmailResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified VerifyEmailResponseBody message, length delimited. Does not implicitly {@link api.external.VerifyEmailResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.VerifyEmailResponseBody
             * @static
             * @param {api.external.IVerifyEmailResponseBody} message VerifyEmailResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyEmailResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a VerifyEmailResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.VerifyEmailResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.VerifyEmailResponseBody} VerifyEmailResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyEmailResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.VerifyEmailResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a VerifyEmailResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.VerifyEmailResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.VerifyEmailResponseBody} VerifyEmailResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyEmailResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a VerifyEmailResponseBody message.
             * @function verify
             * @memberof api.external.VerifyEmailResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            VerifyEmailResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a VerifyEmailResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.VerifyEmailResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.VerifyEmailResponseBody} VerifyEmailResponseBody
             */
            VerifyEmailResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.VerifyEmailResponseBody)
                    return object;
                return new $root.api.external.VerifyEmailResponseBody();
            };

            /**
             * Creates a plain object from a VerifyEmailResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.VerifyEmailResponseBody
             * @static
             * @param {api.external.VerifyEmailResponseBody} message VerifyEmailResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            VerifyEmailResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this VerifyEmailResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.VerifyEmailResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            VerifyEmailResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return VerifyEmailResponseBody;
        })();

        external.GetBankStatementsSessionResponseBody = (function() {

            /**
             * Properties of a GetBankStatementsSessionResponseBody.
             * @memberof api.external
             * @interface IGetBankStatementsSessionResponseBody
             * @property {string|null} [guid] GetBankStatementsSessionResponseBody guid
             * @property {string|null} [user_token] GetBankStatementsSessionResponseBody user_token
             */

            /**
             * Constructs a new GetBankStatementsSessionResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetBankStatementsSessionResponseBody.
             * @implements IGetBankStatementsSessionResponseBody
             * @constructor
             * @param {api.external.IGetBankStatementsSessionResponseBody=} [properties] Properties to set
             */
            function GetBankStatementsSessionResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetBankStatementsSessionResponseBody guid.
             * @member {string} guid
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @instance
             */
            GetBankStatementsSessionResponseBody.prototype.guid = "";

            /**
             * GetBankStatementsSessionResponseBody user_token.
             * @member {string} user_token
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @instance
             */
            GetBankStatementsSessionResponseBody.prototype.user_token = "";

            /**
             * Creates a new GetBankStatementsSessionResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @static
             * @param {api.external.IGetBankStatementsSessionResponseBody=} [properties] Properties to set
             * @returns {api.external.GetBankStatementsSessionResponseBody} GetBankStatementsSessionResponseBody instance
             */
            GetBankStatementsSessionResponseBody.create = function create(properties) {
                return new GetBankStatementsSessionResponseBody(properties);
            };

            /**
             * Encodes the specified GetBankStatementsSessionResponseBody message. Does not implicitly {@link api.external.GetBankStatementsSessionResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @static
             * @param {api.external.IGetBankStatementsSessionResponseBody} message GetBankStatementsSessionResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetBankStatementsSessionResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.guid != null && message.hasOwnProperty("guid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
                if (message.user_token != null && message.hasOwnProperty("user_token"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.user_token);
                return writer;
            };

            /**
             * Encodes the specified GetBankStatementsSessionResponseBody message, length delimited. Does not implicitly {@link api.external.GetBankStatementsSessionResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @static
             * @param {api.external.IGetBankStatementsSessionResponseBody} message GetBankStatementsSessionResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetBankStatementsSessionResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetBankStatementsSessionResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetBankStatementsSessionResponseBody} GetBankStatementsSessionResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetBankStatementsSessionResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetBankStatementsSessionResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.guid = reader.string();
                        break;
                    case 2:
                        message.user_token = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetBankStatementsSessionResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetBankStatementsSessionResponseBody} GetBankStatementsSessionResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetBankStatementsSessionResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetBankStatementsSessionResponseBody message.
             * @function verify
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetBankStatementsSessionResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.guid != null && message.hasOwnProperty("guid"))
                    if (!$util.isString(message.guid))
                        return "guid: string expected";
                if (message.user_token != null && message.hasOwnProperty("user_token"))
                    if (!$util.isString(message.user_token))
                        return "user_token: string expected";
                return null;
            };

            /**
             * Creates a GetBankStatementsSessionResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetBankStatementsSessionResponseBody} GetBankStatementsSessionResponseBody
             */
            GetBankStatementsSessionResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetBankStatementsSessionResponseBody)
                    return object;
                let message = new $root.api.external.GetBankStatementsSessionResponseBody();
                if (object.guid != null)
                    message.guid = String(object.guid);
                if (object.user_token != null)
                    message.user_token = String(object.user_token);
                return message;
            };

            /**
             * Creates a plain object from a GetBankStatementsSessionResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @static
             * @param {api.external.GetBankStatementsSessionResponseBody} message GetBankStatementsSessionResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetBankStatementsSessionResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.guid = "";
                    object.user_token = "";
                }
                if (message.guid != null && message.hasOwnProperty("guid"))
                    object.guid = message.guid;
                if (message.user_token != null && message.hasOwnProperty("user_token"))
                    object.user_token = message.user_token;
                return object;
            };

            /**
             * Converts this GetBankStatementsSessionResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetBankStatementsSessionResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetBankStatementsSessionResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetBankStatementsSessionResponseBody;
        })();

        external.ErrorResponseBody = (function() {

            /**
             * Properties of an ErrorResponseBody.
             * @memberof api.external
             * @interface IErrorResponseBody
             * @property {string|null} [request_id] ErrorResponseBody request_id
             * @property {number|null} [status_code] ErrorResponseBody status_code
             * @property {string|null} [message] ErrorResponseBody message
             */

            /**
             * Constructs a new ErrorResponseBody.
             * @memberof api.external
             * @classdesc Represents an ErrorResponseBody.
             * @implements IErrorResponseBody
             * @constructor
             * @param {api.external.IErrorResponseBody=} [properties] Properties to set
             */
            function ErrorResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ErrorResponseBody request_id.
             * @member {string} request_id
             * @memberof api.external.ErrorResponseBody
             * @instance
             */
            ErrorResponseBody.prototype.request_id = "";

            /**
             * ErrorResponseBody status_code.
             * @member {number} status_code
             * @memberof api.external.ErrorResponseBody
             * @instance
             */
            ErrorResponseBody.prototype.status_code = 0;

            /**
             * ErrorResponseBody message.
             * @member {string} message
             * @memberof api.external.ErrorResponseBody
             * @instance
             */
            ErrorResponseBody.prototype.message = "";

            /**
             * Creates a new ErrorResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.ErrorResponseBody
             * @static
             * @param {api.external.IErrorResponseBody=} [properties] Properties to set
             * @returns {api.external.ErrorResponseBody} ErrorResponseBody instance
             */
            ErrorResponseBody.create = function create(properties) {
                return new ErrorResponseBody(properties);
            };

            /**
             * Encodes the specified ErrorResponseBody message. Does not implicitly {@link api.external.ErrorResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.ErrorResponseBody
             * @static
             * @param {api.external.IErrorResponseBody} message ErrorResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ErrorResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.request_id != null && message.hasOwnProperty("request_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.request_id);
                if (message.status_code != null && message.hasOwnProperty("status_code"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status_code);
                if (message.message != null && message.hasOwnProperty("message"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
                return writer;
            };

            /**
             * Encodes the specified ErrorResponseBody message, length delimited. Does not implicitly {@link api.external.ErrorResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.ErrorResponseBody
             * @static
             * @param {api.external.IErrorResponseBody} message ErrorResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ErrorResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ErrorResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.ErrorResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.ErrorResponseBody} ErrorResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ErrorResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.ErrorResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.request_id = reader.string();
                        break;
                    case 2:
                        message.status_code = reader.int32();
                        break;
                    case 3:
                        message.message = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ErrorResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.ErrorResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.ErrorResponseBody} ErrorResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ErrorResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ErrorResponseBody message.
             * @function verify
             * @memberof api.external.ErrorResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ErrorResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.request_id != null && message.hasOwnProperty("request_id"))
                    if (!$util.isString(message.request_id))
                        return "request_id: string expected";
                if (message.status_code != null && message.hasOwnProperty("status_code"))
                    if (!$util.isInteger(message.status_code))
                        return "status_code: integer expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                return null;
            };

            /**
             * Creates an ErrorResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.ErrorResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.ErrorResponseBody} ErrorResponseBody
             */
            ErrorResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.ErrorResponseBody)
                    return object;
                let message = new $root.api.external.ErrorResponseBody();
                if (object.request_id != null)
                    message.request_id = String(object.request_id);
                if (object.status_code != null)
                    message.status_code = object.status_code | 0;
                if (object.message != null)
                    message.message = String(object.message);
                return message;
            };

            /**
             * Creates a plain object from an ErrorResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.ErrorResponseBody
             * @static
             * @param {api.external.ErrorResponseBody} message ErrorResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ErrorResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.request_id = "";
                    object.status_code = 0;
                    object.message = "";
                }
                if (message.request_id != null && message.hasOwnProperty("request_id"))
                    object.request_id = message.request_id;
                if (message.status_code != null && message.hasOwnProperty("status_code"))
                    object.status_code = message.status_code;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                return object;
            };

            /**
             * Converts this ErrorResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.ErrorResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ErrorResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ErrorResponseBody;
        })();

        external.SetGreenIdFieldsRequestBody = (function() {

            /**
             * Properties of a SetGreenIdFieldsRequestBody.
             * @memberof api.external
             * @interface ISetGreenIdFieldsRequestBody
             * @property {string|null} [source_name] SetGreenIdFieldsRequestBody source_name
             * @property {Object.<string,string>|null} [field_inputs] SetGreenIdFieldsRequestBody field_inputs
             * @property {string|null} [verification_id] SetGreenIdFieldsRequestBody verification_id
             */

            /**
             * Constructs a new SetGreenIdFieldsRequestBody.
             * @memberof api.external
             * @classdesc Represents a SetGreenIdFieldsRequestBody.
             * @implements ISetGreenIdFieldsRequestBody
             * @constructor
             * @param {api.external.ISetGreenIdFieldsRequestBody=} [properties] Properties to set
             */
            function SetGreenIdFieldsRequestBody(properties) {
                this.field_inputs = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetGreenIdFieldsRequestBody source_name.
             * @member {string} source_name
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @instance
             */
            SetGreenIdFieldsRequestBody.prototype.source_name = "";

            /**
             * SetGreenIdFieldsRequestBody field_inputs.
             * @member {Object.<string,string>} field_inputs
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @instance
             */
            SetGreenIdFieldsRequestBody.prototype.field_inputs = $util.emptyObject;

            /**
             * SetGreenIdFieldsRequestBody verification_id.
             * @member {string} verification_id
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @instance
             */
            SetGreenIdFieldsRequestBody.prototype.verification_id = "";

            /**
             * Creates a new SetGreenIdFieldsRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @static
             * @param {api.external.ISetGreenIdFieldsRequestBody=} [properties] Properties to set
             * @returns {api.external.SetGreenIdFieldsRequestBody} SetGreenIdFieldsRequestBody instance
             */
            SetGreenIdFieldsRequestBody.create = function create(properties) {
                return new SetGreenIdFieldsRequestBody(properties);
            };

            /**
             * Encodes the specified SetGreenIdFieldsRequestBody message. Does not implicitly {@link api.external.SetGreenIdFieldsRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @static
             * @param {api.external.ISetGreenIdFieldsRequestBody} message SetGreenIdFieldsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetGreenIdFieldsRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.source_name != null && message.hasOwnProperty("source_name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.source_name);
                if (message.field_inputs != null && message.hasOwnProperty("field_inputs"))
                    for (let keys = Object.keys(message.field_inputs), i = 0; i < keys.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.field_inputs[keys[i]]).ldelim();
                if (message.verification_id != null && message.hasOwnProperty("verification_id"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.verification_id);
                return writer;
            };

            /**
             * Encodes the specified SetGreenIdFieldsRequestBody message, length delimited. Does not implicitly {@link api.external.SetGreenIdFieldsRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @static
             * @param {api.external.ISetGreenIdFieldsRequestBody} message SetGreenIdFieldsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetGreenIdFieldsRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetGreenIdFieldsRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.SetGreenIdFieldsRequestBody} SetGreenIdFieldsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetGreenIdFieldsRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.SetGreenIdFieldsRequestBody(), key;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.source_name = reader.string();
                        break;
                    case 2:
                        reader.skip().pos++;
                        if (message.field_inputs === $util.emptyObject)
                            message.field_inputs = {};
                        key = reader.string();
                        reader.pos++;
                        message.field_inputs[key] = reader.string();
                        break;
                    case 3:
                        message.verification_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetGreenIdFieldsRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.SetGreenIdFieldsRequestBody} SetGreenIdFieldsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetGreenIdFieldsRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetGreenIdFieldsRequestBody message.
             * @function verify
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetGreenIdFieldsRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.source_name != null && message.hasOwnProperty("source_name"))
                    if (!$util.isString(message.source_name))
                        return "source_name: string expected";
                if (message.field_inputs != null && message.hasOwnProperty("field_inputs")) {
                    if (!$util.isObject(message.field_inputs))
                        return "field_inputs: object expected";
                    let key = Object.keys(message.field_inputs);
                    for (let i = 0; i < key.length; ++i)
                        if (!$util.isString(message.field_inputs[key[i]]))
                            return "field_inputs: string{k:string} expected";
                }
                if (message.verification_id != null && message.hasOwnProperty("verification_id"))
                    if (!$util.isString(message.verification_id))
                        return "verification_id: string expected";
                return null;
            };

            /**
             * Creates a SetGreenIdFieldsRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.SetGreenIdFieldsRequestBody} SetGreenIdFieldsRequestBody
             */
            SetGreenIdFieldsRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.SetGreenIdFieldsRequestBody)
                    return object;
                let message = new $root.api.external.SetGreenIdFieldsRequestBody();
                if (object.source_name != null)
                    message.source_name = String(object.source_name);
                if (object.field_inputs) {
                    if (typeof object.field_inputs !== "object")
                        throw TypeError(".api.external.SetGreenIdFieldsRequestBody.field_inputs: object expected");
                    message.field_inputs = {};
                    for (let keys = Object.keys(object.field_inputs), i = 0; i < keys.length; ++i)
                        message.field_inputs[keys[i]] = String(object.field_inputs[keys[i]]);
                }
                if (object.verification_id != null)
                    message.verification_id = String(object.verification_id);
                return message;
            };

            /**
             * Creates a plain object from a SetGreenIdFieldsRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @static
             * @param {api.external.SetGreenIdFieldsRequestBody} message SetGreenIdFieldsRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetGreenIdFieldsRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.objects || options.defaults)
                    object.field_inputs = {};
                if (options.defaults) {
                    object.source_name = "";
                    object.verification_id = "";
                }
                if (message.source_name != null && message.hasOwnProperty("source_name"))
                    object.source_name = message.source_name;
                let keys2;
                if (message.field_inputs && (keys2 = Object.keys(message.field_inputs)).length) {
                    object.field_inputs = {};
                    for (let j = 0; j < keys2.length; ++j)
                        object.field_inputs[keys2[j]] = message.field_inputs[keys2[j]];
                }
                if (message.verification_id != null && message.hasOwnProperty("verification_id"))
                    object.verification_id = message.verification_id;
                return object;
            };

            /**
             * Converts this SetGreenIdFieldsRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.SetGreenIdFieldsRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetGreenIdFieldsRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SetGreenIdFieldsRequestBody;
        })();

        external.SetGreenIdFieldsResponseBody = (function() {

            /**
             * Properties of a SetGreenIdFieldsResponseBody.
             * @memberof api.external
             * @interface ISetGreenIdFieldsResponseBody
             */

            /**
             * Constructs a new SetGreenIdFieldsResponseBody.
             * @memberof api.external
             * @classdesc Represents a SetGreenIdFieldsResponseBody.
             * @implements ISetGreenIdFieldsResponseBody
             * @constructor
             * @param {api.external.ISetGreenIdFieldsResponseBody=} [properties] Properties to set
             */
            function SetGreenIdFieldsResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new SetGreenIdFieldsResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @static
             * @param {api.external.ISetGreenIdFieldsResponseBody=} [properties] Properties to set
             * @returns {api.external.SetGreenIdFieldsResponseBody} SetGreenIdFieldsResponseBody instance
             */
            SetGreenIdFieldsResponseBody.create = function create(properties) {
                return new SetGreenIdFieldsResponseBody(properties);
            };

            /**
             * Encodes the specified SetGreenIdFieldsResponseBody message. Does not implicitly {@link api.external.SetGreenIdFieldsResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @static
             * @param {api.external.ISetGreenIdFieldsResponseBody} message SetGreenIdFieldsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetGreenIdFieldsResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified SetGreenIdFieldsResponseBody message, length delimited. Does not implicitly {@link api.external.SetGreenIdFieldsResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @static
             * @param {api.external.ISetGreenIdFieldsResponseBody} message SetGreenIdFieldsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetGreenIdFieldsResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetGreenIdFieldsResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.SetGreenIdFieldsResponseBody} SetGreenIdFieldsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetGreenIdFieldsResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.SetGreenIdFieldsResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetGreenIdFieldsResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.SetGreenIdFieldsResponseBody} SetGreenIdFieldsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetGreenIdFieldsResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetGreenIdFieldsResponseBody message.
             * @function verify
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetGreenIdFieldsResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a SetGreenIdFieldsResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.SetGreenIdFieldsResponseBody} SetGreenIdFieldsResponseBody
             */
            SetGreenIdFieldsResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.SetGreenIdFieldsResponseBody)
                    return object;
                return new $root.api.external.SetGreenIdFieldsResponseBody();
            };

            /**
             * Creates a plain object from a SetGreenIdFieldsResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @static
             * @param {api.external.SetGreenIdFieldsResponseBody} message SetGreenIdFieldsResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetGreenIdFieldsResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this SetGreenIdFieldsResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.SetGreenIdFieldsResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetGreenIdFieldsResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SetGreenIdFieldsResponseBody;
        })();

        external.CreateSuperProductInstanceRequestBody = (function() {

            /**
             * Properties of a CreateSuperProductInstanceRequestBody.
             * @memberof api.external
             * @interface ICreateSuperProductInstanceRequestBody
             * @property {string|null} [impact_id] CreateSuperProductInstanceRequestBody impact_id
             * @property {SuperProductInstance.JoinType.Enum|null} [join_type] CreateSuperProductInstanceRequestBody join_type
             * @property {string|null} [sargon_member_id] CreateSuperProductInstanceRequestBody sargon_member_id
             */

            /**
             * Constructs a new CreateSuperProductInstanceRequestBody.
             * @memberof api.external
             * @classdesc Represents a CreateSuperProductInstanceRequestBody.
             * @implements ICreateSuperProductInstanceRequestBody
             * @constructor
             * @param {api.external.ICreateSuperProductInstanceRequestBody=} [properties] Properties to set
             */
            function CreateSuperProductInstanceRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateSuperProductInstanceRequestBody impact_id.
             * @member {string} impact_id
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @instance
             */
            CreateSuperProductInstanceRequestBody.prototype.impact_id = "";

            /**
             * CreateSuperProductInstanceRequestBody join_type.
             * @member {SuperProductInstance.JoinType.Enum} join_type
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @instance
             */
            CreateSuperProductInstanceRequestBody.prototype.join_type = 0;

            /**
             * CreateSuperProductInstanceRequestBody sargon_member_id.
             * @member {string} sargon_member_id
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @instance
             */
            CreateSuperProductInstanceRequestBody.prototype.sargon_member_id = "";

            /**
             * Creates a new CreateSuperProductInstanceRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @static
             * @param {api.external.ICreateSuperProductInstanceRequestBody=} [properties] Properties to set
             * @returns {api.external.CreateSuperProductInstanceRequestBody} CreateSuperProductInstanceRequestBody instance
             */
            CreateSuperProductInstanceRequestBody.create = function create(properties) {
                return new CreateSuperProductInstanceRequestBody(properties);
            };

            /**
             * Encodes the specified CreateSuperProductInstanceRequestBody message. Does not implicitly {@link api.external.CreateSuperProductInstanceRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @static
             * @param {api.external.ICreateSuperProductInstanceRequestBody} message CreateSuperProductInstanceRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSuperProductInstanceRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.impact_id != null && message.hasOwnProperty("impact_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.impact_id);
                if (message.join_type != null && message.hasOwnProperty("join_type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.join_type);
                if (message.sargon_member_id != null && message.hasOwnProperty("sargon_member_id"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.sargon_member_id);
                return writer;
            };

            /**
             * Encodes the specified CreateSuperProductInstanceRequestBody message, length delimited. Does not implicitly {@link api.external.CreateSuperProductInstanceRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @static
             * @param {api.external.ICreateSuperProductInstanceRequestBody} message CreateSuperProductInstanceRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSuperProductInstanceRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSuperProductInstanceRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateSuperProductInstanceRequestBody} CreateSuperProductInstanceRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSuperProductInstanceRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateSuperProductInstanceRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.impact_id = reader.string();
                        break;
                    case 2:
                        message.join_type = reader.int32();
                        break;
                    case 3:
                        message.sargon_member_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSuperProductInstanceRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateSuperProductInstanceRequestBody} CreateSuperProductInstanceRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSuperProductInstanceRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSuperProductInstanceRequestBody message.
             * @function verify
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSuperProductInstanceRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.impact_id != null && message.hasOwnProperty("impact_id"))
                    if (!$util.isString(message.impact_id))
                        return "impact_id: string expected";
                if (message.join_type != null && message.hasOwnProperty("join_type"))
                    switch (message.join_type) {
                    default:
                        return "join_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                        break;
                    }
                if (message.sargon_member_id != null && message.hasOwnProperty("sargon_member_id"))
                    if (!$util.isString(message.sargon_member_id))
                        return "sargon_member_id: string expected";
                return null;
            };

            /**
             * Creates a CreateSuperProductInstanceRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateSuperProductInstanceRequestBody} CreateSuperProductInstanceRequestBody
             */
            CreateSuperProductInstanceRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateSuperProductInstanceRequestBody)
                    return object;
                let message = new $root.api.external.CreateSuperProductInstanceRequestBody();
                if (object.impact_id != null)
                    message.impact_id = String(object.impact_id);
                switch (object.join_type) {
                case "UNKNOWN":
                case 0:
                    message.join_type = 0;
                    break;
                case "SIGN_UP":
                case 1:
                    message.join_type = 1;
                    break;
                case "SOFT_LINK":
                case 2:
                    message.join_type = 2;
                    break;
                case "HARD_LINK":
                case 3:
                    message.join_type = 3;
                    break;
                case "MIGRATED_FROM_WEB":
                case 4:
                    message.join_type = 4;
                    break;
                case "SIGN_UP_WEB":
                case 5:
                    message.join_type = 5;
                    break;
                case "HARD_LINK_WEB":
                case 6:
                    message.join_type = 6;
                    break;
                case "EMPLOYMENT_HERO":
                case 7:
                    message.join_type = 7;
                    break;
                case "BOOKIPI":
                case 8:
                    message.join_type = 8;
                    break;
                case "FOUNDU":
                case 9:
                    message.join_type = 9;
                    break;
                case "FLARE":
                case 10:
                    message.join_type = 10;
                    break;
                }
                if (object.sargon_member_id != null)
                    message.sargon_member_id = String(object.sargon_member_id);
                return message;
            };

            /**
             * Creates a plain object from a CreateSuperProductInstanceRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @static
             * @param {api.external.CreateSuperProductInstanceRequestBody} message CreateSuperProductInstanceRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSuperProductInstanceRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.impact_id = "";
                    object.join_type = options.enums === String ? "UNKNOWN" : 0;
                    object.sargon_member_id = "";
                }
                if (message.impact_id != null && message.hasOwnProperty("impact_id"))
                    object.impact_id = message.impact_id;
                if (message.join_type != null && message.hasOwnProperty("join_type"))
                    object.join_type = options.enums === String ? $root.SuperProductInstance.JoinType.Enum[message.join_type] : message.join_type;
                if (message.sargon_member_id != null && message.hasOwnProperty("sargon_member_id"))
                    object.sargon_member_id = message.sargon_member_id;
                return object;
            };

            /**
             * Converts this CreateSuperProductInstanceRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateSuperProductInstanceRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSuperProductInstanceRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateSuperProductInstanceRequestBody;
        })();

        external.CreateSuperProductInstanceResponseBody = (function() {

            /**
             * Properties of a CreateSuperProductInstanceResponseBody.
             * @memberof api.external
             * @interface ICreateSuperProductInstanceResponseBody
             */

            /**
             * Constructs a new CreateSuperProductInstanceResponseBody.
             * @memberof api.external
             * @classdesc Represents a CreateSuperProductInstanceResponseBody.
             * @implements ICreateSuperProductInstanceResponseBody
             * @constructor
             * @param {api.external.ICreateSuperProductInstanceResponseBody=} [properties] Properties to set
             */
            function CreateSuperProductInstanceResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateSuperProductInstanceResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @static
             * @param {api.external.ICreateSuperProductInstanceResponseBody=} [properties] Properties to set
             * @returns {api.external.CreateSuperProductInstanceResponseBody} CreateSuperProductInstanceResponseBody instance
             */
            CreateSuperProductInstanceResponseBody.create = function create(properties) {
                return new CreateSuperProductInstanceResponseBody(properties);
            };

            /**
             * Encodes the specified CreateSuperProductInstanceResponseBody message. Does not implicitly {@link api.external.CreateSuperProductInstanceResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @static
             * @param {api.external.ICreateSuperProductInstanceResponseBody} message CreateSuperProductInstanceResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSuperProductInstanceResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateSuperProductInstanceResponseBody message, length delimited. Does not implicitly {@link api.external.CreateSuperProductInstanceResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @static
             * @param {api.external.ICreateSuperProductInstanceResponseBody} message CreateSuperProductInstanceResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSuperProductInstanceResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSuperProductInstanceResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateSuperProductInstanceResponseBody} CreateSuperProductInstanceResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSuperProductInstanceResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateSuperProductInstanceResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSuperProductInstanceResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateSuperProductInstanceResponseBody} CreateSuperProductInstanceResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSuperProductInstanceResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSuperProductInstanceResponseBody message.
             * @function verify
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSuperProductInstanceResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateSuperProductInstanceResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateSuperProductInstanceResponseBody} CreateSuperProductInstanceResponseBody
             */
            CreateSuperProductInstanceResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateSuperProductInstanceResponseBody)
                    return object;
                return new $root.api.external.CreateSuperProductInstanceResponseBody();
            };

            /**
             * Creates a plain object from a CreateSuperProductInstanceResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @static
             * @param {api.external.CreateSuperProductInstanceResponseBody} message CreateSuperProductInstanceResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSuperProductInstanceResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateSuperProductInstanceResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateSuperProductInstanceResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSuperProductInstanceResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateSuperProductInstanceResponseBody;
        })();

        external.GetSuperProductInstanceByAccountIdResponseBody = (function() {

            /**
             * Properties of a GetSuperProductInstanceByAccountIdResponseBody.
             * @memberof api.external
             * @interface IGetSuperProductInstanceByAccountIdResponseBody
             * @property {ISuperProductInstance|null} [instance] GetSuperProductInstanceByAccountIdResponseBody instance
             */

            /**
             * Constructs a new GetSuperProductInstanceByAccountIdResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetSuperProductInstanceByAccountIdResponseBody.
             * @implements IGetSuperProductInstanceByAccountIdResponseBody
             * @constructor
             * @param {api.external.IGetSuperProductInstanceByAccountIdResponseBody=} [properties] Properties to set
             */
            function GetSuperProductInstanceByAccountIdResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetSuperProductInstanceByAccountIdResponseBody instance.
             * @member {ISuperProductInstance|null|undefined} instance
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @instance
             */
            GetSuperProductInstanceByAccountIdResponseBody.prototype.instance = null;

            /**
             * Creates a new GetSuperProductInstanceByAccountIdResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @static
             * @param {api.external.IGetSuperProductInstanceByAccountIdResponseBody=} [properties] Properties to set
             * @returns {api.external.GetSuperProductInstanceByAccountIdResponseBody} GetSuperProductInstanceByAccountIdResponseBody instance
             */
            GetSuperProductInstanceByAccountIdResponseBody.create = function create(properties) {
                return new GetSuperProductInstanceByAccountIdResponseBody(properties);
            };

            /**
             * Encodes the specified GetSuperProductInstanceByAccountIdResponseBody message. Does not implicitly {@link api.external.GetSuperProductInstanceByAccountIdResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @static
             * @param {api.external.IGetSuperProductInstanceByAccountIdResponseBody} message GetSuperProductInstanceByAccountIdResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSuperProductInstanceByAccountIdResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.instance != null && message.hasOwnProperty("instance"))
                    $root.SuperProductInstance.encode(message.instance, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetSuperProductInstanceByAccountIdResponseBody message, length delimited. Does not implicitly {@link api.external.GetSuperProductInstanceByAccountIdResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @static
             * @param {api.external.IGetSuperProductInstanceByAccountIdResponseBody} message GetSuperProductInstanceByAccountIdResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSuperProductInstanceByAccountIdResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetSuperProductInstanceByAccountIdResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetSuperProductInstanceByAccountIdResponseBody} GetSuperProductInstanceByAccountIdResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSuperProductInstanceByAccountIdResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetSuperProductInstanceByAccountIdResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.instance = $root.SuperProductInstance.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetSuperProductInstanceByAccountIdResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetSuperProductInstanceByAccountIdResponseBody} GetSuperProductInstanceByAccountIdResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSuperProductInstanceByAccountIdResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetSuperProductInstanceByAccountIdResponseBody message.
             * @function verify
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetSuperProductInstanceByAccountIdResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.instance != null && message.hasOwnProperty("instance")) {
                    let error = $root.SuperProductInstance.verify(message.instance);
                    if (error)
                        return "instance." + error;
                }
                return null;
            };

            /**
             * Creates a GetSuperProductInstanceByAccountIdResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetSuperProductInstanceByAccountIdResponseBody} GetSuperProductInstanceByAccountIdResponseBody
             */
            GetSuperProductInstanceByAccountIdResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetSuperProductInstanceByAccountIdResponseBody)
                    return object;
                let message = new $root.api.external.GetSuperProductInstanceByAccountIdResponseBody();
                if (object.instance != null) {
                    if (typeof object.instance !== "object")
                        throw TypeError(".api.external.GetSuperProductInstanceByAccountIdResponseBody.instance: object expected");
                    message.instance = $root.SuperProductInstance.fromObject(object.instance);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetSuperProductInstanceByAccountIdResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @static
             * @param {api.external.GetSuperProductInstanceByAccountIdResponseBody} message GetSuperProductInstanceByAccountIdResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetSuperProductInstanceByAccountIdResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.instance = null;
                if (message.instance != null && message.hasOwnProperty("instance"))
                    object.instance = $root.SuperProductInstance.toObject(message.instance, options);
                return object;
            };

            /**
             * Converts this GetSuperProductInstanceByAccountIdResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetSuperProductInstanceByAccountIdResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetSuperProductInstanceByAccountIdResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetSuperProductInstanceByAccountIdResponseBody;
        })();

        external.UpdateSargonContactDetailsRequestBody = (function() {

            /**
             * Properties of an UpdateSargonContactDetailsRequestBody.
             * @memberof api.external
             * @interface IUpdateSargonContactDetailsRequestBody
             * @property {string|null} [sargon_phone_number] UpdateSargonContactDetailsRequestBody sargon_phone_number
             * @property {string|null} [sargon_email_address] UpdateSargonContactDetailsRequestBody sargon_email_address
             * @property {IAddress|null} [sargon_address] UpdateSargonContactDetailsRequestBody sargon_address
             * @property {string|null} [impact_id] UpdateSargonContactDetailsRequestBody impact_id
             */

            /**
             * Constructs a new UpdateSargonContactDetailsRequestBody.
             * @memberof api.external
             * @classdesc Represents an UpdateSargonContactDetailsRequestBody.
             * @implements IUpdateSargonContactDetailsRequestBody
             * @constructor
             * @param {api.external.IUpdateSargonContactDetailsRequestBody=} [properties] Properties to set
             */
            function UpdateSargonContactDetailsRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdateSargonContactDetailsRequestBody sargon_phone_number.
             * @member {string} sargon_phone_number
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @instance
             */
            UpdateSargonContactDetailsRequestBody.prototype.sargon_phone_number = "";

            /**
             * UpdateSargonContactDetailsRequestBody sargon_email_address.
             * @member {string} sargon_email_address
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @instance
             */
            UpdateSargonContactDetailsRequestBody.prototype.sargon_email_address = "";

            /**
             * UpdateSargonContactDetailsRequestBody sargon_address.
             * @member {IAddress|null|undefined} sargon_address
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @instance
             */
            UpdateSargonContactDetailsRequestBody.prototype.sargon_address = null;

            /**
             * UpdateSargonContactDetailsRequestBody impact_id.
             * @member {string} impact_id
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @instance
             */
            UpdateSargonContactDetailsRequestBody.prototype.impact_id = "";

            /**
             * Creates a new UpdateSargonContactDetailsRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @static
             * @param {api.external.IUpdateSargonContactDetailsRequestBody=} [properties] Properties to set
             * @returns {api.external.UpdateSargonContactDetailsRequestBody} UpdateSargonContactDetailsRequestBody instance
             */
            UpdateSargonContactDetailsRequestBody.create = function create(properties) {
                return new UpdateSargonContactDetailsRequestBody(properties);
            };

            /**
             * Encodes the specified UpdateSargonContactDetailsRequestBody message. Does not implicitly {@link api.external.UpdateSargonContactDetailsRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @static
             * @param {api.external.IUpdateSargonContactDetailsRequestBody} message UpdateSargonContactDetailsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSargonContactDetailsRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sargon_phone_number != null && message.hasOwnProperty("sargon_phone_number"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sargon_phone_number);
                if (message.sargon_email_address != null && message.hasOwnProperty("sargon_email_address"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.sargon_email_address);
                if (message.sargon_address != null && message.hasOwnProperty("sargon_address"))
                    $root.Address.encode(message.sargon_address, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.impact_id != null && message.hasOwnProperty("impact_id"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.impact_id);
                return writer;
            };

            /**
             * Encodes the specified UpdateSargonContactDetailsRequestBody message, length delimited. Does not implicitly {@link api.external.UpdateSargonContactDetailsRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @static
             * @param {api.external.IUpdateSargonContactDetailsRequestBody} message UpdateSargonContactDetailsRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSargonContactDetailsRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateSargonContactDetailsRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateSargonContactDetailsRequestBody} UpdateSargonContactDetailsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSargonContactDetailsRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateSargonContactDetailsRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.sargon_phone_number = reader.string();
                        break;
                    case 2:
                        message.sargon_email_address = reader.string();
                        break;
                    case 3:
                        message.sargon_address = $root.Address.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.impact_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateSargonContactDetailsRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateSargonContactDetailsRequestBody} UpdateSargonContactDetailsRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSargonContactDetailsRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateSargonContactDetailsRequestBody message.
             * @function verify
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateSargonContactDetailsRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sargon_phone_number != null && message.hasOwnProperty("sargon_phone_number"))
                    if (!$util.isString(message.sargon_phone_number))
                        return "sargon_phone_number: string expected";
                if (message.sargon_email_address != null && message.hasOwnProperty("sargon_email_address"))
                    if (!$util.isString(message.sargon_email_address))
                        return "sargon_email_address: string expected";
                if (message.sargon_address != null && message.hasOwnProperty("sargon_address")) {
                    let error = $root.Address.verify(message.sargon_address);
                    if (error)
                        return "sargon_address." + error;
                }
                if (message.impact_id != null && message.hasOwnProperty("impact_id"))
                    if (!$util.isString(message.impact_id))
                        return "impact_id: string expected";
                return null;
            };

            /**
             * Creates an UpdateSargonContactDetailsRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateSargonContactDetailsRequestBody} UpdateSargonContactDetailsRequestBody
             */
            UpdateSargonContactDetailsRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateSargonContactDetailsRequestBody)
                    return object;
                let message = new $root.api.external.UpdateSargonContactDetailsRequestBody();
                if (object.sargon_phone_number != null)
                    message.sargon_phone_number = String(object.sargon_phone_number);
                if (object.sargon_email_address != null)
                    message.sargon_email_address = String(object.sargon_email_address);
                if (object.sargon_address != null) {
                    if (typeof object.sargon_address !== "object")
                        throw TypeError(".api.external.UpdateSargonContactDetailsRequestBody.sargon_address: object expected");
                    message.sargon_address = $root.Address.fromObject(object.sargon_address);
                }
                if (object.impact_id != null)
                    message.impact_id = String(object.impact_id);
                return message;
            };

            /**
             * Creates a plain object from an UpdateSargonContactDetailsRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @static
             * @param {api.external.UpdateSargonContactDetailsRequestBody} message UpdateSargonContactDetailsRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateSargonContactDetailsRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.sargon_phone_number = "";
                    object.sargon_email_address = "";
                    object.sargon_address = null;
                    object.impact_id = "";
                }
                if (message.sargon_phone_number != null && message.hasOwnProperty("sargon_phone_number"))
                    object.sargon_phone_number = message.sargon_phone_number;
                if (message.sargon_email_address != null && message.hasOwnProperty("sargon_email_address"))
                    object.sargon_email_address = message.sargon_email_address;
                if (message.sargon_address != null && message.hasOwnProperty("sargon_address"))
                    object.sargon_address = $root.Address.toObject(message.sargon_address, options);
                if (message.impact_id != null && message.hasOwnProperty("impact_id"))
                    object.impact_id = message.impact_id;
                return object;
            };

            /**
             * Converts this UpdateSargonContactDetailsRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateSargonContactDetailsRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateSargonContactDetailsRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateSargonContactDetailsRequestBody;
        })();

        external.UpdateSargonContactDetailsResponseBody = (function() {

            /**
             * Properties of an UpdateSargonContactDetailsResponseBody.
             * @memberof api.external
             * @interface IUpdateSargonContactDetailsResponseBody
             */

            /**
             * Constructs a new UpdateSargonContactDetailsResponseBody.
             * @memberof api.external
             * @classdesc Represents an UpdateSargonContactDetailsResponseBody.
             * @implements IUpdateSargonContactDetailsResponseBody
             * @constructor
             * @param {api.external.IUpdateSargonContactDetailsResponseBody=} [properties] Properties to set
             */
            function UpdateSargonContactDetailsResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateSargonContactDetailsResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @static
             * @param {api.external.IUpdateSargonContactDetailsResponseBody=} [properties] Properties to set
             * @returns {api.external.UpdateSargonContactDetailsResponseBody} UpdateSargonContactDetailsResponseBody instance
             */
            UpdateSargonContactDetailsResponseBody.create = function create(properties) {
                return new UpdateSargonContactDetailsResponseBody(properties);
            };

            /**
             * Encodes the specified UpdateSargonContactDetailsResponseBody message. Does not implicitly {@link api.external.UpdateSargonContactDetailsResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @static
             * @param {api.external.IUpdateSargonContactDetailsResponseBody} message UpdateSargonContactDetailsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSargonContactDetailsResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateSargonContactDetailsResponseBody message, length delimited. Does not implicitly {@link api.external.UpdateSargonContactDetailsResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @static
             * @param {api.external.IUpdateSargonContactDetailsResponseBody} message UpdateSargonContactDetailsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSargonContactDetailsResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateSargonContactDetailsResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateSargonContactDetailsResponseBody} UpdateSargonContactDetailsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSargonContactDetailsResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateSargonContactDetailsResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateSargonContactDetailsResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateSargonContactDetailsResponseBody} UpdateSargonContactDetailsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSargonContactDetailsResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateSargonContactDetailsResponseBody message.
             * @function verify
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateSargonContactDetailsResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateSargonContactDetailsResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateSargonContactDetailsResponseBody} UpdateSargonContactDetailsResponseBody
             */
            UpdateSargonContactDetailsResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateSargonContactDetailsResponseBody)
                    return object;
                return new $root.api.external.UpdateSargonContactDetailsResponseBody();
            };

            /**
             * Creates a plain object from an UpdateSargonContactDetailsResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @static
             * @param {api.external.UpdateSargonContactDetailsResponseBody} message UpdateSargonContactDetailsResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateSargonContactDetailsResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateSargonContactDetailsResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateSargonContactDetailsResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateSargonContactDetailsResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateSargonContactDetailsResponseBody;
        })();

        external.GetSuperPortfolioCompaniesByPortfolioResponseBody = (function() {

            /**
             * Properties of a GetSuperPortfolioCompaniesByPortfolioResponseBody.
             * @memberof api.external
             * @interface IGetSuperPortfolioCompaniesByPortfolioResponseBody
             * @property {Array.<ISuperPortfolioCompany>|null} [companies] GetSuperPortfolioCompaniesByPortfolioResponseBody companies
             * @property {Array.<ISuperAllocation>|null} [asset_allocations] GetSuperPortfolioCompaniesByPortfolioResponseBody asset_allocations
             * @property {Array.<ISuperAllocation>|null} [country_allocations] GetSuperPortfolioCompaniesByPortfolioResponseBody country_allocations
             * @property {Array.<ISuperAllocation>|null} [sector_allocations] GetSuperPortfolioCompaniesByPortfolioResponseBody sector_allocations
             * @property {string|null} [last_updated_at] GetSuperPortfolioCompaniesByPortfolioResponseBody last_updated_at
             */

            /**
             * Constructs a new GetSuperPortfolioCompaniesByPortfolioResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetSuperPortfolioCompaniesByPortfolioResponseBody.
             * @implements IGetSuperPortfolioCompaniesByPortfolioResponseBody
             * @constructor
             * @param {api.external.IGetSuperPortfolioCompaniesByPortfolioResponseBody=} [properties] Properties to set
             */
            function GetSuperPortfolioCompaniesByPortfolioResponseBody(properties) {
                this.companies = [];
                this.asset_allocations = [];
                this.country_allocations = [];
                this.sector_allocations = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetSuperPortfolioCompaniesByPortfolioResponseBody companies.
             * @member {Array.<ISuperPortfolioCompany>} companies
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @instance
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.prototype.companies = $util.emptyArray;

            /**
             * GetSuperPortfolioCompaniesByPortfolioResponseBody asset_allocations.
             * @member {Array.<ISuperAllocation>} asset_allocations
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @instance
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.prototype.asset_allocations = $util.emptyArray;

            /**
             * GetSuperPortfolioCompaniesByPortfolioResponseBody country_allocations.
             * @member {Array.<ISuperAllocation>} country_allocations
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @instance
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.prototype.country_allocations = $util.emptyArray;

            /**
             * GetSuperPortfolioCompaniesByPortfolioResponseBody sector_allocations.
             * @member {Array.<ISuperAllocation>} sector_allocations
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @instance
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.prototype.sector_allocations = $util.emptyArray;

            /**
             * GetSuperPortfolioCompaniesByPortfolioResponseBody last_updated_at.
             * @member {string} last_updated_at
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @instance
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.prototype.last_updated_at = "";

            /**
             * Creates a new GetSuperPortfolioCompaniesByPortfolioResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @static
             * @param {api.external.IGetSuperPortfolioCompaniesByPortfolioResponseBody=} [properties] Properties to set
             * @returns {api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody} GetSuperPortfolioCompaniesByPortfolioResponseBody instance
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.create = function create(properties) {
                return new GetSuperPortfolioCompaniesByPortfolioResponseBody(properties);
            };

            /**
             * Encodes the specified GetSuperPortfolioCompaniesByPortfolioResponseBody message. Does not implicitly {@link api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @static
             * @param {api.external.IGetSuperPortfolioCompaniesByPortfolioResponseBody} message GetSuperPortfolioCompaniesByPortfolioResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.companies != null && message.companies.length)
                    for (let i = 0; i < message.companies.length; ++i)
                        $root.SuperPortfolioCompany.encode(message.companies[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.asset_allocations != null && message.asset_allocations.length)
                    for (let i = 0; i < message.asset_allocations.length; ++i)
                        $root.SuperAllocation.encode(message.asset_allocations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.country_allocations != null && message.country_allocations.length)
                    for (let i = 0; i < message.country_allocations.length; ++i)
                        $root.SuperAllocation.encode(message.country_allocations[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.sector_allocations != null && message.sector_allocations.length)
                    for (let i = 0; i < message.sector_allocations.length; ++i)
                        $root.SuperAllocation.encode(message.sector_allocations[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
                    writer.uint32(/* id 99, wireType 2 =*/794).string(message.last_updated_at);
                return writer;
            };

            /**
             * Encodes the specified GetSuperPortfolioCompaniesByPortfolioResponseBody message, length delimited. Does not implicitly {@link api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @static
             * @param {api.external.IGetSuperPortfolioCompaniesByPortfolioResponseBody} message GetSuperPortfolioCompaniesByPortfolioResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetSuperPortfolioCompaniesByPortfolioResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody} GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.companies && message.companies.length))
                            message.companies = [];
                        message.companies.push($root.SuperPortfolioCompany.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        if (!(message.asset_allocations && message.asset_allocations.length))
                            message.asset_allocations = [];
                        message.asset_allocations.push($root.SuperAllocation.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        if (!(message.country_allocations && message.country_allocations.length))
                            message.country_allocations = [];
                        message.country_allocations.push($root.SuperAllocation.decode(reader, reader.uint32()));
                        break;
                    case 4:
                        if (!(message.sector_allocations && message.sector_allocations.length))
                            message.sector_allocations = [];
                        message.sector_allocations.push($root.SuperAllocation.decode(reader, reader.uint32()));
                        break;
                    case 99:
                        message.last_updated_at = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetSuperPortfolioCompaniesByPortfolioResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody} GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetSuperPortfolioCompaniesByPortfolioResponseBody message.
             * @function verify
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.companies != null && message.hasOwnProperty("companies")) {
                    if (!Array.isArray(message.companies))
                        return "companies: array expected";
                    for (let i = 0; i < message.companies.length; ++i) {
                        let error = $root.SuperPortfolioCompany.verify(message.companies[i]);
                        if (error)
                            return "companies." + error;
                    }
                }
                if (message.asset_allocations != null && message.hasOwnProperty("asset_allocations")) {
                    if (!Array.isArray(message.asset_allocations))
                        return "asset_allocations: array expected";
                    for (let i = 0; i < message.asset_allocations.length; ++i) {
                        let error = $root.SuperAllocation.verify(message.asset_allocations[i]);
                        if (error)
                            return "asset_allocations." + error;
                    }
                }
                if (message.country_allocations != null && message.hasOwnProperty("country_allocations")) {
                    if (!Array.isArray(message.country_allocations))
                        return "country_allocations: array expected";
                    for (let i = 0; i < message.country_allocations.length; ++i) {
                        let error = $root.SuperAllocation.verify(message.country_allocations[i]);
                        if (error)
                            return "country_allocations." + error;
                    }
                }
                if (message.sector_allocations != null && message.hasOwnProperty("sector_allocations")) {
                    if (!Array.isArray(message.sector_allocations))
                        return "sector_allocations: array expected";
                    for (let i = 0; i < message.sector_allocations.length; ++i) {
                        let error = $root.SuperAllocation.verify(message.sector_allocations[i]);
                        if (error)
                            return "sector_allocations." + error;
                    }
                }
                if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
                    if (!$util.isString(message.last_updated_at))
                        return "last_updated_at: string expected";
                return null;
            };

            /**
             * Creates a GetSuperPortfolioCompaniesByPortfolioResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody} GetSuperPortfolioCompaniesByPortfolioResponseBody
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody)
                    return object;
                let message = new $root.api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody();
                if (object.companies) {
                    if (!Array.isArray(object.companies))
                        throw TypeError(".api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.companies: array expected");
                    message.companies = [];
                    for (let i = 0; i < object.companies.length; ++i) {
                        if (typeof object.companies[i] !== "object")
                            throw TypeError(".api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.companies: object expected");
                        message.companies[i] = $root.SuperPortfolioCompany.fromObject(object.companies[i]);
                    }
                }
                if (object.asset_allocations) {
                    if (!Array.isArray(object.asset_allocations))
                        throw TypeError(".api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.asset_allocations: array expected");
                    message.asset_allocations = [];
                    for (let i = 0; i < object.asset_allocations.length; ++i) {
                        if (typeof object.asset_allocations[i] !== "object")
                            throw TypeError(".api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.asset_allocations: object expected");
                        message.asset_allocations[i] = $root.SuperAllocation.fromObject(object.asset_allocations[i]);
                    }
                }
                if (object.country_allocations) {
                    if (!Array.isArray(object.country_allocations))
                        throw TypeError(".api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.country_allocations: array expected");
                    message.country_allocations = [];
                    for (let i = 0; i < object.country_allocations.length; ++i) {
                        if (typeof object.country_allocations[i] !== "object")
                            throw TypeError(".api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.country_allocations: object expected");
                        message.country_allocations[i] = $root.SuperAllocation.fromObject(object.country_allocations[i]);
                    }
                }
                if (object.sector_allocations) {
                    if (!Array.isArray(object.sector_allocations))
                        throw TypeError(".api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.sector_allocations: array expected");
                    message.sector_allocations = [];
                    for (let i = 0; i < object.sector_allocations.length; ++i) {
                        if (typeof object.sector_allocations[i] !== "object")
                            throw TypeError(".api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody.sector_allocations: object expected");
                        message.sector_allocations[i] = $root.SuperAllocation.fromObject(object.sector_allocations[i]);
                    }
                }
                if (object.last_updated_at != null)
                    message.last_updated_at = String(object.last_updated_at);
                return message;
            };

            /**
             * Creates a plain object from a GetSuperPortfolioCompaniesByPortfolioResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @static
             * @param {api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody} message GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.companies = [];
                    object.asset_allocations = [];
                    object.country_allocations = [];
                    object.sector_allocations = [];
                }
                if (options.defaults)
                    object.last_updated_at = "";
                if (message.companies && message.companies.length) {
                    object.companies = [];
                    for (let j = 0; j < message.companies.length; ++j)
                        object.companies[j] = $root.SuperPortfolioCompany.toObject(message.companies[j], options);
                }
                if (message.asset_allocations && message.asset_allocations.length) {
                    object.asset_allocations = [];
                    for (let j = 0; j < message.asset_allocations.length; ++j)
                        object.asset_allocations[j] = $root.SuperAllocation.toObject(message.asset_allocations[j], options);
                }
                if (message.country_allocations && message.country_allocations.length) {
                    object.country_allocations = [];
                    for (let j = 0; j < message.country_allocations.length; ++j)
                        object.country_allocations[j] = $root.SuperAllocation.toObject(message.country_allocations[j], options);
                }
                if (message.sector_allocations && message.sector_allocations.length) {
                    object.sector_allocations = [];
                    for (let j = 0; j < message.sector_allocations.length; ++j)
                        object.sector_allocations[j] = $root.SuperAllocation.toObject(message.sector_allocations[j], options);
                }
                if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
                    object.last_updated_at = message.last_updated_at;
                return object;
            };

            /**
             * Converts this GetSuperPortfolioCompaniesByPortfolioResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetSuperPortfolioCompaniesByPortfolioResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetSuperPortfolioCompaniesByPortfolioResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetSuperPortfolioCompaniesByPortfolioResponseBody;
        })();

        external.AddForeignTaxResidencesRequestBody = (function() {

            /**
             * Properties of an AddForeignTaxResidencesRequestBody.
             * @memberof api.external
             * @interface IAddForeignTaxResidencesRequestBody
             * @property {Array.<api.external.AddForeignTaxResidencesRequestBody.IForeignTaxResidenceCreateRequest>|null} [foreign_tax_residence_create_requests] AddForeignTaxResidencesRequestBody foreign_tax_residence_create_requests
             */

            /**
             * Constructs a new AddForeignTaxResidencesRequestBody.
             * @memberof api.external
             * @classdesc Represents an AddForeignTaxResidencesRequestBody.
             * @implements IAddForeignTaxResidencesRequestBody
             * @constructor
             * @param {api.external.IAddForeignTaxResidencesRequestBody=} [properties] Properties to set
             */
            function AddForeignTaxResidencesRequestBody(properties) {
                this.foreign_tax_residence_create_requests = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AddForeignTaxResidencesRequestBody foreign_tax_residence_create_requests.
             * @member {Array.<api.external.AddForeignTaxResidencesRequestBody.IForeignTaxResidenceCreateRequest>} foreign_tax_residence_create_requests
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @instance
             */
            AddForeignTaxResidencesRequestBody.prototype.foreign_tax_residence_create_requests = $util.emptyArray;

            /**
             * Creates a new AddForeignTaxResidencesRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IAddForeignTaxResidencesRequestBody=} [properties] Properties to set
             * @returns {api.external.AddForeignTaxResidencesRequestBody} AddForeignTaxResidencesRequestBody instance
             */
            AddForeignTaxResidencesRequestBody.create = function create(properties) {
                return new AddForeignTaxResidencesRequestBody(properties);
            };

            /**
             * Encodes the specified AddForeignTaxResidencesRequestBody message. Does not implicitly {@link api.external.AddForeignTaxResidencesRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IAddForeignTaxResidencesRequestBody} message AddForeignTaxResidencesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddForeignTaxResidencesRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.foreign_tax_residence_create_requests != null && message.foreign_tax_residence_create_requests.length)
                    for (let i = 0; i < message.foreign_tax_residence_create_requests.length; ++i)
                        $root.api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest.encode(message.foreign_tax_residence_create_requests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AddForeignTaxResidencesRequestBody message, length delimited. Does not implicitly {@link api.external.AddForeignTaxResidencesRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IAddForeignTaxResidencesRequestBody} message AddForeignTaxResidencesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddForeignTaxResidencesRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddForeignTaxResidencesRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.AddForeignTaxResidencesRequestBody} AddForeignTaxResidencesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddForeignTaxResidencesRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.AddForeignTaxResidencesRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.foreign_tax_residence_create_requests && message.foreign_tax_residence_create_requests.length))
                            message.foreign_tax_residence_create_requests = [];
                        message.foreign_tax_residence_create_requests.push($root.api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddForeignTaxResidencesRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.AddForeignTaxResidencesRequestBody} AddForeignTaxResidencesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddForeignTaxResidencesRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddForeignTaxResidencesRequestBody message.
             * @function verify
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddForeignTaxResidencesRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.foreign_tax_residence_create_requests != null && message.hasOwnProperty("foreign_tax_residence_create_requests")) {
                    if (!Array.isArray(message.foreign_tax_residence_create_requests))
                        return "foreign_tax_residence_create_requests: array expected";
                    for (let i = 0; i < message.foreign_tax_residence_create_requests.length; ++i) {
                        let error = $root.api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest.verify(message.foreign_tax_residence_create_requests[i]);
                        if (error)
                            return "foreign_tax_residence_create_requests." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AddForeignTaxResidencesRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.AddForeignTaxResidencesRequestBody} AddForeignTaxResidencesRequestBody
             */
            AddForeignTaxResidencesRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.AddForeignTaxResidencesRequestBody)
                    return object;
                let message = new $root.api.external.AddForeignTaxResidencesRequestBody();
                if (object.foreign_tax_residence_create_requests) {
                    if (!Array.isArray(object.foreign_tax_residence_create_requests))
                        throw TypeError(".api.external.AddForeignTaxResidencesRequestBody.foreign_tax_residence_create_requests: array expected");
                    message.foreign_tax_residence_create_requests = [];
                    for (let i = 0; i < object.foreign_tax_residence_create_requests.length; ++i) {
                        if (typeof object.foreign_tax_residence_create_requests[i] !== "object")
                            throw TypeError(".api.external.AddForeignTaxResidencesRequestBody.foreign_tax_residence_create_requests: object expected");
                        message.foreign_tax_residence_create_requests[i] = $root.api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest.fromObject(object.foreign_tax_residence_create_requests[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AddForeignTaxResidencesRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.AddForeignTaxResidencesRequestBody} message AddForeignTaxResidencesRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddForeignTaxResidencesRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.foreign_tax_residence_create_requests = [];
                if (message.foreign_tax_residence_create_requests && message.foreign_tax_residence_create_requests.length) {
                    object.foreign_tax_residence_create_requests = [];
                    for (let j = 0; j < message.foreign_tax_residence_create_requests.length; ++j)
                        object.foreign_tax_residence_create_requests[j] = $root.api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest.toObject(message.foreign_tax_residence_create_requests[j], options);
                }
                return object;
            };

            /**
             * Converts this AddForeignTaxResidencesRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.AddForeignTaxResidencesRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddForeignTaxResidencesRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest = (function() {

                /**
                 * Properties of a ForeignTaxResidenceCreateRequest.
                 * @memberof api.external.AddForeignTaxResidencesRequestBody
                 * @interface IForeignTaxResidenceCreateRequest
                 * @property {string|null} [country_id] ForeignTaxResidenceCreateRequest country_id
                 * @property {string|null} [tin] ForeignTaxResidenceCreateRequest tin
                 * @property {boolean|null} [primary_residence] ForeignTaxResidenceCreateRequest primary_residence
                 * @property {ForeignTaxResidence.MissingTinDetails.Reason.Enum|null} [missing_tin_reason] ForeignTaxResidenceCreateRequest missing_tin_reason
                 * @property {string|null} [missing_tin_other_reason_description] ForeignTaxResidenceCreateRequest missing_tin_other_reason_description
                 */

                /**
                 * Constructs a new ForeignTaxResidenceCreateRequest.
                 * @memberof api.external.AddForeignTaxResidencesRequestBody
                 * @classdesc Represents a ForeignTaxResidenceCreateRequest.
                 * @implements IForeignTaxResidenceCreateRequest
                 * @constructor
                 * @param {api.external.AddForeignTaxResidencesRequestBody.IForeignTaxResidenceCreateRequest=} [properties] Properties to set
                 */
                function ForeignTaxResidenceCreateRequest(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ForeignTaxResidenceCreateRequest country_id.
                 * @member {string} country_id
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @instance
                 */
                ForeignTaxResidenceCreateRequest.prototype.country_id = "";

                /**
                 * ForeignTaxResidenceCreateRequest tin.
                 * @member {string} tin
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @instance
                 */
                ForeignTaxResidenceCreateRequest.prototype.tin = "";

                /**
                 * ForeignTaxResidenceCreateRequest primary_residence.
                 * @member {boolean} primary_residence
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @instance
                 */
                ForeignTaxResidenceCreateRequest.prototype.primary_residence = false;

                /**
                 * ForeignTaxResidenceCreateRequest missing_tin_reason.
                 * @member {ForeignTaxResidence.MissingTinDetails.Reason.Enum} missing_tin_reason
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @instance
                 */
                ForeignTaxResidenceCreateRequest.prototype.missing_tin_reason = 0;

                /**
                 * ForeignTaxResidenceCreateRequest missing_tin_other_reason_description.
                 * @member {string} missing_tin_other_reason_description
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @instance
                 */
                ForeignTaxResidenceCreateRequest.prototype.missing_tin_other_reason_description = "";

                /**
                 * Creates a new ForeignTaxResidenceCreateRequest instance using the specified properties.
                 * @function create
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @static
                 * @param {api.external.AddForeignTaxResidencesRequestBody.IForeignTaxResidenceCreateRequest=} [properties] Properties to set
                 * @returns {api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest} ForeignTaxResidenceCreateRequest instance
                 */
                ForeignTaxResidenceCreateRequest.create = function create(properties) {
                    return new ForeignTaxResidenceCreateRequest(properties);
                };

                /**
                 * Encodes the specified ForeignTaxResidenceCreateRequest message. Does not implicitly {@link api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest.verify|verify} messages.
                 * @function encode
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @static
                 * @param {api.external.AddForeignTaxResidencesRequestBody.IForeignTaxResidenceCreateRequest} message ForeignTaxResidenceCreateRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ForeignTaxResidenceCreateRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.country_id != null && message.hasOwnProperty("country_id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.country_id);
                    if (message.tin != null && message.hasOwnProperty("tin"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.tin);
                    if (message.primary_residence != null && message.hasOwnProperty("primary_residence"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.primary_residence);
                    if (message.missing_tin_reason != null && message.hasOwnProperty("missing_tin_reason"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.missing_tin_reason);
                    if (message.missing_tin_other_reason_description != null && message.hasOwnProperty("missing_tin_other_reason_description"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.missing_tin_other_reason_description);
                    return writer;
                };

                /**
                 * Encodes the specified ForeignTaxResidenceCreateRequest message, length delimited. Does not implicitly {@link api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @static
                 * @param {api.external.AddForeignTaxResidencesRequestBody.IForeignTaxResidenceCreateRequest} message ForeignTaxResidenceCreateRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ForeignTaxResidenceCreateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ForeignTaxResidenceCreateRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest} ForeignTaxResidenceCreateRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ForeignTaxResidenceCreateRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.country_id = reader.string();
                            break;
                        case 2:
                            message.tin = reader.string();
                            break;
                        case 3:
                            message.primary_residence = reader.bool();
                            break;
                        case 4:
                            message.missing_tin_reason = reader.int32();
                            break;
                        case 5:
                            message.missing_tin_other_reason_description = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ForeignTaxResidenceCreateRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest} ForeignTaxResidenceCreateRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ForeignTaxResidenceCreateRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ForeignTaxResidenceCreateRequest message.
                 * @function verify
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ForeignTaxResidenceCreateRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.country_id != null && message.hasOwnProperty("country_id"))
                        if (!$util.isString(message.country_id))
                            return "country_id: string expected";
                    if (message.tin != null && message.hasOwnProperty("tin"))
                        if (!$util.isString(message.tin))
                            return "tin: string expected";
                    if (message.primary_residence != null && message.hasOwnProperty("primary_residence"))
                        if (typeof message.primary_residence !== "boolean")
                            return "primary_residence: boolean expected";
                    if (message.missing_tin_reason != null && message.hasOwnProperty("missing_tin_reason"))
                        switch (message.missing_tin_reason) {
                        default:
                            return "missing_tin_reason: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.missing_tin_other_reason_description != null && message.hasOwnProperty("missing_tin_other_reason_description"))
                        if (!$util.isString(message.missing_tin_other_reason_description))
                            return "missing_tin_other_reason_description: string expected";
                    return null;
                };

                /**
                 * Creates a ForeignTaxResidenceCreateRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest} ForeignTaxResidenceCreateRequest
                 */
                ForeignTaxResidenceCreateRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest)
                        return object;
                    let message = new $root.api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest();
                    if (object.country_id != null)
                        message.country_id = String(object.country_id);
                    if (object.tin != null)
                        message.tin = String(object.tin);
                    if (object.primary_residence != null)
                        message.primary_residence = Boolean(object.primary_residence);
                    switch (object.missing_tin_reason) {
                    case "UNKNOWN":
                    case 0:
                        message.missing_tin_reason = 0;
                        break;
                    case "COUNTRY_DOES_NOT_PROVIDE_TIN":
                    case 1:
                        message.missing_tin_reason = 1;
                        break;
                    case "TIN_YET_TO_BE_ISSUED":
                    case 2:
                        message.missing_tin_reason = 2;
                        break;
                    case "OTHER":
                    case 3:
                        message.missing_tin_reason = 3;
                        break;
                    }
                    if (object.missing_tin_other_reason_description != null)
                        message.missing_tin_other_reason_description = String(object.missing_tin_other_reason_description);
                    return message;
                };

                /**
                 * Creates a plain object from a ForeignTaxResidenceCreateRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @static
                 * @param {api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest} message ForeignTaxResidenceCreateRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ForeignTaxResidenceCreateRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.country_id = "";
                        object.tin = "";
                        object.primary_residence = false;
                        object.missing_tin_reason = options.enums === String ? "UNKNOWN" : 0;
                        object.missing_tin_other_reason_description = "";
                    }
                    if (message.country_id != null && message.hasOwnProperty("country_id"))
                        object.country_id = message.country_id;
                    if (message.tin != null && message.hasOwnProperty("tin"))
                        object.tin = message.tin;
                    if (message.primary_residence != null && message.hasOwnProperty("primary_residence"))
                        object.primary_residence = message.primary_residence;
                    if (message.missing_tin_reason != null && message.hasOwnProperty("missing_tin_reason"))
                        object.missing_tin_reason = options.enums === String ? $root.ForeignTaxResidence.MissingTinDetails.Reason.Enum[message.missing_tin_reason] : message.missing_tin_reason;
                    if (message.missing_tin_other_reason_description != null && message.hasOwnProperty("missing_tin_other_reason_description"))
                        object.missing_tin_other_reason_description = message.missing_tin_other_reason_description;
                    return object;
                };

                /**
                 * Converts this ForeignTaxResidenceCreateRequest to JSON.
                 * @function toJSON
                 * @memberof api.external.AddForeignTaxResidencesRequestBody.ForeignTaxResidenceCreateRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ForeignTaxResidenceCreateRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ForeignTaxResidenceCreateRequest;
            })();

            return AddForeignTaxResidencesRequestBody;
        })();

        external.AddForeignTaxResidencesResponseBody = (function() {

            /**
             * Properties of an AddForeignTaxResidencesResponseBody.
             * @memberof api.external
             * @interface IAddForeignTaxResidencesResponseBody
             */

            /**
             * Constructs a new AddForeignTaxResidencesResponseBody.
             * @memberof api.external
             * @classdesc Represents an AddForeignTaxResidencesResponseBody.
             * @implements IAddForeignTaxResidencesResponseBody
             * @constructor
             * @param {api.external.IAddForeignTaxResidencesResponseBody=} [properties] Properties to set
             */
            function AddForeignTaxResidencesResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AddForeignTaxResidencesResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IAddForeignTaxResidencesResponseBody=} [properties] Properties to set
             * @returns {api.external.AddForeignTaxResidencesResponseBody} AddForeignTaxResidencesResponseBody instance
             */
            AddForeignTaxResidencesResponseBody.create = function create(properties) {
                return new AddForeignTaxResidencesResponseBody(properties);
            };

            /**
             * Encodes the specified AddForeignTaxResidencesResponseBody message. Does not implicitly {@link api.external.AddForeignTaxResidencesResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IAddForeignTaxResidencesResponseBody} message AddForeignTaxResidencesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddForeignTaxResidencesResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AddForeignTaxResidencesResponseBody message, length delimited. Does not implicitly {@link api.external.AddForeignTaxResidencesResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IAddForeignTaxResidencesResponseBody} message AddForeignTaxResidencesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddForeignTaxResidencesResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddForeignTaxResidencesResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.AddForeignTaxResidencesResponseBody} AddForeignTaxResidencesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddForeignTaxResidencesResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.AddForeignTaxResidencesResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddForeignTaxResidencesResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.AddForeignTaxResidencesResponseBody} AddForeignTaxResidencesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddForeignTaxResidencesResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddForeignTaxResidencesResponseBody message.
             * @function verify
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddForeignTaxResidencesResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AddForeignTaxResidencesResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.AddForeignTaxResidencesResponseBody} AddForeignTaxResidencesResponseBody
             */
            AddForeignTaxResidencesResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.AddForeignTaxResidencesResponseBody)
                    return object;
                return new $root.api.external.AddForeignTaxResidencesResponseBody();
            };

            /**
             * Creates a plain object from an AddForeignTaxResidencesResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.AddForeignTaxResidencesResponseBody} message AddForeignTaxResidencesResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddForeignTaxResidencesResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AddForeignTaxResidencesResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.AddForeignTaxResidencesResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddForeignTaxResidencesResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AddForeignTaxResidencesResponseBody;
        })();

        external.UpdateForeignTaxResidencesRequestBody = (function() {

            /**
             * Properties of an UpdateForeignTaxResidencesRequestBody.
             * @memberof api.external
             * @interface IUpdateForeignTaxResidencesRequestBody
             * @property {Array.<api.external.UpdateForeignTaxResidencesRequestBody.IForeignTaxResidenceUpdateRequest>|null} [foreign_tax_residence_update_requests] UpdateForeignTaxResidencesRequestBody foreign_tax_residence_update_requests
             */

            /**
             * Constructs a new UpdateForeignTaxResidencesRequestBody.
             * @memberof api.external
             * @classdesc Represents an UpdateForeignTaxResidencesRequestBody.
             * @implements IUpdateForeignTaxResidencesRequestBody
             * @constructor
             * @param {api.external.IUpdateForeignTaxResidencesRequestBody=} [properties] Properties to set
             */
            function UpdateForeignTaxResidencesRequestBody(properties) {
                this.foreign_tax_residence_update_requests = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdateForeignTaxResidencesRequestBody foreign_tax_residence_update_requests.
             * @member {Array.<api.external.UpdateForeignTaxResidencesRequestBody.IForeignTaxResidenceUpdateRequest>} foreign_tax_residence_update_requests
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @instance
             */
            UpdateForeignTaxResidencesRequestBody.prototype.foreign_tax_residence_update_requests = $util.emptyArray;

            /**
             * Creates a new UpdateForeignTaxResidencesRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IUpdateForeignTaxResidencesRequestBody=} [properties] Properties to set
             * @returns {api.external.UpdateForeignTaxResidencesRequestBody} UpdateForeignTaxResidencesRequestBody instance
             */
            UpdateForeignTaxResidencesRequestBody.create = function create(properties) {
                return new UpdateForeignTaxResidencesRequestBody(properties);
            };

            /**
             * Encodes the specified UpdateForeignTaxResidencesRequestBody message. Does not implicitly {@link api.external.UpdateForeignTaxResidencesRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IUpdateForeignTaxResidencesRequestBody} message UpdateForeignTaxResidencesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateForeignTaxResidencesRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.foreign_tax_residence_update_requests != null && message.foreign_tax_residence_update_requests.length)
                    for (let i = 0; i < message.foreign_tax_residence_update_requests.length; ++i)
                        $root.api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.encode(message.foreign_tax_residence_update_requests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified UpdateForeignTaxResidencesRequestBody message, length delimited. Does not implicitly {@link api.external.UpdateForeignTaxResidencesRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IUpdateForeignTaxResidencesRequestBody} message UpdateForeignTaxResidencesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateForeignTaxResidencesRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateForeignTaxResidencesRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateForeignTaxResidencesRequestBody} UpdateForeignTaxResidencesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateForeignTaxResidencesRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateForeignTaxResidencesRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.foreign_tax_residence_update_requests && message.foreign_tax_residence_update_requests.length))
                            message.foreign_tax_residence_update_requests = [];
                        message.foreign_tax_residence_update_requests.push($root.api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateForeignTaxResidencesRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateForeignTaxResidencesRequestBody} UpdateForeignTaxResidencesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateForeignTaxResidencesRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateForeignTaxResidencesRequestBody message.
             * @function verify
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateForeignTaxResidencesRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.foreign_tax_residence_update_requests != null && message.hasOwnProperty("foreign_tax_residence_update_requests")) {
                    if (!Array.isArray(message.foreign_tax_residence_update_requests))
                        return "foreign_tax_residence_update_requests: array expected";
                    for (let i = 0; i < message.foreign_tax_residence_update_requests.length; ++i) {
                        let error = $root.api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.verify(message.foreign_tax_residence_update_requests[i]);
                        if (error)
                            return "foreign_tax_residence_update_requests." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an UpdateForeignTaxResidencesRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateForeignTaxResidencesRequestBody} UpdateForeignTaxResidencesRequestBody
             */
            UpdateForeignTaxResidencesRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateForeignTaxResidencesRequestBody)
                    return object;
                let message = new $root.api.external.UpdateForeignTaxResidencesRequestBody();
                if (object.foreign_tax_residence_update_requests) {
                    if (!Array.isArray(object.foreign_tax_residence_update_requests))
                        throw TypeError(".api.external.UpdateForeignTaxResidencesRequestBody.foreign_tax_residence_update_requests: array expected");
                    message.foreign_tax_residence_update_requests = [];
                    for (let i = 0; i < object.foreign_tax_residence_update_requests.length; ++i) {
                        if (typeof object.foreign_tax_residence_update_requests[i] !== "object")
                            throw TypeError(".api.external.UpdateForeignTaxResidencesRequestBody.foreign_tax_residence_update_requests: object expected");
                        message.foreign_tax_residence_update_requests[i] = $root.api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.fromObject(object.foreign_tax_residence_update_requests[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an UpdateForeignTaxResidencesRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.UpdateForeignTaxResidencesRequestBody} message UpdateForeignTaxResidencesRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateForeignTaxResidencesRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.foreign_tax_residence_update_requests = [];
                if (message.foreign_tax_residence_update_requests && message.foreign_tax_residence_update_requests.length) {
                    object.foreign_tax_residence_update_requests = [];
                    for (let j = 0; j < message.foreign_tax_residence_update_requests.length; ++j)
                        object.foreign_tax_residence_update_requests[j] = $root.api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.toObject(message.foreign_tax_residence_update_requests[j], options);
                }
                return object;
            };

            /**
             * Converts this UpdateForeignTaxResidencesRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateForeignTaxResidencesRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateForeignTaxResidencesRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest = (function() {

                /**
                 * Properties of a ForeignTaxResidenceUpdateRequest.
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody
                 * @interface IForeignTaxResidenceUpdateRequest
                 * @property {string|null} [id] ForeignTaxResidenceUpdateRequest id
                 * @property {google.protobuf.IStringValue|null} [tin] ForeignTaxResidenceUpdateRequest tin
                 * @property {ForeignTaxResidence.MissingTinDetails.Reason.Enum|null} [missing_tin_reason] ForeignTaxResidenceUpdateRequest missing_tin_reason
                 * @property {google.protobuf.IStringValue|null} [missing_tin_other_reason_description] ForeignTaxResidenceUpdateRequest missing_tin_other_reason_description
                 * @property {google.protobuf.IBoolValue|null} [primary_residence] ForeignTaxResidenceUpdateRequest primary_residence
                 */

                /**
                 * Constructs a new ForeignTaxResidenceUpdateRequest.
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody
                 * @classdesc Represents a ForeignTaxResidenceUpdateRequest.
                 * @implements IForeignTaxResidenceUpdateRequest
                 * @constructor
                 * @param {api.external.UpdateForeignTaxResidencesRequestBody.IForeignTaxResidenceUpdateRequest=} [properties] Properties to set
                 */
                function ForeignTaxResidenceUpdateRequest(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ForeignTaxResidenceUpdateRequest id.
                 * @member {string} id
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @instance
                 */
                ForeignTaxResidenceUpdateRequest.prototype.id = "";

                /**
                 * ForeignTaxResidenceUpdateRequest tin.
                 * @member {google.protobuf.IStringValue|null|undefined} tin
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @instance
                 */
                ForeignTaxResidenceUpdateRequest.prototype.tin = null;

                /**
                 * ForeignTaxResidenceUpdateRequest missing_tin_reason.
                 * @member {ForeignTaxResidence.MissingTinDetails.Reason.Enum} missing_tin_reason
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @instance
                 */
                ForeignTaxResidenceUpdateRequest.prototype.missing_tin_reason = 0;

                /**
                 * ForeignTaxResidenceUpdateRequest missing_tin_other_reason_description.
                 * @member {google.protobuf.IStringValue|null|undefined} missing_tin_other_reason_description
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @instance
                 */
                ForeignTaxResidenceUpdateRequest.prototype.missing_tin_other_reason_description = null;

                /**
                 * ForeignTaxResidenceUpdateRequest primary_residence.
                 * @member {google.protobuf.IBoolValue|null|undefined} primary_residence
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @instance
                 */
                ForeignTaxResidenceUpdateRequest.prototype.primary_residence = null;

                /**
                 * Creates a new ForeignTaxResidenceUpdateRequest instance using the specified properties.
                 * @function create
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @static
                 * @param {api.external.UpdateForeignTaxResidencesRequestBody.IForeignTaxResidenceUpdateRequest=} [properties] Properties to set
                 * @returns {api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest} ForeignTaxResidenceUpdateRequest instance
                 */
                ForeignTaxResidenceUpdateRequest.create = function create(properties) {
                    return new ForeignTaxResidenceUpdateRequest(properties);
                };

                /**
                 * Encodes the specified ForeignTaxResidenceUpdateRequest message. Does not implicitly {@link api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.verify|verify} messages.
                 * @function encode
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @static
                 * @param {api.external.UpdateForeignTaxResidencesRequestBody.IForeignTaxResidenceUpdateRequest} message ForeignTaxResidenceUpdateRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ForeignTaxResidenceUpdateRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && message.hasOwnProperty("id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.tin != null && message.hasOwnProperty("tin"))
                        $root.google.protobuf.StringValue.encode(message.tin, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.missing_tin_reason != null && message.hasOwnProperty("missing_tin_reason"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.missing_tin_reason);
                    if (message.missing_tin_other_reason_description != null && message.hasOwnProperty("missing_tin_other_reason_description"))
                        $root.google.protobuf.StringValue.encode(message.missing_tin_other_reason_description, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.primary_residence != null && message.hasOwnProperty("primary_residence"))
                        $root.google.protobuf.BoolValue.encode(message.primary_residence, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ForeignTaxResidenceUpdateRequest message, length delimited. Does not implicitly {@link api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @static
                 * @param {api.external.UpdateForeignTaxResidencesRequestBody.IForeignTaxResidenceUpdateRequest} message ForeignTaxResidenceUpdateRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ForeignTaxResidenceUpdateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ForeignTaxResidenceUpdateRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest} ForeignTaxResidenceUpdateRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ForeignTaxResidenceUpdateRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.string();
                            break;
                        case 2:
                            message.tin = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.missing_tin_reason = reader.int32();
                            break;
                        case 4:
                            message.missing_tin_other_reason_description = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.primary_residence = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ForeignTaxResidenceUpdateRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest} ForeignTaxResidenceUpdateRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ForeignTaxResidenceUpdateRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ForeignTaxResidenceUpdateRequest message.
                 * @function verify
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ForeignTaxResidenceUpdateRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.tin != null && message.hasOwnProperty("tin")) {
                        let error = $root.google.protobuf.StringValue.verify(message.tin);
                        if (error)
                            return "tin." + error;
                    }
                    if (message.missing_tin_reason != null && message.hasOwnProperty("missing_tin_reason"))
                        switch (message.missing_tin_reason) {
                        default:
                            return "missing_tin_reason: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.missing_tin_other_reason_description != null && message.hasOwnProperty("missing_tin_other_reason_description")) {
                        let error = $root.google.protobuf.StringValue.verify(message.missing_tin_other_reason_description);
                        if (error)
                            return "missing_tin_other_reason_description." + error;
                    }
                    if (message.primary_residence != null && message.hasOwnProperty("primary_residence")) {
                        let error = $root.google.protobuf.BoolValue.verify(message.primary_residence);
                        if (error)
                            return "primary_residence." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ForeignTaxResidenceUpdateRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest} ForeignTaxResidenceUpdateRequest
                 */
                ForeignTaxResidenceUpdateRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest)
                        return object;
                    let message = new $root.api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.tin != null) {
                        if (typeof object.tin !== "object")
                            throw TypeError(".api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.tin: object expected");
                        message.tin = $root.google.protobuf.StringValue.fromObject(object.tin);
                    }
                    switch (object.missing_tin_reason) {
                    case "UNKNOWN":
                    case 0:
                        message.missing_tin_reason = 0;
                        break;
                    case "COUNTRY_DOES_NOT_PROVIDE_TIN":
                    case 1:
                        message.missing_tin_reason = 1;
                        break;
                    case "TIN_YET_TO_BE_ISSUED":
                    case 2:
                        message.missing_tin_reason = 2;
                        break;
                    case "OTHER":
                    case 3:
                        message.missing_tin_reason = 3;
                        break;
                    }
                    if (object.missing_tin_other_reason_description != null) {
                        if (typeof object.missing_tin_other_reason_description !== "object")
                            throw TypeError(".api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.missing_tin_other_reason_description: object expected");
                        message.missing_tin_other_reason_description = $root.google.protobuf.StringValue.fromObject(object.missing_tin_other_reason_description);
                    }
                    if (object.primary_residence != null) {
                        if (typeof object.primary_residence !== "object")
                            throw TypeError(".api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest.primary_residence: object expected");
                        message.primary_residence = $root.google.protobuf.BoolValue.fromObject(object.primary_residence);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ForeignTaxResidenceUpdateRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @static
                 * @param {api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest} message ForeignTaxResidenceUpdateRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ForeignTaxResidenceUpdateRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.id = "";
                        object.tin = null;
                        object.missing_tin_reason = options.enums === String ? "UNKNOWN" : 0;
                        object.missing_tin_other_reason_description = null;
                        object.primary_residence = null;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.tin != null && message.hasOwnProperty("tin"))
                        object.tin = $root.google.protobuf.StringValue.toObject(message.tin, options);
                    if (message.missing_tin_reason != null && message.hasOwnProperty("missing_tin_reason"))
                        object.missing_tin_reason = options.enums === String ? $root.ForeignTaxResidence.MissingTinDetails.Reason.Enum[message.missing_tin_reason] : message.missing_tin_reason;
                    if (message.missing_tin_other_reason_description != null && message.hasOwnProperty("missing_tin_other_reason_description"))
                        object.missing_tin_other_reason_description = $root.google.protobuf.StringValue.toObject(message.missing_tin_other_reason_description, options);
                    if (message.primary_residence != null && message.hasOwnProperty("primary_residence"))
                        object.primary_residence = $root.google.protobuf.BoolValue.toObject(message.primary_residence, options);
                    return object;
                };

                /**
                 * Converts this ForeignTaxResidenceUpdateRequest to JSON.
                 * @function toJSON
                 * @memberof api.external.UpdateForeignTaxResidencesRequestBody.ForeignTaxResidenceUpdateRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ForeignTaxResidenceUpdateRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ForeignTaxResidenceUpdateRequest;
            })();

            return UpdateForeignTaxResidencesRequestBody;
        })();

        external.UpdateForeignTaxResidencesResponseBody = (function() {

            /**
             * Properties of an UpdateForeignTaxResidencesResponseBody.
             * @memberof api.external
             * @interface IUpdateForeignTaxResidencesResponseBody
             */

            /**
             * Constructs a new UpdateForeignTaxResidencesResponseBody.
             * @memberof api.external
             * @classdesc Represents an UpdateForeignTaxResidencesResponseBody.
             * @implements IUpdateForeignTaxResidencesResponseBody
             * @constructor
             * @param {api.external.IUpdateForeignTaxResidencesResponseBody=} [properties] Properties to set
             */
            function UpdateForeignTaxResidencesResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new UpdateForeignTaxResidencesResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IUpdateForeignTaxResidencesResponseBody=} [properties] Properties to set
             * @returns {api.external.UpdateForeignTaxResidencesResponseBody} UpdateForeignTaxResidencesResponseBody instance
             */
            UpdateForeignTaxResidencesResponseBody.create = function create(properties) {
                return new UpdateForeignTaxResidencesResponseBody(properties);
            };

            /**
             * Encodes the specified UpdateForeignTaxResidencesResponseBody message. Does not implicitly {@link api.external.UpdateForeignTaxResidencesResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IUpdateForeignTaxResidencesResponseBody} message UpdateForeignTaxResidencesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateForeignTaxResidencesResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified UpdateForeignTaxResidencesResponseBody message, length delimited. Does not implicitly {@link api.external.UpdateForeignTaxResidencesResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IUpdateForeignTaxResidencesResponseBody} message UpdateForeignTaxResidencesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateForeignTaxResidencesResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateForeignTaxResidencesResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.UpdateForeignTaxResidencesResponseBody} UpdateForeignTaxResidencesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateForeignTaxResidencesResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.UpdateForeignTaxResidencesResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateForeignTaxResidencesResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.UpdateForeignTaxResidencesResponseBody} UpdateForeignTaxResidencesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateForeignTaxResidencesResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateForeignTaxResidencesResponseBody message.
             * @function verify
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateForeignTaxResidencesResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an UpdateForeignTaxResidencesResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.UpdateForeignTaxResidencesResponseBody} UpdateForeignTaxResidencesResponseBody
             */
            UpdateForeignTaxResidencesResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.UpdateForeignTaxResidencesResponseBody)
                    return object;
                return new $root.api.external.UpdateForeignTaxResidencesResponseBody();
            };

            /**
             * Creates a plain object from an UpdateForeignTaxResidencesResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.UpdateForeignTaxResidencesResponseBody} message UpdateForeignTaxResidencesResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateForeignTaxResidencesResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this UpdateForeignTaxResidencesResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.UpdateForeignTaxResidencesResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateForeignTaxResidencesResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateForeignTaxResidencesResponseBody;
        })();

        external.DeleteForeignTaxResidencesResponseBody = (function() {

            /**
             * Properties of a DeleteForeignTaxResidencesResponseBody.
             * @memberof api.external
             * @interface IDeleteForeignTaxResidencesResponseBody
             */

            /**
             * Constructs a new DeleteForeignTaxResidencesResponseBody.
             * @memberof api.external
             * @classdesc Represents a DeleteForeignTaxResidencesResponseBody.
             * @implements IDeleteForeignTaxResidencesResponseBody
             * @constructor
             * @param {api.external.IDeleteForeignTaxResidencesResponseBody=} [properties] Properties to set
             */
            function DeleteForeignTaxResidencesResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new DeleteForeignTaxResidencesResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IDeleteForeignTaxResidencesResponseBody=} [properties] Properties to set
             * @returns {api.external.DeleteForeignTaxResidencesResponseBody} DeleteForeignTaxResidencesResponseBody instance
             */
            DeleteForeignTaxResidencesResponseBody.create = function create(properties) {
                return new DeleteForeignTaxResidencesResponseBody(properties);
            };

            /**
             * Encodes the specified DeleteForeignTaxResidencesResponseBody message. Does not implicitly {@link api.external.DeleteForeignTaxResidencesResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IDeleteForeignTaxResidencesResponseBody} message DeleteForeignTaxResidencesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteForeignTaxResidencesResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified DeleteForeignTaxResidencesResponseBody message, length delimited. Does not implicitly {@link api.external.DeleteForeignTaxResidencesResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IDeleteForeignTaxResidencesResponseBody} message DeleteForeignTaxResidencesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeleteForeignTaxResidencesResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeleteForeignTaxResidencesResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.DeleteForeignTaxResidencesResponseBody} DeleteForeignTaxResidencesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteForeignTaxResidencesResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.DeleteForeignTaxResidencesResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeleteForeignTaxResidencesResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.DeleteForeignTaxResidencesResponseBody} DeleteForeignTaxResidencesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeleteForeignTaxResidencesResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeleteForeignTaxResidencesResponseBody message.
             * @function verify
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeleteForeignTaxResidencesResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a DeleteForeignTaxResidencesResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.DeleteForeignTaxResidencesResponseBody} DeleteForeignTaxResidencesResponseBody
             */
            DeleteForeignTaxResidencesResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.DeleteForeignTaxResidencesResponseBody)
                    return object;
                return new $root.api.external.DeleteForeignTaxResidencesResponseBody();
            };

            /**
             * Creates a plain object from a DeleteForeignTaxResidencesResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.DeleteForeignTaxResidencesResponseBody} message DeleteForeignTaxResidencesResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeleteForeignTaxResidencesResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this DeleteForeignTaxResidencesResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.DeleteForeignTaxResidencesResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeleteForeignTaxResidencesResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DeleteForeignTaxResidencesResponseBody;
        })();

        external.GetForeignTaxResidencesRequestBody = (function() {

            /**
             * Properties of a GetForeignTaxResidencesRequestBody.
             * @memberof api.external
             * @interface IGetForeignTaxResidencesRequestBody
             */

            /**
             * Constructs a new GetForeignTaxResidencesRequestBody.
             * @memberof api.external
             * @classdesc Represents a GetForeignTaxResidencesRequestBody.
             * @implements IGetForeignTaxResidencesRequestBody
             * @constructor
             * @param {api.external.IGetForeignTaxResidencesRequestBody=} [properties] Properties to set
             */
            function GetForeignTaxResidencesRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetForeignTaxResidencesRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IGetForeignTaxResidencesRequestBody=} [properties] Properties to set
             * @returns {api.external.GetForeignTaxResidencesRequestBody} GetForeignTaxResidencesRequestBody instance
             */
            GetForeignTaxResidencesRequestBody.create = function create(properties) {
                return new GetForeignTaxResidencesRequestBody(properties);
            };

            /**
             * Encodes the specified GetForeignTaxResidencesRequestBody message. Does not implicitly {@link api.external.GetForeignTaxResidencesRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IGetForeignTaxResidencesRequestBody} message GetForeignTaxResidencesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetForeignTaxResidencesRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetForeignTaxResidencesRequestBody message, length delimited. Does not implicitly {@link api.external.GetForeignTaxResidencesRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.IGetForeignTaxResidencesRequestBody} message GetForeignTaxResidencesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetForeignTaxResidencesRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetForeignTaxResidencesRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetForeignTaxResidencesRequestBody} GetForeignTaxResidencesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetForeignTaxResidencesRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetForeignTaxResidencesRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetForeignTaxResidencesRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetForeignTaxResidencesRequestBody} GetForeignTaxResidencesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetForeignTaxResidencesRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetForeignTaxResidencesRequestBody message.
             * @function verify
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetForeignTaxResidencesRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetForeignTaxResidencesRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetForeignTaxResidencesRequestBody} GetForeignTaxResidencesRequestBody
             */
            GetForeignTaxResidencesRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetForeignTaxResidencesRequestBody)
                    return object;
                return new $root.api.external.GetForeignTaxResidencesRequestBody();
            };

            /**
             * Creates a plain object from a GetForeignTaxResidencesRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @static
             * @param {api.external.GetForeignTaxResidencesRequestBody} message GetForeignTaxResidencesRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetForeignTaxResidencesRequestBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetForeignTaxResidencesRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.GetForeignTaxResidencesRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetForeignTaxResidencesRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetForeignTaxResidencesRequestBody;
        })();

        external.GetForeignTaxResidencesResponseBody = (function() {

            /**
             * Properties of a GetForeignTaxResidencesResponseBody.
             * @memberof api.external
             * @interface IGetForeignTaxResidencesResponseBody
             * @property {Array.<IForeignTaxResidence>|null} [foreign_tax_residences] GetForeignTaxResidencesResponseBody foreign_tax_residences
             */

            /**
             * Constructs a new GetForeignTaxResidencesResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetForeignTaxResidencesResponseBody.
             * @implements IGetForeignTaxResidencesResponseBody
             * @constructor
             * @param {api.external.IGetForeignTaxResidencesResponseBody=} [properties] Properties to set
             */
            function GetForeignTaxResidencesResponseBody(properties) {
                this.foreign_tax_residences = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetForeignTaxResidencesResponseBody foreign_tax_residences.
             * @member {Array.<IForeignTaxResidence>} foreign_tax_residences
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @instance
             */
            GetForeignTaxResidencesResponseBody.prototype.foreign_tax_residences = $util.emptyArray;

            /**
             * Creates a new GetForeignTaxResidencesResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IGetForeignTaxResidencesResponseBody=} [properties] Properties to set
             * @returns {api.external.GetForeignTaxResidencesResponseBody} GetForeignTaxResidencesResponseBody instance
             */
            GetForeignTaxResidencesResponseBody.create = function create(properties) {
                return new GetForeignTaxResidencesResponseBody(properties);
            };

            /**
             * Encodes the specified GetForeignTaxResidencesResponseBody message. Does not implicitly {@link api.external.GetForeignTaxResidencesResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IGetForeignTaxResidencesResponseBody} message GetForeignTaxResidencesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetForeignTaxResidencesResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.foreign_tax_residences != null && message.foreign_tax_residences.length)
                    for (let i = 0; i < message.foreign_tax_residences.length; ++i)
                        $root.ForeignTaxResidence.encode(message.foreign_tax_residences[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetForeignTaxResidencesResponseBody message, length delimited. Does not implicitly {@link api.external.GetForeignTaxResidencesResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.IGetForeignTaxResidencesResponseBody} message GetForeignTaxResidencesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetForeignTaxResidencesResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetForeignTaxResidencesResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetForeignTaxResidencesResponseBody} GetForeignTaxResidencesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetForeignTaxResidencesResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetForeignTaxResidencesResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.foreign_tax_residences && message.foreign_tax_residences.length))
                            message.foreign_tax_residences = [];
                        message.foreign_tax_residences.push($root.ForeignTaxResidence.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetForeignTaxResidencesResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetForeignTaxResidencesResponseBody} GetForeignTaxResidencesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetForeignTaxResidencesResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetForeignTaxResidencesResponseBody message.
             * @function verify
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetForeignTaxResidencesResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.foreign_tax_residences != null && message.hasOwnProperty("foreign_tax_residences")) {
                    if (!Array.isArray(message.foreign_tax_residences))
                        return "foreign_tax_residences: array expected";
                    for (let i = 0; i < message.foreign_tax_residences.length; ++i) {
                        let error = $root.ForeignTaxResidence.verify(message.foreign_tax_residences[i]);
                        if (error)
                            return "foreign_tax_residences." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetForeignTaxResidencesResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetForeignTaxResidencesResponseBody} GetForeignTaxResidencesResponseBody
             */
            GetForeignTaxResidencesResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetForeignTaxResidencesResponseBody)
                    return object;
                let message = new $root.api.external.GetForeignTaxResidencesResponseBody();
                if (object.foreign_tax_residences) {
                    if (!Array.isArray(object.foreign_tax_residences))
                        throw TypeError(".api.external.GetForeignTaxResidencesResponseBody.foreign_tax_residences: array expected");
                    message.foreign_tax_residences = [];
                    for (let i = 0; i < object.foreign_tax_residences.length; ++i) {
                        if (typeof object.foreign_tax_residences[i] !== "object")
                            throw TypeError(".api.external.GetForeignTaxResidencesResponseBody.foreign_tax_residences: object expected");
                        message.foreign_tax_residences[i] = $root.ForeignTaxResidence.fromObject(object.foreign_tax_residences[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetForeignTaxResidencesResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @static
             * @param {api.external.GetForeignTaxResidencesResponseBody} message GetForeignTaxResidencesResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetForeignTaxResidencesResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.foreign_tax_residences = [];
                if (message.foreign_tax_residences && message.foreign_tax_residences.length) {
                    object.foreign_tax_residences = [];
                    for (let j = 0; j < message.foreign_tax_residences.length; ++j)
                        object.foreign_tax_residences[j] = $root.ForeignTaxResidence.toObject(message.foreign_tax_residences[j], options);
                }
                return object;
            };

            /**
             * Converts this GetForeignTaxResidencesResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetForeignTaxResidencesResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetForeignTaxResidencesResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetForeignTaxResidencesResponseBody;
        })();

        external.GetCountriesRequestBody = (function() {

            /**
             * Properties of a GetCountriesRequestBody.
             * @memberof api.external
             * @interface IGetCountriesRequestBody
             */

            /**
             * Constructs a new GetCountriesRequestBody.
             * @memberof api.external
             * @classdesc Represents a GetCountriesRequestBody.
             * @implements IGetCountriesRequestBody
             * @constructor
             * @param {api.external.IGetCountriesRequestBody=} [properties] Properties to set
             */
            function GetCountriesRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new GetCountriesRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetCountriesRequestBody
             * @static
             * @param {api.external.IGetCountriesRequestBody=} [properties] Properties to set
             * @returns {api.external.GetCountriesRequestBody} GetCountriesRequestBody instance
             */
            GetCountriesRequestBody.create = function create(properties) {
                return new GetCountriesRequestBody(properties);
            };

            /**
             * Encodes the specified GetCountriesRequestBody message. Does not implicitly {@link api.external.GetCountriesRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetCountriesRequestBody
             * @static
             * @param {api.external.IGetCountriesRequestBody} message GetCountriesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetCountriesRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified GetCountriesRequestBody message, length delimited. Does not implicitly {@link api.external.GetCountriesRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetCountriesRequestBody
             * @static
             * @param {api.external.IGetCountriesRequestBody} message GetCountriesRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetCountriesRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetCountriesRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetCountriesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetCountriesRequestBody} GetCountriesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetCountriesRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetCountriesRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetCountriesRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetCountriesRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetCountriesRequestBody} GetCountriesRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetCountriesRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetCountriesRequestBody message.
             * @function verify
             * @memberof api.external.GetCountriesRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetCountriesRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a GetCountriesRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetCountriesRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetCountriesRequestBody} GetCountriesRequestBody
             */
            GetCountriesRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetCountriesRequestBody)
                    return object;
                return new $root.api.external.GetCountriesRequestBody();
            };

            /**
             * Creates a plain object from a GetCountriesRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetCountriesRequestBody
             * @static
             * @param {api.external.GetCountriesRequestBody} message GetCountriesRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetCountriesRequestBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this GetCountriesRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.GetCountriesRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetCountriesRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetCountriesRequestBody;
        })();

        external.GetCountriesResponseBody = (function() {

            /**
             * Properties of a GetCountriesResponseBody.
             * @memberof api.external
             * @interface IGetCountriesResponseBody
             * @property {Array.<ICountry>|null} [countries] GetCountriesResponseBody countries
             */

            /**
             * Constructs a new GetCountriesResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetCountriesResponseBody.
             * @implements IGetCountriesResponseBody
             * @constructor
             * @param {api.external.IGetCountriesResponseBody=} [properties] Properties to set
             */
            function GetCountriesResponseBody(properties) {
                this.countries = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetCountriesResponseBody countries.
             * @member {Array.<ICountry>} countries
             * @memberof api.external.GetCountriesResponseBody
             * @instance
             */
            GetCountriesResponseBody.prototype.countries = $util.emptyArray;

            /**
             * Creates a new GetCountriesResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetCountriesResponseBody
             * @static
             * @param {api.external.IGetCountriesResponseBody=} [properties] Properties to set
             * @returns {api.external.GetCountriesResponseBody} GetCountriesResponseBody instance
             */
            GetCountriesResponseBody.create = function create(properties) {
                return new GetCountriesResponseBody(properties);
            };

            /**
             * Encodes the specified GetCountriesResponseBody message. Does not implicitly {@link api.external.GetCountriesResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetCountriesResponseBody
             * @static
             * @param {api.external.IGetCountriesResponseBody} message GetCountriesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetCountriesResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.countries != null && message.countries.length)
                    for (let i = 0; i < message.countries.length; ++i)
                        $root.Country.encode(message.countries[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetCountriesResponseBody message, length delimited. Does not implicitly {@link api.external.GetCountriesResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetCountriesResponseBody
             * @static
             * @param {api.external.IGetCountriesResponseBody} message GetCountriesResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetCountriesResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetCountriesResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetCountriesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetCountriesResponseBody} GetCountriesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetCountriesResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetCountriesResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.countries && message.countries.length))
                            message.countries = [];
                        message.countries.push($root.Country.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetCountriesResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetCountriesResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetCountriesResponseBody} GetCountriesResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetCountriesResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetCountriesResponseBody message.
             * @function verify
             * @memberof api.external.GetCountriesResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetCountriesResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.countries != null && message.hasOwnProperty("countries")) {
                    if (!Array.isArray(message.countries))
                        return "countries: array expected";
                    for (let i = 0; i < message.countries.length; ++i) {
                        let error = $root.Country.verify(message.countries[i]);
                        if (error)
                            return "countries." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetCountriesResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetCountriesResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetCountriesResponseBody} GetCountriesResponseBody
             */
            GetCountriesResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetCountriesResponseBody)
                    return object;
                let message = new $root.api.external.GetCountriesResponseBody();
                if (object.countries) {
                    if (!Array.isArray(object.countries))
                        throw TypeError(".api.external.GetCountriesResponseBody.countries: array expected");
                    message.countries = [];
                    for (let i = 0; i < object.countries.length; ++i) {
                        if (typeof object.countries[i] !== "object")
                            throw TypeError(".api.external.GetCountriesResponseBody.countries: object expected");
                        message.countries[i] = $root.Country.fromObject(object.countries[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetCountriesResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetCountriesResponseBody
             * @static
             * @param {api.external.GetCountriesResponseBody} message GetCountriesResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetCountriesResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.countries = [];
                if (message.countries && message.countries.length) {
                    object.countries = [];
                    for (let j = 0; j < message.countries.length; ++j)
                        object.countries[j] = $root.Country.toObject(message.countries[j], options);
                }
                return object;
            };

            /**
             * Converts this GetCountriesResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetCountriesResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetCountriesResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetCountriesResponseBody;
        })();

        external.EstimateApplicationExecutionDateResponseBody = (function() {

            /**
             * Properties of an EstimateApplicationExecutionDateResponseBody.
             * @memberof api.external
             * @interface IEstimateApplicationExecutionDateResponseBody
             * @property {string|null} [estimated_application_execution_date] EstimateApplicationExecutionDateResponseBody estimated_application_execution_date
             */

            /**
             * Constructs a new EstimateApplicationExecutionDateResponseBody.
             * @memberof api.external
             * @classdesc Represents an EstimateApplicationExecutionDateResponseBody.
             * @implements IEstimateApplicationExecutionDateResponseBody
             * @constructor
             * @param {api.external.IEstimateApplicationExecutionDateResponseBody=} [properties] Properties to set
             */
            function EstimateApplicationExecutionDateResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EstimateApplicationExecutionDateResponseBody estimated_application_execution_date.
             * @member {string} estimated_application_execution_date
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @instance
             */
            EstimateApplicationExecutionDateResponseBody.prototype.estimated_application_execution_date = "";

            /**
             * Creates a new EstimateApplicationExecutionDateResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @static
             * @param {api.external.IEstimateApplicationExecutionDateResponseBody=} [properties] Properties to set
             * @returns {api.external.EstimateApplicationExecutionDateResponseBody} EstimateApplicationExecutionDateResponseBody instance
             */
            EstimateApplicationExecutionDateResponseBody.create = function create(properties) {
                return new EstimateApplicationExecutionDateResponseBody(properties);
            };

            /**
             * Encodes the specified EstimateApplicationExecutionDateResponseBody message. Does not implicitly {@link api.external.EstimateApplicationExecutionDateResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @static
             * @param {api.external.IEstimateApplicationExecutionDateResponseBody} message EstimateApplicationExecutionDateResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EstimateApplicationExecutionDateResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.estimated_application_execution_date);
                return writer;
            };

            /**
             * Encodes the specified EstimateApplicationExecutionDateResponseBody message, length delimited. Does not implicitly {@link api.external.EstimateApplicationExecutionDateResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @static
             * @param {api.external.IEstimateApplicationExecutionDateResponseBody} message EstimateApplicationExecutionDateResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EstimateApplicationExecutionDateResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EstimateApplicationExecutionDateResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.EstimateApplicationExecutionDateResponseBody} EstimateApplicationExecutionDateResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EstimateApplicationExecutionDateResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.EstimateApplicationExecutionDateResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.estimated_application_execution_date = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EstimateApplicationExecutionDateResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.EstimateApplicationExecutionDateResponseBody} EstimateApplicationExecutionDateResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EstimateApplicationExecutionDateResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EstimateApplicationExecutionDateResponseBody message.
             * @function verify
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EstimateApplicationExecutionDateResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
                    if (!$util.isString(message.estimated_application_execution_date))
                        return "estimated_application_execution_date: string expected";
                return null;
            };

            /**
             * Creates an EstimateApplicationExecutionDateResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.EstimateApplicationExecutionDateResponseBody} EstimateApplicationExecutionDateResponseBody
             */
            EstimateApplicationExecutionDateResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.EstimateApplicationExecutionDateResponseBody)
                    return object;
                let message = new $root.api.external.EstimateApplicationExecutionDateResponseBody();
                if (object.estimated_application_execution_date != null)
                    message.estimated_application_execution_date = String(object.estimated_application_execution_date);
                return message;
            };

            /**
             * Creates a plain object from an EstimateApplicationExecutionDateResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @static
             * @param {api.external.EstimateApplicationExecutionDateResponseBody} message EstimateApplicationExecutionDateResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EstimateApplicationExecutionDateResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.estimated_application_execution_date = "";
                if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
                    object.estimated_application_execution_date = message.estimated_application_execution_date;
                return object;
            };

            /**
             * Converts this EstimateApplicationExecutionDateResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.EstimateApplicationExecutionDateResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EstimateApplicationExecutionDateResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EstimateApplicationExecutionDateResponseBody;
        })();

        external.EstimateAnonymousApplicationExecutionDateResponseBody = (function() {

            /**
             * Properties of an EstimateAnonymousApplicationExecutionDateResponseBody.
             * @memberof api.external
             * @interface IEstimateAnonymousApplicationExecutionDateResponseBody
             * @property {string|null} [estimated_application_execution_date] EstimateAnonymousApplicationExecutionDateResponseBody estimated_application_execution_date
             */

            /**
             * Constructs a new EstimateAnonymousApplicationExecutionDateResponseBody.
             * @memberof api.external
             * @classdesc Represents an EstimateAnonymousApplicationExecutionDateResponseBody.
             * @implements IEstimateAnonymousApplicationExecutionDateResponseBody
             * @constructor
             * @param {api.external.IEstimateAnonymousApplicationExecutionDateResponseBody=} [properties] Properties to set
             */
            function EstimateAnonymousApplicationExecutionDateResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EstimateAnonymousApplicationExecutionDateResponseBody estimated_application_execution_date.
             * @member {string} estimated_application_execution_date
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @instance
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.prototype.estimated_application_execution_date = "";

            /**
             * Creates a new EstimateAnonymousApplicationExecutionDateResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @static
             * @param {api.external.IEstimateAnonymousApplicationExecutionDateResponseBody=} [properties] Properties to set
             * @returns {api.external.EstimateAnonymousApplicationExecutionDateResponseBody} EstimateAnonymousApplicationExecutionDateResponseBody instance
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.create = function create(properties) {
                return new EstimateAnonymousApplicationExecutionDateResponseBody(properties);
            };

            /**
             * Encodes the specified EstimateAnonymousApplicationExecutionDateResponseBody message. Does not implicitly {@link api.external.EstimateAnonymousApplicationExecutionDateResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @static
             * @param {api.external.IEstimateAnonymousApplicationExecutionDateResponseBody} message EstimateAnonymousApplicationExecutionDateResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.estimated_application_execution_date);
                return writer;
            };

            /**
             * Encodes the specified EstimateAnonymousApplicationExecutionDateResponseBody message, length delimited. Does not implicitly {@link api.external.EstimateAnonymousApplicationExecutionDateResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @static
             * @param {api.external.IEstimateAnonymousApplicationExecutionDateResponseBody} message EstimateAnonymousApplicationExecutionDateResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EstimateAnonymousApplicationExecutionDateResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.EstimateAnonymousApplicationExecutionDateResponseBody} EstimateAnonymousApplicationExecutionDateResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.EstimateAnonymousApplicationExecutionDateResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.estimated_application_execution_date = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EstimateAnonymousApplicationExecutionDateResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.EstimateAnonymousApplicationExecutionDateResponseBody} EstimateAnonymousApplicationExecutionDateResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EstimateAnonymousApplicationExecutionDateResponseBody message.
             * @function verify
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
                    if (!$util.isString(message.estimated_application_execution_date))
                        return "estimated_application_execution_date: string expected";
                return null;
            };

            /**
             * Creates an EstimateAnonymousApplicationExecutionDateResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.EstimateAnonymousApplicationExecutionDateResponseBody} EstimateAnonymousApplicationExecutionDateResponseBody
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.EstimateAnonymousApplicationExecutionDateResponseBody)
                    return object;
                let message = new $root.api.external.EstimateAnonymousApplicationExecutionDateResponseBody();
                if (object.estimated_application_execution_date != null)
                    message.estimated_application_execution_date = String(object.estimated_application_execution_date);
                return message;
            };

            /**
             * Creates a plain object from an EstimateAnonymousApplicationExecutionDateResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @static
             * @param {api.external.EstimateAnonymousApplicationExecutionDateResponseBody} message EstimateAnonymousApplicationExecutionDateResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.estimated_application_execution_date = "";
                if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
                    object.estimated_application_execution_date = message.estimated_application_execution_date;
                return object;
            };

            /**
             * Converts this EstimateAnonymousApplicationExecutionDateResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.EstimateAnonymousApplicationExecutionDateResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EstimateAnonymousApplicationExecutionDateResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EstimateAnonymousApplicationExecutionDateResponseBody;
        })();

        external.LinkWithSargonRequestBody = (function() {

            /**
             * Properties of a LinkWithSargonRequestBody.
             * @memberof api.external
             * @interface ILinkWithSargonRequestBody
             * @property {ISargonAuth|null} [sargon_auth] LinkWithSargonRequestBody sargon_auth
             */

            /**
             * Constructs a new LinkWithSargonRequestBody.
             * @memberof api.external
             * @classdesc Represents a LinkWithSargonRequestBody.
             * @implements ILinkWithSargonRequestBody
             * @constructor
             * @param {api.external.ILinkWithSargonRequestBody=} [properties] Properties to set
             */
            function LinkWithSargonRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LinkWithSargonRequestBody sargon_auth.
             * @member {ISargonAuth|null|undefined} sargon_auth
             * @memberof api.external.LinkWithSargonRequestBody
             * @instance
             */
            LinkWithSargonRequestBody.prototype.sargon_auth = null;

            /**
             * Creates a new LinkWithSargonRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.LinkWithSargonRequestBody
             * @static
             * @param {api.external.ILinkWithSargonRequestBody=} [properties] Properties to set
             * @returns {api.external.LinkWithSargonRequestBody} LinkWithSargonRequestBody instance
             */
            LinkWithSargonRequestBody.create = function create(properties) {
                return new LinkWithSargonRequestBody(properties);
            };

            /**
             * Encodes the specified LinkWithSargonRequestBody message. Does not implicitly {@link api.external.LinkWithSargonRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.LinkWithSargonRequestBody
             * @static
             * @param {api.external.ILinkWithSargonRequestBody} message LinkWithSargonRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LinkWithSargonRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sargon_auth != null && message.hasOwnProperty("sargon_auth"))
                    $root.SargonAuth.encode(message.sargon_auth, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LinkWithSargonRequestBody message, length delimited. Does not implicitly {@link api.external.LinkWithSargonRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.LinkWithSargonRequestBody
             * @static
             * @param {api.external.ILinkWithSargonRequestBody} message LinkWithSargonRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LinkWithSargonRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LinkWithSargonRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.LinkWithSargonRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.LinkWithSargonRequestBody} LinkWithSargonRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LinkWithSargonRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.LinkWithSargonRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.sargon_auth = $root.SargonAuth.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LinkWithSargonRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.LinkWithSargonRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.LinkWithSargonRequestBody} LinkWithSargonRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LinkWithSargonRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LinkWithSargonRequestBody message.
             * @function verify
             * @memberof api.external.LinkWithSargonRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LinkWithSargonRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sargon_auth != null && message.hasOwnProperty("sargon_auth")) {
                    let error = $root.SargonAuth.verify(message.sargon_auth);
                    if (error)
                        return "sargon_auth." + error;
                }
                return null;
            };

            /**
             * Creates a LinkWithSargonRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.LinkWithSargonRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.LinkWithSargonRequestBody} LinkWithSargonRequestBody
             */
            LinkWithSargonRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.LinkWithSargonRequestBody)
                    return object;
                let message = new $root.api.external.LinkWithSargonRequestBody();
                if (object.sargon_auth != null) {
                    if (typeof object.sargon_auth !== "object")
                        throw TypeError(".api.external.LinkWithSargonRequestBody.sargon_auth: object expected");
                    message.sargon_auth = $root.SargonAuth.fromObject(object.sargon_auth);
                }
                return message;
            };

            /**
             * Creates a plain object from a LinkWithSargonRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.LinkWithSargonRequestBody
             * @static
             * @param {api.external.LinkWithSargonRequestBody} message LinkWithSargonRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LinkWithSargonRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.sargon_auth = null;
                if (message.sargon_auth != null && message.hasOwnProperty("sargon_auth"))
                    object.sargon_auth = $root.SargonAuth.toObject(message.sargon_auth, options);
                return object;
            };

            /**
             * Converts this LinkWithSargonRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.LinkWithSargonRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LinkWithSargonRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LinkWithSargonRequestBody;
        })();

        external.LinkWithSargonResponseBody = (function() {

            /**
             * Properties of a LinkWithSargonResponseBody.
             * @memberof api.external
             * @interface ILinkWithSargonResponseBody
             * @property {IContactMatches|null} [contact_matches] LinkWithSargonResponseBody contact_matches
             */

            /**
             * Constructs a new LinkWithSargonResponseBody.
             * @memberof api.external
             * @classdesc Represents a LinkWithSargonResponseBody.
             * @implements ILinkWithSargonResponseBody
             * @constructor
             * @param {api.external.ILinkWithSargonResponseBody=} [properties] Properties to set
             */
            function LinkWithSargonResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LinkWithSargonResponseBody contact_matches.
             * @member {IContactMatches|null|undefined} contact_matches
             * @memberof api.external.LinkWithSargonResponseBody
             * @instance
             */
            LinkWithSargonResponseBody.prototype.contact_matches = null;

            /**
             * Creates a new LinkWithSargonResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.LinkWithSargonResponseBody
             * @static
             * @param {api.external.ILinkWithSargonResponseBody=} [properties] Properties to set
             * @returns {api.external.LinkWithSargonResponseBody} LinkWithSargonResponseBody instance
             */
            LinkWithSargonResponseBody.create = function create(properties) {
                return new LinkWithSargonResponseBody(properties);
            };

            /**
             * Encodes the specified LinkWithSargonResponseBody message. Does not implicitly {@link api.external.LinkWithSargonResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.LinkWithSargonResponseBody
             * @static
             * @param {api.external.ILinkWithSargonResponseBody} message LinkWithSargonResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LinkWithSargonResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contact_matches != null && message.hasOwnProperty("contact_matches"))
                    $root.ContactMatches.encode(message.contact_matches, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LinkWithSargonResponseBody message, length delimited. Does not implicitly {@link api.external.LinkWithSargonResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.LinkWithSargonResponseBody
             * @static
             * @param {api.external.ILinkWithSargonResponseBody} message LinkWithSargonResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LinkWithSargonResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LinkWithSargonResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.LinkWithSargonResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.LinkWithSargonResponseBody} LinkWithSargonResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LinkWithSargonResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.LinkWithSargonResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.contact_matches = $root.ContactMatches.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LinkWithSargonResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.LinkWithSargonResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.LinkWithSargonResponseBody} LinkWithSargonResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LinkWithSargonResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LinkWithSargonResponseBody message.
             * @function verify
             * @memberof api.external.LinkWithSargonResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LinkWithSargonResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contact_matches != null && message.hasOwnProperty("contact_matches")) {
                    let error = $root.ContactMatches.verify(message.contact_matches);
                    if (error)
                        return "contact_matches." + error;
                }
                return null;
            };

            /**
             * Creates a LinkWithSargonResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.LinkWithSargonResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.LinkWithSargonResponseBody} LinkWithSargonResponseBody
             */
            LinkWithSargonResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.LinkWithSargonResponseBody)
                    return object;
                let message = new $root.api.external.LinkWithSargonResponseBody();
                if (object.contact_matches != null) {
                    if (typeof object.contact_matches !== "object")
                        throw TypeError(".api.external.LinkWithSargonResponseBody.contact_matches: object expected");
                    message.contact_matches = $root.ContactMatches.fromObject(object.contact_matches);
                }
                return message;
            };

            /**
             * Creates a plain object from a LinkWithSargonResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.LinkWithSargonResponseBody
             * @static
             * @param {api.external.LinkWithSargonResponseBody} message LinkWithSargonResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LinkWithSargonResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.contact_matches = null;
                if (message.contact_matches != null && message.hasOwnProperty("contact_matches"))
                    object.contact_matches = $root.ContactMatches.toObject(message.contact_matches, options);
                return object;
            };

            /**
             * Converts this LinkWithSargonResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.LinkWithSargonResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LinkWithSargonResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LinkWithSargonResponseBody;
        })();

        external.CreateSargonMemberRequestBody = (function() {

            /**
             * Properties of a CreateSargonMemberRequestBody.
             * @memberof api.external
             * @interface ICreateSargonMemberRequestBody
             * @property {string|null} [tfn] CreateSargonMemberRequestBody tfn
             * @property {Gender.Enum|null} [gender] CreateSargonMemberRequestBody gender
             * @property {string|null} [documents_accepted_at] CreateSargonMemberRequestBody documents_accepted_at
             */

            /**
             * Constructs a new CreateSargonMemberRequestBody.
             * @memberof api.external
             * @classdesc Represents a CreateSargonMemberRequestBody.
             * @implements ICreateSargonMemberRequestBody
             * @constructor
             * @param {api.external.ICreateSargonMemberRequestBody=} [properties] Properties to set
             */
            function CreateSargonMemberRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateSargonMemberRequestBody tfn.
             * @member {string} tfn
             * @memberof api.external.CreateSargonMemberRequestBody
             * @instance
             */
            CreateSargonMemberRequestBody.prototype.tfn = "";

            /**
             * CreateSargonMemberRequestBody gender.
             * @member {Gender.Enum} gender
             * @memberof api.external.CreateSargonMemberRequestBody
             * @instance
             */
            CreateSargonMemberRequestBody.prototype.gender = 0;

            /**
             * CreateSargonMemberRequestBody documents_accepted_at.
             * @member {string} documents_accepted_at
             * @memberof api.external.CreateSargonMemberRequestBody
             * @instance
             */
            CreateSargonMemberRequestBody.prototype.documents_accepted_at = "";

            /**
             * Creates a new CreateSargonMemberRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateSargonMemberRequestBody
             * @static
             * @param {api.external.ICreateSargonMemberRequestBody=} [properties] Properties to set
             * @returns {api.external.CreateSargonMemberRequestBody} CreateSargonMemberRequestBody instance
             */
            CreateSargonMemberRequestBody.create = function create(properties) {
                return new CreateSargonMemberRequestBody(properties);
            };

            /**
             * Encodes the specified CreateSargonMemberRequestBody message. Does not implicitly {@link api.external.CreateSargonMemberRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateSargonMemberRequestBody
             * @static
             * @param {api.external.ICreateSargonMemberRequestBody} message CreateSargonMemberRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSargonMemberRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.tfn != null && message.hasOwnProperty("tfn"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.tfn);
                if (message.gender != null && message.hasOwnProperty("gender"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.gender);
                if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.documents_accepted_at);
                return writer;
            };

            /**
             * Encodes the specified CreateSargonMemberRequestBody message, length delimited. Does not implicitly {@link api.external.CreateSargonMemberRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateSargonMemberRequestBody
             * @static
             * @param {api.external.ICreateSargonMemberRequestBody} message CreateSargonMemberRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSargonMemberRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSargonMemberRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateSargonMemberRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateSargonMemberRequestBody} CreateSargonMemberRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSargonMemberRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateSargonMemberRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.tfn = reader.string();
                        break;
                    case 2:
                        message.gender = reader.int32();
                        break;
                    case 3:
                        message.documents_accepted_at = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSargonMemberRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateSargonMemberRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateSargonMemberRequestBody} CreateSargonMemberRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSargonMemberRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSargonMemberRequestBody message.
             * @function verify
             * @memberof api.external.CreateSargonMemberRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSargonMemberRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.tfn != null && message.hasOwnProperty("tfn"))
                    if (!$util.isString(message.tfn))
                        return "tfn: string expected";
                if (message.gender != null && message.hasOwnProperty("gender"))
                    switch (message.gender) {
                    default:
                        return "gender: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at"))
                    if (!$util.isString(message.documents_accepted_at))
                        return "documents_accepted_at: string expected";
                return null;
            };

            /**
             * Creates a CreateSargonMemberRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateSargonMemberRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateSargonMemberRequestBody} CreateSargonMemberRequestBody
             */
            CreateSargonMemberRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateSargonMemberRequestBody)
                    return object;
                let message = new $root.api.external.CreateSargonMemberRequestBody();
                if (object.tfn != null)
                    message.tfn = String(object.tfn);
                switch (object.gender) {
                case "UNKNOWN":
                case 0:
                    message.gender = 0;
                    break;
                case "UNSPECIFIED":
                case 1:
                    message.gender = 1;
                    break;
                case "MALE":
                case 2:
                    message.gender = 2;
                    break;
                case "FEMALE":
                case 3:
                    message.gender = 3;
                    break;
                }
                if (object.documents_accepted_at != null)
                    message.documents_accepted_at = String(object.documents_accepted_at);
                return message;
            };

            /**
             * Creates a plain object from a CreateSargonMemberRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateSargonMemberRequestBody
             * @static
             * @param {api.external.CreateSargonMemberRequestBody} message CreateSargonMemberRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSargonMemberRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.tfn = "";
                    object.gender = options.enums === String ? "UNKNOWN" : 0;
                    object.documents_accepted_at = "";
                }
                if (message.tfn != null && message.hasOwnProperty("tfn"))
                    object.tfn = message.tfn;
                if (message.gender != null && message.hasOwnProperty("gender"))
                    object.gender = options.enums === String ? $root.Gender.Enum[message.gender] : message.gender;
                if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at"))
                    object.documents_accepted_at = message.documents_accepted_at;
                return object;
            };

            /**
             * Converts this CreateSargonMemberRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateSargonMemberRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSargonMemberRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateSargonMemberRequestBody;
        })();

        external.CreateSargonMemberResponseBody = (function() {

            /**
             * Properties of a CreateSargonMemberResponseBody.
             * @memberof api.external
             * @interface ICreateSargonMemberResponseBody
             */

            /**
             * Constructs a new CreateSargonMemberResponseBody.
             * @memberof api.external
             * @classdesc Represents a CreateSargonMemberResponseBody.
             * @implements ICreateSargonMemberResponseBody
             * @constructor
             * @param {api.external.ICreateSargonMemberResponseBody=} [properties] Properties to set
             */
            function CreateSargonMemberResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new CreateSargonMemberResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.CreateSargonMemberResponseBody
             * @static
             * @param {api.external.ICreateSargonMemberResponseBody=} [properties] Properties to set
             * @returns {api.external.CreateSargonMemberResponseBody} CreateSargonMemberResponseBody instance
             */
            CreateSargonMemberResponseBody.create = function create(properties) {
                return new CreateSargonMemberResponseBody(properties);
            };

            /**
             * Encodes the specified CreateSargonMemberResponseBody message. Does not implicitly {@link api.external.CreateSargonMemberResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.CreateSargonMemberResponseBody
             * @static
             * @param {api.external.ICreateSargonMemberResponseBody} message CreateSargonMemberResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSargonMemberResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified CreateSargonMemberResponseBody message, length delimited. Does not implicitly {@link api.external.CreateSargonMemberResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.CreateSargonMemberResponseBody
             * @static
             * @param {api.external.ICreateSargonMemberResponseBody} message CreateSargonMemberResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateSargonMemberResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateSargonMemberResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.CreateSargonMemberResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.CreateSargonMemberResponseBody} CreateSargonMemberResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSargonMemberResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.CreateSargonMemberResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateSargonMemberResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.CreateSargonMemberResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.CreateSargonMemberResponseBody} CreateSargonMemberResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateSargonMemberResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateSargonMemberResponseBody message.
             * @function verify
             * @memberof api.external.CreateSargonMemberResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateSargonMemberResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a CreateSargonMemberResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.CreateSargonMemberResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.CreateSargonMemberResponseBody} CreateSargonMemberResponseBody
             */
            CreateSargonMemberResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.CreateSargonMemberResponseBody)
                    return object;
                return new $root.api.external.CreateSargonMemberResponseBody();
            };

            /**
             * Creates a plain object from a CreateSargonMemberResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.CreateSargonMemberResponseBody
             * @static
             * @param {api.external.CreateSargonMemberResponseBody} message CreateSargonMemberResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateSargonMemberResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this CreateSargonMemberResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.CreateSargonMemberResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateSargonMemberResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateSargonMemberResponseBody;
        })();

        external.RecordSuperMatchConsentRequestBody = (function() {

            /**
             * Properties of a RecordSuperMatchConsentRequestBody.
             * @memberof api.external
             * @interface IRecordSuperMatchConsentRequestBody
             */

            /**
             * Constructs a new RecordSuperMatchConsentRequestBody.
             * @memberof api.external
             * @classdesc Represents a RecordSuperMatchConsentRequestBody.
             * @implements IRecordSuperMatchConsentRequestBody
             * @constructor
             * @param {api.external.IRecordSuperMatchConsentRequestBody=} [properties] Properties to set
             */
            function RecordSuperMatchConsentRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RecordSuperMatchConsentRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @static
             * @param {api.external.IRecordSuperMatchConsentRequestBody=} [properties] Properties to set
             * @returns {api.external.RecordSuperMatchConsentRequestBody} RecordSuperMatchConsentRequestBody instance
             */
            RecordSuperMatchConsentRequestBody.create = function create(properties) {
                return new RecordSuperMatchConsentRequestBody(properties);
            };

            /**
             * Encodes the specified RecordSuperMatchConsentRequestBody message. Does not implicitly {@link api.external.RecordSuperMatchConsentRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @static
             * @param {api.external.IRecordSuperMatchConsentRequestBody} message RecordSuperMatchConsentRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RecordSuperMatchConsentRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RecordSuperMatchConsentRequestBody message, length delimited. Does not implicitly {@link api.external.RecordSuperMatchConsentRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @static
             * @param {api.external.IRecordSuperMatchConsentRequestBody} message RecordSuperMatchConsentRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RecordSuperMatchConsentRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RecordSuperMatchConsentRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.RecordSuperMatchConsentRequestBody} RecordSuperMatchConsentRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RecordSuperMatchConsentRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.RecordSuperMatchConsentRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RecordSuperMatchConsentRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.RecordSuperMatchConsentRequestBody} RecordSuperMatchConsentRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RecordSuperMatchConsentRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RecordSuperMatchConsentRequestBody message.
             * @function verify
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RecordSuperMatchConsentRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RecordSuperMatchConsentRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.RecordSuperMatchConsentRequestBody} RecordSuperMatchConsentRequestBody
             */
            RecordSuperMatchConsentRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.RecordSuperMatchConsentRequestBody)
                    return object;
                return new $root.api.external.RecordSuperMatchConsentRequestBody();
            };

            /**
             * Creates a plain object from a RecordSuperMatchConsentRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @static
             * @param {api.external.RecordSuperMatchConsentRequestBody} message RecordSuperMatchConsentRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RecordSuperMatchConsentRequestBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RecordSuperMatchConsentRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.RecordSuperMatchConsentRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RecordSuperMatchConsentRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return RecordSuperMatchConsentRequestBody;
        })();

        external.RecordSuperMatchConsentResponseBody = (function() {

            /**
             * Properties of a RecordSuperMatchConsentResponseBody.
             * @memberof api.external
             * @interface IRecordSuperMatchConsentResponseBody
             */

            /**
             * Constructs a new RecordSuperMatchConsentResponseBody.
             * @memberof api.external
             * @classdesc Represents a RecordSuperMatchConsentResponseBody.
             * @implements IRecordSuperMatchConsentResponseBody
             * @constructor
             * @param {api.external.IRecordSuperMatchConsentResponseBody=} [properties] Properties to set
             */
            function RecordSuperMatchConsentResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RecordSuperMatchConsentResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @static
             * @param {api.external.IRecordSuperMatchConsentResponseBody=} [properties] Properties to set
             * @returns {api.external.RecordSuperMatchConsentResponseBody} RecordSuperMatchConsentResponseBody instance
             */
            RecordSuperMatchConsentResponseBody.create = function create(properties) {
                return new RecordSuperMatchConsentResponseBody(properties);
            };

            /**
             * Encodes the specified RecordSuperMatchConsentResponseBody message. Does not implicitly {@link api.external.RecordSuperMatchConsentResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @static
             * @param {api.external.IRecordSuperMatchConsentResponseBody} message RecordSuperMatchConsentResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RecordSuperMatchConsentResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RecordSuperMatchConsentResponseBody message, length delimited. Does not implicitly {@link api.external.RecordSuperMatchConsentResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @static
             * @param {api.external.IRecordSuperMatchConsentResponseBody} message RecordSuperMatchConsentResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RecordSuperMatchConsentResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RecordSuperMatchConsentResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.RecordSuperMatchConsentResponseBody} RecordSuperMatchConsentResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RecordSuperMatchConsentResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.RecordSuperMatchConsentResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RecordSuperMatchConsentResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.RecordSuperMatchConsentResponseBody} RecordSuperMatchConsentResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RecordSuperMatchConsentResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RecordSuperMatchConsentResponseBody message.
             * @function verify
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RecordSuperMatchConsentResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a RecordSuperMatchConsentResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.RecordSuperMatchConsentResponseBody} RecordSuperMatchConsentResponseBody
             */
            RecordSuperMatchConsentResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.RecordSuperMatchConsentResponseBody)
                    return object;
                return new $root.api.external.RecordSuperMatchConsentResponseBody();
            };

            /**
             * Creates a plain object from a RecordSuperMatchConsentResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @static
             * @param {api.external.RecordSuperMatchConsentResponseBody} message RecordSuperMatchConsentResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RecordSuperMatchConsentResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RecordSuperMatchConsentResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.RecordSuperMatchConsentResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RecordSuperMatchConsentResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return RecordSuperMatchConsentResponseBody;
        })();

        external.VerifyContactRequestBody = (function() {

            /**
             * Properties of a VerifyContactRequestBody.
             * @memberof api.external
             * @interface IVerifyContactRequestBody
             * @property {GreenIdRuleSet.Enum|null} [rule_set] VerifyContactRequestBody rule_set
             */

            /**
             * Constructs a new VerifyContactRequestBody.
             * @memberof api.external
             * @classdesc Represents a VerifyContactRequestBody.
             * @implements IVerifyContactRequestBody
             * @constructor
             * @param {api.external.IVerifyContactRequestBody=} [properties] Properties to set
             */
            function VerifyContactRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * VerifyContactRequestBody rule_set.
             * @member {GreenIdRuleSet.Enum} rule_set
             * @memberof api.external.VerifyContactRequestBody
             * @instance
             */
            VerifyContactRequestBody.prototype.rule_set = 0;

            /**
             * Creates a new VerifyContactRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.VerifyContactRequestBody
             * @static
             * @param {api.external.IVerifyContactRequestBody=} [properties] Properties to set
             * @returns {api.external.VerifyContactRequestBody} VerifyContactRequestBody instance
             */
            VerifyContactRequestBody.create = function create(properties) {
                return new VerifyContactRequestBody(properties);
            };

            /**
             * Encodes the specified VerifyContactRequestBody message. Does not implicitly {@link api.external.VerifyContactRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.VerifyContactRequestBody
             * @static
             * @param {api.external.IVerifyContactRequestBody} message VerifyContactRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyContactRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.rule_set != null && message.hasOwnProperty("rule_set"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.rule_set);
                return writer;
            };

            /**
             * Encodes the specified VerifyContactRequestBody message, length delimited. Does not implicitly {@link api.external.VerifyContactRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.VerifyContactRequestBody
             * @static
             * @param {api.external.IVerifyContactRequestBody} message VerifyContactRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            VerifyContactRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a VerifyContactRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.VerifyContactRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.VerifyContactRequestBody} VerifyContactRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyContactRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.VerifyContactRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.rule_set = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a VerifyContactRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.VerifyContactRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.VerifyContactRequestBody} VerifyContactRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            VerifyContactRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a VerifyContactRequestBody message.
             * @function verify
             * @memberof api.external.VerifyContactRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            VerifyContactRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.rule_set != null && message.hasOwnProperty("rule_set"))
                    switch (message.rule_set) {
                    default:
                        return "rule_set: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a VerifyContactRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.VerifyContactRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.VerifyContactRequestBody} VerifyContactRequestBody
             */
            VerifyContactRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.VerifyContactRequestBody)
                    return object;
                let message = new $root.api.external.VerifyContactRequestBody();
                switch (object.rule_set) {
                case "UNKNOWN":
                case 0:
                    message.rule_set = 0;
                    break;
                case "VOYAGER_ONBOARDING":
                case 1:
                    message.rule_set = 1;
                    break;
                case "SUPERMATCH":
                case 2:
                    message.rule_set = 2;
                    break;
                case "NOVA":
                case 3:
                    message.rule_set = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a VerifyContactRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.VerifyContactRequestBody
             * @static
             * @param {api.external.VerifyContactRequestBody} message VerifyContactRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            VerifyContactRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.rule_set = options.enums === String ? "UNKNOWN" : 0;
                if (message.rule_set != null && message.hasOwnProperty("rule_set"))
                    object.rule_set = options.enums === String ? $root.GreenIdRuleSet.Enum[message.rule_set] : message.rule_set;
                return object;
            };

            /**
             * Converts this VerifyContactRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.VerifyContactRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            VerifyContactRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return VerifyContactRequestBody;
        })();

        external.GetFeatureFlagsResponseBody = (function() {

            /**
             * Properties of a GetFeatureFlagsResponseBody.
             * @memberof api.external
             * @interface IGetFeatureFlagsResponseBody
             * @property {Object.<string,boolean>|null} [feature_flags] GetFeatureFlagsResponseBody feature_flags
             */

            /**
             * Constructs a new GetFeatureFlagsResponseBody.
             * @memberof api.external
             * @classdesc Represents a GetFeatureFlagsResponseBody.
             * @implements IGetFeatureFlagsResponseBody
             * @constructor
             * @param {api.external.IGetFeatureFlagsResponseBody=} [properties] Properties to set
             */
            function GetFeatureFlagsResponseBody(properties) {
                this.feature_flags = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetFeatureFlagsResponseBody feature_flags.
             * @member {Object.<string,boolean>} feature_flags
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @instance
             */
            GetFeatureFlagsResponseBody.prototype.feature_flags = $util.emptyObject;

            /**
             * Creates a new GetFeatureFlagsResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @static
             * @param {api.external.IGetFeatureFlagsResponseBody=} [properties] Properties to set
             * @returns {api.external.GetFeatureFlagsResponseBody} GetFeatureFlagsResponseBody instance
             */
            GetFeatureFlagsResponseBody.create = function create(properties) {
                return new GetFeatureFlagsResponseBody(properties);
            };

            /**
             * Encodes the specified GetFeatureFlagsResponseBody message. Does not implicitly {@link api.external.GetFeatureFlagsResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @static
             * @param {api.external.IGetFeatureFlagsResponseBody} message GetFeatureFlagsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetFeatureFlagsResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.feature_flags != null && message.hasOwnProperty("feature_flags"))
                    for (let keys = Object.keys(message.feature_flags), i = 0; i < keys.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).bool(message.feature_flags[keys[i]]).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetFeatureFlagsResponseBody message, length delimited. Does not implicitly {@link api.external.GetFeatureFlagsResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @static
             * @param {api.external.IGetFeatureFlagsResponseBody} message GetFeatureFlagsResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetFeatureFlagsResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetFeatureFlagsResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.GetFeatureFlagsResponseBody} GetFeatureFlagsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetFeatureFlagsResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.GetFeatureFlagsResponseBody(), key;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        reader.skip().pos++;
                        if (message.feature_flags === $util.emptyObject)
                            message.feature_flags = {};
                        key = reader.string();
                        reader.pos++;
                        message.feature_flags[key] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetFeatureFlagsResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.GetFeatureFlagsResponseBody} GetFeatureFlagsResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetFeatureFlagsResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetFeatureFlagsResponseBody message.
             * @function verify
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetFeatureFlagsResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.feature_flags != null && message.hasOwnProperty("feature_flags")) {
                    if (!$util.isObject(message.feature_flags))
                        return "feature_flags: object expected";
                    let key = Object.keys(message.feature_flags);
                    for (let i = 0; i < key.length; ++i)
                        if (typeof message.feature_flags[key[i]] !== "boolean")
                            return "feature_flags: boolean{k:string} expected";
                }
                return null;
            };

            /**
             * Creates a GetFeatureFlagsResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.GetFeatureFlagsResponseBody} GetFeatureFlagsResponseBody
             */
            GetFeatureFlagsResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.GetFeatureFlagsResponseBody)
                    return object;
                let message = new $root.api.external.GetFeatureFlagsResponseBody();
                if (object.feature_flags) {
                    if (typeof object.feature_flags !== "object")
                        throw TypeError(".api.external.GetFeatureFlagsResponseBody.feature_flags: object expected");
                    message.feature_flags = {};
                    for (let keys = Object.keys(object.feature_flags), i = 0; i < keys.length; ++i)
                        message.feature_flags[keys[i]] = Boolean(object.feature_flags[keys[i]]);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetFeatureFlagsResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @static
             * @param {api.external.GetFeatureFlagsResponseBody} message GetFeatureFlagsResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetFeatureFlagsResponseBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.objects || options.defaults)
                    object.feature_flags = {};
                let keys2;
                if (message.feature_flags && (keys2 = Object.keys(message.feature_flags)).length) {
                    object.feature_flags = {};
                    for (let j = 0; j < keys2.length; ++j)
                        object.feature_flags[keys2[j]] = message.feature_flags[keys2[j]];
                }
                return object;
            };

            /**
             * Converts this GetFeatureFlagsResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.GetFeatureFlagsResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetFeatureFlagsResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetFeatureFlagsResponseBody;
        })();

        external.MigrateSuperWebUserRequestBody = (function() {

            /**
             * Properties of a MigrateSuperWebUserRequestBody.
             * @memberof api.external
             * @interface IMigrateSuperWebUserRequestBody
             * @property {string|null} [cognito_access_token] MigrateSuperWebUserRequestBody cognito_access_token
             * @property {string|null} [password] MigrateSuperWebUserRequestBody password
             * @property {string|null} [lead_utm_source] MigrateSuperWebUserRequestBody lead_utm_source
             */

            /**
             * Constructs a new MigrateSuperWebUserRequestBody.
             * @memberof api.external
             * @classdesc Represents a MigrateSuperWebUserRequestBody.
             * @implements IMigrateSuperWebUserRequestBody
             * @constructor
             * @param {api.external.IMigrateSuperWebUserRequestBody=} [properties] Properties to set
             */
            function MigrateSuperWebUserRequestBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MigrateSuperWebUserRequestBody cognito_access_token.
             * @member {string} cognito_access_token
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @instance
             */
            MigrateSuperWebUserRequestBody.prototype.cognito_access_token = "";

            /**
             * MigrateSuperWebUserRequestBody password.
             * @member {string} password
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @instance
             */
            MigrateSuperWebUserRequestBody.prototype.password = "";

            /**
             * MigrateSuperWebUserRequestBody lead_utm_source.
             * @member {string} lead_utm_source
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @instance
             */
            MigrateSuperWebUserRequestBody.prototype.lead_utm_source = "";

            /**
             * Creates a new MigrateSuperWebUserRequestBody instance using the specified properties.
             * @function create
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @static
             * @param {api.external.IMigrateSuperWebUserRequestBody=} [properties] Properties to set
             * @returns {api.external.MigrateSuperWebUserRequestBody} MigrateSuperWebUserRequestBody instance
             */
            MigrateSuperWebUserRequestBody.create = function create(properties) {
                return new MigrateSuperWebUserRequestBody(properties);
            };

            /**
             * Encodes the specified MigrateSuperWebUserRequestBody message. Does not implicitly {@link api.external.MigrateSuperWebUserRequestBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @static
             * @param {api.external.IMigrateSuperWebUserRequestBody} message MigrateSuperWebUserRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MigrateSuperWebUserRequestBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.cognito_access_token != null && message.hasOwnProperty("cognito_access_token"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.cognito_access_token);
                if (message.password != null && message.hasOwnProperty("password"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
                if (message.lead_utm_source != null && message.hasOwnProperty("lead_utm_source"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.lead_utm_source);
                return writer;
            };

            /**
             * Encodes the specified MigrateSuperWebUserRequestBody message, length delimited. Does not implicitly {@link api.external.MigrateSuperWebUserRequestBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @static
             * @param {api.external.IMigrateSuperWebUserRequestBody} message MigrateSuperWebUserRequestBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MigrateSuperWebUserRequestBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MigrateSuperWebUserRequestBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.MigrateSuperWebUserRequestBody} MigrateSuperWebUserRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MigrateSuperWebUserRequestBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.MigrateSuperWebUserRequestBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.cognito_access_token = reader.string();
                        break;
                    case 2:
                        message.password = reader.string();
                        break;
                    case 3:
                        message.lead_utm_source = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MigrateSuperWebUserRequestBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.MigrateSuperWebUserRequestBody} MigrateSuperWebUserRequestBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MigrateSuperWebUserRequestBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MigrateSuperWebUserRequestBody message.
             * @function verify
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MigrateSuperWebUserRequestBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.cognito_access_token != null && message.hasOwnProperty("cognito_access_token"))
                    if (!$util.isString(message.cognito_access_token))
                        return "cognito_access_token: string expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!$util.isString(message.password))
                        return "password: string expected";
                if (message.lead_utm_source != null && message.hasOwnProperty("lead_utm_source"))
                    if (!$util.isString(message.lead_utm_source))
                        return "lead_utm_source: string expected";
                return null;
            };

            /**
             * Creates a MigrateSuperWebUserRequestBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.MigrateSuperWebUserRequestBody} MigrateSuperWebUserRequestBody
             */
            MigrateSuperWebUserRequestBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.MigrateSuperWebUserRequestBody)
                    return object;
                let message = new $root.api.external.MigrateSuperWebUserRequestBody();
                if (object.cognito_access_token != null)
                    message.cognito_access_token = String(object.cognito_access_token);
                if (object.password != null)
                    message.password = String(object.password);
                if (object.lead_utm_source != null)
                    message.lead_utm_source = String(object.lead_utm_source);
                return message;
            };

            /**
             * Creates a plain object from a MigrateSuperWebUserRequestBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @static
             * @param {api.external.MigrateSuperWebUserRequestBody} message MigrateSuperWebUserRequestBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MigrateSuperWebUserRequestBody.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.cognito_access_token = "";
                    object.password = "";
                    object.lead_utm_source = "";
                }
                if (message.cognito_access_token != null && message.hasOwnProperty("cognito_access_token"))
                    object.cognito_access_token = message.cognito_access_token;
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = message.password;
                if (message.lead_utm_source != null && message.hasOwnProperty("lead_utm_source"))
                    object.lead_utm_source = message.lead_utm_source;
                return object;
            };

            /**
             * Converts this MigrateSuperWebUserRequestBody to JSON.
             * @function toJSON
             * @memberof api.external.MigrateSuperWebUserRequestBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MigrateSuperWebUserRequestBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MigrateSuperWebUserRequestBody;
        })();

        external.MigrateSuperWebUserResponseBody = (function() {

            /**
             * Properties of a MigrateSuperWebUserResponseBody.
             * @memberof api.external
             * @interface IMigrateSuperWebUserResponseBody
             */

            /**
             * Constructs a new MigrateSuperWebUserResponseBody.
             * @memberof api.external
             * @classdesc Represents a MigrateSuperWebUserResponseBody.
             * @implements IMigrateSuperWebUserResponseBody
             * @constructor
             * @param {api.external.IMigrateSuperWebUserResponseBody=} [properties] Properties to set
             */
            function MigrateSuperWebUserResponseBody(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new MigrateSuperWebUserResponseBody instance using the specified properties.
             * @function create
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @static
             * @param {api.external.IMigrateSuperWebUserResponseBody=} [properties] Properties to set
             * @returns {api.external.MigrateSuperWebUserResponseBody} MigrateSuperWebUserResponseBody instance
             */
            MigrateSuperWebUserResponseBody.create = function create(properties) {
                return new MigrateSuperWebUserResponseBody(properties);
            };

            /**
             * Encodes the specified MigrateSuperWebUserResponseBody message. Does not implicitly {@link api.external.MigrateSuperWebUserResponseBody.verify|verify} messages.
             * @function encode
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @static
             * @param {api.external.IMigrateSuperWebUserResponseBody} message MigrateSuperWebUserResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MigrateSuperWebUserResponseBody.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified MigrateSuperWebUserResponseBody message, length delimited. Does not implicitly {@link api.external.MigrateSuperWebUserResponseBody.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @static
             * @param {api.external.IMigrateSuperWebUserResponseBody} message MigrateSuperWebUserResponseBody message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MigrateSuperWebUserResponseBody.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MigrateSuperWebUserResponseBody message from the specified reader or buffer.
             * @function decode
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.external.MigrateSuperWebUserResponseBody} MigrateSuperWebUserResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MigrateSuperWebUserResponseBody.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.external.MigrateSuperWebUserResponseBody();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MigrateSuperWebUserResponseBody message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.external.MigrateSuperWebUserResponseBody} MigrateSuperWebUserResponseBody
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MigrateSuperWebUserResponseBody.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MigrateSuperWebUserResponseBody message.
             * @function verify
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MigrateSuperWebUserResponseBody.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a MigrateSuperWebUserResponseBody message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.external.MigrateSuperWebUserResponseBody} MigrateSuperWebUserResponseBody
             */
            MigrateSuperWebUserResponseBody.fromObject = function fromObject(object) {
                if (object instanceof $root.api.external.MigrateSuperWebUserResponseBody)
                    return object;
                return new $root.api.external.MigrateSuperWebUserResponseBody();
            };

            /**
             * Creates a plain object from a MigrateSuperWebUserResponseBody message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @static
             * @param {api.external.MigrateSuperWebUserResponseBody} message MigrateSuperWebUserResponseBody
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MigrateSuperWebUserResponseBody.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this MigrateSuperWebUserResponseBody to JSON.
             * @function toJSON
             * @memberof api.external.MigrateSuperWebUserResponseBody
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MigrateSuperWebUserResponseBody.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MigrateSuperWebUserResponseBody;
        })();

        return external;
    })();

    return api;
})();

export const CronRequest = $root.CronRequest = (() => {

    /**
     * Properties of a CronRequest.
     * @exports ICronRequest
     * @interface ICronRequest
     */

    /**
     * Constructs a new CronRequest.
     * @exports CronRequest
     * @classdesc Represents a CronRequest.
     * @implements ICronRequest
     * @constructor
     * @param {ICronRequest=} [properties] Properties to set
     */
    function CronRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new CronRequest instance using the specified properties.
     * @function create
     * @memberof CronRequest
     * @static
     * @param {ICronRequest=} [properties] Properties to set
     * @returns {CronRequest} CronRequest instance
     */
    CronRequest.create = function create(properties) {
        return new CronRequest(properties);
    };

    /**
     * Encodes the specified CronRequest message. Does not implicitly {@link CronRequest.verify|verify} messages.
     * @function encode
     * @memberof CronRequest
     * @static
     * @param {ICronRequest} message CronRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CronRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified CronRequest message, length delimited. Does not implicitly {@link CronRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CronRequest
     * @static
     * @param {ICronRequest} message CronRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CronRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CronRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CronRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CronRequest} CronRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CronRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CronRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CronRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CronRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CronRequest} CronRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CronRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CronRequest message.
     * @function verify
     * @memberof CronRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CronRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a CronRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CronRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CronRequest} CronRequest
     */
    CronRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CronRequest)
            return object;
        return new $root.CronRequest();
    };

    /**
     * Creates a plain object from a CronRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CronRequest
     * @static
     * @param {CronRequest} message CronRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CronRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this CronRequest to JSON.
     * @function toJSON
     * @memberof CronRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CronRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CronRequest;
})();

export const CronResponse = $root.CronResponse = (() => {

    /**
     * Properties of a CronResponse.
     * @exports ICronResponse
     * @interface ICronResponse
     * @property {number|null} [processed] CronResponse processed
     */

    /**
     * Constructs a new CronResponse.
     * @exports CronResponse
     * @classdesc Represents a CronResponse.
     * @implements ICronResponse
     * @constructor
     * @param {ICronResponse=} [properties] Properties to set
     */
    function CronResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CronResponse processed.
     * @member {number} processed
     * @memberof CronResponse
     * @instance
     */
    CronResponse.prototype.processed = 0;

    /**
     * Creates a new CronResponse instance using the specified properties.
     * @function create
     * @memberof CronResponse
     * @static
     * @param {ICronResponse=} [properties] Properties to set
     * @returns {CronResponse} CronResponse instance
     */
    CronResponse.create = function create(properties) {
        return new CronResponse(properties);
    };

    /**
     * Encodes the specified CronResponse message. Does not implicitly {@link CronResponse.verify|verify} messages.
     * @function encode
     * @memberof CronResponse
     * @static
     * @param {ICronResponse} message CronResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CronResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.processed != null && message.hasOwnProperty("processed"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.processed);
        return writer;
    };

    /**
     * Encodes the specified CronResponse message, length delimited. Does not implicitly {@link CronResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CronResponse
     * @static
     * @param {ICronResponse} message CronResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CronResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CronResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CronResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CronResponse} CronResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CronResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CronResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.processed = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CronResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CronResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CronResponse} CronResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CronResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CronResponse message.
     * @function verify
     * @memberof CronResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CronResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.processed != null && message.hasOwnProperty("processed"))
            if (!$util.isInteger(message.processed))
                return "processed: integer expected";
        return null;
    };

    /**
     * Creates a CronResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CronResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CronResponse} CronResponse
     */
    CronResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CronResponse)
            return object;
        let message = new $root.CronResponse();
        if (object.processed != null)
            message.processed = object.processed | 0;
        return message;
    };

    /**
     * Creates a plain object from a CronResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CronResponse
     * @static
     * @param {CronResponse} message CronResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CronResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.processed = 0;
        if (message.processed != null && message.hasOwnProperty("processed"))
            object.processed = message.processed;
        return object;
    };

    /**
     * Converts this CronResponse to JSON.
     * @function toJSON
     * @memberof CronResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CronResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CronResponse;
})();

export const ContactStatus = $root.ContactStatus = (() => {

    /**
     * Properties of a ContactStatus.
     * @exports IContactStatus
     * @interface IContactStatus
     */

    /**
     * Constructs a new ContactStatus.
     * @exports ContactStatus
     * @classdesc Represents a ContactStatus.
     * @implements IContactStatus
     * @constructor
     * @param {IContactStatus=} [properties] Properties to set
     */
    function ContactStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new ContactStatus instance using the specified properties.
     * @function create
     * @memberof ContactStatus
     * @static
     * @param {IContactStatus=} [properties] Properties to set
     * @returns {ContactStatus} ContactStatus instance
     */
    ContactStatus.create = function create(properties) {
        return new ContactStatus(properties);
    };

    /**
     * Encodes the specified ContactStatus message. Does not implicitly {@link ContactStatus.verify|verify} messages.
     * @function encode
     * @memberof ContactStatus
     * @static
     * @param {IContactStatus} message ContactStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContactStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified ContactStatus message, length delimited. Does not implicitly {@link ContactStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ContactStatus
     * @static
     * @param {IContactStatus} message ContactStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContactStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ContactStatus message from the specified reader or buffer.
     * @function decode
     * @memberof ContactStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContactStatus} ContactStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContactStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ContactStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ContactStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ContactStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ContactStatus} ContactStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContactStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ContactStatus message.
     * @function verify
     * @memberof ContactStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ContactStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a ContactStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ContactStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ContactStatus} ContactStatus
     */
    ContactStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.ContactStatus)
            return object;
        return new $root.ContactStatus();
    };

    /**
     * Creates a plain object from a ContactStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ContactStatus
     * @static
     * @param {ContactStatus} message ContactStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContactStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this ContactStatus to JSON.
     * @function toJSON
     * @memberof ContactStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContactStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name ContactStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} CLOSED=1 CLOSED value
     * @property {number} ACTIVE=2 ACTIVE value
     * @property {number} PENDING=3 PENDING value
     * @property {number} BLOCKED=4 BLOCKED value
     */
    ContactStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "CLOSED"] = 1;
        values[valuesById[2] = "ACTIVE"] = 2;
        values[valuesById[3] = "PENDING"] = 3;
        values[valuesById[4] = "BLOCKED"] = 4;
        return values;
    })();

    return ContactStatus;
})();

export const EmailTemplate = $root.EmailTemplate = (() => {

    /**
     * Properties of an EmailTemplate.
     * @exports IEmailTemplate
     * @interface IEmailTemplate
     */

    /**
     * Constructs a new EmailTemplate.
     * @exports EmailTemplate
     * @classdesc Represents an EmailTemplate.
     * @implements IEmailTemplate
     * @constructor
     * @param {IEmailTemplate=} [properties] Properties to set
     */
    function EmailTemplate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new EmailTemplate instance using the specified properties.
     * @function create
     * @memberof EmailTemplate
     * @static
     * @param {IEmailTemplate=} [properties] Properties to set
     * @returns {EmailTemplate} EmailTemplate instance
     */
    EmailTemplate.create = function create(properties) {
        return new EmailTemplate(properties);
    };

    /**
     * Encodes the specified EmailTemplate message. Does not implicitly {@link EmailTemplate.verify|verify} messages.
     * @function encode
     * @memberof EmailTemplate
     * @static
     * @param {IEmailTemplate} message EmailTemplate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EmailTemplate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified EmailTemplate message, length delimited. Does not implicitly {@link EmailTemplate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EmailTemplate
     * @static
     * @param {IEmailTemplate} message EmailTemplate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EmailTemplate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an EmailTemplate message from the specified reader or buffer.
     * @function decode
     * @memberof EmailTemplate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EmailTemplate} EmailTemplate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EmailTemplate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmailTemplate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an EmailTemplate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EmailTemplate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EmailTemplate} EmailTemplate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EmailTemplate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an EmailTemplate message.
     * @function verify
     * @memberof EmailTemplate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EmailTemplate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an EmailTemplate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EmailTemplate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EmailTemplate} EmailTemplate
     */
    EmailTemplate.fromObject = function fromObject(object) {
        if (object instanceof $root.EmailTemplate)
            return object;
        return new $root.EmailTemplate();
    };

    /**
     * Creates a plain object from an EmailTemplate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EmailTemplate
     * @static
     * @param {EmailTemplate} message EmailTemplate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EmailTemplate.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this EmailTemplate to JSON.
     * @function toJSON
     * @memberof EmailTemplate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EmailTemplate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name EmailTemplate.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} VOYAGER_WELCOME=1 VOYAGER_WELCOME value
     * @property {number} VOYAGER_ACCOUNT_CLOSURE=2 VOYAGER_ACCOUNT_CLOSURE value
     * @property {number} VOYAGER_CHARGEBACK=3 VOYAGER_CHARGEBACK value
     * @property {number} VOYAGER_GREENID_FAILURE=5 VOYAGER_GREENID_FAILURE value
     * @property {number} VOYAGER_GREENID_PASS=6 VOYAGER_GREENID_PASS value
     * @property {number} VOYAGER_RESET_PASSWORD=7 VOYAGER_RESET_PASSWORD value
     * @property {number} VOYAGER_PASSWORD_CHANGED=8 VOYAGER_PASSWORD_CHANGED value
     * @property {number} VOYAGER_ONE_OFF_DEPOSIT_MADE=9 VOYAGER_ONE_OFF_DEPOSIT_MADE value
     * @property {number} VOYAGER_SAVINGS_PLAN_ADDED=10 VOYAGER_SAVINGS_PLAN_ADDED value
     * @property {number} VOYAGER_SAVINGS_PLAN_CHANGED=11 VOYAGER_SAVINGS_PLAN_CHANGED value
     * @property {number} VOYAGER_SAVINGS_PLAN_STOPPED=12 VOYAGER_SAVINGS_PLAN_STOPPED value
     * @property {number} VOYAGER_WITHDRAWL_REQUEST=13 VOYAGER_WITHDRAWL_REQUEST value
     * @property {number} VOYAGER_VERIFY_EMAIL=14 VOYAGER_VERIFY_EMAIL value
     * @property {number} VOYAGER_FINANCIAL_REPORT_FY19=15 VOYAGER_FINANCIAL_REPORT_FY19 value
     * @property {number} VOYAGER_AMMA_STATEMENT_FY19=16 VOYAGER_AMMA_STATEMENT_FY19 value
     * @property {number} VOYAGER_UNIT_CONFIRMATION=17 VOYAGER_UNIT_CONFIRMATION value
     * @property {number} VOYAGER_PERIODIC_STATEMENT_FY19=18 VOYAGER_PERIODIC_STATEMENT_FY19 value
     * @property {number} VOYAGER_REFERRER_REFERRAL_SUCCESS=19 VOYAGER_REFERRER_REFERRAL_SUCCESS value
     * @property {number} VOYAGER_ACCOUNT_STATEMENT=20 VOYAGER_ACCOUNT_STATEMENT value
     * @property {number} VOYAGER_EXIT_STATEMENT=21 VOYAGER_EXIT_STATEMENT value
     * @property {number} VOYAGER_CLAWBACK_REMEDIATION_OPEN=22 VOYAGER_CLAWBACK_REMEDIATION_OPEN value
     * @property {number} VOYAGER_CLAWBACK_REMEDIATION_CLOSED=23 VOYAGER_CLAWBACK_REMEDIATION_CLOSED value
     * @property {number} VOYAGER_UNVERIFIED_BANK_ACCOUNT_REMINDER=24 VOYAGER_UNVERIFIED_BANK_ACCOUNT_REMINDER value
     * @property {number} VOYAGER_AMMA_STATEMENT_FY20=25 VOYAGER_AMMA_STATEMENT_FY20 value
     * @property {number} VOYAGER_PERIODIC_STATEMENT_FY20=26 VOYAGER_PERIODIC_STATEMENT_FY20 value
     * @property {number} VOYAGER_ACCOUNT_STATEMENT_V2=27 VOYAGER_ACCOUNT_STATEMENT_V2 value
     * @property {number} VOYAGER_EXIT_STATEMENT_V2=28 VOYAGER_EXIT_STATEMENT_V2 value
     * @property {number} VOYAGER_FINANCIAL_REPORT_FY20=29 VOYAGER_FINANCIAL_REPORT_FY20 value
     * @property {number} VOYAGER_BIOMETRIC_VERIFICATION_PASS=30 VOYAGER_BIOMETRIC_VERIFICATION_PASS value
     * @property {number} VOYAGER_BIOMETRIC_VERIFICATION_FAIL=31 VOYAGER_BIOMETRIC_VERIFICATION_FAIL value
     * @property {number} VOYAGER_BIOMETRIC_VERIFICATION_IN_REVIEW=32 VOYAGER_BIOMETRIC_VERIFICATION_IN_REVIEW value
     * @property {number} VOYAGER_SOURCE_ACCOUNT_MERGE_SUCCESSFUL=33 VOYAGER_SOURCE_ACCOUNT_MERGE_SUCCESSFUL value
     * @property {number} VOYAGER_SOURCE_ACCOUNT_MERGE_INITIATED=34 VOYAGER_SOURCE_ACCOUNT_MERGE_INITIATED value
     * @property {number} VOYAGER_DESTINATION_ACCOUNT_MERGE_SUCCESSFUL=35 VOYAGER_DESTINATION_ACCOUNT_MERGE_SUCCESSFUL value
     * @property {number} VOYAGER_DESTINATION_ACCOUNT_MERGE_INITIATED=36 VOYAGER_DESTINATION_ACCOUNT_MERGE_INITIATED value
     * @property {number} VOYAGER_AMMA_STATEMENT_FY21=37 VOYAGER_AMMA_STATEMENT_FY21 value
     * @property {number} VOYAGER_PERIODIC_STATEMENT_FY21=38 VOYAGER_PERIODIC_STATEMENT_FY21 value
     * @property {number} VOYAGER_FINANCIAL_REPORT_FY21=39 VOYAGER_FINANCIAL_REPORT_FY21 value
     * @property {number} VOYAGER_SOURCE_ACCOUNT_MERGE_UNSUCCESSFUL=40 VOYAGER_SOURCE_ACCOUNT_MERGE_UNSUCCESSFUL value
     * @property {number} VOYAGER_DESTINATION_ACCOUNT_MERGE_UNSUCCESSFUL=41 VOYAGER_DESTINATION_ACCOUNT_MERGE_UNSUCCESSFUL value
     * @property {number} VOYAGER_ACCOUNT_STATEMENT_V3=42 VOYAGER_ACCOUNT_STATEMENT_V3 value
     * @property {number} VOYAGER_EXIT_STATEMENT_V3=43 VOYAGER_EXIT_STATEMENT_V3 value
     * @property {number} VOYAGER_PAYMENT_PLAN_AUTO_CANCELLATION=44 VOYAGER_PAYMENT_PLAN_AUTO_CANCELLATION value
     * @property {number} VOYAGER_BOOSTS_AUTO_CANCELLATION=45 VOYAGER_BOOSTS_AUTO_CANCELLATION value
     * @property {number} VOYAGER_AMMA_STATEMENT_FY22=46 VOYAGER_AMMA_STATEMENT_FY22 value
     * @property {number} VOYAGER_PERIODIC_STATEMENT_FY22=47 VOYAGER_PERIODIC_STATEMENT_FY22 value
     * @property {number} VOYAGER_FAILED_ONEOFF_APPLICATION=48 VOYAGER_FAILED_ONEOFF_APPLICATION value
     * @property {number} VOYAGER_FAILED_INVESTMENT_PLAN_APPLICATION=49 VOYAGER_FAILED_INVESTMENT_PLAN_APPLICATION value
     * @property {number} VOYAGER_FAILED_BOOST_APPLICATION=50 VOYAGER_FAILED_BOOST_APPLICATION value
     * @property {number} VOYAGER_FAILED_REDEMPTION=51 VOYAGER_FAILED_REDEMPTION value
     * @property {number} VOYAGER_ACCOUNT_STATEMENT_V4=52 VOYAGER_ACCOUNT_STATEMENT_V4 value
     * @property {number} VOYAGER_EXIT_STATEMENT_V4=53 VOYAGER_EXIT_STATEMENT_V4 value
     * @property {number} VOYAGER_TMD_IN_REVIEW=54 VOYAGER_TMD_IN_REVIEW value
     * @property {number} VOYAGER_TMD_ONBOARDING_APPROVED=55 VOYAGER_TMD_ONBOARDING_APPROVED value
     * @property {number} VOYAGER_TMD_MULTIFUND_APPROVED=56 VOYAGER_TMD_MULTIFUND_APPROVED value
     * @property {number} VOYAGER_TMD_REJECTED=57 VOYAGER_TMD_REJECTED value
     * @property {number} VOYAGER_AMMA_STATEMENT_FY23=58 VOYAGER_AMMA_STATEMENT_FY23 value
     * @property {number} VOYAGER_PERIODIC_STATEMENT_FY23=59 VOYAGER_PERIODIC_STATEMENT_FY23 value
     * @property {number} VOYAGER_AMMA_STATEMENT_FY23_OVERSEAS_RESEND=60 VOYAGER_AMMA_STATEMENT_FY23_OVERSEAS_RESEND value
     * @property {number} VOYAGER_AMMA_STATEMENT_FY23_RESEND=61 VOYAGER_AMMA_STATEMENT_FY23_RESEND value
     * @property {number} VOYAGER_ACCOUNT_STATEMENT_V5=62 VOYAGER_ACCOUNT_STATEMENT_V5 value
     * @property {number} VOYAGER_EXIT_STATEMENT_V5=63 VOYAGER_EXIT_STATEMENT_V5 value
     * @property {number} VOYAGER_AMMA_STATEMENT_FY24=64 VOYAGER_AMMA_STATEMENT_FY24 value
     * @property {number} VOYAGER_PERIODIC_STATEMENT_FY24=65 VOYAGER_PERIODIC_STATEMENT_FY24 value
     * @property {number} VOYAGER_FINANCIAL_REPORT_FY24=66 VOYAGER_FINANCIAL_REPORT_FY24 value
     * @property {number} SUPER_SOFT_LINK=1000 SUPER_SOFT_LINK value
     * @property {number} SUPER_HARD_LINK=1001 SUPER_HARD_LINK value
     * @property {number} SUPER_EMPLOYER_CONTRIBUTION_DETAILS_TO_EMPLOYER=1002 SUPER_EMPLOYER_CONTRIBUTION_DETAILS_TO_EMPLOYER value
     * @property {number} SUPER_EMPLOYER_CONTRIBUTION_DETAILS_TO_SELF=1003 SUPER_EMPLOYER_CONTRIBUTION_DETAILS_TO_SELF value
     * @property {number} SUPER_ACCOUNT_VERIFICATION_REQUIRED=1004 SUPER_ACCOUNT_VERIFICATION_REQUIRED value
     * @property {number} SUPER_BINDING_BENEFICIARY_INTENT=1005 SUPER_BINDING_BENEFICIARY_INTENT value
     * @property {number} SUPER_TAX_DEDUCTION_LETTER=1006 SUPER_TAX_DEDUCTION_LETTER value
     * @property {number} PERSONAL_DETAILS_UPDATED=2000 PERSONAL_DETAILS_UPDATED value
     * @property {number} TAX_RESIDENCY_PROVIDE_TIN_PROMPT=2001 TAX_RESIDENCY_PROVIDE_TIN_PROMPT value
     * @property {number} MANUAL_MFA_VERIFICATIONS_GENERATED=2002 MANUAL_MFA_VERIFICATIONS_GENERATED value
     * @property {number} RESET_PASSWORD_CODE=2003 RESET_PASSWORD_CODE value
     * @property {number} VOYAGER_FEE_COMMS_INCIDENT_NOTIFY=3000 VOYAGER_FEE_COMMS_INCIDENT_NOTIFY value
     * @property {number} VOYAGER_ZEPTO_DIRECT_DEBIT_AGREEMENT_NOTIFY=3001 VOYAGER_ZEPTO_DIRECT_DEBIT_AGREEMENT_NOTIFY value
     * @property {number} VOYAGER_FINANCIAL_REPORT_FY22=3002 VOYAGER_FINANCIAL_REPORT_FY22 value
     * @property {number} VOYAGER_FEE_ANNOUNCEMENT_2023=3003 VOYAGER_FEE_ANNOUNCEMENT_2023 value
     * @property {number} VOYAGER_ORIGIN_PDS_UPDATE_JUN_2023=3004 VOYAGER_ORIGIN_PDS_UPDATE_JUN_2023 value
     * @property {number} VOYAGER_FAILED_DISTRIBUTION_PROMPT_ACTIVE_FY23=3005 VOYAGER_FAILED_DISTRIBUTION_PROMPT_ACTIVE_FY23 value
     * @property {number} VOYAGER_FAILED_DISTRIBUTION_PROMPT_CLOSED_FY23=3006 VOYAGER_FAILED_DISTRIBUTION_PROMPT_CLOSED_FY23 value
     * @property {number} NOVA_TERMS_AND_CONDITIONS_UPDATE_AUG_2023=3007 NOVA_TERMS_AND_CONDITIONS_UPDATE_AUG_2023 value
     * @property {number} NOVA_TERMS_AND_CONDITIONS_UPDATE_SEPT_2023=3008 NOVA_TERMS_AND_CONDITIONS_UPDATE_SEPT_2023 value
     * @property {number} VOYAGER_EARTH_PDS_UPDATE_SEPT_2023=3009 VOYAGER_EARTH_PDS_UPDATE_SEPT_2023 value
     * @property {number} NOVA_FEE_CHARGE_WARNING_SEPT_2023=3010 NOVA_FEE_CHARGE_WARNING_SEPT_2023 value
     * @property {number} VOYAGER_FINANCIAL_REPORT_FY23=3011 VOYAGER_FINANCIAL_REPORT_FY23 value
     * @property {number} VOYAGER_UPDATE_TAX_RESIDENCY_EMAIL_OCT_2023=3012 VOYAGER_UPDATE_TAX_RESIDENCY_EMAIL_OCT_2023 value
     * @property {number} NOVA_ROUNDING_REMEDIATION_OCT_2023=3013 NOVA_ROUNDING_REMEDIATION_OCT_2023 value
     * @property {number} MFA_NOTIFY_TURNING_ON_FOR_LOGIN=3014 MFA_NOTIFY_TURNING_ON_FOR_LOGIN value
     * @property {number} TAX_RESIDENCY_USA_PROVIDE_TIN_PROMPT_DEC_2023=3015 TAX_RESIDENCY_USA_PROVIDE_TIN_PROMPT_DEC_2023 value
     * @property {number} TAX_RESIDENCY_USA_CORRECT_TIN_PROMPT_DEC_2023=3016 TAX_RESIDENCY_USA_CORRECT_TIN_PROMPT_DEC_2023 value
     * @property {number} NOVA_INVESTMENT_PLAN_REMEDIATION_NOV_2023=3017 NOVA_INVESTMENT_PLAN_REMEDIATION_NOV_2023 value
     * @property {number} TAX_RESIDENCY_NON_USA_PROVIDE_TIN_PROMPT_DEC_2023=3018 TAX_RESIDENCY_NON_USA_PROVIDE_TIN_PROMPT_DEC_2023 value
     * @property {number} NOVA_TAF_CHANGE_NOTIFICATION_DEC_2023=3019 NOVA_TAF_CHANGE_NOTIFICATION_DEC_2023 value
     * @property {number} MFA_REQUIRED_NOTIFICATION=3020 MFA_REQUIRED_NOTIFICATION value
     * @property {number} FEE_ANNOUNCEMENT_2024=3021 FEE_ANNOUNCEMENT_2024 value
     * @property {number} NOVA_SEC_CHANGE_NOTIFICATION_MAY_2024=3022 NOVA_SEC_CHANGE_NOTIFICATION_MAY_2024 value
     * @property {number} VOYAGER_UNSENT_EXIT_STATEMENTS_NOTIFY_MAY_2024=3023 VOYAGER_UNSENT_EXIT_STATEMENTS_NOTIFY_MAY_2024 value
     * @property {number} TAX_RESIDENCY_USA_INVALID_TIN_PROMPT_DEC_2023=3024 TAX_RESIDENCY_USA_INVALID_TIN_PROMPT_DEC_2023 value
     * @property {number} ETORO_ANNOUNCEMENT=3025 ETORO_ANNOUNCEMENT value
     * @property {number} NOVA_DISCLOSURE_DOCUMENT_UPDATE_NOV_2024=3026 NOVA_DISCLOSURE_DOCUMENT_UPDATE_NOV_2024 value
     * @property {number} MONEY_PRE_LAUNCH_ANNOUNCEMENT=3027 MONEY_PRE_LAUNCH_ANNOUNCEMENT value
     * @property {number} MONEY_LAUNCH_ANNOUNCEMENT=3028 MONEY_LAUNCH_ANNOUNCEMENT value
     * @property {number} NOVA_BETA_FEE_WAIVER_ENDING_NOTIFICATION=3034 NOVA_BETA_FEE_WAIVER_ENDING_NOTIFICATION value
     * @property {number} NOVA_TRADE_CONFIRMATION=4000 NOVA_TRADE_CONFIRMATION value
     * @property {number} NOVA_ACCOUNT_STATEMENT=4001 NOVA_ACCOUNT_STATEMENT value
     * @property {number} NOVA_WELCOME=4002 NOVA_WELCOME value
     * @property {number} NOVA_APPLICATION_RECEIVED=4003 NOVA_APPLICATION_RECEIVED value
     * @property {number} NOVA_FEES_OUTSTANDING_REMINDER=4004 NOVA_FEES_OUTSTANDING_REMINDER value
     * @property {number} NOVA_FEES_FIRST_CHARGE_FAILED=4005 NOVA_FEES_FIRST_CHARGE_FAILED value
     * @property {number} NOVA_FEES_SUSPENDED=4006 NOVA_FEES_SUSPENDED value
     * @property {number} NOVA_FAILED_ONE_OFF_BUY_ORDER=4007 NOVA_FAILED_ONE_OFF_BUY_ORDER value
     * @property {number} NOVA_FAILED_INVESTMENT_PLAN_BUY_ORDER=4008 NOVA_FAILED_INVESTMENT_PLAN_BUY_ORDER value
     * @property {number} NOVA_INVALID_TAX_RESIDENCY_NOTIFICATION=4009 NOVA_INVALID_TAX_RESIDENCY_NOTIFICATION value
     * @property {number} NOVA_FAILED_PAYOUT=4010 NOVA_FAILED_PAYOUT value
     * @property {number} NOVA_MULTI_MONTH_STATEMENT=4011 NOVA_MULTI_MONTH_STATEMENT value
     * @property {number} MONEY_USER_DEPOSIT_SUCCESSFUL=5000 MONEY_USER_DEPOSIT_SUCCESSFUL value
     * @property {number} MONEY_USER_DEPOSIT_FAILED=5001 MONEY_USER_DEPOSIT_FAILED value
     * @property {number} MONEY_USER_WITHDRAWAL_SUCCESSFUL=5003 MONEY_USER_WITHDRAWAL_SUCCESSFUL value
     * @property {number} MONEY_USER_WITHDRAWAL_FAILED=5004 MONEY_USER_WITHDRAWAL_FAILED value
     */
    EmailTemplate.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "VOYAGER_WELCOME"] = 1;
        values[valuesById[2] = "VOYAGER_ACCOUNT_CLOSURE"] = 2;
        values[valuesById[3] = "VOYAGER_CHARGEBACK"] = 3;
        values[valuesById[5] = "VOYAGER_GREENID_FAILURE"] = 5;
        values[valuesById[6] = "VOYAGER_GREENID_PASS"] = 6;
        values[valuesById[7] = "VOYAGER_RESET_PASSWORD"] = 7;
        values[valuesById[8] = "VOYAGER_PASSWORD_CHANGED"] = 8;
        values[valuesById[9] = "VOYAGER_ONE_OFF_DEPOSIT_MADE"] = 9;
        values[valuesById[10] = "VOYAGER_SAVINGS_PLAN_ADDED"] = 10;
        values[valuesById[11] = "VOYAGER_SAVINGS_PLAN_CHANGED"] = 11;
        values[valuesById[12] = "VOYAGER_SAVINGS_PLAN_STOPPED"] = 12;
        values[valuesById[13] = "VOYAGER_WITHDRAWL_REQUEST"] = 13;
        values[valuesById[14] = "VOYAGER_VERIFY_EMAIL"] = 14;
        values[valuesById[15] = "VOYAGER_FINANCIAL_REPORT_FY19"] = 15;
        values[valuesById[16] = "VOYAGER_AMMA_STATEMENT_FY19"] = 16;
        values[valuesById[17] = "VOYAGER_UNIT_CONFIRMATION"] = 17;
        values[valuesById[18] = "VOYAGER_PERIODIC_STATEMENT_FY19"] = 18;
        values[valuesById[19] = "VOYAGER_REFERRER_REFERRAL_SUCCESS"] = 19;
        values[valuesById[20] = "VOYAGER_ACCOUNT_STATEMENT"] = 20;
        values[valuesById[21] = "VOYAGER_EXIT_STATEMENT"] = 21;
        values[valuesById[22] = "VOYAGER_CLAWBACK_REMEDIATION_OPEN"] = 22;
        values[valuesById[23] = "VOYAGER_CLAWBACK_REMEDIATION_CLOSED"] = 23;
        values[valuesById[24] = "VOYAGER_UNVERIFIED_BANK_ACCOUNT_REMINDER"] = 24;
        values[valuesById[25] = "VOYAGER_AMMA_STATEMENT_FY20"] = 25;
        values[valuesById[26] = "VOYAGER_PERIODIC_STATEMENT_FY20"] = 26;
        values[valuesById[27] = "VOYAGER_ACCOUNT_STATEMENT_V2"] = 27;
        values[valuesById[28] = "VOYAGER_EXIT_STATEMENT_V2"] = 28;
        values[valuesById[29] = "VOYAGER_FINANCIAL_REPORT_FY20"] = 29;
        values[valuesById[30] = "VOYAGER_BIOMETRIC_VERIFICATION_PASS"] = 30;
        values[valuesById[31] = "VOYAGER_BIOMETRIC_VERIFICATION_FAIL"] = 31;
        values[valuesById[32] = "VOYAGER_BIOMETRIC_VERIFICATION_IN_REVIEW"] = 32;
        values[valuesById[33] = "VOYAGER_SOURCE_ACCOUNT_MERGE_SUCCESSFUL"] = 33;
        values[valuesById[34] = "VOYAGER_SOURCE_ACCOUNT_MERGE_INITIATED"] = 34;
        values[valuesById[35] = "VOYAGER_DESTINATION_ACCOUNT_MERGE_SUCCESSFUL"] = 35;
        values[valuesById[36] = "VOYAGER_DESTINATION_ACCOUNT_MERGE_INITIATED"] = 36;
        values[valuesById[37] = "VOYAGER_AMMA_STATEMENT_FY21"] = 37;
        values[valuesById[38] = "VOYAGER_PERIODIC_STATEMENT_FY21"] = 38;
        values[valuesById[39] = "VOYAGER_FINANCIAL_REPORT_FY21"] = 39;
        values[valuesById[40] = "VOYAGER_SOURCE_ACCOUNT_MERGE_UNSUCCESSFUL"] = 40;
        values[valuesById[41] = "VOYAGER_DESTINATION_ACCOUNT_MERGE_UNSUCCESSFUL"] = 41;
        values[valuesById[42] = "VOYAGER_ACCOUNT_STATEMENT_V3"] = 42;
        values[valuesById[43] = "VOYAGER_EXIT_STATEMENT_V3"] = 43;
        values[valuesById[44] = "VOYAGER_PAYMENT_PLAN_AUTO_CANCELLATION"] = 44;
        values[valuesById[45] = "VOYAGER_BOOSTS_AUTO_CANCELLATION"] = 45;
        values[valuesById[46] = "VOYAGER_AMMA_STATEMENT_FY22"] = 46;
        values[valuesById[47] = "VOYAGER_PERIODIC_STATEMENT_FY22"] = 47;
        values[valuesById[48] = "VOYAGER_FAILED_ONEOFF_APPLICATION"] = 48;
        values[valuesById[49] = "VOYAGER_FAILED_INVESTMENT_PLAN_APPLICATION"] = 49;
        values[valuesById[50] = "VOYAGER_FAILED_BOOST_APPLICATION"] = 50;
        values[valuesById[51] = "VOYAGER_FAILED_REDEMPTION"] = 51;
        values[valuesById[52] = "VOYAGER_ACCOUNT_STATEMENT_V4"] = 52;
        values[valuesById[53] = "VOYAGER_EXIT_STATEMENT_V4"] = 53;
        values[valuesById[54] = "VOYAGER_TMD_IN_REVIEW"] = 54;
        values[valuesById[55] = "VOYAGER_TMD_ONBOARDING_APPROVED"] = 55;
        values[valuesById[56] = "VOYAGER_TMD_MULTIFUND_APPROVED"] = 56;
        values[valuesById[57] = "VOYAGER_TMD_REJECTED"] = 57;
        values[valuesById[58] = "VOYAGER_AMMA_STATEMENT_FY23"] = 58;
        values[valuesById[59] = "VOYAGER_PERIODIC_STATEMENT_FY23"] = 59;
        values[valuesById[60] = "VOYAGER_AMMA_STATEMENT_FY23_OVERSEAS_RESEND"] = 60;
        values[valuesById[61] = "VOYAGER_AMMA_STATEMENT_FY23_RESEND"] = 61;
        values[valuesById[62] = "VOYAGER_ACCOUNT_STATEMENT_V5"] = 62;
        values[valuesById[63] = "VOYAGER_EXIT_STATEMENT_V5"] = 63;
        values[valuesById[64] = "VOYAGER_AMMA_STATEMENT_FY24"] = 64;
        values[valuesById[65] = "VOYAGER_PERIODIC_STATEMENT_FY24"] = 65;
        values[valuesById[66] = "VOYAGER_FINANCIAL_REPORT_FY24"] = 66;
        values[valuesById[1000] = "SUPER_SOFT_LINK"] = 1000;
        values[valuesById[1001] = "SUPER_HARD_LINK"] = 1001;
        values[valuesById[1002] = "SUPER_EMPLOYER_CONTRIBUTION_DETAILS_TO_EMPLOYER"] = 1002;
        values[valuesById[1003] = "SUPER_EMPLOYER_CONTRIBUTION_DETAILS_TO_SELF"] = 1003;
        values[valuesById[1004] = "SUPER_ACCOUNT_VERIFICATION_REQUIRED"] = 1004;
        values[valuesById[1005] = "SUPER_BINDING_BENEFICIARY_INTENT"] = 1005;
        values[valuesById[1006] = "SUPER_TAX_DEDUCTION_LETTER"] = 1006;
        values[valuesById[2000] = "PERSONAL_DETAILS_UPDATED"] = 2000;
        values[valuesById[2001] = "TAX_RESIDENCY_PROVIDE_TIN_PROMPT"] = 2001;
        values[valuesById[2002] = "MANUAL_MFA_VERIFICATIONS_GENERATED"] = 2002;
        values[valuesById[2003] = "RESET_PASSWORD_CODE"] = 2003;
        values[valuesById[3000] = "VOYAGER_FEE_COMMS_INCIDENT_NOTIFY"] = 3000;
        values[valuesById[3001] = "VOYAGER_ZEPTO_DIRECT_DEBIT_AGREEMENT_NOTIFY"] = 3001;
        values[valuesById[3002] = "VOYAGER_FINANCIAL_REPORT_FY22"] = 3002;
        values[valuesById[3003] = "VOYAGER_FEE_ANNOUNCEMENT_2023"] = 3003;
        values[valuesById[3004] = "VOYAGER_ORIGIN_PDS_UPDATE_JUN_2023"] = 3004;
        values[valuesById[3005] = "VOYAGER_FAILED_DISTRIBUTION_PROMPT_ACTIVE_FY23"] = 3005;
        values[valuesById[3006] = "VOYAGER_FAILED_DISTRIBUTION_PROMPT_CLOSED_FY23"] = 3006;
        values[valuesById[3007] = "NOVA_TERMS_AND_CONDITIONS_UPDATE_AUG_2023"] = 3007;
        values[valuesById[3008] = "NOVA_TERMS_AND_CONDITIONS_UPDATE_SEPT_2023"] = 3008;
        values[valuesById[3009] = "VOYAGER_EARTH_PDS_UPDATE_SEPT_2023"] = 3009;
        values[valuesById[3010] = "NOVA_FEE_CHARGE_WARNING_SEPT_2023"] = 3010;
        values[valuesById[3011] = "VOYAGER_FINANCIAL_REPORT_FY23"] = 3011;
        values[valuesById[3012] = "VOYAGER_UPDATE_TAX_RESIDENCY_EMAIL_OCT_2023"] = 3012;
        values[valuesById[3013] = "NOVA_ROUNDING_REMEDIATION_OCT_2023"] = 3013;
        values[valuesById[3014] = "MFA_NOTIFY_TURNING_ON_FOR_LOGIN"] = 3014;
        values[valuesById[3015] = "TAX_RESIDENCY_USA_PROVIDE_TIN_PROMPT_DEC_2023"] = 3015;
        values[valuesById[3016] = "TAX_RESIDENCY_USA_CORRECT_TIN_PROMPT_DEC_2023"] = 3016;
        values[valuesById[3017] = "NOVA_INVESTMENT_PLAN_REMEDIATION_NOV_2023"] = 3017;
        values[valuesById[3018] = "TAX_RESIDENCY_NON_USA_PROVIDE_TIN_PROMPT_DEC_2023"] = 3018;
        values[valuesById[3019] = "NOVA_TAF_CHANGE_NOTIFICATION_DEC_2023"] = 3019;
        values[valuesById[3020] = "MFA_REQUIRED_NOTIFICATION"] = 3020;
        values[valuesById[3021] = "FEE_ANNOUNCEMENT_2024"] = 3021;
        values[valuesById[3022] = "NOVA_SEC_CHANGE_NOTIFICATION_MAY_2024"] = 3022;
        values[valuesById[3023] = "VOYAGER_UNSENT_EXIT_STATEMENTS_NOTIFY_MAY_2024"] = 3023;
        values[valuesById[3024] = "TAX_RESIDENCY_USA_INVALID_TIN_PROMPT_DEC_2023"] = 3024;
        values[valuesById[3025] = "ETORO_ANNOUNCEMENT"] = 3025;
        values[valuesById[3026] = "NOVA_DISCLOSURE_DOCUMENT_UPDATE_NOV_2024"] = 3026;
        values[valuesById[3027] = "MONEY_PRE_LAUNCH_ANNOUNCEMENT"] = 3027;
        values[valuesById[3028] = "MONEY_LAUNCH_ANNOUNCEMENT"] = 3028;
        values[valuesById[3034] = "NOVA_BETA_FEE_WAIVER_ENDING_NOTIFICATION"] = 3034;
        values[valuesById[4000] = "NOVA_TRADE_CONFIRMATION"] = 4000;
        values[valuesById[4001] = "NOVA_ACCOUNT_STATEMENT"] = 4001;
        values[valuesById[4002] = "NOVA_WELCOME"] = 4002;
        values[valuesById[4003] = "NOVA_APPLICATION_RECEIVED"] = 4003;
        values[valuesById[4004] = "NOVA_FEES_OUTSTANDING_REMINDER"] = 4004;
        values[valuesById[4005] = "NOVA_FEES_FIRST_CHARGE_FAILED"] = 4005;
        values[valuesById[4006] = "NOVA_FEES_SUSPENDED"] = 4006;
        values[valuesById[4007] = "NOVA_FAILED_ONE_OFF_BUY_ORDER"] = 4007;
        values[valuesById[4008] = "NOVA_FAILED_INVESTMENT_PLAN_BUY_ORDER"] = 4008;
        values[valuesById[4009] = "NOVA_INVALID_TAX_RESIDENCY_NOTIFICATION"] = 4009;
        values[valuesById[4010] = "NOVA_FAILED_PAYOUT"] = 4010;
        values[valuesById[4011] = "NOVA_MULTI_MONTH_STATEMENT"] = 4011;
        values[valuesById[5000] = "MONEY_USER_DEPOSIT_SUCCESSFUL"] = 5000;
        values[valuesById[5001] = "MONEY_USER_DEPOSIT_FAILED"] = 5001;
        values[valuesById[5003] = "MONEY_USER_WITHDRAWAL_SUCCESSFUL"] = 5003;
        values[valuesById[5004] = "MONEY_USER_WITHDRAWAL_FAILED"] = 5004;
        return values;
    })();

    return EmailTemplate;
})();

export const DocumentStatus = $root.DocumentStatus = (() => {

    /**
     * Properties of a DocumentStatus.
     * @exports IDocumentStatus
     * @interface IDocumentStatus
     */

    /**
     * Constructs a new DocumentStatus.
     * @exports DocumentStatus
     * @classdesc Represents a DocumentStatus.
     * @implements IDocumentStatus
     * @constructor
     * @param {IDocumentStatus=} [properties] Properties to set
     */
    function DocumentStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new DocumentStatus instance using the specified properties.
     * @function create
     * @memberof DocumentStatus
     * @static
     * @param {IDocumentStatus=} [properties] Properties to set
     * @returns {DocumentStatus} DocumentStatus instance
     */
    DocumentStatus.create = function create(properties) {
        return new DocumentStatus(properties);
    };

    /**
     * Encodes the specified DocumentStatus message. Does not implicitly {@link DocumentStatus.verify|verify} messages.
     * @function encode
     * @memberof DocumentStatus
     * @static
     * @param {IDocumentStatus} message DocumentStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DocumentStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified DocumentStatus message, length delimited. Does not implicitly {@link DocumentStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DocumentStatus
     * @static
     * @param {IDocumentStatus} message DocumentStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DocumentStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DocumentStatus message from the specified reader or buffer.
     * @function decode
     * @memberof DocumentStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DocumentStatus} DocumentStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DocumentStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DocumentStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DocumentStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DocumentStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DocumentStatus} DocumentStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DocumentStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DocumentStatus message.
     * @function verify
     * @memberof DocumentStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DocumentStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a DocumentStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DocumentStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DocumentStatus} DocumentStatus
     */
    DocumentStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.DocumentStatus)
            return object;
        return new $root.DocumentStatus();
    };

    /**
     * Creates a plain object from a DocumentStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DocumentStatus
     * @static
     * @param {DocumentStatus} message DocumentStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DocumentStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this DocumentStatus to JSON.
     * @function toJSON
     * @memberof DocumentStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DocumentStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name DocumentStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PENDING=1 PENDING value
     * @property {number} PROCESSING=2 PROCESSING value
     * @property {number} SENT=3 SENT value
     * @property {number} FAILED=4 FAILED value
     */
    DocumentStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PENDING"] = 1;
        values[valuesById[2] = "PROCESSING"] = 2;
        values[valuesById[3] = "SENT"] = 3;
        values[valuesById[4] = "FAILED"] = 4;
        return values;
    })();

    return DocumentStatus;
})();

export const FraudVerificationStatus = $root.FraudVerificationStatus = (() => {

    /**
     * Properties of a FraudVerificationStatus.
     * @exports IFraudVerificationStatus
     * @interface IFraudVerificationStatus
     */

    /**
     * Constructs a new FraudVerificationStatus.
     * @exports FraudVerificationStatus
     * @classdesc Represents a FraudVerificationStatus.
     * @implements IFraudVerificationStatus
     * @constructor
     * @param {IFraudVerificationStatus=} [properties] Properties to set
     */
    function FraudVerificationStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new FraudVerificationStatus instance using the specified properties.
     * @function create
     * @memberof FraudVerificationStatus
     * @static
     * @param {IFraudVerificationStatus=} [properties] Properties to set
     * @returns {FraudVerificationStatus} FraudVerificationStatus instance
     */
    FraudVerificationStatus.create = function create(properties) {
        return new FraudVerificationStatus(properties);
    };

    /**
     * Encodes the specified FraudVerificationStatus message. Does not implicitly {@link FraudVerificationStatus.verify|verify} messages.
     * @function encode
     * @memberof FraudVerificationStatus
     * @static
     * @param {IFraudVerificationStatus} message FraudVerificationStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FraudVerificationStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified FraudVerificationStatus message, length delimited. Does not implicitly {@link FraudVerificationStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FraudVerificationStatus
     * @static
     * @param {IFraudVerificationStatus} message FraudVerificationStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FraudVerificationStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FraudVerificationStatus message from the specified reader or buffer.
     * @function decode
     * @memberof FraudVerificationStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FraudVerificationStatus} FraudVerificationStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FraudVerificationStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FraudVerificationStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FraudVerificationStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FraudVerificationStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FraudVerificationStatus} FraudVerificationStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FraudVerificationStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FraudVerificationStatus message.
     * @function verify
     * @memberof FraudVerificationStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FraudVerificationStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a FraudVerificationStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FraudVerificationStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FraudVerificationStatus} FraudVerificationStatus
     */
    FraudVerificationStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.FraudVerificationStatus)
            return object;
        return new $root.FraudVerificationStatus();
    };

    /**
     * Creates a plain object from a FraudVerificationStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FraudVerificationStatus
     * @static
     * @param {FraudVerificationStatus} message FraudVerificationStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FraudVerificationStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this FraudVerificationStatus to JSON.
     * @function toJSON
     * @memberof FraudVerificationStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FraudVerificationStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name FraudVerificationStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PENDING=1 PENDING value
     * @property {number} AUTOMATICALLY_REJECTED=2 AUTOMATICALLY_REJECTED value
     * @property {number} AUTOMATICALLY_VERIFIED=3 AUTOMATICALLY_VERIFIED value
     * @property {number} MANUALLY_REJECTED=4 MANUALLY_REJECTED value
     * @property {number} MANUALLY_VERIFIED=5 MANUALLY_VERIFIED value
     * @property {number} ERROR=6 ERROR value
     * @property {number} DOCUMENT_IN_REVIEW=7 DOCUMENT_IN_REVIEW value
     * @property {number} DOCUMENT_UPLOAD_REQUIRED=8 DOCUMENT_UPLOAD_REQUIRED value
     */
    FraudVerificationStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PENDING"] = 1;
        values[valuesById[2] = "AUTOMATICALLY_REJECTED"] = 2;
        values[valuesById[3] = "AUTOMATICALLY_VERIFIED"] = 3;
        values[valuesById[4] = "MANUALLY_REJECTED"] = 4;
        values[valuesById[5] = "MANUALLY_VERIFIED"] = 5;
        values[valuesById[6] = "ERROR"] = 6;
        values[valuesById[7] = "DOCUMENT_IN_REVIEW"] = 7;
        values[valuesById[8] = "DOCUMENT_UPLOAD_REQUIRED"] = 8;
        return values;
    })();

    return FraudVerificationStatus;
})();

export const FraudService = $root.FraudService = (() => {

    /**
     * Properties of a FraudService.
     * @exports IFraudService
     * @interface IFraudService
     */

    /**
     * Constructs a new FraudService.
     * @exports FraudService
     * @classdesc Represents a FraudService.
     * @implements IFraudService
     * @constructor
     * @param {IFraudService=} [properties] Properties to set
     */
    function FraudService(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new FraudService instance using the specified properties.
     * @function create
     * @memberof FraudService
     * @static
     * @param {IFraudService=} [properties] Properties to set
     * @returns {FraudService} FraudService instance
     */
    FraudService.create = function create(properties) {
        return new FraudService(properties);
    };

    /**
     * Encodes the specified FraudService message. Does not implicitly {@link FraudService.verify|verify} messages.
     * @function encode
     * @memberof FraudService
     * @static
     * @param {IFraudService} message FraudService message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FraudService.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified FraudService message, length delimited. Does not implicitly {@link FraudService.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FraudService
     * @static
     * @param {IFraudService} message FraudService message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FraudService.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FraudService message from the specified reader or buffer.
     * @function decode
     * @memberof FraudService
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FraudService} FraudService
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FraudService.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FraudService();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FraudService message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FraudService
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FraudService} FraudService
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FraudService.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FraudService message.
     * @function verify
     * @memberof FraudService
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FraudService.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a FraudService message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FraudService
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FraudService} FraudService
     */
    FraudService.fromObject = function fromObject(object) {
        if (object instanceof $root.FraudService)
            return object;
        return new $root.FraudService();
    };

    /**
     * Creates a plain object from a FraudService message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FraudService
     * @static
     * @param {FraudService} message FraudService
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FraudService.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this FraudService to JSON.
     * @function toJSON
     * @memberof FraudService
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FraudService.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name FraudService.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} EHAWK=1 EHAWK value
     * @property {number} GREENID=2 GREENID value
     */
    FraudService.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "EHAWK"] = 1;
        values[valuesById[2] = "GREENID"] = 2;
        return values;
    })();

    return FraudService;
})();

export const GreenIdSourceName = $root.GreenIdSourceName = (() => {

    /**
     * Properties of a GreenIdSourceName.
     * @exports IGreenIdSourceName
     * @interface IGreenIdSourceName
     */

    /**
     * Constructs a new GreenIdSourceName.
     * @exports GreenIdSourceName
     * @classdesc Represents a GreenIdSourceName.
     * @implements IGreenIdSourceName
     * @constructor
     * @param {IGreenIdSourceName=} [properties] Properties to set
     */
    function GreenIdSourceName(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new GreenIdSourceName instance using the specified properties.
     * @function create
     * @memberof GreenIdSourceName
     * @static
     * @param {IGreenIdSourceName=} [properties] Properties to set
     * @returns {GreenIdSourceName} GreenIdSourceName instance
     */
    GreenIdSourceName.create = function create(properties) {
        return new GreenIdSourceName(properties);
    };

    /**
     * Encodes the specified GreenIdSourceName message. Does not implicitly {@link GreenIdSourceName.verify|verify} messages.
     * @function encode
     * @memberof GreenIdSourceName
     * @static
     * @param {IGreenIdSourceName} message GreenIdSourceName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdSourceName.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified GreenIdSourceName message, length delimited. Does not implicitly {@link GreenIdSourceName.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GreenIdSourceName
     * @static
     * @param {IGreenIdSourceName} message GreenIdSourceName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdSourceName.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GreenIdSourceName message from the specified reader or buffer.
     * @function decode
     * @memberof GreenIdSourceName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GreenIdSourceName} GreenIdSourceName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdSourceName.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GreenIdSourceName();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GreenIdSourceName message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GreenIdSourceName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GreenIdSourceName} GreenIdSourceName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdSourceName.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GreenIdSourceName message.
     * @function verify
     * @memberof GreenIdSourceName
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GreenIdSourceName.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a GreenIdSourceName message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GreenIdSourceName
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GreenIdSourceName} GreenIdSourceName
     */
    GreenIdSourceName.fromObject = function fromObject(object) {
        if (object instanceof $root.GreenIdSourceName)
            return object;
        return new $root.GreenIdSourceName();
    };

    /**
     * Creates a plain object from a GreenIdSourceName message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GreenIdSourceName
     * @static
     * @param {GreenIdSourceName} message GreenIdSourceName
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GreenIdSourceName.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this GreenIdSourceName to JSON.
     * @function toJSON
     * @memberof GreenIdSourceName
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GreenIdSourceName.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name GreenIdSourceName.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ACTREGO=1 ACTREGO value
     * @property {number} ACTREGODVS=2 ACTREGODVS value
     * @property {number} AEC=3 AEC value
     * @property {number} BIRTHCERTIFICATEDVS=4 BIRTHCERTIFICATEDVS value
     * @property {number} CENTRELINKDVS=5 CENTRELINKDVS value
     * @property {number} CHANGEOFNAMECERTIFICATEDVS=6 CHANGEOFNAMECERTIFICATEDVS value
     * @property {number} CITIZENSHIPCERTIFICATEDVS=7 CITIZENSHIPCERTIFICATEDVS value
     * @property {number} DNB=8 DNB value
     * @property {number} IMMICARDDVS=9 IMMICARDDVS value
     * @property {number} MARRIAGECERTIFICATEDVS=10 MARRIAGECERTIFICATEDVS value
     * @property {number} MEDIBANK=11 MEDIBANK value
     * @property {number} MEDICAREDVS=12 MEDICAREDVS value
     * @property {number} NSWREGO=13 NSWREGO value
     * @property {number} NSWREGODVS=14 NSWREGODVS value
     * @property {number} NTREGODVS=15 NTREGODVS value
     * @property {number} PASSPORTDVS=16 PASSPORTDVS value
     * @property {number} QLDREGO=17 QLDREGO value
     * @property {number} QLDREGODVS=18 QLDREGODVS value
     * @property {number} SAREGO=19 SAREGO value
     * @property {number} SAREGODVS=20 SAREGODVS value
     * @property {number} TASREGODVS=21 TASREGODVS value
     * @property {number} VICEC=22 VICEC value
     * @property {number} VICREGO=23 VICREGO value
     * @property {number} VICREGO_OLD=24 VICREGO_OLD value
     * @property {number} VICREGODVS=25 VICREGODVS value
     * @property {number} VISA=26 VISA value
     * @property {number} VISADVS=27 VISADVS value
     * @property {number} WAEC=28 WAEC value
     * @property {number} WAREGO=29 WAREGO value
     * @property {number} WAREGODVS=30 WAREGODVS value
     * @property {number} BANKSTATEMENT=31 BANKSTATEMENT value
     */
    GreenIdSourceName.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ACTREGO"] = 1;
        values[valuesById[2] = "ACTREGODVS"] = 2;
        values[valuesById[3] = "AEC"] = 3;
        values[valuesById[4] = "BIRTHCERTIFICATEDVS"] = 4;
        values[valuesById[5] = "CENTRELINKDVS"] = 5;
        values[valuesById[6] = "CHANGEOFNAMECERTIFICATEDVS"] = 6;
        values[valuesById[7] = "CITIZENSHIPCERTIFICATEDVS"] = 7;
        values[valuesById[8] = "DNB"] = 8;
        values[valuesById[9] = "IMMICARDDVS"] = 9;
        values[valuesById[10] = "MARRIAGECERTIFICATEDVS"] = 10;
        values[valuesById[11] = "MEDIBANK"] = 11;
        values[valuesById[12] = "MEDICAREDVS"] = 12;
        values[valuesById[13] = "NSWREGO"] = 13;
        values[valuesById[14] = "NSWREGODVS"] = 14;
        values[valuesById[15] = "NTREGODVS"] = 15;
        values[valuesById[16] = "PASSPORTDVS"] = 16;
        values[valuesById[17] = "QLDREGO"] = 17;
        values[valuesById[18] = "QLDREGODVS"] = 18;
        values[valuesById[19] = "SAREGO"] = 19;
        values[valuesById[20] = "SAREGODVS"] = 20;
        values[valuesById[21] = "TASREGODVS"] = 21;
        values[valuesById[22] = "VICEC"] = 22;
        values[valuesById[23] = "VICREGO"] = 23;
        values[valuesById[24] = "VICREGO_OLD"] = 24;
        values[valuesById[25] = "VICREGODVS"] = 25;
        values[valuesById[26] = "VISA"] = 26;
        values[valuesById[27] = "VISADVS"] = 27;
        values[valuesById[28] = "WAEC"] = 28;
        values[valuesById[29] = "WAREGO"] = 29;
        values[valuesById[30] = "WAREGODVS"] = 30;
        values[valuesById[31] = "BANKSTATEMENT"] = 31;
        return values;
    })();

    return GreenIdSourceName;
})();

export const GreenIdSourceStatus = $root.GreenIdSourceStatus = (() => {

    /**
     * Properties of a GreenIdSourceStatus.
     * @exports IGreenIdSourceStatus
     * @interface IGreenIdSourceStatus
     */

    /**
     * Constructs a new GreenIdSourceStatus.
     * @exports GreenIdSourceStatus
     * @classdesc Represents a GreenIdSourceStatus.
     * @implements IGreenIdSourceStatus
     * @constructor
     * @param {IGreenIdSourceStatus=} [properties] Properties to set
     */
    function GreenIdSourceStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new GreenIdSourceStatus instance using the specified properties.
     * @function create
     * @memberof GreenIdSourceStatus
     * @static
     * @param {IGreenIdSourceStatus=} [properties] Properties to set
     * @returns {GreenIdSourceStatus} GreenIdSourceStatus instance
     */
    GreenIdSourceStatus.create = function create(properties) {
        return new GreenIdSourceStatus(properties);
    };

    /**
     * Encodes the specified GreenIdSourceStatus message. Does not implicitly {@link GreenIdSourceStatus.verify|verify} messages.
     * @function encode
     * @memberof GreenIdSourceStatus
     * @static
     * @param {IGreenIdSourceStatus} message GreenIdSourceStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdSourceStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified GreenIdSourceStatus message, length delimited. Does not implicitly {@link GreenIdSourceStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GreenIdSourceStatus
     * @static
     * @param {IGreenIdSourceStatus} message GreenIdSourceStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdSourceStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GreenIdSourceStatus message from the specified reader or buffer.
     * @function decode
     * @memberof GreenIdSourceStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GreenIdSourceStatus} GreenIdSourceStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdSourceStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GreenIdSourceStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GreenIdSourceStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GreenIdSourceStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GreenIdSourceStatus} GreenIdSourceStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdSourceStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GreenIdSourceStatus message.
     * @function verify
     * @memberof GreenIdSourceStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GreenIdSourceStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a GreenIdSourceStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GreenIdSourceStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GreenIdSourceStatus} GreenIdSourceStatus
     */
    GreenIdSourceStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.GreenIdSourceStatus)
            return object;
        return new $root.GreenIdSourceStatus();
    };

    /**
     * Creates a plain object from a GreenIdSourceStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GreenIdSourceStatus
     * @static
     * @param {GreenIdSourceStatus} message GreenIdSourceStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GreenIdSourceStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this GreenIdSourceStatus to JSON.
     * @function toJSON
     * @memberof GreenIdSourceStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GreenIdSourceStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name GreenIdSourceStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} VERIFIED=1 VERIFIED value
     * @property {number} VERIFIED_ADMIN=2 VERIFIED_ADMIN value
     * @property {number} VERIFIED_WITH_CHANGES=3 VERIFIED_WITH_CHANGES value
     * @property {number} FAILED=4 FAILED value
     * @property {number} AUTOFAIL=5 AUTOFAIL value
     * @property {number} IN_PROGRESS=6 IN_PROGRESS value
     * @property {number} PENDING=7 PENDING value
     * @property {number} NOT_CONTRIBUTING=8 NOT_CONTRIBUTING value
     * @property {number} LOCKED_OUT=9 LOCKED_OUT value
     * @property {number} ERROR=10 ERROR value
     */
    GreenIdSourceStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "VERIFIED"] = 1;
        values[valuesById[2] = "VERIFIED_ADMIN"] = 2;
        values[valuesById[3] = "VERIFIED_WITH_CHANGES"] = 3;
        values[valuesById[4] = "FAILED"] = 4;
        values[valuesById[5] = "AUTOFAIL"] = 5;
        values[valuesById[6] = "IN_PROGRESS"] = 6;
        values[valuesById[7] = "PENDING"] = 7;
        values[valuesById[8] = "NOT_CONTRIBUTING"] = 8;
        values[valuesById[9] = "LOCKED_OUT"] = 9;
        values[valuesById[10] = "ERROR"] = 10;
        return values;
    })();

    return GreenIdSourceStatus;
})();

export const GreenIdInteractiveSource = $root.GreenIdInteractiveSource = (() => {

    /**
     * Properties of a GreenIdInteractiveSource.
     * @exports IGreenIdInteractiveSource
     * @interface IGreenIdInteractiveSource
     * @property {GreenIdSourceStatus.Enum|null} [status] GreenIdInteractiveSource status
     * @property {GreenIdSourceName.Enum|null} [name] GreenIdInteractiveSource name
     * @property {boolean|null} [is_document_upload] GreenIdInteractiveSource is_document_upload
     */

    /**
     * Constructs a new GreenIdInteractiveSource.
     * @exports GreenIdInteractiveSource
     * @classdesc Represents a GreenIdInteractiveSource.
     * @implements IGreenIdInteractiveSource
     * @constructor
     * @param {IGreenIdInteractiveSource=} [properties] Properties to set
     */
    function GreenIdInteractiveSource(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GreenIdInteractiveSource status.
     * @member {GreenIdSourceStatus.Enum} status
     * @memberof GreenIdInteractiveSource
     * @instance
     */
    GreenIdInteractiveSource.prototype.status = 0;

    /**
     * GreenIdInteractiveSource name.
     * @member {GreenIdSourceName.Enum} name
     * @memberof GreenIdInteractiveSource
     * @instance
     */
    GreenIdInteractiveSource.prototype.name = 0;

    /**
     * GreenIdInteractiveSource is_document_upload.
     * @member {boolean} is_document_upload
     * @memberof GreenIdInteractiveSource
     * @instance
     */
    GreenIdInteractiveSource.prototype.is_document_upload = false;

    /**
     * Creates a new GreenIdInteractiveSource instance using the specified properties.
     * @function create
     * @memberof GreenIdInteractiveSource
     * @static
     * @param {IGreenIdInteractiveSource=} [properties] Properties to set
     * @returns {GreenIdInteractiveSource} GreenIdInteractiveSource instance
     */
    GreenIdInteractiveSource.create = function create(properties) {
        return new GreenIdInteractiveSource(properties);
    };

    /**
     * Encodes the specified GreenIdInteractiveSource message. Does not implicitly {@link GreenIdInteractiveSource.verify|verify} messages.
     * @function encode
     * @memberof GreenIdInteractiveSource
     * @static
     * @param {IGreenIdInteractiveSource} message GreenIdInteractiveSource message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdInteractiveSource.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
        if (message.name != null && message.hasOwnProperty("name"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.name);
        if (message.is_document_upload != null && message.hasOwnProperty("is_document_upload"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.is_document_upload);
        return writer;
    };

    /**
     * Encodes the specified GreenIdInteractiveSource message, length delimited. Does not implicitly {@link GreenIdInteractiveSource.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GreenIdInteractiveSource
     * @static
     * @param {IGreenIdInteractiveSource} message GreenIdInteractiveSource message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdInteractiveSource.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GreenIdInteractiveSource message from the specified reader or buffer.
     * @function decode
     * @memberof GreenIdInteractiveSource
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GreenIdInteractiveSource} GreenIdInteractiveSource
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdInteractiveSource.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GreenIdInteractiveSource();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.status = reader.int32();
                break;
            case 2:
                message.name = reader.int32();
                break;
            case 3:
                message.is_document_upload = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GreenIdInteractiveSource message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GreenIdInteractiveSource
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GreenIdInteractiveSource} GreenIdInteractiveSource
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdInteractiveSource.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GreenIdInteractiveSource message.
     * @function verify
     * @memberof GreenIdInteractiveSource
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GreenIdInteractiveSource.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                break;
            }
        if (message.name != null && message.hasOwnProperty("name"))
            switch (message.name) {
            default:
                return "name: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
                break;
            }
        if (message.is_document_upload != null && message.hasOwnProperty("is_document_upload"))
            if (typeof message.is_document_upload !== "boolean")
                return "is_document_upload: boolean expected";
        return null;
    };

    /**
     * Creates a GreenIdInteractiveSource message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GreenIdInteractiveSource
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GreenIdInteractiveSource} GreenIdInteractiveSource
     */
    GreenIdInteractiveSource.fromObject = function fromObject(object) {
        if (object instanceof $root.GreenIdInteractiveSource)
            return object;
        let message = new $root.GreenIdInteractiveSource();
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "VERIFIED":
        case 1:
            message.status = 1;
            break;
        case "VERIFIED_ADMIN":
        case 2:
            message.status = 2;
            break;
        case "VERIFIED_WITH_CHANGES":
        case 3:
            message.status = 3;
            break;
        case "FAILED":
        case 4:
            message.status = 4;
            break;
        case "AUTOFAIL":
        case 5:
            message.status = 5;
            break;
        case "IN_PROGRESS":
        case 6:
            message.status = 6;
            break;
        case "PENDING":
        case 7:
            message.status = 7;
            break;
        case "NOT_CONTRIBUTING":
        case 8:
            message.status = 8;
            break;
        case "LOCKED_OUT":
        case 9:
            message.status = 9;
            break;
        case "ERROR":
        case 10:
            message.status = 10;
            break;
        }
        switch (object.name) {
        case "UNKNOWN":
        case 0:
            message.name = 0;
            break;
        case "ACTREGO":
        case 1:
            message.name = 1;
            break;
        case "ACTREGODVS":
        case 2:
            message.name = 2;
            break;
        case "AEC":
        case 3:
            message.name = 3;
            break;
        case "BIRTHCERTIFICATEDVS":
        case 4:
            message.name = 4;
            break;
        case "CENTRELINKDVS":
        case 5:
            message.name = 5;
            break;
        case "CHANGEOFNAMECERTIFICATEDVS":
        case 6:
            message.name = 6;
            break;
        case "CITIZENSHIPCERTIFICATEDVS":
        case 7:
            message.name = 7;
            break;
        case "DNB":
        case 8:
            message.name = 8;
            break;
        case "IMMICARDDVS":
        case 9:
            message.name = 9;
            break;
        case "MARRIAGECERTIFICATEDVS":
        case 10:
            message.name = 10;
            break;
        case "MEDIBANK":
        case 11:
            message.name = 11;
            break;
        case "MEDICAREDVS":
        case 12:
            message.name = 12;
            break;
        case "NSWREGO":
        case 13:
            message.name = 13;
            break;
        case "NSWREGODVS":
        case 14:
            message.name = 14;
            break;
        case "NTREGODVS":
        case 15:
            message.name = 15;
            break;
        case "PASSPORTDVS":
        case 16:
            message.name = 16;
            break;
        case "QLDREGO":
        case 17:
            message.name = 17;
            break;
        case "QLDREGODVS":
        case 18:
            message.name = 18;
            break;
        case "SAREGO":
        case 19:
            message.name = 19;
            break;
        case "SAREGODVS":
        case 20:
            message.name = 20;
            break;
        case "TASREGODVS":
        case 21:
            message.name = 21;
            break;
        case "VICEC":
        case 22:
            message.name = 22;
            break;
        case "VICREGO":
        case 23:
            message.name = 23;
            break;
        case "VICREGO_OLD":
        case 24:
            message.name = 24;
            break;
        case "VICREGODVS":
        case 25:
            message.name = 25;
            break;
        case "VISA":
        case 26:
            message.name = 26;
            break;
        case "VISADVS":
        case 27:
            message.name = 27;
            break;
        case "WAEC":
        case 28:
            message.name = 28;
            break;
        case "WAREGO":
        case 29:
            message.name = 29;
            break;
        case "WAREGODVS":
        case 30:
            message.name = 30;
            break;
        case "BANKSTATEMENT":
        case 31:
            message.name = 31;
            break;
        }
        if (object.is_document_upload != null)
            message.is_document_upload = Boolean(object.is_document_upload);
        return message;
    };

    /**
     * Creates a plain object from a GreenIdInteractiveSource message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GreenIdInteractiveSource
     * @static
     * @param {GreenIdInteractiveSource} message GreenIdInteractiveSource
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GreenIdInteractiveSource.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.name = options.enums === String ? "UNKNOWN" : 0;
            object.is_document_upload = false;
        }
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.GreenIdSourceStatus.Enum[message.status] : message.status;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = options.enums === String ? $root.GreenIdSourceName.Enum[message.name] : message.name;
        if (message.is_document_upload != null && message.hasOwnProperty("is_document_upload"))
            object.is_document_upload = message.is_document_upload;
        return object;
    };

    /**
     * Converts this GreenIdInteractiveSource to JSON.
     * @function toJSON
     * @memberof GreenIdInteractiveSource
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GreenIdInteractiveSource.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GreenIdInteractiveSource;
})();

export const TaxResidenceStatus = $root.TaxResidenceStatus = (() => {

    /**
     * Properties of a TaxResidenceStatus.
     * @exports ITaxResidenceStatus
     * @interface ITaxResidenceStatus
     */

    /**
     * Constructs a new TaxResidenceStatus.
     * @exports TaxResidenceStatus
     * @classdesc Represents a TaxResidenceStatus.
     * @implements ITaxResidenceStatus
     * @constructor
     * @param {ITaxResidenceStatus=} [properties] Properties to set
     */
    function TaxResidenceStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new TaxResidenceStatus instance using the specified properties.
     * @function create
     * @memberof TaxResidenceStatus
     * @static
     * @param {ITaxResidenceStatus=} [properties] Properties to set
     * @returns {TaxResidenceStatus} TaxResidenceStatus instance
     */
    TaxResidenceStatus.create = function create(properties) {
        return new TaxResidenceStatus(properties);
    };

    /**
     * Encodes the specified TaxResidenceStatus message. Does not implicitly {@link TaxResidenceStatus.verify|verify} messages.
     * @function encode
     * @memberof TaxResidenceStatus
     * @static
     * @param {ITaxResidenceStatus} message TaxResidenceStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TaxResidenceStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified TaxResidenceStatus message, length delimited. Does not implicitly {@link TaxResidenceStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TaxResidenceStatus
     * @static
     * @param {ITaxResidenceStatus} message TaxResidenceStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TaxResidenceStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TaxResidenceStatus message from the specified reader or buffer.
     * @function decode
     * @memberof TaxResidenceStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TaxResidenceStatus} TaxResidenceStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TaxResidenceStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TaxResidenceStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TaxResidenceStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TaxResidenceStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TaxResidenceStatus} TaxResidenceStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TaxResidenceStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TaxResidenceStatus message.
     * @function verify
     * @memberof TaxResidenceStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TaxResidenceStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a TaxResidenceStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TaxResidenceStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TaxResidenceStatus} TaxResidenceStatus
     */
    TaxResidenceStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.TaxResidenceStatus)
            return object;
        return new $root.TaxResidenceStatus();
    };

    /**
     * Creates a plain object from a TaxResidenceStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TaxResidenceStatus
     * @static
     * @param {TaxResidenceStatus} message TaxResidenceStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TaxResidenceStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this TaxResidenceStatus to JSON.
     * @function toJSON
     * @memberof TaxResidenceStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TaxResidenceStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name TaxResidenceStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} SPECIFIED=1 SPECIFIED value
     * @property {number} UNSPECIFIED=2 UNSPECIFIED value
     */
    TaxResidenceStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "SPECIFIED"] = 1;
        values[valuesById[2] = "UNSPECIFIED"] = 2;
        return values;
    })();

    return TaxResidenceStatus;
})();

export const TaxGroup = $root.TaxGroup = (() => {

    /**
     * Properties of a TaxGroup.
     * @exports ITaxGroup
     * @interface ITaxGroup
     */

    /**
     * Constructs a new TaxGroup.
     * @exports TaxGroup
     * @classdesc Represents a TaxGroup.
     * @implements ITaxGroup
     * @constructor
     * @param {ITaxGroup=} [properties] Properties to set
     */
    function TaxGroup(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new TaxGroup instance using the specified properties.
     * @function create
     * @memberof TaxGroup
     * @static
     * @param {ITaxGroup=} [properties] Properties to set
     * @returns {TaxGroup} TaxGroup instance
     */
    TaxGroup.create = function create(properties) {
        return new TaxGroup(properties);
    };

    /**
     * Encodes the specified TaxGroup message. Does not implicitly {@link TaxGroup.verify|verify} messages.
     * @function encode
     * @memberof TaxGroup
     * @static
     * @param {ITaxGroup} message TaxGroup message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TaxGroup.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified TaxGroup message, length delimited. Does not implicitly {@link TaxGroup.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TaxGroup
     * @static
     * @param {ITaxGroup} message TaxGroup message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TaxGroup.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TaxGroup message from the specified reader or buffer.
     * @function decode
     * @memberof TaxGroup
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TaxGroup} TaxGroup
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TaxGroup.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TaxGroup();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TaxGroup message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TaxGroup
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TaxGroup} TaxGroup
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TaxGroup.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TaxGroup message.
     * @function verify
     * @memberof TaxGroup
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TaxGroup.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a TaxGroup message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TaxGroup
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TaxGroup} TaxGroup
     */
    TaxGroup.fromObject = function fromObject(object) {
        if (object instanceof $root.TaxGroup)
            return object;
        return new $root.TaxGroup();
    };

    /**
     * Creates a plain object from a TaxGroup message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TaxGroup
     * @static
     * @param {TaxGroup} message TaxGroup
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TaxGroup.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this TaxGroup to JSON.
     * @function toJSON
     * @memberof TaxGroup
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TaxGroup.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name TaxGroup.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} UNSPECIFIED=1 UNSPECIFIED value
     * @property {number} AUSTRALIA_ONLY=2 AUSTRALIA_ONLY value
     * @property {number} AUSTRALIA_AND_OVERSEAS=3 AUSTRALIA_AND_OVERSEAS value
     * @property {number} OVERSEAS_ONLY=4 OVERSEAS_ONLY value
     */
    TaxGroup.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "UNSPECIFIED"] = 1;
        values[valuesById[2] = "AUSTRALIA_ONLY"] = 2;
        values[valuesById[3] = "AUSTRALIA_AND_OVERSEAS"] = 3;
        values[valuesById[4] = "OVERSEAS_ONLY"] = 4;
        return values;
    })();

    return TaxGroup;
})();

export const PartnerName = $root.PartnerName = (() => {

    /**
     * Properties of a PartnerName.
     * @exports IPartnerName
     * @interface IPartnerName
     */

    /**
     * Constructs a new PartnerName.
     * @exports PartnerName
     * @classdesc Represents a PartnerName.
     * @implements IPartnerName
     * @constructor
     * @param {IPartnerName=} [properties] Properties to set
     */
    function PartnerName(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new PartnerName instance using the specified properties.
     * @function create
     * @memberof PartnerName
     * @static
     * @param {IPartnerName=} [properties] Properties to set
     * @returns {PartnerName} PartnerName instance
     */
    PartnerName.create = function create(properties) {
        return new PartnerName(properties);
    };

    /**
     * Encodes the specified PartnerName message. Does not implicitly {@link PartnerName.verify|verify} messages.
     * @function encode
     * @memberof PartnerName
     * @static
     * @param {IPartnerName} message PartnerName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PartnerName.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified PartnerName message, length delimited. Does not implicitly {@link PartnerName.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PartnerName
     * @static
     * @param {IPartnerName} message PartnerName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PartnerName.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PartnerName message from the specified reader or buffer.
     * @function decode
     * @memberof PartnerName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PartnerName} PartnerName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PartnerName.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PartnerName();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PartnerName message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PartnerName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PartnerName} PartnerName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PartnerName.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PartnerName message.
     * @function verify
     * @memberof PartnerName
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PartnerName.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a PartnerName message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PartnerName
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PartnerName} PartnerName
     */
    PartnerName.fromObject = function fromObject(object) {
        if (object instanceof $root.PartnerName)
            return object;
        return new $root.PartnerName();
    };

    /**
     * Creates a plain object from a PartnerName message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PartnerName
     * @static
     * @param {PartnerName} message PartnerName
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PartnerName.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this PartnerName to JSON.
     * @function toJSON
     * @memberof PartnerName
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PartnerName.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name PartnerName.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} NONE=1 NONE value
     * @property {number} EMPLOYMENT_HERO=2 EMPLOYMENT_HERO value
     * @property {number} BOOKIPI=3 BOOKIPI value
     * @property {number} FOUNDU=4 FOUNDU value
     * @property {number} FLARE=5 FLARE value
     */
    PartnerName.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "NONE"] = 1;
        values[valuesById[2] = "EMPLOYMENT_HERO"] = 2;
        values[valuesById[3] = "BOOKIPI"] = 3;
        values[valuesById[4] = "FOUNDU"] = 4;
        values[valuesById[5] = "FLARE"] = 5;
        return values;
    })();

    return PartnerName;
})();

export const Contact = $root.Contact = (() => {

    /**
     * Properties of a Contact.
     * @exports IContact
     * @interface IContact
     * @property {string|null} [id] Contact id
     * @property {string|null} [account_id] Contact account_id
     * @property {string|null} [first_name] Contact first_name
     * @property {string|null} [last_name] Contact last_name
     * @property {string|null} [phone_number] Contact phone_number
     * @property {string|null} [email_address] Contact email_address
     * @property {string|null} [date_of_birth] Contact date_of_birth
     * @property {ContactStatus.Enum|null} [status] Contact status
     * @property {IAddress|null} [address] Contact address
     * @property {google.protobuf.ITimestamp|null} [created_at] Contact created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] Contact last_updated_at
     * @property {TaxResidenceStatus.Enum|null} [tax_residence_status] Contact tax_residence_status
     * @property {Array.<ILeadProductIntent>|null} [lead_product_intents] Contact lead_product_intents
     * @property {google.protobuf.IStringValue|null} [preferred_name] Contact preferred_name
     * @property {TaxGroup.Enum|null} [tax_group] Contact tax_group
     * @property {PartnerName.Enum|null} [partner_name] Contact partner_name
     * @property {google.protobuf.ITimestamp|null} [password_last_updated_at] Contact password_last_updated_at
     * @property {string|null} [pub_key] Contact pub_key
     * @property {number|null} [vault_key_version] Contact vault_key_version
     */

    /**
     * Constructs a new Contact.
     * @exports Contact
     * @classdesc Represents a Contact.
     * @implements IContact
     * @constructor
     * @param {IContact=} [properties] Properties to set
     */
    function Contact(properties) {
        this.lead_product_intents = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Contact id.
     * @member {string} id
     * @memberof Contact
     * @instance
     */
    Contact.prototype.id = "";

    /**
     * Contact account_id.
     * @member {string} account_id
     * @memberof Contact
     * @instance
     */
    Contact.prototype.account_id = "";

    /**
     * Contact first_name.
     * @member {string} first_name
     * @memberof Contact
     * @instance
     */
    Contact.prototype.first_name = "";

    /**
     * Contact last_name.
     * @member {string} last_name
     * @memberof Contact
     * @instance
     */
    Contact.prototype.last_name = "";

    /**
     * Contact phone_number.
     * @member {string} phone_number
     * @memberof Contact
     * @instance
     */
    Contact.prototype.phone_number = "";

    /**
     * Contact email_address.
     * @member {string} email_address
     * @memberof Contact
     * @instance
     */
    Contact.prototype.email_address = "";

    /**
     * Contact date_of_birth.
     * @member {string} date_of_birth
     * @memberof Contact
     * @instance
     */
    Contact.prototype.date_of_birth = "";

    /**
     * Contact status.
     * @member {ContactStatus.Enum} status
     * @memberof Contact
     * @instance
     */
    Contact.prototype.status = 0;

    /**
     * Contact address.
     * @member {IAddress|null|undefined} address
     * @memberof Contact
     * @instance
     */
    Contact.prototype.address = null;

    /**
     * Contact created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof Contact
     * @instance
     */
    Contact.prototype.created_at = null;

    /**
     * Contact last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof Contact
     * @instance
     */
    Contact.prototype.last_updated_at = null;

    /**
     * Contact tax_residence_status.
     * @member {TaxResidenceStatus.Enum} tax_residence_status
     * @memberof Contact
     * @instance
     */
    Contact.prototype.tax_residence_status = 0;

    /**
     * Contact lead_product_intents.
     * @member {Array.<ILeadProductIntent>} lead_product_intents
     * @memberof Contact
     * @instance
     */
    Contact.prototype.lead_product_intents = $util.emptyArray;

    /**
     * Contact preferred_name.
     * @member {google.protobuf.IStringValue|null|undefined} preferred_name
     * @memberof Contact
     * @instance
     */
    Contact.prototype.preferred_name = null;

    /**
     * Contact tax_group.
     * @member {TaxGroup.Enum} tax_group
     * @memberof Contact
     * @instance
     */
    Contact.prototype.tax_group = 0;

    /**
     * Contact partner_name.
     * @member {PartnerName.Enum} partner_name
     * @memberof Contact
     * @instance
     */
    Contact.prototype.partner_name = 0;

    /**
     * Contact password_last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} password_last_updated_at
     * @memberof Contact
     * @instance
     */
    Contact.prototype.password_last_updated_at = null;

    /**
     * Contact pub_key.
     * @member {string} pub_key
     * @memberof Contact
     * @instance
     */
    Contact.prototype.pub_key = "";

    /**
     * Contact vault_key_version.
     * @member {number} vault_key_version
     * @memberof Contact
     * @instance
     */
    Contact.prototype.vault_key_version = 0;

    /**
     * Creates a new Contact instance using the specified properties.
     * @function create
     * @memberof Contact
     * @static
     * @param {IContact=} [properties] Properties to set
     * @returns {Contact} Contact instance
     */
    Contact.create = function create(properties) {
        return new Contact(properties);
    };

    /**
     * Encodes the specified Contact message. Does not implicitly {@link Contact.verify|verify} messages.
     * @function encode
     * @memberof Contact
     * @static
     * @param {IContact} message Contact message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Contact.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_id);
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.first_name);
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.last_name);
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.phone_number);
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.email_address);
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.date_of_birth);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
        if (message.address != null && message.hasOwnProperty("address"))
            $root.Address.encode(message.address, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.tax_residence_status != null && message.hasOwnProperty("tax_residence_status"))
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.tax_residence_status);
        if (message.lead_product_intents != null && message.lead_product_intents.length)
            for (let i = 0; i < message.lead_product_intents.length; ++i)
                $root.LeadProductIntent.encode(message.lead_product_intents[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        if (message.preferred_name != null && message.hasOwnProperty("preferred_name"))
            $root.google.protobuf.StringValue.encode(message.preferred_name, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
        if (message.tax_group != null && message.hasOwnProperty("tax_group"))
            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.tax_group);
        if (message.partner_name != null && message.hasOwnProperty("partner_name"))
            writer.uint32(/* id 17, wireType 0 =*/136).int32(message.partner_name);
        if (message.pub_key != null && message.hasOwnProperty("pub_key"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.pub_key);
        if (message.vault_key_version != null && message.hasOwnProperty("vault_key_version"))
            writer.uint32(/* id 19, wireType 0 =*/152).int32(message.vault_key_version);
        if (message.password_last_updated_at != null && message.hasOwnProperty("password_last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.password_last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Contact message, length delimited. Does not implicitly {@link Contact.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Contact
     * @static
     * @param {IContact} message Contact message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Contact.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Contact message from the specified reader or buffer.
     * @function decode
     * @memberof Contact
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Contact} Contact
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Contact.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Contact();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.account_id = reader.string();
                break;
            case 3:
                message.first_name = reader.string();
                break;
            case 4:
                message.last_name = reader.string();
                break;
            case 5:
                message.phone_number = reader.string();
                break;
            case 6:
                message.email_address = reader.string();
                break;
            case 7:
                message.date_of_birth = reader.string();
                break;
            case 8:
                message.status = reader.int32();
                break;
            case 9:
                message.address = $root.Address.decode(reader, reader.uint32());
                break;
            case 10:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 11:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 12:
                message.tax_residence_status = reader.int32();
                break;
            case 13:
                if (!(message.lead_product_intents && message.lead_product_intents.length))
                    message.lead_product_intents = [];
                message.lead_product_intents.push($root.LeadProductIntent.decode(reader, reader.uint32()));
                break;
            case 14:
                message.preferred_name = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 16:
                message.tax_group = reader.int32();
                break;
            case 17:
                message.partner_name = reader.int32();
                break;
            case 99:
                message.password_last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 18:
                message.pub_key = reader.string();
                break;
            case 19:
                message.vault_key_version = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Contact message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Contact
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Contact} Contact
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Contact.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Contact message.
     * @function verify
     * @memberof Contact
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Contact.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            if (!$util.isString(message.account_id))
                return "account_id: string expected";
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            if (!$util.isString(message.first_name))
                return "first_name: string expected";
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            if (!$util.isString(message.last_name))
                return "last_name: string expected";
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            if (!$util.isString(message.phone_number))
                return "phone_number: string expected";
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            if (!$util.isString(message.email_address))
                return "email_address: string expected";
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            if (!$util.isString(message.date_of_birth))
                return "date_of_birth: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.address != null && message.hasOwnProperty("address")) {
            let error = $root.Address.verify(message.address);
            if (error)
                return "address." + error;
        }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        if (message.tax_residence_status != null && message.hasOwnProperty("tax_residence_status"))
            switch (message.tax_residence_status) {
            default:
                return "tax_residence_status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.lead_product_intents != null && message.hasOwnProperty("lead_product_intents")) {
            if (!Array.isArray(message.lead_product_intents))
                return "lead_product_intents: array expected";
            for (let i = 0; i < message.lead_product_intents.length; ++i) {
                let error = $root.LeadProductIntent.verify(message.lead_product_intents[i]);
                if (error)
                    return "lead_product_intents." + error;
            }
        }
        if (message.preferred_name != null && message.hasOwnProperty("preferred_name")) {
            let error = $root.google.protobuf.StringValue.verify(message.preferred_name);
            if (error)
                return "preferred_name." + error;
        }
        if (message.tax_group != null && message.hasOwnProperty("tax_group"))
            switch (message.tax_group) {
            default:
                return "tax_group: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.partner_name != null && message.hasOwnProperty("partner_name"))
            switch (message.partner_name) {
            default:
                return "partner_name: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.password_last_updated_at != null && message.hasOwnProperty("password_last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.password_last_updated_at);
            if (error)
                return "password_last_updated_at." + error;
        }
        if (message.pub_key != null && message.hasOwnProperty("pub_key"))
            if (!$util.isString(message.pub_key))
                return "pub_key: string expected";
        if (message.vault_key_version != null && message.hasOwnProperty("vault_key_version"))
            if (!$util.isInteger(message.vault_key_version))
                return "vault_key_version: integer expected";
        return null;
    };

    /**
     * Creates a Contact message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Contact
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Contact} Contact
     */
    Contact.fromObject = function fromObject(object) {
        if (object instanceof $root.Contact)
            return object;
        let message = new $root.Contact();
        if (object.id != null)
            message.id = String(object.id);
        if (object.account_id != null)
            message.account_id = String(object.account_id);
        if (object.first_name != null)
            message.first_name = String(object.first_name);
        if (object.last_name != null)
            message.last_name = String(object.last_name);
        if (object.phone_number != null)
            message.phone_number = String(object.phone_number);
        if (object.email_address != null)
            message.email_address = String(object.email_address);
        if (object.date_of_birth != null)
            message.date_of_birth = String(object.date_of_birth);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "CLOSED":
        case 1:
            message.status = 1;
            break;
        case "ACTIVE":
        case 2:
            message.status = 2;
            break;
        case "PENDING":
        case 3:
            message.status = 3;
            break;
        case "BLOCKED":
        case 4:
            message.status = 4;
            break;
        }
        if (object.address != null) {
            if (typeof object.address !== "object")
                throw TypeError(".Contact.address: object expected");
            message.address = $root.Address.fromObject(object.address);
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".Contact.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".Contact.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        switch (object.tax_residence_status) {
        case "UNKNOWN":
        case 0:
            message.tax_residence_status = 0;
            break;
        case "SPECIFIED":
        case 1:
            message.tax_residence_status = 1;
            break;
        case "UNSPECIFIED":
        case 2:
            message.tax_residence_status = 2;
            break;
        }
        if (object.lead_product_intents) {
            if (!Array.isArray(object.lead_product_intents))
                throw TypeError(".Contact.lead_product_intents: array expected");
            message.lead_product_intents = [];
            for (let i = 0; i < object.lead_product_intents.length; ++i) {
                if (typeof object.lead_product_intents[i] !== "object")
                    throw TypeError(".Contact.lead_product_intents: object expected");
                message.lead_product_intents[i] = $root.LeadProductIntent.fromObject(object.lead_product_intents[i]);
            }
        }
        if (object.preferred_name != null) {
            if (typeof object.preferred_name !== "object")
                throw TypeError(".Contact.preferred_name: object expected");
            message.preferred_name = $root.google.protobuf.StringValue.fromObject(object.preferred_name);
        }
        switch (object.tax_group) {
        case "UNKNOWN":
        case 0:
            message.tax_group = 0;
            break;
        case "UNSPECIFIED":
        case 1:
            message.tax_group = 1;
            break;
        case "AUSTRALIA_ONLY":
        case 2:
            message.tax_group = 2;
            break;
        case "AUSTRALIA_AND_OVERSEAS":
        case 3:
            message.tax_group = 3;
            break;
        case "OVERSEAS_ONLY":
        case 4:
            message.tax_group = 4;
            break;
        }
        switch (object.partner_name) {
        case "UNKNOWN":
        case 0:
            message.partner_name = 0;
            break;
        case "NONE":
        case 1:
            message.partner_name = 1;
            break;
        case "EMPLOYMENT_HERO":
        case 2:
            message.partner_name = 2;
            break;
        case "BOOKIPI":
        case 3:
            message.partner_name = 3;
            break;
        case "FOUNDU":
        case 4:
            message.partner_name = 4;
            break;
        case "FLARE":
        case 5:
            message.partner_name = 5;
            break;
        }
        if (object.password_last_updated_at != null) {
            if (typeof object.password_last_updated_at !== "object")
                throw TypeError(".Contact.password_last_updated_at: object expected");
            message.password_last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.password_last_updated_at);
        }
        if (object.pub_key != null)
            message.pub_key = String(object.pub_key);
        if (object.vault_key_version != null)
            message.vault_key_version = object.vault_key_version | 0;
        return message;
    };

    /**
     * Creates a plain object from a Contact message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Contact
     * @static
     * @param {Contact} message Contact
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Contact.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.lead_product_intents = [];
        if (options.defaults) {
            object.id = "";
            object.account_id = "";
            object.first_name = "";
            object.last_name = "";
            object.phone_number = "";
            object.email_address = "";
            object.date_of_birth = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.address = null;
            object.created_at = null;
            object.last_updated_at = null;
            object.tax_residence_status = options.enums === String ? "UNKNOWN" : 0;
            object.preferred_name = null;
            object.tax_group = options.enums === String ? "UNKNOWN" : 0;
            object.partner_name = options.enums === String ? "UNKNOWN" : 0;
            object.pub_key = "";
            object.vault_key_version = 0;
            object.password_last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            object.account_id = message.account_id;
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            object.first_name = message.first_name;
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            object.last_name = message.last_name;
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            object.phone_number = message.phone_number;
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            object.email_address = message.email_address;
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            object.date_of_birth = message.date_of_birth;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.ContactStatus.Enum[message.status] : message.status;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = $root.Address.toObject(message.address, options);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        if (message.tax_residence_status != null && message.hasOwnProperty("tax_residence_status"))
            object.tax_residence_status = options.enums === String ? $root.TaxResidenceStatus.Enum[message.tax_residence_status] : message.tax_residence_status;
        if (message.lead_product_intents && message.lead_product_intents.length) {
            object.lead_product_intents = [];
            for (let j = 0; j < message.lead_product_intents.length; ++j)
                object.lead_product_intents[j] = $root.LeadProductIntent.toObject(message.lead_product_intents[j], options);
        }
        if (message.preferred_name != null && message.hasOwnProperty("preferred_name"))
            object.preferred_name = $root.google.protobuf.StringValue.toObject(message.preferred_name, options);
        if (message.tax_group != null && message.hasOwnProperty("tax_group"))
            object.tax_group = options.enums === String ? $root.TaxGroup.Enum[message.tax_group] : message.tax_group;
        if (message.partner_name != null && message.hasOwnProperty("partner_name"))
            object.partner_name = options.enums === String ? $root.PartnerName.Enum[message.partner_name] : message.partner_name;
        if (message.pub_key != null && message.hasOwnProperty("pub_key"))
            object.pub_key = message.pub_key;
        if (message.vault_key_version != null && message.hasOwnProperty("vault_key_version"))
            object.vault_key_version = message.vault_key_version;
        if (message.password_last_updated_at != null && message.hasOwnProperty("password_last_updated_at"))
            object.password_last_updated_at = $root.google.protobuf.Timestamp.toObject(message.password_last_updated_at, options);
        return object;
    };

    /**
     * Converts this Contact to JSON.
     * @function toJSON
     * @memberof Contact
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Contact.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Contact;
})();

export const Address = $root.Address = (() => {

    /**
     * Properties of an Address.
     * @exports IAddress
     * @interface IAddress
     * @property {string|null} [street_address] Address street_address
     * @property {string|null} [suburb] Address suburb
     * @property {string|null} [state] Address state
     * @property {string|null} [postcode] Address postcode
     * @property {string|null} [country] Address country
     * @property {string|null} [raw_address] Address raw_address
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] Address last_updated_at
     * @property {string|null} [unit_number] Address unit_number
     * @property {string|null} [street_number] Address street_number
     * @property {string|null} [street_name] Address street_name
     * @property {string|null} [street_type] Address street_type
     * @property {string|null} [tax_reason] Address tax_reason
     */

    /**
     * Constructs a new Address.
     * @exports Address
     * @classdesc Represents an Address.
     * @implements IAddress
     * @constructor
     * @param {IAddress=} [properties] Properties to set
     */
    function Address(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Address street_address.
     * @member {string} street_address
     * @memberof Address
     * @instance
     */
    Address.prototype.street_address = "";

    /**
     * Address suburb.
     * @member {string} suburb
     * @memberof Address
     * @instance
     */
    Address.prototype.suburb = "";

    /**
     * Address state.
     * @member {string} state
     * @memberof Address
     * @instance
     */
    Address.prototype.state = "";

    /**
     * Address postcode.
     * @member {string} postcode
     * @memberof Address
     * @instance
     */
    Address.prototype.postcode = "";

    /**
     * Address country.
     * @member {string} country
     * @memberof Address
     * @instance
     */
    Address.prototype.country = "";

    /**
     * Address raw_address.
     * @member {string} raw_address
     * @memberof Address
     * @instance
     */
    Address.prototype.raw_address = "";

    /**
     * Address last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof Address
     * @instance
     */
    Address.prototype.last_updated_at = null;

    /**
     * Address unit_number.
     * @member {string} unit_number
     * @memberof Address
     * @instance
     */
    Address.prototype.unit_number = "";

    /**
     * Address street_number.
     * @member {string} street_number
     * @memberof Address
     * @instance
     */
    Address.prototype.street_number = "";

    /**
     * Address street_name.
     * @member {string} street_name
     * @memberof Address
     * @instance
     */
    Address.prototype.street_name = "";

    /**
     * Address street_type.
     * @member {string} street_type
     * @memberof Address
     * @instance
     */
    Address.prototype.street_type = "";

    /**
     * Address tax_reason.
     * @member {string} tax_reason
     * @memberof Address
     * @instance
     */
    Address.prototype.tax_reason = "";

    /**
     * Creates a new Address instance using the specified properties.
     * @function create
     * @memberof Address
     * @static
     * @param {IAddress=} [properties] Properties to set
     * @returns {Address} Address instance
     */
    Address.create = function create(properties) {
        return new Address(properties);
    };

    /**
     * Encodes the specified Address message. Does not implicitly {@link Address.verify|verify} messages.
     * @function encode
     * @memberof Address
     * @static
     * @param {IAddress} message Address message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Address.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.street_address != null && message.hasOwnProperty("street_address"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.street_address);
        if (message.suburb != null && message.hasOwnProperty("suburb"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.suburb);
        if (message.state != null && message.hasOwnProperty("state"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.state);
        if (message.postcode != null && message.hasOwnProperty("postcode"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.postcode);
        if (message.country != null && message.hasOwnProperty("country"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.country);
        if (message.raw_address != null && message.hasOwnProperty("raw_address"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.raw_address);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.unit_number != null && message.hasOwnProperty("unit_number"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.unit_number);
        if (message.street_number != null && message.hasOwnProperty("street_number"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.street_number);
        if (message.street_name != null && message.hasOwnProperty("street_name"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.street_name);
        if (message.street_type != null && message.hasOwnProperty("street_type"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.street_type);
        if (message.tax_reason != null && message.hasOwnProperty("tax_reason"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.tax_reason);
        return writer;
    };

    /**
     * Encodes the specified Address message, length delimited. Does not implicitly {@link Address.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Address
     * @static
     * @param {IAddress} message Address message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Address.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Address message from the specified reader or buffer.
     * @function decode
     * @memberof Address
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Address} Address
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Address.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Address();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.street_address = reader.string();
                break;
            case 2:
                message.suburb = reader.string();
                break;
            case 3:
                message.state = reader.string();
                break;
            case 4:
                message.postcode = reader.string();
                break;
            case 5:
                message.country = reader.string();
                break;
            case 6:
                message.raw_address = reader.string();
                break;
            case 7:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 8:
                message.unit_number = reader.string();
                break;
            case 9:
                message.street_number = reader.string();
                break;
            case 10:
                message.street_name = reader.string();
                break;
            case 11:
                message.street_type = reader.string();
                break;
            case 12:
                message.tax_reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Address message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Address
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Address} Address
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Address.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Address message.
     * @function verify
     * @memberof Address
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Address.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.street_address != null && message.hasOwnProperty("street_address"))
            if (!$util.isString(message.street_address))
                return "street_address: string expected";
        if (message.suburb != null && message.hasOwnProperty("suburb"))
            if (!$util.isString(message.suburb))
                return "suburb: string expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!$util.isString(message.state))
                return "state: string expected";
        if (message.postcode != null && message.hasOwnProperty("postcode"))
            if (!$util.isString(message.postcode))
                return "postcode: string expected";
        if (message.country != null && message.hasOwnProperty("country"))
            if (!$util.isString(message.country))
                return "country: string expected";
        if (message.raw_address != null && message.hasOwnProperty("raw_address"))
            if (!$util.isString(message.raw_address))
                return "raw_address: string expected";
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        if (message.unit_number != null && message.hasOwnProperty("unit_number"))
            if (!$util.isString(message.unit_number))
                return "unit_number: string expected";
        if (message.street_number != null && message.hasOwnProperty("street_number"))
            if (!$util.isString(message.street_number))
                return "street_number: string expected";
        if (message.street_name != null && message.hasOwnProperty("street_name"))
            if (!$util.isString(message.street_name))
                return "street_name: string expected";
        if (message.street_type != null && message.hasOwnProperty("street_type"))
            if (!$util.isString(message.street_type))
                return "street_type: string expected";
        if (message.tax_reason != null && message.hasOwnProperty("tax_reason"))
            if (!$util.isString(message.tax_reason))
                return "tax_reason: string expected";
        return null;
    };

    /**
     * Creates an Address message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Address
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Address} Address
     */
    Address.fromObject = function fromObject(object) {
        if (object instanceof $root.Address)
            return object;
        let message = new $root.Address();
        if (object.street_address != null)
            message.street_address = String(object.street_address);
        if (object.suburb != null)
            message.suburb = String(object.suburb);
        if (object.state != null)
            message.state = String(object.state);
        if (object.postcode != null)
            message.postcode = String(object.postcode);
        if (object.country != null)
            message.country = String(object.country);
        if (object.raw_address != null)
            message.raw_address = String(object.raw_address);
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".Address.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        if (object.unit_number != null)
            message.unit_number = String(object.unit_number);
        if (object.street_number != null)
            message.street_number = String(object.street_number);
        if (object.street_name != null)
            message.street_name = String(object.street_name);
        if (object.street_type != null)
            message.street_type = String(object.street_type);
        if (object.tax_reason != null)
            message.tax_reason = String(object.tax_reason);
        return message;
    };

    /**
     * Creates a plain object from an Address message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Address
     * @static
     * @param {Address} message Address
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Address.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.street_address = "";
            object.suburb = "";
            object.state = "";
            object.postcode = "";
            object.country = "";
            object.raw_address = "";
            object.last_updated_at = null;
            object.unit_number = "";
            object.street_number = "";
            object.street_name = "";
            object.street_type = "";
            object.tax_reason = "";
        }
        if (message.street_address != null && message.hasOwnProperty("street_address"))
            object.street_address = message.street_address;
        if (message.suburb != null && message.hasOwnProperty("suburb"))
            object.suburb = message.suburb;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
        if (message.postcode != null && message.hasOwnProperty("postcode"))
            object.postcode = message.postcode;
        if (message.country != null && message.hasOwnProperty("country"))
            object.country = message.country;
        if (message.raw_address != null && message.hasOwnProperty("raw_address"))
            object.raw_address = message.raw_address;
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        if (message.unit_number != null && message.hasOwnProperty("unit_number"))
            object.unit_number = message.unit_number;
        if (message.street_number != null && message.hasOwnProperty("street_number"))
            object.street_number = message.street_number;
        if (message.street_name != null && message.hasOwnProperty("street_name"))
            object.street_name = message.street_name;
        if (message.street_type != null && message.hasOwnProperty("street_type"))
            object.street_type = message.street_type;
        if (message.tax_reason != null && message.hasOwnProperty("tax_reason"))
            object.tax_reason = message.tax_reason;
        return object;
    };

    /**
     * Converts this Address to JSON.
     * @function toJSON
     * @memberof Address
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Address.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Address;
})();

export const FraudServiceCheck = $root.FraudServiceCheck = (() => {

    /**
     * Properties of a FraudServiceCheck.
     * @exports IFraudServiceCheck
     * @interface IFraudServiceCheck
     * @property {FraudService.Enum|null} [service] FraudServiceCheck service
     * @property {FraudVerificationStatus.Enum|null} [status] FraudServiceCheck status
     * @property {string|null} [id] FraudServiceCheck id
     * @property {google.protobuf.ITimestamp|null} [last_checked_at] FraudServiceCheck last_checked_at
     */

    /**
     * Constructs a new FraudServiceCheck.
     * @exports FraudServiceCheck
     * @classdesc Represents a FraudServiceCheck.
     * @implements IFraudServiceCheck
     * @constructor
     * @param {IFraudServiceCheck=} [properties] Properties to set
     */
    function FraudServiceCheck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FraudServiceCheck service.
     * @member {FraudService.Enum} service
     * @memberof FraudServiceCheck
     * @instance
     */
    FraudServiceCheck.prototype.service = 0;

    /**
     * FraudServiceCheck status.
     * @member {FraudVerificationStatus.Enum} status
     * @memberof FraudServiceCheck
     * @instance
     */
    FraudServiceCheck.prototype.status = 0;

    /**
     * FraudServiceCheck id.
     * @member {string} id
     * @memberof FraudServiceCheck
     * @instance
     */
    FraudServiceCheck.prototype.id = "";

    /**
     * FraudServiceCheck last_checked_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_checked_at
     * @memberof FraudServiceCheck
     * @instance
     */
    FraudServiceCheck.prototype.last_checked_at = null;

    /**
     * Creates a new FraudServiceCheck instance using the specified properties.
     * @function create
     * @memberof FraudServiceCheck
     * @static
     * @param {IFraudServiceCheck=} [properties] Properties to set
     * @returns {FraudServiceCheck} FraudServiceCheck instance
     */
    FraudServiceCheck.create = function create(properties) {
        return new FraudServiceCheck(properties);
    };

    /**
     * Encodes the specified FraudServiceCheck message. Does not implicitly {@link FraudServiceCheck.verify|verify} messages.
     * @function encode
     * @memberof FraudServiceCheck
     * @static
     * @param {IFraudServiceCheck} message FraudServiceCheck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FraudServiceCheck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.service != null && message.hasOwnProperty("service"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.service);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
        if (message.last_checked_at != null && message.hasOwnProperty("last_checked_at"))
            $root.google.protobuf.Timestamp.encode(message.last_checked_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FraudServiceCheck message, length delimited. Does not implicitly {@link FraudServiceCheck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FraudServiceCheck
     * @static
     * @param {IFraudServiceCheck} message FraudServiceCheck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FraudServiceCheck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FraudServiceCheck message from the specified reader or buffer.
     * @function decode
     * @memberof FraudServiceCheck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FraudServiceCheck} FraudServiceCheck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FraudServiceCheck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FraudServiceCheck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.service = reader.int32();
                break;
            case 2:
                message.status = reader.int32();
                break;
            case 3:
                message.id = reader.string();
                break;
            case 99:
                message.last_checked_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FraudServiceCheck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FraudServiceCheck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FraudServiceCheck} FraudServiceCheck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FraudServiceCheck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FraudServiceCheck message.
     * @function verify
     * @memberof FraudServiceCheck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FraudServiceCheck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.service != null && message.hasOwnProperty("service"))
            switch (message.service) {
            default:
                return "service: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.last_checked_at != null && message.hasOwnProperty("last_checked_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_checked_at);
            if (error)
                return "last_checked_at." + error;
        }
        return null;
    };

    /**
     * Creates a FraudServiceCheck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FraudServiceCheck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FraudServiceCheck} FraudServiceCheck
     */
    FraudServiceCheck.fromObject = function fromObject(object) {
        if (object instanceof $root.FraudServiceCheck)
            return object;
        let message = new $root.FraudServiceCheck();
        switch (object.service) {
        case "UNKNOWN":
        case 0:
            message.service = 0;
            break;
        case "EHAWK":
        case 1:
            message.service = 1;
            break;
        case "GREENID":
        case 2:
            message.service = 2;
            break;
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PENDING":
        case 1:
            message.status = 1;
            break;
        case "AUTOMATICALLY_REJECTED":
        case 2:
            message.status = 2;
            break;
        case "AUTOMATICALLY_VERIFIED":
        case 3:
            message.status = 3;
            break;
        case "MANUALLY_REJECTED":
        case 4:
            message.status = 4;
            break;
        case "MANUALLY_VERIFIED":
        case 5:
            message.status = 5;
            break;
        case "ERROR":
        case 6:
            message.status = 6;
            break;
        case "DOCUMENT_IN_REVIEW":
        case 7:
            message.status = 7;
            break;
        case "DOCUMENT_UPLOAD_REQUIRED":
        case 8:
            message.status = 8;
            break;
        }
        if (object.id != null)
            message.id = String(object.id);
        if (object.last_checked_at != null) {
            if (typeof object.last_checked_at !== "object")
                throw TypeError(".FraudServiceCheck.last_checked_at: object expected");
            message.last_checked_at = $root.google.protobuf.Timestamp.fromObject(object.last_checked_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a FraudServiceCheck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FraudServiceCheck
     * @static
     * @param {FraudServiceCheck} message FraudServiceCheck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FraudServiceCheck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.service = options.enums === String ? "UNKNOWN" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.id = "";
            object.last_checked_at = null;
        }
        if (message.service != null && message.hasOwnProperty("service"))
            object.service = options.enums === String ? $root.FraudService.Enum[message.service] : message.service;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.FraudVerificationStatus.Enum[message.status] : message.status;
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.last_checked_at != null && message.hasOwnProperty("last_checked_at"))
            object.last_checked_at = $root.google.protobuf.Timestamp.toObject(message.last_checked_at, options);
        return object;
    };

    /**
     * Converts this FraudServiceCheck to JSON.
     * @function toJSON
     * @memberof FraudServiceCheck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FraudServiceCheck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FraudServiceCheck;
})();

export const GreenIdSourceDetails = $root.GreenIdSourceDetails = (() => {

    /**
     * Properties of a GreenIdSourceDetails.
     * @exports IGreenIdSourceDetails
     * @interface IGreenIdSourceDetails
     * @property {string|null} [sources_left_to_verify] GreenIdSourceDetails sources_left_to_verify
     * @property {Array.<IGreenIdInteractiveSource>|null} [interactive_sources] GreenIdSourceDetails interactive_sources
     */

    /**
     * Constructs a new GreenIdSourceDetails.
     * @exports GreenIdSourceDetails
     * @classdesc Represents a GreenIdSourceDetails.
     * @implements IGreenIdSourceDetails
     * @constructor
     * @param {IGreenIdSourceDetails=} [properties] Properties to set
     */
    function GreenIdSourceDetails(properties) {
        this.interactive_sources = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GreenIdSourceDetails sources_left_to_verify.
     * @member {string} sources_left_to_verify
     * @memberof GreenIdSourceDetails
     * @instance
     */
    GreenIdSourceDetails.prototype.sources_left_to_verify = "";

    /**
     * GreenIdSourceDetails interactive_sources.
     * @member {Array.<IGreenIdInteractiveSource>} interactive_sources
     * @memberof GreenIdSourceDetails
     * @instance
     */
    GreenIdSourceDetails.prototype.interactive_sources = $util.emptyArray;

    /**
     * Creates a new GreenIdSourceDetails instance using the specified properties.
     * @function create
     * @memberof GreenIdSourceDetails
     * @static
     * @param {IGreenIdSourceDetails=} [properties] Properties to set
     * @returns {GreenIdSourceDetails} GreenIdSourceDetails instance
     */
    GreenIdSourceDetails.create = function create(properties) {
        return new GreenIdSourceDetails(properties);
    };

    /**
     * Encodes the specified GreenIdSourceDetails message. Does not implicitly {@link GreenIdSourceDetails.verify|verify} messages.
     * @function encode
     * @memberof GreenIdSourceDetails
     * @static
     * @param {IGreenIdSourceDetails} message GreenIdSourceDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdSourceDetails.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.sources_left_to_verify != null && message.hasOwnProperty("sources_left_to_verify"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.sources_left_to_verify);
        if (message.interactive_sources != null && message.interactive_sources.length)
            for (let i = 0; i < message.interactive_sources.length; ++i)
                $root.GreenIdInteractiveSource.encode(message.interactive_sources[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GreenIdSourceDetails message, length delimited. Does not implicitly {@link GreenIdSourceDetails.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GreenIdSourceDetails
     * @static
     * @param {IGreenIdSourceDetails} message GreenIdSourceDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdSourceDetails.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GreenIdSourceDetails message from the specified reader or buffer.
     * @function decode
     * @memberof GreenIdSourceDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GreenIdSourceDetails} GreenIdSourceDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdSourceDetails.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GreenIdSourceDetails();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.sources_left_to_verify = reader.string();
                break;
            case 2:
                if (!(message.interactive_sources && message.interactive_sources.length))
                    message.interactive_sources = [];
                message.interactive_sources.push($root.GreenIdInteractiveSource.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GreenIdSourceDetails message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GreenIdSourceDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GreenIdSourceDetails} GreenIdSourceDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdSourceDetails.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GreenIdSourceDetails message.
     * @function verify
     * @memberof GreenIdSourceDetails
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GreenIdSourceDetails.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.sources_left_to_verify != null && message.hasOwnProperty("sources_left_to_verify"))
            if (!$util.isString(message.sources_left_to_verify))
                return "sources_left_to_verify: string expected";
        if (message.interactive_sources != null && message.hasOwnProperty("interactive_sources")) {
            if (!Array.isArray(message.interactive_sources))
                return "interactive_sources: array expected";
            for (let i = 0; i < message.interactive_sources.length; ++i) {
                let error = $root.GreenIdInteractiveSource.verify(message.interactive_sources[i]);
                if (error)
                    return "interactive_sources." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GreenIdSourceDetails message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GreenIdSourceDetails
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GreenIdSourceDetails} GreenIdSourceDetails
     */
    GreenIdSourceDetails.fromObject = function fromObject(object) {
        if (object instanceof $root.GreenIdSourceDetails)
            return object;
        let message = new $root.GreenIdSourceDetails();
        if (object.sources_left_to_verify != null)
            message.sources_left_to_verify = String(object.sources_left_to_verify);
        if (object.interactive_sources) {
            if (!Array.isArray(object.interactive_sources))
                throw TypeError(".GreenIdSourceDetails.interactive_sources: array expected");
            message.interactive_sources = [];
            for (let i = 0; i < object.interactive_sources.length; ++i) {
                if (typeof object.interactive_sources[i] !== "object")
                    throw TypeError(".GreenIdSourceDetails.interactive_sources: object expected");
                message.interactive_sources[i] = $root.GreenIdInteractiveSource.fromObject(object.interactive_sources[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GreenIdSourceDetails message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GreenIdSourceDetails
     * @static
     * @param {GreenIdSourceDetails} message GreenIdSourceDetails
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GreenIdSourceDetails.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.interactive_sources = [];
        if (options.defaults)
            object.sources_left_to_verify = "";
        if (message.sources_left_to_verify != null && message.hasOwnProperty("sources_left_to_verify"))
            object.sources_left_to_verify = message.sources_left_to_verify;
        if (message.interactive_sources && message.interactive_sources.length) {
            object.interactive_sources = [];
            for (let j = 0; j < message.interactive_sources.length; ++j)
                object.interactive_sources[j] = $root.GreenIdInteractiveSource.toObject(message.interactive_sources[j], options);
        }
        return object;
    };

    /**
     * Converts this GreenIdSourceDetails to JSON.
     * @function toJSON
     * @memberof GreenIdSourceDetails
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GreenIdSourceDetails.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GreenIdSourceDetails;
})();

export const GreenIdIdentityCheck = $root.GreenIdIdentityCheck = (() => {

    /**
     * Properties of a GreenIdIdentityCheck.
     * @exports IGreenIdIdentityCheck
     * @interface IGreenIdIdentityCheck
     * @property {string|null} [contact_id] GreenIdIdentityCheck contact_id
     * @property {string|null} [verification_id] GreenIdIdentityCheck verification_id
     * @property {FraudVerificationStatus.Enum|null} [verification_status] GreenIdIdentityCheck verification_status
     * @property {string|null} [id] GreenIdIdentityCheck id
     * @property {string|null} [background_sources_passed] GreenIdIdentityCheck background_sources_passed
     * @property {string|null} [interactive_sources_passed] GreenIdIdentityCheck interactive_sources_passed
     * @property {string|null} [background_sources_required] GreenIdIdentityCheck background_sources_required
     * @property {string|null} [interactive_sources_required] GreenIdIdentityCheck interactive_sources_required
     * @property {string|null} [total_sources_required] GreenIdIdentityCheck total_sources_required
     * @property {GreenIdRuleSet.Enum|null} [rule_set] GreenIdIdentityCheck rule_set
     * @property {google.protobuf.ITimestamp|null} [created_at] GreenIdIdentityCheck created_at
     */

    /**
     * Constructs a new GreenIdIdentityCheck.
     * @exports GreenIdIdentityCheck
     * @classdesc Represents a GreenIdIdentityCheck.
     * @implements IGreenIdIdentityCheck
     * @constructor
     * @param {IGreenIdIdentityCheck=} [properties] Properties to set
     */
    function GreenIdIdentityCheck(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GreenIdIdentityCheck contact_id.
     * @member {string} contact_id
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.contact_id = "";

    /**
     * GreenIdIdentityCheck verification_id.
     * @member {string} verification_id
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.verification_id = "";

    /**
     * GreenIdIdentityCheck verification_status.
     * @member {FraudVerificationStatus.Enum} verification_status
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.verification_status = 0;

    /**
     * GreenIdIdentityCheck id.
     * @member {string} id
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.id = "";

    /**
     * GreenIdIdentityCheck background_sources_passed.
     * @member {string} background_sources_passed
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.background_sources_passed = "";

    /**
     * GreenIdIdentityCheck interactive_sources_passed.
     * @member {string} interactive_sources_passed
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.interactive_sources_passed = "";

    /**
     * GreenIdIdentityCheck background_sources_required.
     * @member {string} background_sources_required
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.background_sources_required = "";

    /**
     * GreenIdIdentityCheck interactive_sources_required.
     * @member {string} interactive_sources_required
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.interactive_sources_required = "";

    /**
     * GreenIdIdentityCheck total_sources_required.
     * @member {string} total_sources_required
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.total_sources_required = "";

    /**
     * GreenIdIdentityCheck rule_set.
     * @member {GreenIdRuleSet.Enum} rule_set
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.rule_set = 0;

    /**
     * GreenIdIdentityCheck created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof GreenIdIdentityCheck
     * @instance
     */
    GreenIdIdentityCheck.prototype.created_at = null;

    /**
     * Creates a new GreenIdIdentityCheck instance using the specified properties.
     * @function create
     * @memberof GreenIdIdentityCheck
     * @static
     * @param {IGreenIdIdentityCheck=} [properties] Properties to set
     * @returns {GreenIdIdentityCheck} GreenIdIdentityCheck instance
     */
    GreenIdIdentityCheck.create = function create(properties) {
        return new GreenIdIdentityCheck(properties);
    };

    /**
     * Encodes the specified GreenIdIdentityCheck message. Does not implicitly {@link GreenIdIdentityCheck.verify|verify} messages.
     * @function encode
     * @memberof GreenIdIdentityCheck
     * @static
     * @param {IGreenIdIdentityCheck} message GreenIdIdentityCheck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdIdentityCheck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.contact_id);
        if (message.verification_id != null && message.hasOwnProperty("verification_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.verification_id);
        if (message.verification_status != null && message.hasOwnProperty("verification_status"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.verification_status);
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.id);
        if (message.background_sources_passed != null && message.hasOwnProperty("background_sources_passed"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.background_sources_passed);
        if (message.interactive_sources_passed != null && message.hasOwnProperty("interactive_sources_passed"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.interactive_sources_passed);
        if (message.background_sources_required != null && message.hasOwnProperty("background_sources_required"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.background_sources_required);
        if (message.interactive_sources_required != null && message.hasOwnProperty("interactive_sources_required"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.interactive_sources_required);
        if (message.total_sources_required != null && message.hasOwnProperty("total_sources_required"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.total_sources_required);
        if (message.rule_set != null && message.hasOwnProperty("rule_set"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.rule_set);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GreenIdIdentityCheck message, length delimited. Does not implicitly {@link GreenIdIdentityCheck.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GreenIdIdentityCheck
     * @static
     * @param {IGreenIdIdentityCheck} message GreenIdIdentityCheck message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdIdentityCheck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GreenIdIdentityCheck message from the specified reader or buffer.
     * @function decode
     * @memberof GreenIdIdentityCheck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GreenIdIdentityCheck} GreenIdIdentityCheck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdIdentityCheck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GreenIdIdentityCheck();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.contact_id = reader.string();
                break;
            case 2:
                message.verification_id = reader.string();
                break;
            case 3:
                message.verification_status = reader.int32();
                break;
            case 4:
                message.id = reader.string();
                break;
            case 5:
                message.background_sources_passed = reader.string();
                break;
            case 6:
                message.interactive_sources_passed = reader.string();
                break;
            case 7:
                message.background_sources_required = reader.string();
                break;
            case 8:
                message.interactive_sources_required = reader.string();
                break;
            case 9:
                message.total_sources_required = reader.string();
                break;
            case 10:
                message.rule_set = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GreenIdIdentityCheck message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GreenIdIdentityCheck
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GreenIdIdentityCheck} GreenIdIdentityCheck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdIdentityCheck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GreenIdIdentityCheck message.
     * @function verify
     * @memberof GreenIdIdentityCheck
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GreenIdIdentityCheck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            if (!$util.isString(message.contact_id))
                return "contact_id: string expected";
        if (message.verification_id != null && message.hasOwnProperty("verification_id"))
            if (!$util.isString(message.verification_id))
                return "verification_id: string expected";
        if (message.verification_status != null && message.hasOwnProperty("verification_status"))
            switch (message.verification_status) {
            default:
                return "verification_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.background_sources_passed != null && message.hasOwnProperty("background_sources_passed"))
            if (!$util.isString(message.background_sources_passed))
                return "background_sources_passed: string expected";
        if (message.interactive_sources_passed != null && message.hasOwnProperty("interactive_sources_passed"))
            if (!$util.isString(message.interactive_sources_passed))
                return "interactive_sources_passed: string expected";
        if (message.background_sources_required != null && message.hasOwnProperty("background_sources_required"))
            if (!$util.isString(message.background_sources_required))
                return "background_sources_required: string expected";
        if (message.interactive_sources_required != null && message.hasOwnProperty("interactive_sources_required"))
            if (!$util.isString(message.interactive_sources_required))
                return "interactive_sources_required: string expected";
        if (message.total_sources_required != null && message.hasOwnProperty("total_sources_required"))
            if (!$util.isString(message.total_sources_required))
                return "total_sources_required: string expected";
        if (message.rule_set != null && message.hasOwnProperty("rule_set"))
            switch (message.rule_set) {
            default:
                return "rule_set: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a GreenIdIdentityCheck message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GreenIdIdentityCheck
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GreenIdIdentityCheck} GreenIdIdentityCheck
     */
    GreenIdIdentityCheck.fromObject = function fromObject(object) {
        if (object instanceof $root.GreenIdIdentityCheck)
            return object;
        let message = new $root.GreenIdIdentityCheck();
        if (object.contact_id != null)
            message.contact_id = String(object.contact_id);
        if (object.verification_id != null)
            message.verification_id = String(object.verification_id);
        switch (object.verification_status) {
        case "UNKNOWN":
        case 0:
            message.verification_status = 0;
            break;
        case "PENDING":
        case 1:
            message.verification_status = 1;
            break;
        case "AUTOMATICALLY_REJECTED":
        case 2:
            message.verification_status = 2;
            break;
        case "AUTOMATICALLY_VERIFIED":
        case 3:
            message.verification_status = 3;
            break;
        case "MANUALLY_REJECTED":
        case 4:
            message.verification_status = 4;
            break;
        case "MANUALLY_VERIFIED":
        case 5:
            message.verification_status = 5;
            break;
        case "ERROR":
        case 6:
            message.verification_status = 6;
            break;
        case "DOCUMENT_IN_REVIEW":
        case 7:
            message.verification_status = 7;
            break;
        case "DOCUMENT_UPLOAD_REQUIRED":
        case 8:
            message.verification_status = 8;
            break;
        }
        if (object.id != null)
            message.id = String(object.id);
        if (object.background_sources_passed != null)
            message.background_sources_passed = String(object.background_sources_passed);
        if (object.interactive_sources_passed != null)
            message.interactive_sources_passed = String(object.interactive_sources_passed);
        if (object.background_sources_required != null)
            message.background_sources_required = String(object.background_sources_required);
        if (object.interactive_sources_required != null)
            message.interactive_sources_required = String(object.interactive_sources_required);
        if (object.total_sources_required != null)
            message.total_sources_required = String(object.total_sources_required);
        switch (object.rule_set) {
        case "UNKNOWN":
        case 0:
            message.rule_set = 0;
            break;
        case "VOYAGER_ONBOARDING":
        case 1:
            message.rule_set = 1;
            break;
        case "SUPERMATCH":
        case 2:
            message.rule_set = 2;
            break;
        case "NOVA":
        case 3:
            message.rule_set = 3;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".GreenIdIdentityCheck.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a GreenIdIdentityCheck message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GreenIdIdentityCheck
     * @static
     * @param {GreenIdIdentityCheck} message GreenIdIdentityCheck
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GreenIdIdentityCheck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.contact_id = "";
            object.verification_id = "";
            object.verification_status = options.enums === String ? "UNKNOWN" : 0;
            object.id = "";
            object.background_sources_passed = "";
            object.interactive_sources_passed = "";
            object.background_sources_required = "";
            object.interactive_sources_required = "";
            object.total_sources_required = "";
            object.rule_set = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
        }
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            object.contact_id = message.contact_id;
        if (message.verification_id != null && message.hasOwnProperty("verification_id"))
            object.verification_id = message.verification_id;
        if (message.verification_status != null && message.hasOwnProperty("verification_status"))
            object.verification_status = options.enums === String ? $root.FraudVerificationStatus.Enum[message.verification_status] : message.verification_status;
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.background_sources_passed != null && message.hasOwnProperty("background_sources_passed"))
            object.background_sources_passed = message.background_sources_passed;
        if (message.interactive_sources_passed != null && message.hasOwnProperty("interactive_sources_passed"))
            object.interactive_sources_passed = message.interactive_sources_passed;
        if (message.background_sources_required != null && message.hasOwnProperty("background_sources_required"))
            object.background_sources_required = message.background_sources_required;
        if (message.interactive_sources_required != null && message.hasOwnProperty("interactive_sources_required"))
            object.interactive_sources_required = message.interactive_sources_required;
        if (message.total_sources_required != null && message.hasOwnProperty("total_sources_required"))
            object.total_sources_required = message.total_sources_required;
        if (message.rule_set != null && message.hasOwnProperty("rule_set"))
            object.rule_set = options.enums === String ? $root.GreenIdRuleSet.Enum[message.rule_set] : message.rule_set;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this GreenIdIdentityCheck to JSON.
     * @function toJSON
     * @memberof GreenIdIdentityCheck
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GreenIdIdentityCheck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GreenIdIdentityCheck;
})();

export const EmailVerificationStatus = $root.EmailVerificationStatus = (() => {

    /**
     * Properties of an EmailVerificationStatus.
     * @exports IEmailVerificationStatus
     * @interface IEmailVerificationStatus
     */

    /**
     * Constructs a new EmailVerificationStatus.
     * @exports EmailVerificationStatus
     * @classdesc Represents an EmailVerificationStatus.
     * @implements IEmailVerificationStatus
     * @constructor
     * @param {IEmailVerificationStatus=} [properties] Properties to set
     */
    function EmailVerificationStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new EmailVerificationStatus instance using the specified properties.
     * @function create
     * @memberof EmailVerificationStatus
     * @static
     * @param {IEmailVerificationStatus=} [properties] Properties to set
     * @returns {EmailVerificationStatus} EmailVerificationStatus instance
     */
    EmailVerificationStatus.create = function create(properties) {
        return new EmailVerificationStatus(properties);
    };

    /**
     * Encodes the specified EmailVerificationStatus message. Does not implicitly {@link EmailVerificationStatus.verify|verify} messages.
     * @function encode
     * @memberof EmailVerificationStatus
     * @static
     * @param {IEmailVerificationStatus} message EmailVerificationStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EmailVerificationStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified EmailVerificationStatus message, length delimited. Does not implicitly {@link EmailVerificationStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EmailVerificationStatus
     * @static
     * @param {IEmailVerificationStatus} message EmailVerificationStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EmailVerificationStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an EmailVerificationStatus message from the specified reader or buffer.
     * @function decode
     * @memberof EmailVerificationStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EmailVerificationStatus} EmailVerificationStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EmailVerificationStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmailVerificationStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an EmailVerificationStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EmailVerificationStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EmailVerificationStatus} EmailVerificationStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EmailVerificationStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an EmailVerificationStatus message.
     * @function verify
     * @memberof EmailVerificationStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EmailVerificationStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an EmailVerificationStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EmailVerificationStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EmailVerificationStatus} EmailVerificationStatus
     */
    EmailVerificationStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.EmailVerificationStatus)
            return object;
        return new $root.EmailVerificationStatus();
    };

    /**
     * Creates a plain object from an EmailVerificationStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EmailVerificationStatus
     * @static
     * @param {EmailVerificationStatus} message EmailVerificationStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EmailVerificationStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this EmailVerificationStatus to JSON.
     * @function toJSON
     * @memberof EmailVerificationStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EmailVerificationStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name EmailVerificationStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PENDING=1 PENDING value
     * @property {number} VERIFIED=2 VERIFIED value
     * @property {number} EXPIRED=3 EXPIRED value
     */
    EmailVerificationStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PENDING"] = 1;
        values[valuesById[2] = "VERIFIED"] = 2;
        values[valuesById[3] = "EXPIRED"] = 3;
        return values;
    })();

    return EmailVerificationStatus;
})();

export const EmailVerification = $root.EmailVerification = (() => {

    /**
     * Properties of an EmailVerification.
     * @exports IEmailVerification
     * @interface IEmailVerification
     * @property {string|null} [id] EmailVerification id
     * @property {string|null} [contact_id] EmailVerification contact_id
     * @property {EmailVerificationStatus.Enum|null} [status] EmailVerification status
     * @property {google.protobuf.ITimestamp|null} [created_at] EmailVerification created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] EmailVerification last_updated_at
     */

    /**
     * Constructs a new EmailVerification.
     * @exports EmailVerification
     * @classdesc Represents an EmailVerification.
     * @implements IEmailVerification
     * @constructor
     * @param {IEmailVerification=} [properties] Properties to set
     */
    function EmailVerification(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * EmailVerification id.
     * @member {string} id
     * @memberof EmailVerification
     * @instance
     */
    EmailVerification.prototype.id = "";

    /**
     * EmailVerification contact_id.
     * @member {string} contact_id
     * @memberof EmailVerification
     * @instance
     */
    EmailVerification.prototype.contact_id = "";

    /**
     * EmailVerification status.
     * @member {EmailVerificationStatus.Enum} status
     * @memberof EmailVerification
     * @instance
     */
    EmailVerification.prototype.status = 0;

    /**
     * EmailVerification created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof EmailVerification
     * @instance
     */
    EmailVerification.prototype.created_at = null;

    /**
     * EmailVerification last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof EmailVerification
     * @instance
     */
    EmailVerification.prototype.last_updated_at = null;

    /**
     * Creates a new EmailVerification instance using the specified properties.
     * @function create
     * @memberof EmailVerification
     * @static
     * @param {IEmailVerification=} [properties] Properties to set
     * @returns {EmailVerification} EmailVerification instance
     */
    EmailVerification.create = function create(properties) {
        return new EmailVerification(properties);
    };

    /**
     * Encodes the specified EmailVerification message. Does not implicitly {@link EmailVerification.verify|verify} messages.
     * @function encode
     * @memberof EmailVerification
     * @static
     * @param {IEmailVerification} message EmailVerification message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EmailVerification.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.contact_id);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified EmailVerification message, length delimited. Does not implicitly {@link EmailVerification.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EmailVerification
     * @static
     * @param {IEmailVerification} message EmailVerification message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EmailVerification.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an EmailVerification message from the specified reader or buffer.
     * @function decode
     * @memberof EmailVerification
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EmailVerification} EmailVerification
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EmailVerification.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmailVerification();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.contact_id = reader.string();
                break;
            case 3:
                message.status = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an EmailVerification message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EmailVerification
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EmailVerification} EmailVerification
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EmailVerification.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an EmailVerification message.
     * @function verify
     * @memberof EmailVerification
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EmailVerification.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            if (!$util.isString(message.contact_id))
                return "contact_id: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates an EmailVerification message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EmailVerification
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EmailVerification} EmailVerification
     */
    EmailVerification.fromObject = function fromObject(object) {
        if (object instanceof $root.EmailVerification)
            return object;
        let message = new $root.EmailVerification();
        if (object.id != null)
            message.id = String(object.id);
        if (object.contact_id != null)
            message.contact_id = String(object.contact_id);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PENDING":
        case 1:
            message.status = 1;
            break;
        case "VERIFIED":
        case 2:
            message.status = 2;
            break;
        case "EXPIRED":
        case 3:
            message.status = 3;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".EmailVerification.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".EmailVerification.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an EmailVerification message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EmailVerification
     * @static
     * @param {EmailVerification} message EmailVerification
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EmailVerification.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.contact_id = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            object.contact_id = message.contact_id;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.EmailVerificationStatus.Enum[message.status] : message.status;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this EmailVerification to JSON.
     * @function toJSON
     * @memberof EmailVerification
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EmailVerification.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmailVerification;
})();

export const Document = $root.Document = (() => {

    /**
     * Properties of a Document.
     * @exports IDocument
     * @interface IDocument
     * @property {string|null} [id] Document id
     * @property {string|null} [contact_id] Document contact_id
     * @property {string|null} [email_address] Document email_address
     * @property {EmailTemplate.Enum|null} [template_name] Document template_name
     * @property {Object.<string,string>|null} [template_vars] Document template_vars
     * @property {DocumentStatus.Enum|null} [status] Document status
     * @property {google.protobuf.ITimestamp|null} [created_at] Document created_at
     */

    /**
     * Constructs a new Document.
     * @exports Document
     * @classdesc Represents a Document.
     * @implements IDocument
     * @constructor
     * @param {IDocument=} [properties] Properties to set
     */
    function Document(properties) {
        this.template_vars = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Document id.
     * @member {string} id
     * @memberof Document
     * @instance
     */
    Document.prototype.id = "";

    /**
     * Document contact_id.
     * @member {string} contact_id
     * @memberof Document
     * @instance
     */
    Document.prototype.contact_id = "";

    /**
     * Document email_address.
     * @member {string} email_address
     * @memberof Document
     * @instance
     */
    Document.prototype.email_address = "";

    /**
     * Document template_name.
     * @member {EmailTemplate.Enum} template_name
     * @memberof Document
     * @instance
     */
    Document.prototype.template_name = 0;

    /**
     * Document template_vars.
     * @member {Object.<string,string>} template_vars
     * @memberof Document
     * @instance
     */
    Document.prototype.template_vars = $util.emptyObject;

    /**
     * Document status.
     * @member {DocumentStatus.Enum} status
     * @memberof Document
     * @instance
     */
    Document.prototype.status = 0;

    /**
     * Document created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof Document
     * @instance
     */
    Document.prototype.created_at = null;

    /**
     * Creates a new Document instance using the specified properties.
     * @function create
     * @memberof Document
     * @static
     * @param {IDocument=} [properties] Properties to set
     * @returns {Document} Document instance
     */
    Document.create = function create(properties) {
        return new Document(properties);
    };

    /**
     * Encodes the specified Document message. Does not implicitly {@link Document.verify|verify} messages.
     * @function encode
     * @memberof Document
     * @static
     * @param {IDocument} message Document message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Document.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.contact_id);
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.email_address);
        if (message.template_name != null && message.hasOwnProperty("template_name"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.template_name);
        if (message.template_vars != null && message.hasOwnProperty("template_vars"))
            for (let keys = Object.keys(message.template_vars), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.template_vars[keys[i]]).ldelim();
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.status);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Document message, length delimited. Does not implicitly {@link Document.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Document
     * @static
     * @param {IDocument} message Document message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Document.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Document message from the specified reader or buffer.
     * @function decode
     * @memberof Document
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Document} Document
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Document.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Document(), key;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.contact_id = reader.string();
                break;
            case 3:
                message.email_address = reader.string();
                break;
            case 4:
                message.template_name = reader.int32();
                break;
            case 5:
                reader.skip().pos++;
                if (message.template_vars === $util.emptyObject)
                    message.template_vars = {};
                key = reader.string();
                reader.pos++;
                message.template_vars[key] = reader.string();
                break;
            case 6:
                message.status = reader.int32();
                break;
            case 7:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Document message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Document
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Document} Document
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Document.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Document message.
     * @function verify
     * @memberof Document
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Document.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            if (!$util.isString(message.contact_id))
                return "contact_id: string expected";
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            if (!$util.isString(message.email_address))
                return "email_address: string expected";
        if (message.template_name != null && message.hasOwnProperty("template_name"))
            switch (message.template_name) {
            default:
                return "template_name: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
            case 32:
            case 33:
            case 34:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 41:
            case 42:
            case 43:
            case 44:
            case 45:
            case 46:
            case 47:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
            case 58:
            case 59:
            case 60:
            case 61:
            case 62:
            case 63:
            case 64:
            case 65:
            case 66:
            case 1000:
            case 1001:
            case 1002:
            case 1003:
            case 1004:
            case 1005:
            case 1006:
            case 2000:
            case 2001:
            case 2002:
            case 2003:
            case 3000:
            case 3001:
            case 3002:
            case 3003:
            case 3004:
            case 3005:
            case 3006:
            case 3007:
            case 3008:
            case 3009:
            case 3010:
            case 3011:
            case 3012:
            case 3013:
            case 3014:
            case 3015:
            case 3016:
            case 3017:
            case 3018:
            case 3019:
            case 3020:
            case 3021:
            case 3022:
            case 3023:
            case 3024:
            case 3025:
            case 3026:
            case 3027:
            case 3028:
            case 3034:
            case 4000:
            case 4001:
            case 4002:
            case 4003:
            case 4004:
            case 4005:
            case 4006:
            case 4007:
            case 4008:
            case 4009:
            case 4010:
            case 4011:
            case 5000:
            case 5001:
            case 5003:
            case 5004:
                break;
            }
        if (message.template_vars != null && message.hasOwnProperty("template_vars")) {
            if (!$util.isObject(message.template_vars))
                return "template_vars: object expected";
            let key = Object.keys(message.template_vars);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.template_vars[key[i]]))
                    return "template_vars: string{k:string} expected";
        }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a Document message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Document
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Document} Document
     */
    Document.fromObject = function fromObject(object) {
        if (object instanceof $root.Document)
            return object;
        let message = new $root.Document();
        if (object.id != null)
            message.id = String(object.id);
        if (object.contact_id != null)
            message.contact_id = String(object.contact_id);
        if (object.email_address != null)
            message.email_address = String(object.email_address);
        switch (object.template_name) {
        case "UNKNOWN":
        case 0:
            message.template_name = 0;
            break;
        case "VOYAGER_WELCOME":
        case 1:
            message.template_name = 1;
            break;
        case "VOYAGER_ACCOUNT_CLOSURE":
        case 2:
            message.template_name = 2;
            break;
        case "VOYAGER_CHARGEBACK":
        case 3:
            message.template_name = 3;
            break;
        case "VOYAGER_GREENID_FAILURE":
        case 5:
            message.template_name = 5;
            break;
        case "VOYAGER_GREENID_PASS":
        case 6:
            message.template_name = 6;
            break;
        case "VOYAGER_RESET_PASSWORD":
        case 7:
            message.template_name = 7;
            break;
        case "VOYAGER_PASSWORD_CHANGED":
        case 8:
            message.template_name = 8;
            break;
        case "VOYAGER_ONE_OFF_DEPOSIT_MADE":
        case 9:
            message.template_name = 9;
            break;
        case "VOYAGER_SAVINGS_PLAN_ADDED":
        case 10:
            message.template_name = 10;
            break;
        case "VOYAGER_SAVINGS_PLAN_CHANGED":
        case 11:
            message.template_name = 11;
            break;
        case "VOYAGER_SAVINGS_PLAN_STOPPED":
        case 12:
            message.template_name = 12;
            break;
        case "VOYAGER_WITHDRAWL_REQUEST":
        case 13:
            message.template_name = 13;
            break;
        case "VOYAGER_VERIFY_EMAIL":
        case 14:
            message.template_name = 14;
            break;
        case "VOYAGER_FINANCIAL_REPORT_FY19":
        case 15:
            message.template_name = 15;
            break;
        case "VOYAGER_AMMA_STATEMENT_FY19":
        case 16:
            message.template_name = 16;
            break;
        case "VOYAGER_UNIT_CONFIRMATION":
        case 17:
            message.template_name = 17;
            break;
        case "VOYAGER_PERIODIC_STATEMENT_FY19":
        case 18:
            message.template_name = 18;
            break;
        case "VOYAGER_REFERRER_REFERRAL_SUCCESS":
        case 19:
            message.template_name = 19;
            break;
        case "VOYAGER_ACCOUNT_STATEMENT":
        case 20:
            message.template_name = 20;
            break;
        case "VOYAGER_EXIT_STATEMENT":
        case 21:
            message.template_name = 21;
            break;
        case "VOYAGER_CLAWBACK_REMEDIATION_OPEN":
        case 22:
            message.template_name = 22;
            break;
        case "VOYAGER_CLAWBACK_REMEDIATION_CLOSED":
        case 23:
            message.template_name = 23;
            break;
        case "VOYAGER_UNVERIFIED_BANK_ACCOUNT_REMINDER":
        case 24:
            message.template_name = 24;
            break;
        case "VOYAGER_AMMA_STATEMENT_FY20":
        case 25:
            message.template_name = 25;
            break;
        case "VOYAGER_PERIODIC_STATEMENT_FY20":
        case 26:
            message.template_name = 26;
            break;
        case "VOYAGER_ACCOUNT_STATEMENT_V2":
        case 27:
            message.template_name = 27;
            break;
        case "VOYAGER_EXIT_STATEMENT_V2":
        case 28:
            message.template_name = 28;
            break;
        case "VOYAGER_FINANCIAL_REPORT_FY20":
        case 29:
            message.template_name = 29;
            break;
        case "VOYAGER_BIOMETRIC_VERIFICATION_PASS":
        case 30:
            message.template_name = 30;
            break;
        case "VOYAGER_BIOMETRIC_VERIFICATION_FAIL":
        case 31:
            message.template_name = 31;
            break;
        case "VOYAGER_BIOMETRIC_VERIFICATION_IN_REVIEW":
        case 32:
            message.template_name = 32;
            break;
        case "VOYAGER_SOURCE_ACCOUNT_MERGE_SUCCESSFUL":
        case 33:
            message.template_name = 33;
            break;
        case "VOYAGER_SOURCE_ACCOUNT_MERGE_INITIATED":
        case 34:
            message.template_name = 34;
            break;
        case "VOYAGER_DESTINATION_ACCOUNT_MERGE_SUCCESSFUL":
        case 35:
            message.template_name = 35;
            break;
        case "VOYAGER_DESTINATION_ACCOUNT_MERGE_INITIATED":
        case 36:
            message.template_name = 36;
            break;
        case "VOYAGER_AMMA_STATEMENT_FY21":
        case 37:
            message.template_name = 37;
            break;
        case "VOYAGER_PERIODIC_STATEMENT_FY21":
        case 38:
            message.template_name = 38;
            break;
        case "VOYAGER_FINANCIAL_REPORT_FY21":
        case 39:
            message.template_name = 39;
            break;
        case "VOYAGER_SOURCE_ACCOUNT_MERGE_UNSUCCESSFUL":
        case 40:
            message.template_name = 40;
            break;
        case "VOYAGER_DESTINATION_ACCOUNT_MERGE_UNSUCCESSFUL":
        case 41:
            message.template_name = 41;
            break;
        case "VOYAGER_ACCOUNT_STATEMENT_V3":
        case 42:
            message.template_name = 42;
            break;
        case "VOYAGER_EXIT_STATEMENT_V3":
        case 43:
            message.template_name = 43;
            break;
        case "VOYAGER_PAYMENT_PLAN_AUTO_CANCELLATION":
        case 44:
            message.template_name = 44;
            break;
        case "VOYAGER_BOOSTS_AUTO_CANCELLATION":
        case 45:
            message.template_name = 45;
            break;
        case "VOYAGER_AMMA_STATEMENT_FY22":
        case 46:
            message.template_name = 46;
            break;
        case "VOYAGER_PERIODIC_STATEMENT_FY22":
        case 47:
            message.template_name = 47;
            break;
        case "VOYAGER_FAILED_ONEOFF_APPLICATION":
        case 48:
            message.template_name = 48;
            break;
        case "VOYAGER_FAILED_INVESTMENT_PLAN_APPLICATION":
        case 49:
            message.template_name = 49;
            break;
        case "VOYAGER_FAILED_BOOST_APPLICATION":
        case 50:
            message.template_name = 50;
            break;
        case "VOYAGER_FAILED_REDEMPTION":
        case 51:
            message.template_name = 51;
            break;
        case "VOYAGER_ACCOUNT_STATEMENT_V4":
        case 52:
            message.template_name = 52;
            break;
        case "VOYAGER_EXIT_STATEMENT_V4":
        case 53:
            message.template_name = 53;
            break;
        case "VOYAGER_TMD_IN_REVIEW":
        case 54:
            message.template_name = 54;
            break;
        case "VOYAGER_TMD_ONBOARDING_APPROVED":
        case 55:
            message.template_name = 55;
            break;
        case "VOYAGER_TMD_MULTIFUND_APPROVED":
        case 56:
            message.template_name = 56;
            break;
        case "VOYAGER_TMD_REJECTED":
        case 57:
            message.template_name = 57;
            break;
        case "VOYAGER_AMMA_STATEMENT_FY23":
        case 58:
            message.template_name = 58;
            break;
        case "VOYAGER_PERIODIC_STATEMENT_FY23":
        case 59:
            message.template_name = 59;
            break;
        case "VOYAGER_AMMA_STATEMENT_FY23_OVERSEAS_RESEND":
        case 60:
            message.template_name = 60;
            break;
        case "VOYAGER_AMMA_STATEMENT_FY23_RESEND":
        case 61:
            message.template_name = 61;
            break;
        case "VOYAGER_ACCOUNT_STATEMENT_V5":
        case 62:
            message.template_name = 62;
            break;
        case "VOYAGER_EXIT_STATEMENT_V5":
        case 63:
            message.template_name = 63;
            break;
        case "VOYAGER_AMMA_STATEMENT_FY24":
        case 64:
            message.template_name = 64;
            break;
        case "VOYAGER_PERIODIC_STATEMENT_FY24":
        case 65:
            message.template_name = 65;
            break;
        case "VOYAGER_FINANCIAL_REPORT_FY24":
        case 66:
            message.template_name = 66;
            break;
        case "SUPER_SOFT_LINK":
        case 1000:
            message.template_name = 1000;
            break;
        case "SUPER_HARD_LINK":
        case 1001:
            message.template_name = 1001;
            break;
        case "SUPER_EMPLOYER_CONTRIBUTION_DETAILS_TO_EMPLOYER":
        case 1002:
            message.template_name = 1002;
            break;
        case "SUPER_EMPLOYER_CONTRIBUTION_DETAILS_TO_SELF":
        case 1003:
            message.template_name = 1003;
            break;
        case "SUPER_ACCOUNT_VERIFICATION_REQUIRED":
        case 1004:
            message.template_name = 1004;
            break;
        case "SUPER_BINDING_BENEFICIARY_INTENT":
        case 1005:
            message.template_name = 1005;
            break;
        case "SUPER_TAX_DEDUCTION_LETTER":
        case 1006:
            message.template_name = 1006;
            break;
        case "PERSONAL_DETAILS_UPDATED":
        case 2000:
            message.template_name = 2000;
            break;
        case "TAX_RESIDENCY_PROVIDE_TIN_PROMPT":
        case 2001:
            message.template_name = 2001;
            break;
        case "MANUAL_MFA_VERIFICATIONS_GENERATED":
        case 2002:
            message.template_name = 2002;
            break;
        case "RESET_PASSWORD_CODE":
        case 2003:
            message.template_name = 2003;
            break;
        case "VOYAGER_FEE_COMMS_INCIDENT_NOTIFY":
        case 3000:
            message.template_name = 3000;
            break;
        case "VOYAGER_ZEPTO_DIRECT_DEBIT_AGREEMENT_NOTIFY":
        case 3001:
            message.template_name = 3001;
            break;
        case "VOYAGER_FINANCIAL_REPORT_FY22":
        case 3002:
            message.template_name = 3002;
            break;
        case "VOYAGER_FEE_ANNOUNCEMENT_2023":
        case 3003:
            message.template_name = 3003;
            break;
        case "VOYAGER_ORIGIN_PDS_UPDATE_JUN_2023":
        case 3004:
            message.template_name = 3004;
            break;
        case "VOYAGER_FAILED_DISTRIBUTION_PROMPT_ACTIVE_FY23":
        case 3005:
            message.template_name = 3005;
            break;
        case "VOYAGER_FAILED_DISTRIBUTION_PROMPT_CLOSED_FY23":
        case 3006:
            message.template_name = 3006;
            break;
        case "NOVA_TERMS_AND_CONDITIONS_UPDATE_AUG_2023":
        case 3007:
            message.template_name = 3007;
            break;
        case "NOVA_TERMS_AND_CONDITIONS_UPDATE_SEPT_2023":
        case 3008:
            message.template_name = 3008;
            break;
        case "VOYAGER_EARTH_PDS_UPDATE_SEPT_2023":
        case 3009:
            message.template_name = 3009;
            break;
        case "NOVA_FEE_CHARGE_WARNING_SEPT_2023":
        case 3010:
            message.template_name = 3010;
            break;
        case "VOYAGER_FINANCIAL_REPORT_FY23":
        case 3011:
            message.template_name = 3011;
            break;
        case "VOYAGER_UPDATE_TAX_RESIDENCY_EMAIL_OCT_2023":
        case 3012:
            message.template_name = 3012;
            break;
        case "NOVA_ROUNDING_REMEDIATION_OCT_2023":
        case 3013:
            message.template_name = 3013;
            break;
        case "MFA_NOTIFY_TURNING_ON_FOR_LOGIN":
        case 3014:
            message.template_name = 3014;
            break;
        case "TAX_RESIDENCY_USA_PROVIDE_TIN_PROMPT_DEC_2023":
        case 3015:
            message.template_name = 3015;
            break;
        case "TAX_RESIDENCY_USA_CORRECT_TIN_PROMPT_DEC_2023":
        case 3016:
            message.template_name = 3016;
            break;
        case "NOVA_INVESTMENT_PLAN_REMEDIATION_NOV_2023":
        case 3017:
            message.template_name = 3017;
            break;
        case "TAX_RESIDENCY_NON_USA_PROVIDE_TIN_PROMPT_DEC_2023":
        case 3018:
            message.template_name = 3018;
            break;
        case "NOVA_TAF_CHANGE_NOTIFICATION_DEC_2023":
        case 3019:
            message.template_name = 3019;
            break;
        case "MFA_REQUIRED_NOTIFICATION":
        case 3020:
            message.template_name = 3020;
            break;
        case "FEE_ANNOUNCEMENT_2024":
        case 3021:
            message.template_name = 3021;
            break;
        case "NOVA_SEC_CHANGE_NOTIFICATION_MAY_2024":
        case 3022:
            message.template_name = 3022;
            break;
        case "VOYAGER_UNSENT_EXIT_STATEMENTS_NOTIFY_MAY_2024":
        case 3023:
            message.template_name = 3023;
            break;
        case "TAX_RESIDENCY_USA_INVALID_TIN_PROMPT_DEC_2023":
        case 3024:
            message.template_name = 3024;
            break;
        case "ETORO_ANNOUNCEMENT":
        case 3025:
            message.template_name = 3025;
            break;
        case "NOVA_DISCLOSURE_DOCUMENT_UPDATE_NOV_2024":
        case 3026:
            message.template_name = 3026;
            break;
        case "MONEY_PRE_LAUNCH_ANNOUNCEMENT":
        case 3027:
            message.template_name = 3027;
            break;
        case "MONEY_LAUNCH_ANNOUNCEMENT":
        case 3028:
            message.template_name = 3028;
            break;
        case "NOVA_BETA_FEE_WAIVER_ENDING_NOTIFICATION":
        case 3034:
            message.template_name = 3034;
            break;
        case "NOVA_TRADE_CONFIRMATION":
        case 4000:
            message.template_name = 4000;
            break;
        case "NOVA_ACCOUNT_STATEMENT":
        case 4001:
            message.template_name = 4001;
            break;
        case "NOVA_WELCOME":
        case 4002:
            message.template_name = 4002;
            break;
        case "NOVA_APPLICATION_RECEIVED":
        case 4003:
            message.template_name = 4003;
            break;
        case "NOVA_FEES_OUTSTANDING_REMINDER":
        case 4004:
            message.template_name = 4004;
            break;
        case "NOVA_FEES_FIRST_CHARGE_FAILED":
        case 4005:
            message.template_name = 4005;
            break;
        case "NOVA_FEES_SUSPENDED":
        case 4006:
            message.template_name = 4006;
            break;
        case "NOVA_FAILED_ONE_OFF_BUY_ORDER":
        case 4007:
            message.template_name = 4007;
            break;
        case "NOVA_FAILED_INVESTMENT_PLAN_BUY_ORDER":
        case 4008:
            message.template_name = 4008;
            break;
        case "NOVA_INVALID_TAX_RESIDENCY_NOTIFICATION":
        case 4009:
            message.template_name = 4009;
            break;
        case "NOVA_FAILED_PAYOUT":
        case 4010:
            message.template_name = 4010;
            break;
        case "NOVA_MULTI_MONTH_STATEMENT":
        case 4011:
            message.template_name = 4011;
            break;
        case "MONEY_USER_DEPOSIT_SUCCESSFUL":
        case 5000:
            message.template_name = 5000;
            break;
        case "MONEY_USER_DEPOSIT_FAILED":
        case 5001:
            message.template_name = 5001;
            break;
        case "MONEY_USER_WITHDRAWAL_SUCCESSFUL":
        case 5003:
            message.template_name = 5003;
            break;
        case "MONEY_USER_WITHDRAWAL_FAILED":
        case 5004:
            message.template_name = 5004;
            break;
        }
        if (object.template_vars) {
            if (typeof object.template_vars !== "object")
                throw TypeError(".Document.template_vars: object expected");
            message.template_vars = {};
            for (let keys = Object.keys(object.template_vars), i = 0; i < keys.length; ++i)
                message.template_vars[keys[i]] = String(object.template_vars[keys[i]]);
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PENDING":
        case 1:
            message.status = 1;
            break;
        case "PROCESSING":
        case 2:
            message.status = 2;
            break;
        case "SENT":
        case 3:
            message.status = 3;
            break;
        case "FAILED":
        case 4:
            message.status = 4;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".Document.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a Document message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Document
     * @static
     * @param {Document} message Document
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Document.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.template_vars = {};
        if (options.defaults) {
            object.id = "";
            object.contact_id = "";
            object.email_address = "";
            object.template_name = options.enums === String ? "UNKNOWN" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            object.contact_id = message.contact_id;
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            object.email_address = message.email_address;
        if (message.template_name != null && message.hasOwnProperty("template_name"))
            object.template_name = options.enums === String ? $root.EmailTemplate.Enum[message.template_name] : message.template_name;
        let keys2;
        if (message.template_vars && (keys2 = Object.keys(message.template_vars)).length) {
            object.template_vars = {};
            for (let j = 0; j < keys2.length; ++j)
                object.template_vars[keys2[j]] = message.template_vars[keys2[j]];
        }
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.DocumentStatus.Enum[message.status] : message.status;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this Document to JSON.
     * @function toJSON
     * @memberof Document
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Document.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Document;
})();

export const DocumentList = $root.DocumentList = (() => {

    /**
     * Properties of a DocumentList.
     * @exports IDocumentList
     * @interface IDocumentList
     * @property {Array.<IDocument>|null} [list] DocumentList list
     */

    /**
     * Constructs a new DocumentList.
     * @exports DocumentList
     * @classdesc Represents a DocumentList.
     * @implements IDocumentList
     * @constructor
     * @param {IDocumentList=} [properties] Properties to set
     */
    function DocumentList(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DocumentList list.
     * @member {Array.<IDocument>} list
     * @memberof DocumentList
     * @instance
     */
    DocumentList.prototype.list = $util.emptyArray;

    /**
     * Creates a new DocumentList instance using the specified properties.
     * @function create
     * @memberof DocumentList
     * @static
     * @param {IDocumentList=} [properties] Properties to set
     * @returns {DocumentList} DocumentList instance
     */
    DocumentList.create = function create(properties) {
        return new DocumentList(properties);
    };

    /**
     * Encodes the specified DocumentList message. Does not implicitly {@link DocumentList.verify|verify} messages.
     * @function encode
     * @memberof DocumentList
     * @static
     * @param {IDocumentList} message DocumentList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DocumentList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.Document.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DocumentList message, length delimited. Does not implicitly {@link DocumentList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DocumentList
     * @static
     * @param {IDocumentList} message DocumentList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DocumentList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DocumentList message from the specified reader or buffer.
     * @function decode
     * @memberof DocumentList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DocumentList} DocumentList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DocumentList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DocumentList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.Document.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DocumentList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DocumentList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DocumentList} DocumentList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DocumentList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DocumentList message.
     * @function verify
     * @memberof DocumentList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DocumentList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.Document.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates a DocumentList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DocumentList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DocumentList} DocumentList
     */
    DocumentList.fromObject = function fromObject(object) {
        if (object instanceof $root.DocumentList)
            return object;
        let message = new $root.DocumentList();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".DocumentList.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".DocumentList.list: object expected");
                message.list[i] = $root.Document.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a DocumentList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DocumentList
     * @static
     * @param {DocumentList} message DocumentList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DocumentList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.Document.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this DocumentList to JSON.
     * @function toJSON
     * @memberof DocumentList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DocumentList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DocumentList;
})();

export const TrackingIdType = $root.TrackingIdType = (() => {

    /**
     * Properties of a TrackingIdType.
     * @exports ITrackingIdType
     * @interface ITrackingIdType
     */

    /**
     * Constructs a new TrackingIdType.
     * @exports TrackingIdType
     * @classdesc Represents a TrackingIdType.
     * @implements ITrackingIdType
     * @constructor
     * @param {ITrackingIdType=} [properties] Properties to set
     */
    function TrackingIdType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new TrackingIdType instance using the specified properties.
     * @function create
     * @memberof TrackingIdType
     * @static
     * @param {ITrackingIdType=} [properties] Properties to set
     * @returns {TrackingIdType} TrackingIdType instance
     */
    TrackingIdType.create = function create(properties) {
        return new TrackingIdType(properties);
    };

    /**
     * Encodes the specified TrackingIdType message. Does not implicitly {@link TrackingIdType.verify|verify} messages.
     * @function encode
     * @memberof TrackingIdType
     * @static
     * @param {ITrackingIdType} message TrackingIdType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TrackingIdType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified TrackingIdType message, length delimited. Does not implicitly {@link TrackingIdType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TrackingIdType
     * @static
     * @param {ITrackingIdType} message TrackingIdType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TrackingIdType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TrackingIdType message from the specified reader or buffer.
     * @function decode
     * @memberof TrackingIdType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TrackingIdType} TrackingIdType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TrackingIdType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackingIdType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TrackingIdType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TrackingIdType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TrackingIdType} TrackingIdType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TrackingIdType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TrackingIdType message.
     * @function verify
     * @memberof TrackingIdType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TrackingIdType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a TrackingIdType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TrackingIdType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TrackingIdType} TrackingIdType
     */
    TrackingIdType.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackingIdType)
            return object;
        return new $root.TrackingIdType();
    };

    /**
     * Creates a plain object from a TrackingIdType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TrackingIdType
     * @static
     * @param {TrackingIdType} message TrackingIdType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TrackingIdType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this TrackingIdType to JSON.
     * @function toJSON
     * @memberof TrackingIdType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TrackingIdType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name TrackingIdType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ADMIN=1 ADMIN value
     * @property {number} CONTACT=2 CONTACT value
     * @property {number} ACCOUNT=3 ACCOUNT value
     * @property {number} SUPER_PRODUCT=4 SUPER_PRODUCT value
     * @property {number} SERVICE=5 SERVICE value
     * @property {number} SAVER_PRODUCT=6 SAVER_PRODUCT value
     * @property {number} SAVER_SYSTEM=7 SAVER_SYSTEM value
     * @property {number} MARS_SYSTEM=8 MARS_SYSTEM value
     * @property {number} NOVA_PRODUCT=9 NOVA_PRODUCT value
     * @property {number} NOVA_SYSTEM=10 NOVA_SYSTEM value
     * @property {number} MONEY_SYSTEM=11 MONEY_SYSTEM value
     */
    TrackingIdType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ADMIN"] = 1;
        values[valuesById[2] = "CONTACT"] = 2;
        values[valuesById[3] = "ACCOUNT"] = 3;
        values[valuesById[4] = "SUPER_PRODUCT"] = 4;
        values[valuesById[5] = "SERVICE"] = 5;
        values[valuesById[6] = "SAVER_PRODUCT"] = 6;
        values[valuesById[7] = "SAVER_SYSTEM"] = 7;
        values[valuesById[8] = "MARS_SYSTEM"] = 8;
        values[valuesById[9] = "NOVA_PRODUCT"] = 9;
        values[valuesById[10] = "NOVA_SYSTEM"] = 10;
        values[valuesById[11] = "MONEY_SYSTEM"] = 11;
        return values;
    })();

    return TrackingIdType;
})();

export const TrackingTag = $root.TrackingTag = (() => {

    /**
     * Properties of a TrackingTag.
     * @exports ITrackingTag
     * @interface ITrackingTag
     */

    /**
     * Constructs a new TrackingTag.
     * @exports TrackingTag
     * @classdesc Represents a TrackingTag.
     * @implements ITrackingTag
     * @constructor
     * @param {ITrackingTag=} [properties] Properties to set
     */
    function TrackingTag(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new TrackingTag instance using the specified properties.
     * @function create
     * @memberof TrackingTag
     * @static
     * @param {ITrackingTag=} [properties] Properties to set
     * @returns {TrackingTag} TrackingTag instance
     */
    TrackingTag.create = function create(properties) {
        return new TrackingTag(properties);
    };

    /**
     * Encodes the specified TrackingTag message. Does not implicitly {@link TrackingTag.verify|verify} messages.
     * @function encode
     * @memberof TrackingTag
     * @static
     * @param {ITrackingTag} message TrackingTag message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TrackingTag.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified TrackingTag message, length delimited. Does not implicitly {@link TrackingTag.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TrackingTag
     * @static
     * @param {ITrackingTag} message TrackingTag message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TrackingTag.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TrackingTag message from the specified reader or buffer.
     * @function decode
     * @memberof TrackingTag
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TrackingTag} TrackingTag
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TrackingTag.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackingTag();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TrackingTag message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TrackingTag
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TrackingTag} TrackingTag
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TrackingTag.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TrackingTag message.
     * @function verify
     * @memberof TrackingTag
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TrackingTag.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a TrackingTag message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TrackingTag
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TrackingTag} TrackingTag
     */
    TrackingTag.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackingTag)
            return object;
        return new $root.TrackingTag();
    };

    /**
     * Creates a plain object from a TrackingTag message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TrackingTag
     * @static
     * @param {TrackingTag} message TrackingTag
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TrackingTag.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this TrackingTag to JSON.
     * @function toJSON
     * @memberof TrackingTag
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TrackingTag.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name TrackingTag.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ADMIN_WRITE=1 ADMIN_WRITE value
     * @property {number} ADMIN_READ=2 ADMIN_READ value
     * @property {number} USER_ACCOUNT=3 USER_ACCOUNT value
     * @property {number} USER_SUPER=4 USER_SUPER value
     * @property {number} USER_VOYAGER=5 USER_VOYAGER value
     * @property {number} LEGACY=6 LEGACY value
     * @property {number} USER_NOVA=7 USER_NOVA value
     */
    TrackingTag.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ADMIN_WRITE"] = 1;
        values[valuesById[2] = "ADMIN_READ"] = 2;
        values[valuesById[3] = "USER_ACCOUNT"] = 3;
        values[valuesById[4] = "USER_SUPER"] = 4;
        values[valuesById[5] = "USER_VOYAGER"] = 5;
        values[valuesById[6] = "LEGACY"] = 6;
        values[valuesById[7] = "USER_NOVA"] = 7;
        return values;
    })();

    return TrackingTag;
})();

export const ActionReport = $root.ActionReport = (() => {

    /**
     * Properties of an ActionReport.
     * @exports IActionReport
     * @interface IActionReport
     * @property {string|null} [id] ActionReport id
     * @property {string|null} [agent_id] ActionReport agent_id
     * @property {TrackingIdType.Enum|null} [agent_id_type] ActionReport agent_id_type
     * @property {string|null} [recipient_id] ActionReport recipient_id
     * @property {TrackingIdType.Enum|null} [recipient_id_type] ActionReport recipient_id_type
     * @property {string|null} [description] ActionReport description
     * @property {google.protobuf.ITimestamp|null} [attempted_timestamp] ActionReport attempted_timestamp
     * @property {boolean|null} [has_result] ActionReport has_result
     * @property {boolean|null} [success] ActionReport success
     * @property {string|null} [error_details] ActionReport error_details
     * @property {google.protobuf.ITimestamp|null} [result_timestamp] ActionReport result_timestamp
     * @property {string|null} [human_readable_summary] ActionReport human_readable_summary
     * @property {TrackingTag.Enum|null} [tag] ActionReport tag
     */

    /**
     * Constructs a new ActionReport.
     * @exports ActionReport
     * @classdesc Represents an ActionReport.
     * @implements IActionReport
     * @constructor
     * @param {IActionReport=} [properties] Properties to set
     */
    function ActionReport(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ActionReport id.
     * @member {string} id
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.id = "";

    /**
     * ActionReport agent_id.
     * @member {string} agent_id
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.agent_id = "";

    /**
     * ActionReport agent_id_type.
     * @member {TrackingIdType.Enum} agent_id_type
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.agent_id_type = 0;

    /**
     * ActionReport recipient_id.
     * @member {string} recipient_id
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.recipient_id = "";

    /**
     * ActionReport recipient_id_type.
     * @member {TrackingIdType.Enum} recipient_id_type
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.recipient_id_type = 0;

    /**
     * ActionReport description.
     * @member {string} description
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.description = "";

    /**
     * ActionReport attempted_timestamp.
     * @member {google.protobuf.ITimestamp|null|undefined} attempted_timestamp
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.attempted_timestamp = null;

    /**
     * ActionReport has_result.
     * @member {boolean} has_result
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.has_result = false;

    /**
     * ActionReport success.
     * @member {boolean} success
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.success = false;

    /**
     * ActionReport error_details.
     * @member {string} error_details
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.error_details = "";

    /**
     * ActionReport result_timestamp.
     * @member {google.protobuf.ITimestamp|null|undefined} result_timestamp
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.result_timestamp = null;

    /**
     * ActionReport human_readable_summary.
     * @member {string} human_readable_summary
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.human_readable_summary = "";

    /**
     * ActionReport tag.
     * @member {TrackingTag.Enum} tag
     * @memberof ActionReport
     * @instance
     */
    ActionReport.prototype.tag = 0;

    /**
     * Creates a new ActionReport instance using the specified properties.
     * @function create
     * @memberof ActionReport
     * @static
     * @param {IActionReport=} [properties] Properties to set
     * @returns {ActionReport} ActionReport instance
     */
    ActionReport.create = function create(properties) {
        return new ActionReport(properties);
    };

    /**
     * Encodes the specified ActionReport message. Does not implicitly {@link ActionReport.verify|verify} messages.
     * @function encode
     * @memberof ActionReport
     * @static
     * @param {IActionReport} message ActionReport message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ActionReport.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.agent_id != null && message.hasOwnProperty("agent_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.agent_id);
        if (message.agent_id_type != null && message.hasOwnProperty("agent_id_type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.agent_id_type);
        if (message.recipient_id != null && message.hasOwnProperty("recipient_id"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.recipient_id);
        if (message.recipient_id_type != null && message.hasOwnProperty("recipient_id_type"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.recipient_id_type);
        if (message.description != null && message.hasOwnProperty("description"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.description);
        if (message.attempted_timestamp != null && message.hasOwnProperty("attempted_timestamp"))
            $root.google.protobuf.Timestamp.encode(message.attempted_timestamp, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.has_result != null && message.hasOwnProperty("has_result"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.has_result);
        if (message.success != null && message.hasOwnProperty("success"))
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.success);
        if (message.error_details != null && message.hasOwnProperty("error_details"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.error_details);
        if (message.result_timestamp != null && message.hasOwnProperty("result_timestamp"))
            $root.google.protobuf.Timestamp.encode(message.result_timestamp, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.human_readable_summary != null && message.hasOwnProperty("human_readable_summary"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.human_readable_summary);
        if (message.tag != null && message.hasOwnProperty("tag"))
            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.tag);
        return writer;
    };

    /**
     * Encodes the specified ActionReport message, length delimited. Does not implicitly {@link ActionReport.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ActionReport
     * @static
     * @param {IActionReport} message ActionReport message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ActionReport.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ActionReport message from the specified reader or buffer.
     * @function decode
     * @memberof ActionReport
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ActionReport} ActionReport
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ActionReport.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ActionReport();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.agent_id = reader.string();
                break;
            case 3:
                message.agent_id_type = reader.int32();
                break;
            case 4:
                message.recipient_id = reader.string();
                break;
            case 5:
                message.recipient_id_type = reader.int32();
                break;
            case 6:
                message.description = reader.string();
                break;
            case 7:
                message.attempted_timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 8:
                message.has_result = reader.bool();
                break;
            case 9:
                message.success = reader.bool();
                break;
            case 11:
                message.error_details = reader.string();
                break;
            case 12:
                message.result_timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 13:
                message.human_readable_summary = reader.string();
                break;
            case 14:
                message.tag = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ActionReport message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ActionReport
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ActionReport} ActionReport
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ActionReport.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ActionReport message.
     * @function verify
     * @memberof ActionReport
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ActionReport.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.agent_id != null && message.hasOwnProperty("agent_id"))
            if (!$util.isString(message.agent_id))
                return "agent_id: string expected";
        if (message.agent_id_type != null && message.hasOwnProperty("agent_id_type"))
            switch (message.agent_id_type) {
            default:
                return "agent_id_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.recipient_id != null && message.hasOwnProperty("recipient_id"))
            if (!$util.isString(message.recipient_id))
                return "recipient_id: string expected";
        if (message.recipient_id_type != null && message.hasOwnProperty("recipient_id_type"))
            switch (message.recipient_id_type) {
            default:
                return "recipient_id_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.attempted_timestamp != null && message.hasOwnProperty("attempted_timestamp")) {
            let error = $root.google.protobuf.Timestamp.verify(message.attempted_timestamp);
            if (error)
                return "attempted_timestamp." + error;
        }
        if (message.has_result != null && message.hasOwnProperty("has_result"))
            if (typeof message.has_result !== "boolean")
                return "has_result: boolean expected";
        if (message.success != null && message.hasOwnProperty("success"))
            if (typeof message.success !== "boolean")
                return "success: boolean expected";
        if (message.error_details != null && message.hasOwnProperty("error_details"))
            if (!$util.isString(message.error_details))
                return "error_details: string expected";
        if (message.result_timestamp != null && message.hasOwnProperty("result_timestamp")) {
            let error = $root.google.protobuf.Timestamp.verify(message.result_timestamp);
            if (error)
                return "result_timestamp." + error;
        }
        if (message.human_readable_summary != null && message.hasOwnProperty("human_readable_summary"))
            if (!$util.isString(message.human_readable_summary))
                return "human_readable_summary: string expected";
        if (message.tag != null && message.hasOwnProperty("tag"))
            switch (message.tag) {
            default:
                return "tag: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                break;
            }
        return null;
    };

    /**
     * Creates an ActionReport message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ActionReport
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ActionReport} ActionReport
     */
    ActionReport.fromObject = function fromObject(object) {
        if (object instanceof $root.ActionReport)
            return object;
        let message = new $root.ActionReport();
        if (object.id != null)
            message.id = String(object.id);
        if (object.agent_id != null)
            message.agent_id = String(object.agent_id);
        switch (object.agent_id_type) {
        case "UNKNOWN":
        case 0:
            message.agent_id_type = 0;
            break;
        case "ADMIN":
        case 1:
            message.agent_id_type = 1;
            break;
        case "CONTACT":
        case 2:
            message.agent_id_type = 2;
            break;
        case "ACCOUNT":
        case 3:
            message.agent_id_type = 3;
            break;
        case "SUPER_PRODUCT":
        case 4:
            message.agent_id_type = 4;
            break;
        case "SERVICE":
        case 5:
            message.agent_id_type = 5;
            break;
        case "SAVER_PRODUCT":
        case 6:
            message.agent_id_type = 6;
            break;
        case "SAVER_SYSTEM":
        case 7:
            message.agent_id_type = 7;
            break;
        case "MARS_SYSTEM":
        case 8:
            message.agent_id_type = 8;
            break;
        case "NOVA_PRODUCT":
        case 9:
            message.agent_id_type = 9;
            break;
        case "NOVA_SYSTEM":
        case 10:
            message.agent_id_type = 10;
            break;
        case "MONEY_SYSTEM":
        case 11:
            message.agent_id_type = 11;
            break;
        }
        if (object.recipient_id != null)
            message.recipient_id = String(object.recipient_id);
        switch (object.recipient_id_type) {
        case "UNKNOWN":
        case 0:
            message.recipient_id_type = 0;
            break;
        case "ADMIN":
        case 1:
            message.recipient_id_type = 1;
            break;
        case "CONTACT":
        case 2:
            message.recipient_id_type = 2;
            break;
        case "ACCOUNT":
        case 3:
            message.recipient_id_type = 3;
            break;
        case "SUPER_PRODUCT":
        case 4:
            message.recipient_id_type = 4;
            break;
        case "SERVICE":
        case 5:
            message.recipient_id_type = 5;
            break;
        case "SAVER_PRODUCT":
        case 6:
            message.recipient_id_type = 6;
            break;
        case "SAVER_SYSTEM":
        case 7:
            message.recipient_id_type = 7;
            break;
        case "MARS_SYSTEM":
        case 8:
            message.recipient_id_type = 8;
            break;
        case "NOVA_PRODUCT":
        case 9:
            message.recipient_id_type = 9;
            break;
        case "NOVA_SYSTEM":
        case 10:
            message.recipient_id_type = 10;
            break;
        case "MONEY_SYSTEM":
        case 11:
            message.recipient_id_type = 11;
            break;
        }
        if (object.description != null)
            message.description = String(object.description);
        if (object.attempted_timestamp != null) {
            if (typeof object.attempted_timestamp !== "object")
                throw TypeError(".ActionReport.attempted_timestamp: object expected");
            message.attempted_timestamp = $root.google.protobuf.Timestamp.fromObject(object.attempted_timestamp);
        }
        if (object.has_result != null)
            message.has_result = Boolean(object.has_result);
        if (object.success != null)
            message.success = Boolean(object.success);
        if (object.error_details != null)
            message.error_details = String(object.error_details);
        if (object.result_timestamp != null) {
            if (typeof object.result_timestamp !== "object")
                throw TypeError(".ActionReport.result_timestamp: object expected");
            message.result_timestamp = $root.google.protobuf.Timestamp.fromObject(object.result_timestamp);
        }
        if (object.human_readable_summary != null)
            message.human_readable_summary = String(object.human_readable_summary);
        switch (object.tag) {
        case "UNKNOWN":
        case 0:
            message.tag = 0;
            break;
        case "ADMIN_WRITE":
        case 1:
            message.tag = 1;
            break;
        case "ADMIN_READ":
        case 2:
            message.tag = 2;
            break;
        case "USER_ACCOUNT":
        case 3:
            message.tag = 3;
            break;
        case "USER_SUPER":
        case 4:
            message.tag = 4;
            break;
        case "USER_VOYAGER":
        case 5:
            message.tag = 5;
            break;
        case "LEGACY":
        case 6:
            message.tag = 6;
            break;
        case "USER_NOVA":
        case 7:
            message.tag = 7;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from an ActionReport message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ActionReport
     * @static
     * @param {ActionReport} message ActionReport
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ActionReport.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.agent_id = "";
            object.agent_id_type = options.enums === String ? "UNKNOWN" : 0;
            object.recipient_id = "";
            object.recipient_id_type = options.enums === String ? "UNKNOWN" : 0;
            object.description = "";
            object.attempted_timestamp = null;
            object.has_result = false;
            object.success = false;
            object.error_details = "";
            object.result_timestamp = null;
            object.human_readable_summary = "";
            object.tag = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.agent_id != null && message.hasOwnProperty("agent_id"))
            object.agent_id = message.agent_id;
        if (message.agent_id_type != null && message.hasOwnProperty("agent_id_type"))
            object.agent_id_type = options.enums === String ? $root.TrackingIdType.Enum[message.agent_id_type] : message.agent_id_type;
        if (message.recipient_id != null && message.hasOwnProperty("recipient_id"))
            object.recipient_id = message.recipient_id;
        if (message.recipient_id_type != null && message.hasOwnProperty("recipient_id_type"))
            object.recipient_id_type = options.enums === String ? $root.TrackingIdType.Enum[message.recipient_id_type] : message.recipient_id_type;
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.attempted_timestamp != null && message.hasOwnProperty("attempted_timestamp"))
            object.attempted_timestamp = $root.google.protobuf.Timestamp.toObject(message.attempted_timestamp, options);
        if (message.has_result != null && message.hasOwnProperty("has_result"))
            object.has_result = message.has_result;
        if (message.success != null && message.hasOwnProperty("success"))
            object.success = message.success;
        if (message.error_details != null && message.hasOwnProperty("error_details"))
            object.error_details = message.error_details;
        if (message.result_timestamp != null && message.hasOwnProperty("result_timestamp"))
            object.result_timestamp = $root.google.protobuf.Timestamp.toObject(message.result_timestamp, options);
        if (message.human_readable_summary != null && message.hasOwnProperty("human_readable_summary"))
            object.human_readable_summary = message.human_readable_summary;
        if (message.tag != null && message.hasOwnProperty("tag"))
            object.tag = options.enums === String ? $root.TrackingTag.Enum[message.tag] : message.tag;
        return object;
    };

    /**
     * Converts this ActionReport to JSON.
     * @function toJSON
     * @memberof ActionReport
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ActionReport.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ActionReport;
})();

export const AdminAccount = $root.AdminAccount = (() => {

    /**
     * Properties of an AdminAccount.
     * @exports IAdminAccount
     * @interface IAdminAccount
     * @property {string|null} [id] AdminAccount id
     * @property {string|null} [email_address] AdminAccount email_address
     * @property {string|null} [first_name] AdminAccount first_name
     * @property {string|null} [last_name] AdminAccount last_name
     * @property {google.protobuf.ITimestamp|null} [last_login] AdminAccount last_login
     * @property {google.protobuf.ITimestamp|null} [created_at] AdminAccount created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] AdminAccount last_updated_at
     */

    /**
     * Constructs a new AdminAccount.
     * @exports AdminAccount
     * @classdesc Represents an AdminAccount.
     * @implements IAdminAccount
     * @constructor
     * @param {IAdminAccount=} [properties] Properties to set
     */
    function AdminAccount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AdminAccount id.
     * @member {string} id
     * @memberof AdminAccount
     * @instance
     */
    AdminAccount.prototype.id = "";

    /**
     * AdminAccount email_address.
     * @member {string} email_address
     * @memberof AdminAccount
     * @instance
     */
    AdminAccount.prototype.email_address = "";

    /**
     * AdminAccount first_name.
     * @member {string} first_name
     * @memberof AdminAccount
     * @instance
     */
    AdminAccount.prototype.first_name = "";

    /**
     * AdminAccount last_name.
     * @member {string} last_name
     * @memberof AdminAccount
     * @instance
     */
    AdminAccount.prototype.last_name = "";

    /**
     * AdminAccount last_login.
     * @member {google.protobuf.ITimestamp|null|undefined} last_login
     * @memberof AdminAccount
     * @instance
     */
    AdminAccount.prototype.last_login = null;

    /**
     * AdminAccount created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof AdminAccount
     * @instance
     */
    AdminAccount.prototype.created_at = null;

    /**
     * AdminAccount last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof AdminAccount
     * @instance
     */
    AdminAccount.prototype.last_updated_at = null;

    /**
     * Creates a new AdminAccount instance using the specified properties.
     * @function create
     * @memberof AdminAccount
     * @static
     * @param {IAdminAccount=} [properties] Properties to set
     * @returns {AdminAccount} AdminAccount instance
     */
    AdminAccount.create = function create(properties) {
        return new AdminAccount(properties);
    };

    /**
     * Encodes the specified AdminAccount message. Does not implicitly {@link AdminAccount.verify|verify} messages.
     * @function encode
     * @memberof AdminAccount
     * @static
     * @param {IAdminAccount} message AdminAccount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminAccount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.email_address);
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.first_name);
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.last_name);
        if (message.last_login != null && message.hasOwnProperty("last_login"))
            $root.google.protobuf.Timestamp.encode(message.last_login, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AdminAccount message, length delimited. Does not implicitly {@link AdminAccount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AdminAccount
     * @static
     * @param {IAdminAccount} message AdminAccount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AdminAccount message from the specified reader or buffer.
     * @function decode
     * @memberof AdminAccount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AdminAccount} AdminAccount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AdminAccount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.email_address = reader.string();
                break;
            case 3:
                message.first_name = reader.string();
                break;
            case 4:
                message.last_name = reader.string();
                break;
            case 5:
                message.last_login = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 6:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 7:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AdminAccount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AdminAccount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AdminAccount} AdminAccount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AdminAccount message.
     * @function verify
     * @memberof AdminAccount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AdminAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            if (!$util.isString(message.email_address))
                return "email_address: string expected";
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            if (!$util.isString(message.first_name))
                return "first_name: string expected";
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            if (!$util.isString(message.last_name))
                return "last_name: string expected";
        if (message.last_login != null && message.hasOwnProperty("last_login")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_login);
            if (error)
                return "last_login." + error;
        }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates an AdminAccount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AdminAccount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AdminAccount} AdminAccount
     */
    AdminAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.AdminAccount)
            return object;
        let message = new $root.AdminAccount();
        if (object.id != null)
            message.id = String(object.id);
        if (object.email_address != null)
            message.email_address = String(object.email_address);
        if (object.first_name != null)
            message.first_name = String(object.first_name);
        if (object.last_name != null)
            message.last_name = String(object.last_name);
        if (object.last_login != null) {
            if (typeof object.last_login !== "object")
                throw TypeError(".AdminAccount.last_login: object expected");
            message.last_login = $root.google.protobuf.Timestamp.fromObject(object.last_login);
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".AdminAccount.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".AdminAccount.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an AdminAccount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AdminAccount
     * @static
     * @param {AdminAccount} message AdminAccount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AdminAccount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.email_address = "";
            object.first_name = "";
            object.last_name = "";
            object.last_login = null;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            object.email_address = message.email_address;
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            object.first_name = message.first_name;
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            object.last_name = message.last_name;
        if (message.last_login != null && message.hasOwnProperty("last_login"))
            object.last_login = $root.google.protobuf.Timestamp.toObject(message.last_login, options);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this AdminAccount to JSON.
     * @function toJSON
     * @memberof AdminAccount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AdminAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AdminAccount;
})();

export const Auth = $root.Auth = (() => {

    /**
     * Properties of an Auth.
     * @exports IAuth
     * @interface IAuth
     * @property {string|null} [auth_token] Auth auth_token
     * @property {string|null} [refresh_token] Auth refresh_token
     * @property {Array.<string>|null} [scopes] Auth scopes
     */

    /**
     * Constructs a new Auth.
     * @exports Auth
     * @classdesc Represents an Auth.
     * @implements IAuth
     * @constructor
     * @param {IAuth=} [properties] Properties to set
     */
    function Auth(properties) {
        this.scopes = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Auth auth_token.
     * @member {string} auth_token
     * @memberof Auth
     * @instance
     */
    Auth.prototype.auth_token = "";

    /**
     * Auth refresh_token.
     * @member {string} refresh_token
     * @memberof Auth
     * @instance
     */
    Auth.prototype.refresh_token = "";

    /**
     * Auth scopes.
     * @member {Array.<string>} scopes
     * @memberof Auth
     * @instance
     */
    Auth.prototype.scopes = $util.emptyArray;

    /**
     * Creates a new Auth instance using the specified properties.
     * @function create
     * @memberof Auth
     * @static
     * @param {IAuth=} [properties] Properties to set
     * @returns {Auth} Auth instance
     */
    Auth.create = function create(properties) {
        return new Auth(properties);
    };

    /**
     * Encodes the specified Auth message. Does not implicitly {@link Auth.verify|verify} messages.
     * @function encode
     * @memberof Auth
     * @static
     * @param {IAuth} message Auth message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Auth.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.auth_token != null && message.hasOwnProperty("auth_token"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.auth_token);
        if (message.refresh_token != null && message.hasOwnProperty("refresh_token"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.refresh_token);
        if (message.scopes != null && message.scopes.length)
            for (let i = 0; i < message.scopes.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.scopes[i]);
        return writer;
    };

    /**
     * Encodes the specified Auth message, length delimited. Does not implicitly {@link Auth.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Auth
     * @static
     * @param {IAuth} message Auth message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Auth.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Auth message from the specified reader or buffer.
     * @function decode
     * @memberof Auth
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Auth} Auth
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Auth.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Auth();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.auth_token = reader.string();
                break;
            case 2:
                message.refresh_token = reader.string();
                break;
            case 3:
                if (!(message.scopes && message.scopes.length))
                    message.scopes = [];
                message.scopes.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Auth message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Auth
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Auth} Auth
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Auth.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Auth message.
     * @function verify
     * @memberof Auth
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Auth.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.auth_token != null && message.hasOwnProperty("auth_token"))
            if (!$util.isString(message.auth_token))
                return "auth_token: string expected";
        if (message.refresh_token != null && message.hasOwnProperty("refresh_token"))
            if (!$util.isString(message.refresh_token))
                return "refresh_token: string expected";
        if (message.scopes != null && message.hasOwnProperty("scopes")) {
            if (!Array.isArray(message.scopes))
                return "scopes: array expected";
            for (let i = 0; i < message.scopes.length; ++i)
                if (!$util.isString(message.scopes[i]))
                    return "scopes: string[] expected";
        }
        return null;
    };

    /**
     * Creates an Auth message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Auth
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Auth} Auth
     */
    Auth.fromObject = function fromObject(object) {
        if (object instanceof $root.Auth)
            return object;
        let message = new $root.Auth();
        if (object.auth_token != null)
            message.auth_token = String(object.auth_token);
        if (object.refresh_token != null)
            message.refresh_token = String(object.refresh_token);
        if (object.scopes) {
            if (!Array.isArray(object.scopes))
                throw TypeError(".Auth.scopes: array expected");
            message.scopes = [];
            for (let i = 0; i < object.scopes.length; ++i)
                message.scopes[i] = String(object.scopes[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from an Auth message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Auth
     * @static
     * @param {Auth} message Auth
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Auth.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.scopes = [];
        if (options.defaults) {
            object.auth_token = "";
            object.refresh_token = "";
        }
        if (message.auth_token != null && message.hasOwnProperty("auth_token"))
            object.auth_token = message.auth_token;
        if (message.refresh_token != null && message.hasOwnProperty("refresh_token"))
            object.refresh_token = message.refresh_token;
        if (message.scopes && message.scopes.length) {
            object.scopes = [];
            for (let j = 0; j < message.scopes.length; ++j)
                object.scopes[j] = message.scopes[j];
        }
        return object;
    };

    /**
     * Converts this Auth to JSON.
     * @function toJSON
     * @memberof Auth
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Auth.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Auth;
})();

export const IntercomHashes = $root.IntercomHashes = (() => {

    /**
     * Properties of an IntercomHashes.
     * @exports IIntercomHashes
     * @interface IIntercomHashes
     * @property {string|null} [ios] IntercomHashes ios
     * @property {string|null} [android] IntercomHashes android
     * @property {string|null} [web] IntercomHashes web
     */

    /**
     * Constructs a new IntercomHashes.
     * @exports IntercomHashes
     * @classdesc Represents an IntercomHashes.
     * @implements IIntercomHashes
     * @constructor
     * @param {IIntercomHashes=} [properties] Properties to set
     */
    function IntercomHashes(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * IntercomHashes ios.
     * @member {string} ios
     * @memberof IntercomHashes
     * @instance
     */
    IntercomHashes.prototype.ios = "";

    /**
     * IntercomHashes android.
     * @member {string} android
     * @memberof IntercomHashes
     * @instance
     */
    IntercomHashes.prototype.android = "";

    /**
     * IntercomHashes web.
     * @member {string} web
     * @memberof IntercomHashes
     * @instance
     */
    IntercomHashes.prototype.web = "";

    /**
     * Creates a new IntercomHashes instance using the specified properties.
     * @function create
     * @memberof IntercomHashes
     * @static
     * @param {IIntercomHashes=} [properties] Properties to set
     * @returns {IntercomHashes} IntercomHashes instance
     */
    IntercomHashes.create = function create(properties) {
        return new IntercomHashes(properties);
    };

    /**
     * Encodes the specified IntercomHashes message. Does not implicitly {@link IntercomHashes.verify|verify} messages.
     * @function encode
     * @memberof IntercomHashes
     * @static
     * @param {IIntercomHashes} message IntercomHashes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    IntercomHashes.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ios != null && message.hasOwnProperty("ios"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.ios);
        if (message.android != null && message.hasOwnProperty("android"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.android);
        if (message.web != null && message.hasOwnProperty("web"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.web);
        return writer;
    };

    /**
     * Encodes the specified IntercomHashes message, length delimited. Does not implicitly {@link IntercomHashes.verify|verify} messages.
     * @function encodeDelimited
     * @memberof IntercomHashes
     * @static
     * @param {IIntercomHashes} message IntercomHashes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    IntercomHashes.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an IntercomHashes message from the specified reader or buffer.
     * @function decode
     * @memberof IntercomHashes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {IntercomHashes} IntercomHashes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    IntercomHashes.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.IntercomHashes();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ios = reader.string();
                break;
            case 2:
                message.android = reader.string();
                break;
            case 3:
                message.web = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an IntercomHashes message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof IntercomHashes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {IntercomHashes} IntercomHashes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    IntercomHashes.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an IntercomHashes message.
     * @function verify
     * @memberof IntercomHashes
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    IntercomHashes.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ios != null && message.hasOwnProperty("ios"))
            if (!$util.isString(message.ios))
                return "ios: string expected";
        if (message.android != null && message.hasOwnProperty("android"))
            if (!$util.isString(message.android))
                return "android: string expected";
        if (message.web != null && message.hasOwnProperty("web"))
            if (!$util.isString(message.web))
                return "web: string expected";
        return null;
    };

    /**
     * Creates an IntercomHashes message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof IntercomHashes
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {IntercomHashes} IntercomHashes
     */
    IntercomHashes.fromObject = function fromObject(object) {
        if (object instanceof $root.IntercomHashes)
            return object;
        let message = new $root.IntercomHashes();
        if (object.ios != null)
            message.ios = String(object.ios);
        if (object.android != null)
            message.android = String(object.android);
        if (object.web != null)
            message.web = String(object.web);
        return message;
    };

    /**
     * Creates a plain object from an IntercomHashes message. Also converts values to other types if specified.
     * @function toObject
     * @memberof IntercomHashes
     * @static
     * @param {IntercomHashes} message IntercomHashes
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    IntercomHashes.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.ios = "";
            object.android = "";
            object.web = "";
        }
        if (message.ios != null && message.hasOwnProperty("ios"))
            object.ios = message.ios;
        if (message.android != null && message.hasOwnProperty("android"))
            object.android = message.android;
        if (message.web != null && message.hasOwnProperty("web"))
            object.web = message.web;
        return object;
    };

    /**
     * Converts this IntercomHashes to JSON.
     * @function toJSON
     * @memberof IntercomHashes
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    IntercomHashes.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return IntercomHashes;
})();

export const ResetPasswordErrorReason = $root.ResetPasswordErrorReason = (() => {

    /**
     * Properties of a ResetPasswordErrorReason.
     * @exports IResetPasswordErrorReason
     * @interface IResetPasswordErrorReason
     */

    /**
     * Constructs a new ResetPasswordErrorReason.
     * @exports ResetPasswordErrorReason
     * @classdesc Represents a ResetPasswordErrorReason.
     * @implements IResetPasswordErrorReason
     * @constructor
     * @param {IResetPasswordErrorReason=} [properties] Properties to set
     */
    function ResetPasswordErrorReason(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new ResetPasswordErrorReason instance using the specified properties.
     * @function create
     * @memberof ResetPasswordErrorReason
     * @static
     * @param {IResetPasswordErrorReason=} [properties] Properties to set
     * @returns {ResetPasswordErrorReason} ResetPasswordErrorReason instance
     */
    ResetPasswordErrorReason.create = function create(properties) {
        return new ResetPasswordErrorReason(properties);
    };

    /**
     * Encodes the specified ResetPasswordErrorReason message. Does not implicitly {@link ResetPasswordErrorReason.verify|verify} messages.
     * @function encode
     * @memberof ResetPasswordErrorReason
     * @static
     * @param {IResetPasswordErrorReason} message ResetPasswordErrorReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResetPasswordErrorReason.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified ResetPasswordErrorReason message, length delimited. Does not implicitly {@link ResetPasswordErrorReason.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ResetPasswordErrorReason
     * @static
     * @param {IResetPasswordErrorReason} message ResetPasswordErrorReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResetPasswordErrorReason.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ResetPasswordErrorReason message from the specified reader or buffer.
     * @function decode
     * @memberof ResetPasswordErrorReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ResetPasswordErrorReason} ResetPasswordErrorReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResetPasswordErrorReason.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResetPasswordErrorReason();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ResetPasswordErrorReason message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ResetPasswordErrorReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ResetPasswordErrorReason} ResetPasswordErrorReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResetPasswordErrorReason.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ResetPasswordErrorReason message.
     * @function verify
     * @memberof ResetPasswordErrorReason
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ResetPasswordErrorReason.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a ResetPasswordErrorReason message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ResetPasswordErrorReason
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ResetPasswordErrorReason} ResetPasswordErrorReason
     */
    ResetPasswordErrorReason.fromObject = function fromObject(object) {
        if (object instanceof $root.ResetPasswordErrorReason)
            return object;
        return new $root.ResetPasswordErrorReason();
    };

    /**
     * Creates a plain object from a ResetPasswordErrorReason message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ResetPasswordErrorReason
     * @static
     * @param {ResetPasswordErrorReason} message ResetPasswordErrorReason
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ResetPasswordErrorReason.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this ResetPasswordErrorReason to JSON.
     * @function toJSON
     * @memberof ResetPasswordErrorReason
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ResetPasswordErrorReason.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name ResetPasswordErrorReason.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} MISMATCH=1 MISMATCH value
     * @property {number} USED=2 USED value
     * @property {number} EXPIRED=3 EXPIRED value
     */
    ResetPasswordErrorReason.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "MISMATCH"] = 1;
        values[valuesById[2] = "USED"] = 2;
        values[valuesById[3] = "EXPIRED"] = 3;
        return values;
    })();

    return ResetPasswordErrorReason;
})();

export const CronEntry = $root.CronEntry = (() => {

    /**
     * Properties of a CronEntry.
     * @exports ICronEntry
     * @interface ICronEntry
     * @property {string|null} [id] CronEntry id
     * @property {string|null} [job_name] CronEntry job_name
     * @property {google.protobuf.ITimestamp|null} [prev] CronEntry prev
     * @property {google.protobuf.ITimestamp|null} [next] CronEntry next
     */

    /**
     * Constructs a new CronEntry.
     * @exports CronEntry
     * @classdesc Represents a CronEntry.
     * @implements ICronEntry
     * @constructor
     * @param {ICronEntry=} [properties] Properties to set
     */
    function CronEntry(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CronEntry id.
     * @member {string} id
     * @memberof CronEntry
     * @instance
     */
    CronEntry.prototype.id = "";

    /**
     * CronEntry job_name.
     * @member {string} job_name
     * @memberof CronEntry
     * @instance
     */
    CronEntry.prototype.job_name = "";

    /**
     * CronEntry prev.
     * @member {google.protobuf.ITimestamp|null|undefined} prev
     * @memberof CronEntry
     * @instance
     */
    CronEntry.prototype.prev = null;

    /**
     * CronEntry next.
     * @member {google.protobuf.ITimestamp|null|undefined} next
     * @memberof CronEntry
     * @instance
     */
    CronEntry.prototype.next = null;

    /**
     * Creates a new CronEntry instance using the specified properties.
     * @function create
     * @memberof CronEntry
     * @static
     * @param {ICronEntry=} [properties] Properties to set
     * @returns {CronEntry} CronEntry instance
     */
    CronEntry.create = function create(properties) {
        return new CronEntry(properties);
    };

    /**
     * Encodes the specified CronEntry message. Does not implicitly {@link CronEntry.verify|verify} messages.
     * @function encode
     * @memberof CronEntry
     * @static
     * @param {ICronEntry} message CronEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CronEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.job_name != null && message.hasOwnProperty("job_name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.job_name);
        if (message.prev != null && message.hasOwnProperty("prev"))
            $root.google.protobuf.Timestamp.encode(message.prev, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.next != null && message.hasOwnProperty("next"))
            $root.google.protobuf.Timestamp.encode(message.next, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified CronEntry message, length delimited. Does not implicitly {@link CronEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CronEntry
     * @static
     * @param {ICronEntry} message CronEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CronEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CronEntry message from the specified reader or buffer.
     * @function decode
     * @memberof CronEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CronEntry} CronEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CronEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CronEntry();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.job_name = reader.string();
                break;
            case 4:
                message.prev = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 5:
                message.next = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CronEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CronEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CronEntry} CronEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CronEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CronEntry message.
     * @function verify
     * @memberof CronEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CronEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.job_name != null && message.hasOwnProperty("job_name"))
            if (!$util.isString(message.job_name))
                return "job_name: string expected";
        if (message.prev != null && message.hasOwnProperty("prev")) {
            let error = $root.google.protobuf.Timestamp.verify(message.prev);
            if (error)
                return "prev." + error;
        }
        if (message.next != null && message.hasOwnProperty("next")) {
            let error = $root.google.protobuf.Timestamp.verify(message.next);
            if (error)
                return "next." + error;
        }
        return null;
    };

    /**
     * Creates a CronEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CronEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CronEntry} CronEntry
     */
    CronEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.CronEntry)
            return object;
        let message = new $root.CronEntry();
        if (object.id != null)
            message.id = String(object.id);
        if (object.job_name != null)
            message.job_name = String(object.job_name);
        if (object.prev != null) {
            if (typeof object.prev !== "object")
                throw TypeError(".CronEntry.prev: object expected");
            message.prev = $root.google.protobuf.Timestamp.fromObject(object.prev);
        }
        if (object.next != null) {
            if (typeof object.next !== "object")
                throw TypeError(".CronEntry.next: object expected");
            message.next = $root.google.protobuf.Timestamp.fromObject(object.next);
        }
        return message;
    };

    /**
     * Creates a plain object from a CronEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CronEntry
     * @static
     * @param {CronEntry} message CronEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CronEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.job_name = "";
            object.prev = null;
            object.next = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.job_name != null && message.hasOwnProperty("job_name"))
            object.job_name = message.job_name;
        if (message.prev != null && message.hasOwnProperty("prev"))
            object.prev = $root.google.protobuf.Timestamp.toObject(message.prev, options);
        if (message.next != null && message.hasOwnProperty("next"))
            object.next = $root.google.protobuf.Timestamp.toObject(message.next, options);
        return object;
    };

    /**
     * Converts this CronEntry to JSON.
     * @function toJSON
     * @memberof CronEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CronEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CronEntry;
})();

export const DateFilter = $root.DateFilter = (() => {

    /**
     * Properties of a DateFilter.
     * @exports IDateFilter
     * @interface IDateFilter
     * @property {string|null} [from_date] DateFilter from_date
     * @property {string|null} [to_date] DateFilter to_date
     * @property {Array.<string>|null} [dates] DateFilter dates
     */

    /**
     * Constructs a new DateFilter.
     * @exports DateFilter
     * @classdesc Represents a DateFilter.
     * @implements IDateFilter
     * @constructor
     * @param {IDateFilter=} [properties] Properties to set
     */
    function DateFilter(properties) {
        this.dates = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DateFilter from_date.
     * @member {string} from_date
     * @memberof DateFilter
     * @instance
     */
    DateFilter.prototype.from_date = "";

    /**
     * DateFilter to_date.
     * @member {string} to_date
     * @memberof DateFilter
     * @instance
     */
    DateFilter.prototype.to_date = "";

    /**
     * DateFilter dates.
     * @member {Array.<string>} dates
     * @memberof DateFilter
     * @instance
     */
    DateFilter.prototype.dates = $util.emptyArray;

    /**
     * Creates a new DateFilter instance using the specified properties.
     * @function create
     * @memberof DateFilter
     * @static
     * @param {IDateFilter=} [properties] Properties to set
     * @returns {DateFilter} DateFilter instance
     */
    DateFilter.create = function create(properties) {
        return new DateFilter(properties);
    };

    /**
     * Encodes the specified DateFilter message. Does not implicitly {@link DateFilter.verify|verify} messages.
     * @function encode
     * @memberof DateFilter
     * @static
     * @param {IDateFilter} message DateFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DateFilter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.from_date != null && message.hasOwnProperty("from_date"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.from_date);
        if (message.to_date != null && message.hasOwnProperty("to_date"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.to_date);
        if (message.dates != null && message.dates.length)
            for (let i = 0; i < message.dates.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.dates[i]);
        return writer;
    };

    /**
     * Encodes the specified DateFilter message, length delimited. Does not implicitly {@link DateFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DateFilter
     * @static
     * @param {IDateFilter} message DateFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DateFilter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DateFilter message from the specified reader or buffer.
     * @function decode
     * @memberof DateFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DateFilter} DateFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DateFilter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DateFilter();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.from_date = reader.string();
                break;
            case 2:
                message.to_date = reader.string();
                break;
            case 3:
                if (!(message.dates && message.dates.length))
                    message.dates = [];
                message.dates.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DateFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DateFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DateFilter} DateFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DateFilter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DateFilter message.
     * @function verify
     * @memberof DateFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DateFilter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.from_date != null && message.hasOwnProperty("from_date"))
            if (!$util.isString(message.from_date))
                return "from_date: string expected";
        if (message.to_date != null && message.hasOwnProperty("to_date"))
            if (!$util.isString(message.to_date))
                return "to_date: string expected";
        if (message.dates != null && message.hasOwnProperty("dates")) {
            if (!Array.isArray(message.dates))
                return "dates: array expected";
            for (let i = 0; i < message.dates.length; ++i)
                if (!$util.isString(message.dates[i]))
                    return "dates: string[] expected";
        }
        return null;
    };

    /**
     * Creates a DateFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DateFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DateFilter} DateFilter
     */
    DateFilter.fromObject = function fromObject(object) {
        if (object instanceof $root.DateFilter)
            return object;
        let message = new $root.DateFilter();
        if (object.from_date != null)
            message.from_date = String(object.from_date);
        if (object.to_date != null)
            message.to_date = String(object.to_date);
        if (object.dates) {
            if (!Array.isArray(object.dates))
                throw TypeError(".DateFilter.dates: array expected");
            message.dates = [];
            for (let i = 0; i < object.dates.length; ++i)
                message.dates[i] = String(object.dates[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a DateFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DateFilter
     * @static
     * @param {DateFilter} message DateFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DateFilter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.dates = [];
        if (options.defaults) {
            object.from_date = "";
            object.to_date = "";
        }
        if (message.from_date != null && message.hasOwnProperty("from_date"))
            object.from_date = message.from_date;
        if (message.to_date != null && message.hasOwnProperty("to_date"))
            object.to_date = message.to_date;
        if (message.dates && message.dates.length) {
            object.dates = [];
            for (let j = 0; j < message.dates.length; ++j)
                object.dates[j] = message.dates[j];
        }
        return object;
    };

    /**
     * Converts this DateFilter to JSON.
     * @function toJSON
     * @memberof DateFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DateFilter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DateFilter;
})();

export const ForeignTaxResidence = $root.ForeignTaxResidence = (() => {

    /**
     * Properties of a ForeignTaxResidence.
     * @exports IForeignTaxResidence
     * @interface IForeignTaxResidence
     * @property {string|null} [id] ForeignTaxResidence id
     * @property {string|null} [contact_id] ForeignTaxResidence contact_id
     * @property {string|null} [country_id] ForeignTaxResidence country_id
     * @property {boolean|null} [tin_provided] ForeignTaxResidence tin_provided
     * @property {boolean|null} [primary_residence] ForeignTaxResidence primary_residence
     * @property {ForeignTaxResidence.IMissingTinDetails|null} [missing_tin_details] ForeignTaxResidence missing_tin_details
     * @property {boolean|null} [deleted] ForeignTaxResidence deleted
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] ForeignTaxResidence last_updated_at
     * @property {google.protobuf.ITimestamp|null} [created_at] ForeignTaxResidence created_at
     */

    /**
     * Constructs a new ForeignTaxResidence.
     * @exports ForeignTaxResidence
     * @classdesc Represents a ForeignTaxResidence.
     * @implements IForeignTaxResidence
     * @constructor
     * @param {IForeignTaxResidence=} [properties] Properties to set
     */
    function ForeignTaxResidence(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ForeignTaxResidence id.
     * @member {string} id
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.id = "";

    /**
     * ForeignTaxResidence contact_id.
     * @member {string} contact_id
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.contact_id = "";

    /**
     * ForeignTaxResidence country_id.
     * @member {string} country_id
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.country_id = "";

    /**
     * ForeignTaxResidence tin_provided.
     * @member {boolean} tin_provided
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.tin_provided = false;

    /**
     * ForeignTaxResidence primary_residence.
     * @member {boolean} primary_residence
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.primary_residence = false;

    /**
     * ForeignTaxResidence missing_tin_details.
     * @member {ForeignTaxResidence.IMissingTinDetails|null|undefined} missing_tin_details
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.missing_tin_details = null;

    /**
     * ForeignTaxResidence deleted.
     * @member {boolean} deleted
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.deleted = false;

    /**
     * ForeignTaxResidence last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.last_updated_at = null;

    /**
     * ForeignTaxResidence created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof ForeignTaxResidence
     * @instance
     */
    ForeignTaxResidence.prototype.created_at = null;

    /**
     * Creates a new ForeignTaxResidence instance using the specified properties.
     * @function create
     * @memberof ForeignTaxResidence
     * @static
     * @param {IForeignTaxResidence=} [properties] Properties to set
     * @returns {ForeignTaxResidence} ForeignTaxResidence instance
     */
    ForeignTaxResidence.create = function create(properties) {
        return new ForeignTaxResidence(properties);
    };

    /**
     * Encodes the specified ForeignTaxResidence message. Does not implicitly {@link ForeignTaxResidence.verify|verify} messages.
     * @function encode
     * @memberof ForeignTaxResidence
     * @static
     * @param {IForeignTaxResidence} message ForeignTaxResidence message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForeignTaxResidence.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.contact_id);
        if (message.country_id != null && message.hasOwnProperty("country_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.country_id);
        if (message.tin_provided != null && message.hasOwnProperty("tin_provided"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.tin_provided);
        if (message.primary_residence != null && message.hasOwnProperty("primary_residence"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.primary_residence);
        if (message.missing_tin_details != null && message.hasOwnProperty("missing_tin_details"))
            $root.ForeignTaxResidence.MissingTinDetails.encode(message.missing_tin_details, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.deleted != null && message.hasOwnProperty("deleted"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.deleted);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ForeignTaxResidence message, length delimited. Does not implicitly {@link ForeignTaxResidence.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ForeignTaxResidence
     * @static
     * @param {IForeignTaxResidence} message ForeignTaxResidence message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForeignTaxResidence.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ForeignTaxResidence message from the specified reader or buffer.
     * @function decode
     * @memberof ForeignTaxResidence
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForeignTaxResidence} ForeignTaxResidence
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForeignTaxResidence.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ForeignTaxResidence();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.contact_id = reader.string();
                break;
            case 3:
                message.country_id = reader.string();
                break;
            case 4:
                message.tin_provided = reader.bool();
                break;
            case 5:
                message.primary_residence = reader.bool();
                break;
            case 6:
                message.missing_tin_details = $root.ForeignTaxResidence.MissingTinDetails.decode(reader, reader.uint32());
                break;
            case 7:
                message.deleted = reader.bool();
                break;
            case 98:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ForeignTaxResidence message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ForeignTaxResidence
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ForeignTaxResidence} ForeignTaxResidence
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForeignTaxResidence.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ForeignTaxResidence message.
     * @function verify
     * @memberof ForeignTaxResidence
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ForeignTaxResidence.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            if (!$util.isString(message.contact_id))
                return "contact_id: string expected";
        if (message.country_id != null && message.hasOwnProperty("country_id"))
            if (!$util.isString(message.country_id))
                return "country_id: string expected";
        if (message.tin_provided != null && message.hasOwnProperty("tin_provided"))
            if (typeof message.tin_provided !== "boolean")
                return "tin_provided: boolean expected";
        if (message.primary_residence != null && message.hasOwnProperty("primary_residence"))
            if (typeof message.primary_residence !== "boolean")
                return "primary_residence: boolean expected";
        if (message.missing_tin_details != null && message.hasOwnProperty("missing_tin_details")) {
            let error = $root.ForeignTaxResidence.MissingTinDetails.verify(message.missing_tin_details);
            if (error)
                return "missing_tin_details." + error;
        }
        if (message.deleted != null && message.hasOwnProperty("deleted"))
            if (typeof message.deleted !== "boolean")
                return "deleted: boolean expected";
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a ForeignTaxResidence message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForeignTaxResidence
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForeignTaxResidence} ForeignTaxResidence
     */
    ForeignTaxResidence.fromObject = function fromObject(object) {
        if (object instanceof $root.ForeignTaxResidence)
            return object;
        let message = new $root.ForeignTaxResidence();
        if (object.id != null)
            message.id = String(object.id);
        if (object.contact_id != null)
            message.contact_id = String(object.contact_id);
        if (object.country_id != null)
            message.country_id = String(object.country_id);
        if (object.tin_provided != null)
            message.tin_provided = Boolean(object.tin_provided);
        if (object.primary_residence != null)
            message.primary_residence = Boolean(object.primary_residence);
        if (object.missing_tin_details != null) {
            if (typeof object.missing_tin_details !== "object")
                throw TypeError(".ForeignTaxResidence.missing_tin_details: object expected");
            message.missing_tin_details = $root.ForeignTaxResidence.MissingTinDetails.fromObject(object.missing_tin_details);
        }
        if (object.deleted != null)
            message.deleted = Boolean(object.deleted);
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".ForeignTaxResidence.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".ForeignTaxResidence.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a ForeignTaxResidence message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForeignTaxResidence
     * @static
     * @param {ForeignTaxResidence} message ForeignTaxResidence
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForeignTaxResidence.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.contact_id = "";
            object.country_id = "";
            object.tin_provided = false;
            object.primary_residence = false;
            object.missing_tin_details = null;
            object.deleted = false;
            object.last_updated_at = null;
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            object.contact_id = message.contact_id;
        if (message.country_id != null && message.hasOwnProperty("country_id"))
            object.country_id = message.country_id;
        if (message.tin_provided != null && message.hasOwnProperty("tin_provided"))
            object.tin_provided = message.tin_provided;
        if (message.primary_residence != null && message.hasOwnProperty("primary_residence"))
            object.primary_residence = message.primary_residence;
        if (message.missing_tin_details != null && message.hasOwnProperty("missing_tin_details"))
            object.missing_tin_details = $root.ForeignTaxResidence.MissingTinDetails.toObject(message.missing_tin_details, options);
        if (message.deleted != null && message.hasOwnProperty("deleted"))
            object.deleted = message.deleted;
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this ForeignTaxResidence to JSON.
     * @function toJSON
     * @memberof ForeignTaxResidence
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForeignTaxResidence.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ForeignTaxResidence.MissingTinDetails = (function() {

        /**
         * Properties of a MissingTinDetails.
         * @memberof ForeignTaxResidence
         * @interface IMissingTinDetails
         * @property {ForeignTaxResidence.MissingTinDetails.Reason.Enum|null} [reason] MissingTinDetails reason
         * @property {string|null} [other_reason_description] MissingTinDetails other_reason_description
         * @property {boolean|null} [active] MissingTinDetails active
         * @property {google.protobuf.ITimestamp|null} [last_updated_at] MissingTinDetails last_updated_at
         * @property {google.protobuf.ITimestamp|null} [created_at] MissingTinDetails created_at
         */

        /**
         * Constructs a new MissingTinDetails.
         * @memberof ForeignTaxResidence
         * @classdesc Represents a MissingTinDetails.
         * @implements IMissingTinDetails
         * @constructor
         * @param {ForeignTaxResidence.IMissingTinDetails=} [properties] Properties to set
         */
        function MissingTinDetails(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MissingTinDetails reason.
         * @member {ForeignTaxResidence.MissingTinDetails.Reason.Enum} reason
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @instance
         */
        MissingTinDetails.prototype.reason = 0;

        /**
         * MissingTinDetails other_reason_description.
         * @member {string} other_reason_description
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @instance
         */
        MissingTinDetails.prototype.other_reason_description = "";

        /**
         * MissingTinDetails active.
         * @member {boolean} active
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @instance
         */
        MissingTinDetails.prototype.active = false;

        /**
         * MissingTinDetails last_updated_at.
         * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @instance
         */
        MissingTinDetails.prototype.last_updated_at = null;

        /**
         * MissingTinDetails created_at.
         * @member {google.protobuf.ITimestamp|null|undefined} created_at
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @instance
         */
        MissingTinDetails.prototype.created_at = null;

        /**
         * Creates a new MissingTinDetails instance using the specified properties.
         * @function create
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @static
         * @param {ForeignTaxResidence.IMissingTinDetails=} [properties] Properties to set
         * @returns {ForeignTaxResidence.MissingTinDetails} MissingTinDetails instance
         */
        MissingTinDetails.create = function create(properties) {
            return new MissingTinDetails(properties);
        };

        /**
         * Encodes the specified MissingTinDetails message. Does not implicitly {@link ForeignTaxResidence.MissingTinDetails.verify|verify} messages.
         * @function encode
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @static
         * @param {ForeignTaxResidence.IMissingTinDetails} message MissingTinDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MissingTinDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.reason != null && message.hasOwnProperty("reason"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.reason);
            if (message.other_reason_description != null && message.hasOwnProperty("other_reason_description"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.other_reason_description);
            if (message.active != null && message.hasOwnProperty("active"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.active);
            if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
                $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MissingTinDetails message, length delimited. Does not implicitly {@link ForeignTaxResidence.MissingTinDetails.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @static
         * @param {ForeignTaxResidence.IMissingTinDetails} message MissingTinDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MissingTinDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MissingTinDetails message from the specified reader or buffer.
         * @function decode
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ForeignTaxResidence.MissingTinDetails} MissingTinDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MissingTinDetails.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ForeignTaxResidence.MissingTinDetails();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.reason = reader.int32();
                    break;
                case 2:
                    message.other_reason_description = reader.string();
                    break;
                case 3:
                    message.active = reader.bool();
                    break;
                case 98:
                    message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                    break;
                case 99:
                    message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MissingTinDetails message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ForeignTaxResidence.MissingTinDetails} MissingTinDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MissingTinDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MissingTinDetails message.
         * @function verify
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MissingTinDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                switch (message.reason) {
                default:
                    return "reason: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.other_reason_description != null && message.hasOwnProperty("other_reason_description"))
                if (!$util.isString(message.other_reason_description))
                    return "other_reason_description: string expected";
            if (message.active != null && message.hasOwnProperty("active"))
                if (typeof message.active !== "boolean")
                    return "active: boolean expected";
            if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
                let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
                if (error)
                    return "last_updated_at." + error;
            }
            if (message.created_at != null && message.hasOwnProperty("created_at")) {
                let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                if (error)
                    return "created_at." + error;
            }
            return null;
        };

        /**
         * Creates a MissingTinDetails message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ForeignTaxResidence.MissingTinDetails} MissingTinDetails
         */
        MissingTinDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.ForeignTaxResidence.MissingTinDetails)
                return object;
            let message = new $root.ForeignTaxResidence.MissingTinDetails();
            switch (object.reason) {
            case "UNKNOWN":
            case 0:
                message.reason = 0;
                break;
            case "COUNTRY_DOES_NOT_PROVIDE_TIN":
            case 1:
                message.reason = 1;
                break;
            case "TIN_YET_TO_BE_ISSUED":
            case 2:
                message.reason = 2;
                break;
            case "OTHER":
            case 3:
                message.reason = 3;
                break;
            }
            if (object.other_reason_description != null)
                message.other_reason_description = String(object.other_reason_description);
            if (object.active != null)
                message.active = Boolean(object.active);
            if (object.last_updated_at != null) {
                if (typeof object.last_updated_at !== "object")
                    throw TypeError(".ForeignTaxResidence.MissingTinDetails.last_updated_at: object expected");
                message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
            }
            if (object.created_at != null) {
                if (typeof object.created_at !== "object")
                    throw TypeError(".ForeignTaxResidence.MissingTinDetails.created_at: object expected");
                message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
            }
            return message;
        };

        /**
         * Creates a plain object from a MissingTinDetails message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @static
         * @param {ForeignTaxResidence.MissingTinDetails} message MissingTinDetails
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MissingTinDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.reason = options.enums === String ? "UNKNOWN" : 0;
                object.other_reason_description = "";
                object.active = false;
                object.last_updated_at = null;
                object.created_at = null;
            }
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = options.enums === String ? $root.ForeignTaxResidence.MissingTinDetails.Reason.Enum[message.reason] : message.reason;
            if (message.other_reason_description != null && message.hasOwnProperty("other_reason_description"))
                object.other_reason_description = message.other_reason_description;
            if (message.active != null && message.hasOwnProperty("active"))
                object.active = message.active;
            if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
                object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
            return object;
        };

        /**
         * Converts this MissingTinDetails to JSON.
         * @function toJSON
         * @memberof ForeignTaxResidence.MissingTinDetails
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MissingTinDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        MissingTinDetails.Reason = (function() {

            /**
             * Properties of a Reason.
             * @memberof ForeignTaxResidence.MissingTinDetails
             * @interface IReason
             */

            /**
             * Constructs a new Reason.
             * @memberof ForeignTaxResidence.MissingTinDetails
             * @classdesc Represents a Reason.
             * @implements IReason
             * @constructor
             * @param {ForeignTaxResidence.MissingTinDetails.IReason=} [properties] Properties to set
             */
            function Reason(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Reason instance using the specified properties.
             * @function create
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @static
             * @param {ForeignTaxResidence.MissingTinDetails.IReason=} [properties] Properties to set
             * @returns {ForeignTaxResidence.MissingTinDetails.Reason} Reason instance
             */
            Reason.create = function create(properties) {
                return new Reason(properties);
            };

            /**
             * Encodes the specified Reason message. Does not implicitly {@link ForeignTaxResidence.MissingTinDetails.Reason.verify|verify} messages.
             * @function encode
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @static
             * @param {ForeignTaxResidence.MissingTinDetails.IReason} message Reason message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Reason.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Reason message, length delimited. Does not implicitly {@link ForeignTaxResidence.MissingTinDetails.Reason.verify|verify} messages.
             * @function encodeDelimited
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @static
             * @param {ForeignTaxResidence.MissingTinDetails.IReason} message Reason message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Reason.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Reason message from the specified reader or buffer.
             * @function decode
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {ForeignTaxResidence.MissingTinDetails.Reason} Reason
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Reason.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ForeignTaxResidence.MissingTinDetails.Reason();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Reason message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {ForeignTaxResidence.MissingTinDetails.Reason} Reason
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Reason.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Reason message.
             * @function verify
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Reason.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Reason message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {ForeignTaxResidence.MissingTinDetails.Reason} Reason
             */
            Reason.fromObject = function fromObject(object) {
                if (object instanceof $root.ForeignTaxResidence.MissingTinDetails.Reason)
                    return object;
                return new $root.ForeignTaxResidence.MissingTinDetails.Reason();
            };

            /**
             * Creates a plain object from a Reason message. Also converts values to other types if specified.
             * @function toObject
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @static
             * @param {ForeignTaxResidence.MissingTinDetails.Reason} message Reason
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Reason.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Reason to JSON.
             * @function toJSON
             * @memberof ForeignTaxResidence.MissingTinDetails.Reason
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Reason.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name ForeignTaxResidence.MissingTinDetails.Reason.Enum
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} COUNTRY_DOES_NOT_PROVIDE_TIN=1 COUNTRY_DOES_NOT_PROVIDE_TIN value
             * @property {number} TIN_YET_TO_BE_ISSUED=2 TIN_YET_TO_BE_ISSUED value
             * @property {number} OTHER=3 OTHER value
             */
            Reason.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "COUNTRY_DOES_NOT_PROVIDE_TIN"] = 1;
                values[valuesById[2] = "TIN_YET_TO_BE_ISSUED"] = 2;
                values[valuesById[3] = "OTHER"] = 3;
                return values;
            })();

            return Reason;
        })();

        return MissingTinDetails;
    })();

    return ForeignTaxResidence;
})();

export const ForeignTaxResidences = $root.ForeignTaxResidences = (() => {

    /**
     * Properties of a ForeignTaxResidences.
     * @exports IForeignTaxResidences
     * @interface IForeignTaxResidences
     * @property {Array.<IForeignTaxResidence>|null} [list] ForeignTaxResidences list
     */

    /**
     * Constructs a new ForeignTaxResidences.
     * @exports ForeignTaxResidences
     * @classdesc Represents a ForeignTaxResidences.
     * @implements IForeignTaxResidences
     * @constructor
     * @param {IForeignTaxResidences=} [properties] Properties to set
     */
    function ForeignTaxResidences(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ForeignTaxResidences list.
     * @member {Array.<IForeignTaxResidence>} list
     * @memberof ForeignTaxResidences
     * @instance
     */
    ForeignTaxResidences.prototype.list = $util.emptyArray;

    /**
     * Creates a new ForeignTaxResidences instance using the specified properties.
     * @function create
     * @memberof ForeignTaxResidences
     * @static
     * @param {IForeignTaxResidences=} [properties] Properties to set
     * @returns {ForeignTaxResidences} ForeignTaxResidences instance
     */
    ForeignTaxResidences.create = function create(properties) {
        return new ForeignTaxResidences(properties);
    };

    /**
     * Encodes the specified ForeignTaxResidences message. Does not implicitly {@link ForeignTaxResidences.verify|verify} messages.
     * @function encode
     * @memberof ForeignTaxResidences
     * @static
     * @param {IForeignTaxResidences} message ForeignTaxResidences message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForeignTaxResidences.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.ForeignTaxResidence.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ForeignTaxResidences message, length delimited. Does not implicitly {@link ForeignTaxResidences.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ForeignTaxResidences
     * @static
     * @param {IForeignTaxResidences} message ForeignTaxResidences message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForeignTaxResidences.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ForeignTaxResidences message from the specified reader or buffer.
     * @function decode
     * @memberof ForeignTaxResidences
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForeignTaxResidences} ForeignTaxResidences
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForeignTaxResidences.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ForeignTaxResidences();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.ForeignTaxResidence.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ForeignTaxResidences message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ForeignTaxResidences
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ForeignTaxResidences} ForeignTaxResidences
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForeignTaxResidences.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ForeignTaxResidences message.
     * @function verify
     * @memberof ForeignTaxResidences
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ForeignTaxResidences.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.ForeignTaxResidence.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ForeignTaxResidences message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForeignTaxResidences
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForeignTaxResidences} ForeignTaxResidences
     */
    ForeignTaxResidences.fromObject = function fromObject(object) {
        if (object instanceof $root.ForeignTaxResidences)
            return object;
        let message = new $root.ForeignTaxResidences();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".ForeignTaxResidences.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".ForeignTaxResidences.list: object expected");
                message.list[i] = $root.ForeignTaxResidence.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ForeignTaxResidences message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForeignTaxResidences
     * @static
     * @param {ForeignTaxResidences} message ForeignTaxResidences
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForeignTaxResidences.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.ForeignTaxResidence.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this ForeignTaxResidences to JSON.
     * @function toJSON
     * @memberof ForeignTaxResidences
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForeignTaxResidences.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ForeignTaxResidences;
})();

export const Country = $root.Country = (() => {

    /**
     * Properties of a Country.
     * @exports ICountry
     * @interface ICountry
     * @property {string|null} [id] Country id
     * @property {string|null} [country_name] Country country_name
     * @property {string|null} [country_code] Country country_code
     * @property {boolean|null} [active] Country active
     * @property {string|null} [country_code_3_letter] Country country_code_3_letter
     * @property {boolean|null} [tin_required] Country tin_required
     * @property {string|null} [tin_information_link] Country tin_information_link
     * @property {boolean|null} [tax_residency_allowed] Country tax_residency_allowed
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] Country last_updated_at
     * @property {google.protobuf.ITimestamp|null} [created_at] Country created_at
     */

    /**
     * Constructs a new Country.
     * @exports Country
     * @classdesc Represents a Country.
     * @implements ICountry
     * @constructor
     * @param {ICountry=} [properties] Properties to set
     */
    function Country(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Country id.
     * @member {string} id
     * @memberof Country
     * @instance
     */
    Country.prototype.id = "";

    /**
     * Country country_name.
     * @member {string} country_name
     * @memberof Country
     * @instance
     */
    Country.prototype.country_name = "";

    /**
     * Country country_code.
     * @member {string} country_code
     * @memberof Country
     * @instance
     */
    Country.prototype.country_code = "";

    /**
     * Country active.
     * @member {boolean} active
     * @memberof Country
     * @instance
     */
    Country.prototype.active = false;

    /**
     * Country country_code_3_letter.
     * @member {string} country_code_3_letter
     * @memberof Country
     * @instance
     */
    Country.prototype.country_code_3_letter = "";

    /**
     * Country tin_required.
     * @member {boolean} tin_required
     * @memberof Country
     * @instance
     */
    Country.prototype.tin_required = false;

    /**
     * Country tin_information_link.
     * @member {string} tin_information_link
     * @memberof Country
     * @instance
     */
    Country.prototype.tin_information_link = "";

    /**
     * Country tax_residency_allowed.
     * @member {boolean} tax_residency_allowed
     * @memberof Country
     * @instance
     */
    Country.prototype.tax_residency_allowed = false;

    /**
     * Country last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof Country
     * @instance
     */
    Country.prototype.last_updated_at = null;

    /**
     * Country created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof Country
     * @instance
     */
    Country.prototype.created_at = null;

    /**
     * Creates a new Country instance using the specified properties.
     * @function create
     * @memberof Country
     * @static
     * @param {ICountry=} [properties] Properties to set
     * @returns {Country} Country instance
     */
    Country.create = function create(properties) {
        return new Country(properties);
    };

    /**
     * Encodes the specified Country message. Does not implicitly {@link Country.verify|verify} messages.
     * @function encode
     * @memberof Country
     * @static
     * @param {ICountry} message Country message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Country.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.country_name != null && message.hasOwnProperty("country_name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.country_name);
        if (message.country_code != null && message.hasOwnProperty("country_code"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.country_code);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.active);
        if (message.country_code_3_letter != null && message.hasOwnProperty("country_code_3_letter"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.country_code_3_letter);
        if (message.tin_required != null && message.hasOwnProperty("tin_required"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.tin_required);
        if (message.tin_information_link != null && message.hasOwnProperty("tin_information_link"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.tin_information_link);
        if (message.tax_residency_allowed != null && message.hasOwnProperty("tax_residency_allowed"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.tax_residency_allowed);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Country message, length delimited. Does not implicitly {@link Country.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Country
     * @static
     * @param {ICountry} message Country message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Country.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Country message from the specified reader or buffer.
     * @function decode
     * @memberof Country
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Country} Country
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Country.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Country();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.country_name = reader.string();
                break;
            case 3:
                message.country_code = reader.string();
                break;
            case 4:
                message.active = reader.bool();
                break;
            case 5:
                message.country_code_3_letter = reader.string();
                break;
            case 6:
                message.tin_required = reader.bool();
                break;
            case 7:
                message.tin_information_link = reader.string();
                break;
            case 8:
                message.tax_residency_allowed = reader.bool();
                break;
            case 98:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Country message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Country
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Country} Country
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Country.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Country message.
     * @function verify
     * @memberof Country
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Country.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.country_name != null && message.hasOwnProperty("country_name"))
            if (!$util.isString(message.country_name))
                return "country_name: string expected";
        if (message.country_code != null && message.hasOwnProperty("country_code"))
            if (!$util.isString(message.country_code))
                return "country_code: string expected";
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.country_code_3_letter != null && message.hasOwnProperty("country_code_3_letter"))
            if (!$util.isString(message.country_code_3_letter))
                return "country_code_3_letter: string expected";
        if (message.tin_required != null && message.hasOwnProperty("tin_required"))
            if (typeof message.tin_required !== "boolean")
                return "tin_required: boolean expected";
        if (message.tin_information_link != null && message.hasOwnProperty("tin_information_link"))
            if (!$util.isString(message.tin_information_link))
                return "tin_information_link: string expected";
        if (message.tax_residency_allowed != null && message.hasOwnProperty("tax_residency_allowed"))
            if (typeof message.tax_residency_allowed !== "boolean")
                return "tax_residency_allowed: boolean expected";
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a Country message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Country
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Country} Country
     */
    Country.fromObject = function fromObject(object) {
        if (object instanceof $root.Country)
            return object;
        let message = new $root.Country();
        if (object.id != null)
            message.id = String(object.id);
        if (object.country_name != null)
            message.country_name = String(object.country_name);
        if (object.country_code != null)
            message.country_code = String(object.country_code);
        if (object.active != null)
            message.active = Boolean(object.active);
        if (object.country_code_3_letter != null)
            message.country_code_3_letter = String(object.country_code_3_letter);
        if (object.tin_required != null)
            message.tin_required = Boolean(object.tin_required);
        if (object.tin_information_link != null)
            message.tin_information_link = String(object.tin_information_link);
        if (object.tax_residency_allowed != null)
            message.tax_residency_allowed = Boolean(object.tax_residency_allowed);
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".Country.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".Country.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a Country message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Country
     * @static
     * @param {Country} message Country
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Country.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.country_name = "";
            object.country_code = "";
            object.active = false;
            object.country_code_3_letter = "";
            object.tin_required = false;
            object.tin_information_link = "";
            object.tax_residency_allowed = false;
            object.last_updated_at = null;
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.country_name != null && message.hasOwnProperty("country_name"))
            object.country_name = message.country_name;
        if (message.country_code != null && message.hasOwnProperty("country_code"))
            object.country_code = message.country_code;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.country_code_3_letter != null && message.hasOwnProperty("country_code_3_letter"))
            object.country_code_3_letter = message.country_code_3_letter;
        if (message.tin_required != null && message.hasOwnProperty("tin_required"))
            object.tin_required = message.tin_required;
        if (message.tin_information_link != null && message.hasOwnProperty("tin_information_link"))
            object.tin_information_link = message.tin_information_link;
        if (message.tax_residency_allowed != null && message.hasOwnProperty("tax_residency_allowed"))
            object.tax_residency_allowed = message.tax_residency_allowed;
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this Country to JSON.
     * @function toJSON
     * @memberof Country
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Country.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Country;
})();

export const GreenIdRuleSet = $root.GreenIdRuleSet = (() => {

    /**
     * Properties of a GreenIdRuleSet.
     * @exports IGreenIdRuleSet
     * @interface IGreenIdRuleSet
     */

    /**
     * Constructs a new GreenIdRuleSet.
     * @exports GreenIdRuleSet
     * @classdesc Represents a GreenIdRuleSet.
     * @implements IGreenIdRuleSet
     * @constructor
     * @param {IGreenIdRuleSet=} [properties] Properties to set
     */
    function GreenIdRuleSet(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new GreenIdRuleSet instance using the specified properties.
     * @function create
     * @memberof GreenIdRuleSet
     * @static
     * @param {IGreenIdRuleSet=} [properties] Properties to set
     * @returns {GreenIdRuleSet} GreenIdRuleSet instance
     */
    GreenIdRuleSet.create = function create(properties) {
        return new GreenIdRuleSet(properties);
    };

    /**
     * Encodes the specified GreenIdRuleSet message. Does not implicitly {@link GreenIdRuleSet.verify|verify} messages.
     * @function encode
     * @memberof GreenIdRuleSet
     * @static
     * @param {IGreenIdRuleSet} message GreenIdRuleSet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdRuleSet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified GreenIdRuleSet message, length delimited. Does not implicitly {@link GreenIdRuleSet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GreenIdRuleSet
     * @static
     * @param {IGreenIdRuleSet} message GreenIdRuleSet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreenIdRuleSet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GreenIdRuleSet message from the specified reader or buffer.
     * @function decode
     * @memberof GreenIdRuleSet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GreenIdRuleSet} GreenIdRuleSet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdRuleSet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GreenIdRuleSet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GreenIdRuleSet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GreenIdRuleSet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GreenIdRuleSet} GreenIdRuleSet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreenIdRuleSet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GreenIdRuleSet message.
     * @function verify
     * @memberof GreenIdRuleSet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GreenIdRuleSet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a GreenIdRuleSet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GreenIdRuleSet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GreenIdRuleSet} GreenIdRuleSet
     */
    GreenIdRuleSet.fromObject = function fromObject(object) {
        if (object instanceof $root.GreenIdRuleSet)
            return object;
        return new $root.GreenIdRuleSet();
    };

    /**
     * Creates a plain object from a GreenIdRuleSet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GreenIdRuleSet
     * @static
     * @param {GreenIdRuleSet} message GreenIdRuleSet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GreenIdRuleSet.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this GreenIdRuleSet to JSON.
     * @function toJSON
     * @memberof GreenIdRuleSet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GreenIdRuleSet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name GreenIdRuleSet.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} VOYAGER_ONBOARDING=1 VOYAGER_ONBOARDING value
     * @property {number} SUPERMATCH=2 SUPERMATCH value
     * @property {number} NOVA=3 NOVA value
     */
    GreenIdRuleSet.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "VOYAGER_ONBOARDING"] = 1;
        values[valuesById[2] = "SUPERMATCH"] = 2;
        values[valuesById[3] = "NOVA"] = 3;
        return values;
    })();

    return GreenIdRuleSet;
})();

export const Gender = $root.Gender = (() => {

    /**
     * Properties of a Gender.
     * @exports IGender
     * @interface IGender
     */

    /**
     * Constructs a new Gender.
     * @exports Gender
     * @classdesc Represents a Gender.
     * @implements IGender
     * @constructor
     * @param {IGender=} [properties] Properties to set
     */
    function Gender(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new Gender instance using the specified properties.
     * @function create
     * @memberof Gender
     * @static
     * @param {IGender=} [properties] Properties to set
     * @returns {Gender} Gender instance
     */
    Gender.create = function create(properties) {
        return new Gender(properties);
    };

    /**
     * Encodes the specified Gender message. Does not implicitly {@link Gender.verify|verify} messages.
     * @function encode
     * @memberof Gender
     * @static
     * @param {IGender} message Gender message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Gender.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified Gender message, length delimited. Does not implicitly {@link Gender.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Gender
     * @static
     * @param {IGender} message Gender message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Gender.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Gender message from the specified reader or buffer.
     * @function decode
     * @memberof Gender
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Gender} Gender
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Gender.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Gender();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Gender message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Gender
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Gender} Gender
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Gender.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Gender message.
     * @function verify
     * @memberof Gender
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Gender.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a Gender message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Gender
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Gender} Gender
     */
    Gender.fromObject = function fromObject(object) {
        if (object instanceof $root.Gender)
            return object;
        return new $root.Gender();
    };

    /**
     * Creates a plain object from a Gender message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Gender
     * @static
     * @param {Gender} message Gender
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Gender.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this Gender to JSON.
     * @function toJSON
     * @memberof Gender
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Gender.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name Gender.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} UNSPECIFIED=1 UNSPECIFIED value
     * @property {number} MALE=2 MALE value
     * @property {number} FEMALE=3 FEMALE value
     */
    Gender.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "UNSPECIFIED"] = 1;
        values[valuesById[2] = "MALE"] = 2;
        values[valuesById[3] = "FEMALE"] = 3;
        return values;
    })();

    return Gender;
})();

export const Product = $root.Product = (() => {

    /**
     * Properties of a Product.
     * @exports IProduct
     * @interface IProduct
     */

    /**
     * Constructs a new Product.
     * @exports Product
     * @classdesc Represents a Product.
     * @implements IProduct
     * @constructor
     * @param {IProduct=} [properties] Properties to set
     */
    function Product(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new Product instance using the specified properties.
     * @function create
     * @memberof Product
     * @static
     * @param {IProduct=} [properties] Properties to set
     * @returns {Product} Product instance
     */
    Product.create = function create(properties) {
        return new Product(properties);
    };

    /**
     * Encodes the specified Product message. Does not implicitly {@link Product.verify|verify} messages.
     * @function encode
     * @memberof Product
     * @static
     * @param {IProduct} message Product message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Product.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified Product message, length delimited. Does not implicitly {@link Product.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Product
     * @static
     * @param {IProduct} message Product message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Product.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Product message from the specified reader or buffer.
     * @function decode
     * @memberof Product
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Product} Product
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Product.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Product();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Product message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Product
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Product} Product
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Product.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Product message.
     * @function verify
     * @memberof Product
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Product.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a Product message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Product
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Product} Product
     */
    Product.fromObject = function fromObject(object) {
        if (object instanceof $root.Product)
            return object;
        return new $root.Product();
    };

    /**
     * Creates a plain object from a Product message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Product
     * @static
     * @param {Product} message Product
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Product.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this Product to JSON.
     * @function toJSON
     * @memberof Product
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Product.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name Product.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} SUPER=1 SUPER value
     * @property {number} VOYAGER=2 VOYAGER value
     * @property {number} NOVA=3 NOVA value
     */
    Product.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "SUPER"] = 1;
        values[valuesById[2] = "VOYAGER"] = 2;
        values[valuesById[3] = "NOVA"] = 3;
        return values;
    })();

    return Product;
})();

export const LeadProductIntent = $root.LeadProductIntent = (() => {

    /**
     * Properties of a LeadProductIntent.
     * @exports ILeadProductIntent
     * @interface ILeadProductIntent
     * @property {string|null} [id] LeadProductIntent id
     * @property {string|null} [lead_id] LeadProductIntent lead_id
     * @property {Product.Enum|null} [product] LeadProductIntent product
     * @property {google.protobuf.ITimestamp|null} [created_at] LeadProductIntent created_at
     */

    /**
     * Constructs a new LeadProductIntent.
     * @exports LeadProductIntent
     * @classdesc Represents a LeadProductIntent.
     * @implements ILeadProductIntent
     * @constructor
     * @param {ILeadProductIntent=} [properties] Properties to set
     */
    function LeadProductIntent(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LeadProductIntent id.
     * @member {string} id
     * @memberof LeadProductIntent
     * @instance
     */
    LeadProductIntent.prototype.id = "";

    /**
     * LeadProductIntent lead_id.
     * @member {string} lead_id
     * @memberof LeadProductIntent
     * @instance
     */
    LeadProductIntent.prototype.lead_id = "";

    /**
     * LeadProductIntent product.
     * @member {Product.Enum} product
     * @memberof LeadProductIntent
     * @instance
     */
    LeadProductIntent.prototype.product = 0;

    /**
     * LeadProductIntent created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof LeadProductIntent
     * @instance
     */
    LeadProductIntent.prototype.created_at = null;

    /**
     * Creates a new LeadProductIntent instance using the specified properties.
     * @function create
     * @memberof LeadProductIntent
     * @static
     * @param {ILeadProductIntent=} [properties] Properties to set
     * @returns {LeadProductIntent} LeadProductIntent instance
     */
    LeadProductIntent.create = function create(properties) {
        return new LeadProductIntent(properties);
    };

    /**
     * Encodes the specified LeadProductIntent message. Does not implicitly {@link LeadProductIntent.verify|verify} messages.
     * @function encode
     * @memberof LeadProductIntent
     * @static
     * @param {ILeadProductIntent} message LeadProductIntent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LeadProductIntent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.lead_id != null && message.hasOwnProperty("lead_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.lead_id);
        if (message.product != null && message.hasOwnProperty("product"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.product);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified LeadProductIntent message, length delimited. Does not implicitly {@link LeadProductIntent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LeadProductIntent
     * @static
     * @param {ILeadProductIntent} message LeadProductIntent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LeadProductIntent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LeadProductIntent message from the specified reader or buffer.
     * @function decode
     * @memberof LeadProductIntent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LeadProductIntent} LeadProductIntent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LeadProductIntent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LeadProductIntent();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.lead_id = reader.string();
                break;
            case 3:
                message.product = reader.int32();
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LeadProductIntent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LeadProductIntent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LeadProductIntent} LeadProductIntent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LeadProductIntent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LeadProductIntent message.
     * @function verify
     * @memberof LeadProductIntent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LeadProductIntent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.lead_id != null && message.hasOwnProperty("lead_id"))
            if (!$util.isString(message.lead_id))
                return "lead_id: string expected";
        if (message.product != null && message.hasOwnProperty("product"))
            switch (message.product) {
            default:
                return "product: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a LeadProductIntent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LeadProductIntent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LeadProductIntent} LeadProductIntent
     */
    LeadProductIntent.fromObject = function fromObject(object) {
        if (object instanceof $root.LeadProductIntent)
            return object;
        let message = new $root.LeadProductIntent();
        if (object.id != null)
            message.id = String(object.id);
        if (object.lead_id != null)
            message.lead_id = String(object.lead_id);
        switch (object.product) {
        case "UNKNOWN":
        case 0:
            message.product = 0;
            break;
        case "SUPER":
        case 1:
            message.product = 1;
            break;
        case "VOYAGER":
        case 2:
            message.product = 2;
            break;
        case "NOVA":
        case 3:
            message.product = 3;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".LeadProductIntent.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a LeadProductIntent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LeadProductIntent
     * @static
     * @param {LeadProductIntent} message LeadProductIntent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LeadProductIntent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.lead_id = "";
            object.product = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.lead_id != null && message.hasOwnProperty("lead_id"))
            object.lead_id = message.lead_id;
        if (message.product != null && message.hasOwnProperty("product"))
            object.product = options.enums === String ? $root.Product.Enum[message.product] : message.product;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this LeadProductIntent to JSON.
     * @function toJSON
     * @memberof LeadProductIntent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LeadProductIntent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LeadProductIntent;
})();

export const AccountFlag = $root.AccountFlag = (() => {

    /**
     * Properties of an AccountFlag.
     * @exports IAccountFlag
     * @interface IAccountFlag
     * @property {string|null} [id] AccountFlag id
     * @property {string|null} [account_id] AccountFlag account_id
     * @property {AccountFlag.Type.Enum|null} [type] AccountFlag type
     * @property {string|null} [created_by_admin_id] AccountFlag created_by_admin_id
     * @property {string|null} [resolved_by_admin_id] AccountFlag resolved_by_admin_id
     * @property {google.protobuf.ITimestamp|null} [resolved_at] AccountFlag resolved_at
     * @property {Array.<AccountFlag.INote>|null} [notes] AccountFlag notes
     * @property {google.protobuf.ITimestamp|null} [created_at] AccountFlag created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] AccountFlag last_updated_at
     */

    /**
     * Constructs a new AccountFlag.
     * @exports AccountFlag
     * @classdesc Represents an AccountFlag.
     * @implements IAccountFlag
     * @constructor
     * @param {IAccountFlag=} [properties] Properties to set
     */
    function AccountFlag(properties) {
        this.notes = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountFlag id.
     * @member {string} id
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.id = "";

    /**
     * AccountFlag account_id.
     * @member {string} account_id
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.account_id = "";

    /**
     * AccountFlag type.
     * @member {AccountFlag.Type.Enum} type
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.type = 0;

    /**
     * AccountFlag created_by_admin_id.
     * @member {string} created_by_admin_id
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.created_by_admin_id = "";

    /**
     * AccountFlag resolved_by_admin_id.
     * @member {string} resolved_by_admin_id
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.resolved_by_admin_id = "";

    /**
     * AccountFlag resolved_at.
     * @member {google.protobuf.ITimestamp|null|undefined} resolved_at
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.resolved_at = null;

    /**
     * AccountFlag notes.
     * @member {Array.<AccountFlag.INote>} notes
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.notes = $util.emptyArray;

    /**
     * AccountFlag created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.created_at = null;

    /**
     * AccountFlag last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof AccountFlag
     * @instance
     */
    AccountFlag.prototype.last_updated_at = null;

    /**
     * Creates a new AccountFlag instance using the specified properties.
     * @function create
     * @memberof AccountFlag
     * @static
     * @param {IAccountFlag=} [properties] Properties to set
     * @returns {AccountFlag} AccountFlag instance
     */
    AccountFlag.create = function create(properties) {
        return new AccountFlag(properties);
    };

    /**
     * Encodes the specified AccountFlag message. Does not implicitly {@link AccountFlag.verify|verify} messages.
     * @function encode
     * @memberof AccountFlag
     * @static
     * @param {IAccountFlag} message AccountFlag message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountFlag.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_id);
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.created_by_admin_id);
        if (message.resolved_by_admin_id != null && message.hasOwnProperty("resolved_by_admin_id"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.resolved_by_admin_id);
        if (message.resolved_at != null && message.hasOwnProperty("resolved_at"))
            $root.google.protobuf.Timestamp.encode(message.resolved_at, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.notes != null && message.notes.length)
            for (let i = 0; i < message.notes.length; ++i)
                $root.AccountFlag.Note.encode(message.notes[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AccountFlag message, length delimited. Does not implicitly {@link AccountFlag.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountFlag
     * @static
     * @param {IAccountFlag} message AccountFlag message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountFlag.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountFlag message from the specified reader or buffer.
     * @function decode
     * @memberof AccountFlag
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountFlag} AccountFlag
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountFlag.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountFlag();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.account_id = reader.string();
                break;
            case 3:
                message.type = reader.int32();
                break;
            case 4:
                message.created_by_admin_id = reader.string();
                break;
            case 5:
                message.resolved_by_admin_id = reader.string();
                break;
            case 6:
                message.resolved_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 7:
                if (!(message.notes && message.notes.length))
                    message.notes = [];
                message.notes.push($root.AccountFlag.Note.decode(reader, reader.uint32()));
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountFlag message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountFlag
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountFlag} AccountFlag
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountFlag.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountFlag message.
     * @function verify
     * @memberof AccountFlag
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountFlag.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            if (!$util.isString(message.account_id))
                return "account_id: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            if (!$util.isString(message.created_by_admin_id))
                return "created_by_admin_id: string expected";
        if (message.resolved_by_admin_id != null && message.hasOwnProperty("resolved_by_admin_id"))
            if (!$util.isString(message.resolved_by_admin_id))
                return "resolved_by_admin_id: string expected";
        if (message.resolved_at != null && message.hasOwnProperty("resolved_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.resolved_at);
            if (error)
                return "resolved_at." + error;
        }
        if (message.notes != null && message.hasOwnProperty("notes")) {
            if (!Array.isArray(message.notes))
                return "notes: array expected";
            for (let i = 0; i < message.notes.length; ++i) {
                let error = $root.AccountFlag.Note.verify(message.notes[i]);
                if (error)
                    return "notes." + error;
            }
        }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates an AccountFlag message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountFlag
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountFlag} AccountFlag
     */
    AccountFlag.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountFlag)
            return object;
        let message = new $root.AccountFlag();
        if (object.id != null)
            message.id = String(object.id);
        if (object.account_id != null)
            message.account_id = String(object.account_id);
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "MONITOR":
        case 1:
            message.type = 1;
            break;
        case "FRAUD":
        case 2:
            message.type = 2;
            break;
        case "HIGH_RISK":
        case 3:
            message.type = 3;
            break;
        case "HIGH_VALUE":
        case 4:
            message.type = 4;
            break;
        case "DECEASED":
        case 5:
            message.type = 5;
            break;
        case "POLITICALLY_EXPOSED_PERSON":
        case 6:
            message.type = 6;
            break;
        case "SANCTIONED":
        case 7:
            message.type = 7;
            break;
        case "INFORMATION":
        case 8:
            message.type = 8;
            break;
        case "ASSISTED_KYC":
        case 9:
            message.type = 9;
            break;
        }
        if (object.created_by_admin_id != null)
            message.created_by_admin_id = String(object.created_by_admin_id);
        if (object.resolved_by_admin_id != null)
            message.resolved_by_admin_id = String(object.resolved_by_admin_id);
        if (object.resolved_at != null) {
            if (typeof object.resolved_at !== "object")
                throw TypeError(".AccountFlag.resolved_at: object expected");
            message.resolved_at = $root.google.protobuf.Timestamp.fromObject(object.resolved_at);
        }
        if (object.notes) {
            if (!Array.isArray(object.notes))
                throw TypeError(".AccountFlag.notes: array expected");
            message.notes = [];
            for (let i = 0; i < object.notes.length; ++i) {
                if (typeof object.notes[i] !== "object")
                    throw TypeError(".AccountFlag.notes: object expected");
                message.notes[i] = $root.AccountFlag.Note.fromObject(object.notes[i]);
            }
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".AccountFlag.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".AccountFlag.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an AccountFlag message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountFlag
     * @static
     * @param {AccountFlag} message AccountFlag
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountFlag.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.notes = [];
        if (options.defaults) {
            object.id = "";
            object.account_id = "";
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.created_by_admin_id = "";
            object.resolved_by_admin_id = "";
            object.resolved_at = null;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            object.account_id = message.account_id;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.AccountFlag.Type.Enum[message.type] : message.type;
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            object.created_by_admin_id = message.created_by_admin_id;
        if (message.resolved_by_admin_id != null && message.hasOwnProperty("resolved_by_admin_id"))
            object.resolved_by_admin_id = message.resolved_by_admin_id;
        if (message.resolved_at != null && message.hasOwnProperty("resolved_at"))
            object.resolved_at = $root.google.protobuf.Timestamp.toObject(message.resolved_at, options);
        if (message.notes && message.notes.length) {
            object.notes = [];
            for (let j = 0; j < message.notes.length; ++j)
                object.notes[j] = $root.AccountFlag.Note.toObject(message.notes[j], options);
        }
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this AccountFlag to JSON.
     * @function toJSON
     * @memberof AccountFlag
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountFlag.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    AccountFlag.Type = (function() {

        /**
         * Properties of a Type.
         * @memberof AccountFlag
         * @interface IType
         */

        /**
         * Constructs a new Type.
         * @memberof AccountFlag
         * @classdesc Represents a Type.
         * @implements IType
         * @constructor
         * @param {AccountFlag.IType=} [properties] Properties to set
         */
        function Type(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Type instance using the specified properties.
         * @function create
         * @memberof AccountFlag.Type
         * @static
         * @param {AccountFlag.IType=} [properties] Properties to set
         * @returns {AccountFlag.Type} Type instance
         */
        Type.create = function create(properties) {
            return new Type(properties);
        };

        /**
         * Encodes the specified Type message. Does not implicitly {@link AccountFlag.Type.verify|verify} messages.
         * @function encode
         * @memberof AccountFlag.Type
         * @static
         * @param {AccountFlag.IType} message Type message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Type.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Type message, length delimited. Does not implicitly {@link AccountFlag.Type.verify|verify} messages.
         * @function encodeDelimited
         * @memberof AccountFlag.Type
         * @static
         * @param {AccountFlag.IType} message Type message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Type.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Type message from the specified reader or buffer.
         * @function decode
         * @memberof AccountFlag.Type
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {AccountFlag.Type} Type
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Type.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountFlag.Type();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Type message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof AccountFlag.Type
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {AccountFlag.Type} Type
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Type.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Type message.
         * @function verify
         * @memberof AccountFlag.Type
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Type.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Type message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof AccountFlag.Type
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {AccountFlag.Type} Type
         */
        Type.fromObject = function fromObject(object) {
            if (object instanceof $root.AccountFlag.Type)
                return object;
            return new $root.AccountFlag.Type();
        };

        /**
         * Creates a plain object from a Type message. Also converts values to other types if specified.
         * @function toObject
         * @memberof AccountFlag.Type
         * @static
         * @param {AccountFlag.Type} message Type
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Type.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Type to JSON.
         * @function toJSON
         * @memberof AccountFlag.Type
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Type.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name AccountFlag.Type.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} MONITOR=1 MONITOR value
         * @property {number} FRAUD=2 FRAUD value
         * @property {number} HIGH_RISK=3 HIGH_RISK value
         * @property {number} HIGH_VALUE=4 HIGH_VALUE value
         * @property {number} DECEASED=5 DECEASED value
         * @property {number} POLITICALLY_EXPOSED_PERSON=6 POLITICALLY_EXPOSED_PERSON value
         * @property {number} SANCTIONED=7 SANCTIONED value
         * @property {number} INFORMATION=8 INFORMATION value
         * @property {number} ASSISTED_KYC=9 ASSISTED_KYC value
         */
        Type.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "MONITOR"] = 1;
            values[valuesById[2] = "FRAUD"] = 2;
            values[valuesById[3] = "HIGH_RISK"] = 3;
            values[valuesById[4] = "HIGH_VALUE"] = 4;
            values[valuesById[5] = "DECEASED"] = 5;
            values[valuesById[6] = "POLITICALLY_EXPOSED_PERSON"] = 6;
            values[valuesById[7] = "SANCTIONED"] = 7;
            values[valuesById[8] = "INFORMATION"] = 8;
            values[valuesById[9] = "ASSISTED_KYC"] = 9;
            return values;
        })();

        return Type;
    })();

    AccountFlag.Note = (function() {

        /**
         * Properties of a Note.
         * @memberof AccountFlag
         * @interface INote
         * @property {string|null} [id] Note id
         * @property {string|null} [created_by_admin_id] Note created_by_admin_id
         * @property {string|null} [content] Note content
         * @property {google.protobuf.ITimestamp|null} [created_at] Note created_at
         */

        /**
         * Constructs a new Note.
         * @memberof AccountFlag
         * @classdesc Represents a Note.
         * @implements INote
         * @constructor
         * @param {AccountFlag.INote=} [properties] Properties to set
         */
        function Note(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Note id.
         * @member {string} id
         * @memberof AccountFlag.Note
         * @instance
         */
        Note.prototype.id = "";

        /**
         * Note created_by_admin_id.
         * @member {string} created_by_admin_id
         * @memberof AccountFlag.Note
         * @instance
         */
        Note.prototype.created_by_admin_id = "";

        /**
         * Note content.
         * @member {string} content
         * @memberof AccountFlag.Note
         * @instance
         */
        Note.prototype.content = "";

        /**
         * Note created_at.
         * @member {google.protobuf.ITimestamp|null|undefined} created_at
         * @memberof AccountFlag.Note
         * @instance
         */
        Note.prototype.created_at = null;

        /**
         * Creates a new Note instance using the specified properties.
         * @function create
         * @memberof AccountFlag.Note
         * @static
         * @param {AccountFlag.INote=} [properties] Properties to set
         * @returns {AccountFlag.Note} Note instance
         */
        Note.create = function create(properties) {
            return new Note(properties);
        };

        /**
         * Encodes the specified Note message. Does not implicitly {@link AccountFlag.Note.verify|verify} messages.
         * @function encode
         * @memberof AccountFlag.Note
         * @static
         * @param {AccountFlag.INote} message Note message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Note.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && message.hasOwnProperty("id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.created_by_admin_id);
            if (message.content != null && message.hasOwnProperty("content"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.content);
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Note message, length delimited. Does not implicitly {@link AccountFlag.Note.verify|verify} messages.
         * @function encodeDelimited
         * @memberof AccountFlag.Note
         * @static
         * @param {AccountFlag.INote} message Note message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Note.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Note message from the specified reader or buffer.
         * @function decode
         * @memberof AccountFlag.Note
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {AccountFlag.Note} Note
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Note.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountFlag.Note();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.created_by_admin_id = reader.string();
                    break;
                case 3:
                    message.content = reader.string();
                    break;
                case 99:
                    message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Note message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof AccountFlag.Note
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {AccountFlag.Note} Note
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Note.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Note message.
         * @function verify
         * @memberof AccountFlag.Note
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Note.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
                if (!$util.isString(message.created_by_admin_id))
                    return "created_by_admin_id: string expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            if (message.created_at != null && message.hasOwnProperty("created_at")) {
                let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                if (error)
                    return "created_at." + error;
            }
            return null;
        };

        /**
         * Creates a Note message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof AccountFlag.Note
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {AccountFlag.Note} Note
         */
        Note.fromObject = function fromObject(object) {
            if (object instanceof $root.AccountFlag.Note)
                return object;
            let message = new $root.AccountFlag.Note();
            if (object.id != null)
                message.id = String(object.id);
            if (object.created_by_admin_id != null)
                message.created_by_admin_id = String(object.created_by_admin_id);
            if (object.content != null)
                message.content = String(object.content);
            if (object.created_at != null) {
                if (typeof object.created_at !== "object")
                    throw TypeError(".AccountFlag.Note.created_at: object expected");
                message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
            }
            return message;
        };

        /**
         * Creates a plain object from a Note message. Also converts values to other types if specified.
         * @function toObject
         * @memberof AccountFlag.Note
         * @static
         * @param {AccountFlag.Note} message Note
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Note.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.created_by_admin_id = "";
                object.content = "";
                object.created_at = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
                object.created_by_admin_id = message.created_by_admin_id;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
            return object;
        };

        /**
         * Converts this Note to JSON.
         * @function toJSON
         * @memberof AccountFlag.Note
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Note.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Note;
    })();

    return AccountFlag;
})();

export const Offence = $root.Offence = (() => {

    /**
     * Properties of an Offence.
     * @exports IOffence
     * @interface IOffence
     * @property {string|null} [id] Offence id
     * @property {string|null} [entity_id] Offence entity_id
     * @property {EntityType.Enum|null} [entity_type] Offence entity_type
     * @property {OffenceSeverity.Enum|null} [severity] Offence severity
     * @property {RuleType.Enum|null} [rule_type] Offence rule_type
     * @property {string|null} [rule_description] Offence rule_description
     * @property {google.protobuf.ITimestamp|null} [created_at] Offence created_at
     */

    /**
     * Constructs a new Offence.
     * @exports Offence
     * @classdesc Represents an Offence.
     * @implements IOffence
     * @constructor
     * @param {IOffence=} [properties] Properties to set
     */
    function Offence(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Offence id.
     * @member {string} id
     * @memberof Offence
     * @instance
     */
    Offence.prototype.id = "";

    /**
     * Offence entity_id.
     * @member {string} entity_id
     * @memberof Offence
     * @instance
     */
    Offence.prototype.entity_id = "";

    /**
     * Offence entity_type.
     * @member {EntityType.Enum} entity_type
     * @memberof Offence
     * @instance
     */
    Offence.prototype.entity_type = 0;

    /**
     * Offence severity.
     * @member {OffenceSeverity.Enum} severity
     * @memberof Offence
     * @instance
     */
    Offence.prototype.severity = 0;

    /**
     * Offence rule_type.
     * @member {RuleType.Enum} rule_type
     * @memberof Offence
     * @instance
     */
    Offence.prototype.rule_type = 0;

    /**
     * Offence rule_description.
     * @member {string} rule_description
     * @memberof Offence
     * @instance
     */
    Offence.prototype.rule_description = "";

    /**
     * Offence created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof Offence
     * @instance
     */
    Offence.prototype.created_at = null;

    /**
     * Creates a new Offence instance using the specified properties.
     * @function create
     * @memberof Offence
     * @static
     * @param {IOffence=} [properties] Properties to set
     * @returns {Offence} Offence instance
     */
    Offence.create = function create(properties) {
        return new Offence(properties);
    };

    /**
     * Encodes the specified Offence message. Does not implicitly {@link Offence.verify|verify} messages.
     * @function encode
     * @memberof Offence
     * @static
     * @param {IOffence} message Offence message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Offence.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.entity_id != null && message.hasOwnProperty("entity_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.entity_id);
        if (message.entity_type != null && message.hasOwnProperty("entity_type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.entity_type);
        if (message.severity != null && message.hasOwnProperty("severity"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.severity);
        if (message.rule_type != null && message.hasOwnProperty("rule_type"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.rule_type);
        if (message.rule_description != null && message.hasOwnProperty("rule_description"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.rule_description);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Offence message, length delimited. Does not implicitly {@link Offence.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Offence
     * @static
     * @param {IOffence} message Offence message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Offence.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Offence message from the specified reader or buffer.
     * @function decode
     * @memberof Offence
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Offence} Offence
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Offence.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Offence();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.entity_id = reader.string();
                break;
            case 3:
                message.entity_type = reader.int32();
                break;
            case 4:
                message.severity = reader.int32();
                break;
            case 5:
                message.rule_type = reader.int32();
                break;
            case 6:
                message.rule_description = reader.string();
                break;
            case 100:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Offence message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Offence
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Offence} Offence
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Offence.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Offence message.
     * @function verify
     * @memberof Offence
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Offence.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.entity_id != null && message.hasOwnProperty("entity_id"))
            if (!$util.isString(message.entity_id))
                return "entity_id: string expected";
        if (message.entity_type != null && message.hasOwnProperty("entity_type"))
            switch (message.entity_type) {
            default:
                return "entity_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.severity != null && message.hasOwnProperty("severity"))
            switch (message.severity) {
            default:
                return "severity: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.rule_type != null && message.hasOwnProperty("rule_type"))
            switch (message.rule_type) {
            default:
                return "rule_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
        if (message.rule_description != null && message.hasOwnProperty("rule_description"))
            if (!$util.isString(message.rule_description))
                return "rule_description: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates an Offence message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Offence
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Offence} Offence
     */
    Offence.fromObject = function fromObject(object) {
        if (object instanceof $root.Offence)
            return object;
        let message = new $root.Offence();
        if (object.id != null)
            message.id = String(object.id);
        if (object.entity_id != null)
            message.entity_id = String(object.entity_id);
        switch (object.entity_type) {
        case "UNKNOWN":
        case 0:
            message.entity_type = 0;
            break;
        case "APPLICATION":
        case 1:
            message.entity_type = 1;
            break;
        case "REDEMPTION":
        case 2:
            message.entity_type = 2;
            break;
        }
        switch (object.severity) {
        case "UNKNOWN":
        case 0:
            message.severity = 0;
            break;
        case "WARN":
        case 1:
            message.severity = 1;
            break;
        case "DENY":
        case 2:
            message.severity = 2;
            break;
        }
        switch (object.rule_type) {
        case "UNKNOWN":
        case 0:
            message.rule_type = 0;
            break;
        case "BANK_ACCOUNT_CHANGED":
        case 1:
            message.rule_type = 1;
            break;
        case "CONTACT_DETAILS_CHANGED":
        case 2:
            message.rule_type = 2;
            break;
        case "TRANSACTION_AMOUNT":
        case 3:
            message.rule_type = 3;
            break;
        case "BALANCE_PERCENTAGE":
        case 4:
            message.rule_type = 4;
            break;
        case "OTHER_FRAUDULENT_ACCOUNT":
        case 5:
            message.rule_type = 5;
            break;
        case "BANK_ACCOUNT_NUMBER_FLAGGED":
        case 6:
            message.rule_type = 6;
            break;
        case "BANK_ACCOUNT_NAME_FLAGGED":
        case 7:
            message.rule_type = 7;
            break;
        case "MERGED_ACCOUNT":
        case 8:
            message.rule_type = 8;
            break;
        }
        if (object.rule_description != null)
            message.rule_description = String(object.rule_description);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".Offence.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an Offence message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Offence
     * @static
     * @param {Offence} message Offence
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Offence.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.entity_id = "";
            object.entity_type = options.enums === String ? "UNKNOWN" : 0;
            object.severity = options.enums === String ? "UNKNOWN" : 0;
            object.rule_type = options.enums === String ? "UNKNOWN" : 0;
            object.rule_description = "";
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.entity_id != null && message.hasOwnProperty("entity_id"))
            object.entity_id = message.entity_id;
        if (message.entity_type != null && message.hasOwnProperty("entity_type"))
            object.entity_type = options.enums === String ? $root.EntityType.Enum[message.entity_type] : message.entity_type;
        if (message.severity != null && message.hasOwnProperty("severity"))
            object.severity = options.enums === String ? $root.OffenceSeverity.Enum[message.severity] : message.severity;
        if (message.rule_type != null && message.hasOwnProperty("rule_type"))
            object.rule_type = options.enums === String ? $root.RuleType.Enum[message.rule_type] : message.rule_type;
        if (message.rule_description != null && message.hasOwnProperty("rule_description"))
            object.rule_description = message.rule_description;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this Offence to JSON.
     * @function toJSON
     * @memberof Offence
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Offence.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Offence;
})();

export const Offences = $root.Offences = (() => {

    /**
     * Properties of an Offences.
     * @exports IOffences
     * @interface IOffences
     * @property {Array.<IOffence>|null} [list] Offences list
     */

    /**
     * Constructs a new Offences.
     * @exports Offences
     * @classdesc Represents an Offences.
     * @implements IOffences
     * @constructor
     * @param {IOffences=} [properties] Properties to set
     */
    function Offences(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Offences list.
     * @member {Array.<IOffence>} list
     * @memberof Offences
     * @instance
     */
    Offences.prototype.list = $util.emptyArray;

    /**
     * Creates a new Offences instance using the specified properties.
     * @function create
     * @memberof Offences
     * @static
     * @param {IOffences=} [properties] Properties to set
     * @returns {Offences} Offences instance
     */
    Offences.create = function create(properties) {
        return new Offences(properties);
    };

    /**
     * Encodes the specified Offences message. Does not implicitly {@link Offences.verify|verify} messages.
     * @function encode
     * @memberof Offences
     * @static
     * @param {IOffences} message Offences message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Offences.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.Offence.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Offences message, length delimited. Does not implicitly {@link Offences.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Offences
     * @static
     * @param {IOffences} message Offences message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Offences.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Offences message from the specified reader or buffer.
     * @function decode
     * @memberof Offences
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Offences} Offences
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Offences.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Offences();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.Offence.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Offences message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Offences
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Offences} Offences
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Offences.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Offences message.
     * @function verify
     * @memberof Offences
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Offences.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.Offence.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates an Offences message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Offences
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Offences} Offences
     */
    Offences.fromObject = function fromObject(object) {
        if (object instanceof $root.Offences)
            return object;
        let message = new $root.Offences();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".Offences.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".Offences.list: object expected");
                message.list[i] = $root.Offence.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from an Offences message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Offences
     * @static
     * @param {Offences} message Offences
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Offences.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.Offence.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this Offences to JSON.
     * @function toJSON
     * @memberof Offences
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Offences.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Offences;
})();

export const EntityType = $root.EntityType = (() => {

    /**
     * Properties of an EntityType.
     * @exports IEntityType
     * @interface IEntityType
     */

    /**
     * Constructs a new EntityType.
     * @exports EntityType
     * @classdesc Represents an EntityType.
     * @implements IEntityType
     * @constructor
     * @param {IEntityType=} [properties] Properties to set
     */
    function EntityType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new EntityType instance using the specified properties.
     * @function create
     * @memberof EntityType
     * @static
     * @param {IEntityType=} [properties] Properties to set
     * @returns {EntityType} EntityType instance
     */
    EntityType.create = function create(properties) {
        return new EntityType(properties);
    };

    /**
     * Encodes the specified EntityType message. Does not implicitly {@link EntityType.verify|verify} messages.
     * @function encode
     * @memberof EntityType
     * @static
     * @param {IEntityType} message EntityType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EntityType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified EntityType message, length delimited. Does not implicitly {@link EntityType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EntityType
     * @static
     * @param {IEntityType} message EntityType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EntityType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an EntityType message from the specified reader or buffer.
     * @function decode
     * @memberof EntityType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EntityType} EntityType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EntityType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.EntityType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an EntityType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EntityType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EntityType} EntityType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EntityType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an EntityType message.
     * @function verify
     * @memberof EntityType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EntityType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an EntityType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EntityType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EntityType} EntityType
     */
    EntityType.fromObject = function fromObject(object) {
        if (object instanceof $root.EntityType)
            return object;
        return new $root.EntityType();
    };

    /**
     * Creates a plain object from an EntityType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EntityType
     * @static
     * @param {EntityType} message EntityType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EntityType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this EntityType to JSON.
     * @function toJSON
     * @memberof EntityType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EntityType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name EntityType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} APPLICATION=1 APPLICATION value
     * @property {number} REDEMPTION=2 REDEMPTION value
     */
    EntityType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "APPLICATION"] = 1;
        values[valuesById[2] = "REDEMPTION"] = 2;
        return values;
    })();

    return EntityType;
})();

export const RuleType = $root.RuleType = (() => {

    /**
     * Properties of a RuleType.
     * @exports IRuleType
     * @interface IRuleType
     */

    /**
     * Constructs a new RuleType.
     * @exports RuleType
     * @classdesc Represents a RuleType.
     * @implements IRuleType
     * @constructor
     * @param {IRuleType=} [properties] Properties to set
     */
    function RuleType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new RuleType instance using the specified properties.
     * @function create
     * @memberof RuleType
     * @static
     * @param {IRuleType=} [properties] Properties to set
     * @returns {RuleType} RuleType instance
     */
    RuleType.create = function create(properties) {
        return new RuleType(properties);
    };

    /**
     * Encodes the specified RuleType message. Does not implicitly {@link RuleType.verify|verify} messages.
     * @function encode
     * @memberof RuleType
     * @static
     * @param {IRuleType} message RuleType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RuleType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified RuleType message, length delimited. Does not implicitly {@link RuleType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RuleType
     * @static
     * @param {IRuleType} message RuleType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RuleType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RuleType message from the specified reader or buffer.
     * @function decode
     * @memberof RuleType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RuleType} RuleType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RuleType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RuleType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RuleType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RuleType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RuleType} RuleType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RuleType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RuleType message.
     * @function verify
     * @memberof RuleType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RuleType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a RuleType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RuleType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RuleType} RuleType
     */
    RuleType.fromObject = function fromObject(object) {
        if (object instanceof $root.RuleType)
            return object;
        return new $root.RuleType();
    };

    /**
     * Creates a plain object from a RuleType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RuleType
     * @static
     * @param {RuleType} message RuleType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RuleType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this RuleType to JSON.
     * @function toJSON
     * @memberof RuleType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RuleType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name RuleType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} BANK_ACCOUNT_CHANGED=1 BANK_ACCOUNT_CHANGED value
     * @property {number} CONTACT_DETAILS_CHANGED=2 CONTACT_DETAILS_CHANGED value
     * @property {number} TRANSACTION_AMOUNT=3 TRANSACTION_AMOUNT value
     * @property {number} BALANCE_PERCENTAGE=4 BALANCE_PERCENTAGE value
     * @property {number} OTHER_FRAUDULENT_ACCOUNT=5 OTHER_FRAUDULENT_ACCOUNT value
     * @property {number} BANK_ACCOUNT_NUMBER_FLAGGED=6 BANK_ACCOUNT_NUMBER_FLAGGED value
     * @property {number} BANK_ACCOUNT_NAME_FLAGGED=7 BANK_ACCOUNT_NAME_FLAGGED value
     * @property {number} MERGED_ACCOUNT=8 MERGED_ACCOUNT value
     */
    RuleType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "BANK_ACCOUNT_CHANGED"] = 1;
        values[valuesById[2] = "CONTACT_DETAILS_CHANGED"] = 2;
        values[valuesById[3] = "TRANSACTION_AMOUNT"] = 3;
        values[valuesById[4] = "BALANCE_PERCENTAGE"] = 4;
        values[valuesById[5] = "OTHER_FRAUDULENT_ACCOUNT"] = 5;
        values[valuesById[6] = "BANK_ACCOUNT_NUMBER_FLAGGED"] = 6;
        values[valuesById[7] = "BANK_ACCOUNT_NAME_FLAGGED"] = 7;
        values[valuesById[8] = "MERGED_ACCOUNT"] = 8;
        return values;
    })();

    return RuleType;
})();

export const OffenceSeverity = $root.OffenceSeverity = (() => {

    /**
     * Properties of an OffenceSeverity.
     * @exports IOffenceSeverity
     * @interface IOffenceSeverity
     */

    /**
     * Constructs a new OffenceSeverity.
     * @exports OffenceSeverity
     * @classdesc Represents an OffenceSeverity.
     * @implements IOffenceSeverity
     * @constructor
     * @param {IOffenceSeverity=} [properties] Properties to set
     */
    function OffenceSeverity(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new OffenceSeverity instance using the specified properties.
     * @function create
     * @memberof OffenceSeverity
     * @static
     * @param {IOffenceSeverity=} [properties] Properties to set
     * @returns {OffenceSeverity} OffenceSeverity instance
     */
    OffenceSeverity.create = function create(properties) {
        return new OffenceSeverity(properties);
    };

    /**
     * Encodes the specified OffenceSeverity message. Does not implicitly {@link OffenceSeverity.verify|verify} messages.
     * @function encode
     * @memberof OffenceSeverity
     * @static
     * @param {IOffenceSeverity} message OffenceSeverity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OffenceSeverity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified OffenceSeverity message, length delimited. Does not implicitly {@link OffenceSeverity.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OffenceSeverity
     * @static
     * @param {IOffenceSeverity} message OffenceSeverity message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OffenceSeverity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OffenceSeverity message from the specified reader or buffer.
     * @function decode
     * @memberof OffenceSeverity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OffenceSeverity} OffenceSeverity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OffenceSeverity.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OffenceSeverity();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OffenceSeverity message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OffenceSeverity
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OffenceSeverity} OffenceSeverity
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OffenceSeverity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OffenceSeverity message.
     * @function verify
     * @memberof OffenceSeverity
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OffenceSeverity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an OffenceSeverity message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OffenceSeverity
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OffenceSeverity} OffenceSeverity
     */
    OffenceSeverity.fromObject = function fromObject(object) {
        if (object instanceof $root.OffenceSeverity)
            return object;
        return new $root.OffenceSeverity();
    };

    /**
     * Creates a plain object from an OffenceSeverity message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OffenceSeverity
     * @static
     * @param {OffenceSeverity} message OffenceSeverity
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OffenceSeverity.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this OffenceSeverity to JSON.
     * @function toJSON
     * @memberof OffenceSeverity
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OffenceSeverity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name OffenceSeverity.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} WARN=1 WARN value
     * @property {number} DENY=2 DENY value
     */
    OffenceSeverity.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "WARN"] = 1;
        values[valuesById[2] = "DENY"] = 2;
        return values;
    })();

    return OffenceSeverity;
})();

export const FraudulentBankAccount = $root.FraudulentBankAccount = (() => {

    /**
     * Properties of a FraudulentBankAccount.
     * @exports IFraudulentBankAccount
     * @interface IFraudulentBankAccount
     * @property {string|null} [account_number] FraudulentBankAccount account_number
     * @property {string|null} [bsb] FraudulentBankAccount bsb
     * @property {OffenceSeverity.Enum|null} [severity] FraudulentBankAccount severity
     * @property {boolean|null} [active] FraudulentBankAccount active
     */

    /**
     * Constructs a new FraudulentBankAccount.
     * @exports FraudulentBankAccount
     * @classdesc Represents a FraudulentBankAccount.
     * @implements IFraudulentBankAccount
     * @constructor
     * @param {IFraudulentBankAccount=} [properties] Properties to set
     */
    function FraudulentBankAccount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FraudulentBankAccount account_number.
     * @member {string} account_number
     * @memberof FraudulentBankAccount
     * @instance
     */
    FraudulentBankAccount.prototype.account_number = "";

    /**
     * FraudulentBankAccount bsb.
     * @member {string} bsb
     * @memberof FraudulentBankAccount
     * @instance
     */
    FraudulentBankAccount.prototype.bsb = "";

    /**
     * FraudulentBankAccount severity.
     * @member {OffenceSeverity.Enum} severity
     * @memberof FraudulentBankAccount
     * @instance
     */
    FraudulentBankAccount.prototype.severity = 0;

    /**
     * FraudulentBankAccount active.
     * @member {boolean} active
     * @memberof FraudulentBankAccount
     * @instance
     */
    FraudulentBankAccount.prototype.active = false;

    /**
     * Creates a new FraudulentBankAccount instance using the specified properties.
     * @function create
     * @memberof FraudulentBankAccount
     * @static
     * @param {IFraudulentBankAccount=} [properties] Properties to set
     * @returns {FraudulentBankAccount} FraudulentBankAccount instance
     */
    FraudulentBankAccount.create = function create(properties) {
        return new FraudulentBankAccount(properties);
    };

    /**
     * Encodes the specified FraudulentBankAccount message. Does not implicitly {@link FraudulentBankAccount.verify|verify} messages.
     * @function encode
     * @memberof FraudulentBankAccount
     * @static
     * @param {IFraudulentBankAccount} message FraudulentBankAccount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FraudulentBankAccount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.account_number);
        if (message.bsb != null && message.hasOwnProperty("bsb"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.bsb);
        if (message.severity != null && message.hasOwnProperty("severity"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.severity);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.active);
        return writer;
    };

    /**
     * Encodes the specified FraudulentBankAccount message, length delimited. Does not implicitly {@link FraudulentBankAccount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FraudulentBankAccount
     * @static
     * @param {IFraudulentBankAccount} message FraudulentBankAccount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FraudulentBankAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FraudulentBankAccount message from the specified reader or buffer.
     * @function decode
     * @memberof FraudulentBankAccount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FraudulentBankAccount} FraudulentBankAccount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FraudulentBankAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FraudulentBankAccount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.account_number = reader.string();
                break;
            case 2:
                message.bsb = reader.string();
                break;
            case 3:
                message.severity = reader.int32();
                break;
            case 4:
                message.active = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FraudulentBankAccount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FraudulentBankAccount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FraudulentBankAccount} FraudulentBankAccount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FraudulentBankAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FraudulentBankAccount message.
     * @function verify
     * @memberof FraudulentBankAccount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FraudulentBankAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            if (!$util.isString(message.account_number))
                return "account_number: string expected";
        if (message.bsb != null && message.hasOwnProperty("bsb"))
            if (!$util.isString(message.bsb))
                return "bsb: string expected";
        if (message.severity != null && message.hasOwnProperty("severity"))
            switch (message.severity) {
            default:
                return "severity: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        return null;
    };

    /**
     * Creates a FraudulentBankAccount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FraudulentBankAccount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FraudulentBankAccount} FraudulentBankAccount
     */
    FraudulentBankAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.FraudulentBankAccount)
            return object;
        let message = new $root.FraudulentBankAccount();
        if (object.account_number != null)
            message.account_number = String(object.account_number);
        if (object.bsb != null)
            message.bsb = String(object.bsb);
        switch (object.severity) {
        case "UNKNOWN":
        case 0:
            message.severity = 0;
            break;
        case "WARN":
        case 1:
            message.severity = 1;
            break;
        case "DENY":
        case 2:
            message.severity = 2;
            break;
        }
        if (object.active != null)
            message.active = Boolean(object.active);
        return message;
    };

    /**
     * Creates a plain object from a FraudulentBankAccount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FraudulentBankAccount
     * @static
     * @param {FraudulentBankAccount} message FraudulentBankAccount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FraudulentBankAccount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.account_number = "";
            object.bsb = "";
            object.severity = options.enums === String ? "UNKNOWN" : 0;
            object.active = false;
        }
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            object.account_number = message.account_number;
        if (message.bsb != null && message.hasOwnProperty("bsb"))
            object.bsb = message.bsb;
        if (message.severity != null && message.hasOwnProperty("severity"))
            object.severity = options.enums === String ? $root.OffenceSeverity.Enum[message.severity] : message.severity;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        return object;
    };

    /**
     * Converts this FraudulentBankAccount to JSON.
     * @function toJSON
     * @memberof FraudulentBankAccount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FraudulentBankAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FraudulentBankAccount;
})();

export const BiometricVerificationStatus = $root.BiometricVerificationStatus = (() => {

    /**
     * Properties of a BiometricVerificationStatus.
     * @exports IBiometricVerificationStatus
     * @interface IBiometricVerificationStatus
     */

    /**
     * Constructs a new BiometricVerificationStatus.
     * @exports BiometricVerificationStatus
     * @classdesc Represents a BiometricVerificationStatus.
     * @implements IBiometricVerificationStatus
     * @constructor
     * @param {IBiometricVerificationStatus=} [properties] Properties to set
     */
    function BiometricVerificationStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new BiometricVerificationStatus instance using the specified properties.
     * @function create
     * @memberof BiometricVerificationStatus
     * @static
     * @param {IBiometricVerificationStatus=} [properties] Properties to set
     * @returns {BiometricVerificationStatus} BiometricVerificationStatus instance
     */
    BiometricVerificationStatus.create = function create(properties) {
        return new BiometricVerificationStatus(properties);
    };

    /**
     * Encodes the specified BiometricVerificationStatus message. Does not implicitly {@link BiometricVerificationStatus.verify|verify} messages.
     * @function encode
     * @memberof BiometricVerificationStatus
     * @static
     * @param {IBiometricVerificationStatus} message BiometricVerificationStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BiometricVerificationStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified BiometricVerificationStatus message, length delimited. Does not implicitly {@link BiometricVerificationStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BiometricVerificationStatus
     * @static
     * @param {IBiometricVerificationStatus} message BiometricVerificationStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BiometricVerificationStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BiometricVerificationStatus message from the specified reader or buffer.
     * @function decode
     * @memberof BiometricVerificationStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BiometricVerificationStatus} BiometricVerificationStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BiometricVerificationStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BiometricVerificationStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BiometricVerificationStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BiometricVerificationStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BiometricVerificationStatus} BiometricVerificationStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BiometricVerificationStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BiometricVerificationStatus message.
     * @function verify
     * @memberof BiometricVerificationStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BiometricVerificationStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a BiometricVerificationStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BiometricVerificationStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BiometricVerificationStatus} BiometricVerificationStatus
     */
    BiometricVerificationStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.BiometricVerificationStatus)
            return object;
        return new $root.BiometricVerificationStatus();
    };

    /**
     * Creates a plain object from a BiometricVerificationStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BiometricVerificationStatus
     * @static
     * @param {BiometricVerificationStatus} message BiometricVerificationStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BiometricVerificationStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this BiometricVerificationStatus to JSON.
     * @function toJSON
     * @memberof BiometricVerificationStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BiometricVerificationStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name BiometricVerificationStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} UNVERIFIED=1 UNVERIFIED value
     * @property {number} IN_PROGRESS=2 IN_PROGRESS value
     * @property {number} VERIFIED=3 VERIFIED value
     * @property {number} FAILED=4 FAILED value
     */
    BiometricVerificationStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "UNVERIFIED"] = 1;
        values[valuesById[2] = "IN_PROGRESS"] = 2;
        values[valuesById[3] = "VERIFIED"] = 3;
        values[valuesById[4] = "FAILED"] = 4;
        return values;
    })();

    return BiometricVerificationStatus;
})();

export const OCRTransactionStatus = $root.OCRTransactionStatus = (() => {

    /**
     * Properties of a OCRTransactionStatus.
     * @exports IOCRTransactionStatus
     * @interface IOCRTransactionStatus
     */

    /**
     * Constructs a new OCRTransactionStatus.
     * @exports OCRTransactionStatus
     * @classdesc Represents a OCRTransactionStatus.
     * @implements IOCRTransactionStatus
     * @constructor
     * @param {IOCRTransactionStatus=} [properties] Properties to set
     */
    function OCRTransactionStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new OCRTransactionStatus instance using the specified properties.
     * @function create
     * @memberof OCRTransactionStatus
     * @static
     * @param {IOCRTransactionStatus=} [properties] Properties to set
     * @returns {OCRTransactionStatus} OCRTransactionStatus instance
     */
    OCRTransactionStatus.create = function create(properties) {
        return new OCRTransactionStatus(properties);
    };

    /**
     * Encodes the specified OCRTransactionStatus message. Does not implicitly {@link OCRTransactionStatus.verify|verify} messages.
     * @function encode
     * @memberof OCRTransactionStatus
     * @static
     * @param {IOCRTransactionStatus} message OCRTransactionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRTransactionStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified OCRTransactionStatus message, length delimited. Does not implicitly {@link OCRTransactionStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OCRTransactionStatus
     * @static
     * @param {IOCRTransactionStatus} message OCRTransactionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRTransactionStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a OCRTransactionStatus message from the specified reader or buffer.
     * @function decode
     * @memberof OCRTransactionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OCRTransactionStatus} OCRTransactionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRTransactionStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OCRTransactionStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a OCRTransactionStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OCRTransactionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OCRTransactionStatus} OCRTransactionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRTransactionStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a OCRTransactionStatus message.
     * @function verify
     * @memberof OCRTransactionStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OCRTransactionStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a OCRTransactionStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OCRTransactionStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OCRTransactionStatus} OCRTransactionStatus
     */
    OCRTransactionStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.OCRTransactionStatus)
            return object;
        return new $root.OCRTransactionStatus();
    };

    /**
     * Creates a plain object from a OCRTransactionStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OCRTransactionStatus
     * @static
     * @param {OCRTransactionStatus} message OCRTransactionStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OCRTransactionStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this OCRTransactionStatus to JSON.
     * @function toJSON
     * @memberof OCRTransactionStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OCRTransactionStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name OCRTransactionStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} NOT_FETCHED_YET=1 NOT_FETCHED_YET value
     * @property {number} PENDING=2 PENDING value
     * @property {number} IN_PROGRESS=3 IN_PROGRESS value
     * @property {number} COMPLETED_PASS=4 COMPLETED_PASS value
     * @property {number} COMPLETED_FLAGGED=5 COMPLETED_FLAGGED value
     * @property {number} EXPIRED=6 EXPIRED value
     * @property {number} CANCELLED=7 CANCELLED value
     */
    OCRTransactionStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "NOT_FETCHED_YET"] = 1;
        values[valuesById[2] = "PENDING"] = 2;
        values[valuesById[3] = "IN_PROGRESS"] = 3;
        values[valuesById[4] = "COMPLETED_PASS"] = 4;
        values[valuesById[5] = "COMPLETED_FLAGGED"] = 5;
        values[valuesById[6] = "EXPIRED"] = 6;
        values[valuesById[7] = "CANCELLED"] = 7;
        return values;
    })();

    return OCRTransactionStatus;
})();

export const OCRContactMatchStatus = $root.OCRContactMatchStatus = (() => {

    /**
     * Properties of a OCRContactMatchStatus.
     * @exports IOCRContactMatchStatus
     * @interface IOCRContactMatchStatus
     */

    /**
     * Constructs a new OCRContactMatchStatus.
     * @exports OCRContactMatchStatus
     * @classdesc Represents a OCRContactMatchStatus.
     * @implements IOCRContactMatchStatus
     * @constructor
     * @param {IOCRContactMatchStatus=} [properties] Properties to set
     */
    function OCRContactMatchStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new OCRContactMatchStatus instance using the specified properties.
     * @function create
     * @memberof OCRContactMatchStatus
     * @static
     * @param {IOCRContactMatchStatus=} [properties] Properties to set
     * @returns {OCRContactMatchStatus} OCRContactMatchStatus instance
     */
    OCRContactMatchStatus.create = function create(properties) {
        return new OCRContactMatchStatus(properties);
    };

    /**
     * Encodes the specified OCRContactMatchStatus message. Does not implicitly {@link OCRContactMatchStatus.verify|verify} messages.
     * @function encode
     * @memberof OCRContactMatchStatus
     * @static
     * @param {IOCRContactMatchStatus} message OCRContactMatchStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRContactMatchStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified OCRContactMatchStatus message, length delimited. Does not implicitly {@link OCRContactMatchStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OCRContactMatchStatus
     * @static
     * @param {IOCRContactMatchStatus} message OCRContactMatchStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRContactMatchStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a OCRContactMatchStatus message from the specified reader or buffer.
     * @function decode
     * @memberof OCRContactMatchStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OCRContactMatchStatus} OCRContactMatchStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRContactMatchStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OCRContactMatchStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a OCRContactMatchStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OCRContactMatchStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OCRContactMatchStatus} OCRContactMatchStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRContactMatchStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a OCRContactMatchStatus message.
     * @function verify
     * @memberof OCRContactMatchStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OCRContactMatchStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a OCRContactMatchStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OCRContactMatchStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OCRContactMatchStatus} OCRContactMatchStatus
     */
    OCRContactMatchStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.OCRContactMatchStatus)
            return object;
        return new $root.OCRContactMatchStatus();
    };

    /**
     * Creates a plain object from a OCRContactMatchStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OCRContactMatchStatus
     * @static
     * @param {OCRContactMatchStatus} message OCRContactMatchStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OCRContactMatchStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this OCRContactMatchStatus to JSON.
     * @function toJSON
     * @memberof OCRContactMatchStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OCRContactMatchStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name OCRContactMatchStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} NOT_MATCHED_YET=1 NOT_MATCHED_YET value
     * @property {number} EXACT_MATCH=2 EXACT_MATCH value
     * @property {number} NO_MATCH=3 NO_MATCH value
     * @property {number} FUZZY_MATCH=4 FUZZY_MATCH value
     */
    OCRContactMatchStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "NOT_MATCHED_YET"] = 1;
        values[valuesById[2] = "EXACT_MATCH"] = 2;
        values[valuesById[3] = "NO_MATCH"] = 3;
        values[valuesById[4] = "FUZZY_MATCH"] = 4;
        return values;
    })();

    return OCRContactMatchStatus;
})();

export const OCRTransactionSource = $root.OCRTransactionSource = (() => {

    /**
     * Properties of a OCRTransactionSource.
     * @exports IOCRTransactionSource
     * @interface IOCRTransactionSource
     */

    /**
     * Constructs a new OCRTransactionSource.
     * @exports OCRTransactionSource
     * @classdesc Represents a OCRTransactionSource.
     * @implements IOCRTransactionSource
     * @constructor
     * @param {IOCRTransactionSource=} [properties] Properties to set
     */
    function OCRTransactionSource(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new OCRTransactionSource instance using the specified properties.
     * @function create
     * @memberof OCRTransactionSource
     * @static
     * @param {IOCRTransactionSource=} [properties] Properties to set
     * @returns {OCRTransactionSource} OCRTransactionSource instance
     */
    OCRTransactionSource.create = function create(properties) {
        return new OCRTransactionSource(properties);
    };

    /**
     * Encodes the specified OCRTransactionSource message. Does not implicitly {@link OCRTransactionSource.verify|verify} messages.
     * @function encode
     * @memberof OCRTransactionSource
     * @static
     * @param {IOCRTransactionSource} message OCRTransactionSource message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRTransactionSource.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified OCRTransactionSource message, length delimited. Does not implicitly {@link OCRTransactionSource.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OCRTransactionSource
     * @static
     * @param {IOCRTransactionSource} message OCRTransactionSource message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRTransactionSource.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a OCRTransactionSource message from the specified reader or buffer.
     * @function decode
     * @memberof OCRTransactionSource
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OCRTransactionSource} OCRTransactionSource
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRTransactionSource.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OCRTransactionSource();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a OCRTransactionSource message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OCRTransactionSource
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OCRTransactionSource} OCRTransactionSource
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRTransactionSource.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a OCRTransactionSource message.
     * @function verify
     * @memberof OCRTransactionSource
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OCRTransactionSource.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a OCRTransactionSource message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OCRTransactionSource
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OCRTransactionSource} OCRTransactionSource
     */
    OCRTransactionSource.fromObject = function fromObject(object) {
        if (object instanceof $root.OCRTransactionSource)
            return object;
        return new $root.OCRTransactionSource();
    };

    /**
     * Creates a plain object from a OCRTransactionSource message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OCRTransactionSource
     * @static
     * @param {OCRTransactionSource} message OCRTransactionSource
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OCRTransactionSource.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this OCRTransactionSource to JSON.
     * @function toJSON
     * @memberof OCRTransactionSource
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OCRTransactionSource.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name OCRTransactionSource.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} NATIVE_APP=1 NATIVE_APP value
     * @property {number} WEB_APP=2 WEB_APP value
     */
    OCRTransactionSource.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "NATIVE_APP"] = 1;
        values[valuesById[2] = "WEB_APP"] = 2;
        return values;
    })();

    return OCRTransactionSource;
})();

export const OCRLabsTransaction = $root.OCRLabsTransaction = (() => {

    /**
     * Properties of a OCRLabsTransaction.
     * @exports IOCRLabsTransaction
     * @interface IOCRLabsTransaction
     * @property {string|null} [id] OCRLabsTransaction id
     * @property {string|null} [contact_id] OCRLabsTransaction contact_id
     * @property {string|null} [phone_number] OCRLabsTransaction phone_number
     * @property {OCRTransactionStatus.Enum|null} [ocr_status] OCRLabsTransaction ocr_status
     * @property {OCRContactMatchStatus.Enum|null} [contact_match_status] OCRLabsTransaction contact_match_status
     * @property {google.protobuf.ITimestamp|null} [matched_at] OCRLabsTransaction matched_at
     * @property {string|null} [first_name] OCRLabsTransaction first_name
     * @property {string|null} [middle_name] OCRLabsTransaction middle_name
     * @property {string|null} [last_name] OCRLabsTransaction last_name
     * @property {string|null} [date_of_birth] OCRLabsTransaction date_of_birth
     * @property {OCRTransactionSource.Enum|null} [source] OCRLabsTransaction source
     * @property {OCRTransactionReason.Enum|null} [reason] OCRLabsTransaction reason
     * @property {google.protobuf.ITimestamp|null} [created_at] OCRLabsTransaction created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] OCRLabsTransaction last_updated_at
     */

    /**
     * Constructs a new OCRLabsTransaction.
     * @exports OCRLabsTransaction
     * @classdesc Represents a OCRLabsTransaction.
     * @implements IOCRLabsTransaction
     * @constructor
     * @param {IOCRLabsTransaction=} [properties] Properties to set
     */
    function OCRLabsTransaction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OCRLabsTransaction id.
     * @member {string} id
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.id = "";

    /**
     * OCRLabsTransaction contact_id.
     * @member {string} contact_id
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.contact_id = "";

    /**
     * OCRLabsTransaction phone_number.
     * @member {string} phone_number
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.phone_number = "";

    /**
     * OCRLabsTransaction ocr_status.
     * @member {OCRTransactionStatus.Enum} ocr_status
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.ocr_status = 0;

    /**
     * OCRLabsTransaction contact_match_status.
     * @member {OCRContactMatchStatus.Enum} contact_match_status
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.contact_match_status = 0;

    /**
     * OCRLabsTransaction matched_at.
     * @member {google.protobuf.ITimestamp|null|undefined} matched_at
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.matched_at = null;

    /**
     * OCRLabsTransaction first_name.
     * @member {string} first_name
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.first_name = "";

    /**
     * OCRLabsTransaction middle_name.
     * @member {string} middle_name
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.middle_name = "";

    /**
     * OCRLabsTransaction last_name.
     * @member {string} last_name
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.last_name = "";

    /**
     * OCRLabsTransaction date_of_birth.
     * @member {string} date_of_birth
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.date_of_birth = "";

    /**
     * OCRLabsTransaction source.
     * @member {OCRTransactionSource.Enum} source
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.source = 0;

    /**
     * OCRLabsTransaction reason.
     * @member {OCRTransactionReason.Enum} reason
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.reason = 0;

    /**
     * OCRLabsTransaction created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.created_at = null;

    /**
     * OCRLabsTransaction last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof OCRLabsTransaction
     * @instance
     */
    OCRLabsTransaction.prototype.last_updated_at = null;

    /**
     * Creates a new OCRLabsTransaction instance using the specified properties.
     * @function create
     * @memberof OCRLabsTransaction
     * @static
     * @param {IOCRLabsTransaction=} [properties] Properties to set
     * @returns {OCRLabsTransaction} OCRLabsTransaction instance
     */
    OCRLabsTransaction.create = function create(properties) {
        return new OCRLabsTransaction(properties);
    };

    /**
     * Encodes the specified OCRLabsTransaction message. Does not implicitly {@link OCRLabsTransaction.verify|verify} messages.
     * @function encode
     * @memberof OCRLabsTransaction
     * @static
     * @param {IOCRLabsTransaction} message OCRLabsTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRLabsTransaction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.contact_id);
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.phone_number);
        if (message.ocr_status != null && message.hasOwnProperty("ocr_status"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.ocr_status);
        if (message.contact_match_status != null && message.hasOwnProperty("contact_match_status"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.contact_match_status);
        if (message.matched_at != null && message.hasOwnProperty("matched_at"))
            $root.google.protobuf.Timestamp.encode(message.matched_at, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.first_name);
        if (message.middle_name != null && message.hasOwnProperty("middle_name"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.middle_name);
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.last_name);
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.date_of_birth);
        if (message.source != null && message.hasOwnProperty("source"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.source);
        if (message.reason != null && message.hasOwnProperty("reason"))
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.reason);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified OCRLabsTransaction message, length delimited. Does not implicitly {@link OCRLabsTransaction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OCRLabsTransaction
     * @static
     * @param {IOCRLabsTransaction} message OCRLabsTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRLabsTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a OCRLabsTransaction message from the specified reader or buffer.
     * @function decode
     * @memberof OCRLabsTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OCRLabsTransaction} OCRLabsTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRLabsTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OCRLabsTransaction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.contact_id = reader.string();
                break;
            case 3:
                message.phone_number = reader.string();
                break;
            case 4:
                message.ocr_status = reader.int32();
                break;
            case 5:
                message.contact_match_status = reader.int32();
                break;
            case 6:
                message.matched_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 7:
                message.first_name = reader.string();
                break;
            case 8:
                message.middle_name = reader.string();
                break;
            case 9:
                message.last_name = reader.string();
                break;
            case 10:
                message.date_of_birth = reader.string();
                break;
            case 11:
                message.source = reader.int32();
                break;
            case 12:
                message.reason = reader.int32();
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a OCRLabsTransaction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OCRLabsTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OCRLabsTransaction} OCRLabsTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRLabsTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a OCRLabsTransaction message.
     * @function verify
     * @memberof OCRLabsTransaction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OCRLabsTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            if (!$util.isString(message.contact_id))
                return "contact_id: string expected";
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            if (!$util.isString(message.phone_number))
                return "phone_number: string expected";
        if (message.ocr_status != null && message.hasOwnProperty("ocr_status"))
            switch (message.ocr_status) {
            default:
                return "ocr_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                break;
            }
        if (message.contact_match_status != null && message.hasOwnProperty("contact_match_status"))
            switch (message.contact_match_status) {
            default:
                return "contact_match_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.matched_at != null && message.hasOwnProperty("matched_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.matched_at);
            if (error)
                return "matched_at." + error;
        }
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            if (!$util.isString(message.first_name))
                return "first_name: string expected";
        if (message.middle_name != null && message.hasOwnProperty("middle_name"))
            if (!$util.isString(message.middle_name))
                return "middle_name: string expected";
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            if (!$util.isString(message.last_name))
                return "last_name: string expected";
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            if (!$util.isString(message.date_of_birth))
                return "date_of_birth: string expected";
        if (message.source != null && message.hasOwnProperty("source"))
            switch (message.source) {
            default:
                return "source: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.reason != null && message.hasOwnProperty("reason"))
            switch (message.reason) {
            default:
                return "reason: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a OCRLabsTransaction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OCRLabsTransaction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OCRLabsTransaction} OCRLabsTransaction
     */
    OCRLabsTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.OCRLabsTransaction)
            return object;
        let message = new $root.OCRLabsTransaction();
        if (object.id != null)
            message.id = String(object.id);
        if (object.contact_id != null)
            message.contact_id = String(object.contact_id);
        if (object.phone_number != null)
            message.phone_number = String(object.phone_number);
        switch (object.ocr_status) {
        case "UNKNOWN":
        case 0:
            message.ocr_status = 0;
            break;
        case "NOT_FETCHED_YET":
        case 1:
            message.ocr_status = 1;
            break;
        case "PENDING":
        case 2:
            message.ocr_status = 2;
            break;
        case "IN_PROGRESS":
        case 3:
            message.ocr_status = 3;
            break;
        case "COMPLETED_PASS":
        case 4:
            message.ocr_status = 4;
            break;
        case "COMPLETED_FLAGGED":
        case 5:
            message.ocr_status = 5;
            break;
        case "EXPIRED":
        case 6:
            message.ocr_status = 6;
            break;
        case "CANCELLED":
        case 7:
            message.ocr_status = 7;
            break;
        }
        switch (object.contact_match_status) {
        case "UNKNOWN":
        case 0:
            message.contact_match_status = 0;
            break;
        case "NOT_MATCHED_YET":
        case 1:
            message.contact_match_status = 1;
            break;
        case "EXACT_MATCH":
        case 2:
            message.contact_match_status = 2;
            break;
        case "NO_MATCH":
        case 3:
            message.contact_match_status = 3;
            break;
        case "FUZZY_MATCH":
        case 4:
            message.contact_match_status = 4;
            break;
        }
        if (object.matched_at != null) {
            if (typeof object.matched_at !== "object")
                throw TypeError(".OCRLabsTransaction.matched_at: object expected");
            message.matched_at = $root.google.protobuf.Timestamp.fromObject(object.matched_at);
        }
        if (object.first_name != null)
            message.first_name = String(object.first_name);
        if (object.middle_name != null)
            message.middle_name = String(object.middle_name);
        if (object.last_name != null)
            message.last_name = String(object.last_name);
        if (object.date_of_birth != null)
            message.date_of_birth = String(object.date_of_birth);
        switch (object.source) {
        case "UNKNOWN":
        case 0:
            message.source = 0;
            break;
        case "NATIVE_APP":
        case 1:
            message.source = 1;
            break;
        case "WEB_APP":
        case 2:
            message.source = 2;
            break;
        }
        switch (object.reason) {
        case "UNKNOWN":
        case 0:
            message.reason = 0;
            break;
        case "CHANGE_BANK_ACCOUNT":
        case 1:
            message.reason = 1;
            break;
        case "MERGE_VOYAGER_ACCOUNT":
        case 2:
            message.reason = 2;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".OCRLabsTransaction.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".OCRLabsTransaction.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a OCRLabsTransaction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OCRLabsTransaction
     * @static
     * @param {OCRLabsTransaction} message OCRLabsTransaction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OCRLabsTransaction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.contact_id = "";
            object.phone_number = "";
            object.ocr_status = options.enums === String ? "UNKNOWN" : 0;
            object.contact_match_status = options.enums === String ? "UNKNOWN" : 0;
            object.matched_at = null;
            object.first_name = "";
            object.middle_name = "";
            object.last_name = "";
            object.date_of_birth = "";
            object.source = options.enums === String ? "UNKNOWN" : 0;
            object.reason = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            object.contact_id = message.contact_id;
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            object.phone_number = message.phone_number;
        if (message.ocr_status != null && message.hasOwnProperty("ocr_status"))
            object.ocr_status = options.enums === String ? $root.OCRTransactionStatus.Enum[message.ocr_status] : message.ocr_status;
        if (message.contact_match_status != null && message.hasOwnProperty("contact_match_status"))
            object.contact_match_status = options.enums === String ? $root.OCRContactMatchStatus.Enum[message.contact_match_status] : message.contact_match_status;
        if (message.matched_at != null && message.hasOwnProperty("matched_at"))
            object.matched_at = $root.google.protobuf.Timestamp.toObject(message.matched_at, options);
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            object.first_name = message.first_name;
        if (message.middle_name != null && message.hasOwnProperty("middle_name"))
            object.middle_name = message.middle_name;
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            object.last_name = message.last_name;
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            object.date_of_birth = message.date_of_birth;
        if (message.source != null && message.hasOwnProperty("source"))
            object.source = options.enums === String ? $root.OCRTransactionSource.Enum[message.source] : message.source;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = options.enums === String ? $root.OCRTransactionReason.Enum[message.reason] : message.reason;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this OCRLabsTransaction to JSON.
     * @function toJSON
     * @memberof OCRLabsTransaction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OCRLabsTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OCRLabsTransaction;
})();

export const OCRLabsOverrideAction = $root.OCRLabsOverrideAction = (() => {

    /**
     * Properties of a OCRLabsOverrideAction.
     * @exports IOCRLabsOverrideAction
     * @interface IOCRLabsOverrideAction
     */

    /**
     * Constructs a new OCRLabsOverrideAction.
     * @exports OCRLabsOverrideAction
     * @classdesc Represents a OCRLabsOverrideAction.
     * @implements IOCRLabsOverrideAction
     * @constructor
     * @param {IOCRLabsOverrideAction=} [properties] Properties to set
     */
    function OCRLabsOverrideAction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new OCRLabsOverrideAction instance using the specified properties.
     * @function create
     * @memberof OCRLabsOverrideAction
     * @static
     * @param {IOCRLabsOverrideAction=} [properties] Properties to set
     * @returns {OCRLabsOverrideAction} OCRLabsOverrideAction instance
     */
    OCRLabsOverrideAction.create = function create(properties) {
        return new OCRLabsOverrideAction(properties);
    };

    /**
     * Encodes the specified OCRLabsOverrideAction message. Does not implicitly {@link OCRLabsOverrideAction.verify|verify} messages.
     * @function encode
     * @memberof OCRLabsOverrideAction
     * @static
     * @param {IOCRLabsOverrideAction} message OCRLabsOverrideAction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRLabsOverrideAction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified OCRLabsOverrideAction message, length delimited. Does not implicitly {@link OCRLabsOverrideAction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OCRLabsOverrideAction
     * @static
     * @param {IOCRLabsOverrideAction} message OCRLabsOverrideAction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRLabsOverrideAction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a OCRLabsOverrideAction message from the specified reader or buffer.
     * @function decode
     * @memberof OCRLabsOverrideAction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OCRLabsOverrideAction} OCRLabsOverrideAction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRLabsOverrideAction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OCRLabsOverrideAction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a OCRLabsOverrideAction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OCRLabsOverrideAction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OCRLabsOverrideAction} OCRLabsOverrideAction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRLabsOverrideAction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a OCRLabsOverrideAction message.
     * @function verify
     * @memberof OCRLabsOverrideAction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OCRLabsOverrideAction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a OCRLabsOverrideAction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OCRLabsOverrideAction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OCRLabsOverrideAction} OCRLabsOverrideAction
     */
    OCRLabsOverrideAction.fromObject = function fromObject(object) {
        if (object instanceof $root.OCRLabsOverrideAction)
            return object;
        return new $root.OCRLabsOverrideAction();
    };

    /**
     * Creates a plain object from a OCRLabsOverrideAction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OCRLabsOverrideAction
     * @static
     * @param {OCRLabsOverrideAction} message OCRLabsOverrideAction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OCRLabsOverrideAction.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this OCRLabsOverrideAction to JSON.
     * @function toJSON
     * @memberof OCRLabsOverrideAction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OCRLabsOverrideAction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name OCRLabsOverrideAction.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} APPROVED=1 APPROVED value
     * @property {number} REJECTED=2 REJECTED value
     */
    OCRLabsOverrideAction.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "APPROVED"] = 1;
        values[valuesById[2] = "REJECTED"] = 2;
        return values;
    })();

    return OCRLabsOverrideAction;
})();

export const OCRLabsContactVerificationOverride = $root.OCRLabsContactVerificationOverride = (() => {

    /**
     * Properties of a OCRLabsContactVerificationOverride.
     * @exports IOCRLabsContactVerificationOverride
     * @interface IOCRLabsContactVerificationOverride
     * @property {string|null} [id] OCRLabsContactVerificationOverride id
     * @property {string|null} [contact_id] OCRLabsContactVerificationOverride contact_id
     * @property {OCRLabsOverrideAction.Enum|null} [action] OCRLabsContactVerificationOverride action
     * @property {string|null} [note] OCRLabsContactVerificationOverride note
     * @property {string|null} [transaction_id] OCRLabsContactVerificationOverride transaction_id
     * @property {string|null} [created_by_admin_id] OCRLabsContactVerificationOverride created_by_admin_id
     * @property {google.protobuf.ITimestamp|null} [created_at] OCRLabsContactVerificationOverride created_at
     */

    /**
     * Constructs a new OCRLabsContactVerificationOverride.
     * @exports OCRLabsContactVerificationOverride
     * @classdesc Represents a OCRLabsContactVerificationOverride.
     * @implements IOCRLabsContactVerificationOverride
     * @constructor
     * @param {IOCRLabsContactVerificationOverride=} [properties] Properties to set
     */
    function OCRLabsContactVerificationOverride(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OCRLabsContactVerificationOverride id.
     * @member {string} id
     * @memberof OCRLabsContactVerificationOverride
     * @instance
     */
    OCRLabsContactVerificationOverride.prototype.id = "";

    /**
     * OCRLabsContactVerificationOverride contact_id.
     * @member {string} contact_id
     * @memberof OCRLabsContactVerificationOverride
     * @instance
     */
    OCRLabsContactVerificationOverride.prototype.contact_id = "";

    /**
     * OCRLabsContactVerificationOverride action.
     * @member {OCRLabsOverrideAction.Enum} action
     * @memberof OCRLabsContactVerificationOverride
     * @instance
     */
    OCRLabsContactVerificationOverride.prototype.action = 0;

    /**
     * OCRLabsContactVerificationOverride note.
     * @member {string} note
     * @memberof OCRLabsContactVerificationOverride
     * @instance
     */
    OCRLabsContactVerificationOverride.prototype.note = "";

    /**
     * OCRLabsContactVerificationOverride transaction_id.
     * @member {string} transaction_id
     * @memberof OCRLabsContactVerificationOverride
     * @instance
     */
    OCRLabsContactVerificationOverride.prototype.transaction_id = "";

    /**
     * OCRLabsContactVerificationOverride created_by_admin_id.
     * @member {string} created_by_admin_id
     * @memberof OCRLabsContactVerificationOverride
     * @instance
     */
    OCRLabsContactVerificationOverride.prototype.created_by_admin_id = "";

    /**
     * OCRLabsContactVerificationOverride created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof OCRLabsContactVerificationOverride
     * @instance
     */
    OCRLabsContactVerificationOverride.prototype.created_at = null;

    /**
     * Creates a new OCRLabsContactVerificationOverride instance using the specified properties.
     * @function create
     * @memberof OCRLabsContactVerificationOverride
     * @static
     * @param {IOCRLabsContactVerificationOverride=} [properties] Properties to set
     * @returns {OCRLabsContactVerificationOverride} OCRLabsContactVerificationOverride instance
     */
    OCRLabsContactVerificationOverride.create = function create(properties) {
        return new OCRLabsContactVerificationOverride(properties);
    };

    /**
     * Encodes the specified OCRLabsContactVerificationOverride message. Does not implicitly {@link OCRLabsContactVerificationOverride.verify|verify} messages.
     * @function encode
     * @memberof OCRLabsContactVerificationOverride
     * @static
     * @param {IOCRLabsContactVerificationOverride} message OCRLabsContactVerificationOverride message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRLabsContactVerificationOverride.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.contact_id);
        if (message.action != null && message.hasOwnProperty("action"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.action);
        if (message.note != null && message.hasOwnProperty("note"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.note);
        if (message.transaction_id != null && message.hasOwnProperty("transaction_id"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.transaction_id);
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.created_by_admin_id);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified OCRLabsContactVerificationOverride message, length delimited. Does not implicitly {@link OCRLabsContactVerificationOverride.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OCRLabsContactVerificationOverride
     * @static
     * @param {IOCRLabsContactVerificationOverride} message OCRLabsContactVerificationOverride message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRLabsContactVerificationOverride.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a OCRLabsContactVerificationOverride message from the specified reader or buffer.
     * @function decode
     * @memberof OCRLabsContactVerificationOverride
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OCRLabsContactVerificationOverride} OCRLabsContactVerificationOverride
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRLabsContactVerificationOverride.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OCRLabsContactVerificationOverride();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.contact_id = reader.string();
                break;
            case 3:
                message.action = reader.int32();
                break;
            case 4:
                message.note = reader.string();
                break;
            case 5:
                message.transaction_id = reader.string();
                break;
            case 6:
                message.created_by_admin_id = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a OCRLabsContactVerificationOverride message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OCRLabsContactVerificationOverride
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OCRLabsContactVerificationOverride} OCRLabsContactVerificationOverride
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRLabsContactVerificationOverride.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a OCRLabsContactVerificationOverride message.
     * @function verify
     * @memberof OCRLabsContactVerificationOverride
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OCRLabsContactVerificationOverride.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            if (!$util.isString(message.contact_id))
                return "contact_id: string expected";
        if (message.action != null && message.hasOwnProperty("action"))
            switch (message.action) {
            default:
                return "action: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.note != null && message.hasOwnProperty("note"))
            if (!$util.isString(message.note))
                return "note: string expected";
        if (message.transaction_id != null && message.hasOwnProperty("transaction_id"))
            if (!$util.isString(message.transaction_id))
                return "transaction_id: string expected";
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            if (!$util.isString(message.created_by_admin_id))
                return "created_by_admin_id: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a OCRLabsContactVerificationOverride message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OCRLabsContactVerificationOverride
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OCRLabsContactVerificationOverride} OCRLabsContactVerificationOverride
     */
    OCRLabsContactVerificationOverride.fromObject = function fromObject(object) {
        if (object instanceof $root.OCRLabsContactVerificationOverride)
            return object;
        let message = new $root.OCRLabsContactVerificationOverride();
        if (object.id != null)
            message.id = String(object.id);
        if (object.contact_id != null)
            message.contact_id = String(object.contact_id);
        switch (object.action) {
        case "UNKNOWN":
        case 0:
            message.action = 0;
            break;
        case "APPROVED":
        case 1:
            message.action = 1;
            break;
        case "REJECTED":
        case 2:
            message.action = 2;
            break;
        }
        if (object.note != null)
            message.note = String(object.note);
        if (object.transaction_id != null)
            message.transaction_id = String(object.transaction_id);
        if (object.created_by_admin_id != null)
            message.created_by_admin_id = String(object.created_by_admin_id);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".OCRLabsContactVerificationOverride.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a OCRLabsContactVerificationOverride message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OCRLabsContactVerificationOverride
     * @static
     * @param {OCRLabsContactVerificationOverride} message OCRLabsContactVerificationOverride
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OCRLabsContactVerificationOverride.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.contact_id = "";
            object.action = options.enums === String ? "UNKNOWN" : 0;
            object.note = "";
            object.transaction_id = "";
            object.created_by_admin_id = "";
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.contact_id != null && message.hasOwnProperty("contact_id"))
            object.contact_id = message.contact_id;
        if (message.action != null && message.hasOwnProperty("action"))
            object.action = options.enums === String ? $root.OCRLabsOverrideAction.Enum[message.action] : message.action;
        if (message.note != null && message.hasOwnProperty("note"))
            object.note = message.note;
        if (message.transaction_id != null && message.hasOwnProperty("transaction_id"))
            object.transaction_id = message.transaction_id;
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            object.created_by_admin_id = message.created_by_admin_id;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this OCRLabsContactVerificationOverride to JSON.
     * @function toJSON
     * @memberof OCRLabsContactVerificationOverride
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OCRLabsContactVerificationOverride.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OCRLabsContactVerificationOverride;
})();

export const BankAccountStatus = $root.BankAccountStatus = (() => {

    /**
     * Properties of a BankAccountStatus.
     * @exports IBankAccountStatus
     * @interface IBankAccountStatus
     */

    /**
     * Constructs a new BankAccountStatus.
     * @exports BankAccountStatus
     * @classdesc Represents a BankAccountStatus.
     * @implements IBankAccountStatus
     * @constructor
     * @param {IBankAccountStatus=} [properties] Properties to set
     */
    function BankAccountStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new BankAccountStatus instance using the specified properties.
     * @function create
     * @memberof BankAccountStatus
     * @static
     * @param {IBankAccountStatus=} [properties] Properties to set
     * @returns {BankAccountStatus} BankAccountStatus instance
     */
    BankAccountStatus.create = function create(properties) {
        return new BankAccountStatus(properties);
    };

    /**
     * Encodes the specified BankAccountStatus message. Does not implicitly {@link BankAccountStatus.verify|verify} messages.
     * @function encode
     * @memberof BankAccountStatus
     * @static
     * @param {IBankAccountStatus} message BankAccountStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccountStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified BankAccountStatus message, length delimited. Does not implicitly {@link BankAccountStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BankAccountStatus
     * @static
     * @param {IBankAccountStatus} message BankAccountStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccountStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BankAccountStatus message from the specified reader or buffer.
     * @function decode
     * @memberof BankAccountStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BankAccountStatus} BankAccountStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccountStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BankAccountStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BankAccountStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BankAccountStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BankAccountStatus} BankAccountStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccountStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BankAccountStatus message.
     * @function verify
     * @memberof BankAccountStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BankAccountStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a BankAccountStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BankAccountStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BankAccountStatus} BankAccountStatus
     */
    BankAccountStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.BankAccountStatus)
            return object;
        return new $root.BankAccountStatus();
    };

    /**
     * Creates a plain object from a BankAccountStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BankAccountStatus
     * @static
     * @param {BankAccountStatus} message BankAccountStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BankAccountStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this BankAccountStatus to JSON.
     * @function toJSON
     * @memberof BankAccountStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BankAccountStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name BankAccountStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} AUTOMATICALLY_VERIFIED=1 AUTOMATICALLY_VERIFIED value
     * @property {number} MANUALLY_VERIFIED=2 MANUALLY_VERIFIED value
     * @property {number} VERIFICATION_REQUIRED=3 VERIFICATION_REQUIRED value
     * @property {number} ILLION_VERIFIED=4 ILLION_VERIFIED value
     */
    BankAccountStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "AUTOMATICALLY_VERIFIED"] = 1;
        values[valuesById[2] = "MANUALLY_VERIFIED"] = 2;
        values[valuesById[3] = "VERIFICATION_REQUIRED"] = 3;
        values[valuesById[4] = "ILLION_VERIFIED"] = 4;
        return values;
    })();

    return BankAccountStatus;
})();

export const BankAccount = $root.BankAccount = (() => {

    /**
     * Properties of a BankAccount.
     * @exports IBankAccount
     * @interface IBankAccount
     * @property {string|null} [id] BankAccount id
     * @property {string|null} [account_number] BankAccount account_number
     * @property {string|null} [bsb] BankAccount bsb
     * @property {string|null} [friendly_name] BankAccount friendly_name
     * @property {BankAccountStatus.Enum|null} [status] BankAccount status
     * @property {google.protobuf.ITimestamp|null} [created_at] BankAccount created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] BankAccount last_updated_at
     * @property {string|null} [account_name] BankAccount account_name
     * @property {boolean|null} [active] BankAccount active
     * @property {string|null} [account_id] BankAccount account_id
     */

    /**
     * Constructs a new BankAccount.
     * @exports BankAccount
     * @classdesc Represents a BankAccount.
     * @implements IBankAccount
     * @constructor
     * @param {IBankAccount=} [properties] Properties to set
     */
    function BankAccount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BankAccount id.
     * @member {string} id
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.id = "";

    /**
     * BankAccount account_number.
     * @member {string} account_number
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.account_number = "";

    /**
     * BankAccount bsb.
     * @member {string} bsb
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.bsb = "";

    /**
     * BankAccount friendly_name.
     * @member {string} friendly_name
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.friendly_name = "";

    /**
     * BankAccount status.
     * @member {BankAccountStatus.Enum} status
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.status = 0;

    /**
     * BankAccount created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.created_at = null;

    /**
     * BankAccount last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.last_updated_at = null;

    /**
     * BankAccount account_name.
     * @member {string} account_name
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.account_name = "";

    /**
     * BankAccount active.
     * @member {boolean} active
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.active = false;

    /**
     * BankAccount account_id.
     * @member {string} account_id
     * @memberof BankAccount
     * @instance
     */
    BankAccount.prototype.account_id = "";

    /**
     * Creates a new BankAccount instance using the specified properties.
     * @function create
     * @memberof BankAccount
     * @static
     * @param {IBankAccount=} [properties] Properties to set
     * @returns {BankAccount} BankAccount instance
     */
    BankAccount.create = function create(properties) {
        return new BankAccount(properties);
    };

    /**
     * Encodes the specified BankAccount message. Does not implicitly {@link BankAccount.verify|verify} messages.
     * @function encode
     * @memberof BankAccount
     * @static
     * @param {IBankAccount} message BankAccount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_number);
        if (message.bsb != null && message.hasOwnProperty("bsb"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.bsb);
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.friendly_name);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.status);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.account_name != null && message.hasOwnProperty("account_name"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.account_name);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.active);
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.account_id);
        return writer;
    };

    /**
     * Encodes the specified BankAccount message, length delimited. Does not implicitly {@link BankAccount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BankAccount
     * @static
     * @param {IBankAccount} message BankAccount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BankAccount message from the specified reader or buffer.
     * @function decode
     * @memberof BankAccount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BankAccount} BankAccount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BankAccount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.account_number = reader.string();
                break;
            case 3:
                message.bsb = reader.string();
                break;
            case 4:
                message.friendly_name = reader.string();
                break;
            case 5:
                message.status = reader.int32();
                break;
            case 6:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 7:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 9:
                message.account_name = reader.string();
                break;
            case 10:
                message.active = reader.bool();
                break;
            case 11:
                message.account_id = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BankAccount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BankAccount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BankAccount} BankAccount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BankAccount message.
     * @function verify
     * @memberof BankAccount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BankAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            if (!$util.isString(message.account_number))
                return "account_number: string expected";
        if (message.bsb != null && message.hasOwnProperty("bsb"))
            if (!$util.isString(message.bsb))
                return "bsb: string expected";
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            if (!$util.isString(message.friendly_name))
                return "friendly_name: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        if (message.account_name != null && message.hasOwnProperty("account_name"))
            if (!$util.isString(message.account_name))
                return "account_name: string expected";
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            if (!$util.isString(message.account_id))
                return "account_id: string expected";
        return null;
    };

    /**
     * Creates a BankAccount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BankAccount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BankAccount} BankAccount
     */
    BankAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.BankAccount)
            return object;
        let message = new $root.BankAccount();
        if (object.id != null)
            message.id = String(object.id);
        if (object.account_number != null)
            message.account_number = String(object.account_number);
        if (object.bsb != null)
            message.bsb = String(object.bsb);
        if (object.friendly_name != null)
            message.friendly_name = String(object.friendly_name);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "AUTOMATICALLY_VERIFIED":
        case 1:
            message.status = 1;
            break;
        case "MANUALLY_VERIFIED":
        case 2:
            message.status = 2;
            break;
        case "VERIFICATION_REQUIRED":
        case 3:
            message.status = 3;
            break;
        case "ILLION_VERIFIED":
        case 4:
            message.status = 4;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".BankAccount.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".BankAccount.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        if (object.account_name != null)
            message.account_name = String(object.account_name);
        if (object.active != null)
            message.active = Boolean(object.active);
        if (object.account_id != null)
            message.account_id = String(object.account_id);
        return message;
    };

    /**
     * Creates a plain object from a BankAccount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BankAccount
     * @static
     * @param {BankAccount} message BankAccount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BankAccount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.account_number = "";
            object.bsb = "";
            object.friendly_name = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
            object.account_name = "";
            object.active = false;
            object.account_id = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            object.account_number = message.account_number;
        if (message.bsb != null && message.hasOwnProperty("bsb"))
            object.bsb = message.bsb;
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            object.friendly_name = message.friendly_name;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.BankAccountStatus.Enum[message.status] : message.status;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        if (message.account_name != null && message.hasOwnProperty("account_name"))
            object.account_name = message.account_name;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            object.account_id = message.account_id;
        return object;
    };

    /**
     * Converts this BankAccount to JSON.
     * @function toJSON
     * @memberof BankAccount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BankAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BankAccount;
})();

export const BranchDetails = $root.BranchDetails = (() => {

    /**
     * Properties of a BranchDetails.
     * @exports IBranchDetails
     * @interface IBranchDetails
     * @property {string|null} [bsb_number] BranchDetails bsb_number
     * @property {string|null} [bank_type] BranchDetails bank_type
     * @property {string|null} [branch_name] BranchDetails branch_name
     * @property {string|null} [street_address] BranchDetails street_address
     * @property {string|null} [city] BranchDetails city
     * @property {string|null} [state] BranchDetails state
     * @property {string|null} [postcode] BranchDetails postcode
     * @property {string|null} [allowed_payment_type] BranchDetails allowed_payment_type
     * @property {boolean|null} [allows_direct_debit] BranchDetails allows_direct_debit
     * @property {boolean|null} [active] BranchDetails active
     * @property {string|null} [bank_name] BranchDetails bank_name
     * @property {string|null} [bank_id] BranchDetails bank_id
     * @property {google.protobuf.ITimestamp|null} [created_at] BranchDetails created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] BranchDetails last_updated_at
     */

    /**
     * Constructs a new BranchDetails.
     * @exports BranchDetails
     * @classdesc Represents a BranchDetails.
     * @implements IBranchDetails
     * @constructor
     * @param {IBranchDetails=} [properties] Properties to set
     */
    function BranchDetails(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BranchDetails bsb_number.
     * @member {string} bsb_number
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.bsb_number = "";

    /**
     * BranchDetails bank_type.
     * @member {string} bank_type
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.bank_type = "";

    /**
     * BranchDetails branch_name.
     * @member {string} branch_name
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.branch_name = "";

    /**
     * BranchDetails street_address.
     * @member {string} street_address
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.street_address = "";

    /**
     * BranchDetails city.
     * @member {string} city
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.city = "";

    /**
     * BranchDetails state.
     * @member {string} state
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.state = "";

    /**
     * BranchDetails postcode.
     * @member {string} postcode
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.postcode = "";

    /**
     * BranchDetails allowed_payment_type.
     * @member {string} allowed_payment_type
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.allowed_payment_type = "";

    /**
     * BranchDetails allows_direct_debit.
     * @member {boolean} allows_direct_debit
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.allows_direct_debit = false;

    /**
     * BranchDetails active.
     * @member {boolean} active
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.active = false;

    /**
     * BranchDetails bank_name.
     * @member {string} bank_name
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.bank_name = "";

    /**
     * BranchDetails bank_id.
     * @member {string} bank_id
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.bank_id = "";

    /**
     * BranchDetails created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.created_at = null;

    /**
     * BranchDetails last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof BranchDetails
     * @instance
     */
    BranchDetails.prototype.last_updated_at = null;

    /**
     * Creates a new BranchDetails instance using the specified properties.
     * @function create
     * @memberof BranchDetails
     * @static
     * @param {IBranchDetails=} [properties] Properties to set
     * @returns {BranchDetails} BranchDetails instance
     */
    BranchDetails.create = function create(properties) {
        return new BranchDetails(properties);
    };

    /**
     * Encodes the specified BranchDetails message. Does not implicitly {@link BranchDetails.verify|verify} messages.
     * @function encode
     * @memberof BranchDetails
     * @static
     * @param {IBranchDetails} message BranchDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BranchDetails.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bsb_number != null && message.hasOwnProperty("bsb_number"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.bsb_number);
        if (message.bank_type != null && message.hasOwnProperty("bank_type"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.bank_type);
        if (message.branch_name != null && message.hasOwnProperty("branch_name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.branch_name);
        if (message.street_address != null && message.hasOwnProperty("street_address"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.street_address);
        if (message.city != null && message.hasOwnProperty("city"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.city);
        if (message.state != null && message.hasOwnProperty("state"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.state);
        if (message.postcode != null && message.hasOwnProperty("postcode"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.postcode);
        if (message.allowed_payment_type != null && message.hasOwnProperty("allowed_payment_type"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.allowed_payment_type);
        if (message.allows_direct_debit != null && message.hasOwnProperty("allows_direct_debit"))
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.allows_direct_debit);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.active);
        if (message.bank_name != null && message.hasOwnProperty("bank_name"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.bank_name);
        if (message.bank_id != null && message.hasOwnProperty("bank_id"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.bank_id);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 102, wireType 2 =*/818).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BranchDetails message, length delimited. Does not implicitly {@link BranchDetails.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BranchDetails
     * @static
     * @param {IBranchDetails} message BranchDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BranchDetails.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BranchDetails message from the specified reader or buffer.
     * @function decode
     * @memberof BranchDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BranchDetails} BranchDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BranchDetails.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BranchDetails();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.bsb_number = reader.string();
                break;
            case 2:
                message.bank_type = reader.string();
                break;
            case 3:
                message.branch_name = reader.string();
                break;
            case 4:
                message.street_address = reader.string();
                break;
            case 5:
                message.city = reader.string();
                break;
            case 6:
                message.state = reader.string();
                break;
            case 7:
                message.postcode = reader.string();
                break;
            case 8:
                message.allowed_payment_type = reader.string();
                break;
            case 9:
                message.allows_direct_debit = reader.bool();
                break;
            case 10:
                message.active = reader.bool();
                break;
            case 11:
                message.bank_name = reader.string();
                break;
            case 12:
                message.bank_id = reader.string();
                break;
            case 101:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 102:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BranchDetails message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BranchDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BranchDetails} BranchDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BranchDetails.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BranchDetails message.
     * @function verify
     * @memberof BranchDetails
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BranchDetails.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bsb_number != null && message.hasOwnProperty("bsb_number"))
            if (!$util.isString(message.bsb_number))
                return "bsb_number: string expected";
        if (message.bank_type != null && message.hasOwnProperty("bank_type"))
            if (!$util.isString(message.bank_type))
                return "bank_type: string expected";
        if (message.branch_name != null && message.hasOwnProperty("branch_name"))
            if (!$util.isString(message.branch_name))
                return "branch_name: string expected";
        if (message.street_address != null && message.hasOwnProperty("street_address"))
            if (!$util.isString(message.street_address))
                return "street_address: string expected";
        if (message.city != null && message.hasOwnProperty("city"))
            if (!$util.isString(message.city))
                return "city: string expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!$util.isString(message.state))
                return "state: string expected";
        if (message.postcode != null && message.hasOwnProperty("postcode"))
            if (!$util.isString(message.postcode))
                return "postcode: string expected";
        if (message.allowed_payment_type != null && message.hasOwnProperty("allowed_payment_type"))
            if (!$util.isString(message.allowed_payment_type))
                return "allowed_payment_type: string expected";
        if (message.allows_direct_debit != null && message.hasOwnProperty("allows_direct_debit"))
            if (typeof message.allows_direct_debit !== "boolean")
                return "allows_direct_debit: boolean expected";
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.bank_name != null && message.hasOwnProperty("bank_name"))
            if (!$util.isString(message.bank_name))
                return "bank_name: string expected";
        if (message.bank_id != null && message.hasOwnProperty("bank_id"))
            if (!$util.isString(message.bank_id))
                return "bank_id: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a BranchDetails message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BranchDetails
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BranchDetails} BranchDetails
     */
    BranchDetails.fromObject = function fromObject(object) {
        if (object instanceof $root.BranchDetails)
            return object;
        let message = new $root.BranchDetails();
        if (object.bsb_number != null)
            message.bsb_number = String(object.bsb_number);
        if (object.bank_type != null)
            message.bank_type = String(object.bank_type);
        if (object.branch_name != null)
            message.branch_name = String(object.branch_name);
        if (object.street_address != null)
            message.street_address = String(object.street_address);
        if (object.city != null)
            message.city = String(object.city);
        if (object.state != null)
            message.state = String(object.state);
        if (object.postcode != null)
            message.postcode = String(object.postcode);
        if (object.allowed_payment_type != null)
            message.allowed_payment_type = String(object.allowed_payment_type);
        if (object.allows_direct_debit != null)
            message.allows_direct_debit = Boolean(object.allows_direct_debit);
        if (object.active != null)
            message.active = Boolean(object.active);
        if (object.bank_name != null)
            message.bank_name = String(object.bank_name);
        if (object.bank_id != null)
            message.bank_id = String(object.bank_id);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".BranchDetails.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".BranchDetails.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a BranchDetails message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BranchDetails
     * @static
     * @param {BranchDetails} message BranchDetails
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BranchDetails.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.bsb_number = "";
            object.bank_type = "";
            object.branch_name = "";
            object.street_address = "";
            object.city = "";
            object.state = "";
            object.postcode = "";
            object.allowed_payment_type = "";
            object.allows_direct_debit = false;
            object.active = false;
            object.bank_name = "";
            object.bank_id = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.bsb_number != null && message.hasOwnProperty("bsb_number"))
            object.bsb_number = message.bsb_number;
        if (message.bank_type != null && message.hasOwnProperty("bank_type"))
            object.bank_type = message.bank_type;
        if (message.branch_name != null && message.hasOwnProperty("branch_name"))
            object.branch_name = message.branch_name;
        if (message.street_address != null && message.hasOwnProperty("street_address"))
            object.street_address = message.street_address;
        if (message.city != null && message.hasOwnProperty("city"))
            object.city = message.city;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
        if (message.postcode != null && message.hasOwnProperty("postcode"))
            object.postcode = message.postcode;
        if (message.allowed_payment_type != null && message.hasOwnProperty("allowed_payment_type"))
            object.allowed_payment_type = message.allowed_payment_type;
        if (message.allows_direct_debit != null && message.hasOwnProperty("allows_direct_debit"))
            object.allows_direct_debit = message.allows_direct_debit;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.bank_name != null && message.hasOwnProperty("bank_name"))
            object.bank_name = message.bank_name;
        if (message.bank_id != null && message.hasOwnProperty("bank_id"))
            object.bank_id = message.bank_id;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this BranchDetails to JSON.
     * @function toJSON
     * @memberof BranchDetails
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BranchDetails.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BranchDetails;
})();

export const KVPair = $root.KVPair = (() => {

    /**
     * Properties of a KVPair.
     * @exports IKVPair
     * @interface IKVPair
     * @property {string|null} [key] KVPair key
     * @property {Uint8Array|null} [value] KVPair value
     */

    /**
     * Constructs a new KVPair.
     * @exports KVPair
     * @classdesc Represents a KVPair.
     * @implements IKVPair
     * @constructor
     * @param {IKVPair=} [properties] Properties to set
     */
    function KVPair(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * KVPair key.
     * @member {string} key
     * @memberof KVPair
     * @instance
     */
    KVPair.prototype.key = "";

    /**
     * KVPair value.
     * @member {Uint8Array} value
     * @memberof KVPair
     * @instance
     */
    KVPair.prototype.value = $util.newBuffer([]);

    /**
     * Creates a new KVPair instance using the specified properties.
     * @function create
     * @memberof KVPair
     * @static
     * @param {IKVPair=} [properties] Properties to set
     * @returns {KVPair} KVPair instance
     */
    KVPair.create = function create(properties) {
        return new KVPair(properties);
    };

    /**
     * Encodes the specified KVPair message. Does not implicitly {@link KVPair.verify|verify} messages.
     * @function encode
     * @memberof KVPair
     * @static
     * @param {IKVPair} message KVPair message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KVPair.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && message.hasOwnProperty("key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
        return writer;
    };

    /**
     * Encodes the specified KVPair message, length delimited. Does not implicitly {@link KVPair.verify|verify} messages.
     * @function encodeDelimited
     * @memberof KVPair
     * @static
     * @param {IKVPair} message KVPair message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KVPair.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a KVPair message from the specified reader or buffer.
     * @function decode
     * @memberof KVPair
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {KVPair} KVPair
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KVPair.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.KVPair();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key = reader.string();
                break;
            case 2:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a KVPair message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof KVPair
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {KVPair} KVPair
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KVPair.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a KVPair message.
     * @function verify
     * @memberof KVPair
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    KVPair.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        return null;
    };

    /**
     * Creates a KVPair message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof KVPair
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {KVPair} KVPair
     */
    KVPair.fromObject = function fromObject(object) {
        if (object instanceof $root.KVPair)
            return object;
        let message = new $root.KVPair();
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    /**
     * Creates a plain object from a KVPair message. Also converts values to other types if specified.
     * @function toObject
     * @memberof KVPair
     * @static
     * @param {KVPair} message KVPair
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    KVPair.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.key = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    /**
     * Converts this KVPair to JSON.
     * @function toJSON
     * @memberof KVPair
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    KVPair.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KVPair;
})();

export const DynamicConfiguration = $root.DynamicConfiguration = (() => {

    /**
     * Properties of a DynamicConfiguration.
     * @exports IDynamicConfiguration
     * @interface IDynamicConfiguration
     * @property {DynamicConfiguration.ICore|null} [core] DynamicConfiguration core
     * @property {Uint8Array|null} [value] DynamicConfiguration value
     * @property {DynamicConfiguration.IExceptions|null} [exceptions] DynamicConfiguration exceptions
     */

    /**
     * Constructs a new DynamicConfiguration.
     * @exports DynamicConfiguration
     * @classdesc Represents a DynamicConfiguration.
     * @implements IDynamicConfiguration
     * @constructor
     * @param {IDynamicConfiguration=} [properties] Properties to set
     */
    function DynamicConfiguration(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DynamicConfiguration core.
     * @member {DynamicConfiguration.ICore|null|undefined} core
     * @memberof DynamicConfiguration
     * @instance
     */
    DynamicConfiguration.prototype.core = null;

    /**
     * DynamicConfiguration value.
     * @member {Uint8Array} value
     * @memberof DynamicConfiguration
     * @instance
     */
    DynamicConfiguration.prototype.value = $util.newBuffer([]);

    /**
     * DynamicConfiguration exceptions.
     * @member {DynamicConfiguration.IExceptions|null|undefined} exceptions
     * @memberof DynamicConfiguration
     * @instance
     */
    DynamicConfiguration.prototype.exceptions = null;

    /**
     * Creates a new DynamicConfiguration instance using the specified properties.
     * @function create
     * @memberof DynamicConfiguration
     * @static
     * @param {IDynamicConfiguration=} [properties] Properties to set
     * @returns {DynamicConfiguration} DynamicConfiguration instance
     */
    DynamicConfiguration.create = function create(properties) {
        return new DynamicConfiguration(properties);
    };

    /**
     * Encodes the specified DynamicConfiguration message. Does not implicitly {@link DynamicConfiguration.verify|verify} messages.
     * @function encode
     * @memberof DynamicConfiguration
     * @static
     * @param {IDynamicConfiguration} message DynamicConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DynamicConfiguration.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.core != null && message.hasOwnProperty("core"))
            $root.DynamicConfiguration.Core.encode(message.core, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
        if (message.exceptions != null && message.hasOwnProperty("exceptions"))
            $root.DynamicConfiguration.Exceptions.encode(message.exceptions, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DynamicConfiguration message, length delimited. Does not implicitly {@link DynamicConfiguration.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DynamicConfiguration
     * @static
     * @param {IDynamicConfiguration} message DynamicConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DynamicConfiguration.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DynamicConfiguration message from the specified reader or buffer.
     * @function decode
     * @memberof DynamicConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DynamicConfiguration} DynamicConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DynamicConfiguration.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.core = $root.DynamicConfiguration.Core.decode(reader, reader.uint32());
                break;
            case 2:
                message.value = reader.bytes();
                break;
            case 3:
                message.exceptions = $root.DynamicConfiguration.Exceptions.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DynamicConfiguration message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DynamicConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DynamicConfiguration} DynamicConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DynamicConfiguration.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DynamicConfiguration message.
     * @function verify
     * @memberof DynamicConfiguration
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DynamicConfiguration.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.core != null && message.hasOwnProperty("core")) {
            let error = $root.DynamicConfiguration.Core.verify(message.core);
            if (error)
                return "core." + error;
        }
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.exceptions != null && message.hasOwnProperty("exceptions")) {
            let error = $root.DynamicConfiguration.Exceptions.verify(message.exceptions);
            if (error)
                return "exceptions." + error;
        }
        return null;
    };

    /**
     * Creates a DynamicConfiguration message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DynamicConfiguration
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DynamicConfiguration} DynamicConfiguration
     */
    DynamicConfiguration.fromObject = function fromObject(object) {
        if (object instanceof $root.DynamicConfiguration)
            return object;
        let message = new $root.DynamicConfiguration();
        if (object.core != null) {
            if (typeof object.core !== "object")
                throw TypeError(".DynamicConfiguration.core: object expected");
            message.core = $root.DynamicConfiguration.Core.fromObject(object.core);
        }
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.exceptions != null) {
            if (typeof object.exceptions !== "object")
                throw TypeError(".DynamicConfiguration.exceptions: object expected");
            message.exceptions = $root.DynamicConfiguration.Exceptions.fromObject(object.exceptions);
        }
        return message;
    };

    /**
     * Creates a plain object from a DynamicConfiguration message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DynamicConfiguration
     * @static
     * @param {DynamicConfiguration} message DynamicConfiguration
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DynamicConfiguration.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.core = null;
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            object.exceptions = null;
        }
        if (message.core != null && message.hasOwnProperty("core"))
            object.core = $root.DynamicConfiguration.Core.toObject(message.core, options);
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.exceptions != null && message.hasOwnProperty("exceptions"))
            object.exceptions = $root.DynamicConfiguration.Exceptions.toObject(message.exceptions, options);
        return object;
    };

    /**
     * Converts this DynamicConfiguration to JSON.
     * @function toJSON
     * @memberof DynamicConfiguration
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DynamicConfiguration.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    DynamicConfiguration.Namespace = (function() {

        /**
         * Properties of a Namespace.
         * @memberof DynamicConfiguration
         * @interface INamespace
         */

        /**
         * Constructs a new Namespace.
         * @memberof DynamicConfiguration
         * @classdesc Represents a Namespace.
         * @implements INamespace
         * @constructor
         * @param {DynamicConfiguration.INamespace=} [properties] Properties to set
         */
        function Namespace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Namespace instance using the specified properties.
         * @function create
         * @memberof DynamicConfiguration.Namespace
         * @static
         * @param {DynamicConfiguration.INamespace=} [properties] Properties to set
         * @returns {DynamicConfiguration.Namespace} Namespace instance
         */
        Namespace.create = function create(properties) {
            return new Namespace(properties);
        };

        /**
         * Encodes the specified Namespace message. Does not implicitly {@link DynamicConfiguration.Namespace.verify|verify} messages.
         * @function encode
         * @memberof DynamicConfiguration.Namespace
         * @static
         * @param {DynamicConfiguration.INamespace} message Namespace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Namespace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Namespace message, length delimited. Does not implicitly {@link DynamicConfiguration.Namespace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof DynamicConfiguration.Namespace
         * @static
         * @param {DynamicConfiguration.INamespace} message Namespace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Namespace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Namespace message from the specified reader or buffer.
         * @function decode
         * @memberof DynamicConfiguration.Namespace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {DynamicConfiguration.Namespace} Namespace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Namespace.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.Namespace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Namespace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof DynamicConfiguration.Namespace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {DynamicConfiguration.Namespace} Namespace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Namespace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Namespace message.
         * @function verify
         * @memberof DynamicConfiguration.Namespace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Namespace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Namespace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof DynamicConfiguration.Namespace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {DynamicConfiguration.Namespace} Namespace
         */
        Namespace.fromObject = function fromObject(object) {
            if (object instanceof $root.DynamicConfiguration.Namespace)
                return object;
            return new $root.DynamicConfiguration.Namespace();
        };

        /**
         * Creates a plain object from a Namespace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof DynamicConfiguration.Namespace
         * @static
         * @param {DynamicConfiguration.Namespace} message Namespace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Namespace.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Namespace to JSON.
         * @function toJSON
         * @memberof DynamicConfiguration.Namespace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Namespace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name DynamicConfiguration.Namespace.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} PUBLIC=1 PUBLIC value
         * @property {number} PRIVATE=2 PRIVATE value
         * @property {number} XP=3 XP value
         */
        Namespace.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "PUBLIC"] = 1;
            values[valuesById[2] = "PRIVATE"] = 2;
            values[valuesById[3] = "XP"] = 3;
            return values;
        })();

        return Namespace;
    })();

    DynamicConfiguration.ValueType = (function() {

        /**
         * Properties of a ValueType.
         * @memberof DynamicConfiguration
         * @interface IValueType
         */

        /**
         * Constructs a new ValueType.
         * @memberof DynamicConfiguration
         * @classdesc Represents a ValueType.
         * @implements IValueType
         * @constructor
         * @param {DynamicConfiguration.IValueType=} [properties] Properties to set
         */
        function ValueType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ValueType instance using the specified properties.
         * @function create
         * @memberof DynamicConfiguration.ValueType
         * @static
         * @param {DynamicConfiguration.IValueType=} [properties] Properties to set
         * @returns {DynamicConfiguration.ValueType} ValueType instance
         */
        ValueType.create = function create(properties) {
            return new ValueType(properties);
        };

        /**
         * Encodes the specified ValueType message. Does not implicitly {@link DynamicConfiguration.ValueType.verify|verify} messages.
         * @function encode
         * @memberof DynamicConfiguration.ValueType
         * @static
         * @param {DynamicConfiguration.IValueType} message ValueType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValueType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ValueType message, length delimited. Does not implicitly {@link DynamicConfiguration.ValueType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof DynamicConfiguration.ValueType
         * @static
         * @param {DynamicConfiguration.IValueType} message ValueType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValueType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ValueType message from the specified reader or buffer.
         * @function decode
         * @memberof DynamicConfiguration.ValueType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {DynamicConfiguration.ValueType} ValueType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValueType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.ValueType();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ValueType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof DynamicConfiguration.ValueType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {DynamicConfiguration.ValueType} ValueType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValueType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ValueType message.
         * @function verify
         * @memberof DynamicConfiguration.ValueType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ValueType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ValueType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof DynamicConfiguration.ValueType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {DynamicConfiguration.ValueType} ValueType
         */
        ValueType.fromObject = function fromObject(object) {
            if (object instanceof $root.DynamicConfiguration.ValueType)
                return object;
            return new $root.DynamicConfiguration.ValueType();
        };

        /**
         * Creates a plain object from a ValueType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof DynamicConfiguration.ValueType
         * @static
         * @param {DynamicConfiguration.ValueType} message ValueType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValueType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ValueType to JSON.
         * @function toJSON
         * @memberof DynamicConfiguration.ValueType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValueType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name DynamicConfiguration.ValueType.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} BOOL=1 BOOL value
         * @property {number} STRING=2 STRING value
         * @property {number} INT64=3 INT64 value
         * @property {number} FLOAT64=4 FLOAT64 value
         * @property {number} JSON=5 JSON value
         */
        ValueType.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "BOOL"] = 1;
            values[valuesById[2] = "STRING"] = 2;
            values[valuesById[3] = "INT64"] = 3;
            values[valuesById[4] = "FLOAT64"] = 4;
            values[valuesById[5] = "JSON"] = 5;
            return values;
        })();

        return ValueType;
    })();

    DynamicConfiguration.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof DynamicConfiguration
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof DynamicConfiguration
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {DynamicConfiguration.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof DynamicConfiguration.Status
         * @static
         * @param {DynamicConfiguration.IStatus=} [properties] Properties to set
         * @returns {DynamicConfiguration.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link DynamicConfiguration.Status.verify|verify} messages.
         * @function encode
         * @memberof DynamicConfiguration.Status
         * @static
         * @param {DynamicConfiguration.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link DynamicConfiguration.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof DynamicConfiguration.Status
         * @static
         * @param {DynamicConfiguration.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof DynamicConfiguration.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {DynamicConfiguration.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof DynamicConfiguration.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {DynamicConfiguration.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof DynamicConfiguration.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof DynamicConfiguration.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {DynamicConfiguration.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.DynamicConfiguration.Status)
                return object;
            return new $root.DynamicConfiguration.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof DynamicConfiguration.Status
         * @static
         * @param {DynamicConfiguration.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof DynamicConfiguration.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name DynamicConfiguration.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} ENABLED=1 ENABLED value
         * @property {number} DISABLED=2 DISABLED value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "ENABLED"] = 1;
            values[valuesById[2] = "DISABLED"] = 2;
            return values;
        })();

        return Status;
    })();

    DynamicConfiguration.Core = (function() {

        /**
         * Properties of a Core.
         * @memberof DynamicConfiguration
         * @interface ICore
         * @property {string|null} [key] Core key
         * @property {DynamicConfiguration.Namespace.Enum|null} [namespace] Core namespace
         * @property {DynamicConfiguration.ValueType.Enum|null} [expected_value_type] Core expected_value_type
         * @property {DynamicConfiguration.Status.Enum|null} [status] Core status
         * @property {string|null} [revised_by_admin_id] Core revised_by_admin_id
         * @property {string|null} [revision_note] Core revision_note
         * @property {google.protobuf.ITimestamp|null} [created_at] Core created_at
         */

        /**
         * Constructs a new Core.
         * @memberof DynamicConfiguration
         * @classdesc Represents a Core.
         * @implements ICore
         * @constructor
         * @param {DynamicConfiguration.ICore=} [properties] Properties to set
         */
        function Core(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Core key.
         * @member {string} key
         * @memberof DynamicConfiguration.Core
         * @instance
         */
        Core.prototype.key = "";

        /**
         * Core namespace.
         * @member {DynamicConfiguration.Namespace.Enum} namespace
         * @memberof DynamicConfiguration.Core
         * @instance
         */
        Core.prototype.namespace = 0;

        /**
         * Core expected_value_type.
         * @member {DynamicConfiguration.ValueType.Enum} expected_value_type
         * @memberof DynamicConfiguration.Core
         * @instance
         */
        Core.prototype.expected_value_type = 0;

        /**
         * Core status.
         * @member {DynamicConfiguration.Status.Enum} status
         * @memberof DynamicConfiguration.Core
         * @instance
         */
        Core.prototype.status = 0;

        /**
         * Core revised_by_admin_id.
         * @member {string} revised_by_admin_id
         * @memberof DynamicConfiguration.Core
         * @instance
         */
        Core.prototype.revised_by_admin_id = "";

        /**
         * Core revision_note.
         * @member {string} revision_note
         * @memberof DynamicConfiguration.Core
         * @instance
         */
        Core.prototype.revision_note = "";

        /**
         * Core created_at.
         * @member {google.protobuf.ITimestamp|null|undefined} created_at
         * @memberof DynamicConfiguration.Core
         * @instance
         */
        Core.prototype.created_at = null;

        /**
         * Creates a new Core instance using the specified properties.
         * @function create
         * @memberof DynamicConfiguration.Core
         * @static
         * @param {DynamicConfiguration.ICore=} [properties] Properties to set
         * @returns {DynamicConfiguration.Core} Core instance
         */
        Core.create = function create(properties) {
            return new Core(properties);
        };

        /**
         * Encodes the specified Core message. Does not implicitly {@link DynamicConfiguration.Core.verify|verify} messages.
         * @function encode
         * @memberof DynamicConfiguration.Core
         * @static
         * @param {DynamicConfiguration.ICore} message Core message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Core.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && message.hasOwnProperty("key"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.namespace);
            if (message.expected_value_type != null && message.hasOwnProperty("expected_value_type"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.expected_value_type);
            if (message.status != null && message.hasOwnProperty("status"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
            if (message.revised_by_admin_id != null && message.hasOwnProperty("revised_by_admin_id"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.revised_by_admin_id);
            if (message.revision_note != null && message.hasOwnProperty("revision_note"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.revision_note);
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Core message, length delimited. Does not implicitly {@link DynamicConfiguration.Core.verify|verify} messages.
         * @function encodeDelimited
         * @memberof DynamicConfiguration.Core
         * @static
         * @param {DynamicConfiguration.ICore} message Core message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Core.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Core message from the specified reader or buffer.
         * @function decode
         * @memberof DynamicConfiguration.Core
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {DynamicConfiguration.Core} Core
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Core.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.Core();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.namespace = reader.int32();
                    break;
                case 3:
                    message.expected_value_type = reader.int32();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.revised_by_admin_id = reader.string();
                    break;
                case 6:
                    message.revision_note = reader.string();
                    break;
                case 98:
                    message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Core message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof DynamicConfiguration.Core
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {DynamicConfiguration.Core} Core
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Core.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Core message.
         * @function verify
         * @memberof DynamicConfiguration.Core
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Core.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                switch (message.namespace) {
                default:
                    return "namespace: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.expected_value_type != null && message.hasOwnProperty("expected_value_type"))
                switch (message.expected_value_type) {
                default:
                    return "expected_value_type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.revised_by_admin_id != null && message.hasOwnProperty("revised_by_admin_id"))
                if (!$util.isString(message.revised_by_admin_id))
                    return "revised_by_admin_id: string expected";
            if (message.revision_note != null && message.hasOwnProperty("revision_note"))
                if (!$util.isString(message.revision_note))
                    return "revision_note: string expected";
            if (message.created_at != null && message.hasOwnProperty("created_at")) {
                let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                if (error)
                    return "created_at." + error;
            }
            return null;
        };

        /**
         * Creates a Core message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof DynamicConfiguration.Core
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {DynamicConfiguration.Core} Core
         */
        Core.fromObject = function fromObject(object) {
            if (object instanceof $root.DynamicConfiguration.Core)
                return object;
            let message = new $root.DynamicConfiguration.Core();
            if (object.key != null)
                message.key = String(object.key);
            switch (object.namespace) {
            case "UNKNOWN":
            case 0:
                message.namespace = 0;
                break;
            case "PUBLIC":
            case 1:
                message.namespace = 1;
                break;
            case "PRIVATE":
            case 2:
                message.namespace = 2;
                break;
            case "XP":
            case 3:
                message.namespace = 3;
                break;
            }
            switch (object.expected_value_type) {
            case "UNKNOWN":
            case 0:
                message.expected_value_type = 0;
                break;
            case "BOOL":
            case 1:
                message.expected_value_type = 1;
                break;
            case "STRING":
            case 2:
                message.expected_value_type = 2;
                break;
            case "INT64":
            case 3:
                message.expected_value_type = 3;
                break;
            case "FLOAT64":
            case 4:
                message.expected_value_type = 4;
                break;
            case "JSON":
            case 5:
                message.expected_value_type = 5;
                break;
            }
            switch (object.status) {
            case "UNKNOWN":
            case 0:
                message.status = 0;
                break;
            case "ENABLED":
            case 1:
                message.status = 1;
                break;
            case "DISABLED":
            case 2:
                message.status = 2;
                break;
            }
            if (object.revised_by_admin_id != null)
                message.revised_by_admin_id = String(object.revised_by_admin_id);
            if (object.revision_note != null)
                message.revision_note = String(object.revision_note);
            if (object.created_at != null) {
                if (typeof object.created_at !== "object")
                    throw TypeError(".DynamicConfiguration.Core.created_at: object expected");
                message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
            }
            return message;
        };

        /**
         * Creates a plain object from a Core message. Also converts values to other types if specified.
         * @function toObject
         * @memberof DynamicConfiguration.Core
         * @static
         * @param {DynamicConfiguration.Core} message Core
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Core.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.key = "";
                object.namespace = options.enums === String ? "UNKNOWN" : 0;
                object.expected_value_type = options.enums === String ? "UNKNOWN" : 0;
                object.status = options.enums === String ? "UNKNOWN" : 0;
                object.revised_by_admin_id = "";
                object.revision_note = "";
                object.created_at = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                object.namespace = options.enums === String ? $root.DynamicConfiguration.Namespace.Enum[message.namespace] : message.namespace;
            if (message.expected_value_type != null && message.hasOwnProperty("expected_value_type"))
                object.expected_value_type = options.enums === String ? $root.DynamicConfiguration.ValueType.Enum[message.expected_value_type] : message.expected_value_type;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.DynamicConfiguration.Status.Enum[message.status] : message.status;
            if (message.revised_by_admin_id != null && message.hasOwnProperty("revised_by_admin_id"))
                object.revised_by_admin_id = message.revised_by_admin_id;
            if (message.revision_note != null && message.hasOwnProperty("revision_note"))
                object.revision_note = message.revision_note;
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
            return object;
        };

        /**
         * Converts this Core to JSON.
         * @function toJSON
         * @memberof DynamicConfiguration.Core
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Core.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Core;
    })();

    DynamicConfiguration.Exceptions = (function() {

        /**
         * Properties of an Exceptions.
         * @memberof DynamicConfiguration
         * @interface IExceptions
         * @property {Array.<DynamicConfiguration.Exceptions.IContactIdIn>|null} [contact_id_in_exceptions] Exceptions contact_id_in_exceptions
         * @property {Array.<DynamicConfiguration.Exceptions.IAppVersionGreaterThanOrEqualTo>|null} [app_version_greater_than_or_equal_to_exceptions] Exceptions app_version_greater_than_or_equal_to_exceptions
         * @property {Array.<DynamicConfiguration.Exceptions.IPlatformException>|null} [platform_exceptions] Exceptions platform_exceptions
         */

        /**
         * Constructs a new Exceptions.
         * @memberof DynamicConfiguration
         * @classdesc Represents an Exceptions.
         * @implements IExceptions
         * @constructor
         * @param {DynamicConfiguration.IExceptions=} [properties] Properties to set
         */
        function Exceptions(properties) {
            this.contact_id_in_exceptions = [];
            this.app_version_greater_than_or_equal_to_exceptions = [];
            this.platform_exceptions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Exceptions contact_id_in_exceptions.
         * @member {Array.<DynamicConfiguration.Exceptions.IContactIdIn>} contact_id_in_exceptions
         * @memberof DynamicConfiguration.Exceptions
         * @instance
         */
        Exceptions.prototype.contact_id_in_exceptions = $util.emptyArray;

        /**
         * Exceptions app_version_greater_than_or_equal_to_exceptions.
         * @member {Array.<DynamicConfiguration.Exceptions.IAppVersionGreaterThanOrEqualTo>} app_version_greater_than_or_equal_to_exceptions
         * @memberof DynamicConfiguration.Exceptions
         * @instance
         */
        Exceptions.prototype.app_version_greater_than_or_equal_to_exceptions = $util.emptyArray;

        /**
         * Exceptions platform_exceptions.
         * @member {Array.<DynamicConfiguration.Exceptions.IPlatformException>} platform_exceptions
         * @memberof DynamicConfiguration.Exceptions
         * @instance
         */
        Exceptions.prototype.platform_exceptions = $util.emptyArray;

        /**
         * Creates a new Exceptions instance using the specified properties.
         * @function create
         * @memberof DynamicConfiguration.Exceptions
         * @static
         * @param {DynamicConfiguration.IExceptions=} [properties] Properties to set
         * @returns {DynamicConfiguration.Exceptions} Exceptions instance
         */
        Exceptions.create = function create(properties) {
            return new Exceptions(properties);
        };

        /**
         * Encodes the specified Exceptions message. Does not implicitly {@link DynamicConfiguration.Exceptions.verify|verify} messages.
         * @function encode
         * @memberof DynamicConfiguration.Exceptions
         * @static
         * @param {DynamicConfiguration.IExceptions} message Exceptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Exceptions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.contact_id_in_exceptions != null && message.contact_id_in_exceptions.length)
                for (let i = 0; i < message.contact_id_in_exceptions.length; ++i)
                    $root.DynamicConfiguration.Exceptions.ContactIdIn.encode(message.contact_id_in_exceptions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.app_version_greater_than_or_equal_to_exceptions != null && message.app_version_greater_than_or_equal_to_exceptions.length)
                for (let i = 0; i < message.app_version_greater_than_or_equal_to_exceptions.length; ++i)
                    $root.DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo.encode(message.app_version_greater_than_or_equal_to_exceptions[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.platform_exceptions != null && message.platform_exceptions.length)
                for (let i = 0; i < message.platform_exceptions.length; ++i)
                    $root.DynamicConfiguration.Exceptions.PlatformException.encode(message.platform_exceptions[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Exceptions message, length delimited. Does not implicitly {@link DynamicConfiguration.Exceptions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof DynamicConfiguration.Exceptions
         * @static
         * @param {DynamicConfiguration.IExceptions} message Exceptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Exceptions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Exceptions message from the specified reader or buffer.
         * @function decode
         * @memberof DynamicConfiguration.Exceptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {DynamicConfiguration.Exceptions} Exceptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Exceptions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.Exceptions();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.contact_id_in_exceptions && message.contact_id_in_exceptions.length))
                        message.contact_id_in_exceptions = [];
                    message.contact_id_in_exceptions.push($root.DynamicConfiguration.Exceptions.ContactIdIn.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.app_version_greater_than_or_equal_to_exceptions && message.app_version_greater_than_or_equal_to_exceptions.length))
                        message.app_version_greater_than_or_equal_to_exceptions = [];
                    message.app_version_greater_than_or_equal_to_exceptions.push($root.DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.platform_exceptions && message.platform_exceptions.length))
                        message.platform_exceptions = [];
                    message.platform_exceptions.push($root.DynamicConfiguration.Exceptions.PlatformException.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Exceptions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof DynamicConfiguration.Exceptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {DynamicConfiguration.Exceptions} Exceptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Exceptions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Exceptions message.
         * @function verify
         * @memberof DynamicConfiguration.Exceptions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Exceptions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.contact_id_in_exceptions != null && message.hasOwnProperty("contact_id_in_exceptions")) {
                if (!Array.isArray(message.contact_id_in_exceptions))
                    return "contact_id_in_exceptions: array expected";
                for (let i = 0; i < message.contact_id_in_exceptions.length; ++i) {
                    let error = $root.DynamicConfiguration.Exceptions.ContactIdIn.verify(message.contact_id_in_exceptions[i]);
                    if (error)
                        return "contact_id_in_exceptions." + error;
                }
            }
            if (message.app_version_greater_than_or_equal_to_exceptions != null && message.hasOwnProperty("app_version_greater_than_or_equal_to_exceptions")) {
                if (!Array.isArray(message.app_version_greater_than_or_equal_to_exceptions))
                    return "app_version_greater_than_or_equal_to_exceptions: array expected";
                for (let i = 0; i < message.app_version_greater_than_or_equal_to_exceptions.length; ++i) {
                    let error = $root.DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo.verify(message.app_version_greater_than_or_equal_to_exceptions[i]);
                    if (error)
                        return "app_version_greater_than_or_equal_to_exceptions." + error;
                }
            }
            if (message.platform_exceptions != null && message.hasOwnProperty("platform_exceptions")) {
                if (!Array.isArray(message.platform_exceptions))
                    return "platform_exceptions: array expected";
                for (let i = 0; i < message.platform_exceptions.length; ++i) {
                    let error = $root.DynamicConfiguration.Exceptions.PlatformException.verify(message.platform_exceptions[i]);
                    if (error)
                        return "platform_exceptions." + error;
                }
            }
            return null;
        };

        /**
         * Creates an Exceptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof DynamicConfiguration.Exceptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {DynamicConfiguration.Exceptions} Exceptions
         */
        Exceptions.fromObject = function fromObject(object) {
            if (object instanceof $root.DynamicConfiguration.Exceptions)
                return object;
            let message = new $root.DynamicConfiguration.Exceptions();
            if (object.contact_id_in_exceptions) {
                if (!Array.isArray(object.contact_id_in_exceptions))
                    throw TypeError(".DynamicConfiguration.Exceptions.contact_id_in_exceptions: array expected");
                message.contact_id_in_exceptions = [];
                for (let i = 0; i < object.contact_id_in_exceptions.length; ++i) {
                    if (typeof object.contact_id_in_exceptions[i] !== "object")
                        throw TypeError(".DynamicConfiguration.Exceptions.contact_id_in_exceptions: object expected");
                    message.contact_id_in_exceptions[i] = $root.DynamicConfiguration.Exceptions.ContactIdIn.fromObject(object.contact_id_in_exceptions[i]);
                }
            }
            if (object.app_version_greater_than_or_equal_to_exceptions) {
                if (!Array.isArray(object.app_version_greater_than_or_equal_to_exceptions))
                    throw TypeError(".DynamicConfiguration.Exceptions.app_version_greater_than_or_equal_to_exceptions: array expected");
                message.app_version_greater_than_or_equal_to_exceptions = [];
                for (let i = 0; i < object.app_version_greater_than_or_equal_to_exceptions.length; ++i) {
                    if (typeof object.app_version_greater_than_or_equal_to_exceptions[i] !== "object")
                        throw TypeError(".DynamicConfiguration.Exceptions.app_version_greater_than_or_equal_to_exceptions: object expected");
                    message.app_version_greater_than_or_equal_to_exceptions[i] = $root.DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo.fromObject(object.app_version_greater_than_or_equal_to_exceptions[i]);
                }
            }
            if (object.platform_exceptions) {
                if (!Array.isArray(object.platform_exceptions))
                    throw TypeError(".DynamicConfiguration.Exceptions.platform_exceptions: array expected");
                message.platform_exceptions = [];
                for (let i = 0; i < object.platform_exceptions.length; ++i) {
                    if (typeof object.platform_exceptions[i] !== "object")
                        throw TypeError(".DynamicConfiguration.Exceptions.platform_exceptions: object expected");
                    message.platform_exceptions[i] = $root.DynamicConfiguration.Exceptions.PlatformException.fromObject(object.platform_exceptions[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an Exceptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof DynamicConfiguration.Exceptions
         * @static
         * @param {DynamicConfiguration.Exceptions} message Exceptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Exceptions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.contact_id_in_exceptions = [];
                object.app_version_greater_than_or_equal_to_exceptions = [];
                object.platform_exceptions = [];
            }
            if (message.contact_id_in_exceptions && message.contact_id_in_exceptions.length) {
                object.contact_id_in_exceptions = [];
                for (let j = 0; j < message.contact_id_in_exceptions.length; ++j)
                    object.contact_id_in_exceptions[j] = $root.DynamicConfiguration.Exceptions.ContactIdIn.toObject(message.contact_id_in_exceptions[j], options);
            }
            if (message.app_version_greater_than_or_equal_to_exceptions && message.app_version_greater_than_or_equal_to_exceptions.length) {
                object.app_version_greater_than_or_equal_to_exceptions = [];
                for (let j = 0; j < message.app_version_greater_than_or_equal_to_exceptions.length; ++j)
                    object.app_version_greater_than_or_equal_to_exceptions[j] = $root.DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo.toObject(message.app_version_greater_than_or_equal_to_exceptions[j], options);
            }
            if (message.platform_exceptions && message.platform_exceptions.length) {
                object.platform_exceptions = [];
                for (let j = 0; j < message.platform_exceptions.length; ++j)
                    object.platform_exceptions[j] = $root.DynamicConfiguration.Exceptions.PlatformException.toObject(message.platform_exceptions[j], options);
            }
            return object;
        };

        /**
         * Converts this Exceptions to JSON.
         * @function toJSON
         * @memberof DynamicConfiguration.Exceptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Exceptions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Exceptions.Status = (function() {

            /**
             * Properties of a Status.
             * @memberof DynamicConfiguration.Exceptions
             * @interface IStatus
             */

            /**
             * Constructs a new Status.
             * @memberof DynamicConfiguration.Exceptions
             * @classdesc Represents a Status.
             * @implements IStatus
             * @constructor
             * @param {DynamicConfiguration.Exceptions.IStatus=} [properties] Properties to set
             */
            function Status(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Status instance using the specified properties.
             * @function create
             * @memberof DynamicConfiguration.Exceptions.Status
             * @static
             * @param {DynamicConfiguration.Exceptions.IStatus=} [properties] Properties to set
             * @returns {DynamicConfiguration.Exceptions.Status} Status instance
             */
            Status.create = function create(properties) {
                return new Status(properties);
            };

            /**
             * Encodes the specified Status message. Does not implicitly {@link DynamicConfiguration.Exceptions.Status.verify|verify} messages.
             * @function encode
             * @memberof DynamicConfiguration.Exceptions.Status
             * @static
             * @param {DynamicConfiguration.Exceptions.IStatus} message Status message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Status.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Status message, length delimited. Does not implicitly {@link DynamicConfiguration.Exceptions.Status.verify|verify} messages.
             * @function encodeDelimited
             * @memberof DynamicConfiguration.Exceptions.Status
             * @static
             * @param {DynamicConfiguration.Exceptions.IStatus} message Status message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Status.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Status message from the specified reader or buffer.
             * @function decode
             * @memberof DynamicConfiguration.Exceptions.Status
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {DynamicConfiguration.Exceptions.Status} Status
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Status.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.Exceptions.Status();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Status message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof DynamicConfiguration.Exceptions.Status
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {DynamicConfiguration.Exceptions.Status} Status
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Status.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Status message.
             * @function verify
             * @memberof DynamicConfiguration.Exceptions.Status
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Status.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Status message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof DynamicConfiguration.Exceptions.Status
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {DynamicConfiguration.Exceptions.Status} Status
             */
            Status.fromObject = function fromObject(object) {
                if (object instanceof $root.DynamicConfiguration.Exceptions.Status)
                    return object;
                return new $root.DynamicConfiguration.Exceptions.Status();
            };

            /**
             * Creates a plain object from a Status message. Also converts values to other types if specified.
             * @function toObject
             * @memberof DynamicConfiguration.Exceptions.Status
             * @static
             * @param {DynamicConfiguration.Exceptions.Status} message Status
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Status.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Status to JSON.
             * @function toJSON
             * @memberof DynamicConfiguration.Exceptions.Status
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Status.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name DynamicConfiguration.Exceptions.Status.Enum
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} ENABLED=1 ENABLED value
             * @property {number} DISABLED=2 DISABLED value
             */
            Status.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "ENABLED"] = 1;
                values[valuesById[2] = "DISABLED"] = 2;
                return values;
            })();

            return Status;
        })();

        Exceptions.ContactIdIn = (function() {

            /**
             * Properties of a ContactIdIn.
             * @memberof DynamicConfiguration.Exceptions
             * @interface IContactIdIn
             * @property {string|null} [id] ContactIdIn id
             * @property {Array.<string>|null} [contact_ids] ContactIdIn contact_ids
             * @property {Uint8Array|null} [override_value] ContactIdIn override_value
             * @property {DynamicConfiguration.Exceptions.Status.Enum|null} [status] ContactIdIn status
             * @property {number|null} [priority] ContactIdIn priority
             * @property {google.protobuf.ITimestamp|null} [created_at] ContactIdIn created_at
             */

            /**
             * Constructs a new ContactIdIn.
             * @memberof DynamicConfiguration.Exceptions
             * @classdesc Represents a ContactIdIn.
             * @implements IContactIdIn
             * @constructor
             * @param {DynamicConfiguration.Exceptions.IContactIdIn=} [properties] Properties to set
             */
            function ContactIdIn(properties) {
                this.contact_ids = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ContactIdIn id.
             * @member {string} id
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @instance
             */
            ContactIdIn.prototype.id = "";

            /**
             * ContactIdIn contact_ids.
             * @member {Array.<string>} contact_ids
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @instance
             */
            ContactIdIn.prototype.contact_ids = $util.emptyArray;

            /**
             * ContactIdIn override_value.
             * @member {Uint8Array} override_value
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @instance
             */
            ContactIdIn.prototype.override_value = $util.newBuffer([]);

            /**
             * ContactIdIn status.
             * @member {DynamicConfiguration.Exceptions.Status.Enum} status
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @instance
             */
            ContactIdIn.prototype.status = 0;

            /**
             * ContactIdIn priority.
             * @member {number} priority
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @instance
             */
            ContactIdIn.prototype.priority = 0;

            /**
             * ContactIdIn created_at.
             * @member {google.protobuf.ITimestamp|null|undefined} created_at
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @instance
             */
            ContactIdIn.prototype.created_at = null;

            /**
             * Creates a new ContactIdIn instance using the specified properties.
             * @function create
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @static
             * @param {DynamicConfiguration.Exceptions.IContactIdIn=} [properties] Properties to set
             * @returns {DynamicConfiguration.Exceptions.ContactIdIn} ContactIdIn instance
             */
            ContactIdIn.create = function create(properties) {
                return new ContactIdIn(properties);
            };

            /**
             * Encodes the specified ContactIdIn message. Does not implicitly {@link DynamicConfiguration.Exceptions.ContactIdIn.verify|verify} messages.
             * @function encode
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @static
             * @param {DynamicConfiguration.Exceptions.IContactIdIn} message ContactIdIn message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ContactIdIn.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && message.hasOwnProperty("id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.contact_ids != null && message.contact_ids.length)
                    for (let i = 0; i < message.contact_ids.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.contact_ids[i]);
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.override_value);
                if (message.status != null && message.hasOwnProperty("status"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
                if (message.priority != null && message.hasOwnProperty("priority"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.priority);
                if (message.created_at != null && message.hasOwnProperty("created_at"))
                    $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ContactIdIn message, length delimited. Does not implicitly {@link DynamicConfiguration.Exceptions.ContactIdIn.verify|verify} messages.
             * @function encodeDelimited
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @static
             * @param {DynamicConfiguration.Exceptions.IContactIdIn} message ContactIdIn message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ContactIdIn.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ContactIdIn message from the specified reader or buffer.
             * @function decode
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {DynamicConfiguration.Exceptions.ContactIdIn} ContactIdIn
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ContactIdIn.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.Exceptions.ContactIdIn();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        if (!(message.contact_ids && message.contact_ids.length))
                            message.contact_ids = [];
                        message.contact_ids.push(reader.string());
                        break;
                    case 3:
                        message.override_value = reader.bytes();
                        break;
                    case 4:
                        message.status = reader.int32();
                        break;
                    case 5:
                        message.priority = reader.int32();
                        break;
                    case 98:
                        message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ContactIdIn message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {DynamicConfiguration.Exceptions.ContactIdIn} ContactIdIn
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ContactIdIn.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ContactIdIn message.
             * @function verify
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ContactIdIn.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.contact_ids != null && message.hasOwnProperty("contact_ids")) {
                    if (!Array.isArray(message.contact_ids))
                        return "contact_ids: array expected";
                    for (let i = 0; i < message.contact_ids.length; ++i)
                        if (!$util.isString(message.contact_ids[i]))
                            return "contact_ids: string[] expected";
                }
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    if (!(message.override_value && typeof message.override_value.length === "number" || $util.isString(message.override_value)))
                        return "override_value: buffer expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.priority != null && message.hasOwnProperty("priority"))
                    if (!$util.isInteger(message.priority))
                        return "priority: integer expected";
                if (message.created_at != null && message.hasOwnProperty("created_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                    if (error)
                        return "created_at." + error;
                }
                return null;
            };

            /**
             * Creates a ContactIdIn message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {DynamicConfiguration.Exceptions.ContactIdIn} ContactIdIn
             */
            ContactIdIn.fromObject = function fromObject(object) {
                if (object instanceof $root.DynamicConfiguration.Exceptions.ContactIdIn)
                    return object;
                let message = new $root.DynamicConfiguration.Exceptions.ContactIdIn();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.contact_ids) {
                    if (!Array.isArray(object.contact_ids))
                        throw TypeError(".DynamicConfiguration.Exceptions.ContactIdIn.contact_ids: array expected");
                    message.contact_ids = [];
                    for (let i = 0; i < object.contact_ids.length; ++i)
                        message.contact_ids[i] = String(object.contact_ids[i]);
                }
                if (object.override_value != null)
                    if (typeof object.override_value === "string")
                        $util.base64.decode(object.override_value, message.override_value = $util.newBuffer($util.base64.length(object.override_value)), 0);
                    else if (object.override_value.length)
                        message.override_value = object.override_value;
                switch (object.status) {
                case "UNKNOWN":
                case 0:
                    message.status = 0;
                    break;
                case "ENABLED":
                case 1:
                    message.status = 1;
                    break;
                case "DISABLED":
                case 2:
                    message.status = 2;
                    break;
                }
                if (object.priority != null)
                    message.priority = object.priority | 0;
                if (object.created_at != null) {
                    if (typeof object.created_at !== "object")
                        throw TypeError(".DynamicConfiguration.Exceptions.ContactIdIn.created_at: object expected");
                    message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
                }
                return message;
            };

            /**
             * Creates a plain object from a ContactIdIn message. Also converts values to other types if specified.
             * @function toObject
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @static
             * @param {DynamicConfiguration.Exceptions.ContactIdIn} message ContactIdIn
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ContactIdIn.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.contact_ids = [];
                if (options.defaults) {
                    object.id = "";
                    if (options.bytes === String)
                        object.override_value = "";
                    else {
                        object.override_value = [];
                        if (options.bytes !== Array)
                            object.override_value = $util.newBuffer(object.override_value);
                    }
                    object.status = options.enums === String ? "UNKNOWN" : 0;
                    object.priority = 0;
                    object.created_at = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.contact_ids && message.contact_ids.length) {
                    object.contact_ids = [];
                    for (let j = 0; j < message.contact_ids.length; ++j)
                        object.contact_ids[j] = message.contact_ids[j];
                }
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    object.override_value = options.bytes === String ? $util.base64.encode(message.override_value, 0, message.override_value.length) : options.bytes === Array ? Array.prototype.slice.call(message.override_value) : message.override_value;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.DynamicConfiguration.Exceptions.Status.Enum[message.status] : message.status;
                if (message.priority != null && message.hasOwnProperty("priority"))
                    object.priority = message.priority;
                if (message.created_at != null && message.hasOwnProperty("created_at"))
                    object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
                return object;
            };

            /**
             * Converts this ContactIdIn to JSON.
             * @function toJSON
             * @memberof DynamicConfiguration.Exceptions.ContactIdIn
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ContactIdIn.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ContactIdIn;
        })();

        Exceptions.AppVersionGreaterThanOrEqualTo = (function() {

            /**
             * Properties of an AppVersionGreaterThanOrEqualTo.
             * @memberof DynamicConfiguration.Exceptions
             * @interface IAppVersionGreaterThanOrEqualTo
             * @property {string|null} [id] AppVersionGreaterThanOrEqualTo id
             * @property {string|null} [app_version] AppVersionGreaterThanOrEqualTo app_version
             * @property {Uint8Array|null} [override_value] AppVersionGreaterThanOrEqualTo override_value
             * @property {DynamicConfiguration.Exceptions.Status.Enum|null} [status] AppVersionGreaterThanOrEqualTo status
             * @property {number|null} [priority] AppVersionGreaterThanOrEqualTo priority
             * @property {google.protobuf.ITimestamp|null} [created_at] AppVersionGreaterThanOrEqualTo created_at
             */

            /**
             * Constructs a new AppVersionGreaterThanOrEqualTo.
             * @memberof DynamicConfiguration.Exceptions
             * @classdesc Represents an AppVersionGreaterThanOrEqualTo.
             * @implements IAppVersionGreaterThanOrEqualTo
             * @constructor
             * @param {DynamicConfiguration.Exceptions.IAppVersionGreaterThanOrEqualTo=} [properties] Properties to set
             */
            function AppVersionGreaterThanOrEqualTo(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppVersionGreaterThanOrEqualTo id.
             * @member {string} id
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @instance
             */
            AppVersionGreaterThanOrEqualTo.prototype.id = "";

            /**
             * AppVersionGreaterThanOrEqualTo app_version.
             * @member {string} app_version
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @instance
             */
            AppVersionGreaterThanOrEqualTo.prototype.app_version = "";

            /**
             * AppVersionGreaterThanOrEqualTo override_value.
             * @member {Uint8Array} override_value
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @instance
             */
            AppVersionGreaterThanOrEqualTo.prototype.override_value = $util.newBuffer([]);

            /**
             * AppVersionGreaterThanOrEqualTo status.
             * @member {DynamicConfiguration.Exceptions.Status.Enum} status
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @instance
             */
            AppVersionGreaterThanOrEqualTo.prototype.status = 0;

            /**
             * AppVersionGreaterThanOrEqualTo priority.
             * @member {number} priority
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @instance
             */
            AppVersionGreaterThanOrEqualTo.prototype.priority = 0;

            /**
             * AppVersionGreaterThanOrEqualTo created_at.
             * @member {google.protobuf.ITimestamp|null|undefined} created_at
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @instance
             */
            AppVersionGreaterThanOrEqualTo.prototype.created_at = null;

            /**
             * Creates a new AppVersionGreaterThanOrEqualTo instance using the specified properties.
             * @function create
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @static
             * @param {DynamicConfiguration.Exceptions.IAppVersionGreaterThanOrEqualTo=} [properties] Properties to set
             * @returns {DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo} AppVersionGreaterThanOrEqualTo instance
             */
            AppVersionGreaterThanOrEqualTo.create = function create(properties) {
                return new AppVersionGreaterThanOrEqualTo(properties);
            };

            /**
             * Encodes the specified AppVersionGreaterThanOrEqualTo message. Does not implicitly {@link DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo.verify|verify} messages.
             * @function encode
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @static
             * @param {DynamicConfiguration.Exceptions.IAppVersionGreaterThanOrEqualTo} message AppVersionGreaterThanOrEqualTo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppVersionGreaterThanOrEqualTo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && message.hasOwnProperty("id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.app_version != null && message.hasOwnProperty("app_version"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.app_version);
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.override_value);
                if (message.status != null && message.hasOwnProperty("status"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
                if (message.priority != null && message.hasOwnProperty("priority"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.priority);
                if (message.created_at != null && message.hasOwnProperty("created_at"))
                    $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppVersionGreaterThanOrEqualTo message, length delimited. Does not implicitly {@link DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @static
             * @param {DynamicConfiguration.Exceptions.IAppVersionGreaterThanOrEqualTo} message AppVersionGreaterThanOrEqualTo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppVersionGreaterThanOrEqualTo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppVersionGreaterThanOrEqualTo message from the specified reader or buffer.
             * @function decode
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo} AppVersionGreaterThanOrEqualTo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppVersionGreaterThanOrEqualTo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.app_version = reader.string();
                        break;
                    case 3:
                        message.override_value = reader.bytes();
                        break;
                    case 4:
                        message.status = reader.int32();
                        break;
                    case 5:
                        message.priority = reader.int32();
                        break;
                    case 98:
                        message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppVersionGreaterThanOrEqualTo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo} AppVersionGreaterThanOrEqualTo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppVersionGreaterThanOrEqualTo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppVersionGreaterThanOrEqualTo message.
             * @function verify
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppVersionGreaterThanOrEqualTo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.app_version != null && message.hasOwnProperty("app_version"))
                    if (!$util.isString(message.app_version))
                        return "app_version: string expected";
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    if (!(message.override_value && typeof message.override_value.length === "number" || $util.isString(message.override_value)))
                        return "override_value: buffer expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.priority != null && message.hasOwnProperty("priority"))
                    if (!$util.isInteger(message.priority))
                        return "priority: integer expected";
                if (message.created_at != null && message.hasOwnProperty("created_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                    if (error)
                        return "created_at." + error;
                }
                return null;
            };

            /**
             * Creates an AppVersionGreaterThanOrEqualTo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo} AppVersionGreaterThanOrEqualTo
             */
            AppVersionGreaterThanOrEqualTo.fromObject = function fromObject(object) {
                if (object instanceof $root.DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo)
                    return object;
                let message = new $root.DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.app_version != null)
                    message.app_version = String(object.app_version);
                if (object.override_value != null)
                    if (typeof object.override_value === "string")
                        $util.base64.decode(object.override_value, message.override_value = $util.newBuffer($util.base64.length(object.override_value)), 0);
                    else if (object.override_value.length)
                        message.override_value = object.override_value;
                switch (object.status) {
                case "UNKNOWN":
                case 0:
                    message.status = 0;
                    break;
                case "ENABLED":
                case 1:
                    message.status = 1;
                    break;
                case "DISABLED":
                case 2:
                    message.status = 2;
                    break;
                }
                if (object.priority != null)
                    message.priority = object.priority | 0;
                if (object.created_at != null) {
                    if (typeof object.created_at !== "object")
                        throw TypeError(".DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo.created_at: object expected");
                    message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
                }
                return message;
            };

            /**
             * Creates a plain object from an AppVersionGreaterThanOrEqualTo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @static
             * @param {DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo} message AppVersionGreaterThanOrEqualTo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppVersionGreaterThanOrEqualTo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.id = "";
                    object.app_version = "";
                    if (options.bytes === String)
                        object.override_value = "";
                    else {
                        object.override_value = [];
                        if (options.bytes !== Array)
                            object.override_value = $util.newBuffer(object.override_value);
                    }
                    object.status = options.enums === String ? "UNKNOWN" : 0;
                    object.priority = 0;
                    object.created_at = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.app_version != null && message.hasOwnProperty("app_version"))
                    object.app_version = message.app_version;
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    object.override_value = options.bytes === String ? $util.base64.encode(message.override_value, 0, message.override_value.length) : options.bytes === Array ? Array.prototype.slice.call(message.override_value) : message.override_value;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.DynamicConfiguration.Exceptions.Status.Enum[message.status] : message.status;
                if (message.priority != null && message.hasOwnProperty("priority"))
                    object.priority = message.priority;
                if (message.created_at != null && message.hasOwnProperty("created_at"))
                    object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
                return object;
            };

            /**
             * Converts this AppVersionGreaterThanOrEqualTo to JSON.
             * @function toJSON
             * @memberof DynamicConfiguration.Exceptions.AppVersionGreaterThanOrEqualTo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppVersionGreaterThanOrEqualTo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppVersionGreaterThanOrEqualTo;
        })();

        Exceptions.PlatformException = (function() {

            /**
             * Properties of a PlatformException.
             * @memberof DynamicConfiguration.Exceptions
             * @interface IPlatformException
             * @property {string|null} [id] PlatformException id
             * @property {Platform.Enum|null} [platform] PlatformException platform
             * @property {Uint8Array|null} [override_value] PlatformException override_value
             * @property {DynamicConfiguration.Exceptions.Status.Enum|null} [status] PlatformException status
             * @property {number|null} [priority] PlatformException priority
             * @property {google.protobuf.ITimestamp|null} [created_at] PlatformException created_at
             */

            /**
             * Constructs a new PlatformException.
             * @memberof DynamicConfiguration.Exceptions
             * @classdesc Represents a PlatformException.
             * @implements IPlatformException
             * @constructor
             * @param {DynamicConfiguration.Exceptions.IPlatformException=} [properties] Properties to set
             */
            function PlatformException(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PlatformException id.
             * @member {string} id
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @instance
             */
            PlatformException.prototype.id = "";

            /**
             * PlatformException platform.
             * @member {Platform.Enum} platform
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @instance
             */
            PlatformException.prototype.platform = 0;

            /**
             * PlatformException override_value.
             * @member {Uint8Array} override_value
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @instance
             */
            PlatformException.prototype.override_value = $util.newBuffer([]);

            /**
             * PlatformException status.
             * @member {DynamicConfiguration.Exceptions.Status.Enum} status
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @instance
             */
            PlatformException.prototype.status = 0;

            /**
             * PlatformException priority.
             * @member {number} priority
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @instance
             */
            PlatformException.prototype.priority = 0;

            /**
             * PlatformException created_at.
             * @member {google.protobuf.ITimestamp|null|undefined} created_at
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @instance
             */
            PlatformException.prototype.created_at = null;

            /**
             * Creates a new PlatformException instance using the specified properties.
             * @function create
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @static
             * @param {DynamicConfiguration.Exceptions.IPlatformException=} [properties] Properties to set
             * @returns {DynamicConfiguration.Exceptions.PlatformException} PlatformException instance
             */
            PlatformException.create = function create(properties) {
                return new PlatformException(properties);
            };

            /**
             * Encodes the specified PlatformException message. Does not implicitly {@link DynamicConfiguration.Exceptions.PlatformException.verify|verify} messages.
             * @function encode
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @static
             * @param {DynamicConfiguration.Exceptions.IPlatformException} message PlatformException message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlatformException.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && message.hasOwnProperty("id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.platform != null && message.hasOwnProperty("platform"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.platform);
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.override_value);
                if (message.status != null && message.hasOwnProperty("status"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
                if (message.priority != null && message.hasOwnProperty("priority"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.priority);
                if (message.created_at != null && message.hasOwnProperty("created_at"))
                    $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PlatformException message, length delimited. Does not implicitly {@link DynamicConfiguration.Exceptions.PlatformException.verify|verify} messages.
             * @function encodeDelimited
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @static
             * @param {DynamicConfiguration.Exceptions.IPlatformException} message PlatformException message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlatformException.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PlatformException message from the specified reader or buffer.
             * @function decode
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {DynamicConfiguration.Exceptions.PlatformException} PlatformException
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlatformException.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfiguration.Exceptions.PlatformException();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.platform = reader.int32();
                        break;
                    case 3:
                        message.override_value = reader.bytes();
                        break;
                    case 4:
                        message.status = reader.int32();
                        break;
                    case 5:
                        message.priority = reader.int32();
                        break;
                    case 98:
                        message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PlatformException message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {DynamicConfiguration.Exceptions.PlatformException} PlatformException
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlatformException.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PlatformException message.
             * @function verify
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PlatformException.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.platform != null && message.hasOwnProperty("platform"))
                    switch (message.platform) {
                    default:
                        return "platform: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    if (!(message.override_value && typeof message.override_value.length === "number" || $util.isString(message.override_value)))
                        return "override_value: buffer expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.priority != null && message.hasOwnProperty("priority"))
                    if (!$util.isInteger(message.priority))
                        return "priority: integer expected";
                if (message.created_at != null && message.hasOwnProperty("created_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                    if (error)
                        return "created_at." + error;
                }
                return null;
            };

            /**
             * Creates a PlatformException message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {DynamicConfiguration.Exceptions.PlatformException} PlatformException
             */
            PlatformException.fromObject = function fromObject(object) {
                if (object instanceof $root.DynamicConfiguration.Exceptions.PlatformException)
                    return object;
                let message = new $root.DynamicConfiguration.Exceptions.PlatformException();
                if (object.id != null)
                    message.id = String(object.id);
                switch (object.platform) {
                case "UNKNOWN":
                case 0:
                    message.platform = 0;
                    break;
                case "IOS":
                case 1:
                    message.platform = 1;
                    break;
                case "ANDROID":
                case 2:
                    message.platform = 2;
                    break;
                case "WEB":
                case 3:
                    message.platform = 3;
                    break;
                }
                if (object.override_value != null)
                    if (typeof object.override_value === "string")
                        $util.base64.decode(object.override_value, message.override_value = $util.newBuffer($util.base64.length(object.override_value)), 0);
                    else if (object.override_value.length)
                        message.override_value = object.override_value;
                switch (object.status) {
                case "UNKNOWN":
                case 0:
                    message.status = 0;
                    break;
                case "ENABLED":
                case 1:
                    message.status = 1;
                    break;
                case "DISABLED":
                case 2:
                    message.status = 2;
                    break;
                }
                if (object.priority != null)
                    message.priority = object.priority | 0;
                if (object.created_at != null) {
                    if (typeof object.created_at !== "object")
                        throw TypeError(".DynamicConfiguration.Exceptions.PlatformException.created_at: object expected");
                    message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
                }
                return message;
            };

            /**
             * Creates a plain object from a PlatformException message. Also converts values to other types if specified.
             * @function toObject
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @static
             * @param {DynamicConfiguration.Exceptions.PlatformException} message PlatformException
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PlatformException.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.id = "";
                    object.platform = options.enums === String ? "UNKNOWN" : 0;
                    if (options.bytes === String)
                        object.override_value = "";
                    else {
                        object.override_value = [];
                        if (options.bytes !== Array)
                            object.override_value = $util.newBuffer(object.override_value);
                    }
                    object.status = options.enums === String ? "UNKNOWN" : 0;
                    object.priority = 0;
                    object.created_at = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.platform != null && message.hasOwnProperty("platform"))
                    object.platform = options.enums === String ? $root.Platform.Enum[message.platform] : message.platform;
                if (message.override_value != null && message.hasOwnProperty("override_value"))
                    object.override_value = options.bytes === String ? $util.base64.encode(message.override_value, 0, message.override_value.length) : options.bytes === Array ? Array.prototype.slice.call(message.override_value) : message.override_value;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.DynamicConfiguration.Exceptions.Status.Enum[message.status] : message.status;
                if (message.priority != null && message.hasOwnProperty("priority"))
                    object.priority = message.priority;
                if (message.created_at != null && message.hasOwnProperty("created_at"))
                    object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
                return object;
            };

            /**
             * Converts this PlatformException to JSON.
             * @function toJSON
             * @memberof DynamicConfiguration.Exceptions.PlatformException
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PlatformException.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PlatformException;
        })();

        return Exceptions;
    })();

    return DynamicConfiguration;
})();

export const DynamicConfigurationRequest = $root.DynamicConfigurationRequest = (() => {

    /**
     * Properties of a DynamicConfigurationRequest.
     * @exports IDynamicConfigurationRequest
     * @interface IDynamicConfigurationRequest
     * @property {string|null} [key] DynamicConfigurationRequest key
     * @property {DynamicConfiguration.Namespace.Enum|null} [namespace] DynamicConfigurationRequest namespace
     * @property {DynamicConfiguration.ValueType.Enum|null} [expected_value_type] DynamicConfigurationRequest expected_value_type
     * @property {DynamicConfiguration.Status.Enum|null} [status] DynamicConfigurationRequest status
     * @property {DynamicConfiguration.IExceptions|null} [exceptions] DynamicConfigurationRequest exceptions
     * @property {Uint8Array|null} [value] DynamicConfigurationRequest value
     * @property {string|null} [revision_note] DynamicConfigurationRequest revision_note
     */

    /**
     * Constructs a new DynamicConfigurationRequest.
     * @exports DynamicConfigurationRequest
     * @classdesc Represents a DynamicConfigurationRequest.
     * @implements IDynamicConfigurationRequest
     * @constructor
     * @param {IDynamicConfigurationRequest=} [properties] Properties to set
     */
    function DynamicConfigurationRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DynamicConfigurationRequest key.
     * @member {string} key
     * @memberof DynamicConfigurationRequest
     * @instance
     */
    DynamicConfigurationRequest.prototype.key = "";

    /**
     * DynamicConfigurationRequest namespace.
     * @member {DynamicConfiguration.Namespace.Enum} namespace
     * @memberof DynamicConfigurationRequest
     * @instance
     */
    DynamicConfigurationRequest.prototype.namespace = 0;

    /**
     * DynamicConfigurationRequest expected_value_type.
     * @member {DynamicConfiguration.ValueType.Enum} expected_value_type
     * @memberof DynamicConfigurationRequest
     * @instance
     */
    DynamicConfigurationRequest.prototype.expected_value_type = 0;

    /**
     * DynamicConfigurationRequest status.
     * @member {DynamicConfiguration.Status.Enum} status
     * @memberof DynamicConfigurationRequest
     * @instance
     */
    DynamicConfigurationRequest.prototype.status = 0;

    /**
     * DynamicConfigurationRequest exceptions.
     * @member {DynamicConfiguration.IExceptions|null|undefined} exceptions
     * @memberof DynamicConfigurationRequest
     * @instance
     */
    DynamicConfigurationRequest.prototype.exceptions = null;

    /**
     * DynamicConfigurationRequest value.
     * @member {Uint8Array} value
     * @memberof DynamicConfigurationRequest
     * @instance
     */
    DynamicConfigurationRequest.prototype.value = $util.newBuffer([]);

    /**
     * DynamicConfigurationRequest revision_note.
     * @member {string} revision_note
     * @memberof DynamicConfigurationRequest
     * @instance
     */
    DynamicConfigurationRequest.prototype.revision_note = "";

    /**
     * Creates a new DynamicConfigurationRequest instance using the specified properties.
     * @function create
     * @memberof DynamicConfigurationRequest
     * @static
     * @param {IDynamicConfigurationRequest=} [properties] Properties to set
     * @returns {DynamicConfigurationRequest} DynamicConfigurationRequest instance
     */
    DynamicConfigurationRequest.create = function create(properties) {
        return new DynamicConfigurationRequest(properties);
    };

    /**
     * Encodes the specified DynamicConfigurationRequest message. Does not implicitly {@link DynamicConfigurationRequest.verify|verify} messages.
     * @function encode
     * @memberof DynamicConfigurationRequest
     * @static
     * @param {IDynamicConfigurationRequest} message DynamicConfigurationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DynamicConfigurationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && message.hasOwnProperty("key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.namespace != null && message.hasOwnProperty("namespace"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.namespace);
        if (message.expected_value_type != null && message.hasOwnProperty("expected_value_type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.expected_value_type);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
        if (message.exceptions != null && message.hasOwnProperty("exceptions"))
            $root.DynamicConfiguration.Exceptions.encode(message.exceptions, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.value);
        if (message.revision_note != null && message.hasOwnProperty("revision_note"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.revision_note);
        return writer;
    };

    /**
     * Encodes the specified DynamicConfigurationRequest message, length delimited. Does not implicitly {@link DynamicConfigurationRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DynamicConfigurationRequest
     * @static
     * @param {IDynamicConfigurationRequest} message DynamicConfigurationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DynamicConfigurationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DynamicConfigurationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof DynamicConfigurationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DynamicConfigurationRequest} DynamicConfigurationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DynamicConfigurationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DynamicConfigurationRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key = reader.string();
                break;
            case 2:
                message.namespace = reader.int32();
                break;
            case 3:
                message.expected_value_type = reader.int32();
                break;
            case 4:
                message.status = reader.int32();
                break;
            case 5:
                message.exceptions = $root.DynamicConfiguration.Exceptions.decode(reader, reader.uint32());
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.revision_note = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DynamicConfigurationRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DynamicConfigurationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DynamicConfigurationRequest} DynamicConfigurationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DynamicConfigurationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DynamicConfigurationRequest message.
     * @function verify
     * @memberof DynamicConfigurationRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DynamicConfigurationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.namespace != null && message.hasOwnProperty("namespace"))
            switch (message.namespace) {
            default:
                return "namespace: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.expected_value_type != null && message.hasOwnProperty("expected_value_type"))
            switch (message.expected_value_type) {
            default:
                return "expected_value_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.exceptions != null && message.hasOwnProperty("exceptions")) {
            let error = $root.DynamicConfiguration.Exceptions.verify(message.exceptions);
            if (error)
                return "exceptions." + error;
        }
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.revision_note != null && message.hasOwnProperty("revision_note"))
            if (!$util.isString(message.revision_note))
                return "revision_note: string expected";
        return null;
    };

    /**
     * Creates a DynamicConfigurationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DynamicConfigurationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DynamicConfigurationRequest} DynamicConfigurationRequest
     */
    DynamicConfigurationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DynamicConfigurationRequest)
            return object;
        let message = new $root.DynamicConfigurationRequest();
        if (object.key != null)
            message.key = String(object.key);
        switch (object.namespace) {
        case "UNKNOWN":
        case 0:
            message.namespace = 0;
            break;
        case "PUBLIC":
        case 1:
            message.namespace = 1;
            break;
        case "PRIVATE":
        case 2:
            message.namespace = 2;
            break;
        case "XP":
        case 3:
            message.namespace = 3;
            break;
        }
        switch (object.expected_value_type) {
        case "UNKNOWN":
        case 0:
            message.expected_value_type = 0;
            break;
        case "BOOL":
        case 1:
            message.expected_value_type = 1;
            break;
        case "STRING":
        case 2:
            message.expected_value_type = 2;
            break;
        case "INT64":
        case 3:
            message.expected_value_type = 3;
            break;
        case "FLOAT64":
        case 4:
            message.expected_value_type = 4;
            break;
        case "JSON":
        case 5:
            message.expected_value_type = 5;
            break;
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ENABLED":
        case 1:
            message.status = 1;
            break;
        case "DISABLED":
        case 2:
            message.status = 2;
            break;
        }
        if (object.exceptions != null) {
            if (typeof object.exceptions !== "object")
                throw TypeError(".DynamicConfigurationRequest.exceptions: object expected");
            message.exceptions = $root.DynamicConfiguration.Exceptions.fromObject(object.exceptions);
        }
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.revision_note != null)
            message.revision_note = String(object.revision_note);
        return message;
    };

    /**
     * Creates a plain object from a DynamicConfigurationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DynamicConfigurationRequest
     * @static
     * @param {DynamicConfigurationRequest} message DynamicConfigurationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DynamicConfigurationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.key = "";
            object.namespace = options.enums === String ? "UNKNOWN" : 0;
            object.expected_value_type = options.enums === String ? "UNKNOWN" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.exceptions = null;
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            object.revision_note = "";
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.namespace != null && message.hasOwnProperty("namespace"))
            object.namespace = options.enums === String ? $root.DynamicConfiguration.Namespace.Enum[message.namespace] : message.namespace;
        if (message.expected_value_type != null && message.hasOwnProperty("expected_value_type"))
            object.expected_value_type = options.enums === String ? $root.DynamicConfiguration.ValueType.Enum[message.expected_value_type] : message.expected_value_type;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.DynamicConfiguration.Status.Enum[message.status] : message.status;
        if (message.exceptions != null && message.hasOwnProperty("exceptions"))
            object.exceptions = $root.DynamicConfiguration.Exceptions.toObject(message.exceptions, options);
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.revision_note != null && message.hasOwnProperty("revision_note"))
            object.revision_note = message.revision_note;
        return object;
    };

    /**
     * Converts this DynamicConfigurationRequest to JSON.
     * @function toJSON
     * @memberof DynamicConfigurationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DynamicConfigurationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DynamicConfigurationRequest;
})();

export const Platform = $root.Platform = (() => {

    /**
     * Properties of a Platform.
     * @exports IPlatform
     * @interface IPlatform
     */

    /**
     * Constructs a new Platform.
     * @exports Platform
     * @classdesc Represents a Platform.
     * @implements IPlatform
     * @constructor
     * @param {IPlatform=} [properties] Properties to set
     */
    function Platform(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new Platform instance using the specified properties.
     * @function create
     * @memberof Platform
     * @static
     * @param {IPlatform=} [properties] Properties to set
     * @returns {Platform} Platform instance
     */
    Platform.create = function create(properties) {
        return new Platform(properties);
    };

    /**
     * Encodes the specified Platform message. Does not implicitly {@link Platform.verify|verify} messages.
     * @function encode
     * @memberof Platform
     * @static
     * @param {IPlatform} message Platform message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Platform.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified Platform message, length delimited. Does not implicitly {@link Platform.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Platform
     * @static
     * @param {IPlatform} message Platform message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Platform.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Platform message from the specified reader or buffer.
     * @function decode
     * @memberof Platform
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Platform} Platform
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Platform.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Platform();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Platform message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Platform
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Platform} Platform
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Platform.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Platform message.
     * @function verify
     * @memberof Platform
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Platform.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a Platform message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Platform
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Platform} Platform
     */
    Platform.fromObject = function fromObject(object) {
        if (object instanceof $root.Platform)
            return object;
        return new $root.Platform();
    };

    /**
     * Creates a plain object from a Platform message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Platform
     * @static
     * @param {Platform} message Platform
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Platform.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this Platform to JSON.
     * @function toJSON
     * @memberof Platform
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Platform.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name Platform.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} IOS=1 IOS value
     * @property {number} ANDROID=2 ANDROID value
     * @property {number} WEB=3 WEB value
     */
    Platform.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "IOS"] = 1;
        values[valuesById[2] = "ANDROID"] = 2;
        values[valuesById[3] = "WEB"] = 3;
        return values;
    })();

    return Platform;
})();

export const Experiment = $root.Experiment = (() => {

    /**
     * Properties of an Experiment.
     * @exports IExperiment
     * @interface IExperiment
     * @property {string|null} [name] Experiment name
     * @property {string|null} [description] Experiment description
     * @property {Experiment.Status.Enum|null} [status] Experiment status
     * @property {Array.<Experiment.IAudience>|null} [audiences] Experiment audiences
     * @property {Array.<Experiment.ITreatment>|null} [treatments] Experiment treatments
     * @property {boolean|null} [is_fingerprint_xp] Experiment is_fingerprint_xp
     * @property {string|null} [revised_by_admin_id] Experiment revised_by_admin_id
     * @property {google.protobuf.ITimestamp|null} [created_at] Experiment created_at
     */

    /**
     * Constructs a new Experiment.
     * @exports Experiment
     * @classdesc Represents an Experiment.
     * @implements IExperiment
     * @constructor
     * @param {IExperiment=} [properties] Properties to set
     */
    function Experiment(properties) {
        this.audiences = [];
        this.treatments = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Experiment name.
     * @member {string} name
     * @memberof Experiment
     * @instance
     */
    Experiment.prototype.name = "";

    /**
     * Experiment description.
     * @member {string} description
     * @memberof Experiment
     * @instance
     */
    Experiment.prototype.description = "";

    /**
     * Experiment status.
     * @member {Experiment.Status.Enum} status
     * @memberof Experiment
     * @instance
     */
    Experiment.prototype.status = 0;

    /**
     * Experiment audiences.
     * @member {Array.<Experiment.IAudience>} audiences
     * @memberof Experiment
     * @instance
     */
    Experiment.prototype.audiences = $util.emptyArray;

    /**
     * Experiment treatments.
     * @member {Array.<Experiment.ITreatment>} treatments
     * @memberof Experiment
     * @instance
     */
    Experiment.prototype.treatments = $util.emptyArray;

    /**
     * Experiment is_fingerprint_xp.
     * @member {boolean} is_fingerprint_xp
     * @memberof Experiment
     * @instance
     */
    Experiment.prototype.is_fingerprint_xp = false;

    /**
     * Experiment revised_by_admin_id.
     * @member {string} revised_by_admin_id
     * @memberof Experiment
     * @instance
     */
    Experiment.prototype.revised_by_admin_id = "";

    /**
     * Experiment created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof Experiment
     * @instance
     */
    Experiment.prototype.created_at = null;

    /**
     * Creates a new Experiment instance using the specified properties.
     * @function create
     * @memberof Experiment
     * @static
     * @param {IExperiment=} [properties] Properties to set
     * @returns {Experiment} Experiment instance
     */
    Experiment.create = function create(properties) {
        return new Experiment(properties);
    };

    /**
     * Encodes the specified Experiment message. Does not implicitly {@link Experiment.verify|verify} messages.
     * @function encode
     * @memberof Experiment
     * @static
     * @param {IExperiment} message Experiment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Experiment.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.name != null && message.hasOwnProperty("name"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
        if (message.description != null && message.hasOwnProperty("description"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
        if (message.audiences != null && message.audiences.length)
            for (let i = 0; i < message.audiences.length; ++i)
                $root.Experiment.Audience.encode(message.audiences[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.treatments != null && message.treatments.length)
            for (let i = 0; i < message.treatments.length; ++i)
                $root.Experiment.Treatment.encode(message.treatments[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.is_fingerprint_xp != null && message.hasOwnProperty("is_fingerprint_xp"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.is_fingerprint_xp);
        if (message.revised_by_admin_id != null && message.hasOwnProperty("revised_by_admin_id"))
            writer.uint32(/* id 98, wireType 2 =*/786).string(message.revised_by_admin_id);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Experiment message, length delimited. Does not implicitly {@link Experiment.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Experiment
     * @static
     * @param {IExperiment} message Experiment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Experiment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Experiment message from the specified reader or buffer.
     * @function decode
     * @memberof Experiment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Experiment} Experiment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Experiment.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.name = reader.string();
                break;
            case 2:
                message.description = reader.string();
                break;
            case 3:
                message.status = reader.int32();
                break;
            case 4:
                if (!(message.audiences && message.audiences.length))
                    message.audiences = [];
                message.audiences.push($root.Experiment.Audience.decode(reader, reader.uint32()));
                break;
            case 5:
                if (!(message.treatments && message.treatments.length))
                    message.treatments = [];
                message.treatments.push($root.Experiment.Treatment.decode(reader, reader.uint32()));
                break;
            case 6:
                message.is_fingerprint_xp = reader.bool();
                break;
            case 98:
                message.revised_by_admin_id = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Experiment message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Experiment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Experiment} Experiment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Experiment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Experiment message.
     * @function verify
     * @memberof Experiment
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Experiment.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.audiences != null && message.hasOwnProperty("audiences")) {
            if (!Array.isArray(message.audiences))
                return "audiences: array expected";
            for (let i = 0; i < message.audiences.length; ++i) {
                let error = $root.Experiment.Audience.verify(message.audiences[i]);
                if (error)
                    return "audiences." + error;
            }
        }
        if (message.treatments != null && message.hasOwnProperty("treatments")) {
            if (!Array.isArray(message.treatments))
                return "treatments: array expected";
            for (let i = 0; i < message.treatments.length; ++i) {
                let error = $root.Experiment.Treatment.verify(message.treatments[i]);
                if (error)
                    return "treatments." + error;
            }
        }
        if (message.is_fingerprint_xp != null && message.hasOwnProperty("is_fingerprint_xp"))
            if (typeof message.is_fingerprint_xp !== "boolean")
                return "is_fingerprint_xp: boolean expected";
        if (message.revised_by_admin_id != null && message.hasOwnProperty("revised_by_admin_id"))
            if (!$util.isString(message.revised_by_admin_id))
                return "revised_by_admin_id: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates an Experiment message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Experiment
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Experiment} Experiment
     */
    Experiment.fromObject = function fromObject(object) {
        if (object instanceof $root.Experiment)
            return object;
        let message = new $root.Experiment();
        if (object.name != null)
            message.name = String(object.name);
        if (object.description != null)
            message.description = String(object.description);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ONGOING":
        case 1:
            message.status = 1;
            break;
        case "COMPLETE":
        case 2:
            message.status = 2;
            break;
        }
        if (object.audiences) {
            if (!Array.isArray(object.audiences))
                throw TypeError(".Experiment.audiences: array expected");
            message.audiences = [];
            for (let i = 0; i < object.audiences.length; ++i) {
                if (typeof object.audiences[i] !== "object")
                    throw TypeError(".Experiment.audiences: object expected");
                message.audiences[i] = $root.Experiment.Audience.fromObject(object.audiences[i]);
            }
        }
        if (object.treatments) {
            if (!Array.isArray(object.treatments))
                throw TypeError(".Experiment.treatments: array expected");
            message.treatments = [];
            for (let i = 0; i < object.treatments.length; ++i) {
                if (typeof object.treatments[i] !== "object")
                    throw TypeError(".Experiment.treatments: object expected");
                message.treatments[i] = $root.Experiment.Treatment.fromObject(object.treatments[i]);
            }
        }
        if (object.is_fingerprint_xp != null)
            message.is_fingerprint_xp = Boolean(object.is_fingerprint_xp);
        if (object.revised_by_admin_id != null)
            message.revised_by_admin_id = String(object.revised_by_admin_id);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".Experiment.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an Experiment message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Experiment
     * @static
     * @param {Experiment} message Experiment
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Experiment.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.audiences = [];
            object.treatments = [];
        }
        if (options.defaults) {
            object.name = "";
            object.description = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.is_fingerprint_xp = false;
            object.revised_by_admin_id = "";
            object.created_at = null;
        }
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.Experiment.Status.Enum[message.status] : message.status;
        if (message.audiences && message.audiences.length) {
            object.audiences = [];
            for (let j = 0; j < message.audiences.length; ++j)
                object.audiences[j] = $root.Experiment.Audience.toObject(message.audiences[j], options);
        }
        if (message.treatments && message.treatments.length) {
            object.treatments = [];
            for (let j = 0; j < message.treatments.length; ++j)
                object.treatments[j] = $root.Experiment.Treatment.toObject(message.treatments[j], options);
        }
        if (message.is_fingerprint_xp != null && message.hasOwnProperty("is_fingerprint_xp"))
            object.is_fingerprint_xp = message.is_fingerprint_xp;
        if (message.revised_by_admin_id != null && message.hasOwnProperty("revised_by_admin_id"))
            object.revised_by_admin_id = message.revised_by_admin_id;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this Experiment to JSON.
     * @function toJSON
     * @memberof Experiment
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Experiment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Experiment.Audience = (function() {

        /**
         * Properties of an Audience.
         * @memberof Experiment
         * @interface IAudience
         * @property {string|null} [name] Audience name
         * @property {Experiment.Audience.ICriteria|null} [criteria] Audience criteria
         * @property {string|null} [hash_salt] Audience hash_salt
         * @property {number|null} [roll_out_thousandths] Audience roll_out_thousandths
         * @property {Object.<string,number>|null} [treatment_name_to_distribution_thousandths] Audience treatment_name_to_distribution_thousandths
         */

        /**
         * Constructs a new Audience.
         * @memberof Experiment
         * @classdesc Represents an Audience.
         * @implements IAudience
         * @constructor
         * @param {Experiment.IAudience=} [properties] Properties to set
         */
        function Audience(properties) {
            this.treatment_name_to_distribution_thousandths = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Audience name.
         * @member {string} name
         * @memberof Experiment.Audience
         * @instance
         */
        Audience.prototype.name = "";

        /**
         * Audience criteria.
         * @member {Experiment.Audience.ICriteria|null|undefined} criteria
         * @memberof Experiment.Audience
         * @instance
         */
        Audience.prototype.criteria = null;

        /**
         * Audience hash_salt.
         * @member {string} hash_salt
         * @memberof Experiment.Audience
         * @instance
         */
        Audience.prototype.hash_salt = "";

        /**
         * Audience roll_out_thousandths.
         * @member {number} roll_out_thousandths
         * @memberof Experiment.Audience
         * @instance
         */
        Audience.prototype.roll_out_thousandths = 0;

        /**
         * Audience treatment_name_to_distribution_thousandths.
         * @member {Object.<string,number>} treatment_name_to_distribution_thousandths
         * @memberof Experiment.Audience
         * @instance
         */
        Audience.prototype.treatment_name_to_distribution_thousandths = $util.emptyObject;

        /**
         * Creates a new Audience instance using the specified properties.
         * @function create
         * @memberof Experiment.Audience
         * @static
         * @param {Experiment.IAudience=} [properties] Properties to set
         * @returns {Experiment.Audience} Audience instance
         */
        Audience.create = function create(properties) {
            return new Audience(properties);
        };

        /**
         * Encodes the specified Audience message. Does not implicitly {@link Experiment.Audience.verify|verify} messages.
         * @function encode
         * @memberof Experiment.Audience
         * @static
         * @param {Experiment.IAudience} message Audience message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Audience.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && message.hasOwnProperty("name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.criteria != null && message.hasOwnProperty("criteria"))
                $root.Experiment.Audience.Criteria.encode(message.criteria, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.hash_salt != null && message.hasOwnProperty("hash_salt"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.hash_salt);
            if (message.roll_out_thousandths != null && message.hasOwnProperty("roll_out_thousandths"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.roll_out_thousandths);
            if (message.treatment_name_to_distribution_thousandths != null && message.hasOwnProperty("treatment_name_to_distribution_thousandths"))
                for (let keys = Object.keys(message.treatment_name_to_distribution_thousandths), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.treatment_name_to_distribution_thousandths[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Audience message, length delimited. Does not implicitly {@link Experiment.Audience.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Experiment.Audience
         * @static
         * @param {Experiment.IAudience} message Audience message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Audience.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Audience message from the specified reader or buffer.
         * @function decode
         * @memberof Experiment.Audience
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Experiment.Audience} Audience
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Audience.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Audience(), key;
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.criteria = $root.Experiment.Audience.Criteria.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.hash_salt = reader.string();
                    break;
                case 4:
                    message.roll_out_thousandths = reader.int32();
                    break;
                case 5:
                    reader.skip().pos++;
                    if (message.treatment_name_to_distribution_thousandths === $util.emptyObject)
                        message.treatment_name_to_distribution_thousandths = {};
                    key = reader.string();
                    reader.pos++;
                    message.treatment_name_to_distribution_thousandths[key] = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Audience message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Experiment.Audience
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Experiment.Audience} Audience
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Audience.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Audience message.
         * @function verify
         * @memberof Experiment.Audience
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Audience.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.criteria != null && message.hasOwnProperty("criteria")) {
                let error = $root.Experiment.Audience.Criteria.verify(message.criteria);
                if (error)
                    return "criteria." + error;
            }
            if (message.hash_salt != null && message.hasOwnProperty("hash_salt"))
                if (!$util.isString(message.hash_salt))
                    return "hash_salt: string expected";
            if (message.roll_out_thousandths != null && message.hasOwnProperty("roll_out_thousandths"))
                if (!$util.isInteger(message.roll_out_thousandths))
                    return "roll_out_thousandths: integer expected";
            if (message.treatment_name_to_distribution_thousandths != null && message.hasOwnProperty("treatment_name_to_distribution_thousandths")) {
                if (!$util.isObject(message.treatment_name_to_distribution_thousandths))
                    return "treatment_name_to_distribution_thousandths: object expected";
                let key = Object.keys(message.treatment_name_to_distribution_thousandths);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isInteger(message.treatment_name_to_distribution_thousandths[key[i]]))
                        return "treatment_name_to_distribution_thousandths: integer{k:string} expected";
            }
            return null;
        };

        /**
         * Creates an Audience message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Experiment.Audience
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Experiment.Audience} Audience
         */
        Audience.fromObject = function fromObject(object) {
            if (object instanceof $root.Experiment.Audience)
                return object;
            let message = new $root.Experiment.Audience();
            if (object.name != null)
                message.name = String(object.name);
            if (object.criteria != null) {
                if (typeof object.criteria !== "object")
                    throw TypeError(".Experiment.Audience.criteria: object expected");
                message.criteria = $root.Experiment.Audience.Criteria.fromObject(object.criteria);
            }
            if (object.hash_salt != null)
                message.hash_salt = String(object.hash_salt);
            if (object.roll_out_thousandths != null)
                message.roll_out_thousandths = object.roll_out_thousandths | 0;
            if (object.treatment_name_to_distribution_thousandths) {
                if (typeof object.treatment_name_to_distribution_thousandths !== "object")
                    throw TypeError(".Experiment.Audience.treatment_name_to_distribution_thousandths: object expected");
                message.treatment_name_to_distribution_thousandths = {};
                for (let keys = Object.keys(object.treatment_name_to_distribution_thousandths), i = 0; i < keys.length; ++i)
                    message.treatment_name_to_distribution_thousandths[keys[i]] = object.treatment_name_to_distribution_thousandths[keys[i]] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from an Audience message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Experiment.Audience
         * @static
         * @param {Experiment.Audience} message Audience
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Audience.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.treatment_name_to_distribution_thousandths = {};
            if (options.defaults) {
                object.name = "";
                object.criteria = null;
                object.hash_salt = "";
                object.roll_out_thousandths = 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.criteria != null && message.hasOwnProperty("criteria"))
                object.criteria = $root.Experiment.Audience.Criteria.toObject(message.criteria, options);
            if (message.hash_salt != null && message.hasOwnProperty("hash_salt"))
                object.hash_salt = message.hash_salt;
            if (message.roll_out_thousandths != null && message.hasOwnProperty("roll_out_thousandths"))
                object.roll_out_thousandths = message.roll_out_thousandths;
            let keys2;
            if (message.treatment_name_to_distribution_thousandths && (keys2 = Object.keys(message.treatment_name_to_distribution_thousandths)).length) {
                object.treatment_name_to_distribution_thousandths = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.treatment_name_to_distribution_thousandths[keys2[j]] = message.treatment_name_to_distribution_thousandths[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this Audience to JSON.
         * @function toJSON
         * @memberof Experiment.Audience
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Audience.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Audience.Criteria = (function() {

            /**
             * Properties of a Criteria.
             * @memberof Experiment.Audience
             * @interface ICriteria
             * @property {Experiment.Audience.Criteria.IContactIdIn|null} [contact_id_in] Criteria contact_id_in
             * @property {Experiment.Audience.Criteria.IPlatformIn|null} [platform_in] Criteria platform_in
             * @property {Experiment.Audience.Criteria.IAppVersionGreaterThanOrEqualTo|null} [app_version_greater_than_or_equal_to] Criteria app_version_greater_than_or_equal_to
             * @property {Experiment.Audience.Criteria.ISpaceshipEmployee|null} [spaceship_employee] Criteria spaceship_employee
             * @property {Experiment.Audience.Criteria.IDeviceFingerprintIn|null} [device_fingerprint_in] Criteria device_fingerprint_in
             */

            /**
             * Constructs a new Criteria.
             * @memberof Experiment.Audience
             * @classdesc Represents a Criteria.
             * @implements ICriteria
             * @constructor
             * @param {Experiment.Audience.ICriteria=} [properties] Properties to set
             */
            function Criteria(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Criteria contact_id_in.
             * @member {Experiment.Audience.Criteria.IContactIdIn|null|undefined} contact_id_in
             * @memberof Experiment.Audience.Criteria
             * @instance
             */
            Criteria.prototype.contact_id_in = null;

            /**
             * Criteria platform_in.
             * @member {Experiment.Audience.Criteria.IPlatformIn|null|undefined} platform_in
             * @memberof Experiment.Audience.Criteria
             * @instance
             */
            Criteria.prototype.platform_in = null;

            /**
             * Criteria app_version_greater_than_or_equal_to.
             * @member {Experiment.Audience.Criteria.IAppVersionGreaterThanOrEqualTo|null|undefined} app_version_greater_than_or_equal_to
             * @memberof Experiment.Audience.Criteria
             * @instance
             */
            Criteria.prototype.app_version_greater_than_or_equal_to = null;

            /**
             * Criteria spaceship_employee.
             * @member {Experiment.Audience.Criteria.ISpaceshipEmployee|null|undefined} spaceship_employee
             * @memberof Experiment.Audience.Criteria
             * @instance
             */
            Criteria.prototype.spaceship_employee = null;

            /**
             * Criteria device_fingerprint_in.
             * @member {Experiment.Audience.Criteria.IDeviceFingerprintIn|null|undefined} device_fingerprint_in
             * @memberof Experiment.Audience.Criteria
             * @instance
             */
            Criteria.prototype.device_fingerprint_in = null;

            /**
             * Creates a new Criteria instance using the specified properties.
             * @function create
             * @memberof Experiment.Audience.Criteria
             * @static
             * @param {Experiment.Audience.ICriteria=} [properties] Properties to set
             * @returns {Experiment.Audience.Criteria} Criteria instance
             */
            Criteria.create = function create(properties) {
                return new Criteria(properties);
            };

            /**
             * Encodes the specified Criteria message. Does not implicitly {@link Experiment.Audience.Criteria.verify|verify} messages.
             * @function encode
             * @memberof Experiment.Audience.Criteria
             * @static
             * @param {Experiment.Audience.ICriteria} message Criteria message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Criteria.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contact_id_in != null && message.hasOwnProperty("contact_id_in"))
                    $root.Experiment.Audience.Criteria.ContactIdIn.encode(message.contact_id_in, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.platform_in != null && message.hasOwnProperty("platform_in"))
                    $root.Experiment.Audience.Criteria.PlatformIn.encode(message.platform_in, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.app_version_greater_than_or_equal_to != null && message.hasOwnProperty("app_version_greater_than_or_equal_to"))
                    $root.Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo.encode(message.app_version_greater_than_or_equal_to, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.spaceship_employee != null && message.hasOwnProperty("spaceship_employee"))
                    $root.Experiment.Audience.Criteria.SpaceshipEmployee.encode(message.spaceship_employee, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.device_fingerprint_in != null && message.hasOwnProperty("device_fingerprint_in"))
                    $root.Experiment.Audience.Criteria.DeviceFingerprintIn.encode(message.device_fingerprint_in, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Criteria message, length delimited. Does not implicitly {@link Experiment.Audience.Criteria.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Experiment.Audience.Criteria
             * @static
             * @param {Experiment.Audience.ICriteria} message Criteria message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Criteria.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Criteria message from the specified reader or buffer.
             * @function decode
             * @memberof Experiment.Audience.Criteria
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Experiment.Audience.Criteria} Criteria
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Criteria.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Audience.Criteria();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.contact_id_in = $root.Experiment.Audience.Criteria.ContactIdIn.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.platform_in = $root.Experiment.Audience.Criteria.PlatformIn.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.app_version_greater_than_or_equal_to = $root.Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.spaceship_employee = $root.Experiment.Audience.Criteria.SpaceshipEmployee.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.device_fingerprint_in = $root.Experiment.Audience.Criteria.DeviceFingerprintIn.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Criteria message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Experiment.Audience.Criteria
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Experiment.Audience.Criteria} Criteria
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Criteria.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Criteria message.
             * @function verify
             * @memberof Experiment.Audience.Criteria
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Criteria.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contact_id_in != null && message.hasOwnProperty("contact_id_in")) {
                    let error = $root.Experiment.Audience.Criteria.ContactIdIn.verify(message.contact_id_in);
                    if (error)
                        return "contact_id_in." + error;
                }
                if (message.platform_in != null && message.hasOwnProperty("platform_in")) {
                    let error = $root.Experiment.Audience.Criteria.PlatformIn.verify(message.platform_in);
                    if (error)
                        return "platform_in." + error;
                }
                if (message.app_version_greater_than_or_equal_to != null && message.hasOwnProperty("app_version_greater_than_or_equal_to")) {
                    let error = $root.Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo.verify(message.app_version_greater_than_or_equal_to);
                    if (error)
                        return "app_version_greater_than_or_equal_to." + error;
                }
                if (message.spaceship_employee != null && message.hasOwnProperty("spaceship_employee")) {
                    let error = $root.Experiment.Audience.Criteria.SpaceshipEmployee.verify(message.spaceship_employee);
                    if (error)
                        return "spaceship_employee." + error;
                }
                if (message.device_fingerprint_in != null && message.hasOwnProperty("device_fingerprint_in")) {
                    let error = $root.Experiment.Audience.Criteria.DeviceFingerprintIn.verify(message.device_fingerprint_in);
                    if (error)
                        return "device_fingerprint_in." + error;
                }
                return null;
            };

            /**
             * Creates a Criteria message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Experiment.Audience.Criteria
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Experiment.Audience.Criteria} Criteria
             */
            Criteria.fromObject = function fromObject(object) {
                if (object instanceof $root.Experiment.Audience.Criteria)
                    return object;
                let message = new $root.Experiment.Audience.Criteria();
                if (object.contact_id_in != null) {
                    if (typeof object.contact_id_in !== "object")
                        throw TypeError(".Experiment.Audience.Criteria.contact_id_in: object expected");
                    message.contact_id_in = $root.Experiment.Audience.Criteria.ContactIdIn.fromObject(object.contact_id_in);
                }
                if (object.platform_in != null) {
                    if (typeof object.platform_in !== "object")
                        throw TypeError(".Experiment.Audience.Criteria.platform_in: object expected");
                    message.platform_in = $root.Experiment.Audience.Criteria.PlatformIn.fromObject(object.platform_in);
                }
                if (object.app_version_greater_than_or_equal_to != null) {
                    if (typeof object.app_version_greater_than_or_equal_to !== "object")
                        throw TypeError(".Experiment.Audience.Criteria.app_version_greater_than_or_equal_to: object expected");
                    message.app_version_greater_than_or_equal_to = $root.Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo.fromObject(object.app_version_greater_than_or_equal_to);
                }
                if (object.spaceship_employee != null) {
                    if (typeof object.spaceship_employee !== "object")
                        throw TypeError(".Experiment.Audience.Criteria.spaceship_employee: object expected");
                    message.spaceship_employee = $root.Experiment.Audience.Criteria.SpaceshipEmployee.fromObject(object.spaceship_employee);
                }
                if (object.device_fingerprint_in != null) {
                    if (typeof object.device_fingerprint_in !== "object")
                        throw TypeError(".Experiment.Audience.Criteria.device_fingerprint_in: object expected");
                    message.device_fingerprint_in = $root.Experiment.Audience.Criteria.DeviceFingerprintIn.fromObject(object.device_fingerprint_in);
                }
                return message;
            };

            /**
             * Creates a plain object from a Criteria message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Experiment.Audience.Criteria
             * @static
             * @param {Experiment.Audience.Criteria} message Criteria
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Criteria.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.contact_id_in = null;
                    object.platform_in = null;
                    object.app_version_greater_than_or_equal_to = null;
                    object.spaceship_employee = null;
                    object.device_fingerprint_in = null;
                }
                if (message.contact_id_in != null && message.hasOwnProperty("contact_id_in"))
                    object.contact_id_in = $root.Experiment.Audience.Criteria.ContactIdIn.toObject(message.contact_id_in, options);
                if (message.platform_in != null && message.hasOwnProperty("platform_in"))
                    object.platform_in = $root.Experiment.Audience.Criteria.PlatformIn.toObject(message.platform_in, options);
                if (message.app_version_greater_than_or_equal_to != null && message.hasOwnProperty("app_version_greater_than_or_equal_to"))
                    object.app_version_greater_than_or_equal_to = $root.Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo.toObject(message.app_version_greater_than_or_equal_to, options);
                if (message.spaceship_employee != null && message.hasOwnProperty("spaceship_employee"))
                    object.spaceship_employee = $root.Experiment.Audience.Criteria.SpaceshipEmployee.toObject(message.spaceship_employee, options);
                if (message.device_fingerprint_in != null && message.hasOwnProperty("device_fingerprint_in"))
                    object.device_fingerprint_in = $root.Experiment.Audience.Criteria.DeviceFingerprintIn.toObject(message.device_fingerprint_in, options);
                return object;
            };

            /**
             * Converts this Criteria to JSON.
             * @function toJSON
             * @memberof Experiment.Audience.Criteria
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Criteria.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Criteria.ContactIdIn = (function() {

                /**
                 * Properties of a ContactIdIn.
                 * @memberof Experiment.Audience.Criteria
                 * @interface IContactIdIn
                 * @property {Array.<string>|null} [contact_ids] ContactIdIn contact_ids
                 */

                /**
                 * Constructs a new ContactIdIn.
                 * @memberof Experiment.Audience.Criteria
                 * @classdesc Represents a ContactIdIn.
                 * @implements IContactIdIn
                 * @constructor
                 * @param {Experiment.Audience.Criteria.IContactIdIn=} [properties] Properties to set
                 */
                function ContactIdIn(properties) {
                    this.contact_ids = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ContactIdIn contact_ids.
                 * @member {Array.<string>} contact_ids
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @instance
                 */
                ContactIdIn.prototype.contact_ids = $util.emptyArray;

                /**
                 * Creates a new ContactIdIn instance using the specified properties.
                 * @function create
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IContactIdIn=} [properties] Properties to set
                 * @returns {Experiment.Audience.Criteria.ContactIdIn} ContactIdIn instance
                 */
                ContactIdIn.create = function create(properties) {
                    return new ContactIdIn(properties);
                };

                /**
                 * Encodes the specified ContactIdIn message. Does not implicitly {@link Experiment.Audience.Criteria.ContactIdIn.verify|verify} messages.
                 * @function encode
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IContactIdIn} message ContactIdIn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ContactIdIn.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.contact_ids != null && message.contact_ids.length)
                        for (let i = 0; i < message.contact_ids.length; ++i)
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.contact_ids[i]);
                    return writer;
                };

                /**
                 * Encodes the specified ContactIdIn message, length delimited. Does not implicitly {@link Experiment.Audience.Criteria.ContactIdIn.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IContactIdIn} message ContactIdIn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ContactIdIn.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ContactIdIn message from the specified reader or buffer.
                 * @function decode
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {Experiment.Audience.Criteria.ContactIdIn} ContactIdIn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ContactIdIn.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Audience.Criteria.ContactIdIn();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.contact_ids && message.contact_ids.length))
                                message.contact_ids = [];
                            message.contact_ids.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ContactIdIn message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {Experiment.Audience.Criteria.ContactIdIn} ContactIdIn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ContactIdIn.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ContactIdIn message.
                 * @function verify
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ContactIdIn.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.contact_ids != null && message.hasOwnProperty("contact_ids")) {
                        if (!Array.isArray(message.contact_ids))
                            return "contact_ids: array expected";
                        for (let i = 0; i < message.contact_ids.length; ++i)
                            if (!$util.isString(message.contact_ids[i]))
                                return "contact_ids: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a ContactIdIn message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {Experiment.Audience.Criteria.ContactIdIn} ContactIdIn
                 */
                ContactIdIn.fromObject = function fromObject(object) {
                    if (object instanceof $root.Experiment.Audience.Criteria.ContactIdIn)
                        return object;
                    let message = new $root.Experiment.Audience.Criteria.ContactIdIn();
                    if (object.contact_ids) {
                        if (!Array.isArray(object.contact_ids))
                            throw TypeError(".Experiment.Audience.Criteria.ContactIdIn.contact_ids: array expected");
                        message.contact_ids = [];
                        for (let i = 0; i < object.contact_ids.length; ++i)
                            message.contact_ids[i] = String(object.contact_ids[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ContactIdIn message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @static
                 * @param {Experiment.Audience.Criteria.ContactIdIn} message ContactIdIn
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ContactIdIn.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.contact_ids = [];
                    if (message.contact_ids && message.contact_ids.length) {
                        object.contact_ids = [];
                        for (let j = 0; j < message.contact_ids.length; ++j)
                            object.contact_ids[j] = message.contact_ids[j];
                    }
                    return object;
                };

                /**
                 * Converts this ContactIdIn to JSON.
                 * @function toJSON
                 * @memberof Experiment.Audience.Criteria.ContactIdIn
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ContactIdIn.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ContactIdIn;
            })();

            Criteria.PlatformIn = (function() {

                /**
                 * Properties of a PlatformIn.
                 * @memberof Experiment.Audience.Criteria
                 * @interface IPlatformIn
                 * @property {Array.<Platform.Enum>|null} [platforms] PlatformIn platforms
                 */

                /**
                 * Constructs a new PlatformIn.
                 * @memberof Experiment.Audience.Criteria
                 * @classdesc Represents a PlatformIn.
                 * @implements IPlatformIn
                 * @constructor
                 * @param {Experiment.Audience.Criteria.IPlatformIn=} [properties] Properties to set
                 */
                function PlatformIn(properties) {
                    this.platforms = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PlatformIn platforms.
                 * @member {Array.<Platform.Enum>} platforms
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @instance
                 */
                PlatformIn.prototype.platforms = $util.emptyArray;

                /**
                 * Creates a new PlatformIn instance using the specified properties.
                 * @function create
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IPlatformIn=} [properties] Properties to set
                 * @returns {Experiment.Audience.Criteria.PlatformIn} PlatformIn instance
                 */
                PlatformIn.create = function create(properties) {
                    return new PlatformIn(properties);
                };

                /**
                 * Encodes the specified PlatformIn message. Does not implicitly {@link Experiment.Audience.Criteria.PlatformIn.verify|verify} messages.
                 * @function encode
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IPlatformIn} message PlatformIn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PlatformIn.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.platforms != null && message.platforms.length) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork();
                        for (let i = 0; i < message.platforms.length; ++i)
                            writer.int32(message.platforms[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified PlatformIn message, length delimited. Does not implicitly {@link Experiment.Audience.Criteria.PlatformIn.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IPlatformIn} message PlatformIn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PlatformIn.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PlatformIn message from the specified reader or buffer.
                 * @function decode
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {Experiment.Audience.Criteria.PlatformIn} PlatformIn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PlatformIn.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Audience.Criteria.PlatformIn();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.platforms && message.platforms.length))
                                message.platforms = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.platforms.push(reader.int32());
                            } else
                                message.platforms.push(reader.int32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PlatformIn message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {Experiment.Audience.Criteria.PlatformIn} PlatformIn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PlatformIn.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PlatformIn message.
                 * @function verify
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PlatformIn.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.platforms != null && message.hasOwnProperty("platforms")) {
                        if (!Array.isArray(message.platforms))
                            return "platforms: array expected";
                        for (let i = 0; i < message.platforms.length; ++i)
                            switch (message.platforms[i]) {
                            default:
                                return "platforms: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a PlatformIn message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {Experiment.Audience.Criteria.PlatformIn} PlatformIn
                 */
                PlatformIn.fromObject = function fromObject(object) {
                    if (object instanceof $root.Experiment.Audience.Criteria.PlatformIn)
                        return object;
                    let message = new $root.Experiment.Audience.Criteria.PlatformIn();
                    if (object.platforms) {
                        if (!Array.isArray(object.platforms))
                            throw TypeError(".Experiment.Audience.Criteria.PlatformIn.platforms: array expected");
                        message.platforms = [];
                        for (let i = 0; i < object.platforms.length; ++i)
                            switch (object.platforms[i]) {
                            default:
                            case "UNKNOWN":
                            case 0:
                                message.platforms[i] = 0;
                                break;
                            case "IOS":
                            case 1:
                                message.platforms[i] = 1;
                                break;
                            case "ANDROID":
                            case 2:
                                message.platforms[i] = 2;
                                break;
                            case "WEB":
                            case 3:
                                message.platforms[i] = 3;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PlatformIn message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @static
                 * @param {Experiment.Audience.Criteria.PlatformIn} message PlatformIn
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PlatformIn.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.platforms = [];
                    if (message.platforms && message.platforms.length) {
                        object.platforms = [];
                        for (let j = 0; j < message.platforms.length; ++j)
                            object.platforms[j] = options.enums === String ? $root.Platform.Enum[message.platforms[j]] : message.platforms[j];
                    }
                    return object;
                };

                /**
                 * Converts this PlatformIn to JSON.
                 * @function toJSON
                 * @memberof Experiment.Audience.Criteria.PlatformIn
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PlatformIn.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PlatformIn;
            })();

            Criteria.AppVersionGreaterThanOrEqualTo = (function() {

                /**
                 * Properties of an AppVersionGreaterThanOrEqualTo.
                 * @memberof Experiment.Audience.Criteria
                 * @interface IAppVersionGreaterThanOrEqualTo
                 * @property {string|null} [app_version] AppVersionGreaterThanOrEqualTo app_version
                 */

                /**
                 * Constructs a new AppVersionGreaterThanOrEqualTo.
                 * @memberof Experiment.Audience.Criteria
                 * @classdesc Represents an AppVersionGreaterThanOrEqualTo.
                 * @implements IAppVersionGreaterThanOrEqualTo
                 * @constructor
                 * @param {Experiment.Audience.Criteria.IAppVersionGreaterThanOrEqualTo=} [properties] Properties to set
                 */
                function AppVersionGreaterThanOrEqualTo(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AppVersionGreaterThanOrEqualTo app_version.
                 * @member {string} app_version
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @instance
                 */
                AppVersionGreaterThanOrEqualTo.prototype.app_version = "";

                /**
                 * Creates a new AppVersionGreaterThanOrEqualTo instance using the specified properties.
                 * @function create
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @static
                 * @param {Experiment.Audience.Criteria.IAppVersionGreaterThanOrEqualTo=} [properties] Properties to set
                 * @returns {Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo} AppVersionGreaterThanOrEqualTo instance
                 */
                AppVersionGreaterThanOrEqualTo.create = function create(properties) {
                    return new AppVersionGreaterThanOrEqualTo(properties);
                };

                /**
                 * Encodes the specified AppVersionGreaterThanOrEqualTo message. Does not implicitly {@link Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo.verify|verify} messages.
                 * @function encode
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @static
                 * @param {Experiment.Audience.Criteria.IAppVersionGreaterThanOrEqualTo} message AppVersionGreaterThanOrEqualTo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AppVersionGreaterThanOrEqualTo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.app_version != null && message.hasOwnProperty("app_version"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.app_version);
                    return writer;
                };

                /**
                 * Encodes the specified AppVersionGreaterThanOrEqualTo message, length delimited. Does not implicitly {@link Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @static
                 * @param {Experiment.Audience.Criteria.IAppVersionGreaterThanOrEqualTo} message AppVersionGreaterThanOrEqualTo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AppVersionGreaterThanOrEqualTo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AppVersionGreaterThanOrEqualTo message from the specified reader or buffer.
                 * @function decode
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo} AppVersionGreaterThanOrEqualTo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AppVersionGreaterThanOrEqualTo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.app_version = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AppVersionGreaterThanOrEqualTo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo} AppVersionGreaterThanOrEqualTo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AppVersionGreaterThanOrEqualTo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AppVersionGreaterThanOrEqualTo message.
                 * @function verify
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AppVersionGreaterThanOrEqualTo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.app_version != null && message.hasOwnProperty("app_version"))
                        if (!$util.isString(message.app_version))
                            return "app_version: string expected";
                    return null;
                };

                /**
                 * Creates an AppVersionGreaterThanOrEqualTo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo} AppVersionGreaterThanOrEqualTo
                 */
                AppVersionGreaterThanOrEqualTo.fromObject = function fromObject(object) {
                    if (object instanceof $root.Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo)
                        return object;
                    let message = new $root.Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo();
                    if (object.app_version != null)
                        message.app_version = String(object.app_version);
                    return message;
                };

                /**
                 * Creates a plain object from an AppVersionGreaterThanOrEqualTo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @static
                 * @param {Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo} message AppVersionGreaterThanOrEqualTo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AppVersionGreaterThanOrEqualTo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.app_version = "";
                    if (message.app_version != null && message.hasOwnProperty("app_version"))
                        object.app_version = message.app_version;
                    return object;
                };

                /**
                 * Converts this AppVersionGreaterThanOrEqualTo to JSON.
                 * @function toJSON
                 * @memberof Experiment.Audience.Criteria.AppVersionGreaterThanOrEqualTo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AppVersionGreaterThanOrEqualTo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AppVersionGreaterThanOrEqualTo;
            })();

            Criteria.SpaceshipEmployee = (function() {

                /**
                 * Properties of a SpaceshipEmployee.
                 * @memberof Experiment.Audience.Criteria
                 * @interface ISpaceshipEmployee
                 * @property {boolean|null} [is_spaceship_employee] SpaceshipEmployee is_spaceship_employee
                 */

                /**
                 * Constructs a new SpaceshipEmployee.
                 * @memberof Experiment.Audience.Criteria
                 * @classdesc Represents a SpaceshipEmployee.
                 * @implements ISpaceshipEmployee
                 * @constructor
                 * @param {Experiment.Audience.Criteria.ISpaceshipEmployee=} [properties] Properties to set
                 */
                function SpaceshipEmployee(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SpaceshipEmployee is_spaceship_employee.
                 * @member {boolean} is_spaceship_employee
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @instance
                 */
                SpaceshipEmployee.prototype.is_spaceship_employee = false;

                /**
                 * Creates a new SpaceshipEmployee instance using the specified properties.
                 * @function create
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @static
                 * @param {Experiment.Audience.Criteria.ISpaceshipEmployee=} [properties] Properties to set
                 * @returns {Experiment.Audience.Criteria.SpaceshipEmployee} SpaceshipEmployee instance
                 */
                SpaceshipEmployee.create = function create(properties) {
                    return new SpaceshipEmployee(properties);
                };

                /**
                 * Encodes the specified SpaceshipEmployee message. Does not implicitly {@link Experiment.Audience.Criteria.SpaceshipEmployee.verify|verify} messages.
                 * @function encode
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @static
                 * @param {Experiment.Audience.Criteria.ISpaceshipEmployee} message SpaceshipEmployee message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpaceshipEmployee.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.is_spaceship_employee != null && message.hasOwnProperty("is_spaceship_employee"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.is_spaceship_employee);
                    return writer;
                };

                /**
                 * Encodes the specified SpaceshipEmployee message, length delimited. Does not implicitly {@link Experiment.Audience.Criteria.SpaceshipEmployee.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @static
                 * @param {Experiment.Audience.Criteria.ISpaceshipEmployee} message SpaceshipEmployee message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpaceshipEmployee.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SpaceshipEmployee message from the specified reader or buffer.
                 * @function decode
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {Experiment.Audience.Criteria.SpaceshipEmployee} SpaceshipEmployee
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpaceshipEmployee.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Audience.Criteria.SpaceshipEmployee();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.is_spaceship_employee = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SpaceshipEmployee message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {Experiment.Audience.Criteria.SpaceshipEmployee} SpaceshipEmployee
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpaceshipEmployee.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SpaceshipEmployee message.
                 * @function verify
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SpaceshipEmployee.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.is_spaceship_employee != null && message.hasOwnProperty("is_spaceship_employee"))
                        if (typeof message.is_spaceship_employee !== "boolean")
                            return "is_spaceship_employee: boolean expected";
                    return null;
                };

                /**
                 * Creates a SpaceshipEmployee message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {Experiment.Audience.Criteria.SpaceshipEmployee} SpaceshipEmployee
                 */
                SpaceshipEmployee.fromObject = function fromObject(object) {
                    if (object instanceof $root.Experiment.Audience.Criteria.SpaceshipEmployee)
                        return object;
                    let message = new $root.Experiment.Audience.Criteria.SpaceshipEmployee();
                    if (object.is_spaceship_employee != null)
                        message.is_spaceship_employee = Boolean(object.is_spaceship_employee);
                    return message;
                };

                /**
                 * Creates a plain object from a SpaceshipEmployee message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @static
                 * @param {Experiment.Audience.Criteria.SpaceshipEmployee} message SpaceshipEmployee
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SpaceshipEmployee.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.is_spaceship_employee = false;
                    if (message.is_spaceship_employee != null && message.hasOwnProperty("is_spaceship_employee"))
                        object.is_spaceship_employee = message.is_spaceship_employee;
                    return object;
                };

                /**
                 * Converts this SpaceshipEmployee to JSON.
                 * @function toJSON
                 * @memberof Experiment.Audience.Criteria.SpaceshipEmployee
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SpaceshipEmployee.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SpaceshipEmployee;
            })();

            Criteria.DeviceFingerprintIn = (function() {

                /**
                 * Properties of a DeviceFingerprintIn.
                 * @memberof Experiment.Audience.Criteria
                 * @interface IDeviceFingerprintIn
                 * @property {Array.<string>|null} [device_fingerprints] DeviceFingerprintIn device_fingerprints
                 */

                /**
                 * Constructs a new DeviceFingerprintIn.
                 * @memberof Experiment.Audience.Criteria
                 * @classdesc Represents a DeviceFingerprintIn.
                 * @implements IDeviceFingerprintIn
                 * @constructor
                 * @param {Experiment.Audience.Criteria.IDeviceFingerprintIn=} [properties] Properties to set
                 */
                function DeviceFingerprintIn(properties) {
                    this.device_fingerprints = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceFingerprintIn device_fingerprints.
                 * @member {Array.<string>} device_fingerprints
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @instance
                 */
                DeviceFingerprintIn.prototype.device_fingerprints = $util.emptyArray;

                /**
                 * Creates a new DeviceFingerprintIn instance using the specified properties.
                 * @function create
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IDeviceFingerprintIn=} [properties] Properties to set
                 * @returns {Experiment.Audience.Criteria.DeviceFingerprintIn} DeviceFingerprintIn instance
                 */
                DeviceFingerprintIn.create = function create(properties) {
                    return new DeviceFingerprintIn(properties);
                };

                /**
                 * Encodes the specified DeviceFingerprintIn message. Does not implicitly {@link Experiment.Audience.Criteria.DeviceFingerprintIn.verify|verify} messages.
                 * @function encode
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IDeviceFingerprintIn} message DeviceFingerprintIn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFingerprintIn.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.device_fingerprints != null && message.device_fingerprints.length)
                        for (let i = 0; i < message.device_fingerprints.length; ++i)
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.device_fingerprints[i]);
                    return writer;
                };

                /**
                 * Encodes the specified DeviceFingerprintIn message, length delimited. Does not implicitly {@link Experiment.Audience.Criteria.DeviceFingerprintIn.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @static
                 * @param {Experiment.Audience.Criteria.IDeviceFingerprintIn} message DeviceFingerprintIn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFingerprintIn.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceFingerprintIn message from the specified reader or buffer.
                 * @function decode
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {Experiment.Audience.Criteria.DeviceFingerprintIn} DeviceFingerprintIn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFingerprintIn.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Audience.Criteria.DeviceFingerprintIn();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.device_fingerprints && message.device_fingerprints.length))
                                message.device_fingerprints = [];
                            message.device_fingerprints.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceFingerprintIn message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {Experiment.Audience.Criteria.DeviceFingerprintIn} DeviceFingerprintIn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFingerprintIn.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceFingerprintIn message.
                 * @function verify
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceFingerprintIn.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.device_fingerprints != null && message.hasOwnProperty("device_fingerprints")) {
                        if (!Array.isArray(message.device_fingerprints))
                            return "device_fingerprints: array expected";
                        for (let i = 0; i < message.device_fingerprints.length; ++i)
                            if (!$util.isString(message.device_fingerprints[i]))
                                return "device_fingerprints: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a DeviceFingerprintIn message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {Experiment.Audience.Criteria.DeviceFingerprintIn} DeviceFingerprintIn
                 */
                DeviceFingerprintIn.fromObject = function fromObject(object) {
                    if (object instanceof $root.Experiment.Audience.Criteria.DeviceFingerprintIn)
                        return object;
                    let message = new $root.Experiment.Audience.Criteria.DeviceFingerprintIn();
                    if (object.device_fingerprints) {
                        if (!Array.isArray(object.device_fingerprints))
                            throw TypeError(".Experiment.Audience.Criteria.DeviceFingerprintIn.device_fingerprints: array expected");
                        message.device_fingerprints = [];
                        for (let i = 0; i < object.device_fingerprints.length; ++i)
                            message.device_fingerprints[i] = String(object.device_fingerprints[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceFingerprintIn message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @static
                 * @param {Experiment.Audience.Criteria.DeviceFingerprintIn} message DeviceFingerprintIn
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceFingerprintIn.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.device_fingerprints = [];
                    if (message.device_fingerprints && message.device_fingerprints.length) {
                        object.device_fingerprints = [];
                        for (let j = 0; j < message.device_fingerprints.length; ++j)
                            object.device_fingerprints[j] = message.device_fingerprints[j];
                    }
                    return object;
                };

                /**
                 * Converts this DeviceFingerprintIn to JSON.
                 * @function toJSON
                 * @memberof Experiment.Audience.Criteria.DeviceFingerprintIn
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceFingerprintIn.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DeviceFingerprintIn;
            })();

            return Criteria;
        })();

        return Audience;
    })();

    Experiment.Treatment = (function() {

        /**
         * Properties of a Treatment.
         * @memberof Experiment
         * @interface ITreatment
         * @property {string|null} [name] Treatment name
         * @property {string|null} [description] Treatment description
         * @property {Object.<string,string>|null} [parameters] Treatment parameters
         */

        /**
         * Constructs a new Treatment.
         * @memberof Experiment
         * @classdesc Represents a Treatment.
         * @implements ITreatment
         * @constructor
         * @param {Experiment.ITreatment=} [properties] Properties to set
         */
        function Treatment(properties) {
            this.parameters = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Treatment name.
         * @member {string} name
         * @memberof Experiment.Treatment
         * @instance
         */
        Treatment.prototype.name = "";

        /**
         * Treatment description.
         * @member {string} description
         * @memberof Experiment.Treatment
         * @instance
         */
        Treatment.prototype.description = "";

        /**
         * Treatment parameters.
         * @member {Object.<string,string>} parameters
         * @memberof Experiment.Treatment
         * @instance
         */
        Treatment.prototype.parameters = $util.emptyObject;

        /**
         * Creates a new Treatment instance using the specified properties.
         * @function create
         * @memberof Experiment.Treatment
         * @static
         * @param {Experiment.ITreatment=} [properties] Properties to set
         * @returns {Experiment.Treatment} Treatment instance
         */
        Treatment.create = function create(properties) {
            return new Treatment(properties);
        };

        /**
         * Encodes the specified Treatment message. Does not implicitly {@link Experiment.Treatment.verify|verify} messages.
         * @function encode
         * @memberof Experiment.Treatment
         * @static
         * @param {Experiment.ITreatment} message Treatment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Treatment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && message.hasOwnProperty("name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.description != null && message.hasOwnProperty("description"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
            if (message.parameters != null && message.hasOwnProperty("parameters"))
                for (let keys = Object.keys(message.parameters), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.parameters[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Treatment message, length delimited. Does not implicitly {@link Experiment.Treatment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Experiment.Treatment
         * @static
         * @param {Experiment.ITreatment} message Treatment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Treatment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Treatment message from the specified reader or buffer.
         * @function decode
         * @memberof Experiment.Treatment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Experiment.Treatment} Treatment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Treatment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Treatment(), key;
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    reader.skip().pos++;
                    if (message.parameters === $util.emptyObject)
                        message.parameters = {};
                    key = reader.string();
                    reader.pos++;
                    message.parameters[key] = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Treatment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Experiment.Treatment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Experiment.Treatment} Treatment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Treatment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Treatment message.
         * @function verify
         * @memberof Experiment.Treatment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Treatment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.parameters != null && message.hasOwnProperty("parameters")) {
                if (!$util.isObject(message.parameters))
                    return "parameters: object expected";
                let key = Object.keys(message.parameters);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.parameters[key[i]]))
                        return "parameters: string{k:string} expected";
            }
            return null;
        };

        /**
         * Creates a Treatment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Experiment.Treatment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Experiment.Treatment} Treatment
         */
        Treatment.fromObject = function fromObject(object) {
            if (object instanceof $root.Experiment.Treatment)
                return object;
            let message = new $root.Experiment.Treatment();
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            if (object.parameters) {
                if (typeof object.parameters !== "object")
                    throw TypeError(".Experiment.Treatment.parameters: object expected");
                message.parameters = {};
                for (let keys = Object.keys(object.parameters), i = 0; i < keys.length; ++i)
                    message.parameters[keys[i]] = String(object.parameters[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a Treatment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Experiment.Treatment
         * @static
         * @param {Experiment.Treatment} message Treatment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Treatment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.parameters = {};
            if (options.defaults) {
                object.name = "";
                object.description = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            let keys2;
            if (message.parameters && (keys2 = Object.keys(message.parameters)).length) {
                object.parameters = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.parameters[keys2[j]] = message.parameters[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this Treatment to JSON.
         * @function toJSON
         * @memberof Experiment.Treatment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Treatment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Treatment;
    })();

    Experiment.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof Experiment
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof Experiment
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {Experiment.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof Experiment.Status
         * @static
         * @param {Experiment.IStatus=} [properties] Properties to set
         * @returns {Experiment.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link Experiment.Status.verify|verify} messages.
         * @function encode
         * @memberof Experiment.Status
         * @static
         * @param {Experiment.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link Experiment.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Experiment.Status
         * @static
         * @param {Experiment.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof Experiment.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Experiment.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Experiment.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Experiment.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Experiment.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof Experiment.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Experiment.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Experiment.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.Experiment.Status)
                return object;
            return new $root.Experiment.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Experiment.Status
         * @static
         * @param {Experiment.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof Experiment.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name Experiment.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} ONGOING=1 ONGOING value
         * @property {number} COMPLETE=2 COMPLETE value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "ONGOING"] = 1;
            values[valuesById[2] = "COMPLETE"] = 2;
            return values;
        })();

        return Status;
    })();

    return Experiment;
})();

export const ExperimentRequest = $root.ExperimentRequest = (() => {

    /**
     * Properties of an ExperimentRequest.
     * @exports IExperimentRequest
     * @interface IExperimentRequest
     * @property {string|null} [name] ExperimentRequest name
     * @property {string|null} [description] ExperimentRequest description
     * @property {Experiment.Status.Enum|null} [status] ExperimentRequest status
     * @property {Array.<Experiment.IAudience>|null} [audiences] ExperimentRequest audiences
     * @property {Array.<Experiment.ITreatment>|null} [treatments] ExperimentRequest treatments
     * @property {boolean|null} [is_fingerprint_xp] ExperimentRequest is_fingerprint_xp
     */

    /**
     * Constructs a new ExperimentRequest.
     * @exports ExperimentRequest
     * @classdesc Represents an ExperimentRequest.
     * @implements IExperimentRequest
     * @constructor
     * @param {IExperimentRequest=} [properties] Properties to set
     */
    function ExperimentRequest(properties) {
        this.audiences = [];
        this.treatments = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ExperimentRequest name.
     * @member {string} name
     * @memberof ExperimentRequest
     * @instance
     */
    ExperimentRequest.prototype.name = "";

    /**
     * ExperimentRequest description.
     * @member {string} description
     * @memberof ExperimentRequest
     * @instance
     */
    ExperimentRequest.prototype.description = "";

    /**
     * ExperimentRequest status.
     * @member {Experiment.Status.Enum} status
     * @memberof ExperimentRequest
     * @instance
     */
    ExperimentRequest.prototype.status = 0;

    /**
     * ExperimentRequest audiences.
     * @member {Array.<Experiment.IAudience>} audiences
     * @memberof ExperimentRequest
     * @instance
     */
    ExperimentRequest.prototype.audiences = $util.emptyArray;

    /**
     * ExperimentRequest treatments.
     * @member {Array.<Experiment.ITreatment>} treatments
     * @memberof ExperimentRequest
     * @instance
     */
    ExperimentRequest.prototype.treatments = $util.emptyArray;

    /**
     * ExperimentRequest is_fingerprint_xp.
     * @member {boolean} is_fingerprint_xp
     * @memberof ExperimentRequest
     * @instance
     */
    ExperimentRequest.prototype.is_fingerprint_xp = false;

    /**
     * Creates a new ExperimentRequest instance using the specified properties.
     * @function create
     * @memberof ExperimentRequest
     * @static
     * @param {IExperimentRequest=} [properties] Properties to set
     * @returns {ExperimentRequest} ExperimentRequest instance
     */
    ExperimentRequest.create = function create(properties) {
        return new ExperimentRequest(properties);
    };

    /**
     * Encodes the specified ExperimentRequest message. Does not implicitly {@link ExperimentRequest.verify|verify} messages.
     * @function encode
     * @memberof ExperimentRequest
     * @static
     * @param {IExperimentRequest} message ExperimentRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ExperimentRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.name != null && message.hasOwnProperty("name"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
        if (message.description != null && message.hasOwnProperty("description"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
        if (message.audiences != null && message.audiences.length)
            for (let i = 0; i < message.audiences.length; ++i)
                $root.Experiment.Audience.encode(message.audiences[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.treatments != null && message.treatments.length)
            for (let i = 0; i < message.treatments.length; ++i)
                $root.Experiment.Treatment.encode(message.treatments[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.is_fingerprint_xp != null && message.hasOwnProperty("is_fingerprint_xp"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.is_fingerprint_xp);
        return writer;
    };

    /**
     * Encodes the specified ExperimentRequest message, length delimited. Does not implicitly {@link ExperimentRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ExperimentRequest
     * @static
     * @param {IExperimentRequest} message ExperimentRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ExperimentRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ExperimentRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ExperimentRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ExperimentRequest} ExperimentRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ExperimentRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ExperimentRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.name = reader.string();
                break;
            case 2:
                message.description = reader.string();
                break;
            case 3:
                message.status = reader.int32();
                break;
            case 4:
                if (!(message.audiences && message.audiences.length))
                    message.audiences = [];
                message.audiences.push($root.Experiment.Audience.decode(reader, reader.uint32()));
                break;
            case 5:
                if (!(message.treatments && message.treatments.length))
                    message.treatments = [];
                message.treatments.push($root.Experiment.Treatment.decode(reader, reader.uint32()));
                break;
            case 6:
                message.is_fingerprint_xp = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ExperimentRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ExperimentRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ExperimentRequest} ExperimentRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ExperimentRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ExperimentRequest message.
     * @function verify
     * @memberof ExperimentRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ExperimentRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.audiences != null && message.hasOwnProperty("audiences")) {
            if (!Array.isArray(message.audiences))
                return "audiences: array expected";
            for (let i = 0; i < message.audiences.length; ++i) {
                let error = $root.Experiment.Audience.verify(message.audiences[i]);
                if (error)
                    return "audiences." + error;
            }
        }
        if (message.treatments != null && message.hasOwnProperty("treatments")) {
            if (!Array.isArray(message.treatments))
                return "treatments: array expected";
            for (let i = 0; i < message.treatments.length; ++i) {
                let error = $root.Experiment.Treatment.verify(message.treatments[i]);
                if (error)
                    return "treatments." + error;
            }
        }
        if (message.is_fingerprint_xp != null && message.hasOwnProperty("is_fingerprint_xp"))
            if (typeof message.is_fingerprint_xp !== "boolean")
                return "is_fingerprint_xp: boolean expected";
        return null;
    };

    /**
     * Creates an ExperimentRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ExperimentRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ExperimentRequest} ExperimentRequest
     */
    ExperimentRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ExperimentRequest)
            return object;
        let message = new $root.ExperimentRequest();
        if (object.name != null)
            message.name = String(object.name);
        if (object.description != null)
            message.description = String(object.description);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ONGOING":
        case 1:
            message.status = 1;
            break;
        case "COMPLETE":
        case 2:
            message.status = 2;
            break;
        }
        if (object.audiences) {
            if (!Array.isArray(object.audiences))
                throw TypeError(".ExperimentRequest.audiences: array expected");
            message.audiences = [];
            for (let i = 0; i < object.audiences.length; ++i) {
                if (typeof object.audiences[i] !== "object")
                    throw TypeError(".ExperimentRequest.audiences: object expected");
                message.audiences[i] = $root.Experiment.Audience.fromObject(object.audiences[i]);
            }
        }
        if (object.treatments) {
            if (!Array.isArray(object.treatments))
                throw TypeError(".ExperimentRequest.treatments: array expected");
            message.treatments = [];
            for (let i = 0; i < object.treatments.length; ++i) {
                if (typeof object.treatments[i] !== "object")
                    throw TypeError(".ExperimentRequest.treatments: object expected");
                message.treatments[i] = $root.Experiment.Treatment.fromObject(object.treatments[i]);
            }
        }
        if (object.is_fingerprint_xp != null)
            message.is_fingerprint_xp = Boolean(object.is_fingerprint_xp);
        return message;
    };

    /**
     * Creates a plain object from an ExperimentRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ExperimentRequest
     * @static
     * @param {ExperimentRequest} message ExperimentRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ExperimentRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.audiences = [];
            object.treatments = [];
        }
        if (options.defaults) {
            object.name = "";
            object.description = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.is_fingerprint_xp = false;
        }
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.Experiment.Status.Enum[message.status] : message.status;
        if (message.audiences && message.audiences.length) {
            object.audiences = [];
            for (let j = 0; j < message.audiences.length; ++j)
                object.audiences[j] = $root.Experiment.Audience.toObject(message.audiences[j], options);
        }
        if (message.treatments && message.treatments.length) {
            object.treatments = [];
            for (let j = 0; j < message.treatments.length; ++j)
                object.treatments[j] = $root.Experiment.Treatment.toObject(message.treatments[j], options);
        }
        if (message.is_fingerprint_xp != null && message.hasOwnProperty("is_fingerprint_xp"))
            object.is_fingerprint_xp = message.is_fingerprint_xp;
        return object;
    };

    /**
     * Converts this ExperimentRequest to JSON.
     * @function toJSON
     * @memberof ExperimentRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ExperimentRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ExperimentRequest;
})();

export const OCRTransactionReason = $root.OCRTransactionReason = (() => {

    /**
     * Properties of a OCRTransactionReason.
     * @exports IOCRTransactionReason
     * @interface IOCRTransactionReason
     */

    /**
     * Constructs a new OCRTransactionReason.
     * @exports OCRTransactionReason
     * @classdesc Represents a OCRTransactionReason.
     * @implements IOCRTransactionReason
     * @constructor
     * @param {IOCRTransactionReason=} [properties] Properties to set
     */
    function OCRTransactionReason(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new OCRTransactionReason instance using the specified properties.
     * @function create
     * @memberof OCRTransactionReason
     * @static
     * @param {IOCRTransactionReason=} [properties] Properties to set
     * @returns {OCRTransactionReason} OCRTransactionReason instance
     */
    OCRTransactionReason.create = function create(properties) {
        return new OCRTransactionReason(properties);
    };

    /**
     * Encodes the specified OCRTransactionReason message. Does not implicitly {@link OCRTransactionReason.verify|verify} messages.
     * @function encode
     * @memberof OCRTransactionReason
     * @static
     * @param {IOCRTransactionReason} message OCRTransactionReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRTransactionReason.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified OCRTransactionReason message, length delimited. Does not implicitly {@link OCRTransactionReason.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OCRTransactionReason
     * @static
     * @param {IOCRTransactionReason} message OCRTransactionReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OCRTransactionReason.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a OCRTransactionReason message from the specified reader or buffer.
     * @function decode
     * @memberof OCRTransactionReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OCRTransactionReason} OCRTransactionReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRTransactionReason.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OCRTransactionReason();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a OCRTransactionReason message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OCRTransactionReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OCRTransactionReason} OCRTransactionReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OCRTransactionReason.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a OCRTransactionReason message.
     * @function verify
     * @memberof OCRTransactionReason
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OCRTransactionReason.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a OCRTransactionReason message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OCRTransactionReason
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OCRTransactionReason} OCRTransactionReason
     */
    OCRTransactionReason.fromObject = function fromObject(object) {
        if (object instanceof $root.OCRTransactionReason)
            return object;
        return new $root.OCRTransactionReason();
    };

    /**
     * Creates a plain object from a OCRTransactionReason message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OCRTransactionReason
     * @static
     * @param {OCRTransactionReason} message OCRTransactionReason
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OCRTransactionReason.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this OCRTransactionReason to JSON.
     * @function toJSON
     * @memberof OCRTransactionReason
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OCRTransactionReason.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name OCRTransactionReason.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} CHANGE_BANK_ACCOUNT=1 CHANGE_BANK_ACCOUNT value
     * @property {number} MERGE_VOYAGER_ACCOUNT=2 MERGE_VOYAGER_ACCOUNT value
     */
    OCRTransactionReason.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "CHANGE_BANK_ACCOUNT"] = 1;
        values[valuesById[2] = "MERGE_VOYAGER_ACCOUNT"] = 2;
        return values;
    })();

    return OCRTransactionReason;
})();

export const PageInfo = $root.PageInfo = (() => {

    /**
     * Properties of a PageInfo.
     * @exports IPageInfo
     * @interface IPageInfo
     * @property {number|Long|null} [total] PageInfo total
     * @property {boolean|null} [has_previous_page] PageInfo has_previous_page
     * @property {boolean|null} [has_next_page] PageInfo has_next_page
     * @property {string|null} [start_cursor] PageInfo start_cursor
     * @property {string|null} [end_cursor] PageInfo end_cursor
     * @property {number|Long|null} [page_count] PageInfo page_count
     */

    /**
     * Constructs a new PageInfo.
     * @exports PageInfo
     * @classdesc Represents a PageInfo.
     * @implements IPageInfo
     * @constructor
     * @param {IPageInfo=} [properties] Properties to set
     */
    function PageInfo(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PageInfo total.
     * @member {number|Long} total
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PageInfo has_previous_page.
     * @member {boolean} has_previous_page
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.has_previous_page = false;

    /**
     * PageInfo has_next_page.
     * @member {boolean} has_next_page
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.has_next_page = false;

    /**
     * PageInfo start_cursor.
     * @member {string} start_cursor
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.start_cursor = "";

    /**
     * PageInfo end_cursor.
     * @member {string} end_cursor
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.end_cursor = "";

    /**
     * PageInfo page_count.
     * @member {number|Long} page_count
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.page_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new PageInfo instance using the specified properties.
     * @function create
     * @memberof PageInfo
     * @static
     * @param {IPageInfo=} [properties] Properties to set
     * @returns {PageInfo} PageInfo instance
     */
    PageInfo.create = function create(properties) {
        return new PageInfo(properties);
    };

    /**
     * Encodes the specified PageInfo message. Does not implicitly {@link PageInfo.verify|verify} messages.
     * @function encode
     * @memberof PageInfo
     * @static
     * @param {IPageInfo} message PageInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.total != null && message.hasOwnProperty("total"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.total);
        if (message.has_previous_page != null && message.hasOwnProperty("has_previous_page"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.has_previous_page);
        if (message.has_next_page != null && message.hasOwnProperty("has_next_page"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.has_next_page);
        if (message.start_cursor != null && message.hasOwnProperty("start_cursor"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.start_cursor);
        if (message.end_cursor != null && message.hasOwnProperty("end_cursor"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.end_cursor);
        if (message.page_count != null && message.hasOwnProperty("page_count"))
            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.page_count);
        return writer;
    };

    /**
     * Encodes the specified PageInfo message, length delimited. Does not implicitly {@link PageInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PageInfo
     * @static
     * @param {IPageInfo} message PageInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PageInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PageInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PageInfo} PageInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PageInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.total = reader.int64();
                break;
            case 2:
                message.has_previous_page = reader.bool();
                break;
            case 3:
                message.has_next_page = reader.bool();
                break;
            case 4:
                message.start_cursor = reader.string();
                break;
            case 5:
                message.end_cursor = reader.string();
                break;
            case 6:
                message.page_count = reader.int64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PageInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PageInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PageInfo} PageInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PageInfo message.
     * @function verify
     * @memberof PageInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PageInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.total != null && message.hasOwnProperty("total"))
            if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                return "total: integer|Long expected";
        if (message.has_previous_page != null && message.hasOwnProperty("has_previous_page"))
            if (typeof message.has_previous_page !== "boolean")
                return "has_previous_page: boolean expected";
        if (message.has_next_page != null && message.hasOwnProperty("has_next_page"))
            if (typeof message.has_next_page !== "boolean")
                return "has_next_page: boolean expected";
        if (message.start_cursor != null && message.hasOwnProperty("start_cursor"))
            if (!$util.isString(message.start_cursor))
                return "start_cursor: string expected";
        if (message.end_cursor != null && message.hasOwnProperty("end_cursor"))
            if (!$util.isString(message.end_cursor))
                return "end_cursor: string expected";
        if (message.page_count != null && message.hasOwnProperty("page_count"))
            if (!$util.isInteger(message.page_count) && !(message.page_count && $util.isInteger(message.page_count.low) && $util.isInteger(message.page_count.high)))
                return "page_count: integer|Long expected";
        return null;
    };

    /**
     * Creates a PageInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PageInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PageInfo} PageInfo
     */
    PageInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.PageInfo)
            return object;
        let message = new $root.PageInfo();
        if (object.total != null)
            if ($util.Long)
                (message.total = $util.Long.fromValue(object.total)).unsigned = false;
            else if (typeof object.total === "string")
                message.total = parseInt(object.total, 10);
            else if (typeof object.total === "number")
                message.total = object.total;
            else if (typeof object.total === "object")
                message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
        if (object.has_previous_page != null)
            message.has_previous_page = Boolean(object.has_previous_page);
        if (object.has_next_page != null)
            message.has_next_page = Boolean(object.has_next_page);
        if (object.start_cursor != null)
            message.start_cursor = String(object.start_cursor);
        if (object.end_cursor != null)
            message.end_cursor = String(object.end_cursor);
        if (object.page_count != null)
            if ($util.Long)
                (message.page_count = $util.Long.fromValue(object.page_count)).unsigned = false;
            else if (typeof object.page_count === "string")
                message.page_count = parseInt(object.page_count, 10);
            else if (typeof object.page_count === "number")
                message.page_count = object.page_count;
            else if (typeof object.page_count === "object")
                message.page_count = new $util.LongBits(object.page_count.low >>> 0, object.page_count.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a PageInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PageInfo
     * @static
     * @param {PageInfo} message PageInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PageInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.total = options.longs === String ? "0" : 0;
            object.has_previous_page = false;
            object.has_next_page = false;
            object.start_cursor = "";
            object.end_cursor = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.page_count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.page_count = options.longs === String ? "0" : 0;
        }
        if (message.total != null && message.hasOwnProperty("total"))
            if (typeof message.total === "number")
                object.total = options.longs === String ? String(message.total) : message.total;
            else
                object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
        if (message.has_previous_page != null && message.hasOwnProperty("has_previous_page"))
            object.has_previous_page = message.has_previous_page;
        if (message.has_next_page != null && message.hasOwnProperty("has_next_page"))
            object.has_next_page = message.has_next_page;
        if (message.start_cursor != null && message.hasOwnProperty("start_cursor"))
            object.start_cursor = message.start_cursor;
        if (message.end_cursor != null && message.hasOwnProperty("end_cursor"))
            object.end_cursor = message.end_cursor;
        if (message.page_count != null && message.hasOwnProperty("page_count"))
            if (typeof message.page_count === "number")
                object.page_count = options.longs === String ? String(message.page_count) : message.page_count;
            else
                object.page_count = options.longs === String ? $util.Long.prototype.toString.call(message.page_count) : options.longs === Number ? new $util.LongBits(message.page_count.low >>> 0, message.page_count.high >>> 0).toNumber() : message.page_count;
        return object;
    };

    /**
     * Converts this PageInfo to JSON.
     * @function toJSON
     * @memberof PageInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PageInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PageInfo;
})();

export const PageParams = $root.PageParams = (() => {

    /**
     * Properties of a PageParams.
     * @exports IPageParams
     * @interface IPageParams
     * @property {number|Long|null} [first] PageParams first
     * @property {string|null} [after] PageParams after
     * @property {string|null} [before] PageParams before
     */

    /**
     * Constructs a new PageParams.
     * @exports PageParams
     * @classdesc Represents a PageParams.
     * @implements IPageParams
     * @constructor
     * @param {IPageParams=} [properties] Properties to set
     */
    function PageParams(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PageParams first.
     * @member {number|Long} first
     * @memberof PageParams
     * @instance
     */
    PageParams.prototype.first = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PageParams after.
     * @member {string} after
     * @memberof PageParams
     * @instance
     */
    PageParams.prototype.after = "";

    /**
     * PageParams before.
     * @member {string} before
     * @memberof PageParams
     * @instance
     */
    PageParams.prototype.before = "";

    /**
     * Creates a new PageParams instance using the specified properties.
     * @function create
     * @memberof PageParams
     * @static
     * @param {IPageParams=} [properties] Properties to set
     * @returns {PageParams} PageParams instance
     */
    PageParams.create = function create(properties) {
        return new PageParams(properties);
    };

    /**
     * Encodes the specified PageParams message. Does not implicitly {@link PageParams.verify|verify} messages.
     * @function encode
     * @memberof PageParams
     * @static
     * @param {IPageParams} message PageParams message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageParams.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.first != null && message.hasOwnProperty("first"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.first);
        if (message.after != null && message.hasOwnProperty("after"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.after);
        if (message.before != null && message.hasOwnProperty("before"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.before);
        return writer;
    };

    /**
     * Encodes the specified PageParams message, length delimited. Does not implicitly {@link PageParams.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PageParams
     * @static
     * @param {IPageParams} message PageParams message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageParams.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PageParams message from the specified reader or buffer.
     * @function decode
     * @memberof PageParams
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PageParams} PageParams
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageParams.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PageParams();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.first = reader.int64();
                break;
            case 2:
                message.after = reader.string();
                break;
            case 3:
                message.before = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PageParams message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PageParams
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PageParams} PageParams
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageParams.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PageParams message.
     * @function verify
     * @memberof PageParams
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PageParams.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.first != null && message.hasOwnProperty("first"))
            if (!$util.isInteger(message.first) && !(message.first && $util.isInteger(message.first.low) && $util.isInteger(message.first.high)))
                return "first: integer|Long expected";
        if (message.after != null && message.hasOwnProperty("after"))
            if (!$util.isString(message.after))
                return "after: string expected";
        if (message.before != null && message.hasOwnProperty("before"))
            if (!$util.isString(message.before))
                return "before: string expected";
        return null;
    };

    /**
     * Creates a PageParams message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PageParams
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PageParams} PageParams
     */
    PageParams.fromObject = function fromObject(object) {
        if (object instanceof $root.PageParams)
            return object;
        let message = new $root.PageParams();
        if (object.first != null)
            if ($util.Long)
                (message.first = $util.Long.fromValue(object.first)).unsigned = false;
            else if (typeof object.first === "string")
                message.first = parseInt(object.first, 10);
            else if (typeof object.first === "number")
                message.first = object.first;
            else if (typeof object.first === "object")
                message.first = new $util.LongBits(object.first.low >>> 0, object.first.high >>> 0).toNumber();
        if (object.after != null)
            message.after = String(object.after);
        if (object.before != null)
            message.before = String(object.before);
        return message;
    };

    /**
     * Creates a plain object from a PageParams message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PageParams
     * @static
     * @param {PageParams} message PageParams
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PageParams.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.first = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.first = options.longs === String ? "0" : 0;
            object.after = "";
            object.before = "";
        }
        if (message.first != null && message.hasOwnProperty("first"))
            if (typeof message.first === "number")
                object.first = options.longs === String ? String(message.first) : message.first;
            else
                object.first = options.longs === String ? $util.Long.prototype.toString.call(message.first) : options.longs === Number ? new $util.LongBits(message.first.low >>> 0, message.first.high >>> 0).toNumber() : message.first;
        if (message.after != null && message.hasOwnProperty("after"))
            object.after = message.after;
        if (message.before != null && message.hasOwnProperty("before"))
            object.before = message.before;
        return object;
    };

    /**
     * Converts this PageParams to JSON.
     * @function toJSON
     * @memberof PageParams
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PageParams.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PageParams;
})();

export const SaverPortfolio = $root.SaverPortfolio = (() => {

    /**
     * Properties of a SaverPortfolio.
     * @exports ISaverPortfolio
     * @interface ISaverPortfolio
     */

    /**
     * Constructs a new SaverPortfolio.
     * @exports SaverPortfolio
     * @classdesc Represents a SaverPortfolio.
     * @implements ISaverPortfolio
     * @constructor
     * @param {ISaverPortfolio=} [properties] Properties to set
     */
    function SaverPortfolio(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SaverPortfolio instance using the specified properties.
     * @function create
     * @memberof SaverPortfolio
     * @static
     * @param {ISaverPortfolio=} [properties] Properties to set
     * @returns {SaverPortfolio} SaverPortfolio instance
     */
    SaverPortfolio.create = function create(properties) {
        return new SaverPortfolio(properties);
    };

    /**
     * Encodes the specified SaverPortfolio message. Does not implicitly {@link SaverPortfolio.verify|verify} messages.
     * @function encode
     * @memberof SaverPortfolio
     * @static
     * @param {ISaverPortfolio} message SaverPortfolio message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SaverPortfolio.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified SaverPortfolio message, length delimited. Does not implicitly {@link SaverPortfolio.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SaverPortfolio
     * @static
     * @param {ISaverPortfolio} message SaverPortfolio message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SaverPortfolio.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SaverPortfolio message from the specified reader or buffer.
     * @function decode
     * @memberof SaverPortfolio
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SaverPortfolio} SaverPortfolio
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SaverPortfolio.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SaverPortfolio();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SaverPortfolio message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SaverPortfolio
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SaverPortfolio} SaverPortfolio
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SaverPortfolio.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SaverPortfolio message.
     * @function verify
     * @memberof SaverPortfolio
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SaverPortfolio.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a SaverPortfolio message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SaverPortfolio
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SaverPortfolio} SaverPortfolio
     */
    SaverPortfolio.fromObject = function fromObject(object) {
        if (object instanceof $root.SaverPortfolio)
            return object;
        return new $root.SaverPortfolio();
    };

    /**
     * Creates a plain object from a SaverPortfolio message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SaverPortfolio
     * @static
     * @param {SaverPortfolio} message SaverPortfolio
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SaverPortfolio.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this SaverPortfolio to JSON.
     * @function toJSON
     * @memberof SaverPortfolio
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SaverPortfolio.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name SaverPortfolio.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} INDEX=1 INDEX value
     * @property {number} UNIVERSE=2 UNIVERSE value
     * @property {number} EARTH=3 EARTH value
     * @property {number} GALAXY=4 GALAXY value
     * @property {number} EXPLORER=5 EXPLORER value
     */
    SaverPortfolio.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "INDEX"] = 1;
        values[valuesById[2] = "UNIVERSE"] = 2;
        values[valuesById[3] = "EARTH"] = 3;
        values[valuesById[4] = "GALAXY"] = 4;
        values[valuesById[5] = "EXPLORER"] = 5;
        return values;
    })();

    return SaverPortfolio;
})();

export const SaverProductInstance = $root.SaverProductInstance = (() => {

    /**
     * Properties of a SaverProductInstance.
     * @exports ISaverProductInstance
     * @interface ISaverProductInstance
     * @property {string|null} [id] SaverProductInstance id
     * @property {string|null} [account_id] SaverProductInstance account_id
     * @property {SaverPortfolio.Enum|null} [portfolio] SaverProductInstance portfolio
     * @property {google.protobuf.ITimestamp|null} [created_at] SaverProductInstance created_at
     * @property {boolean|null} [is_tfn_provided] SaverProductInstance is_tfn_provided
     * @property {TFNExemptionCode.Enum|null} [tfn_exemption_code] SaverProductInstance tfn_exemption_code
     * @property {google.protobuf.ITimestamp|null} [tfn_last_updated_at] SaverProductInstance tfn_last_updated_at
     * @property {SaverProductInstance.ProductStatus.Enum|null} [status] SaverProductInstance status
     * @property {google.protobuf.ITimestamp|null} [documents_accepted_at] SaverProductInstance documents_accepted_at
     */

    /**
     * Constructs a new SaverProductInstance.
     * @exports SaverProductInstance
     * @classdesc Represents a SaverProductInstance.
     * @implements ISaverProductInstance
     * @constructor
     * @param {ISaverProductInstance=} [properties] Properties to set
     */
    function SaverProductInstance(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SaverProductInstance id.
     * @member {string} id
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.id = "";

    /**
     * SaverProductInstance account_id.
     * @member {string} account_id
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.account_id = "";

    /**
     * SaverProductInstance portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.portfolio = 0;

    /**
     * SaverProductInstance created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.created_at = null;

    /**
     * SaverProductInstance is_tfn_provided.
     * @member {boolean} is_tfn_provided
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.is_tfn_provided = false;

    /**
     * SaverProductInstance tfn_exemption_code.
     * @member {TFNExemptionCode.Enum} tfn_exemption_code
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.tfn_exemption_code = 0;

    /**
     * SaverProductInstance tfn_last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} tfn_last_updated_at
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.tfn_last_updated_at = null;

    /**
     * SaverProductInstance status.
     * @member {SaverProductInstance.ProductStatus.Enum} status
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.status = 0;

    /**
     * SaverProductInstance documents_accepted_at.
     * @member {google.protobuf.ITimestamp|null|undefined} documents_accepted_at
     * @memberof SaverProductInstance
     * @instance
     */
    SaverProductInstance.prototype.documents_accepted_at = null;

    /**
     * Creates a new SaverProductInstance instance using the specified properties.
     * @function create
     * @memberof SaverProductInstance
     * @static
     * @param {ISaverProductInstance=} [properties] Properties to set
     * @returns {SaverProductInstance} SaverProductInstance instance
     */
    SaverProductInstance.create = function create(properties) {
        return new SaverProductInstance(properties);
    };

    /**
     * Encodes the specified SaverProductInstance message. Does not implicitly {@link SaverProductInstance.verify|verify} messages.
     * @function encode
     * @memberof SaverProductInstance
     * @static
     * @param {ISaverProductInstance} message SaverProductInstance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SaverProductInstance.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.portfolio);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.is_tfn_provided != null && message.hasOwnProperty("is_tfn_provided"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.is_tfn_provided);
        if (message.tfn_exemption_code != null && message.hasOwnProperty("tfn_exemption_code"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.tfn_exemption_code);
        if (message.tfn_last_updated_at != null && message.hasOwnProperty("tfn_last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.tfn_last_updated_at, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
        if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at"))
            $root.google.protobuf.Timestamp.encode(message.documents_accepted_at, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SaverProductInstance message, length delimited. Does not implicitly {@link SaverProductInstance.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SaverProductInstance
     * @static
     * @param {ISaverProductInstance} message SaverProductInstance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SaverProductInstance.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SaverProductInstance message from the specified reader or buffer.
     * @function decode
     * @memberof SaverProductInstance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SaverProductInstance} SaverProductInstance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SaverProductInstance.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SaverProductInstance();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.account_id = reader.string();
                break;
            case 3:
                message.portfolio = reader.int32();
                break;
            case 4:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 5:
                message.is_tfn_provided = reader.bool();
                break;
            case 6:
                message.tfn_exemption_code = reader.int32();
                break;
            case 7:
                message.tfn_last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 8:
                message.status = reader.int32();
                break;
            case 10:
                message.documents_accepted_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SaverProductInstance message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SaverProductInstance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SaverProductInstance} SaverProductInstance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SaverProductInstance.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SaverProductInstance message.
     * @function verify
     * @memberof SaverProductInstance
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SaverProductInstance.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            if (!$util.isString(message.account_id))
                return "account_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.is_tfn_provided != null && message.hasOwnProperty("is_tfn_provided"))
            if (typeof message.is_tfn_provided !== "boolean")
                return "is_tfn_provided: boolean expected";
        if (message.tfn_exemption_code != null && message.hasOwnProperty("tfn_exemption_code"))
            switch (message.tfn_exemption_code) {
            default:
                return "tfn_exemption_code: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                break;
            }
        if (message.tfn_last_updated_at != null && message.hasOwnProperty("tfn_last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.tfn_last_updated_at);
            if (error)
                return "tfn_last_updated_at." + error;
        }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.documents_accepted_at);
            if (error)
                return "documents_accepted_at." + error;
        }
        return null;
    };

    /**
     * Creates a SaverProductInstance message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SaverProductInstance
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SaverProductInstance} SaverProductInstance
     */
    SaverProductInstance.fromObject = function fromObject(object) {
        if (object instanceof $root.SaverProductInstance)
            return object;
        let message = new $root.SaverProductInstance();
        if (object.id != null)
            message.id = String(object.id);
        if (object.account_id != null)
            message.account_id = String(object.account_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".SaverProductInstance.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.is_tfn_provided != null)
            message.is_tfn_provided = Boolean(object.is_tfn_provided);
        switch (object.tfn_exemption_code) {
        case "UNKNOWN":
        case 0:
            message.tfn_exemption_code = 0;
            break;
        case "PENSIONER":
        case 1:
            message.tfn_exemption_code = 1;
            break;
        case "CENTRELINK":
        case 2:
            message.tfn_exemption_code = 2;
            break;
        case "UNDER_16":
        case 3:
            message.tfn_exemption_code = 3;
            break;
        case "ENTITY_NOT_REQUIRED":
        case 4:
            message.tfn_exemption_code = 4;
            break;
        case "BUSINESS_INVESTOR":
        case 5:
            message.tfn_exemption_code = 5;
            break;
        case "NON_RESIDENT":
        case 6:
            message.tfn_exemption_code = 6;
            break;
        case "NOT_AN_ABN":
        case 7:
            message.tfn_exemption_code = 7;
            break;
        }
        if (object.tfn_last_updated_at != null) {
            if (typeof object.tfn_last_updated_at !== "object")
                throw TypeError(".SaverProductInstance.tfn_last_updated_at: object expected");
            message.tfn_last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.tfn_last_updated_at);
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ACTIVE":
        case 1:
            message.status = 1;
            break;
        case "INACTIVE":
        case 2:
            message.status = 2;
            break;
        }
        if (object.documents_accepted_at != null) {
            if (typeof object.documents_accepted_at !== "object")
                throw TypeError(".SaverProductInstance.documents_accepted_at: object expected");
            message.documents_accepted_at = $root.google.protobuf.Timestamp.fromObject(object.documents_accepted_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a SaverProductInstance message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SaverProductInstance
     * @static
     * @param {SaverProductInstance} message SaverProductInstance
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SaverProductInstance.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.account_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.is_tfn_provided = false;
            object.tfn_exemption_code = options.enums === String ? "UNKNOWN" : 0;
            object.tfn_last_updated_at = null;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.documents_accepted_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            object.account_id = message.account_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.is_tfn_provided != null && message.hasOwnProperty("is_tfn_provided"))
            object.is_tfn_provided = message.is_tfn_provided;
        if (message.tfn_exemption_code != null && message.hasOwnProperty("tfn_exemption_code"))
            object.tfn_exemption_code = options.enums === String ? $root.TFNExemptionCode.Enum[message.tfn_exemption_code] : message.tfn_exemption_code;
        if (message.tfn_last_updated_at != null && message.hasOwnProperty("tfn_last_updated_at"))
            object.tfn_last_updated_at = $root.google.protobuf.Timestamp.toObject(message.tfn_last_updated_at, options);
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.SaverProductInstance.ProductStatus.Enum[message.status] : message.status;
        if (message.documents_accepted_at != null && message.hasOwnProperty("documents_accepted_at"))
            object.documents_accepted_at = $root.google.protobuf.Timestamp.toObject(message.documents_accepted_at, options);
        return object;
    };

    /**
     * Converts this SaverProductInstance to JSON.
     * @function toJSON
     * @memberof SaverProductInstance
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SaverProductInstance.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SaverProductInstance.ProductStatus = (function() {

        /**
         * Properties of a ProductStatus.
         * @memberof SaverProductInstance
         * @interface IProductStatus
         */

        /**
         * Constructs a new ProductStatus.
         * @memberof SaverProductInstance
         * @classdesc Represents a ProductStatus.
         * @implements IProductStatus
         * @constructor
         * @param {SaverProductInstance.IProductStatus=} [properties] Properties to set
         */
        function ProductStatus(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ProductStatus instance using the specified properties.
         * @function create
         * @memberof SaverProductInstance.ProductStatus
         * @static
         * @param {SaverProductInstance.IProductStatus=} [properties] Properties to set
         * @returns {SaverProductInstance.ProductStatus} ProductStatus instance
         */
        ProductStatus.create = function create(properties) {
            return new ProductStatus(properties);
        };

        /**
         * Encodes the specified ProductStatus message. Does not implicitly {@link SaverProductInstance.ProductStatus.verify|verify} messages.
         * @function encode
         * @memberof SaverProductInstance.ProductStatus
         * @static
         * @param {SaverProductInstance.IProductStatus} message ProductStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductStatus.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ProductStatus message, length delimited. Does not implicitly {@link SaverProductInstance.ProductStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SaverProductInstance.ProductStatus
         * @static
         * @param {SaverProductInstance.IProductStatus} message ProductStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProductStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProductStatus message from the specified reader or buffer.
         * @function decode
         * @memberof SaverProductInstance.ProductStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SaverProductInstance.ProductStatus} ProductStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductStatus.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SaverProductInstance.ProductStatus();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProductStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SaverProductInstance.ProductStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SaverProductInstance.ProductStatus} ProductStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProductStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProductStatus message.
         * @function verify
         * @memberof SaverProductInstance.ProductStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProductStatus.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ProductStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SaverProductInstance.ProductStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SaverProductInstance.ProductStatus} ProductStatus
         */
        ProductStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.SaverProductInstance.ProductStatus)
                return object;
            return new $root.SaverProductInstance.ProductStatus();
        };

        /**
         * Creates a plain object from a ProductStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SaverProductInstance.ProductStatus
         * @static
         * @param {SaverProductInstance.ProductStatus} message ProductStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProductStatus.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ProductStatus to JSON.
         * @function toJSON
         * @memberof SaverProductInstance.ProductStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProductStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name SaverProductInstance.ProductStatus.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} ACTIVE=1 ACTIVE value
         * @property {number} INACTIVE=2 INACTIVE value
         */
        ProductStatus.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "ACTIVE"] = 1;
            values[valuesById[2] = "INACTIVE"] = 2;
            return values;
        })();

        return ProductStatus;
    })();

    return SaverProductInstance;
})();

export const BankAccountName = $root.BankAccountName = (() => {

    /**
     * Properties of a BankAccountName.
     * @exports IBankAccountName
     * @interface IBankAccountName
     */

    /**
     * Constructs a new BankAccountName.
     * @exports BankAccountName
     * @classdesc Represents a BankAccountName.
     * @implements IBankAccountName
     * @constructor
     * @param {IBankAccountName=} [properties] Properties to set
     */
    function BankAccountName(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new BankAccountName instance using the specified properties.
     * @function create
     * @memberof BankAccountName
     * @static
     * @param {IBankAccountName=} [properties] Properties to set
     * @returns {BankAccountName} BankAccountName instance
     */
    BankAccountName.create = function create(properties) {
        return new BankAccountName(properties);
    };

    /**
     * Encodes the specified BankAccountName message. Does not implicitly {@link BankAccountName.verify|verify} messages.
     * @function encode
     * @memberof BankAccountName
     * @static
     * @param {IBankAccountName} message BankAccountName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccountName.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified BankAccountName message, length delimited. Does not implicitly {@link BankAccountName.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BankAccountName
     * @static
     * @param {IBankAccountName} message BankAccountName message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccountName.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BankAccountName message from the specified reader or buffer.
     * @function decode
     * @memberof BankAccountName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BankAccountName} BankAccountName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccountName.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BankAccountName();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BankAccountName message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BankAccountName
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BankAccountName} BankAccountName
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccountName.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BankAccountName message.
     * @function verify
     * @memberof BankAccountName
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BankAccountName.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a BankAccountName message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BankAccountName
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BankAccountName} BankAccountName
     */
    BankAccountName.fromObject = function fromObject(object) {
        if (object instanceof $root.BankAccountName)
            return object;
        return new $root.BankAccountName();
    };

    /**
     * Creates a plain object from a BankAccountName message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BankAccountName
     * @static
     * @param {BankAccountName} message BankAccountName
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BankAccountName.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this BankAccountName to JSON.
     * @function toJSON
     * @memberof BankAccountName
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BankAccountName.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name BankAccountName.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} MACQUARIE_SUSPENSE_UNIVERSE=1 MACQUARIE_SUSPENSE_UNIVERSE value
     * @property {number} MACQUARIE_SUSPENSE_INDEX=2 MACQUARIE_SUSPENSE_INDEX value
     * @property {number} MACQUARIE_SUSPENSE_SHARED=3 MACQUARIE_SUSPENSE_SHARED value
     * @property {number} MACQUARIE_FUND_UNIVERSE=4 MACQUARIE_FUND_UNIVERSE value
     * @property {number} MACQUARIE_FUND_INDEX=5 MACQUARIE_FUND_INDEX value
     * @property {number} MACQUARIE_DISTRIBUTIONS_UNIVERSE=6 MACQUARIE_DISTRIBUTIONS_UNIVERSE value
     * @property {number} MACQUARIE_DISTRIBUTIONS_INDEX=7 MACQUARIE_DISTRIBUTIONS_INDEX value
     * @property {number} MACQUARIE_FREEBIES_UNIVERSE=8 MACQUARIE_FREEBIES_UNIVERSE value
     * @property {number} MACQUARIE_FREEBIES_INDEX=9 MACQUARIE_FREEBIES_INDEX value
     * @property {number} MACQUARIE_FREEBIES_EARTH=10 MACQUARIE_FREEBIES_EARTH value
     * @property {number} MACQUARIE_SUSPENSE_EARTH=11 MACQUARIE_SUSPENSE_EARTH value
     * @property {number} MACQUARIE_FUND_EARTH=12 MACQUARIE_FUND_EARTH value
     * @property {number} MACQUARIE_DISTRIBUTIONS_EARTH=13 MACQUARIE_DISTRIBUTIONS_EARTH value
     * @property {number} ZEPTO_FLOAT_ORIGIN=14 ZEPTO_FLOAT_ORIGIN value
     * @property {number} ZEPTO_FLOAT_UNIVERSE=15 ZEPTO_FLOAT_UNIVERSE value
     * @property {number} ZEPTO_FLOAT_EARTH=16 ZEPTO_FLOAT_EARTH value
     * @property {number} ZEPTO_FLOAT_NOVA=17 ZEPTO_FLOAT_NOVA value
     * @property {number} ZEPTO_TRUST_ORIGIN=18 ZEPTO_TRUST_ORIGIN value
     * @property {number} ZEPTO_TRUST_UNIVERSE=19 ZEPTO_TRUST_UNIVERSE value
     * @property {number} ZEPTO_TRUST_EARTH=20 ZEPTO_TRUST_EARTH value
     * @property {number} ZEPTO_TRUST_NOVA=21 ZEPTO_TRUST_NOVA value
     * @property {number} ZEPTO_FLOAT_NOVA_FEES=22 ZEPTO_FLOAT_NOVA_FEES value
     * @property {number} ZEPTO_TRUST_CASH=23 ZEPTO_TRUST_CASH value
     * @property {number} ZEPTO_TRUST_GALAXY=24 ZEPTO_TRUST_GALAXY value
     * @property {number} ZEPTO_TRUST_EXPLORER=25 ZEPTO_TRUST_EXPLORER value
     * @property {number} ZEPTO_FLOAT_GALAXY=26 ZEPTO_FLOAT_GALAXY value
     * @property {number} ZEPTO_FLOAT_EXPLORER=27 ZEPTO_FLOAT_EXPLORER value
     * @property {number} ZEPTO_DISTRIBUTIONS_EXPLORER=28 ZEPTO_DISTRIBUTIONS_EXPLORER value
     * @property {number} ZEPTO_DISTRIBUTIONS_GALAXY=29 ZEPTO_DISTRIBUTIONS_GALAXY value
     * @property {number} ZEPTO_DISTRIBUTIONS_INDEX=30 ZEPTO_DISTRIBUTIONS_INDEX value
     * @property {number} ZEPTO_DISTRIBUTIONS_UNIVERSE=31 ZEPTO_DISTRIBUTIONS_UNIVERSE value
     * @property {number} ZEPTO_DISTRIBUTIONS_EARTH=32 ZEPTO_DISTRIBUTIONS_EARTH value
     * @property {number} ZEPTO_TRUST_CASH_MISC=33 ZEPTO_TRUST_CASH_MISC value
     * @property {number} WESTPAC_SUSPENSE_ORIGIN=51 WESTPAC_SUSPENSE_ORIGIN value
     * @property {number} WESTPAC_SUSPENSE_UNIVERSE=52 WESTPAC_SUSPENSE_UNIVERSE value
     * @property {number} WESTPAC_SUSPENSE_EARTH=53 WESTPAC_SUSPENSE_EARTH value
     * @property {number} WESTPAC_FUND_ORIGIN=54 WESTPAC_FUND_ORIGIN value
     * @property {number} WESTPAC_FUND_UNIVERSE=55 WESTPAC_FUND_UNIVERSE value
     * @property {number} WESTPAC_FUND_EARTH=56 WESTPAC_FUND_EARTH value
     * @property {number} WESTPAC_DISTRIBUTIONS_ORIGIN=57 WESTPAC_DISTRIBUTIONS_ORIGIN value
     * @property {number} WESTPAC_DISTRIBUTIONS_UNIVERSE=58 WESTPAC_DISTRIBUTIONS_UNIVERSE value
     * @property {number} WESTPAC_DISTRIBUTIONS_EARTH=59 WESTPAC_DISTRIBUTIONS_EARTH value
     * @property {number} WESTPAC_FREEBIES_SHARED=60 WESTPAC_FREEBIES_SHARED value
     * @property {number} WESTPAC_FEES_AND_CHARGES=61 WESTPAC_FEES_AND_CHARGES value
     * @property {number} WESTPAC_981B_NOVA=62 WESTPAC_981B_NOVA value
     * @property {number} WESTPAC_NOVA_FEES=63 WESTPAC_NOVA_FEES value
     * @property {number} WESTPAC_NOVA_MISC=64 WESTPAC_NOVA_MISC value
     * @property {number} WESTPAC_SAVER_FIXED_FEES=65 WESTPAC_SAVER_FIXED_FEES value
     * @property {number} WESTPAC_SAVER_BPS_FEES=66 WESTPAC_SAVER_BPS_FEES value
     * @property {number} ALPACA_AIRWALLEX=100 ALPACA_AIRWALLEX value
     * @property {number} IB_ORIGIN=200 IB_ORIGIN value
     * @property {number} IB_UNIVERSE=201 IB_UNIVERSE value
     * @property {number} IB_EARTH=202 IB_EARTH value
     * @property {number} IB_EXPLORER=203 IB_EXPLORER value
     * @property {number} IB_GALAXY=204 IB_GALAXY value
     */
    BankAccountName.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "MACQUARIE_SUSPENSE_UNIVERSE"] = 1;
        values[valuesById[2] = "MACQUARIE_SUSPENSE_INDEX"] = 2;
        values[valuesById[3] = "MACQUARIE_SUSPENSE_SHARED"] = 3;
        values[valuesById[4] = "MACQUARIE_FUND_UNIVERSE"] = 4;
        values[valuesById[5] = "MACQUARIE_FUND_INDEX"] = 5;
        values[valuesById[6] = "MACQUARIE_DISTRIBUTIONS_UNIVERSE"] = 6;
        values[valuesById[7] = "MACQUARIE_DISTRIBUTIONS_INDEX"] = 7;
        values[valuesById[8] = "MACQUARIE_FREEBIES_UNIVERSE"] = 8;
        values[valuesById[9] = "MACQUARIE_FREEBIES_INDEX"] = 9;
        values[valuesById[10] = "MACQUARIE_FREEBIES_EARTH"] = 10;
        values[valuesById[11] = "MACQUARIE_SUSPENSE_EARTH"] = 11;
        values[valuesById[12] = "MACQUARIE_FUND_EARTH"] = 12;
        values[valuesById[13] = "MACQUARIE_DISTRIBUTIONS_EARTH"] = 13;
        values[valuesById[14] = "ZEPTO_FLOAT_ORIGIN"] = 14;
        values[valuesById[15] = "ZEPTO_FLOAT_UNIVERSE"] = 15;
        values[valuesById[16] = "ZEPTO_FLOAT_EARTH"] = 16;
        values[valuesById[17] = "ZEPTO_FLOAT_NOVA"] = 17;
        values[valuesById[18] = "ZEPTO_TRUST_ORIGIN"] = 18;
        values[valuesById[19] = "ZEPTO_TRUST_UNIVERSE"] = 19;
        values[valuesById[20] = "ZEPTO_TRUST_EARTH"] = 20;
        values[valuesById[21] = "ZEPTO_TRUST_NOVA"] = 21;
        values[valuesById[22] = "ZEPTO_FLOAT_NOVA_FEES"] = 22;
        values[valuesById[23] = "ZEPTO_TRUST_CASH"] = 23;
        values[valuesById[24] = "ZEPTO_TRUST_GALAXY"] = 24;
        values[valuesById[25] = "ZEPTO_TRUST_EXPLORER"] = 25;
        values[valuesById[26] = "ZEPTO_FLOAT_GALAXY"] = 26;
        values[valuesById[27] = "ZEPTO_FLOAT_EXPLORER"] = 27;
        values[valuesById[28] = "ZEPTO_DISTRIBUTIONS_EXPLORER"] = 28;
        values[valuesById[29] = "ZEPTO_DISTRIBUTIONS_GALAXY"] = 29;
        values[valuesById[30] = "ZEPTO_DISTRIBUTIONS_INDEX"] = 30;
        values[valuesById[31] = "ZEPTO_DISTRIBUTIONS_UNIVERSE"] = 31;
        values[valuesById[32] = "ZEPTO_DISTRIBUTIONS_EARTH"] = 32;
        values[valuesById[33] = "ZEPTO_TRUST_CASH_MISC"] = 33;
        values[valuesById[51] = "WESTPAC_SUSPENSE_ORIGIN"] = 51;
        values[valuesById[52] = "WESTPAC_SUSPENSE_UNIVERSE"] = 52;
        values[valuesById[53] = "WESTPAC_SUSPENSE_EARTH"] = 53;
        values[valuesById[54] = "WESTPAC_FUND_ORIGIN"] = 54;
        values[valuesById[55] = "WESTPAC_FUND_UNIVERSE"] = 55;
        values[valuesById[56] = "WESTPAC_FUND_EARTH"] = 56;
        values[valuesById[57] = "WESTPAC_DISTRIBUTIONS_ORIGIN"] = 57;
        values[valuesById[58] = "WESTPAC_DISTRIBUTIONS_UNIVERSE"] = 58;
        values[valuesById[59] = "WESTPAC_DISTRIBUTIONS_EARTH"] = 59;
        values[valuesById[60] = "WESTPAC_FREEBIES_SHARED"] = 60;
        values[valuesById[61] = "WESTPAC_FEES_AND_CHARGES"] = 61;
        values[valuesById[62] = "WESTPAC_981B_NOVA"] = 62;
        values[valuesById[63] = "WESTPAC_NOVA_FEES"] = 63;
        values[valuesById[64] = "WESTPAC_NOVA_MISC"] = 64;
        values[valuesById[65] = "WESTPAC_SAVER_FIXED_FEES"] = 65;
        values[valuesById[66] = "WESTPAC_SAVER_BPS_FEES"] = 66;
        values[valuesById[100] = "ALPACA_AIRWALLEX"] = 100;
        values[valuesById[200] = "IB_ORIGIN"] = 200;
        values[valuesById[201] = "IB_UNIVERSE"] = 201;
        values[valuesById[202] = "IB_EARTH"] = 202;
        values[valuesById[203] = "IB_EXPLORER"] = 203;
        values[valuesById[204] = "IB_GALAXY"] = 204;
        return values;
    })();

    return BankAccountName;
})();

export const SchedulerFrequency = $root.SchedulerFrequency = (() => {

    /**
     * Properties of a SchedulerFrequency.
     * @exports ISchedulerFrequency
     * @interface ISchedulerFrequency
     */

    /**
     * Constructs a new SchedulerFrequency.
     * @exports SchedulerFrequency
     * @classdesc Represents a SchedulerFrequency.
     * @implements ISchedulerFrequency
     * @constructor
     * @param {ISchedulerFrequency=} [properties] Properties to set
     */
    function SchedulerFrequency(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SchedulerFrequency instance using the specified properties.
     * @function create
     * @memberof SchedulerFrequency
     * @static
     * @param {ISchedulerFrequency=} [properties] Properties to set
     * @returns {SchedulerFrequency} SchedulerFrequency instance
     */
    SchedulerFrequency.create = function create(properties) {
        return new SchedulerFrequency(properties);
    };

    /**
     * Encodes the specified SchedulerFrequency message. Does not implicitly {@link SchedulerFrequency.verify|verify} messages.
     * @function encode
     * @memberof SchedulerFrequency
     * @static
     * @param {ISchedulerFrequency} message SchedulerFrequency message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SchedulerFrequency.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified SchedulerFrequency message, length delimited. Does not implicitly {@link SchedulerFrequency.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SchedulerFrequency
     * @static
     * @param {ISchedulerFrequency} message SchedulerFrequency message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SchedulerFrequency.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SchedulerFrequency message from the specified reader or buffer.
     * @function decode
     * @memberof SchedulerFrequency
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SchedulerFrequency} SchedulerFrequency
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SchedulerFrequency.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SchedulerFrequency();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SchedulerFrequency message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SchedulerFrequency
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SchedulerFrequency} SchedulerFrequency
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SchedulerFrequency.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SchedulerFrequency message.
     * @function verify
     * @memberof SchedulerFrequency
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SchedulerFrequency.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a SchedulerFrequency message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SchedulerFrequency
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SchedulerFrequency} SchedulerFrequency
     */
    SchedulerFrequency.fromObject = function fromObject(object) {
        if (object instanceof $root.SchedulerFrequency)
            return object;
        return new $root.SchedulerFrequency();
    };

    /**
     * Creates a plain object from a SchedulerFrequency message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SchedulerFrequency
     * @static
     * @param {SchedulerFrequency} message SchedulerFrequency
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SchedulerFrequency.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this SchedulerFrequency to JSON.
     * @function toJSON
     * @memberof SchedulerFrequency
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SchedulerFrequency.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name SchedulerFrequency.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ONE_TIME=1 ONE_TIME value
     * @property {number} WEEKLY=2 WEEKLY value
     * @property {number} FORTNIGHTLY=3 FORTNIGHTLY value
     * @property {number} MONTHLY=4 MONTHLY value
     */
    SchedulerFrequency.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ONE_TIME"] = 1;
        values[valuesById[2] = "WEEKLY"] = 2;
        values[valuesById[3] = "FORTNIGHTLY"] = 3;
        values[valuesById[4] = "MONTHLY"] = 4;
        return values;
    })();

    return SchedulerFrequency;
})();

export const PaymentSchedule = $root.PaymentSchedule = (() => {

    /**
     * Properties of a PaymentSchedule.
     * @exports IPaymentSchedule
     * @interface IPaymentSchedule
     * @property {SchedulerFrequency.Enum|null} [frequency] PaymentSchedule frequency
     * @property {string|null} [aud_amount] PaymentSchedule aud_amount
     * @property {string|null} [start_date] PaymentSchedule start_date
     * @property {SaverPortfolio.Enum|null} [portfolio] PaymentSchedule portfolio
     * @property {string|null} [next_due] PaymentSchedule next_due
     * @property {string|null} [last_ran] PaymentSchedule last_ran
     * @property {string|null} [id] PaymentSchedule id
     * @property {google.protobuf.ITimestamp|null} [created_at] PaymentSchedule created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] PaymentSchedule last_updated_at
     * @property {string|null} [product_id] PaymentSchedule product_id
     */

    /**
     * Constructs a new PaymentSchedule.
     * @exports PaymentSchedule
     * @classdesc Represents a PaymentSchedule.
     * @implements IPaymentSchedule
     * @constructor
     * @param {IPaymentSchedule=} [properties] Properties to set
     */
    function PaymentSchedule(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PaymentSchedule frequency.
     * @member {SchedulerFrequency.Enum} frequency
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.frequency = 0;

    /**
     * PaymentSchedule aud_amount.
     * @member {string} aud_amount
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.aud_amount = "";

    /**
     * PaymentSchedule start_date.
     * @member {string} start_date
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.start_date = "";

    /**
     * PaymentSchedule portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.portfolio = 0;

    /**
     * PaymentSchedule next_due.
     * @member {string} next_due
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.next_due = "";

    /**
     * PaymentSchedule last_ran.
     * @member {string} last_ran
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.last_ran = "";

    /**
     * PaymentSchedule id.
     * @member {string} id
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.id = "";

    /**
     * PaymentSchedule created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.created_at = null;

    /**
     * PaymentSchedule last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.last_updated_at = null;

    /**
     * PaymentSchedule product_id.
     * @member {string} product_id
     * @memberof PaymentSchedule
     * @instance
     */
    PaymentSchedule.prototype.product_id = "";

    /**
     * Creates a new PaymentSchedule instance using the specified properties.
     * @function create
     * @memberof PaymentSchedule
     * @static
     * @param {IPaymentSchedule=} [properties] Properties to set
     * @returns {PaymentSchedule} PaymentSchedule instance
     */
    PaymentSchedule.create = function create(properties) {
        return new PaymentSchedule(properties);
    };

    /**
     * Encodes the specified PaymentSchedule message. Does not implicitly {@link PaymentSchedule.verify|verify} messages.
     * @function encode
     * @memberof PaymentSchedule
     * @static
     * @param {IPaymentSchedule} message PaymentSchedule message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PaymentSchedule.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.frequency != null && message.hasOwnProperty("frequency"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.frequency);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.aud_amount);
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.start_date);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.portfolio);
        if (message.next_due != null && message.hasOwnProperty("next_due"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.next_due);
        if (message.last_ran != null && message.hasOwnProperty("last_ran"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.last_ran);
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.id);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.product_id);
        return writer;
    };

    /**
     * Encodes the specified PaymentSchedule message, length delimited. Does not implicitly {@link PaymentSchedule.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PaymentSchedule
     * @static
     * @param {IPaymentSchedule} message PaymentSchedule message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PaymentSchedule.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PaymentSchedule message from the specified reader or buffer.
     * @function decode
     * @memberof PaymentSchedule
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PaymentSchedule} PaymentSchedule
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PaymentSchedule.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PaymentSchedule();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.frequency = reader.int32();
                break;
            case 2:
                message.aud_amount = reader.string();
                break;
            case 3:
                message.start_date = reader.string();
                break;
            case 4:
                message.portfolio = reader.int32();
                break;
            case 5:
                message.next_due = reader.string();
                break;
            case 6:
                message.last_ran = reader.string();
                break;
            case 7:
                message.id = reader.string();
                break;
            case 8:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 9:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 10:
                message.product_id = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PaymentSchedule message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PaymentSchedule
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PaymentSchedule} PaymentSchedule
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PaymentSchedule.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PaymentSchedule message.
     * @function verify
     * @memberof PaymentSchedule
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PaymentSchedule.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.frequency != null && message.hasOwnProperty("frequency"))
            switch (message.frequency) {
            default:
                return "frequency: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            if (!$util.isString(message.start_date))
                return "start_date: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.next_due != null && message.hasOwnProperty("next_due"))
            if (!$util.isString(message.next_due))
                return "next_due: string expected";
        if (message.last_ran != null && message.hasOwnProperty("last_ran"))
            if (!$util.isString(message.last_ran))
                return "last_ran: string expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        return null;
    };

    /**
     * Creates a PaymentSchedule message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PaymentSchedule
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PaymentSchedule} PaymentSchedule
     */
    PaymentSchedule.fromObject = function fromObject(object) {
        if (object instanceof $root.PaymentSchedule)
            return object;
        let message = new $root.PaymentSchedule();
        switch (object.frequency) {
        case "UNKNOWN":
        case 0:
            message.frequency = 0;
            break;
        case "ONE_TIME":
        case 1:
            message.frequency = 1;
            break;
        case "WEEKLY":
        case 2:
            message.frequency = 2;
            break;
        case "FORTNIGHTLY":
        case 3:
            message.frequency = 3;
            break;
        case "MONTHLY":
        case 4:
            message.frequency = 4;
            break;
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        if (object.start_date != null)
            message.start_date = String(object.start_date);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.next_due != null)
            message.next_due = String(object.next_due);
        if (object.last_ran != null)
            message.last_ran = String(object.last_ran);
        if (object.id != null)
            message.id = String(object.id);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".PaymentSchedule.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".PaymentSchedule.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        return message;
    };

    /**
     * Creates a plain object from a PaymentSchedule message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PaymentSchedule
     * @static
     * @param {PaymentSchedule} message PaymentSchedule
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PaymentSchedule.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.frequency = options.enums === String ? "UNKNOWN" : 0;
            object.aud_amount = "";
            object.start_date = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.next_due = "";
            object.last_ran = "";
            object.id = "";
            object.created_at = null;
            object.last_updated_at = null;
            object.product_id = "";
        }
        if (message.frequency != null && message.hasOwnProperty("frequency"))
            object.frequency = options.enums === String ? $root.SchedulerFrequency.Enum[message.frequency] : message.frequency;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            object.start_date = message.start_date;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.next_due != null && message.hasOwnProperty("next_due"))
            object.next_due = message.next_due;
        if (message.last_ran != null && message.hasOwnProperty("last_ran"))
            object.last_ran = message.last_ran;
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        return object;
    };

    /**
     * Converts this PaymentSchedule to JSON.
     * @function toJSON
     * @memberof PaymentSchedule
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PaymentSchedule.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PaymentSchedule;
})();

export const TransactionStatus = $root.TransactionStatus = (() => {

    /**
     * Properties of a TransactionStatus.
     * @exports ITransactionStatus
     * @interface ITransactionStatus
     */

    /**
     * Constructs a new TransactionStatus.
     * @exports TransactionStatus
     * @classdesc Represents a TransactionStatus.
     * @implements ITransactionStatus
     * @constructor
     * @param {ITransactionStatus=} [properties] Properties to set
     */
    function TransactionStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new TransactionStatus instance using the specified properties.
     * @function create
     * @memberof TransactionStatus
     * @static
     * @param {ITransactionStatus=} [properties] Properties to set
     * @returns {TransactionStatus} TransactionStatus instance
     */
    TransactionStatus.create = function create(properties) {
        return new TransactionStatus(properties);
    };

    /**
     * Encodes the specified TransactionStatus message. Does not implicitly {@link TransactionStatus.verify|verify} messages.
     * @function encode
     * @memberof TransactionStatus
     * @static
     * @param {ITransactionStatus} message TransactionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TransactionStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified TransactionStatus message, length delimited. Does not implicitly {@link TransactionStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TransactionStatus
     * @static
     * @param {ITransactionStatus} message TransactionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TransactionStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TransactionStatus message from the specified reader or buffer.
     * @function decode
     * @memberof TransactionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TransactionStatus} TransactionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TransactionStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TransactionStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TransactionStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TransactionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TransactionStatus} TransactionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TransactionStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TransactionStatus message.
     * @function verify
     * @memberof TransactionStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TransactionStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a TransactionStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TransactionStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TransactionStatus} TransactionStatus
     */
    TransactionStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.TransactionStatus)
            return object;
        return new $root.TransactionStatus();
    };

    /**
     * Creates a plain object from a TransactionStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TransactionStatus
     * @static
     * @param {TransactionStatus} message TransactionStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TransactionStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this TransactionStatus to JSON.
     * @function toJSON
     * @memberof TransactionStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TransactionStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name TransactionStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PENDING_REVIEW=1 PENDING_REVIEW value
     * @property {number} REJECTED_BY_RISK_TEAM=2 REJECTED_BY_RISK_TEAM value
     * @property {number} SCHEDULED=3 SCHEDULED value
     * @property {number} FAILED=4 FAILED value
     * @property {number} PAID=5 PAID value
     * @property {number} READY_TO_SCHEDULE=6 READY_TO_SCHEDULE value
     * @property {number} CLEARED=7 CLEARED value
     * @property {number} CLEARING=8 CLEARING value
     * @property {number} CLEARING_UNITS_ISSUED=9 CLEARING_UNITS_ISSUED value
     * @property {number} USER_CANCELLED=10 USER_CANCELLED value
     */
    TransactionStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PENDING_REVIEW"] = 1;
        values[valuesById[2] = "REJECTED_BY_RISK_TEAM"] = 2;
        values[valuesById[3] = "SCHEDULED"] = 3;
        values[valuesById[4] = "FAILED"] = 4;
        values[valuesById[5] = "PAID"] = 5;
        values[valuesById[6] = "READY_TO_SCHEDULE"] = 6;
        values[valuesById[7] = "CLEARED"] = 7;
        values[valuesById[8] = "CLEARING"] = 8;
        values[valuesById[9] = "CLEARING_UNITS_ISSUED"] = 9;
        values[valuesById[10] = "USER_CANCELLED"] = 10;
        return values;
    })();

    return TransactionStatus;
})();

export const TransactionReason = $root.TransactionReason = (() => {

    /**
     * Properties of a TransactionReason.
     * @exports ITransactionReason
     * @interface ITransactionReason
     */

    /**
     * Constructs a new TransactionReason.
     * @exports TransactionReason
     * @classdesc Represents a TransactionReason.
     * @implements ITransactionReason
     * @constructor
     * @param {ITransactionReason=} [properties] Properties to set
     */
    function TransactionReason(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new TransactionReason instance using the specified properties.
     * @function create
     * @memberof TransactionReason
     * @static
     * @param {ITransactionReason=} [properties] Properties to set
     * @returns {TransactionReason} TransactionReason instance
     */
    TransactionReason.create = function create(properties) {
        return new TransactionReason(properties);
    };

    /**
     * Encodes the specified TransactionReason message. Does not implicitly {@link TransactionReason.verify|verify} messages.
     * @function encode
     * @memberof TransactionReason
     * @static
     * @param {ITransactionReason} message TransactionReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TransactionReason.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified TransactionReason message, length delimited. Does not implicitly {@link TransactionReason.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TransactionReason
     * @static
     * @param {ITransactionReason} message TransactionReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TransactionReason.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TransactionReason message from the specified reader or buffer.
     * @function decode
     * @memberof TransactionReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TransactionReason} TransactionReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TransactionReason.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TransactionReason();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TransactionReason message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TransactionReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TransactionReason} TransactionReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TransactionReason.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TransactionReason message.
     * @function verify
     * @memberof TransactionReason
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TransactionReason.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a TransactionReason message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TransactionReason
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TransactionReason} TransactionReason
     */
    TransactionReason.fromObject = function fromObject(object) {
        if (object instanceof $root.TransactionReason)
            return object;
        return new $root.TransactionReason();
    };

    /**
     * Creates a plain object from a TransactionReason message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TransactionReason
     * @static
     * @param {TransactionReason} message TransactionReason
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TransactionReason.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this TransactionReason to JSON.
     * @function toJSON
     * @memberof TransactionReason
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TransactionReason.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name TransactionReason.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} FUND_APPLICATION=1 FUND_APPLICATION value
     * @property {number} FUND_EXIT=2 FUND_EXIT value
     * @property {number} PORTFOLIO_FEES=3 PORTFOLIO_FEES value
     * @property {number} MARKET_TRADE=4 MARKET_TRADE value
     * @property {number} INTEREST_PAYMENT=5 INTEREST_PAYMENT value
     * @property {number} DIVIDEND_CASH_PAYMENT=6 DIVIDEND_CASH_PAYMENT value
     * @property {number} ERROR_ADJUSTMENT_PAYMENT=7 ERROR_ADJUSTMENT_PAYMENT value
     * @property {number} FREEBIE_ISSUANCE=8 FREEBIE_ISSUANCE value
     * @property {number} MANUAL=9 MANUAL value
     * @property {number} RETURN_DIRECT_ENTRY_RETURN=10 RETURN_DIRECT_ENTRY_RETURN value
     * @property {number} MANAGEMENT_FEES=11 MANAGEMENT_FEES value
     */
    TransactionReason.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "FUND_APPLICATION"] = 1;
        values[valuesById[2] = "FUND_EXIT"] = 2;
        values[valuesById[3] = "PORTFOLIO_FEES"] = 3;
        values[valuesById[4] = "MARKET_TRADE"] = 4;
        values[valuesById[5] = "INTEREST_PAYMENT"] = 5;
        values[valuesById[6] = "DIVIDEND_CASH_PAYMENT"] = 6;
        values[valuesById[7] = "ERROR_ADJUSTMENT_PAYMENT"] = 7;
        values[valuesById[8] = "FREEBIE_ISSUANCE"] = 8;
        values[valuesById[9] = "MANUAL"] = 9;
        values[valuesById[10] = "RETURN_DIRECT_ENTRY_RETURN"] = 10;
        values[valuesById[11] = "MANAGEMENT_FEES"] = 11;
        return values;
    })();

    return TransactionReason;
})();

export const FinancierProvider = $root.FinancierProvider = (() => {

    /**
     * Properties of a FinancierProvider.
     * @exports IFinancierProvider
     * @interface IFinancierProvider
     */

    /**
     * Constructs a new FinancierProvider.
     * @exports FinancierProvider
     * @classdesc Represents a FinancierProvider.
     * @implements IFinancierProvider
     * @constructor
     * @param {IFinancierProvider=} [properties] Properties to set
     */
    function FinancierProvider(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new FinancierProvider instance using the specified properties.
     * @function create
     * @memberof FinancierProvider
     * @static
     * @param {IFinancierProvider=} [properties] Properties to set
     * @returns {FinancierProvider} FinancierProvider instance
     */
    FinancierProvider.create = function create(properties) {
        return new FinancierProvider(properties);
    };

    /**
     * Encodes the specified FinancierProvider message. Does not implicitly {@link FinancierProvider.verify|verify} messages.
     * @function encode
     * @memberof FinancierProvider
     * @static
     * @param {IFinancierProvider} message FinancierProvider message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierProvider.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified FinancierProvider message, length delimited. Does not implicitly {@link FinancierProvider.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FinancierProvider
     * @static
     * @param {IFinancierProvider} message FinancierProvider message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierProvider.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FinancierProvider message from the specified reader or buffer.
     * @function decode
     * @memberof FinancierProvider
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FinancierProvider} FinancierProvider
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierProvider.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FinancierProvider();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FinancierProvider message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FinancierProvider
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FinancierProvider} FinancierProvider
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierProvider.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FinancierProvider message.
     * @function verify
     * @memberof FinancierProvider
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FinancierProvider.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a FinancierProvider message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FinancierProvider
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FinancierProvider} FinancierProvider
     */
    FinancierProvider.fromObject = function fromObject(object) {
        if (object instanceof $root.FinancierProvider)
            return object;
        return new $root.FinancierProvider();
    };

    /**
     * Creates a plain object from a FinancierProvider message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FinancierProvider
     * @static
     * @param {FinancierProvider} message FinancierProvider
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FinancierProvider.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this FinancierProvider to JSON.
     * @function toJSON
     * @memberof FinancierProvider
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FinancierProvider.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name FinancierProvider.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} MACQUARIE=1 MACQUARIE value
     * @property {number} ZEPTO=2 ZEPTO value
     * @property {number} WESTPAC=3 WESTPAC value
     * @property {number} MONEY=4 MONEY value
     */
    FinancierProvider.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "MACQUARIE"] = 1;
        values[valuesById[2] = "ZEPTO"] = 2;
        values[valuesById[3] = "WESTPAC"] = 3;
        values[valuesById[4] = "MONEY"] = 4;
        return values;
    })();

    return FinancierProvider;
})();

export const FundTransaction = $root.FundTransaction = (() => {

    /**
     * Properties of a FundTransaction.
     * @exports IFundTransaction
     * @interface IFundTransaction
     * @property {string|null} [transaction_reference] FundTransaction transaction_reference
     * @property {string|null} [product_id] FundTransaction product_id
     * @property {string|null} [bsb_number] FundTransaction bsb_number
     * @property {string|null} [account_number] FundTransaction account_number
     * @property {string|null} [aud_amount] FundTransaction aud_amount
     * @property {SaverPortfolio.Enum|null} [portfolio] FundTransaction portfolio
     * @property {TransactionStatus.Enum|null} [status] FundTransaction status
     * @property {TransactionReason.Enum|null} [reason] FundTransaction reason
     * @property {string|null} [external_reference] FundTransaction external_reference
     * @property {google.protobuf.ITimestamp|null} [posted_at] FundTransaction posted_at
     * @property {google.protobuf.ITimestamp|null} [requested_at] FundTransaction requested_at
     * @property {google.protobuf.ITimestamp|null} [response_at] FundTransaction response_at
     * @property {string|null} [macquarie_transaction_date] FundTransaction macquarie_transaction_date
     * @property {AccountingStatus.Enum|null} [accounting_status] FundTransaction accounting_status
     * @property {AccountingReconciliationStatus.Enum|null} [reconciliation_status] FundTransaction reconciliation_status
     * @property {string|null} [aba_id] FundTransaction aba_id
     * @property {FinancierProvider.Enum|null} [provider] FundTransaction provider
     */

    /**
     * Constructs a new FundTransaction.
     * @exports FundTransaction
     * @classdesc Represents a FundTransaction.
     * @implements IFundTransaction
     * @constructor
     * @param {IFundTransaction=} [properties] Properties to set
     */
    function FundTransaction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FundTransaction transaction_reference.
     * @member {string} transaction_reference
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.transaction_reference = "";

    /**
     * FundTransaction product_id.
     * @member {string} product_id
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.product_id = "";

    /**
     * FundTransaction bsb_number.
     * @member {string} bsb_number
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.bsb_number = "";

    /**
     * FundTransaction account_number.
     * @member {string} account_number
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.account_number = "";

    /**
     * FundTransaction aud_amount.
     * @member {string} aud_amount
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.aud_amount = "";

    /**
     * FundTransaction portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.portfolio = 0;

    /**
     * FundTransaction status.
     * @member {TransactionStatus.Enum} status
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.status = 0;

    /**
     * FundTransaction reason.
     * @member {TransactionReason.Enum} reason
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.reason = 0;

    /**
     * FundTransaction external_reference.
     * @member {string} external_reference
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.external_reference = "";

    /**
     * FundTransaction posted_at.
     * @member {google.protobuf.ITimestamp|null|undefined} posted_at
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.posted_at = null;

    /**
     * FundTransaction requested_at.
     * @member {google.protobuf.ITimestamp|null|undefined} requested_at
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.requested_at = null;

    /**
     * FundTransaction response_at.
     * @member {google.protobuf.ITimestamp|null|undefined} response_at
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.response_at = null;

    /**
     * FundTransaction macquarie_transaction_date.
     * @member {string} macquarie_transaction_date
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.macquarie_transaction_date = "";

    /**
     * FundTransaction accounting_status.
     * @member {AccountingStatus.Enum} accounting_status
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.accounting_status = 0;

    /**
     * FundTransaction reconciliation_status.
     * @member {AccountingReconciliationStatus.Enum} reconciliation_status
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.reconciliation_status = 0;

    /**
     * FundTransaction aba_id.
     * @member {string} aba_id
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.aba_id = "";

    /**
     * FundTransaction provider.
     * @member {FinancierProvider.Enum} provider
     * @memberof FundTransaction
     * @instance
     */
    FundTransaction.prototype.provider = 0;

    /**
     * Creates a new FundTransaction instance using the specified properties.
     * @function create
     * @memberof FundTransaction
     * @static
     * @param {IFundTransaction=} [properties] Properties to set
     * @returns {FundTransaction} FundTransaction instance
     */
    FundTransaction.create = function create(properties) {
        return new FundTransaction(properties);
    };

    /**
     * Encodes the specified FundTransaction message. Does not implicitly {@link FundTransaction.verify|verify} messages.
     * @function encode
     * @memberof FundTransaction
     * @static
     * @param {IFundTransaction} message FundTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FundTransaction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.product_id);
        if (message.bsb_number != null && message.hasOwnProperty("bsb_number"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.bsb_number);
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.account_number);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.aud_amount);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.portfolio);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
        if (message.reason != null && message.hasOwnProperty("reason"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.reason);
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.external_reference);
        if (message.posted_at != null && message.hasOwnProperty("posted_at"))
            $root.google.protobuf.Timestamp.encode(message.posted_at, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.requested_at != null && message.hasOwnProperty("requested_at"))
            $root.google.protobuf.Timestamp.encode(message.requested_at, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.response_at != null && message.hasOwnProperty("response_at"))
            $root.google.protobuf.Timestamp.encode(message.response_at, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.macquarie_transaction_date != null && message.hasOwnProperty("macquarie_transaction_date"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.macquarie_transaction_date);
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.accounting_status);
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.reconciliation_status);
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.aba_id);
        if (message.provider != null && message.hasOwnProperty("provider"))
            writer.uint32(/* id 17, wireType 0 =*/136).int32(message.provider);
        return writer;
    };

    /**
     * Encodes the specified FundTransaction message, length delimited. Does not implicitly {@link FundTransaction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FundTransaction
     * @static
     * @param {IFundTransaction} message FundTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FundTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FundTransaction message from the specified reader or buffer.
     * @function decode
     * @memberof FundTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FundTransaction} FundTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FundTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FundTransaction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_reference = reader.string();
                break;
            case 2:
                message.product_id = reader.string();
                break;
            case 3:
                message.bsb_number = reader.string();
                break;
            case 4:
                message.account_number = reader.string();
                break;
            case 5:
                message.aud_amount = reader.string();
                break;
            case 6:
                message.portfolio = reader.int32();
                break;
            case 7:
                message.status = reader.int32();
                break;
            case 8:
                message.reason = reader.int32();
                break;
            case 9:
                message.external_reference = reader.string();
                break;
            case 10:
                message.posted_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 11:
                message.requested_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 12:
                message.response_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 13:
                message.macquarie_transaction_date = reader.string();
                break;
            case 14:
                message.accounting_status = reader.int32();
                break;
            case 15:
                message.reconciliation_status = reader.int32();
                break;
            case 16:
                message.aba_id = reader.string();
                break;
            case 17:
                message.provider = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FundTransaction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FundTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FundTransaction} FundTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FundTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FundTransaction message.
     * @function verify
     * @memberof FundTransaction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FundTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.bsb_number != null && message.hasOwnProperty("bsb_number"))
            if (!$util.isString(message.bsb_number))
                return "bsb_number: string expected";
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            if (!$util.isString(message.account_number))
                return "account_number: string expected";
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                break;
            }
        if (message.reason != null && message.hasOwnProperty("reason"))
            switch (message.reason) {
            default:
                return "reason: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            if (!$util.isString(message.external_reference))
                return "external_reference: string expected";
        if (message.posted_at != null && message.hasOwnProperty("posted_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.posted_at);
            if (error)
                return "posted_at." + error;
        }
        if (message.requested_at != null && message.hasOwnProperty("requested_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.requested_at);
            if (error)
                return "requested_at." + error;
        }
        if (message.response_at != null && message.hasOwnProperty("response_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.response_at);
            if (error)
                return "response_at." + error;
        }
        if (message.macquarie_transaction_date != null && message.hasOwnProperty("macquarie_transaction_date"))
            if (!$util.isString(message.macquarie_transaction_date))
                return "macquarie_transaction_date: string expected";
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            switch (message.accounting_status) {
            default:
                return "accounting_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            switch (message.reconciliation_status) {
            default:
                return "reconciliation_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            if (!$util.isString(message.aba_id))
                return "aba_id: string expected";
        if (message.provider != null && message.hasOwnProperty("provider"))
            switch (message.provider) {
            default:
                return "provider: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates a FundTransaction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FundTransaction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FundTransaction} FundTransaction
     */
    FundTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.FundTransaction)
            return object;
        let message = new $root.FundTransaction();
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.bsb_number != null)
            message.bsb_number = String(object.bsb_number);
        if (object.account_number != null)
            message.account_number = String(object.account_number);
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PENDING_REVIEW":
        case 1:
            message.status = 1;
            break;
        case "REJECTED_BY_RISK_TEAM":
        case 2:
            message.status = 2;
            break;
        case "SCHEDULED":
        case 3:
            message.status = 3;
            break;
        case "FAILED":
        case 4:
            message.status = 4;
            break;
        case "PAID":
        case 5:
            message.status = 5;
            break;
        case "READY_TO_SCHEDULE":
        case 6:
            message.status = 6;
            break;
        case "CLEARED":
        case 7:
            message.status = 7;
            break;
        case "CLEARING":
        case 8:
            message.status = 8;
            break;
        case "CLEARING_UNITS_ISSUED":
        case 9:
            message.status = 9;
            break;
        case "USER_CANCELLED":
        case 10:
            message.status = 10;
            break;
        }
        switch (object.reason) {
        case "UNKNOWN":
        case 0:
            message.reason = 0;
            break;
        case "FUND_APPLICATION":
        case 1:
            message.reason = 1;
            break;
        case "FUND_EXIT":
        case 2:
            message.reason = 2;
            break;
        case "PORTFOLIO_FEES":
        case 3:
            message.reason = 3;
            break;
        case "MARKET_TRADE":
        case 4:
            message.reason = 4;
            break;
        case "INTEREST_PAYMENT":
        case 5:
            message.reason = 5;
            break;
        case "DIVIDEND_CASH_PAYMENT":
        case 6:
            message.reason = 6;
            break;
        case "ERROR_ADJUSTMENT_PAYMENT":
        case 7:
            message.reason = 7;
            break;
        case "FREEBIE_ISSUANCE":
        case 8:
            message.reason = 8;
            break;
        case "MANUAL":
        case 9:
            message.reason = 9;
            break;
        case "RETURN_DIRECT_ENTRY_RETURN":
        case 10:
            message.reason = 10;
            break;
        case "MANAGEMENT_FEES":
        case 11:
            message.reason = 11;
            break;
        }
        if (object.external_reference != null)
            message.external_reference = String(object.external_reference);
        if (object.posted_at != null) {
            if (typeof object.posted_at !== "object")
                throw TypeError(".FundTransaction.posted_at: object expected");
            message.posted_at = $root.google.protobuf.Timestamp.fromObject(object.posted_at);
        }
        if (object.requested_at != null) {
            if (typeof object.requested_at !== "object")
                throw TypeError(".FundTransaction.requested_at: object expected");
            message.requested_at = $root.google.protobuf.Timestamp.fromObject(object.requested_at);
        }
        if (object.response_at != null) {
            if (typeof object.response_at !== "object")
                throw TypeError(".FundTransaction.response_at: object expected");
            message.response_at = $root.google.protobuf.Timestamp.fromObject(object.response_at);
        }
        if (object.macquarie_transaction_date != null)
            message.macquarie_transaction_date = String(object.macquarie_transaction_date);
        switch (object.accounting_status) {
        case "UNKNOWN":
        case 0:
            message.accounting_status = 0;
            break;
        case "PENDING":
        case 1:
            message.accounting_status = 1;
            break;
        case "UNCATEGORISED":
        case 2:
            message.accounting_status = 2;
            break;
        case "CATEGORISED":
        case 3:
            message.accounting_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.accounting_status = 4;
            break;
        }
        switch (object.reconciliation_status) {
        case "UNKNOWN":
        case 0:
            message.reconciliation_status = 0;
            break;
        case "PENDING":
        case 1:
            message.reconciliation_status = 1;
            break;
        case "RECONCILED":
        case 2:
            message.reconciliation_status = 2;
            break;
        case "UNRECONCILED":
        case 3:
            message.reconciliation_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.reconciliation_status = 4;
            break;
        }
        if (object.aba_id != null)
            message.aba_id = String(object.aba_id);
        switch (object.provider) {
        case "UNKNOWN":
        case 0:
            message.provider = 0;
            break;
        case "MACQUARIE":
        case 1:
            message.provider = 1;
            break;
        case "ZEPTO":
        case 2:
            message.provider = 2;
            break;
        case "WESTPAC":
        case 3:
            message.provider = 3;
            break;
        case "MONEY":
        case 4:
            message.provider = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a FundTransaction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FundTransaction
     * @static
     * @param {FundTransaction} message FundTransaction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FundTransaction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_reference = "";
            object.product_id = "";
            object.bsb_number = "";
            object.account_number = "";
            object.aud_amount = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.reason = options.enums === String ? "UNKNOWN" : 0;
            object.external_reference = "";
            object.posted_at = null;
            object.requested_at = null;
            object.response_at = null;
            object.macquarie_transaction_date = "";
            object.accounting_status = options.enums === String ? "UNKNOWN" : 0;
            object.reconciliation_status = options.enums === String ? "UNKNOWN" : 0;
            object.aba_id = "";
            object.provider = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.bsb_number != null && message.hasOwnProperty("bsb_number"))
            object.bsb_number = message.bsb_number;
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            object.account_number = message.account_number;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.TransactionStatus.Enum[message.status] : message.status;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = options.enums === String ? $root.TransactionReason.Enum[message.reason] : message.reason;
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            object.external_reference = message.external_reference;
        if (message.posted_at != null && message.hasOwnProperty("posted_at"))
            object.posted_at = $root.google.protobuf.Timestamp.toObject(message.posted_at, options);
        if (message.requested_at != null && message.hasOwnProperty("requested_at"))
            object.requested_at = $root.google.protobuf.Timestamp.toObject(message.requested_at, options);
        if (message.response_at != null && message.hasOwnProperty("response_at"))
            object.response_at = $root.google.protobuf.Timestamp.toObject(message.response_at, options);
        if (message.macquarie_transaction_date != null && message.hasOwnProperty("macquarie_transaction_date"))
            object.macquarie_transaction_date = message.macquarie_transaction_date;
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            object.accounting_status = options.enums === String ? $root.AccountingStatus.Enum[message.accounting_status] : message.accounting_status;
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            object.reconciliation_status = options.enums === String ? $root.AccountingReconciliationStatus.Enum[message.reconciliation_status] : message.reconciliation_status;
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            object.aba_id = message.aba_id;
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = options.enums === String ? $root.FinancierProvider.Enum[message.provider] : message.provider;
        return object;
    };

    /**
     * Converts this FundTransaction to JSON.
     * @function toJSON
     * @memberof FundTransaction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FundTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FundTransaction;
})();

export const SuspenseTransaction = $root.SuspenseTransaction = (() => {

    /**
     * Properties of a SuspenseTransaction.
     * @exports ISuspenseTransaction
     * @interface ISuspenseTransaction
     * @property {string|null} [transaction_reference] SuspenseTransaction transaction_reference
     * @property {google.protobuf.ITimestamp|null} [defined_time] SuspenseTransaction defined_time
     * @property {string|null} [product_id] SuspenseTransaction product_id
     * @property {SaverPortfolio.Enum|null} [portfolio] SuspenseTransaction portfolio
     * @property {string|null} [aud_amount] SuspenseTransaction aud_amount
     * @property {TransactionStatus.Enum|null} [status] SuspenseTransaction status
     * @property {TransactionReason.Enum|null} [reason] SuspenseTransaction reason
     * @property {string|null} [bank_account_id] SuspenseTransaction bank_account_id
     * @property {string|null} [external_reference] SuspenseTransaction external_reference
     * @property {google.protobuf.ITimestamp|null} [posted_at] SuspenseTransaction posted_at
     * @property {google.protobuf.ITimestamp|null} [response_at] SuspenseTransaction response_at
     * @property {string|null} [macquarie_transaction_date] SuspenseTransaction macquarie_transaction_date
     * @property {AccountingStatus.Enum|null} [accounting_status] SuspenseTransaction accounting_status
     * @property {AccountingReconciliationStatus.Enum|null} [reconciliation_status] SuspenseTransaction reconciliation_status
     * @property {string|null} [aba_id] SuspenseTransaction aba_id
     * @property {string|null} [estimated_application_execution_date] SuspenseTransaction estimated_application_execution_date
     * @property {google.protobuf.ITimestamp|null} [cancel_deadline] SuspenseTransaction cancel_deadline
     * @property {FinancierProvider.Enum|null} [provider] SuspenseTransaction provider
     * @property {core.money.PaymentMethod.Enum|null} [payment_method] SuspenseTransaction payment_method
     */

    /**
     * Constructs a new SuspenseTransaction.
     * @exports SuspenseTransaction
     * @classdesc Represents a SuspenseTransaction.
     * @implements ISuspenseTransaction
     * @constructor
     * @param {ISuspenseTransaction=} [properties] Properties to set
     */
    function SuspenseTransaction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuspenseTransaction transaction_reference.
     * @member {string} transaction_reference
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.transaction_reference = "";

    /**
     * SuspenseTransaction defined_time.
     * @member {google.protobuf.ITimestamp|null|undefined} defined_time
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.defined_time = null;

    /**
     * SuspenseTransaction product_id.
     * @member {string} product_id
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.product_id = "";

    /**
     * SuspenseTransaction portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.portfolio = 0;

    /**
     * SuspenseTransaction aud_amount.
     * @member {string} aud_amount
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.aud_amount = "";

    /**
     * SuspenseTransaction status.
     * @member {TransactionStatus.Enum} status
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.status = 0;

    /**
     * SuspenseTransaction reason.
     * @member {TransactionReason.Enum} reason
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.reason = 0;

    /**
     * SuspenseTransaction bank_account_id.
     * @member {string} bank_account_id
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.bank_account_id = "";

    /**
     * SuspenseTransaction external_reference.
     * @member {string} external_reference
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.external_reference = "";

    /**
     * SuspenseTransaction posted_at.
     * @member {google.protobuf.ITimestamp|null|undefined} posted_at
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.posted_at = null;

    /**
     * SuspenseTransaction response_at.
     * @member {google.protobuf.ITimestamp|null|undefined} response_at
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.response_at = null;

    /**
     * SuspenseTransaction macquarie_transaction_date.
     * @member {string} macquarie_transaction_date
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.macquarie_transaction_date = "";

    /**
     * SuspenseTransaction accounting_status.
     * @member {AccountingStatus.Enum} accounting_status
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.accounting_status = 0;

    /**
     * SuspenseTransaction reconciliation_status.
     * @member {AccountingReconciliationStatus.Enum} reconciliation_status
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.reconciliation_status = 0;

    /**
     * SuspenseTransaction aba_id.
     * @member {string} aba_id
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.aba_id = "";

    /**
     * SuspenseTransaction estimated_application_execution_date.
     * @member {string} estimated_application_execution_date
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.estimated_application_execution_date = "";

    /**
     * SuspenseTransaction cancel_deadline.
     * @member {google.protobuf.ITimestamp|null|undefined} cancel_deadline
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.cancel_deadline = null;

    /**
     * SuspenseTransaction provider.
     * @member {FinancierProvider.Enum} provider
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.provider = 0;

    /**
     * SuspenseTransaction payment_method.
     * @member {core.money.PaymentMethod.Enum} payment_method
     * @memberof SuspenseTransaction
     * @instance
     */
    SuspenseTransaction.prototype.payment_method = 0;

    /**
     * Creates a new SuspenseTransaction instance using the specified properties.
     * @function create
     * @memberof SuspenseTransaction
     * @static
     * @param {ISuspenseTransaction=} [properties] Properties to set
     * @returns {SuspenseTransaction} SuspenseTransaction instance
     */
    SuspenseTransaction.create = function create(properties) {
        return new SuspenseTransaction(properties);
    };

    /**
     * Encodes the specified SuspenseTransaction message. Does not implicitly {@link SuspenseTransaction.verify|verify} messages.
     * @function encode
     * @memberof SuspenseTransaction
     * @static
     * @param {ISuspenseTransaction} message SuspenseTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuspenseTransaction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
        if (message.defined_time != null && message.hasOwnProperty("defined_time"))
            $root.google.protobuf.Timestamp.encode(message.defined_time, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.product_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.portfolio);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.aud_amount);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.status);
        if (message.reason != null && message.hasOwnProperty("reason"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.reason);
        if (message.bank_account_id != null && message.hasOwnProperty("bank_account_id"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.bank_account_id);
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.external_reference);
        if (message.posted_at != null && message.hasOwnProperty("posted_at"))
            $root.google.protobuf.Timestamp.encode(message.posted_at, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.response_at != null && message.hasOwnProperty("response_at"))
            $root.google.protobuf.Timestamp.encode(message.response_at, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.macquarie_transaction_date != null && message.hasOwnProperty("macquarie_transaction_date"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.macquarie_transaction_date);
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.accounting_status);
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.reconciliation_status);
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.aba_id);
        if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.estimated_application_execution_date);
        if (message.cancel_deadline != null && message.hasOwnProperty("cancel_deadline"))
            $root.google.protobuf.Timestamp.encode(message.cancel_deadline, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
        if (message.provider != null && message.hasOwnProperty("provider"))
            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.provider);
        if (message.payment_method != null && message.hasOwnProperty("payment_method"))
            writer.uint32(/* id 19, wireType 0 =*/152).int32(message.payment_method);
        return writer;
    };

    /**
     * Encodes the specified SuspenseTransaction message, length delimited. Does not implicitly {@link SuspenseTransaction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuspenseTransaction
     * @static
     * @param {ISuspenseTransaction} message SuspenseTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuspenseTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuspenseTransaction message from the specified reader or buffer.
     * @function decode
     * @memberof SuspenseTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuspenseTransaction} SuspenseTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuspenseTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuspenseTransaction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_reference = reader.string();
                break;
            case 2:
                message.defined_time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 3:
                message.product_id = reader.string();
                break;
            case 4:
                message.portfolio = reader.int32();
                break;
            case 5:
                message.aud_amount = reader.string();
                break;
            case 6:
                message.status = reader.int32();
                break;
            case 7:
                message.reason = reader.int32();
                break;
            case 8:
                message.bank_account_id = reader.string();
                break;
            case 9:
                message.external_reference = reader.string();
                break;
            case 10:
                message.posted_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 11:
                message.response_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 12:
                message.macquarie_transaction_date = reader.string();
                break;
            case 13:
                message.accounting_status = reader.int32();
                break;
            case 14:
                message.reconciliation_status = reader.int32();
                break;
            case 15:
                message.aba_id = reader.string();
                break;
            case 16:
                message.estimated_application_execution_date = reader.string();
                break;
            case 17:
                message.cancel_deadline = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 18:
                message.provider = reader.int32();
                break;
            case 19:
                message.payment_method = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuspenseTransaction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuspenseTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuspenseTransaction} SuspenseTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuspenseTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuspenseTransaction message.
     * @function verify
     * @memberof SuspenseTransaction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuspenseTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.defined_time != null && message.hasOwnProperty("defined_time")) {
            let error = $root.google.protobuf.Timestamp.verify(message.defined_time);
            if (error)
                return "defined_time." + error;
        }
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                break;
            }
        if (message.reason != null && message.hasOwnProperty("reason"))
            switch (message.reason) {
            default:
                return "reason: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.bank_account_id != null && message.hasOwnProperty("bank_account_id"))
            if (!$util.isString(message.bank_account_id))
                return "bank_account_id: string expected";
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            if (!$util.isString(message.external_reference))
                return "external_reference: string expected";
        if (message.posted_at != null && message.hasOwnProperty("posted_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.posted_at);
            if (error)
                return "posted_at." + error;
        }
        if (message.response_at != null && message.hasOwnProperty("response_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.response_at);
            if (error)
                return "response_at." + error;
        }
        if (message.macquarie_transaction_date != null && message.hasOwnProperty("macquarie_transaction_date"))
            if (!$util.isString(message.macquarie_transaction_date))
                return "macquarie_transaction_date: string expected";
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            switch (message.accounting_status) {
            default:
                return "accounting_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            switch (message.reconciliation_status) {
            default:
                return "reconciliation_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            if (!$util.isString(message.aba_id))
                return "aba_id: string expected";
        if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
            if (!$util.isString(message.estimated_application_execution_date))
                return "estimated_application_execution_date: string expected";
        if (message.cancel_deadline != null && message.hasOwnProperty("cancel_deadline")) {
            let error = $root.google.protobuf.Timestamp.verify(message.cancel_deadline);
            if (error)
                return "cancel_deadline." + error;
        }
        if (message.provider != null && message.hasOwnProperty("provider"))
            switch (message.provider) {
            default:
                return "provider: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.payment_method != null && message.hasOwnProperty("payment_method"))
            switch (message.payment_method) {
            default:
                return "payment_method: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    /**
     * Creates a SuspenseTransaction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuspenseTransaction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuspenseTransaction} SuspenseTransaction
     */
    SuspenseTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.SuspenseTransaction)
            return object;
        let message = new $root.SuspenseTransaction();
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.defined_time != null) {
            if (typeof object.defined_time !== "object")
                throw TypeError(".SuspenseTransaction.defined_time: object expected");
            message.defined_time = $root.google.protobuf.Timestamp.fromObject(object.defined_time);
        }
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PENDING_REVIEW":
        case 1:
            message.status = 1;
            break;
        case "REJECTED_BY_RISK_TEAM":
        case 2:
            message.status = 2;
            break;
        case "SCHEDULED":
        case 3:
            message.status = 3;
            break;
        case "FAILED":
        case 4:
            message.status = 4;
            break;
        case "PAID":
        case 5:
            message.status = 5;
            break;
        case "READY_TO_SCHEDULE":
        case 6:
            message.status = 6;
            break;
        case "CLEARED":
        case 7:
            message.status = 7;
            break;
        case "CLEARING":
        case 8:
            message.status = 8;
            break;
        case "CLEARING_UNITS_ISSUED":
        case 9:
            message.status = 9;
            break;
        case "USER_CANCELLED":
        case 10:
            message.status = 10;
            break;
        }
        switch (object.reason) {
        case "UNKNOWN":
        case 0:
            message.reason = 0;
            break;
        case "FUND_APPLICATION":
        case 1:
            message.reason = 1;
            break;
        case "FUND_EXIT":
        case 2:
            message.reason = 2;
            break;
        case "PORTFOLIO_FEES":
        case 3:
            message.reason = 3;
            break;
        case "MARKET_TRADE":
        case 4:
            message.reason = 4;
            break;
        case "INTEREST_PAYMENT":
        case 5:
            message.reason = 5;
            break;
        case "DIVIDEND_CASH_PAYMENT":
        case 6:
            message.reason = 6;
            break;
        case "ERROR_ADJUSTMENT_PAYMENT":
        case 7:
            message.reason = 7;
            break;
        case "FREEBIE_ISSUANCE":
        case 8:
            message.reason = 8;
            break;
        case "MANUAL":
        case 9:
            message.reason = 9;
            break;
        case "RETURN_DIRECT_ENTRY_RETURN":
        case 10:
            message.reason = 10;
            break;
        case "MANAGEMENT_FEES":
        case 11:
            message.reason = 11;
            break;
        }
        if (object.bank_account_id != null)
            message.bank_account_id = String(object.bank_account_id);
        if (object.external_reference != null)
            message.external_reference = String(object.external_reference);
        if (object.posted_at != null) {
            if (typeof object.posted_at !== "object")
                throw TypeError(".SuspenseTransaction.posted_at: object expected");
            message.posted_at = $root.google.protobuf.Timestamp.fromObject(object.posted_at);
        }
        if (object.response_at != null) {
            if (typeof object.response_at !== "object")
                throw TypeError(".SuspenseTransaction.response_at: object expected");
            message.response_at = $root.google.protobuf.Timestamp.fromObject(object.response_at);
        }
        if (object.macquarie_transaction_date != null)
            message.macquarie_transaction_date = String(object.macquarie_transaction_date);
        switch (object.accounting_status) {
        case "UNKNOWN":
        case 0:
            message.accounting_status = 0;
            break;
        case "PENDING":
        case 1:
            message.accounting_status = 1;
            break;
        case "UNCATEGORISED":
        case 2:
            message.accounting_status = 2;
            break;
        case "CATEGORISED":
        case 3:
            message.accounting_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.accounting_status = 4;
            break;
        }
        switch (object.reconciliation_status) {
        case "UNKNOWN":
        case 0:
            message.reconciliation_status = 0;
            break;
        case "PENDING":
        case 1:
            message.reconciliation_status = 1;
            break;
        case "RECONCILED":
        case 2:
            message.reconciliation_status = 2;
            break;
        case "UNRECONCILED":
        case 3:
            message.reconciliation_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.reconciliation_status = 4;
            break;
        }
        if (object.aba_id != null)
            message.aba_id = String(object.aba_id);
        if (object.estimated_application_execution_date != null)
            message.estimated_application_execution_date = String(object.estimated_application_execution_date);
        if (object.cancel_deadline != null) {
            if (typeof object.cancel_deadline !== "object")
                throw TypeError(".SuspenseTransaction.cancel_deadline: object expected");
            message.cancel_deadline = $root.google.protobuf.Timestamp.fromObject(object.cancel_deadline);
        }
        switch (object.provider) {
        case "UNKNOWN":
        case 0:
            message.provider = 0;
            break;
        case "MACQUARIE":
        case 1:
            message.provider = 1;
            break;
        case "ZEPTO":
        case 2:
            message.provider = 2;
            break;
        case "WESTPAC":
        case 3:
            message.provider = 3;
            break;
        case "MONEY":
        case 4:
            message.provider = 4;
            break;
        }
        switch (object.payment_method) {
        case "UNKNOWN":
        case 0:
            message.payment_method = 0;
            break;
        case "MONEY":
        case 1:
            message.payment_method = 1;
            break;
        case "DIRECT_ENTRY":
        case 2:
            message.payment_method = 2;
            break;
        case "PAYTO":
        case 3:
            message.payment_method = 3;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a SuspenseTransaction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuspenseTransaction
     * @static
     * @param {SuspenseTransaction} message SuspenseTransaction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuspenseTransaction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_reference = "";
            object.defined_time = null;
            object.product_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.aud_amount = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.reason = options.enums === String ? "UNKNOWN" : 0;
            object.bank_account_id = "";
            object.external_reference = "";
            object.posted_at = null;
            object.response_at = null;
            object.macquarie_transaction_date = "";
            object.accounting_status = options.enums === String ? "UNKNOWN" : 0;
            object.reconciliation_status = options.enums === String ? "UNKNOWN" : 0;
            object.aba_id = "";
            object.estimated_application_execution_date = "";
            object.cancel_deadline = null;
            object.provider = options.enums === String ? "UNKNOWN" : 0;
            object.payment_method = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.defined_time != null && message.hasOwnProperty("defined_time"))
            object.defined_time = $root.google.protobuf.Timestamp.toObject(message.defined_time, options);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.TransactionStatus.Enum[message.status] : message.status;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = options.enums === String ? $root.TransactionReason.Enum[message.reason] : message.reason;
        if (message.bank_account_id != null && message.hasOwnProperty("bank_account_id"))
            object.bank_account_id = message.bank_account_id;
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            object.external_reference = message.external_reference;
        if (message.posted_at != null && message.hasOwnProperty("posted_at"))
            object.posted_at = $root.google.protobuf.Timestamp.toObject(message.posted_at, options);
        if (message.response_at != null && message.hasOwnProperty("response_at"))
            object.response_at = $root.google.protobuf.Timestamp.toObject(message.response_at, options);
        if (message.macquarie_transaction_date != null && message.hasOwnProperty("macquarie_transaction_date"))
            object.macquarie_transaction_date = message.macquarie_transaction_date;
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            object.accounting_status = options.enums === String ? $root.AccountingStatus.Enum[message.accounting_status] : message.accounting_status;
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            object.reconciliation_status = options.enums === String ? $root.AccountingReconciliationStatus.Enum[message.reconciliation_status] : message.reconciliation_status;
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            object.aba_id = message.aba_id;
        if (message.estimated_application_execution_date != null && message.hasOwnProperty("estimated_application_execution_date"))
            object.estimated_application_execution_date = message.estimated_application_execution_date;
        if (message.cancel_deadline != null && message.hasOwnProperty("cancel_deadline"))
            object.cancel_deadline = $root.google.protobuf.Timestamp.toObject(message.cancel_deadline, options);
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = options.enums === String ? $root.FinancierProvider.Enum[message.provider] : message.provider;
        if (message.payment_method != null && message.hasOwnProperty("payment_method"))
            object.payment_method = options.enums === String ? $root.core.money.PaymentMethod.Enum[message.payment_method] : message.payment_method;
        return object;
    };

    /**
     * Converts this SuspenseTransaction to JSON.
     * @function toJSON
     * @memberof SuspenseTransaction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuspenseTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuspenseTransaction;
})();

export const UnitLedgerReason = $root.UnitLedgerReason = (() => {

    /**
     * Properties of an UnitLedgerReason.
     * @exports IUnitLedgerReason
     * @interface IUnitLedgerReason
     */

    /**
     * Constructs a new UnitLedgerReason.
     * @exports UnitLedgerReason
     * @classdesc Represents an UnitLedgerReason.
     * @implements IUnitLedgerReason
     * @constructor
     * @param {IUnitLedgerReason=} [properties] Properties to set
     */
    function UnitLedgerReason(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new UnitLedgerReason instance using the specified properties.
     * @function create
     * @memberof UnitLedgerReason
     * @static
     * @param {IUnitLedgerReason=} [properties] Properties to set
     * @returns {UnitLedgerReason} UnitLedgerReason instance
     */
    UnitLedgerReason.create = function create(properties) {
        return new UnitLedgerReason(properties);
    };

    /**
     * Encodes the specified UnitLedgerReason message. Does not implicitly {@link UnitLedgerReason.verify|verify} messages.
     * @function encode
     * @memberof UnitLedgerReason
     * @static
     * @param {IUnitLedgerReason} message UnitLedgerReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitLedgerReason.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified UnitLedgerReason message, length delimited. Does not implicitly {@link UnitLedgerReason.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitLedgerReason
     * @static
     * @param {IUnitLedgerReason} message UnitLedgerReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitLedgerReason.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitLedgerReason message from the specified reader or buffer.
     * @function decode
     * @memberof UnitLedgerReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitLedgerReason} UnitLedgerReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitLedgerReason.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitLedgerReason();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitLedgerReason message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitLedgerReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitLedgerReason} UnitLedgerReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitLedgerReason.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitLedgerReason message.
     * @function verify
     * @memberof UnitLedgerReason
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitLedgerReason.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an UnitLedgerReason message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitLedgerReason
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitLedgerReason} UnitLedgerReason
     */
    UnitLedgerReason.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitLedgerReason)
            return object;
        return new $root.UnitLedgerReason();
    };

    /**
     * Creates a plain object from an UnitLedgerReason message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitLedgerReason
     * @static
     * @param {UnitLedgerReason} message UnitLedgerReason
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitLedgerReason.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this UnitLedgerReason to JSON.
     * @function toJSON
     * @memberof UnitLedgerReason
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitLedgerReason.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name UnitLedgerReason.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} UNIT_EXCHANGE=1 UNIT_EXCHANGE value
     * @property {number} FEE_REBATE=2 FEE_REBATE value
     * @property {number} TRANSFER_SOURCE=3 TRANSFER_SOURCE value
     * @property {number} TRANSFER_DESTINATION=4 TRANSFER_DESTINATION value
     * @property {number} UNIT_ADJUSTMENT=5 UNIT_ADJUSTMENT value
     */
    UnitLedgerReason.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "UNIT_EXCHANGE"] = 1;
        values[valuesById[2] = "FEE_REBATE"] = 2;
        values[valuesById[3] = "TRANSFER_SOURCE"] = 3;
        values[valuesById[4] = "TRANSFER_DESTINATION"] = 4;
        values[valuesById[5] = "UNIT_ADJUSTMENT"] = 5;
        return values;
    })();

    return UnitLedgerReason;
})();

export const UnitLedgerEntry = $root.UnitLedgerEntry = (() => {

    /**
     * Properties of an UnitLedgerEntry.
     * @exports IUnitLedgerEntry
     * @interface IUnitLedgerEntry
     * @property {string|null} [product_id] UnitLedgerEntry product_id
     * @property {string|null} [unique_id] UnitLedgerEntry unique_id
     * @property {string|null} [units] UnitLedgerEntry units
     * @property {UnitLedgerReason.Enum|null} [reason] UnitLedgerEntry reason
     * @property {string|null} [unit_calc_id] UnitLedgerEntry unit_calc_id
     * @property {SaverPortfolio.Enum|null} [portfolio] UnitLedgerEntry portfolio
     * @property {google.protobuf.ITimestamp|null} [event_time] UnitLedgerEntry event_time
     * @property {AccountingStatus.Enum|null} [accounting_status] UnitLedgerEntry accounting_status
     */

    /**
     * Constructs a new UnitLedgerEntry.
     * @exports UnitLedgerEntry
     * @classdesc Represents an UnitLedgerEntry.
     * @implements IUnitLedgerEntry
     * @constructor
     * @param {IUnitLedgerEntry=} [properties] Properties to set
     */
    function UnitLedgerEntry(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnitLedgerEntry product_id.
     * @member {string} product_id
     * @memberof UnitLedgerEntry
     * @instance
     */
    UnitLedgerEntry.prototype.product_id = "";

    /**
     * UnitLedgerEntry unique_id.
     * @member {string} unique_id
     * @memberof UnitLedgerEntry
     * @instance
     */
    UnitLedgerEntry.prototype.unique_id = "";

    /**
     * UnitLedgerEntry units.
     * @member {string} units
     * @memberof UnitLedgerEntry
     * @instance
     */
    UnitLedgerEntry.prototype.units = "";

    /**
     * UnitLedgerEntry reason.
     * @member {UnitLedgerReason.Enum} reason
     * @memberof UnitLedgerEntry
     * @instance
     */
    UnitLedgerEntry.prototype.reason = 0;

    /**
     * UnitLedgerEntry unit_calc_id.
     * @member {string} unit_calc_id
     * @memberof UnitLedgerEntry
     * @instance
     */
    UnitLedgerEntry.prototype.unit_calc_id = "";

    /**
     * UnitLedgerEntry portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof UnitLedgerEntry
     * @instance
     */
    UnitLedgerEntry.prototype.portfolio = 0;

    /**
     * UnitLedgerEntry event_time.
     * @member {google.protobuf.ITimestamp|null|undefined} event_time
     * @memberof UnitLedgerEntry
     * @instance
     */
    UnitLedgerEntry.prototype.event_time = null;

    /**
     * UnitLedgerEntry accounting_status.
     * @member {AccountingStatus.Enum} accounting_status
     * @memberof UnitLedgerEntry
     * @instance
     */
    UnitLedgerEntry.prototype.accounting_status = 0;

    /**
     * Creates a new UnitLedgerEntry instance using the specified properties.
     * @function create
     * @memberof UnitLedgerEntry
     * @static
     * @param {IUnitLedgerEntry=} [properties] Properties to set
     * @returns {UnitLedgerEntry} UnitLedgerEntry instance
     */
    UnitLedgerEntry.create = function create(properties) {
        return new UnitLedgerEntry(properties);
    };

    /**
     * Encodes the specified UnitLedgerEntry message. Does not implicitly {@link UnitLedgerEntry.verify|verify} messages.
     * @function encode
     * @memberof UnitLedgerEntry
     * @static
     * @param {IUnitLedgerEntry} message UnitLedgerEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitLedgerEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.product_id);
        if (message.unique_id != null && message.hasOwnProperty("unique_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.unique_id);
        if (message.units != null && message.hasOwnProperty("units"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.units);
        if (message.reason != null && message.hasOwnProperty("reason"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.reason);
        if (message.unit_calc_id != null && message.hasOwnProperty("unit_calc_id"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.unit_calc_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.portfolio);
        if (message.event_time != null && message.hasOwnProperty("event_time"))
            $root.google.protobuf.Timestamp.encode(message.event_time, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.accounting_status);
        return writer;
    };

    /**
     * Encodes the specified UnitLedgerEntry message, length delimited. Does not implicitly {@link UnitLedgerEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitLedgerEntry
     * @static
     * @param {IUnitLedgerEntry} message UnitLedgerEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitLedgerEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitLedgerEntry message from the specified reader or buffer.
     * @function decode
     * @memberof UnitLedgerEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitLedgerEntry} UnitLedgerEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitLedgerEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitLedgerEntry();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.product_id = reader.string();
                break;
            case 2:
                message.unique_id = reader.string();
                break;
            case 3:
                message.units = reader.string();
                break;
            case 4:
                message.reason = reader.int32();
                break;
            case 5:
                message.unit_calc_id = reader.string();
                break;
            case 6:
                message.portfolio = reader.int32();
                break;
            case 7:
                message.event_time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 8:
                message.accounting_status = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitLedgerEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitLedgerEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitLedgerEntry} UnitLedgerEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitLedgerEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitLedgerEntry message.
     * @function verify
     * @memberof UnitLedgerEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitLedgerEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.unique_id != null && message.hasOwnProperty("unique_id"))
            if (!$util.isString(message.unique_id))
                return "unique_id: string expected";
        if (message.units != null && message.hasOwnProperty("units"))
            if (!$util.isString(message.units))
                return "units: string expected";
        if (message.reason != null && message.hasOwnProperty("reason"))
            switch (message.reason) {
            default:
                return "reason: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.unit_calc_id != null && message.hasOwnProperty("unit_calc_id"))
            if (!$util.isString(message.unit_calc_id))
                return "unit_calc_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.event_time != null && message.hasOwnProperty("event_time")) {
            let error = $root.google.protobuf.Timestamp.verify(message.event_time);
            if (error)
                return "event_time." + error;
        }
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            switch (message.accounting_status) {
            default:
                return "accounting_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates an UnitLedgerEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitLedgerEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitLedgerEntry} UnitLedgerEntry
     */
    UnitLedgerEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitLedgerEntry)
            return object;
        let message = new $root.UnitLedgerEntry();
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.unique_id != null)
            message.unique_id = String(object.unique_id);
        if (object.units != null)
            message.units = String(object.units);
        switch (object.reason) {
        case "UNKNOWN":
        case 0:
            message.reason = 0;
            break;
        case "UNIT_EXCHANGE":
        case 1:
            message.reason = 1;
            break;
        case "FEE_REBATE":
        case 2:
            message.reason = 2;
            break;
        case "TRANSFER_SOURCE":
        case 3:
            message.reason = 3;
            break;
        case "TRANSFER_DESTINATION":
        case 4:
            message.reason = 4;
            break;
        case "UNIT_ADJUSTMENT":
        case 5:
            message.reason = 5;
            break;
        }
        if (object.unit_calc_id != null)
            message.unit_calc_id = String(object.unit_calc_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.event_time != null) {
            if (typeof object.event_time !== "object")
                throw TypeError(".UnitLedgerEntry.event_time: object expected");
            message.event_time = $root.google.protobuf.Timestamp.fromObject(object.event_time);
        }
        switch (object.accounting_status) {
        case "UNKNOWN":
        case 0:
            message.accounting_status = 0;
            break;
        case "PENDING":
        case 1:
            message.accounting_status = 1;
            break;
        case "UNCATEGORISED":
        case 2:
            message.accounting_status = 2;
            break;
        case "CATEGORISED":
        case 3:
            message.accounting_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.accounting_status = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from an UnitLedgerEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitLedgerEntry
     * @static
     * @param {UnitLedgerEntry} message UnitLedgerEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitLedgerEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.product_id = "";
            object.unique_id = "";
            object.units = "";
            object.reason = options.enums === String ? "UNKNOWN" : 0;
            object.unit_calc_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.event_time = null;
            object.accounting_status = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.unique_id != null && message.hasOwnProperty("unique_id"))
            object.unique_id = message.unique_id;
        if (message.units != null && message.hasOwnProperty("units"))
            object.units = message.units;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = options.enums === String ? $root.UnitLedgerReason.Enum[message.reason] : message.reason;
        if (message.unit_calc_id != null && message.hasOwnProperty("unit_calc_id"))
            object.unit_calc_id = message.unit_calc_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.event_time != null && message.hasOwnProperty("event_time"))
            object.event_time = $root.google.protobuf.Timestamp.toObject(message.event_time, options);
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            object.accounting_status = options.enums === String ? $root.AccountingStatus.Enum[message.accounting_status] : message.accounting_status;
        return object;
    };

    /**
     * Converts this UnitLedgerEntry to JSON.
     * @function toJSON
     * @memberof UnitLedgerEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitLedgerEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnitLedgerEntry;
})();

export const UnitTransaction = $root.UnitTransaction = (() => {

    /**
     * Properties of an UnitTransaction.
     * @exports IUnitTransaction
     * @interface IUnitTransaction
     * @property {IUnitLedgerEntry|null} [entry] UnitTransaction entry
     * @property {string|null} [aud_amount] UnitTransaction aud_amount
     * @property {string|null} [adjustment_aud_amount] UnitTransaction adjustment_aud_amount
     */

    /**
     * Constructs a new UnitTransaction.
     * @exports UnitTransaction
     * @classdesc Represents an UnitTransaction.
     * @implements IUnitTransaction
     * @constructor
     * @param {IUnitTransaction=} [properties] Properties to set
     */
    function UnitTransaction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnitTransaction entry.
     * @member {IUnitLedgerEntry|null|undefined} entry
     * @memberof UnitTransaction
     * @instance
     */
    UnitTransaction.prototype.entry = null;

    /**
     * UnitTransaction aud_amount.
     * @member {string} aud_amount
     * @memberof UnitTransaction
     * @instance
     */
    UnitTransaction.prototype.aud_amount = "";

    /**
     * UnitTransaction adjustment_aud_amount.
     * @member {string} adjustment_aud_amount
     * @memberof UnitTransaction
     * @instance
     */
    UnitTransaction.prototype.adjustment_aud_amount = "";

    /**
     * Creates a new UnitTransaction instance using the specified properties.
     * @function create
     * @memberof UnitTransaction
     * @static
     * @param {IUnitTransaction=} [properties] Properties to set
     * @returns {UnitTransaction} UnitTransaction instance
     */
    UnitTransaction.create = function create(properties) {
        return new UnitTransaction(properties);
    };

    /**
     * Encodes the specified UnitTransaction message. Does not implicitly {@link UnitTransaction.verify|verify} messages.
     * @function encode
     * @memberof UnitTransaction
     * @static
     * @param {IUnitTransaction} message UnitTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitTransaction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.entry != null && message.hasOwnProperty("entry"))
            $root.UnitLedgerEntry.encode(message.entry, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.aud_amount);
        if (message.adjustment_aud_amount != null && message.hasOwnProperty("adjustment_aud_amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.adjustment_aud_amount);
        return writer;
    };

    /**
     * Encodes the specified UnitTransaction message, length delimited. Does not implicitly {@link UnitTransaction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitTransaction
     * @static
     * @param {IUnitTransaction} message UnitTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitTransaction message from the specified reader or buffer.
     * @function decode
     * @memberof UnitTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitTransaction} UnitTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitTransaction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entry = $root.UnitLedgerEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.aud_amount = reader.string();
                break;
            case 3:
                message.adjustment_aud_amount = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitTransaction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitTransaction} UnitTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitTransaction message.
     * @function verify
     * @memberof UnitTransaction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.entry != null && message.hasOwnProperty("entry")) {
            let error = $root.UnitLedgerEntry.verify(message.entry);
            if (error)
                return "entry." + error;
        }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.adjustment_aud_amount != null && message.hasOwnProperty("adjustment_aud_amount"))
            if (!$util.isString(message.adjustment_aud_amount))
                return "adjustment_aud_amount: string expected";
        return null;
    };

    /**
     * Creates an UnitTransaction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitTransaction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitTransaction} UnitTransaction
     */
    UnitTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitTransaction)
            return object;
        let message = new $root.UnitTransaction();
        if (object.entry != null) {
            if (typeof object.entry !== "object")
                throw TypeError(".UnitTransaction.entry: object expected");
            message.entry = $root.UnitLedgerEntry.fromObject(object.entry);
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        if (object.adjustment_aud_amount != null)
            message.adjustment_aud_amount = String(object.adjustment_aud_amount);
        return message;
    };

    /**
     * Creates a plain object from an UnitTransaction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitTransaction
     * @static
     * @param {UnitTransaction} message UnitTransaction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitTransaction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.entry = null;
            object.aud_amount = "";
            object.adjustment_aud_amount = "";
        }
        if (message.entry != null && message.hasOwnProperty("entry"))
            object.entry = $root.UnitLedgerEntry.toObject(message.entry, options);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.adjustment_aud_amount != null && message.hasOwnProperty("adjustment_aud_amount"))
            object.adjustment_aud_amount = message.adjustment_aud_amount;
        return object;
    };

    /**
     * Converts this UnitTransaction to JSON.
     * @function toJSON
     * @memberof UnitTransaction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnitTransaction;
})();

export const UnitLedgerEntries = $root.UnitLedgerEntries = (() => {

    /**
     * Properties of an UnitLedgerEntries.
     * @exports IUnitLedgerEntries
     * @interface IUnitLedgerEntries
     * @property {Array.<IUnitLedgerEntry>|null} [list] UnitLedgerEntries list
     */

    /**
     * Constructs a new UnitLedgerEntries.
     * @exports UnitLedgerEntries
     * @classdesc Represents an UnitLedgerEntries.
     * @implements IUnitLedgerEntries
     * @constructor
     * @param {IUnitLedgerEntries=} [properties] Properties to set
     */
    function UnitLedgerEntries(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnitLedgerEntries list.
     * @member {Array.<IUnitLedgerEntry>} list
     * @memberof UnitLedgerEntries
     * @instance
     */
    UnitLedgerEntries.prototype.list = $util.emptyArray;

    /**
     * Creates a new UnitLedgerEntries instance using the specified properties.
     * @function create
     * @memberof UnitLedgerEntries
     * @static
     * @param {IUnitLedgerEntries=} [properties] Properties to set
     * @returns {UnitLedgerEntries} UnitLedgerEntries instance
     */
    UnitLedgerEntries.create = function create(properties) {
        return new UnitLedgerEntries(properties);
    };

    /**
     * Encodes the specified UnitLedgerEntries message. Does not implicitly {@link UnitLedgerEntries.verify|verify} messages.
     * @function encode
     * @memberof UnitLedgerEntries
     * @static
     * @param {IUnitLedgerEntries} message UnitLedgerEntries message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitLedgerEntries.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.UnitLedgerEntry.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UnitLedgerEntries message, length delimited. Does not implicitly {@link UnitLedgerEntries.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitLedgerEntries
     * @static
     * @param {IUnitLedgerEntries} message UnitLedgerEntries message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitLedgerEntries.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitLedgerEntries message from the specified reader or buffer.
     * @function decode
     * @memberof UnitLedgerEntries
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitLedgerEntries} UnitLedgerEntries
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitLedgerEntries.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitLedgerEntries();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.UnitLedgerEntry.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitLedgerEntries message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitLedgerEntries
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitLedgerEntries} UnitLedgerEntries
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitLedgerEntries.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitLedgerEntries message.
     * @function verify
     * @memberof UnitLedgerEntries
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitLedgerEntries.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.UnitLedgerEntry.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates an UnitLedgerEntries message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitLedgerEntries
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitLedgerEntries} UnitLedgerEntries
     */
    UnitLedgerEntries.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitLedgerEntries)
            return object;
        let message = new $root.UnitLedgerEntries();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".UnitLedgerEntries.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".UnitLedgerEntries.list: object expected");
                message.list[i] = $root.UnitLedgerEntry.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from an UnitLedgerEntries message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitLedgerEntries
     * @static
     * @param {UnitLedgerEntries} message UnitLedgerEntries
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitLedgerEntries.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.UnitLedgerEntry.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this UnitLedgerEntries to JSON.
     * @function toJSON
     * @memberof UnitLedgerEntries
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitLedgerEntries.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnitLedgerEntries;
})();

export const SuspenseTransactions = $root.SuspenseTransactions = (() => {

    /**
     * Properties of a SuspenseTransactions.
     * @exports ISuspenseTransactions
     * @interface ISuspenseTransactions
     * @property {Array.<ISuspenseTransaction>|null} [list] SuspenseTransactions list
     */

    /**
     * Constructs a new SuspenseTransactions.
     * @exports SuspenseTransactions
     * @classdesc Represents a SuspenseTransactions.
     * @implements ISuspenseTransactions
     * @constructor
     * @param {ISuspenseTransactions=} [properties] Properties to set
     */
    function SuspenseTransactions(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuspenseTransactions list.
     * @member {Array.<ISuspenseTransaction>} list
     * @memberof SuspenseTransactions
     * @instance
     */
    SuspenseTransactions.prototype.list = $util.emptyArray;

    /**
     * Creates a new SuspenseTransactions instance using the specified properties.
     * @function create
     * @memberof SuspenseTransactions
     * @static
     * @param {ISuspenseTransactions=} [properties] Properties to set
     * @returns {SuspenseTransactions} SuspenseTransactions instance
     */
    SuspenseTransactions.create = function create(properties) {
        return new SuspenseTransactions(properties);
    };

    /**
     * Encodes the specified SuspenseTransactions message. Does not implicitly {@link SuspenseTransactions.verify|verify} messages.
     * @function encode
     * @memberof SuspenseTransactions
     * @static
     * @param {ISuspenseTransactions} message SuspenseTransactions message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuspenseTransactions.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.SuspenseTransaction.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SuspenseTransactions message, length delimited. Does not implicitly {@link SuspenseTransactions.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuspenseTransactions
     * @static
     * @param {ISuspenseTransactions} message SuspenseTransactions message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuspenseTransactions.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuspenseTransactions message from the specified reader or buffer.
     * @function decode
     * @memberof SuspenseTransactions
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuspenseTransactions} SuspenseTransactions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuspenseTransactions.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuspenseTransactions();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.SuspenseTransaction.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuspenseTransactions message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuspenseTransactions
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuspenseTransactions} SuspenseTransactions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuspenseTransactions.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuspenseTransactions message.
     * @function verify
     * @memberof SuspenseTransactions
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuspenseTransactions.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.SuspenseTransaction.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates a SuspenseTransactions message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuspenseTransactions
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuspenseTransactions} SuspenseTransactions
     */
    SuspenseTransactions.fromObject = function fromObject(object) {
        if (object instanceof $root.SuspenseTransactions)
            return object;
        let message = new $root.SuspenseTransactions();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".SuspenseTransactions.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".SuspenseTransactions.list: object expected");
                message.list[i] = $root.SuspenseTransaction.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SuspenseTransactions message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuspenseTransactions
     * @static
     * @param {SuspenseTransactions} message SuspenseTransactions
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuspenseTransactions.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.SuspenseTransaction.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this SuspenseTransactions to JSON.
     * @function toJSON
     * @memberof SuspenseTransactions
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuspenseTransactions.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuspenseTransactions;
})();

export const FundTransactions = $root.FundTransactions = (() => {

    /**
     * Properties of a FundTransactions.
     * @exports IFundTransactions
     * @interface IFundTransactions
     * @property {Array.<IFundTransaction>|null} [list] FundTransactions list
     */

    /**
     * Constructs a new FundTransactions.
     * @exports FundTransactions
     * @classdesc Represents a FundTransactions.
     * @implements IFundTransactions
     * @constructor
     * @param {IFundTransactions=} [properties] Properties to set
     */
    function FundTransactions(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FundTransactions list.
     * @member {Array.<IFundTransaction>} list
     * @memberof FundTransactions
     * @instance
     */
    FundTransactions.prototype.list = $util.emptyArray;

    /**
     * Creates a new FundTransactions instance using the specified properties.
     * @function create
     * @memberof FundTransactions
     * @static
     * @param {IFundTransactions=} [properties] Properties to set
     * @returns {FundTransactions} FundTransactions instance
     */
    FundTransactions.create = function create(properties) {
        return new FundTransactions(properties);
    };

    /**
     * Encodes the specified FundTransactions message. Does not implicitly {@link FundTransactions.verify|verify} messages.
     * @function encode
     * @memberof FundTransactions
     * @static
     * @param {IFundTransactions} message FundTransactions message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FundTransactions.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.FundTransaction.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FundTransactions message, length delimited. Does not implicitly {@link FundTransactions.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FundTransactions
     * @static
     * @param {IFundTransactions} message FundTransactions message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FundTransactions.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FundTransactions message from the specified reader or buffer.
     * @function decode
     * @memberof FundTransactions
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FundTransactions} FundTransactions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FundTransactions.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FundTransactions();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.FundTransaction.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FundTransactions message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FundTransactions
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FundTransactions} FundTransactions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FundTransactions.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FundTransactions message.
     * @function verify
     * @memberof FundTransactions
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FundTransactions.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.FundTransaction.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates a FundTransactions message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FundTransactions
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FundTransactions} FundTransactions
     */
    FundTransactions.fromObject = function fromObject(object) {
        if (object instanceof $root.FundTransactions)
            return object;
        let message = new $root.FundTransactions();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".FundTransactions.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".FundTransactions.list: object expected");
                message.list[i] = $root.FundTransaction.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a FundTransactions message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FundTransactions
     * @static
     * @param {FundTransactions} message FundTransactions
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FundTransactions.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.FundTransaction.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this FundTransactions to JSON.
     * @function toJSON
     * @memberof FundTransactions
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FundTransactions.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FundTransactions;
})();

export const PositionMismatch = $root.PositionMismatch = (() => {

    /**
     * Properties of a PositionMismatch.
     * @exports IPositionMismatch
     * @interface IPositionMismatch
     * @property {string|null} [instrument_id] PositionMismatch instrument_id
     * @property {string|null} [ib_position] PositionMismatch ib_position
     * @property {string|null} [um_position] PositionMismatch um_position
     */

    /**
     * Constructs a new PositionMismatch.
     * @exports PositionMismatch
     * @classdesc Represents a PositionMismatch.
     * @implements IPositionMismatch
     * @constructor
     * @param {IPositionMismatch=} [properties] Properties to set
     */
    function PositionMismatch(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PositionMismatch instrument_id.
     * @member {string} instrument_id
     * @memberof PositionMismatch
     * @instance
     */
    PositionMismatch.prototype.instrument_id = "";

    /**
     * PositionMismatch ib_position.
     * @member {string} ib_position
     * @memberof PositionMismatch
     * @instance
     */
    PositionMismatch.prototype.ib_position = "";

    /**
     * PositionMismatch um_position.
     * @member {string} um_position
     * @memberof PositionMismatch
     * @instance
     */
    PositionMismatch.prototype.um_position = "";

    /**
     * Creates a new PositionMismatch instance using the specified properties.
     * @function create
     * @memberof PositionMismatch
     * @static
     * @param {IPositionMismatch=} [properties] Properties to set
     * @returns {PositionMismatch} PositionMismatch instance
     */
    PositionMismatch.create = function create(properties) {
        return new PositionMismatch(properties);
    };

    /**
     * Encodes the specified PositionMismatch message. Does not implicitly {@link PositionMismatch.verify|verify} messages.
     * @function encode
     * @memberof PositionMismatch
     * @static
     * @param {IPositionMismatch} message PositionMismatch message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PositionMismatch.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.instrument_id);
        if (message.ib_position != null && message.hasOwnProperty("ib_position"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.ib_position);
        if (message.um_position != null && message.hasOwnProperty("um_position"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.um_position);
        return writer;
    };

    /**
     * Encodes the specified PositionMismatch message, length delimited. Does not implicitly {@link PositionMismatch.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PositionMismatch
     * @static
     * @param {IPositionMismatch} message PositionMismatch message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PositionMismatch.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PositionMismatch message from the specified reader or buffer.
     * @function decode
     * @memberof PositionMismatch
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PositionMismatch} PositionMismatch
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PositionMismatch.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PositionMismatch();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.instrument_id = reader.string();
                break;
            case 2:
                message.ib_position = reader.string();
                break;
            case 3:
                message.um_position = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PositionMismatch message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PositionMismatch
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PositionMismatch} PositionMismatch
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PositionMismatch.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PositionMismatch message.
     * @function verify
     * @memberof PositionMismatch
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PositionMismatch.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            if (!$util.isString(message.instrument_id))
                return "instrument_id: string expected";
        if (message.ib_position != null && message.hasOwnProperty("ib_position"))
            if (!$util.isString(message.ib_position))
                return "ib_position: string expected";
        if (message.um_position != null && message.hasOwnProperty("um_position"))
            if (!$util.isString(message.um_position))
                return "um_position: string expected";
        return null;
    };

    /**
     * Creates a PositionMismatch message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PositionMismatch
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PositionMismatch} PositionMismatch
     */
    PositionMismatch.fromObject = function fromObject(object) {
        if (object instanceof $root.PositionMismatch)
            return object;
        let message = new $root.PositionMismatch();
        if (object.instrument_id != null)
            message.instrument_id = String(object.instrument_id);
        if (object.ib_position != null)
            message.ib_position = String(object.ib_position);
        if (object.um_position != null)
            message.um_position = String(object.um_position);
        return message;
    };

    /**
     * Creates a plain object from a PositionMismatch message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PositionMismatch
     * @static
     * @param {PositionMismatch} message PositionMismatch
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PositionMismatch.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.instrument_id = "";
            object.ib_position = "";
            object.um_position = "";
        }
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            object.instrument_id = message.instrument_id;
        if (message.ib_position != null && message.hasOwnProperty("ib_position"))
            object.ib_position = message.ib_position;
        if (message.um_position != null && message.hasOwnProperty("um_position"))
            object.um_position = message.um_position;
        return object;
    };

    /**
     * Converts this PositionMismatch to JSON.
     * @function toJSON
     * @memberof PositionMismatch
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PositionMismatch.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PositionMismatch;
})();

export const StrikeTaskReason = $root.StrikeTaskReason = (() => {

    /**
     * Properties of a StrikeTaskReason.
     * @exports IStrikeTaskReason
     * @interface IStrikeTaskReason
     */

    /**
     * Constructs a new StrikeTaskReason.
     * @exports StrikeTaskReason
     * @classdesc Represents a StrikeTaskReason.
     * @implements IStrikeTaskReason
     * @constructor
     * @param {IStrikeTaskReason=} [properties] Properties to set
     */
    function StrikeTaskReason(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new StrikeTaskReason instance using the specified properties.
     * @function create
     * @memberof StrikeTaskReason
     * @static
     * @param {IStrikeTaskReason=} [properties] Properties to set
     * @returns {StrikeTaskReason} StrikeTaskReason instance
     */
    StrikeTaskReason.create = function create(properties) {
        return new StrikeTaskReason(properties);
    };

    /**
     * Encodes the specified StrikeTaskReason message. Does not implicitly {@link StrikeTaskReason.verify|verify} messages.
     * @function encode
     * @memberof StrikeTaskReason
     * @static
     * @param {IStrikeTaskReason} message StrikeTaskReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StrikeTaskReason.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified StrikeTaskReason message, length delimited. Does not implicitly {@link StrikeTaskReason.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StrikeTaskReason
     * @static
     * @param {IStrikeTaskReason} message StrikeTaskReason message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StrikeTaskReason.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StrikeTaskReason message from the specified reader or buffer.
     * @function decode
     * @memberof StrikeTaskReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StrikeTaskReason} StrikeTaskReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StrikeTaskReason.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StrikeTaskReason();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a StrikeTaskReason message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StrikeTaskReason
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StrikeTaskReason} StrikeTaskReason
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StrikeTaskReason.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StrikeTaskReason message.
     * @function verify
     * @memberof StrikeTaskReason
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StrikeTaskReason.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a StrikeTaskReason message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StrikeTaskReason
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StrikeTaskReason} StrikeTaskReason
     */
    StrikeTaskReason.fromObject = function fromObject(object) {
        if (object instanceof $root.StrikeTaskReason)
            return object;
        return new $root.StrikeTaskReason();
    };

    /**
     * Creates a plain object from a StrikeTaskReason message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StrikeTaskReason
     * @static
     * @param {StrikeTaskReason} message StrikeTaskReason
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StrikeTaskReason.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this StrikeTaskReason to JSON.
     * @function toJSON
     * @memberof StrikeTaskReason
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StrikeTaskReason.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name StrikeTaskReason.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} NOT_STRIKE_DAY=1 NOT_STRIKE_DAY value
     * @property {number} TOO_EARLY=2 TOO_EARLY value
     * @property {number} MISSING_BB_FOREX=3 MISSING_BB_FOREX value
     * @property {number} MISSING_BB_PRICE=4 MISSING_BB_PRICE value
     * @property {number} TRADE_MARKET_DISCREPANCY=5 TRADE_MARKET_DISCREPANCY value
     * @property {number} MISSING_IB_POSITION_COMPARISON=6 MISSING_IB_POSITION_COMPARISON value
     * @property {number} MISSING_IB_ACTIVITY_STATEMENT=7 MISSING_IB_ACTIVITY_STATEMENT value
     * @property {number} UNPROCESSED_IB_DIVIDEND_ACCRUALS=8 UNPROCESSED_IB_DIVIDEND_ACCRUALS value
     * @property {number} UNPROCESSED_IB_CASH_TRANSACTIONS=9 UNPROCESSED_IB_CASH_TRANSACTIONS value
     * @property {number} UNPROCESSED_DIVIDEND_PAYMENTS=10 UNPROCESSED_DIVIDEND_PAYMENTS value
     * @property {number} MISSING_DIVIDEND_ACCRUAL_ADJUSTMENT=11 MISSING_DIVIDEND_ACCRUAL_ADJUSTMENT value
     * @property {number} CHECK_UNIT_STRIKE_PREVIEW=12 CHECK_UNIT_STRIKE_PREVIEW value
     * @property {number} CHECK_CASH_SUMMARY=13 CHECK_CASH_SUMMARY value
     * @property {number} EXISTING_NEGATIVE_UNIT_BALANCES=14 EXISTING_NEGATIVE_UNIT_BALANCES value
     * @property {number} MISSING_LAST_UNIT_PRICE=15 MISSING_LAST_UNIT_PRICE value
     * @property {number} LOCKED=16 LOCKED value
     * @property {number} CHECK_NEW_UNIT_STRIKE_PREVIEW=17 CHECK_NEW_UNIT_STRIKE_PREVIEW value
     * @property {number} VERIFY_FAST_TRACKED_APPLICATION_ORDERS_PLACED=18 VERIFY_FAST_TRACKED_APPLICATION_ORDERS_PLACED value
     * @property {number} VERIFY_ORDER_REVERSALS_EXECUTED=19 VERIFY_ORDER_REVERSALS_EXECUTED value
     * @property {number} MISSING_MACQUARIE_TXN_FILE=20 MISSING_MACQUARIE_TXN_FILE value
     * @property {number} UNPROCESSED_MACQUARIE_TRANSACTIONS=21 UNPROCESSED_MACQUARIE_TRANSACTIONS value
     * @property {number} MISSING_LAST_EX_UNIT_PRICE=22 MISSING_LAST_EX_UNIT_PRICE value
     * @property {number} CHECK_FEE_SUMMARY=23 CHECK_FEE_SUMMARY value
     * @property {number} CHECK_FEE_CASH_SUMMARY=24 CHECK_FEE_CASH_SUMMARY value
     * @property {number} MISSING_EZE_DATA=25 MISSING_EZE_DATA value
     * @property {number} EZE_NAV_AMOUNT=26 EZE_NAV_AMOUNT value
     * @property {number} EZE_MANAGEMENT_FEE_AMOUNT=27 EZE_MANAGEMENT_FEE_AMOUNT value
     */
    StrikeTaskReason.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "NOT_STRIKE_DAY"] = 1;
        values[valuesById[2] = "TOO_EARLY"] = 2;
        values[valuesById[3] = "MISSING_BB_FOREX"] = 3;
        values[valuesById[4] = "MISSING_BB_PRICE"] = 4;
        values[valuesById[5] = "TRADE_MARKET_DISCREPANCY"] = 5;
        values[valuesById[6] = "MISSING_IB_POSITION_COMPARISON"] = 6;
        values[valuesById[7] = "MISSING_IB_ACTIVITY_STATEMENT"] = 7;
        values[valuesById[8] = "UNPROCESSED_IB_DIVIDEND_ACCRUALS"] = 8;
        values[valuesById[9] = "UNPROCESSED_IB_CASH_TRANSACTIONS"] = 9;
        values[valuesById[10] = "UNPROCESSED_DIVIDEND_PAYMENTS"] = 10;
        values[valuesById[11] = "MISSING_DIVIDEND_ACCRUAL_ADJUSTMENT"] = 11;
        values[valuesById[12] = "CHECK_UNIT_STRIKE_PREVIEW"] = 12;
        values[valuesById[13] = "CHECK_CASH_SUMMARY"] = 13;
        values[valuesById[14] = "EXISTING_NEGATIVE_UNIT_BALANCES"] = 14;
        values[valuesById[15] = "MISSING_LAST_UNIT_PRICE"] = 15;
        values[valuesById[16] = "LOCKED"] = 16;
        values[valuesById[17] = "CHECK_NEW_UNIT_STRIKE_PREVIEW"] = 17;
        values[valuesById[18] = "VERIFY_FAST_TRACKED_APPLICATION_ORDERS_PLACED"] = 18;
        values[valuesById[19] = "VERIFY_ORDER_REVERSALS_EXECUTED"] = 19;
        values[valuesById[20] = "MISSING_MACQUARIE_TXN_FILE"] = 20;
        values[valuesById[21] = "UNPROCESSED_MACQUARIE_TRANSACTIONS"] = 21;
        values[valuesById[22] = "MISSING_LAST_EX_UNIT_PRICE"] = 22;
        values[valuesById[23] = "CHECK_FEE_SUMMARY"] = 23;
        values[valuesById[24] = "CHECK_FEE_CASH_SUMMARY"] = 24;
        values[valuesById[25] = "MISSING_EZE_DATA"] = 25;
        values[valuesById[26] = "EZE_NAV_AMOUNT"] = 26;
        values[valuesById[27] = "EZE_MANAGEMENT_FEE_AMOUNT"] = 27;
        return values;
    })();

    return StrikeTaskReason;
})();

export const StrikeTask = $root.StrikeTask = (() => {

    /**
     * Properties of a StrikeTask.
     * @exports IStrikeTask
     * @interface IStrikeTask
     * @property {string|null} [description] StrikeTask description
     * @property {StrikeTaskReason.Enum|null} [reason] StrikeTask reason
     * @property {string|null} [reference_id] StrikeTask reference_id
     * @property {string|null} [effective_date] StrikeTask effective_date
     */

    /**
     * Constructs a new StrikeTask.
     * @exports StrikeTask
     * @classdesc Represents a StrikeTask.
     * @implements IStrikeTask
     * @constructor
     * @param {IStrikeTask=} [properties] Properties to set
     */
    function StrikeTask(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * StrikeTask description.
     * @member {string} description
     * @memberof StrikeTask
     * @instance
     */
    StrikeTask.prototype.description = "";

    /**
     * StrikeTask reason.
     * @member {StrikeTaskReason.Enum} reason
     * @memberof StrikeTask
     * @instance
     */
    StrikeTask.prototype.reason = 0;

    /**
     * StrikeTask reference_id.
     * @member {string} reference_id
     * @memberof StrikeTask
     * @instance
     */
    StrikeTask.prototype.reference_id = "";

    /**
     * StrikeTask effective_date.
     * @member {string} effective_date
     * @memberof StrikeTask
     * @instance
     */
    StrikeTask.prototype.effective_date = "";

    /**
     * Creates a new StrikeTask instance using the specified properties.
     * @function create
     * @memberof StrikeTask
     * @static
     * @param {IStrikeTask=} [properties] Properties to set
     * @returns {StrikeTask} StrikeTask instance
     */
    StrikeTask.create = function create(properties) {
        return new StrikeTask(properties);
    };

    /**
     * Encodes the specified StrikeTask message. Does not implicitly {@link StrikeTask.verify|verify} messages.
     * @function encode
     * @memberof StrikeTask
     * @static
     * @param {IStrikeTask} message StrikeTask message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StrikeTask.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.description != null && message.hasOwnProperty("description"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.description);
        if (message.reason != null && message.hasOwnProperty("reason"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.reason);
        if (message.reference_id != null && message.hasOwnProperty("reference_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.reference_id);
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.effective_date);
        return writer;
    };

    /**
     * Encodes the specified StrikeTask message, length delimited. Does not implicitly {@link StrikeTask.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StrikeTask
     * @static
     * @param {IStrikeTask} message StrikeTask message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StrikeTask.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StrikeTask message from the specified reader or buffer.
     * @function decode
     * @memberof StrikeTask
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StrikeTask} StrikeTask
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StrikeTask.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StrikeTask();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.description = reader.string();
                break;
            case 2:
                message.reason = reader.int32();
                break;
            case 3:
                message.reference_id = reader.string();
                break;
            case 4:
                message.effective_date = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a StrikeTask message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StrikeTask
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StrikeTask} StrikeTask
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StrikeTask.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StrikeTask message.
     * @function verify
     * @memberof StrikeTask
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StrikeTask.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.reason != null && message.hasOwnProperty("reason"))
            switch (message.reason) {
            default:
                return "reason: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
                break;
            }
        if (message.reference_id != null && message.hasOwnProperty("reference_id"))
            if (!$util.isString(message.reference_id))
                return "reference_id: string expected";
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            if (!$util.isString(message.effective_date))
                return "effective_date: string expected";
        return null;
    };

    /**
     * Creates a StrikeTask message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StrikeTask
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StrikeTask} StrikeTask
     */
    StrikeTask.fromObject = function fromObject(object) {
        if (object instanceof $root.StrikeTask)
            return object;
        let message = new $root.StrikeTask();
        if (object.description != null)
            message.description = String(object.description);
        switch (object.reason) {
        case "UNKNOWN":
        case 0:
            message.reason = 0;
            break;
        case "NOT_STRIKE_DAY":
        case 1:
            message.reason = 1;
            break;
        case "TOO_EARLY":
        case 2:
            message.reason = 2;
            break;
        case "MISSING_BB_FOREX":
        case 3:
            message.reason = 3;
            break;
        case "MISSING_BB_PRICE":
        case 4:
            message.reason = 4;
            break;
        case "TRADE_MARKET_DISCREPANCY":
        case 5:
            message.reason = 5;
            break;
        case "MISSING_IB_POSITION_COMPARISON":
        case 6:
            message.reason = 6;
            break;
        case "MISSING_IB_ACTIVITY_STATEMENT":
        case 7:
            message.reason = 7;
            break;
        case "UNPROCESSED_IB_DIVIDEND_ACCRUALS":
        case 8:
            message.reason = 8;
            break;
        case "UNPROCESSED_IB_CASH_TRANSACTIONS":
        case 9:
            message.reason = 9;
            break;
        case "UNPROCESSED_DIVIDEND_PAYMENTS":
        case 10:
            message.reason = 10;
            break;
        case "MISSING_DIVIDEND_ACCRUAL_ADJUSTMENT":
        case 11:
            message.reason = 11;
            break;
        case "CHECK_UNIT_STRIKE_PREVIEW":
        case 12:
            message.reason = 12;
            break;
        case "CHECK_CASH_SUMMARY":
        case 13:
            message.reason = 13;
            break;
        case "EXISTING_NEGATIVE_UNIT_BALANCES":
        case 14:
            message.reason = 14;
            break;
        case "MISSING_LAST_UNIT_PRICE":
        case 15:
            message.reason = 15;
            break;
        case "LOCKED":
        case 16:
            message.reason = 16;
            break;
        case "CHECK_NEW_UNIT_STRIKE_PREVIEW":
        case 17:
            message.reason = 17;
            break;
        case "VERIFY_FAST_TRACKED_APPLICATION_ORDERS_PLACED":
        case 18:
            message.reason = 18;
            break;
        case "VERIFY_ORDER_REVERSALS_EXECUTED":
        case 19:
            message.reason = 19;
            break;
        case "MISSING_MACQUARIE_TXN_FILE":
        case 20:
            message.reason = 20;
            break;
        case "UNPROCESSED_MACQUARIE_TRANSACTIONS":
        case 21:
            message.reason = 21;
            break;
        case "MISSING_LAST_EX_UNIT_PRICE":
        case 22:
            message.reason = 22;
            break;
        case "CHECK_FEE_SUMMARY":
        case 23:
            message.reason = 23;
            break;
        case "CHECK_FEE_CASH_SUMMARY":
        case 24:
            message.reason = 24;
            break;
        case "MISSING_EZE_DATA":
        case 25:
            message.reason = 25;
            break;
        case "EZE_NAV_AMOUNT":
        case 26:
            message.reason = 26;
            break;
        case "EZE_MANAGEMENT_FEE_AMOUNT":
        case 27:
            message.reason = 27;
            break;
        }
        if (object.reference_id != null)
            message.reference_id = String(object.reference_id);
        if (object.effective_date != null)
            message.effective_date = String(object.effective_date);
        return message;
    };

    /**
     * Creates a plain object from a StrikeTask message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StrikeTask
     * @static
     * @param {StrikeTask} message StrikeTask
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StrikeTask.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.description = "";
            object.reason = options.enums === String ? "UNKNOWN" : 0;
            object.reference_id = "";
            object.effective_date = "";
        }
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = options.enums === String ? $root.StrikeTaskReason.Enum[message.reason] : message.reason;
        if (message.reference_id != null && message.hasOwnProperty("reference_id"))
            object.reference_id = message.reference_id;
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            object.effective_date = message.effective_date;
        return object;
    };

    /**
     * Converts this StrikeTask to JSON.
     * @function toJSON
     * @memberof StrikeTask
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StrikeTask.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StrikeTask;
})();

export const PortfolioStrikeTasks = $root.PortfolioStrikeTasks = (() => {

    /**
     * Properties of a PortfolioStrikeTasks.
     * @exports IPortfolioStrikeTasks
     * @interface IPortfolioStrikeTasks
     * @property {SaverPortfolio.Enum|null} [portfolio] PortfolioStrikeTasks portfolio
     * @property {Array.<IStrikeTask>|null} [strike_tasks] PortfolioStrikeTasks strike_tasks
     */

    /**
     * Constructs a new PortfolioStrikeTasks.
     * @exports PortfolioStrikeTasks
     * @classdesc Represents a PortfolioStrikeTasks.
     * @implements IPortfolioStrikeTasks
     * @constructor
     * @param {IPortfolioStrikeTasks=} [properties] Properties to set
     */
    function PortfolioStrikeTasks(properties) {
        this.strike_tasks = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PortfolioStrikeTasks portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof PortfolioStrikeTasks
     * @instance
     */
    PortfolioStrikeTasks.prototype.portfolio = 0;

    /**
     * PortfolioStrikeTasks strike_tasks.
     * @member {Array.<IStrikeTask>} strike_tasks
     * @memberof PortfolioStrikeTasks
     * @instance
     */
    PortfolioStrikeTasks.prototype.strike_tasks = $util.emptyArray;

    /**
     * Creates a new PortfolioStrikeTasks instance using the specified properties.
     * @function create
     * @memberof PortfolioStrikeTasks
     * @static
     * @param {IPortfolioStrikeTasks=} [properties] Properties to set
     * @returns {PortfolioStrikeTasks} PortfolioStrikeTasks instance
     */
    PortfolioStrikeTasks.create = function create(properties) {
        return new PortfolioStrikeTasks(properties);
    };

    /**
     * Encodes the specified PortfolioStrikeTasks message. Does not implicitly {@link PortfolioStrikeTasks.verify|verify} messages.
     * @function encode
     * @memberof PortfolioStrikeTasks
     * @static
     * @param {IPortfolioStrikeTasks} message PortfolioStrikeTasks message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PortfolioStrikeTasks.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
        if (message.strike_tasks != null && message.strike_tasks.length)
            for (let i = 0; i < message.strike_tasks.length; ++i)
                $root.StrikeTask.encode(message.strike_tasks[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PortfolioStrikeTasks message, length delimited. Does not implicitly {@link PortfolioStrikeTasks.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PortfolioStrikeTasks
     * @static
     * @param {IPortfolioStrikeTasks} message PortfolioStrikeTasks message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PortfolioStrikeTasks.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PortfolioStrikeTasks message from the specified reader or buffer.
     * @function decode
     * @memberof PortfolioStrikeTasks
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PortfolioStrikeTasks} PortfolioStrikeTasks
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PortfolioStrikeTasks.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PortfolioStrikeTasks();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.portfolio = reader.int32();
                break;
            case 2:
                if (!(message.strike_tasks && message.strike_tasks.length))
                    message.strike_tasks = [];
                message.strike_tasks.push($root.StrikeTask.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PortfolioStrikeTasks message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PortfolioStrikeTasks
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PortfolioStrikeTasks} PortfolioStrikeTasks
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PortfolioStrikeTasks.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PortfolioStrikeTasks message.
     * @function verify
     * @memberof PortfolioStrikeTasks
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PortfolioStrikeTasks.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.strike_tasks != null && message.hasOwnProperty("strike_tasks")) {
            if (!Array.isArray(message.strike_tasks))
                return "strike_tasks: array expected";
            for (let i = 0; i < message.strike_tasks.length; ++i) {
                let error = $root.StrikeTask.verify(message.strike_tasks[i]);
                if (error)
                    return "strike_tasks." + error;
            }
        }
        return null;
    };

    /**
     * Creates a PortfolioStrikeTasks message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PortfolioStrikeTasks
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PortfolioStrikeTasks} PortfolioStrikeTasks
     */
    PortfolioStrikeTasks.fromObject = function fromObject(object) {
        if (object instanceof $root.PortfolioStrikeTasks)
            return object;
        let message = new $root.PortfolioStrikeTasks();
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.strike_tasks) {
            if (!Array.isArray(object.strike_tasks))
                throw TypeError(".PortfolioStrikeTasks.strike_tasks: array expected");
            message.strike_tasks = [];
            for (let i = 0; i < object.strike_tasks.length; ++i) {
                if (typeof object.strike_tasks[i] !== "object")
                    throw TypeError(".PortfolioStrikeTasks.strike_tasks: object expected");
                message.strike_tasks[i] = $root.StrikeTask.fromObject(object.strike_tasks[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a PortfolioStrikeTasks message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PortfolioStrikeTasks
     * @static
     * @param {PortfolioStrikeTasks} message PortfolioStrikeTasks
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PortfolioStrikeTasks.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.strike_tasks = [];
        if (options.defaults)
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.strike_tasks && message.strike_tasks.length) {
            object.strike_tasks = [];
            for (let j = 0; j < message.strike_tasks.length; ++j)
                object.strike_tasks[j] = $root.StrikeTask.toObject(message.strike_tasks[j], options);
        }
        return object;
    };

    /**
     * Converts this PortfolioStrikeTasks to JSON.
     * @function toJSON
     * @memberof PortfolioStrikeTasks
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PortfolioStrikeTasks.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PortfolioStrikeTasks;
})();

export const FailedExit = $root.FailedExit = (() => {

    /**
     * Properties of a FailedExit.
     * @exports IFailedExit
     * @interface IFailedExit
     * @property {string|null} [id] FailedExit id
     * @property {ISuspenseTransaction|null} [suspense_transaction] FailedExit suspense_transaction
     * @property {boolean|null} [resolved] FailedExit resolved
     * @property {string|null} [resolved_by_admin_id] FailedExit resolved_by_admin_id
     * @property {google.protobuf.ITimestamp|null} [created_at] FailedExit created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] FailedExit last_updated_at
     */

    /**
     * Constructs a new FailedExit.
     * @exports FailedExit
     * @classdesc Represents a FailedExit.
     * @implements IFailedExit
     * @constructor
     * @param {IFailedExit=} [properties] Properties to set
     */
    function FailedExit(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FailedExit id.
     * @member {string} id
     * @memberof FailedExit
     * @instance
     */
    FailedExit.prototype.id = "";

    /**
     * FailedExit suspense_transaction.
     * @member {ISuspenseTransaction|null|undefined} suspense_transaction
     * @memberof FailedExit
     * @instance
     */
    FailedExit.prototype.suspense_transaction = null;

    /**
     * FailedExit resolved.
     * @member {boolean} resolved
     * @memberof FailedExit
     * @instance
     */
    FailedExit.prototype.resolved = false;

    /**
     * FailedExit resolved_by_admin_id.
     * @member {string} resolved_by_admin_id
     * @memberof FailedExit
     * @instance
     */
    FailedExit.prototype.resolved_by_admin_id = "";

    /**
     * FailedExit created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof FailedExit
     * @instance
     */
    FailedExit.prototype.created_at = null;

    /**
     * FailedExit last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof FailedExit
     * @instance
     */
    FailedExit.prototype.last_updated_at = null;

    /**
     * Creates a new FailedExit instance using the specified properties.
     * @function create
     * @memberof FailedExit
     * @static
     * @param {IFailedExit=} [properties] Properties to set
     * @returns {FailedExit} FailedExit instance
     */
    FailedExit.create = function create(properties) {
        return new FailedExit(properties);
    };

    /**
     * Encodes the specified FailedExit message. Does not implicitly {@link FailedExit.verify|verify} messages.
     * @function encode
     * @memberof FailedExit
     * @static
     * @param {IFailedExit} message FailedExit message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FailedExit.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction"))
            $root.SuspenseTransaction.encode(message.suspense_transaction, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.resolved != null && message.hasOwnProperty("resolved"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.resolved);
        if (message.resolved_by_admin_id != null && message.hasOwnProperty("resolved_by_admin_id"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.resolved_by_admin_id);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FailedExit message, length delimited. Does not implicitly {@link FailedExit.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FailedExit
     * @static
     * @param {IFailedExit} message FailedExit message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FailedExit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FailedExit message from the specified reader or buffer.
     * @function decode
     * @memberof FailedExit
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FailedExit} FailedExit
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FailedExit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FailedExit();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.suspense_transaction = $root.SuspenseTransaction.decode(reader, reader.uint32());
                break;
            case 3:
                message.resolved = reader.bool();
                break;
            case 4:
                message.resolved_by_admin_id = reader.string();
                break;
            case 5:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 6:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FailedExit message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FailedExit
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FailedExit} FailedExit
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FailedExit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FailedExit message.
     * @function verify
     * @memberof FailedExit
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FailedExit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction")) {
            let error = $root.SuspenseTransaction.verify(message.suspense_transaction);
            if (error)
                return "suspense_transaction." + error;
        }
        if (message.resolved != null && message.hasOwnProperty("resolved"))
            if (typeof message.resolved !== "boolean")
                return "resolved: boolean expected";
        if (message.resolved_by_admin_id != null && message.hasOwnProperty("resolved_by_admin_id"))
            if (!$util.isString(message.resolved_by_admin_id))
                return "resolved_by_admin_id: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a FailedExit message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FailedExit
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FailedExit} FailedExit
     */
    FailedExit.fromObject = function fromObject(object) {
        if (object instanceof $root.FailedExit)
            return object;
        let message = new $root.FailedExit();
        if (object.id != null)
            message.id = String(object.id);
        if (object.suspense_transaction != null) {
            if (typeof object.suspense_transaction !== "object")
                throw TypeError(".FailedExit.suspense_transaction: object expected");
            message.suspense_transaction = $root.SuspenseTransaction.fromObject(object.suspense_transaction);
        }
        if (object.resolved != null)
            message.resolved = Boolean(object.resolved);
        if (object.resolved_by_admin_id != null)
            message.resolved_by_admin_id = String(object.resolved_by_admin_id);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".FailedExit.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".FailedExit.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a FailedExit message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FailedExit
     * @static
     * @param {FailedExit} message FailedExit
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FailedExit.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.suspense_transaction = null;
            object.resolved = false;
            object.resolved_by_admin_id = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction"))
            object.suspense_transaction = $root.SuspenseTransaction.toObject(message.suspense_transaction, options);
        if (message.resolved != null && message.hasOwnProperty("resolved"))
            object.resolved = message.resolved;
        if (message.resolved_by_admin_id != null && message.hasOwnProperty("resolved_by_admin_id"))
            object.resolved_by_admin_id = message.resolved_by_admin_id;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this FailedExit to JSON.
     * @function toJSON
     * @memberof FailedExit
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FailedExit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FailedExit;
})();

export const MacquarieTransactionCode = $root.MacquarieTransactionCode = (() => {

    /**
     * Properties of a MacquarieTransactionCode.
     * @exports IMacquarieTransactionCode
     * @interface IMacquarieTransactionCode
     */

    /**
     * Constructs a new MacquarieTransactionCode.
     * @exports MacquarieTransactionCode
     * @classdesc Represents a MacquarieTransactionCode.
     * @implements IMacquarieTransactionCode
     * @constructor
     * @param {IMacquarieTransactionCode=} [properties] Properties to set
     */
    function MacquarieTransactionCode(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new MacquarieTransactionCode instance using the specified properties.
     * @function create
     * @memberof MacquarieTransactionCode
     * @static
     * @param {IMacquarieTransactionCode=} [properties] Properties to set
     * @returns {MacquarieTransactionCode} MacquarieTransactionCode instance
     */
    MacquarieTransactionCode.create = function create(properties) {
        return new MacquarieTransactionCode(properties);
    };

    /**
     * Encodes the specified MacquarieTransactionCode message. Does not implicitly {@link MacquarieTransactionCode.verify|verify} messages.
     * @function encode
     * @memberof MacquarieTransactionCode
     * @static
     * @param {IMacquarieTransactionCode} message MacquarieTransactionCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MacquarieTransactionCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified MacquarieTransactionCode message, length delimited. Does not implicitly {@link MacquarieTransactionCode.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MacquarieTransactionCode
     * @static
     * @param {IMacquarieTransactionCode} message MacquarieTransactionCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MacquarieTransactionCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MacquarieTransactionCode message from the specified reader or buffer.
     * @function decode
     * @memberof MacquarieTransactionCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MacquarieTransactionCode} MacquarieTransactionCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MacquarieTransactionCode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MacquarieTransactionCode();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MacquarieTransactionCode message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MacquarieTransactionCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MacquarieTransactionCode} MacquarieTransactionCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MacquarieTransactionCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MacquarieTransactionCode message.
     * @function verify
     * @memberof MacquarieTransactionCode
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MacquarieTransactionCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a MacquarieTransactionCode message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MacquarieTransactionCode
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MacquarieTransactionCode} MacquarieTransactionCode
     */
    MacquarieTransactionCode.fromObject = function fromObject(object) {
        if (object instanceof $root.MacquarieTransactionCode)
            return object;
        return new $root.MacquarieTransactionCode();
    };

    /**
     * Creates a plain object from a MacquarieTransactionCode message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MacquarieTransactionCode
     * @static
     * @param {MacquarieTransactionCode} message MacquarieTransactionCode
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MacquarieTransactionCode.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this MacquarieTransactionCode to JSON.
     * @function toJSON
     * @memberof MacquarieTransactionCode
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MacquarieTransactionCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name MacquarieTransactionCode.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} DEPOSIT=1 DEPOSIT value
     * @property {number} INTEREST_PAID=2 INTEREST_PAID value
     * @property {number} REVERSAL_CREDIT=3 REVERSAL_CREDIT value
     * @property {number} DEBIT=4 DEBIT value
     * @property {number} REVERSAL_DEBIT=5 REVERSAL_DEBIT value
     * @property {number} DISHONOUR=6 DISHONOUR value
     * @property {number} SERVICE_CHARGE=7 SERVICE_CHARGE value
     * @property {number} CHEQUE=8 CHEQUE value
     * @property {number} INTEREST_CHARGED=9 INTEREST_CHARGED value
     */
    MacquarieTransactionCode.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "DEPOSIT"] = 1;
        values[valuesById[2] = "INTEREST_PAID"] = 2;
        values[valuesById[3] = "REVERSAL_CREDIT"] = 3;
        values[valuesById[4] = "DEBIT"] = 4;
        values[valuesById[5] = "REVERSAL_DEBIT"] = 5;
        values[valuesById[6] = "DISHONOUR"] = 6;
        values[valuesById[7] = "SERVICE_CHARGE"] = 7;
        values[valuesById[8] = "CHEQUE"] = 8;
        values[valuesById[9] = "INTEREST_CHARGED"] = 9;
        return values;
    })();

    return MacquarieTransactionCode;
})();

export const MacquarieTransaction = $root.MacquarieTransaction = (() => {

    /**
     * Properties of a MacquarieTransaction.
     * @exports IMacquarieTransaction
     * @interface IMacquarieTransaction
     * @property {string|null} [id] MacquarieTransaction id
     * @property {string|null} [raw_txn_record] MacquarieTransaction raw_txn_record
     * @property {string|null} [external_ref] MacquarieTransaction external_ref
     * @property {string|null} [bank_account_number] MacquarieTransaction bank_account_number
     * @property {string|null} [date_fetched_for] MacquarieTransaction date_fetched_for
     * @property {boolean|null} [processed] MacquarieTransaction processed
     * @property {ISuspenseTransaction|null} [suspense_transaction] MacquarieTransaction suspense_transaction
     * @property {IFundTransaction|null} [fund_transaction] MacquarieTransaction fund_transaction
     * @property {TransactionDirection.Enum|null} [direction] MacquarieTransaction direction
     * @property {MacquarieTransactionCode.Enum|null} [transaction_code] MacquarieTransaction transaction_code
     * @property {string|null} [aud_amount] MacquarieTransaction aud_amount
     * @property {BankAccountName.Enum|null} [bank_account] MacquarieTransaction bank_account
     * @property {google.protobuf.ITimestamp|null} [created_at] MacquarieTransaction created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] MacquarieTransaction last_updated_at
     */

    /**
     * Constructs a new MacquarieTransaction.
     * @exports MacquarieTransaction
     * @classdesc Represents a MacquarieTransaction.
     * @implements IMacquarieTransaction
     * @constructor
     * @param {IMacquarieTransaction=} [properties] Properties to set
     */
    function MacquarieTransaction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MacquarieTransaction id.
     * @member {string} id
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.id = "";

    /**
     * MacquarieTransaction raw_txn_record.
     * @member {string} raw_txn_record
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.raw_txn_record = "";

    /**
     * MacquarieTransaction external_ref.
     * @member {string} external_ref
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.external_ref = "";

    /**
     * MacquarieTransaction bank_account_number.
     * @member {string} bank_account_number
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.bank_account_number = "";

    /**
     * MacquarieTransaction date_fetched_for.
     * @member {string} date_fetched_for
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.date_fetched_for = "";

    /**
     * MacquarieTransaction processed.
     * @member {boolean} processed
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.processed = false;

    /**
     * MacquarieTransaction suspense_transaction.
     * @member {ISuspenseTransaction|null|undefined} suspense_transaction
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.suspense_transaction = null;

    /**
     * MacquarieTransaction fund_transaction.
     * @member {IFundTransaction|null|undefined} fund_transaction
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.fund_transaction = null;

    /**
     * MacquarieTransaction direction.
     * @member {TransactionDirection.Enum} direction
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.direction = 0;

    /**
     * MacquarieTransaction transaction_code.
     * @member {MacquarieTransactionCode.Enum} transaction_code
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.transaction_code = 0;

    /**
     * MacquarieTransaction aud_amount.
     * @member {string} aud_amount
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.aud_amount = "";

    /**
     * MacquarieTransaction bank_account.
     * @member {BankAccountName.Enum} bank_account
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.bank_account = 0;

    /**
     * MacquarieTransaction created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.created_at = null;

    /**
     * MacquarieTransaction last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof MacquarieTransaction
     * @instance
     */
    MacquarieTransaction.prototype.last_updated_at = null;

    /**
     * Creates a new MacquarieTransaction instance using the specified properties.
     * @function create
     * @memberof MacquarieTransaction
     * @static
     * @param {IMacquarieTransaction=} [properties] Properties to set
     * @returns {MacquarieTransaction} MacquarieTransaction instance
     */
    MacquarieTransaction.create = function create(properties) {
        return new MacquarieTransaction(properties);
    };

    /**
     * Encodes the specified MacquarieTransaction message. Does not implicitly {@link MacquarieTransaction.verify|verify} messages.
     * @function encode
     * @memberof MacquarieTransaction
     * @static
     * @param {IMacquarieTransaction} message MacquarieTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MacquarieTransaction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.raw_txn_record != null && message.hasOwnProperty("raw_txn_record"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.raw_txn_record);
        if (message.external_ref != null && message.hasOwnProperty("external_ref"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.external_ref);
        if (message.bank_account_number != null && message.hasOwnProperty("bank_account_number"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.bank_account_number);
        if (message.date_fetched_for != null && message.hasOwnProperty("date_fetched_for"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.date_fetched_for);
        if (message.processed != null && message.hasOwnProperty("processed"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.processed);
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction"))
            $root.SuspenseTransaction.encode(message.suspense_transaction, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.fund_transaction != null && message.hasOwnProperty("fund_transaction"))
            $root.FundTransaction.encode(message.fund_transaction, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.direction != null && message.hasOwnProperty("direction"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.direction);
        if (message.transaction_code != null && message.hasOwnProperty("transaction_code"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.transaction_code);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.aud_amount);
        if (message.bank_account != null && message.hasOwnProperty("bank_account"))
            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.bank_account);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MacquarieTransaction message, length delimited. Does not implicitly {@link MacquarieTransaction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MacquarieTransaction
     * @static
     * @param {IMacquarieTransaction} message MacquarieTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MacquarieTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MacquarieTransaction message from the specified reader or buffer.
     * @function decode
     * @memberof MacquarieTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MacquarieTransaction} MacquarieTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MacquarieTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MacquarieTransaction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.raw_txn_record = reader.string();
                break;
            case 3:
                message.external_ref = reader.string();
                break;
            case 4:
                message.bank_account_number = reader.string();
                break;
            case 5:
                message.date_fetched_for = reader.string();
                break;
            case 6:
                message.processed = reader.bool();
                break;
            case 8:
                message.suspense_transaction = $root.SuspenseTransaction.decode(reader, reader.uint32());
                break;
            case 9:
                message.fund_transaction = $root.FundTransaction.decode(reader, reader.uint32());
                break;
            case 10:
                message.direction = reader.int32();
                break;
            case 11:
                message.transaction_code = reader.int32();
                break;
            case 12:
                message.aud_amount = reader.string();
                break;
            case 13:
                message.bank_account = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MacquarieTransaction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MacquarieTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MacquarieTransaction} MacquarieTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MacquarieTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MacquarieTransaction message.
     * @function verify
     * @memberof MacquarieTransaction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MacquarieTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.raw_txn_record != null && message.hasOwnProperty("raw_txn_record"))
            if (!$util.isString(message.raw_txn_record))
                return "raw_txn_record: string expected";
        if (message.external_ref != null && message.hasOwnProperty("external_ref"))
            if (!$util.isString(message.external_ref))
                return "external_ref: string expected";
        if (message.bank_account_number != null && message.hasOwnProperty("bank_account_number"))
            if (!$util.isString(message.bank_account_number))
                return "bank_account_number: string expected";
        if (message.date_fetched_for != null && message.hasOwnProperty("date_fetched_for"))
            if (!$util.isString(message.date_fetched_for))
                return "date_fetched_for: string expected";
        if (message.processed != null && message.hasOwnProperty("processed"))
            if (typeof message.processed !== "boolean")
                return "processed: boolean expected";
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction")) {
            let error = $root.SuspenseTransaction.verify(message.suspense_transaction);
            if (error)
                return "suspense_transaction." + error;
        }
        if (message.fund_transaction != null && message.hasOwnProperty("fund_transaction")) {
            let error = $root.FundTransaction.verify(message.fund_transaction);
            if (error)
                return "fund_transaction." + error;
        }
        if (message.direction != null && message.hasOwnProperty("direction"))
            switch (message.direction) {
            default:
                return "direction: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.transaction_code != null && message.hasOwnProperty("transaction_code"))
            switch (message.transaction_code) {
            default:
                return "transaction_code: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.bank_account != null && message.hasOwnProperty("bank_account"))
            switch (message.bank_account) {
            default:
                return "bank_account: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
            case 32:
            case 33:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
            case 58:
            case 59:
            case 60:
            case 61:
            case 62:
            case 63:
            case 64:
            case 65:
            case 66:
            case 100:
            case 200:
            case 201:
            case 202:
            case 203:
            case 204:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a MacquarieTransaction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MacquarieTransaction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MacquarieTransaction} MacquarieTransaction
     */
    MacquarieTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.MacquarieTransaction)
            return object;
        let message = new $root.MacquarieTransaction();
        if (object.id != null)
            message.id = String(object.id);
        if (object.raw_txn_record != null)
            message.raw_txn_record = String(object.raw_txn_record);
        if (object.external_ref != null)
            message.external_ref = String(object.external_ref);
        if (object.bank_account_number != null)
            message.bank_account_number = String(object.bank_account_number);
        if (object.date_fetched_for != null)
            message.date_fetched_for = String(object.date_fetched_for);
        if (object.processed != null)
            message.processed = Boolean(object.processed);
        if (object.suspense_transaction != null) {
            if (typeof object.suspense_transaction !== "object")
                throw TypeError(".MacquarieTransaction.suspense_transaction: object expected");
            message.suspense_transaction = $root.SuspenseTransaction.fromObject(object.suspense_transaction);
        }
        if (object.fund_transaction != null) {
            if (typeof object.fund_transaction !== "object")
                throw TypeError(".MacquarieTransaction.fund_transaction: object expected");
            message.fund_transaction = $root.FundTransaction.fromObject(object.fund_transaction);
        }
        switch (object.direction) {
        case "UNKNOWN":
        case 0:
            message.direction = 0;
            break;
        case "CREDIT":
        case 1:
            message.direction = 1;
            break;
        case "DEBIT":
        case 2:
            message.direction = 2;
            break;
        }
        switch (object.transaction_code) {
        case "UNKNOWN":
        case 0:
            message.transaction_code = 0;
            break;
        case "DEPOSIT":
        case 1:
            message.transaction_code = 1;
            break;
        case "INTEREST_PAID":
        case 2:
            message.transaction_code = 2;
            break;
        case "REVERSAL_CREDIT":
        case 3:
            message.transaction_code = 3;
            break;
        case "DEBIT":
        case 4:
            message.transaction_code = 4;
            break;
        case "REVERSAL_DEBIT":
        case 5:
            message.transaction_code = 5;
            break;
        case "DISHONOUR":
        case 6:
            message.transaction_code = 6;
            break;
        case "SERVICE_CHARGE":
        case 7:
            message.transaction_code = 7;
            break;
        case "CHEQUE":
        case 8:
            message.transaction_code = 8;
            break;
        case "INTEREST_CHARGED":
        case 9:
            message.transaction_code = 9;
            break;
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        switch (object.bank_account) {
        case "UNKNOWN":
        case 0:
            message.bank_account = 0;
            break;
        case "MACQUARIE_SUSPENSE_UNIVERSE":
        case 1:
            message.bank_account = 1;
            break;
        case "MACQUARIE_SUSPENSE_INDEX":
        case 2:
            message.bank_account = 2;
            break;
        case "MACQUARIE_SUSPENSE_SHARED":
        case 3:
            message.bank_account = 3;
            break;
        case "MACQUARIE_FUND_UNIVERSE":
        case 4:
            message.bank_account = 4;
            break;
        case "MACQUARIE_FUND_INDEX":
        case 5:
            message.bank_account = 5;
            break;
        case "MACQUARIE_DISTRIBUTIONS_UNIVERSE":
        case 6:
            message.bank_account = 6;
            break;
        case "MACQUARIE_DISTRIBUTIONS_INDEX":
        case 7:
            message.bank_account = 7;
            break;
        case "MACQUARIE_FREEBIES_UNIVERSE":
        case 8:
            message.bank_account = 8;
            break;
        case "MACQUARIE_FREEBIES_INDEX":
        case 9:
            message.bank_account = 9;
            break;
        case "MACQUARIE_FREEBIES_EARTH":
        case 10:
            message.bank_account = 10;
            break;
        case "MACQUARIE_SUSPENSE_EARTH":
        case 11:
            message.bank_account = 11;
            break;
        case "MACQUARIE_FUND_EARTH":
        case 12:
            message.bank_account = 12;
            break;
        case "MACQUARIE_DISTRIBUTIONS_EARTH":
        case 13:
            message.bank_account = 13;
            break;
        case "ZEPTO_FLOAT_ORIGIN":
        case 14:
            message.bank_account = 14;
            break;
        case "ZEPTO_FLOAT_UNIVERSE":
        case 15:
            message.bank_account = 15;
            break;
        case "ZEPTO_FLOAT_EARTH":
        case 16:
            message.bank_account = 16;
            break;
        case "ZEPTO_FLOAT_NOVA":
        case 17:
            message.bank_account = 17;
            break;
        case "ZEPTO_TRUST_ORIGIN":
        case 18:
            message.bank_account = 18;
            break;
        case "ZEPTO_TRUST_UNIVERSE":
        case 19:
            message.bank_account = 19;
            break;
        case "ZEPTO_TRUST_EARTH":
        case 20:
            message.bank_account = 20;
            break;
        case "ZEPTO_TRUST_NOVA":
        case 21:
            message.bank_account = 21;
            break;
        case "ZEPTO_FLOAT_NOVA_FEES":
        case 22:
            message.bank_account = 22;
            break;
        case "ZEPTO_TRUST_CASH":
        case 23:
            message.bank_account = 23;
            break;
        case "ZEPTO_TRUST_GALAXY":
        case 24:
            message.bank_account = 24;
            break;
        case "ZEPTO_TRUST_EXPLORER":
        case 25:
            message.bank_account = 25;
            break;
        case "ZEPTO_FLOAT_GALAXY":
        case 26:
            message.bank_account = 26;
            break;
        case "ZEPTO_FLOAT_EXPLORER":
        case 27:
            message.bank_account = 27;
            break;
        case "ZEPTO_DISTRIBUTIONS_EXPLORER":
        case 28:
            message.bank_account = 28;
            break;
        case "ZEPTO_DISTRIBUTIONS_GALAXY":
        case 29:
            message.bank_account = 29;
            break;
        case "ZEPTO_DISTRIBUTIONS_INDEX":
        case 30:
            message.bank_account = 30;
            break;
        case "ZEPTO_DISTRIBUTIONS_UNIVERSE":
        case 31:
            message.bank_account = 31;
            break;
        case "ZEPTO_DISTRIBUTIONS_EARTH":
        case 32:
            message.bank_account = 32;
            break;
        case "ZEPTO_TRUST_CASH_MISC":
        case 33:
            message.bank_account = 33;
            break;
        case "WESTPAC_SUSPENSE_ORIGIN":
        case 51:
            message.bank_account = 51;
            break;
        case "WESTPAC_SUSPENSE_UNIVERSE":
        case 52:
            message.bank_account = 52;
            break;
        case "WESTPAC_SUSPENSE_EARTH":
        case 53:
            message.bank_account = 53;
            break;
        case "WESTPAC_FUND_ORIGIN":
        case 54:
            message.bank_account = 54;
            break;
        case "WESTPAC_FUND_UNIVERSE":
        case 55:
            message.bank_account = 55;
            break;
        case "WESTPAC_FUND_EARTH":
        case 56:
            message.bank_account = 56;
            break;
        case "WESTPAC_DISTRIBUTIONS_ORIGIN":
        case 57:
            message.bank_account = 57;
            break;
        case "WESTPAC_DISTRIBUTIONS_UNIVERSE":
        case 58:
            message.bank_account = 58;
            break;
        case "WESTPAC_DISTRIBUTIONS_EARTH":
        case 59:
            message.bank_account = 59;
            break;
        case "WESTPAC_FREEBIES_SHARED":
        case 60:
            message.bank_account = 60;
            break;
        case "WESTPAC_FEES_AND_CHARGES":
        case 61:
            message.bank_account = 61;
            break;
        case "WESTPAC_981B_NOVA":
        case 62:
            message.bank_account = 62;
            break;
        case "WESTPAC_NOVA_FEES":
        case 63:
            message.bank_account = 63;
            break;
        case "WESTPAC_NOVA_MISC":
        case 64:
            message.bank_account = 64;
            break;
        case "WESTPAC_SAVER_FIXED_FEES":
        case 65:
            message.bank_account = 65;
            break;
        case "WESTPAC_SAVER_BPS_FEES":
        case 66:
            message.bank_account = 66;
            break;
        case "ALPACA_AIRWALLEX":
        case 100:
            message.bank_account = 100;
            break;
        case "IB_ORIGIN":
        case 200:
            message.bank_account = 200;
            break;
        case "IB_UNIVERSE":
        case 201:
            message.bank_account = 201;
            break;
        case "IB_EARTH":
        case 202:
            message.bank_account = 202;
            break;
        case "IB_EXPLORER":
        case 203:
            message.bank_account = 203;
            break;
        case "IB_GALAXY":
        case 204:
            message.bank_account = 204;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".MacquarieTransaction.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".MacquarieTransaction.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a MacquarieTransaction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MacquarieTransaction
     * @static
     * @param {MacquarieTransaction} message MacquarieTransaction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MacquarieTransaction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.raw_txn_record = "";
            object.external_ref = "";
            object.bank_account_number = "";
            object.date_fetched_for = "";
            object.processed = false;
            object.suspense_transaction = null;
            object.fund_transaction = null;
            object.direction = options.enums === String ? "UNKNOWN" : 0;
            object.transaction_code = options.enums === String ? "UNKNOWN" : 0;
            object.aud_amount = "";
            object.bank_account = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.raw_txn_record != null && message.hasOwnProperty("raw_txn_record"))
            object.raw_txn_record = message.raw_txn_record;
        if (message.external_ref != null && message.hasOwnProperty("external_ref"))
            object.external_ref = message.external_ref;
        if (message.bank_account_number != null && message.hasOwnProperty("bank_account_number"))
            object.bank_account_number = message.bank_account_number;
        if (message.date_fetched_for != null && message.hasOwnProperty("date_fetched_for"))
            object.date_fetched_for = message.date_fetched_for;
        if (message.processed != null && message.hasOwnProperty("processed"))
            object.processed = message.processed;
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction"))
            object.suspense_transaction = $root.SuspenseTransaction.toObject(message.suspense_transaction, options);
        if (message.fund_transaction != null && message.hasOwnProperty("fund_transaction"))
            object.fund_transaction = $root.FundTransaction.toObject(message.fund_transaction, options);
        if (message.direction != null && message.hasOwnProperty("direction"))
            object.direction = options.enums === String ? $root.TransactionDirection.Enum[message.direction] : message.direction;
        if (message.transaction_code != null && message.hasOwnProperty("transaction_code"))
            object.transaction_code = options.enums === String ? $root.MacquarieTransactionCode.Enum[message.transaction_code] : message.transaction_code;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.bank_account != null && message.hasOwnProperty("bank_account"))
            object.bank_account = options.enums === String ? $root.BankAccountName.Enum[message.bank_account] : message.bank_account;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this MacquarieTransaction to JSON.
     * @function toJSON
     * @memberof MacquarieTransaction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MacquarieTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MacquarieTransaction;
})();

export const MacquarieTransactions = $root.MacquarieTransactions = (() => {

    /**
     * Properties of a MacquarieTransactions.
     * @exports IMacquarieTransactions
     * @interface IMacquarieTransactions
     * @property {Array.<IMacquarieTransaction>|null} [list] MacquarieTransactions list
     */

    /**
     * Constructs a new MacquarieTransactions.
     * @exports MacquarieTransactions
     * @classdesc Represents a MacquarieTransactions.
     * @implements IMacquarieTransactions
     * @constructor
     * @param {IMacquarieTransactions=} [properties] Properties to set
     */
    function MacquarieTransactions(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MacquarieTransactions list.
     * @member {Array.<IMacquarieTransaction>} list
     * @memberof MacquarieTransactions
     * @instance
     */
    MacquarieTransactions.prototype.list = $util.emptyArray;

    /**
     * Creates a new MacquarieTransactions instance using the specified properties.
     * @function create
     * @memberof MacquarieTransactions
     * @static
     * @param {IMacquarieTransactions=} [properties] Properties to set
     * @returns {MacquarieTransactions} MacquarieTransactions instance
     */
    MacquarieTransactions.create = function create(properties) {
        return new MacquarieTransactions(properties);
    };

    /**
     * Encodes the specified MacquarieTransactions message. Does not implicitly {@link MacquarieTransactions.verify|verify} messages.
     * @function encode
     * @memberof MacquarieTransactions
     * @static
     * @param {IMacquarieTransactions} message MacquarieTransactions message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MacquarieTransactions.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.MacquarieTransaction.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MacquarieTransactions message, length delimited. Does not implicitly {@link MacquarieTransactions.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MacquarieTransactions
     * @static
     * @param {IMacquarieTransactions} message MacquarieTransactions message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MacquarieTransactions.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MacquarieTransactions message from the specified reader or buffer.
     * @function decode
     * @memberof MacquarieTransactions
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MacquarieTransactions} MacquarieTransactions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MacquarieTransactions.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MacquarieTransactions();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.MacquarieTransaction.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MacquarieTransactions message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MacquarieTransactions
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MacquarieTransactions} MacquarieTransactions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MacquarieTransactions.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MacquarieTransactions message.
     * @function verify
     * @memberof MacquarieTransactions
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MacquarieTransactions.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.MacquarieTransaction.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates a MacquarieTransactions message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MacquarieTransactions
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MacquarieTransactions} MacquarieTransactions
     */
    MacquarieTransactions.fromObject = function fromObject(object) {
        if (object instanceof $root.MacquarieTransactions)
            return object;
        let message = new $root.MacquarieTransactions();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".MacquarieTransactions.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".MacquarieTransactions.list: object expected");
                message.list[i] = $root.MacquarieTransaction.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a MacquarieTransactions message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MacquarieTransactions
     * @static
     * @param {MacquarieTransactions} message MacquarieTransactions
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MacquarieTransactions.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.MacquarieTransaction.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this MacquarieTransactions to JSON.
     * @function toJSON
     * @memberof MacquarieTransactions
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MacquarieTransactions.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MacquarieTransactions;
})();

export const TradeConfirmationMapping = $root.TradeConfirmationMapping = (() => {

    /**
     * Properties of a TradeConfirmationMapping.
     * @exports ITradeConfirmationMapping
     * @interface ITradeConfirmationMapping
     * @property {string|null} [symbol] TradeConfirmationMapping symbol
     * @property {string|null} [exchange] TradeConfirmationMapping exchange
     */

    /**
     * Constructs a new TradeConfirmationMapping.
     * @exports TradeConfirmationMapping
     * @classdesc Represents a TradeConfirmationMapping.
     * @implements ITradeConfirmationMapping
     * @constructor
     * @param {ITradeConfirmationMapping=} [properties] Properties to set
     */
    function TradeConfirmationMapping(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TradeConfirmationMapping symbol.
     * @member {string} symbol
     * @memberof TradeConfirmationMapping
     * @instance
     */
    TradeConfirmationMapping.prototype.symbol = "";

    /**
     * TradeConfirmationMapping exchange.
     * @member {string} exchange
     * @memberof TradeConfirmationMapping
     * @instance
     */
    TradeConfirmationMapping.prototype.exchange = "";

    /**
     * Creates a new TradeConfirmationMapping instance using the specified properties.
     * @function create
     * @memberof TradeConfirmationMapping
     * @static
     * @param {ITradeConfirmationMapping=} [properties] Properties to set
     * @returns {TradeConfirmationMapping} TradeConfirmationMapping instance
     */
    TradeConfirmationMapping.create = function create(properties) {
        return new TradeConfirmationMapping(properties);
    };

    /**
     * Encodes the specified TradeConfirmationMapping message. Does not implicitly {@link TradeConfirmationMapping.verify|verify} messages.
     * @function encode
     * @memberof TradeConfirmationMapping
     * @static
     * @param {ITradeConfirmationMapping} message TradeConfirmationMapping message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TradeConfirmationMapping.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
        if (message.exchange != null && message.hasOwnProperty("exchange"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.exchange);
        return writer;
    };

    /**
     * Encodes the specified TradeConfirmationMapping message, length delimited. Does not implicitly {@link TradeConfirmationMapping.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TradeConfirmationMapping
     * @static
     * @param {ITradeConfirmationMapping} message TradeConfirmationMapping message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TradeConfirmationMapping.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TradeConfirmationMapping message from the specified reader or buffer.
     * @function decode
     * @memberof TradeConfirmationMapping
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TradeConfirmationMapping} TradeConfirmationMapping
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TradeConfirmationMapping.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TradeConfirmationMapping();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.symbol = reader.string();
                break;
            case 2:
                message.exchange = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TradeConfirmationMapping message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TradeConfirmationMapping
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TradeConfirmationMapping} TradeConfirmationMapping
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TradeConfirmationMapping.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TradeConfirmationMapping message.
     * @function verify
     * @memberof TradeConfirmationMapping
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TradeConfirmationMapping.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        if (message.exchange != null && message.hasOwnProperty("exchange"))
            if (!$util.isString(message.exchange))
                return "exchange: string expected";
        return null;
    };

    /**
     * Creates a TradeConfirmationMapping message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TradeConfirmationMapping
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TradeConfirmationMapping} TradeConfirmationMapping
     */
    TradeConfirmationMapping.fromObject = function fromObject(object) {
        if (object instanceof $root.TradeConfirmationMapping)
            return object;
        let message = new $root.TradeConfirmationMapping();
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        if (object.exchange != null)
            message.exchange = String(object.exchange);
        return message;
    };

    /**
     * Creates a plain object from a TradeConfirmationMapping message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TradeConfirmationMapping
     * @static
     * @param {TradeConfirmationMapping} message TradeConfirmationMapping
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TradeConfirmationMapping.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.symbol = "";
            object.exchange = "";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.exchange != null && message.hasOwnProperty("exchange"))
            object.exchange = message.exchange;
        return object;
    };

    /**
     * Converts this TradeConfirmationMapping to JSON.
     * @function toJSON
     * @memberof TradeConfirmationMapping
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TradeConfirmationMapping.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TradeConfirmationMapping;
})();

export const InstrumentDefinition = $root.InstrumentDefinition = (() => {

    /**
     * Properties of an InstrumentDefinition.
     * @exports IInstrumentDefinition
     * @interface IInstrumentDefinition
     * @property {string|null} [id] InstrumentDefinition id
     * @property {string|null} [isin] InstrumentDefinition isin
     * @property {string|null} [friendly_name] InstrumentDefinition friendly_name
     * @property {string|null} [capiq_symbol] InstrumentDefinition capiq_symbol
     * @property {string|null} [capiq_exchange] InstrumentDefinition capiq_exchange
     * @property {string|null} [ib_feedcode] InstrumentDefinition ib_feedcode
     * @property {string|null} [ib_market] InstrumentDefinition ib_market
     * @property {string|null} [ib_kind_code] InstrumentDefinition ib_kind_code
     * @property {string|null} [ib_currency] InstrumentDefinition ib_currency
     * @property {Array.<ITradeConfirmationMapping>|null} [trade_conf_mappings] InstrumentDefinition trade_conf_mappings
     * @property {string|null} [ib_position_symbol] InstrumentDefinition ib_position_symbol
     * @property {string|null} [bb_id] InstrumentDefinition bb_id
     * @property {string|null} [bb_currency_code] InstrumentDefinition bb_currency_code
     * @property {string|null} [bb_market_identifier_code] InstrumentDefinition bb_market_identifier_code
     * @property {string|null} [country] InstrumentDefinition country
     * @property {string|null} [sector] InstrumentDefinition sector
     */

    /**
     * Constructs a new InstrumentDefinition.
     * @exports InstrumentDefinition
     * @classdesc Represents an InstrumentDefinition.
     * @implements IInstrumentDefinition
     * @constructor
     * @param {IInstrumentDefinition=} [properties] Properties to set
     */
    function InstrumentDefinition(properties) {
        this.trade_conf_mappings = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InstrumentDefinition id.
     * @member {string} id
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.id = "";

    /**
     * InstrumentDefinition isin.
     * @member {string} isin
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.isin = "";

    /**
     * InstrumentDefinition friendly_name.
     * @member {string} friendly_name
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.friendly_name = "";

    /**
     * InstrumentDefinition capiq_symbol.
     * @member {string} capiq_symbol
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.capiq_symbol = "";

    /**
     * InstrumentDefinition capiq_exchange.
     * @member {string} capiq_exchange
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.capiq_exchange = "";

    /**
     * InstrumentDefinition ib_feedcode.
     * @member {string} ib_feedcode
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.ib_feedcode = "";

    /**
     * InstrumentDefinition ib_market.
     * @member {string} ib_market
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.ib_market = "";

    /**
     * InstrumentDefinition ib_kind_code.
     * @member {string} ib_kind_code
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.ib_kind_code = "";

    /**
     * InstrumentDefinition ib_currency.
     * @member {string} ib_currency
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.ib_currency = "";

    /**
     * InstrumentDefinition trade_conf_mappings.
     * @member {Array.<ITradeConfirmationMapping>} trade_conf_mappings
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.trade_conf_mappings = $util.emptyArray;

    /**
     * InstrumentDefinition ib_position_symbol.
     * @member {string} ib_position_symbol
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.ib_position_symbol = "";

    /**
     * InstrumentDefinition bb_id.
     * @member {string} bb_id
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.bb_id = "";

    /**
     * InstrumentDefinition bb_currency_code.
     * @member {string} bb_currency_code
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.bb_currency_code = "";

    /**
     * InstrumentDefinition bb_market_identifier_code.
     * @member {string} bb_market_identifier_code
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.bb_market_identifier_code = "";

    /**
     * InstrumentDefinition country.
     * @member {string} country
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.country = "";

    /**
     * InstrumentDefinition sector.
     * @member {string} sector
     * @memberof InstrumentDefinition
     * @instance
     */
    InstrumentDefinition.prototype.sector = "";

    /**
     * Creates a new InstrumentDefinition instance using the specified properties.
     * @function create
     * @memberof InstrumentDefinition
     * @static
     * @param {IInstrumentDefinition=} [properties] Properties to set
     * @returns {InstrumentDefinition} InstrumentDefinition instance
     */
    InstrumentDefinition.create = function create(properties) {
        return new InstrumentDefinition(properties);
    };

    /**
     * Encodes the specified InstrumentDefinition message. Does not implicitly {@link InstrumentDefinition.verify|verify} messages.
     * @function encode
     * @memberof InstrumentDefinition
     * @static
     * @param {IInstrumentDefinition} message InstrumentDefinition message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstrumentDefinition.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.isin != null && message.hasOwnProperty("isin"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.isin);
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.friendly_name);
        if (message.capiq_symbol != null && message.hasOwnProperty("capiq_symbol"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.capiq_symbol);
        if (message.capiq_exchange != null && message.hasOwnProperty("capiq_exchange"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.capiq_exchange);
        if (message.ib_feedcode != null && message.hasOwnProperty("ib_feedcode"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.ib_feedcode);
        if (message.ib_market != null && message.hasOwnProperty("ib_market"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.ib_market);
        if (message.ib_kind_code != null && message.hasOwnProperty("ib_kind_code"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.ib_kind_code);
        if (message.ib_currency != null && message.hasOwnProperty("ib_currency"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.ib_currency);
        if (message.trade_conf_mappings != null && message.trade_conf_mappings.length)
            for (let i = 0; i < message.trade_conf_mappings.length; ++i)
                $root.TradeConfirmationMapping.encode(message.trade_conf_mappings[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.ib_position_symbol != null && message.hasOwnProperty("ib_position_symbol"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.ib_position_symbol);
        if (message.bb_id != null && message.hasOwnProperty("bb_id"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.bb_id);
        if (message.bb_currency_code != null && message.hasOwnProperty("bb_currency_code"))
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.bb_currency_code);
        if (message.bb_market_identifier_code != null && message.hasOwnProperty("bb_market_identifier_code"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.bb_market_identifier_code);
        if (message.country != null && message.hasOwnProperty("country"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.country);
        if (message.sector != null && message.hasOwnProperty("sector"))
            writer.uint32(/* id 20, wireType 2 =*/162).string(message.sector);
        return writer;
    };

    /**
     * Encodes the specified InstrumentDefinition message, length delimited. Does not implicitly {@link InstrumentDefinition.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InstrumentDefinition
     * @static
     * @param {IInstrumentDefinition} message InstrumentDefinition message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstrumentDefinition.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an InstrumentDefinition message from the specified reader or buffer.
     * @function decode
     * @memberof InstrumentDefinition
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InstrumentDefinition} InstrumentDefinition
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstrumentDefinition.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InstrumentDefinition();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.isin = reader.string();
                break;
            case 3:
                message.friendly_name = reader.string();
                break;
            case 4:
                message.capiq_symbol = reader.string();
                break;
            case 5:
                message.capiq_exchange = reader.string();
                break;
            case 6:
                message.ib_feedcode = reader.string();
                break;
            case 7:
                message.ib_market = reader.string();
                break;
            case 8:
                message.ib_kind_code = reader.string();
                break;
            case 9:
                message.ib_currency = reader.string();
                break;
            case 10:
                if (!(message.trade_conf_mappings && message.trade_conf_mappings.length))
                    message.trade_conf_mappings = [];
                message.trade_conf_mappings.push($root.TradeConfirmationMapping.decode(reader, reader.uint32()));
                break;
            case 15:
                message.ib_position_symbol = reader.string();
                break;
            case 16:
                message.bb_id = reader.string();
                break;
            case 17:
                message.bb_currency_code = reader.string();
                break;
            case 18:
                message.bb_market_identifier_code = reader.string();
                break;
            case 19:
                message.country = reader.string();
                break;
            case 20:
                message.sector = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an InstrumentDefinition message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InstrumentDefinition
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InstrumentDefinition} InstrumentDefinition
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstrumentDefinition.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InstrumentDefinition message.
     * @function verify
     * @memberof InstrumentDefinition
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InstrumentDefinition.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.isin != null && message.hasOwnProperty("isin"))
            if (!$util.isString(message.isin))
                return "isin: string expected";
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            if (!$util.isString(message.friendly_name))
                return "friendly_name: string expected";
        if (message.capiq_symbol != null && message.hasOwnProperty("capiq_symbol"))
            if (!$util.isString(message.capiq_symbol))
                return "capiq_symbol: string expected";
        if (message.capiq_exchange != null && message.hasOwnProperty("capiq_exchange"))
            if (!$util.isString(message.capiq_exchange))
                return "capiq_exchange: string expected";
        if (message.ib_feedcode != null && message.hasOwnProperty("ib_feedcode"))
            if (!$util.isString(message.ib_feedcode))
                return "ib_feedcode: string expected";
        if (message.ib_market != null && message.hasOwnProperty("ib_market"))
            if (!$util.isString(message.ib_market))
                return "ib_market: string expected";
        if (message.ib_kind_code != null && message.hasOwnProperty("ib_kind_code"))
            if (!$util.isString(message.ib_kind_code))
                return "ib_kind_code: string expected";
        if (message.ib_currency != null && message.hasOwnProperty("ib_currency"))
            if (!$util.isString(message.ib_currency))
                return "ib_currency: string expected";
        if (message.trade_conf_mappings != null && message.hasOwnProperty("trade_conf_mappings")) {
            if (!Array.isArray(message.trade_conf_mappings))
                return "trade_conf_mappings: array expected";
            for (let i = 0; i < message.trade_conf_mappings.length; ++i) {
                let error = $root.TradeConfirmationMapping.verify(message.trade_conf_mappings[i]);
                if (error)
                    return "trade_conf_mappings." + error;
            }
        }
        if (message.ib_position_symbol != null && message.hasOwnProperty("ib_position_symbol"))
            if (!$util.isString(message.ib_position_symbol))
                return "ib_position_symbol: string expected";
        if (message.bb_id != null && message.hasOwnProperty("bb_id"))
            if (!$util.isString(message.bb_id))
                return "bb_id: string expected";
        if (message.bb_currency_code != null && message.hasOwnProperty("bb_currency_code"))
            if (!$util.isString(message.bb_currency_code))
                return "bb_currency_code: string expected";
        if (message.bb_market_identifier_code != null && message.hasOwnProperty("bb_market_identifier_code"))
            if (!$util.isString(message.bb_market_identifier_code))
                return "bb_market_identifier_code: string expected";
        if (message.country != null && message.hasOwnProperty("country"))
            if (!$util.isString(message.country))
                return "country: string expected";
        if (message.sector != null && message.hasOwnProperty("sector"))
            if (!$util.isString(message.sector))
                return "sector: string expected";
        return null;
    };

    /**
     * Creates an InstrumentDefinition message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InstrumentDefinition
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InstrumentDefinition} InstrumentDefinition
     */
    InstrumentDefinition.fromObject = function fromObject(object) {
        if (object instanceof $root.InstrumentDefinition)
            return object;
        let message = new $root.InstrumentDefinition();
        if (object.id != null)
            message.id = String(object.id);
        if (object.isin != null)
            message.isin = String(object.isin);
        if (object.friendly_name != null)
            message.friendly_name = String(object.friendly_name);
        if (object.capiq_symbol != null)
            message.capiq_symbol = String(object.capiq_symbol);
        if (object.capiq_exchange != null)
            message.capiq_exchange = String(object.capiq_exchange);
        if (object.ib_feedcode != null)
            message.ib_feedcode = String(object.ib_feedcode);
        if (object.ib_market != null)
            message.ib_market = String(object.ib_market);
        if (object.ib_kind_code != null)
            message.ib_kind_code = String(object.ib_kind_code);
        if (object.ib_currency != null)
            message.ib_currency = String(object.ib_currency);
        if (object.trade_conf_mappings) {
            if (!Array.isArray(object.trade_conf_mappings))
                throw TypeError(".InstrumentDefinition.trade_conf_mappings: array expected");
            message.trade_conf_mappings = [];
            for (let i = 0; i < object.trade_conf_mappings.length; ++i) {
                if (typeof object.trade_conf_mappings[i] !== "object")
                    throw TypeError(".InstrumentDefinition.trade_conf_mappings: object expected");
                message.trade_conf_mappings[i] = $root.TradeConfirmationMapping.fromObject(object.trade_conf_mappings[i]);
            }
        }
        if (object.ib_position_symbol != null)
            message.ib_position_symbol = String(object.ib_position_symbol);
        if (object.bb_id != null)
            message.bb_id = String(object.bb_id);
        if (object.bb_currency_code != null)
            message.bb_currency_code = String(object.bb_currency_code);
        if (object.bb_market_identifier_code != null)
            message.bb_market_identifier_code = String(object.bb_market_identifier_code);
        if (object.country != null)
            message.country = String(object.country);
        if (object.sector != null)
            message.sector = String(object.sector);
        return message;
    };

    /**
     * Creates a plain object from an InstrumentDefinition message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InstrumentDefinition
     * @static
     * @param {InstrumentDefinition} message InstrumentDefinition
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InstrumentDefinition.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.trade_conf_mappings = [];
        if (options.defaults) {
            object.id = "";
            object.isin = "";
            object.friendly_name = "";
            object.capiq_symbol = "";
            object.capiq_exchange = "";
            object.ib_feedcode = "";
            object.ib_market = "";
            object.ib_kind_code = "";
            object.ib_currency = "";
            object.ib_position_symbol = "";
            object.bb_id = "";
            object.bb_currency_code = "";
            object.bb_market_identifier_code = "";
            object.country = "";
            object.sector = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.isin != null && message.hasOwnProperty("isin"))
            object.isin = message.isin;
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            object.friendly_name = message.friendly_name;
        if (message.capiq_symbol != null && message.hasOwnProperty("capiq_symbol"))
            object.capiq_symbol = message.capiq_symbol;
        if (message.capiq_exchange != null && message.hasOwnProperty("capiq_exchange"))
            object.capiq_exchange = message.capiq_exchange;
        if (message.ib_feedcode != null && message.hasOwnProperty("ib_feedcode"))
            object.ib_feedcode = message.ib_feedcode;
        if (message.ib_market != null && message.hasOwnProperty("ib_market"))
            object.ib_market = message.ib_market;
        if (message.ib_kind_code != null && message.hasOwnProperty("ib_kind_code"))
            object.ib_kind_code = message.ib_kind_code;
        if (message.ib_currency != null && message.hasOwnProperty("ib_currency"))
            object.ib_currency = message.ib_currency;
        if (message.trade_conf_mappings && message.trade_conf_mappings.length) {
            object.trade_conf_mappings = [];
            for (let j = 0; j < message.trade_conf_mappings.length; ++j)
                object.trade_conf_mappings[j] = $root.TradeConfirmationMapping.toObject(message.trade_conf_mappings[j], options);
        }
        if (message.ib_position_symbol != null && message.hasOwnProperty("ib_position_symbol"))
            object.ib_position_symbol = message.ib_position_symbol;
        if (message.bb_id != null && message.hasOwnProperty("bb_id"))
            object.bb_id = message.bb_id;
        if (message.bb_currency_code != null && message.hasOwnProperty("bb_currency_code"))
            object.bb_currency_code = message.bb_currency_code;
        if (message.bb_market_identifier_code != null && message.hasOwnProperty("bb_market_identifier_code"))
            object.bb_market_identifier_code = message.bb_market_identifier_code;
        if (message.country != null && message.hasOwnProperty("country"))
            object.country = message.country;
        if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
        return object;
    };

    /**
     * Converts this InstrumentDefinition to JSON.
     * @function toJSON
     * @memberof InstrumentDefinition
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InstrumentDefinition.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return InstrumentDefinition;
})();

export const StagedInstrumentStatus = $root.StagedInstrumentStatus = (() => {

    /**
     * Properties of a StagedInstrumentStatus.
     * @exports IStagedInstrumentStatus
     * @interface IStagedInstrumentStatus
     */

    /**
     * Constructs a new StagedInstrumentStatus.
     * @exports StagedInstrumentStatus
     * @classdesc Represents a StagedInstrumentStatus.
     * @implements IStagedInstrumentStatus
     * @constructor
     * @param {IStagedInstrumentStatus=} [properties] Properties to set
     */
    function StagedInstrumentStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new StagedInstrumentStatus instance using the specified properties.
     * @function create
     * @memberof StagedInstrumentStatus
     * @static
     * @param {IStagedInstrumentStatus=} [properties] Properties to set
     * @returns {StagedInstrumentStatus} StagedInstrumentStatus instance
     */
    StagedInstrumentStatus.create = function create(properties) {
        return new StagedInstrumentStatus(properties);
    };

    /**
     * Encodes the specified StagedInstrumentStatus message. Does not implicitly {@link StagedInstrumentStatus.verify|verify} messages.
     * @function encode
     * @memberof StagedInstrumentStatus
     * @static
     * @param {IStagedInstrumentStatus} message StagedInstrumentStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StagedInstrumentStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified StagedInstrumentStatus message, length delimited. Does not implicitly {@link StagedInstrumentStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StagedInstrumentStatus
     * @static
     * @param {IStagedInstrumentStatus} message StagedInstrumentStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StagedInstrumentStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StagedInstrumentStatus message from the specified reader or buffer.
     * @function decode
     * @memberof StagedInstrumentStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StagedInstrumentStatus} StagedInstrumentStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StagedInstrumentStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StagedInstrumentStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a StagedInstrumentStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StagedInstrumentStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StagedInstrumentStatus} StagedInstrumentStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StagedInstrumentStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StagedInstrumentStatus message.
     * @function verify
     * @memberof StagedInstrumentStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StagedInstrumentStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a StagedInstrumentStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StagedInstrumentStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StagedInstrumentStatus} StagedInstrumentStatus
     */
    StagedInstrumentStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.StagedInstrumentStatus)
            return object;
        return new $root.StagedInstrumentStatus();
    };

    /**
     * Creates a plain object from a StagedInstrumentStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StagedInstrumentStatus
     * @static
     * @param {StagedInstrumentStatus} message StagedInstrumentStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StagedInstrumentStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this StagedInstrumentStatus to JSON.
     * @function toJSON
     * @memberof StagedInstrumentStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StagedInstrumentStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name StagedInstrumentStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PENDING_DATA_COLLECTION=1 PENDING_DATA_COLLECTION value
     * @property {number} FAILED_DATA_COLLECTION=2 FAILED_DATA_COLLECTION value
     * @property {number} READY_FOR_APPROVAL=3 READY_FOR_APPROVAL value
     * @property {number} APPROVED=4 APPROVED value
     * @property {number} CREATED=5 CREATED value
     * @property {number} DELETED=6 DELETED value
     */
    StagedInstrumentStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PENDING_DATA_COLLECTION"] = 1;
        values[valuesById[2] = "FAILED_DATA_COLLECTION"] = 2;
        values[valuesById[3] = "READY_FOR_APPROVAL"] = 3;
        values[valuesById[4] = "APPROVED"] = 4;
        values[valuesById[5] = "CREATED"] = 5;
        values[valuesById[6] = "DELETED"] = 6;
        return values;
    })();

    return StagedInstrumentStatus;
})();

export const StagedInstrumentDefinition = $root.StagedInstrumentDefinition = (() => {

    /**
     * Properties of a StagedInstrumentDefinition.
     * @exports IStagedInstrumentDefinition
     * @interface IStagedInstrumentDefinition
     * @property {string|null} [id] StagedInstrumentDefinition id
     * @property {string|null} [isin] StagedInstrumentDefinition isin
     * @property {string|null} [friendly_name] StagedInstrumentDefinition friendly_name
     * @property {string|null} [capiq_symbol] StagedInstrumentDefinition capiq_symbol
     * @property {string|null} [capiq_exchange] StagedInstrumentDefinition capiq_exchange
     * @property {string|null} [ib_feedcode] StagedInstrumentDefinition ib_feedcode
     * @property {string|null} [ib_market] StagedInstrumentDefinition ib_market
     * @property {string|null} [ib_kind_code] StagedInstrumentDefinition ib_kind_code
     * @property {string|null} [ib_currency] StagedInstrumentDefinition ib_currency
     * @property {string|null} [ib_position_symbol] StagedInstrumentDefinition ib_position_symbol
     * @property {string|null} [bb_id] StagedInstrumentDefinition bb_id
     * @property {string|null} [bb_currency_code] StagedInstrumentDefinition bb_currency_code
     * @property {string|null} [bb_market_identifier_code] StagedInstrumentDefinition bb_market_identifier_code
     * @property {string|null} [country] StagedInstrumentDefinition country
     * @property {string|null} [sector] StagedInstrumentDefinition sector
     * @property {StagedInstrumentStatus.Enum|null} [status] StagedInstrumentDefinition status
     * @property {string|null} [ib_trade_confirmation_symbol] StagedInstrumentDefinition ib_trade_confirmation_symbol
     * @property {string|null} [ib_trade_confirmation_exchange] StagedInstrumentDefinition ib_trade_confirmation_exchange
     * @property {string|null} [approved_by_admin_id] StagedInstrumentDefinition approved_by_admin_id
     * @property {google.protobuf.ITimestamp|null} [approved_at] StagedInstrumentDefinition approved_at
     * @property {string|null} [created_by_admin_id] StagedInstrumentDefinition created_by_admin_id
     * @property {string|null} [deleted_by_admin_id] StagedInstrumentDefinition deleted_by_admin_id
     * @property {google.protobuf.ITimestamp|null} [deleted_at] StagedInstrumentDefinition deleted_at
     * @property {string|null} [bb_local_close_price] StagedInstrumentDefinition bb_local_close_price
     * @property {string|null} [bb_close_date] StagedInstrumentDefinition bb_close_date
     * @property {string|null} [market_aud_close_price] StagedInstrumentDefinition market_aud_close_price
     * @property {string|null} [market_close_date] StagedInstrumentDefinition market_close_date
     * @property {google.protobuf.ITimestamp|null} [created_at] StagedInstrumentDefinition created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] StagedInstrumentDefinition last_updated_at
     */

    /**
     * Constructs a new StagedInstrumentDefinition.
     * @exports StagedInstrumentDefinition
     * @classdesc Represents a StagedInstrumentDefinition.
     * @implements IStagedInstrumentDefinition
     * @constructor
     * @param {IStagedInstrumentDefinition=} [properties] Properties to set
     */
    function StagedInstrumentDefinition(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * StagedInstrumentDefinition id.
     * @member {string} id
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.id = "";

    /**
     * StagedInstrumentDefinition isin.
     * @member {string} isin
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.isin = "";

    /**
     * StagedInstrumentDefinition friendly_name.
     * @member {string} friendly_name
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.friendly_name = "";

    /**
     * StagedInstrumentDefinition capiq_symbol.
     * @member {string} capiq_symbol
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.capiq_symbol = "";

    /**
     * StagedInstrumentDefinition capiq_exchange.
     * @member {string} capiq_exchange
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.capiq_exchange = "";

    /**
     * StagedInstrumentDefinition ib_feedcode.
     * @member {string} ib_feedcode
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.ib_feedcode = "";

    /**
     * StagedInstrumentDefinition ib_market.
     * @member {string} ib_market
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.ib_market = "";

    /**
     * StagedInstrumentDefinition ib_kind_code.
     * @member {string} ib_kind_code
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.ib_kind_code = "";

    /**
     * StagedInstrumentDefinition ib_currency.
     * @member {string} ib_currency
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.ib_currency = "";

    /**
     * StagedInstrumentDefinition ib_position_symbol.
     * @member {string} ib_position_symbol
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.ib_position_symbol = "";

    /**
     * StagedInstrumentDefinition bb_id.
     * @member {string} bb_id
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.bb_id = "";

    /**
     * StagedInstrumentDefinition bb_currency_code.
     * @member {string} bb_currency_code
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.bb_currency_code = "";

    /**
     * StagedInstrumentDefinition bb_market_identifier_code.
     * @member {string} bb_market_identifier_code
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.bb_market_identifier_code = "";

    /**
     * StagedInstrumentDefinition country.
     * @member {string} country
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.country = "";

    /**
     * StagedInstrumentDefinition sector.
     * @member {string} sector
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.sector = "";

    /**
     * StagedInstrumentDefinition status.
     * @member {StagedInstrumentStatus.Enum} status
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.status = 0;

    /**
     * StagedInstrumentDefinition ib_trade_confirmation_symbol.
     * @member {string} ib_trade_confirmation_symbol
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.ib_trade_confirmation_symbol = "";

    /**
     * StagedInstrumentDefinition ib_trade_confirmation_exchange.
     * @member {string} ib_trade_confirmation_exchange
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.ib_trade_confirmation_exchange = "";

    /**
     * StagedInstrumentDefinition approved_by_admin_id.
     * @member {string} approved_by_admin_id
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.approved_by_admin_id = "";

    /**
     * StagedInstrumentDefinition approved_at.
     * @member {google.protobuf.ITimestamp|null|undefined} approved_at
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.approved_at = null;

    /**
     * StagedInstrumentDefinition created_by_admin_id.
     * @member {string} created_by_admin_id
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.created_by_admin_id = "";

    /**
     * StagedInstrumentDefinition deleted_by_admin_id.
     * @member {string} deleted_by_admin_id
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.deleted_by_admin_id = "";

    /**
     * StagedInstrumentDefinition deleted_at.
     * @member {google.protobuf.ITimestamp|null|undefined} deleted_at
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.deleted_at = null;

    /**
     * StagedInstrumentDefinition bb_local_close_price.
     * @member {string} bb_local_close_price
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.bb_local_close_price = "";

    /**
     * StagedInstrumentDefinition bb_close_date.
     * @member {string} bb_close_date
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.bb_close_date = "";

    /**
     * StagedInstrumentDefinition market_aud_close_price.
     * @member {string} market_aud_close_price
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.market_aud_close_price = "";

    /**
     * StagedInstrumentDefinition market_close_date.
     * @member {string} market_close_date
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.market_close_date = "";

    /**
     * StagedInstrumentDefinition created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.created_at = null;

    /**
     * StagedInstrumentDefinition last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof StagedInstrumentDefinition
     * @instance
     */
    StagedInstrumentDefinition.prototype.last_updated_at = null;

    /**
     * Creates a new StagedInstrumentDefinition instance using the specified properties.
     * @function create
     * @memberof StagedInstrumentDefinition
     * @static
     * @param {IStagedInstrumentDefinition=} [properties] Properties to set
     * @returns {StagedInstrumentDefinition} StagedInstrumentDefinition instance
     */
    StagedInstrumentDefinition.create = function create(properties) {
        return new StagedInstrumentDefinition(properties);
    };

    /**
     * Encodes the specified StagedInstrumentDefinition message. Does not implicitly {@link StagedInstrumentDefinition.verify|verify} messages.
     * @function encode
     * @memberof StagedInstrumentDefinition
     * @static
     * @param {IStagedInstrumentDefinition} message StagedInstrumentDefinition message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StagedInstrumentDefinition.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.isin != null && message.hasOwnProperty("isin"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.isin);
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.friendly_name);
        if (message.capiq_symbol != null && message.hasOwnProperty("capiq_symbol"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.capiq_symbol);
        if (message.capiq_exchange != null && message.hasOwnProperty("capiq_exchange"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.capiq_exchange);
        if (message.ib_feedcode != null && message.hasOwnProperty("ib_feedcode"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.ib_feedcode);
        if (message.ib_market != null && message.hasOwnProperty("ib_market"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.ib_market);
        if (message.ib_kind_code != null && message.hasOwnProperty("ib_kind_code"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.ib_kind_code);
        if (message.ib_currency != null && message.hasOwnProperty("ib_currency"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.ib_currency);
        if (message.ib_position_symbol != null && message.hasOwnProperty("ib_position_symbol"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.ib_position_symbol);
        if (message.bb_id != null && message.hasOwnProperty("bb_id"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.bb_id);
        if (message.bb_currency_code != null && message.hasOwnProperty("bb_currency_code"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.bb_currency_code);
        if (message.bb_market_identifier_code != null && message.hasOwnProperty("bb_market_identifier_code"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.bb_market_identifier_code);
        if (message.country != null && message.hasOwnProperty("country"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.country);
        if (message.sector != null && message.hasOwnProperty("sector"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.sector);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.status);
        if (message.ib_trade_confirmation_symbol != null && message.hasOwnProperty("ib_trade_confirmation_symbol"))
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.ib_trade_confirmation_symbol);
        if (message.ib_trade_confirmation_exchange != null && message.hasOwnProperty("ib_trade_confirmation_exchange"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.ib_trade_confirmation_exchange);
        if (message.approved_by_admin_id != null && message.hasOwnProperty("approved_by_admin_id"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.approved_by_admin_id);
        if (message.approved_at != null && message.hasOwnProperty("approved_at"))
            $root.google.protobuf.Timestamp.encode(message.approved_at, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            writer.uint32(/* id 21, wireType 2 =*/170).string(message.created_by_admin_id);
        if (message.deleted_by_admin_id != null && message.hasOwnProperty("deleted_by_admin_id"))
            writer.uint32(/* id 22, wireType 2 =*/178).string(message.deleted_by_admin_id);
        if (message.deleted_at != null && message.hasOwnProperty("deleted_at"))
            $root.google.protobuf.Timestamp.encode(message.deleted_at, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
        if (message.bb_local_close_price != null && message.hasOwnProperty("bb_local_close_price"))
            writer.uint32(/* id 24, wireType 2 =*/194).string(message.bb_local_close_price);
        if (message.bb_close_date != null && message.hasOwnProperty("bb_close_date"))
            writer.uint32(/* id 25, wireType 2 =*/202).string(message.bb_close_date);
        if (message.market_aud_close_price != null && message.hasOwnProperty("market_aud_close_price"))
            writer.uint32(/* id 26, wireType 2 =*/210).string(message.market_aud_close_price);
        if (message.market_close_date != null && message.hasOwnProperty("market_close_date"))
            writer.uint32(/* id 27, wireType 2 =*/218).string(message.market_close_date);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified StagedInstrumentDefinition message, length delimited. Does not implicitly {@link StagedInstrumentDefinition.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StagedInstrumentDefinition
     * @static
     * @param {IStagedInstrumentDefinition} message StagedInstrumentDefinition message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StagedInstrumentDefinition.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StagedInstrumentDefinition message from the specified reader or buffer.
     * @function decode
     * @memberof StagedInstrumentDefinition
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StagedInstrumentDefinition} StagedInstrumentDefinition
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StagedInstrumentDefinition.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StagedInstrumentDefinition();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.isin = reader.string();
                break;
            case 3:
                message.friendly_name = reader.string();
                break;
            case 4:
                message.capiq_symbol = reader.string();
                break;
            case 5:
                message.capiq_exchange = reader.string();
                break;
            case 6:
                message.ib_feedcode = reader.string();
                break;
            case 7:
                message.ib_market = reader.string();
                break;
            case 8:
                message.ib_kind_code = reader.string();
                break;
            case 9:
                message.ib_currency = reader.string();
                break;
            case 10:
                message.ib_position_symbol = reader.string();
                break;
            case 11:
                message.bb_id = reader.string();
                break;
            case 12:
                message.bb_currency_code = reader.string();
                break;
            case 13:
                message.bb_market_identifier_code = reader.string();
                break;
            case 14:
                message.country = reader.string();
                break;
            case 15:
                message.sector = reader.string();
                break;
            case 16:
                message.status = reader.int32();
                break;
            case 17:
                message.ib_trade_confirmation_symbol = reader.string();
                break;
            case 18:
                message.ib_trade_confirmation_exchange = reader.string();
                break;
            case 19:
                message.approved_by_admin_id = reader.string();
                break;
            case 20:
                message.approved_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 21:
                message.created_by_admin_id = reader.string();
                break;
            case 22:
                message.deleted_by_admin_id = reader.string();
                break;
            case 23:
                message.deleted_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 24:
                message.bb_local_close_price = reader.string();
                break;
            case 25:
                message.bb_close_date = reader.string();
                break;
            case 26:
                message.market_aud_close_price = reader.string();
                break;
            case 27:
                message.market_close_date = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a StagedInstrumentDefinition message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StagedInstrumentDefinition
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StagedInstrumentDefinition} StagedInstrumentDefinition
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StagedInstrumentDefinition.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StagedInstrumentDefinition message.
     * @function verify
     * @memberof StagedInstrumentDefinition
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StagedInstrumentDefinition.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.isin != null && message.hasOwnProperty("isin"))
            if (!$util.isString(message.isin))
                return "isin: string expected";
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            if (!$util.isString(message.friendly_name))
                return "friendly_name: string expected";
        if (message.capiq_symbol != null && message.hasOwnProperty("capiq_symbol"))
            if (!$util.isString(message.capiq_symbol))
                return "capiq_symbol: string expected";
        if (message.capiq_exchange != null && message.hasOwnProperty("capiq_exchange"))
            if (!$util.isString(message.capiq_exchange))
                return "capiq_exchange: string expected";
        if (message.ib_feedcode != null && message.hasOwnProperty("ib_feedcode"))
            if (!$util.isString(message.ib_feedcode))
                return "ib_feedcode: string expected";
        if (message.ib_market != null && message.hasOwnProperty("ib_market"))
            if (!$util.isString(message.ib_market))
                return "ib_market: string expected";
        if (message.ib_kind_code != null && message.hasOwnProperty("ib_kind_code"))
            if (!$util.isString(message.ib_kind_code))
                return "ib_kind_code: string expected";
        if (message.ib_currency != null && message.hasOwnProperty("ib_currency"))
            if (!$util.isString(message.ib_currency))
                return "ib_currency: string expected";
        if (message.ib_position_symbol != null && message.hasOwnProperty("ib_position_symbol"))
            if (!$util.isString(message.ib_position_symbol))
                return "ib_position_symbol: string expected";
        if (message.bb_id != null && message.hasOwnProperty("bb_id"))
            if (!$util.isString(message.bb_id))
                return "bb_id: string expected";
        if (message.bb_currency_code != null && message.hasOwnProperty("bb_currency_code"))
            if (!$util.isString(message.bb_currency_code))
                return "bb_currency_code: string expected";
        if (message.bb_market_identifier_code != null && message.hasOwnProperty("bb_market_identifier_code"))
            if (!$util.isString(message.bb_market_identifier_code))
                return "bb_market_identifier_code: string expected";
        if (message.country != null && message.hasOwnProperty("country"))
            if (!$util.isString(message.country))
                return "country: string expected";
        if (message.sector != null && message.hasOwnProperty("sector"))
            if (!$util.isString(message.sector))
                return "sector: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                break;
            }
        if (message.ib_trade_confirmation_symbol != null && message.hasOwnProperty("ib_trade_confirmation_symbol"))
            if (!$util.isString(message.ib_trade_confirmation_symbol))
                return "ib_trade_confirmation_symbol: string expected";
        if (message.ib_trade_confirmation_exchange != null && message.hasOwnProperty("ib_trade_confirmation_exchange"))
            if (!$util.isString(message.ib_trade_confirmation_exchange))
                return "ib_trade_confirmation_exchange: string expected";
        if (message.approved_by_admin_id != null && message.hasOwnProperty("approved_by_admin_id"))
            if (!$util.isString(message.approved_by_admin_id))
                return "approved_by_admin_id: string expected";
        if (message.approved_at != null && message.hasOwnProperty("approved_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.approved_at);
            if (error)
                return "approved_at." + error;
        }
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            if (!$util.isString(message.created_by_admin_id))
                return "created_by_admin_id: string expected";
        if (message.deleted_by_admin_id != null && message.hasOwnProperty("deleted_by_admin_id"))
            if (!$util.isString(message.deleted_by_admin_id))
                return "deleted_by_admin_id: string expected";
        if (message.deleted_at != null && message.hasOwnProperty("deleted_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.deleted_at);
            if (error)
                return "deleted_at." + error;
        }
        if (message.bb_local_close_price != null && message.hasOwnProperty("bb_local_close_price"))
            if (!$util.isString(message.bb_local_close_price))
                return "bb_local_close_price: string expected";
        if (message.bb_close_date != null && message.hasOwnProperty("bb_close_date"))
            if (!$util.isString(message.bb_close_date))
                return "bb_close_date: string expected";
        if (message.market_aud_close_price != null && message.hasOwnProperty("market_aud_close_price"))
            if (!$util.isString(message.market_aud_close_price))
                return "market_aud_close_price: string expected";
        if (message.market_close_date != null && message.hasOwnProperty("market_close_date"))
            if (!$util.isString(message.market_close_date))
                return "market_close_date: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a StagedInstrumentDefinition message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StagedInstrumentDefinition
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StagedInstrumentDefinition} StagedInstrumentDefinition
     */
    StagedInstrumentDefinition.fromObject = function fromObject(object) {
        if (object instanceof $root.StagedInstrumentDefinition)
            return object;
        let message = new $root.StagedInstrumentDefinition();
        if (object.id != null)
            message.id = String(object.id);
        if (object.isin != null)
            message.isin = String(object.isin);
        if (object.friendly_name != null)
            message.friendly_name = String(object.friendly_name);
        if (object.capiq_symbol != null)
            message.capiq_symbol = String(object.capiq_symbol);
        if (object.capiq_exchange != null)
            message.capiq_exchange = String(object.capiq_exchange);
        if (object.ib_feedcode != null)
            message.ib_feedcode = String(object.ib_feedcode);
        if (object.ib_market != null)
            message.ib_market = String(object.ib_market);
        if (object.ib_kind_code != null)
            message.ib_kind_code = String(object.ib_kind_code);
        if (object.ib_currency != null)
            message.ib_currency = String(object.ib_currency);
        if (object.ib_position_symbol != null)
            message.ib_position_symbol = String(object.ib_position_symbol);
        if (object.bb_id != null)
            message.bb_id = String(object.bb_id);
        if (object.bb_currency_code != null)
            message.bb_currency_code = String(object.bb_currency_code);
        if (object.bb_market_identifier_code != null)
            message.bb_market_identifier_code = String(object.bb_market_identifier_code);
        if (object.country != null)
            message.country = String(object.country);
        if (object.sector != null)
            message.sector = String(object.sector);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PENDING_DATA_COLLECTION":
        case 1:
            message.status = 1;
            break;
        case "FAILED_DATA_COLLECTION":
        case 2:
            message.status = 2;
            break;
        case "READY_FOR_APPROVAL":
        case 3:
            message.status = 3;
            break;
        case "APPROVED":
        case 4:
            message.status = 4;
            break;
        case "CREATED":
        case 5:
            message.status = 5;
            break;
        case "DELETED":
        case 6:
            message.status = 6;
            break;
        }
        if (object.ib_trade_confirmation_symbol != null)
            message.ib_trade_confirmation_symbol = String(object.ib_trade_confirmation_symbol);
        if (object.ib_trade_confirmation_exchange != null)
            message.ib_trade_confirmation_exchange = String(object.ib_trade_confirmation_exchange);
        if (object.approved_by_admin_id != null)
            message.approved_by_admin_id = String(object.approved_by_admin_id);
        if (object.approved_at != null) {
            if (typeof object.approved_at !== "object")
                throw TypeError(".StagedInstrumentDefinition.approved_at: object expected");
            message.approved_at = $root.google.protobuf.Timestamp.fromObject(object.approved_at);
        }
        if (object.created_by_admin_id != null)
            message.created_by_admin_id = String(object.created_by_admin_id);
        if (object.deleted_by_admin_id != null)
            message.deleted_by_admin_id = String(object.deleted_by_admin_id);
        if (object.deleted_at != null) {
            if (typeof object.deleted_at !== "object")
                throw TypeError(".StagedInstrumentDefinition.deleted_at: object expected");
            message.deleted_at = $root.google.protobuf.Timestamp.fromObject(object.deleted_at);
        }
        if (object.bb_local_close_price != null)
            message.bb_local_close_price = String(object.bb_local_close_price);
        if (object.bb_close_date != null)
            message.bb_close_date = String(object.bb_close_date);
        if (object.market_aud_close_price != null)
            message.market_aud_close_price = String(object.market_aud_close_price);
        if (object.market_close_date != null)
            message.market_close_date = String(object.market_close_date);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".StagedInstrumentDefinition.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".StagedInstrumentDefinition.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a StagedInstrumentDefinition message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StagedInstrumentDefinition
     * @static
     * @param {StagedInstrumentDefinition} message StagedInstrumentDefinition
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StagedInstrumentDefinition.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.isin = "";
            object.friendly_name = "";
            object.capiq_symbol = "";
            object.capiq_exchange = "";
            object.ib_feedcode = "";
            object.ib_market = "";
            object.ib_kind_code = "";
            object.ib_currency = "";
            object.ib_position_symbol = "";
            object.bb_id = "";
            object.bb_currency_code = "";
            object.bb_market_identifier_code = "";
            object.country = "";
            object.sector = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.ib_trade_confirmation_symbol = "";
            object.ib_trade_confirmation_exchange = "";
            object.approved_by_admin_id = "";
            object.approved_at = null;
            object.created_by_admin_id = "";
            object.deleted_by_admin_id = "";
            object.deleted_at = null;
            object.bb_local_close_price = "";
            object.bb_close_date = "";
            object.market_aud_close_price = "";
            object.market_close_date = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.isin != null && message.hasOwnProperty("isin"))
            object.isin = message.isin;
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            object.friendly_name = message.friendly_name;
        if (message.capiq_symbol != null && message.hasOwnProperty("capiq_symbol"))
            object.capiq_symbol = message.capiq_symbol;
        if (message.capiq_exchange != null && message.hasOwnProperty("capiq_exchange"))
            object.capiq_exchange = message.capiq_exchange;
        if (message.ib_feedcode != null && message.hasOwnProperty("ib_feedcode"))
            object.ib_feedcode = message.ib_feedcode;
        if (message.ib_market != null && message.hasOwnProperty("ib_market"))
            object.ib_market = message.ib_market;
        if (message.ib_kind_code != null && message.hasOwnProperty("ib_kind_code"))
            object.ib_kind_code = message.ib_kind_code;
        if (message.ib_currency != null && message.hasOwnProperty("ib_currency"))
            object.ib_currency = message.ib_currency;
        if (message.ib_position_symbol != null && message.hasOwnProperty("ib_position_symbol"))
            object.ib_position_symbol = message.ib_position_symbol;
        if (message.bb_id != null && message.hasOwnProperty("bb_id"))
            object.bb_id = message.bb_id;
        if (message.bb_currency_code != null && message.hasOwnProperty("bb_currency_code"))
            object.bb_currency_code = message.bb_currency_code;
        if (message.bb_market_identifier_code != null && message.hasOwnProperty("bb_market_identifier_code"))
            object.bb_market_identifier_code = message.bb_market_identifier_code;
        if (message.country != null && message.hasOwnProperty("country"))
            object.country = message.country;
        if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.StagedInstrumentStatus.Enum[message.status] : message.status;
        if (message.ib_trade_confirmation_symbol != null && message.hasOwnProperty("ib_trade_confirmation_symbol"))
            object.ib_trade_confirmation_symbol = message.ib_trade_confirmation_symbol;
        if (message.ib_trade_confirmation_exchange != null && message.hasOwnProperty("ib_trade_confirmation_exchange"))
            object.ib_trade_confirmation_exchange = message.ib_trade_confirmation_exchange;
        if (message.approved_by_admin_id != null && message.hasOwnProperty("approved_by_admin_id"))
            object.approved_by_admin_id = message.approved_by_admin_id;
        if (message.approved_at != null && message.hasOwnProperty("approved_at"))
            object.approved_at = $root.google.protobuf.Timestamp.toObject(message.approved_at, options);
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            object.created_by_admin_id = message.created_by_admin_id;
        if (message.deleted_by_admin_id != null && message.hasOwnProperty("deleted_by_admin_id"))
            object.deleted_by_admin_id = message.deleted_by_admin_id;
        if (message.deleted_at != null && message.hasOwnProperty("deleted_at"))
            object.deleted_at = $root.google.protobuf.Timestamp.toObject(message.deleted_at, options);
        if (message.bb_local_close_price != null && message.hasOwnProperty("bb_local_close_price"))
            object.bb_local_close_price = message.bb_local_close_price;
        if (message.bb_close_date != null && message.hasOwnProperty("bb_close_date"))
            object.bb_close_date = message.bb_close_date;
        if (message.market_aud_close_price != null && message.hasOwnProperty("market_aud_close_price"))
            object.market_aud_close_price = message.market_aud_close_price;
        if (message.market_close_date != null && message.hasOwnProperty("market_close_date"))
            object.market_close_date = message.market_close_date;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this StagedInstrumentDefinition to JSON.
     * @function toJSON
     * @memberof StagedInstrumentDefinition
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StagedInstrumentDefinition.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StagedInstrumentDefinition;
})();

export const InstrumentOverview = $root.InstrumentOverview = (() => {

    /**
     * Properties of an InstrumentOverview.
     * @exports IInstrumentOverview
     * @interface IInstrumentOverview
     * @property {string|null} [id] InstrumentOverview id
     * @property {string|null} [isin] InstrumentOverview isin
     * @property {string|null} [friendly_name] InstrumentOverview friendly_name
     * @property {string|null} [market_cap] InstrumentOverview market_cap
     * @property {string|null} [latest_price] InstrumentOverview latest_price
     * @property {string|null} [ytd_percentage_change] InstrumentOverview ytd_percentage_change
     * @property {string|null} [ytd_percentage_low] InstrumentOverview ytd_percentage_low
     * @property {string|null} [ytd_percentage_high] InstrumentOverview ytd_percentage_high
     * @property {string|null} [country] InstrumentOverview country
     * @property {string|null} [sector] InstrumentOverview sector
     * @property {string|null} [target_allocation] InstrumentOverview target_allocation
     * @property {string|null} [symbol] InstrumentOverview symbol
     * @property {string|null} [exchange] InstrumentOverview exchange
     */

    /**
     * Constructs a new InstrumentOverview.
     * @exports InstrumentOverview
     * @classdesc Represents an InstrumentOverview.
     * @implements IInstrumentOverview
     * @constructor
     * @param {IInstrumentOverview=} [properties] Properties to set
     */
    function InstrumentOverview(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InstrumentOverview id.
     * @member {string} id
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.id = "";

    /**
     * InstrumentOverview isin.
     * @member {string} isin
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.isin = "";

    /**
     * InstrumentOverview friendly_name.
     * @member {string} friendly_name
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.friendly_name = "";

    /**
     * InstrumentOverview market_cap.
     * @member {string} market_cap
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.market_cap = "";

    /**
     * InstrumentOverview latest_price.
     * @member {string} latest_price
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.latest_price = "";

    /**
     * InstrumentOverview ytd_percentage_change.
     * @member {string} ytd_percentage_change
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.ytd_percentage_change = "";

    /**
     * InstrumentOverview ytd_percentage_low.
     * @member {string} ytd_percentage_low
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.ytd_percentage_low = "";

    /**
     * InstrumentOverview ytd_percentage_high.
     * @member {string} ytd_percentage_high
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.ytd_percentage_high = "";

    /**
     * InstrumentOverview country.
     * @member {string} country
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.country = "";

    /**
     * InstrumentOverview sector.
     * @member {string} sector
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.sector = "";

    /**
     * InstrumentOverview target_allocation.
     * @member {string} target_allocation
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.target_allocation = "";

    /**
     * InstrumentOverview symbol.
     * @member {string} symbol
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.symbol = "";

    /**
     * InstrumentOverview exchange.
     * @member {string} exchange
     * @memberof InstrumentOverview
     * @instance
     */
    InstrumentOverview.prototype.exchange = "";

    /**
     * Creates a new InstrumentOverview instance using the specified properties.
     * @function create
     * @memberof InstrumentOverview
     * @static
     * @param {IInstrumentOverview=} [properties] Properties to set
     * @returns {InstrumentOverview} InstrumentOverview instance
     */
    InstrumentOverview.create = function create(properties) {
        return new InstrumentOverview(properties);
    };

    /**
     * Encodes the specified InstrumentOverview message. Does not implicitly {@link InstrumentOverview.verify|verify} messages.
     * @function encode
     * @memberof InstrumentOverview
     * @static
     * @param {IInstrumentOverview} message InstrumentOverview message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstrumentOverview.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.isin != null && message.hasOwnProperty("isin"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.isin);
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.friendly_name);
        if (message.market_cap != null && message.hasOwnProperty("market_cap"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.market_cap);
        if (message.latest_price != null && message.hasOwnProperty("latest_price"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.latest_price);
        if (message.ytd_percentage_change != null && message.hasOwnProperty("ytd_percentage_change"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.ytd_percentage_change);
        if (message.ytd_percentage_low != null && message.hasOwnProperty("ytd_percentage_low"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.ytd_percentage_low);
        if (message.ytd_percentage_high != null && message.hasOwnProperty("ytd_percentage_high"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.ytd_percentage_high);
        if (message.country != null && message.hasOwnProperty("country"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.country);
        if (message.sector != null && message.hasOwnProperty("sector"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.sector);
        if (message.target_allocation != null && message.hasOwnProperty("target_allocation"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.target_allocation);
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.symbol);
        if (message.exchange != null && message.hasOwnProperty("exchange"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.exchange);
        return writer;
    };

    /**
     * Encodes the specified InstrumentOverview message, length delimited. Does not implicitly {@link InstrumentOverview.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InstrumentOverview
     * @static
     * @param {IInstrumentOverview} message InstrumentOverview message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstrumentOverview.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an InstrumentOverview message from the specified reader or buffer.
     * @function decode
     * @memberof InstrumentOverview
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InstrumentOverview} InstrumentOverview
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstrumentOverview.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InstrumentOverview();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.isin = reader.string();
                break;
            case 3:
                message.friendly_name = reader.string();
                break;
            case 4:
                message.market_cap = reader.string();
                break;
            case 5:
                message.latest_price = reader.string();
                break;
            case 6:
                message.ytd_percentage_change = reader.string();
                break;
            case 7:
                message.ytd_percentage_low = reader.string();
                break;
            case 8:
                message.ytd_percentage_high = reader.string();
                break;
            case 9:
                message.country = reader.string();
                break;
            case 10:
                message.sector = reader.string();
                break;
            case 11:
                message.target_allocation = reader.string();
                break;
            case 12:
                message.symbol = reader.string();
                break;
            case 13:
                message.exchange = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an InstrumentOverview message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InstrumentOverview
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InstrumentOverview} InstrumentOverview
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstrumentOverview.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InstrumentOverview message.
     * @function verify
     * @memberof InstrumentOverview
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InstrumentOverview.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.isin != null && message.hasOwnProperty("isin"))
            if (!$util.isString(message.isin))
                return "isin: string expected";
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            if (!$util.isString(message.friendly_name))
                return "friendly_name: string expected";
        if (message.market_cap != null && message.hasOwnProperty("market_cap"))
            if (!$util.isString(message.market_cap))
                return "market_cap: string expected";
        if (message.latest_price != null && message.hasOwnProperty("latest_price"))
            if (!$util.isString(message.latest_price))
                return "latest_price: string expected";
        if (message.ytd_percentage_change != null && message.hasOwnProperty("ytd_percentage_change"))
            if (!$util.isString(message.ytd_percentage_change))
                return "ytd_percentage_change: string expected";
        if (message.ytd_percentage_low != null && message.hasOwnProperty("ytd_percentage_low"))
            if (!$util.isString(message.ytd_percentage_low))
                return "ytd_percentage_low: string expected";
        if (message.ytd_percentage_high != null && message.hasOwnProperty("ytd_percentage_high"))
            if (!$util.isString(message.ytd_percentage_high))
                return "ytd_percentage_high: string expected";
        if (message.country != null && message.hasOwnProperty("country"))
            if (!$util.isString(message.country))
                return "country: string expected";
        if (message.sector != null && message.hasOwnProperty("sector"))
            if (!$util.isString(message.sector))
                return "sector: string expected";
        if (message.target_allocation != null && message.hasOwnProperty("target_allocation"))
            if (!$util.isString(message.target_allocation))
                return "target_allocation: string expected";
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        if (message.exchange != null && message.hasOwnProperty("exchange"))
            if (!$util.isString(message.exchange))
                return "exchange: string expected";
        return null;
    };

    /**
     * Creates an InstrumentOverview message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InstrumentOverview
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InstrumentOverview} InstrumentOverview
     */
    InstrumentOverview.fromObject = function fromObject(object) {
        if (object instanceof $root.InstrumentOverview)
            return object;
        let message = new $root.InstrumentOverview();
        if (object.id != null)
            message.id = String(object.id);
        if (object.isin != null)
            message.isin = String(object.isin);
        if (object.friendly_name != null)
            message.friendly_name = String(object.friendly_name);
        if (object.market_cap != null)
            message.market_cap = String(object.market_cap);
        if (object.latest_price != null)
            message.latest_price = String(object.latest_price);
        if (object.ytd_percentage_change != null)
            message.ytd_percentage_change = String(object.ytd_percentage_change);
        if (object.ytd_percentage_low != null)
            message.ytd_percentage_low = String(object.ytd_percentage_low);
        if (object.ytd_percentage_high != null)
            message.ytd_percentage_high = String(object.ytd_percentage_high);
        if (object.country != null)
            message.country = String(object.country);
        if (object.sector != null)
            message.sector = String(object.sector);
        if (object.target_allocation != null)
            message.target_allocation = String(object.target_allocation);
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        if (object.exchange != null)
            message.exchange = String(object.exchange);
        return message;
    };

    /**
     * Creates a plain object from an InstrumentOverview message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InstrumentOverview
     * @static
     * @param {InstrumentOverview} message InstrumentOverview
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InstrumentOverview.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.isin = "";
            object.friendly_name = "";
            object.market_cap = "";
            object.latest_price = "";
            object.ytd_percentage_change = "";
            object.ytd_percentage_low = "";
            object.ytd_percentage_high = "";
            object.country = "";
            object.sector = "";
            object.target_allocation = "";
            object.symbol = "";
            object.exchange = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.isin != null && message.hasOwnProperty("isin"))
            object.isin = message.isin;
        if (message.friendly_name != null && message.hasOwnProperty("friendly_name"))
            object.friendly_name = message.friendly_name;
        if (message.market_cap != null && message.hasOwnProperty("market_cap"))
            object.market_cap = message.market_cap;
        if (message.latest_price != null && message.hasOwnProperty("latest_price"))
            object.latest_price = message.latest_price;
        if (message.ytd_percentage_change != null && message.hasOwnProperty("ytd_percentage_change"))
            object.ytd_percentage_change = message.ytd_percentage_change;
        if (message.ytd_percentage_low != null && message.hasOwnProperty("ytd_percentage_low"))
            object.ytd_percentage_low = message.ytd_percentage_low;
        if (message.ytd_percentage_high != null && message.hasOwnProperty("ytd_percentage_high"))
            object.ytd_percentage_high = message.ytd_percentage_high;
        if (message.country != null && message.hasOwnProperty("country"))
            object.country = message.country;
        if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
        if (message.target_allocation != null && message.hasOwnProperty("target_allocation"))
            object.target_allocation = message.target_allocation;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.exchange != null && message.hasOwnProperty("exchange"))
            object.exchange = message.exchange;
        return object;
    };

    /**
     * Converts this InstrumentOverview to JSON.
     * @function toJSON
     * @memberof InstrumentOverview
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InstrumentOverview.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return InstrumentOverview;
})();

export const InstrumentPriceDataPoint = $root.InstrumentPriceDataPoint = (() => {

    /**
     * Properties of an InstrumentPriceDataPoint.
     * @exports IInstrumentPriceDataPoint
     * @interface IInstrumentPriceDataPoint
     * @property {string|null} [date] InstrumentPriceDataPoint date
     * @property {string|null} [aud_price] InstrumentPriceDataPoint aud_price
     */

    /**
     * Constructs a new InstrumentPriceDataPoint.
     * @exports InstrumentPriceDataPoint
     * @classdesc Represents an InstrumentPriceDataPoint.
     * @implements IInstrumentPriceDataPoint
     * @constructor
     * @param {IInstrumentPriceDataPoint=} [properties] Properties to set
     */
    function InstrumentPriceDataPoint(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InstrumentPriceDataPoint date.
     * @member {string} date
     * @memberof InstrumentPriceDataPoint
     * @instance
     */
    InstrumentPriceDataPoint.prototype.date = "";

    /**
     * InstrumentPriceDataPoint aud_price.
     * @member {string} aud_price
     * @memberof InstrumentPriceDataPoint
     * @instance
     */
    InstrumentPriceDataPoint.prototype.aud_price = "";

    /**
     * Creates a new InstrumentPriceDataPoint instance using the specified properties.
     * @function create
     * @memberof InstrumentPriceDataPoint
     * @static
     * @param {IInstrumentPriceDataPoint=} [properties] Properties to set
     * @returns {InstrumentPriceDataPoint} InstrumentPriceDataPoint instance
     */
    InstrumentPriceDataPoint.create = function create(properties) {
        return new InstrumentPriceDataPoint(properties);
    };

    /**
     * Encodes the specified InstrumentPriceDataPoint message. Does not implicitly {@link InstrumentPriceDataPoint.verify|verify} messages.
     * @function encode
     * @memberof InstrumentPriceDataPoint
     * @static
     * @param {IInstrumentPriceDataPoint} message InstrumentPriceDataPoint message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstrumentPriceDataPoint.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.date != null && message.hasOwnProperty("date"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.date);
        if (message.aud_price != null && message.hasOwnProperty("aud_price"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.aud_price);
        return writer;
    };

    /**
     * Encodes the specified InstrumentPriceDataPoint message, length delimited. Does not implicitly {@link InstrumentPriceDataPoint.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InstrumentPriceDataPoint
     * @static
     * @param {IInstrumentPriceDataPoint} message InstrumentPriceDataPoint message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstrumentPriceDataPoint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an InstrumentPriceDataPoint message from the specified reader or buffer.
     * @function decode
     * @memberof InstrumentPriceDataPoint
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InstrumentPriceDataPoint} InstrumentPriceDataPoint
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstrumentPriceDataPoint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InstrumentPriceDataPoint();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.date = reader.string();
                break;
            case 2:
                message.aud_price = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an InstrumentPriceDataPoint message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InstrumentPriceDataPoint
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InstrumentPriceDataPoint} InstrumentPriceDataPoint
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstrumentPriceDataPoint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InstrumentPriceDataPoint message.
     * @function verify
     * @memberof InstrumentPriceDataPoint
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InstrumentPriceDataPoint.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.date != null && message.hasOwnProperty("date"))
            if (!$util.isString(message.date))
                return "date: string expected";
        if (message.aud_price != null && message.hasOwnProperty("aud_price"))
            if (!$util.isString(message.aud_price))
                return "aud_price: string expected";
        return null;
    };

    /**
     * Creates an InstrumentPriceDataPoint message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InstrumentPriceDataPoint
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InstrumentPriceDataPoint} InstrumentPriceDataPoint
     */
    InstrumentPriceDataPoint.fromObject = function fromObject(object) {
        if (object instanceof $root.InstrumentPriceDataPoint)
            return object;
        let message = new $root.InstrumentPriceDataPoint();
        if (object.date != null)
            message.date = String(object.date);
        if (object.aud_price != null)
            message.aud_price = String(object.aud_price);
        return message;
    };

    /**
     * Creates a plain object from an InstrumentPriceDataPoint message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InstrumentPriceDataPoint
     * @static
     * @param {InstrumentPriceDataPoint} message InstrumentPriceDataPoint
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InstrumentPriceDataPoint.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.date = "";
            object.aud_price = "";
        }
        if (message.date != null && message.hasOwnProperty("date"))
            object.date = message.date;
        if (message.aud_price != null && message.hasOwnProperty("aud_price"))
            object.aud_price = message.aud_price;
        return object;
    };

    /**
     * Converts this InstrumentPriceDataPoint to JSON.
     * @function toJSON
     * @memberof InstrumentPriceDataPoint
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InstrumentPriceDataPoint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return InstrumentPriceDataPoint;
})();

export const TransactionDirection = $root.TransactionDirection = (() => {

    /**
     * Properties of a TransactionDirection.
     * @exports ITransactionDirection
     * @interface ITransactionDirection
     */

    /**
     * Constructs a new TransactionDirection.
     * @exports TransactionDirection
     * @classdesc Represents a TransactionDirection.
     * @implements ITransactionDirection
     * @constructor
     * @param {ITransactionDirection=} [properties] Properties to set
     */
    function TransactionDirection(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new TransactionDirection instance using the specified properties.
     * @function create
     * @memberof TransactionDirection
     * @static
     * @param {ITransactionDirection=} [properties] Properties to set
     * @returns {TransactionDirection} TransactionDirection instance
     */
    TransactionDirection.create = function create(properties) {
        return new TransactionDirection(properties);
    };

    /**
     * Encodes the specified TransactionDirection message. Does not implicitly {@link TransactionDirection.verify|verify} messages.
     * @function encode
     * @memberof TransactionDirection
     * @static
     * @param {ITransactionDirection} message TransactionDirection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TransactionDirection.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified TransactionDirection message, length delimited. Does not implicitly {@link TransactionDirection.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TransactionDirection
     * @static
     * @param {ITransactionDirection} message TransactionDirection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TransactionDirection.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TransactionDirection message from the specified reader or buffer.
     * @function decode
     * @memberof TransactionDirection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TransactionDirection} TransactionDirection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TransactionDirection.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TransactionDirection();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TransactionDirection message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TransactionDirection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TransactionDirection} TransactionDirection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TransactionDirection.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TransactionDirection message.
     * @function verify
     * @memberof TransactionDirection
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TransactionDirection.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a TransactionDirection message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TransactionDirection
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TransactionDirection} TransactionDirection
     */
    TransactionDirection.fromObject = function fromObject(object) {
        if (object instanceof $root.TransactionDirection)
            return object;
        return new $root.TransactionDirection();
    };

    /**
     * Creates a plain object from a TransactionDirection message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TransactionDirection
     * @static
     * @param {TransactionDirection} message TransactionDirection
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TransactionDirection.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this TransactionDirection to JSON.
     * @function toJSON
     * @memberof TransactionDirection
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TransactionDirection.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name TransactionDirection.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} CREDIT=1 CREDIT value
     * @property {number} DEBIT=2 DEBIT value
     */
    TransactionDirection.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "CREDIT"] = 1;
        values[valuesById[2] = "DEBIT"] = 2;
        return values;
    })();

    return TransactionDirection;
})();

export const ExternalReferenceAndDirection = $root.ExternalReferenceAndDirection = (() => {

    /**
     * Properties of an ExternalReferenceAndDirection.
     * @exports IExternalReferenceAndDirection
     * @interface IExternalReferenceAndDirection
     * @property {string|null} [external_reference] ExternalReferenceAndDirection external_reference
     * @property {TransactionDirection.Enum|null} [direction] ExternalReferenceAndDirection direction
     */

    /**
     * Constructs a new ExternalReferenceAndDirection.
     * @exports ExternalReferenceAndDirection
     * @classdesc Represents an ExternalReferenceAndDirection.
     * @implements IExternalReferenceAndDirection
     * @constructor
     * @param {IExternalReferenceAndDirection=} [properties] Properties to set
     */
    function ExternalReferenceAndDirection(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ExternalReferenceAndDirection external_reference.
     * @member {string} external_reference
     * @memberof ExternalReferenceAndDirection
     * @instance
     */
    ExternalReferenceAndDirection.prototype.external_reference = "";

    /**
     * ExternalReferenceAndDirection direction.
     * @member {TransactionDirection.Enum} direction
     * @memberof ExternalReferenceAndDirection
     * @instance
     */
    ExternalReferenceAndDirection.prototype.direction = 0;

    /**
     * Creates a new ExternalReferenceAndDirection instance using the specified properties.
     * @function create
     * @memberof ExternalReferenceAndDirection
     * @static
     * @param {IExternalReferenceAndDirection=} [properties] Properties to set
     * @returns {ExternalReferenceAndDirection} ExternalReferenceAndDirection instance
     */
    ExternalReferenceAndDirection.create = function create(properties) {
        return new ExternalReferenceAndDirection(properties);
    };

    /**
     * Encodes the specified ExternalReferenceAndDirection message. Does not implicitly {@link ExternalReferenceAndDirection.verify|verify} messages.
     * @function encode
     * @memberof ExternalReferenceAndDirection
     * @static
     * @param {IExternalReferenceAndDirection} message ExternalReferenceAndDirection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ExternalReferenceAndDirection.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.external_reference);
        if (message.direction != null && message.hasOwnProperty("direction"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.direction);
        return writer;
    };

    /**
     * Encodes the specified ExternalReferenceAndDirection message, length delimited. Does not implicitly {@link ExternalReferenceAndDirection.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ExternalReferenceAndDirection
     * @static
     * @param {IExternalReferenceAndDirection} message ExternalReferenceAndDirection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ExternalReferenceAndDirection.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ExternalReferenceAndDirection message from the specified reader or buffer.
     * @function decode
     * @memberof ExternalReferenceAndDirection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ExternalReferenceAndDirection} ExternalReferenceAndDirection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ExternalReferenceAndDirection.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ExternalReferenceAndDirection();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.external_reference = reader.string();
                break;
            case 2:
                message.direction = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ExternalReferenceAndDirection message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ExternalReferenceAndDirection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ExternalReferenceAndDirection} ExternalReferenceAndDirection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ExternalReferenceAndDirection.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ExternalReferenceAndDirection message.
     * @function verify
     * @memberof ExternalReferenceAndDirection
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ExternalReferenceAndDirection.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            if (!$util.isString(message.external_reference))
                return "external_reference: string expected";
        if (message.direction != null && message.hasOwnProperty("direction"))
            switch (message.direction) {
            default:
                return "direction: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    /**
     * Creates an ExternalReferenceAndDirection message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ExternalReferenceAndDirection
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ExternalReferenceAndDirection} ExternalReferenceAndDirection
     */
    ExternalReferenceAndDirection.fromObject = function fromObject(object) {
        if (object instanceof $root.ExternalReferenceAndDirection)
            return object;
        let message = new $root.ExternalReferenceAndDirection();
        if (object.external_reference != null)
            message.external_reference = String(object.external_reference);
        switch (object.direction) {
        case "UNKNOWN":
        case 0:
            message.direction = 0;
            break;
        case "CREDIT":
        case 1:
            message.direction = 1;
            break;
        case "DEBIT":
        case 2:
            message.direction = 2;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from an ExternalReferenceAndDirection message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ExternalReferenceAndDirection
     * @static
     * @param {ExternalReferenceAndDirection} message ExternalReferenceAndDirection
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ExternalReferenceAndDirection.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.external_reference = "";
            object.direction = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            object.external_reference = message.external_reference;
        if (message.direction != null && message.hasOwnProperty("direction"))
            object.direction = options.enums === String ? $root.TransactionDirection.Enum[message.direction] : message.direction;
        return object;
    };

    /**
     * Converts this ExternalReferenceAndDirection to JSON.
     * @function toJSON
     * @memberof ExternalReferenceAndDirection
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ExternalReferenceAndDirection.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ExternalReferenceAndDirection;
})();

export const PendingUnitExchangeStatus = $root.PendingUnitExchangeStatus = (() => {

    /**
     * Properties of a PendingUnitExchangeStatus.
     * @exports IPendingUnitExchangeStatus
     * @interface IPendingUnitExchangeStatus
     */

    /**
     * Constructs a new PendingUnitExchangeStatus.
     * @exports PendingUnitExchangeStatus
     * @classdesc Represents a PendingUnitExchangeStatus.
     * @implements IPendingUnitExchangeStatus
     * @constructor
     * @param {IPendingUnitExchangeStatus=} [properties] Properties to set
     */
    function PendingUnitExchangeStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new PendingUnitExchangeStatus instance using the specified properties.
     * @function create
     * @memberof PendingUnitExchangeStatus
     * @static
     * @param {IPendingUnitExchangeStatus=} [properties] Properties to set
     * @returns {PendingUnitExchangeStatus} PendingUnitExchangeStatus instance
     */
    PendingUnitExchangeStatus.create = function create(properties) {
        return new PendingUnitExchangeStatus(properties);
    };

    /**
     * Encodes the specified PendingUnitExchangeStatus message. Does not implicitly {@link PendingUnitExchangeStatus.verify|verify} messages.
     * @function encode
     * @memberof PendingUnitExchangeStatus
     * @static
     * @param {IPendingUnitExchangeStatus} message PendingUnitExchangeStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PendingUnitExchangeStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified PendingUnitExchangeStatus message, length delimited. Does not implicitly {@link PendingUnitExchangeStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PendingUnitExchangeStatus
     * @static
     * @param {IPendingUnitExchangeStatus} message PendingUnitExchangeStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PendingUnitExchangeStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PendingUnitExchangeStatus message from the specified reader or buffer.
     * @function decode
     * @memberof PendingUnitExchangeStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PendingUnitExchangeStatus} PendingUnitExchangeStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PendingUnitExchangeStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PendingUnitExchangeStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PendingUnitExchangeStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PendingUnitExchangeStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PendingUnitExchangeStatus} PendingUnitExchangeStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PendingUnitExchangeStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PendingUnitExchangeStatus message.
     * @function verify
     * @memberof PendingUnitExchangeStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PendingUnitExchangeStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a PendingUnitExchangeStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PendingUnitExchangeStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PendingUnitExchangeStatus} PendingUnitExchangeStatus
     */
    PendingUnitExchangeStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.PendingUnitExchangeStatus)
            return object;
        return new $root.PendingUnitExchangeStatus();
    };

    /**
     * Creates a plain object from a PendingUnitExchangeStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PendingUnitExchangeStatus
     * @static
     * @param {PendingUnitExchangeStatus} message PendingUnitExchangeStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PendingUnitExchangeStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this PendingUnitExchangeStatus to JSON.
     * @function toJSON
     * @memberof PendingUnitExchangeStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PendingUnitExchangeStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name PendingUnitExchangeStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} AUTOMATICALLY_VERIFIED=1 AUTOMATICALLY_VERIFIED value
     * @property {number} PENDING_REVIEW=2 PENDING_REVIEW value
     * @property {number} MANUALLY_VERIFIED=3 MANUALLY_VERIFIED value
     * @property {number} MANUALLY_REJECTED=4 MANUALLY_REJECTED value
     * @property {number} AUTOMATICALLY_REJECTED=5 AUTOMATICALLY_REJECTED value
     */
    PendingUnitExchangeStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "AUTOMATICALLY_VERIFIED"] = 1;
        values[valuesById[2] = "PENDING_REVIEW"] = 2;
        values[valuesById[3] = "MANUALLY_VERIFIED"] = 3;
        values[valuesById[4] = "MANUALLY_REJECTED"] = 4;
        values[valuesById[5] = "AUTOMATICALLY_REJECTED"] = 5;
        return values;
    })();

    return PendingUnitExchangeStatus;
})();

export const UnitExchangeDirection = $root.UnitExchangeDirection = (() => {

    /**
     * Properties of an UnitExchangeDirection.
     * @exports IUnitExchangeDirection
     * @interface IUnitExchangeDirection
     */

    /**
     * Constructs a new UnitExchangeDirection.
     * @exports UnitExchangeDirection
     * @classdesc Represents an UnitExchangeDirection.
     * @implements IUnitExchangeDirection
     * @constructor
     * @param {IUnitExchangeDirection=} [properties] Properties to set
     */
    function UnitExchangeDirection(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new UnitExchangeDirection instance using the specified properties.
     * @function create
     * @memberof UnitExchangeDirection
     * @static
     * @param {IUnitExchangeDirection=} [properties] Properties to set
     * @returns {UnitExchangeDirection} UnitExchangeDirection instance
     */
    UnitExchangeDirection.create = function create(properties) {
        return new UnitExchangeDirection(properties);
    };

    /**
     * Encodes the specified UnitExchangeDirection message. Does not implicitly {@link UnitExchangeDirection.verify|verify} messages.
     * @function encode
     * @memberof UnitExchangeDirection
     * @static
     * @param {IUnitExchangeDirection} message UnitExchangeDirection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitExchangeDirection.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified UnitExchangeDirection message, length delimited. Does not implicitly {@link UnitExchangeDirection.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitExchangeDirection
     * @static
     * @param {IUnitExchangeDirection} message UnitExchangeDirection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitExchangeDirection.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitExchangeDirection message from the specified reader or buffer.
     * @function decode
     * @memberof UnitExchangeDirection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitExchangeDirection} UnitExchangeDirection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitExchangeDirection.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitExchangeDirection();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitExchangeDirection message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitExchangeDirection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitExchangeDirection} UnitExchangeDirection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitExchangeDirection.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitExchangeDirection message.
     * @function verify
     * @memberof UnitExchangeDirection
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitExchangeDirection.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an UnitExchangeDirection message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitExchangeDirection
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitExchangeDirection} UnitExchangeDirection
     */
    UnitExchangeDirection.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitExchangeDirection)
            return object;
        return new $root.UnitExchangeDirection();
    };

    /**
     * Creates a plain object from an UnitExchangeDirection message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitExchangeDirection
     * @static
     * @param {UnitExchangeDirection} message UnitExchangeDirection
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitExchangeDirection.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this UnitExchangeDirection to JSON.
     * @function toJSON
     * @memberof UnitExchangeDirection
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitExchangeDirection.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name UnitExchangeDirection.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ISSUED=1 ISSUED value
     * @property {number} REDEEMED=2 REDEEMED value
     */
    UnitExchangeDirection.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ISSUED"] = 1;
        values[valuesById[2] = "REDEEMED"] = 2;
        return values;
    })();

    return UnitExchangeDirection;
})();

export const PendingUnitExchange = $root.PendingUnitExchange = (() => {

    /**
     * Properties of a PendingUnitExchange.
     * @exports IPendingUnitExchange
     * @interface IPendingUnitExchange
     * @property {string|null} [product_id] PendingUnitExchange product_id
     * @property {SaverPortfolio.Enum|null} [portfolio] PendingUnitExchange portfolio
     * @property {string|null} [transaction_reference] PendingUnitExchange transaction_reference
     * @property {UnitExchangeDirection.Enum|null} [direction] PendingUnitExchange direction
     * @property {string|null} [amount] PendingUnitExchange amount
     * @property {PendingUnitExchangeStatus.Enum|null} [status] PendingUnitExchange status
     * @property {boolean|null} [bank_account_requires_verification] PendingUnitExchange bank_account_requires_verification
     * @property {google.protobuf.ITimestamp|null} [event_time] PendingUnitExchange event_time
     * @property {google.protobuf.ITimestamp|null} [processed_at] PendingUnitExchange processed_at
     */

    /**
     * Constructs a new PendingUnitExchange.
     * @exports PendingUnitExchange
     * @classdesc Represents a PendingUnitExchange.
     * @implements IPendingUnitExchange
     * @constructor
     * @param {IPendingUnitExchange=} [properties] Properties to set
     */
    function PendingUnitExchange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PendingUnitExchange product_id.
     * @member {string} product_id
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.product_id = "";

    /**
     * PendingUnitExchange portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.portfolio = 0;

    /**
     * PendingUnitExchange transaction_reference.
     * @member {string} transaction_reference
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.transaction_reference = "";

    /**
     * PendingUnitExchange direction.
     * @member {UnitExchangeDirection.Enum} direction
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.direction = 0;

    /**
     * PendingUnitExchange amount.
     * @member {string} amount
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.amount = "";

    /**
     * PendingUnitExchange status.
     * @member {PendingUnitExchangeStatus.Enum} status
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.status = 0;

    /**
     * PendingUnitExchange bank_account_requires_verification.
     * @member {boolean} bank_account_requires_verification
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.bank_account_requires_verification = false;

    /**
     * PendingUnitExchange event_time.
     * @member {google.protobuf.ITimestamp|null|undefined} event_time
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.event_time = null;

    /**
     * PendingUnitExchange processed_at.
     * @member {google.protobuf.ITimestamp|null|undefined} processed_at
     * @memberof PendingUnitExchange
     * @instance
     */
    PendingUnitExchange.prototype.processed_at = null;

    /**
     * Creates a new PendingUnitExchange instance using the specified properties.
     * @function create
     * @memberof PendingUnitExchange
     * @static
     * @param {IPendingUnitExchange=} [properties] Properties to set
     * @returns {PendingUnitExchange} PendingUnitExchange instance
     */
    PendingUnitExchange.create = function create(properties) {
        return new PendingUnitExchange(properties);
    };

    /**
     * Encodes the specified PendingUnitExchange message. Does not implicitly {@link PendingUnitExchange.verify|verify} messages.
     * @function encode
     * @memberof PendingUnitExchange
     * @static
     * @param {IPendingUnitExchange} message PendingUnitExchange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PendingUnitExchange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.product_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.portfolio);
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.transaction_reference);
        if (message.direction != null && message.hasOwnProperty("direction"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.direction);
        if (message.amount != null && message.hasOwnProperty("amount"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.amount);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.status);
        if (message.bank_account_requires_verification != null && message.hasOwnProperty("bank_account_requires_verification"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.bank_account_requires_verification);
        if (message.event_time != null && message.hasOwnProperty("event_time"))
            $root.google.protobuf.Timestamp.encode(message.event_time, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.processed_at != null && message.hasOwnProperty("processed_at"))
            $root.google.protobuf.Timestamp.encode(message.processed_at, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PendingUnitExchange message, length delimited. Does not implicitly {@link PendingUnitExchange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PendingUnitExchange
     * @static
     * @param {IPendingUnitExchange} message PendingUnitExchange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PendingUnitExchange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PendingUnitExchange message from the specified reader or buffer.
     * @function decode
     * @memberof PendingUnitExchange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PendingUnitExchange} PendingUnitExchange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PendingUnitExchange.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PendingUnitExchange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.product_id = reader.string();
                break;
            case 2:
                message.portfolio = reader.int32();
                break;
            case 3:
                message.transaction_reference = reader.string();
                break;
            case 4:
                message.direction = reader.int32();
                break;
            case 5:
                message.amount = reader.string();
                break;
            case 6:
                message.status = reader.int32();
                break;
            case 7:
                message.bank_account_requires_verification = reader.bool();
                break;
            case 8:
                message.event_time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 9:
                message.processed_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PendingUnitExchange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PendingUnitExchange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PendingUnitExchange} PendingUnitExchange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PendingUnitExchange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PendingUnitExchange message.
     * @function verify
     * @memberof PendingUnitExchange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PendingUnitExchange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.direction != null && message.hasOwnProperty("direction"))
            switch (message.direction) {
            default:
                return "direction: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isString(message.amount))
                return "amount: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.bank_account_requires_verification != null && message.hasOwnProperty("bank_account_requires_verification"))
            if (typeof message.bank_account_requires_verification !== "boolean")
                return "bank_account_requires_verification: boolean expected";
        if (message.event_time != null && message.hasOwnProperty("event_time")) {
            let error = $root.google.protobuf.Timestamp.verify(message.event_time);
            if (error)
                return "event_time." + error;
        }
        if (message.processed_at != null && message.hasOwnProperty("processed_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.processed_at);
            if (error)
                return "processed_at." + error;
        }
        return null;
    };

    /**
     * Creates a PendingUnitExchange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PendingUnitExchange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PendingUnitExchange} PendingUnitExchange
     */
    PendingUnitExchange.fromObject = function fromObject(object) {
        if (object instanceof $root.PendingUnitExchange)
            return object;
        let message = new $root.PendingUnitExchange();
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        switch (object.direction) {
        case "UNKNOWN":
        case 0:
            message.direction = 0;
            break;
        case "ISSUED":
        case 1:
            message.direction = 1;
            break;
        case "REDEEMED":
        case 2:
            message.direction = 2;
            break;
        }
        if (object.amount != null)
            message.amount = String(object.amount);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "AUTOMATICALLY_VERIFIED":
        case 1:
            message.status = 1;
            break;
        case "PENDING_REVIEW":
        case 2:
            message.status = 2;
            break;
        case "MANUALLY_VERIFIED":
        case 3:
            message.status = 3;
            break;
        case "MANUALLY_REJECTED":
        case 4:
            message.status = 4;
            break;
        case "AUTOMATICALLY_REJECTED":
        case 5:
            message.status = 5;
            break;
        }
        if (object.bank_account_requires_verification != null)
            message.bank_account_requires_verification = Boolean(object.bank_account_requires_verification);
        if (object.event_time != null) {
            if (typeof object.event_time !== "object")
                throw TypeError(".PendingUnitExchange.event_time: object expected");
            message.event_time = $root.google.protobuf.Timestamp.fromObject(object.event_time);
        }
        if (object.processed_at != null) {
            if (typeof object.processed_at !== "object")
                throw TypeError(".PendingUnitExchange.processed_at: object expected");
            message.processed_at = $root.google.protobuf.Timestamp.fromObject(object.processed_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a PendingUnitExchange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PendingUnitExchange
     * @static
     * @param {PendingUnitExchange} message PendingUnitExchange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PendingUnitExchange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.product_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.transaction_reference = "";
            object.direction = options.enums === String ? "UNKNOWN" : 0;
            object.amount = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.bank_account_requires_verification = false;
            object.event_time = null;
            object.processed_at = null;
        }
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.direction != null && message.hasOwnProperty("direction"))
            object.direction = options.enums === String ? $root.UnitExchangeDirection.Enum[message.direction] : message.direction;
        if (message.amount != null && message.hasOwnProperty("amount"))
            object.amount = message.amount;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.PendingUnitExchangeStatus.Enum[message.status] : message.status;
        if (message.bank_account_requires_verification != null && message.hasOwnProperty("bank_account_requires_verification"))
            object.bank_account_requires_verification = message.bank_account_requires_verification;
        if (message.event_time != null && message.hasOwnProperty("event_time"))
            object.event_time = $root.google.protobuf.Timestamp.toObject(message.event_time, options);
        if (message.processed_at != null && message.hasOwnProperty("processed_at"))
            object.processed_at = $root.google.protobuf.Timestamp.toObject(message.processed_at, options);
        return object;
    };

    /**
     * Converts this PendingUnitExchange to JSON.
     * @function toJSON
     * @memberof PendingUnitExchange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PendingUnitExchange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PendingUnitExchange;
})();

export const InstrumentAllocation = $root.InstrumentAllocation = (() => {

    /**
     * Properties of an InstrumentAllocation.
     * @exports IInstrumentAllocation
     * @interface IInstrumentAllocation
     * @property {string|null} [instrument_id] InstrumentAllocation instrument_id
     * @property {SaverPortfolio.Enum|null} [portfolio] InstrumentAllocation portfolio
     * @property {boolean|null} [active] InstrumentAllocation active
     * @property {string|null} [target_allocation] InstrumentAllocation target_allocation
     */

    /**
     * Constructs a new InstrumentAllocation.
     * @exports InstrumentAllocation
     * @classdesc Represents an InstrumentAllocation.
     * @implements IInstrumentAllocation
     * @constructor
     * @param {IInstrumentAllocation=} [properties] Properties to set
     */
    function InstrumentAllocation(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InstrumentAllocation instrument_id.
     * @member {string} instrument_id
     * @memberof InstrumentAllocation
     * @instance
     */
    InstrumentAllocation.prototype.instrument_id = "";

    /**
     * InstrumentAllocation portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof InstrumentAllocation
     * @instance
     */
    InstrumentAllocation.prototype.portfolio = 0;

    /**
     * InstrumentAllocation active.
     * @member {boolean} active
     * @memberof InstrumentAllocation
     * @instance
     */
    InstrumentAllocation.prototype.active = false;

    /**
     * InstrumentAllocation target_allocation.
     * @member {string} target_allocation
     * @memberof InstrumentAllocation
     * @instance
     */
    InstrumentAllocation.prototype.target_allocation = "";

    /**
     * Creates a new InstrumentAllocation instance using the specified properties.
     * @function create
     * @memberof InstrumentAllocation
     * @static
     * @param {IInstrumentAllocation=} [properties] Properties to set
     * @returns {InstrumentAllocation} InstrumentAllocation instance
     */
    InstrumentAllocation.create = function create(properties) {
        return new InstrumentAllocation(properties);
    };

    /**
     * Encodes the specified InstrumentAllocation message. Does not implicitly {@link InstrumentAllocation.verify|verify} messages.
     * @function encode
     * @memberof InstrumentAllocation
     * @static
     * @param {IInstrumentAllocation} message InstrumentAllocation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstrumentAllocation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.instrument_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.portfolio);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.active);
        if (message.target_allocation != null && message.hasOwnProperty("target_allocation"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.target_allocation);
        return writer;
    };

    /**
     * Encodes the specified InstrumentAllocation message, length delimited. Does not implicitly {@link InstrumentAllocation.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InstrumentAllocation
     * @static
     * @param {IInstrumentAllocation} message InstrumentAllocation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstrumentAllocation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an InstrumentAllocation message from the specified reader or buffer.
     * @function decode
     * @memberof InstrumentAllocation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InstrumentAllocation} InstrumentAllocation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstrumentAllocation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InstrumentAllocation();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.instrument_id = reader.string();
                break;
            case 2:
                message.portfolio = reader.int32();
                break;
            case 3:
                message.active = reader.bool();
                break;
            case 4:
                message.target_allocation = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an InstrumentAllocation message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InstrumentAllocation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InstrumentAllocation} InstrumentAllocation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstrumentAllocation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InstrumentAllocation message.
     * @function verify
     * @memberof InstrumentAllocation
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InstrumentAllocation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            if (!$util.isString(message.instrument_id))
                return "instrument_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.target_allocation != null && message.hasOwnProperty("target_allocation"))
            if (!$util.isString(message.target_allocation))
                return "target_allocation: string expected";
        return null;
    };

    /**
     * Creates an InstrumentAllocation message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InstrumentAllocation
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InstrumentAllocation} InstrumentAllocation
     */
    InstrumentAllocation.fromObject = function fromObject(object) {
        if (object instanceof $root.InstrumentAllocation)
            return object;
        let message = new $root.InstrumentAllocation();
        if (object.instrument_id != null)
            message.instrument_id = String(object.instrument_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.active != null)
            message.active = Boolean(object.active);
        if (object.target_allocation != null)
            message.target_allocation = String(object.target_allocation);
        return message;
    };

    /**
     * Creates a plain object from an InstrumentAllocation message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InstrumentAllocation
     * @static
     * @param {InstrumentAllocation} message InstrumentAllocation
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InstrumentAllocation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.instrument_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.active = false;
            object.target_allocation = "";
        }
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            object.instrument_id = message.instrument_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.target_allocation != null && message.hasOwnProperty("target_allocation"))
            object.target_allocation = message.target_allocation;
        return object;
    };

    /**
     * Converts this InstrumentAllocation to JSON.
     * @function toJSON
     * @memberof InstrumentAllocation
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InstrumentAllocation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return InstrumentAllocation;
})();

export const ABAType = $root.ABAType = (() => {

    /**
     * Properties of a ABAType.
     * @exports IABAType
     * @interface IABAType
     */

    /**
     * Constructs a new ABAType.
     * @exports ABAType
     * @classdesc Represents a ABAType.
     * @implements IABAType
     * @constructor
     * @param {IABAType=} [properties] Properties to set
     */
    function ABAType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new ABAType instance using the specified properties.
     * @function create
     * @memberof ABAType
     * @static
     * @param {IABAType=} [properties] Properties to set
     * @returns {ABAType} ABAType instance
     */
    ABAType.create = function create(properties) {
        return new ABAType(properties);
    };

    /**
     * Encodes the specified ABAType message. Does not implicitly {@link ABAType.verify|verify} messages.
     * @function encode
     * @memberof ABAType
     * @static
     * @param {IABAType} message ABAType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ABAType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified ABAType message, length delimited. Does not implicitly {@link ABAType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ABAType
     * @static
     * @param {IABAType} message ABAType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ABAType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ABAType message from the specified reader or buffer.
     * @function decode
     * @memberof ABAType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ABAType} ABAType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ABAType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ABAType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ABAType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ABAType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ABAType} ABAType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ABAType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ABAType message.
     * @function verify
     * @memberof ABAType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ABAType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a ABAType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ABAType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ABAType} ABAType
     */
    ABAType.fromObject = function fromObject(object) {
        if (object instanceof $root.ABAType)
            return object;
        return new $root.ABAType();
    };

    /**
     * Creates a plain object from a ABAType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ABAType
     * @static
     * @param {ABAType} message ABAType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ABAType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this ABAType to JSON.
     * @function toJSON
     * @memberof ABAType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ABAType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name ABAType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} CUSTOMER_TO_SUSPENSE=1 CUSTOMER_TO_SUSPENSE value
     * @property {number} SUSPENSE_TO_FUND=2 SUSPENSE_TO_FUND value
     * @property {number} FUND_TO_SUSPENSE=3 FUND_TO_SUSPENSE value
     * @property {number} SUSPENSE_TO_CUSTOMER=4 SUSPENSE_TO_CUSTOMER value
     * @property {number} FUND_TO_EXTERNAL=5 FUND_TO_EXTERNAL value
     * @property {number} FUND_TO_CUSTOMER=6 FUND_TO_CUSTOMER value
     * @property {number} REFERRALS_TO_FUND=7 REFERRALS_TO_FUND value
     */
    ABAType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "CUSTOMER_TO_SUSPENSE"] = 1;
        values[valuesById[2] = "SUSPENSE_TO_FUND"] = 2;
        values[valuesById[3] = "FUND_TO_SUSPENSE"] = 3;
        values[valuesById[4] = "SUSPENSE_TO_CUSTOMER"] = 4;
        values[valuesById[5] = "FUND_TO_EXTERNAL"] = 5;
        values[valuesById[6] = "FUND_TO_CUSTOMER"] = 6;
        values[valuesById[7] = "REFERRALS_TO_FUND"] = 7;
        return values;
    })();

    return ABAType;
})();

export const LegacyFreebieIssuanceDetails = $root.LegacyFreebieIssuanceDetails = (() => {

    /**
     * Properties of a LegacyFreebieIssuanceDetails.
     * @exports ILegacyFreebieIssuanceDetails
     * @interface ILegacyFreebieIssuanceDetails
     * @property {string|null} [issuance_id] LegacyFreebieIssuanceDetails issuance_id
     * @property {string|null} [aud_amount] LegacyFreebieIssuanceDetails aud_amount
     */

    /**
     * Constructs a new LegacyFreebieIssuanceDetails.
     * @exports LegacyFreebieIssuanceDetails
     * @classdesc Represents a LegacyFreebieIssuanceDetails.
     * @implements ILegacyFreebieIssuanceDetails
     * @constructor
     * @param {ILegacyFreebieIssuanceDetails=} [properties] Properties to set
     */
    function LegacyFreebieIssuanceDetails(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LegacyFreebieIssuanceDetails issuance_id.
     * @member {string} issuance_id
     * @memberof LegacyFreebieIssuanceDetails
     * @instance
     */
    LegacyFreebieIssuanceDetails.prototype.issuance_id = "";

    /**
     * LegacyFreebieIssuanceDetails aud_amount.
     * @member {string} aud_amount
     * @memberof LegacyFreebieIssuanceDetails
     * @instance
     */
    LegacyFreebieIssuanceDetails.prototype.aud_amount = "";

    /**
     * Creates a new LegacyFreebieIssuanceDetails instance using the specified properties.
     * @function create
     * @memberof LegacyFreebieIssuanceDetails
     * @static
     * @param {ILegacyFreebieIssuanceDetails=} [properties] Properties to set
     * @returns {LegacyFreebieIssuanceDetails} LegacyFreebieIssuanceDetails instance
     */
    LegacyFreebieIssuanceDetails.create = function create(properties) {
        return new LegacyFreebieIssuanceDetails(properties);
    };

    /**
     * Encodes the specified LegacyFreebieIssuanceDetails message. Does not implicitly {@link LegacyFreebieIssuanceDetails.verify|verify} messages.
     * @function encode
     * @memberof LegacyFreebieIssuanceDetails
     * @static
     * @param {ILegacyFreebieIssuanceDetails} message LegacyFreebieIssuanceDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LegacyFreebieIssuanceDetails.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.issuance_id != null && message.hasOwnProperty("issuance_id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.issuance_id);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.aud_amount);
        return writer;
    };

    /**
     * Encodes the specified LegacyFreebieIssuanceDetails message, length delimited. Does not implicitly {@link LegacyFreebieIssuanceDetails.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LegacyFreebieIssuanceDetails
     * @static
     * @param {ILegacyFreebieIssuanceDetails} message LegacyFreebieIssuanceDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LegacyFreebieIssuanceDetails.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LegacyFreebieIssuanceDetails message from the specified reader or buffer.
     * @function decode
     * @memberof LegacyFreebieIssuanceDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LegacyFreebieIssuanceDetails} LegacyFreebieIssuanceDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LegacyFreebieIssuanceDetails.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LegacyFreebieIssuanceDetails();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.issuance_id = reader.string();
                break;
            case 2:
                message.aud_amount = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LegacyFreebieIssuanceDetails message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LegacyFreebieIssuanceDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LegacyFreebieIssuanceDetails} LegacyFreebieIssuanceDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LegacyFreebieIssuanceDetails.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LegacyFreebieIssuanceDetails message.
     * @function verify
     * @memberof LegacyFreebieIssuanceDetails
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LegacyFreebieIssuanceDetails.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.issuance_id != null && message.hasOwnProperty("issuance_id"))
            if (!$util.isString(message.issuance_id))
                return "issuance_id: string expected";
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        return null;
    };

    /**
     * Creates a LegacyFreebieIssuanceDetails message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LegacyFreebieIssuanceDetails
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LegacyFreebieIssuanceDetails} LegacyFreebieIssuanceDetails
     */
    LegacyFreebieIssuanceDetails.fromObject = function fromObject(object) {
        if (object instanceof $root.LegacyFreebieIssuanceDetails)
            return object;
        let message = new $root.LegacyFreebieIssuanceDetails();
        if (object.issuance_id != null)
            message.issuance_id = String(object.issuance_id);
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        return message;
    };

    /**
     * Creates a plain object from a LegacyFreebieIssuanceDetails message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LegacyFreebieIssuanceDetails
     * @static
     * @param {LegacyFreebieIssuanceDetails} message LegacyFreebieIssuanceDetails
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LegacyFreebieIssuanceDetails.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.issuance_id = "";
            object.aud_amount = "";
        }
        if (message.issuance_id != null && message.hasOwnProperty("issuance_id"))
            object.issuance_id = message.issuance_id;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        return object;
    };

    /**
     * Converts this LegacyFreebieIssuanceDetails to JSON.
     * @function toJSON
     * @memberof LegacyFreebieIssuanceDetails
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LegacyFreebieIssuanceDetails.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LegacyFreebieIssuanceDetails;
})();

export const PromoOverview = $root.PromoOverview = (() => {

    /**
     * Properties of a PromoOverview.
     * @exports IPromoOverview
     * @interface IPromoOverview
     * @property {IPromoCampaign|null} [campaign] PromoOverview campaign
     * @property {IPromoCode|null} [code] PromoOverview code
     * @property {IPromoCodeUsage|null} [usage] PromoOverview usage
     * @property {IFreebieIssuance|null} [issuance] PromoOverview issuance
     * @property {IUnitLedgerEntry|null} [unit_ledger_entry] PromoOverview unit_ledger_entry
     * @property {ILegacyFreebieIssuanceDetails|null} [legacy_issuance_details] PromoOverview legacy_issuance_details
     */

    /**
     * Constructs a new PromoOverview.
     * @exports PromoOverview
     * @classdesc Represents a PromoOverview.
     * @implements IPromoOverview
     * @constructor
     * @param {IPromoOverview=} [properties] Properties to set
     */
    function PromoOverview(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PromoOverview campaign.
     * @member {IPromoCampaign|null|undefined} campaign
     * @memberof PromoOverview
     * @instance
     */
    PromoOverview.prototype.campaign = null;

    /**
     * PromoOverview code.
     * @member {IPromoCode|null|undefined} code
     * @memberof PromoOverview
     * @instance
     */
    PromoOverview.prototype.code = null;

    /**
     * PromoOverview usage.
     * @member {IPromoCodeUsage|null|undefined} usage
     * @memberof PromoOverview
     * @instance
     */
    PromoOverview.prototype.usage = null;

    /**
     * PromoOverview issuance.
     * @member {IFreebieIssuance|null|undefined} issuance
     * @memberof PromoOverview
     * @instance
     */
    PromoOverview.prototype.issuance = null;

    /**
     * PromoOverview unit_ledger_entry.
     * @member {IUnitLedgerEntry|null|undefined} unit_ledger_entry
     * @memberof PromoOverview
     * @instance
     */
    PromoOverview.prototype.unit_ledger_entry = null;

    /**
     * PromoOverview legacy_issuance_details.
     * @member {ILegacyFreebieIssuanceDetails|null|undefined} legacy_issuance_details
     * @memberof PromoOverview
     * @instance
     */
    PromoOverview.prototype.legacy_issuance_details = null;

    /**
     * Creates a new PromoOverview instance using the specified properties.
     * @function create
     * @memberof PromoOverview
     * @static
     * @param {IPromoOverview=} [properties] Properties to set
     * @returns {PromoOverview} PromoOverview instance
     */
    PromoOverview.create = function create(properties) {
        return new PromoOverview(properties);
    };

    /**
     * Encodes the specified PromoOverview message. Does not implicitly {@link PromoOverview.verify|verify} messages.
     * @function encode
     * @memberof PromoOverview
     * @static
     * @param {IPromoOverview} message PromoOverview message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromoOverview.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.campaign != null && message.hasOwnProperty("campaign"))
            $root.PromoCampaign.encode(message.campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.code != null && message.hasOwnProperty("code"))
            $root.PromoCode.encode(message.code, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.usage != null && message.hasOwnProperty("usage"))
            $root.PromoCodeUsage.encode(message.usage, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.issuance != null && message.hasOwnProperty("issuance"))
            $root.FreebieIssuance.encode(message.issuance, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.unit_ledger_entry != null && message.hasOwnProperty("unit_ledger_entry"))
            $root.UnitLedgerEntry.encode(message.unit_ledger_entry, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.legacy_issuance_details != null && message.hasOwnProperty("legacy_issuance_details"))
            $root.LegacyFreebieIssuanceDetails.encode(message.legacy_issuance_details, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PromoOverview message, length delimited. Does not implicitly {@link PromoOverview.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PromoOverview
     * @static
     * @param {IPromoOverview} message PromoOverview message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromoOverview.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PromoOverview message from the specified reader or buffer.
     * @function decode
     * @memberof PromoOverview
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PromoOverview} PromoOverview
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromoOverview.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PromoOverview();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.campaign = $root.PromoCampaign.decode(reader, reader.uint32());
                break;
            case 2:
                message.code = $root.PromoCode.decode(reader, reader.uint32());
                break;
            case 3:
                message.usage = $root.PromoCodeUsage.decode(reader, reader.uint32());
                break;
            case 4:
                message.issuance = $root.FreebieIssuance.decode(reader, reader.uint32());
                break;
            case 5:
                message.unit_ledger_entry = $root.UnitLedgerEntry.decode(reader, reader.uint32());
                break;
            case 6:
                message.legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PromoOverview message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PromoOverview
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PromoOverview} PromoOverview
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromoOverview.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PromoOverview message.
     * @function verify
     * @memberof PromoOverview
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PromoOverview.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.campaign != null && message.hasOwnProperty("campaign")) {
            let error = $root.PromoCampaign.verify(message.campaign);
            if (error)
                return "campaign." + error;
        }
        if (message.code != null && message.hasOwnProperty("code")) {
            let error = $root.PromoCode.verify(message.code);
            if (error)
                return "code." + error;
        }
        if (message.usage != null && message.hasOwnProperty("usage")) {
            let error = $root.PromoCodeUsage.verify(message.usage);
            if (error)
                return "usage." + error;
        }
        if (message.issuance != null && message.hasOwnProperty("issuance")) {
            let error = $root.FreebieIssuance.verify(message.issuance);
            if (error)
                return "issuance." + error;
        }
        if (message.unit_ledger_entry != null && message.hasOwnProperty("unit_ledger_entry")) {
            let error = $root.UnitLedgerEntry.verify(message.unit_ledger_entry);
            if (error)
                return "unit_ledger_entry." + error;
        }
        if (message.legacy_issuance_details != null && message.hasOwnProperty("legacy_issuance_details")) {
            let error = $root.LegacyFreebieIssuanceDetails.verify(message.legacy_issuance_details);
            if (error)
                return "legacy_issuance_details." + error;
        }
        return null;
    };

    /**
     * Creates a PromoOverview message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PromoOverview
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PromoOverview} PromoOverview
     */
    PromoOverview.fromObject = function fromObject(object) {
        if (object instanceof $root.PromoOverview)
            return object;
        let message = new $root.PromoOverview();
        if (object.campaign != null) {
            if (typeof object.campaign !== "object")
                throw TypeError(".PromoOverview.campaign: object expected");
            message.campaign = $root.PromoCampaign.fromObject(object.campaign);
        }
        if (object.code != null) {
            if (typeof object.code !== "object")
                throw TypeError(".PromoOverview.code: object expected");
            message.code = $root.PromoCode.fromObject(object.code);
        }
        if (object.usage != null) {
            if (typeof object.usage !== "object")
                throw TypeError(".PromoOverview.usage: object expected");
            message.usage = $root.PromoCodeUsage.fromObject(object.usage);
        }
        if (object.issuance != null) {
            if (typeof object.issuance !== "object")
                throw TypeError(".PromoOverview.issuance: object expected");
            message.issuance = $root.FreebieIssuance.fromObject(object.issuance);
        }
        if (object.unit_ledger_entry != null) {
            if (typeof object.unit_ledger_entry !== "object")
                throw TypeError(".PromoOverview.unit_ledger_entry: object expected");
            message.unit_ledger_entry = $root.UnitLedgerEntry.fromObject(object.unit_ledger_entry);
        }
        if (object.legacy_issuance_details != null) {
            if (typeof object.legacy_issuance_details !== "object")
                throw TypeError(".PromoOverview.legacy_issuance_details: object expected");
            message.legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.fromObject(object.legacy_issuance_details);
        }
        return message;
    };

    /**
     * Creates a plain object from a PromoOverview message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PromoOverview
     * @static
     * @param {PromoOverview} message PromoOverview
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PromoOverview.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.campaign = null;
            object.code = null;
            object.usage = null;
            object.issuance = null;
            object.unit_ledger_entry = null;
            object.legacy_issuance_details = null;
        }
        if (message.campaign != null && message.hasOwnProperty("campaign"))
            object.campaign = $root.PromoCampaign.toObject(message.campaign, options);
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = $root.PromoCode.toObject(message.code, options);
        if (message.usage != null && message.hasOwnProperty("usage"))
            object.usage = $root.PromoCodeUsage.toObject(message.usage, options);
        if (message.issuance != null && message.hasOwnProperty("issuance"))
            object.issuance = $root.FreebieIssuance.toObject(message.issuance, options);
        if (message.unit_ledger_entry != null && message.hasOwnProperty("unit_ledger_entry"))
            object.unit_ledger_entry = $root.UnitLedgerEntry.toObject(message.unit_ledger_entry, options);
        if (message.legacy_issuance_details != null && message.hasOwnProperty("legacy_issuance_details"))
            object.legacy_issuance_details = $root.LegacyFreebieIssuanceDetails.toObject(message.legacy_issuance_details, options);
        return object;
    };

    /**
     * Converts this PromoOverview to JSON.
     * @function toJSON
     * @memberof PromoOverview
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PromoOverview.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PromoOverview;
})();

export const ReferralCampaign = $root.ReferralCampaign = (() => {

    /**
     * Properties of a ReferralCampaign.
     * @exports IReferralCampaign
     * @interface IReferralCampaign
     * @property {string|null} [id] ReferralCampaign id
     * @property {string|null} [title] ReferralCampaign title
     * @property {string|null} [start_date] ReferralCampaign start_date
     * @property {string|null} [end_date] ReferralCampaign end_date
     * @property {string|null} [aud_referrer_issuance_amount] ReferralCampaign aud_referrer_issuance_amount
     * @property {string|null} [aud_referrer_minimum_investment_amount] ReferralCampaign aud_referrer_minimum_investment_amount
     * @property {string|null} [aud_referral_issuance_amount] ReferralCampaign aud_referral_issuance_amount
     * @property {string|null} [aud_referral_minimum_investment_amount] ReferralCampaign aud_referral_minimum_investment_amount
     * @property {ReferralCampaign.Status.Enum|null} [status] ReferralCampaign status
     * @property {string|null} [terms_and_conditions_url] ReferralCampaign terms_and_conditions_url
     * @property {number|null} [max_referral_code_usage_days] ReferralCampaign max_referral_code_usage_days
     * @property {google.protobuf.ITimestamp|null} [created_at] ReferralCampaign created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] ReferralCampaign last_updated_at
     */

    /**
     * Constructs a new ReferralCampaign.
     * @exports ReferralCampaign
     * @classdesc Represents a ReferralCampaign.
     * @implements IReferralCampaign
     * @constructor
     * @param {IReferralCampaign=} [properties] Properties to set
     */
    function ReferralCampaign(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ReferralCampaign id.
     * @member {string} id
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.id = "";

    /**
     * ReferralCampaign title.
     * @member {string} title
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.title = "";

    /**
     * ReferralCampaign start_date.
     * @member {string} start_date
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.start_date = "";

    /**
     * ReferralCampaign end_date.
     * @member {string} end_date
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.end_date = "";

    /**
     * ReferralCampaign aud_referrer_issuance_amount.
     * @member {string} aud_referrer_issuance_amount
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.aud_referrer_issuance_amount = "";

    /**
     * ReferralCampaign aud_referrer_minimum_investment_amount.
     * @member {string} aud_referrer_minimum_investment_amount
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.aud_referrer_minimum_investment_amount = "";

    /**
     * ReferralCampaign aud_referral_issuance_amount.
     * @member {string} aud_referral_issuance_amount
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.aud_referral_issuance_amount = "";

    /**
     * ReferralCampaign aud_referral_minimum_investment_amount.
     * @member {string} aud_referral_minimum_investment_amount
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.aud_referral_minimum_investment_amount = "";

    /**
     * ReferralCampaign status.
     * @member {ReferralCampaign.Status.Enum} status
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.status = 0;

    /**
     * ReferralCampaign terms_and_conditions_url.
     * @member {string} terms_and_conditions_url
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.terms_and_conditions_url = "";

    /**
     * ReferralCampaign max_referral_code_usage_days.
     * @member {number} max_referral_code_usage_days
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.max_referral_code_usage_days = 0;

    /**
     * ReferralCampaign created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.created_at = null;

    /**
     * ReferralCampaign last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof ReferralCampaign
     * @instance
     */
    ReferralCampaign.prototype.last_updated_at = null;

    /**
     * Creates a new ReferralCampaign instance using the specified properties.
     * @function create
     * @memberof ReferralCampaign
     * @static
     * @param {IReferralCampaign=} [properties] Properties to set
     * @returns {ReferralCampaign} ReferralCampaign instance
     */
    ReferralCampaign.create = function create(properties) {
        return new ReferralCampaign(properties);
    };

    /**
     * Encodes the specified ReferralCampaign message. Does not implicitly {@link ReferralCampaign.verify|verify} messages.
     * @function encode
     * @memberof ReferralCampaign
     * @static
     * @param {IReferralCampaign} message ReferralCampaign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReferralCampaign.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.title != null && message.hasOwnProperty("title"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.start_date);
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.end_date);
        if (message.aud_referrer_issuance_amount != null && message.hasOwnProperty("aud_referrer_issuance_amount"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.aud_referrer_issuance_amount);
        if (message.aud_referrer_minimum_investment_amount != null && message.hasOwnProperty("aud_referrer_minimum_investment_amount"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.aud_referrer_minimum_investment_amount);
        if (message.aud_referral_issuance_amount != null && message.hasOwnProperty("aud_referral_issuance_amount"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.aud_referral_issuance_amount);
        if (message.aud_referral_minimum_investment_amount != null && message.hasOwnProperty("aud_referral_minimum_investment_amount"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.aud_referral_minimum_investment_amount);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.status);
        if (message.terms_and_conditions_url != null && message.hasOwnProperty("terms_and_conditions_url"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.terms_and_conditions_url);
        if (message.max_referral_code_usage_days != null && message.hasOwnProperty("max_referral_code_usage_days"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.max_referral_code_usage_days);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ReferralCampaign message, length delimited. Does not implicitly {@link ReferralCampaign.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReferralCampaign
     * @static
     * @param {IReferralCampaign} message ReferralCampaign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReferralCampaign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReferralCampaign message from the specified reader or buffer.
     * @function decode
     * @memberof ReferralCampaign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReferralCampaign} ReferralCampaign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReferralCampaign.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReferralCampaign();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.title = reader.string();
                break;
            case 3:
                message.start_date = reader.string();
                break;
            case 4:
                message.end_date = reader.string();
                break;
            case 5:
                message.aud_referrer_issuance_amount = reader.string();
                break;
            case 6:
                message.aud_referrer_minimum_investment_amount = reader.string();
                break;
            case 7:
                message.aud_referral_issuance_amount = reader.string();
                break;
            case 8:
                message.aud_referral_minimum_investment_amount = reader.string();
                break;
            case 9:
                message.status = reader.int32();
                break;
            case 10:
                message.terms_and_conditions_url = reader.string();
                break;
            case 11:
                message.max_referral_code_usage_days = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReferralCampaign message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReferralCampaign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReferralCampaign} ReferralCampaign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReferralCampaign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReferralCampaign message.
     * @function verify
     * @memberof ReferralCampaign
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReferralCampaign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.title != null && message.hasOwnProperty("title"))
            if (!$util.isString(message.title))
                return "title: string expected";
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            if (!$util.isString(message.start_date))
                return "start_date: string expected";
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            if (!$util.isString(message.end_date))
                return "end_date: string expected";
        if (message.aud_referrer_issuance_amount != null && message.hasOwnProperty("aud_referrer_issuance_amount"))
            if (!$util.isString(message.aud_referrer_issuance_amount))
                return "aud_referrer_issuance_amount: string expected";
        if (message.aud_referrer_minimum_investment_amount != null && message.hasOwnProperty("aud_referrer_minimum_investment_amount"))
            if (!$util.isString(message.aud_referrer_minimum_investment_amount))
                return "aud_referrer_minimum_investment_amount: string expected";
        if (message.aud_referral_issuance_amount != null && message.hasOwnProperty("aud_referral_issuance_amount"))
            if (!$util.isString(message.aud_referral_issuance_amount))
                return "aud_referral_issuance_amount: string expected";
        if (message.aud_referral_minimum_investment_amount != null && message.hasOwnProperty("aud_referral_minimum_investment_amount"))
            if (!$util.isString(message.aud_referral_minimum_investment_amount))
                return "aud_referral_minimum_investment_amount: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.terms_and_conditions_url != null && message.hasOwnProperty("terms_and_conditions_url"))
            if (!$util.isString(message.terms_and_conditions_url))
                return "terms_and_conditions_url: string expected";
        if (message.max_referral_code_usage_days != null && message.hasOwnProperty("max_referral_code_usage_days"))
            if (!$util.isInteger(message.max_referral_code_usage_days))
                return "max_referral_code_usage_days: integer expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a ReferralCampaign message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReferralCampaign
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReferralCampaign} ReferralCampaign
     */
    ReferralCampaign.fromObject = function fromObject(object) {
        if (object instanceof $root.ReferralCampaign)
            return object;
        let message = new $root.ReferralCampaign();
        if (object.id != null)
            message.id = String(object.id);
        if (object.title != null)
            message.title = String(object.title);
        if (object.start_date != null)
            message.start_date = String(object.start_date);
        if (object.end_date != null)
            message.end_date = String(object.end_date);
        if (object.aud_referrer_issuance_amount != null)
            message.aud_referrer_issuance_amount = String(object.aud_referrer_issuance_amount);
        if (object.aud_referrer_minimum_investment_amount != null)
            message.aud_referrer_minimum_investment_amount = String(object.aud_referrer_minimum_investment_amount);
        if (object.aud_referral_issuance_amount != null)
            message.aud_referral_issuance_amount = String(object.aud_referral_issuance_amount);
        if (object.aud_referral_minimum_investment_amount != null)
            message.aud_referral_minimum_investment_amount = String(object.aud_referral_minimum_investment_amount);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ACTIVE":
        case 1:
            message.status = 1;
            break;
        case "INACTIVE":
        case 2:
            message.status = 2;
            break;
        case "LEGACY":
        case 3:
            message.status = 3;
            break;
        }
        if (object.terms_and_conditions_url != null)
            message.terms_and_conditions_url = String(object.terms_and_conditions_url);
        if (object.max_referral_code_usage_days != null)
            message.max_referral_code_usage_days = object.max_referral_code_usage_days | 0;
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".ReferralCampaign.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".ReferralCampaign.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a ReferralCampaign message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReferralCampaign
     * @static
     * @param {ReferralCampaign} message ReferralCampaign
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReferralCampaign.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.title = "";
            object.start_date = "";
            object.end_date = "";
            object.aud_referrer_issuance_amount = "";
            object.aud_referrer_minimum_investment_amount = "";
            object.aud_referral_issuance_amount = "";
            object.aud_referral_minimum_investment_amount = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.terms_and_conditions_url = "";
            object.max_referral_code_usage_days = 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.title != null && message.hasOwnProperty("title"))
            object.title = message.title;
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            object.start_date = message.start_date;
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            object.end_date = message.end_date;
        if (message.aud_referrer_issuance_amount != null && message.hasOwnProperty("aud_referrer_issuance_amount"))
            object.aud_referrer_issuance_amount = message.aud_referrer_issuance_amount;
        if (message.aud_referrer_minimum_investment_amount != null && message.hasOwnProperty("aud_referrer_minimum_investment_amount"))
            object.aud_referrer_minimum_investment_amount = message.aud_referrer_minimum_investment_amount;
        if (message.aud_referral_issuance_amount != null && message.hasOwnProperty("aud_referral_issuance_amount"))
            object.aud_referral_issuance_amount = message.aud_referral_issuance_amount;
        if (message.aud_referral_minimum_investment_amount != null && message.hasOwnProperty("aud_referral_minimum_investment_amount"))
            object.aud_referral_minimum_investment_amount = message.aud_referral_minimum_investment_amount;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.ReferralCampaign.Status.Enum[message.status] : message.status;
        if (message.terms_and_conditions_url != null && message.hasOwnProperty("terms_and_conditions_url"))
            object.terms_and_conditions_url = message.terms_and_conditions_url;
        if (message.max_referral_code_usage_days != null && message.hasOwnProperty("max_referral_code_usage_days"))
            object.max_referral_code_usage_days = message.max_referral_code_usage_days;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this ReferralCampaign to JSON.
     * @function toJSON
     * @memberof ReferralCampaign
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReferralCampaign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ReferralCampaign.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof ReferralCampaign
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof ReferralCampaign
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {ReferralCampaign.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof ReferralCampaign.Status
         * @static
         * @param {ReferralCampaign.IStatus=} [properties] Properties to set
         * @returns {ReferralCampaign.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link ReferralCampaign.Status.verify|verify} messages.
         * @function encode
         * @memberof ReferralCampaign.Status
         * @static
         * @param {ReferralCampaign.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link ReferralCampaign.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ReferralCampaign.Status
         * @static
         * @param {ReferralCampaign.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof ReferralCampaign.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ReferralCampaign.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReferralCampaign.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ReferralCampaign.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ReferralCampaign.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof ReferralCampaign.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ReferralCampaign.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ReferralCampaign.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.ReferralCampaign.Status)
                return object;
            return new $root.ReferralCampaign.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ReferralCampaign.Status
         * @static
         * @param {ReferralCampaign.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof ReferralCampaign.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name ReferralCampaign.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} ACTIVE=1 ACTIVE value
         * @property {number} INACTIVE=2 INACTIVE value
         * @property {number} LEGACY=3 LEGACY value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "ACTIVE"] = 1;
            values[valuesById[2] = "INACTIVE"] = 2;
            values[valuesById[3] = "LEGACY"] = 3;
            return values;
        })();

        return Status;
    })();

    return ReferralCampaign;
})();

export const ReferralCode = $root.ReferralCode = (() => {

    /**
     * Properties of a ReferralCode.
     * @exports IReferralCode
     * @interface IReferralCode
     * @property {string|null} [id] ReferralCode id
     * @property {string|null} [product_id] ReferralCode product_id
     * @property {string|null} [referral_code] ReferralCode referral_code
     * @property {ReferralCode.Status.Enum|null} [status] ReferralCode status
     * @property {string|null} [campaign_id] ReferralCode campaign_id
     * @property {google.protobuf.ITimestamp|null} [created_at] ReferralCode created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] ReferralCode last_updated_at
     */

    /**
     * Constructs a new ReferralCode.
     * @exports ReferralCode
     * @classdesc Represents a ReferralCode.
     * @implements IReferralCode
     * @constructor
     * @param {IReferralCode=} [properties] Properties to set
     */
    function ReferralCode(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ReferralCode id.
     * @member {string} id
     * @memberof ReferralCode
     * @instance
     */
    ReferralCode.prototype.id = "";

    /**
     * ReferralCode product_id.
     * @member {string} product_id
     * @memberof ReferralCode
     * @instance
     */
    ReferralCode.prototype.product_id = "";

    /**
     * ReferralCode referral_code.
     * @member {string} referral_code
     * @memberof ReferralCode
     * @instance
     */
    ReferralCode.prototype.referral_code = "";

    /**
     * ReferralCode status.
     * @member {ReferralCode.Status.Enum} status
     * @memberof ReferralCode
     * @instance
     */
    ReferralCode.prototype.status = 0;

    /**
     * ReferralCode campaign_id.
     * @member {string} campaign_id
     * @memberof ReferralCode
     * @instance
     */
    ReferralCode.prototype.campaign_id = "";

    /**
     * ReferralCode created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof ReferralCode
     * @instance
     */
    ReferralCode.prototype.created_at = null;

    /**
     * ReferralCode last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof ReferralCode
     * @instance
     */
    ReferralCode.prototype.last_updated_at = null;

    /**
     * Creates a new ReferralCode instance using the specified properties.
     * @function create
     * @memberof ReferralCode
     * @static
     * @param {IReferralCode=} [properties] Properties to set
     * @returns {ReferralCode} ReferralCode instance
     */
    ReferralCode.create = function create(properties) {
        return new ReferralCode(properties);
    };

    /**
     * Encodes the specified ReferralCode message. Does not implicitly {@link ReferralCode.verify|verify} messages.
     * @function encode
     * @memberof ReferralCode
     * @static
     * @param {IReferralCode} message ReferralCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReferralCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.product_id);
        if (message.referral_code != null && message.hasOwnProperty("referral_code"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.referral_code);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
        if (message.campaign_id != null && message.hasOwnProperty("campaign_id"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.campaign_id);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ReferralCode message, length delimited. Does not implicitly {@link ReferralCode.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReferralCode
     * @static
     * @param {IReferralCode} message ReferralCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReferralCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReferralCode message from the specified reader or buffer.
     * @function decode
     * @memberof ReferralCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReferralCode} ReferralCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReferralCode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReferralCode();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.product_id = reader.string();
                break;
            case 3:
                message.referral_code = reader.string();
                break;
            case 4:
                message.status = reader.int32();
                break;
            case 5:
                message.campaign_id = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReferralCode message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReferralCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReferralCode} ReferralCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReferralCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReferralCode message.
     * @function verify
     * @memberof ReferralCode
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReferralCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.referral_code != null && message.hasOwnProperty("referral_code"))
            if (!$util.isString(message.referral_code))
                return "referral_code: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.campaign_id != null && message.hasOwnProperty("campaign_id"))
            if (!$util.isString(message.campaign_id))
                return "campaign_id: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a ReferralCode message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReferralCode
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReferralCode} ReferralCode
     */
    ReferralCode.fromObject = function fromObject(object) {
        if (object instanceof $root.ReferralCode)
            return object;
        let message = new $root.ReferralCode();
        if (object.id != null)
            message.id = String(object.id);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.referral_code != null)
            message.referral_code = String(object.referral_code);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ACTIVE":
        case 1:
            message.status = 1;
            break;
        case "INACTIVE":
        case 2:
            message.status = 2;
            break;
        }
        if (object.campaign_id != null)
            message.campaign_id = String(object.campaign_id);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".ReferralCode.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".ReferralCode.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a ReferralCode message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReferralCode
     * @static
     * @param {ReferralCode} message ReferralCode
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReferralCode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.product_id = "";
            object.referral_code = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.campaign_id = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.referral_code != null && message.hasOwnProperty("referral_code"))
            object.referral_code = message.referral_code;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.ReferralCode.Status.Enum[message.status] : message.status;
        if (message.campaign_id != null && message.hasOwnProperty("campaign_id"))
            object.campaign_id = message.campaign_id;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this ReferralCode to JSON.
     * @function toJSON
     * @memberof ReferralCode
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReferralCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ReferralCode.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof ReferralCode
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof ReferralCode
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {ReferralCode.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof ReferralCode.Status
         * @static
         * @param {ReferralCode.IStatus=} [properties] Properties to set
         * @returns {ReferralCode.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link ReferralCode.Status.verify|verify} messages.
         * @function encode
         * @memberof ReferralCode.Status
         * @static
         * @param {ReferralCode.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link ReferralCode.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ReferralCode.Status
         * @static
         * @param {ReferralCode.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof ReferralCode.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ReferralCode.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReferralCode.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ReferralCode.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ReferralCode.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof ReferralCode.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ReferralCode.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ReferralCode.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.ReferralCode.Status)
                return object;
            return new $root.ReferralCode.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ReferralCode.Status
         * @static
         * @param {ReferralCode.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof ReferralCode.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name ReferralCode.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} ACTIVE=1 ACTIVE value
         * @property {number} INACTIVE=2 INACTIVE value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "ACTIVE"] = 1;
            values[valuesById[2] = "INACTIVE"] = 2;
            return values;
        })();

        return Status;
    })();

    return ReferralCode;
})();

export const ReferralBan = $root.ReferralBan = (() => {

    /**
     * Properties of a ReferralBan.
     * @exports IReferralBan
     * @interface IReferralBan
     * @property {string|null} [id] ReferralBan id
     * @property {string|null} [product_id] ReferralBan product_id
     * @property {string|null} [comment] ReferralBan comment
     * @property {FreebieBanStatus.Enum|null} [status] ReferralBan status
     * @property {google.protobuf.ITimestamp|null} [created_at] ReferralBan created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] ReferralBan last_updated_at
     */

    /**
     * Constructs a new ReferralBan.
     * @exports ReferralBan
     * @classdesc Represents a ReferralBan.
     * @implements IReferralBan
     * @constructor
     * @param {IReferralBan=} [properties] Properties to set
     */
    function ReferralBan(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ReferralBan id.
     * @member {string} id
     * @memberof ReferralBan
     * @instance
     */
    ReferralBan.prototype.id = "";

    /**
     * ReferralBan product_id.
     * @member {string} product_id
     * @memberof ReferralBan
     * @instance
     */
    ReferralBan.prototype.product_id = "";

    /**
     * ReferralBan comment.
     * @member {string} comment
     * @memberof ReferralBan
     * @instance
     */
    ReferralBan.prototype.comment = "";

    /**
     * ReferralBan status.
     * @member {FreebieBanStatus.Enum} status
     * @memberof ReferralBan
     * @instance
     */
    ReferralBan.prototype.status = 0;

    /**
     * ReferralBan created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof ReferralBan
     * @instance
     */
    ReferralBan.prototype.created_at = null;

    /**
     * ReferralBan last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof ReferralBan
     * @instance
     */
    ReferralBan.prototype.last_updated_at = null;

    /**
     * Creates a new ReferralBan instance using the specified properties.
     * @function create
     * @memberof ReferralBan
     * @static
     * @param {IReferralBan=} [properties] Properties to set
     * @returns {ReferralBan} ReferralBan instance
     */
    ReferralBan.create = function create(properties) {
        return new ReferralBan(properties);
    };

    /**
     * Encodes the specified ReferralBan message. Does not implicitly {@link ReferralBan.verify|verify} messages.
     * @function encode
     * @memberof ReferralBan
     * @static
     * @param {IReferralBan} message ReferralBan message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReferralBan.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.product_id);
        if (message.comment != null && message.hasOwnProperty("comment"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.comment);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ReferralBan message, length delimited. Does not implicitly {@link ReferralBan.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReferralBan
     * @static
     * @param {IReferralBan} message ReferralBan message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReferralBan.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReferralBan message from the specified reader or buffer.
     * @function decode
     * @memberof ReferralBan
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReferralBan} ReferralBan
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReferralBan.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReferralBan();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.product_id = reader.string();
                break;
            case 3:
                message.comment = reader.string();
                break;
            case 4:
                message.status = reader.int32();
                break;
            case 5:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 6:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReferralBan message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReferralBan
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReferralBan} ReferralBan
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReferralBan.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReferralBan message.
     * @function verify
     * @memberof ReferralBan
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReferralBan.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.comment != null && message.hasOwnProperty("comment"))
            if (!$util.isString(message.comment))
                return "comment: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a ReferralBan message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReferralBan
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReferralBan} ReferralBan
     */
    ReferralBan.fromObject = function fromObject(object) {
        if (object instanceof $root.ReferralBan)
            return object;
        let message = new $root.ReferralBan();
        if (object.id != null)
            message.id = String(object.id);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.comment != null)
            message.comment = String(object.comment);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ACTIVE":
        case 1:
            message.status = 1;
            break;
        case "INACTIVE":
        case 2:
            message.status = 2;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".ReferralBan.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".ReferralBan.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a ReferralBan message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReferralBan
     * @static
     * @param {ReferralBan} message ReferralBan
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReferralBan.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.product_id = "";
            object.comment = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.comment != null && message.hasOwnProperty("comment"))
            object.comment = message.comment;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.FreebieBanStatus.Enum[message.status] : message.status;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this ReferralBan to JSON.
     * @function toJSON
     * @memberof ReferralBan
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReferralBan.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReferralBan;
})();

export const ReferralCodeUsage = $root.ReferralCodeUsage = (() => {

    /**
     * Properties of a ReferralCodeUsage.
     * @exports IReferralCodeUsage
     * @interface IReferralCodeUsage
     * @property {string|null} [id] ReferralCodeUsage id
     * @property {string|null} [referral_code_id] ReferralCodeUsage referral_code_id
     * @property {string|null} [product_id] ReferralCodeUsage product_id
     * @property {google.protobuf.ITimestamp|null} [created_at] ReferralCodeUsage created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] ReferralCodeUsage last_updated_at
     */

    /**
     * Constructs a new ReferralCodeUsage.
     * @exports ReferralCodeUsage
     * @classdesc Represents a ReferralCodeUsage.
     * @implements IReferralCodeUsage
     * @constructor
     * @param {IReferralCodeUsage=} [properties] Properties to set
     */
    function ReferralCodeUsage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ReferralCodeUsage id.
     * @member {string} id
     * @memberof ReferralCodeUsage
     * @instance
     */
    ReferralCodeUsage.prototype.id = "";

    /**
     * ReferralCodeUsage referral_code_id.
     * @member {string} referral_code_id
     * @memberof ReferralCodeUsage
     * @instance
     */
    ReferralCodeUsage.prototype.referral_code_id = "";

    /**
     * ReferralCodeUsage product_id.
     * @member {string} product_id
     * @memberof ReferralCodeUsage
     * @instance
     */
    ReferralCodeUsage.prototype.product_id = "";

    /**
     * ReferralCodeUsage created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof ReferralCodeUsage
     * @instance
     */
    ReferralCodeUsage.prototype.created_at = null;

    /**
     * ReferralCodeUsage last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof ReferralCodeUsage
     * @instance
     */
    ReferralCodeUsage.prototype.last_updated_at = null;

    /**
     * Creates a new ReferralCodeUsage instance using the specified properties.
     * @function create
     * @memberof ReferralCodeUsage
     * @static
     * @param {IReferralCodeUsage=} [properties] Properties to set
     * @returns {ReferralCodeUsage} ReferralCodeUsage instance
     */
    ReferralCodeUsage.create = function create(properties) {
        return new ReferralCodeUsage(properties);
    };

    /**
     * Encodes the specified ReferralCodeUsage message. Does not implicitly {@link ReferralCodeUsage.verify|verify} messages.
     * @function encode
     * @memberof ReferralCodeUsage
     * @static
     * @param {IReferralCodeUsage} message ReferralCodeUsage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReferralCodeUsage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.referral_code_id != null && message.hasOwnProperty("referral_code_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.referral_code_id);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.product_id);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ReferralCodeUsage message, length delimited. Does not implicitly {@link ReferralCodeUsage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReferralCodeUsage
     * @static
     * @param {IReferralCodeUsage} message ReferralCodeUsage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReferralCodeUsage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReferralCodeUsage message from the specified reader or buffer.
     * @function decode
     * @memberof ReferralCodeUsage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReferralCodeUsage} ReferralCodeUsage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReferralCodeUsage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReferralCodeUsage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.referral_code_id = reader.string();
                break;
            case 3:
                message.product_id = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReferralCodeUsage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReferralCodeUsage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReferralCodeUsage} ReferralCodeUsage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReferralCodeUsage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReferralCodeUsage message.
     * @function verify
     * @memberof ReferralCodeUsage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReferralCodeUsage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.referral_code_id != null && message.hasOwnProperty("referral_code_id"))
            if (!$util.isString(message.referral_code_id))
                return "referral_code_id: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a ReferralCodeUsage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReferralCodeUsage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReferralCodeUsage} ReferralCodeUsage
     */
    ReferralCodeUsage.fromObject = function fromObject(object) {
        if (object instanceof $root.ReferralCodeUsage)
            return object;
        let message = new $root.ReferralCodeUsage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.referral_code_id != null)
            message.referral_code_id = String(object.referral_code_id);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".ReferralCodeUsage.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".ReferralCodeUsage.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a ReferralCodeUsage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReferralCodeUsage
     * @static
     * @param {ReferralCodeUsage} message ReferralCodeUsage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReferralCodeUsage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.referral_code_id = "";
            object.product_id = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.referral_code_id != null && message.hasOwnProperty("referral_code_id"))
            object.referral_code_id = message.referral_code_id;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this ReferralCodeUsage to JSON.
     * @function toJSON
     * @memberof ReferralCodeUsage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReferralCodeUsage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReferralCodeUsage;
})();

export const FlaggedReferralUsage = $root.FlaggedReferralUsage = (() => {

    /**
     * Properties of a FlaggedReferralUsage.
     * @exports IFlaggedReferralUsage
     * @interface IFlaggedReferralUsage
     * @property {string|null} [id] FlaggedReferralUsage id
     * @property {string|null} [referral_usage_id] FlaggedReferralUsage referral_usage_id
     * @property {string|null} [comment] FlaggedReferralUsage comment
     * @property {FlaggedReferralUsage.Reason.Enum|null} [reason] FlaggedReferralUsage reason
     * @property {FreebieUsageFlagStatus.Enum|null} [status] FlaggedReferralUsage status
     * @property {google.protobuf.ITimestamp|null} [created_at] FlaggedReferralUsage created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] FlaggedReferralUsage last_updated_at
     */

    /**
     * Constructs a new FlaggedReferralUsage.
     * @exports FlaggedReferralUsage
     * @classdesc Represents a FlaggedReferralUsage.
     * @implements IFlaggedReferralUsage
     * @constructor
     * @param {IFlaggedReferralUsage=} [properties] Properties to set
     */
    function FlaggedReferralUsage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FlaggedReferralUsage id.
     * @member {string} id
     * @memberof FlaggedReferralUsage
     * @instance
     */
    FlaggedReferralUsage.prototype.id = "";

    /**
     * FlaggedReferralUsage referral_usage_id.
     * @member {string} referral_usage_id
     * @memberof FlaggedReferralUsage
     * @instance
     */
    FlaggedReferralUsage.prototype.referral_usage_id = "";

    /**
     * FlaggedReferralUsage comment.
     * @member {string} comment
     * @memberof FlaggedReferralUsage
     * @instance
     */
    FlaggedReferralUsage.prototype.comment = "";

    /**
     * FlaggedReferralUsage reason.
     * @member {FlaggedReferralUsage.Reason.Enum} reason
     * @memberof FlaggedReferralUsage
     * @instance
     */
    FlaggedReferralUsage.prototype.reason = 0;

    /**
     * FlaggedReferralUsage status.
     * @member {FreebieUsageFlagStatus.Enum} status
     * @memberof FlaggedReferralUsage
     * @instance
     */
    FlaggedReferralUsage.prototype.status = 0;

    /**
     * FlaggedReferralUsage created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof FlaggedReferralUsage
     * @instance
     */
    FlaggedReferralUsage.prototype.created_at = null;

    /**
     * FlaggedReferralUsage last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof FlaggedReferralUsage
     * @instance
     */
    FlaggedReferralUsage.prototype.last_updated_at = null;

    /**
     * Creates a new FlaggedReferralUsage instance using the specified properties.
     * @function create
     * @memberof FlaggedReferralUsage
     * @static
     * @param {IFlaggedReferralUsage=} [properties] Properties to set
     * @returns {FlaggedReferralUsage} FlaggedReferralUsage instance
     */
    FlaggedReferralUsage.create = function create(properties) {
        return new FlaggedReferralUsage(properties);
    };

    /**
     * Encodes the specified FlaggedReferralUsage message. Does not implicitly {@link FlaggedReferralUsage.verify|verify} messages.
     * @function encode
     * @memberof FlaggedReferralUsage
     * @static
     * @param {IFlaggedReferralUsage} message FlaggedReferralUsage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FlaggedReferralUsage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.referral_usage_id != null && message.hasOwnProperty("referral_usage_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.referral_usage_id);
        if (message.comment != null && message.hasOwnProperty("comment"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.comment);
        if (message.reason != null && message.hasOwnProperty("reason"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.reason);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.status);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FlaggedReferralUsage message, length delimited. Does not implicitly {@link FlaggedReferralUsage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FlaggedReferralUsage
     * @static
     * @param {IFlaggedReferralUsage} message FlaggedReferralUsage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FlaggedReferralUsage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FlaggedReferralUsage message from the specified reader or buffer.
     * @function decode
     * @memberof FlaggedReferralUsage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FlaggedReferralUsage} FlaggedReferralUsage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FlaggedReferralUsage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FlaggedReferralUsage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.referral_usage_id = reader.string();
                break;
            case 3:
                message.comment = reader.string();
                break;
            case 4:
                message.reason = reader.int32();
                break;
            case 5:
                message.status = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FlaggedReferralUsage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FlaggedReferralUsage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FlaggedReferralUsage} FlaggedReferralUsage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FlaggedReferralUsage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FlaggedReferralUsage message.
     * @function verify
     * @memberof FlaggedReferralUsage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FlaggedReferralUsage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.referral_usage_id != null && message.hasOwnProperty("referral_usage_id"))
            if (!$util.isString(message.referral_usage_id))
                return "referral_usage_id: string expected";
        if (message.comment != null && message.hasOwnProperty("comment"))
            if (!$util.isString(message.comment))
                return "comment: string expected";
        if (message.reason != null && message.hasOwnProperty("reason"))
            switch (message.reason) {
            default:
                return "reason: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a FlaggedReferralUsage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FlaggedReferralUsage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FlaggedReferralUsage} FlaggedReferralUsage
     */
    FlaggedReferralUsage.fromObject = function fromObject(object) {
        if (object instanceof $root.FlaggedReferralUsage)
            return object;
        let message = new $root.FlaggedReferralUsage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.referral_usage_id != null)
            message.referral_usage_id = String(object.referral_usage_id);
        if (object.comment != null)
            message.comment = String(object.comment);
        switch (object.reason) {
        case "UNKNOWN":
        case 0:
            message.reason = 0;
            break;
        case "SAME_BANK_DETAILS":
        case 1:
            message.reason = 1;
            break;
        case "TOO_MANY_REFERRALS":
        case 2:
            message.reason = 2;
            break;
        case "MINIMUM_AMOUNT_DEADLINE_EXPIRED":
        case 3:
            message.reason = 3;
            break;
        case "PROMO_CODE_ALREADY_APPLIED":
        case 4:
            message.reason = 4;
            break;
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "REQUIRES_VERIFICATION":
        case 1:
            message.status = 1;
            break;
        case "MANUALLY_VERIFIED":
        case 2:
            message.status = 2;
            break;
        case "MANUALLY_REJECTED":
        case 3:
            message.status = 3;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".FlaggedReferralUsage.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".FlaggedReferralUsage.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a FlaggedReferralUsage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FlaggedReferralUsage
     * @static
     * @param {FlaggedReferralUsage} message FlaggedReferralUsage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FlaggedReferralUsage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.referral_usage_id = "";
            object.comment = "";
            object.reason = options.enums === String ? "UNKNOWN" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.referral_usage_id != null && message.hasOwnProperty("referral_usage_id"))
            object.referral_usage_id = message.referral_usage_id;
        if (message.comment != null && message.hasOwnProperty("comment"))
            object.comment = message.comment;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = options.enums === String ? $root.FlaggedReferralUsage.Reason.Enum[message.reason] : message.reason;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.FreebieUsageFlagStatus.Enum[message.status] : message.status;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this FlaggedReferralUsage to JSON.
     * @function toJSON
     * @memberof FlaggedReferralUsage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FlaggedReferralUsage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    FlaggedReferralUsage.Reason = (function() {

        /**
         * Properties of a Reason.
         * @memberof FlaggedReferralUsage
         * @interface IReason
         */

        /**
         * Constructs a new Reason.
         * @memberof FlaggedReferralUsage
         * @classdesc Represents a Reason.
         * @implements IReason
         * @constructor
         * @param {FlaggedReferralUsage.IReason=} [properties] Properties to set
         */
        function Reason(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Reason instance using the specified properties.
         * @function create
         * @memberof FlaggedReferralUsage.Reason
         * @static
         * @param {FlaggedReferralUsage.IReason=} [properties] Properties to set
         * @returns {FlaggedReferralUsage.Reason} Reason instance
         */
        Reason.create = function create(properties) {
            return new Reason(properties);
        };

        /**
         * Encodes the specified Reason message. Does not implicitly {@link FlaggedReferralUsage.Reason.verify|verify} messages.
         * @function encode
         * @memberof FlaggedReferralUsage.Reason
         * @static
         * @param {FlaggedReferralUsage.IReason} message Reason message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reason.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Reason message, length delimited. Does not implicitly {@link FlaggedReferralUsage.Reason.verify|verify} messages.
         * @function encodeDelimited
         * @memberof FlaggedReferralUsage.Reason
         * @static
         * @param {FlaggedReferralUsage.IReason} message Reason message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reason.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Reason message from the specified reader or buffer.
         * @function decode
         * @memberof FlaggedReferralUsage.Reason
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {FlaggedReferralUsage.Reason} Reason
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reason.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FlaggedReferralUsage.Reason();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Reason message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof FlaggedReferralUsage.Reason
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {FlaggedReferralUsage.Reason} Reason
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reason.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Reason message.
         * @function verify
         * @memberof FlaggedReferralUsage.Reason
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Reason.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Reason message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof FlaggedReferralUsage.Reason
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {FlaggedReferralUsage.Reason} Reason
         */
        Reason.fromObject = function fromObject(object) {
            if (object instanceof $root.FlaggedReferralUsage.Reason)
                return object;
            return new $root.FlaggedReferralUsage.Reason();
        };

        /**
         * Creates a plain object from a Reason message. Also converts values to other types if specified.
         * @function toObject
         * @memberof FlaggedReferralUsage.Reason
         * @static
         * @param {FlaggedReferralUsage.Reason} message Reason
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Reason.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Reason to JSON.
         * @function toJSON
         * @memberof FlaggedReferralUsage.Reason
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Reason.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name FlaggedReferralUsage.Reason.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} SAME_BANK_DETAILS=1 SAME_BANK_DETAILS value
         * @property {number} TOO_MANY_REFERRALS=2 TOO_MANY_REFERRALS value
         * @property {number} MINIMUM_AMOUNT_DEADLINE_EXPIRED=3 MINIMUM_AMOUNT_DEADLINE_EXPIRED value
         * @property {number} PROMO_CODE_ALREADY_APPLIED=4 PROMO_CODE_ALREADY_APPLIED value
         */
        Reason.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "SAME_BANK_DETAILS"] = 1;
            values[valuesById[2] = "TOO_MANY_REFERRALS"] = 2;
            values[valuesById[3] = "MINIMUM_AMOUNT_DEADLINE_EXPIRED"] = 3;
            values[valuesById[4] = "PROMO_CODE_ALREADY_APPLIED"] = 4;
            return values;
        })();

        return Reason;
    })();

    return FlaggedReferralUsage;
})();

export const PromoCampaign = $root.PromoCampaign = (() => {

    /**
     * Properties of a PromoCampaign.
     * @exports IPromoCampaign
     * @interface IPromoCampaign
     * @property {string|null} [id] PromoCampaign id
     * @property {string|null} [description] PromoCampaign description
     * @property {PromoCampaign.Status.Enum|null} [status] PromoCampaign status
     * @property {string|null} [start_date] PromoCampaign start_date
     * @property {string|null} [end_date] PromoCampaign end_date
     * @property {google.protobuf.ITimestamp|null} [created_at] PromoCampaign created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] PromoCampaign last_updated_at
     */

    /**
     * Constructs a new PromoCampaign.
     * @exports PromoCampaign
     * @classdesc Represents a PromoCampaign.
     * @implements IPromoCampaign
     * @constructor
     * @param {IPromoCampaign=} [properties] Properties to set
     */
    function PromoCampaign(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PromoCampaign id.
     * @member {string} id
     * @memberof PromoCampaign
     * @instance
     */
    PromoCampaign.prototype.id = "";

    /**
     * PromoCampaign description.
     * @member {string} description
     * @memberof PromoCampaign
     * @instance
     */
    PromoCampaign.prototype.description = "";

    /**
     * PromoCampaign status.
     * @member {PromoCampaign.Status.Enum} status
     * @memberof PromoCampaign
     * @instance
     */
    PromoCampaign.prototype.status = 0;

    /**
     * PromoCampaign start_date.
     * @member {string} start_date
     * @memberof PromoCampaign
     * @instance
     */
    PromoCampaign.prototype.start_date = "";

    /**
     * PromoCampaign end_date.
     * @member {string} end_date
     * @memberof PromoCampaign
     * @instance
     */
    PromoCampaign.prototype.end_date = "";

    /**
     * PromoCampaign created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof PromoCampaign
     * @instance
     */
    PromoCampaign.prototype.created_at = null;

    /**
     * PromoCampaign last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof PromoCampaign
     * @instance
     */
    PromoCampaign.prototype.last_updated_at = null;

    /**
     * Creates a new PromoCampaign instance using the specified properties.
     * @function create
     * @memberof PromoCampaign
     * @static
     * @param {IPromoCampaign=} [properties] Properties to set
     * @returns {PromoCampaign} PromoCampaign instance
     */
    PromoCampaign.create = function create(properties) {
        return new PromoCampaign(properties);
    };

    /**
     * Encodes the specified PromoCampaign message. Does not implicitly {@link PromoCampaign.verify|verify} messages.
     * @function encode
     * @memberof PromoCampaign
     * @static
     * @param {IPromoCampaign} message PromoCampaign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromoCampaign.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.description != null && message.hasOwnProperty("description"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.start_date);
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.end_date);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PromoCampaign message, length delimited. Does not implicitly {@link PromoCampaign.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PromoCampaign
     * @static
     * @param {IPromoCampaign} message PromoCampaign message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromoCampaign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PromoCampaign message from the specified reader or buffer.
     * @function decode
     * @memberof PromoCampaign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PromoCampaign} PromoCampaign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromoCampaign.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PromoCampaign();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.description = reader.string();
                break;
            case 3:
                message.status = reader.int32();
                break;
            case 4:
                message.start_date = reader.string();
                break;
            case 5:
                message.end_date = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PromoCampaign message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PromoCampaign
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PromoCampaign} PromoCampaign
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromoCampaign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PromoCampaign message.
     * @function verify
     * @memberof PromoCampaign
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PromoCampaign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            if (!$util.isString(message.start_date))
                return "start_date: string expected";
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            if (!$util.isString(message.end_date))
                return "end_date: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a PromoCampaign message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PromoCampaign
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PromoCampaign} PromoCampaign
     */
    PromoCampaign.fromObject = function fromObject(object) {
        if (object instanceof $root.PromoCampaign)
            return object;
        let message = new $root.PromoCampaign();
        if (object.id != null)
            message.id = String(object.id);
        if (object.description != null)
            message.description = String(object.description);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ACTIVE":
        case 1:
            message.status = 1;
            break;
        case "INACTIVE":
        case 2:
            message.status = 2;
            break;
        case "LEGACY":
        case 3:
            message.status = 3;
            break;
        }
        if (object.start_date != null)
            message.start_date = String(object.start_date);
        if (object.end_date != null)
            message.end_date = String(object.end_date);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".PromoCampaign.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".PromoCampaign.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a PromoCampaign message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PromoCampaign
     * @static
     * @param {PromoCampaign} message PromoCampaign
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PromoCampaign.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.description = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.start_date = "";
            object.end_date = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.PromoCampaign.Status.Enum[message.status] : message.status;
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            object.start_date = message.start_date;
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            object.end_date = message.end_date;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this PromoCampaign to JSON.
     * @function toJSON
     * @memberof PromoCampaign
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PromoCampaign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    PromoCampaign.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof PromoCampaign
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof PromoCampaign
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {PromoCampaign.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof PromoCampaign.Status
         * @static
         * @param {PromoCampaign.IStatus=} [properties] Properties to set
         * @returns {PromoCampaign.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link PromoCampaign.Status.verify|verify} messages.
         * @function encode
         * @memberof PromoCampaign.Status
         * @static
         * @param {PromoCampaign.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link PromoCampaign.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof PromoCampaign.Status
         * @static
         * @param {PromoCampaign.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof PromoCampaign.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {PromoCampaign.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PromoCampaign.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof PromoCampaign.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {PromoCampaign.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof PromoCampaign.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof PromoCampaign.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {PromoCampaign.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.PromoCampaign.Status)
                return object;
            return new $root.PromoCampaign.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof PromoCampaign.Status
         * @static
         * @param {PromoCampaign.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof PromoCampaign.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name PromoCampaign.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} ACTIVE=1 ACTIVE value
         * @property {number} INACTIVE=2 INACTIVE value
         * @property {number} LEGACY=3 LEGACY value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "ACTIVE"] = 1;
            values[valuesById[2] = "INACTIVE"] = 2;
            values[valuesById[3] = "LEGACY"] = 3;
            return values;
        })();

        return Status;
    })();

    return PromoCampaign;
})();

export const PromoCode = $root.PromoCode = (() => {

    /**
     * Properties of a PromoCode.
     * @exports IPromoCode
     * @interface IPromoCode
     * @property {string|null} [id] PromoCode id
     * @property {string|null} [promo_code] PromoCode promo_code
     * @property {PromoCode.Status.Enum|null} [status] PromoCode status
     * @property {string|null} [aud_amount] PromoCode aud_amount
     * @property {google.protobuf.ITimestamp|null} [created_at] PromoCode created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] PromoCode last_updated_at
     */

    /**
     * Constructs a new PromoCode.
     * @exports PromoCode
     * @classdesc Represents a PromoCode.
     * @implements IPromoCode
     * @constructor
     * @param {IPromoCode=} [properties] Properties to set
     */
    function PromoCode(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PromoCode id.
     * @member {string} id
     * @memberof PromoCode
     * @instance
     */
    PromoCode.prototype.id = "";

    /**
     * PromoCode promo_code.
     * @member {string} promo_code
     * @memberof PromoCode
     * @instance
     */
    PromoCode.prototype.promo_code = "";

    /**
     * PromoCode status.
     * @member {PromoCode.Status.Enum} status
     * @memberof PromoCode
     * @instance
     */
    PromoCode.prototype.status = 0;

    /**
     * PromoCode aud_amount.
     * @member {string} aud_amount
     * @memberof PromoCode
     * @instance
     */
    PromoCode.prototype.aud_amount = "";

    /**
     * PromoCode created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof PromoCode
     * @instance
     */
    PromoCode.prototype.created_at = null;

    /**
     * PromoCode last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof PromoCode
     * @instance
     */
    PromoCode.prototype.last_updated_at = null;

    /**
     * Creates a new PromoCode instance using the specified properties.
     * @function create
     * @memberof PromoCode
     * @static
     * @param {IPromoCode=} [properties] Properties to set
     * @returns {PromoCode} PromoCode instance
     */
    PromoCode.create = function create(properties) {
        return new PromoCode(properties);
    };

    /**
     * Encodes the specified PromoCode message. Does not implicitly {@link PromoCode.verify|verify} messages.
     * @function encode
     * @memberof PromoCode
     * @static
     * @param {IPromoCode} message PromoCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromoCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.promo_code != null && message.hasOwnProperty("promo_code"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.promo_code);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.aud_amount);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PromoCode message, length delimited. Does not implicitly {@link PromoCode.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PromoCode
     * @static
     * @param {IPromoCode} message PromoCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromoCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PromoCode message from the specified reader or buffer.
     * @function decode
     * @memberof PromoCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PromoCode} PromoCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromoCode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PromoCode();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.promo_code = reader.string();
                break;
            case 3:
                message.status = reader.int32();
                break;
            case 4:
                message.aud_amount = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PromoCode message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PromoCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PromoCode} PromoCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromoCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PromoCode message.
     * @function verify
     * @memberof PromoCode
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PromoCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.promo_code != null && message.hasOwnProperty("promo_code"))
            if (!$util.isString(message.promo_code))
                return "promo_code: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a PromoCode message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PromoCode
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PromoCode} PromoCode
     */
    PromoCode.fromObject = function fromObject(object) {
        if (object instanceof $root.PromoCode)
            return object;
        let message = new $root.PromoCode();
        if (object.id != null)
            message.id = String(object.id);
        if (object.promo_code != null)
            message.promo_code = String(object.promo_code);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ACTIVE":
        case 1:
            message.status = 1;
            break;
        case "INACTIVE":
        case 2:
            message.status = 2;
            break;
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".PromoCode.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".PromoCode.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a PromoCode message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PromoCode
     * @static
     * @param {PromoCode} message PromoCode
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PromoCode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.promo_code = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.aud_amount = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.promo_code != null && message.hasOwnProperty("promo_code"))
            object.promo_code = message.promo_code;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.PromoCode.Status.Enum[message.status] : message.status;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this PromoCode to JSON.
     * @function toJSON
     * @memberof PromoCode
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PromoCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    PromoCode.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof PromoCode
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof PromoCode
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {PromoCode.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof PromoCode.Status
         * @static
         * @param {PromoCode.IStatus=} [properties] Properties to set
         * @returns {PromoCode.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link PromoCode.Status.verify|verify} messages.
         * @function encode
         * @memberof PromoCode.Status
         * @static
         * @param {PromoCode.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link PromoCode.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof PromoCode.Status
         * @static
         * @param {PromoCode.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof PromoCode.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {PromoCode.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PromoCode.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof PromoCode.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {PromoCode.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof PromoCode.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof PromoCode.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {PromoCode.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.PromoCode.Status)
                return object;
            return new $root.PromoCode.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof PromoCode.Status
         * @static
         * @param {PromoCode.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof PromoCode.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name PromoCode.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} ACTIVE=1 ACTIVE value
         * @property {number} INACTIVE=2 INACTIVE value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "ACTIVE"] = 1;
            values[valuesById[2] = "INACTIVE"] = 2;
            return values;
        })();

        return Status;
    })();

    return PromoCode;
})();

export const PromoCodeUsage = $root.PromoCodeUsage = (() => {

    /**
     * Properties of a PromoCodeUsage.
     * @exports IPromoCodeUsage
     * @interface IPromoCodeUsage
     * @property {string|null} [id] PromoCodeUsage id
     * @property {string|null} [promo_code_id] PromoCodeUsage promo_code_id
     * @property {string|null} [product_id] PromoCodeUsage product_id
     * @property {google.protobuf.ITimestamp|null} [created_at] PromoCodeUsage created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] PromoCodeUsage last_updated_at
     */

    /**
     * Constructs a new PromoCodeUsage.
     * @exports PromoCodeUsage
     * @classdesc Represents a PromoCodeUsage.
     * @implements IPromoCodeUsage
     * @constructor
     * @param {IPromoCodeUsage=} [properties] Properties to set
     */
    function PromoCodeUsage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PromoCodeUsage id.
     * @member {string} id
     * @memberof PromoCodeUsage
     * @instance
     */
    PromoCodeUsage.prototype.id = "";

    /**
     * PromoCodeUsage promo_code_id.
     * @member {string} promo_code_id
     * @memberof PromoCodeUsage
     * @instance
     */
    PromoCodeUsage.prototype.promo_code_id = "";

    /**
     * PromoCodeUsage product_id.
     * @member {string} product_id
     * @memberof PromoCodeUsage
     * @instance
     */
    PromoCodeUsage.prototype.product_id = "";

    /**
     * PromoCodeUsage created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof PromoCodeUsage
     * @instance
     */
    PromoCodeUsage.prototype.created_at = null;

    /**
     * PromoCodeUsage last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof PromoCodeUsage
     * @instance
     */
    PromoCodeUsage.prototype.last_updated_at = null;

    /**
     * Creates a new PromoCodeUsage instance using the specified properties.
     * @function create
     * @memberof PromoCodeUsage
     * @static
     * @param {IPromoCodeUsage=} [properties] Properties to set
     * @returns {PromoCodeUsage} PromoCodeUsage instance
     */
    PromoCodeUsage.create = function create(properties) {
        return new PromoCodeUsage(properties);
    };

    /**
     * Encodes the specified PromoCodeUsage message. Does not implicitly {@link PromoCodeUsage.verify|verify} messages.
     * @function encode
     * @memberof PromoCodeUsage
     * @static
     * @param {IPromoCodeUsage} message PromoCodeUsage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromoCodeUsage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.promo_code_id != null && message.hasOwnProperty("promo_code_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.promo_code_id);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.product_id);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PromoCodeUsage message, length delimited. Does not implicitly {@link PromoCodeUsage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PromoCodeUsage
     * @static
     * @param {IPromoCodeUsage} message PromoCodeUsage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromoCodeUsage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PromoCodeUsage message from the specified reader or buffer.
     * @function decode
     * @memberof PromoCodeUsage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PromoCodeUsage} PromoCodeUsage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromoCodeUsage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PromoCodeUsage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.promo_code_id = reader.string();
                break;
            case 3:
                message.product_id = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PromoCodeUsage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PromoCodeUsage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PromoCodeUsage} PromoCodeUsage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromoCodeUsage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PromoCodeUsage message.
     * @function verify
     * @memberof PromoCodeUsage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PromoCodeUsage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.promo_code_id != null && message.hasOwnProperty("promo_code_id"))
            if (!$util.isString(message.promo_code_id))
                return "promo_code_id: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a PromoCodeUsage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PromoCodeUsage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PromoCodeUsage} PromoCodeUsage
     */
    PromoCodeUsage.fromObject = function fromObject(object) {
        if (object instanceof $root.PromoCodeUsage)
            return object;
        let message = new $root.PromoCodeUsage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.promo_code_id != null)
            message.promo_code_id = String(object.promo_code_id);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".PromoCodeUsage.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".PromoCodeUsage.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a PromoCodeUsage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PromoCodeUsage
     * @static
     * @param {PromoCodeUsage} message PromoCodeUsage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PromoCodeUsage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.promo_code_id = "";
            object.product_id = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.promo_code_id != null && message.hasOwnProperty("promo_code_id"))
            object.promo_code_id = message.promo_code_id;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this PromoCodeUsage to JSON.
     * @function toJSON
     * @memberof PromoCodeUsage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PromoCodeUsage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PromoCodeUsage;
})();

export const FreebieIssuance = $root.FreebieIssuance = (() => {

    /**
     * Properties of a FreebieIssuance.
     * @exports IFreebieIssuance
     * @interface IFreebieIssuance
     * @property {string|null} [id] FreebieIssuance id
     * @property {FreebieIssuance.Status.Enum|null} [status] FreebieIssuance status
     * @property {string|null} [referral_code_usage_id] FreebieIssuance referral_code_usage_id
     * @property {string|null} [promo_code_usage_id] FreebieIssuance promo_code_usage_id
     * @property {string|null} [product_id] FreebieIssuance product_id
     * @property {FreebieIssuance.EmailStatus.Enum|null} [email_status] FreebieIssuance email_status
     * @property {google.protobuf.ITimestamp|null} [created_at] FreebieIssuance created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] FreebieIssuance last_updated_at
     */

    /**
     * Constructs a new FreebieIssuance.
     * @exports FreebieIssuance
     * @classdesc Represents a FreebieIssuance.
     * @implements IFreebieIssuance
     * @constructor
     * @param {IFreebieIssuance=} [properties] Properties to set
     */
    function FreebieIssuance(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FreebieIssuance id.
     * @member {string} id
     * @memberof FreebieIssuance
     * @instance
     */
    FreebieIssuance.prototype.id = "";

    /**
     * FreebieIssuance status.
     * @member {FreebieIssuance.Status.Enum} status
     * @memberof FreebieIssuance
     * @instance
     */
    FreebieIssuance.prototype.status = 0;

    /**
     * FreebieIssuance referral_code_usage_id.
     * @member {string} referral_code_usage_id
     * @memberof FreebieIssuance
     * @instance
     */
    FreebieIssuance.prototype.referral_code_usage_id = "";

    /**
     * FreebieIssuance promo_code_usage_id.
     * @member {string} promo_code_usage_id
     * @memberof FreebieIssuance
     * @instance
     */
    FreebieIssuance.prototype.promo_code_usage_id = "";

    /**
     * FreebieIssuance product_id.
     * @member {string} product_id
     * @memberof FreebieIssuance
     * @instance
     */
    FreebieIssuance.prototype.product_id = "";

    /**
     * FreebieIssuance email_status.
     * @member {FreebieIssuance.EmailStatus.Enum} email_status
     * @memberof FreebieIssuance
     * @instance
     */
    FreebieIssuance.prototype.email_status = 0;

    /**
     * FreebieIssuance created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof FreebieIssuance
     * @instance
     */
    FreebieIssuance.prototype.created_at = null;

    /**
     * FreebieIssuance last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof FreebieIssuance
     * @instance
     */
    FreebieIssuance.prototype.last_updated_at = null;

    /**
     * Creates a new FreebieIssuance instance using the specified properties.
     * @function create
     * @memberof FreebieIssuance
     * @static
     * @param {IFreebieIssuance=} [properties] Properties to set
     * @returns {FreebieIssuance} FreebieIssuance instance
     */
    FreebieIssuance.create = function create(properties) {
        return new FreebieIssuance(properties);
    };

    /**
     * Encodes the specified FreebieIssuance message. Does not implicitly {@link FreebieIssuance.verify|verify} messages.
     * @function encode
     * @memberof FreebieIssuance
     * @static
     * @param {IFreebieIssuance} message FreebieIssuance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreebieIssuance.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
        if (message.referral_code_usage_id != null && message.hasOwnProperty("referral_code_usage_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.referral_code_usage_id);
        if (message.promo_code_usage_id != null && message.hasOwnProperty("promo_code_usage_id"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.promo_code_usage_id);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.product_id);
        if (message.email_status != null && message.hasOwnProperty("email_status"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.email_status);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FreebieIssuance message, length delimited. Does not implicitly {@link FreebieIssuance.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FreebieIssuance
     * @static
     * @param {IFreebieIssuance} message FreebieIssuance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreebieIssuance.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FreebieIssuance message from the specified reader or buffer.
     * @function decode
     * @memberof FreebieIssuance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FreebieIssuance} FreebieIssuance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreebieIssuance.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FreebieIssuance();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.status = reader.int32();
                break;
            case 3:
                message.referral_code_usage_id = reader.string();
                break;
            case 4:
                message.promo_code_usage_id = reader.string();
                break;
            case 5:
                message.product_id = reader.string();
                break;
            case 6:
                message.email_status = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FreebieIssuance message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FreebieIssuance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FreebieIssuance} FreebieIssuance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreebieIssuance.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FreebieIssuance message.
     * @function verify
     * @memberof FreebieIssuance
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FreebieIssuance.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.referral_code_usage_id != null && message.hasOwnProperty("referral_code_usage_id"))
            if (!$util.isString(message.referral_code_usage_id))
                return "referral_code_usage_id: string expected";
        if (message.promo_code_usage_id != null && message.hasOwnProperty("promo_code_usage_id"))
            if (!$util.isString(message.promo_code_usage_id))
                return "promo_code_usage_id: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.email_status != null && message.hasOwnProperty("email_status"))
            switch (message.email_status) {
            default:
                return "email_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a FreebieIssuance message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FreebieIssuance
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FreebieIssuance} FreebieIssuance
     */
    FreebieIssuance.fromObject = function fromObject(object) {
        if (object instanceof $root.FreebieIssuance)
            return object;
        let message = new $root.FreebieIssuance();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "UNPROCESSED":
        case 1:
            message.status = 1;
            break;
        case "PROCESSED":
        case 2:
            message.status = 2;
            break;
        }
        if (object.referral_code_usage_id != null)
            message.referral_code_usage_id = String(object.referral_code_usage_id);
        if (object.promo_code_usage_id != null)
            message.promo_code_usage_id = String(object.promo_code_usage_id);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        switch (object.email_status) {
        case "UNKNOWN":
        case 0:
            message.email_status = 0;
            break;
        case "PENDING":
        case 1:
            message.email_status = 1;
            break;
        case "WONT_SEND":
        case 2:
            message.email_status = 2;
            break;
        case "READY_TO_SEND":
        case 3:
            message.email_status = 3;
            break;
        case "SENT":
        case 4:
            message.email_status = 4;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".FreebieIssuance.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".FreebieIssuance.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a FreebieIssuance message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FreebieIssuance
     * @static
     * @param {FreebieIssuance} message FreebieIssuance
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FreebieIssuance.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.referral_code_usage_id = "";
            object.promo_code_usage_id = "";
            object.product_id = "";
            object.email_status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.FreebieIssuance.Status.Enum[message.status] : message.status;
        if (message.referral_code_usage_id != null && message.hasOwnProperty("referral_code_usage_id"))
            object.referral_code_usage_id = message.referral_code_usage_id;
        if (message.promo_code_usage_id != null && message.hasOwnProperty("promo_code_usage_id"))
            object.promo_code_usage_id = message.promo_code_usage_id;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.email_status != null && message.hasOwnProperty("email_status"))
            object.email_status = options.enums === String ? $root.FreebieIssuance.EmailStatus.Enum[message.email_status] : message.email_status;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this FreebieIssuance to JSON.
     * @function toJSON
     * @memberof FreebieIssuance
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FreebieIssuance.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    FreebieIssuance.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof FreebieIssuance
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof FreebieIssuance
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {FreebieIssuance.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof FreebieIssuance.Status
         * @static
         * @param {FreebieIssuance.IStatus=} [properties] Properties to set
         * @returns {FreebieIssuance.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link FreebieIssuance.Status.verify|verify} messages.
         * @function encode
         * @memberof FreebieIssuance.Status
         * @static
         * @param {FreebieIssuance.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link FreebieIssuance.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof FreebieIssuance.Status
         * @static
         * @param {FreebieIssuance.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof FreebieIssuance.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {FreebieIssuance.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FreebieIssuance.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof FreebieIssuance.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {FreebieIssuance.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof FreebieIssuance.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof FreebieIssuance.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {FreebieIssuance.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.FreebieIssuance.Status)
                return object;
            return new $root.FreebieIssuance.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof FreebieIssuance.Status
         * @static
         * @param {FreebieIssuance.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof FreebieIssuance.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name FreebieIssuance.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} UNPROCESSED=1 UNPROCESSED value
         * @property {number} PROCESSED=2 PROCESSED value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "UNPROCESSED"] = 1;
            values[valuesById[2] = "PROCESSED"] = 2;
            return values;
        })();

        return Status;
    })();

    FreebieIssuance.EmailStatus = (function() {

        /**
         * Properties of an EmailStatus.
         * @memberof FreebieIssuance
         * @interface IEmailStatus
         */

        /**
         * Constructs a new EmailStatus.
         * @memberof FreebieIssuance
         * @classdesc Represents an EmailStatus.
         * @implements IEmailStatus
         * @constructor
         * @param {FreebieIssuance.IEmailStatus=} [properties] Properties to set
         */
        function EmailStatus(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new EmailStatus instance using the specified properties.
         * @function create
         * @memberof FreebieIssuance.EmailStatus
         * @static
         * @param {FreebieIssuance.IEmailStatus=} [properties] Properties to set
         * @returns {FreebieIssuance.EmailStatus} EmailStatus instance
         */
        EmailStatus.create = function create(properties) {
            return new EmailStatus(properties);
        };

        /**
         * Encodes the specified EmailStatus message. Does not implicitly {@link FreebieIssuance.EmailStatus.verify|verify} messages.
         * @function encode
         * @memberof FreebieIssuance.EmailStatus
         * @static
         * @param {FreebieIssuance.IEmailStatus} message EmailStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EmailStatus.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified EmailStatus message, length delimited. Does not implicitly {@link FreebieIssuance.EmailStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof FreebieIssuance.EmailStatus
         * @static
         * @param {FreebieIssuance.IEmailStatus} message EmailStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EmailStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EmailStatus message from the specified reader or buffer.
         * @function decode
         * @memberof FreebieIssuance.EmailStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {FreebieIssuance.EmailStatus} EmailStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EmailStatus.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FreebieIssuance.EmailStatus();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EmailStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof FreebieIssuance.EmailStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {FreebieIssuance.EmailStatus} EmailStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EmailStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EmailStatus message.
         * @function verify
         * @memberof FreebieIssuance.EmailStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EmailStatus.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an EmailStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof FreebieIssuance.EmailStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {FreebieIssuance.EmailStatus} EmailStatus
         */
        EmailStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.FreebieIssuance.EmailStatus)
                return object;
            return new $root.FreebieIssuance.EmailStatus();
        };

        /**
         * Creates a plain object from an EmailStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof FreebieIssuance.EmailStatus
         * @static
         * @param {FreebieIssuance.EmailStatus} message EmailStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EmailStatus.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this EmailStatus to JSON.
         * @function toJSON
         * @memberof FreebieIssuance.EmailStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EmailStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name FreebieIssuance.EmailStatus.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} PENDING=1 PENDING value
         * @property {number} WONT_SEND=2 WONT_SEND value
         * @property {number} READY_TO_SEND=3 READY_TO_SEND value
         * @property {number} SENT=4 SENT value
         */
        EmailStatus.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "PENDING"] = 1;
            values[valuesById[2] = "WONT_SEND"] = 2;
            values[valuesById[3] = "READY_TO_SEND"] = 3;
            values[valuesById[4] = "SENT"] = 4;
            return values;
        })();

        return EmailStatus;
    })();

    return FreebieIssuance;
})();

export const SuspenseTransactionWithMetadata = $root.SuspenseTransactionWithMetadata = (() => {

    /**
     * Properties of a SuspenseTransactionWithMetadata.
     * @exports ISuspenseTransactionWithMetadata
     * @interface ISuspenseTransactionWithMetadata
     * @property {ISuspenseTransaction|null} [suspense_transaction] SuspenseTransactionWithMetadata suspense_transaction
     * @property {SuspenseTransactionWithMetadata.IMetadata|null} [metadata] SuspenseTransactionWithMetadata metadata
     */

    /**
     * Constructs a new SuspenseTransactionWithMetadata.
     * @exports SuspenseTransactionWithMetadata
     * @classdesc Represents a SuspenseTransactionWithMetadata.
     * @implements ISuspenseTransactionWithMetadata
     * @constructor
     * @param {ISuspenseTransactionWithMetadata=} [properties] Properties to set
     */
    function SuspenseTransactionWithMetadata(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuspenseTransactionWithMetadata suspense_transaction.
     * @member {ISuspenseTransaction|null|undefined} suspense_transaction
     * @memberof SuspenseTransactionWithMetadata
     * @instance
     */
    SuspenseTransactionWithMetadata.prototype.suspense_transaction = null;

    /**
     * SuspenseTransactionWithMetadata metadata.
     * @member {SuspenseTransactionWithMetadata.IMetadata|null|undefined} metadata
     * @memberof SuspenseTransactionWithMetadata
     * @instance
     */
    SuspenseTransactionWithMetadata.prototype.metadata = null;

    /**
     * Creates a new SuspenseTransactionWithMetadata instance using the specified properties.
     * @function create
     * @memberof SuspenseTransactionWithMetadata
     * @static
     * @param {ISuspenseTransactionWithMetadata=} [properties] Properties to set
     * @returns {SuspenseTransactionWithMetadata} SuspenseTransactionWithMetadata instance
     */
    SuspenseTransactionWithMetadata.create = function create(properties) {
        return new SuspenseTransactionWithMetadata(properties);
    };

    /**
     * Encodes the specified SuspenseTransactionWithMetadata message. Does not implicitly {@link SuspenseTransactionWithMetadata.verify|verify} messages.
     * @function encode
     * @memberof SuspenseTransactionWithMetadata
     * @static
     * @param {ISuspenseTransactionWithMetadata} message SuspenseTransactionWithMetadata message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuspenseTransactionWithMetadata.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction"))
            $root.SuspenseTransaction.encode(message.suspense_transaction, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.metadata != null && message.hasOwnProperty("metadata"))
            $root.SuspenseTransactionWithMetadata.Metadata.encode(message.metadata, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SuspenseTransactionWithMetadata message, length delimited. Does not implicitly {@link SuspenseTransactionWithMetadata.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuspenseTransactionWithMetadata
     * @static
     * @param {ISuspenseTransactionWithMetadata} message SuspenseTransactionWithMetadata message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuspenseTransactionWithMetadata.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuspenseTransactionWithMetadata message from the specified reader or buffer.
     * @function decode
     * @memberof SuspenseTransactionWithMetadata
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuspenseTransactionWithMetadata} SuspenseTransactionWithMetadata
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuspenseTransactionWithMetadata.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuspenseTransactionWithMetadata();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.suspense_transaction = $root.SuspenseTransaction.decode(reader, reader.uint32());
                break;
            case 2:
                message.metadata = $root.SuspenseTransactionWithMetadata.Metadata.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuspenseTransactionWithMetadata message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuspenseTransactionWithMetadata
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuspenseTransactionWithMetadata} SuspenseTransactionWithMetadata
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuspenseTransactionWithMetadata.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuspenseTransactionWithMetadata message.
     * @function verify
     * @memberof SuspenseTransactionWithMetadata
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuspenseTransactionWithMetadata.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction")) {
            let error = $root.SuspenseTransaction.verify(message.suspense_transaction);
            if (error)
                return "suspense_transaction." + error;
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
            let error = $root.SuspenseTransactionWithMetadata.Metadata.verify(message.metadata);
            if (error)
                return "metadata." + error;
        }
        return null;
    };

    /**
     * Creates a SuspenseTransactionWithMetadata message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuspenseTransactionWithMetadata
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuspenseTransactionWithMetadata} SuspenseTransactionWithMetadata
     */
    SuspenseTransactionWithMetadata.fromObject = function fromObject(object) {
        if (object instanceof $root.SuspenseTransactionWithMetadata)
            return object;
        let message = new $root.SuspenseTransactionWithMetadata();
        if (object.suspense_transaction != null) {
            if (typeof object.suspense_transaction !== "object")
                throw TypeError(".SuspenseTransactionWithMetadata.suspense_transaction: object expected");
            message.suspense_transaction = $root.SuspenseTransaction.fromObject(object.suspense_transaction);
        }
        if (object.metadata != null) {
            if (typeof object.metadata !== "object")
                throw TypeError(".SuspenseTransactionWithMetadata.metadata: object expected");
            message.metadata = $root.SuspenseTransactionWithMetadata.Metadata.fromObject(object.metadata);
        }
        return message;
    };

    /**
     * Creates a plain object from a SuspenseTransactionWithMetadata message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuspenseTransactionWithMetadata
     * @static
     * @param {SuspenseTransactionWithMetadata} message SuspenseTransactionWithMetadata
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuspenseTransactionWithMetadata.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.suspense_transaction = null;
            object.metadata = null;
        }
        if (message.suspense_transaction != null && message.hasOwnProperty("suspense_transaction"))
            object.suspense_transaction = $root.SuspenseTransaction.toObject(message.suspense_transaction, options);
        if (message.metadata != null && message.hasOwnProperty("metadata"))
            object.metadata = $root.SuspenseTransactionWithMetadata.Metadata.toObject(message.metadata, options);
        return object;
    };

    /**
     * Converts this SuspenseTransactionWithMetadata to JSON.
     * @function toJSON
     * @memberof SuspenseTransactionWithMetadata
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuspenseTransactionWithMetadata.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SuspenseTransactionWithMetadata.Metadata = (function() {

        /**
         * Properties of a Metadata.
         * @memberof SuspenseTransactionWithMetadata
         * @interface IMetadata
         * @property {IFundTransaction|null} [fund_transaction] Metadata fund_transaction
         * @property {IBankAccount|null} [bank_account] Metadata bank_account
         * @property {ISaverProductInstance|null} [product_instance] Metadata product_instance
         * @property {IRedemption|null} [redemption] Metadata redemption
         */

        /**
         * Constructs a new Metadata.
         * @memberof SuspenseTransactionWithMetadata
         * @classdesc Represents a Metadata.
         * @implements IMetadata
         * @constructor
         * @param {SuspenseTransactionWithMetadata.IMetadata=} [properties] Properties to set
         */
        function Metadata(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Metadata fund_transaction.
         * @member {IFundTransaction|null|undefined} fund_transaction
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @instance
         */
        Metadata.prototype.fund_transaction = null;

        /**
         * Metadata bank_account.
         * @member {IBankAccount|null|undefined} bank_account
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @instance
         */
        Metadata.prototype.bank_account = null;

        /**
         * Metadata product_instance.
         * @member {ISaverProductInstance|null|undefined} product_instance
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @instance
         */
        Metadata.prototype.product_instance = null;

        /**
         * Metadata redemption.
         * @member {IRedemption|null|undefined} redemption
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @instance
         */
        Metadata.prototype.redemption = null;

        /**
         * Creates a new Metadata instance using the specified properties.
         * @function create
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @static
         * @param {SuspenseTransactionWithMetadata.IMetadata=} [properties] Properties to set
         * @returns {SuspenseTransactionWithMetadata.Metadata} Metadata instance
         */
        Metadata.create = function create(properties) {
            return new Metadata(properties);
        };

        /**
         * Encodes the specified Metadata message. Does not implicitly {@link SuspenseTransactionWithMetadata.Metadata.verify|verify} messages.
         * @function encode
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @static
         * @param {SuspenseTransactionWithMetadata.IMetadata} message Metadata message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Metadata.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fund_transaction != null && message.hasOwnProperty("fund_transaction"))
                $root.FundTransaction.encode(message.fund_transaction, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.bank_account != null && message.hasOwnProperty("bank_account"))
                $root.BankAccount.encode(message.bank_account, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.product_instance != null && message.hasOwnProperty("product_instance"))
                $root.SaverProductInstance.encode(message.product_instance, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.redemption != null && message.hasOwnProperty("redemption"))
                $root.Redemption.encode(message.redemption, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Metadata message, length delimited. Does not implicitly {@link SuspenseTransactionWithMetadata.Metadata.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @static
         * @param {SuspenseTransactionWithMetadata.IMetadata} message Metadata message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Metadata.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Metadata message from the specified reader or buffer.
         * @function decode
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SuspenseTransactionWithMetadata.Metadata} Metadata
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Metadata.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuspenseTransactionWithMetadata.Metadata();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fund_transaction = $root.FundTransaction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.bank_account = $root.BankAccount.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.product_instance = $root.SaverProductInstance.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.redemption = $root.Redemption.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Metadata message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SuspenseTransactionWithMetadata.Metadata} Metadata
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Metadata.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Metadata message.
         * @function verify
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Metadata.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fund_transaction != null && message.hasOwnProperty("fund_transaction")) {
                let error = $root.FundTransaction.verify(message.fund_transaction);
                if (error)
                    return "fund_transaction." + error;
            }
            if (message.bank_account != null && message.hasOwnProperty("bank_account")) {
                let error = $root.BankAccount.verify(message.bank_account);
                if (error)
                    return "bank_account." + error;
            }
            if (message.product_instance != null && message.hasOwnProperty("product_instance")) {
                let error = $root.SaverProductInstance.verify(message.product_instance);
                if (error)
                    return "product_instance." + error;
            }
            if (message.redemption != null && message.hasOwnProperty("redemption")) {
                let error = $root.Redemption.verify(message.redemption);
                if (error)
                    return "redemption." + error;
            }
            return null;
        };

        /**
         * Creates a Metadata message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SuspenseTransactionWithMetadata.Metadata} Metadata
         */
        Metadata.fromObject = function fromObject(object) {
            if (object instanceof $root.SuspenseTransactionWithMetadata.Metadata)
                return object;
            let message = new $root.SuspenseTransactionWithMetadata.Metadata();
            if (object.fund_transaction != null) {
                if (typeof object.fund_transaction !== "object")
                    throw TypeError(".SuspenseTransactionWithMetadata.Metadata.fund_transaction: object expected");
                message.fund_transaction = $root.FundTransaction.fromObject(object.fund_transaction);
            }
            if (object.bank_account != null) {
                if (typeof object.bank_account !== "object")
                    throw TypeError(".SuspenseTransactionWithMetadata.Metadata.bank_account: object expected");
                message.bank_account = $root.BankAccount.fromObject(object.bank_account);
            }
            if (object.product_instance != null) {
                if (typeof object.product_instance !== "object")
                    throw TypeError(".SuspenseTransactionWithMetadata.Metadata.product_instance: object expected");
                message.product_instance = $root.SaverProductInstance.fromObject(object.product_instance);
            }
            if (object.redemption != null) {
                if (typeof object.redemption !== "object")
                    throw TypeError(".SuspenseTransactionWithMetadata.Metadata.redemption: object expected");
                message.redemption = $root.Redemption.fromObject(object.redemption);
            }
            return message;
        };

        /**
         * Creates a plain object from a Metadata message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @static
         * @param {SuspenseTransactionWithMetadata.Metadata} message Metadata
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Metadata.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fund_transaction = null;
                object.bank_account = null;
                object.product_instance = null;
                object.redemption = null;
            }
            if (message.fund_transaction != null && message.hasOwnProperty("fund_transaction"))
                object.fund_transaction = $root.FundTransaction.toObject(message.fund_transaction, options);
            if (message.bank_account != null && message.hasOwnProperty("bank_account"))
                object.bank_account = $root.BankAccount.toObject(message.bank_account, options);
            if (message.product_instance != null && message.hasOwnProperty("product_instance"))
                object.product_instance = $root.SaverProductInstance.toObject(message.product_instance, options);
            if (message.redemption != null && message.hasOwnProperty("redemption"))
                object.redemption = $root.Redemption.toObject(message.redemption, options);
            return object;
        };

        /**
         * Converts this Metadata to JSON.
         * @function toJSON
         * @memberof SuspenseTransactionWithMetadata.Metadata
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Metadata.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Metadata;
    })();

    return SuspenseTransactionWithMetadata;
})();

export const WatchlistType = $root.WatchlistType = (() => {

    /**
     * Properties of a WatchlistType.
     * @exports IWatchlistType
     * @interface IWatchlistType
     */

    /**
     * Constructs a new WatchlistType.
     * @exports WatchlistType
     * @classdesc Represents a WatchlistType.
     * @implements IWatchlistType
     * @constructor
     * @param {IWatchlistType=} [properties] Properties to set
     */
    function WatchlistType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new WatchlistType instance using the specified properties.
     * @function create
     * @memberof WatchlistType
     * @static
     * @param {IWatchlistType=} [properties] Properties to set
     * @returns {WatchlistType} WatchlistType instance
     */
    WatchlistType.create = function create(properties) {
        return new WatchlistType(properties);
    };

    /**
     * Encodes the specified WatchlistType message. Does not implicitly {@link WatchlistType.verify|verify} messages.
     * @function encode
     * @memberof WatchlistType
     * @static
     * @param {IWatchlistType} message WatchlistType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchlistType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified WatchlistType message, length delimited. Does not implicitly {@link WatchlistType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WatchlistType
     * @static
     * @param {IWatchlistType} message WatchlistType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchlistType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WatchlistType message from the specified reader or buffer.
     * @function decode
     * @memberof WatchlistType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WatchlistType} WatchlistType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchlistType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WatchlistType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WatchlistType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WatchlistType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WatchlistType} WatchlistType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchlistType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WatchlistType message.
     * @function verify
     * @memberof WatchlistType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WatchlistType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a WatchlistType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WatchlistType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WatchlistType} WatchlistType
     */
    WatchlistType.fromObject = function fromObject(object) {
        if (object instanceof $root.WatchlistType)
            return object;
        return new $root.WatchlistType();
    };

    /**
     * Creates a plain object from a WatchlistType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WatchlistType
     * @static
     * @param {WatchlistType} message WatchlistType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WatchlistType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this WatchlistType to JSON.
     * @function toJSON
     * @memberof WatchlistType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WatchlistType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name WatchlistType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} BLACK=1 BLACK value
     * @property {number} GREY=2 GREY value
     * @property {number} WHITE=3 WHITE value
     */
    WatchlistType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "BLACK"] = 1;
        values[valuesById[2] = "GREY"] = 2;
        values[valuesById[3] = "WHITE"] = 3;
        return values;
    })();

    return WatchlistType;
})();

export const WatchlistCondition = $root.WatchlistCondition = (() => {

    /**
     * Properties of a WatchlistCondition.
     * @exports IWatchlistCondition
     * @interface IWatchlistCondition
     */

    /**
     * Constructs a new WatchlistCondition.
     * @exports WatchlistCondition
     * @classdesc Represents a WatchlistCondition.
     * @implements IWatchlistCondition
     * @constructor
     * @param {IWatchlistCondition=} [properties] Properties to set
     */
    function WatchlistCondition(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new WatchlistCondition instance using the specified properties.
     * @function create
     * @memberof WatchlistCondition
     * @static
     * @param {IWatchlistCondition=} [properties] Properties to set
     * @returns {WatchlistCondition} WatchlistCondition instance
     */
    WatchlistCondition.create = function create(properties) {
        return new WatchlistCondition(properties);
    };

    /**
     * Encodes the specified WatchlistCondition message. Does not implicitly {@link WatchlistCondition.verify|verify} messages.
     * @function encode
     * @memberof WatchlistCondition
     * @static
     * @param {IWatchlistCondition} message WatchlistCondition message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchlistCondition.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified WatchlistCondition message, length delimited. Does not implicitly {@link WatchlistCondition.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WatchlistCondition
     * @static
     * @param {IWatchlistCondition} message WatchlistCondition message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchlistCondition.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WatchlistCondition message from the specified reader or buffer.
     * @function decode
     * @memberof WatchlistCondition
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WatchlistCondition} WatchlistCondition
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchlistCondition.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WatchlistCondition();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WatchlistCondition message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WatchlistCondition
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WatchlistCondition} WatchlistCondition
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchlistCondition.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WatchlistCondition message.
     * @function verify
     * @memberof WatchlistCondition
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WatchlistCondition.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a WatchlistCondition message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WatchlistCondition
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WatchlistCondition} WatchlistCondition
     */
    WatchlistCondition.fromObject = function fromObject(object) {
        if (object instanceof $root.WatchlistCondition)
            return object;
        return new $root.WatchlistCondition();
    };

    /**
     * Creates a plain object from a WatchlistCondition message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WatchlistCondition
     * @static
     * @param {WatchlistCondition} message WatchlistCondition
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WatchlistCondition.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this WatchlistCondition to JSON.
     * @function toJSON
     * @memberof WatchlistCondition
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WatchlistCondition.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name WatchlistCondition.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} AMOUNT_EQUAL=1 AMOUNT_EQUAL value
     * @property {number} AMOUNT_GREATER_THAN=2 AMOUNT_GREATER_THAN value
     * @property {number} AMOUNT_LESS_THAN=3 AMOUNT_LESS_THAN value
     * @property {number} STRING_CONTAINS=4 STRING_CONTAINS value
     * @property {number} STRING_EQUALS=5 STRING_EQUALS value
     */
    WatchlistCondition.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "AMOUNT_EQUAL"] = 1;
        values[valuesById[2] = "AMOUNT_GREATER_THAN"] = 2;
        values[valuesById[3] = "AMOUNT_LESS_THAN"] = 3;
        values[valuesById[4] = "STRING_CONTAINS"] = 4;
        values[valuesById[5] = "STRING_EQUALS"] = 5;
        return values;
    })();

    return WatchlistCondition;
})();

export const WatchlistSubject = $root.WatchlistSubject = (() => {

    /**
     * Properties of a WatchlistSubject.
     * @exports IWatchlistSubject
     * @interface IWatchlistSubject
     */

    /**
     * Constructs a new WatchlistSubject.
     * @exports WatchlistSubject
     * @classdesc Represents a WatchlistSubject.
     * @implements IWatchlistSubject
     * @constructor
     * @param {IWatchlistSubject=} [properties] Properties to set
     */
    function WatchlistSubject(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new WatchlistSubject instance using the specified properties.
     * @function create
     * @memberof WatchlistSubject
     * @static
     * @param {IWatchlistSubject=} [properties] Properties to set
     * @returns {WatchlistSubject} WatchlistSubject instance
     */
    WatchlistSubject.create = function create(properties) {
        return new WatchlistSubject(properties);
    };

    /**
     * Encodes the specified WatchlistSubject message. Does not implicitly {@link WatchlistSubject.verify|verify} messages.
     * @function encode
     * @memberof WatchlistSubject
     * @static
     * @param {IWatchlistSubject} message WatchlistSubject message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchlistSubject.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified WatchlistSubject message, length delimited. Does not implicitly {@link WatchlistSubject.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WatchlistSubject
     * @static
     * @param {IWatchlistSubject} message WatchlistSubject message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WatchlistSubject.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WatchlistSubject message from the specified reader or buffer.
     * @function decode
     * @memberof WatchlistSubject
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WatchlistSubject} WatchlistSubject
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchlistSubject.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WatchlistSubject();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WatchlistSubject message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WatchlistSubject
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WatchlistSubject} WatchlistSubject
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WatchlistSubject.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WatchlistSubject message.
     * @function verify
     * @memberof WatchlistSubject
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WatchlistSubject.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a WatchlistSubject message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WatchlistSubject
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WatchlistSubject} WatchlistSubject
     */
    WatchlistSubject.fromObject = function fromObject(object) {
        if (object instanceof $root.WatchlistSubject)
            return object;
        return new $root.WatchlistSubject();
    };

    /**
     * Creates a plain object from a WatchlistSubject message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WatchlistSubject
     * @static
     * @param {WatchlistSubject} message WatchlistSubject
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WatchlistSubject.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this WatchlistSubject to JSON.
     * @function toJSON
     * @memberof WatchlistSubject
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WatchlistSubject.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name WatchlistSubject.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} USER_ACCOUNT_NAME=1 USER_ACCOUNT_NAME value
     * @property {number} BANK_ACCOUNT_NAME=2 BANK_ACCOUNT_NAME value
     * @property {number} BANK_ACCOUNT_NUMBER=3 BANK_ACCOUNT_NUMBER value
     * @property {number} BANK_ACCOUNT_COUNT=4 BANK_ACCOUNT_COUNT value
     * @property {number} BANK_ACCOUNT_POPULARITY_COUNT=5 BANK_ACCOUNT_POPULARITY_COUNT value
     * @property {number} SUSPENSE_INGRESS_AMOUNT=6 SUSPENSE_INGRESS_AMOUNT value
     * @property {number} SUSPENSE_INGRESS_COUNT=7 SUSPENSE_INGRESS_COUNT value
     * @property {number} SUSPENSE_INGRESS_SUM=8 SUSPENSE_INGRESS_SUM value
     * @property {number} SUSPENSE_EGRESS_AMOUNT=9 SUSPENSE_EGRESS_AMOUNT value
     * @property {number} SUSPENSE_EGRESS_COUNT=10 SUSPENSE_EGRESS_COUNT value
     * @property {number} SUSPENSE_EGRESS_SUM=11 SUSPENSE_EGRESS_SUM value
     */
    WatchlistSubject.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "USER_ACCOUNT_NAME"] = 1;
        values[valuesById[2] = "BANK_ACCOUNT_NAME"] = 2;
        values[valuesById[3] = "BANK_ACCOUNT_NUMBER"] = 3;
        values[valuesById[4] = "BANK_ACCOUNT_COUNT"] = 4;
        values[valuesById[5] = "BANK_ACCOUNT_POPULARITY_COUNT"] = 5;
        values[valuesById[6] = "SUSPENSE_INGRESS_AMOUNT"] = 6;
        values[valuesById[7] = "SUSPENSE_INGRESS_COUNT"] = 7;
        values[valuesById[8] = "SUSPENSE_INGRESS_SUM"] = 8;
        values[valuesById[9] = "SUSPENSE_EGRESS_AMOUNT"] = 9;
        values[valuesById[10] = "SUSPENSE_EGRESS_COUNT"] = 10;
        values[valuesById[11] = "SUSPENSE_EGRESS_SUM"] = 11;
        return values;
    })();

    return WatchlistSubject;
})();

export const NumericWatchlistItem = $root.NumericWatchlistItem = (() => {

    /**
     * Properties of a NumericWatchlistItem.
     * @exports INumericWatchlistItem
     * @interface INumericWatchlistItem
     * @property {string|null} [id] NumericWatchlistItem id
     * @property {string|null} [created_by_admin_id] NumericWatchlistItem created_by_admin_id
     * @property {string|null} [description] NumericWatchlistItem description
     * @property {WatchlistSubject.Enum|null} [subject] NumericWatchlistItem subject
     * @property {WatchlistCondition.Enum|null} [condition] NumericWatchlistItem condition
     * @property {string|null} [value] NumericWatchlistItem value
     * @property {boolean|null} [active] NumericWatchlistItem active
     * @property {WatchlistType.Enum|null} [type] NumericWatchlistItem type
     * @property {number|null} [timeframe_in_days] NumericWatchlistItem timeframe_in_days
     * @property {google.protobuf.ITimestamp|null} [created_at] NumericWatchlistItem created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] NumericWatchlistItem last_updated_at
     */

    /**
     * Constructs a new NumericWatchlistItem.
     * @exports NumericWatchlistItem
     * @classdesc Represents a NumericWatchlistItem.
     * @implements INumericWatchlistItem
     * @constructor
     * @param {INumericWatchlistItem=} [properties] Properties to set
     */
    function NumericWatchlistItem(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NumericWatchlistItem id.
     * @member {string} id
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.id = "";

    /**
     * NumericWatchlistItem created_by_admin_id.
     * @member {string} created_by_admin_id
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.created_by_admin_id = "";

    /**
     * NumericWatchlistItem description.
     * @member {string} description
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.description = "";

    /**
     * NumericWatchlistItem subject.
     * @member {WatchlistSubject.Enum} subject
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.subject = 0;

    /**
     * NumericWatchlistItem condition.
     * @member {WatchlistCondition.Enum} condition
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.condition = 0;

    /**
     * NumericWatchlistItem value.
     * @member {string} value
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.value = "";

    /**
     * NumericWatchlistItem active.
     * @member {boolean} active
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.active = false;

    /**
     * NumericWatchlistItem type.
     * @member {WatchlistType.Enum} type
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.type = 0;

    /**
     * NumericWatchlistItem timeframe_in_days.
     * @member {number} timeframe_in_days
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.timeframe_in_days = 0;

    /**
     * NumericWatchlistItem created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.created_at = null;

    /**
     * NumericWatchlistItem last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof NumericWatchlistItem
     * @instance
     */
    NumericWatchlistItem.prototype.last_updated_at = null;

    /**
     * Creates a new NumericWatchlistItem instance using the specified properties.
     * @function create
     * @memberof NumericWatchlistItem
     * @static
     * @param {INumericWatchlistItem=} [properties] Properties to set
     * @returns {NumericWatchlistItem} NumericWatchlistItem instance
     */
    NumericWatchlistItem.create = function create(properties) {
        return new NumericWatchlistItem(properties);
    };

    /**
     * Encodes the specified NumericWatchlistItem message. Does not implicitly {@link NumericWatchlistItem.verify|verify} messages.
     * @function encode
     * @memberof NumericWatchlistItem
     * @static
     * @param {INumericWatchlistItem} message NumericWatchlistItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NumericWatchlistItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.created_by_admin_id);
        if (message.description != null && message.hasOwnProperty("description"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
        if (message.subject != null && message.hasOwnProperty("subject"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.subject);
        if (message.condition != null && message.hasOwnProperty("condition"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.condition);
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.value);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.active);
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.type);
        if (message.timeframe_in_days != null && message.hasOwnProperty("timeframe_in_days"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.timeframe_in_days);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified NumericWatchlistItem message, length delimited. Does not implicitly {@link NumericWatchlistItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NumericWatchlistItem
     * @static
     * @param {INumericWatchlistItem} message NumericWatchlistItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NumericWatchlistItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NumericWatchlistItem message from the specified reader or buffer.
     * @function decode
     * @memberof NumericWatchlistItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NumericWatchlistItem} NumericWatchlistItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NumericWatchlistItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.NumericWatchlistItem();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.created_by_admin_id = reader.string();
                break;
            case 3:
                message.description = reader.string();
                break;
            case 4:
                message.subject = reader.int32();
                break;
            case 5:
                message.condition = reader.int32();
                break;
            case 6:
                message.value = reader.string();
                break;
            case 7:
                message.active = reader.bool();
                break;
            case 8:
                message.type = reader.int32();
                break;
            case 9:
                message.timeframe_in_days = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NumericWatchlistItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NumericWatchlistItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NumericWatchlistItem} NumericWatchlistItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NumericWatchlistItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NumericWatchlistItem message.
     * @function verify
     * @memberof NumericWatchlistItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NumericWatchlistItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            if (!$util.isString(message.created_by_admin_id))
                return "created_by_admin_id: string expected";
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.subject != null && message.hasOwnProperty("subject"))
            switch (message.subject) {
            default:
                return "subject: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.condition != null && message.hasOwnProperty("condition"))
            switch (message.condition) {
            default:
                return "condition: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isString(message.value))
                return "value: string expected";
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.timeframe_in_days != null && message.hasOwnProperty("timeframe_in_days"))
            if (!$util.isInteger(message.timeframe_in_days))
                return "timeframe_in_days: integer expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a NumericWatchlistItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NumericWatchlistItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NumericWatchlistItem} NumericWatchlistItem
     */
    NumericWatchlistItem.fromObject = function fromObject(object) {
        if (object instanceof $root.NumericWatchlistItem)
            return object;
        let message = new $root.NumericWatchlistItem();
        if (object.id != null)
            message.id = String(object.id);
        if (object.created_by_admin_id != null)
            message.created_by_admin_id = String(object.created_by_admin_id);
        if (object.description != null)
            message.description = String(object.description);
        switch (object.subject) {
        case "UNKNOWN":
        case 0:
            message.subject = 0;
            break;
        case "USER_ACCOUNT_NAME":
        case 1:
            message.subject = 1;
            break;
        case "BANK_ACCOUNT_NAME":
        case 2:
            message.subject = 2;
            break;
        case "BANK_ACCOUNT_NUMBER":
        case 3:
            message.subject = 3;
            break;
        case "BANK_ACCOUNT_COUNT":
        case 4:
            message.subject = 4;
            break;
        case "BANK_ACCOUNT_POPULARITY_COUNT":
        case 5:
            message.subject = 5;
            break;
        case "SUSPENSE_INGRESS_AMOUNT":
        case 6:
            message.subject = 6;
            break;
        case "SUSPENSE_INGRESS_COUNT":
        case 7:
            message.subject = 7;
            break;
        case "SUSPENSE_INGRESS_SUM":
        case 8:
            message.subject = 8;
            break;
        case "SUSPENSE_EGRESS_AMOUNT":
        case 9:
            message.subject = 9;
            break;
        case "SUSPENSE_EGRESS_COUNT":
        case 10:
            message.subject = 10;
            break;
        case "SUSPENSE_EGRESS_SUM":
        case 11:
            message.subject = 11;
            break;
        }
        switch (object.condition) {
        case "UNKNOWN":
        case 0:
            message.condition = 0;
            break;
        case "AMOUNT_EQUAL":
        case 1:
            message.condition = 1;
            break;
        case "AMOUNT_GREATER_THAN":
        case 2:
            message.condition = 2;
            break;
        case "AMOUNT_LESS_THAN":
        case 3:
            message.condition = 3;
            break;
        case "STRING_CONTAINS":
        case 4:
            message.condition = 4;
            break;
        case "STRING_EQUALS":
        case 5:
            message.condition = 5;
            break;
        }
        if (object.value != null)
            message.value = String(object.value);
        if (object.active != null)
            message.active = Boolean(object.active);
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "BLACK":
        case 1:
            message.type = 1;
            break;
        case "GREY":
        case 2:
            message.type = 2;
            break;
        case "WHITE":
        case 3:
            message.type = 3;
            break;
        }
        if (object.timeframe_in_days != null)
            message.timeframe_in_days = object.timeframe_in_days | 0;
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".NumericWatchlistItem.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".NumericWatchlistItem.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a NumericWatchlistItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NumericWatchlistItem
     * @static
     * @param {NumericWatchlistItem} message NumericWatchlistItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NumericWatchlistItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.created_by_admin_id = "";
            object.description = "";
            object.subject = options.enums === String ? "UNKNOWN" : 0;
            object.condition = options.enums === String ? "UNKNOWN" : 0;
            object.value = "";
            object.active = false;
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.timeframe_in_days = 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            object.created_by_admin_id = message.created_by_admin_id;
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.subject != null && message.hasOwnProperty("subject"))
            object.subject = options.enums === String ? $root.WatchlistSubject.Enum[message.subject] : message.subject;
        if (message.condition != null && message.hasOwnProperty("condition"))
            object.condition = options.enums === String ? $root.WatchlistCondition.Enum[message.condition] : message.condition;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.WatchlistType.Enum[message.type] : message.type;
        if (message.timeframe_in_days != null && message.hasOwnProperty("timeframe_in_days"))
            object.timeframe_in_days = message.timeframe_in_days;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this NumericWatchlistItem to JSON.
     * @function toJSON
     * @memberof NumericWatchlistItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NumericWatchlistItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NumericWatchlistItem;
})();

export const StringWatchlistItem = $root.StringWatchlistItem = (() => {

    /**
     * Properties of a StringWatchlistItem.
     * @exports IStringWatchlistItem
     * @interface IStringWatchlistItem
     * @property {string|null} [id] StringWatchlistItem id
     * @property {string|null} [created_by_admin_id] StringWatchlistItem created_by_admin_id
     * @property {string|null} [description] StringWatchlistItem description
     * @property {WatchlistSubject.Enum|null} [subject] StringWatchlistItem subject
     * @property {WatchlistCondition.Enum|null} [condition] StringWatchlistItem condition
     * @property {string|null} [value] StringWatchlistItem value
     * @property {boolean|null} [active] StringWatchlistItem active
     * @property {WatchlistType.Enum|null} [type] StringWatchlistItem type
     * @property {google.protobuf.ITimestamp|null} [created_at] StringWatchlistItem created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] StringWatchlistItem last_updated_at
     */

    /**
     * Constructs a new StringWatchlistItem.
     * @exports StringWatchlistItem
     * @classdesc Represents a StringWatchlistItem.
     * @implements IStringWatchlistItem
     * @constructor
     * @param {IStringWatchlistItem=} [properties] Properties to set
     */
    function StringWatchlistItem(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * StringWatchlistItem id.
     * @member {string} id
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.id = "";

    /**
     * StringWatchlistItem created_by_admin_id.
     * @member {string} created_by_admin_id
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.created_by_admin_id = "";

    /**
     * StringWatchlistItem description.
     * @member {string} description
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.description = "";

    /**
     * StringWatchlistItem subject.
     * @member {WatchlistSubject.Enum} subject
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.subject = 0;

    /**
     * StringWatchlistItem condition.
     * @member {WatchlistCondition.Enum} condition
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.condition = 0;

    /**
     * StringWatchlistItem value.
     * @member {string} value
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.value = "";

    /**
     * StringWatchlistItem active.
     * @member {boolean} active
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.active = false;

    /**
     * StringWatchlistItem type.
     * @member {WatchlistType.Enum} type
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.type = 0;

    /**
     * StringWatchlistItem created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.created_at = null;

    /**
     * StringWatchlistItem last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof StringWatchlistItem
     * @instance
     */
    StringWatchlistItem.prototype.last_updated_at = null;

    /**
     * Creates a new StringWatchlistItem instance using the specified properties.
     * @function create
     * @memberof StringWatchlistItem
     * @static
     * @param {IStringWatchlistItem=} [properties] Properties to set
     * @returns {StringWatchlistItem} StringWatchlistItem instance
     */
    StringWatchlistItem.create = function create(properties) {
        return new StringWatchlistItem(properties);
    };

    /**
     * Encodes the specified StringWatchlistItem message. Does not implicitly {@link StringWatchlistItem.verify|verify} messages.
     * @function encode
     * @memberof StringWatchlistItem
     * @static
     * @param {IStringWatchlistItem} message StringWatchlistItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StringWatchlistItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.created_by_admin_id);
        if (message.description != null && message.hasOwnProperty("description"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
        if (message.subject != null && message.hasOwnProperty("subject"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.subject);
        if (message.condition != null && message.hasOwnProperty("condition"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.condition);
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.value);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.active);
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.type);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified StringWatchlistItem message, length delimited. Does not implicitly {@link StringWatchlistItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StringWatchlistItem
     * @static
     * @param {IStringWatchlistItem} message StringWatchlistItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StringWatchlistItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StringWatchlistItem message from the specified reader or buffer.
     * @function decode
     * @memberof StringWatchlistItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StringWatchlistItem} StringWatchlistItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StringWatchlistItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StringWatchlistItem();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.created_by_admin_id = reader.string();
                break;
            case 3:
                message.description = reader.string();
                break;
            case 4:
                message.subject = reader.int32();
                break;
            case 5:
                message.condition = reader.int32();
                break;
            case 6:
                message.value = reader.string();
                break;
            case 7:
                message.active = reader.bool();
                break;
            case 8:
                message.type = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a StringWatchlistItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StringWatchlistItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StringWatchlistItem} StringWatchlistItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StringWatchlistItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StringWatchlistItem message.
     * @function verify
     * @memberof StringWatchlistItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StringWatchlistItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            if (!$util.isString(message.created_by_admin_id))
                return "created_by_admin_id: string expected";
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.subject != null && message.hasOwnProperty("subject"))
            switch (message.subject) {
            default:
                return "subject: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.condition != null && message.hasOwnProperty("condition"))
            switch (message.condition) {
            default:
                return "condition: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isString(message.value))
                return "value: string expected";
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a StringWatchlistItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StringWatchlistItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StringWatchlistItem} StringWatchlistItem
     */
    StringWatchlistItem.fromObject = function fromObject(object) {
        if (object instanceof $root.StringWatchlistItem)
            return object;
        let message = new $root.StringWatchlistItem();
        if (object.id != null)
            message.id = String(object.id);
        if (object.created_by_admin_id != null)
            message.created_by_admin_id = String(object.created_by_admin_id);
        if (object.description != null)
            message.description = String(object.description);
        switch (object.subject) {
        case "UNKNOWN":
        case 0:
            message.subject = 0;
            break;
        case "USER_ACCOUNT_NAME":
        case 1:
            message.subject = 1;
            break;
        case "BANK_ACCOUNT_NAME":
        case 2:
            message.subject = 2;
            break;
        case "BANK_ACCOUNT_NUMBER":
        case 3:
            message.subject = 3;
            break;
        case "BANK_ACCOUNT_COUNT":
        case 4:
            message.subject = 4;
            break;
        case "BANK_ACCOUNT_POPULARITY_COUNT":
        case 5:
            message.subject = 5;
            break;
        case "SUSPENSE_INGRESS_AMOUNT":
        case 6:
            message.subject = 6;
            break;
        case "SUSPENSE_INGRESS_COUNT":
        case 7:
            message.subject = 7;
            break;
        case "SUSPENSE_INGRESS_SUM":
        case 8:
            message.subject = 8;
            break;
        case "SUSPENSE_EGRESS_AMOUNT":
        case 9:
            message.subject = 9;
            break;
        case "SUSPENSE_EGRESS_COUNT":
        case 10:
            message.subject = 10;
            break;
        case "SUSPENSE_EGRESS_SUM":
        case 11:
            message.subject = 11;
            break;
        }
        switch (object.condition) {
        case "UNKNOWN":
        case 0:
            message.condition = 0;
            break;
        case "AMOUNT_EQUAL":
        case 1:
            message.condition = 1;
            break;
        case "AMOUNT_GREATER_THAN":
        case 2:
            message.condition = 2;
            break;
        case "AMOUNT_LESS_THAN":
        case 3:
            message.condition = 3;
            break;
        case "STRING_CONTAINS":
        case 4:
            message.condition = 4;
            break;
        case "STRING_EQUALS":
        case 5:
            message.condition = 5;
            break;
        }
        if (object.value != null)
            message.value = String(object.value);
        if (object.active != null)
            message.active = Boolean(object.active);
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "BLACK":
        case 1:
            message.type = 1;
            break;
        case "GREY":
        case 2:
            message.type = 2;
            break;
        case "WHITE":
        case 3:
            message.type = 3;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".StringWatchlistItem.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".StringWatchlistItem.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a StringWatchlistItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StringWatchlistItem
     * @static
     * @param {StringWatchlistItem} message StringWatchlistItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StringWatchlistItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.created_by_admin_id = "";
            object.description = "";
            object.subject = options.enums === String ? "UNKNOWN" : 0;
            object.condition = options.enums === String ? "UNKNOWN" : 0;
            object.value = "";
            object.active = false;
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            object.created_by_admin_id = message.created_by_admin_id;
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.subject != null && message.hasOwnProperty("subject"))
            object.subject = options.enums === String ? $root.WatchlistSubject.Enum[message.subject] : message.subject;
        if (message.condition != null && message.hasOwnProperty("condition"))
            object.condition = options.enums === String ? $root.WatchlistCondition.Enum[message.condition] : message.condition;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.WatchlistType.Enum[message.type] : message.type;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this StringWatchlistItem to JSON.
     * @function toJSON
     * @memberof StringWatchlistItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StringWatchlistItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StringWatchlistItem;
})();

export const UserBalanceGraphDataPoint = $root.UserBalanceGraphDataPoint = (() => {

    /**
     * Properties of a UserBalanceGraphDataPoint.
     * @exports IUserBalanceGraphDataPoint
     * @interface IUserBalanceGraphDataPoint
     * @property {string|null} [date] UserBalanceGraphDataPoint date
     * @property {string|null} [balance] UserBalanceGraphDataPoint balance
     */

    /**
     * Constructs a new UserBalanceGraphDataPoint.
     * @exports UserBalanceGraphDataPoint
     * @classdesc Represents a UserBalanceGraphDataPoint.
     * @implements IUserBalanceGraphDataPoint
     * @constructor
     * @param {IUserBalanceGraphDataPoint=} [properties] Properties to set
     */
    function UserBalanceGraphDataPoint(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserBalanceGraphDataPoint date.
     * @member {string} date
     * @memberof UserBalanceGraphDataPoint
     * @instance
     */
    UserBalanceGraphDataPoint.prototype.date = "";

    /**
     * UserBalanceGraphDataPoint balance.
     * @member {string} balance
     * @memberof UserBalanceGraphDataPoint
     * @instance
     */
    UserBalanceGraphDataPoint.prototype.balance = "";

    /**
     * Creates a new UserBalanceGraphDataPoint instance using the specified properties.
     * @function create
     * @memberof UserBalanceGraphDataPoint
     * @static
     * @param {IUserBalanceGraphDataPoint=} [properties] Properties to set
     * @returns {UserBalanceGraphDataPoint} UserBalanceGraphDataPoint instance
     */
    UserBalanceGraphDataPoint.create = function create(properties) {
        return new UserBalanceGraphDataPoint(properties);
    };

    /**
     * Encodes the specified UserBalanceGraphDataPoint message. Does not implicitly {@link UserBalanceGraphDataPoint.verify|verify} messages.
     * @function encode
     * @memberof UserBalanceGraphDataPoint
     * @static
     * @param {IUserBalanceGraphDataPoint} message UserBalanceGraphDataPoint message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserBalanceGraphDataPoint.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.date != null && message.hasOwnProperty("date"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.date);
        if (message.balance != null && message.hasOwnProperty("balance"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.balance);
        return writer;
    };

    /**
     * Encodes the specified UserBalanceGraphDataPoint message, length delimited. Does not implicitly {@link UserBalanceGraphDataPoint.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserBalanceGraphDataPoint
     * @static
     * @param {IUserBalanceGraphDataPoint} message UserBalanceGraphDataPoint message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserBalanceGraphDataPoint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserBalanceGraphDataPoint message from the specified reader or buffer.
     * @function decode
     * @memberof UserBalanceGraphDataPoint
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserBalanceGraphDataPoint} UserBalanceGraphDataPoint
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserBalanceGraphDataPoint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserBalanceGraphDataPoint();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.date = reader.string();
                break;
            case 2:
                message.balance = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserBalanceGraphDataPoint message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserBalanceGraphDataPoint
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserBalanceGraphDataPoint} UserBalanceGraphDataPoint
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserBalanceGraphDataPoint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserBalanceGraphDataPoint message.
     * @function verify
     * @memberof UserBalanceGraphDataPoint
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserBalanceGraphDataPoint.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.date != null && message.hasOwnProperty("date"))
            if (!$util.isString(message.date))
                return "date: string expected";
        if (message.balance != null && message.hasOwnProperty("balance"))
            if (!$util.isString(message.balance))
                return "balance: string expected";
        return null;
    };

    /**
     * Creates a UserBalanceGraphDataPoint message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserBalanceGraphDataPoint
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserBalanceGraphDataPoint} UserBalanceGraphDataPoint
     */
    UserBalanceGraphDataPoint.fromObject = function fromObject(object) {
        if (object instanceof $root.UserBalanceGraphDataPoint)
            return object;
        let message = new $root.UserBalanceGraphDataPoint();
        if (object.date != null)
            message.date = String(object.date);
        if (object.balance != null)
            message.balance = String(object.balance);
        return message;
    };

    /**
     * Creates a plain object from a UserBalanceGraphDataPoint message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserBalanceGraphDataPoint
     * @static
     * @param {UserBalanceGraphDataPoint} message UserBalanceGraphDataPoint
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserBalanceGraphDataPoint.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.date = "";
            object.balance = "";
        }
        if (message.date != null && message.hasOwnProperty("date"))
            object.date = message.date;
        if (message.balance != null && message.hasOwnProperty("balance"))
            object.balance = message.balance;
        return object;
    };

    /**
     * Converts this UserBalanceGraphDataPoint to JSON.
     * @function toJSON
     * @memberof UserBalanceGraphDataPoint
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserBalanceGraphDataPoint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UserBalanceGraphDataPoint;
})();

export const UnitPriceGraphDataPoint = $root.UnitPriceGraphDataPoint = (() => {

    /**
     * Properties of an UnitPriceGraphDataPoint.
     * @exports IUnitPriceGraphDataPoint
     * @interface IUnitPriceGraphDataPoint
     * @property {string|null} [date] UnitPriceGraphDataPoint date
     * @property {string|null} [aud_price] UnitPriceGraphDataPoint aud_price
     */

    /**
     * Constructs a new UnitPriceGraphDataPoint.
     * @exports UnitPriceGraphDataPoint
     * @classdesc Represents an UnitPriceGraphDataPoint.
     * @implements IUnitPriceGraphDataPoint
     * @constructor
     * @param {IUnitPriceGraphDataPoint=} [properties] Properties to set
     */
    function UnitPriceGraphDataPoint(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnitPriceGraphDataPoint date.
     * @member {string} date
     * @memberof UnitPriceGraphDataPoint
     * @instance
     */
    UnitPriceGraphDataPoint.prototype.date = "";

    /**
     * UnitPriceGraphDataPoint aud_price.
     * @member {string} aud_price
     * @memberof UnitPriceGraphDataPoint
     * @instance
     */
    UnitPriceGraphDataPoint.prototype.aud_price = "";

    /**
     * Creates a new UnitPriceGraphDataPoint instance using the specified properties.
     * @function create
     * @memberof UnitPriceGraphDataPoint
     * @static
     * @param {IUnitPriceGraphDataPoint=} [properties] Properties to set
     * @returns {UnitPriceGraphDataPoint} UnitPriceGraphDataPoint instance
     */
    UnitPriceGraphDataPoint.create = function create(properties) {
        return new UnitPriceGraphDataPoint(properties);
    };

    /**
     * Encodes the specified UnitPriceGraphDataPoint message. Does not implicitly {@link UnitPriceGraphDataPoint.verify|verify} messages.
     * @function encode
     * @memberof UnitPriceGraphDataPoint
     * @static
     * @param {IUnitPriceGraphDataPoint} message UnitPriceGraphDataPoint message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitPriceGraphDataPoint.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.date != null && message.hasOwnProperty("date"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.date);
        if (message.aud_price != null && message.hasOwnProperty("aud_price"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.aud_price);
        return writer;
    };

    /**
     * Encodes the specified UnitPriceGraphDataPoint message, length delimited. Does not implicitly {@link UnitPriceGraphDataPoint.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitPriceGraphDataPoint
     * @static
     * @param {IUnitPriceGraphDataPoint} message UnitPriceGraphDataPoint message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitPriceGraphDataPoint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitPriceGraphDataPoint message from the specified reader or buffer.
     * @function decode
     * @memberof UnitPriceGraphDataPoint
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitPriceGraphDataPoint} UnitPriceGraphDataPoint
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitPriceGraphDataPoint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitPriceGraphDataPoint();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.date = reader.string();
                break;
            case 2:
                message.aud_price = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitPriceGraphDataPoint message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitPriceGraphDataPoint
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitPriceGraphDataPoint} UnitPriceGraphDataPoint
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitPriceGraphDataPoint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitPriceGraphDataPoint message.
     * @function verify
     * @memberof UnitPriceGraphDataPoint
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitPriceGraphDataPoint.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.date != null && message.hasOwnProperty("date"))
            if (!$util.isString(message.date))
                return "date: string expected";
        if (message.aud_price != null && message.hasOwnProperty("aud_price"))
            if (!$util.isString(message.aud_price))
                return "aud_price: string expected";
        return null;
    };

    /**
     * Creates an UnitPriceGraphDataPoint message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitPriceGraphDataPoint
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitPriceGraphDataPoint} UnitPriceGraphDataPoint
     */
    UnitPriceGraphDataPoint.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitPriceGraphDataPoint)
            return object;
        let message = new $root.UnitPriceGraphDataPoint();
        if (object.date != null)
            message.date = String(object.date);
        if (object.aud_price != null)
            message.aud_price = String(object.aud_price);
        return message;
    };

    /**
     * Creates a plain object from an UnitPriceGraphDataPoint message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitPriceGraphDataPoint
     * @static
     * @param {UnitPriceGraphDataPoint} message UnitPriceGraphDataPoint
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitPriceGraphDataPoint.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.date = "";
            object.aud_price = "";
        }
        if (message.date != null && message.hasOwnProperty("date"))
            object.date = message.date;
        if (message.aud_price != null && message.hasOwnProperty("aud_price"))
            object.aud_price = message.aud_price;
        return object;
    };

    /**
     * Converts this UnitPriceGraphDataPoint to JSON.
     * @function toJSON
     * @memberof UnitPriceGraphDataPoint
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitPriceGraphDataPoint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnitPriceGraphDataPoint;
})();

export const AccountingTransactionType = $root.AccountingTransactionType = (() => {

    /**
     * Properties of an AccountingTransactionType.
     * @exports IAccountingTransactionType
     * @interface IAccountingTransactionType
     * @property {string|null} [id] AccountingTransactionType id
     * @property {string|null} [name] AccountingTransactionType name
     * @property {google.protobuf.ITimestamp|null} [created_at] AccountingTransactionType created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] AccountingTransactionType last_updated_at
     */

    /**
     * Constructs a new AccountingTransactionType.
     * @exports AccountingTransactionType
     * @classdesc Represents an AccountingTransactionType.
     * @implements IAccountingTransactionType
     * @constructor
     * @param {IAccountingTransactionType=} [properties] Properties to set
     */
    function AccountingTransactionType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountingTransactionType id.
     * @member {string} id
     * @memberof AccountingTransactionType
     * @instance
     */
    AccountingTransactionType.prototype.id = "";

    /**
     * AccountingTransactionType name.
     * @member {string} name
     * @memberof AccountingTransactionType
     * @instance
     */
    AccountingTransactionType.prototype.name = "";

    /**
     * AccountingTransactionType created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof AccountingTransactionType
     * @instance
     */
    AccountingTransactionType.prototype.created_at = null;

    /**
     * AccountingTransactionType last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof AccountingTransactionType
     * @instance
     */
    AccountingTransactionType.prototype.last_updated_at = null;

    /**
     * Creates a new AccountingTransactionType instance using the specified properties.
     * @function create
     * @memberof AccountingTransactionType
     * @static
     * @param {IAccountingTransactionType=} [properties] Properties to set
     * @returns {AccountingTransactionType} AccountingTransactionType instance
     */
    AccountingTransactionType.create = function create(properties) {
        return new AccountingTransactionType(properties);
    };

    /**
     * Encodes the specified AccountingTransactionType message. Does not implicitly {@link AccountingTransactionType.verify|verify} messages.
     * @function encode
     * @memberof AccountingTransactionType
     * @static
     * @param {IAccountingTransactionType} message AccountingTransactionType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingTransactionType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.name != null && message.hasOwnProperty("name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AccountingTransactionType message, length delimited. Does not implicitly {@link AccountingTransactionType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountingTransactionType
     * @static
     * @param {IAccountingTransactionType} message AccountingTransactionType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingTransactionType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountingTransactionType message from the specified reader or buffer.
     * @function decode
     * @memberof AccountingTransactionType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountingTransactionType} AccountingTransactionType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingTransactionType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountingTransactionType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.name = reader.string();
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountingTransactionType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountingTransactionType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountingTransactionType} AccountingTransactionType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingTransactionType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountingTransactionType message.
     * @function verify
     * @memberof AccountingTransactionType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountingTransactionType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates an AccountingTransactionType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountingTransactionType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountingTransactionType} AccountingTransactionType
     */
    AccountingTransactionType.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountingTransactionType)
            return object;
        let message = new $root.AccountingTransactionType();
        if (object.id != null)
            message.id = String(object.id);
        if (object.name != null)
            message.name = String(object.name);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".AccountingTransactionType.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".AccountingTransactionType.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an AccountingTransactionType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountingTransactionType
     * @static
     * @param {AccountingTransactionType} message AccountingTransactionType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountingTransactionType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.name = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this AccountingTransactionType to JSON.
     * @function toJSON
     * @memberof AccountingTransactionType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountingTransactionType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AccountingTransactionType;
})();

export const JournalEntry = $root.JournalEntry = (() => {

    /**
     * Properties of a JournalEntry.
     * @exports IJournalEntry
     * @interface IJournalEntry
     * @property {string|null} [id] JournalEntry id
     * @property {string|null} [transaction_date] JournalEntry transaction_date
     * @property {IAccountingTransactionType|null} [transaction_type] JournalEntry transaction_type
     * @property {SaverPortfolio.Enum|null} [portfolio] JournalEntry portfolio
     * @property {Array.<IJournalEntryRecording>|null} [recordings] JournalEntry recordings
     * @property {string|null} [external_reference] JournalEntry external_reference
     * @property {string|null} [product_id] JournalEntry product_id
     * @property {string|null} [transaction_reference] JournalEntry transaction_reference
     * @property {google.protobuf.ITimestamp|null} [created_at] JournalEntry created_at
     */

    /**
     * Constructs a new JournalEntry.
     * @exports JournalEntry
     * @classdesc Represents a JournalEntry.
     * @implements IJournalEntry
     * @constructor
     * @param {IJournalEntry=} [properties] Properties to set
     */
    function JournalEntry(properties) {
        this.recordings = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * JournalEntry id.
     * @member {string} id
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.id = "";

    /**
     * JournalEntry transaction_date.
     * @member {string} transaction_date
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.transaction_date = "";

    /**
     * JournalEntry transaction_type.
     * @member {IAccountingTransactionType|null|undefined} transaction_type
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.transaction_type = null;

    /**
     * JournalEntry portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.portfolio = 0;

    /**
     * JournalEntry recordings.
     * @member {Array.<IJournalEntryRecording>} recordings
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.recordings = $util.emptyArray;

    /**
     * JournalEntry external_reference.
     * @member {string} external_reference
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.external_reference = "";

    /**
     * JournalEntry product_id.
     * @member {string} product_id
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.product_id = "";

    /**
     * JournalEntry transaction_reference.
     * @member {string} transaction_reference
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.transaction_reference = "";

    /**
     * JournalEntry created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof JournalEntry
     * @instance
     */
    JournalEntry.prototype.created_at = null;

    /**
     * Creates a new JournalEntry instance using the specified properties.
     * @function create
     * @memberof JournalEntry
     * @static
     * @param {IJournalEntry=} [properties] Properties to set
     * @returns {JournalEntry} JournalEntry instance
     */
    JournalEntry.create = function create(properties) {
        return new JournalEntry(properties);
    };

    /**
     * Encodes the specified JournalEntry message. Does not implicitly {@link JournalEntry.verify|verify} messages.
     * @function encode
     * @memberof JournalEntry
     * @static
     * @param {IJournalEntry} message JournalEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    JournalEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.transaction_date != null && message.hasOwnProperty("transaction_date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.transaction_date);
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
            $root.AccountingTransactionType.encode(message.transaction_type, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.portfolio);
        if (message.recordings != null && message.recordings.length)
            for (let i = 0; i < message.recordings.length; ++i)
                $root.JournalEntryRecording.encode(message.recordings[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.external_reference);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.product_id);
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.transaction_reference);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified JournalEntry message, length delimited. Does not implicitly {@link JournalEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof JournalEntry
     * @static
     * @param {IJournalEntry} message JournalEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    JournalEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a JournalEntry message from the specified reader or buffer.
     * @function decode
     * @memberof JournalEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {JournalEntry} JournalEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    JournalEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.JournalEntry();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 3:
                message.transaction_date = reader.string();
                break;
            case 4:
                message.transaction_type = $root.AccountingTransactionType.decode(reader, reader.uint32());
                break;
            case 5:
                message.portfolio = reader.int32();
                break;
            case 6:
                if (!(message.recordings && message.recordings.length))
                    message.recordings = [];
                message.recordings.push($root.JournalEntryRecording.decode(reader, reader.uint32()));
                break;
            case 7:
                message.external_reference = reader.string();
                break;
            case 8:
                message.product_id = reader.string();
                break;
            case 9:
                message.transaction_reference = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a JournalEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof JournalEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {JournalEntry} JournalEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    JournalEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a JournalEntry message.
     * @function verify
     * @memberof JournalEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    JournalEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.transaction_date != null && message.hasOwnProperty("transaction_date"))
            if (!$util.isString(message.transaction_date))
                return "transaction_date: string expected";
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type")) {
            let error = $root.AccountingTransactionType.verify(message.transaction_type);
            if (error)
                return "transaction_type." + error;
        }
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.recordings != null && message.hasOwnProperty("recordings")) {
            if (!Array.isArray(message.recordings))
                return "recordings: array expected";
            for (let i = 0; i < message.recordings.length; ++i) {
                let error = $root.JournalEntryRecording.verify(message.recordings[i]);
                if (error)
                    return "recordings." + error;
            }
        }
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            if (!$util.isString(message.external_reference))
                return "external_reference: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a JournalEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof JournalEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {JournalEntry} JournalEntry
     */
    JournalEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.JournalEntry)
            return object;
        let message = new $root.JournalEntry();
        if (object.id != null)
            message.id = String(object.id);
        if (object.transaction_date != null)
            message.transaction_date = String(object.transaction_date);
        if (object.transaction_type != null) {
            if (typeof object.transaction_type !== "object")
                throw TypeError(".JournalEntry.transaction_type: object expected");
            message.transaction_type = $root.AccountingTransactionType.fromObject(object.transaction_type);
        }
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.recordings) {
            if (!Array.isArray(object.recordings))
                throw TypeError(".JournalEntry.recordings: array expected");
            message.recordings = [];
            for (let i = 0; i < object.recordings.length; ++i) {
                if (typeof object.recordings[i] !== "object")
                    throw TypeError(".JournalEntry.recordings: object expected");
                message.recordings[i] = $root.JournalEntryRecording.fromObject(object.recordings[i]);
            }
        }
        if (object.external_reference != null)
            message.external_reference = String(object.external_reference);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".JournalEntry.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a JournalEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof JournalEntry
     * @static
     * @param {JournalEntry} message JournalEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    JournalEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.recordings = [];
        if (options.defaults) {
            object.id = "";
            object.transaction_date = "";
            object.transaction_type = null;
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.external_reference = "";
            object.product_id = "";
            object.transaction_reference = "";
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.transaction_date != null && message.hasOwnProperty("transaction_date"))
            object.transaction_date = message.transaction_date;
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
            object.transaction_type = $root.AccountingTransactionType.toObject(message.transaction_type, options);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.recordings && message.recordings.length) {
            object.recordings = [];
            for (let j = 0; j < message.recordings.length; ++j)
                object.recordings[j] = $root.JournalEntryRecording.toObject(message.recordings[j], options);
        }
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            object.external_reference = message.external_reference;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this JournalEntry to JSON.
     * @function toJSON
     * @memberof JournalEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    JournalEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return JournalEntry;
})();

export const LedgerAccountType = $root.LedgerAccountType = (() => {

    /**
     * Properties of a LedgerAccountType.
     * @exports ILedgerAccountType
     * @interface ILedgerAccountType
     */

    /**
     * Constructs a new LedgerAccountType.
     * @exports LedgerAccountType
     * @classdesc Represents a LedgerAccountType.
     * @implements ILedgerAccountType
     * @constructor
     * @param {ILedgerAccountType=} [properties] Properties to set
     */
    function LedgerAccountType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new LedgerAccountType instance using the specified properties.
     * @function create
     * @memberof LedgerAccountType
     * @static
     * @param {ILedgerAccountType=} [properties] Properties to set
     * @returns {LedgerAccountType} LedgerAccountType instance
     */
    LedgerAccountType.create = function create(properties) {
        return new LedgerAccountType(properties);
    };

    /**
     * Encodes the specified LedgerAccountType message. Does not implicitly {@link LedgerAccountType.verify|verify} messages.
     * @function encode
     * @memberof LedgerAccountType
     * @static
     * @param {ILedgerAccountType} message LedgerAccountType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccountType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified LedgerAccountType message, length delimited. Does not implicitly {@link LedgerAccountType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LedgerAccountType
     * @static
     * @param {ILedgerAccountType} message LedgerAccountType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccountType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LedgerAccountType message from the specified reader or buffer.
     * @function decode
     * @memberof LedgerAccountType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LedgerAccountType} LedgerAccountType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccountType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LedgerAccountType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LedgerAccountType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LedgerAccountType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LedgerAccountType} LedgerAccountType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccountType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LedgerAccountType message.
     * @function verify
     * @memberof LedgerAccountType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LedgerAccountType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a LedgerAccountType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LedgerAccountType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LedgerAccountType} LedgerAccountType
     */
    LedgerAccountType.fromObject = function fromObject(object) {
        if (object instanceof $root.LedgerAccountType)
            return object;
        return new $root.LedgerAccountType();
    };

    /**
     * Creates a plain object from a LedgerAccountType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LedgerAccountType
     * @static
     * @param {LedgerAccountType} message LedgerAccountType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LedgerAccountType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this LedgerAccountType to JSON.
     * @function toJSON
     * @memberof LedgerAccountType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LedgerAccountType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name LedgerAccountType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ASSET=1 ASSET value
     * @property {number} LIABILITY=2 LIABILITY value
     * @property {number} EQUITY=3 EQUITY value
     * @property {number} EXPENSE=4 EXPENSE value
     * @property {number} INCOME=5 INCOME value
     */
    LedgerAccountType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ASSET"] = 1;
        values[valuesById[2] = "LIABILITY"] = 2;
        values[valuesById[3] = "EQUITY"] = 3;
        values[valuesById[4] = "EXPENSE"] = 4;
        values[valuesById[5] = "INCOME"] = 5;
        return values;
    })();

    return LedgerAccountType;
})();

export const LedgerAccount = $root.LedgerAccount = (() => {

    /**
     * Properties of a LedgerAccount.
     * @exports ILedgerAccount
     * @interface ILedgerAccount
     * @property {string|null} [id] LedgerAccount id
     * @property {string|null} [name] LedgerAccount name
     * @property {LedgerAccountType.Enum|null} [type] LedgerAccount type
     * @property {google.protobuf.ITimestamp|null} [created_at] LedgerAccount created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] LedgerAccount last_updated_at
     */

    /**
     * Constructs a new LedgerAccount.
     * @exports LedgerAccount
     * @classdesc Represents a LedgerAccount.
     * @implements ILedgerAccount
     * @constructor
     * @param {ILedgerAccount=} [properties] Properties to set
     */
    function LedgerAccount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LedgerAccount id.
     * @member {string} id
     * @memberof LedgerAccount
     * @instance
     */
    LedgerAccount.prototype.id = "";

    /**
     * LedgerAccount name.
     * @member {string} name
     * @memberof LedgerAccount
     * @instance
     */
    LedgerAccount.prototype.name = "";

    /**
     * LedgerAccount type.
     * @member {LedgerAccountType.Enum} type
     * @memberof LedgerAccount
     * @instance
     */
    LedgerAccount.prototype.type = 0;

    /**
     * LedgerAccount created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof LedgerAccount
     * @instance
     */
    LedgerAccount.prototype.created_at = null;

    /**
     * LedgerAccount last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof LedgerAccount
     * @instance
     */
    LedgerAccount.prototype.last_updated_at = null;

    /**
     * Creates a new LedgerAccount instance using the specified properties.
     * @function create
     * @memberof LedgerAccount
     * @static
     * @param {ILedgerAccount=} [properties] Properties to set
     * @returns {LedgerAccount} LedgerAccount instance
     */
    LedgerAccount.create = function create(properties) {
        return new LedgerAccount(properties);
    };

    /**
     * Encodes the specified LedgerAccount message. Does not implicitly {@link LedgerAccount.verify|verify} messages.
     * @function encode
     * @memberof LedgerAccount
     * @static
     * @param {ILedgerAccount} message LedgerAccount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.name != null && message.hasOwnProperty("name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified LedgerAccount message, length delimited. Does not implicitly {@link LedgerAccount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LedgerAccount
     * @static
     * @param {ILedgerAccount} message LedgerAccount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LedgerAccount message from the specified reader or buffer.
     * @function decode
     * @memberof LedgerAccount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LedgerAccount} LedgerAccount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LedgerAccount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.name = reader.string();
                break;
            case 3:
                message.type = reader.int32();
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LedgerAccount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LedgerAccount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LedgerAccount} LedgerAccount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LedgerAccount message.
     * @function verify
     * @memberof LedgerAccount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LedgerAccount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a LedgerAccount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LedgerAccount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LedgerAccount} LedgerAccount
     */
    LedgerAccount.fromObject = function fromObject(object) {
        if (object instanceof $root.LedgerAccount)
            return object;
        let message = new $root.LedgerAccount();
        if (object.id != null)
            message.id = String(object.id);
        if (object.name != null)
            message.name = String(object.name);
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "ASSET":
        case 1:
            message.type = 1;
            break;
        case "LIABILITY":
        case 2:
            message.type = 2;
            break;
        case "EQUITY":
        case 3:
            message.type = 3;
            break;
        case "EXPENSE":
        case 4:
            message.type = 4;
            break;
        case "INCOME":
        case 5:
            message.type = 5;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".LedgerAccount.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".LedgerAccount.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a LedgerAccount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LedgerAccount
     * @static
     * @param {LedgerAccount} message LedgerAccount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LedgerAccount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.name = "";
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.LedgerAccountType.Enum[message.type] : message.type;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this LedgerAccount to JSON.
     * @function toJSON
     * @memberof LedgerAccount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LedgerAccount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LedgerAccount;
})();

export const LedgerAccountSummary = $root.LedgerAccountSummary = (() => {

    /**
     * Properties of a LedgerAccountSummary.
     * @exports ILedgerAccountSummary
     * @interface ILedgerAccountSummary
     * @property {string|null} [start_balance] LedgerAccountSummary start_balance
     * @property {string|null} [end_balance] LedgerAccountSummary end_balance
     * @property {string|null} [debit_aud_amount] LedgerAccountSummary debit_aud_amount
     * @property {string|null} [credit_aud_amount] LedgerAccountSummary credit_aud_amount
     */

    /**
     * Constructs a new LedgerAccountSummary.
     * @exports LedgerAccountSummary
     * @classdesc Represents a LedgerAccountSummary.
     * @implements ILedgerAccountSummary
     * @constructor
     * @param {ILedgerAccountSummary=} [properties] Properties to set
     */
    function LedgerAccountSummary(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LedgerAccountSummary start_balance.
     * @member {string} start_balance
     * @memberof LedgerAccountSummary
     * @instance
     */
    LedgerAccountSummary.prototype.start_balance = "";

    /**
     * LedgerAccountSummary end_balance.
     * @member {string} end_balance
     * @memberof LedgerAccountSummary
     * @instance
     */
    LedgerAccountSummary.prototype.end_balance = "";

    /**
     * LedgerAccountSummary debit_aud_amount.
     * @member {string} debit_aud_amount
     * @memberof LedgerAccountSummary
     * @instance
     */
    LedgerAccountSummary.prototype.debit_aud_amount = "";

    /**
     * LedgerAccountSummary credit_aud_amount.
     * @member {string} credit_aud_amount
     * @memberof LedgerAccountSummary
     * @instance
     */
    LedgerAccountSummary.prototype.credit_aud_amount = "";

    /**
     * Creates a new LedgerAccountSummary instance using the specified properties.
     * @function create
     * @memberof LedgerAccountSummary
     * @static
     * @param {ILedgerAccountSummary=} [properties] Properties to set
     * @returns {LedgerAccountSummary} LedgerAccountSummary instance
     */
    LedgerAccountSummary.create = function create(properties) {
        return new LedgerAccountSummary(properties);
    };

    /**
     * Encodes the specified LedgerAccountSummary message. Does not implicitly {@link LedgerAccountSummary.verify|verify} messages.
     * @function encode
     * @memberof LedgerAccountSummary
     * @static
     * @param {ILedgerAccountSummary} message LedgerAccountSummary message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccountSummary.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.start_balance != null && message.hasOwnProperty("start_balance"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.start_balance);
        if (message.end_balance != null && message.hasOwnProperty("end_balance"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.end_balance);
        if (message.debit_aud_amount != null && message.hasOwnProperty("debit_aud_amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.debit_aud_amount);
        if (message.credit_aud_amount != null && message.hasOwnProperty("credit_aud_amount"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.credit_aud_amount);
        return writer;
    };

    /**
     * Encodes the specified LedgerAccountSummary message, length delimited. Does not implicitly {@link LedgerAccountSummary.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LedgerAccountSummary
     * @static
     * @param {ILedgerAccountSummary} message LedgerAccountSummary message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccountSummary.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LedgerAccountSummary message from the specified reader or buffer.
     * @function decode
     * @memberof LedgerAccountSummary
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LedgerAccountSummary} LedgerAccountSummary
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccountSummary.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LedgerAccountSummary();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.start_balance = reader.string();
                break;
            case 2:
                message.end_balance = reader.string();
                break;
            case 3:
                message.debit_aud_amount = reader.string();
                break;
            case 4:
                message.credit_aud_amount = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LedgerAccountSummary message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LedgerAccountSummary
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LedgerAccountSummary} LedgerAccountSummary
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccountSummary.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LedgerAccountSummary message.
     * @function verify
     * @memberof LedgerAccountSummary
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LedgerAccountSummary.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.start_balance != null && message.hasOwnProperty("start_balance"))
            if (!$util.isString(message.start_balance))
                return "start_balance: string expected";
        if (message.end_balance != null && message.hasOwnProperty("end_balance"))
            if (!$util.isString(message.end_balance))
                return "end_balance: string expected";
        if (message.debit_aud_amount != null && message.hasOwnProperty("debit_aud_amount"))
            if (!$util.isString(message.debit_aud_amount))
                return "debit_aud_amount: string expected";
        if (message.credit_aud_amount != null && message.hasOwnProperty("credit_aud_amount"))
            if (!$util.isString(message.credit_aud_amount))
                return "credit_aud_amount: string expected";
        return null;
    };

    /**
     * Creates a LedgerAccountSummary message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LedgerAccountSummary
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LedgerAccountSummary} LedgerAccountSummary
     */
    LedgerAccountSummary.fromObject = function fromObject(object) {
        if (object instanceof $root.LedgerAccountSummary)
            return object;
        let message = new $root.LedgerAccountSummary();
        if (object.start_balance != null)
            message.start_balance = String(object.start_balance);
        if (object.end_balance != null)
            message.end_balance = String(object.end_balance);
        if (object.debit_aud_amount != null)
            message.debit_aud_amount = String(object.debit_aud_amount);
        if (object.credit_aud_amount != null)
            message.credit_aud_amount = String(object.credit_aud_amount);
        return message;
    };

    /**
     * Creates a plain object from a LedgerAccountSummary message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LedgerAccountSummary
     * @static
     * @param {LedgerAccountSummary} message LedgerAccountSummary
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LedgerAccountSummary.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.start_balance = "";
            object.end_balance = "";
            object.debit_aud_amount = "";
            object.credit_aud_amount = "";
        }
        if (message.start_balance != null && message.hasOwnProperty("start_balance"))
            object.start_balance = message.start_balance;
        if (message.end_balance != null && message.hasOwnProperty("end_balance"))
            object.end_balance = message.end_balance;
        if (message.debit_aud_amount != null && message.hasOwnProperty("debit_aud_amount"))
            object.debit_aud_amount = message.debit_aud_amount;
        if (message.credit_aud_amount != null && message.hasOwnProperty("credit_aud_amount"))
            object.credit_aud_amount = message.credit_aud_amount;
        return object;
    };

    /**
     * Converts this LedgerAccountSummary to JSON.
     * @function toJSON
     * @memberof LedgerAccountSummary
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LedgerAccountSummary.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LedgerAccountSummary;
})();

export const JournalEntryRecording = $root.JournalEntryRecording = (() => {

    /**
     * Properties of a JournalEntryRecording.
     * @exports IJournalEntryRecording
     * @interface IJournalEntryRecording
     * @property {string|null} [id] JournalEntryRecording id
     * @property {string|null} [journal_entry_id] JournalEntryRecording journal_entry_id
     * @property {ILedgerAccount|null} [ledger_account] JournalEntryRecording ledger_account
     * @property {TransactionDirection.Enum|null} [direction] JournalEntryRecording direction
     * @property {string|null} [amount] JournalEntryRecording amount
     * @property {string|null} [journal_entry_transaction_date] JournalEntryRecording journal_entry_transaction_date
     * @property {string|null} [journal_entry_transaction_reference] JournalEntryRecording journal_entry_transaction_reference
     * @property {google.protobuf.ITimestamp|null} [created_at] JournalEntryRecording created_at
     */

    /**
     * Constructs a new JournalEntryRecording.
     * @exports JournalEntryRecording
     * @classdesc Represents a JournalEntryRecording.
     * @implements IJournalEntryRecording
     * @constructor
     * @param {IJournalEntryRecording=} [properties] Properties to set
     */
    function JournalEntryRecording(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * JournalEntryRecording id.
     * @member {string} id
     * @memberof JournalEntryRecording
     * @instance
     */
    JournalEntryRecording.prototype.id = "";

    /**
     * JournalEntryRecording journal_entry_id.
     * @member {string} journal_entry_id
     * @memberof JournalEntryRecording
     * @instance
     */
    JournalEntryRecording.prototype.journal_entry_id = "";

    /**
     * JournalEntryRecording ledger_account.
     * @member {ILedgerAccount|null|undefined} ledger_account
     * @memberof JournalEntryRecording
     * @instance
     */
    JournalEntryRecording.prototype.ledger_account = null;

    /**
     * JournalEntryRecording direction.
     * @member {TransactionDirection.Enum} direction
     * @memberof JournalEntryRecording
     * @instance
     */
    JournalEntryRecording.prototype.direction = 0;

    /**
     * JournalEntryRecording amount.
     * @member {string} amount
     * @memberof JournalEntryRecording
     * @instance
     */
    JournalEntryRecording.prototype.amount = "";

    /**
     * JournalEntryRecording journal_entry_transaction_date.
     * @member {string} journal_entry_transaction_date
     * @memberof JournalEntryRecording
     * @instance
     */
    JournalEntryRecording.prototype.journal_entry_transaction_date = "";

    /**
     * JournalEntryRecording journal_entry_transaction_reference.
     * @member {string} journal_entry_transaction_reference
     * @memberof JournalEntryRecording
     * @instance
     */
    JournalEntryRecording.prototype.journal_entry_transaction_reference = "";

    /**
     * JournalEntryRecording created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof JournalEntryRecording
     * @instance
     */
    JournalEntryRecording.prototype.created_at = null;

    /**
     * Creates a new JournalEntryRecording instance using the specified properties.
     * @function create
     * @memberof JournalEntryRecording
     * @static
     * @param {IJournalEntryRecording=} [properties] Properties to set
     * @returns {JournalEntryRecording} JournalEntryRecording instance
     */
    JournalEntryRecording.create = function create(properties) {
        return new JournalEntryRecording(properties);
    };

    /**
     * Encodes the specified JournalEntryRecording message. Does not implicitly {@link JournalEntryRecording.verify|verify} messages.
     * @function encode
     * @memberof JournalEntryRecording
     * @static
     * @param {IJournalEntryRecording} message JournalEntryRecording message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    JournalEntryRecording.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.journal_entry_id != null && message.hasOwnProperty("journal_entry_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.journal_entry_id);
        if (message.ledger_account != null && message.hasOwnProperty("ledger_account"))
            $root.LedgerAccount.encode(message.ledger_account, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.direction != null && message.hasOwnProperty("direction"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.direction);
        if (message.amount != null && message.hasOwnProperty("amount"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.amount);
        if (message.journal_entry_transaction_date != null && message.hasOwnProperty("journal_entry_transaction_date"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.journal_entry_transaction_date);
        if (message.journal_entry_transaction_reference != null && message.hasOwnProperty("journal_entry_transaction_reference"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.journal_entry_transaction_reference);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified JournalEntryRecording message, length delimited. Does not implicitly {@link JournalEntryRecording.verify|verify} messages.
     * @function encodeDelimited
     * @memberof JournalEntryRecording
     * @static
     * @param {IJournalEntryRecording} message JournalEntryRecording message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    JournalEntryRecording.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a JournalEntryRecording message from the specified reader or buffer.
     * @function decode
     * @memberof JournalEntryRecording
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {JournalEntryRecording} JournalEntryRecording
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    JournalEntryRecording.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.JournalEntryRecording();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 3:
                message.journal_entry_id = reader.string();
                break;
            case 4:
                message.ledger_account = $root.LedgerAccount.decode(reader, reader.uint32());
                break;
            case 5:
                message.direction = reader.int32();
                break;
            case 6:
                message.amount = reader.string();
                break;
            case 7:
                message.journal_entry_transaction_date = reader.string();
                break;
            case 8:
                message.journal_entry_transaction_reference = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a JournalEntryRecording message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof JournalEntryRecording
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {JournalEntryRecording} JournalEntryRecording
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    JournalEntryRecording.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a JournalEntryRecording message.
     * @function verify
     * @memberof JournalEntryRecording
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    JournalEntryRecording.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.journal_entry_id != null && message.hasOwnProperty("journal_entry_id"))
            if (!$util.isString(message.journal_entry_id))
                return "journal_entry_id: string expected";
        if (message.ledger_account != null && message.hasOwnProperty("ledger_account")) {
            let error = $root.LedgerAccount.verify(message.ledger_account);
            if (error)
                return "ledger_account." + error;
        }
        if (message.direction != null && message.hasOwnProperty("direction"))
            switch (message.direction) {
            default:
                return "direction: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isString(message.amount))
                return "amount: string expected";
        if (message.journal_entry_transaction_date != null && message.hasOwnProperty("journal_entry_transaction_date"))
            if (!$util.isString(message.journal_entry_transaction_date))
                return "journal_entry_transaction_date: string expected";
        if (message.journal_entry_transaction_reference != null && message.hasOwnProperty("journal_entry_transaction_reference"))
            if (!$util.isString(message.journal_entry_transaction_reference))
                return "journal_entry_transaction_reference: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a JournalEntryRecording message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof JournalEntryRecording
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {JournalEntryRecording} JournalEntryRecording
     */
    JournalEntryRecording.fromObject = function fromObject(object) {
        if (object instanceof $root.JournalEntryRecording)
            return object;
        let message = new $root.JournalEntryRecording();
        if (object.id != null)
            message.id = String(object.id);
        if (object.journal_entry_id != null)
            message.journal_entry_id = String(object.journal_entry_id);
        if (object.ledger_account != null) {
            if (typeof object.ledger_account !== "object")
                throw TypeError(".JournalEntryRecording.ledger_account: object expected");
            message.ledger_account = $root.LedgerAccount.fromObject(object.ledger_account);
        }
        switch (object.direction) {
        case "UNKNOWN":
        case 0:
            message.direction = 0;
            break;
        case "CREDIT":
        case 1:
            message.direction = 1;
            break;
        case "DEBIT":
        case 2:
            message.direction = 2;
            break;
        }
        if (object.amount != null)
            message.amount = String(object.amount);
        if (object.journal_entry_transaction_date != null)
            message.journal_entry_transaction_date = String(object.journal_entry_transaction_date);
        if (object.journal_entry_transaction_reference != null)
            message.journal_entry_transaction_reference = String(object.journal_entry_transaction_reference);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".JournalEntryRecording.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a JournalEntryRecording message. Also converts values to other types if specified.
     * @function toObject
     * @memberof JournalEntryRecording
     * @static
     * @param {JournalEntryRecording} message JournalEntryRecording
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    JournalEntryRecording.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.journal_entry_id = "";
            object.ledger_account = null;
            object.direction = options.enums === String ? "UNKNOWN" : 0;
            object.amount = "";
            object.journal_entry_transaction_date = "";
            object.journal_entry_transaction_reference = "";
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.journal_entry_id != null && message.hasOwnProperty("journal_entry_id"))
            object.journal_entry_id = message.journal_entry_id;
        if (message.ledger_account != null && message.hasOwnProperty("ledger_account"))
            object.ledger_account = $root.LedgerAccount.toObject(message.ledger_account, options);
        if (message.direction != null && message.hasOwnProperty("direction"))
            object.direction = options.enums === String ? $root.TransactionDirection.Enum[message.direction] : message.direction;
        if (message.amount != null && message.hasOwnProperty("amount"))
            object.amount = message.amount;
        if (message.journal_entry_transaction_date != null && message.hasOwnProperty("journal_entry_transaction_date"))
            object.journal_entry_transaction_date = message.journal_entry_transaction_date;
        if (message.journal_entry_transaction_reference != null && message.hasOwnProperty("journal_entry_transaction_reference"))
            object.journal_entry_transaction_reference = message.journal_entry_transaction_reference;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this JournalEntryRecording to JSON.
     * @function toJSON
     * @memberof JournalEntryRecording
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    JournalEntryRecording.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return JournalEntryRecording;
})();

export const SearchJournalFilter = $root.SearchJournalFilter = (() => {

    /**
     * Properties of a SearchJournalFilter.
     * @exports ISearchJournalFilter
     * @interface ISearchJournalFilter
     * @property {SaverPortfolio.Enum|null} [portfolio] SearchJournalFilter portfolio
     * @property {string|null} [start_date] SearchJournalFilter start_date
     * @property {string|null} [end_date] SearchJournalFilter end_date
     * @property {string|null} [query] SearchJournalFilter query
     */

    /**
     * Constructs a new SearchJournalFilter.
     * @exports SearchJournalFilter
     * @classdesc Represents a SearchJournalFilter.
     * @implements ISearchJournalFilter
     * @constructor
     * @param {ISearchJournalFilter=} [properties] Properties to set
     */
    function SearchJournalFilter(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchJournalFilter portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof SearchJournalFilter
     * @instance
     */
    SearchJournalFilter.prototype.portfolio = 0;

    /**
     * SearchJournalFilter start_date.
     * @member {string} start_date
     * @memberof SearchJournalFilter
     * @instance
     */
    SearchJournalFilter.prototype.start_date = "";

    /**
     * SearchJournalFilter end_date.
     * @member {string} end_date
     * @memberof SearchJournalFilter
     * @instance
     */
    SearchJournalFilter.prototype.end_date = "";

    /**
     * SearchJournalFilter query.
     * @member {string} query
     * @memberof SearchJournalFilter
     * @instance
     */
    SearchJournalFilter.prototype.query = "";

    /**
     * Creates a new SearchJournalFilter instance using the specified properties.
     * @function create
     * @memberof SearchJournalFilter
     * @static
     * @param {ISearchJournalFilter=} [properties] Properties to set
     * @returns {SearchJournalFilter} SearchJournalFilter instance
     */
    SearchJournalFilter.create = function create(properties) {
        return new SearchJournalFilter(properties);
    };

    /**
     * Encodes the specified SearchJournalFilter message. Does not implicitly {@link SearchJournalFilter.verify|verify} messages.
     * @function encode
     * @memberof SearchJournalFilter
     * @static
     * @param {ISearchJournalFilter} message SearchJournalFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchJournalFilter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.start_date);
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.end_date);
        if (message.query != null && message.hasOwnProperty("query"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.query);
        return writer;
    };

    /**
     * Encodes the specified SearchJournalFilter message, length delimited. Does not implicitly {@link SearchJournalFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchJournalFilter
     * @static
     * @param {ISearchJournalFilter} message SearchJournalFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchJournalFilter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchJournalFilter message from the specified reader or buffer.
     * @function decode
     * @memberof SearchJournalFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchJournalFilter} SearchJournalFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchJournalFilter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchJournalFilter();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.portfolio = reader.int32();
                break;
            case 2:
                message.start_date = reader.string();
                break;
            case 3:
                message.end_date = reader.string();
                break;
            case 4:
                message.query = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchJournalFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchJournalFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchJournalFilter} SearchJournalFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchJournalFilter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchJournalFilter message.
     * @function verify
     * @memberof SearchJournalFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchJournalFilter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            if (!$util.isString(message.start_date))
                return "start_date: string expected";
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            if (!$util.isString(message.end_date))
                return "end_date: string expected";
        if (message.query != null && message.hasOwnProperty("query"))
            if (!$util.isString(message.query))
                return "query: string expected";
        return null;
    };

    /**
     * Creates a SearchJournalFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchJournalFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchJournalFilter} SearchJournalFilter
     */
    SearchJournalFilter.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchJournalFilter)
            return object;
        let message = new $root.SearchJournalFilter();
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.start_date != null)
            message.start_date = String(object.start_date);
        if (object.end_date != null)
            message.end_date = String(object.end_date);
        if (object.query != null)
            message.query = String(object.query);
        return message;
    };

    /**
     * Creates a plain object from a SearchJournalFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchJournalFilter
     * @static
     * @param {SearchJournalFilter} message SearchJournalFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchJournalFilter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.start_date = "";
            object.end_date = "";
            object.query = "";
        }
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            object.start_date = message.start_date;
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            object.end_date = message.end_date;
        if (message.query != null && message.hasOwnProperty("query"))
            object.query = message.query;
        return object;
    };

    /**
     * Converts this SearchJournalFilter to JSON.
     * @function toJSON
     * @memberof SearchJournalFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchJournalFilter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchJournalFilter;
})();

export const SearchJournalPageToken = $root.SearchJournalPageToken = (() => {

    /**
     * Properties of a SearchJournalPageToken.
     * @exports ISearchJournalPageToken
     * @interface ISearchJournalPageToken
     * @property {string|null} [from_transaction_date] SearchJournalPageToken from_transaction_date
     * @property {string|null} [from_id] SearchJournalPageToken from_id
     * @property {ISearchJournalFilter|null} [filter] SearchJournalPageToken filter
     */

    /**
     * Constructs a new SearchJournalPageToken.
     * @exports SearchJournalPageToken
     * @classdesc Represents a SearchJournalPageToken.
     * @implements ISearchJournalPageToken
     * @constructor
     * @param {ISearchJournalPageToken=} [properties] Properties to set
     */
    function SearchJournalPageToken(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchJournalPageToken from_transaction_date.
     * @member {string} from_transaction_date
     * @memberof SearchJournalPageToken
     * @instance
     */
    SearchJournalPageToken.prototype.from_transaction_date = "";

    /**
     * SearchJournalPageToken from_id.
     * @member {string} from_id
     * @memberof SearchJournalPageToken
     * @instance
     */
    SearchJournalPageToken.prototype.from_id = "";

    /**
     * SearchJournalPageToken filter.
     * @member {ISearchJournalFilter|null|undefined} filter
     * @memberof SearchJournalPageToken
     * @instance
     */
    SearchJournalPageToken.prototype.filter = null;

    /**
     * Creates a new SearchJournalPageToken instance using the specified properties.
     * @function create
     * @memberof SearchJournalPageToken
     * @static
     * @param {ISearchJournalPageToken=} [properties] Properties to set
     * @returns {SearchJournalPageToken} SearchJournalPageToken instance
     */
    SearchJournalPageToken.create = function create(properties) {
        return new SearchJournalPageToken(properties);
    };

    /**
     * Encodes the specified SearchJournalPageToken message. Does not implicitly {@link SearchJournalPageToken.verify|verify} messages.
     * @function encode
     * @memberof SearchJournalPageToken
     * @static
     * @param {ISearchJournalPageToken} message SearchJournalPageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchJournalPageToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.from_transaction_date != null && message.hasOwnProperty("from_transaction_date"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.from_transaction_date);
        if (message.from_id != null && message.hasOwnProperty("from_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.from_id);
        if (message.filter != null && message.hasOwnProperty("filter"))
            $root.SearchJournalFilter.encode(message.filter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SearchJournalPageToken message, length delimited. Does not implicitly {@link SearchJournalPageToken.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchJournalPageToken
     * @static
     * @param {ISearchJournalPageToken} message SearchJournalPageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchJournalPageToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchJournalPageToken message from the specified reader or buffer.
     * @function decode
     * @memberof SearchJournalPageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchJournalPageToken} SearchJournalPageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchJournalPageToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchJournalPageToken();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.from_transaction_date = reader.string();
                break;
            case 2:
                message.from_id = reader.string();
                break;
            case 3:
                message.filter = $root.SearchJournalFilter.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchJournalPageToken message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchJournalPageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchJournalPageToken} SearchJournalPageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchJournalPageToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchJournalPageToken message.
     * @function verify
     * @memberof SearchJournalPageToken
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchJournalPageToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.from_transaction_date != null && message.hasOwnProperty("from_transaction_date"))
            if (!$util.isString(message.from_transaction_date))
                return "from_transaction_date: string expected";
        if (message.from_id != null && message.hasOwnProperty("from_id"))
            if (!$util.isString(message.from_id))
                return "from_id: string expected";
        if (message.filter != null && message.hasOwnProperty("filter")) {
            let error = $root.SearchJournalFilter.verify(message.filter);
            if (error)
                return "filter." + error;
        }
        return null;
    };

    /**
     * Creates a SearchJournalPageToken message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchJournalPageToken
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchJournalPageToken} SearchJournalPageToken
     */
    SearchJournalPageToken.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchJournalPageToken)
            return object;
        let message = new $root.SearchJournalPageToken();
        if (object.from_transaction_date != null)
            message.from_transaction_date = String(object.from_transaction_date);
        if (object.from_id != null)
            message.from_id = String(object.from_id);
        if (object.filter != null) {
            if (typeof object.filter !== "object")
                throw TypeError(".SearchJournalPageToken.filter: object expected");
            message.filter = $root.SearchJournalFilter.fromObject(object.filter);
        }
        return message;
    };

    /**
     * Creates a plain object from a SearchJournalPageToken message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchJournalPageToken
     * @static
     * @param {SearchJournalPageToken} message SearchJournalPageToken
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchJournalPageToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.from_transaction_date = "";
            object.from_id = "";
            object.filter = null;
        }
        if (message.from_transaction_date != null && message.hasOwnProperty("from_transaction_date"))
            object.from_transaction_date = message.from_transaction_date;
        if (message.from_id != null && message.hasOwnProperty("from_id"))
            object.from_id = message.from_id;
        if (message.filter != null && message.hasOwnProperty("filter"))
            object.filter = $root.SearchJournalFilter.toObject(message.filter, options);
        return object;
    };

    /**
     * Converts this SearchJournalPageToken to JSON.
     * @function toJSON
     * @memberof SearchJournalPageToken
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchJournalPageToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchJournalPageToken;
})();

export const SearchJournalEntryRecordingsFilter = $root.SearchJournalEntryRecordingsFilter = (() => {

    /**
     * Properties of a SearchJournalEntryRecordingsFilter.
     * @exports ISearchJournalEntryRecordingsFilter
     * @interface ISearchJournalEntryRecordingsFilter
     * @property {SaverPortfolio.Enum|null} [portfolio] SearchJournalEntryRecordingsFilter portfolio
     * @property {string|null} [ledger_account_id] SearchJournalEntryRecordingsFilter ledger_account_id
     * @property {string|null} [start_date] SearchJournalEntryRecordingsFilter start_date
     * @property {string|null} [end_date] SearchJournalEntryRecordingsFilter end_date
     * @property {string|null} [query] SearchJournalEntryRecordingsFilter query
     */

    /**
     * Constructs a new SearchJournalEntryRecordingsFilter.
     * @exports SearchJournalEntryRecordingsFilter
     * @classdesc Represents a SearchJournalEntryRecordingsFilter.
     * @implements ISearchJournalEntryRecordingsFilter
     * @constructor
     * @param {ISearchJournalEntryRecordingsFilter=} [properties] Properties to set
     */
    function SearchJournalEntryRecordingsFilter(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchJournalEntryRecordingsFilter portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof SearchJournalEntryRecordingsFilter
     * @instance
     */
    SearchJournalEntryRecordingsFilter.prototype.portfolio = 0;

    /**
     * SearchJournalEntryRecordingsFilter ledger_account_id.
     * @member {string} ledger_account_id
     * @memberof SearchJournalEntryRecordingsFilter
     * @instance
     */
    SearchJournalEntryRecordingsFilter.prototype.ledger_account_id = "";

    /**
     * SearchJournalEntryRecordingsFilter start_date.
     * @member {string} start_date
     * @memberof SearchJournalEntryRecordingsFilter
     * @instance
     */
    SearchJournalEntryRecordingsFilter.prototype.start_date = "";

    /**
     * SearchJournalEntryRecordingsFilter end_date.
     * @member {string} end_date
     * @memberof SearchJournalEntryRecordingsFilter
     * @instance
     */
    SearchJournalEntryRecordingsFilter.prototype.end_date = "";

    /**
     * SearchJournalEntryRecordingsFilter query.
     * @member {string} query
     * @memberof SearchJournalEntryRecordingsFilter
     * @instance
     */
    SearchJournalEntryRecordingsFilter.prototype.query = "";

    /**
     * Creates a new SearchJournalEntryRecordingsFilter instance using the specified properties.
     * @function create
     * @memberof SearchJournalEntryRecordingsFilter
     * @static
     * @param {ISearchJournalEntryRecordingsFilter=} [properties] Properties to set
     * @returns {SearchJournalEntryRecordingsFilter} SearchJournalEntryRecordingsFilter instance
     */
    SearchJournalEntryRecordingsFilter.create = function create(properties) {
        return new SearchJournalEntryRecordingsFilter(properties);
    };

    /**
     * Encodes the specified SearchJournalEntryRecordingsFilter message. Does not implicitly {@link SearchJournalEntryRecordingsFilter.verify|verify} messages.
     * @function encode
     * @memberof SearchJournalEntryRecordingsFilter
     * @static
     * @param {ISearchJournalEntryRecordingsFilter} message SearchJournalEntryRecordingsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchJournalEntryRecordingsFilter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
        if (message.ledger_account_id != null && message.hasOwnProperty("ledger_account_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.ledger_account_id);
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.start_date);
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.end_date);
        if (message.query != null && message.hasOwnProperty("query"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.query);
        return writer;
    };

    /**
     * Encodes the specified SearchJournalEntryRecordingsFilter message, length delimited. Does not implicitly {@link SearchJournalEntryRecordingsFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchJournalEntryRecordingsFilter
     * @static
     * @param {ISearchJournalEntryRecordingsFilter} message SearchJournalEntryRecordingsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchJournalEntryRecordingsFilter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchJournalEntryRecordingsFilter message from the specified reader or buffer.
     * @function decode
     * @memberof SearchJournalEntryRecordingsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchJournalEntryRecordingsFilter} SearchJournalEntryRecordingsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchJournalEntryRecordingsFilter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchJournalEntryRecordingsFilter();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.portfolio = reader.int32();
                break;
            case 2:
                message.ledger_account_id = reader.string();
                break;
            case 3:
                message.start_date = reader.string();
                break;
            case 4:
                message.end_date = reader.string();
                break;
            case 5:
                message.query = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchJournalEntryRecordingsFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchJournalEntryRecordingsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchJournalEntryRecordingsFilter} SearchJournalEntryRecordingsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchJournalEntryRecordingsFilter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchJournalEntryRecordingsFilter message.
     * @function verify
     * @memberof SearchJournalEntryRecordingsFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchJournalEntryRecordingsFilter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ledger_account_id != null && message.hasOwnProperty("ledger_account_id"))
            if (!$util.isString(message.ledger_account_id))
                return "ledger_account_id: string expected";
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            if (!$util.isString(message.start_date))
                return "start_date: string expected";
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            if (!$util.isString(message.end_date))
                return "end_date: string expected";
        if (message.query != null && message.hasOwnProperty("query"))
            if (!$util.isString(message.query))
                return "query: string expected";
        return null;
    };

    /**
     * Creates a SearchJournalEntryRecordingsFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchJournalEntryRecordingsFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchJournalEntryRecordingsFilter} SearchJournalEntryRecordingsFilter
     */
    SearchJournalEntryRecordingsFilter.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchJournalEntryRecordingsFilter)
            return object;
        let message = new $root.SearchJournalEntryRecordingsFilter();
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.ledger_account_id != null)
            message.ledger_account_id = String(object.ledger_account_id);
        if (object.start_date != null)
            message.start_date = String(object.start_date);
        if (object.end_date != null)
            message.end_date = String(object.end_date);
        if (object.query != null)
            message.query = String(object.query);
        return message;
    };

    /**
     * Creates a plain object from a SearchJournalEntryRecordingsFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchJournalEntryRecordingsFilter
     * @static
     * @param {SearchJournalEntryRecordingsFilter} message SearchJournalEntryRecordingsFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchJournalEntryRecordingsFilter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.ledger_account_id = "";
            object.start_date = "";
            object.end_date = "";
            object.query = "";
        }
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.ledger_account_id != null && message.hasOwnProperty("ledger_account_id"))
            object.ledger_account_id = message.ledger_account_id;
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            object.start_date = message.start_date;
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            object.end_date = message.end_date;
        if (message.query != null && message.hasOwnProperty("query"))
            object.query = message.query;
        return object;
    };

    /**
     * Converts this SearchJournalEntryRecordingsFilter to JSON.
     * @function toJSON
     * @memberof SearchJournalEntryRecordingsFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchJournalEntryRecordingsFilter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchJournalEntryRecordingsFilter;
})();

export const SearchJournalEntryRecordingsPageToken = $root.SearchJournalEntryRecordingsPageToken = (() => {

    /**
     * Properties of a SearchJournalEntryRecordingsPageToken.
     * @exports ISearchJournalEntryRecordingsPageToken
     * @interface ISearchJournalEntryRecordingsPageToken
     * @property {string|null} [from_journal_entry_transaction_date] SearchJournalEntryRecordingsPageToken from_journal_entry_transaction_date
     * @property {string|null} [from_id] SearchJournalEntryRecordingsPageToken from_id
     * @property {ISearchJournalEntryRecordingsFilter|null} [filter] SearchJournalEntryRecordingsPageToken filter
     */

    /**
     * Constructs a new SearchJournalEntryRecordingsPageToken.
     * @exports SearchJournalEntryRecordingsPageToken
     * @classdesc Represents a SearchJournalEntryRecordingsPageToken.
     * @implements ISearchJournalEntryRecordingsPageToken
     * @constructor
     * @param {ISearchJournalEntryRecordingsPageToken=} [properties] Properties to set
     */
    function SearchJournalEntryRecordingsPageToken(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchJournalEntryRecordingsPageToken from_journal_entry_transaction_date.
     * @member {string} from_journal_entry_transaction_date
     * @memberof SearchJournalEntryRecordingsPageToken
     * @instance
     */
    SearchJournalEntryRecordingsPageToken.prototype.from_journal_entry_transaction_date = "";

    /**
     * SearchJournalEntryRecordingsPageToken from_id.
     * @member {string} from_id
     * @memberof SearchJournalEntryRecordingsPageToken
     * @instance
     */
    SearchJournalEntryRecordingsPageToken.prototype.from_id = "";

    /**
     * SearchJournalEntryRecordingsPageToken filter.
     * @member {ISearchJournalEntryRecordingsFilter|null|undefined} filter
     * @memberof SearchJournalEntryRecordingsPageToken
     * @instance
     */
    SearchJournalEntryRecordingsPageToken.prototype.filter = null;

    /**
     * Creates a new SearchJournalEntryRecordingsPageToken instance using the specified properties.
     * @function create
     * @memberof SearchJournalEntryRecordingsPageToken
     * @static
     * @param {ISearchJournalEntryRecordingsPageToken=} [properties] Properties to set
     * @returns {SearchJournalEntryRecordingsPageToken} SearchJournalEntryRecordingsPageToken instance
     */
    SearchJournalEntryRecordingsPageToken.create = function create(properties) {
        return new SearchJournalEntryRecordingsPageToken(properties);
    };

    /**
     * Encodes the specified SearchJournalEntryRecordingsPageToken message. Does not implicitly {@link SearchJournalEntryRecordingsPageToken.verify|verify} messages.
     * @function encode
     * @memberof SearchJournalEntryRecordingsPageToken
     * @static
     * @param {ISearchJournalEntryRecordingsPageToken} message SearchJournalEntryRecordingsPageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchJournalEntryRecordingsPageToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.from_journal_entry_transaction_date != null && message.hasOwnProperty("from_journal_entry_transaction_date"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.from_journal_entry_transaction_date);
        if (message.from_id != null && message.hasOwnProperty("from_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.from_id);
        if (message.filter != null && message.hasOwnProperty("filter"))
            $root.SearchJournalEntryRecordingsFilter.encode(message.filter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SearchJournalEntryRecordingsPageToken message, length delimited. Does not implicitly {@link SearchJournalEntryRecordingsPageToken.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchJournalEntryRecordingsPageToken
     * @static
     * @param {ISearchJournalEntryRecordingsPageToken} message SearchJournalEntryRecordingsPageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchJournalEntryRecordingsPageToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchJournalEntryRecordingsPageToken message from the specified reader or buffer.
     * @function decode
     * @memberof SearchJournalEntryRecordingsPageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchJournalEntryRecordingsPageToken} SearchJournalEntryRecordingsPageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchJournalEntryRecordingsPageToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchJournalEntryRecordingsPageToken();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.from_journal_entry_transaction_date = reader.string();
                break;
            case 2:
                message.from_id = reader.string();
                break;
            case 3:
                message.filter = $root.SearchJournalEntryRecordingsFilter.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchJournalEntryRecordingsPageToken message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchJournalEntryRecordingsPageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchJournalEntryRecordingsPageToken} SearchJournalEntryRecordingsPageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchJournalEntryRecordingsPageToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchJournalEntryRecordingsPageToken message.
     * @function verify
     * @memberof SearchJournalEntryRecordingsPageToken
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchJournalEntryRecordingsPageToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.from_journal_entry_transaction_date != null && message.hasOwnProperty("from_journal_entry_transaction_date"))
            if (!$util.isString(message.from_journal_entry_transaction_date))
                return "from_journal_entry_transaction_date: string expected";
        if (message.from_id != null && message.hasOwnProperty("from_id"))
            if (!$util.isString(message.from_id))
                return "from_id: string expected";
        if (message.filter != null && message.hasOwnProperty("filter")) {
            let error = $root.SearchJournalEntryRecordingsFilter.verify(message.filter);
            if (error)
                return "filter." + error;
        }
        return null;
    };

    /**
     * Creates a SearchJournalEntryRecordingsPageToken message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchJournalEntryRecordingsPageToken
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchJournalEntryRecordingsPageToken} SearchJournalEntryRecordingsPageToken
     */
    SearchJournalEntryRecordingsPageToken.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchJournalEntryRecordingsPageToken)
            return object;
        let message = new $root.SearchJournalEntryRecordingsPageToken();
        if (object.from_journal_entry_transaction_date != null)
            message.from_journal_entry_transaction_date = String(object.from_journal_entry_transaction_date);
        if (object.from_id != null)
            message.from_id = String(object.from_id);
        if (object.filter != null) {
            if (typeof object.filter !== "object")
                throw TypeError(".SearchJournalEntryRecordingsPageToken.filter: object expected");
            message.filter = $root.SearchJournalEntryRecordingsFilter.fromObject(object.filter);
        }
        return message;
    };

    /**
     * Creates a plain object from a SearchJournalEntryRecordingsPageToken message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchJournalEntryRecordingsPageToken
     * @static
     * @param {SearchJournalEntryRecordingsPageToken} message SearchJournalEntryRecordingsPageToken
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchJournalEntryRecordingsPageToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.from_journal_entry_transaction_date = "";
            object.from_id = "";
            object.filter = null;
        }
        if (message.from_journal_entry_transaction_date != null && message.hasOwnProperty("from_journal_entry_transaction_date"))
            object.from_journal_entry_transaction_date = message.from_journal_entry_transaction_date;
        if (message.from_id != null && message.hasOwnProperty("from_id"))
            object.from_id = message.from_id;
        if (message.filter != null && message.hasOwnProperty("filter"))
            object.filter = $root.SearchJournalEntryRecordingsFilter.toObject(message.filter, options);
        return object;
    };

    /**
     * Converts this SearchJournalEntryRecordingsPageToken to JSON.
     * @function toJSON
     * @memberof SearchJournalEntryRecordingsPageToken
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchJournalEntryRecordingsPageToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchJournalEntryRecordingsPageToken;
})();

export const AccountingStatus = $root.AccountingStatus = (() => {

    /**
     * Properties of an AccountingStatus.
     * @exports IAccountingStatus
     * @interface IAccountingStatus
     */

    /**
     * Constructs a new AccountingStatus.
     * @exports AccountingStatus
     * @classdesc Represents an AccountingStatus.
     * @implements IAccountingStatus
     * @constructor
     * @param {IAccountingStatus=} [properties] Properties to set
     */
    function AccountingStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new AccountingStatus instance using the specified properties.
     * @function create
     * @memberof AccountingStatus
     * @static
     * @param {IAccountingStatus=} [properties] Properties to set
     * @returns {AccountingStatus} AccountingStatus instance
     */
    AccountingStatus.create = function create(properties) {
        return new AccountingStatus(properties);
    };

    /**
     * Encodes the specified AccountingStatus message. Does not implicitly {@link AccountingStatus.verify|verify} messages.
     * @function encode
     * @memberof AccountingStatus
     * @static
     * @param {IAccountingStatus} message AccountingStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified AccountingStatus message, length delimited. Does not implicitly {@link AccountingStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountingStatus
     * @static
     * @param {IAccountingStatus} message AccountingStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountingStatus message from the specified reader or buffer.
     * @function decode
     * @memberof AccountingStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountingStatus} AccountingStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountingStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountingStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountingStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountingStatus} AccountingStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountingStatus message.
     * @function verify
     * @memberof AccountingStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountingStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an AccountingStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountingStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountingStatus} AccountingStatus
     */
    AccountingStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountingStatus)
            return object;
        return new $root.AccountingStatus();
    };

    /**
     * Creates a plain object from an AccountingStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountingStatus
     * @static
     * @param {AccountingStatus} message AccountingStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountingStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this AccountingStatus to JSON.
     * @function toJSON
     * @memberof AccountingStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountingStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name AccountingStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PENDING=1 PENDING value
     * @property {number} UNCATEGORISED=2 UNCATEGORISED value
     * @property {number} CATEGORISED=3 CATEGORISED value
     * @property {number} NOT_APPLICABLE=4 NOT_APPLICABLE value
     */
    AccountingStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PENDING"] = 1;
        values[valuesById[2] = "UNCATEGORISED"] = 2;
        values[valuesById[3] = "CATEGORISED"] = 3;
        values[valuesById[4] = "NOT_APPLICABLE"] = 4;
        return values;
    })();

    return AccountingStatus;
})();

export const GeneratedABAFileStatus = $root.GeneratedABAFileStatus = (() => {

    /**
     * Properties of a GeneratedABAFileStatus.
     * @exports IGeneratedABAFileStatus
     * @interface IGeneratedABAFileStatus
     */

    /**
     * Constructs a new GeneratedABAFileStatus.
     * @exports GeneratedABAFileStatus
     * @classdesc Represents a GeneratedABAFileStatus.
     * @implements IGeneratedABAFileStatus
     * @constructor
     * @param {IGeneratedABAFileStatus=} [properties] Properties to set
     */
    function GeneratedABAFileStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new GeneratedABAFileStatus instance using the specified properties.
     * @function create
     * @memberof GeneratedABAFileStatus
     * @static
     * @param {IGeneratedABAFileStatus=} [properties] Properties to set
     * @returns {GeneratedABAFileStatus} GeneratedABAFileStatus instance
     */
    GeneratedABAFileStatus.create = function create(properties) {
        return new GeneratedABAFileStatus(properties);
    };

    /**
     * Encodes the specified GeneratedABAFileStatus message. Does not implicitly {@link GeneratedABAFileStatus.verify|verify} messages.
     * @function encode
     * @memberof GeneratedABAFileStatus
     * @static
     * @param {IGeneratedABAFileStatus} message GeneratedABAFileStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GeneratedABAFileStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified GeneratedABAFileStatus message, length delimited. Does not implicitly {@link GeneratedABAFileStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GeneratedABAFileStatus
     * @static
     * @param {IGeneratedABAFileStatus} message GeneratedABAFileStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GeneratedABAFileStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GeneratedABAFileStatus message from the specified reader or buffer.
     * @function decode
     * @memberof GeneratedABAFileStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GeneratedABAFileStatus} GeneratedABAFileStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GeneratedABAFileStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GeneratedABAFileStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GeneratedABAFileStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GeneratedABAFileStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GeneratedABAFileStatus} GeneratedABAFileStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GeneratedABAFileStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GeneratedABAFileStatus message.
     * @function verify
     * @memberof GeneratedABAFileStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GeneratedABAFileStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a GeneratedABAFileStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GeneratedABAFileStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GeneratedABAFileStatus} GeneratedABAFileStatus
     */
    GeneratedABAFileStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.GeneratedABAFileStatus)
            return object;
        return new $root.GeneratedABAFileStatus();
    };

    /**
     * Creates a plain object from a GeneratedABAFileStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GeneratedABAFileStatus
     * @static
     * @param {GeneratedABAFileStatus} message GeneratedABAFileStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GeneratedABAFileStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this GeneratedABAFileStatus to JSON.
     * @function toJSON
     * @memberof GeneratedABAFileStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GeneratedABAFileStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name GeneratedABAFileStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} OUTSTANDING=1 OUTSTANDING value
     * @property {number} ABANDONED=2 ABANDONED value
     * @property {number} UPLOADED=3 UPLOADED value
     */
    GeneratedABAFileStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "OUTSTANDING"] = 1;
        values[valuesById[2] = "ABANDONED"] = 2;
        values[valuesById[3] = "UPLOADED"] = 3;
        return values;
    })();

    return GeneratedABAFileStatus;
})();

export const GeneratedABAFile = $root.GeneratedABAFile = (() => {

    /**
     * Properties of a GeneratedABAFile.
     * @exports IGeneratedABAFile
     * @interface IGeneratedABAFile
     * @property {string|null} [id] GeneratedABAFile id
     * @property {GeneratedABAFileStatus.Enum|null} [status] GeneratedABAFile status
     * @property {ABAType.Enum|null} [type] GeneratedABAFile type
     * @property {string|null} [aud_amount] GeneratedABAFile aud_amount
     * @property {string|null} [file_name] GeneratedABAFile file_name
     * @property {string|null} [bank_account_number] GeneratedABAFile bank_account_number
     * @property {google.protobuf.ITimestamp|null} [created_at] GeneratedABAFile created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] GeneratedABAFile last_updated_at
     * @property {SaverPortfolio.Enum|null} [portfolio] GeneratedABAFile portfolio
     * @property {string|null} [created_by_admin_id] GeneratedABAFile created_by_admin_id
     * @property {IMacquariePaymentDetails|null} [macquarie_payment_details] GeneratedABAFile macquarie_payment_details
     * @property {FinancierProvider.Enum|null} [provider] GeneratedABAFile provider
     */

    /**
     * Constructs a new GeneratedABAFile.
     * @exports GeneratedABAFile
     * @classdesc Represents a GeneratedABAFile.
     * @implements IGeneratedABAFile
     * @constructor
     * @param {IGeneratedABAFile=} [properties] Properties to set
     */
    function GeneratedABAFile(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GeneratedABAFile id.
     * @member {string} id
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.id = "";

    /**
     * GeneratedABAFile status.
     * @member {GeneratedABAFileStatus.Enum} status
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.status = 0;

    /**
     * GeneratedABAFile type.
     * @member {ABAType.Enum} type
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.type = 0;

    /**
     * GeneratedABAFile aud_amount.
     * @member {string} aud_amount
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.aud_amount = "";

    /**
     * GeneratedABAFile file_name.
     * @member {string} file_name
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.file_name = "";

    /**
     * GeneratedABAFile bank_account_number.
     * @member {string} bank_account_number
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.bank_account_number = "";

    /**
     * GeneratedABAFile created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.created_at = null;

    /**
     * GeneratedABAFile last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.last_updated_at = null;

    /**
     * GeneratedABAFile portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.portfolio = 0;

    /**
     * GeneratedABAFile created_by_admin_id.
     * @member {string} created_by_admin_id
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.created_by_admin_id = "";

    /**
     * GeneratedABAFile macquarie_payment_details.
     * @member {IMacquariePaymentDetails|null|undefined} macquarie_payment_details
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.macquarie_payment_details = null;

    /**
     * GeneratedABAFile provider.
     * @member {FinancierProvider.Enum} provider
     * @memberof GeneratedABAFile
     * @instance
     */
    GeneratedABAFile.prototype.provider = 0;

    /**
     * Creates a new GeneratedABAFile instance using the specified properties.
     * @function create
     * @memberof GeneratedABAFile
     * @static
     * @param {IGeneratedABAFile=} [properties] Properties to set
     * @returns {GeneratedABAFile} GeneratedABAFile instance
     */
    GeneratedABAFile.create = function create(properties) {
        return new GeneratedABAFile(properties);
    };

    /**
     * Encodes the specified GeneratedABAFile message. Does not implicitly {@link GeneratedABAFile.verify|verify} messages.
     * @function encode
     * @memberof GeneratedABAFile
     * @static
     * @param {IGeneratedABAFile} message GeneratedABAFile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GeneratedABAFile.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.aud_amount);
        if (message.file_name != null && message.hasOwnProperty("file_name"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.file_name);
        if (message.bank_account_number != null && message.hasOwnProperty("bank_account_number"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.bank_account_number);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.portfolio);
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.created_by_admin_id);
        if (message.macquarie_payment_details != null && message.hasOwnProperty("macquarie_payment_details"))
            $root.MacquariePaymentDetails.encode(message.macquarie_payment_details, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.provider != null && message.hasOwnProperty("provider"))
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.provider);
        return writer;
    };

    /**
     * Encodes the specified GeneratedABAFile message, length delimited. Does not implicitly {@link GeneratedABAFile.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GeneratedABAFile
     * @static
     * @param {IGeneratedABAFile} message GeneratedABAFile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GeneratedABAFile.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GeneratedABAFile message from the specified reader or buffer.
     * @function decode
     * @memberof GeneratedABAFile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GeneratedABAFile} GeneratedABAFile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GeneratedABAFile.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GeneratedABAFile();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.status = reader.int32();
                break;
            case 3:
                message.type = reader.int32();
                break;
            case 4:
                message.aud_amount = reader.string();
                break;
            case 5:
                message.file_name = reader.string();
                break;
            case 6:
                message.bank_account_number = reader.string();
                break;
            case 7:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 8:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 9:
                message.portfolio = reader.int32();
                break;
            case 10:
                message.created_by_admin_id = reader.string();
                break;
            case 11:
                message.macquarie_payment_details = $root.MacquariePaymentDetails.decode(reader, reader.uint32());
                break;
            case 12:
                message.provider = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GeneratedABAFile message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GeneratedABAFile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GeneratedABAFile} GeneratedABAFile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GeneratedABAFile.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GeneratedABAFile message.
     * @function verify
     * @memberof GeneratedABAFile
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GeneratedABAFile.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                break;
            }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.file_name != null && message.hasOwnProperty("file_name"))
            if (!$util.isString(message.file_name))
                return "file_name: string expected";
        if (message.bank_account_number != null && message.hasOwnProperty("bank_account_number"))
            if (!$util.isString(message.bank_account_number))
                return "bank_account_number: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            if (!$util.isString(message.created_by_admin_id))
                return "created_by_admin_id: string expected";
        if (message.macquarie_payment_details != null && message.hasOwnProperty("macquarie_payment_details")) {
            let error = $root.MacquariePaymentDetails.verify(message.macquarie_payment_details);
            if (error)
                return "macquarie_payment_details." + error;
        }
        if (message.provider != null && message.hasOwnProperty("provider"))
            switch (message.provider) {
            default:
                return "provider: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates a GeneratedABAFile message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GeneratedABAFile
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GeneratedABAFile} GeneratedABAFile
     */
    GeneratedABAFile.fromObject = function fromObject(object) {
        if (object instanceof $root.GeneratedABAFile)
            return object;
        let message = new $root.GeneratedABAFile();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "OUTSTANDING":
        case 1:
            message.status = 1;
            break;
        case "ABANDONED":
        case 2:
            message.status = 2;
            break;
        case "UPLOADED":
        case 3:
            message.status = 3;
            break;
        }
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "CUSTOMER_TO_SUSPENSE":
        case 1:
            message.type = 1;
            break;
        case "SUSPENSE_TO_FUND":
        case 2:
            message.type = 2;
            break;
        case "FUND_TO_SUSPENSE":
        case 3:
            message.type = 3;
            break;
        case "SUSPENSE_TO_CUSTOMER":
        case 4:
            message.type = 4;
            break;
        case "FUND_TO_EXTERNAL":
        case 5:
            message.type = 5;
            break;
        case "FUND_TO_CUSTOMER":
        case 6:
            message.type = 6;
            break;
        case "REFERRALS_TO_FUND":
        case 7:
            message.type = 7;
            break;
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        if (object.file_name != null)
            message.file_name = String(object.file_name);
        if (object.bank_account_number != null)
            message.bank_account_number = String(object.bank_account_number);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".GeneratedABAFile.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".GeneratedABAFile.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.created_by_admin_id != null)
            message.created_by_admin_id = String(object.created_by_admin_id);
        if (object.macquarie_payment_details != null) {
            if (typeof object.macquarie_payment_details !== "object")
                throw TypeError(".GeneratedABAFile.macquarie_payment_details: object expected");
            message.macquarie_payment_details = $root.MacquariePaymentDetails.fromObject(object.macquarie_payment_details);
        }
        switch (object.provider) {
        case "UNKNOWN":
        case 0:
            message.provider = 0;
            break;
        case "MACQUARIE":
        case 1:
            message.provider = 1;
            break;
        case "ZEPTO":
        case 2:
            message.provider = 2;
            break;
        case "WESTPAC":
        case 3:
            message.provider = 3;
            break;
        case "MONEY":
        case 4:
            message.provider = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a GeneratedABAFile message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GeneratedABAFile
     * @static
     * @param {GeneratedABAFile} message GeneratedABAFile
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GeneratedABAFile.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.aud_amount = "";
            object.file_name = "";
            object.bank_account_number = "";
            object.created_at = null;
            object.last_updated_at = null;
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.created_by_admin_id = "";
            object.macquarie_payment_details = null;
            object.provider = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.GeneratedABAFileStatus.Enum[message.status] : message.status;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.ABAType.Enum[message.type] : message.type;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.file_name != null && message.hasOwnProperty("file_name"))
            object.file_name = message.file_name;
        if (message.bank_account_number != null && message.hasOwnProperty("bank_account_number"))
            object.bank_account_number = message.bank_account_number;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            object.created_by_admin_id = message.created_by_admin_id;
        if (message.macquarie_payment_details != null && message.hasOwnProperty("macquarie_payment_details"))
            object.macquarie_payment_details = $root.MacquariePaymentDetails.toObject(message.macquarie_payment_details, options);
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = options.enums === String ? $root.FinancierProvider.Enum[message.provider] : message.provider;
        return object;
    };

    /**
     * Converts this GeneratedABAFile to JSON.
     * @function toJSON
     * @memberof GeneratedABAFile
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GeneratedABAFile.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GeneratedABAFile;
})();

export const MacquariePaymentDetails = $root.MacquariePaymentDetails = (() => {

    /**
     * Properties of a MacquariePaymentDetails.
     * @exports IMacquariePaymentDetails
     * @interface IMacquariePaymentDetails
     * @property {string|null} [id] MacquariePaymentDetails id
     * @property {MacquariePaymentDetails.Status.Enum|null} [status] MacquariePaymentDetails status
     * @property {Array.<string>|null} [warnings] MacquariePaymentDetails warnings
     * @property {Array.<string>|null} [errors] MacquariePaymentDetails errors
     */

    /**
     * Constructs a new MacquariePaymentDetails.
     * @exports MacquariePaymentDetails
     * @classdesc Represents a MacquariePaymentDetails.
     * @implements IMacquariePaymentDetails
     * @constructor
     * @param {IMacquariePaymentDetails=} [properties] Properties to set
     */
    function MacquariePaymentDetails(properties) {
        this.warnings = [];
        this.errors = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MacquariePaymentDetails id.
     * @member {string} id
     * @memberof MacquariePaymentDetails
     * @instance
     */
    MacquariePaymentDetails.prototype.id = "";

    /**
     * MacquariePaymentDetails status.
     * @member {MacquariePaymentDetails.Status.Enum} status
     * @memberof MacquariePaymentDetails
     * @instance
     */
    MacquariePaymentDetails.prototype.status = 0;

    /**
     * MacquariePaymentDetails warnings.
     * @member {Array.<string>} warnings
     * @memberof MacquariePaymentDetails
     * @instance
     */
    MacquariePaymentDetails.prototype.warnings = $util.emptyArray;

    /**
     * MacquariePaymentDetails errors.
     * @member {Array.<string>} errors
     * @memberof MacquariePaymentDetails
     * @instance
     */
    MacquariePaymentDetails.prototype.errors = $util.emptyArray;

    /**
     * Creates a new MacquariePaymentDetails instance using the specified properties.
     * @function create
     * @memberof MacquariePaymentDetails
     * @static
     * @param {IMacquariePaymentDetails=} [properties] Properties to set
     * @returns {MacquariePaymentDetails} MacquariePaymentDetails instance
     */
    MacquariePaymentDetails.create = function create(properties) {
        return new MacquariePaymentDetails(properties);
    };

    /**
     * Encodes the specified MacquariePaymentDetails message. Does not implicitly {@link MacquariePaymentDetails.verify|verify} messages.
     * @function encode
     * @memberof MacquariePaymentDetails
     * @static
     * @param {IMacquariePaymentDetails} message MacquariePaymentDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MacquariePaymentDetails.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
        if (message.warnings != null && message.warnings.length)
            for (let i = 0; i < message.warnings.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.warnings[i]);
        if (message.errors != null && message.errors.length)
            for (let i = 0; i < message.errors.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.errors[i]);
        return writer;
    };

    /**
     * Encodes the specified MacquariePaymentDetails message, length delimited. Does not implicitly {@link MacquariePaymentDetails.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MacquariePaymentDetails
     * @static
     * @param {IMacquariePaymentDetails} message MacquariePaymentDetails message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MacquariePaymentDetails.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MacquariePaymentDetails message from the specified reader or buffer.
     * @function decode
     * @memberof MacquariePaymentDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MacquariePaymentDetails} MacquariePaymentDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MacquariePaymentDetails.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MacquariePaymentDetails();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.status = reader.int32();
                break;
            case 3:
                if (!(message.warnings && message.warnings.length))
                    message.warnings = [];
                message.warnings.push(reader.string());
                break;
            case 4:
                if (!(message.errors && message.errors.length))
                    message.errors = [];
                message.errors.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MacquariePaymentDetails message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MacquariePaymentDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MacquariePaymentDetails} MacquariePaymentDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MacquariePaymentDetails.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MacquariePaymentDetails message.
     * @function verify
     * @memberof MacquariePaymentDetails
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MacquariePaymentDetails.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
                break;
            }
        if (message.warnings != null && message.hasOwnProperty("warnings")) {
            if (!Array.isArray(message.warnings))
                return "warnings: array expected";
            for (let i = 0; i < message.warnings.length; ++i)
                if (!$util.isString(message.warnings[i]))
                    return "warnings: string[] expected";
        }
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (let i = 0; i < message.errors.length; ++i)
                if (!$util.isString(message.errors[i]))
                    return "errors: string[] expected";
        }
        return null;
    };

    /**
     * Creates a MacquariePaymentDetails message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MacquariePaymentDetails
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MacquariePaymentDetails} MacquariePaymentDetails
     */
    MacquariePaymentDetails.fromObject = function fromObject(object) {
        if (object instanceof $root.MacquariePaymentDetails)
            return object;
        let message = new $root.MacquariePaymentDetails();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "NO_STATUS":
        case 1:
            message.status = 1;
            break;
        case "PENDING_AUTH":
        case 2:
            message.status = 2;
            break;
        case "PARTIALLY_AUTH":
        case 3:
            message.status = 3;
            break;
        case "PENDING_MBL_AUTH":
        case 4:
            message.status = 4;
            break;
        case "AUTHORISED":
        case 5:
            message.status = 5;
            break;
        case "EXPIRED":
        case 6:
            message.status = 6;
            break;
        case "DELETED":
        case 7:
            message.status = 7;
            break;
        case "DECLINED":
        case 8:
            message.status = 8;
            break;
        case "AUTH_PENDING_BALANCE":
        case 9:
            message.status = 9;
            break;
        case "UPLOAD_ERRORS":
        case 10:
            message.status = 10;
            break;
        case "PENDING_ACCEPT":
        case 11:
            message.status = 11;
            break;
        case "POSTING_ERROR":
        case 12:
            message.status = 12;
            break;
        case "UPLOAD_IN_PROGRESS":
        case 13:
            message.status = 13;
            break;
        }
        if (object.warnings) {
            if (!Array.isArray(object.warnings))
                throw TypeError(".MacquariePaymentDetails.warnings: array expected");
            message.warnings = [];
            for (let i = 0; i < object.warnings.length; ++i)
                message.warnings[i] = String(object.warnings[i]);
        }
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".MacquariePaymentDetails.errors: array expected");
            message.errors = [];
            for (let i = 0; i < object.errors.length; ++i)
                message.errors[i] = String(object.errors[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a MacquariePaymentDetails message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MacquariePaymentDetails
     * @static
     * @param {MacquariePaymentDetails} message MacquariePaymentDetails
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MacquariePaymentDetails.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.warnings = [];
            object.errors = [];
        }
        if (options.defaults) {
            object.id = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.MacquariePaymentDetails.Status.Enum[message.status] : message.status;
        if (message.warnings && message.warnings.length) {
            object.warnings = [];
            for (let j = 0; j < message.warnings.length; ++j)
                object.warnings[j] = message.warnings[j];
        }
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (let j = 0; j < message.errors.length; ++j)
                object.errors[j] = message.errors[j];
        }
        return object;
    };

    /**
     * Converts this MacquariePaymentDetails to JSON.
     * @function toJSON
     * @memberof MacquariePaymentDetails
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MacquariePaymentDetails.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MacquariePaymentDetails.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof MacquariePaymentDetails
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof MacquariePaymentDetails
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {MacquariePaymentDetails.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof MacquariePaymentDetails.Status
         * @static
         * @param {MacquariePaymentDetails.IStatus=} [properties] Properties to set
         * @returns {MacquariePaymentDetails.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link MacquariePaymentDetails.Status.verify|verify} messages.
         * @function encode
         * @memberof MacquariePaymentDetails.Status
         * @static
         * @param {MacquariePaymentDetails.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link MacquariePaymentDetails.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof MacquariePaymentDetails.Status
         * @static
         * @param {MacquariePaymentDetails.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof MacquariePaymentDetails.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {MacquariePaymentDetails.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MacquariePaymentDetails.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof MacquariePaymentDetails.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {MacquariePaymentDetails.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof MacquariePaymentDetails.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof MacquariePaymentDetails.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {MacquariePaymentDetails.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.MacquariePaymentDetails.Status)
                return object;
            return new $root.MacquariePaymentDetails.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof MacquariePaymentDetails.Status
         * @static
         * @param {MacquariePaymentDetails.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof MacquariePaymentDetails.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name MacquariePaymentDetails.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} NO_STATUS=1 NO_STATUS value
         * @property {number} PENDING_AUTH=2 PENDING_AUTH value
         * @property {number} PARTIALLY_AUTH=3 PARTIALLY_AUTH value
         * @property {number} PENDING_MBL_AUTH=4 PENDING_MBL_AUTH value
         * @property {number} AUTHORISED=5 AUTHORISED value
         * @property {number} EXPIRED=6 EXPIRED value
         * @property {number} DELETED=7 DELETED value
         * @property {number} DECLINED=8 DECLINED value
         * @property {number} AUTH_PENDING_BALANCE=9 AUTH_PENDING_BALANCE value
         * @property {number} UPLOAD_ERRORS=10 UPLOAD_ERRORS value
         * @property {number} PENDING_ACCEPT=11 PENDING_ACCEPT value
         * @property {number} POSTING_ERROR=12 POSTING_ERROR value
         * @property {number} UPLOAD_IN_PROGRESS=13 UPLOAD_IN_PROGRESS value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "NO_STATUS"] = 1;
            values[valuesById[2] = "PENDING_AUTH"] = 2;
            values[valuesById[3] = "PARTIALLY_AUTH"] = 3;
            values[valuesById[4] = "PENDING_MBL_AUTH"] = 4;
            values[valuesById[5] = "AUTHORISED"] = 5;
            values[valuesById[6] = "EXPIRED"] = 6;
            values[valuesById[7] = "DELETED"] = 7;
            values[valuesById[8] = "DECLINED"] = 8;
            values[valuesById[9] = "AUTH_PENDING_BALANCE"] = 9;
            values[valuesById[10] = "UPLOAD_ERRORS"] = 10;
            values[valuesById[11] = "PENDING_ACCEPT"] = 11;
            values[valuesById[12] = "POSTING_ERROR"] = 12;
            values[valuesById[13] = "UPLOAD_IN_PROGRESS"] = 13;
            return values;
        })();

        return Status;
    })();

    return MacquariePaymentDetails;
})();

export const TFNExemptionCode = $root.TFNExemptionCode = (() => {

    /**
     * Properties of a TFNExemptionCode.
     * @exports ITFNExemptionCode
     * @interface ITFNExemptionCode
     */

    /**
     * Constructs a new TFNExemptionCode.
     * @exports TFNExemptionCode
     * @classdesc Represents a TFNExemptionCode.
     * @implements ITFNExemptionCode
     * @constructor
     * @param {ITFNExemptionCode=} [properties] Properties to set
     */
    function TFNExemptionCode(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new TFNExemptionCode instance using the specified properties.
     * @function create
     * @memberof TFNExemptionCode
     * @static
     * @param {ITFNExemptionCode=} [properties] Properties to set
     * @returns {TFNExemptionCode} TFNExemptionCode instance
     */
    TFNExemptionCode.create = function create(properties) {
        return new TFNExemptionCode(properties);
    };

    /**
     * Encodes the specified TFNExemptionCode message. Does not implicitly {@link TFNExemptionCode.verify|verify} messages.
     * @function encode
     * @memberof TFNExemptionCode
     * @static
     * @param {ITFNExemptionCode} message TFNExemptionCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TFNExemptionCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified TFNExemptionCode message, length delimited. Does not implicitly {@link TFNExemptionCode.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TFNExemptionCode
     * @static
     * @param {ITFNExemptionCode} message TFNExemptionCode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TFNExemptionCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TFNExemptionCode message from the specified reader or buffer.
     * @function decode
     * @memberof TFNExemptionCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TFNExemptionCode} TFNExemptionCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TFNExemptionCode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TFNExemptionCode();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TFNExemptionCode message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TFNExemptionCode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TFNExemptionCode} TFNExemptionCode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TFNExemptionCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TFNExemptionCode message.
     * @function verify
     * @memberof TFNExemptionCode
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TFNExemptionCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a TFNExemptionCode message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TFNExemptionCode
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TFNExemptionCode} TFNExemptionCode
     */
    TFNExemptionCode.fromObject = function fromObject(object) {
        if (object instanceof $root.TFNExemptionCode)
            return object;
        return new $root.TFNExemptionCode();
    };

    /**
     * Creates a plain object from a TFNExemptionCode message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TFNExemptionCode
     * @static
     * @param {TFNExemptionCode} message TFNExemptionCode
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TFNExemptionCode.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this TFNExemptionCode to JSON.
     * @function toJSON
     * @memberof TFNExemptionCode
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TFNExemptionCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name TFNExemptionCode.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PENSIONER=1 PENSIONER value
     * @property {number} CENTRELINK=2 CENTRELINK value
     * @property {number} UNDER_16=3 UNDER_16 value
     * @property {number} ENTITY_NOT_REQUIRED=4 ENTITY_NOT_REQUIRED value
     * @property {number} BUSINESS_INVESTOR=5 BUSINESS_INVESTOR value
     * @property {number} NON_RESIDENT=6 NON_RESIDENT value
     * @property {number} NOT_AN_ABN=7 NOT_AN_ABN value
     */
    TFNExemptionCode.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PENSIONER"] = 1;
        values[valuesById[2] = "CENTRELINK"] = 2;
        values[valuesById[3] = "UNDER_16"] = 3;
        values[valuesById[4] = "ENTITY_NOT_REQUIRED"] = 4;
        values[valuesById[5] = "BUSINESS_INVESTOR"] = 5;
        values[valuesById[6] = "NON_RESIDENT"] = 6;
        values[valuesById[7] = "NOT_AN_ABN"] = 7;
        return values;
    })();

    return TFNExemptionCode;
})();

export const TFNExemption = $root.TFNExemption = (() => {

    /**
     * Properties of a TFNExemption.
     * @exports ITFNExemption
     * @interface ITFNExemption
     * @property {string|null} [id] TFNExemption id
     * @property {string|null} [product_id] TFNExemption product_id
     * @property {TFNExemptionCode.Enum|null} [code] TFNExemption code
     * @property {boolean|null} [active] TFNExemption active
     * @property {google.protobuf.ITimestamp|null} [created_at] TFNExemption created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] TFNExemption last_updated_at
     */

    /**
     * Constructs a new TFNExemption.
     * @exports TFNExemption
     * @classdesc Represents a TFNExemption.
     * @implements ITFNExemption
     * @constructor
     * @param {ITFNExemption=} [properties] Properties to set
     */
    function TFNExemption(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TFNExemption id.
     * @member {string} id
     * @memberof TFNExemption
     * @instance
     */
    TFNExemption.prototype.id = "";

    /**
     * TFNExemption product_id.
     * @member {string} product_id
     * @memberof TFNExemption
     * @instance
     */
    TFNExemption.prototype.product_id = "";

    /**
     * TFNExemption code.
     * @member {TFNExemptionCode.Enum} code
     * @memberof TFNExemption
     * @instance
     */
    TFNExemption.prototype.code = 0;

    /**
     * TFNExemption active.
     * @member {boolean} active
     * @memberof TFNExemption
     * @instance
     */
    TFNExemption.prototype.active = false;

    /**
     * TFNExemption created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof TFNExemption
     * @instance
     */
    TFNExemption.prototype.created_at = null;

    /**
     * TFNExemption last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof TFNExemption
     * @instance
     */
    TFNExemption.prototype.last_updated_at = null;

    /**
     * Creates a new TFNExemption instance using the specified properties.
     * @function create
     * @memberof TFNExemption
     * @static
     * @param {ITFNExemption=} [properties] Properties to set
     * @returns {TFNExemption} TFNExemption instance
     */
    TFNExemption.create = function create(properties) {
        return new TFNExemption(properties);
    };

    /**
     * Encodes the specified TFNExemption message. Does not implicitly {@link TFNExemption.verify|verify} messages.
     * @function encode
     * @memberof TFNExemption
     * @static
     * @param {ITFNExemption} message TFNExemption message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TFNExemption.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.product_id);
        if (message.code != null && message.hasOwnProperty("code"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.code);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.active);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TFNExemption message, length delimited. Does not implicitly {@link TFNExemption.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TFNExemption
     * @static
     * @param {ITFNExemption} message TFNExemption message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TFNExemption.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TFNExemption message from the specified reader or buffer.
     * @function decode
     * @memberof TFNExemption
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TFNExemption} TFNExemption
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TFNExemption.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TFNExemption();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.product_id = reader.string();
                break;
            case 3:
                message.code = reader.int32();
                break;
            case 4:
                message.active = reader.bool();
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TFNExemption message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TFNExemption
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TFNExemption} TFNExemption
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TFNExemption.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TFNExemption message.
     * @function verify
     * @memberof TFNExemption
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TFNExemption.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.code != null && message.hasOwnProperty("code"))
            switch (message.code) {
            default:
                return "code: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                break;
            }
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a TFNExemption message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TFNExemption
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TFNExemption} TFNExemption
     */
    TFNExemption.fromObject = function fromObject(object) {
        if (object instanceof $root.TFNExemption)
            return object;
        let message = new $root.TFNExemption();
        if (object.id != null)
            message.id = String(object.id);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        switch (object.code) {
        case "UNKNOWN":
        case 0:
            message.code = 0;
            break;
        case "PENSIONER":
        case 1:
            message.code = 1;
            break;
        case "CENTRELINK":
        case 2:
            message.code = 2;
            break;
        case "UNDER_16":
        case 3:
            message.code = 3;
            break;
        case "ENTITY_NOT_REQUIRED":
        case 4:
            message.code = 4;
            break;
        case "BUSINESS_INVESTOR":
        case 5:
            message.code = 5;
            break;
        case "NON_RESIDENT":
        case 6:
            message.code = 6;
            break;
        case "NOT_AN_ABN":
        case 7:
            message.code = 7;
            break;
        }
        if (object.active != null)
            message.active = Boolean(object.active);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".TFNExemption.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".TFNExemption.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a TFNExemption message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TFNExemption
     * @static
     * @param {TFNExemption} message TFNExemption
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TFNExemption.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.product_id = "";
            object.code = options.enums === String ? "UNKNOWN" : 0;
            object.active = false;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = options.enums === String ? $root.TFNExemptionCode.Enum[message.code] : message.code;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this TFNExemption to JSON.
     * @function toJSON
     * @memberof TFNExemption
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TFNExemption.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TFNExemption;
})();

export const SearchAccountingTransactionsFilter = $root.SearchAccountingTransactionsFilter = (() => {

    /**
     * Properties of a SearchAccountingTransactionsFilter.
     * @exports ISearchAccountingTransactionsFilter
     * @interface ISearchAccountingTransactionsFilter
     * @property {SaverPortfolio.Enum|null} [portfolio] SearchAccountingTransactionsFilter portfolio
     * @property {AccountingStatus.Enum|null} [accounting_status] SearchAccountingTransactionsFilter accounting_status
     * @property {string|null} [start_date] SearchAccountingTransactionsFilter start_date
     * @property {string|null} [end_date] SearchAccountingTransactionsFilter end_date
     * @property {string|null} [query] SearchAccountingTransactionsFilter query
     * @property {AccountingReconciliationStatus.Enum|null} [reconciliation_status] SearchAccountingTransactionsFilter reconciliation_status
     */

    /**
     * Constructs a new SearchAccountingTransactionsFilter.
     * @exports SearchAccountingTransactionsFilter
     * @classdesc Represents a SearchAccountingTransactionsFilter.
     * @implements ISearchAccountingTransactionsFilter
     * @constructor
     * @param {ISearchAccountingTransactionsFilter=} [properties] Properties to set
     */
    function SearchAccountingTransactionsFilter(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchAccountingTransactionsFilter portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof SearchAccountingTransactionsFilter
     * @instance
     */
    SearchAccountingTransactionsFilter.prototype.portfolio = 0;

    /**
     * SearchAccountingTransactionsFilter accounting_status.
     * @member {AccountingStatus.Enum} accounting_status
     * @memberof SearchAccountingTransactionsFilter
     * @instance
     */
    SearchAccountingTransactionsFilter.prototype.accounting_status = 0;

    /**
     * SearchAccountingTransactionsFilter start_date.
     * @member {string} start_date
     * @memberof SearchAccountingTransactionsFilter
     * @instance
     */
    SearchAccountingTransactionsFilter.prototype.start_date = "";

    /**
     * SearchAccountingTransactionsFilter end_date.
     * @member {string} end_date
     * @memberof SearchAccountingTransactionsFilter
     * @instance
     */
    SearchAccountingTransactionsFilter.prototype.end_date = "";

    /**
     * SearchAccountingTransactionsFilter query.
     * @member {string} query
     * @memberof SearchAccountingTransactionsFilter
     * @instance
     */
    SearchAccountingTransactionsFilter.prototype.query = "";

    /**
     * SearchAccountingTransactionsFilter reconciliation_status.
     * @member {AccountingReconciliationStatus.Enum} reconciliation_status
     * @memberof SearchAccountingTransactionsFilter
     * @instance
     */
    SearchAccountingTransactionsFilter.prototype.reconciliation_status = 0;

    /**
     * Creates a new SearchAccountingTransactionsFilter instance using the specified properties.
     * @function create
     * @memberof SearchAccountingTransactionsFilter
     * @static
     * @param {ISearchAccountingTransactionsFilter=} [properties] Properties to set
     * @returns {SearchAccountingTransactionsFilter} SearchAccountingTransactionsFilter instance
     */
    SearchAccountingTransactionsFilter.create = function create(properties) {
        return new SearchAccountingTransactionsFilter(properties);
    };

    /**
     * Encodes the specified SearchAccountingTransactionsFilter message. Does not implicitly {@link SearchAccountingTransactionsFilter.verify|verify} messages.
     * @function encode
     * @memberof SearchAccountingTransactionsFilter
     * @static
     * @param {ISearchAccountingTransactionsFilter} message SearchAccountingTransactionsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchAccountingTransactionsFilter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.accounting_status);
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.start_date);
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.end_date);
        if (message.query != null && message.hasOwnProperty("query"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.query);
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.reconciliation_status);
        return writer;
    };

    /**
     * Encodes the specified SearchAccountingTransactionsFilter message, length delimited. Does not implicitly {@link SearchAccountingTransactionsFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchAccountingTransactionsFilter
     * @static
     * @param {ISearchAccountingTransactionsFilter} message SearchAccountingTransactionsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchAccountingTransactionsFilter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchAccountingTransactionsFilter message from the specified reader or buffer.
     * @function decode
     * @memberof SearchAccountingTransactionsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchAccountingTransactionsFilter} SearchAccountingTransactionsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchAccountingTransactionsFilter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchAccountingTransactionsFilter();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.portfolio = reader.int32();
                break;
            case 2:
                message.accounting_status = reader.int32();
                break;
            case 3:
                message.start_date = reader.string();
                break;
            case 4:
                message.end_date = reader.string();
                break;
            case 5:
                message.query = reader.string();
                break;
            case 6:
                message.reconciliation_status = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchAccountingTransactionsFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchAccountingTransactionsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchAccountingTransactionsFilter} SearchAccountingTransactionsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchAccountingTransactionsFilter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchAccountingTransactionsFilter message.
     * @function verify
     * @memberof SearchAccountingTransactionsFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchAccountingTransactionsFilter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            switch (message.accounting_status) {
            default:
                return "accounting_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            if (!$util.isString(message.start_date))
                return "start_date: string expected";
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            if (!$util.isString(message.end_date))
                return "end_date: string expected";
        if (message.query != null && message.hasOwnProperty("query"))
            if (!$util.isString(message.query))
                return "query: string expected";
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            switch (message.reconciliation_status) {
            default:
                return "reconciliation_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates a SearchAccountingTransactionsFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchAccountingTransactionsFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchAccountingTransactionsFilter} SearchAccountingTransactionsFilter
     */
    SearchAccountingTransactionsFilter.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchAccountingTransactionsFilter)
            return object;
        let message = new $root.SearchAccountingTransactionsFilter();
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        switch (object.accounting_status) {
        case "UNKNOWN":
        case 0:
            message.accounting_status = 0;
            break;
        case "PENDING":
        case 1:
            message.accounting_status = 1;
            break;
        case "UNCATEGORISED":
        case 2:
            message.accounting_status = 2;
            break;
        case "CATEGORISED":
        case 3:
            message.accounting_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.accounting_status = 4;
            break;
        }
        if (object.start_date != null)
            message.start_date = String(object.start_date);
        if (object.end_date != null)
            message.end_date = String(object.end_date);
        if (object.query != null)
            message.query = String(object.query);
        switch (object.reconciliation_status) {
        case "UNKNOWN":
        case 0:
            message.reconciliation_status = 0;
            break;
        case "PENDING":
        case 1:
            message.reconciliation_status = 1;
            break;
        case "RECONCILED":
        case 2:
            message.reconciliation_status = 2;
            break;
        case "UNRECONCILED":
        case 3:
            message.reconciliation_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.reconciliation_status = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a SearchAccountingTransactionsFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchAccountingTransactionsFilter
     * @static
     * @param {SearchAccountingTransactionsFilter} message SearchAccountingTransactionsFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchAccountingTransactionsFilter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.accounting_status = options.enums === String ? "UNKNOWN" : 0;
            object.start_date = "";
            object.end_date = "";
            object.query = "";
            object.reconciliation_status = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            object.accounting_status = options.enums === String ? $root.AccountingStatus.Enum[message.accounting_status] : message.accounting_status;
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            object.start_date = message.start_date;
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            object.end_date = message.end_date;
        if (message.query != null && message.hasOwnProperty("query"))
            object.query = message.query;
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            object.reconciliation_status = options.enums === String ? $root.AccountingReconciliationStatus.Enum[message.reconciliation_status] : message.reconciliation_status;
        return object;
    };

    /**
     * Converts this SearchAccountingTransactionsFilter to JSON.
     * @function toJSON
     * @memberof SearchAccountingTransactionsFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchAccountingTransactionsFilter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchAccountingTransactionsFilter;
})();

export const SearchAccountingTransactionsPageToken = $root.SearchAccountingTransactionsPageToken = (() => {

    /**
     * Properties of a SearchAccountingTransactionsPageToken.
     * @exports ISearchAccountingTransactionsPageToken
     * @interface ISearchAccountingTransactionsPageToken
     * @property {google.protobuf.ITimestamp|null} [from_created_at] SearchAccountingTransactionsPageToken from_created_at
     * @property {string|null} [from_transaction_reference] SearchAccountingTransactionsPageToken from_transaction_reference
     * @property {ISearchAccountingTransactionsFilter|null} [filter] SearchAccountingTransactionsPageToken filter
     */

    /**
     * Constructs a new SearchAccountingTransactionsPageToken.
     * @exports SearchAccountingTransactionsPageToken
     * @classdesc Represents a SearchAccountingTransactionsPageToken.
     * @implements ISearchAccountingTransactionsPageToken
     * @constructor
     * @param {ISearchAccountingTransactionsPageToken=} [properties] Properties to set
     */
    function SearchAccountingTransactionsPageToken(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchAccountingTransactionsPageToken from_created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} from_created_at
     * @memberof SearchAccountingTransactionsPageToken
     * @instance
     */
    SearchAccountingTransactionsPageToken.prototype.from_created_at = null;

    /**
     * SearchAccountingTransactionsPageToken from_transaction_reference.
     * @member {string} from_transaction_reference
     * @memberof SearchAccountingTransactionsPageToken
     * @instance
     */
    SearchAccountingTransactionsPageToken.prototype.from_transaction_reference = "";

    /**
     * SearchAccountingTransactionsPageToken filter.
     * @member {ISearchAccountingTransactionsFilter|null|undefined} filter
     * @memberof SearchAccountingTransactionsPageToken
     * @instance
     */
    SearchAccountingTransactionsPageToken.prototype.filter = null;

    /**
     * Creates a new SearchAccountingTransactionsPageToken instance using the specified properties.
     * @function create
     * @memberof SearchAccountingTransactionsPageToken
     * @static
     * @param {ISearchAccountingTransactionsPageToken=} [properties] Properties to set
     * @returns {SearchAccountingTransactionsPageToken} SearchAccountingTransactionsPageToken instance
     */
    SearchAccountingTransactionsPageToken.create = function create(properties) {
        return new SearchAccountingTransactionsPageToken(properties);
    };

    /**
     * Encodes the specified SearchAccountingTransactionsPageToken message. Does not implicitly {@link SearchAccountingTransactionsPageToken.verify|verify} messages.
     * @function encode
     * @memberof SearchAccountingTransactionsPageToken
     * @static
     * @param {ISearchAccountingTransactionsPageToken} message SearchAccountingTransactionsPageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchAccountingTransactionsPageToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.from_created_at != null && message.hasOwnProperty("from_created_at"))
            $root.google.protobuf.Timestamp.encode(message.from_created_at, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.from_transaction_reference != null && message.hasOwnProperty("from_transaction_reference"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.from_transaction_reference);
        if (message.filter != null && message.hasOwnProperty("filter"))
            $root.SearchAccountingTransactionsFilter.encode(message.filter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SearchAccountingTransactionsPageToken message, length delimited. Does not implicitly {@link SearchAccountingTransactionsPageToken.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchAccountingTransactionsPageToken
     * @static
     * @param {ISearchAccountingTransactionsPageToken} message SearchAccountingTransactionsPageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchAccountingTransactionsPageToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchAccountingTransactionsPageToken message from the specified reader or buffer.
     * @function decode
     * @memberof SearchAccountingTransactionsPageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchAccountingTransactionsPageToken} SearchAccountingTransactionsPageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchAccountingTransactionsPageToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchAccountingTransactionsPageToken();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.from_created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 2:
                message.from_transaction_reference = reader.string();
                break;
            case 3:
                message.filter = $root.SearchAccountingTransactionsFilter.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchAccountingTransactionsPageToken message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchAccountingTransactionsPageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchAccountingTransactionsPageToken} SearchAccountingTransactionsPageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchAccountingTransactionsPageToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchAccountingTransactionsPageToken message.
     * @function verify
     * @memberof SearchAccountingTransactionsPageToken
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchAccountingTransactionsPageToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.from_created_at != null && message.hasOwnProperty("from_created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.from_created_at);
            if (error)
                return "from_created_at." + error;
        }
        if (message.from_transaction_reference != null && message.hasOwnProperty("from_transaction_reference"))
            if (!$util.isString(message.from_transaction_reference))
                return "from_transaction_reference: string expected";
        if (message.filter != null && message.hasOwnProperty("filter")) {
            let error = $root.SearchAccountingTransactionsFilter.verify(message.filter);
            if (error)
                return "filter." + error;
        }
        return null;
    };

    /**
     * Creates a SearchAccountingTransactionsPageToken message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchAccountingTransactionsPageToken
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchAccountingTransactionsPageToken} SearchAccountingTransactionsPageToken
     */
    SearchAccountingTransactionsPageToken.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchAccountingTransactionsPageToken)
            return object;
        let message = new $root.SearchAccountingTransactionsPageToken();
        if (object.from_created_at != null) {
            if (typeof object.from_created_at !== "object")
                throw TypeError(".SearchAccountingTransactionsPageToken.from_created_at: object expected");
            message.from_created_at = $root.google.protobuf.Timestamp.fromObject(object.from_created_at);
        }
        if (object.from_transaction_reference != null)
            message.from_transaction_reference = String(object.from_transaction_reference);
        if (object.filter != null) {
            if (typeof object.filter !== "object")
                throw TypeError(".SearchAccountingTransactionsPageToken.filter: object expected");
            message.filter = $root.SearchAccountingTransactionsFilter.fromObject(object.filter);
        }
        return message;
    };

    /**
     * Creates a plain object from a SearchAccountingTransactionsPageToken message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchAccountingTransactionsPageToken
     * @static
     * @param {SearchAccountingTransactionsPageToken} message SearchAccountingTransactionsPageToken
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchAccountingTransactionsPageToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.from_created_at = null;
            object.from_transaction_reference = "";
            object.filter = null;
        }
        if (message.from_created_at != null && message.hasOwnProperty("from_created_at"))
            object.from_created_at = $root.google.protobuf.Timestamp.toObject(message.from_created_at, options);
        if (message.from_transaction_reference != null && message.hasOwnProperty("from_transaction_reference"))
            object.from_transaction_reference = message.from_transaction_reference;
        if (message.filter != null && message.hasOwnProperty("filter"))
            object.filter = $root.SearchAccountingTransactionsFilter.toObject(message.filter, options);
        return object;
    };

    /**
     * Converts this SearchAccountingTransactionsPageToken to JSON.
     * @function toJSON
     * @memberof SearchAccountingTransactionsPageToken
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchAccountingTransactionsPageToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchAccountingTransactionsPageToken;
})();

export const AccountingSource = $root.AccountingSource = (() => {

    /**
     * Properties of an AccountingSource.
     * @exports IAccountingSource
     * @interface IAccountingSource
     */

    /**
     * Constructs a new AccountingSource.
     * @exports AccountingSource
     * @classdesc Represents an AccountingSource.
     * @implements IAccountingSource
     * @constructor
     * @param {IAccountingSource=} [properties] Properties to set
     */
    function AccountingSource(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new AccountingSource instance using the specified properties.
     * @function create
     * @memberof AccountingSource
     * @static
     * @param {IAccountingSource=} [properties] Properties to set
     * @returns {AccountingSource} AccountingSource instance
     */
    AccountingSource.create = function create(properties) {
        return new AccountingSource(properties);
    };

    /**
     * Encodes the specified AccountingSource message. Does not implicitly {@link AccountingSource.verify|verify} messages.
     * @function encode
     * @memberof AccountingSource
     * @static
     * @param {IAccountingSource} message AccountingSource message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingSource.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified AccountingSource message, length delimited. Does not implicitly {@link AccountingSource.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountingSource
     * @static
     * @param {IAccountingSource} message AccountingSource message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingSource.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountingSource message from the specified reader or buffer.
     * @function decode
     * @memberof AccountingSource
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountingSource} AccountingSource
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingSource.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountingSource();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountingSource message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountingSource
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountingSource} AccountingSource
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingSource.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountingSource message.
     * @function verify
     * @memberof AccountingSource
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountingSource.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an AccountingSource message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountingSource
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountingSource} AccountingSource
     */
    AccountingSource.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountingSource)
            return object;
        return new $root.AccountingSource();
    };

    /**
     * Creates a plain object from an AccountingSource message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountingSource
     * @static
     * @param {AccountingSource} message AccountingSource
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountingSource.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this AccountingSource to JSON.
     * @function toJSON
     * @memberof AccountingSource
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountingSource.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name AccountingSource.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} FINANCIER_SUSPENSE=1 FINANCIER_SUSPENSE value
     * @property {number} FINANCIER_FUND=2 FINANCIER_FUND value
     * @property {number} UNIT_REGISTRY=3 UNIT_REGISTRY value
     * @property {number} MACQUARIE=4 MACQUARIE value
     * @property {number} IB=5 IB value
     * @property {number} SPACESHIP_CAPITAL=6 SPACESHIP_CAPITAL value
     * @property {number} DISTRIBUTIONS=7 DISTRIBUTIONS value
     * @property {number} MEMBER_DISTRIBUTIONS=8 MEMBER_DISTRIBUTIONS value
     * @property {number} ORDERS=9 ORDERS value
     * @property {number} WESTPAC=10 WESTPAC value
     * @property {number} UNIT_PRICING=11 UNIT_PRICING value
     * @property {number} ZEPTO=12 ZEPTO value
     */
    AccountingSource.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "FINANCIER_SUSPENSE"] = 1;
        values[valuesById[2] = "FINANCIER_FUND"] = 2;
        values[valuesById[3] = "UNIT_REGISTRY"] = 3;
        values[valuesById[4] = "MACQUARIE"] = 4;
        values[valuesById[5] = "IB"] = 5;
        values[valuesById[6] = "SPACESHIP_CAPITAL"] = 6;
        values[valuesById[7] = "DISTRIBUTIONS"] = 7;
        values[valuesById[8] = "MEMBER_DISTRIBUTIONS"] = 8;
        values[valuesById[9] = "ORDERS"] = 9;
        values[valuesById[10] = "WESTPAC"] = 10;
        values[valuesById[11] = "UNIT_PRICING"] = 11;
        values[valuesById[12] = "ZEPTO"] = 12;
        return values;
    })();

    return AccountingSource;
})();

export const AccountingReconciliationStatus = $root.AccountingReconciliationStatus = (() => {

    /**
     * Properties of an AccountingReconciliationStatus.
     * @exports IAccountingReconciliationStatus
     * @interface IAccountingReconciliationStatus
     */

    /**
     * Constructs a new AccountingReconciliationStatus.
     * @exports AccountingReconciliationStatus
     * @classdesc Represents an AccountingReconciliationStatus.
     * @implements IAccountingReconciliationStatus
     * @constructor
     * @param {IAccountingReconciliationStatus=} [properties] Properties to set
     */
    function AccountingReconciliationStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new AccountingReconciliationStatus instance using the specified properties.
     * @function create
     * @memberof AccountingReconciliationStatus
     * @static
     * @param {IAccountingReconciliationStatus=} [properties] Properties to set
     * @returns {AccountingReconciliationStatus} AccountingReconciliationStatus instance
     */
    AccountingReconciliationStatus.create = function create(properties) {
        return new AccountingReconciliationStatus(properties);
    };

    /**
     * Encodes the specified AccountingReconciliationStatus message. Does not implicitly {@link AccountingReconciliationStatus.verify|verify} messages.
     * @function encode
     * @memberof AccountingReconciliationStatus
     * @static
     * @param {IAccountingReconciliationStatus} message AccountingReconciliationStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingReconciliationStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified AccountingReconciliationStatus message, length delimited. Does not implicitly {@link AccountingReconciliationStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountingReconciliationStatus
     * @static
     * @param {IAccountingReconciliationStatus} message AccountingReconciliationStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingReconciliationStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountingReconciliationStatus message from the specified reader or buffer.
     * @function decode
     * @memberof AccountingReconciliationStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountingReconciliationStatus} AccountingReconciliationStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingReconciliationStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountingReconciliationStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountingReconciliationStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountingReconciliationStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountingReconciliationStatus} AccountingReconciliationStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingReconciliationStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountingReconciliationStatus message.
     * @function verify
     * @memberof AccountingReconciliationStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountingReconciliationStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an AccountingReconciliationStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountingReconciliationStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountingReconciliationStatus} AccountingReconciliationStatus
     */
    AccountingReconciliationStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountingReconciliationStatus)
            return object;
        return new $root.AccountingReconciliationStatus();
    };

    /**
     * Creates a plain object from an AccountingReconciliationStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountingReconciliationStatus
     * @static
     * @param {AccountingReconciliationStatus} message AccountingReconciliationStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountingReconciliationStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this AccountingReconciliationStatus to JSON.
     * @function toJSON
     * @memberof AccountingReconciliationStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountingReconciliationStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name AccountingReconciliationStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PENDING=1 PENDING value
     * @property {number} RECONCILED=2 RECONCILED value
     * @property {number} UNRECONCILED=3 UNRECONCILED value
     * @property {number} NOT_APPLICABLE=4 NOT_APPLICABLE value
     */
    AccountingReconciliationStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PENDING"] = 1;
        values[valuesById[2] = "RECONCILED"] = 2;
        values[valuesById[3] = "UNRECONCILED"] = 3;
        values[valuesById[4] = "NOT_APPLICABLE"] = 4;
        return values;
    })();

    return AccountingReconciliationStatus;
})();

export const AccountingTransaction = $root.AccountingTransaction = (() => {

    /**
     * Properties of an AccountingTransaction.
     * @exports IAccountingTransaction
     * @interface IAccountingTransaction
     * @property {SaverPortfolio.Enum|null} [portfolio] AccountingTransaction portfolio
     * @property {AccountingStatus.Enum|null} [accounting_status] AccountingTransaction accounting_status
     * @property {AccountingSource.Enum|null} [source] AccountingTransaction source
     * @property {string|null} [external_reference] AccountingTransaction external_reference
     * @property {string|null} [product_id] AccountingTransaction product_id
     * @property {string|null} [transaction_reference] AccountingTransaction transaction_reference
     * @property {AccountingReconciliationStatus.Enum|null} [reconciliation_status] AccountingTransaction reconciliation_status
     * @property {google.protobuf.ITimestamp|null} [created_at] AccountingTransaction created_at
     */

    /**
     * Constructs a new AccountingTransaction.
     * @exports AccountingTransaction
     * @classdesc Represents an AccountingTransaction.
     * @implements IAccountingTransaction
     * @constructor
     * @param {IAccountingTransaction=} [properties] Properties to set
     */
    function AccountingTransaction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountingTransaction portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof AccountingTransaction
     * @instance
     */
    AccountingTransaction.prototype.portfolio = 0;

    /**
     * AccountingTransaction accounting_status.
     * @member {AccountingStatus.Enum} accounting_status
     * @memberof AccountingTransaction
     * @instance
     */
    AccountingTransaction.prototype.accounting_status = 0;

    /**
     * AccountingTransaction source.
     * @member {AccountingSource.Enum} source
     * @memberof AccountingTransaction
     * @instance
     */
    AccountingTransaction.prototype.source = 0;

    /**
     * AccountingTransaction external_reference.
     * @member {string} external_reference
     * @memberof AccountingTransaction
     * @instance
     */
    AccountingTransaction.prototype.external_reference = "";

    /**
     * AccountingTransaction product_id.
     * @member {string} product_id
     * @memberof AccountingTransaction
     * @instance
     */
    AccountingTransaction.prototype.product_id = "";

    /**
     * AccountingTransaction transaction_reference.
     * @member {string} transaction_reference
     * @memberof AccountingTransaction
     * @instance
     */
    AccountingTransaction.prototype.transaction_reference = "";

    /**
     * AccountingTransaction reconciliation_status.
     * @member {AccountingReconciliationStatus.Enum} reconciliation_status
     * @memberof AccountingTransaction
     * @instance
     */
    AccountingTransaction.prototype.reconciliation_status = 0;

    /**
     * AccountingTransaction created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof AccountingTransaction
     * @instance
     */
    AccountingTransaction.prototype.created_at = null;

    /**
     * Creates a new AccountingTransaction instance using the specified properties.
     * @function create
     * @memberof AccountingTransaction
     * @static
     * @param {IAccountingTransaction=} [properties] Properties to set
     * @returns {AccountingTransaction} AccountingTransaction instance
     */
    AccountingTransaction.create = function create(properties) {
        return new AccountingTransaction(properties);
    };

    /**
     * Encodes the specified AccountingTransaction message. Does not implicitly {@link AccountingTransaction.verify|verify} messages.
     * @function encode
     * @memberof AccountingTransaction
     * @static
     * @param {IAccountingTransaction} message AccountingTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingTransaction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.accounting_status);
        if (message.source != null && message.hasOwnProperty("source"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.source);
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.external_reference);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.product_id);
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.transaction_reference);
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.reconciliation_status);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AccountingTransaction message, length delimited. Does not implicitly {@link AccountingTransaction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountingTransaction
     * @static
     * @param {IAccountingTransaction} message AccountingTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountingTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountingTransaction message from the specified reader or buffer.
     * @function decode
     * @memberof AccountingTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountingTransaction} AccountingTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountingTransaction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.portfolio = reader.int32();
                break;
            case 2:
                message.accounting_status = reader.int32();
                break;
            case 3:
                message.source = reader.int32();
                break;
            case 4:
                message.external_reference = reader.string();
                break;
            case 5:
                message.product_id = reader.string();
                break;
            case 6:
                message.transaction_reference = reader.string();
                break;
            case 7:
                message.reconciliation_status = reader.int32();
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountingTransaction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountingTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountingTransaction} AccountingTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountingTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountingTransaction message.
     * @function verify
     * @memberof AccountingTransaction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountingTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            switch (message.accounting_status) {
            default:
                return "accounting_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.source != null && message.hasOwnProperty("source"))
            switch (message.source) {
            default:
                return "source: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
                break;
            }
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            if (!$util.isString(message.external_reference))
                return "external_reference: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            switch (message.reconciliation_status) {
            default:
                return "reconciliation_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates an AccountingTransaction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountingTransaction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountingTransaction} AccountingTransaction
     */
    AccountingTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountingTransaction)
            return object;
        let message = new $root.AccountingTransaction();
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        switch (object.accounting_status) {
        case "UNKNOWN":
        case 0:
            message.accounting_status = 0;
            break;
        case "PENDING":
        case 1:
            message.accounting_status = 1;
            break;
        case "UNCATEGORISED":
        case 2:
            message.accounting_status = 2;
            break;
        case "CATEGORISED":
        case 3:
            message.accounting_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.accounting_status = 4;
            break;
        }
        switch (object.source) {
        case "UNKNOWN":
        case 0:
            message.source = 0;
            break;
        case "FINANCIER_SUSPENSE":
        case 1:
            message.source = 1;
            break;
        case "FINANCIER_FUND":
        case 2:
            message.source = 2;
            break;
        case "UNIT_REGISTRY":
        case 3:
            message.source = 3;
            break;
        case "MACQUARIE":
        case 4:
            message.source = 4;
            break;
        case "IB":
        case 5:
            message.source = 5;
            break;
        case "SPACESHIP_CAPITAL":
        case 6:
            message.source = 6;
            break;
        case "DISTRIBUTIONS":
        case 7:
            message.source = 7;
            break;
        case "MEMBER_DISTRIBUTIONS":
        case 8:
            message.source = 8;
            break;
        case "ORDERS":
        case 9:
            message.source = 9;
            break;
        case "WESTPAC":
        case 10:
            message.source = 10;
            break;
        case "UNIT_PRICING":
        case 11:
            message.source = 11;
            break;
        case "ZEPTO":
        case 12:
            message.source = 12;
            break;
        }
        if (object.external_reference != null)
            message.external_reference = String(object.external_reference);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        switch (object.reconciliation_status) {
        case "UNKNOWN":
        case 0:
            message.reconciliation_status = 0;
            break;
        case "PENDING":
        case 1:
            message.reconciliation_status = 1;
            break;
        case "RECONCILED":
        case 2:
            message.reconciliation_status = 2;
            break;
        case "UNRECONCILED":
        case 3:
            message.reconciliation_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.reconciliation_status = 4;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".AccountingTransaction.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an AccountingTransaction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountingTransaction
     * @static
     * @param {AccountingTransaction} message AccountingTransaction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountingTransaction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.accounting_status = options.enums === String ? "UNKNOWN" : 0;
            object.source = options.enums === String ? "UNKNOWN" : 0;
            object.external_reference = "";
            object.product_id = "";
            object.transaction_reference = "";
            object.reconciliation_status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
        }
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            object.accounting_status = options.enums === String ? $root.AccountingStatus.Enum[message.accounting_status] : message.accounting_status;
        if (message.source != null && message.hasOwnProperty("source"))
            object.source = options.enums === String ? $root.AccountingSource.Enum[message.source] : message.source;
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            object.external_reference = message.external_reference;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            object.reconciliation_status = options.enums === String ? $root.AccountingReconciliationStatus.Enum[message.reconciliation_status] : message.reconciliation_status;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this AccountingTransaction to JSON.
     * @function toJSON
     * @memberof AccountingTransaction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountingTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AccountingTransaction;
})();

export const FinancierAdjustmentType = $root.FinancierAdjustmentType = (() => {

    /**
     * Properties of a FinancierAdjustmentType.
     * @exports IFinancierAdjustmentType
     * @interface IFinancierAdjustmentType
     */

    /**
     * Constructs a new FinancierAdjustmentType.
     * @exports FinancierAdjustmentType
     * @classdesc Represents a FinancierAdjustmentType.
     * @implements IFinancierAdjustmentType
     * @constructor
     * @param {IFinancierAdjustmentType=} [properties] Properties to set
     */
    function FinancierAdjustmentType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new FinancierAdjustmentType instance using the specified properties.
     * @function create
     * @memberof FinancierAdjustmentType
     * @static
     * @param {IFinancierAdjustmentType=} [properties] Properties to set
     * @returns {FinancierAdjustmentType} FinancierAdjustmentType instance
     */
    FinancierAdjustmentType.create = function create(properties) {
        return new FinancierAdjustmentType(properties);
    };

    /**
     * Encodes the specified FinancierAdjustmentType message. Does not implicitly {@link FinancierAdjustmentType.verify|verify} messages.
     * @function encode
     * @memberof FinancierAdjustmentType
     * @static
     * @param {IFinancierAdjustmentType} message FinancierAdjustmentType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierAdjustmentType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified FinancierAdjustmentType message, length delimited. Does not implicitly {@link FinancierAdjustmentType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FinancierAdjustmentType
     * @static
     * @param {IFinancierAdjustmentType} message FinancierAdjustmentType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierAdjustmentType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FinancierAdjustmentType message from the specified reader or buffer.
     * @function decode
     * @memberof FinancierAdjustmentType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FinancierAdjustmentType} FinancierAdjustmentType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierAdjustmentType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FinancierAdjustmentType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FinancierAdjustmentType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FinancierAdjustmentType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FinancierAdjustmentType} FinancierAdjustmentType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierAdjustmentType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FinancierAdjustmentType message.
     * @function verify
     * @memberof FinancierAdjustmentType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FinancierAdjustmentType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a FinancierAdjustmentType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FinancierAdjustmentType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FinancierAdjustmentType} FinancierAdjustmentType
     */
    FinancierAdjustmentType.fromObject = function fromObject(object) {
        if (object instanceof $root.FinancierAdjustmentType)
            return object;
        return new $root.FinancierAdjustmentType();
    };

    /**
     * Creates a plain object from a FinancierAdjustmentType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FinancierAdjustmentType
     * @static
     * @param {FinancierAdjustmentType} message FinancierAdjustmentType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FinancierAdjustmentType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this FinancierAdjustmentType to JSON.
     * @function toJSON
     * @memberof FinancierAdjustmentType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FinancierAdjustmentType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name FinancierAdjustmentType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} DDR=1 DDR value
     * @property {number} DDR_MANUAL=2 DDR_MANUAL value
     * @property {number} DELAYED_TRANSACTION_PROCESSING_BY_BANK=3 DELAYED_TRANSACTION_PROCESSING_BY_BANK value
     * @property {number} FRAUD=4 FRAUD value
     * @property {number} FUND_APPLICATION_UNIT_PRICE_ADJUSTMENT=5 FUND_APPLICATION_UNIT_PRICE_ADJUSTMENT value
     * @property {number} INCORRECT_REVERSAL=6 INCORRECT_REVERSAL value
     * @property {number} INSTANT_UNITS=7 INSTANT_UNITS value
     * @property {number} ZERO_OUT_CLOSED_ACCOUNT=8 ZERO_OUT_CLOSED_ACCOUNT value
     * @property {number} FEE_REBATE=9 FEE_REBATE value
     * @property {number} UNIT_TRANSFER=10 UNIT_TRANSFER value
     * @property {number} UNIT_PRICING_REMEDIATION=11 UNIT_PRICING_REMEDIATION value
     * @property {number} COMPLIMENTARY=12 COMPLIMENTARY value
     * @property {number} COMPLIMENTARY_INSTANT_UNITS=13 COMPLIMENTARY_INSTANT_UNITS value
     * @property {number} REVERSAL=14 REVERSAL value
     * @property {number} FAST_TRACKED_APPLICATION_FAILURE=15 FAST_TRACKED_APPLICATION_FAILURE value
     * @property {number} DISTRIBUTION_REMEDIATION_FY19=16 DISTRIBUTION_REMEDIATION_FY19 value
     * @property {number} DISTRIBUTION_REMEDIATION_FY20=17 DISTRIBUTION_REMEDIATION_FY20 value
     * @property {number} FEE_COMMS_INCIDENT_REMEDIATION_2022=18 FEE_COMMS_INCIDENT_REMEDIATION_2022 value
     * @property {number} UNIT_PRICING_REMEDIATION_REVERSAL=19 UNIT_PRICING_REMEDIATION_REVERSAL value
     */
    FinancierAdjustmentType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "DDR"] = 1;
        values[valuesById[2] = "DDR_MANUAL"] = 2;
        values[valuesById[3] = "DELAYED_TRANSACTION_PROCESSING_BY_BANK"] = 3;
        values[valuesById[4] = "FRAUD"] = 4;
        values[valuesById[5] = "FUND_APPLICATION_UNIT_PRICE_ADJUSTMENT"] = 5;
        values[valuesById[6] = "INCORRECT_REVERSAL"] = 6;
        values[valuesById[7] = "INSTANT_UNITS"] = 7;
        values[valuesById[8] = "ZERO_OUT_CLOSED_ACCOUNT"] = 8;
        values[valuesById[9] = "FEE_REBATE"] = 9;
        values[valuesById[10] = "UNIT_TRANSFER"] = 10;
        values[valuesById[11] = "UNIT_PRICING_REMEDIATION"] = 11;
        values[valuesById[12] = "COMPLIMENTARY"] = 12;
        values[valuesById[13] = "COMPLIMENTARY_INSTANT_UNITS"] = 13;
        values[valuesById[14] = "REVERSAL"] = 14;
        values[valuesById[15] = "FAST_TRACKED_APPLICATION_FAILURE"] = 15;
        values[valuesById[16] = "DISTRIBUTION_REMEDIATION_FY19"] = 16;
        values[valuesById[17] = "DISTRIBUTION_REMEDIATION_FY20"] = 17;
        values[valuesById[18] = "FEE_COMMS_INCIDENT_REMEDIATION_2022"] = 18;
        values[valuesById[19] = "UNIT_PRICING_REMEDIATION_REVERSAL"] = 19;
        return values;
    })();

    return FinancierAdjustmentType;
})();

export const FinancierAdjustment = $root.FinancierAdjustment = (() => {

    /**
     * Properties of a FinancierAdjustment.
     * @exports IFinancierAdjustment
     * @interface IFinancierAdjustment
     * @property {string|null} [transaction_reference] FinancierAdjustment transaction_reference
     * @property {string|null} [original_transaction_reference] FinancierAdjustment original_transaction_reference
     * @property {string|null} [description] FinancierAdjustment description
     * @property {boolean|null} [processed] FinancierAdjustment processed
     * @property {string|null} [aud_amount_payable] FinancierAdjustment aud_amount_payable
     * @property {string|null} [payment_transaction_reference] FinancierAdjustment payment_transaction_reference
     * @property {FinancierAdjustmentType.Enum|null} [type] FinancierAdjustment type
     * @property {google.protobuf.ITimestamp|null} [created_at] FinancierAdjustment created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] FinancierAdjustment last_updated_at
     */

    /**
     * Constructs a new FinancierAdjustment.
     * @exports FinancierAdjustment
     * @classdesc Represents a FinancierAdjustment.
     * @implements IFinancierAdjustment
     * @constructor
     * @param {IFinancierAdjustment=} [properties] Properties to set
     */
    function FinancierAdjustment(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FinancierAdjustment transaction_reference.
     * @member {string} transaction_reference
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.transaction_reference = "";

    /**
     * FinancierAdjustment original_transaction_reference.
     * @member {string} original_transaction_reference
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.original_transaction_reference = "";

    /**
     * FinancierAdjustment description.
     * @member {string} description
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.description = "";

    /**
     * FinancierAdjustment processed.
     * @member {boolean} processed
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.processed = false;

    /**
     * FinancierAdjustment aud_amount_payable.
     * @member {string} aud_amount_payable
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.aud_amount_payable = "";

    /**
     * FinancierAdjustment payment_transaction_reference.
     * @member {string} payment_transaction_reference
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.payment_transaction_reference = "";

    /**
     * FinancierAdjustment type.
     * @member {FinancierAdjustmentType.Enum} type
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.type = 0;

    /**
     * FinancierAdjustment created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.created_at = null;

    /**
     * FinancierAdjustment last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof FinancierAdjustment
     * @instance
     */
    FinancierAdjustment.prototype.last_updated_at = null;

    /**
     * Creates a new FinancierAdjustment instance using the specified properties.
     * @function create
     * @memberof FinancierAdjustment
     * @static
     * @param {IFinancierAdjustment=} [properties] Properties to set
     * @returns {FinancierAdjustment} FinancierAdjustment instance
     */
    FinancierAdjustment.create = function create(properties) {
        return new FinancierAdjustment(properties);
    };

    /**
     * Encodes the specified FinancierAdjustment message. Does not implicitly {@link FinancierAdjustment.verify|verify} messages.
     * @function encode
     * @memberof FinancierAdjustment
     * @static
     * @param {IFinancierAdjustment} message FinancierAdjustment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierAdjustment.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
        if (message.original_transaction_reference != null && message.hasOwnProperty("original_transaction_reference"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.original_transaction_reference);
        if (message.description != null && message.hasOwnProperty("description"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
        if (message.processed != null && message.hasOwnProperty("processed"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.processed);
        if (message.aud_amount_payable != null && message.hasOwnProperty("aud_amount_payable"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.aud_amount_payable);
        if (message.payment_transaction_reference != null && message.hasOwnProperty("payment_transaction_reference"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.payment_transaction_reference);
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.type);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FinancierAdjustment message, length delimited. Does not implicitly {@link FinancierAdjustment.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FinancierAdjustment
     * @static
     * @param {IFinancierAdjustment} message FinancierAdjustment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierAdjustment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FinancierAdjustment message from the specified reader or buffer.
     * @function decode
     * @memberof FinancierAdjustment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FinancierAdjustment} FinancierAdjustment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierAdjustment.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FinancierAdjustment();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_reference = reader.string();
                break;
            case 2:
                message.original_transaction_reference = reader.string();
                break;
            case 3:
                message.description = reader.string();
                break;
            case 4:
                message.processed = reader.bool();
                break;
            case 5:
                message.aud_amount_payable = reader.string();
                break;
            case 6:
                message.payment_transaction_reference = reader.string();
                break;
            case 7:
                message.type = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FinancierAdjustment message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FinancierAdjustment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FinancierAdjustment} FinancierAdjustment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierAdjustment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FinancierAdjustment message.
     * @function verify
     * @memberof FinancierAdjustment
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FinancierAdjustment.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.original_transaction_reference != null && message.hasOwnProperty("original_transaction_reference"))
            if (!$util.isString(message.original_transaction_reference))
                return "original_transaction_reference: string expected";
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.processed != null && message.hasOwnProperty("processed"))
            if (typeof message.processed !== "boolean")
                return "processed: boolean expected";
        if (message.aud_amount_payable != null && message.hasOwnProperty("aud_amount_payable"))
            if (!$util.isString(message.aud_amount_payable))
                return "aud_amount_payable: string expected";
        if (message.payment_transaction_reference != null && message.hasOwnProperty("payment_transaction_reference"))
            if (!$util.isString(message.payment_transaction_reference))
                return "payment_transaction_reference: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a FinancierAdjustment message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FinancierAdjustment
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FinancierAdjustment} FinancierAdjustment
     */
    FinancierAdjustment.fromObject = function fromObject(object) {
        if (object instanceof $root.FinancierAdjustment)
            return object;
        let message = new $root.FinancierAdjustment();
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.original_transaction_reference != null)
            message.original_transaction_reference = String(object.original_transaction_reference);
        if (object.description != null)
            message.description = String(object.description);
        if (object.processed != null)
            message.processed = Boolean(object.processed);
        if (object.aud_amount_payable != null)
            message.aud_amount_payable = String(object.aud_amount_payable);
        if (object.payment_transaction_reference != null)
            message.payment_transaction_reference = String(object.payment_transaction_reference);
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "DDR":
        case 1:
            message.type = 1;
            break;
        case "DDR_MANUAL":
        case 2:
            message.type = 2;
            break;
        case "DELAYED_TRANSACTION_PROCESSING_BY_BANK":
        case 3:
            message.type = 3;
            break;
        case "FRAUD":
        case 4:
            message.type = 4;
            break;
        case "FUND_APPLICATION_UNIT_PRICE_ADJUSTMENT":
        case 5:
            message.type = 5;
            break;
        case "INCORRECT_REVERSAL":
        case 6:
            message.type = 6;
            break;
        case "INSTANT_UNITS":
        case 7:
            message.type = 7;
            break;
        case "ZERO_OUT_CLOSED_ACCOUNT":
        case 8:
            message.type = 8;
            break;
        case "FEE_REBATE":
        case 9:
            message.type = 9;
            break;
        case "UNIT_TRANSFER":
        case 10:
            message.type = 10;
            break;
        case "UNIT_PRICING_REMEDIATION":
        case 11:
            message.type = 11;
            break;
        case "COMPLIMENTARY":
        case 12:
            message.type = 12;
            break;
        case "COMPLIMENTARY_INSTANT_UNITS":
        case 13:
            message.type = 13;
            break;
        case "REVERSAL":
        case 14:
            message.type = 14;
            break;
        case "FAST_TRACKED_APPLICATION_FAILURE":
        case 15:
            message.type = 15;
            break;
        case "DISTRIBUTION_REMEDIATION_FY19":
        case 16:
            message.type = 16;
            break;
        case "DISTRIBUTION_REMEDIATION_FY20":
        case 17:
            message.type = 17;
            break;
        case "FEE_COMMS_INCIDENT_REMEDIATION_2022":
        case 18:
            message.type = 18;
            break;
        case "UNIT_PRICING_REMEDIATION_REVERSAL":
        case 19:
            message.type = 19;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".FinancierAdjustment.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".FinancierAdjustment.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a FinancierAdjustment message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FinancierAdjustment
     * @static
     * @param {FinancierAdjustment} message FinancierAdjustment
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FinancierAdjustment.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_reference = "";
            object.original_transaction_reference = "";
            object.description = "";
            object.processed = false;
            object.aud_amount_payable = "";
            object.payment_transaction_reference = "";
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.original_transaction_reference != null && message.hasOwnProperty("original_transaction_reference"))
            object.original_transaction_reference = message.original_transaction_reference;
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.processed != null && message.hasOwnProperty("processed"))
            object.processed = message.processed;
        if (message.aud_amount_payable != null && message.hasOwnProperty("aud_amount_payable"))
            object.aud_amount_payable = message.aud_amount_payable;
        if (message.payment_transaction_reference != null && message.hasOwnProperty("payment_transaction_reference"))
            object.payment_transaction_reference = message.payment_transaction_reference;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.FinancierAdjustmentType.Enum[message.type] : message.type;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this FinancierAdjustment to JSON.
     * @function toJSON
     * @memberof FinancierAdjustment
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FinancierAdjustment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FinancierAdjustment;
})();

export const Article = $root.Article = (() => {

    /**
     * Properties of an Article.
     * @exports IArticle
     * @interface IArticle
     * @property {string|null} [id] Article id
     * @property {boolean|null} [active] Article active
     * @property {string|null} [isin] Article isin
     * @property {string|null} [heading] Article heading
     * @property {string|null} [subheading] Article subheading
     * @property {string|null} [publication] Article publication
     * @property {string|null} [publication_url] Article publication_url
     * @property {string|null} [article_url] Article article_url
     * @property {string|null} [image_url] Article image_url
     * @property {string|null} [instrument_id] Article instrument_id
     * @property {string|null} [image_public_url] Article image_public_url
     * @property {google.protobuf.ITimestamp|null} [created_at] Article created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] Article last_updated_at
     */

    /**
     * Constructs a new Article.
     * @exports Article
     * @classdesc Represents an Article.
     * @implements IArticle
     * @constructor
     * @param {IArticle=} [properties] Properties to set
     */
    function Article(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Article id.
     * @member {string} id
     * @memberof Article
     * @instance
     */
    Article.prototype.id = "";

    /**
     * Article active.
     * @member {boolean} active
     * @memberof Article
     * @instance
     */
    Article.prototype.active = false;

    /**
     * Article isin.
     * @member {string} isin
     * @memberof Article
     * @instance
     */
    Article.prototype.isin = "";

    /**
     * Article heading.
     * @member {string} heading
     * @memberof Article
     * @instance
     */
    Article.prototype.heading = "";

    /**
     * Article subheading.
     * @member {string} subheading
     * @memberof Article
     * @instance
     */
    Article.prototype.subheading = "";

    /**
     * Article publication.
     * @member {string} publication
     * @memberof Article
     * @instance
     */
    Article.prototype.publication = "";

    /**
     * Article publication_url.
     * @member {string} publication_url
     * @memberof Article
     * @instance
     */
    Article.prototype.publication_url = "";

    /**
     * Article article_url.
     * @member {string} article_url
     * @memberof Article
     * @instance
     */
    Article.prototype.article_url = "";

    /**
     * Article image_url.
     * @member {string} image_url
     * @memberof Article
     * @instance
     */
    Article.prototype.image_url = "";

    /**
     * Article instrument_id.
     * @member {string} instrument_id
     * @memberof Article
     * @instance
     */
    Article.prototype.instrument_id = "";

    /**
     * Article image_public_url.
     * @member {string} image_public_url
     * @memberof Article
     * @instance
     */
    Article.prototype.image_public_url = "";

    /**
     * Article created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof Article
     * @instance
     */
    Article.prototype.created_at = null;

    /**
     * Article last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof Article
     * @instance
     */
    Article.prototype.last_updated_at = null;

    /**
     * Creates a new Article instance using the specified properties.
     * @function create
     * @memberof Article
     * @static
     * @param {IArticle=} [properties] Properties to set
     * @returns {Article} Article instance
     */
    Article.create = function create(properties) {
        return new Article(properties);
    };

    /**
     * Encodes the specified Article message. Does not implicitly {@link Article.verify|verify} messages.
     * @function encode
     * @memberof Article
     * @static
     * @param {IArticle} message Article message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Article.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.active);
        if (message.isin != null && message.hasOwnProperty("isin"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.isin);
        if (message.heading != null && message.hasOwnProperty("heading"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.heading);
        if (message.subheading != null && message.hasOwnProperty("subheading"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.subheading);
        if (message.publication != null && message.hasOwnProperty("publication"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.publication);
        if (message.publication_url != null && message.hasOwnProperty("publication_url"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.publication_url);
        if (message.article_url != null && message.hasOwnProperty("article_url"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.article_url);
        if (message.image_url != null && message.hasOwnProperty("image_url"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.image_url);
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.instrument_id);
        if (message.image_public_url != null && message.hasOwnProperty("image_public_url"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.image_public_url);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Article message, length delimited. Does not implicitly {@link Article.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Article
     * @static
     * @param {IArticle} message Article message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Article.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Article message from the specified reader or buffer.
     * @function decode
     * @memberof Article
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Article} Article
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Article.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Article();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.active = reader.bool();
                break;
            case 3:
                message.isin = reader.string();
                break;
            case 4:
                message.heading = reader.string();
                break;
            case 5:
                message.subheading = reader.string();
                break;
            case 6:
                message.publication = reader.string();
                break;
            case 7:
                message.publication_url = reader.string();
                break;
            case 8:
                message.article_url = reader.string();
                break;
            case 9:
                message.image_url = reader.string();
                break;
            case 10:
                message.instrument_id = reader.string();
                break;
            case 11:
                message.image_public_url = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Article message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Article
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Article} Article
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Article.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Article message.
     * @function verify
     * @memberof Article
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Article.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.isin != null && message.hasOwnProperty("isin"))
            if (!$util.isString(message.isin))
                return "isin: string expected";
        if (message.heading != null && message.hasOwnProperty("heading"))
            if (!$util.isString(message.heading))
                return "heading: string expected";
        if (message.subheading != null && message.hasOwnProperty("subheading"))
            if (!$util.isString(message.subheading))
                return "subheading: string expected";
        if (message.publication != null && message.hasOwnProperty("publication"))
            if (!$util.isString(message.publication))
                return "publication: string expected";
        if (message.publication_url != null && message.hasOwnProperty("publication_url"))
            if (!$util.isString(message.publication_url))
                return "publication_url: string expected";
        if (message.article_url != null && message.hasOwnProperty("article_url"))
            if (!$util.isString(message.article_url))
                return "article_url: string expected";
        if (message.image_url != null && message.hasOwnProperty("image_url"))
            if (!$util.isString(message.image_url))
                return "image_url: string expected";
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            if (!$util.isString(message.instrument_id))
                return "instrument_id: string expected";
        if (message.image_public_url != null && message.hasOwnProperty("image_public_url"))
            if (!$util.isString(message.image_public_url))
                return "image_public_url: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates an Article message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Article
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Article} Article
     */
    Article.fromObject = function fromObject(object) {
        if (object instanceof $root.Article)
            return object;
        let message = new $root.Article();
        if (object.id != null)
            message.id = String(object.id);
        if (object.active != null)
            message.active = Boolean(object.active);
        if (object.isin != null)
            message.isin = String(object.isin);
        if (object.heading != null)
            message.heading = String(object.heading);
        if (object.subheading != null)
            message.subheading = String(object.subheading);
        if (object.publication != null)
            message.publication = String(object.publication);
        if (object.publication_url != null)
            message.publication_url = String(object.publication_url);
        if (object.article_url != null)
            message.article_url = String(object.article_url);
        if (object.image_url != null)
            message.image_url = String(object.image_url);
        if (object.instrument_id != null)
            message.instrument_id = String(object.instrument_id);
        if (object.image_public_url != null)
            message.image_public_url = String(object.image_public_url);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".Article.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".Article.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an Article message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Article
     * @static
     * @param {Article} message Article
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Article.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.active = false;
            object.isin = "";
            object.heading = "";
            object.subheading = "";
            object.publication = "";
            object.publication_url = "";
            object.article_url = "";
            object.image_url = "";
            object.instrument_id = "";
            object.image_public_url = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.isin != null && message.hasOwnProperty("isin"))
            object.isin = message.isin;
        if (message.heading != null && message.hasOwnProperty("heading"))
            object.heading = message.heading;
        if (message.subheading != null && message.hasOwnProperty("subheading"))
            object.subheading = message.subheading;
        if (message.publication != null && message.hasOwnProperty("publication"))
            object.publication = message.publication;
        if (message.publication_url != null && message.hasOwnProperty("publication_url"))
            object.publication_url = message.publication_url;
        if (message.article_url != null && message.hasOwnProperty("article_url"))
            object.article_url = message.article_url;
        if (message.image_url != null && message.hasOwnProperty("image_url"))
            object.image_url = message.image_url;
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            object.instrument_id = message.instrument_id;
        if (message.image_public_url != null && message.hasOwnProperty("image_public_url"))
            object.image_public_url = message.image_public_url;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this Article to JSON.
     * @function toJSON
     * @memberof Article
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Article.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Article;
})();

export const ContentArticlePageToken = $root.ContentArticlePageToken = (() => {

    /**
     * Properties of a ContentArticlePageToken.
     * @exports IContentArticlePageToken
     * @interface IContentArticlePageToken
     * @property {google.protobuf.ITimestamp|null} [created_at] ContentArticlePageToken created_at
     * @property {string|null} [article_id] ContentArticlePageToken article_id
     */

    /**
     * Constructs a new ContentArticlePageToken.
     * @exports ContentArticlePageToken
     * @classdesc Represents a ContentArticlePageToken.
     * @implements IContentArticlePageToken
     * @constructor
     * @param {IContentArticlePageToken=} [properties] Properties to set
     */
    function ContentArticlePageToken(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContentArticlePageToken created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof ContentArticlePageToken
     * @instance
     */
    ContentArticlePageToken.prototype.created_at = null;

    /**
     * ContentArticlePageToken article_id.
     * @member {string} article_id
     * @memberof ContentArticlePageToken
     * @instance
     */
    ContentArticlePageToken.prototype.article_id = "";

    /**
     * Creates a new ContentArticlePageToken instance using the specified properties.
     * @function create
     * @memberof ContentArticlePageToken
     * @static
     * @param {IContentArticlePageToken=} [properties] Properties to set
     * @returns {ContentArticlePageToken} ContentArticlePageToken instance
     */
    ContentArticlePageToken.create = function create(properties) {
        return new ContentArticlePageToken(properties);
    };

    /**
     * Encodes the specified ContentArticlePageToken message. Does not implicitly {@link ContentArticlePageToken.verify|verify} messages.
     * @function encode
     * @memberof ContentArticlePageToken
     * @static
     * @param {IContentArticlePageToken} message ContentArticlePageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentArticlePageToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.article_id != null && message.hasOwnProperty("article_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.article_id);
        return writer;
    };

    /**
     * Encodes the specified ContentArticlePageToken message, length delimited. Does not implicitly {@link ContentArticlePageToken.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ContentArticlePageToken
     * @static
     * @param {IContentArticlePageToken} message ContentArticlePageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentArticlePageToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ContentArticlePageToken message from the specified reader or buffer.
     * @function decode
     * @memberof ContentArticlePageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContentArticlePageToken} ContentArticlePageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentArticlePageToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ContentArticlePageToken();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 2:
                message.article_id = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ContentArticlePageToken message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ContentArticlePageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ContentArticlePageToken} ContentArticlePageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentArticlePageToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ContentArticlePageToken message.
     * @function verify
     * @memberof ContentArticlePageToken
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ContentArticlePageToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.article_id != null && message.hasOwnProperty("article_id"))
            if (!$util.isString(message.article_id))
                return "article_id: string expected";
        return null;
    };

    /**
     * Creates a ContentArticlePageToken message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ContentArticlePageToken
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ContentArticlePageToken} ContentArticlePageToken
     */
    ContentArticlePageToken.fromObject = function fromObject(object) {
        if (object instanceof $root.ContentArticlePageToken)
            return object;
        let message = new $root.ContentArticlePageToken();
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".ContentArticlePageToken.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.article_id != null)
            message.article_id = String(object.article_id);
        return message;
    };

    /**
     * Creates a plain object from a ContentArticlePageToken message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ContentArticlePageToken
     * @static
     * @param {ContentArticlePageToken} message ContentArticlePageToken
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContentArticlePageToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.created_at = null;
            object.article_id = "";
        }
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.article_id != null && message.hasOwnProperty("article_id"))
            object.article_id = message.article_id;
        return object;
    };

    /**
     * Converts this ContentArticlePageToken to JSON.
     * @function toJSON
     * @memberof ContentArticlePageToken
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContentArticlePageToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ContentArticlePageToken;
})();

export const CompanyProfile = $root.CompanyProfile = (() => {

    /**
     * Properties of a CompanyProfile.
     * @exports ICompanyProfile
     * @interface ICompanyProfile
     * @property {string|null} [id] CompanyProfile id
     * @property {string|null} [instrument_id] CompanyProfile instrument_id
     * @property {SaverPortfolio.Enum|null} [portfolio] CompanyProfile portfolio
     * @property {string|null} [isin] CompanyProfile isin
     * @property {boolean|null} [active] CompanyProfile active
     * @property {string|null} [body_text] CompanyProfile body_text
     * @property {string|null} [video_caption] CompanyProfile video_caption
     * @property {string|null} [video_link] CompanyProfile video_link
     * @property {google.protobuf.ITimestamp|null} [created_at] CompanyProfile created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] CompanyProfile last_updated_at
     */

    /**
     * Constructs a new CompanyProfile.
     * @exports CompanyProfile
     * @classdesc Represents a CompanyProfile.
     * @implements ICompanyProfile
     * @constructor
     * @param {ICompanyProfile=} [properties] Properties to set
     */
    function CompanyProfile(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CompanyProfile id.
     * @member {string} id
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.id = "";

    /**
     * CompanyProfile instrument_id.
     * @member {string} instrument_id
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.instrument_id = "";

    /**
     * CompanyProfile portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.portfolio = 0;

    /**
     * CompanyProfile isin.
     * @member {string} isin
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.isin = "";

    /**
     * CompanyProfile active.
     * @member {boolean} active
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.active = false;

    /**
     * CompanyProfile body_text.
     * @member {string} body_text
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.body_text = "";

    /**
     * CompanyProfile video_caption.
     * @member {string} video_caption
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.video_caption = "";

    /**
     * CompanyProfile video_link.
     * @member {string} video_link
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.video_link = "";

    /**
     * CompanyProfile created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.created_at = null;

    /**
     * CompanyProfile last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof CompanyProfile
     * @instance
     */
    CompanyProfile.prototype.last_updated_at = null;

    /**
     * Creates a new CompanyProfile instance using the specified properties.
     * @function create
     * @memberof CompanyProfile
     * @static
     * @param {ICompanyProfile=} [properties] Properties to set
     * @returns {CompanyProfile} CompanyProfile instance
     */
    CompanyProfile.create = function create(properties) {
        return new CompanyProfile(properties);
    };

    /**
     * Encodes the specified CompanyProfile message. Does not implicitly {@link CompanyProfile.verify|verify} messages.
     * @function encode
     * @memberof CompanyProfile
     * @static
     * @param {ICompanyProfile} message CompanyProfile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CompanyProfile.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.instrument_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.portfolio);
        if (message.isin != null && message.hasOwnProperty("isin"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.isin);
        if (message.active != null && message.hasOwnProperty("active"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.active);
        if (message.body_text != null && message.hasOwnProperty("body_text"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.body_text);
        if (message.video_caption != null && message.hasOwnProperty("video_caption"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.video_caption);
        if (message.video_link != null && message.hasOwnProperty("video_link"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.video_link);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified CompanyProfile message, length delimited. Does not implicitly {@link CompanyProfile.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CompanyProfile
     * @static
     * @param {ICompanyProfile} message CompanyProfile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CompanyProfile.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CompanyProfile message from the specified reader or buffer.
     * @function decode
     * @memberof CompanyProfile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CompanyProfile} CompanyProfile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CompanyProfile.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CompanyProfile();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.instrument_id = reader.string();
                break;
            case 3:
                message.portfolio = reader.int32();
                break;
            case 4:
                message.isin = reader.string();
                break;
            case 5:
                message.active = reader.bool();
                break;
            case 6:
                message.body_text = reader.string();
                break;
            case 7:
                message.video_caption = reader.string();
                break;
            case 8:
                message.video_link = reader.string();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CompanyProfile message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CompanyProfile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CompanyProfile} CompanyProfile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CompanyProfile.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CompanyProfile message.
     * @function verify
     * @memberof CompanyProfile
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CompanyProfile.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            if (!$util.isString(message.instrument_id))
                return "instrument_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.isin != null && message.hasOwnProperty("isin"))
            if (!$util.isString(message.isin))
                return "isin: string expected";
        if (message.active != null && message.hasOwnProperty("active"))
            if (typeof message.active !== "boolean")
                return "active: boolean expected";
        if (message.body_text != null && message.hasOwnProperty("body_text"))
            if (!$util.isString(message.body_text))
                return "body_text: string expected";
        if (message.video_caption != null && message.hasOwnProperty("video_caption"))
            if (!$util.isString(message.video_caption))
                return "video_caption: string expected";
        if (message.video_link != null && message.hasOwnProperty("video_link"))
            if (!$util.isString(message.video_link))
                return "video_link: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a CompanyProfile message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CompanyProfile
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CompanyProfile} CompanyProfile
     */
    CompanyProfile.fromObject = function fromObject(object) {
        if (object instanceof $root.CompanyProfile)
            return object;
        let message = new $root.CompanyProfile();
        if (object.id != null)
            message.id = String(object.id);
        if (object.instrument_id != null)
            message.instrument_id = String(object.instrument_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.isin != null)
            message.isin = String(object.isin);
        if (object.active != null)
            message.active = Boolean(object.active);
        if (object.body_text != null)
            message.body_text = String(object.body_text);
        if (object.video_caption != null)
            message.video_caption = String(object.video_caption);
        if (object.video_link != null)
            message.video_link = String(object.video_link);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".CompanyProfile.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".CompanyProfile.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a CompanyProfile message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CompanyProfile
     * @static
     * @param {CompanyProfile} message CompanyProfile
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CompanyProfile.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.instrument_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.isin = "";
            object.active = false;
            object.body_text = "";
            object.video_caption = "";
            object.video_link = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.instrument_id != null && message.hasOwnProperty("instrument_id"))
            object.instrument_id = message.instrument_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.isin != null && message.hasOwnProperty("isin"))
            object.isin = message.isin;
        if (message.active != null && message.hasOwnProperty("active"))
            object.active = message.active;
        if (message.body_text != null && message.hasOwnProperty("body_text"))
            object.body_text = message.body_text;
        if (message.video_caption != null && message.hasOwnProperty("video_caption"))
            object.video_caption = message.video_caption;
        if (message.video_link != null && message.hasOwnProperty("video_link"))
            object.video_link = message.video_link;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this CompanyProfile to JSON.
     * @function toJSON
     * @memberof CompanyProfile
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CompanyProfile.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CompanyProfile;
})();

export const FinancierTransactionType = $root.FinancierTransactionType = (() => {

    /**
     * Properties of a FinancierTransactionType.
     * @exports IFinancierTransactionType
     * @interface IFinancierTransactionType
     */

    /**
     * Constructs a new FinancierTransactionType.
     * @exports FinancierTransactionType
     * @classdesc Represents a FinancierTransactionType.
     * @implements IFinancierTransactionType
     * @constructor
     * @param {IFinancierTransactionType=} [properties] Properties to set
     */
    function FinancierTransactionType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new FinancierTransactionType instance using the specified properties.
     * @function create
     * @memberof FinancierTransactionType
     * @static
     * @param {IFinancierTransactionType=} [properties] Properties to set
     * @returns {FinancierTransactionType} FinancierTransactionType instance
     */
    FinancierTransactionType.create = function create(properties) {
        return new FinancierTransactionType(properties);
    };

    /**
     * Encodes the specified FinancierTransactionType message. Does not implicitly {@link FinancierTransactionType.verify|verify} messages.
     * @function encode
     * @memberof FinancierTransactionType
     * @static
     * @param {IFinancierTransactionType} message FinancierTransactionType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierTransactionType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified FinancierTransactionType message, length delimited. Does not implicitly {@link FinancierTransactionType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FinancierTransactionType
     * @static
     * @param {IFinancierTransactionType} message FinancierTransactionType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierTransactionType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FinancierTransactionType message from the specified reader or buffer.
     * @function decode
     * @memberof FinancierTransactionType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FinancierTransactionType} FinancierTransactionType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierTransactionType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FinancierTransactionType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FinancierTransactionType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FinancierTransactionType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FinancierTransactionType} FinancierTransactionType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierTransactionType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FinancierTransactionType message.
     * @function verify
     * @memberof FinancierTransactionType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FinancierTransactionType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a FinancierTransactionType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FinancierTransactionType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FinancierTransactionType} FinancierTransactionType
     */
    FinancierTransactionType.fromObject = function fromObject(object) {
        if (object instanceof $root.FinancierTransactionType)
            return object;
        return new $root.FinancierTransactionType();
    };

    /**
     * Creates a plain object from a FinancierTransactionType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FinancierTransactionType
     * @static
     * @param {FinancierTransactionType} message FinancierTransactionType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FinancierTransactionType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this FinancierTransactionType to JSON.
     * @function toJSON
     * @memberof FinancierTransactionType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FinancierTransactionType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name FinancierTransactionType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} SUSPENSE=1 SUSPENSE value
     * @property {number} FUND=2 FUND value
     */
    FinancierTransactionType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "SUSPENSE"] = 1;
        values[valuesById[2] = "FUND"] = 2;
        return values;
    })();

    return FinancierTransactionType;
})();

export const FinancierTransaction = $root.FinancierTransaction = (() => {

    /**
     * Properties of a FinancierTransaction.
     * @exports IFinancierTransaction
     * @interface IFinancierTransaction
     * @property {string|null} [transaction_reference] FinancierTransaction transaction_reference
     * @property {string|null} [external_reference] FinancierTransaction external_reference
     * @property {string|null} [product_id] FinancierTransaction product_id
     * @property {string|null} [aud_amount] FinancierTransaction aud_amount
     * @property {string|null} [bank_transaction_date] FinancierTransaction bank_transaction_date
     * @property {SaverPortfolio.Enum|null} [portfolio] FinancierTransaction portfolio
     * @property {TransactionReason.Enum|null} [reason] FinancierTransaction reason
     * @property {TransactionStatus.Enum|null} [status] FinancierTransaction status
     * @property {FinancierTransactionType.Enum|null} [type] FinancierTransaction type
     * @property {AccountingStatus.Enum|null} [accounting_status] FinancierTransaction accounting_status
     * @property {AccountingReconciliationStatus.Enum|null} [reconciliation_status] FinancierTransaction reconciliation_status
     * @property {FinancierTransaction.IOffendedWatchlistItems|null} [offended_watchlist_items] FinancierTransaction offended_watchlist_items
     * @property {string|null} [aba_id] FinancierTransaction aba_id
     * @property {BankAccountName.Enum|null} [bank_account] FinancierTransaction bank_account
     * @property {FinancierProvider.Enum|null} [provider] FinancierTransaction provider
     * @property {google.protobuf.ITimestamp|null} [requested_at] FinancierTransaction requested_at
     * @property {google.protobuf.ITimestamp|null} [posted_at] FinancierTransaction posted_at
     * @property {google.protobuf.ITimestamp|null} [response_at] FinancierTransaction response_at
     */

    /**
     * Constructs a new FinancierTransaction.
     * @exports FinancierTransaction
     * @classdesc Represents a FinancierTransaction.
     * @implements IFinancierTransaction
     * @constructor
     * @param {IFinancierTransaction=} [properties] Properties to set
     */
    function FinancierTransaction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FinancierTransaction transaction_reference.
     * @member {string} transaction_reference
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.transaction_reference = "";

    /**
     * FinancierTransaction external_reference.
     * @member {string} external_reference
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.external_reference = "";

    /**
     * FinancierTransaction product_id.
     * @member {string} product_id
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.product_id = "";

    /**
     * FinancierTransaction aud_amount.
     * @member {string} aud_amount
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.aud_amount = "";

    /**
     * FinancierTransaction bank_transaction_date.
     * @member {string} bank_transaction_date
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.bank_transaction_date = "";

    /**
     * FinancierTransaction portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.portfolio = 0;

    /**
     * FinancierTransaction reason.
     * @member {TransactionReason.Enum} reason
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.reason = 0;

    /**
     * FinancierTransaction status.
     * @member {TransactionStatus.Enum} status
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.status = 0;

    /**
     * FinancierTransaction type.
     * @member {FinancierTransactionType.Enum} type
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.type = 0;

    /**
     * FinancierTransaction accounting_status.
     * @member {AccountingStatus.Enum} accounting_status
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.accounting_status = 0;

    /**
     * FinancierTransaction reconciliation_status.
     * @member {AccountingReconciliationStatus.Enum} reconciliation_status
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.reconciliation_status = 0;

    /**
     * FinancierTransaction offended_watchlist_items.
     * @member {FinancierTransaction.IOffendedWatchlistItems|null|undefined} offended_watchlist_items
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.offended_watchlist_items = null;

    /**
     * FinancierTransaction aba_id.
     * @member {string} aba_id
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.aba_id = "";

    /**
     * FinancierTransaction bank_account.
     * @member {BankAccountName.Enum} bank_account
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.bank_account = 0;

    /**
     * FinancierTransaction provider.
     * @member {FinancierProvider.Enum} provider
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.provider = 0;

    /**
     * FinancierTransaction requested_at.
     * @member {google.protobuf.ITimestamp|null|undefined} requested_at
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.requested_at = null;

    /**
     * FinancierTransaction posted_at.
     * @member {google.protobuf.ITimestamp|null|undefined} posted_at
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.posted_at = null;

    /**
     * FinancierTransaction response_at.
     * @member {google.protobuf.ITimestamp|null|undefined} response_at
     * @memberof FinancierTransaction
     * @instance
     */
    FinancierTransaction.prototype.response_at = null;

    /**
     * Creates a new FinancierTransaction instance using the specified properties.
     * @function create
     * @memberof FinancierTransaction
     * @static
     * @param {IFinancierTransaction=} [properties] Properties to set
     * @returns {FinancierTransaction} FinancierTransaction instance
     */
    FinancierTransaction.create = function create(properties) {
        return new FinancierTransaction(properties);
    };

    /**
     * Encodes the specified FinancierTransaction message. Does not implicitly {@link FinancierTransaction.verify|verify} messages.
     * @function encode
     * @memberof FinancierTransaction
     * @static
     * @param {IFinancierTransaction} message FinancierTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierTransaction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.external_reference);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.product_id);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.aud_amount);
        if (message.bank_transaction_date != null && message.hasOwnProperty("bank_transaction_date"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.bank_transaction_date);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.portfolio);
        if (message.reason != null && message.hasOwnProperty("reason"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.reason);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.type);
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.accounting_status);
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.reconciliation_status);
        if (message.offended_watchlist_items != null && message.hasOwnProperty("offended_watchlist_items"))
            $root.FinancierTransaction.OffendedWatchlistItems.encode(message.offended_watchlist_items, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.aba_id);
        if (message.bank_account != null && message.hasOwnProperty("bank_account"))
            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.bank_account);
        if (message.provider != null && message.hasOwnProperty("provider"))
            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.provider);
        if (message.requested_at != null && message.hasOwnProperty("requested_at"))
            $root.google.protobuf.Timestamp.encode(message.requested_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        if (message.posted_at != null && message.hasOwnProperty("posted_at"))
            $root.google.protobuf.Timestamp.encode(message.posted_at, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        if (message.response_at != null && message.hasOwnProperty("response_at"))
            $root.google.protobuf.Timestamp.encode(message.response_at, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FinancierTransaction message, length delimited. Does not implicitly {@link FinancierTransaction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FinancierTransaction
     * @static
     * @param {IFinancierTransaction} message FinancierTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinancierTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FinancierTransaction message from the specified reader or buffer.
     * @function decode
     * @memberof FinancierTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FinancierTransaction} FinancierTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FinancierTransaction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_reference = reader.string();
                break;
            case 2:
                message.external_reference = reader.string();
                break;
            case 3:
                message.product_id = reader.string();
                break;
            case 4:
                message.aud_amount = reader.string();
                break;
            case 5:
                message.bank_transaction_date = reader.string();
                break;
            case 6:
                message.portfolio = reader.int32();
                break;
            case 7:
                message.reason = reader.int32();
                break;
            case 8:
                message.status = reader.int32();
                break;
            case 9:
                message.type = reader.int32();
                break;
            case 10:
                message.accounting_status = reader.int32();
                break;
            case 11:
                message.reconciliation_status = reader.int32();
                break;
            case 12:
                message.offended_watchlist_items = $root.FinancierTransaction.OffendedWatchlistItems.decode(reader, reader.uint32());
                break;
            case 13:
                message.aba_id = reader.string();
                break;
            case 14:
                message.bank_account = reader.int32();
                break;
            case 15:
                message.provider = reader.int32();
                break;
            case 99:
                message.requested_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 100:
                message.posted_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 101:
                message.response_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FinancierTransaction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FinancierTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FinancierTransaction} FinancierTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinancierTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FinancierTransaction message.
     * @function verify
     * @memberof FinancierTransaction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FinancierTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            if (!$util.isString(message.external_reference))
                return "external_reference: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.bank_transaction_date != null && message.hasOwnProperty("bank_transaction_date"))
            if (!$util.isString(message.bank_transaction_date))
                return "bank_transaction_date: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.reason != null && message.hasOwnProperty("reason"))
            switch (message.reason) {
            default:
                return "reason: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                break;
            }
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            switch (message.accounting_status) {
            default:
                return "accounting_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            switch (message.reconciliation_status) {
            default:
                return "reconciliation_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.offended_watchlist_items != null && message.hasOwnProperty("offended_watchlist_items")) {
            let error = $root.FinancierTransaction.OffendedWatchlistItems.verify(message.offended_watchlist_items);
            if (error)
                return "offended_watchlist_items." + error;
        }
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            if (!$util.isString(message.aba_id))
                return "aba_id: string expected";
        if (message.bank_account != null && message.hasOwnProperty("bank_account"))
            switch (message.bank_account) {
            default:
                return "bank_account: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
            case 32:
            case 33:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
            case 58:
            case 59:
            case 60:
            case 61:
            case 62:
            case 63:
            case 64:
            case 65:
            case 66:
            case 100:
            case 200:
            case 201:
            case 202:
            case 203:
            case 204:
                break;
            }
        if (message.provider != null && message.hasOwnProperty("provider"))
            switch (message.provider) {
            default:
                return "provider: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.requested_at != null && message.hasOwnProperty("requested_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.requested_at);
            if (error)
                return "requested_at." + error;
        }
        if (message.posted_at != null && message.hasOwnProperty("posted_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.posted_at);
            if (error)
                return "posted_at." + error;
        }
        if (message.response_at != null && message.hasOwnProperty("response_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.response_at);
            if (error)
                return "response_at." + error;
        }
        return null;
    };

    /**
     * Creates a FinancierTransaction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FinancierTransaction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FinancierTransaction} FinancierTransaction
     */
    FinancierTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.FinancierTransaction)
            return object;
        let message = new $root.FinancierTransaction();
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.external_reference != null)
            message.external_reference = String(object.external_reference);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        if (object.bank_transaction_date != null)
            message.bank_transaction_date = String(object.bank_transaction_date);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        switch (object.reason) {
        case "UNKNOWN":
        case 0:
            message.reason = 0;
            break;
        case "FUND_APPLICATION":
        case 1:
            message.reason = 1;
            break;
        case "FUND_EXIT":
        case 2:
            message.reason = 2;
            break;
        case "PORTFOLIO_FEES":
        case 3:
            message.reason = 3;
            break;
        case "MARKET_TRADE":
        case 4:
            message.reason = 4;
            break;
        case "INTEREST_PAYMENT":
        case 5:
            message.reason = 5;
            break;
        case "DIVIDEND_CASH_PAYMENT":
        case 6:
            message.reason = 6;
            break;
        case "ERROR_ADJUSTMENT_PAYMENT":
        case 7:
            message.reason = 7;
            break;
        case "FREEBIE_ISSUANCE":
        case 8:
            message.reason = 8;
            break;
        case "MANUAL":
        case 9:
            message.reason = 9;
            break;
        case "RETURN_DIRECT_ENTRY_RETURN":
        case 10:
            message.reason = 10;
            break;
        case "MANAGEMENT_FEES":
        case 11:
            message.reason = 11;
            break;
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PENDING_REVIEW":
        case 1:
            message.status = 1;
            break;
        case "REJECTED_BY_RISK_TEAM":
        case 2:
            message.status = 2;
            break;
        case "SCHEDULED":
        case 3:
            message.status = 3;
            break;
        case "FAILED":
        case 4:
            message.status = 4;
            break;
        case "PAID":
        case 5:
            message.status = 5;
            break;
        case "READY_TO_SCHEDULE":
        case 6:
            message.status = 6;
            break;
        case "CLEARED":
        case 7:
            message.status = 7;
            break;
        case "CLEARING":
        case 8:
            message.status = 8;
            break;
        case "CLEARING_UNITS_ISSUED":
        case 9:
            message.status = 9;
            break;
        case "USER_CANCELLED":
        case 10:
            message.status = 10;
            break;
        }
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "SUSPENSE":
        case 1:
            message.type = 1;
            break;
        case "FUND":
        case 2:
            message.type = 2;
            break;
        }
        switch (object.accounting_status) {
        case "UNKNOWN":
        case 0:
            message.accounting_status = 0;
            break;
        case "PENDING":
        case 1:
            message.accounting_status = 1;
            break;
        case "UNCATEGORISED":
        case 2:
            message.accounting_status = 2;
            break;
        case "CATEGORISED":
        case 3:
            message.accounting_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.accounting_status = 4;
            break;
        }
        switch (object.reconciliation_status) {
        case "UNKNOWN":
        case 0:
            message.reconciliation_status = 0;
            break;
        case "PENDING":
        case 1:
            message.reconciliation_status = 1;
            break;
        case "RECONCILED":
        case 2:
            message.reconciliation_status = 2;
            break;
        case "UNRECONCILED":
        case 3:
            message.reconciliation_status = 3;
            break;
        case "NOT_APPLICABLE":
        case 4:
            message.reconciliation_status = 4;
            break;
        }
        if (object.offended_watchlist_items != null) {
            if (typeof object.offended_watchlist_items !== "object")
                throw TypeError(".FinancierTransaction.offended_watchlist_items: object expected");
            message.offended_watchlist_items = $root.FinancierTransaction.OffendedWatchlistItems.fromObject(object.offended_watchlist_items);
        }
        if (object.aba_id != null)
            message.aba_id = String(object.aba_id);
        switch (object.bank_account) {
        case "UNKNOWN":
        case 0:
            message.bank_account = 0;
            break;
        case "MACQUARIE_SUSPENSE_UNIVERSE":
        case 1:
            message.bank_account = 1;
            break;
        case "MACQUARIE_SUSPENSE_INDEX":
        case 2:
            message.bank_account = 2;
            break;
        case "MACQUARIE_SUSPENSE_SHARED":
        case 3:
            message.bank_account = 3;
            break;
        case "MACQUARIE_FUND_UNIVERSE":
        case 4:
            message.bank_account = 4;
            break;
        case "MACQUARIE_FUND_INDEX":
        case 5:
            message.bank_account = 5;
            break;
        case "MACQUARIE_DISTRIBUTIONS_UNIVERSE":
        case 6:
            message.bank_account = 6;
            break;
        case "MACQUARIE_DISTRIBUTIONS_INDEX":
        case 7:
            message.bank_account = 7;
            break;
        case "MACQUARIE_FREEBIES_UNIVERSE":
        case 8:
            message.bank_account = 8;
            break;
        case "MACQUARIE_FREEBIES_INDEX":
        case 9:
            message.bank_account = 9;
            break;
        case "MACQUARIE_FREEBIES_EARTH":
        case 10:
            message.bank_account = 10;
            break;
        case "MACQUARIE_SUSPENSE_EARTH":
        case 11:
            message.bank_account = 11;
            break;
        case "MACQUARIE_FUND_EARTH":
        case 12:
            message.bank_account = 12;
            break;
        case "MACQUARIE_DISTRIBUTIONS_EARTH":
        case 13:
            message.bank_account = 13;
            break;
        case "ZEPTO_FLOAT_ORIGIN":
        case 14:
            message.bank_account = 14;
            break;
        case "ZEPTO_FLOAT_UNIVERSE":
        case 15:
            message.bank_account = 15;
            break;
        case "ZEPTO_FLOAT_EARTH":
        case 16:
            message.bank_account = 16;
            break;
        case "ZEPTO_FLOAT_NOVA":
        case 17:
            message.bank_account = 17;
            break;
        case "ZEPTO_TRUST_ORIGIN":
        case 18:
            message.bank_account = 18;
            break;
        case "ZEPTO_TRUST_UNIVERSE":
        case 19:
            message.bank_account = 19;
            break;
        case "ZEPTO_TRUST_EARTH":
        case 20:
            message.bank_account = 20;
            break;
        case "ZEPTO_TRUST_NOVA":
        case 21:
            message.bank_account = 21;
            break;
        case "ZEPTO_FLOAT_NOVA_FEES":
        case 22:
            message.bank_account = 22;
            break;
        case "ZEPTO_TRUST_CASH":
        case 23:
            message.bank_account = 23;
            break;
        case "ZEPTO_TRUST_GALAXY":
        case 24:
            message.bank_account = 24;
            break;
        case "ZEPTO_TRUST_EXPLORER":
        case 25:
            message.bank_account = 25;
            break;
        case "ZEPTO_FLOAT_GALAXY":
        case 26:
            message.bank_account = 26;
            break;
        case "ZEPTO_FLOAT_EXPLORER":
        case 27:
            message.bank_account = 27;
            break;
        case "ZEPTO_DISTRIBUTIONS_EXPLORER":
        case 28:
            message.bank_account = 28;
            break;
        case "ZEPTO_DISTRIBUTIONS_GALAXY":
        case 29:
            message.bank_account = 29;
            break;
        case "ZEPTO_DISTRIBUTIONS_INDEX":
        case 30:
            message.bank_account = 30;
            break;
        case "ZEPTO_DISTRIBUTIONS_UNIVERSE":
        case 31:
            message.bank_account = 31;
            break;
        case "ZEPTO_DISTRIBUTIONS_EARTH":
        case 32:
            message.bank_account = 32;
            break;
        case "ZEPTO_TRUST_CASH_MISC":
        case 33:
            message.bank_account = 33;
            break;
        case "WESTPAC_SUSPENSE_ORIGIN":
        case 51:
            message.bank_account = 51;
            break;
        case "WESTPAC_SUSPENSE_UNIVERSE":
        case 52:
            message.bank_account = 52;
            break;
        case "WESTPAC_SUSPENSE_EARTH":
        case 53:
            message.bank_account = 53;
            break;
        case "WESTPAC_FUND_ORIGIN":
        case 54:
            message.bank_account = 54;
            break;
        case "WESTPAC_FUND_UNIVERSE":
        case 55:
            message.bank_account = 55;
            break;
        case "WESTPAC_FUND_EARTH":
        case 56:
            message.bank_account = 56;
            break;
        case "WESTPAC_DISTRIBUTIONS_ORIGIN":
        case 57:
            message.bank_account = 57;
            break;
        case "WESTPAC_DISTRIBUTIONS_UNIVERSE":
        case 58:
            message.bank_account = 58;
            break;
        case "WESTPAC_DISTRIBUTIONS_EARTH":
        case 59:
            message.bank_account = 59;
            break;
        case "WESTPAC_FREEBIES_SHARED":
        case 60:
            message.bank_account = 60;
            break;
        case "WESTPAC_FEES_AND_CHARGES":
        case 61:
            message.bank_account = 61;
            break;
        case "WESTPAC_981B_NOVA":
        case 62:
            message.bank_account = 62;
            break;
        case "WESTPAC_NOVA_FEES":
        case 63:
            message.bank_account = 63;
            break;
        case "WESTPAC_NOVA_MISC":
        case 64:
            message.bank_account = 64;
            break;
        case "WESTPAC_SAVER_FIXED_FEES":
        case 65:
            message.bank_account = 65;
            break;
        case "WESTPAC_SAVER_BPS_FEES":
        case 66:
            message.bank_account = 66;
            break;
        case "ALPACA_AIRWALLEX":
        case 100:
            message.bank_account = 100;
            break;
        case "IB_ORIGIN":
        case 200:
            message.bank_account = 200;
            break;
        case "IB_UNIVERSE":
        case 201:
            message.bank_account = 201;
            break;
        case "IB_EARTH":
        case 202:
            message.bank_account = 202;
            break;
        case "IB_EXPLORER":
        case 203:
            message.bank_account = 203;
            break;
        case "IB_GALAXY":
        case 204:
            message.bank_account = 204;
            break;
        }
        switch (object.provider) {
        case "UNKNOWN":
        case 0:
            message.provider = 0;
            break;
        case "MACQUARIE":
        case 1:
            message.provider = 1;
            break;
        case "ZEPTO":
        case 2:
            message.provider = 2;
            break;
        case "WESTPAC":
        case 3:
            message.provider = 3;
            break;
        case "MONEY":
        case 4:
            message.provider = 4;
            break;
        }
        if (object.requested_at != null) {
            if (typeof object.requested_at !== "object")
                throw TypeError(".FinancierTransaction.requested_at: object expected");
            message.requested_at = $root.google.protobuf.Timestamp.fromObject(object.requested_at);
        }
        if (object.posted_at != null) {
            if (typeof object.posted_at !== "object")
                throw TypeError(".FinancierTransaction.posted_at: object expected");
            message.posted_at = $root.google.protobuf.Timestamp.fromObject(object.posted_at);
        }
        if (object.response_at != null) {
            if (typeof object.response_at !== "object")
                throw TypeError(".FinancierTransaction.response_at: object expected");
            message.response_at = $root.google.protobuf.Timestamp.fromObject(object.response_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a FinancierTransaction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FinancierTransaction
     * @static
     * @param {FinancierTransaction} message FinancierTransaction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FinancierTransaction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_reference = "";
            object.external_reference = "";
            object.product_id = "";
            object.aud_amount = "";
            object.bank_transaction_date = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.reason = options.enums === String ? "UNKNOWN" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.accounting_status = options.enums === String ? "UNKNOWN" : 0;
            object.reconciliation_status = options.enums === String ? "UNKNOWN" : 0;
            object.offended_watchlist_items = null;
            object.aba_id = "";
            object.bank_account = options.enums === String ? "UNKNOWN" : 0;
            object.provider = options.enums === String ? "UNKNOWN" : 0;
            object.requested_at = null;
            object.posted_at = null;
            object.response_at = null;
        }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.external_reference != null && message.hasOwnProperty("external_reference"))
            object.external_reference = message.external_reference;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.bank_transaction_date != null && message.hasOwnProperty("bank_transaction_date"))
            object.bank_transaction_date = message.bank_transaction_date;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = options.enums === String ? $root.TransactionReason.Enum[message.reason] : message.reason;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.TransactionStatus.Enum[message.status] : message.status;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.FinancierTransactionType.Enum[message.type] : message.type;
        if (message.accounting_status != null && message.hasOwnProperty("accounting_status"))
            object.accounting_status = options.enums === String ? $root.AccountingStatus.Enum[message.accounting_status] : message.accounting_status;
        if (message.reconciliation_status != null && message.hasOwnProperty("reconciliation_status"))
            object.reconciliation_status = options.enums === String ? $root.AccountingReconciliationStatus.Enum[message.reconciliation_status] : message.reconciliation_status;
        if (message.offended_watchlist_items != null && message.hasOwnProperty("offended_watchlist_items"))
            object.offended_watchlist_items = $root.FinancierTransaction.OffendedWatchlistItems.toObject(message.offended_watchlist_items, options);
        if (message.aba_id != null && message.hasOwnProperty("aba_id"))
            object.aba_id = message.aba_id;
        if (message.bank_account != null && message.hasOwnProperty("bank_account"))
            object.bank_account = options.enums === String ? $root.BankAccountName.Enum[message.bank_account] : message.bank_account;
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = options.enums === String ? $root.FinancierProvider.Enum[message.provider] : message.provider;
        if (message.requested_at != null && message.hasOwnProperty("requested_at"))
            object.requested_at = $root.google.protobuf.Timestamp.toObject(message.requested_at, options);
        if (message.posted_at != null && message.hasOwnProperty("posted_at"))
            object.posted_at = $root.google.protobuf.Timestamp.toObject(message.posted_at, options);
        if (message.response_at != null && message.hasOwnProperty("response_at"))
            object.response_at = $root.google.protobuf.Timestamp.toObject(message.response_at, options);
        return object;
    };

    /**
     * Converts this FinancierTransaction to JSON.
     * @function toJSON
     * @memberof FinancierTransaction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FinancierTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    FinancierTransaction.OffendedWatchlistItems = (function() {

        /**
         * Properties of an OffendedWatchlistItems.
         * @memberof FinancierTransaction
         * @interface IOffendedWatchlistItems
         * @property {Array.<IStringWatchlistItem>|null} [string_items] OffendedWatchlistItems string_items
         * @property {Array.<INumericWatchlistItem>|null} [numeric_items] OffendedWatchlistItems numeric_items
         */

        /**
         * Constructs a new OffendedWatchlistItems.
         * @memberof FinancierTransaction
         * @classdesc Represents an OffendedWatchlistItems.
         * @implements IOffendedWatchlistItems
         * @constructor
         * @param {FinancierTransaction.IOffendedWatchlistItems=} [properties] Properties to set
         */
        function OffendedWatchlistItems(properties) {
            this.string_items = [];
            this.numeric_items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OffendedWatchlistItems string_items.
         * @member {Array.<IStringWatchlistItem>} string_items
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @instance
         */
        OffendedWatchlistItems.prototype.string_items = $util.emptyArray;

        /**
         * OffendedWatchlistItems numeric_items.
         * @member {Array.<INumericWatchlistItem>} numeric_items
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @instance
         */
        OffendedWatchlistItems.prototype.numeric_items = $util.emptyArray;

        /**
         * Creates a new OffendedWatchlistItems instance using the specified properties.
         * @function create
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @static
         * @param {FinancierTransaction.IOffendedWatchlistItems=} [properties] Properties to set
         * @returns {FinancierTransaction.OffendedWatchlistItems} OffendedWatchlistItems instance
         */
        OffendedWatchlistItems.create = function create(properties) {
            return new OffendedWatchlistItems(properties);
        };

        /**
         * Encodes the specified OffendedWatchlistItems message. Does not implicitly {@link FinancierTransaction.OffendedWatchlistItems.verify|verify} messages.
         * @function encode
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @static
         * @param {FinancierTransaction.IOffendedWatchlistItems} message OffendedWatchlistItems message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OffendedWatchlistItems.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.string_items != null && message.string_items.length)
                for (let i = 0; i < message.string_items.length; ++i)
                    $root.StringWatchlistItem.encode(message.string_items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.numeric_items != null && message.numeric_items.length)
                for (let i = 0; i < message.numeric_items.length; ++i)
                    $root.NumericWatchlistItem.encode(message.numeric_items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OffendedWatchlistItems message, length delimited. Does not implicitly {@link FinancierTransaction.OffendedWatchlistItems.verify|verify} messages.
         * @function encodeDelimited
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @static
         * @param {FinancierTransaction.IOffendedWatchlistItems} message OffendedWatchlistItems message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OffendedWatchlistItems.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OffendedWatchlistItems message from the specified reader or buffer.
         * @function decode
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {FinancierTransaction.OffendedWatchlistItems} OffendedWatchlistItems
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OffendedWatchlistItems.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FinancierTransaction.OffendedWatchlistItems();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.string_items && message.string_items.length))
                        message.string_items = [];
                    message.string_items.push($root.StringWatchlistItem.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.numeric_items && message.numeric_items.length))
                        message.numeric_items = [];
                    message.numeric_items.push($root.NumericWatchlistItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OffendedWatchlistItems message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {FinancierTransaction.OffendedWatchlistItems} OffendedWatchlistItems
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OffendedWatchlistItems.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OffendedWatchlistItems message.
         * @function verify
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OffendedWatchlistItems.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.string_items != null && message.hasOwnProperty("string_items")) {
                if (!Array.isArray(message.string_items))
                    return "string_items: array expected";
                for (let i = 0; i < message.string_items.length; ++i) {
                    let error = $root.StringWatchlistItem.verify(message.string_items[i]);
                    if (error)
                        return "string_items." + error;
                }
            }
            if (message.numeric_items != null && message.hasOwnProperty("numeric_items")) {
                if (!Array.isArray(message.numeric_items))
                    return "numeric_items: array expected";
                for (let i = 0; i < message.numeric_items.length; ++i) {
                    let error = $root.NumericWatchlistItem.verify(message.numeric_items[i]);
                    if (error)
                        return "numeric_items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an OffendedWatchlistItems message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {FinancierTransaction.OffendedWatchlistItems} OffendedWatchlistItems
         */
        OffendedWatchlistItems.fromObject = function fromObject(object) {
            if (object instanceof $root.FinancierTransaction.OffendedWatchlistItems)
                return object;
            let message = new $root.FinancierTransaction.OffendedWatchlistItems();
            if (object.string_items) {
                if (!Array.isArray(object.string_items))
                    throw TypeError(".FinancierTransaction.OffendedWatchlistItems.string_items: array expected");
                message.string_items = [];
                for (let i = 0; i < object.string_items.length; ++i) {
                    if (typeof object.string_items[i] !== "object")
                        throw TypeError(".FinancierTransaction.OffendedWatchlistItems.string_items: object expected");
                    message.string_items[i] = $root.StringWatchlistItem.fromObject(object.string_items[i]);
                }
            }
            if (object.numeric_items) {
                if (!Array.isArray(object.numeric_items))
                    throw TypeError(".FinancierTransaction.OffendedWatchlistItems.numeric_items: array expected");
                message.numeric_items = [];
                for (let i = 0; i < object.numeric_items.length; ++i) {
                    if (typeof object.numeric_items[i] !== "object")
                        throw TypeError(".FinancierTransaction.OffendedWatchlistItems.numeric_items: object expected");
                    message.numeric_items[i] = $root.NumericWatchlistItem.fromObject(object.numeric_items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an OffendedWatchlistItems message. Also converts values to other types if specified.
         * @function toObject
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @static
         * @param {FinancierTransaction.OffendedWatchlistItems} message OffendedWatchlistItems
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OffendedWatchlistItems.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.string_items = [];
                object.numeric_items = [];
            }
            if (message.string_items && message.string_items.length) {
                object.string_items = [];
                for (let j = 0; j < message.string_items.length; ++j)
                    object.string_items[j] = $root.StringWatchlistItem.toObject(message.string_items[j], options);
            }
            if (message.numeric_items && message.numeric_items.length) {
                object.numeric_items = [];
                for (let j = 0; j < message.numeric_items.length; ++j)
                    object.numeric_items[j] = $root.NumericWatchlistItem.toObject(message.numeric_items[j], options);
            }
            return object;
        };

        /**
         * Converts this OffendedWatchlistItems to JSON.
         * @function toJSON
         * @memberof FinancierTransaction.OffendedWatchlistItems
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OffendedWatchlistItems.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OffendedWatchlistItems;
    })();

    return FinancierTransaction;
})();

export const SearchFinancierTransactionsFilter = $root.SearchFinancierTransactionsFilter = (() => {

    /**
     * Properties of a SearchFinancierTransactionsFilter.
     * @exports ISearchFinancierTransactionsFilter
     * @interface ISearchFinancierTransactionsFilter
     * @property {SaverPortfolio.Enum|null} [portfolio] SearchFinancierTransactionsFilter portfolio
     * @property {TransactionReason.Enum|null} [transaction_reason] SearchFinancierTransactionsFilter transaction_reason
     * @property {FinancierTransactionType.Enum|null} [transaction_type] SearchFinancierTransactionsFilter transaction_type
     * @property {TransactionStatus.Enum|null} [transaction_status] SearchFinancierTransactionsFilter transaction_status
     * @property {string|null} [start_date] SearchFinancierTransactionsFilter start_date
     * @property {string|null} [end_date] SearchFinancierTransactionsFilter end_date
     * @property {string|null} [query] SearchFinancierTransactionsFilter query
     */

    /**
     * Constructs a new SearchFinancierTransactionsFilter.
     * @exports SearchFinancierTransactionsFilter
     * @classdesc Represents a SearchFinancierTransactionsFilter.
     * @implements ISearchFinancierTransactionsFilter
     * @constructor
     * @param {ISearchFinancierTransactionsFilter=} [properties] Properties to set
     */
    function SearchFinancierTransactionsFilter(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchFinancierTransactionsFilter portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof SearchFinancierTransactionsFilter
     * @instance
     */
    SearchFinancierTransactionsFilter.prototype.portfolio = 0;

    /**
     * SearchFinancierTransactionsFilter transaction_reason.
     * @member {TransactionReason.Enum} transaction_reason
     * @memberof SearchFinancierTransactionsFilter
     * @instance
     */
    SearchFinancierTransactionsFilter.prototype.transaction_reason = 0;

    /**
     * SearchFinancierTransactionsFilter transaction_type.
     * @member {FinancierTransactionType.Enum} transaction_type
     * @memberof SearchFinancierTransactionsFilter
     * @instance
     */
    SearchFinancierTransactionsFilter.prototype.transaction_type = 0;

    /**
     * SearchFinancierTransactionsFilter transaction_status.
     * @member {TransactionStatus.Enum} transaction_status
     * @memberof SearchFinancierTransactionsFilter
     * @instance
     */
    SearchFinancierTransactionsFilter.prototype.transaction_status = 0;

    /**
     * SearchFinancierTransactionsFilter start_date.
     * @member {string} start_date
     * @memberof SearchFinancierTransactionsFilter
     * @instance
     */
    SearchFinancierTransactionsFilter.prototype.start_date = "";

    /**
     * SearchFinancierTransactionsFilter end_date.
     * @member {string} end_date
     * @memberof SearchFinancierTransactionsFilter
     * @instance
     */
    SearchFinancierTransactionsFilter.prototype.end_date = "";

    /**
     * SearchFinancierTransactionsFilter query.
     * @member {string} query
     * @memberof SearchFinancierTransactionsFilter
     * @instance
     */
    SearchFinancierTransactionsFilter.prototype.query = "";

    /**
     * Creates a new SearchFinancierTransactionsFilter instance using the specified properties.
     * @function create
     * @memberof SearchFinancierTransactionsFilter
     * @static
     * @param {ISearchFinancierTransactionsFilter=} [properties] Properties to set
     * @returns {SearchFinancierTransactionsFilter} SearchFinancierTransactionsFilter instance
     */
    SearchFinancierTransactionsFilter.create = function create(properties) {
        return new SearchFinancierTransactionsFilter(properties);
    };

    /**
     * Encodes the specified SearchFinancierTransactionsFilter message. Does not implicitly {@link SearchFinancierTransactionsFilter.verify|verify} messages.
     * @function encode
     * @memberof SearchFinancierTransactionsFilter
     * @static
     * @param {ISearchFinancierTransactionsFilter} message SearchFinancierTransactionsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchFinancierTransactionsFilter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.portfolio);
        if (message.transaction_reason != null && message.hasOwnProperty("transaction_reason"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.transaction_reason);
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.transaction_type);
        if (message.transaction_status != null && message.hasOwnProperty("transaction_status"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.transaction_status);
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.start_date);
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.end_date);
        if (message.query != null && message.hasOwnProperty("query"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.query);
        return writer;
    };

    /**
     * Encodes the specified SearchFinancierTransactionsFilter message, length delimited. Does not implicitly {@link SearchFinancierTransactionsFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchFinancierTransactionsFilter
     * @static
     * @param {ISearchFinancierTransactionsFilter} message SearchFinancierTransactionsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchFinancierTransactionsFilter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchFinancierTransactionsFilter message from the specified reader or buffer.
     * @function decode
     * @memberof SearchFinancierTransactionsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchFinancierTransactionsFilter} SearchFinancierTransactionsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchFinancierTransactionsFilter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchFinancierTransactionsFilter();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.portfolio = reader.int32();
                break;
            case 2:
                message.transaction_reason = reader.int32();
                break;
            case 3:
                message.transaction_type = reader.int32();
                break;
            case 4:
                message.transaction_status = reader.int32();
                break;
            case 5:
                message.start_date = reader.string();
                break;
            case 6:
                message.end_date = reader.string();
                break;
            case 7:
                message.query = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchFinancierTransactionsFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchFinancierTransactionsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchFinancierTransactionsFilter} SearchFinancierTransactionsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchFinancierTransactionsFilter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchFinancierTransactionsFilter message.
     * @function verify
     * @memberof SearchFinancierTransactionsFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchFinancierTransactionsFilter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.transaction_reason != null && message.hasOwnProperty("transaction_reason"))
            switch (message.transaction_reason) {
            default:
                return "transaction_reason: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
            switch (message.transaction_type) {
            default:
                return "transaction_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.transaction_status != null && message.hasOwnProperty("transaction_status"))
            switch (message.transaction_status) {
            default:
                return "transaction_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                break;
            }
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            if (!$util.isString(message.start_date))
                return "start_date: string expected";
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            if (!$util.isString(message.end_date))
                return "end_date: string expected";
        if (message.query != null && message.hasOwnProperty("query"))
            if (!$util.isString(message.query))
                return "query: string expected";
        return null;
    };

    /**
     * Creates a SearchFinancierTransactionsFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchFinancierTransactionsFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchFinancierTransactionsFilter} SearchFinancierTransactionsFilter
     */
    SearchFinancierTransactionsFilter.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchFinancierTransactionsFilter)
            return object;
        let message = new $root.SearchFinancierTransactionsFilter();
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        switch (object.transaction_reason) {
        case "UNKNOWN":
        case 0:
            message.transaction_reason = 0;
            break;
        case "FUND_APPLICATION":
        case 1:
            message.transaction_reason = 1;
            break;
        case "FUND_EXIT":
        case 2:
            message.transaction_reason = 2;
            break;
        case "PORTFOLIO_FEES":
        case 3:
            message.transaction_reason = 3;
            break;
        case "MARKET_TRADE":
        case 4:
            message.transaction_reason = 4;
            break;
        case "INTEREST_PAYMENT":
        case 5:
            message.transaction_reason = 5;
            break;
        case "DIVIDEND_CASH_PAYMENT":
        case 6:
            message.transaction_reason = 6;
            break;
        case "ERROR_ADJUSTMENT_PAYMENT":
        case 7:
            message.transaction_reason = 7;
            break;
        case "FREEBIE_ISSUANCE":
        case 8:
            message.transaction_reason = 8;
            break;
        case "MANUAL":
        case 9:
            message.transaction_reason = 9;
            break;
        case "RETURN_DIRECT_ENTRY_RETURN":
        case 10:
            message.transaction_reason = 10;
            break;
        case "MANAGEMENT_FEES":
        case 11:
            message.transaction_reason = 11;
            break;
        }
        switch (object.transaction_type) {
        case "UNKNOWN":
        case 0:
            message.transaction_type = 0;
            break;
        case "SUSPENSE":
        case 1:
            message.transaction_type = 1;
            break;
        case "FUND":
        case 2:
            message.transaction_type = 2;
            break;
        }
        switch (object.transaction_status) {
        case "UNKNOWN":
        case 0:
            message.transaction_status = 0;
            break;
        case "PENDING_REVIEW":
        case 1:
            message.transaction_status = 1;
            break;
        case "REJECTED_BY_RISK_TEAM":
        case 2:
            message.transaction_status = 2;
            break;
        case "SCHEDULED":
        case 3:
            message.transaction_status = 3;
            break;
        case "FAILED":
        case 4:
            message.transaction_status = 4;
            break;
        case "PAID":
        case 5:
            message.transaction_status = 5;
            break;
        case "READY_TO_SCHEDULE":
        case 6:
            message.transaction_status = 6;
            break;
        case "CLEARED":
        case 7:
            message.transaction_status = 7;
            break;
        case "CLEARING":
        case 8:
            message.transaction_status = 8;
            break;
        case "CLEARING_UNITS_ISSUED":
        case 9:
            message.transaction_status = 9;
            break;
        case "USER_CANCELLED":
        case 10:
            message.transaction_status = 10;
            break;
        }
        if (object.start_date != null)
            message.start_date = String(object.start_date);
        if (object.end_date != null)
            message.end_date = String(object.end_date);
        if (object.query != null)
            message.query = String(object.query);
        return message;
    };

    /**
     * Creates a plain object from a SearchFinancierTransactionsFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchFinancierTransactionsFilter
     * @static
     * @param {SearchFinancierTransactionsFilter} message SearchFinancierTransactionsFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchFinancierTransactionsFilter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.transaction_reason = options.enums === String ? "UNKNOWN" : 0;
            object.transaction_type = options.enums === String ? "UNKNOWN" : 0;
            object.transaction_status = options.enums === String ? "UNKNOWN" : 0;
            object.start_date = "";
            object.end_date = "";
            object.query = "";
        }
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.transaction_reason != null && message.hasOwnProperty("transaction_reason"))
            object.transaction_reason = options.enums === String ? $root.TransactionReason.Enum[message.transaction_reason] : message.transaction_reason;
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
            object.transaction_type = options.enums === String ? $root.FinancierTransactionType.Enum[message.transaction_type] : message.transaction_type;
        if (message.transaction_status != null && message.hasOwnProperty("transaction_status"))
            object.transaction_status = options.enums === String ? $root.TransactionStatus.Enum[message.transaction_status] : message.transaction_status;
        if (message.start_date != null && message.hasOwnProperty("start_date"))
            object.start_date = message.start_date;
        if (message.end_date != null && message.hasOwnProperty("end_date"))
            object.end_date = message.end_date;
        if (message.query != null && message.hasOwnProperty("query"))
            object.query = message.query;
        return object;
    };

    /**
     * Converts this SearchFinancierTransactionsFilter to JSON.
     * @function toJSON
     * @memberof SearchFinancierTransactionsFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchFinancierTransactionsFilter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchFinancierTransactionsFilter;
})();

export const SortDirection = $root.SortDirection = (() => {

    /**
     * Properties of a SortDirection.
     * @exports ISortDirection
     * @interface ISortDirection
     */

    /**
     * Constructs a new SortDirection.
     * @exports SortDirection
     * @classdesc Represents a SortDirection.
     * @implements ISortDirection
     * @constructor
     * @param {ISortDirection=} [properties] Properties to set
     */
    function SortDirection(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SortDirection instance using the specified properties.
     * @function create
     * @memberof SortDirection
     * @static
     * @param {ISortDirection=} [properties] Properties to set
     * @returns {SortDirection} SortDirection instance
     */
    SortDirection.create = function create(properties) {
        return new SortDirection(properties);
    };

    /**
     * Encodes the specified SortDirection message. Does not implicitly {@link SortDirection.verify|verify} messages.
     * @function encode
     * @memberof SortDirection
     * @static
     * @param {ISortDirection} message SortDirection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SortDirection.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified SortDirection message, length delimited. Does not implicitly {@link SortDirection.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SortDirection
     * @static
     * @param {ISortDirection} message SortDirection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SortDirection.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SortDirection message from the specified reader or buffer.
     * @function decode
     * @memberof SortDirection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SortDirection} SortDirection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SortDirection.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SortDirection();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SortDirection message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SortDirection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SortDirection} SortDirection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SortDirection.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SortDirection message.
     * @function verify
     * @memberof SortDirection
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SortDirection.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a SortDirection message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SortDirection
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SortDirection} SortDirection
     */
    SortDirection.fromObject = function fromObject(object) {
        if (object instanceof $root.SortDirection)
            return object;
        return new $root.SortDirection();
    };

    /**
     * Creates a plain object from a SortDirection message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SortDirection
     * @static
     * @param {SortDirection} message SortDirection
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SortDirection.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this SortDirection to JSON.
     * @function toJSON
     * @memberof SortDirection
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SortDirection.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name SortDirection.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ASCENDING=1 ASCENDING value
     * @property {number} DESCENDING=2 DESCENDING value
     */
    SortDirection.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ASCENDING"] = 1;
        values[valuesById[2] = "DESCENDING"] = 2;
        return values;
    })();

    return SortDirection;
})();

export const SearchFinancierTransactionsSortField = $root.SearchFinancierTransactionsSortField = (() => {

    /**
     * Properties of a SearchFinancierTransactionsSortField.
     * @exports ISearchFinancierTransactionsSortField
     * @interface ISearchFinancierTransactionsSortField
     */

    /**
     * Constructs a new SearchFinancierTransactionsSortField.
     * @exports SearchFinancierTransactionsSortField
     * @classdesc Represents a SearchFinancierTransactionsSortField.
     * @implements ISearchFinancierTransactionsSortField
     * @constructor
     * @param {ISearchFinancierTransactionsSortField=} [properties] Properties to set
     */
    function SearchFinancierTransactionsSortField(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SearchFinancierTransactionsSortField instance using the specified properties.
     * @function create
     * @memberof SearchFinancierTransactionsSortField
     * @static
     * @param {ISearchFinancierTransactionsSortField=} [properties] Properties to set
     * @returns {SearchFinancierTransactionsSortField} SearchFinancierTransactionsSortField instance
     */
    SearchFinancierTransactionsSortField.create = function create(properties) {
        return new SearchFinancierTransactionsSortField(properties);
    };

    /**
     * Encodes the specified SearchFinancierTransactionsSortField message. Does not implicitly {@link SearchFinancierTransactionsSortField.verify|verify} messages.
     * @function encode
     * @memberof SearchFinancierTransactionsSortField
     * @static
     * @param {ISearchFinancierTransactionsSortField} message SearchFinancierTransactionsSortField message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchFinancierTransactionsSortField.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified SearchFinancierTransactionsSortField message, length delimited. Does not implicitly {@link SearchFinancierTransactionsSortField.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchFinancierTransactionsSortField
     * @static
     * @param {ISearchFinancierTransactionsSortField} message SearchFinancierTransactionsSortField message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchFinancierTransactionsSortField.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchFinancierTransactionsSortField message from the specified reader or buffer.
     * @function decode
     * @memberof SearchFinancierTransactionsSortField
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchFinancierTransactionsSortField} SearchFinancierTransactionsSortField
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchFinancierTransactionsSortField.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchFinancierTransactionsSortField();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchFinancierTransactionsSortField message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchFinancierTransactionsSortField
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchFinancierTransactionsSortField} SearchFinancierTransactionsSortField
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchFinancierTransactionsSortField.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchFinancierTransactionsSortField message.
     * @function verify
     * @memberof SearchFinancierTransactionsSortField
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchFinancierTransactionsSortField.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a SearchFinancierTransactionsSortField message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchFinancierTransactionsSortField
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchFinancierTransactionsSortField} SearchFinancierTransactionsSortField
     */
    SearchFinancierTransactionsSortField.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchFinancierTransactionsSortField)
            return object;
        return new $root.SearchFinancierTransactionsSortField();
    };

    /**
     * Creates a plain object from a SearchFinancierTransactionsSortField message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchFinancierTransactionsSortField
     * @static
     * @param {SearchFinancierTransactionsSortField} message SearchFinancierTransactionsSortField
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchFinancierTransactionsSortField.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this SearchFinancierTransactionsSortField to JSON.
     * @function toJSON
     * @memberof SearchFinancierTransactionsSortField
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchFinancierTransactionsSortField.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name SearchFinancierTransactionsSortField.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} REQUESTED_AT=1 REQUESTED_AT value
     * @property {number} AUD_AMOUNT=2 AUD_AMOUNT value
     */
    SearchFinancierTransactionsSortField.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "REQUESTED_AT"] = 1;
        values[valuesById[2] = "AUD_AMOUNT"] = 2;
        return values;
    })();

    return SearchFinancierTransactionsSortField;
})();

export const SearchFinancierTransactionsPageToken = $root.SearchFinancierTransactionsPageToken = (() => {

    /**
     * Properties of a SearchFinancierTransactionsPageToken.
     * @exports ISearchFinancierTransactionsPageToken
     * @interface ISearchFinancierTransactionsPageToken
     * @property {string|null} [from_transaction_reference] SearchFinancierTransactionsPageToken from_transaction_reference
     * @property {ISearchFinancierTransactionsFilter|null} [filter] SearchFinancierTransactionsPageToken filter
     * @property {SearchFinancierTransactionsSortField.Enum|null} [sort_field] SearchFinancierTransactionsPageToken sort_field
     * @property {SortDirection.Enum|null} [sort_direction] SearchFinancierTransactionsPageToken sort_direction
     */

    /**
     * Constructs a new SearchFinancierTransactionsPageToken.
     * @exports SearchFinancierTransactionsPageToken
     * @classdesc Represents a SearchFinancierTransactionsPageToken.
     * @implements ISearchFinancierTransactionsPageToken
     * @constructor
     * @param {ISearchFinancierTransactionsPageToken=} [properties] Properties to set
     */
    function SearchFinancierTransactionsPageToken(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchFinancierTransactionsPageToken from_transaction_reference.
     * @member {string} from_transaction_reference
     * @memberof SearchFinancierTransactionsPageToken
     * @instance
     */
    SearchFinancierTransactionsPageToken.prototype.from_transaction_reference = "";

    /**
     * SearchFinancierTransactionsPageToken filter.
     * @member {ISearchFinancierTransactionsFilter|null|undefined} filter
     * @memberof SearchFinancierTransactionsPageToken
     * @instance
     */
    SearchFinancierTransactionsPageToken.prototype.filter = null;

    /**
     * SearchFinancierTransactionsPageToken sort_field.
     * @member {SearchFinancierTransactionsSortField.Enum} sort_field
     * @memberof SearchFinancierTransactionsPageToken
     * @instance
     */
    SearchFinancierTransactionsPageToken.prototype.sort_field = 0;

    /**
     * SearchFinancierTransactionsPageToken sort_direction.
     * @member {SortDirection.Enum} sort_direction
     * @memberof SearchFinancierTransactionsPageToken
     * @instance
     */
    SearchFinancierTransactionsPageToken.prototype.sort_direction = 0;

    /**
     * Creates a new SearchFinancierTransactionsPageToken instance using the specified properties.
     * @function create
     * @memberof SearchFinancierTransactionsPageToken
     * @static
     * @param {ISearchFinancierTransactionsPageToken=} [properties] Properties to set
     * @returns {SearchFinancierTransactionsPageToken} SearchFinancierTransactionsPageToken instance
     */
    SearchFinancierTransactionsPageToken.create = function create(properties) {
        return new SearchFinancierTransactionsPageToken(properties);
    };

    /**
     * Encodes the specified SearchFinancierTransactionsPageToken message. Does not implicitly {@link SearchFinancierTransactionsPageToken.verify|verify} messages.
     * @function encode
     * @memberof SearchFinancierTransactionsPageToken
     * @static
     * @param {ISearchFinancierTransactionsPageToken} message SearchFinancierTransactionsPageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchFinancierTransactionsPageToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.from_transaction_reference != null && message.hasOwnProperty("from_transaction_reference"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.from_transaction_reference);
        if (message.filter != null && message.hasOwnProperty("filter"))
            $root.SearchFinancierTransactionsFilter.encode(message.filter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.sort_field != null && message.hasOwnProperty("sort_field"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sort_field);
        if (message.sort_direction != null && message.hasOwnProperty("sort_direction"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.sort_direction);
        return writer;
    };

    /**
     * Encodes the specified SearchFinancierTransactionsPageToken message, length delimited. Does not implicitly {@link SearchFinancierTransactionsPageToken.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SearchFinancierTransactionsPageToken
     * @static
     * @param {ISearchFinancierTransactionsPageToken} message SearchFinancierTransactionsPageToken message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchFinancierTransactionsPageToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchFinancierTransactionsPageToken message from the specified reader or buffer.
     * @function decode
     * @memberof SearchFinancierTransactionsPageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SearchFinancierTransactionsPageToken} SearchFinancierTransactionsPageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchFinancierTransactionsPageToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SearchFinancierTransactionsPageToken();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.from_transaction_reference = reader.string();
                break;
            case 3:
                message.filter = $root.SearchFinancierTransactionsFilter.decode(reader, reader.uint32());
                break;
            case 4:
                message.sort_field = reader.int32();
                break;
            case 5:
                message.sort_direction = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SearchFinancierTransactionsPageToken message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SearchFinancierTransactionsPageToken
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SearchFinancierTransactionsPageToken} SearchFinancierTransactionsPageToken
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchFinancierTransactionsPageToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchFinancierTransactionsPageToken message.
     * @function verify
     * @memberof SearchFinancierTransactionsPageToken
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchFinancierTransactionsPageToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.from_transaction_reference != null && message.hasOwnProperty("from_transaction_reference"))
            if (!$util.isString(message.from_transaction_reference))
                return "from_transaction_reference: string expected";
        if (message.filter != null && message.hasOwnProperty("filter")) {
            let error = $root.SearchFinancierTransactionsFilter.verify(message.filter);
            if (error)
                return "filter." + error;
        }
        if (message.sort_field != null && message.hasOwnProperty("sort_field"))
            switch (message.sort_field) {
            default:
                return "sort_field: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.sort_direction != null && message.hasOwnProperty("sort_direction"))
            switch (message.sort_direction) {
            default:
                return "sort_direction: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    /**
     * Creates a SearchFinancierTransactionsPageToken message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SearchFinancierTransactionsPageToken
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SearchFinancierTransactionsPageToken} SearchFinancierTransactionsPageToken
     */
    SearchFinancierTransactionsPageToken.fromObject = function fromObject(object) {
        if (object instanceof $root.SearchFinancierTransactionsPageToken)
            return object;
        let message = new $root.SearchFinancierTransactionsPageToken();
        if (object.from_transaction_reference != null)
            message.from_transaction_reference = String(object.from_transaction_reference);
        if (object.filter != null) {
            if (typeof object.filter !== "object")
                throw TypeError(".SearchFinancierTransactionsPageToken.filter: object expected");
            message.filter = $root.SearchFinancierTransactionsFilter.fromObject(object.filter);
        }
        switch (object.sort_field) {
        case "UNKNOWN":
        case 0:
            message.sort_field = 0;
            break;
        case "REQUESTED_AT":
        case 1:
            message.sort_field = 1;
            break;
        case "AUD_AMOUNT":
        case 2:
            message.sort_field = 2;
            break;
        }
        switch (object.sort_direction) {
        case "UNKNOWN":
        case 0:
            message.sort_direction = 0;
            break;
        case "ASCENDING":
        case 1:
            message.sort_direction = 1;
            break;
        case "DESCENDING":
        case 2:
            message.sort_direction = 2;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a SearchFinancierTransactionsPageToken message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SearchFinancierTransactionsPageToken
     * @static
     * @param {SearchFinancierTransactionsPageToken} message SearchFinancierTransactionsPageToken
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchFinancierTransactionsPageToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.from_transaction_reference = "";
            object.filter = null;
            object.sort_field = options.enums === String ? "UNKNOWN" : 0;
            object.sort_direction = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.from_transaction_reference != null && message.hasOwnProperty("from_transaction_reference"))
            object.from_transaction_reference = message.from_transaction_reference;
        if (message.filter != null && message.hasOwnProperty("filter"))
            object.filter = $root.SearchFinancierTransactionsFilter.toObject(message.filter, options);
        if (message.sort_field != null && message.hasOwnProperty("sort_field"))
            object.sort_field = options.enums === String ? $root.SearchFinancierTransactionsSortField.Enum[message.sort_field] : message.sort_field;
        if (message.sort_direction != null && message.hasOwnProperty("sort_direction"))
            object.sort_direction = options.enums === String ? $root.SortDirection.Enum[message.sort_direction] : message.sort_direction;
        return object;
    };

    /**
     * Converts this SearchFinancierTransactionsPageToken to JSON.
     * @function toJSON
     * @memberof SearchFinancierTransactionsPageToken
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchFinancierTransactionsPageToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchFinancierTransactionsPageToken;
})();

export const FreebieBanStatus = $root.FreebieBanStatus = (() => {

    /**
     * Properties of a FreebieBanStatus.
     * @exports IFreebieBanStatus
     * @interface IFreebieBanStatus
     */

    /**
     * Constructs a new FreebieBanStatus.
     * @exports FreebieBanStatus
     * @classdesc Represents a FreebieBanStatus.
     * @implements IFreebieBanStatus
     * @constructor
     * @param {IFreebieBanStatus=} [properties] Properties to set
     */
    function FreebieBanStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new FreebieBanStatus instance using the specified properties.
     * @function create
     * @memberof FreebieBanStatus
     * @static
     * @param {IFreebieBanStatus=} [properties] Properties to set
     * @returns {FreebieBanStatus} FreebieBanStatus instance
     */
    FreebieBanStatus.create = function create(properties) {
        return new FreebieBanStatus(properties);
    };

    /**
     * Encodes the specified FreebieBanStatus message. Does not implicitly {@link FreebieBanStatus.verify|verify} messages.
     * @function encode
     * @memberof FreebieBanStatus
     * @static
     * @param {IFreebieBanStatus} message FreebieBanStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreebieBanStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified FreebieBanStatus message, length delimited. Does not implicitly {@link FreebieBanStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FreebieBanStatus
     * @static
     * @param {IFreebieBanStatus} message FreebieBanStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreebieBanStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FreebieBanStatus message from the specified reader or buffer.
     * @function decode
     * @memberof FreebieBanStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FreebieBanStatus} FreebieBanStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreebieBanStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FreebieBanStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FreebieBanStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FreebieBanStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FreebieBanStatus} FreebieBanStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreebieBanStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FreebieBanStatus message.
     * @function verify
     * @memberof FreebieBanStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FreebieBanStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a FreebieBanStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FreebieBanStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FreebieBanStatus} FreebieBanStatus
     */
    FreebieBanStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.FreebieBanStatus)
            return object;
        return new $root.FreebieBanStatus();
    };

    /**
     * Creates a plain object from a FreebieBanStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FreebieBanStatus
     * @static
     * @param {FreebieBanStatus} message FreebieBanStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FreebieBanStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this FreebieBanStatus to JSON.
     * @function toJSON
     * @memberof FreebieBanStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FreebieBanStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name FreebieBanStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ACTIVE=1 ACTIVE value
     * @property {number} INACTIVE=2 INACTIVE value
     */
    FreebieBanStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "ACTIVE"] = 1;
        values[valuesById[2] = "INACTIVE"] = 2;
        return values;
    })();

    return FreebieBanStatus;
})();

export const FreebieUsageFlagStatus = $root.FreebieUsageFlagStatus = (() => {

    /**
     * Properties of a FreebieUsageFlagStatus.
     * @exports IFreebieUsageFlagStatus
     * @interface IFreebieUsageFlagStatus
     */

    /**
     * Constructs a new FreebieUsageFlagStatus.
     * @exports FreebieUsageFlagStatus
     * @classdesc Represents a FreebieUsageFlagStatus.
     * @implements IFreebieUsageFlagStatus
     * @constructor
     * @param {IFreebieUsageFlagStatus=} [properties] Properties to set
     */
    function FreebieUsageFlagStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new FreebieUsageFlagStatus instance using the specified properties.
     * @function create
     * @memberof FreebieUsageFlagStatus
     * @static
     * @param {IFreebieUsageFlagStatus=} [properties] Properties to set
     * @returns {FreebieUsageFlagStatus} FreebieUsageFlagStatus instance
     */
    FreebieUsageFlagStatus.create = function create(properties) {
        return new FreebieUsageFlagStatus(properties);
    };

    /**
     * Encodes the specified FreebieUsageFlagStatus message. Does not implicitly {@link FreebieUsageFlagStatus.verify|verify} messages.
     * @function encode
     * @memberof FreebieUsageFlagStatus
     * @static
     * @param {IFreebieUsageFlagStatus} message FreebieUsageFlagStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreebieUsageFlagStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified FreebieUsageFlagStatus message, length delimited. Does not implicitly {@link FreebieUsageFlagStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FreebieUsageFlagStatus
     * @static
     * @param {IFreebieUsageFlagStatus} message FreebieUsageFlagStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreebieUsageFlagStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FreebieUsageFlagStatus message from the specified reader or buffer.
     * @function decode
     * @memberof FreebieUsageFlagStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FreebieUsageFlagStatus} FreebieUsageFlagStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreebieUsageFlagStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FreebieUsageFlagStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FreebieUsageFlagStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FreebieUsageFlagStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FreebieUsageFlagStatus} FreebieUsageFlagStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreebieUsageFlagStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FreebieUsageFlagStatus message.
     * @function verify
     * @memberof FreebieUsageFlagStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FreebieUsageFlagStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a FreebieUsageFlagStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FreebieUsageFlagStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FreebieUsageFlagStatus} FreebieUsageFlagStatus
     */
    FreebieUsageFlagStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.FreebieUsageFlagStatus)
            return object;
        return new $root.FreebieUsageFlagStatus();
    };

    /**
     * Creates a plain object from a FreebieUsageFlagStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FreebieUsageFlagStatus
     * @static
     * @param {FreebieUsageFlagStatus} message FreebieUsageFlagStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FreebieUsageFlagStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this FreebieUsageFlagStatus to JSON.
     * @function toJSON
     * @memberof FreebieUsageFlagStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FreebieUsageFlagStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name FreebieUsageFlagStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} REQUIRES_VERIFICATION=1 REQUIRES_VERIFICATION value
     * @property {number} MANUALLY_VERIFIED=2 MANUALLY_VERIFIED value
     * @property {number} MANUALLY_REJECTED=3 MANUALLY_REJECTED value
     */
    FreebieUsageFlagStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "REQUIRES_VERIFICATION"] = 1;
        values[valuesById[2] = "MANUALLY_VERIFIED"] = 2;
        values[valuesById[3] = "MANUALLY_REJECTED"] = 3;
        return values;
    })();

    return FreebieUsageFlagStatus;
})();

export const UserBalance = $root.UserBalance = (() => {

    /**
     * Properties of a UserBalance.
     * @exports IUserBalance
     * @interface IUserBalance
     * @property {string|null} [product_id] UserBalance product_id
     * @property {string|null} [unit_price] UserBalance unit_price
     * @property {string|null} [unit_balance] UserBalance unit_balance
     * @property {string|null} [aud_balance] UserBalance aud_balance
     * @property {string|null} [date] UserBalance date
     * @property {SaverPortfolio.Enum|null} [portfolio] UserBalance portfolio
     */

    /**
     * Constructs a new UserBalance.
     * @exports UserBalance
     * @classdesc Represents a UserBalance.
     * @implements IUserBalance
     * @constructor
     * @param {IUserBalance=} [properties] Properties to set
     */
    function UserBalance(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserBalance product_id.
     * @member {string} product_id
     * @memberof UserBalance
     * @instance
     */
    UserBalance.prototype.product_id = "";

    /**
     * UserBalance unit_price.
     * @member {string} unit_price
     * @memberof UserBalance
     * @instance
     */
    UserBalance.prototype.unit_price = "";

    /**
     * UserBalance unit_balance.
     * @member {string} unit_balance
     * @memberof UserBalance
     * @instance
     */
    UserBalance.prototype.unit_balance = "";

    /**
     * UserBalance aud_balance.
     * @member {string} aud_balance
     * @memberof UserBalance
     * @instance
     */
    UserBalance.prototype.aud_balance = "";

    /**
     * UserBalance date.
     * @member {string} date
     * @memberof UserBalance
     * @instance
     */
    UserBalance.prototype.date = "";

    /**
     * UserBalance portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof UserBalance
     * @instance
     */
    UserBalance.prototype.portfolio = 0;

    /**
     * Creates a new UserBalance instance using the specified properties.
     * @function create
     * @memberof UserBalance
     * @static
     * @param {IUserBalance=} [properties] Properties to set
     * @returns {UserBalance} UserBalance instance
     */
    UserBalance.create = function create(properties) {
        return new UserBalance(properties);
    };

    /**
     * Encodes the specified UserBalance message. Does not implicitly {@link UserBalance.verify|verify} messages.
     * @function encode
     * @memberof UserBalance
     * @static
     * @param {IUserBalance} message UserBalance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserBalance.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.product_id);
        if (message.unit_price != null && message.hasOwnProperty("unit_price"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.unit_price);
        if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.unit_balance);
        if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.aud_balance);
        if (message.date != null && message.hasOwnProperty("date"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.date);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.portfolio);
        return writer;
    };

    /**
     * Encodes the specified UserBalance message, length delimited. Does not implicitly {@link UserBalance.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserBalance
     * @static
     * @param {IUserBalance} message UserBalance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserBalance.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserBalance message from the specified reader or buffer.
     * @function decode
     * @memberof UserBalance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserBalance} UserBalance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserBalance.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserBalance();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.product_id = reader.string();
                break;
            case 2:
                message.unit_price = reader.string();
                break;
            case 3:
                message.unit_balance = reader.string();
                break;
            case 4:
                message.aud_balance = reader.string();
                break;
            case 5:
                message.date = reader.string();
                break;
            case 6:
                message.portfolio = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserBalance message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserBalance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserBalance} UserBalance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserBalance.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserBalance message.
     * @function verify
     * @memberof UserBalance
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserBalance.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.unit_price != null && message.hasOwnProperty("unit_price"))
            if (!$util.isString(message.unit_price))
                return "unit_price: string expected";
        if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
            if (!$util.isString(message.unit_balance))
                return "unit_balance: string expected";
        if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
            if (!$util.isString(message.aud_balance))
                return "aud_balance: string expected";
        if (message.date != null && message.hasOwnProperty("date"))
            if (!$util.isString(message.date))
                return "date: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        return null;
    };

    /**
     * Creates a UserBalance message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserBalance
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserBalance} UserBalance
     */
    UserBalance.fromObject = function fromObject(object) {
        if (object instanceof $root.UserBalance)
            return object;
        let message = new $root.UserBalance();
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.unit_price != null)
            message.unit_price = String(object.unit_price);
        if (object.unit_balance != null)
            message.unit_balance = String(object.unit_balance);
        if (object.aud_balance != null)
            message.aud_balance = String(object.aud_balance);
        if (object.date != null)
            message.date = String(object.date);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a UserBalance message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserBalance
     * @static
     * @param {UserBalance} message UserBalance
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserBalance.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.product_id = "";
            object.unit_price = "";
            object.unit_balance = "";
            object.aud_balance = "";
            object.date = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.unit_price != null && message.hasOwnProperty("unit_price"))
            object.unit_price = message.unit_price;
        if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
            object.unit_balance = message.unit_balance;
        if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
            object.aud_balance = message.aud_balance;
        if (message.date != null && message.hasOwnProperty("date"))
            object.date = message.date;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        return object;
    };

    /**
     * Converts this UserBalance to JSON.
     * @function toJSON
     * @memberof UserBalance
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserBalance.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UserBalance;
})();

export const LedgerAccountBreakdown = $root.LedgerAccountBreakdown = (() => {

    /**
     * Properties of a LedgerAccountBreakdown.
     * @exports ILedgerAccountBreakdown
     * @interface ILedgerAccountBreakdown
     * @property {IAccountingTransactionType|null} [transaction_type] LedgerAccountBreakdown transaction_type
     * @property {TransactionDirection.Enum|null} [transaction_direction] LedgerAccountBreakdown transaction_direction
     * @property {string|null} [aud_amount] LedgerAccountBreakdown aud_amount
     * @property {number|null} [count] LedgerAccountBreakdown count
     * @property {string|null} [date] LedgerAccountBreakdown date
     * @property {string|null} [ledger_account_id] LedgerAccountBreakdown ledger_account_id
     */

    /**
     * Constructs a new LedgerAccountBreakdown.
     * @exports LedgerAccountBreakdown
     * @classdesc Represents a LedgerAccountBreakdown.
     * @implements ILedgerAccountBreakdown
     * @constructor
     * @param {ILedgerAccountBreakdown=} [properties] Properties to set
     */
    function LedgerAccountBreakdown(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LedgerAccountBreakdown transaction_type.
     * @member {IAccountingTransactionType|null|undefined} transaction_type
     * @memberof LedgerAccountBreakdown
     * @instance
     */
    LedgerAccountBreakdown.prototype.transaction_type = null;

    /**
     * LedgerAccountBreakdown transaction_direction.
     * @member {TransactionDirection.Enum} transaction_direction
     * @memberof LedgerAccountBreakdown
     * @instance
     */
    LedgerAccountBreakdown.prototype.transaction_direction = 0;

    /**
     * LedgerAccountBreakdown aud_amount.
     * @member {string} aud_amount
     * @memberof LedgerAccountBreakdown
     * @instance
     */
    LedgerAccountBreakdown.prototype.aud_amount = "";

    /**
     * LedgerAccountBreakdown count.
     * @member {number} count
     * @memberof LedgerAccountBreakdown
     * @instance
     */
    LedgerAccountBreakdown.prototype.count = 0;

    /**
     * LedgerAccountBreakdown date.
     * @member {string} date
     * @memberof LedgerAccountBreakdown
     * @instance
     */
    LedgerAccountBreakdown.prototype.date = "";

    /**
     * LedgerAccountBreakdown ledger_account_id.
     * @member {string} ledger_account_id
     * @memberof LedgerAccountBreakdown
     * @instance
     */
    LedgerAccountBreakdown.prototype.ledger_account_id = "";

    /**
     * Creates a new LedgerAccountBreakdown instance using the specified properties.
     * @function create
     * @memberof LedgerAccountBreakdown
     * @static
     * @param {ILedgerAccountBreakdown=} [properties] Properties to set
     * @returns {LedgerAccountBreakdown} LedgerAccountBreakdown instance
     */
    LedgerAccountBreakdown.create = function create(properties) {
        return new LedgerAccountBreakdown(properties);
    };

    /**
     * Encodes the specified LedgerAccountBreakdown message. Does not implicitly {@link LedgerAccountBreakdown.verify|verify} messages.
     * @function encode
     * @memberof LedgerAccountBreakdown
     * @static
     * @param {ILedgerAccountBreakdown} message LedgerAccountBreakdown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccountBreakdown.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
            $root.AccountingTransactionType.encode(message.transaction_type, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.transaction_direction != null && message.hasOwnProperty("transaction_direction"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.transaction_direction);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.aud_amount);
        if (message.count != null && message.hasOwnProperty("count"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.count);
        if (message.date != null && message.hasOwnProperty("date"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.date);
        if (message.ledger_account_id != null && message.hasOwnProperty("ledger_account_id"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.ledger_account_id);
        return writer;
    };

    /**
     * Encodes the specified LedgerAccountBreakdown message, length delimited. Does not implicitly {@link LedgerAccountBreakdown.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LedgerAccountBreakdown
     * @static
     * @param {ILedgerAccountBreakdown} message LedgerAccountBreakdown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccountBreakdown.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LedgerAccountBreakdown message from the specified reader or buffer.
     * @function decode
     * @memberof LedgerAccountBreakdown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LedgerAccountBreakdown} LedgerAccountBreakdown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccountBreakdown.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LedgerAccountBreakdown();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_type = $root.AccountingTransactionType.decode(reader, reader.uint32());
                break;
            case 2:
                message.transaction_direction = reader.int32();
                break;
            case 3:
                message.aud_amount = reader.string();
                break;
            case 4:
                message.count = reader.int32();
                break;
            case 5:
                message.date = reader.string();
                break;
            case 6:
                message.ledger_account_id = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LedgerAccountBreakdown message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LedgerAccountBreakdown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LedgerAccountBreakdown} LedgerAccountBreakdown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccountBreakdown.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LedgerAccountBreakdown message.
     * @function verify
     * @memberof LedgerAccountBreakdown
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LedgerAccountBreakdown.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type")) {
            let error = $root.AccountingTransactionType.verify(message.transaction_type);
            if (error)
                return "transaction_type." + error;
        }
        if (message.transaction_direction != null && message.hasOwnProperty("transaction_direction"))
            switch (message.transaction_direction) {
            default:
                return "transaction_direction: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.count != null && message.hasOwnProperty("count"))
            if (!$util.isInteger(message.count))
                return "count: integer expected";
        if (message.date != null && message.hasOwnProperty("date"))
            if (!$util.isString(message.date))
                return "date: string expected";
        if (message.ledger_account_id != null && message.hasOwnProperty("ledger_account_id"))
            if (!$util.isString(message.ledger_account_id))
                return "ledger_account_id: string expected";
        return null;
    };

    /**
     * Creates a LedgerAccountBreakdown message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LedgerAccountBreakdown
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LedgerAccountBreakdown} LedgerAccountBreakdown
     */
    LedgerAccountBreakdown.fromObject = function fromObject(object) {
        if (object instanceof $root.LedgerAccountBreakdown)
            return object;
        let message = new $root.LedgerAccountBreakdown();
        if (object.transaction_type != null) {
            if (typeof object.transaction_type !== "object")
                throw TypeError(".LedgerAccountBreakdown.transaction_type: object expected");
            message.transaction_type = $root.AccountingTransactionType.fromObject(object.transaction_type);
        }
        switch (object.transaction_direction) {
        case "UNKNOWN":
        case 0:
            message.transaction_direction = 0;
            break;
        case "CREDIT":
        case 1:
            message.transaction_direction = 1;
            break;
        case "DEBIT":
        case 2:
            message.transaction_direction = 2;
            break;
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        if (object.count != null)
            message.count = object.count | 0;
        if (object.date != null)
            message.date = String(object.date);
        if (object.ledger_account_id != null)
            message.ledger_account_id = String(object.ledger_account_id);
        return message;
    };

    /**
     * Creates a plain object from a LedgerAccountBreakdown message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LedgerAccountBreakdown
     * @static
     * @param {LedgerAccountBreakdown} message LedgerAccountBreakdown
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LedgerAccountBreakdown.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_type = null;
            object.transaction_direction = options.enums === String ? "UNKNOWN" : 0;
            object.aud_amount = "";
            object.count = 0;
            object.date = "";
            object.ledger_account_id = "";
        }
        if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
            object.transaction_type = $root.AccountingTransactionType.toObject(message.transaction_type, options);
        if (message.transaction_direction != null && message.hasOwnProperty("transaction_direction"))
            object.transaction_direction = options.enums === String ? $root.TransactionDirection.Enum[message.transaction_direction] : message.transaction_direction;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.count != null && message.hasOwnProperty("count"))
            object.count = message.count;
        if (message.date != null && message.hasOwnProperty("date"))
            object.date = message.date;
        if (message.ledger_account_id != null && message.hasOwnProperty("ledger_account_id"))
            object.ledger_account_id = message.ledger_account_id;
        return object;
    };

    /**
     * Converts this LedgerAccountBreakdown to JSON.
     * @function toJSON
     * @memberof LedgerAccountBreakdown
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LedgerAccountBreakdown.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LedgerAccountBreakdown;
})();

export const LedgerAccountBreakdownList = $root.LedgerAccountBreakdownList = (() => {

    /**
     * Properties of a LedgerAccountBreakdownList.
     * @exports ILedgerAccountBreakdownList
     * @interface ILedgerAccountBreakdownList
     * @property {Array.<ILedgerAccountBreakdown>|null} [list] LedgerAccountBreakdownList list
     */

    /**
     * Constructs a new LedgerAccountBreakdownList.
     * @exports LedgerAccountBreakdownList
     * @classdesc Represents a LedgerAccountBreakdownList.
     * @implements ILedgerAccountBreakdownList
     * @constructor
     * @param {ILedgerAccountBreakdownList=} [properties] Properties to set
     */
    function LedgerAccountBreakdownList(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LedgerAccountBreakdownList list.
     * @member {Array.<ILedgerAccountBreakdown>} list
     * @memberof LedgerAccountBreakdownList
     * @instance
     */
    LedgerAccountBreakdownList.prototype.list = $util.emptyArray;

    /**
     * Creates a new LedgerAccountBreakdownList instance using the specified properties.
     * @function create
     * @memberof LedgerAccountBreakdownList
     * @static
     * @param {ILedgerAccountBreakdownList=} [properties] Properties to set
     * @returns {LedgerAccountBreakdownList} LedgerAccountBreakdownList instance
     */
    LedgerAccountBreakdownList.create = function create(properties) {
        return new LedgerAccountBreakdownList(properties);
    };

    /**
     * Encodes the specified LedgerAccountBreakdownList message. Does not implicitly {@link LedgerAccountBreakdownList.verify|verify} messages.
     * @function encode
     * @memberof LedgerAccountBreakdownList
     * @static
     * @param {ILedgerAccountBreakdownList} message LedgerAccountBreakdownList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccountBreakdownList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.LedgerAccountBreakdown.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified LedgerAccountBreakdownList message, length delimited. Does not implicitly {@link LedgerAccountBreakdownList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LedgerAccountBreakdownList
     * @static
     * @param {ILedgerAccountBreakdownList} message LedgerAccountBreakdownList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LedgerAccountBreakdownList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LedgerAccountBreakdownList message from the specified reader or buffer.
     * @function decode
     * @memberof LedgerAccountBreakdownList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LedgerAccountBreakdownList} LedgerAccountBreakdownList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccountBreakdownList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LedgerAccountBreakdownList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.LedgerAccountBreakdown.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LedgerAccountBreakdownList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LedgerAccountBreakdownList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LedgerAccountBreakdownList} LedgerAccountBreakdownList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LedgerAccountBreakdownList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LedgerAccountBreakdownList message.
     * @function verify
     * @memberof LedgerAccountBreakdownList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LedgerAccountBreakdownList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.LedgerAccountBreakdown.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates a LedgerAccountBreakdownList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LedgerAccountBreakdownList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LedgerAccountBreakdownList} LedgerAccountBreakdownList
     */
    LedgerAccountBreakdownList.fromObject = function fromObject(object) {
        if (object instanceof $root.LedgerAccountBreakdownList)
            return object;
        let message = new $root.LedgerAccountBreakdownList();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".LedgerAccountBreakdownList.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".LedgerAccountBreakdownList.list: object expected");
                message.list[i] = $root.LedgerAccountBreakdown.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a LedgerAccountBreakdownList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LedgerAccountBreakdownList
     * @static
     * @param {LedgerAccountBreakdownList} message LedgerAccountBreakdownList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LedgerAccountBreakdownList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.LedgerAccountBreakdown.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this LedgerAccountBreakdownList to JSON.
     * @function toJSON
     * @memberof LedgerAccountBreakdownList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LedgerAccountBreakdownList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LedgerAccountBreakdownList;
})();

export const BankAccountDailySummary = $root.BankAccountDailySummary = (() => {

    /**
     * Properties of a BankAccountDailySummary.
     * @exports IBankAccountDailySummary
     * @interface IBankAccountDailySummary
     * @property {string|null} [opening_balance_aud_amount] BankAccountDailySummary opening_balance_aud_amount
     * @property {string|null} [closing_balance_aud_amount] BankAccountDailySummary closing_balance_aud_amount
     * @property {string|null} [debit_aud_amount] BankAccountDailySummary debit_aud_amount
     * @property {string|null} [debit_count] BankAccountDailySummary debit_count
     * @property {string|null} [credit_aud_amount] BankAccountDailySummary credit_aud_amount
     * @property {string|null} [credit_count] BankAccountDailySummary credit_count
     * @property {string|null} [date] BankAccountDailySummary date
     */

    /**
     * Constructs a new BankAccountDailySummary.
     * @exports BankAccountDailySummary
     * @classdesc Represents a BankAccountDailySummary.
     * @implements IBankAccountDailySummary
     * @constructor
     * @param {IBankAccountDailySummary=} [properties] Properties to set
     */
    function BankAccountDailySummary(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BankAccountDailySummary opening_balance_aud_amount.
     * @member {string} opening_balance_aud_amount
     * @memberof BankAccountDailySummary
     * @instance
     */
    BankAccountDailySummary.prototype.opening_balance_aud_amount = "";

    /**
     * BankAccountDailySummary closing_balance_aud_amount.
     * @member {string} closing_balance_aud_amount
     * @memberof BankAccountDailySummary
     * @instance
     */
    BankAccountDailySummary.prototype.closing_balance_aud_amount = "";

    /**
     * BankAccountDailySummary debit_aud_amount.
     * @member {string} debit_aud_amount
     * @memberof BankAccountDailySummary
     * @instance
     */
    BankAccountDailySummary.prototype.debit_aud_amount = "";

    /**
     * BankAccountDailySummary debit_count.
     * @member {string} debit_count
     * @memberof BankAccountDailySummary
     * @instance
     */
    BankAccountDailySummary.prototype.debit_count = "";

    /**
     * BankAccountDailySummary credit_aud_amount.
     * @member {string} credit_aud_amount
     * @memberof BankAccountDailySummary
     * @instance
     */
    BankAccountDailySummary.prototype.credit_aud_amount = "";

    /**
     * BankAccountDailySummary credit_count.
     * @member {string} credit_count
     * @memberof BankAccountDailySummary
     * @instance
     */
    BankAccountDailySummary.prototype.credit_count = "";

    /**
     * BankAccountDailySummary date.
     * @member {string} date
     * @memberof BankAccountDailySummary
     * @instance
     */
    BankAccountDailySummary.prototype.date = "";

    /**
     * Creates a new BankAccountDailySummary instance using the specified properties.
     * @function create
     * @memberof BankAccountDailySummary
     * @static
     * @param {IBankAccountDailySummary=} [properties] Properties to set
     * @returns {BankAccountDailySummary} BankAccountDailySummary instance
     */
    BankAccountDailySummary.create = function create(properties) {
        return new BankAccountDailySummary(properties);
    };

    /**
     * Encodes the specified BankAccountDailySummary message. Does not implicitly {@link BankAccountDailySummary.verify|verify} messages.
     * @function encode
     * @memberof BankAccountDailySummary
     * @static
     * @param {IBankAccountDailySummary} message BankAccountDailySummary message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccountDailySummary.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.opening_balance_aud_amount != null && message.hasOwnProperty("opening_balance_aud_amount"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.opening_balance_aud_amount);
        if (message.closing_balance_aud_amount != null && message.hasOwnProperty("closing_balance_aud_amount"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.closing_balance_aud_amount);
        if (message.debit_aud_amount != null && message.hasOwnProperty("debit_aud_amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.debit_aud_amount);
        if (message.debit_count != null && message.hasOwnProperty("debit_count"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.debit_count);
        if (message.credit_aud_amount != null && message.hasOwnProperty("credit_aud_amount"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.credit_aud_amount);
        if (message.credit_count != null && message.hasOwnProperty("credit_count"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.credit_count);
        if (message.date != null && message.hasOwnProperty("date"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.date);
        return writer;
    };

    /**
     * Encodes the specified BankAccountDailySummary message, length delimited. Does not implicitly {@link BankAccountDailySummary.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BankAccountDailySummary
     * @static
     * @param {IBankAccountDailySummary} message BankAccountDailySummary message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccountDailySummary.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BankAccountDailySummary message from the specified reader or buffer.
     * @function decode
     * @memberof BankAccountDailySummary
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BankAccountDailySummary} BankAccountDailySummary
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccountDailySummary.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BankAccountDailySummary();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.opening_balance_aud_amount = reader.string();
                break;
            case 2:
                message.closing_balance_aud_amount = reader.string();
                break;
            case 3:
                message.debit_aud_amount = reader.string();
                break;
            case 4:
                message.debit_count = reader.string();
                break;
            case 5:
                message.credit_aud_amount = reader.string();
                break;
            case 6:
                message.credit_count = reader.string();
                break;
            case 7:
                message.date = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BankAccountDailySummary message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BankAccountDailySummary
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BankAccountDailySummary} BankAccountDailySummary
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccountDailySummary.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BankAccountDailySummary message.
     * @function verify
     * @memberof BankAccountDailySummary
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BankAccountDailySummary.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.opening_balance_aud_amount != null && message.hasOwnProperty("opening_balance_aud_amount"))
            if (!$util.isString(message.opening_balance_aud_amount))
                return "opening_balance_aud_amount: string expected";
        if (message.closing_balance_aud_amount != null && message.hasOwnProperty("closing_balance_aud_amount"))
            if (!$util.isString(message.closing_balance_aud_amount))
                return "closing_balance_aud_amount: string expected";
        if (message.debit_aud_amount != null && message.hasOwnProperty("debit_aud_amount"))
            if (!$util.isString(message.debit_aud_amount))
                return "debit_aud_amount: string expected";
        if (message.debit_count != null && message.hasOwnProperty("debit_count"))
            if (!$util.isString(message.debit_count))
                return "debit_count: string expected";
        if (message.credit_aud_amount != null && message.hasOwnProperty("credit_aud_amount"))
            if (!$util.isString(message.credit_aud_amount))
                return "credit_aud_amount: string expected";
        if (message.credit_count != null && message.hasOwnProperty("credit_count"))
            if (!$util.isString(message.credit_count))
                return "credit_count: string expected";
        if (message.date != null && message.hasOwnProperty("date"))
            if (!$util.isString(message.date))
                return "date: string expected";
        return null;
    };

    /**
     * Creates a BankAccountDailySummary message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BankAccountDailySummary
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BankAccountDailySummary} BankAccountDailySummary
     */
    BankAccountDailySummary.fromObject = function fromObject(object) {
        if (object instanceof $root.BankAccountDailySummary)
            return object;
        let message = new $root.BankAccountDailySummary();
        if (object.opening_balance_aud_amount != null)
            message.opening_balance_aud_amount = String(object.opening_balance_aud_amount);
        if (object.closing_balance_aud_amount != null)
            message.closing_balance_aud_amount = String(object.closing_balance_aud_amount);
        if (object.debit_aud_amount != null)
            message.debit_aud_amount = String(object.debit_aud_amount);
        if (object.debit_count != null)
            message.debit_count = String(object.debit_count);
        if (object.credit_aud_amount != null)
            message.credit_aud_amount = String(object.credit_aud_amount);
        if (object.credit_count != null)
            message.credit_count = String(object.credit_count);
        if (object.date != null)
            message.date = String(object.date);
        return message;
    };

    /**
     * Creates a plain object from a BankAccountDailySummary message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BankAccountDailySummary
     * @static
     * @param {BankAccountDailySummary} message BankAccountDailySummary
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BankAccountDailySummary.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.opening_balance_aud_amount = "";
            object.closing_balance_aud_amount = "";
            object.debit_aud_amount = "";
            object.debit_count = "";
            object.credit_aud_amount = "";
            object.credit_count = "";
            object.date = "";
        }
        if (message.opening_balance_aud_amount != null && message.hasOwnProperty("opening_balance_aud_amount"))
            object.opening_balance_aud_amount = message.opening_balance_aud_amount;
        if (message.closing_balance_aud_amount != null && message.hasOwnProperty("closing_balance_aud_amount"))
            object.closing_balance_aud_amount = message.closing_balance_aud_amount;
        if (message.debit_aud_amount != null && message.hasOwnProperty("debit_aud_amount"))
            object.debit_aud_amount = message.debit_aud_amount;
        if (message.debit_count != null && message.hasOwnProperty("debit_count"))
            object.debit_count = message.debit_count;
        if (message.credit_aud_amount != null && message.hasOwnProperty("credit_aud_amount"))
            object.credit_aud_amount = message.credit_aud_amount;
        if (message.credit_count != null && message.hasOwnProperty("credit_count"))
            object.credit_count = message.credit_count;
        if (message.date != null && message.hasOwnProperty("date"))
            object.date = message.date;
        return object;
    };

    /**
     * Converts this BankAccountDailySummary to JSON.
     * @function toJSON
     * @memberof BankAccountDailySummary
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BankAccountDailySummary.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BankAccountDailySummary;
})();

export const BankAccountTransactionBreakdown = $root.BankAccountTransactionBreakdown = (() => {

    /**
     * Properties of a BankAccountTransactionBreakdown.
     * @exports IBankAccountTransactionBreakdown
     * @interface IBankAccountTransactionBreakdown
     * @property {TransactionDirection.Enum|null} [transaction_direction] BankAccountTransactionBreakdown transaction_direction
     * @property {MacquarieTransactionCode.Enum|null} [transaction_code] BankAccountTransactionBreakdown transaction_code
     * @property {string|null} [aud_amount] BankAccountTransactionBreakdown aud_amount
     * @property {string|null} [count] BankAccountTransactionBreakdown count
     */

    /**
     * Constructs a new BankAccountTransactionBreakdown.
     * @exports BankAccountTransactionBreakdown
     * @classdesc Represents a BankAccountTransactionBreakdown.
     * @implements IBankAccountTransactionBreakdown
     * @constructor
     * @param {IBankAccountTransactionBreakdown=} [properties] Properties to set
     */
    function BankAccountTransactionBreakdown(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BankAccountTransactionBreakdown transaction_direction.
     * @member {TransactionDirection.Enum} transaction_direction
     * @memberof BankAccountTransactionBreakdown
     * @instance
     */
    BankAccountTransactionBreakdown.prototype.transaction_direction = 0;

    /**
     * BankAccountTransactionBreakdown transaction_code.
     * @member {MacquarieTransactionCode.Enum} transaction_code
     * @memberof BankAccountTransactionBreakdown
     * @instance
     */
    BankAccountTransactionBreakdown.prototype.transaction_code = 0;

    /**
     * BankAccountTransactionBreakdown aud_amount.
     * @member {string} aud_amount
     * @memberof BankAccountTransactionBreakdown
     * @instance
     */
    BankAccountTransactionBreakdown.prototype.aud_amount = "";

    /**
     * BankAccountTransactionBreakdown count.
     * @member {string} count
     * @memberof BankAccountTransactionBreakdown
     * @instance
     */
    BankAccountTransactionBreakdown.prototype.count = "";

    /**
     * Creates a new BankAccountTransactionBreakdown instance using the specified properties.
     * @function create
     * @memberof BankAccountTransactionBreakdown
     * @static
     * @param {IBankAccountTransactionBreakdown=} [properties] Properties to set
     * @returns {BankAccountTransactionBreakdown} BankAccountTransactionBreakdown instance
     */
    BankAccountTransactionBreakdown.create = function create(properties) {
        return new BankAccountTransactionBreakdown(properties);
    };

    /**
     * Encodes the specified BankAccountTransactionBreakdown message. Does not implicitly {@link BankAccountTransactionBreakdown.verify|verify} messages.
     * @function encode
     * @memberof BankAccountTransactionBreakdown
     * @static
     * @param {IBankAccountTransactionBreakdown} message BankAccountTransactionBreakdown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccountTransactionBreakdown.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_direction != null && message.hasOwnProperty("transaction_direction"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.transaction_direction);
        if (message.transaction_code != null && message.hasOwnProperty("transaction_code"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.transaction_code);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.aud_amount);
        if (message.count != null && message.hasOwnProperty("count"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.count);
        return writer;
    };

    /**
     * Encodes the specified BankAccountTransactionBreakdown message, length delimited. Does not implicitly {@link BankAccountTransactionBreakdown.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BankAccountTransactionBreakdown
     * @static
     * @param {IBankAccountTransactionBreakdown} message BankAccountTransactionBreakdown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BankAccountTransactionBreakdown.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BankAccountTransactionBreakdown message from the specified reader or buffer.
     * @function decode
     * @memberof BankAccountTransactionBreakdown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BankAccountTransactionBreakdown} BankAccountTransactionBreakdown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccountTransactionBreakdown.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BankAccountTransactionBreakdown();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_direction = reader.int32();
                break;
            case 2:
                message.transaction_code = reader.int32();
                break;
            case 3:
                message.aud_amount = reader.string();
                break;
            case 4:
                message.count = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BankAccountTransactionBreakdown message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BankAccountTransactionBreakdown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BankAccountTransactionBreakdown} BankAccountTransactionBreakdown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BankAccountTransactionBreakdown.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BankAccountTransactionBreakdown message.
     * @function verify
     * @memberof BankAccountTransactionBreakdown
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BankAccountTransactionBreakdown.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_direction != null && message.hasOwnProperty("transaction_direction"))
            switch (message.transaction_direction) {
            default:
                return "transaction_direction: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.transaction_code != null && message.hasOwnProperty("transaction_code"))
            switch (message.transaction_code) {
            default:
                return "transaction_code: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.count != null && message.hasOwnProperty("count"))
            if (!$util.isString(message.count))
                return "count: string expected";
        return null;
    };

    /**
     * Creates a BankAccountTransactionBreakdown message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BankAccountTransactionBreakdown
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BankAccountTransactionBreakdown} BankAccountTransactionBreakdown
     */
    BankAccountTransactionBreakdown.fromObject = function fromObject(object) {
        if (object instanceof $root.BankAccountTransactionBreakdown)
            return object;
        let message = new $root.BankAccountTransactionBreakdown();
        switch (object.transaction_direction) {
        case "UNKNOWN":
        case 0:
            message.transaction_direction = 0;
            break;
        case "CREDIT":
        case 1:
            message.transaction_direction = 1;
            break;
        case "DEBIT":
        case 2:
            message.transaction_direction = 2;
            break;
        }
        switch (object.transaction_code) {
        case "UNKNOWN":
        case 0:
            message.transaction_code = 0;
            break;
        case "DEPOSIT":
        case 1:
            message.transaction_code = 1;
            break;
        case "INTEREST_PAID":
        case 2:
            message.transaction_code = 2;
            break;
        case "REVERSAL_CREDIT":
        case 3:
            message.transaction_code = 3;
            break;
        case "DEBIT":
        case 4:
            message.transaction_code = 4;
            break;
        case "REVERSAL_DEBIT":
        case 5:
            message.transaction_code = 5;
            break;
        case "DISHONOUR":
        case 6:
            message.transaction_code = 6;
            break;
        case "SERVICE_CHARGE":
        case 7:
            message.transaction_code = 7;
            break;
        case "CHEQUE":
        case 8:
            message.transaction_code = 8;
            break;
        case "INTEREST_CHARGED":
        case 9:
            message.transaction_code = 9;
            break;
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        if (object.count != null)
            message.count = String(object.count);
        return message;
    };

    /**
     * Creates a plain object from a BankAccountTransactionBreakdown message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BankAccountTransactionBreakdown
     * @static
     * @param {BankAccountTransactionBreakdown} message BankAccountTransactionBreakdown
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BankAccountTransactionBreakdown.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_direction = options.enums === String ? "UNKNOWN" : 0;
            object.transaction_code = options.enums === String ? "UNKNOWN" : 0;
            object.aud_amount = "";
            object.count = "";
        }
        if (message.transaction_direction != null && message.hasOwnProperty("transaction_direction"))
            object.transaction_direction = options.enums === String ? $root.TransactionDirection.Enum[message.transaction_direction] : message.transaction_direction;
        if (message.transaction_code != null && message.hasOwnProperty("transaction_code"))
            object.transaction_code = options.enums === String ? $root.MacquarieTransactionCode.Enum[message.transaction_code] : message.transaction_code;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.count != null && message.hasOwnProperty("count"))
            object.count = message.count;
        return object;
    };

    /**
     * Converts this BankAccountTransactionBreakdown to JSON.
     * @function toJSON
     * @memberof BankAccountTransactionBreakdown
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BankAccountTransactionBreakdown.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BankAccountTransactionBreakdown;
})();

export const PortfolioChangeStatus = $root.PortfolioChangeStatus = (() => {

    /**
     * Properties of a PortfolioChangeStatus.
     * @exports IPortfolioChangeStatus
     * @interface IPortfolioChangeStatus
     */

    /**
     * Constructs a new PortfolioChangeStatus.
     * @exports PortfolioChangeStatus
     * @classdesc Represents a PortfolioChangeStatus.
     * @implements IPortfolioChangeStatus
     * @constructor
     * @param {IPortfolioChangeStatus=} [properties] Properties to set
     */
    function PortfolioChangeStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new PortfolioChangeStatus instance using the specified properties.
     * @function create
     * @memberof PortfolioChangeStatus
     * @static
     * @param {IPortfolioChangeStatus=} [properties] Properties to set
     * @returns {PortfolioChangeStatus} PortfolioChangeStatus instance
     */
    PortfolioChangeStatus.create = function create(properties) {
        return new PortfolioChangeStatus(properties);
    };

    /**
     * Encodes the specified PortfolioChangeStatus message. Does not implicitly {@link PortfolioChangeStatus.verify|verify} messages.
     * @function encode
     * @memberof PortfolioChangeStatus
     * @static
     * @param {IPortfolioChangeStatus} message PortfolioChangeStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PortfolioChangeStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified PortfolioChangeStatus message, length delimited. Does not implicitly {@link PortfolioChangeStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PortfolioChangeStatus
     * @static
     * @param {IPortfolioChangeStatus} message PortfolioChangeStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PortfolioChangeStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PortfolioChangeStatus message from the specified reader or buffer.
     * @function decode
     * @memberof PortfolioChangeStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PortfolioChangeStatus} PortfolioChangeStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PortfolioChangeStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PortfolioChangeStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PortfolioChangeStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PortfolioChangeStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PortfolioChangeStatus} PortfolioChangeStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PortfolioChangeStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PortfolioChangeStatus message.
     * @function verify
     * @memberof PortfolioChangeStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PortfolioChangeStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a PortfolioChangeStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PortfolioChangeStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PortfolioChangeStatus} PortfolioChangeStatus
     */
    PortfolioChangeStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.PortfolioChangeStatus)
            return object;
        return new $root.PortfolioChangeStatus();
    };

    /**
     * Creates a plain object from a PortfolioChangeStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PortfolioChangeStatus
     * @static
     * @param {PortfolioChangeStatus} message PortfolioChangeStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PortfolioChangeStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this PortfolioChangeStatus to JSON.
     * @function toJSON
     * @memberof PortfolioChangeStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PortfolioChangeStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name PortfolioChangeStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} PREPARING=1 PREPARING value
     * @property {number} WAITING_FOR_APPROVAL=2 WAITING_FOR_APPROVAL value
     * @property {number} APPROVED=3 APPROVED value
     * @property {number} APPLIED=4 APPLIED value
     * @property {number} DELETED=5 DELETED value
     */
    PortfolioChangeStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "PREPARING"] = 1;
        values[valuesById[2] = "WAITING_FOR_APPROVAL"] = 2;
        values[valuesById[3] = "APPROVED"] = 3;
        values[valuesById[4] = "APPLIED"] = 4;
        values[valuesById[5] = "DELETED"] = 5;
        return values;
    })();

    return PortfolioChangeStatus;
})();

export const PortfolioChange = $root.PortfolioChange = (() => {

    /**
     * Properties of a PortfolioChange.
     * @exports IPortfolioChange
     * @interface IPortfolioChange
     * @property {string|null} [id] PortfolioChange id
     * @property {string|null} [name] PortfolioChange name
     * @property {SaverPortfolio.Enum|null} [portfolio] PortfolioChange portfolio
     * @property {PortfolioChangeStatus.Enum|null} [status] PortfolioChange status
     * @property {Array.<string>|null} [instrument_ids_added] PortfolioChange instrument_ids_added
     * @property {Array.<string>|null} [instrument_ids_removed] PortfolioChange instrument_ids_removed
     * @property {Object.<string,string>|null} [instrument_id_to_target_allocation] PortfolioChange instrument_id_to_target_allocation
     * @property {Object.<string,string>|null} [instrument_id_to_last_close_price] PortfolioChange instrument_id_to_last_close_price
     * @property {string|null} [created_by_admin_id] PortfolioChange created_by_admin_id
     * @property {string|null} [approved_by_admin_id] PortfolioChange approved_by_admin_id
     * @property {google.protobuf.ITimestamp|null} [approved_at] PortfolioChange approved_at
     * @property {google.protobuf.ITimestamp|null} [applied_at] PortfolioChange applied_at
     * @property {string|null} [deleted_by_admin_id] PortfolioChange deleted_by_admin_id
     * @property {google.protobuf.ITimestamp|null} [deleted_at] PortfolioChange deleted_at
     * @property {google.protobuf.ITimestamp|null} [created_at] PortfolioChange created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] PortfolioChange last_updated_at
     */

    /**
     * Constructs a new PortfolioChange.
     * @exports PortfolioChange
     * @classdesc Represents a PortfolioChange.
     * @implements IPortfolioChange
     * @constructor
     * @param {IPortfolioChange=} [properties] Properties to set
     */
    function PortfolioChange(properties) {
        this.instrument_ids_added = [];
        this.instrument_ids_removed = [];
        this.instrument_id_to_target_allocation = {};
        this.instrument_id_to_last_close_price = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PortfolioChange id.
     * @member {string} id
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.id = "";

    /**
     * PortfolioChange name.
     * @member {string} name
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.name = "";

    /**
     * PortfolioChange portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.portfolio = 0;

    /**
     * PortfolioChange status.
     * @member {PortfolioChangeStatus.Enum} status
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.status = 0;

    /**
     * PortfolioChange instrument_ids_added.
     * @member {Array.<string>} instrument_ids_added
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.instrument_ids_added = $util.emptyArray;

    /**
     * PortfolioChange instrument_ids_removed.
     * @member {Array.<string>} instrument_ids_removed
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.instrument_ids_removed = $util.emptyArray;

    /**
     * PortfolioChange instrument_id_to_target_allocation.
     * @member {Object.<string,string>} instrument_id_to_target_allocation
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.instrument_id_to_target_allocation = $util.emptyObject;

    /**
     * PortfolioChange instrument_id_to_last_close_price.
     * @member {Object.<string,string>} instrument_id_to_last_close_price
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.instrument_id_to_last_close_price = $util.emptyObject;

    /**
     * PortfolioChange created_by_admin_id.
     * @member {string} created_by_admin_id
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.created_by_admin_id = "";

    /**
     * PortfolioChange approved_by_admin_id.
     * @member {string} approved_by_admin_id
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.approved_by_admin_id = "";

    /**
     * PortfolioChange approved_at.
     * @member {google.protobuf.ITimestamp|null|undefined} approved_at
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.approved_at = null;

    /**
     * PortfolioChange applied_at.
     * @member {google.protobuf.ITimestamp|null|undefined} applied_at
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.applied_at = null;

    /**
     * PortfolioChange deleted_by_admin_id.
     * @member {string} deleted_by_admin_id
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.deleted_by_admin_id = "";

    /**
     * PortfolioChange deleted_at.
     * @member {google.protobuf.ITimestamp|null|undefined} deleted_at
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.deleted_at = null;

    /**
     * PortfolioChange created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.created_at = null;

    /**
     * PortfolioChange last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof PortfolioChange
     * @instance
     */
    PortfolioChange.prototype.last_updated_at = null;

    /**
     * Creates a new PortfolioChange instance using the specified properties.
     * @function create
     * @memberof PortfolioChange
     * @static
     * @param {IPortfolioChange=} [properties] Properties to set
     * @returns {PortfolioChange} PortfolioChange instance
     */
    PortfolioChange.create = function create(properties) {
        return new PortfolioChange(properties);
    };

    /**
     * Encodes the specified PortfolioChange message. Does not implicitly {@link PortfolioChange.verify|verify} messages.
     * @function encode
     * @memberof PortfolioChange
     * @static
     * @param {IPortfolioChange} message PortfolioChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PortfolioChange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.name != null && message.hasOwnProperty("name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.portfolio);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
        if (message.instrument_ids_added != null && message.instrument_ids_added.length)
            for (let i = 0; i < message.instrument_ids_added.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.instrument_ids_added[i]);
        if (message.instrument_ids_removed != null && message.instrument_ids_removed.length)
            for (let i = 0; i < message.instrument_ids_removed.length; ++i)
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.instrument_ids_removed[i]);
        if (message.instrument_id_to_target_allocation != null && message.hasOwnProperty("instrument_id_to_target_allocation"))
            for (let keys = Object.keys(message.instrument_id_to_target_allocation), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 7, wireType 2 =*/58).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.instrument_id_to_target_allocation[keys[i]]).ldelim();
        if (message.instrument_id_to_last_close_price != null && message.hasOwnProperty("instrument_id_to_last_close_price"))
            for (let keys = Object.keys(message.instrument_id_to_last_close_price), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 8, wireType 2 =*/66).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.instrument_id_to_last_close_price[keys[i]]).ldelim();
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.created_by_admin_id);
        if (message.approved_by_admin_id != null && message.hasOwnProperty("approved_by_admin_id"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.approved_by_admin_id);
        if (message.approved_at != null && message.hasOwnProperty("approved_at"))
            $root.google.protobuf.Timestamp.encode(message.approved_at, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.applied_at != null && message.hasOwnProperty("applied_at"))
            $root.google.protobuf.Timestamp.encode(message.applied_at, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.deleted_by_admin_id != null && message.hasOwnProperty("deleted_by_admin_id"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.deleted_by_admin_id);
        if (message.deleted_at != null && message.hasOwnProperty("deleted_at"))
            $root.google.protobuf.Timestamp.encode(message.deleted_at, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PortfolioChange message, length delimited. Does not implicitly {@link PortfolioChange.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PortfolioChange
     * @static
     * @param {IPortfolioChange} message PortfolioChange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PortfolioChange.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PortfolioChange message from the specified reader or buffer.
     * @function decode
     * @memberof PortfolioChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PortfolioChange} PortfolioChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PortfolioChange.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PortfolioChange(), key;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.name = reader.string();
                break;
            case 3:
                message.portfolio = reader.int32();
                break;
            case 4:
                message.status = reader.int32();
                break;
            case 5:
                if (!(message.instrument_ids_added && message.instrument_ids_added.length))
                    message.instrument_ids_added = [];
                message.instrument_ids_added.push(reader.string());
                break;
            case 6:
                if (!(message.instrument_ids_removed && message.instrument_ids_removed.length))
                    message.instrument_ids_removed = [];
                message.instrument_ids_removed.push(reader.string());
                break;
            case 7:
                reader.skip().pos++;
                if (message.instrument_id_to_target_allocation === $util.emptyObject)
                    message.instrument_id_to_target_allocation = {};
                key = reader.string();
                reader.pos++;
                message.instrument_id_to_target_allocation[key] = reader.string();
                break;
            case 8:
                reader.skip().pos++;
                if (message.instrument_id_to_last_close_price === $util.emptyObject)
                    message.instrument_id_to_last_close_price = {};
                key = reader.string();
                reader.pos++;
                message.instrument_id_to_last_close_price[key] = reader.string();
                break;
            case 9:
                message.created_by_admin_id = reader.string();
                break;
            case 10:
                message.approved_by_admin_id = reader.string();
                break;
            case 11:
                message.approved_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 12:
                message.applied_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 13:
                message.deleted_by_admin_id = reader.string();
                break;
            case 14:
                message.deleted_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PortfolioChange message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PortfolioChange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PortfolioChange} PortfolioChange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PortfolioChange.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PortfolioChange message.
     * @function verify
     * @memberof PortfolioChange
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PortfolioChange.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.instrument_ids_added != null && message.hasOwnProperty("instrument_ids_added")) {
            if (!Array.isArray(message.instrument_ids_added))
                return "instrument_ids_added: array expected";
            for (let i = 0; i < message.instrument_ids_added.length; ++i)
                if (!$util.isString(message.instrument_ids_added[i]))
                    return "instrument_ids_added: string[] expected";
        }
        if (message.instrument_ids_removed != null && message.hasOwnProperty("instrument_ids_removed")) {
            if (!Array.isArray(message.instrument_ids_removed))
                return "instrument_ids_removed: array expected";
            for (let i = 0; i < message.instrument_ids_removed.length; ++i)
                if (!$util.isString(message.instrument_ids_removed[i]))
                    return "instrument_ids_removed: string[] expected";
        }
        if (message.instrument_id_to_target_allocation != null && message.hasOwnProperty("instrument_id_to_target_allocation")) {
            if (!$util.isObject(message.instrument_id_to_target_allocation))
                return "instrument_id_to_target_allocation: object expected";
            let key = Object.keys(message.instrument_id_to_target_allocation);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.instrument_id_to_target_allocation[key[i]]))
                    return "instrument_id_to_target_allocation: string{k:string} expected";
        }
        if (message.instrument_id_to_last_close_price != null && message.hasOwnProperty("instrument_id_to_last_close_price")) {
            if (!$util.isObject(message.instrument_id_to_last_close_price))
                return "instrument_id_to_last_close_price: object expected";
            let key = Object.keys(message.instrument_id_to_last_close_price);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.instrument_id_to_last_close_price[key[i]]))
                    return "instrument_id_to_last_close_price: string{k:string} expected";
        }
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            if (!$util.isString(message.created_by_admin_id))
                return "created_by_admin_id: string expected";
        if (message.approved_by_admin_id != null && message.hasOwnProperty("approved_by_admin_id"))
            if (!$util.isString(message.approved_by_admin_id))
                return "approved_by_admin_id: string expected";
        if (message.approved_at != null && message.hasOwnProperty("approved_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.approved_at);
            if (error)
                return "approved_at." + error;
        }
        if (message.applied_at != null && message.hasOwnProperty("applied_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.applied_at);
            if (error)
                return "applied_at." + error;
        }
        if (message.deleted_by_admin_id != null && message.hasOwnProperty("deleted_by_admin_id"))
            if (!$util.isString(message.deleted_by_admin_id))
                return "deleted_by_admin_id: string expected";
        if (message.deleted_at != null && message.hasOwnProperty("deleted_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.deleted_at);
            if (error)
                return "deleted_at." + error;
        }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a PortfolioChange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PortfolioChange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PortfolioChange} PortfolioChange
     */
    PortfolioChange.fromObject = function fromObject(object) {
        if (object instanceof $root.PortfolioChange)
            return object;
        let message = new $root.PortfolioChange();
        if (object.id != null)
            message.id = String(object.id);
        if (object.name != null)
            message.name = String(object.name);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PREPARING":
        case 1:
            message.status = 1;
            break;
        case "WAITING_FOR_APPROVAL":
        case 2:
            message.status = 2;
            break;
        case "APPROVED":
        case 3:
            message.status = 3;
            break;
        case "APPLIED":
        case 4:
            message.status = 4;
            break;
        case "DELETED":
        case 5:
            message.status = 5;
            break;
        }
        if (object.instrument_ids_added) {
            if (!Array.isArray(object.instrument_ids_added))
                throw TypeError(".PortfolioChange.instrument_ids_added: array expected");
            message.instrument_ids_added = [];
            for (let i = 0; i < object.instrument_ids_added.length; ++i)
                message.instrument_ids_added[i] = String(object.instrument_ids_added[i]);
        }
        if (object.instrument_ids_removed) {
            if (!Array.isArray(object.instrument_ids_removed))
                throw TypeError(".PortfolioChange.instrument_ids_removed: array expected");
            message.instrument_ids_removed = [];
            for (let i = 0; i < object.instrument_ids_removed.length; ++i)
                message.instrument_ids_removed[i] = String(object.instrument_ids_removed[i]);
        }
        if (object.instrument_id_to_target_allocation) {
            if (typeof object.instrument_id_to_target_allocation !== "object")
                throw TypeError(".PortfolioChange.instrument_id_to_target_allocation: object expected");
            message.instrument_id_to_target_allocation = {};
            for (let keys = Object.keys(object.instrument_id_to_target_allocation), i = 0; i < keys.length; ++i)
                message.instrument_id_to_target_allocation[keys[i]] = String(object.instrument_id_to_target_allocation[keys[i]]);
        }
        if (object.instrument_id_to_last_close_price) {
            if (typeof object.instrument_id_to_last_close_price !== "object")
                throw TypeError(".PortfolioChange.instrument_id_to_last_close_price: object expected");
            message.instrument_id_to_last_close_price = {};
            for (let keys = Object.keys(object.instrument_id_to_last_close_price), i = 0; i < keys.length; ++i)
                message.instrument_id_to_last_close_price[keys[i]] = String(object.instrument_id_to_last_close_price[keys[i]]);
        }
        if (object.created_by_admin_id != null)
            message.created_by_admin_id = String(object.created_by_admin_id);
        if (object.approved_by_admin_id != null)
            message.approved_by_admin_id = String(object.approved_by_admin_id);
        if (object.approved_at != null) {
            if (typeof object.approved_at !== "object")
                throw TypeError(".PortfolioChange.approved_at: object expected");
            message.approved_at = $root.google.protobuf.Timestamp.fromObject(object.approved_at);
        }
        if (object.applied_at != null) {
            if (typeof object.applied_at !== "object")
                throw TypeError(".PortfolioChange.applied_at: object expected");
            message.applied_at = $root.google.protobuf.Timestamp.fromObject(object.applied_at);
        }
        if (object.deleted_by_admin_id != null)
            message.deleted_by_admin_id = String(object.deleted_by_admin_id);
        if (object.deleted_at != null) {
            if (typeof object.deleted_at !== "object")
                throw TypeError(".PortfolioChange.deleted_at: object expected");
            message.deleted_at = $root.google.protobuf.Timestamp.fromObject(object.deleted_at);
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".PortfolioChange.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".PortfolioChange.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a PortfolioChange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PortfolioChange
     * @static
     * @param {PortfolioChange} message PortfolioChange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PortfolioChange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.instrument_ids_added = [];
            object.instrument_ids_removed = [];
        }
        if (options.objects || options.defaults) {
            object.instrument_id_to_target_allocation = {};
            object.instrument_id_to_last_close_price = {};
        }
        if (options.defaults) {
            object.id = "";
            object.name = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.created_by_admin_id = "";
            object.approved_by_admin_id = "";
            object.approved_at = null;
            object.applied_at = null;
            object.deleted_by_admin_id = "";
            object.deleted_at = null;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.PortfolioChangeStatus.Enum[message.status] : message.status;
        if (message.instrument_ids_added && message.instrument_ids_added.length) {
            object.instrument_ids_added = [];
            for (let j = 0; j < message.instrument_ids_added.length; ++j)
                object.instrument_ids_added[j] = message.instrument_ids_added[j];
        }
        if (message.instrument_ids_removed && message.instrument_ids_removed.length) {
            object.instrument_ids_removed = [];
            for (let j = 0; j < message.instrument_ids_removed.length; ++j)
                object.instrument_ids_removed[j] = message.instrument_ids_removed[j];
        }
        let keys2;
        if (message.instrument_id_to_target_allocation && (keys2 = Object.keys(message.instrument_id_to_target_allocation)).length) {
            object.instrument_id_to_target_allocation = {};
            for (let j = 0; j < keys2.length; ++j)
                object.instrument_id_to_target_allocation[keys2[j]] = message.instrument_id_to_target_allocation[keys2[j]];
        }
        if (message.instrument_id_to_last_close_price && (keys2 = Object.keys(message.instrument_id_to_last_close_price)).length) {
            object.instrument_id_to_last_close_price = {};
            for (let j = 0; j < keys2.length; ++j)
                object.instrument_id_to_last_close_price[keys2[j]] = message.instrument_id_to_last_close_price[keys2[j]];
        }
        if (message.created_by_admin_id != null && message.hasOwnProperty("created_by_admin_id"))
            object.created_by_admin_id = message.created_by_admin_id;
        if (message.approved_by_admin_id != null && message.hasOwnProperty("approved_by_admin_id"))
            object.approved_by_admin_id = message.approved_by_admin_id;
        if (message.approved_at != null && message.hasOwnProperty("approved_at"))
            object.approved_at = $root.google.protobuf.Timestamp.toObject(message.approved_at, options);
        if (message.applied_at != null && message.hasOwnProperty("applied_at"))
            object.applied_at = $root.google.protobuf.Timestamp.toObject(message.applied_at, options);
        if (message.deleted_by_admin_id != null && message.hasOwnProperty("deleted_by_admin_id"))
            object.deleted_by_admin_id = message.deleted_by_admin_id;
        if (message.deleted_at != null && message.hasOwnProperty("deleted_at"))
            object.deleted_at = $root.google.protobuf.Timestamp.toObject(message.deleted_at, options);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this PortfolioChange to JSON.
     * @function toJSON
     * @memberof PortfolioChange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PortfolioChange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PortfolioChange;
})();

export const StatementType = $root.StatementType = (() => {

    /**
     * Properties of a StatementType.
     * @exports IStatementType
     * @interface IStatementType
     */

    /**
     * Constructs a new StatementType.
     * @exports StatementType
     * @classdesc Represents a StatementType.
     * @implements IStatementType
     * @constructor
     * @param {IStatementType=} [properties] Properties to set
     */
    function StatementType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new StatementType instance using the specified properties.
     * @function create
     * @memberof StatementType
     * @static
     * @param {IStatementType=} [properties] Properties to set
     * @returns {StatementType} StatementType instance
     */
    StatementType.create = function create(properties) {
        return new StatementType(properties);
    };

    /**
     * Encodes the specified StatementType message. Does not implicitly {@link StatementType.verify|verify} messages.
     * @function encode
     * @memberof StatementType
     * @static
     * @param {IStatementType} message StatementType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StatementType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified StatementType message, length delimited. Does not implicitly {@link StatementType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StatementType
     * @static
     * @param {IStatementType} message StatementType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StatementType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StatementType message from the specified reader or buffer.
     * @function decode
     * @memberof StatementType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StatementType} StatementType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StatementType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StatementType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a StatementType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StatementType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StatementType} StatementType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StatementType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StatementType message.
     * @function verify
     * @memberof StatementType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StatementType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a StatementType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StatementType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StatementType} StatementType
     */
    StatementType.fromObject = function fromObject(object) {
        if (object instanceof $root.StatementType)
            return object;
        return new $root.StatementType();
    };

    /**
     * Creates a plain object from a StatementType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StatementType
     * @static
     * @param {StatementType} message StatementType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StatementType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this StatementType to JSON.
     * @function toJSON
     * @memberof StatementType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StatementType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name StatementType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} EXIT=1 EXIT value
     * @property {number} ACCOUNT=2 ACCOUNT value
     * @property {number} PERIODIC=3 PERIODIC value
     */
    StatementType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "EXIT"] = 1;
        values[valuesById[2] = "ACCOUNT"] = 2;
        values[valuesById[3] = "PERIODIC"] = 3;
        return values;
    })();

    return StatementType;
})();

export const UnitPriceType = $root.UnitPriceType = (() => {

    /**
     * Properties of an UnitPriceType.
     * @exports IUnitPriceType
     * @interface IUnitPriceType
     */

    /**
     * Constructs a new UnitPriceType.
     * @exports UnitPriceType
     * @classdesc Represents an UnitPriceType.
     * @implements IUnitPriceType
     * @constructor
     * @param {IUnitPriceType=} [properties] Properties to set
     */
    function UnitPriceType(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new UnitPriceType instance using the specified properties.
     * @function create
     * @memberof UnitPriceType
     * @static
     * @param {IUnitPriceType=} [properties] Properties to set
     * @returns {UnitPriceType} UnitPriceType instance
     */
    UnitPriceType.create = function create(properties) {
        return new UnitPriceType(properties);
    };

    /**
     * Encodes the specified UnitPriceType message. Does not implicitly {@link UnitPriceType.verify|verify} messages.
     * @function encode
     * @memberof UnitPriceType
     * @static
     * @param {IUnitPriceType} message UnitPriceType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitPriceType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified UnitPriceType message, length delimited. Does not implicitly {@link UnitPriceType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitPriceType
     * @static
     * @param {IUnitPriceType} message UnitPriceType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitPriceType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitPriceType message from the specified reader or buffer.
     * @function decode
     * @memberof UnitPriceType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitPriceType} UnitPriceType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitPriceType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitPriceType();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitPriceType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitPriceType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitPriceType} UnitPriceType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitPriceType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitPriceType message.
     * @function verify
     * @memberof UnitPriceType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitPriceType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an UnitPriceType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitPriceType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitPriceType} UnitPriceType
     */
    UnitPriceType.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitPriceType)
            return object;
        return new $root.UnitPriceType();
    };

    /**
     * Creates a plain object from an UnitPriceType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitPriceType
     * @static
     * @param {UnitPriceType} message UnitPriceType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitPriceType.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this UnitPriceType to JSON.
     * @function toJSON
     * @memberof UnitPriceType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitPriceType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name UnitPriceType.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} BAU=1 BAU value
     * @property {number} EX=2 EX value
     */
    UnitPriceType.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "BAU"] = 1;
        values[valuesById[2] = "EX"] = 2;
        return values;
    })();

    return UnitPriceType;
})();

export const UnitPrice = $root.UnitPrice = (() => {

    /**
     * Properties of an UnitPrice.
     * @exports IUnitPrice
     * @interface IUnitPrice
     * @property {string|null} [id] UnitPrice id
     * @property {SaverPortfolio.Enum|null} [portfolio] UnitPrice portfolio
     * @property {string|null} [effective_date] UnitPrice effective_date
     * @property {string|null} [unit_price] UnitPrice unit_price
     * @property {string|null} [total_unit_holdings] UnitPrice total_unit_holdings
     * @property {string|null} [net_asset_value] UnitPrice net_asset_value
     * @property {google.protobuf.ITimestamp|null} [scheduled_time] UnitPrice scheduled_time
     * @property {UnitPriceType.Enum|null} [type] UnitPrice type
     * @property {google.protobuf.ITimestamp|null} [created_at] UnitPrice created_at
     */

    /**
     * Constructs a new UnitPrice.
     * @exports UnitPrice
     * @classdesc Represents an UnitPrice.
     * @implements IUnitPrice
     * @constructor
     * @param {IUnitPrice=} [properties] Properties to set
     */
    function UnitPrice(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnitPrice id.
     * @member {string} id
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.id = "";

    /**
     * UnitPrice portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.portfolio = 0;

    /**
     * UnitPrice effective_date.
     * @member {string} effective_date
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.effective_date = "";

    /**
     * UnitPrice unit_price.
     * @member {string} unit_price
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.unit_price = "";

    /**
     * UnitPrice total_unit_holdings.
     * @member {string} total_unit_holdings
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.total_unit_holdings = "";

    /**
     * UnitPrice net_asset_value.
     * @member {string} net_asset_value
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.net_asset_value = "";

    /**
     * UnitPrice scheduled_time.
     * @member {google.protobuf.ITimestamp|null|undefined} scheduled_time
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.scheduled_time = null;

    /**
     * UnitPrice type.
     * @member {UnitPriceType.Enum} type
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.type = 0;

    /**
     * UnitPrice created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof UnitPrice
     * @instance
     */
    UnitPrice.prototype.created_at = null;

    /**
     * Creates a new UnitPrice instance using the specified properties.
     * @function create
     * @memberof UnitPrice
     * @static
     * @param {IUnitPrice=} [properties] Properties to set
     * @returns {UnitPrice} UnitPrice instance
     */
    UnitPrice.create = function create(properties) {
        return new UnitPrice(properties);
    };

    /**
     * Encodes the specified UnitPrice message. Does not implicitly {@link UnitPrice.verify|verify} messages.
     * @function encode
     * @memberof UnitPrice
     * @static
     * @param {IUnitPrice} message UnitPrice message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitPrice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.portfolio);
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.effective_date);
        if (message.unit_price != null && message.hasOwnProperty("unit_price"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.unit_price);
        if (message.total_unit_holdings != null && message.hasOwnProperty("total_unit_holdings"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.total_unit_holdings);
        if (message.net_asset_value != null && message.hasOwnProperty("net_asset_value"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.net_asset_value);
        if (message.scheduled_time != null && message.hasOwnProperty("scheduled_time"))
            $root.google.protobuf.Timestamp.encode(message.scheduled_time, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.type);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UnitPrice message, length delimited. Does not implicitly {@link UnitPrice.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitPrice
     * @static
     * @param {IUnitPrice} message UnitPrice message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitPrice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitPrice message from the specified reader or buffer.
     * @function decode
     * @memberof UnitPrice
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitPrice} UnitPrice
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitPrice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitPrice();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.portfolio = reader.int32();
                break;
            case 3:
                message.effective_date = reader.string();
                break;
            case 4:
                message.unit_price = reader.string();
                break;
            case 5:
                message.total_unit_holdings = reader.string();
                break;
            case 6:
                message.net_asset_value = reader.string();
                break;
            case 7:
                message.scheduled_time = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 8:
                message.type = reader.int32();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitPrice message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitPrice
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitPrice} UnitPrice
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitPrice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitPrice message.
     * @function verify
     * @memberof UnitPrice
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitPrice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            if (!$util.isString(message.effective_date))
                return "effective_date: string expected";
        if (message.unit_price != null && message.hasOwnProperty("unit_price"))
            if (!$util.isString(message.unit_price))
                return "unit_price: string expected";
        if (message.total_unit_holdings != null && message.hasOwnProperty("total_unit_holdings"))
            if (!$util.isString(message.total_unit_holdings))
                return "total_unit_holdings: string expected";
        if (message.net_asset_value != null && message.hasOwnProperty("net_asset_value"))
            if (!$util.isString(message.net_asset_value))
                return "net_asset_value: string expected";
        if (message.scheduled_time != null && message.hasOwnProperty("scheduled_time")) {
            let error = $root.google.protobuf.Timestamp.verify(message.scheduled_time);
            if (error)
                return "scheduled_time." + error;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates an UnitPrice message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitPrice
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitPrice} UnitPrice
     */
    UnitPrice.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitPrice)
            return object;
        let message = new $root.UnitPrice();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.effective_date != null)
            message.effective_date = String(object.effective_date);
        if (object.unit_price != null)
            message.unit_price = String(object.unit_price);
        if (object.total_unit_holdings != null)
            message.total_unit_holdings = String(object.total_unit_holdings);
        if (object.net_asset_value != null)
            message.net_asset_value = String(object.net_asset_value);
        if (object.scheduled_time != null) {
            if (typeof object.scheduled_time !== "object")
                throw TypeError(".UnitPrice.scheduled_time: object expected");
            message.scheduled_time = $root.google.protobuf.Timestamp.fromObject(object.scheduled_time);
        }
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "BAU":
        case 1:
            message.type = 1;
            break;
        case "EX":
        case 2:
            message.type = 2;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".UnitPrice.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an UnitPrice message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitPrice
     * @static
     * @param {UnitPrice} message UnitPrice
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitPrice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.effective_date = "";
            object.unit_price = "";
            object.total_unit_holdings = "";
            object.net_asset_value = "";
            object.scheduled_time = null;
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            object.effective_date = message.effective_date;
        if (message.unit_price != null && message.hasOwnProperty("unit_price"))
            object.unit_price = message.unit_price;
        if (message.total_unit_holdings != null && message.hasOwnProperty("total_unit_holdings"))
            object.total_unit_holdings = message.total_unit_holdings;
        if (message.net_asset_value != null && message.hasOwnProperty("net_asset_value"))
            object.net_asset_value = message.net_asset_value;
        if (message.scheduled_time != null && message.hasOwnProperty("scheduled_time"))
            object.scheduled_time = $root.google.protobuf.Timestamp.toObject(message.scheduled_time, options);
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.UnitPriceType.Enum[message.type] : message.type;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this UnitPrice to JSON.
     * @function toJSON
     * @memberof UnitPrice
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitPrice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnitPrice;
})();

export const Order = $root.Order = (() => {

    /**
     * Properties of an Order.
     * @exports IOrder
     * @interface IOrder
     * @property {string|null} [transaction_reference] Order transaction_reference
     * @property {string|null} [product_id] Order product_id
     * @property {SaverPortfolio.Enum|null} [portfolio] Order portfolio
     * @property {Order.Type.Enum|null} [type] Order type
     * @property {Order.Direction.Enum|null} [direction] Order direction
     * @property {string|null} [aud_amount] Order aud_amount
     * @property {Order.Status.Enum|null} [status] Order status
     * @property {string|null} [actual_aud_amount] Order actual_aud_amount
     * @property {google.protobuf.ITimestamp|null} [eligible_at] Order eligible_at
     * @property {google.protobuf.ITimestamp|null} [created_at] Order created_at
     */

    /**
     * Constructs a new Order.
     * @exports Order
     * @classdesc Represents an Order.
     * @implements IOrder
     * @constructor
     * @param {IOrder=} [properties] Properties to set
     */
    function Order(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Order transaction_reference.
     * @member {string} transaction_reference
     * @memberof Order
     * @instance
     */
    Order.prototype.transaction_reference = "";

    /**
     * Order product_id.
     * @member {string} product_id
     * @memberof Order
     * @instance
     */
    Order.prototype.product_id = "";

    /**
     * Order portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof Order
     * @instance
     */
    Order.prototype.portfolio = 0;

    /**
     * Order type.
     * @member {Order.Type.Enum} type
     * @memberof Order
     * @instance
     */
    Order.prototype.type = 0;

    /**
     * Order direction.
     * @member {Order.Direction.Enum} direction
     * @memberof Order
     * @instance
     */
    Order.prototype.direction = 0;

    /**
     * Order aud_amount.
     * @member {string} aud_amount
     * @memberof Order
     * @instance
     */
    Order.prototype.aud_amount = "";

    /**
     * Order status.
     * @member {Order.Status.Enum} status
     * @memberof Order
     * @instance
     */
    Order.prototype.status = 0;

    /**
     * Order actual_aud_amount.
     * @member {string} actual_aud_amount
     * @memberof Order
     * @instance
     */
    Order.prototype.actual_aud_amount = "";

    /**
     * Order eligible_at.
     * @member {google.protobuf.ITimestamp|null|undefined} eligible_at
     * @memberof Order
     * @instance
     */
    Order.prototype.eligible_at = null;

    /**
     * Order created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof Order
     * @instance
     */
    Order.prototype.created_at = null;

    /**
     * Creates a new Order instance using the specified properties.
     * @function create
     * @memberof Order
     * @static
     * @param {IOrder=} [properties] Properties to set
     * @returns {Order} Order instance
     */
    Order.create = function create(properties) {
        return new Order(properties);
    };

    /**
     * Encodes the specified Order message. Does not implicitly {@link Order.verify|verify} messages.
     * @function encode
     * @memberof Order
     * @static
     * @param {IOrder} message Order message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Order.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.product_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.portfolio);
        if (message.type != null && message.hasOwnProperty("type"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
        if (message.direction != null && message.hasOwnProperty("direction"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.direction);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.aud_amount);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
        if (message.actual_aud_amount != null && message.hasOwnProperty("actual_aud_amount"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.actual_aud_amount);
        if (message.eligible_at != null && message.hasOwnProperty("eligible_at"))
            $root.google.protobuf.Timestamp.encode(message.eligible_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Order message, length delimited. Does not implicitly {@link Order.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Order
     * @static
     * @param {IOrder} message Order message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Order.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Order message from the specified reader or buffer.
     * @function decode
     * @memberof Order
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Order} Order
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Order.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Order();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_reference = reader.string();
                break;
            case 2:
                message.product_id = reader.string();
                break;
            case 3:
                message.portfolio = reader.int32();
                break;
            case 4:
                message.type = reader.int32();
                break;
            case 5:
                message.direction = reader.int32();
                break;
            case 6:
                message.aud_amount = reader.string();
                break;
            case 7:
                message.status = reader.int32();
                break;
            case 8:
                message.actual_aud_amount = reader.string();
                break;
            case 98:
                message.eligible_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Order message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Order
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Order} Order
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Order.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Order message.
     * @function verify
     * @memberof Order
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Order.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.direction != null && message.hasOwnProperty("direction"))
            switch (message.direction) {
            default:
                return "direction: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.actual_aud_amount != null && message.hasOwnProperty("actual_aud_amount"))
            if (!$util.isString(message.actual_aud_amount))
                return "actual_aud_amount: string expected";
        if (message.eligible_at != null && message.hasOwnProperty("eligible_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.eligible_at);
            if (error)
                return "eligible_at." + error;
        }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates an Order message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Order
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Order} Order
     */
    Order.fromObject = function fromObject(object) {
        if (object instanceof $root.Order)
            return object;
        let message = new $root.Order();
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        switch (object.type) {
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "FEE":
        case 1:
            message.type = 1;
            break;
        case "APPLICATION":
        case 2:
            message.type = 2;
            break;
        case "REDEMPTION":
        case 3:
            message.type = 3;
            break;
        case "FREEBIE":
        case 4:
            message.type = 4;
            break;
        case "FULL_REDEMPTION":
        case 5:
            message.type = 5;
            break;
        case "REVERSAL":
        case 6:
            message.type = 6;
            break;
        case "ADJUSTMENT":
        case 7:
            message.type = 7;
            break;
        case "LEGACY_TRANSFER_SOURCE":
        case 8:
            message.type = 8;
            break;
        case "LEGACY_TRANSFER_DESTINATION":
        case 9:
            message.type = 9;
            break;
        case "REINVESTMENT":
        case 10:
            message.type = 10;
            break;
        case "ACCOUNT_FEE":
        case 11:
            message.type = 11;
            break;
        }
        switch (object.direction) {
        case "UNKNOWN":
        case 0:
            message.direction = 0;
            break;
        case "BUY":
        case 1:
            message.direction = 1;
            break;
        case "SELL":
        case 2:
            message.direction = 2;
            break;
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PENDING":
        case 1:
            message.status = 1;
            break;
        case "EXECUTED":
        case 2:
            message.status = 2;
            break;
        case "INSUFFICIENT_BALANCE":
        case 3:
            message.status = 3;
            break;
        case "CANCELLED":
        case 4:
            message.status = 4;
            break;
        case "ORIGINAL_CANCELLED":
        case 5:
            message.status = 5;
            break;
        }
        if (object.actual_aud_amount != null)
            message.actual_aud_amount = String(object.actual_aud_amount);
        if (object.eligible_at != null) {
            if (typeof object.eligible_at !== "object")
                throw TypeError(".Order.eligible_at: object expected");
            message.eligible_at = $root.google.protobuf.Timestamp.fromObject(object.eligible_at);
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".Order.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an Order message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Order
     * @static
     * @param {Order} message Order
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Order.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_reference = "";
            object.product_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.direction = options.enums === String ? "UNKNOWN" : 0;
            object.aud_amount = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.actual_aud_amount = "";
            object.eligible_at = null;
            object.created_at = null;
        }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.Order.Type.Enum[message.type] : message.type;
        if (message.direction != null && message.hasOwnProperty("direction"))
            object.direction = options.enums === String ? $root.Order.Direction.Enum[message.direction] : message.direction;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.Order.Status.Enum[message.status] : message.status;
        if (message.actual_aud_amount != null && message.hasOwnProperty("actual_aud_amount"))
            object.actual_aud_amount = message.actual_aud_amount;
        if (message.eligible_at != null && message.hasOwnProperty("eligible_at"))
            object.eligible_at = $root.google.protobuf.Timestamp.toObject(message.eligible_at, options);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this Order to JSON.
     * @function toJSON
     * @memberof Order
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Order.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Order.Type = (function() {

        /**
         * Properties of a Type.
         * @memberof Order
         * @interface IType
         */

        /**
         * Constructs a new Type.
         * @memberof Order
         * @classdesc Represents a Type.
         * @implements IType
         * @constructor
         * @param {Order.IType=} [properties] Properties to set
         */
        function Type(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Type instance using the specified properties.
         * @function create
         * @memberof Order.Type
         * @static
         * @param {Order.IType=} [properties] Properties to set
         * @returns {Order.Type} Type instance
         */
        Type.create = function create(properties) {
            return new Type(properties);
        };

        /**
         * Encodes the specified Type message. Does not implicitly {@link Order.Type.verify|verify} messages.
         * @function encode
         * @memberof Order.Type
         * @static
         * @param {Order.IType} message Type message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Type.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Type message, length delimited. Does not implicitly {@link Order.Type.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Order.Type
         * @static
         * @param {Order.IType} message Type message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Type.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Type message from the specified reader or buffer.
         * @function decode
         * @memberof Order.Type
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Order.Type} Type
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Type.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Order.Type();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Type message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Order.Type
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Order.Type} Type
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Type.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Type message.
         * @function verify
         * @memberof Order.Type
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Type.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Type message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Order.Type
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Order.Type} Type
         */
        Type.fromObject = function fromObject(object) {
            if (object instanceof $root.Order.Type)
                return object;
            return new $root.Order.Type();
        };

        /**
         * Creates a plain object from a Type message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Order.Type
         * @static
         * @param {Order.Type} message Type
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Type.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Type to JSON.
         * @function toJSON
         * @memberof Order.Type
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Type.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name Order.Type.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} FEE=1 FEE value
         * @property {number} APPLICATION=2 APPLICATION value
         * @property {number} REDEMPTION=3 REDEMPTION value
         * @property {number} FREEBIE=4 FREEBIE value
         * @property {number} FULL_REDEMPTION=5 FULL_REDEMPTION value
         * @property {number} REVERSAL=6 REVERSAL value
         * @property {number} ADJUSTMENT=7 ADJUSTMENT value
         * @property {number} LEGACY_TRANSFER_SOURCE=8 LEGACY_TRANSFER_SOURCE value
         * @property {number} LEGACY_TRANSFER_DESTINATION=9 LEGACY_TRANSFER_DESTINATION value
         * @property {number} REINVESTMENT=10 REINVESTMENT value
         * @property {number} ACCOUNT_FEE=11 ACCOUNT_FEE value
         */
        Type.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "FEE"] = 1;
            values[valuesById[2] = "APPLICATION"] = 2;
            values[valuesById[3] = "REDEMPTION"] = 3;
            values[valuesById[4] = "FREEBIE"] = 4;
            values[valuesById[5] = "FULL_REDEMPTION"] = 5;
            values[valuesById[6] = "REVERSAL"] = 6;
            values[valuesById[7] = "ADJUSTMENT"] = 7;
            values[valuesById[8] = "LEGACY_TRANSFER_SOURCE"] = 8;
            values[valuesById[9] = "LEGACY_TRANSFER_DESTINATION"] = 9;
            values[valuesById[10] = "REINVESTMENT"] = 10;
            values[valuesById[11] = "ACCOUNT_FEE"] = 11;
            return values;
        })();

        return Type;
    })();

    Order.Direction = (function() {

        /**
         * Properties of a Direction.
         * @memberof Order
         * @interface IDirection
         */

        /**
         * Constructs a new Direction.
         * @memberof Order
         * @classdesc Represents a Direction.
         * @implements IDirection
         * @constructor
         * @param {Order.IDirection=} [properties] Properties to set
         */
        function Direction(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Direction instance using the specified properties.
         * @function create
         * @memberof Order.Direction
         * @static
         * @param {Order.IDirection=} [properties] Properties to set
         * @returns {Order.Direction} Direction instance
         */
        Direction.create = function create(properties) {
            return new Direction(properties);
        };

        /**
         * Encodes the specified Direction message. Does not implicitly {@link Order.Direction.verify|verify} messages.
         * @function encode
         * @memberof Order.Direction
         * @static
         * @param {Order.IDirection} message Direction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Direction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Direction message, length delimited. Does not implicitly {@link Order.Direction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Order.Direction
         * @static
         * @param {Order.IDirection} message Direction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Direction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Direction message from the specified reader or buffer.
         * @function decode
         * @memberof Order.Direction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Order.Direction} Direction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Direction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Order.Direction();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Direction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Order.Direction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Order.Direction} Direction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Direction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Direction message.
         * @function verify
         * @memberof Order.Direction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Direction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Direction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Order.Direction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Order.Direction} Direction
         */
        Direction.fromObject = function fromObject(object) {
            if (object instanceof $root.Order.Direction)
                return object;
            return new $root.Order.Direction();
        };

        /**
         * Creates a plain object from a Direction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Order.Direction
         * @static
         * @param {Order.Direction} message Direction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Direction.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Direction to JSON.
         * @function toJSON
         * @memberof Order.Direction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Direction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name Order.Direction.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} BUY=1 BUY value
         * @property {number} SELL=2 SELL value
         */
        Direction.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "BUY"] = 1;
            values[valuesById[2] = "SELL"] = 2;
            return values;
        })();

        return Direction;
    })();

    Order.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof Order
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof Order
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {Order.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof Order.Status
         * @static
         * @param {Order.IStatus=} [properties] Properties to set
         * @returns {Order.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link Order.Status.verify|verify} messages.
         * @function encode
         * @memberof Order.Status
         * @static
         * @param {Order.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link Order.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Order.Status
         * @static
         * @param {Order.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof Order.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Order.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Order.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Order.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Order.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof Order.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Order.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Order.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.Order.Status)
                return object;
            return new $root.Order.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Order.Status
         * @static
         * @param {Order.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof Order.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name Order.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} PENDING=1 PENDING value
         * @property {number} EXECUTED=2 EXECUTED value
         * @property {number} INSUFFICIENT_BALANCE=3 INSUFFICIENT_BALANCE value
         * @property {number} CANCELLED=4 CANCELLED value
         * @property {number} ORIGINAL_CANCELLED=5 ORIGINAL_CANCELLED value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "PENDING"] = 1;
            values[valuesById[2] = "EXECUTED"] = 2;
            values[valuesById[3] = "INSUFFICIENT_BALANCE"] = 3;
            values[valuesById[4] = "CANCELLED"] = 4;
            values[valuesById[5] = "ORIGINAL_CANCELLED"] = 5;
            return values;
        })();

        return Status;
    })();

    return Order;
})();

export const RedemptionStatus = $root.RedemptionStatus = (() => {

    /**
     * Properties of a RedemptionStatus.
     * @exports IRedemptionStatus
     * @interface IRedemptionStatus
     */

    /**
     * Constructs a new RedemptionStatus.
     * @exports RedemptionStatus
     * @classdesc Represents a RedemptionStatus.
     * @implements IRedemptionStatus
     * @constructor
     * @param {IRedemptionStatus=} [properties] Properties to set
     */
    function RedemptionStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new RedemptionStatus instance using the specified properties.
     * @function create
     * @memberof RedemptionStatus
     * @static
     * @param {IRedemptionStatus=} [properties] Properties to set
     * @returns {RedemptionStatus} RedemptionStatus instance
     */
    RedemptionStatus.create = function create(properties) {
        return new RedemptionStatus(properties);
    };

    /**
     * Encodes the specified RedemptionStatus message. Does not implicitly {@link RedemptionStatus.verify|verify} messages.
     * @function encode
     * @memberof RedemptionStatus
     * @static
     * @param {IRedemptionStatus} message RedemptionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RedemptionStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified RedemptionStatus message, length delimited. Does not implicitly {@link RedemptionStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RedemptionStatus
     * @static
     * @param {IRedemptionStatus} message RedemptionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RedemptionStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RedemptionStatus message from the specified reader or buffer.
     * @function decode
     * @memberof RedemptionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RedemptionStatus} RedemptionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RedemptionStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RedemptionStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RedemptionStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RedemptionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RedemptionStatus} RedemptionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RedemptionStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RedemptionStatus message.
     * @function verify
     * @memberof RedemptionStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RedemptionStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a RedemptionStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RedemptionStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RedemptionStatus} RedemptionStatus
     */
    RedemptionStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.RedemptionStatus)
            return object;
        return new $root.RedemptionStatus();
    };

    /**
     * Creates a plain object from a RedemptionStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RedemptionStatus
     * @static
     * @param {RedemptionStatus} message RedemptionStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RedemptionStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this RedemptionStatus to JSON.
     * @function toJSON
     * @memberof RedemptionStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RedemptionStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name RedemptionStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} REVIEW_REQUIRED=1 REVIEW_REQUIRED value
     * @property {number} MANUALLY_REJECTED=2 MANUALLY_REJECTED value
     * @property {number} BANK_ACCOUNT_VERIFICATION_REQUIRED=3 BANK_ACCOUNT_VERIFICATION_REQUIRED value
     * @property {number} APPROVED=4 APPROVED value
     */
    RedemptionStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "REVIEW_REQUIRED"] = 1;
        values[valuesById[2] = "MANUALLY_REJECTED"] = 2;
        values[valuesById[3] = "BANK_ACCOUNT_VERIFICATION_REQUIRED"] = 3;
        values[valuesById[4] = "APPROVED"] = 4;
        return values;
    })();

    return RedemptionStatus;
})();

export const RedemptionOrderStatus = $root.RedemptionOrderStatus = (() => {

    /**
     * Properties of a RedemptionOrderStatus.
     * @exports IRedemptionOrderStatus
     * @interface IRedemptionOrderStatus
     */

    /**
     * Constructs a new RedemptionOrderStatus.
     * @exports RedemptionOrderStatus
     * @classdesc Represents a RedemptionOrderStatus.
     * @implements IRedemptionOrderStatus
     * @constructor
     * @param {IRedemptionOrderStatus=} [properties] Properties to set
     */
    function RedemptionOrderStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new RedemptionOrderStatus instance using the specified properties.
     * @function create
     * @memberof RedemptionOrderStatus
     * @static
     * @param {IRedemptionOrderStatus=} [properties] Properties to set
     * @returns {RedemptionOrderStatus} RedemptionOrderStatus instance
     */
    RedemptionOrderStatus.create = function create(properties) {
        return new RedemptionOrderStatus(properties);
    };

    /**
     * Encodes the specified RedemptionOrderStatus message. Does not implicitly {@link RedemptionOrderStatus.verify|verify} messages.
     * @function encode
     * @memberof RedemptionOrderStatus
     * @static
     * @param {IRedemptionOrderStatus} message RedemptionOrderStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RedemptionOrderStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified RedemptionOrderStatus message, length delimited. Does not implicitly {@link RedemptionOrderStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RedemptionOrderStatus
     * @static
     * @param {IRedemptionOrderStatus} message RedemptionOrderStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RedemptionOrderStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RedemptionOrderStatus message from the specified reader or buffer.
     * @function decode
     * @memberof RedemptionOrderStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RedemptionOrderStatus} RedemptionOrderStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RedemptionOrderStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RedemptionOrderStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RedemptionOrderStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RedemptionOrderStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RedemptionOrderStatus} RedemptionOrderStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RedemptionOrderStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RedemptionOrderStatus message.
     * @function verify
     * @memberof RedemptionOrderStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RedemptionOrderStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a RedemptionOrderStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RedemptionOrderStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RedemptionOrderStatus} RedemptionOrderStatus
     */
    RedemptionOrderStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.RedemptionOrderStatus)
            return object;
        return new $root.RedemptionOrderStatus();
    };

    /**
     * Creates a plain object from a RedemptionOrderStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RedemptionOrderStatus
     * @static
     * @param {RedemptionOrderStatus} message RedemptionOrderStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RedemptionOrderStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this RedemptionOrderStatus to JSON.
     * @function toJSON
     * @memberof RedemptionOrderStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RedemptionOrderStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name RedemptionOrderStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} NOT_PLACED=1 NOT_PLACED value
     * @property {number} PLACED=2 PLACED value
     * @property {number} FINALISED=3 FINALISED value
     */
    RedemptionOrderStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "NOT_PLACED"] = 1;
        values[valuesById[2] = "PLACED"] = 2;
        values[valuesById[3] = "FINALISED"] = 3;
        return values;
    })();

    return RedemptionOrderStatus;
})();

export const Redemptions = $root.Redemptions = (() => {

    /**
     * Properties of a Redemptions.
     * @exports IRedemptions
     * @interface IRedemptions
     * @property {Array.<IRedemption>|null} [list] Redemptions list
     */

    /**
     * Constructs a new Redemptions.
     * @exports Redemptions
     * @classdesc Represents a Redemptions.
     * @implements IRedemptions
     * @constructor
     * @param {IRedemptions=} [properties] Properties to set
     */
    function Redemptions(properties) {
        this.list = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Redemptions list.
     * @member {Array.<IRedemption>} list
     * @memberof Redemptions
     * @instance
     */
    Redemptions.prototype.list = $util.emptyArray;

    /**
     * Creates a new Redemptions instance using the specified properties.
     * @function create
     * @memberof Redemptions
     * @static
     * @param {IRedemptions=} [properties] Properties to set
     * @returns {Redemptions} Redemptions instance
     */
    Redemptions.create = function create(properties) {
        return new Redemptions(properties);
    };

    /**
     * Encodes the specified Redemptions message. Does not implicitly {@link Redemptions.verify|verify} messages.
     * @function encode
     * @memberof Redemptions
     * @static
     * @param {IRedemptions} message Redemptions message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Redemptions.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.list != null && message.list.length)
            for (let i = 0; i < message.list.length; ++i)
                $root.Redemption.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Redemptions message, length delimited. Does not implicitly {@link Redemptions.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Redemptions
     * @static
     * @param {IRedemptions} message Redemptions message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Redemptions.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Redemptions message from the specified reader or buffer.
     * @function decode
     * @memberof Redemptions
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Redemptions} Redemptions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Redemptions.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Redemptions();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.list && message.list.length))
                    message.list = [];
                message.list.push($root.Redemption.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Redemptions message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Redemptions
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Redemptions} Redemptions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Redemptions.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Redemptions message.
     * @function verify
     * @memberof Redemptions
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Redemptions.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.list != null && message.hasOwnProperty("list")) {
            if (!Array.isArray(message.list))
                return "list: array expected";
            for (let i = 0; i < message.list.length; ++i) {
                let error = $root.Redemption.verify(message.list[i]);
                if (error)
                    return "list." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Redemptions message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Redemptions
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Redemptions} Redemptions
     */
    Redemptions.fromObject = function fromObject(object) {
        if (object instanceof $root.Redemptions)
            return object;
        let message = new $root.Redemptions();
        if (object.list) {
            if (!Array.isArray(object.list))
                throw TypeError(".Redemptions.list: array expected");
            message.list = [];
            for (let i = 0; i < object.list.length; ++i) {
                if (typeof object.list[i] !== "object")
                    throw TypeError(".Redemptions.list: object expected");
                message.list[i] = $root.Redemption.fromObject(object.list[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Redemptions message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Redemptions
     * @static
     * @param {Redemptions} message Redemptions
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Redemptions.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.list = [];
        if (message.list && message.list.length) {
            object.list = [];
            for (let j = 0; j < message.list.length; ++j)
                object.list[j] = $root.Redemption.toObject(message.list[j], options);
        }
        return object;
    };

    /**
     * Converts this Redemptions to JSON.
     * @function toJSON
     * @memberof Redemptions
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Redemptions.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Redemptions;
})();

export const Redemption = $root.Redemption = (() => {

    /**
     * Properties of a Redemption.
     * @exports IRedemption
     * @interface IRedemption
     * @property {string|null} [transaction_reference] Redemption transaction_reference
     * @property {string|null} [product_id] Redemption product_id
     * @property {SaverPortfolio.Enum|null} [portfolio] Redemption portfolio
     * @property {boolean|null} [full_redemption] Redemption full_redemption
     * @property {string|null} [aud_amount] Redemption aud_amount
     * @property {RedemptionStatus.Enum|null} [status] Redemption status
     * @property {RedemptionOrderStatus.Enum|null} [order_status] Redemption order_status
     * @property {boolean|null} [antifraud_checked] Redemption antifraud_checked
     * @property {google.protobuf.ITimestamp|null} [created_at] Redemption created_at
     */

    /**
     * Constructs a new Redemption.
     * @exports Redemption
     * @classdesc Represents a Redemption.
     * @implements IRedemption
     * @constructor
     * @param {IRedemption=} [properties] Properties to set
     */
    function Redemption(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Redemption transaction_reference.
     * @member {string} transaction_reference
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.transaction_reference = "";

    /**
     * Redemption product_id.
     * @member {string} product_id
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.product_id = "";

    /**
     * Redemption portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.portfolio = 0;

    /**
     * Redemption full_redemption.
     * @member {boolean} full_redemption
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.full_redemption = false;

    /**
     * Redemption aud_amount.
     * @member {string} aud_amount
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.aud_amount = "";

    /**
     * Redemption status.
     * @member {RedemptionStatus.Enum} status
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.status = 0;

    /**
     * Redemption order_status.
     * @member {RedemptionOrderStatus.Enum} order_status
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.order_status = 0;

    /**
     * Redemption antifraud_checked.
     * @member {boolean} antifraud_checked
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.antifraud_checked = false;

    /**
     * Redemption created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof Redemption
     * @instance
     */
    Redemption.prototype.created_at = null;

    /**
     * Creates a new Redemption instance using the specified properties.
     * @function create
     * @memberof Redemption
     * @static
     * @param {IRedemption=} [properties] Properties to set
     * @returns {Redemption} Redemption instance
     */
    Redemption.create = function create(properties) {
        return new Redemption(properties);
    };

    /**
     * Encodes the specified Redemption message. Does not implicitly {@link Redemption.verify|verify} messages.
     * @function encode
     * @memberof Redemption
     * @static
     * @param {IRedemption} message Redemption message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Redemption.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.product_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.portfolio);
        if (message.full_redemption != null && message.hasOwnProperty("full_redemption"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.full_redemption);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.aud_amount);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.status);
        if (message.order_status != null && message.hasOwnProperty("order_status"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.order_status);
        if (message.antifraud_checked != null && message.hasOwnProperty("antifraud_checked"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.antifraud_checked);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Redemption message, length delimited. Does not implicitly {@link Redemption.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Redemption
     * @static
     * @param {IRedemption} message Redemption message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Redemption.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Redemption message from the specified reader or buffer.
     * @function decode
     * @memberof Redemption
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Redemption} Redemption
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Redemption.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Redemption();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_reference = reader.string();
                break;
            case 2:
                message.product_id = reader.string();
                break;
            case 3:
                message.portfolio = reader.int32();
                break;
            case 4:
                message.full_redemption = reader.bool();
                break;
            case 5:
                message.aud_amount = reader.string();
                break;
            case 6:
                message.status = reader.int32();
                break;
            case 7:
                message.order_status = reader.int32();
                break;
            case 8:
                message.antifraud_checked = reader.bool();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Redemption message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Redemption
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Redemption} Redemption
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Redemption.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Redemption message.
     * @function verify
     * @memberof Redemption
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Redemption.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.full_redemption != null && message.hasOwnProperty("full_redemption"))
            if (typeof message.full_redemption !== "boolean")
                return "full_redemption: boolean expected";
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.order_status != null && message.hasOwnProperty("order_status"))
            switch (message.order_status) {
            default:
                return "order_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.antifraud_checked != null && message.hasOwnProperty("antifraud_checked"))
            if (typeof message.antifraud_checked !== "boolean")
                return "antifraud_checked: boolean expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates a Redemption message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Redemption
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Redemption} Redemption
     */
    Redemption.fromObject = function fromObject(object) {
        if (object instanceof $root.Redemption)
            return object;
        let message = new $root.Redemption();
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.full_redemption != null)
            message.full_redemption = Boolean(object.full_redemption);
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "REVIEW_REQUIRED":
        case 1:
            message.status = 1;
            break;
        case "MANUALLY_REJECTED":
        case 2:
            message.status = 2;
            break;
        case "BANK_ACCOUNT_VERIFICATION_REQUIRED":
        case 3:
            message.status = 3;
            break;
        case "APPROVED":
        case 4:
            message.status = 4;
            break;
        }
        switch (object.order_status) {
        case "UNKNOWN":
        case 0:
            message.order_status = 0;
            break;
        case "NOT_PLACED":
        case 1:
            message.order_status = 1;
            break;
        case "PLACED":
        case 2:
            message.order_status = 2;
            break;
        case "FINALISED":
        case 3:
            message.order_status = 3;
            break;
        }
        if (object.antifraud_checked != null)
            message.antifraud_checked = Boolean(object.antifraud_checked);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".Redemption.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a Redemption message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Redemption
     * @static
     * @param {Redemption} message Redemption
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Redemption.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_reference = "";
            object.product_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.full_redemption = false;
            object.aud_amount = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.order_status = options.enums === String ? "UNKNOWN" : 0;
            object.antifraud_checked = false;
            object.created_at = null;
        }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.full_redemption != null && message.hasOwnProperty("full_redemption"))
            object.full_redemption = message.full_redemption;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.RedemptionStatus.Enum[message.status] : message.status;
        if (message.order_status != null && message.hasOwnProperty("order_status"))
            object.order_status = options.enums === String ? $root.RedemptionOrderStatus.Enum[message.order_status] : message.order_status;
        if (message.antifraud_checked != null && message.hasOwnProperty("antifraud_checked"))
            object.antifraud_checked = message.antifraud_checked;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this Redemption to JSON.
     * @function toJSON
     * @memberof Redemption
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Redemption.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Redemption;
})();

export const UnitsAndAUDAmount = $root.UnitsAndAUDAmount = (() => {

    /**
     * Properties of an UnitsAndAUDAmount.
     * @exports IUnitsAndAUDAmount
     * @interface IUnitsAndAUDAmount
     * @property {string|null} [units] UnitsAndAUDAmount units
     * @property {string|null} [aud_amount] UnitsAndAUDAmount aud_amount
     */

    /**
     * Constructs a new UnitsAndAUDAmount.
     * @exports UnitsAndAUDAmount
     * @classdesc Represents an UnitsAndAUDAmount.
     * @implements IUnitsAndAUDAmount
     * @constructor
     * @param {IUnitsAndAUDAmount=} [properties] Properties to set
     */
    function UnitsAndAUDAmount(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnitsAndAUDAmount units.
     * @member {string} units
     * @memberof UnitsAndAUDAmount
     * @instance
     */
    UnitsAndAUDAmount.prototype.units = "";

    /**
     * UnitsAndAUDAmount aud_amount.
     * @member {string} aud_amount
     * @memberof UnitsAndAUDAmount
     * @instance
     */
    UnitsAndAUDAmount.prototype.aud_amount = "";

    /**
     * Creates a new UnitsAndAUDAmount instance using the specified properties.
     * @function create
     * @memberof UnitsAndAUDAmount
     * @static
     * @param {IUnitsAndAUDAmount=} [properties] Properties to set
     * @returns {UnitsAndAUDAmount} UnitsAndAUDAmount instance
     */
    UnitsAndAUDAmount.create = function create(properties) {
        return new UnitsAndAUDAmount(properties);
    };

    /**
     * Encodes the specified UnitsAndAUDAmount message. Does not implicitly {@link UnitsAndAUDAmount.verify|verify} messages.
     * @function encode
     * @memberof UnitsAndAUDAmount
     * @static
     * @param {IUnitsAndAUDAmount} message UnitsAndAUDAmount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitsAndAUDAmount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.units != null && message.hasOwnProperty("units"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.units);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.aud_amount);
        return writer;
    };

    /**
     * Encodes the specified UnitsAndAUDAmount message, length delimited. Does not implicitly {@link UnitsAndAUDAmount.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitsAndAUDAmount
     * @static
     * @param {IUnitsAndAUDAmount} message UnitsAndAUDAmount message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitsAndAUDAmount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitsAndAUDAmount message from the specified reader or buffer.
     * @function decode
     * @memberof UnitsAndAUDAmount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitsAndAUDAmount} UnitsAndAUDAmount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitsAndAUDAmount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitsAndAUDAmount();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.units = reader.string();
                break;
            case 2:
                message.aud_amount = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitsAndAUDAmount message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitsAndAUDAmount
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitsAndAUDAmount} UnitsAndAUDAmount
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitsAndAUDAmount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitsAndAUDAmount message.
     * @function verify
     * @memberof UnitsAndAUDAmount
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitsAndAUDAmount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.units != null && message.hasOwnProperty("units"))
            if (!$util.isString(message.units))
                return "units: string expected";
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        return null;
    };

    /**
     * Creates an UnitsAndAUDAmount message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitsAndAUDAmount
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitsAndAUDAmount} UnitsAndAUDAmount
     */
    UnitsAndAUDAmount.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitsAndAUDAmount)
            return object;
        let message = new $root.UnitsAndAUDAmount();
        if (object.units != null)
            message.units = String(object.units);
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        return message;
    };

    /**
     * Creates a plain object from an UnitsAndAUDAmount message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitsAndAUDAmount
     * @static
     * @param {UnitsAndAUDAmount} message UnitsAndAUDAmount
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitsAndAUDAmount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.units = "";
            object.aud_amount = "";
        }
        if (message.units != null && message.hasOwnProperty("units"))
            object.units = message.units;
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        return object;
    };

    /**
     * Converts this UnitsAndAUDAmount to JSON.
     * @function toJSON
     * @memberof UnitsAndAUDAmount
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitsAndAUDAmount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnitsAndAUDAmount;
})();

export const UnitRegistryLedgerEntry = $root.UnitRegistryLedgerEntry = (() => {

    /**
     * Properties of an UnitRegistryLedgerEntry.
     * @exports IUnitRegistryLedgerEntry
     * @interface IUnitRegistryLedgerEntry
     * @property {string|null} [transaction_reference] UnitRegistryLedgerEntry transaction_reference
     * @property {string|null} [product_id] UnitRegistryLedgerEntry product_id
     * @property {SaverPortfolio.Enum|null} [portfolio] UnitRegistryLedgerEntry portfolio
     * @property {string|null} [unit_price_id] UnitRegistryLedgerEntry unit_price_id
     * @property {string|null} [units] UnitRegistryLedgerEntry units
     * @property {boolean|null} [accountant_notified] UnitRegistryLedgerEntry accountant_notified
     * @property {google.protobuf.ITimestamp|null} [created_at] UnitRegistryLedgerEntry created_at
     */

    /**
     * Constructs a new UnitRegistryLedgerEntry.
     * @exports UnitRegistryLedgerEntry
     * @classdesc Represents an UnitRegistryLedgerEntry.
     * @implements IUnitRegistryLedgerEntry
     * @constructor
     * @param {IUnitRegistryLedgerEntry=} [properties] Properties to set
     */
    function UnitRegistryLedgerEntry(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnitRegistryLedgerEntry transaction_reference.
     * @member {string} transaction_reference
     * @memberof UnitRegistryLedgerEntry
     * @instance
     */
    UnitRegistryLedgerEntry.prototype.transaction_reference = "";

    /**
     * UnitRegistryLedgerEntry product_id.
     * @member {string} product_id
     * @memberof UnitRegistryLedgerEntry
     * @instance
     */
    UnitRegistryLedgerEntry.prototype.product_id = "";

    /**
     * UnitRegistryLedgerEntry portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof UnitRegistryLedgerEntry
     * @instance
     */
    UnitRegistryLedgerEntry.prototype.portfolio = 0;

    /**
     * UnitRegistryLedgerEntry unit_price_id.
     * @member {string} unit_price_id
     * @memberof UnitRegistryLedgerEntry
     * @instance
     */
    UnitRegistryLedgerEntry.prototype.unit_price_id = "";

    /**
     * UnitRegistryLedgerEntry units.
     * @member {string} units
     * @memberof UnitRegistryLedgerEntry
     * @instance
     */
    UnitRegistryLedgerEntry.prototype.units = "";

    /**
     * UnitRegistryLedgerEntry accountant_notified.
     * @member {boolean} accountant_notified
     * @memberof UnitRegistryLedgerEntry
     * @instance
     */
    UnitRegistryLedgerEntry.prototype.accountant_notified = false;

    /**
     * UnitRegistryLedgerEntry created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof UnitRegistryLedgerEntry
     * @instance
     */
    UnitRegistryLedgerEntry.prototype.created_at = null;

    /**
     * Creates a new UnitRegistryLedgerEntry instance using the specified properties.
     * @function create
     * @memberof UnitRegistryLedgerEntry
     * @static
     * @param {IUnitRegistryLedgerEntry=} [properties] Properties to set
     * @returns {UnitRegistryLedgerEntry} UnitRegistryLedgerEntry instance
     */
    UnitRegistryLedgerEntry.create = function create(properties) {
        return new UnitRegistryLedgerEntry(properties);
    };

    /**
     * Encodes the specified UnitRegistryLedgerEntry message. Does not implicitly {@link UnitRegistryLedgerEntry.verify|verify} messages.
     * @function encode
     * @memberof UnitRegistryLedgerEntry
     * @static
     * @param {IUnitRegistryLedgerEntry} message UnitRegistryLedgerEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitRegistryLedgerEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.product_id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.portfolio);
        if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.unit_price_id);
        if (message.units != null && message.hasOwnProperty("units"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.units);
        if (message.accountant_notified != null && message.hasOwnProperty("accountant_notified"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.accountant_notified);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UnitRegistryLedgerEntry message, length delimited. Does not implicitly {@link UnitRegistryLedgerEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitRegistryLedgerEntry
     * @static
     * @param {IUnitRegistryLedgerEntry} message UnitRegistryLedgerEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitRegistryLedgerEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitRegistryLedgerEntry message from the specified reader or buffer.
     * @function decode
     * @memberof UnitRegistryLedgerEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitRegistryLedgerEntry} UnitRegistryLedgerEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitRegistryLedgerEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitRegistryLedgerEntry();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_reference = reader.string();
                break;
            case 2:
                message.product_id = reader.string();
                break;
            case 3:
                message.portfolio = reader.int32();
                break;
            case 4:
                message.unit_price_id = reader.string();
                break;
            case 5:
                message.units = reader.string();
                break;
            case 6:
                message.accountant_notified = reader.bool();
                break;
            case 99:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitRegistryLedgerEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitRegistryLedgerEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitRegistryLedgerEntry} UnitRegistryLedgerEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitRegistryLedgerEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitRegistryLedgerEntry message.
     * @function verify
     * @memberof UnitRegistryLedgerEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitRegistryLedgerEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
            if (!$util.isString(message.unit_price_id))
                return "unit_price_id: string expected";
        if (message.units != null && message.hasOwnProperty("units"))
            if (!$util.isString(message.units))
                return "units: string expected";
        if (message.accountant_notified != null && message.hasOwnProperty("accountant_notified"))
            if (typeof message.accountant_notified !== "boolean")
                return "accountant_notified: boolean expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        return null;
    };

    /**
     * Creates an UnitRegistryLedgerEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitRegistryLedgerEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitRegistryLedgerEntry} UnitRegistryLedgerEntry
     */
    UnitRegistryLedgerEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitRegistryLedgerEntry)
            return object;
        let message = new $root.UnitRegistryLedgerEntry();
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.unit_price_id != null)
            message.unit_price_id = String(object.unit_price_id);
        if (object.units != null)
            message.units = String(object.units);
        if (object.accountant_notified != null)
            message.accountant_notified = Boolean(object.accountant_notified);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".UnitRegistryLedgerEntry.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an UnitRegistryLedgerEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitRegistryLedgerEntry
     * @static
     * @param {UnitRegistryLedgerEntry} message UnitRegistryLedgerEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitRegistryLedgerEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.transaction_reference = "";
            object.product_id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.unit_price_id = "";
            object.units = "";
            object.accountant_notified = false;
            object.created_at = null;
        }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
            object.unit_price_id = message.unit_price_id;
        if (message.units != null && message.hasOwnProperty("units"))
            object.units = message.units;
        if (message.accountant_notified != null && message.hasOwnProperty("accountant_notified"))
            object.accountant_notified = message.accountant_notified;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        return object;
    };

    /**
     * Converts this UnitRegistryLedgerEntry to JSON.
     * @function toJSON
     * @memberof UnitRegistryLedgerEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitRegistryLedgerEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnitRegistryLedgerEntry;
})();

export const UnitRegistryTransaction = $root.UnitRegistryTransaction = (() => {

    /**
     * Properties of an UnitRegistryTransaction.
     * @exports IUnitRegistryTransaction
     * @interface IUnitRegistryTransaction
     * @property {IUnitRegistryLedgerEntry|null} [entry] UnitRegistryTransaction entry
     * @property {string|null} [aud_amount] UnitRegistryTransaction aud_amount
     */

    /**
     * Constructs a new UnitRegistryTransaction.
     * @exports UnitRegistryTransaction
     * @classdesc Represents an UnitRegistryTransaction.
     * @implements IUnitRegistryTransaction
     * @constructor
     * @param {IUnitRegistryTransaction=} [properties] Properties to set
     */
    function UnitRegistryTransaction(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnitRegistryTransaction entry.
     * @member {IUnitRegistryLedgerEntry|null|undefined} entry
     * @memberof UnitRegistryTransaction
     * @instance
     */
    UnitRegistryTransaction.prototype.entry = null;

    /**
     * UnitRegistryTransaction aud_amount.
     * @member {string} aud_amount
     * @memberof UnitRegistryTransaction
     * @instance
     */
    UnitRegistryTransaction.prototype.aud_amount = "";

    /**
     * Creates a new UnitRegistryTransaction instance using the specified properties.
     * @function create
     * @memberof UnitRegistryTransaction
     * @static
     * @param {IUnitRegistryTransaction=} [properties] Properties to set
     * @returns {UnitRegistryTransaction} UnitRegistryTransaction instance
     */
    UnitRegistryTransaction.create = function create(properties) {
        return new UnitRegistryTransaction(properties);
    };

    /**
     * Encodes the specified UnitRegistryTransaction message. Does not implicitly {@link UnitRegistryTransaction.verify|verify} messages.
     * @function encode
     * @memberof UnitRegistryTransaction
     * @static
     * @param {IUnitRegistryTransaction} message UnitRegistryTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitRegistryTransaction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.entry != null && message.hasOwnProperty("entry"))
            $root.UnitRegistryLedgerEntry.encode(message.entry, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.aud_amount);
        return writer;
    };

    /**
     * Encodes the specified UnitRegistryTransaction message, length delimited. Does not implicitly {@link UnitRegistryTransaction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UnitRegistryTransaction
     * @static
     * @param {IUnitRegistryTransaction} message UnitRegistryTransaction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnitRegistryTransaction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnitRegistryTransaction message from the specified reader or buffer.
     * @function decode
     * @memberof UnitRegistryTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnitRegistryTransaction} UnitRegistryTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitRegistryTransaction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnitRegistryTransaction();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entry = $root.UnitRegistryLedgerEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.aud_amount = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UnitRegistryTransaction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UnitRegistryTransaction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UnitRegistryTransaction} UnitRegistryTransaction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnitRegistryTransaction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnitRegistryTransaction message.
     * @function verify
     * @memberof UnitRegistryTransaction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnitRegistryTransaction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.entry != null && message.hasOwnProperty("entry")) {
            let error = $root.UnitRegistryLedgerEntry.verify(message.entry);
            if (error)
                return "entry." + error;
        }
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            if (!$util.isString(message.aud_amount))
                return "aud_amount: string expected";
        return null;
    };

    /**
     * Creates an UnitRegistryTransaction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnitRegistryTransaction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnitRegistryTransaction} UnitRegistryTransaction
     */
    UnitRegistryTransaction.fromObject = function fromObject(object) {
        if (object instanceof $root.UnitRegistryTransaction)
            return object;
        let message = new $root.UnitRegistryTransaction();
        if (object.entry != null) {
            if (typeof object.entry !== "object")
                throw TypeError(".UnitRegistryTransaction.entry: object expected");
            message.entry = $root.UnitRegistryLedgerEntry.fromObject(object.entry);
        }
        if (object.aud_amount != null)
            message.aud_amount = String(object.aud_amount);
        return message;
    };

    /**
     * Creates a plain object from an UnitRegistryTransaction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnitRegistryTransaction
     * @static
     * @param {UnitRegistryTransaction} message UnitRegistryTransaction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnitRegistryTransaction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.entry = null;
            object.aud_amount = "";
        }
        if (message.entry != null && message.hasOwnProperty("entry"))
            object.entry = $root.UnitRegistryLedgerEntry.toObject(message.entry, options);
        if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
            object.aud_amount = message.aud_amount;
        return object;
    };

    /**
     * Converts this UnitRegistryTransaction to JSON.
     * @function toJSON
     * @memberof UnitRegistryTransaction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnitRegistryTransaction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnitRegistryTransaction;
})();

export const ProductInstanceMergerStatus = $root.ProductInstanceMergerStatus = (() => {

    /**
     * Properties of a ProductInstanceMergerStatus.
     * @exports IProductInstanceMergerStatus
     * @interface IProductInstanceMergerStatus
     */

    /**
     * Constructs a new ProductInstanceMergerStatus.
     * @exports ProductInstanceMergerStatus
     * @classdesc Represents a ProductInstanceMergerStatus.
     * @implements IProductInstanceMergerStatus
     * @constructor
     * @param {IProductInstanceMergerStatus=} [properties] Properties to set
     */
    function ProductInstanceMergerStatus(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new ProductInstanceMergerStatus instance using the specified properties.
     * @function create
     * @memberof ProductInstanceMergerStatus
     * @static
     * @param {IProductInstanceMergerStatus=} [properties] Properties to set
     * @returns {ProductInstanceMergerStatus} ProductInstanceMergerStatus instance
     */
    ProductInstanceMergerStatus.create = function create(properties) {
        return new ProductInstanceMergerStatus(properties);
    };

    /**
     * Encodes the specified ProductInstanceMergerStatus message. Does not implicitly {@link ProductInstanceMergerStatus.verify|verify} messages.
     * @function encode
     * @memberof ProductInstanceMergerStatus
     * @static
     * @param {IProductInstanceMergerStatus} message ProductInstanceMergerStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProductInstanceMergerStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified ProductInstanceMergerStatus message, length delimited. Does not implicitly {@link ProductInstanceMergerStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ProductInstanceMergerStatus
     * @static
     * @param {IProductInstanceMergerStatus} message ProductInstanceMergerStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProductInstanceMergerStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ProductInstanceMergerStatus message from the specified reader or buffer.
     * @function decode
     * @memberof ProductInstanceMergerStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ProductInstanceMergerStatus} ProductInstanceMergerStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProductInstanceMergerStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProductInstanceMergerStatus();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ProductInstanceMergerStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ProductInstanceMergerStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ProductInstanceMergerStatus} ProductInstanceMergerStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProductInstanceMergerStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ProductInstanceMergerStatus message.
     * @function verify
     * @memberof ProductInstanceMergerStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ProductInstanceMergerStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a ProductInstanceMergerStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ProductInstanceMergerStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ProductInstanceMergerStatus} ProductInstanceMergerStatus
     */
    ProductInstanceMergerStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.ProductInstanceMergerStatus)
            return object;
        return new $root.ProductInstanceMergerStatus();
    };

    /**
     * Creates a plain object from a ProductInstanceMergerStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ProductInstanceMergerStatus
     * @static
     * @param {ProductInstanceMergerStatus} message ProductInstanceMergerStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ProductInstanceMergerStatus.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this ProductInstanceMergerStatus to JSON.
     * @function toJSON
     * @memberof ProductInstanceMergerStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ProductInstanceMergerStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name ProductInstanceMergerStatus.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} AUTOMATICALLY_APPROVED=1 AUTOMATICALLY_APPROVED value
     * @property {number} REQUIRES_REVIEW=2 REQUIRES_REVIEW value
     * @property {number} MANUALLY_APPROVED=3 MANUALLY_APPROVED value
     * @property {number} MANUALLY_REJECTED=4 MANUALLY_REJECTED value
     * @property {number} FAILED=5 FAILED value
     * @property {number} MERGED=6 MERGED value
     */
    ProductInstanceMergerStatus.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "AUTOMATICALLY_APPROVED"] = 1;
        values[valuesById[2] = "REQUIRES_REVIEW"] = 2;
        values[valuesById[3] = "MANUALLY_APPROVED"] = 3;
        values[valuesById[4] = "MANUALLY_REJECTED"] = 4;
        values[valuesById[5] = "FAILED"] = 5;
        values[valuesById[6] = "MERGED"] = 6;
        return values;
    })();

    return ProductInstanceMergerStatus;
})();

export const AccountFee = $root.AccountFee = (() => {

    /**
     * Properties of an AccountFee.
     * @exports IAccountFee
     * @interface IAccountFee
     * @property {string|null} [transaction_reference] AccountFee transaction_reference
     * @property {string|null} [account_id] AccountFee account_id
     * @property {string|null} [product_id] AccountFee product_id
     * @property {string|null} [fee_coverage_start_date] AccountFee fee_coverage_start_date
     * @property {string|null} [fee_coverage_end_date] AccountFee fee_coverage_end_date
     * @property {string|null} [invoice_id] AccountFee invoice_id
     * @property {string|null} [unit_price_id] AccountFee unit_price_id
     * @property {string|null} [aud_fee_amount] AccountFee aud_fee_amount
     * @property {AccountFee.Status.Enum|null} [status] AccountFee status
     * @property {Array.<AccountFee.IBalanceAssessment>|null} [balance_assessments] AccountFee balance_assessments
     * @property {google.protobuf.ITimestamp|null} [created_at] AccountFee created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] AccountFee last_updated_at
     */

    /**
     * Constructs a new AccountFee.
     * @exports AccountFee
     * @classdesc Represents an AccountFee.
     * @implements IAccountFee
     * @constructor
     * @param {IAccountFee=} [properties] Properties to set
     */
    function AccountFee(properties) {
        this.balance_assessments = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountFee transaction_reference.
     * @member {string} transaction_reference
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.transaction_reference = "";

    /**
     * AccountFee account_id.
     * @member {string} account_id
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.account_id = "";

    /**
     * AccountFee product_id.
     * @member {string} product_id
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.product_id = "";

    /**
     * AccountFee fee_coverage_start_date.
     * @member {string} fee_coverage_start_date
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.fee_coverage_start_date = "";

    /**
     * AccountFee fee_coverage_end_date.
     * @member {string} fee_coverage_end_date
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.fee_coverage_end_date = "";

    /**
     * AccountFee invoice_id.
     * @member {string} invoice_id
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.invoice_id = "";

    /**
     * AccountFee unit_price_id.
     * @member {string} unit_price_id
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.unit_price_id = "";

    /**
     * AccountFee aud_fee_amount.
     * @member {string} aud_fee_amount
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.aud_fee_amount = "";

    /**
     * AccountFee status.
     * @member {AccountFee.Status.Enum} status
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.status = 0;

    /**
     * AccountFee balance_assessments.
     * @member {Array.<AccountFee.IBalanceAssessment>} balance_assessments
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.balance_assessments = $util.emptyArray;

    /**
     * AccountFee created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.created_at = null;

    /**
     * AccountFee last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof AccountFee
     * @instance
     */
    AccountFee.prototype.last_updated_at = null;

    /**
     * Creates a new AccountFee instance using the specified properties.
     * @function create
     * @memberof AccountFee
     * @static
     * @param {IAccountFee=} [properties] Properties to set
     * @returns {AccountFee} AccountFee instance
     */
    AccountFee.create = function create(properties) {
        return new AccountFee(properties);
    };

    /**
     * Encodes the specified AccountFee message. Does not implicitly {@link AccountFee.verify|verify} messages.
     * @function encode
     * @memberof AccountFee
     * @static
     * @param {IAccountFee} message AccountFee message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountFee.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_id);
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.product_id);
        if (message.fee_coverage_start_date != null && message.hasOwnProperty("fee_coverage_start_date"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fee_coverage_start_date);
        if (message.fee_coverage_end_date != null && message.hasOwnProperty("fee_coverage_end_date"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.fee_coverage_end_date);
        if (message.invoice_id != null && message.hasOwnProperty("invoice_id"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.invoice_id);
        if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.unit_price_id);
        if (message.aud_fee_amount != null && message.hasOwnProperty("aud_fee_amount"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.aud_fee_amount);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.status);
        if (message.balance_assessments != null && message.balance_assessments.length)
            for (let i = 0; i < message.balance_assessments.length; ++i)
                $root.AccountFee.BalanceAssessment.encode(message.balance_assessments[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AccountFee message, length delimited. Does not implicitly {@link AccountFee.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountFee
     * @static
     * @param {IAccountFee} message AccountFee message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountFee.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountFee message from the specified reader or buffer.
     * @function decode
     * @memberof AccountFee
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountFee} AccountFee
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountFee.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountFee();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction_reference = reader.string();
                break;
            case 2:
                message.account_id = reader.string();
                break;
            case 3:
                message.product_id = reader.string();
                break;
            case 4:
                message.fee_coverage_start_date = reader.string();
                break;
            case 5:
                message.fee_coverage_end_date = reader.string();
                break;
            case 6:
                message.invoice_id = reader.string();
                break;
            case 7:
                message.unit_price_id = reader.string();
                break;
            case 8:
                message.aud_fee_amount = reader.string();
                break;
            case 9:
                message.status = reader.int32();
                break;
            case 10:
                if (!(message.balance_assessments && message.balance_assessments.length))
                    message.balance_assessments = [];
                message.balance_assessments.push($root.AccountFee.BalanceAssessment.decode(reader, reader.uint32()));
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountFee message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountFee
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountFee} AccountFee
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountFee.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountFee message.
     * @function verify
     * @memberof AccountFee
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountFee.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            if (!$util.isString(message.transaction_reference))
                return "transaction_reference: string expected";
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            if (!$util.isString(message.account_id))
                return "account_id: string expected";
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            if (!$util.isString(message.product_id))
                return "product_id: string expected";
        if (message.fee_coverage_start_date != null && message.hasOwnProperty("fee_coverage_start_date"))
            if (!$util.isString(message.fee_coverage_start_date))
                return "fee_coverage_start_date: string expected";
        if (message.fee_coverage_end_date != null && message.hasOwnProperty("fee_coverage_end_date"))
            if (!$util.isString(message.fee_coverage_end_date))
                return "fee_coverage_end_date: string expected";
        if (message.invoice_id != null && message.hasOwnProperty("invoice_id"))
            if (!$util.isString(message.invoice_id))
                return "invoice_id: string expected";
        if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
            if (!$util.isString(message.unit_price_id))
                return "unit_price_id: string expected";
        if (message.aud_fee_amount != null && message.hasOwnProperty("aud_fee_amount"))
            if (!$util.isString(message.aud_fee_amount))
                return "aud_fee_amount: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.balance_assessments != null && message.hasOwnProperty("balance_assessments")) {
            if (!Array.isArray(message.balance_assessments))
                return "balance_assessments: array expected";
            for (let i = 0; i < message.balance_assessments.length; ++i) {
                let error = $root.AccountFee.BalanceAssessment.verify(message.balance_assessments[i]);
                if (error)
                    return "balance_assessments." + error;
            }
        }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates an AccountFee message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountFee
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountFee} AccountFee
     */
    AccountFee.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountFee)
            return object;
        let message = new $root.AccountFee();
        if (object.transaction_reference != null)
            message.transaction_reference = String(object.transaction_reference);
        if (object.account_id != null)
            message.account_id = String(object.account_id);
        if (object.product_id != null)
            message.product_id = String(object.product_id);
        if (object.fee_coverage_start_date != null)
            message.fee_coverage_start_date = String(object.fee_coverage_start_date);
        if (object.fee_coverage_end_date != null)
            message.fee_coverage_end_date = String(object.fee_coverage_end_date);
        if (object.invoice_id != null)
            message.invoice_id = String(object.invoice_id);
        if (object.unit_price_id != null)
            message.unit_price_id = String(object.unit_price_id);
        if (object.aud_fee_amount != null)
            message.aud_fee_amount = String(object.aud_fee_amount);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "PLACED":
        case 1:
            message.status = 1;
            break;
        case "DEDUCTED":
        case 2:
            message.status = 2;
            break;
        case "FAILED":
        case 3:
            message.status = 3;
            break;
        }
        if (object.balance_assessments) {
            if (!Array.isArray(object.balance_assessments))
                throw TypeError(".AccountFee.balance_assessments: array expected");
            message.balance_assessments = [];
            for (let i = 0; i < object.balance_assessments.length; ++i) {
                if (typeof object.balance_assessments[i] !== "object")
                    throw TypeError(".AccountFee.balance_assessments: object expected");
                message.balance_assessments[i] = $root.AccountFee.BalanceAssessment.fromObject(object.balance_assessments[i]);
            }
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".AccountFee.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".AccountFee.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an AccountFee message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountFee
     * @static
     * @param {AccountFee} message AccountFee
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountFee.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.balance_assessments = [];
        if (options.defaults) {
            object.transaction_reference = "";
            object.account_id = "";
            object.product_id = "";
            object.fee_coverage_start_date = "";
            object.fee_coverage_end_date = "";
            object.invoice_id = "";
            object.unit_price_id = "";
            object.aud_fee_amount = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
            object.transaction_reference = message.transaction_reference;
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            object.account_id = message.account_id;
        if (message.product_id != null && message.hasOwnProperty("product_id"))
            object.product_id = message.product_id;
        if (message.fee_coverage_start_date != null && message.hasOwnProperty("fee_coverage_start_date"))
            object.fee_coverage_start_date = message.fee_coverage_start_date;
        if (message.fee_coverage_end_date != null && message.hasOwnProperty("fee_coverage_end_date"))
            object.fee_coverage_end_date = message.fee_coverage_end_date;
        if (message.invoice_id != null && message.hasOwnProperty("invoice_id"))
            object.invoice_id = message.invoice_id;
        if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
            object.unit_price_id = message.unit_price_id;
        if (message.aud_fee_amount != null && message.hasOwnProperty("aud_fee_amount"))
            object.aud_fee_amount = message.aud_fee_amount;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.AccountFee.Status.Enum[message.status] : message.status;
        if (message.balance_assessments && message.balance_assessments.length) {
            object.balance_assessments = [];
            for (let j = 0; j < message.balance_assessments.length; ++j)
                object.balance_assessments[j] = $root.AccountFee.BalanceAssessment.toObject(message.balance_assessments[j], options);
        }
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this AccountFee to JSON.
     * @function toJSON
     * @memberof AccountFee
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountFee.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    AccountFee.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof AccountFee
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof AccountFee
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {AccountFee.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof AccountFee.Status
         * @static
         * @param {AccountFee.IStatus=} [properties] Properties to set
         * @returns {AccountFee.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link AccountFee.Status.verify|verify} messages.
         * @function encode
         * @memberof AccountFee.Status
         * @static
         * @param {AccountFee.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link AccountFee.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof AccountFee.Status
         * @static
         * @param {AccountFee.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof AccountFee.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {AccountFee.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountFee.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof AccountFee.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {AccountFee.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof AccountFee.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof AccountFee.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {AccountFee.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.AccountFee.Status)
                return object;
            return new $root.AccountFee.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof AccountFee.Status
         * @static
         * @param {AccountFee.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof AccountFee.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name AccountFee.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} PLACED=1 PLACED value
         * @property {number} DEDUCTED=2 DEDUCTED value
         * @property {number} FAILED=3 FAILED value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "PLACED"] = 1;
            values[valuesById[2] = "DEDUCTED"] = 2;
            values[valuesById[3] = "FAILED"] = 3;
            return values;
        })();

        return Status;
    })();

    AccountFee.BalanceAssessment = (function() {

        /**
         * Properties of a BalanceAssessment.
         * @memberof AccountFee
         * @interface IBalanceAssessment
         * @property {string|null} [transaction_reference] BalanceAssessment transaction_reference
         * @property {string|null} [product_id] BalanceAssessment product_id
         * @property {string|null} [unit_price_id] BalanceAssessment unit_price_id
         * @property {string|null} [unit_balance] BalanceAssessment unit_balance
         * @property {string|null} [aud_balance] BalanceAssessment aud_balance
         * @property {string|null} [aud_assessment_threshold] BalanceAssessment aud_assessment_threshold
         * @property {string|null} [previous_coverage_start_date] BalanceAssessment previous_coverage_start_date
         * @property {string|null} [previous_coverage_end_date] BalanceAssessment previous_coverage_end_date
         * @property {google.protobuf.ITimestamp|null} [created_at] BalanceAssessment created_at
         */

        /**
         * Constructs a new BalanceAssessment.
         * @memberof AccountFee
         * @classdesc Represents a BalanceAssessment.
         * @implements IBalanceAssessment
         * @constructor
         * @param {AccountFee.IBalanceAssessment=} [properties] Properties to set
         */
        function BalanceAssessment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BalanceAssessment transaction_reference.
         * @member {string} transaction_reference
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.transaction_reference = "";

        /**
         * BalanceAssessment product_id.
         * @member {string} product_id
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.product_id = "";

        /**
         * BalanceAssessment unit_price_id.
         * @member {string} unit_price_id
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.unit_price_id = "";

        /**
         * BalanceAssessment unit_balance.
         * @member {string} unit_balance
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.unit_balance = "";

        /**
         * BalanceAssessment aud_balance.
         * @member {string} aud_balance
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.aud_balance = "";

        /**
         * BalanceAssessment aud_assessment_threshold.
         * @member {string} aud_assessment_threshold
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.aud_assessment_threshold = "";

        /**
         * BalanceAssessment previous_coverage_start_date.
         * @member {string} previous_coverage_start_date
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.previous_coverage_start_date = "";

        /**
         * BalanceAssessment previous_coverage_end_date.
         * @member {string} previous_coverage_end_date
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.previous_coverage_end_date = "";

        /**
         * BalanceAssessment created_at.
         * @member {google.protobuf.ITimestamp|null|undefined} created_at
         * @memberof AccountFee.BalanceAssessment
         * @instance
         */
        BalanceAssessment.prototype.created_at = null;

        /**
         * Creates a new BalanceAssessment instance using the specified properties.
         * @function create
         * @memberof AccountFee.BalanceAssessment
         * @static
         * @param {AccountFee.IBalanceAssessment=} [properties] Properties to set
         * @returns {AccountFee.BalanceAssessment} BalanceAssessment instance
         */
        BalanceAssessment.create = function create(properties) {
            return new BalanceAssessment(properties);
        };

        /**
         * Encodes the specified BalanceAssessment message. Does not implicitly {@link AccountFee.BalanceAssessment.verify|verify} messages.
         * @function encode
         * @memberof AccountFee.BalanceAssessment
         * @static
         * @param {AccountFee.IBalanceAssessment} message BalanceAssessment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BalanceAssessment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
            if (message.product_id != null && message.hasOwnProperty("product_id"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.product_id);
            if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.unit_price_id);
            if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.unit_balance);
            if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.aud_balance);
            if (message.aud_assessment_threshold != null && message.hasOwnProperty("aud_assessment_threshold"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.aud_assessment_threshold);
            if (message.previous_coverage_start_date != null && message.hasOwnProperty("previous_coverage_start_date"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.previous_coverage_start_date);
            if (message.previous_coverage_end_date != null && message.hasOwnProperty("previous_coverage_end_date"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.previous_coverage_end_date);
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BalanceAssessment message, length delimited. Does not implicitly {@link AccountFee.BalanceAssessment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof AccountFee.BalanceAssessment
         * @static
         * @param {AccountFee.IBalanceAssessment} message BalanceAssessment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BalanceAssessment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BalanceAssessment message from the specified reader or buffer.
         * @function decode
         * @memberof AccountFee.BalanceAssessment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {AccountFee.BalanceAssessment} BalanceAssessment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BalanceAssessment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountFee.BalanceAssessment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.transaction_reference = reader.string();
                    break;
                case 2:
                    message.product_id = reader.string();
                    break;
                case 3:
                    message.unit_price_id = reader.string();
                    break;
                case 4:
                    message.unit_balance = reader.string();
                    break;
                case 5:
                    message.aud_balance = reader.string();
                    break;
                case 6:
                    message.aud_assessment_threshold = reader.string();
                    break;
                case 7:
                    message.previous_coverage_start_date = reader.string();
                    break;
                case 8:
                    message.previous_coverage_end_date = reader.string();
                    break;
                case 99:
                    message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BalanceAssessment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof AccountFee.BalanceAssessment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {AccountFee.BalanceAssessment} BalanceAssessment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BalanceAssessment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BalanceAssessment message.
         * @function verify
         * @memberof AccountFee.BalanceAssessment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BalanceAssessment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                if (!$util.isString(message.transaction_reference))
                    return "transaction_reference: string expected";
            if (message.product_id != null && message.hasOwnProperty("product_id"))
                if (!$util.isString(message.product_id))
                    return "product_id: string expected";
            if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
                if (!$util.isString(message.unit_price_id))
                    return "unit_price_id: string expected";
            if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
                if (!$util.isString(message.unit_balance))
                    return "unit_balance: string expected";
            if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
                if (!$util.isString(message.aud_balance))
                    return "aud_balance: string expected";
            if (message.aud_assessment_threshold != null && message.hasOwnProperty("aud_assessment_threshold"))
                if (!$util.isString(message.aud_assessment_threshold))
                    return "aud_assessment_threshold: string expected";
            if (message.previous_coverage_start_date != null && message.hasOwnProperty("previous_coverage_start_date"))
                if (!$util.isString(message.previous_coverage_start_date))
                    return "previous_coverage_start_date: string expected";
            if (message.previous_coverage_end_date != null && message.hasOwnProperty("previous_coverage_end_date"))
                if (!$util.isString(message.previous_coverage_end_date))
                    return "previous_coverage_end_date: string expected";
            if (message.created_at != null && message.hasOwnProperty("created_at")) {
                let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                if (error)
                    return "created_at." + error;
            }
            return null;
        };

        /**
         * Creates a BalanceAssessment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof AccountFee.BalanceAssessment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {AccountFee.BalanceAssessment} BalanceAssessment
         */
        BalanceAssessment.fromObject = function fromObject(object) {
            if (object instanceof $root.AccountFee.BalanceAssessment)
                return object;
            let message = new $root.AccountFee.BalanceAssessment();
            if (object.transaction_reference != null)
                message.transaction_reference = String(object.transaction_reference);
            if (object.product_id != null)
                message.product_id = String(object.product_id);
            if (object.unit_price_id != null)
                message.unit_price_id = String(object.unit_price_id);
            if (object.unit_balance != null)
                message.unit_balance = String(object.unit_balance);
            if (object.aud_balance != null)
                message.aud_balance = String(object.aud_balance);
            if (object.aud_assessment_threshold != null)
                message.aud_assessment_threshold = String(object.aud_assessment_threshold);
            if (object.previous_coverage_start_date != null)
                message.previous_coverage_start_date = String(object.previous_coverage_start_date);
            if (object.previous_coverage_end_date != null)
                message.previous_coverage_end_date = String(object.previous_coverage_end_date);
            if (object.created_at != null) {
                if (typeof object.created_at !== "object")
                    throw TypeError(".AccountFee.BalanceAssessment.created_at: object expected");
                message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
            }
            return message;
        };

        /**
         * Creates a plain object from a BalanceAssessment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof AccountFee.BalanceAssessment
         * @static
         * @param {AccountFee.BalanceAssessment} message BalanceAssessment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BalanceAssessment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.transaction_reference = "";
                object.product_id = "";
                object.unit_price_id = "";
                object.unit_balance = "";
                object.aud_balance = "";
                object.aud_assessment_threshold = "";
                object.previous_coverage_start_date = "";
                object.previous_coverage_end_date = "";
                object.created_at = null;
            }
            if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                object.transaction_reference = message.transaction_reference;
            if (message.product_id != null && message.hasOwnProperty("product_id"))
                object.product_id = message.product_id;
            if (message.unit_price_id != null && message.hasOwnProperty("unit_price_id"))
                object.unit_price_id = message.unit_price_id;
            if (message.unit_balance != null && message.hasOwnProperty("unit_balance"))
                object.unit_balance = message.unit_balance;
            if (message.aud_balance != null && message.hasOwnProperty("aud_balance"))
                object.aud_balance = message.aud_balance;
            if (message.aud_assessment_threshold != null && message.hasOwnProperty("aud_assessment_threshold"))
                object.aud_assessment_threshold = message.aud_assessment_threshold;
            if (message.previous_coverage_start_date != null && message.hasOwnProperty("previous_coverage_start_date"))
                object.previous_coverage_start_date = message.previous_coverage_start_date;
            if (message.previous_coverage_end_date != null && message.hasOwnProperty("previous_coverage_end_date"))
                object.previous_coverage_end_date = message.previous_coverage_end_date;
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
            return object;
        };

        /**
         * Converts this BalanceAssessment to JSON.
         * @function toJSON
         * @memberof AccountFee.BalanceAssessment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BalanceAssessment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BalanceAssessment;
    })();

    return AccountFee;
})();

export const AccountFeePortfolioInvoice = $root.AccountFeePortfolioInvoice = (() => {

    /**
     * Properties of an AccountFeePortfolioInvoice.
     * @exports IAccountFeePortfolioInvoice
     * @interface IAccountFeePortfolioInvoice
     * @property {string|null} [id] AccountFeePortfolioInvoice id
     * @property {SaverPortfolio.Enum|null} [portfolio] AccountFeePortfolioInvoice portfolio
     * @property {string|null} [effective_date] AccountFeePortfolioInvoice effective_date
     * @property {AccountFeePortfolioInvoice.Status.Enum|null} [status] AccountFeePortfolioInvoice status
     * @property {number|null} [fee_count] AccountFeePortfolioInvoice fee_count
     * @property {string|null} [aud_net_fee_rate] AccountFeePortfolioInvoice aud_net_fee_rate
     * @property {string|null} [aud_gross_fee_rate] AccountFeePortfolioInvoice aud_gross_fee_rate
     * @property {string|null} [aud_fee_gst] AccountFeePortfolioInvoice aud_fee_gst
     * @property {string|null} [aud_total] AccountFeePortfolioInvoice aud_total
     * @property {string|null} [aud_subtotal] AccountFeePortfolioInvoice aud_subtotal
     * @property {string|null} [aud_total_gst] AccountFeePortfolioInvoice aud_total_gst
     * @property {string|null} [aud_ritc_credit] AccountFeePortfolioInvoice aud_ritc_credit
     * @property {string|null} [aud_amount_due] AccountFeePortfolioInvoice aud_amount_due
     * @property {google.protobuf.ITimestamp|null} [created_at] AccountFeePortfolioInvoice created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] AccountFeePortfolioInvoice last_updated_at
     */

    /**
     * Constructs a new AccountFeePortfolioInvoice.
     * @exports AccountFeePortfolioInvoice
     * @classdesc Represents an AccountFeePortfolioInvoice.
     * @implements IAccountFeePortfolioInvoice
     * @constructor
     * @param {IAccountFeePortfolioInvoice=} [properties] Properties to set
     */
    function AccountFeePortfolioInvoice(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountFeePortfolioInvoice id.
     * @member {string} id
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.id = "";

    /**
     * AccountFeePortfolioInvoice portfolio.
     * @member {SaverPortfolio.Enum} portfolio
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.portfolio = 0;

    /**
     * AccountFeePortfolioInvoice effective_date.
     * @member {string} effective_date
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.effective_date = "";

    /**
     * AccountFeePortfolioInvoice status.
     * @member {AccountFeePortfolioInvoice.Status.Enum} status
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.status = 0;

    /**
     * AccountFeePortfolioInvoice fee_count.
     * @member {number} fee_count
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.fee_count = 0;

    /**
     * AccountFeePortfolioInvoice aud_net_fee_rate.
     * @member {string} aud_net_fee_rate
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.aud_net_fee_rate = "";

    /**
     * AccountFeePortfolioInvoice aud_gross_fee_rate.
     * @member {string} aud_gross_fee_rate
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.aud_gross_fee_rate = "";

    /**
     * AccountFeePortfolioInvoice aud_fee_gst.
     * @member {string} aud_fee_gst
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.aud_fee_gst = "";

    /**
     * AccountFeePortfolioInvoice aud_total.
     * @member {string} aud_total
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.aud_total = "";

    /**
     * AccountFeePortfolioInvoice aud_subtotal.
     * @member {string} aud_subtotal
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.aud_subtotal = "";

    /**
     * AccountFeePortfolioInvoice aud_total_gst.
     * @member {string} aud_total_gst
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.aud_total_gst = "";

    /**
     * AccountFeePortfolioInvoice aud_ritc_credit.
     * @member {string} aud_ritc_credit
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.aud_ritc_credit = "";

    /**
     * AccountFeePortfolioInvoice aud_amount_due.
     * @member {string} aud_amount_due
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.aud_amount_due = "";

    /**
     * AccountFeePortfolioInvoice created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.created_at = null;

    /**
     * AccountFeePortfolioInvoice last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof AccountFeePortfolioInvoice
     * @instance
     */
    AccountFeePortfolioInvoice.prototype.last_updated_at = null;

    /**
     * Creates a new AccountFeePortfolioInvoice instance using the specified properties.
     * @function create
     * @memberof AccountFeePortfolioInvoice
     * @static
     * @param {IAccountFeePortfolioInvoice=} [properties] Properties to set
     * @returns {AccountFeePortfolioInvoice} AccountFeePortfolioInvoice instance
     */
    AccountFeePortfolioInvoice.create = function create(properties) {
        return new AccountFeePortfolioInvoice(properties);
    };

    /**
     * Encodes the specified AccountFeePortfolioInvoice message. Does not implicitly {@link AccountFeePortfolioInvoice.verify|verify} messages.
     * @function encode
     * @memberof AccountFeePortfolioInvoice
     * @static
     * @param {IAccountFeePortfolioInvoice} message AccountFeePortfolioInvoice message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountFeePortfolioInvoice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.portfolio);
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.effective_date);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
        if (message.fee_count != null && message.hasOwnProperty("fee_count"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.fee_count);
        if (message.aud_net_fee_rate != null && message.hasOwnProperty("aud_net_fee_rate"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.aud_net_fee_rate);
        if (message.aud_gross_fee_rate != null && message.hasOwnProperty("aud_gross_fee_rate"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.aud_gross_fee_rate);
        if (message.aud_fee_gst != null && message.hasOwnProperty("aud_fee_gst"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.aud_fee_gst);
        if (message.aud_total != null && message.hasOwnProperty("aud_total"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.aud_total);
        if (message.aud_subtotal != null && message.hasOwnProperty("aud_subtotal"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.aud_subtotal);
        if (message.aud_total_gst != null && message.hasOwnProperty("aud_total_gst"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.aud_total_gst);
        if (message.aud_ritc_credit != null && message.hasOwnProperty("aud_ritc_credit"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.aud_ritc_credit);
        if (message.aud_amount_due != null && message.hasOwnProperty("aud_amount_due"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.aud_amount_due);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AccountFeePortfolioInvoice message, length delimited. Does not implicitly {@link AccountFeePortfolioInvoice.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountFeePortfolioInvoice
     * @static
     * @param {IAccountFeePortfolioInvoice} message AccountFeePortfolioInvoice message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountFeePortfolioInvoice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountFeePortfolioInvoice message from the specified reader or buffer.
     * @function decode
     * @memberof AccountFeePortfolioInvoice
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountFeePortfolioInvoice} AccountFeePortfolioInvoice
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountFeePortfolioInvoice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountFeePortfolioInvoice();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.portfolio = reader.int32();
                break;
            case 3:
                message.effective_date = reader.string();
                break;
            case 4:
                message.status = reader.int32();
                break;
            case 5:
                message.fee_count = reader.int32();
                break;
            case 6:
                message.aud_net_fee_rate = reader.string();
                break;
            case 7:
                message.aud_gross_fee_rate = reader.string();
                break;
            case 8:
                message.aud_fee_gst = reader.string();
                break;
            case 9:
                message.aud_total = reader.string();
                break;
            case 10:
                message.aud_subtotal = reader.string();
                break;
            case 11:
                message.aud_total_gst = reader.string();
                break;
            case 12:
                message.aud_ritc_credit = reader.string();
                break;
            case 13:
                message.aud_amount_due = reader.string();
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountFeePortfolioInvoice message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountFeePortfolioInvoice
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountFeePortfolioInvoice} AccountFeePortfolioInvoice
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountFeePortfolioInvoice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountFeePortfolioInvoice message.
     * @function verify
     * @memberof AccountFeePortfolioInvoice
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountFeePortfolioInvoice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            switch (message.portfolio) {
            default:
                return "portfolio: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            if (!$util.isString(message.effective_date))
                return "effective_date: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.fee_count != null && message.hasOwnProperty("fee_count"))
            if (!$util.isInteger(message.fee_count))
                return "fee_count: integer expected";
        if (message.aud_net_fee_rate != null && message.hasOwnProperty("aud_net_fee_rate"))
            if (!$util.isString(message.aud_net_fee_rate))
                return "aud_net_fee_rate: string expected";
        if (message.aud_gross_fee_rate != null && message.hasOwnProperty("aud_gross_fee_rate"))
            if (!$util.isString(message.aud_gross_fee_rate))
                return "aud_gross_fee_rate: string expected";
        if (message.aud_fee_gst != null && message.hasOwnProperty("aud_fee_gst"))
            if (!$util.isString(message.aud_fee_gst))
                return "aud_fee_gst: string expected";
        if (message.aud_total != null && message.hasOwnProperty("aud_total"))
            if (!$util.isString(message.aud_total))
                return "aud_total: string expected";
        if (message.aud_subtotal != null && message.hasOwnProperty("aud_subtotal"))
            if (!$util.isString(message.aud_subtotal))
                return "aud_subtotal: string expected";
        if (message.aud_total_gst != null && message.hasOwnProperty("aud_total_gst"))
            if (!$util.isString(message.aud_total_gst))
                return "aud_total_gst: string expected";
        if (message.aud_ritc_credit != null && message.hasOwnProperty("aud_ritc_credit"))
            if (!$util.isString(message.aud_ritc_credit))
                return "aud_ritc_credit: string expected";
        if (message.aud_amount_due != null && message.hasOwnProperty("aud_amount_due"))
            if (!$util.isString(message.aud_amount_due))
                return "aud_amount_due: string expected";
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates an AccountFeePortfolioInvoice message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountFeePortfolioInvoice
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountFeePortfolioInvoice} AccountFeePortfolioInvoice
     */
    AccountFeePortfolioInvoice.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountFeePortfolioInvoice)
            return object;
        let message = new $root.AccountFeePortfolioInvoice();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.portfolio) {
        case "UNKNOWN":
        case 0:
            message.portfolio = 0;
            break;
        case "INDEX":
        case 1:
            message.portfolio = 1;
            break;
        case "UNIVERSE":
        case 2:
            message.portfolio = 2;
            break;
        case "EARTH":
        case 3:
            message.portfolio = 3;
            break;
        case "GALAXY":
        case 4:
            message.portfolio = 4;
            break;
        case "EXPLORER":
        case 5:
            message.portfolio = 5;
            break;
        }
        if (object.effective_date != null)
            message.effective_date = String(object.effective_date);
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "STAGED":
        case 1:
            message.status = 1;
            break;
        case "FINALISED":
        case 2:
            message.status = 2;
            break;
        case "PAYMENT_ACTIONED":
        case 3:
            message.status = 3;
            break;
        }
        if (object.fee_count != null)
            message.fee_count = object.fee_count | 0;
        if (object.aud_net_fee_rate != null)
            message.aud_net_fee_rate = String(object.aud_net_fee_rate);
        if (object.aud_gross_fee_rate != null)
            message.aud_gross_fee_rate = String(object.aud_gross_fee_rate);
        if (object.aud_fee_gst != null)
            message.aud_fee_gst = String(object.aud_fee_gst);
        if (object.aud_total != null)
            message.aud_total = String(object.aud_total);
        if (object.aud_subtotal != null)
            message.aud_subtotal = String(object.aud_subtotal);
        if (object.aud_total_gst != null)
            message.aud_total_gst = String(object.aud_total_gst);
        if (object.aud_ritc_credit != null)
            message.aud_ritc_credit = String(object.aud_ritc_credit);
        if (object.aud_amount_due != null)
            message.aud_amount_due = String(object.aud_amount_due);
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".AccountFeePortfolioInvoice.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".AccountFeePortfolioInvoice.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from an AccountFeePortfolioInvoice message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountFeePortfolioInvoice
     * @static
     * @param {AccountFeePortfolioInvoice} message AccountFeePortfolioInvoice
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountFeePortfolioInvoice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.portfolio = options.enums === String ? "UNKNOWN" : 0;
            object.effective_date = "";
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.fee_count = 0;
            object.aud_net_fee_rate = "";
            object.aud_gross_fee_rate = "";
            object.aud_fee_gst = "";
            object.aud_total = "";
            object.aud_subtotal = "";
            object.aud_total_gst = "";
            object.aud_ritc_credit = "";
            object.aud_amount_due = "";
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.portfolio != null && message.hasOwnProperty("portfolio"))
            object.portfolio = options.enums === String ? $root.SaverPortfolio.Enum[message.portfolio] : message.portfolio;
        if (message.effective_date != null && message.hasOwnProperty("effective_date"))
            object.effective_date = message.effective_date;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.AccountFeePortfolioInvoice.Status.Enum[message.status] : message.status;
        if (message.fee_count != null && message.hasOwnProperty("fee_count"))
            object.fee_count = message.fee_count;
        if (message.aud_net_fee_rate != null && message.hasOwnProperty("aud_net_fee_rate"))
            object.aud_net_fee_rate = message.aud_net_fee_rate;
        if (message.aud_gross_fee_rate != null && message.hasOwnProperty("aud_gross_fee_rate"))
            object.aud_gross_fee_rate = message.aud_gross_fee_rate;
        if (message.aud_fee_gst != null && message.hasOwnProperty("aud_fee_gst"))
            object.aud_fee_gst = message.aud_fee_gst;
        if (message.aud_total != null && message.hasOwnProperty("aud_total"))
            object.aud_total = message.aud_total;
        if (message.aud_subtotal != null && message.hasOwnProperty("aud_subtotal"))
            object.aud_subtotal = message.aud_subtotal;
        if (message.aud_total_gst != null && message.hasOwnProperty("aud_total_gst"))
            object.aud_total_gst = message.aud_total_gst;
        if (message.aud_ritc_credit != null && message.hasOwnProperty("aud_ritc_credit"))
            object.aud_ritc_credit = message.aud_ritc_credit;
        if (message.aud_amount_due != null && message.hasOwnProperty("aud_amount_due"))
            object.aud_amount_due = message.aud_amount_due;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this AccountFeePortfolioInvoice to JSON.
     * @function toJSON
     * @memberof AccountFeePortfolioInvoice
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountFeePortfolioInvoice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    AccountFeePortfolioInvoice.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof AccountFeePortfolioInvoice
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof AccountFeePortfolioInvoice
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {AccountFeePortfolioInvoice.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof AccountFeePortfolioInvoice.Status
         * @static
         * @param {AccountFeePortfolioInvoice.IStatus=} [properties] Properties to set
         * @returns {AccountFeePortfolioInvoice.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link AccountFeePortfolioInvoice.Status.verify|verify} messages.
         * @function encode
         * @memberof AccountFeePortfolioInvoice.Status
         * @static
         * @param {AccountFeePortfolioInvoice.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link AccountFeePortfolioInvoice.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof AccountFeePortfolioInvoice.Status
         * @static
         * @param {AccountFeePortfolioInvoice.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof AccountFeePortfolioInvoice.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {AccountFeePortfolioInvoice.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountFeePortfolioInvoice.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof AccountFeePortfolioInvoice.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {AccountFeePortfolioInvoice.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof AccountFeePortfolioInvoice.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof AccountFeePortfolioInvoice.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {AccountFeePortfolioInvoice.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.AccountFeePortfolioInvoice.Status)
                return object;
            return new $root.AccountFeePortfolioInvoice.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof AccountFeePortfolioInvoice.Status
         * @static
         * @param {AccountFeePortfolioInvoice.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof AccountFeePortfolioInvoice.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name AccountFeePortfolioInvoice.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} STAGED=1 STAGED value
         * @property {number} FINALISED=2 FINALISED value
         * @property {number} PAYMENT_ACTIONED=3 PAYMENT_ACTIONED value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "STAGED"] = 1;
            values[valuesById[2] = "FINALISED"] = 2;
            values[valuesById[3] = "PAYMENT_ACTIONED"] = 3;
            return values;
        })();

        return Status;
    })();

    return AccountFeePortfolioInvoice;
})();

export const core = $root.core = (() => {

    /**
     * Namespace core.
     * @exports core
     * @namespace
     */
    const core = {};

    core.money = (function() {

        /**
         * Namespace money.
         * @memberof core
         * @namespace
         */
        const money = {};

        money.CoreMoney = (function() {

            /**
             * Constructs a new CoreMoney service.
             * @memberof core.money
             * @classdesc Represents a CoreMoney
             * @extends $protobuf.rpc.Service
             * @constructor
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             */
            function CoreMoney(rpcImpl, requestDelimited, responseDelimited) {
                $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
            }

            (CoreMoney.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CoreMoney;

            /**
             * Creates new CoreMoney service using the specified rpc implementation.
             * @function create
             * @memberof core.money.CoreMoney
             * @static
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             * @returns {CoreMoney} RPC service. Useful where requests and/or responses are streamed.
             */
            CoreMoney.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                return new this(rpcImpl, requestDelimited, responseDelimited);
            };

            /**
             * Callback as used by {@link core.money.CoreMoney#createDeposit}.
             * @memberof core.money.CoreMoney
             * @typedef CreateDepositCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls CreateDeposit.
             * @function createDeposit
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.ICreateDepositRequest} request CreateDepositRequest message or plain object
             * @param {core.money.CoreMoney.CreateDepositCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.createDeposit = function createDeposit(request, callback) {
                return this.rpcCall(createDeposit, $root.core.money.CreateDepositRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "CreateDeposit" });

            /**
             * Calls CreateDeposit.
             * @function createDeposit
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.ICreateDepositRequest} request CreateDepositRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#createWithdrawal}.
             * @memberof core.money.CoreMoney
             * @typedef CreateWithdrawalCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls CreateWithdrawal.
             * @function createWithdrawal
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.ICreateWithdrawalRequest} request CreateWithdrawalRequest message or plain object
             * @param {core.money.CoreMoney.CreateWithdrawalCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.createWithdrawal = function createWithdrawal(request, callback) {
                return this.rpcCall(createWithdrawal, $root.core.money.CreateWithdrawalRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "CreateWithdrawal" });

            /**
             * Calls CreateWithdrawal.
             * @function createWithdrawal
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.ICreateWithdrawalRequest} request CreateWithdrawalRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#cancelTransaction}.
             * @memberof core.money.CoreMoney
             * @typedef CancelTransactionCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls CancelTransaction.
             * @function cancelTransaction
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.ICancelTransactionRequest} request CancelTransactionRequest message or plain object
             * @param {core.money.CoreMoney.CancelTransactionCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.cancelTransaction = function cancelTransaction(request, callback) {
                return this.rpcCall(cancelTransaction, $root.core.money.CancelTransactionRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "CancelTransaction" });

            /**
             * Calls CancelTransaction.
             * @function cancelTransaction
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.ICancelTransactionRequest} request CancelTransactionRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getLatestBalancesByAccountID}.
             * @memberof core.money.CoreMoney
             * @typedef GetLatestBalancesByAccountIDCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetLatestBalancesByAccountIDResponse} [response] GetLatestBalancesByAccountIDResponse
             */

            /**
             * Calls GetLatestBalancesByAccountID.
             * @function getLatestBalancesByAccountID
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetLatestBalancesByAccountIDRequest} request GetLatestBalancesByAccountIDRequest message or plain object
             * @param {core.money.CoreMoney.GetLatestBalancesByAccountIDCallback} callback Node-style callback called with the error, if any, and GetLatestBalancesByAccountIDResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getLatestBalancesByAccountID = function getLatestBalancesByAccountID(request, callback) {
                return this.rpcCall(getLatestBalancesByAccountID, $root.core.money.GetLatestBalancesByAccountIDRequest, $root.core.money.GetLatestBalancesByAccountIDResponse, request, callback);
            }, "name", { value: "GetLatestBalancesByAccountID" });

            /**
             * Calls GetLatestBalancesByAccountID.
             * @function getLatestBalancesByAccountID
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetLatestBalancesByAccountIDRequest} request GetLatestBalancesByAccountIDRequest message or plain object
             * @returns {Promise<core.money.GetLatestBalancesByAccountIDResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getTransactionsByAccountID}.
             * @memberof core.money.CoreMoney
             * @typedef GetTransactionsByAccountIDCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetTransactionsByAccountIDResponse} [response] GetTransactionsByAccountIDResponse
             */

            /**
             * Calls GetTransactionsByAccountID.
             * @function getTransactionsByAccountID
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionsByAccountIDRequest} request GetTransactionsByAccountIDRequest message or plain object
             * @param {core.money.CoreMoney.GetTransactionsByAccountIDCallback} callback Node-style callback called with the error, if any, and GetTransactionsByAccountIDResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getTransactionsByAccountID = function getTransactionsByAccountID(request, callback) {
                return this.rpcCall(getTransactionsByAccountID, $root.core.money.GetTransactionsByAccountIDRequest, $root.core.money.GetTransactionsByAccountIDResponse, request, callback);
            }, "name", { value: "GetTransactionsByAccountID" });

            /**
             * Calls GetTransactionsByAccountID.
             * @function getTransactionsByAccountID
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionsByAccountIDRequest} request GetTransactionsByAccountIDRequest message or plain object
             * @returns {Promise<core.money.GetTransactionsByAccountIDResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getTransactionsByAccountIDPaginated}.
             * @memberof core.money.CoreMoney
             * @typedef GetTransactionsByAccountIDPaginatedCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetTransactionsByAccountIDResponse} [response] GetTransactionsByAccountIDResponse
             */

            /**
             * Calls GetTransactionsByAccountIDPaginated.
             * @function getTransactionsByAccountIDPaginated
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionsByAccountIDRequest} request GetTransactionsByAccountIDRequest message or plain object
             * @param {core.money.CoreMoney.GetTransactionsByAccountIDPaginatedCallback} callback Node-style callback called with the error, if any, and GetTransactionsByAccountIDResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getTransactionsByAccountIDPaginated = function getTransactionsByAccountIDPaginated(request, callback) {
                return this.rpcCall(getTransactionsByAccountIDPaginated, $root.core.money.GetTransactionsByAccountIDRequest, $root.core.money.GetTransactionsByAccountIDResponse, request, callback);
            }, "name", { value: "GetTransactionsByAccountIDPaginated" });

            /**
             * Calls GetTransactionsByAccountIDPaginated.
             * @function getTransactionsByAccountIDPaginated
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionsByAccountIDRequest} request GetTransactionsByAccountIDRequest message or plain object
             * @returns {Promise<core.money.GetTransactionsByAccountIDResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getTransactionByTransactionReference}.
             * @memberof core.money.CoreMoney
             * @typedef GetTransactionByTransactionReferenceCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetTransactionByTransactionReferenceResponse} [response] GetTransactionByTransactionReferenceResponse
             */

            /**
             * Calls GetTransactionByTransactionReference.
             * @function getTransactionByTransactionReference
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionByTransactionReferenceRequest} request GetTransactionByTransactionReferenceRequest message or plain object
             * @param {core.money.CoreMoney.GetTransactionByTransactionReferenceCallback} callback Node-style callback called with the error, if any, and GetTransactionByTransactionReferenceResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getTransactionByTransactionReference = function getTransactionByTransactionReference(request, callback) {
                return this.rpcCall(getTransactionByTransactionReference, $root.core.money.GetTransactionByTransactionReferenceRequest, $root.core.money.GetTransactionByTransactionReferenceResponse, request, callback);
            }, "name", { value: "GetTransactionByTransactionReference" });

            /**
             * Calls GetTransactionByTransactionReference.
             * @function getTransactionByTransactionReference
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionByTransactionReferenceRequest} request GetTransactionByTransactionReferenceRequest message or plain object
             * @returns {Promise<core.money.GetTransactionByTransactionReferenceResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getTransactionsByTransactionReferences}.
             * @memberof core.money.CoreMoney
             * @typedef GetTransactionsByTransactionReferencesCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetTransactionsByTransactionReferencesResponse} [response] GetTransactionsByTransactionReferencesResponse
             */

            /**
             * Calls GetTransactionsByTransactionReferences.
             * @function getTransactionsByTransactionReferences
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionsByTransactionReferencesRequest} request GetTransactionsByTransactionReferencesRequest message or plain object
             * @param {core.money.CoreMoney.GetTransactionsByTransactionReferencesCallback} callback Node-style callback called with the error, if any, and GetTransactionsByTransactionReferencesResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getTransactionsByTransactionReferences = function getTransactionsByTransactionReferences(request, callback) {
                return this.rpcCall(getTransactionsByTransactionReferences, $root.core.money.GetTransactionsByTransactionReferencesRequest, $root.core.money.GetTransactionsByTransactionReferencesResponse, request, callback);
            }, "name", { value: "GetTransactionsByTransactionReferences" });

            /**
             * Calls GetTransactionsByTransactionReferences.
             * @function getTransactionsByTransactionReferences
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionsByTransactionReferencesRequest} request GetTransactionsByTransactionReferencesRequest message or plain object
             * @returns {Promise<core.money.GetTransactionsByTransactionReferencesResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getTransactionLimits}.
             * @memberof core.money.CoreMoney
             * @typedef GetTransactionLimitsCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetTransactionLimitsResponse} [response] GetTransactionLimitsResponse
             */

            /**
             * Calls GetTransactionLimits.
             * @function getTransactionLimits
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionLimitsRequest} request GetTransactionLimitsRequest message or plain object
             * @param {core.money.CoreMoney.GetTransactionLimitsCallback} callback Node-style callback called with the error, if any, and GetTransactionLimitsResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getTransactionLimits = function getTransactionLimits(request, callback) {
                return this.rpcCall(getTransactionLimits, $root.core.money.GetTransactionLimitsRequest, $root.core.money.GetTransactionLimitsResponse, request, callback);
            }, "name", { value: "GetTransactionLimits" });

            /**
             * Calls GetTransactionLimits.
             * @function getTransactionLimits
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetTransactionLimitsRequest} request GetTransactionLimitsRequest message or plain object
             * @returns {Promise<core.money.GetTransactionLimitsResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getPaymentMethod}.
             * @memberof core.money.CoreMoney
             * @typedef GetPaymentMethodCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetPaymentMethodResponse} [response] GetPaymentMethodResponse
             */

            /**
             * Calls GetPaymentMethod.
             * @function getPaymentMethod
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetPaymentMethodRequest} request GetPaymentMethodRequest message or plain object
             * @param {core.money.CoreMoney.GetPaymentMethodCallback} callback Node-style callback called with the error, if any, and GetPaymentMethodResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getPaymentMethod = function getPaymentMethod(request, callback) {
                return this.rpcCall(getPaymentMethod, $root.core.money.GetPaymentMethodRequest, $root.core.money.GetPaymentMethodResponse, request, callback);
            }, "name", { value: "GetPaymentMethod" });

            /**
             * Calls GetPaymentMethod.
             * @function getPaymentMethod
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetPaymentMethodRequest} request GetPaymentMethodRequest message or plain object
             * @returns {Promise<core.money.GetPaymentMethodResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getReconciliationDataByAccountID}.
             * @memberof core.money.CoreMoney
             * @typedef GetReconciliationDataByAccountIDCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetReconciliationDataByAccountIDResponse} [response] GetReconciliationDataByAccountIDResponse
             */

            /**
             * Calls GetReconciliationDataByAccountID.
             * @function getReconciliationDataByAccountID
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetReconciliationDataByAccountIDRequest} request GetReconciliationDataByAccountIDRequest message or plain object
             * @param {core.money.CoreMoney.GetReconciliationDataByAccountIDCallback} callback Node-style callback called with the error, if any, and GetReconciliationDataByAccountIDResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getReconciliationDataByAccountID = function getReconciliationDataByAccountID(request, callback) {
                return this.rpcCall(getReconciliationDataByAccountID, $root.core.money.GetReconciliationDataByAccountIDRequest, $root.core.money.GetReconciliationDataByAccountIDResponse, request, callback);
            }, "name", { value: "GetReconciliationDataByAccountID" });

            /**
             * Calls GetReconciliationDataByAccountID.
             * @function getReconciliationDataByAccountID
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetReconciliationDataByAccountIDRequest} request GetReconciliationDataByAccountIDRequest message or plain object
             * @returns {Promise<core.money.GetReconciliationDataByAccountIDResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getReconciliationData}.
             * @memberof core.money.CoreMoney
             * @typedef GetReconciliationDataCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetReconciliationDataResponse} [response] GetReconciliationDataResponse
             */

            /**
             * Calls GetReconciliationData.
             * @function getReconciliationData
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetReconciliationDataRequest} request GetReconciliationDataRequest message or plain object
             * @param {core.money.CoreMoney.GetReconciliationDataCallback} callback Node-style callback called with the error, if any, and GetReconciliationDataResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getReconciliationData = function getReconciliationData(request, callback) {
                return this.rpcCall(getReconciliationData, $root.core.money.GetReconciliationDataRequest, $root.core.money.GetReconciliationDataResponse, request, callback);
            }, "name", { value: "GetReconciliationData" });

            /**
             * Calls GetReconciliationData.
             * @function getReconciliationData
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetReconciliationDataRequest} request GetReconciliationDataRequest message or plain object
             * @returns {Promise<core.money.GetReconciliationDataResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#addReconciliationComment}.
             * @memberof core.money.CoreMoney
             * @typedef AddReconciliationCommentCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls AddReconciliationComment.
             * @function addReconciliationComment
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IAddReconciliationCommentRequest} request AddReconciliationCommentRequest message or plain object
             * @param {core.money.CoreMoney.AddReconciliationCommentCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.addReconciliationComment = function addReconciliationComment(request, callback) {
                return this.rpcCall(addReconciliationComment, $root.core.money.AddReconciliationCommentRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "AddReconciliationComment" });

            /**
             * Calls AddReconciliationComment.
             * @function addReconciliationComment
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IAddReconciliationCommentRequest} request AddReconciliationCommentRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#createMoneyInstance}.
             * @memberof core.money.CoreMoney
             * @typedef CreateMoneyInstanceCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls CreateMoneyInstance.
             * @function createMoneyInstance
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.ICreateMoneyInstanceRequest} request CreateMoneyInstanceRequest message or plain object
             * @param {core.money.CoreMoney.CreateMoneyInstanceCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.createMoneyInstance = function createMoneyInstance(request, callback) {
                return this.rpcCall(createMoneyInstance, $root.core.money.CreateMoneyInstanceRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "CreateMoneyInstance" });

            /**
             * Calls CreateMoneyInstance.
             * @function createMoneyInstance
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.ICreateMoneyInstanceRequest} request CreateMoneyInstanceRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#updateMoneyInstance}.
             * @memberof core.money.CoreMoney
             * @typedef UpdateMoneyInstanceCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls UpdateMoneyInstance.
             * @function updateMoneyInstance
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IUpdateMoneyInstanceRequest} request UpdateMoneyInstanceRequest message or plain object
             * @param {core.money.CoreMoney.UpdateMoneyInstanceCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.updateMoneyInstance = function updateMoneyInstance(request, callback) {
                return this.rpcCall(updateMoneyInstance, $root.core.money.UpdateMoneyInstanceRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "UpdateMoneyInstance" });

            /**
             * Calls UpdateMoneyInstance.
             * @function updateMoneyInstance
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IUpdateMoneyInstanceRequest} request UpdateMoneyInstanceRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link core.money.CoreMoney#getMoneyInstancesByAccountIDs}.
             * @memberof core.money.CoreMoney
             * @typedef GetMoneyInstancesByAccountIDsCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {core.money.GetMoneyInstancesByAccountIDsResponse} [response] GetMoneyInstancesByAccountIDsResponse
             */

            /**
             * Calls GetMoneyInstancesByAccountIDs.
             * @function getMoneyInstancesByAccountIDs
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetMoneyInstancesByAccountIDsRequest} request GetMoneyInstancesByAccountIDsRequest message or plain object
             * @param {core.money.CoreMoney.GetMoneyInstancesByAccountIDsCallback} callback Node-style callback called with the error, if any, and GetMoneyInstancesByAccountIDsResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(CoreMoney.prototype.getMoneyInstancesByAccountIDs = function getMoneyInstancesByAccountIDs(request, callback) {
                return this.rpcCall(getMoneyInstancesByAccountIDs, $root.core.money.GetMoneyInstancesByAccountIDsRequest, $root.core.money.GetMoneyInstancesByAccountIDsResponse, request, callback);
            }, "name", { value: "GetMoneyInstancesByAccountIDs" });

            /**
             * Calls GetMoneyInstancesByAccountIDs.
             * @function getMoneyInstancesByAccountIDs
             * @memberof core.money.CoreMoney
             * @instance
             * @param {core.money.IGetMoneyInstancesByAccountIDsRequest} request GetMoneyInstancesByAccountIDsRequest message or plain object
             * @returns {Promise<core.money.GetMoneyInstancesByAccountIDsResponse>} Promise
             * @variation 2
             */

            return CoreMoney;
        })();

        money.TransactionType = (function() {

            /**
             * Properties of a TransactionType.
             * @memberof core.money
             * @interface ITransactionType
             */

            /**
             * Constructs a new TransactionType.
             * @memberof core.money
             * @classdesc Represents a TransactionType.
             * @implements ITransactionType
             * @constructor
             * @param {core.money.ITransactionType=} [properties] Properties to set
             */
            function TransactionType(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new TransactionType instance using the specified properties.
             * @function create
             * @memberof core.money.TransactionType
             * @static
             * @param {core.money.ITransactionType=} [properties] Properties to set
             * @returns {core.money.TransactionType} TransactionType instance
             */
            TransactionType.create = function create(properties) {
                return new TransactionType(properties);
            };

            /**
             * Encodes the specified TransactionType message. Does not implicitly {@link core.money.TransactionType.verify|verify} messages.
             * @function encode
             * @memberof core.money.TransactionType
             * @static
             * @param {core.money.ITransactionType} message TransactionType message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified TransactionType message, length delimited. Does not implicitly {@link core.money.TransactionType.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.TransactionType
             * @static
             * @param {core.money.ITransactionType} message TransactionType message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TransactionType message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.TransactionType
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.TransactionType} TransactionType
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.TransactionType();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TransactionType message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.TransactionType
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.TransactionType} TransactionType
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TransactionType message.
             * @function verify
             * @memberof core.money.TransactionType
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TransactionType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a TransactionType message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.TransactionType
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.TransactionType} TransactionType
             */
            TransactionType.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.TransactionType)
                    return object;
                return new $root.core.money.TransactionType();
            };

            /**
             * Creates a plain object from a TransactionType message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.TransactionType
             * @static
             * @param {core.money.TransactionType} message TransactionType
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TransactionType.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this TransactionType to JSON.
             * @function toJSON
             * @memberof core.money.TransactionType
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TransactionType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name core.money.TransactionType.Enum
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} USER_DEPOSIT=1 USER_DEPOSIT value
             * @property {number} VOYAGER_SALE=2 VOYAGER_SALE value
             * @property {number} NOVA_SALE=3 NOVA_SALE value
             * @property {number} NOVA_DIVIDEND=4 NOVA_DIVIDEND value
             * @property {number} VOYAGER_DISTRIBUTION=5 VOYAGER_DISTRIBUTION value
             * @property {number} USER_WITHDRAWAL=6 USER_WITHDRAWAL value
             * @property {number} VOYAGER_PURCHASE=7 VOYAGER_PURCHASE value
             * @property {number} NOVA_PURCHASE=8 NOVA_PURCHASE value
             * @property {number} VOYAGER_MONTHLY_FEE=9 VOYAGER_MONTHLY_FEE value
             * @property {number} OTHER=10 OTHER value
             * @property {number} NOVA_REG_FEE=11 NOVA_REG_FEE value
             * @property {number} NOVA_MONTHLY_FEE=12 NOVA_MONTHLY_FEE value
             * @property {number} NOVA_MERGER_ACQUISITIONS=13 NOVA_MERGER_ACQUISITIONS value
             * @property {number} VOYAGER_BOOST=14 VOYAGER_BOOST value
             * @property {number} NOVA_TAF_FEE=15 NOVA_TAF_FEE value
             * @property {number} USER_DEPOSIT_REVERSAL=16 USER_DEPOSIT_REVERSAL value
             * @property {number} USER_WITHDRAWAL_REVERSAL=17 USER_WITHDRAWAL_REVERSAL value
             */
            TransactionType.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "USER_DEPOSIT"] = 1;
                values[valuesById[2] = "VOYAGER_SALE"] = 2;
                values[valuesById[3] = "NOVA_SALE"] = 3;
                values[valuesById[4] = "NOVA_DIVIDEND"] = 4;
                values[valuesById[5] = "VOYAGER_DISTRIBUTION"] = 5;
                values[valuesById[6] = "USER_WITHDRAWAL"] = 6;
                values[valuesById[7] = "VOYAGER_PURCHASE"] = 7;
                values[valuesById[8] = "NOVA_PURCHASE"] = 8;
                values[valuesById[9] = "VOYAGER_MONTHLY_FEE"] = 9;
                values[valuesById[10] = "OTHER"] = 10;
                values[valuesById[11] = "NOVA_REG_FEE"] = 11;
                values[valuesById[12] = "NOVA_MONTHLY_FEE"] = 12;
                values[valuesById[13] = "NOVA_MERGER_ACQUISITIONS"] = 13;
                values[valuesById[14] = "VOYAGER_BOOST"] = 14;
                values[valuesById[15] = "NOVA_TAF_FEE"] = 15;
                values[valuesById[16] = "USER_DEPOSIT_REVERSAL"] = 16;
                values[valuesById[17] = "USER_WITHDRAWAL_REVERSAL"] = 17;
                return values;
            })();

            return TransactionType;
        })();

        money.CreateDepositRequest = (function() {

            /**
             * Properties of a CreateDepositRequest.
             * @memberof core.money
             * @interface ICreateDepositRequest
             * @property {string|null} [transaction_reference] CreateDepositRequest transaction_reference
             * @property {string|null} [account_id] CreateDepositRequest account_id
             * @property {string|null} [aud_amount] CreateDepositRequest aud_amount
             * @property {core.money.TransactionType.Enum|null} [transaction_type] CreateDepositRequest transaction_type
             * @property {core.money.PaymentMethod.Enum|null} [payment_method] CreateDepositRequest payment_method
             */

            /**
             * Constructs a new CreateDepositRequest.
             * @memberof core.money
             * @classdesc Represents a CreateDepositRequest.
             * @implements ICreateDepositRequest
             * @constructor
             * @param {core.money.ICreateDepositRequest=} [properties] Properties to set
             */
            function CreateDepositRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateDepositRequest transaction_reference.
             * @member {string} transaction_reference
             * @memberof core.money.CreateDepositRequest
             * @instance
             */
            CreateDepositRequest.prototype.transaction_reference = "";

            /**
             * CreateDepositRequest account_id.
             * @member {string} account_id
             * @memberof core.money.CreateDepositRequest
             * @instance
             */
            CreateDepositRequest.prototype.account_id = "";

            /**
             * CreateDepositRequest aud_amount.
             * @member {string} aud_amount
             * @memberof core.money.CreateDepositRequest
             * @instance
             */
            CreateDepositRequest.prototype.aud_amount = "";

            /**
             * CreateDepositRequest transaction_type.
             * @member {core.money.TransactionType.Enum} transaction_type
             * @memberof core.money.CreateDepositRequest
             * @instance
             */
            CreateDepositRequest.prototype.transaction_type = 0;

            /**
             * CreateDepositRequest payment_method.
             * @member {core.money.PaymentMethod.Enum} payment_method
             * @memberof core.money.CreateDepositRequest
             * @instance
             */
            CreateDepositRequest.prototype.payment_method = 0;

            /**
             * Creates a new CreateDepositRequest instance using the specified properties.
             * @function create
             * @memberof core.money.CreateDepositRequest
             * @static
             * @param {core.money.ICreateDepositRequest=} [properties] Properties to set
             * @returns {core.money.CreateDepositRequest} CreateDepositRequest instance
             */
            CreateDepositRequest.create = function create(properties) {
                return new CreateDepositRequest(properties);
            };

            /**
             * Encodes the specified CreateDepositRequest message. Does not implicitly {@link core.money.CreateDepositRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.CreateDepositRequest
             * @static
             * @param {core.money.ICreateDepositRequest} message CreateDepositRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateDepositRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_id);
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.aud_amount);
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.transaction_type);
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.payment_method);
                return writer;
            };

            /**
             * Encodes the specified CreateDepositRequest message, length delimited. Does not implicitly {@link core.money.CreateDepositRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.CreateDepositRequest
             * @static
             * @param {core.money.ICreateDepositRequest} message CreateDepositRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateDepositRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateDepositRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.CreateDepositRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.CreateDepositRequest} CreateDepositRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateDepositRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.CreateDepositRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction_reference = reader.string();
                        break;
                    case 2:
                        message.account_id = reader.string();
                        break;
                    case 3:
                        message.aud_amount = reader.string();
                        break;
                    case 4:
                        message.transaction_type = reader.int32();
                        break;
                    case 5:
                        message.payment_method = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateDepositRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.CreateDepositRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.CreateDepositRequest} CreateDepositRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateDepositRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateDepositRequest message.
             * @function verify
             * @memberof core.money.CreateDepositRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateDepositRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    if (!$util.isString(message.transaction_reference))
                        return "transaction_reference: string expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    if (!$util.isString(message.aud_amount))
                        return "aud_amount: string expected";
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    switch (message.transaction_type) {
                    default:
                        return "transaction_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                        break;
                    }
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    switch (message.payment_method) {
                    default:
                        return "payment_method: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a CreateDepositRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.CreateDepositRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.CreateDepositRequest} CreateDepositRequest
             */
            CreateDepositRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.CreateDepositRequest)
                    return object;
                let message = new $root.core.money.CreateDepositRequest();
                if (object.transaction_reference != null)
                    message.transaction_reference = String(object.transaction_reference);
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                if (object.aud_amount != null)
                    message.aud_amount = String(object.aud_amount);
                switch (object.transaction_type) {
                case "UNKNOWN":
                case 0:
                    message.transaction_type = 0;
                    break;
                case "USER_DEPOSIT":
                case 1:
                    message.transaction_type = 1;
                    break;
                case "VOYAGER_SALE":
                case 2:
                    message.transaction_type = 2;
                    break;
                case "NOVA_SALE":
                case 3:
                    message.transaction_type = 3;
                    break;
                case "NOVA_DIVIDEND":
                case 4:
                    message.transaction_type = 4;
                    break;
                case "VOYAGER_DISTRIBUTION":
                case 5:
                    message.transaction_type = 5;
                    break;
                case "USER_WITHDRAWAL":
                case 6:
                    message.transaction_type = 6;
                    break;
                case "VOYAGER_PURCHASE":
                case 7:
                    message.transaction_type = 7;
                    break;
                case "NOVA_PURCHASE":
                case 8:
                    message.transaction_type = 8;
                    break;
                case "VOYAGER_MONTHLY_FEE":
                case 9:
                    message.transaction_type = 9;
                    break;
                case "OTHER":
                case 10:
                    message.transaction_type = 10;
                    break;
                case "NOVA_REG_FEE":
                case 11:
                    message.transaction_type = 11;
                    break;
                case "NOVA_MONTHLY_FEE":
                case 12:
                    message.transaction_type = 12;
                    break;
                case "NOVA_MERGER_ACQUISITIONS":
                case 13:
                    message.transaction_type = 13;
                    break;
                case "VOYAGER_BOOST":
                case 14:
                    message.transaction_type = 14;
                    break;
                case "NOVA_TAF_FEE":
                case 15:
                    message.transaction_type = 15;
                    break;
                case "USER_DEPOSIT_REVERSAL":
                case 16:
                    message.transaction_type = 16;
                    break;
                case "USER_WITHDRAWAL_REVERSAL":
                case 17:
                    message.transaction_type = 17;
                    break;
                }
                switch (object.payment_method) {
                case "UNKNOWN":
                case 0:
                    message.payment_method = 0;
                    break;
                case "MONEY":
                case 1:
                    message.payment_method = 1;
                    break;
                case "DIRECT_ENTRY":
                case 2:
                    message.payment_method = 2;
                    break;
                case "PAYTO":
                case 3:
                    message.payment_method = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a CreateDepositRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.CreateDepositRequest
             * @static
             * @param {core.money.CreateDepositRequest} message CreateDepositRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateDepositRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.transaction_reference = "";
                    object.account_id = "";
                    object.aud_amount = "";
                    object.transaction_type = options.enums === String ? "UNKNOWN" : 0;
                    object.payment_method = options.enums === String ? "UNKNOWN" : 0;
                }
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    object.transaction_reference = message.transaction_reference;
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    object.aud_amount = message.aud_amount;
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    object.transaction_type = options.enums === String ? $root.core.money.TransactionType.Enum[message.transaction_type] : message.transaction_type;
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    object.payment_method = options.enums === String ? $root.core.money.PaymentMethod.Enum[message.payment_method] : message.payment_method;
                return object;
            };

            /**
             * Converts this CreateDepositRequest to JSON.
             * @function toJSON
             * @memberof core.money.CreateDepositRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateDepositRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateDepositRequest;
        })();

        money.CreateWithdrawalRequest = (function() {

            /**
             * Properties of a CreateWithdrawalRequest.
             * @memberof core.money
             * @interface ICreateWithdrawalRequest
             * @property {string|null} [transaction_reference] CreateWithdrawalRequest transaction_reference
             * @property {string|null} [account_id] CreateWithdrawalRequest account_id
             * @property {string|null} [aud_amount] CreateWithdrawalRequest aud_amount
             * @property {core.money.TransactionType.Enum|null} [transaction_type] CreateWithdrawalRequest transaction_type
             * @property {core.money.PaymentMethod.Enum|null} [payment_method] CreateWithdrawalRequest payment_method
             */

            /**
             * Constructs a new CreateWithdrawalRequest.
             * @memberof core.money
             * @classdesc Represents a CreateWithdrawalRequest.
             * @implements ICreateWithdrawalRequest
             * @constructor
             * @param {core.money.ICreateWithdrawalRequest=} [properties] Properties to set
             */
            function CreateWithdrawalRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateWithdrawalRequest transaction_reference.
             * @member {string} transaction_reference
             * @memberof core.money.CreateWithdrawalRequest
             * @instance
             */
            CreateWithdrawalRequest.prototype.transaction_reference = "";

            /**
             * CreateWithdrawalRequest account_id.
             * @member {string} account_id
             * @memberof core.money.CreateWithdrawalRequest
             * @instance
             */
            CreateWithdrawalRequest.prototype.account_id = "";

            /**
             * CreateWithdrawalRequest aud_amount.
             * @member {string} aud_amount
             * @memberof core.money.CreateWithdrawalRequest
             * @instance
             */
            CreateWithdrawalRequest.prototype.aud_amount = "";

            /**
             * CreateWithdrawalRequest transaction_type.
             * @member {core.money.TransactionType.Enum} transaction_type
             * @memberof core.money.CreateWithdrawalRequest
             * @instance
             */
            CreateWithdrawalRequest.prototype.transaction_type = 0;

            /**
             * CreateWithdrawalRequest payment_method.
             * @member {core.money.PaymentMethod.Enum} payment_method
             * @memberof core.money.CreateWithdrawalRequest
             * @instance
             */
            CreateWithdrawalRequest.prototype.payment_method = 0;

            /**
             * Creates a new CreateWithdrawalRequest instance using the specified properties.
             * @function create
             * @memberof core.money.CreateWithdrawalRequest
             * @static
             * @param {core.money.ICreateWithdrawalRequest=} [properties] Properties to set
             * @returns {core.money.CreateWithdrawalRequest} CreateWithdrawalRequest instance
             */
            CreateWithdrawalRequest.create = function create(properties) {
                return new CreateWithdrawalRequest(properties);
            };

            /**
             * Encodes the specified CreateWithdrawalRequest message. Does not implicitly {@link core.money.CreateWithdrawalRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.CreateWithdrawalRequest
             * @static
             * @param {core.money.ICreateWithdrawalRequest} message CreateWithdrawalRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateWithdrawalRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_id);
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.aud_amount);
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.transaction_type);
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.payment_method);
                return writer;
            };

            /**
             * Encodes the specified CreateWithdrawalRequest message, length delimited. Does not implicitly {@link core.money.CreateWithdrawalRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.CreateWithdrawalRequest
             * @static
             * @param {core.money.ICreateWithdrawalRequest} message CreateWithdrawalRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateWithdrawalRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateWithdrawalRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.CreateWithdrawalRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.CreateWithdrawalRequest} CreateWithdrawalRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateWithdrawalRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.CreateWithdrawalRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction_reference = reader.string();
                        break;
                    case 2:
                        message.account_id = reader.string();
                        break;
                    case 3:
                        message.aud_amount = reader.string();
                        break;
                    case 4:
                        message.transaction_type = reader.int32();
                        break;
                    case 5:
                        message.payment_method = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateWithdrawalRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.CreateWithdrawalRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.CreateWithdrawalRequest} CreateWithdrawalRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateWithdrawalRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateWithdrawalRequest message.
             * @function verify
             * @memberof core.money.CreateWithdrawalRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateWithdrawalRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    if (!$util.isString(message.transaction_reference))
                        return "transaction_reference: string expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    if (!$util.isString(message.aud_amount))
                        return "aud_amount: string expected";
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    switch (message.transaction_type) {
                    default:
                        return "transaction_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                        break;
                    }
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    switch (message.payment_method) {
                    default:
                        return "payment_method: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a CreateWithdrawalRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.CreateWithdrawalRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.CreateWithdrawalRequest} CreateWithdrawalRequest
             */
            CreateWithdrawalRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.CreateWithdrawalRequest)
                    return object;
                let message = new $root.core.money.CreateWithdrawalRequest();
                if (object.transaction_reference != null)
                    message.transaction_reference = String(object.transaction_reference);
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                if (object.aud_amount != null)
                    message.aud_amount = String(object.aud_amount);
                switch (object.transaction_type) {
                case "UNKNOWN":
                case 0:
                    message.transaction_type = 0;
                    break;
                case "USER_DEPOSIT":
                case 1:
                    message.transaction_type = 1;
                    break;
                case "VOYAGER_SALE":
                case 2:
                    message.transaction_type = 2;
                    break;
                case "NOVA_SALE":
                case 3:
                    message.transaction_type = 3;
                    break;
                case "NOVA_DIVIDEND":
                case 4:
                    message.transaction_type = 4;
                    break;
                case "VOYAGER_DISTRIBUTION":
                case 5:
                    message.transaction_type = 5;
                    break;
                case "USER_WITHDRAWAL":
                case 6:
                    message.transaction_type = 6;
                    break;
                case "VOYAGER_PURCHASE":
                case 7:
                    message.transaction_type = 7;
                    break;
                case "NOVA_PURCHASE":
                case 8:
                    message.transaction_type = 8;
                    break;
                case "VOYAGER_MONTHLY_FEE":
                case 9:
                    message.transaction_type = 9;
                    break;
                case "OTHER":
                case 10:
                    message.transaction_type = 10;
                    break;
                case "NOVA_REG_FEE":
                case 11:
                    message.transaction_type = 11;
                    break;
                case "NOVA_MONTHLY_FEE":
                case 12:
                    message.transaction_type = 12;
                    break;
                case "NOVA_MERGER_ACQUISITIONS":
                case 13:
                    message.transaction_type = 13;
                    break;
                case "VOYAGER_BOOST":
                case 14:
                    message.transaction_type = 14;
                    break;
                case "NOVA_TAF_FEE":
                case 15:
                    message.transaction_type = 15;
                    break;
                case "USER_DEPOSIT_REVERSAL":
                case 16:
                    message.transaction_type = 16;
                    break;
                case "USER_WITHDRAWAL_REVERSAL":
                case 17:
                    message.transaction_type = 17;
                    break;
                }
                switch (object.payment_method) {
                case "UNKNOWN":
                case 0:
                    message.payment_method = 0;
                    break;
                case "MONEY":
                case 1:
                    message.payment_method = 1;
                    break;
                case "DIRECT_ENTRY":
                case 2:
                    message.payment_method = 2;
                    break;
                case "PAYTO":
                case 3:
                    message.payment_method = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a CreateWithdrawalRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.CreateWithdrawalRequest
             * @static
             * @param {core.money.CreateWithdrawalRequest} message CreateWithdrawalRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateWithdrawalRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.transaction_reference = "";
                    object.account_id = "";
                    object.aud_amount = "";
                    object.transaction_type = options.enums === String ? "UNKNOWN" : 0;
                    object.payment_method = options.enums === String ? "UNKNOWN" : 0;
                }
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    object.transaction_reference = message.transaction_reference;
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    object.aud_amount = message.aud_amount;
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    object.transaction_type = options.enums === String ? $root.core.money.TransactionType.Enum[message.transaction_type] : message.transaction_type;
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    object.payment_method = options.enums === String ? $root.core.money.PaymentMethod.Enum[message.payment_method] : message.payment_method;
                return object;
            };

            /**
             * Converts this CreateWithdrawalRequest to JSON.
             * @function toJSON
             * @memberof core.money.CreateWithdrawalRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateWithdrawalRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateWithdrawalRequest;
        })();

        money.CancelTransactionRequest = (function() {

            /**
             * Properties of a CancelTransactionRequest.
             * @memberof core.money
             * @interface ICancelTransactionRequest
             * @property {string|null} [transaction_reference] CancelTransactionRequest transaction_reference
             */

            /**
             * Constructs a new CancelTransactionRequest.
             * @memberof core.money
             * @classdesc Represents a CancelTransactionRequest.
             * @implements ICancelTransactionRequest
             * @constructor
             * @param {core.money.ICancelTransactionRequest=} [properties] Properties to set
             */
            function CancelTransactionRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CancelTransactionRequest transaction_reference.
             * @member {string} transaction_reference
             * @memberof core.money.CancelTransactionRequest
             * @instance
             */
            CancelTransactionRequest.prototype.transaction_reference = "";

            /**
             * Creates a new CancelTransactionRequest instance using the specified properties.
             * @function create
             * @memberof core.money.CancelTransactionRequest
             * @static
             * @param {core.money.ICancelTransactionRequest=} [properties] Properties to set
             * @returns {core.money.CancelTransactionRequest} CancelTransactionRequest instance
             */
            CancelTransactionRequest.create = function create(properties) {
                return new CancelTransactionRequest(properties);
            };

            /**
             * Encodes the specified CancelTransactionRequest message. Does not implicitly {@link core.money.CancelTransactionRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.CancelTransactionRequest
             * @static
             * @param {core.money.ICancelTransactionRequest} message CancelTransactionRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CancelTransactionRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
                return writer;
            };

            /**
             * Encodes the specified CancelTransactionRequest message, length delimited. Does not implicitly {@link core.money.CancelTransactionRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.CancelTransactionRequest
             * @static
             * @param {core.money.ICancelTransactionRequest} message CancelTransactionRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CancelTransactionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CancelTransactionRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.CancelTransactionRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.CancelTransactionRequest} CancelTransactionRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CancelTransactionRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.CancelTransactionRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction_reference = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CancelTransactionRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.CancelTransactionRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.CancelTransactionRequest} CancelTransactionRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CancelTransactionRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CancelTransactionRequest message.
             * @function verify
             * @memberof core.money.CancelTransactionRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CancelTransactionRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    if (!$util.isString(message.transaction_reference))
                        return "transaction_reference: string expected";
                return null;
            };

            /**
             * Creates a CancelTransactionRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.CancelTransactionRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.CancelTransactionRequest} CancelTransactionRequest
             */
            CancelTransactionRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.CancelTransactionRequest)
                    return object;
                let message = new $root.core.money.CancelTransactionRequest();
                if (object.transaction_reference != null)
                    message.transaction_reference = String(object.transaction_reference);
                return message;
            };

            /**
             * Creates a plain object from a CancelTransactionRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.CancelTransactionRequest
             * @static
             * @param {core.money.CancelTransactionRequest} message CancelTransactionRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CancelTransactionRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.transaction_reference = "";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    object.transaction_reference = message.transaction_reference;
                return object;
            };

            /**
             * Converts this CancelTransactionRequest to JSON.
             * @function toJSON
             * @memberof core.money.CancelTransactionRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CancelTransactionRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CancelTransactionRequest;
        })();

        money.GetLatestBalancesByAccountIDRequest = (function() {

            /**
             * Properties of a GetLatestBalancesByAccountIDRequest.
             * @memberof core.money
             * @interface IGetLatestBalancesByAccountIDRequest
             * @property {string|null} [account_id] GetLatestBalancesByAccountIDRequest account_id
             */

            /**
             * Constructs a new GetLatestBalancesByAccountIDRequest.
             * @memberof core.money
             * @classdesc Represents a GetLatestBalancesByAccountIDRequest.
             * @implements IGetLatestBalancesByAccountIDRequest
             * @constructor
             * @param {core.money.IGetLatestBalancesByAccountIDRequest=} [properties] Properties to set
             */
            function GetLatestBalancesByAccountIDRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetLatestBalancesByAccountIDRequest account_id.
             * @member {string} account_id
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @instance
             */
            GetLatestBalancesByAccountIDRequest.prototype.account_id = "";

            /**
             * Creates a new GetLatestBalancesByAccountIDRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @static
             * @param {core.money.IGetLatestBalancesByAccountIDRequest=} [properties] Properties to set
             * @returns {core.money.GetLatestBalancesByAccountIDRequest} GetLatestBalancesByAccountIDRequest instance
             */
            GetLatestBalancesByAccountIDRequest.create = function create(properties) {
                return new GetLatestBalancesByAccountIDRequest(properties);
            };

            /**
             * Encodes the specified GetLatestBalancesByAccountIDRequest message. Does not implicitly {@link core.money.GetLatestBalancesByAccountIDRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @static
             * @param {core.money.IGetLatestBalancesByAccountIDRequest} message GetLatestBalancesByAccountIDRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLatestBalancesByAccountIDRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.account_id);
                return writer;
            };

            /**
             * Encodes the specified GetLatestBalancesByAccountIDRequest message, length delimited. Does not implicitly {@link core.money.GetLatestBalancesByAccountIDRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @static
             * @param {core.money.IGetLatestBalancesByAccountIDRequest} message GetLatestBalancesByAccountIDRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLatestBalancesByAccountIDRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetLatestBalancesByAccountIDRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetLatestBalancesByAccountIDRequest} GetLatestBalancesByAccountIDRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLatestBalancesByAccountIDRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetLatestBalancesByAccountIDRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.account_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetLatestBalancesByAccountIDRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetLatestBalancesByAccountIDRequest} GetLatestBalancesByAccountIDRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLatestBalancesByAccountIDRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetLatestBalancesByAccountIDRequest message.
             * @function verify
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetLatestBalancesByAccountIDRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                return null;
            };

            /**
             * Creates a GetLatestBalancesByAccountIDRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetLatestBalancesByAccountIDRequest} GetLatestBalancesByAccountIDRequest
             */
            GetLatestBalancesByAccountIDRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetLatestBalancesByAccountIDRequest)
                    return object;
                let message = new $root.core.money.GetLatestBalancesByAccountIDRequest();
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                return message;
            };

            /**
             * Creates a plain object from a GetLatestBalancesByAccountIDRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @static
             * @param {core.money.GetLatestBalancesByAccountIDRequest} message GetLatestBalancesByAccountIDRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetLatestBalancesByAccountIDRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.account_id = "";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                return object;
            };

            /**
             * Converts this GetLatestBalancesByAccountIDRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetLatestBalancesByAccountIDRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetLatestBalancesByAccountIDRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetLatestBalancesByAccountIDRequest;
        })();

        money.GetLatestBalancesByAccountIDResponse = (function() {

            /**
             * Properties of a GetLatestBalancesByAccountIDResponse.
             * @memberof core.money
             * @interface IGetLatestBalancesByAccountIDResponse
             * @property {string|null} [total] GetLatestBalancesByAccountIDResponse total
             * @property {string|null} [available] GetLatestBalancesByAccountIDResponse available
             * @property {string|null} [pending_outflows] GetLatestBalancesByAccountIDResponse pending_outflows
             * @property {string|null} [pending_inflows] GetLatestBalancesByAccountIDResponse pending_inflows
             * @property {string|null} [outstanding] GetLatestBalancesByAccountIDResponse outstanding
             */

            /**
             * Constructs a new GetLatestBalancesByAccountIDResponse.
             * @memberof core.money
             * @classdesc Represents a GetLatestBalancesByAccountIDResponse.
             * @implements IGetLatestBalancesByAccountIDResponse
             * @constructor
             * @param {core.money.IGetLatestBalancesByAccountIDResponse=} [properties] Properties to set
             */
            function GetLatestBalancesByAccountIDResponse(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetLatestBalancesByAccountIDResponse total.
             * @member {string} total
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @instance
             */
            GetLatestBalancesByAccountIDResponse.prototype.total = "";

            /**
             * GetLatestBalancesByAccountIDResponse available.
             * @member {string} available
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @instance
             */
            GetLatestBalancesByAccountIDResponse.prototype.available = "";

            /**
             * GetLatestBalancesByAccountIDResponse pending_outflows.
             * @member {string} pending_outflows
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @instance
             */
            GetLatestBalancesByAccountIDResponse.prototype.pending_outflows = "";

            /**
             * GetLatestBalancesByAccountIDResponse pending_inflows.
             * @member {string} pending_inflows
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @instance
             */
            GetLatestBalancesByAccountIDResponse.prototype.pending_inflows = "";

            /**
             * GetLatestBalancesByAccountIDResponse outstanding.
             * @member {string} outstanding
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @instance
             */
            GetLatestBalancesByAccountIDResponse.prototype.outstanding = "";

            /**
             * Creates a new GetLatestBalancesByAccountIDResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @static
             * @param {core.money.IGetLatestBalancesByAccountIDResponse=} [properties] Properties to set
             * @returns {core.money.GetLatestBalancesByAccountIDResponse} GetLatestBalancesByAccountIDResponse instance
             */
            GetLatestBalancesByAccountIDResponse.create = function create(properties) {
                return new GetLatestBalancesByAccountIDResponse(properties);
            };

            /**
             * Encodes the specified GetLatestBalancesByAccountIDResponse message. Does not implicitly {@link core.money.GetLatestBalancesByAccountIDResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @static
             * @param {core.money.IGetLatestBalancesByAccountIDResponse} message GetLatestBalancesByAccountIDResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLatestBalancesByAccountIDResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.total != null && message.hasOwnProperty("total"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.total);
                if (message.available != null && message.hasOwnProperty("available"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.available);
                if (message.pending_outflows != null && message.hasOwnProperty("pending_outflows"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.pending_outflows);
                if (message.pending_inflows != null && message.hasOwnProperty("pending_inflows"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.pending_inflows);
                if (message.outstanding != null && message.hasOwnProperty("outstanding"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.outstanding);
                return writer;
            };

            /**
             * Encodes the specified GetLatestBalancesByAccountIDResponse message, length delimited. Does not implicitly {@link core.money.GetLatestBalancesByAccountIDResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @static
             * @param {core.money.IGetLatestBalancesByAccountIDResponse} message GetLatestBalancesByAccountIDResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetLatestBalancesByAccountIDResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetLatestBalancesByAccountIDResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetLatestBalancesByAccountIDResponse} GetLatestBalancesByAccountIDResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLatestBalancesByAccountIDResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetLatestBalancesByAccountIDResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.total = reader.string();
                        break;
                    case 2:
                        message.available = reader.string();
                        break;
                    case 3:
                        message.pending_outflows = reader.string();
                        break;
                    case 4:
                        message.pending_inflows = reader.string();
                        break;
                    case 5:
                        message.outstanding = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetLatestBalancesByAccountIDResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetLatestBalancesByAccountIDResponse} GetLatestBalancesByAccountIDResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetLatestBalancesByAccountIDResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetLatestBalancesByAccountIDResponse message.
             * @function verify
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetLatestBalancesByAccountIDResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isString(message.total))
                        return "total: string expected";
                if (message.available != null && message.hasOwnProperty("available"))
                    if (!$util.isString(message.available))
                        return "available: string expected";
                if (message.pending_outflows != null && message.hasOwnProperty("pending_outflows"))
                    if (!$util.isString(message.pending_outflows))
                        return "pending_outflows: string expected";
                if (message.pending_inflows != null && message.hasOwnProperty("pending_inflows"))
                    if (!$util.isString(message.pending_inflows))
                        return "pending_inflows: string expected";
                if (message.outstanding != null && message.hasOwnProperty("outstanding"))
                    if (!$util.isString(message.outstanding))
                        return "outstanding: string expected";
                return null;
            };

            /**
             * Creates a GetLatestBalancesByAccountIDResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetLatestBalancesByAccountIDResponse} GetLatestBalancesByAccountIDResponse
             */
            GetLatestBalancesByAccountIDResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetLatestBalancesByAccountIDResponse)
                    return object;
                let message = new $root.core.money.GetLatestBalancesByAccountIDResponse();
                if (object.total != null)
                    message.total = String(object.total);
                if (object.available != null)
                    message.available = String(object.available);
                if (object.pending_outflows != null)
                    message.pending_outflows = String(object.pending_outflows);
                if (object.pending_inflows != null)
                    message.pending_inflows = String(object.pending_inflows);
                if (object.outstanding != null)
                    message.outstanding = String(object.outstanding);
                return message;
            };

            /**
             * Creates a plain object from a GetLatestBalancesByAccountIDResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @static
             * @param {core.money.GetLatestBalancesByAccountIDResponse} message GetLatestBalancesByAccountIDResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetLatestBalancesByAccountIDResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.total = "";
                    object.available = "";
                    object.pending_outflows = "";
                    object.pending_inflows = "";
                    object.outstanding = "";
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = message.total;
                if (message.available != null && message.hasOwnProperty("available"))
                    object.available = message.available;
                if (message.pending_outflows != null && message.hasOwnProperty("pending_outflows"))
                    object.pending_outflows = message.pending_outflows;
                if (message.pending_inflows != null && message.hasOwnProperty("pending_inflows"))
                    object.pending_inflows = message.pending_inflows;
                if (message.outstanding != null && message.hasOwnProperty("outstanding"))
                    object.outstanding = message.outstanding;
                return object;
            };

            /**
             * Converts this GetLatestBalancesByAccountIDResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetLatestBalancesByAccountIDResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetLatestBalancesByAccountIDResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetLatestBalancesByAccountIDResponse;
        })();

        money.InitialPaymentType = (function() {

            /**
             * Properties of an InitialPaymentType.
             * @memberof core.money
             * @interface IInitialPaymentType
             */

            /**
             * Constructs a new InitialPaymentType.
             * @memberof core.money
             * @classdesc Represents an InitialPaymentType.
             * @implements IInitialPaymentType
             * @constructor
             * @param {core.money.IInitialPaymentType=} [properties] Properties to set
             */
            function InitialPaymentType(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new InitialPaymentType instance using the specified properties.
             * @function create
             * @memberof core.money.InitialPaymentType
             * @static
             * @param {core.money.IInitialPaymentType=} [properties] Properties to set
             * @returns {core.money.InitialPaymentType} InitialPaymentType instance
             */
            InitialPaymentType.create = function create(properties) {
                return new InitialPaymentType(properties);
            };

            /**
             * Encodes the specified InitialPaymentType message. Does not implicitly {@link core.money.InitialPaymentType.verify|verify} messages.
             * @function encode
             * @memberof core.money.InitialPaymentType
             * @static
             * @param {core.money.IInitialPaymentType} message InitialPaymentType message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InitialPaymentType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified InitialPaymentType message, length delimited. Does not implicitly {@link core.money.InitialPaymentType.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.InitialPaymentType
             * @static
             * @param {core.money.IInitialPaymentType} message InitialPaymentType message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InitialPaymentType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an InitialPaymentType message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.InitialPaymentType
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.InitialPaymentType} InitialPaymentType
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InitialPaymentType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.InitialPaymentType();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an InitialPaymentType message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.InitialPaymentType
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.InitialPaymentType} InitialPaymentType
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InitialPaymentType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an InitialPaymentType message.
             * @function verify
             * @memberof core.money.InitialPaymentType
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            InitialPaymentType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an InitialPaymentType message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.InitialPaymentType
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.InitialPaymentType} InitialPaymentType
             */
            InitialPaymentType.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.InitialPaymentType)
                    return object;
                return new $root.core.money.InitialPaymentType();
            };

            /**
             * Creates a plain object from an InitialPaymentType message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.InitialPaymentType
             * @static
             * @param {core.money.InitialPaymentType} message InitialPaymentType
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            InitialPaymentType.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this InitialPaymentType to JSON.
             * @function toJSON
             * @memberof core.money.InitialPaymentType
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            InitialPaymentType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name core.money.InitialPaymentType.Enum
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} NPP=1 NPP value
             * @property {number} DIRECT_ENTRY=2 DIRECT_ENTRY value
             * @property {number} PAYTO=3 PAYTO value
             */
            InitialPaymentType.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "NPP"] = 1;
                values[valuesById[2] = "DIRECT_ENTRY"] = 2;
                values[valuesById[3] = "PAYTO"] = 3;
                return values;
            })();

            return InitialPaymentType;
        })();

        money.PaymentMethod = (function() {

            /**
             * Properties of a PaymentMethod.
             * @memberof core.money
             * @interface IPaymentMethod
             */

            /**
             * Constructs a new PaymentMethod.
             * @memberof core.money
             * @classdesc Represents a PaymentMethod.
             * @implements IPaymentMethod
             * @constructor
             * @param {core.money.IPaymentMethod=} [properties] Properties to set
             */
            function PaymentMethod(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new PaymentMethod instance using the specified properties.
             * @function create
             * @memberof core.money.PaymentMethod
             * @static
             * @param {core.money.IPaymentMethod=} [properties] Properties to set
             * @returns {core.money.PaymentMethod} PaymentMethod instance
             */
            PaymentMethod.create = function create(properties) {
                return new PaymentMethod(properties);
            };

            /**
             * Encodes the specified PaymentMethod message. Does not implicitly {@link core.money.PaymentMethod.verify|verify} messages.
             * @function encode
             * @memberof core.money.PaymentMethod
             * @static
             * @param {core.money.IPaymentMethod} message PaymentMethod message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaymentMethod.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified PaymentMethod message, length delimited. Does not implicitly {@link core.money.PaymentMethod.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.PaymentMethod
             * @static
             * @param {core.money.IPaymentMethod} message PaymentMethod message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PaymentMethod.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PaymentMethod message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.PaymentMethod
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.PaymentMethod} PaymentMethod
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaymentMethod.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.PaymentMethod();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PaymentMethod message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.PaymentMethod
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.PaymentMethod} PaymentMethod
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PaymentMethod.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PaymentMethod message.
             * @function verify
             * @memberof core.money.PaymentMethod
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PaymentMethod.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a PaymentMethod message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.PaymentMethod
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.PaymentMethod} PaymentMethod
             */
            PaymentMethod.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.PaymentMethod)
                    return object;
                return new $root.core.money.PaymentMethod();
            };

            /**
             * Creates a plain object from a PaymentMethod message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.PaymentMethod
             * @static
             * @param {core.money.PaymentMethod} message PaymentMethod
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PaymentMethod.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this PaymentMethod to JSON.
             * @function toJSON
             * @memberof core.money.PaymentMethod
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PaymentMethod.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name core.money.PaymentMethod.Enum
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} MONEY=1 MONEY value
             * @property {number} DIRECT_ENTRY=2 DIRECT_ENTRY value
             * @property {number} PAYTO=3 PAYTO value
             */
            PaymentMethod.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "MONEY"] = 1;
                values[valuesById[2] = "DIRECT_ENTRY"] = 2;
                values[valuesById[3] = "PAYTO"] = 3;
                return values;
            })();

            return PaymentMethod;
        })();

        money.TransactionStatus = (function() {

            /**
             * Properties of a TransactionStatus.
             * @memberof core.money
             * @interface ITransactionStatus
             */

            /**
             * Constructs a new TransactionStatus.
             * @memberof core.money
             * @classdesc Represents a TransactionStatus.
             * @implements ITransactionStatus
             * @constructor
             * @param {core.money.ITransactionStatus=} [properties] Properties to set
             */
            function TransactionStatus(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new TransactionStatus instance using the specified properties.
             * @function create
             * @memberof core.money.TransactionStatus
             * @static
             * @param {core.money.ITransactionStatus=} [properties] Properties to set
             * @returns {core.money.TransactionStatus} TransactionStatus instance
             */
            TransactionStatus.create = function create(properties) {
                return new TransactionStatus(properties);
            };

            /**
             * Encodes the specified TransactionStatus message. Does not implicitly {@link core.money.TransactionStatus.verify|verify} messages.
             * @function encode
             * @memberof core.money.TransactionStatus
             * @static
             * @param {core.money.ITransactionStatus} message TransactionStatus message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionStatus.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified TransactionStatus message, length delimited. Does not implicitly {@link core.money.TransactionStatus.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.TransactionStatus
             * @static
             * @param {core.money.ITransactionStatus} message TransactionStatus message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionStatus.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TransactionStatus message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.TransactionStatus
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.TransactionStatus} TransactionStatus
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionStatus.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.TransactionStatus();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TransactionStatus message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.TransactionStatus
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.TransactionStatus} TransactionStatus
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionStatus.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TransactionStatus message.
             * @function verify
             * @memberof core.money.TransactionStatus
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TransactionStatus.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a TransactionStatus message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.TransactionStatus
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.TransactionStatus} TransactionStatus
             */
            TransactionStatus.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.TransactionStatus)
                    return object;
                return new $root.core.money.TransactionStatus();
            };

            /**
             * Creates a plain object from a TransactionStatus message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.TransactionStatus
             * @static
             * @param {core.money.TransactionStatus} message TransactionStatus
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TransactionStatus.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this TransactionStatus to JSON.
             * @function toJSON
             * @memberof core.money.TransactionStatus
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TransactionStatus.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name core.money.TransactionStatus.Enum
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} PENDING=1 PENDING value
             * @property {number} IN_REVIEW=2 IN_REVIEW value
             * @property {number} PROCESSING=3 PROCESSING value
             * @property {number} COMPLETED=4 COMPLETED value
             * @property {number} FAILED=5 FAILED value
             * @property {number} CANCELLED=6 CANCELLED value
             * @property {number} REQUIRED_TRANSACTION_CLEARING=7 REQUIRED_TRANSACTION_CLEARING value
             * @property {number} FUNDS_AVAILABLE=8 FUNDS_AVAILABLE value
             * @property {number} READY_TO_PROCESS=9 READY_TO_PROCESS value
             * @property {number} FUNDS_CLEARING=10 FUNDS_CLEARING value
             */
            TransactionStatus.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "PENDING"] = 1;
                values[valuesById[2] = "IN_REVIEW"] = 2;
                values[valuesById[3] = "PROCESSING"] = 3;
                values[valuesById[4] = "COMPLETED"] = 4;
                values[valuesById[5] = "FAILED"] = 5;
                values[valuesById[6] = "CANCELLED"] = 6;
                values[valuesById[7] = "REQUIRED_TRANSACTION_CLEARING"] = 7;
                values[valuesById[8] = "FUNDS_AVAILABLE"] = 8;
                values[valuesById[9] = "READY_TO_PROCESS"] = 9;
                values[valuesById[10] = "FUNDS_CLEARING"] = 10;
                return values;
            })();

            return TransactionStatus;
        })();

        money.Transaction = (function() {

            /**
             * Properties of a Transaction.
             * @memberof core.money
             * @interface ITransaction
             * @property {string|null} [transaction_reference] Transaction transaction_reference
             * @property {string|null} [money_reference] Transaction money_reference
             * @property {string|null} [account_id] Transaction account_id
             * @property {string|null} [aud_amount] Transaction aud_amount
             * @property {core.money.TransactionType.Enum|null} [transaction_type] Transaction transaction_type
             * @property {core.money.InitialPaymentType.Enum|null} [initial_payment_type] Transaction initial_payment_type
             * @property {core.money.TransactionStatus.Enum|null} [status] Transaction status
             * @property {string|null} [reversal_transaction_reference] Transaction reversal_transaction_reference
             * @property {string|null} [required_transaction_reference] Transaction required_transaction_reference
             * @property {google.protobuf.ITimestamp|null} [completed_at] Transaction completed_at
             * @property {google.protobuf.ITimestamp|null} [created_at] Transaction created_at
             * @property {google.protobuf.ITimestamp|null} [last_updated_at] Transaction last_updated_at
             * @property {string|null} [core_user_bank_account_id] Transaction core_user_bank_account_id
             * @property {string|null} [pending_aud_amount] Transaction pending_aud_amount
             */

            /**
             * Constructs a new Transaction.
             * @memberof core.money
             * @classdesc Represents a Transaction.
             * @implements ITransaction
             * @constructor
             * @param {core.money.ITransaction=} [properties] Properties to set
             */
            function Transaction(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Transaction transaction_reference.
             * @member {string} transaction_reference
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.transaction_reference = "";

            /**
             * Transaction money_reference.
             * @member {string} money_reference
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.money_reference = "";

            /**
             * Transaction account_id.
             * @member {string} account_id
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.account_id = "";

            /**
             * Transaction aud_amount.
             * @member {string} aud_amount
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.aud_amount = "";

            /**
             * Transaction transaction_type.
             * @member {core.money.TransactionType.Enum} transaction_type
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.transaction_type = 0;

            /**
             * Transaction initial_payment_type.
             * @member {core.money.InitialPaymentType.Enum} initial_payment_type
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.initial_payment_type = 0;

            /**
             * Transaction status.
             * @member {core.money.TransactionStatus.Enum} status
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.status = 0;

            /**
             * Transaction reversal_transaction_reference.
             * @member {string} reversal_transaction_reference
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.reversal_transaction_reference = "";

            /**
             * Transaction required_transaction_reference.
             * @member {string} required_transaction_reference
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.required_transaction_reference = "";

            /**
             * Transaction completed_at.
             * @member {google.protobuf.ITimestamp|null|undefined} completed_at
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.completed_at = null;

            /**
             * Transaction created_at.
             * @member {google.protobuf.ITimestamp|null|undefined} created_at
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.created_at = null;

            /**
             * Transaction last_updated_at.
             * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.last_updated_at = null;

            /**
             * Transaction core_user_bank_account_id.
             * @member {string} core_user_bank_account_id
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.core_user_bank_account_id = "";

            /**
             * Transaction pending_aud_amount.
             * @member {string} pending_aud_amount
             * @memberof core.money.Transaction
             * @instance
             */
            Transaction.prototype.pending_aud_amount = "";

            /**
             * Creates a new Transaction instance using the specified properties.
             * @function create
             * @memberof core.money.Transaction
             * @static
             * @param {core.money.ITransaction=} [properties] Properties to set
             * @returns {core.money.Transaction} Transaction instance
             */
            Transaction.create = function create(properties) {
                return new Transaction(properties);
            };

            /**
             * Encodes the specified Transaction message. Does not implicitly {@link core.money.Transaction.verify|verify} messages.
             * @function encode
             * @memberof core.money.Transaction
             * @static
             * @param {core.money.ITransaction} message Transaction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Transaction.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
                if (message.money_reference != null && message.hasOwnProperty("money_reference"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.money_reference);
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.account_id);
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.aud_amount);
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.transaction_type);
                if (message.initial_payment_type != null && message.hasOwnProperty("initial_payment_type"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.initial_payment_type);
                if (message.status != null && message.hasOwnProperty("status"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
                if (message.reversal_transaction_reference != null && message.hasOwnProperty("reversal_transaction_reference"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.reversal_transaction_reference);
                if (message.required_transaction_reference != null && message.hasOwnProperty("required_transaction_reference"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.required_transaction_reference);
                if (message.completed_at != null && message.hasOwnProperty("completed_at"))
                    $root.google.protobuf.Timestamp.encode(message.completed_at, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.created_at != null && message.hasOwnProperty("created_at"))
                    $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
                    $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.core_user_bank_account_id != null && message.hasOwnProperty("core_user_bank_account_id"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.core_user_bank_account_id);
                if (message.pending_aud_amount != null && message.hasOwnProperty("pending_aud_amount"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.pending_aud_amount);
                return writer;
            };

            /**
             * Encodes the specified Transaction message, length delimited. Does not implicitly {@link core.money.Transaction.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.Transaction
             * @static
             * @param {core.money.ITransaction} message Transaction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Transaction.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Transaction message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.Transaction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.Transaction} Transaction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Transaction.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.Transaction();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction_reference = reader.string();
                        break;
                    case 2:
                        message.money_reference = reader.string();
                        break;
                    case 3:
                        message.account_id = reader.string();
                        break;
                    case 4:
                        message.aud_amount = reader.string();
                        break;
                    case 5:
                        message.transaction_type = reader.int32();
                        break;
                    case 6:
                        message.initial_payment_type = reader.int32();
                        break;
                    case 7:
                        message.status = reader.int32();
                        break;
                    case 8:
                        message.reversal_transaction_reference = reader.string();
                        break;
                    case 9:
                        message.required_transaction_reference = reader.string();
                        break;
                    case 10:
                        message.completed_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 11:
                        message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 12:
                        message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 13:
                        message.core_user_bank_account_id = reader.string();
                        break;
                    case 14:
                        message.pending_aud_amount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Transaction message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.Transaction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.Transaction} Transaction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Transaction.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Transaction message.
             * @function verify
             * @memberof core.money.Transaction
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Transaction.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    if (!$util.isString(message.transaction_reference))
                        return "transaction_reference: string expected";
                if (message.money_reference != null && message.hasOwnProperty("money_reference"))
                    if (!$util.isString(message.money_reference))
                        return "money_reference: string expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    if (!$util.isString(message.aud_amount))
                        return "aud_amount: string expected";
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    switch (message.transaction_type) {
                    default:
                        return "transaction_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                        break;
                    }
                if (message.initial_payment_type != null && message.hasOwnProperty("initial_payment_type"))
                    switch (message.initial_payment_type) {
                    default:
                        return "initial_payment_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                        break;
                    }
                if (message.reversal_transaction_reference != null && message.hasOwnProperty("reversal_transaction_reference"))
                    if (!$util.isString(message.reversal_transaction_reference))
                        return "reversal_transaction_reference: string expected";
                if (message.required_transaction_reference != null && message.hasOwnProperty("required_transaction_reference"))
                    if (!$util.isString(message.required_transaction_reference))
                        return "required_transaction_reference: string expected";
                if (message.completed_at != null && message.hasOwnProperty("completed_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.completed_at);
                    if (error)
                        return "completed_at." + error;
                }
                if (message.created_at != null && message.hasOwnProperty("created_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                    if (error)
                        return "created_at." + error;
                }
                if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
                    let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
                    if (error)
                        return "last_updated_at." + error;
                }
                if (message.core_user_bank_account_id != null && message.hasOwnProperty("core_user_bank_account_id"))
                    if (!$util.isString(message.core_user_bank_account_id))
                        return "core_user_bank_account_id: string expected";
                if (message.pending_aud_amount != null && message.hasOwnProperty("pending_aud_amount"))
                    if (!$util.isString(message.pending_aud_amount))
                        return "pending_aud_amount: string expected";
                return null;
            };

            /**
             * Creates a Transaction message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.Transaction
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.Transaction} Transaction
             */
            Transaction.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.Transaction)
                    return object;
                let message = new $root.core.money.Transaction();
                if (object.transaction_reference != null)
                    message.transaction_reference = String(object.transaction_reference);
                if (object.money_reference != null)
                    message.money_reference = String(object.money_reference);
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                if (object.aud_amount != null)
                    message.aud_amount = String(object.aud_amount);
                switch (object.transaction_type) {
                case "UNKNOWN":
                case 0:
                    message.transaction_type = 0;
                    break;
                case "USER_DEPOSIT":
                case 1:
                    message.transaction_type = 1;
                    break;
                case "VOYAGER_SALE":
                case 2:
                    message.transaction_type = 2;
                    break;
                case "NOVA_SALE":
                case 3:
                    message.transaction_type = 3;
                    break;
                case "NOVA_DIVIDEND":
                case 4:
                    message.transaction_type = 4;
                    break;
                case "VOYAGER_DISTRIBUTION":
                case 5:
                    message.transaction_type = 5;
                    break;
                case "USER_WITHDRAWAL":
                case 6:
                    message.transaction_type = 6;
                    break;
                case "VOYAGER_PURCHASE":
                case 7:
                    message.transaction_type = 7;
                    break;
                case "NOVA_PURCHASE":
                case 8:
                    message.transaction_type = 8;
                    break;
                case "VOYAGER_MONTHLY_FEE":
                case 9:
                    message.transaction_type = 9;
                    break;
                case "OTHER":
                case 10:
                    message.transaction_type = 10;
                    break;
                case "NOVA_REG_FEE":
                case 11:
                    message.transaction_type = 11;
                    break;
                case "NOVA_MONTHLY_FEE":
                case 12:
                    message.transaction_type = 12;
                    break;
                case "NOVA_MERGER_ACQUISITIONS":
                case 13:
                    message.transaction_type = 13;
                    break;
                case "VOYAGER_BOOST":
                case 14:
                    message.transaction_type = 14;
                    break;
                case "NOVA_TAF_FEE":
                case 15:
                    message.transaction_type = 15;
                    break;
                case "USER_DEPOSIT_REVERSAL":
                case 16:
                    message.transaction_type = 16;
                    break;
                case "USER_WITHDRAWAL_REVERSAL":
                case 17:
                    message.transaction_type = 17;
                    break;
                }
                switch (object.initial_payment_type) {
                case "UNKNOWN":
                case 0:
                    message.initial_payment_type = 0;
                    break;
                case "NPP":
                case 1:
                    message.initial_payment_type = 1;
                    break;
                case "DIRECT_ENTRY":
                case 2:
                    message.initial_payment_type = 2;
                    break;
                case "PAYTO":
                case 3:
                    message.initial_payment_type = 3;
                    break;
                }
                switch (object.status) {
                case "UNKNOWN":
                case 0:
                    message.status = 0;
                    break;
                case "PENDING":
                case 1:
                    message.status = 1;
                    break;
                case "IN_REVIEW":
                case 2:
                    message.status = 2;
                    break;
                case "PROCESSING":
                case 3:
                    message.status = 3;
                    break;
                case "COMPLETED":
                case 4:
                    message.status = 4;
                    break;
                case "FAILED":
                case 5:
                    message.status = 5;
                    break;
                case "CANCELLED":
                case 6:
                    message.status = 6;
                    break;
                case "REQUIRED_TRANSACTION_CLEARING":
                case 7:
                    message.status = 7;
                    break;
                case "FUNDS_AVAILABLE":
                case 8:
                    message.status = 8;
                    break;
                case "READY_TO_PROCESS":
                case 9:
                    message.status = 9;
                    break;
                case "FUNDS_CLEARING":
                case 10:
                    message.status = 10;
                    break;
                }
                if (object.reversal_transaction_reference != null)
                    message.reversal_transaction_reference = String(object.reversal_transaction_reference);
                if (object.required_transaction_reference != null)
                    message.required_transaction_reference = String(object.required_transaction_reference);
                if (object.completed_at != null) {
                    if (typeof object.completed_at !== "object")
                        throw TypeError(".core.money.Transaction.completed_at: object expected");
                    message.completed_at = $root.google.protobuf.Timestamp.fromObject(object.completed_at);
                }
                if (object.created_at != null) {
                    if (typeof object.created_at !== "object")
                        throw TypeError(".core.money.Transaction.created_at: object expected");
                    message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
                }
                if (object.last_updated_at != null) {
                    if (typeof object.last_updated_at !== "object")
                        throw TypeError(".core.money.Transaction.last_updated_at: object expected");
                    message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
                }
                if (object.core_user_bank_account_id != null)
                    message.core_user_bank_account_id = String(object.core_user_bank_account_id);
                if (object.pending_aud_amount != null)
                    message.pending_aud_amount = String(object.pending_aud_amount);
                return message;
            };

            /**
             * Creates a plain object from a Transaction message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.Transaction
             * @static
             * @param {core.money.Transaction} message Transaction
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Transaction.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.transaction_reference = "";
                    object.money_reference = "";
                    object.account_id = "";
                    object.aud_amount = "";
                    object.transaction_type = options.enums === String ? "UNKNOWN" : 0;
                    object.initial_payment_type = options.enums === String ? "UNKNOWN" : 0;
                    object.status = options.enums === String ? "UNKNOWN" : 0;
                    object.reversal_transaction_reference = "";
                    object.required_transaction_reference = "";
                    object.completed_at = null;
                    object.created_at = null;
                    object.last_updated_at = null;
                    object.core_user_bank_account_id = "";
                    object.pending_aud_amount = "";
                }
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    object.transaction_reference = message.transaction_reference;
                if (message.money_reference != null && message.hasOwnProperty("money_reference"))
                    object.money_reference = message.money_reference;
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    object.aud_amount = message.aud_amount;
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    object.transaction_type = options.enums === String ? $root.core.money.TransactionType.Enum[message.transaction_type] : message.transaction_type;
                if (message.initial_payment_type != null && message.hasOwnProperty("initial_payment_type"))
                    object.initial_payment_type = options.enums === String ? $root.core.money.InitialPaymentType.Enum[message.initial_payment_type] : message.initial_payment_type;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.core.money.TransactionStatus.Enum[message.status] : message.status;
                if (message.reversal_transaction_reference != null && message.hasOwnProperty("reversal_transaction_reference"))
                    object.reversal_transaction_reference = message.reversal_transaction_reference;
                if (message.required_transaction_reference != null && message.hasOwnProperty("required_transaction_reference"))
                    object.required_transaction_reference = message.required_transaction_reference;
                if (message.completed_at != null && message.hasOwnProperty("completed_at"))
                    object.completed_at = $root.google.protobuf.Timestamp.toObject(message.completed_at, options);
                if (message.created_at != null && message.hasOwnProperty("created_at"))
                    object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
                if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
                    object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
                if (message.core_user_bank_account_id != null && message.hasOwnProperty("core_user_bank_account_id"))
                    object.core_user_bank_account_id = message.core_user_bank_account_id;
                if (message.pending_aud_amount != null && message.hasOwnProperty("pending_aud_amount"))
                    object.pending_aud_amount = message.pending_aud_amount;
                return object;
            };

            /**
             * Converts this Transaction to JSON.
             * @function toJSON
             * @memberof core.money.Transaction
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Transaction.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Transaction;
        })();

        money.TransactionFilter = (function() {

            /**
             * Properties of a TransactionFilter.
             * @memberof core.money
             * @interface ITransactionFilter
             * @property {Array.<core.money.TransactionType.Enum>|null} [transaction_types] TransactionFilter transaction_types
             */

            /**
             * Constructs a new TransactionFilter.
             * @memberof core.money
             * @classdesc Represents a TransactionFilter.
             * @implements ITransactionFilter
             * @constructor
             * @param {core.money.ITransactionFilter=} [properties] Properties to set
             */
            function TransactionFilter(properties) {
                this.transaction_types = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TransactionFilter transaction_types.
             * @member {Array.<core.money.TransactionType.Enum>} transaction_types
             * @memberof core.money.TransactionFilter
             * @instance
             */
            TransactionFilter.prototype.transaction_types = $util.emptyArray;

            /**
             * Creates a new TransactionFilter instance using the specified properties.
             * @function create
             * @memberof core.money.TransactionFilter
             * @static
             * @param {core.money.ITransactionFilter=} [properties] Properties to set
             * @returns {core.money.TransactionFilter} TransactionFilter instance
             */
            TransactionFilter.create = function create(properties) {
                return new TransactionFilter(properties);
            };

            /**
             * Encodes the specified TransactionFilter message. Does not implicitly {@link core.money.TransactionFilter.verify|verify} messages.
             * @function encode
             * @memberof core.money.TransactionFilter
             * @static
             * @param {core.money.ITransactionFilter} message TransactionFilter message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionFilter.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_types != null && message.transaction_types.length) {
                    writer.uint32(/* id 1, wireType 2 =*/10).fork();
                    for (let i = 0; i < message.transaction_types.length; ++i)
                        writer.int32(message.transaction_types[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified TransactionFilter message, length delimited. Does not implicitly {@link core.money.TransactionFilter.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.TransactionFilter
             * @static
             * @param {core.money.ITransactionFilter} message TransactionFilter message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionFilter.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TransactionFilter message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.TransactionFilter
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.TransactionFilter} TransactionFilter
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionFilter.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.TransactionFilter();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.transaction_types && message.transaction_types.length))
                            message.transaction_types = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.transaction_types.push(reader.int32());
                        } else
                            message.transaction_types.push(reader.int32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TransactionFilter message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.TransactionFilter
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.TransactionFilter} TransactionFilter
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionFilter.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TransactionFilter message.
             * @function verify
             * @memberof core.money.TransactionFilter
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TransactionFilter.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_types != null && message.hasOwnProperty("transaction_types")) {
                    if (!Array.isArray(message.transaction_types))
                        return "transaction_types: array expected";
                    for (let i = 0; i < message.transaction_types.length; ++i)
                        switch (message.transaction_types[i]) {
                        default:
                            return "transaction_types: enum value[] expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                        case 17:
                            break;
                        }
                }
                return null;
            };

            /**
             * Creates a TransactionFilter message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.TransactionFilter
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.TransactionFilter} TransactionFilter
             */
            TransactionFilter.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.TransactionFilter)
                    return object;
                let message = new $root.core.money.TransactionFilter();
                if (object.transaction_types) {
                    if (!Array.isArray(object.transaction_types))
                        throw TypeError(".core.money.TransactionFilter.transaction_types: array expected");
                    message.transaction_types = [];
                    for (let i = 0; i < object.transaction_types.length; ++i)
                        switch (object.transaction_types[i]) {
                        default:
                        case "UNKNOWN":
                        case 0:
                            message.transaction_types[i] = 0;
                            break;
                        case "USER_DEPOSIT":
                        case 1:
                            message.transaction_types[i] = 1;
                            break;
                        case "VOYAGER_SALE":
                        case 2:
                            message.transaction_types[i] = 2;
                            break;
                        case "NOVA_SALE":
                        case 3:
                            message.transaction_types[i] = 3;
                            break;
                        case "NOVA_DIVIDEND":
                        case 4:
                            message.transaction_types[i] = 4;
                            break;
                        case "VOYAGER_DISTRIBUTION":
                        case 5:
                            message.transaction_types[i] = 5;
                            break;
                        case "USER_WITHDRAWAL":
                        case 6:
                            message.transaction_types[i] = 6;
                            break;
                        case "VOYAGER_PURCHASE":
                        case 7:
                            message.transaction_types[i] = 7;
                            break;
                        case "NOVA_PURCHASE":
                        case 8:
                            message.transaction_types[i] = 8;
                            break;
                        case "VOYAGER_MONTHLY_FEE":
                        case 9:
                            message.transaction_types[i] = 9;
                            break;
                        case "OTHER":
                        case 10:
                            message.transaction_types[i] = 10;
                            break;
                        case "NOVA_REG_FEE":
                        case 11:
                            message.transaction_types[i] = 11;
                            break;
                        case "NOVA_MONTHLY_FEE":
                        case 12:
                            message.transaction_types[i] = 12;
                            break;
                        case "NOVA_MERGER_ACQUISITIONS":
                        case 13:
                            message.transaction_types[i] = 13;
                            break;
                        case "VOYAGER_BOOST":
                        case 14:
                            message.transaction_types[i] = 14;
                            break;
                        case "NOVA_TAF_FEE":
                        case 15:
                            message.transaction_types[i] = 15;
                            break;
                        case "USER_DEPOSIT_REVERSAL":
                        case 16:
                            message.transaction_types[i] = 16;
                            break;
                        case "USER_WITHDRAWAL_REVERSAL":
                        case 17:
                            message.transaction_types[i] = 17;
                            break;
                        }
                }
                return message;
            };

            /**
             * Creates a plain object from a TransactionFilter message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.TransactionFilter
             * @static
             * @param {core.money.TransactionFilter} message TransactionFilter
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TransactionFilter.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.transaction_types = [];
                if (message.transaction_types && message.transaction_types.length) {
                    object.transaction_types = [];
                    for (let j = 0; j < message.transaction_types.length; ++j)
                        object.transaction_types[j] = options.enums === String ? $root.core.money.TransactionType.Enum[message.transaction_types[j]] : message.transaction_types[j];
                }
                return object;
            };

            /**
             * Converts this TransactionFilter to JSON.
             * @function toJSON
             * @memberof core.money.TransactionFilter
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TransactionFilter.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TransactionFilter;
        })();

        money.GetTransactionsByAccountIDRequest = (function() {

            /**
             * Properties of a GetTransactionsByAccountIDRequest.
             * @memberof core.money
             * @interface IGetTransactionsByAccountIDRequest
             * @property {string|null} [account_id] GetTransactionsByAccountIDRequest account_id
             * @property {core.money.ITransactionFilter|null} [transaction_filter] GetTransactionsByAccountIDRequest transaction_filter
             * @property {IPageParams|null} [page_params] GetTransactionsByAccountIDRequest page_params
             */

            /**
             * Constructs a new GetTransactionsByAccountIDRequest.
             * @memberof core.money
             * @classdesc Represents a GetTransactionsByAccountIDRequest.
             * @implements IGetTransactionsByAccountIDRequest
             * @constructor
             * @param {core.money.IGetTransactionsByAccountIDRequest=} [properties] Properties to set
             */
            function GetTransactionsByAccountIDRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTransactionsByAccountIDRequest account_id.
             * @member {string} account_id
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @instance
             */
            GetTransactionsByAccountIDRequest.prototype.account_id = "";

            /**
             * GetTransactionsByAccountIDRequest transaction_filter.
             * @member {core.money.ITransactionFilter|null|undefined} transaction_filter
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @instance
             */
            GetTransactionsByAccountIDRequest.prototype.transaction_filter = null;

            /**
             * GetTransactionsByAccountIDRequest page_params.
             * @member {IPageParams|null|undefined} page_params
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @instance
             */
            GetTransactionsByAccountIDRequest.prototype.page_params = null;

            /**
             * Creates a new GetTransactionsByAccountIDRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @static
             * @param {core.money.IGetTransactionsByAccountIDRequest=} [properties] Properties to set
             * @returns {core.money.GetTransactionsByAccountIDRequest} GetTransactionsByAccountIDRequest instance
             */
            GetTransactionsByAccountIDRequest.create = function create(properties) {
                return new GetTransactionsByAccountIDRequest(properties);
            };

            /**
             * Encodes the specified GetTransactionsByAccountIDRequest message. Does not implicitly {@link core.money.GetTransactionsByAccountIDRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @static
             * @param {core.money.IGetTransactionsByAccountIDRequest} message GetTransactionsByAccountIDRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionsByAccountIDRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.account_id);
                if (message.transaction_filter != null && message.hasOwnProperty("transaction_filter"))
                    $root.core.money.TransactionFilter.encode(message.transaction_filter, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.page_params != null && message.hasOwnProperty("page_params"))
                    $root.PageParams.encode(message.page_params, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetTransactionsByAccountIDRequest message, length delimited. Does not implicitly {@link core.money.GetTransactionsByAccountIDRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @static
             * @param {core.money.IGetTransactionsByAccountIDRequest} message GetTransactionsByAccountIDRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionsByAccountIDRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTransactionsByAccountIDRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetTransactionsByAccountIDRequest} GetTransactionsByAccountIDRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionsByAccountIDRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetTransactionsByAccountIDRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.account_id = reader.string();
                        break;
                    case 2:
                        message.transaction_filter = $root.core.money.TransactionFilter.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.page_params = $root.PageParams.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTransactionsByAccountIDRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetTransactionsByAccountIDRequest} GetTransactionsByAccountIDRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionsByAccountIDRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTransactionsByAccountIDRequest message.
             * @function verify
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTransactionsByAccountIDRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                if (message.transaction_filter != null && message.hasOwnProperty("transaction_filter")) {
                    let error = $root.core.money.TransactionFilter.verify(message.transaction_filter);
                    if (error)
                        return "transaction_filter." + error;
                }
                if (message.page_params != null && message.hasOwnProperty("page_params")) {
                    let error = $root.PageParams.verify(message.page_params);
                    if (error)
                        return "page_params." + error;
                }
                return null;
            };

            /**
             * Creates a GetTransactionsByAccountIDRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetTransactionsByAccountIDRequest} GetTransactionsByAccountIDRequest
             */
            GetTransactionsByAccountIDRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetTransactionsByAccountIDRequest)
                    return object;
                let message = new $root.core.money.GetTransactionsByAccountIDRequest();
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                if (object.transaction_filter != null) {
                    if (typeof object.transaction_filter !== "object")
                        throw TypeError(".core.money.GetTransactionsByAccountIDRequest.transaction_filter: object expected");
                    message.transaction_filter = $root.core.money.TransactionFilter.fromObject(object.transaction_filter);
                }
                if (object.page_params != null) {
                    if (typeof object.page_params !== "object")
                        throw TypeError(".core.money.GetTransactionsByAccountIDRequest.page_params: object expected");
                    message.page_params = $root.PageParams.fromObject(object.page_params);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetTransactionsByAccountIDRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @static
             * @param {core.money.GetTransactionsByAccountIDRequest} message GetTransactionsByAccountIDRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTransactionsByAccountIDRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.account_id = "";
                    object.transaction_filter = null;
                    object.page_params = null;
                }
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                if (message.transaction_filter != null && message.hasOwnProperty("transaction_filter"))
                    object.transaction_filter = $root.core.money.TransactionFilter.toObject(message.transaction_filter, options);
                if (message.page_params != null && message.hasOwnProperty("page_params"))
                    object.page_params = $root.PageParams.toObject(message.page_params, options);
                return object;
            };

            /**
             * Converts this GetTransactionsByAccountIDRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetTransactionsByAccountIDRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTransactionsByAccountIDRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTransactionsByAccountIDRequest;
        })();

        money.GetTransactionsByAccountIDResponse = (function() {

            /**
             * Properties of a GetTransactionsByAccountIDResponse.
             * @memberof core.money
             * @interface IGetTransactionsByAccountIDResponse
             * @property {Array.<core.money.ITransaction>|null} [transactions] GetTransactionsByAccountIDResponse transactions
             * @property {IPageInfo|null} [page_info] GetTransactionsByAccountIDResponse page_info
             */

            /**
             * Constructs a new GetTransactionsByAccountIDResponse.
             * @memberof core.money
             * @classdesc Represents a GetTransactionsByAccountIDResponse.
             * @implements IGetTransactionsByAccountIDResponse
             * @constructor
             * @param {core.money.IGetTransactionsByAccountIDResponse=} [properties] Properties to set
             */
            function GetTransactionsByAccountIDResponse(properties) {
                this.transactions = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTransactionsByAccountIDResponse transactions.
             * @member {Array.<core.money.ITransaction>} transactions
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @instance
             */
            GetTransactionsByAccountIDResponse.prototype.transactions = $util.emptyArray;

            /**
             * GetTransactionsByAccountIDResponse page_info.
             * @member {IPageInfo|null|undefined} page_info
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @instance
             */
            GetTransactionsByAccountIDResponse.prototype.page_info = null;

            /**
             * Creates a new GetTransactionsByAccountIDResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @static
             * @param {core.money.IGetTransactionsByAccountIDResponse=} [properties] Properties to set
             * @returns {core.money.GetTransactionsByAccountIDResponse} GetTransactionsByAccountIDResponse instance
             */
            GetTransactionsByAccountIDResponse.create = function create(properties) {
                return new GetTransactionsByAccountIDResponse(properties);
            };

            /**
             * Encodes the specified GetTransactionsByAccountIDResponse message. Does not implicitly {@link core.money.GetTransactionsByAccountIDResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @static
             * @param {core.money.IGetTransactionsByAccountIDResponse} message GetTransactionsByAccountIDResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionsByAccountIDResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transactions != null && message.transactions.length)
                    for (let i = 0; i < message.transactions.length; ++i)
                        $root.core.money.Transaction.encode(message.transactions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.page_info != null && message.hasOwnProperty("page_info"))
                    $root.PageInfo.encode(message.page_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetTransactionsByAccountIDResponse message, length delimited. Does not implicitly {@link core.money.GetTransactionsByAccountIDResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @static
             * @param {core.money.IGetTransactionsByAccountIDResponse} message GetTransactionsByAccountIDResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionsByAccountIDResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTransactionsByAccountIDResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetTransactionsByAccountIDResponse} GetTransactionsByAccountIDResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionsByAccountIDResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetTransactionsByAccountIDResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.transactions && message.transactions.length))
                            message.transactions = [];
                        message.transactions.push($root.core.money.Transaction.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.page_info = $root.PageInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTransactionsByAccountIDResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetTransactionsByAccountIDResponse} GetTransactionsByAccountIDResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionsByAccountIDResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTransactionsByAccountIDResponse message.
             * @function verify
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTransactionsByAccountIDResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transactions != null && message.hasOwnProperty("transactions")) {
                    if (!Array.isArray(message.transactions))
                        return "transactions: array expected";
                    for (let i = 0; i < message.transactions.length; ++i) {
                        let error = $root.core.money.Transaction.verify(message.transactions[i]);
                        if (error)
                            return "transactions." + error;
                    }
                }
                if (message.page_info != null && message.hasOwnProperty("page_info")) {
                    let error = $root.PageInfo.verify(message.page_info);
                    if (error)
                        return "page_info." + error;
                }
                return null;
            };

            /**
             * Creates a GetTransactionsByAccountIDResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetTransactionsByAccountIDResponse} GetTransactionsByAccountIDResponse
             */
            GetTransactionsByAccountIDResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetTransactionsByAccountIDResponse)
                    return object;
                let message = new $root.core.money.GetTransactionsByAccountIDResponse();
                if (object.transactions) {
                    if (!Array.isArray(object.transactions))
                        throw TypeError(".core.money.GetTransactionsByAccountIDResponse.transactions: array expected");
                    message.transactions = [];
                    for (let i = 0; i < object.transactions.length; ++i) {
                        if (typeof object.transactions[i] !== "object")
                            throw TypeError(".core.money.GetTransactionsByAccountIDResponse.transactions: object expected");
                        message.transactions[i] = $root.core.money.Transaction.fromObject(object.transactions[i]);
                    }
                }
                if (object.page_info != null) {
                    if (typeof object.page_info !== "object")
                        throw TypeError(".core.money.GetTransactionsByAccountIDResponse.page_info: object expected");
                    message.page_info = $root.PageInfo.fromObject(object.page_info);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetTransactionsByAccountIDResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @static
             * @param {core.money.GetTransactionsByAccountIDResponse} message GetTransactionsByAccountIDResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTransactionsByAccountIDResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.transactions = [];
                if (options.defaults)
                    object.page_info = null;
                if (message.transactions && message.transactions.length) {
                    object.transactions = [];
                    for (let j = 0; j < message.transactions.length; ++j)
                        object.transactions[j] = $root.core.money.Transaction.toObject(message.transactions[j], options);
                }
                if (message.page_info != null && message.hasOwnProperty("page_info"))
                    object.page_info = $root.PageInfo.toObject(message.page_info, options);
                return object;
            };

            /**
             * Converts this GetTransactionsByAccountIDResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetTransactionsByAccountIDResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTransactionsByAccountIDResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTransactionsByAccountIDResponse;
        })();

        money.GetTransactionByTransactionReferenceRequest = (function() {

            /**
             * Properties of a GetTransactionByTransactionReferenceRequest.
             * @memberof core.money
             * @interface IGetTransactionByTransactionReferenceRequest
             * @property {string|null} [transaction_reference] GetTransactionByTransactionReferenceRequest transaction_reference
             */

            /**
             * Constructs a new GetTransactionByTransactionReferenceRequest.
             * @memberof core.money
             * @classdesc Represents a GetTransactionByTransactionReferenceRequest.
             * @implements IGetTransactionByTransactionReferenceRequest
             * @constructor
             * @param {core.money.IGetTransactionByTransactionReferenceRequest=} [properties] Properties to set
             */
            function GetTransactionByTransactionReferenceRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTransactionByTransactionReferenceRequest transaction_reference.
             * @member {string} transaction_reference
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @instance
             */
            GetTransactionByTransactionReferenceRequest.prototype.transaction_reference = "";

            /**
             * Creates a new GetTransactionByTransactionReferenceRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @static
             * @param {core.money.IGetTransactionByTransactionReferenceRequest=} [properties] Properties to set
             * @returns {core.money.GetTransactionByTransactionReferenceRequest} GetTransactionByTransactionReferenceRequest instance
             */
            GetTransactionByTransactionReferenceRequest.create = function create(properties) {
                return new GetTransactionByTransactionReferenceRequest(properties);
            };

            /**
             * Encodes the specified GetTransactionByTransactionReferenceRequest message. Does not implicitly {@link core.money.GetTransactionByTransactionReferenceRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @static
             * @param {core.money.IGetTransactionByTransactionReferenceRequest} message GetTransactionByTransactionReferenceRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionByTransactionReferenceRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_reference);
                return writer;
            };

            /**
             * Encodes the specified GetTransactionByTransactionReferenceRequest message, length delimited. Does not implicitly {@link core.money.GetTransactionByTransactionReferenceRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @static
             * @param {core.money.IGetTransactionByTransactionReferenceRequest} message GetTransactionByTransactionReferenceRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionByTransactionReferenceRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTransactionByTransactionReferenceRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetTransactionByTransactionReferenceRequest} GetTransactionByTransactionReferenceRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionByTransactionReferenceRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetTransactionByTransactionReferenceRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction_reference = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTransactionByTransactionReferenceRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetTransactionByTransactionReferenceRequest} GetTransactionByTransactionReferenceRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionByTransactionReferenceRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTransactionByTransactionReferenceRequest message.
             * @function verify
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTransactionByTransactionReferenceRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    if (!$util.isString(message.transaction_reference))
                        return "transaction_reference: string expected";
                return null;
            };

            /**
             * Creates a GetTransactionByTransactionReferenceRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetTransactionByTransactionReferenceRequest} GetTransactionByTransactionReferenceRequest
             */
            GetTransactionByTransactionReferenceRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetTransactionByTransactionReferenceRequest)
                    return object;
                let message = new $root.core.money.GetTransactionByTransactionReferenceRequest();
                if (object.transaction_reference != null)
                    message.transaction_reference = String(object.transaction_reference);
                return message;
            };

            /**
             * Creates a plain object from a GetTransactionByTransactionReferenceRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @static
             * @param {core.money.GetTransactionByTransactionReferenceRequest} message GetTransactionByTransactionReferenceRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTransactionByTransactionReferenceRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.transaction_reference = "";
                if (message.transaction_reference != null && message.hasOwnProperty("transaction_reference"))
                    object.transaction_reference = message.transaction_reference;
                return object;
            };

            /**
             * Converts this GetTransactionByTransactionReferenceRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetTransactionByTransactionReferenceRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTransactionByTransactionReferenceRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTransactionByTransactionReferenceRequest;
        })();

        money.GetTransactionByTransactionReferenceResponse = (function() {

            /**
             * Properties of a GetTransactionByTransactionReferenceResponse.
             * @memberof core.money
             * @interface IGetTransactionByTransactionReferenceResponse
             * @property {core.money.ITransaction|null} [transaction] GetTransactionByTransactionReferenceResponse transaction
             */

            /**
             * Constructs a new GetTransactionByTransactionReferenceResponse.
             * @memberof core.money
             * @classdesc Represents a GetTransactionByTransactionReferenceResponse.
             * @implements IGetTransactionByTransactionReferenceResponse
             * @constructor
             * @param {core.money.IGetTransactionByTransactionReferenceResponse=} [properties] Properties to set
             */
            function GetTransactionByTransactionReferenceResponse(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTransactionByTransactionReferenceResponse transaction.
             * @member {core.money.ITransaction|null|undefined} transaction
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @instance
             */
            GetTransactionByTransactionReferenceResponse.prototype.transaction = null;

            /**
             * Creates a new GetTransactionByTransactionReferenceResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @static
             * @param {core.money.IGetTransactionByTransactionReferenceResponse=} [properties] Properties to set
             * @returns {core.money.GetTransactionByTransactionReferenceResponse} GetTransactionByTransactionReferenceResponse instance
             */
            GetTransactionByTransactionReferenceResponse.create = function create(properties) {
                return new GetTransactionByTransactionReferenceResponse(properties);
            };

            /**
             * Encodes the specified GetTransactionByTransactionReferenceResponse message. Does not implicitly {@link core.money.GetTransactionByTransactionReferenceResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @static
             * @param {core.money.IGetTransactionByTransactionReferenceResponse} message GetTransactionByTransactionReferenceResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionByTransactionReferenceResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction != null && message.hasOwnProperty("transaction"))
                    $root.core.money.Transaction.encode(message.transaction, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetTransactionByTransactionReferenceResponse message, length delimited. Does not implicitly {@link core.money.GetTransactionByTransactionReferenceResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @static
             * @param {core.money.IGetTransactionByTransactionReferenceResponse} message GetTransactionByTransactionReferenceResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionByTransactionReferenceResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTransactionByTransactionReferenceResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetTransactionByTransactionReferenceResponse} GetTransactionByTransactionReferenceResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionByTransactionReferenceResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetTransactionByTransactionReferenceResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction = $root.core.money.Transaction.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTransactionByTransactionReferenceResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetTransactionByTransactionReferenceResponse} GetTransactionByTransactionReferenceResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionByTransactionReferenceResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTransactionByTransactionReferenceResponse message.
             * @function verify
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTransactionByTransactionReferenceResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction != null && message.hasOwnProperty("transaction")) {
                    let error = $root.core.money.Transaction.verify(message.transaction);
                    if (error)
                        return "transaction." + error;
                }
                return null;
            };

            /**
             * Creates a GetTransactionByTransactionReferenceResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetTransactionByTransactionReferenceResponse} GetTransactionByTransactionReferenceResponse
             */
            GetTransactionByTransactionReferenceResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetTransactionByTransactionReferenceResponse)
                    return object;
                let message = new $root.core.money.GetTransactionByTransactionReferenceResponse();
                if (object.transaction != null) {
                    if (typeof object.transaction !== "object")
                        throw TypeError(".core.money.GetTransactionByTransactionReferenceResponse.transaction: object expected");
                    message.transaction = $root.core.money.Transaction.fromObject(object.transaction);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetTransactionByTransactionReferenceResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @static
             * @param {core.money.GetTransactionByTransactionReferenceResponse} message GetTransactionByTransactionReferenceResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTransactionByTransactionReferenceResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.transaction = null;
                if (message.transaction != null && message.hasOwnProperty("transaction"))
                    object.transaction = $root.core.money.Transaction.toObject(message.transaction, options);
                return object;
            };

            /**
             * Converts this GetTransactionByTransactionReferenceResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetTransactionByTransactionReferenceResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTransactionByTransactionReferenceResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTransactionByTransactionReferenceResponse;
        })();

        money.GetTransactionsByTransactionReferencesRequest = (function() {

            /**
             * Properties of a GetTransactionsByTransactionReferencesRequest.
             * @memberof core.money
             * @interface IGetTransactionsByTransactionReferencesRequest
             * @property {Array.<string>|null} [transaction_references] GetTransactionsByTransactionReferencesRequest transaction_references
             * @property {IPageParams|null} [page_params] GetTransactionsByTransactionReferencesRequest page_params
             */

            /**
             * Constructs a new GetTransactionsByTransactionReferencesRequest.
             * @memberof core.money
             * @classdesc Represents a GetTransactionsByTransactionReferencesRequest.
             * @implements IGetTransactionsByTransactionReferencesRequest
             * @constructor
             * @param {core.money.IGetTransactionsByTransactionReferencesRequest=} [properties] Properties to set
             */
            function GetTransactionsByTransactionReferencesRequest(properties) {
                this.transaction_references = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTransactionsByTransactionReferencesRequest transaction_references.
             * @member {Array.<string>} transaction_references
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @instance
             */
            GetTransactionsByTransactionReferencesRequest.prototype.transaction_references = $util.emptyArray;

            /**
             * GetTransactionsByTransactionReferencesRequest page_params.
             * @member {IPageParams|null|undefined} page_params
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @instance
             */
            GetTransactionsByTransactionReferencesRequest.prototype.page_params = null;

            /**
             * Creates a new GetTransactionsByTransactionReferencesRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @static
             * @param {core.money.IGetTransactionsByTransactionReferencesRequest=} [properties] Properties to set
             * @returns {core.money.GetTransactionsByTransactionReferencesRequest} GetTransactionsByTransactionReferencesRequest instance
             */
            GetTransactionsByTransactionReferencesRequest.create = function create(properties) {
                return new GetTransactionsByTransactionReferencesRequest(properties);
            };

            /**
             * Encodes the specified GetTransactionsByTransactionReferencesRequest message. Does not implicitly {@link core.money.GetTransactionsByTransactionReferencesRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @static
             * @param {core.money.IGetTransactionsByTransactionReferencesRequest} message GetTransactionsByTransactionReferencesRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionsByTransactionReferencesRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction_references != null && message.transaction_references.length)
                    for (let i = 0; i < message.transaction_references.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.transaction_references[i]);
                if (message.page_params != null && message.hasOwnProperty("page_params"))
                    $root.PageParams.encode(message.page_params, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetTransactionsByTransactionReferencesRequest message, length delimited. Does not implicitly {@link core.money.GetTransactionsByTransactionReferencesRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @static
             * @param {core.money.IGetTransactionsByTransactionReferencesRequest} message GetTransactionsByTransactionReferencesRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionsByTransactionReferencesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTransactionsByTransactionReferencesRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetTransactionsByTransactionReferencesRequest} GetTransactionsByTransactionReferencesRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionsByTransactionReferencesRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetTransactionsByTransactionReferencesRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.transaction_references && message.transaction_references.length))
                            message.transaction_references = [];
                        message.transaction_references.push(reader.string());
                        break;
                    case 2:
                        message.page_params = $root.PageParams.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTransactionsByTransactionReferencesRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetTransactionsByTransactionReferencesRequest} GetTransactionsByTransactionReferencesRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionsByTransactionReferencesRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTransactionsByTransactionReferencesRequest message.
             * @function verify
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTransactionsByTransactionReferencesRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction_references != null && message.hasOwnProperty("transaction_references")) {
                    if (!Array.isArray(message.transaction_references))
                        return "transaction_references: array expected";
                    for (let i = 0; i < message.transaction_references.length; ++i)
                        if (!$util.isString(message.transaction_references[i]))
                            return "transaction_references: string[] expected";
                }
                if (message.page_params != null && message.hasOwnProperty("page_params")) {
                    let error = $root.PageParams.verify(message.page_params);
                    if (error)
                        return "page_params." + error;
                }
                return null;
            };

            /**
             * Creates a GetTransactionsByTransactionReferencesRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetTransactionsByTransactionReferencesRequest} GetTransactionsByTransactionReferencesRequest
             */
            GetTransactionsByTransactionReferencesRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetTransactionsByTransactionReferencesRequest)
                    return object;
                let message = new $root.core.money.GetTransactionsByTransactionReferencesRequest();
                if (object.transaction_references) {
                    if (!Array.isArray(object.transaction_references))
                        throw TypeError(".core.money.GetTransactionsByTransactionReferencesRequest.transaction_references: array expected");
                    message.transaction_references = [];
                    for (let i = 0; i < object.transaction_references.length; ++i)
                        message.transaction_references[i] = String(object.transaction_references[i]);
                }
                if (object.page_params != null) {
                    if (typeof object.page_params !== "object")
                        throw TypeError(".core.money.GetTransactionsByTransactionReferencesRequest.page_params: object expected");
                    message.page_params = $root.PageParams.fromObject(object.page_params);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetTransactionsByTransactionReferencesRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @static
             * @param {core.money.GetTransactionsByTransactionReferencesRequest} message GetTransactionsByTransactionReferencesRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTransactionsByTransactionReferencesRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.transaction_references = [];
                if (options.defaults)
                    object.page_params = null;
                if (message.transaction_references && message.transaction_references.length) {
                    object.transaction_references = [];
                    for (let j = 0; j < message.transaction_references.length; ++j)
                        object.transaction_references[j] = message.transaction_references[j];
                }
                if (message.page_params != null && message.hasOwnProperty("page_params"))
                    object.page_params = $root.PageParams.toObject(message.page_params, options);
                return object;
            };

            /**
             * Converts this GetTransactionsByTransactionReferencesRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetTransactionsByTransactionReferencesRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTransactionsByTransactionReferencesRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTransactionsByTransactionReferencesRequest;
        })();

        money.GetTransactionsByTransactionReferencesResponse = (function() {

            /**
             * Properties of a GetTransactionsByTransactionReferencesResponse.
             * @memberof core.money
             * @interface IGetTransactionsByTransactionReferencesResponse
             * @property {Array.<core.money.ITransaction>|null} [transactions] GetTransactionsByTransactionReferencesResponse transactions
             * @property {IPageInfo|null} [page_info] GetTransactionsByTransactionReferencesResponse page_info
             */

            /**
             * Constructs a new GetTransactionsByTransactionReferencesResponse.
             * @memberof core.money
             * @classdesc Represents a GetTransactionsByTransactionReferencesResponse.
             * @implements IGetTransactionsByTransactionReferencesResponse
             * @constructor
             * @param {core.money.IGetTransactionsByTransactionReferencesResponse=} [properties] Properties to set
             */
            function GetTransactionsByTransactionReferencesResponse(properties) {
                this.transactions = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTransactionsByTransactionReferencesResponse transactions.
             * @member {Array.<core.money.ITransaction>} transactions
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @instance
             */
            GetTransactionsByTransactionReferencesResponse.prototype.transactions = $util.emptyArray;

            /**
             * GetTransactionsByTransactionReferencesResponse page_info.
             * @member {IPageInfo|null|undefined} page_info
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @instance
             */
            GetTransactionsByTransactionReferencesResponse.prototype.page_info = null;

            /**
             * Creates a new GetTransactionsByTransactionReferencesResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @static
             * @param {core.money.IGetTransactionsByTransactionReferencesResponse=} [properties] Properties to set
             * @returns {core.money.GetTransactionsByTransactionReferencesResponse} GetTransactionsByTransactionReferencesResponse instance
             */
            GetTransactionsByTransactionReferencesResponse.create = function create(properties) {
                return new GetTransactionsByTransactionReferencesResponse(properties);
            };

            /**
             * Encodes the specified GetTransactionsByTransactionReferencesResponse message. Does not implicitly {@link core.money.GetTransactionsByTransactionReferencesResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @static
             * @param {core.money.IGetTransactionsByTransactionReferencesResponse} message GetTransactionsByTransactionReferencesResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionsByTransactionReferencesResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transactions != null && message.transactions.length)
                    for (let i = 0; i < message.transactions.length; ++i)
                        $root.core.money.Transaction.encode(message.transactions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.page_info != null && message.hasOwnProperty("page_info"))
                    $root.PageInfo.encode(message.page_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetTransactionsByTransactionReferencesResponse message, length delimited. Does not implicitly {@link core.money.GetTransactionsByTransactionReferencesResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @static
             * @param {core.money.IGetTransactionsByTransactionReferencesResponse} message GetTransactionsByTransactionReferencesResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionsByTransactionReferencesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTransactionsByTransactionReferencesResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetTransactionsByTransactionReferencesResponse} GetTransactionsByTransactionReferencesResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionsByTransactionReferencesResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetTransactionsByTransactionReferencesResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.transactions && message.transactions.length))
                            message.transactions = [];
                        message.transactions.push($root.core.money.Transaction.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.page_info = $root.PageInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTransactionsByTransactionReferencesResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetTransactionsByTransactionReferencesResponse} GetTransactionsByTransactionReferencesResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionsByTransactionReferencesResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTransactionsByTransactionReferencesResponse message.
             * @function verify
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTransactionsByTransactionReferencesResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transactions != null && message.hasOwnProperty("transactions")) {
                    if (!Array.isArray(message.transactions))
                        return "transactions: array expected";
                    for (let i = 0; i < message.transactions.length; ++i) {
                        let error = $root.core.money.Transaction.verify(message.transactions[i]);
                        if (error)
                            return "transactions." + error;
                    }
                }
                if (message.page_info != null && message.hasOwnProperty("page_info")) {
                    let error = $root.PageInfo.verify(message.page_info);
                    if (error)
                        return "page_info." + error;
                }
                return null;
            };

            /**
             * Creates a GetTransactionsByTransactionReferencesResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetTransactionsByTransactionReferencesResponse} GetTransactionsByTransactionReferencesResponse
             */
            GetTransactionsByTransactionReferencesResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetTransactionsByTransactionReferencesResponse)
                    return object;
                let message = new $root.core.money.GetTransactionsByTransactionReferencesResponse();
                if (object.transactions) {
                    if (!Array.isArray(object.transactions))
                        throw TypeError(".core.money.GetTransactionsByTransactionReferencesResponse.transactions: array expected");
                    message.transactions = [];
                    for (let i = 0; i < object.transactions.length; ++i) {
                        if (typeof object.transactions[i] !== "object")
                            throw TypeError(".core.money.GetTransactionsByTransactionReferencesResponse.transactions: object expected");
                        message.transactions[i] = $root.core.money.Transaction.fromObject(object.transactions[i]);
                    }
                }
                if (object.page_info != null) {
                    if (typeof object.page_info !== "object")
                        throw TypeError(".core.money.GetTransactionsByTransactionReferencesResponse.page_info: object expected");
                    message.page_info = $root.PageInfo.fromObject(object.page_info);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetTransactionsByTransactionReferencesResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @static
             * @param {core.money.GetTransactionsByTransactionReferencesResponse} message GetTransactionsByTransactionReferencesResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTransactionsByTransactionReferencesResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.transactions = [];
                if (options.defaults)
                    object.page_info = null;
                if (message.transactions && message.transactions.length) {
                    object.transactions = [];
                    for (let j = 0; j < message.transactions.length; ++j)
                        object.transactions[j] = $root.core.money.Transaction.toObject(message.transactions[j], options);
                }
                if (message.page_info != null && message.hasOwnProperty("page_info"))
                    object.page_info = $root.PageInfo.toObject(message.page_info, options);
                return object;
            };

            /**
             * Converts this GetTransactionsByTransactionReferencesResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetTransactionsByTransactionReferencesResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTransactionsByTransactionReferencesResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTransactionsByTransactionReferencesResponse;
        })();

        money.TransactionDirectDebitDepositLimit = (function() {

            /**
             * Properties of a TransactionDirectDebitDepositLimit.
             * @memberof core.money
             * @interface ITransactionDirectDebitDepositLimit
             * @property {boolean|null} [available] TransactionDirectDebitDepositLimit available
             * @property {string|null} [message] TransactionDirectDebitDepositLimit message
             * @property {string|null} [min_aud_amount] TransactionDirectDebitDepositLimit min_aud_amount
             * @property {string|null} [max_aud_amount] TransactionDirectDebitDepositLimit max_aud_amount
             */

            /**
             * Constructs a new TransactionDirectDebitDepositLimit.
             * @memberof core.money
             * @classdesc Represents a TransactionDirectDebitDepositLimit.
             * @implements ITransactionDirectDebitDepositLimit
             * @constructor
             * @param {core.money.ITransactionDirectDebitDepositLimit=} [properties] Properties to set
             */
            function TransactionDirectDebitDepositLimit(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TransactionDirectDebitDepositLimit available.
             * @member {boolean} available
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @instance
             */
            TransactionDirectDebitDepositLimit.prototype.available = false;

            /**
             * TransactionDirectDebitDepositLimit message.
             * @member {string} message
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @instance
             */
            TransactionDirectDebitDepositLimit.prototype.message = "";

            /**
             * TransactionDirectDebitDepositLimit min_aud_amount.
             * @member {string} min_aud_amount
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @instance
             */
            TransactionDirectDebitDepositLimit.prototype.min_aud_amount = "";

            /**
             * TransactionDirectDebitDepositLimit max_aud_amount.
             * @member {string} max_aud_amount
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @instance
             */
            TransactionDirectDebitDepositLimit.prototype.max_aud_amount = "";

            /**
             * Creates a new TransactionDirectDebitDepositLimit instance using the specified properties.
             * @function create
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @static
             * @param {core.money.ITransactionDirectDebitDepositLimit=} [properties] Properties to set
             * @returns {core.money.TransactionDirectDebitDepositLimit} TransactionDirectDebitDepositLimit instance
             */
            TransactionDirectDebitDepositLimit.create = function create(properties) {
                return new TransactionDirectDebitDepositLimit(properties);
            };

            /**
             * Encodes the specified TransactionDirectDebitDepositLimit message. Does not implicitly {@link core.money.TransactionDirectDebitDepositLimit.verify|verify} messages.
             * @function encode
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @static
             * @param {core.money.ITransactionDirectDebitDepositLimit} message TransactionDirectDebitDepositLimit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionDirectDebitDepositLimit.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.available != null && message.hasOwnProperty("available"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.available);
                if (message.message != null && message.hasOwnProperty("message"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                if (message.min_aud_amount != null && message.hasOwnProperty("min_aud_amount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.min_aud_amount);
                if (message.max_aud_amount != null && message.hasOwnProperty("max_aud_amount"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.max_aud_amount);
                return writer;
            };

            /**
             * Encodes the specified TransactionDirectDebitDepositLimit message, length delimited. Does not implicitly {@link core.money.TransactionDirectDebitDepositLimit.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @static
             * @param {core.money.ITransactionDirectDebitDepositLimit} message TransactionDirectDebitDepositLimit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionDirectDebitDepositLimit.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TransactionDirectDebitDepositLimit message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.TransactionDirectDebitDepositLimit} TransactionDirectDebitDepositLimit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionDirectDebitDepositLimit.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.TransactionDirectDebitDepositLimit();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.available = reader.bool();
                        break;
                    case 2:
                        message.message = reader.string();
                        break;
                    case 3:
                        message.min_aud_amount = reader.string();
                        break;
                    case 4:
                        message.max_aud_amount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TransactionDirectDebitDepositLimit message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.TransactionDirectDebitDepositLimit} TransactionDirectDebitDepositLimit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionDirectDebitDepositLimit.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TransactionDirectDebitDepositLimit message.
             * @function verify
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TransactionDirectDebitDepositLimit.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.available != null && message.hasOwnProperty("available"))
                    if (typeof message.available !== "boolean")
                        return "available: boolean expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                if (message.min_aud_amount != null && message.hasOwnProperty("min_aud_amount"))
                    if (!$util.isString(message.min_aud_amount))
                        return "min_aud_amount: string expected";
                if (message.max_aud_amount != null && message.hasOwnProperty("max_aud_amount"))
                    if (!$util.isString(message.max_aud_amount))
                        return "max_aud_amount: string expected";
                return null;
            };

            /**
             * Creates a TransactionDirectDebitDepositLimit message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.TransactionDirectDebitDepositLimit} TransactionDirectDebitDepositLimit
             */
            TransactionDirectDebitDepositLimit.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.TransactionDirectDebitDepositLimit)
                    return object;
                let message = new $root.core.money.TransactionDirectDebitDepositLimit();
                if (object.available != null)
                    message.available = Boolean(object.available);
                if (object.message != null)
                    message.message = String(object.message);
                if (object.min_aud_amount != null)
                    message.min_aud_amount = String(object.min_aud_amount);
                if (object.max_aud_amount != null)
                    message.max_aud_amount = String(object.max_aud_amount);
                return message;
            };

            /**
             * Creates a plain object from a TransactionDirectDebitDepositLimit message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @static
             * @param {core.money.TransactionDirectDebitDepositLimit} message TransactionDirectDebitDepositLimit
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TransactionDirectDebitDepositLimit.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.available = false;
                    object.message = "";
                    object.min_aud_amount = "";
                    object.max_aud_amount = "";
                }
                if (message.available != null && message.hasOwnProperty("available"))
                    object.available = message.available;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                if (message.min_aud_amount != null && message.hasOwnProperty("min_aud_amount"))
                    object.min_aud_amount = message.min_aud_amount;
                if (message.max_aud_amount != null && message.hasOwnProperty("max_aud_amount"))
                    object.max_aud_amount = message.max_aud_amount;
                return object;
            };

            /**
             * Converts this TransactionDirectDebitDepositLimit to JSON.
             * @function toJSON
             * @memberof core.money.TransactionDirectDebitDepositLimit
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TransactionDirectDebitDepositLimit.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TransactionDirectDebitDepositLimit;
        })();

        money.TransactionWithdrawalLimit = (function() {

            /**
             * Properties of a TransactionWithdrawalLimit.
             * @memberof core.money
             * @interface ITransactionWithdrawalLimit
             * @property {boolean|null} [available] TransactionWithdrawalLimit available
             * @property {string|null} [message] TransactionWithdrawalLimit message
             * @property {string|null} [min_aud_amount] TransactionWithdrawalLimit min_aud_amount
             * @property {string|null} [max_aud_amount] TransactionWithdrawalLimit max_aud_amount
             */

            /**
             * Constructs a new TransactionWithdrawalLimit.
             * @memberof core.money
             * @classdesc Represents a TransactionWithdrawalLimit.
             * @implements ITransactionWithdrawalLimit
             * @constructor
             * @param {core.money.ITransactionWithdrawalLimit=} [properties] Properties to set
             */
            function TransactionWithdrawalLimit(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TransactionWithdrawalLimit available.
             * @member {boolean} available
             * @memberof core.money.TransactionWithdrawalLimit
             * @instance
             */
            TransactionWithdrawalLimit.prototype.available = false;

            /**
             * TransactionWithdrawalLimit message.
             * @member {string} message
             * @memberof core.money.TransactionWithdrawalLimit
             * @instance
             */
            TransactionWithdrawalLimit.prototype.message = "";

            /**
             * TransactionWithdrawalLimit min_aud_amount.
             * @member {string} min_aud_amount
             * @memberof core.money.TransactionWithdrawalLimit
             * @instance
             */
            TransactionWithdrawalLimit.prototype.min_aud_amount = "";

            /**
             * TransactionWithdrawalLimit max_aud_amount.
             * @member {string} max_aud_amount
             * @memberof core.money.TransactionWithdrawalLimit
             * @instance
             */
            TransactionWithdrawalLimit.prototype.max_aud_amount = "";

            /**
             * Creates a new TransactionWithdrawalLimit instance using the specified properties.
             * @function create
             * @memberof core.money.TransactionWithdrawalLimit
             * @static
             * @param {core.money.ITransactionWithdrawalLimit=} [properties] Properties to set
             * @returns {core.money.TransactionWithdrawalLimit} TransactionWithdrawalLimit instance
             */
            TransactionWithdrawalLimit.create = function create(properties) {
                return new TransactionWithdrawalLimit(properties);
            };

            /**
             * Encodes the specified TransactionWithdrawalLimit message. Does not implicitly {@link core.money.TransactionWithdrawalLimit.verify|verify} messages.
             * @function encode
             * @memberof core.money.TransactionWithdrawalLimit
             * @static
             * @param {core.money.ITransactionWithdrawalLimit} message TransactionWithdrawalLimit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionWithdrawalLimit.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.available != null && message.hasOwnProperty("available"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.available);
                if (message.message != null && message.hasOwnProperty("message"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                if (message.min_aud_amount != null && message.hasOwnProperty("min_aud_amount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.min_aud_amount);
                if (message.max_aud_amount != null && message.hasOwnProperty("max_aud_amount"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.max_aud_amount);
                return writer;
            };

            /**
             * Encodes the specified TransactionWithdrawalLimit message, length delimited. Does not implicitly {@link core.money.TransactionWithdrawalLimit.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.TransactionWithdrawalLimit
             * @static
             * @param {core.money.ITransactionWithdrawalLimit} message TransactionWithdrawalLimit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TransactionWithdrawalLimit.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TransactionWithdrawalLimit message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.TransactionWithdrawalLimit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.TransactionWithdrawalLimit} TransactionWithdrawalLimit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionWithdrawalLimit.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.TransactionWithdrawalLimit();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.available = reader.bool();
                        break;
                    case 2:
                        message.message = reader.string();
                        break;
                    case 3:
                        message.min_aud_amount = reader.string();
                        break;
                    case 4:
                        message.max_aud_amount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TransactionWithdrawalLimit message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.TransactionWithdrawalLimit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.TransactionWithdrawalLimit} TransactionWithdrawalLimit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TransactionWithdrawalLimit.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TransactionWithdrawalLimit message.
             * @function verify
             * @memberof core.money.TransactionWithdrawalLimit
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TransactionWithdrawalLimit.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.available != null && message.hasOwnProperty("available"))
                    if (typeof message.available !== "boolean")
                        return "available: boolean expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                if (message.min_aud_amount != null && message.hasOwnProperty("min_aud_amount"))
                    if (!$util.isString(message.min_aud_amount))
                        return "min_aud_amount: string expected";
                if (message.max_aud_amount != null && message.hasOwnProperty("max_aud_amount"))
                    if (!$util.isString(message.max_aud_amount))
                        return "max_aud_amount: string expected";
                return null;
            };

            /**
             * Creates a TransactionWithdrawalLimit message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.TransactionWithdrawalLimit
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.TransactionWithdrawalLimit} TransactionWithdrawalLimit
             */
            TransactionWithdrawalLimit.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.TransactionWithdrawalLimit)
                    return object;
                let message = new $root.core.money.TransactionWithdrawalLimit();
                if (object.available != null)
                    message.available = Boolean(object.available);
                if (object.message != null)
                    message.message = String(object.message);
                if (object.min_aud_amount != null)
                    message.min_aud_amount = String(object.min_aud_amount);
                if (object.max_aud_amount != null)
                    message.max_aud_amount = String(object.max_aud_amount);
                return message;
            };

            /**
             * Creates a plain object from a TransactionWithdrawalLimit message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.TransactionWithdrawalLimit
             * @static
             * @param {core.money.TransactionWithdrawalLimit} message TransactionWithdrawalLimit
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TransactionWithdrawalLimit.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.available = false;
                    object.message = "";
                    object.min_aud_amount = "";
                    object.max_aud_amount = "";
                }
                if (message.available != null && message.hasOwnProperty("available"))
                    object.available = message.available;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                if (message.min_aud_amount != null && message.hasOwnProperty("min_aud_amount"))
                    object.min_aud_amount = message.min_aud_amount;
                if (message.max_aud_amount != null && message.hasOwnProperty("max_aud_amount"))
                    object.max_aud_amount = message.max_aud_amount;
                return object;
            };

            /**
             * Converts this TransactionWithdrawalLimit to JSON.
             * @function toJSON
             * @memberof core.money.TransactionWithdrawalLimit
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TransactionWithdrawalLimit.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TransactionWithdrawalLimit;
        })();

        money.GetTransactionLimitsRequest = (function() {

            /**
             * Properties of a GetTransactionLimitsRequest.
             * @memberof core.money
             * @interface IGetTransactionLimitsRequest
             * @property {string|null} [account_id] GetTransactionLimitsRequest account_id
             */

            /**
             * Constructs a new GetTransactionLimitsRequest.
             * @memberof core.money
             * @classdesc Represents a GetTransactionLimitsRequest.
             * @implements IGetTransactionLimitsRequest
             * @constructor
             * @param {core.money.IGetTransactionLimitsRequest=} [properties] Properties to set
             */
            function GetTransactionLimitsRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTransactionLimitsRequest account_id.
             * @member {string} account_id
             * @memberof core.money.GetTransactionLimitsRequest
             * @instance
             */
            GetTransactionLimitsRequest.prototype.account_id = "";

            /**
             * Creates a new GetTransactionLimitsRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetTransactionLimitsRequest
             * @static
             * @param {core.money.IGetTransactionLimitsRequest=} [properties] Properties to set
             * @returns {core.money.GetTransactionLimitsRequest} GetTransactionLimitsRequest instance
             */
            GetTransactionLimitsRequest.create = function create(properties) {
                return new GetTransactionLimitsRequest(properties);
            };

            /**
             * Encodes the specified GetTransactionLimitsRequest message. Does not implicitly {@link core.money.GetTransactionLimitsRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetTransactionLimitsRequest
             * @static
             * @param {core.money.IGetTransactionLimitsRequest} message GetTransactionLimitsRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionLimitsRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.account_id);
                return writer;
            };

            /**
             * Encodes the specified GetTransactionLimitsRequest message, length delimited. Does not implicitly {@link core.money.GetTransactionLimitsRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetTransactionLimitsRequest
             * @static
             * @param {core.money.IGetTransactionLimitsRequest} message GetTransactionLimitsRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionLimitsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTransactionLimitsRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetTransactionLimitsRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetTransactionLimitsRequest} GetTransactionLimitsRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionLimitsRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetTransactionLimitsRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.account_id = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTransactionLimitsRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetTransactionLimitsRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetTransactionLimitsRequest} GetTransactionLimitsRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionLimitsRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTransactionLimitsRequest message.
             * @function verify
             * @memberof core.money.GetTransactionLimitsRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTransactionLimitsRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                return null;
            };

            /**
             * Creates a GetTransactionLimitsRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetTransactionLimitsRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetTransactionLimitsRequest} GetTransactionLimitsRequest
             */
            GetTransactionLimitsRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetTransactionLimitsRequest)
                    return object;
                let message = new $root.core.money.GetTransactionLimitsRequest();
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                return message;
            };

            /**
             * Creates a plain object from a GetTransactionLimitsRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetTransactionLimitsRequest
             * @static
             * @param {core.money.GetTransactionLimitsRequest} message GetTransactionLimitsRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTransactionLimitsRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.account_id = "";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                return object;
            };

            /**
             * Converts this GetTransactionLimitsRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetTransactionLimitsRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTransactionLimitsRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTransactionLimitsRequest;
        })();

        money.GetTransactionLimitsResponse = (function() {

            /**
             * Properties of a GetTransactionLimitsResponse.
             * @memberof core.money
             * @interface IGetTransactionLimitsResponse
             * @property {core.money.ITransactionDirectDebitDepositLimit|null} [direct_debit_deposit] GetTransactionLimitsResponse direct_debit_deposit
             * @property {core.money.ITransactionWithdrawalLimit|null} [withdrawal] GetTransactionLimitsResponse withdrawal
             */

            /**
             * Constructs a new GetTransactionLimitsResponse.
             * @memberof core.money
             * @classdesc Represents a GetTransactionLimitsResponse.
             * @implements IGetTransactionLimitsResponse
             * @constructor
             * @param {core.money.IGetTransactionLimitsResponse=} [properties] Properties to set
             */
            function GetTransactionLimitsResponse(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetTransactionLimitsResponse direct_debit_deposit.
             * @member {core.money.ITransactionDirectDebitDepositLimit|null|undefined} direct_debit_deposit
             * @memberof core.money.GetTransactionLimitsResponse
             * @instance
             */
            GetTransactionLimitsResponse.prototype.direct_debit_deposit = null;

            /**
             * GetTransactionLimitsResponse withdrawal.
             * @member {core.money.ITransactionWithdrawalLimit|null|undefined} withdrawal
             * @memberof core.money.GetTransactionLimitsResponse
             * @instance
             */
            GetTransactionLimitsResponse.prototype.withdrawal = null;

            /**
             * Creates a new GetTransactionLimitsResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetTransactionLimitsResponse
             * @static
             * @param {core.money.IGetTransactionLimitsResponse=} [properties] Properties to set
             * @returns {core.money.GetTransactionLimitsResponse} GetTransactionLimitsResponse instance
             */
            GetTransactionLimitsResponse.create = function create(properties) {
                return new GetTransactionLimitsResponse(properties);
            };

            /**
             * Encodes the specified GetTransactionLimitsResponse message. Does not implicitly {@link core.money.GetTransactionLimitsResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetTransactionLimitsResponse
             * @static
             * @param {core.money.IGetTransactionLimitsResponse} message GetTransactionLimitsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionLimitsResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.direct_debit_deposit != null && message.hasOwnProperty("direct_debit_deposit"))
                    $root.core.money.TransactionDirectDebitDepositLimit.encode(message.direct_debit_deposit, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.withdrawal != null && message.hasOwnProperty("withdrawal"))
                    $root.core.money.TransactionWithdrawalLimit.encode(message.withdrawal, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetTransactionLimitsResponse message, length delimited. Does not implicitly {@link core.money.GetTransactionLimitsResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetTransactionLimitsResponse
             * @static
             * @param {core.money.IGetTransactionLimitsResponse} message GetTransactionLimitsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetTransactionLimitsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetTransactionLimitsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetTransactionLimitsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetTransactionLimitsResponse} GetTransactionLimitsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionLimitsResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetTransactionLimitsResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.direct_debit_deposit = $root.core.money.TransactionDirectDebitDepositLimit.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.withdrawal = $root.core.money.TransactionWithdrawalLimit.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetTransactionLimitsResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetTransactionLimitsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetTransactionLimitsResponse} GetTransactionLimitsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetTransactionLimitsResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetTransactionLimitsResponse message.
             * @function verify
             * @memberof core.money.GetTransactionLimitsResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetTransactionLimitsResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.direct_debit_deposit != null && message.hasOwnProperty("direct_debit_deposit")) {
                    let error = $root.core.money.TransactionDirectDebitDepositLimit.verify(message.direct_debit_deposit);
                    if (error)
                        return "direct_debit_deposit." + error;
                }
                if (message.withdrawal != null && message.hasOwnProperty("withdrawal")) {
                    let error = $root.core.money.TransactionWithdrawalLimit.verify(message.withdrawal);
                    if (error)
                        return "withdrawal." + error;
                }
                return null;
            };

            /**
             * Creates a GetTransactionLimitsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetTransactionLimitsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetTransactionLimitsResponse} GetTransactionLimitsResponse
             */
            GetTransactionLimitsResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetTransactionLimitsResponse)
                    return object;
                let message = new $root.core.money.GetTransactionLimitsResponse();
                if (object.direct_debit_deposit != null) {
                    if (typeof object.direct_debit_deposit !== "object")
                        throw TypeError(".core.money.GetTransactionLimitsResponse.direct_debit_deposit: object expected");
                    message.direct_debit_deposit = $root.core.money.TransactionDirectDebitDepositLimit.fromObject(object.direct_debit_deposit);
                }
                if (object.withdrawal != null) {
                    if (typeof object.withdrawal !== "object")
                        throw TypeError(".core.money.GetTransactionLimitsResponse.withdrawal: object expected");
                    message.withdrawal = $root.core.money.TransactionWithdrawalLimit.fromObject(object.withdrawal);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetTransactionLimitsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetTransactionLimitsResponse
             * @static
             * @param {core.money.GetTransactionLimitsResponse} message GetTransactionLimitsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetTransactionLimitsResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.direct_debit_deposit = null;
                    object.withdrawal = null;
                }
                if (message.direct_debit_deposit != null && message.hasOwnProperty("direct_debit_deposit"))
                    object.direct_debit_deposit = $root.core.money.TransactionDirectDebitDepositLimit.toObject(message.direct_debit_deposit, options);
                if (message.withdrawal != null && message.hasOwnProperty("withdrawal"))
                    object.withdrawal = $root.core.money.TransactionWithdrawalLimit.toObject(message.withdrawal, options);
                return object;
            };

            /**
             * Converts this GetTransactionLimitsResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetTransactionLimitsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetTransactionLimitsResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetTransactionLimitsResponse;
        })();

        money.GetPaymentMethodRequest = (function() {

            /**
             * Properties of a GetPaymentMethodRequest.
             * @memberof core.money
             * @interface IGetPaymentMethodRequest
             * @property {string|null} [account_id] GetPaymentMethodRequest account_id
             * @property {core.money.TransactionType.Enum|null} [transaction_type] GetPaymentMethodRequest transaction_type
             * @property {string|null} [aud_amount] GetPaymentMethodRequest aud_amount
             */

            /**
             * Constructs a new GetPaymentMethodRequest.
             * @memberof core.money
             * @classdesc Represents a GetPaymentMethodRequest.
             * @implements IGetPaymentMethodRequest
             * @constructor
             * @param {core.money.IGetPaymentMethodRequest=} [properties] Properties to set
             */
            function GetPaymentMethodRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetPaymentMethodRequest account_id.
             * @member {string} account_id
             * @memberof core.money.GetPaymentMethodRequest
             * @instance
             */
            GetPaymentMethodRequest.prototype.account_id = "";

            /**
             * GetPaymentMethodRequest transaction_type.
             * @member {core.money.TransactionType.Enum} transaction_type
             * @memberof core.money.GetPaymentMethodRequest
             * @instance
             */
            GetPaymentMethodRequest.prototype.transaction_type = 0;

            /**
             * GetPaymentMethodRequest aud_amount.
             * @member {string} aud_amount
             * @memberof core.money.GetPaymentMethodRequest
             * @instance
             */
            GetPaymentMethodRequest.prototype.aud_amount = "";

            /**
             * Creates a new GetPaymentMethodRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetPaymentMethodRequest
             * @static
             * @param {core.money.IGetPaymentMethodRequest=} [properties] Properties to set
             * @returns {core.money.GetPaymentMethodRequest} GetPaymentMethodRequest instance
             */
            GetPaymentMethodRequest.create = function create(properties) {
                return new GetPaymentMethodRequest(properties);
            };

            /**
             * Encodes the specified GetPaymentMethodRequest message. Does not implicitly {@link core.money.GetPaymentMethodRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetPaymentMethodRequest
             * @static
             * @param {core.money.IGetPaymentMethodRequest} message GetPaymentMethodRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPaymentMethodRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.account_id);
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.transaction_type);
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.aud_amount);
                return writer;
            };

            /**
             * Encodes the specified GetPaymentMethodRequest message, length delimited. Does not implicitly {@link core.money.GetPaymentMethodRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetPaymentMethodRequest
             * @static
             * @param {core.money.IGetPaymentMethodRequest} message GetPaymentMethodRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPaymentMethodRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetPaymentMethodRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetPaymentMethodRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetPaymentMethodRequest} GetPaymentMethodRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPaymentMethodRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetPaymentMethodRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.account_id = reader.string();
                        break;
                    case 2:
                        message.transaction_type = reader.int32();
                        break;
                    case 3:
                        message.aud_amount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetPaymentMethodRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetPaymentMethodRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetPaymentMethodRequest} GetPaymentMethodRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPaymentMethodRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetPaymentMethodRequest message.
             * @function verify
             * @memberof core.money.GetPaymentMethodRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetPaymentMethodRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    switch (message.transaction_type) {
                    default:
                        return "transaction_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                        break;
                    }
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    if (!$util.isString(message.aud_amount))
                        return "aud_amount: string expected";
                return null;
            };

            /**
             * Creates a GetPaymentMethodRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetPaymentMethodRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetPaymentMethodRequest} GetPaymentMethodRequest
             */
            GetPaymentMethodRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetPaymentMethodRequest)
                    return object;
                let message = new $root.core.money.GetPaymentMethodRequest();
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                switch (object.transaction_type) {
                case "UNKNOWN":
                case 0:
                    message.transaction_type = 0;
                    break;
                case "USER_DEPOSIT":
                case 1:
                    message.transaction_type = 1;
                    break;
                case "VOYAGER_SALE":
                case 2:
                    message.transaction_type = 2;
                    break;
                case "NOVA_SALE":
                case 3:
                    message.transaction_type = 3;
                    break;
                case "NOVA_DIVIDEND":
                case 4:
                    message.transaction_type = 4;
                    break;
                case "VOYAGER_DISTRIBUTION":
                case 5:
                    message.transaction_type = 5;
                    break;
                case "USER_WITHDRAWAL":
                case 6:
                    message.transaction_type = 6;
                    break;
                case "VOYAGER_PURCHASE":
                case 7:
                    message.transaction_type = 7;
                    break;
                case "NOVA_PURCHASE":
                case 8:
                    message.transaction_type = 8;
                    break;
                case "VOYAGER_MONTHLY_FEE":
                case 9:
                    message.transaction_type = 9;
                    break;
                case "OTHER":
                case 10:
                    message.transaction_type = 10;
                    break;
                case "NOVA_REG_FEE":
                case 11:
                    message.transaction_type = 11;
                    break;
                case "NOVA_MONTHLY_FEE":
                case 12:
                    message.transaction_type = 12;
                    break;
                case "NOVA_MERGER_ACQUISITIONS":
                case 13:
                    message.transaction_type = 13;
                    break;
                case "VOYAGER_BOOST":
                case 14:
                    message.transaction_type = 14;
                    break;
                case "NOVA_TAF_FEE":
                case 15:
                    message.transaction_type = 15;
                    break;
                case "USER_DEPOSIT_REVERSAL":
                case 16:
                    message.transaction_type = 16;
                    break;
                case "USER_WITHDRAWAL_REVERSAL":
                case 17:
                    message.transaction_type = 17;
                    break;
                }
                if (object.aud_amount != null)
                    message.aud_amount = String(object.aud_amount);
                return message;
            };

            /**
             * Creates a plain object from a GetPaymentMethodRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetPaymentMethodRequest
             * @static
             * @param {core.money.GetPaymentMethodRequest} message GetPaymentMethodRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetPaymentMethodRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.account_id = "";
                    object.transaction_type = options.enums === String ? "UNKNOWN" : 0;
                    object.aud_amount = "";
                }
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                if (message.transaction_type != null && message.hasOwnProperty("transaction_type"))
                    object.transaction_type = options.enums === String ? $root.core.money.TransactionType.Enum[message.transaction_type] : message.transaction_type;
                if (message.aud_amount != null && message.hasOwnProperty("aud_amount"))
                    object.aud_amount = message.aud_amount;
                return object;
            };

            /**
             * Converts this GetPaymentMethodRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetPaymentMethodRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetPaymentMethodRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetPaymentMethodRequest;
        })();

        money.GetPaymentMethodResponse = (function() {

            /**
             * Properties of a GetPaymentMethodResponse.
             * @memberof core.money
             * @interface IGetPaymentMethodResponse
             * @property {core.money.PaymentMethod.Enum|null} [payment_method] GetPaymentMethodResponse payment_method
             */

            /**
             * Constructs a new GetPaymentMethodResponse.
             * @memberof core.money
             * @classdesc Represents a GetPaymentMethodResponse.
             * @implements IGetPaymentMethodResponse
             * @constructor
             * @param {core.money.IGetPaymentMethodResponse=} [properties] Properties to set
             */
            function GetPaymentMethodResponse(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetPaymentMethodResponse payment_method.
             * @member {core.money.PaymentMethod.Enum} payment_method
             * @memberof core.money.GetPaymentMethodResponse
             * @instance
             */
            GetPaymentMethodResponse.prototype.payment_method = 0;

            /**
             * Creates a new GetPaymentMethodResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetPaymentMethodResponse
             * @static
             * @param {core.money.IGetPaymentMethodResponse=} [properties] Properties to set
             * @returns {core.money.GetPaymentMethodResponse} GetPaymentMethodResponse instance
             */
            GetPaymentMethodResponse.create = function create(properties) {
                return new GetPaymentMethodResponse(properties);
            };

            /**
             * Encodes the specified GetPaymentMethodResponse message. Does not implicitly {@link core.money.GetPaymentMethodResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetPaymentMethodResponse
             * @static
             * @param {core.money.IGetPaymentMethodResponse} message GetPaymentMethodResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPaymentMethodResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.payment_method);
                return writer;
            };

            /**
             * Encodes the specified GetPaymentMethodResponse message, length delimited. Does not implicitly {@link core.money.GetPaymentMethodResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetPaymentMethodResponse
             * @static
             * @param {core.money.IGetPaymentMethodResponse} message GetPaymentMethodResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetPaymentMethodResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetPaymentMethodResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetPaymentMethodResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetPaymentMethodResponse} GetPaymentMethodResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPaymentMethodResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetPaymentMethodResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.payment_method = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetPaymentMethodResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetPaymentMethodResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetPaymentMethodResponse} GetPaymentMethodResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetPaymentMethodResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetPaymentMethodResponse message.
             * @function verify
             * @memberof core.money.GetPaymentMethodResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetPaymentMethodResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    switch (message.payment_method) {
                    default:
                        return "payment_method: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a GetPaymentMethodResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetPaymentMethodResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetPaymentMethodResponse} GetPaymentMethodResponse
             */
            GetPaymentMethodResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetPaymentMethodResponse)
                    return object;
                let message = new $root.core.money.GetPaymentMethodResponse();
                switch (object.payment_method) {
                case "UNKNOWN":
                case 0:
                    message.payment_method = 0;
                    break;
                case "MONEY":
                case 1:
                    message.payment_method = 1;
                    break;
                case "DIRECT_ENTRY":
                case 2:
                    message.payment_method = 2;
                    break;
                case "PAYTO":
                case 3:
                    message.payment_method = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a GetPaymentMethodResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetPaymentMethodResponse
             * @static
             * @param {core.money.GetPaymentMethodResponse} message GetPaymentMethodResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetPaymentMethodResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.payment_method = options.enums === String ? "UNKNOWN" : 0;
                if (message.payment_method != null && message.hasOwnProperty("payment_method"))
                    object.payment_method = options.enums === String ? $root.core.money.PaymentMethod.Enum[message.payment_method] : message.payment_method;
                return object;
            };

            /**
             * Converts this GetPaymentMethodResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetPaymentMethodResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetPaymentMethodResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetPaymentMethodResponse;
        })();

        money.GetReconciliationDataByAccountIDRequest = (function() {

            /**
             * Properties of a GetReconciliationDataByAccountIDRequest.
             * @memberof core.money
             * @interface IGetReconciliationDataByAccountIDRequest
             * @property {string|null} [account_id] GetReconciliationDataByAccountIDRequest account_id
             * @property {IDateFilter|null} [date_filter] GetReconciliationDataByAccountIDRequest date_filter
             */

            /**
             * Constructs a new GetReconciliationDataByAccountIDRequest.
             * @memberof core.money
             * @classdesc Represents a GetReconciliationDataByAccountIDRequest.
             * @implements IGetReconciliationDataByAccountIDRequest
             * @constructor
             * @param {core.money.IGetReconciliationDataByAccountIDRequest=} [properties] Properties to set
             */
            function GetReconciliationDataByAccountIDRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetReconciliationDataByAccountIDRequest account_id.
             * @member {string} account_id
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @instance
             */
            GetReconciliationDataByAccountIDRequest.prototype.account_id = "";

            /**
             * GetReconciliationDataByAccountIDRequest date_filter.
             * @member {IDateFilter|null|undefined} date_filter
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @instance
             */
            GetReconciliationDataByAccountIDRequest.prototype.date_filter = null;

            /**
             * Creates a new GetReconciliationDataByAccountIDRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @static
             * @param {core.money.IGetReconciliationDataByAccountIDRequest=} [properties] Properties to set
             * @returns {core.money.GetReconciliationDataByAccountIDRequest} GetReconciliationDataByAccountIDRequest instance
             */
            GetReconciliationDataByAccountIDRequest.create = function create(properties) {
                return new GetReconciliationDataByAccountIDRequest(properties);
            };

            /**
             * Encodes the specified GetReconciliationDataByAccountIDRequest message. Does not implicitly {@link core.money.GetReconciliationDataByAccountIDRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @static
             * @param {core.money.IGetReconciliationDataByAccountIDRequest} message GetReconciliationDataByAccountIDRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReconciliationDataByAccountIDRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.account_id);
                if (message.date_filter != null && message.hasOwnProperty("date_filter"))
                    $root.DateFilter.encode(message.date_filter, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetReconciliationDataByAccountIDRequest message, length delimited. Does not implicitly {@link core.money.GetReconciliationDataByAccountIDRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @static
             * @param {core.money.IGetReconciliationDataByAccountIDRequest} message GetReconciliationDataByAccountIDRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReconciliationDataByAccountIDRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetReconciliationDataByAccountIDRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetReconciliationDataByAccountIDRequest} GetReconciliationDataByAccountIDRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReconciliationDataByAccountIDRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetReconciliationDataByAccountIDRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.account_id = reader.string();
                        break;
                    case 2:
                        message.date_filter = $root.DateFilter.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetReconciliationDataByAccountIDRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetReconciliationDataByAccountIDRequest} GetReconciliationDataByAccountIDRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReconciliationDataByAccountIDRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetReconciliationDataByAccountIDRequest message.
             * @function verify
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetReconciliationDataByAccountIDRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                if (message.date_filter != null && message.hasOwnProperty("date_filter")) {
                    let error = $root.DateFilter.verify(message.date_filter);
                    if (error)
                        return "date_filter." + error;
                }
                return null;
            };

            /**
             * Creates a GetReconciliationDataByAccountIDRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetReconciliationDataByAccountIDRequest} GetReconciliationDataByAccountIDRequest
             */
            GetReconciliationDataByAccountIDRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetReconciliationDataByAccountIDRequest)
                    return object;
                let message = new $root.core.money.GetReconciliationDataByAccountIDRequest();
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                if (object.date_filter != null) {
                    if (typeof object.date_filter !== "object")
                        throw TypeError(".core.money.GetReconciliationDataByAccountIDRequest.date_filter: object expected");
                    message.date_filter = $root.DateFilter.fromObject(object.date_filter);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetReconciliationDataByAccountIDRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @static
             * @param {core.money.GetReconciliationDataByAccountIDRequest} message GetReconciliationDataByAccountIDRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetReconciliationDataByAccountIDRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.account_id = "";
                    object.date_filter = null;
                }
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                if (message.date_filter != null && message.hasOwnProperty("date_filter"))
                    object.date_filter = $root.DateFilter.toObject(message.date_filter, options);
                return object;
            };

            /**
             * Converts this GetReconciliationDataByAccountIDRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetReconciliationDataByAccountIDRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetReconciliationDataByAccountIDRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetReconciliationDataByAccountIDRequest;
        })();

        money.ReconciliationData = (function() {

            /**
             * Properties of a ReconciliationData.
             * @memberof core.money
             * @interface IReconciliationData
             * @property {string|null} [date] ReconciliationData date
             * @property {number|Long|null} [transaction_count] ReconciliationData transaction_count
             * @property {string|null} [aud_value] ReconciliationData aud_value
             * @property {string|null} [debits] ReconciliationData debits
             * @property {string|null} [credits] ReconciliationData credits
             * @property {string|null} [opening_balance] ReconciliationData opening_balance
             * @property {string|null} [closing_balance] ReconciliationData closing_balance
             * @property {string|null} [zepto_closing_balance] ReconciliationData zepto_closing_balance
             * @property {core.money.ReconciliationStatus.Enum|null} [status] ReconciliationData status
             * @property {Array.<string>|null} [comments] ReconciliationData comments
             */

            /**
             * Constructs a new ReconciliationData.
             * @memberof core.money
             * @classdesc Represents a ReconciliationData.
             * @implements IReconciliationData
             * @constructor
             * @param {core.money.IReconciliationData=} [properties] Properties to set
             */
            function ReconciliationData(properties) {
                this.comments = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReconciliationData date.
             * @member {string} date
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.date = "";

            /**
             * ReconciliationData transaction_count.
             * @member {number|Long} transaction_count
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.transaction_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * ReconciliationData aud_value.
             * @member {string} aud_value
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.aud_value = "";

            /**
             * ReconciliationData debits.
             * @member {string} debits
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.debits = "";

            /**
             * ReconciliationData credits.
             * @member {string} credits
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.credits = "";

            /**
             * ReconciliationData opening_balance.
             * @member {string} opening_balance
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.opening_balance = "";

            /**
             * ReconciliationData closing_balance.
             * @member {string} closing_balance
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.closing_balance = "";

            /**
             * ReconciliationData zepto_closing_balance.
             * @member {string} zepto_closing_balance
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.zepto_closing_balance = "";

            /**
             * ReconciliationData status.
             * @member {core.money.ReconciliationStatus.Enum} status
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.status = 0;

            /**
             * ReconciliationData comments.
             * @member {Array.<string>} comments
             * @memberof core.money.ReconciliationData
             * @instance
             */
            ReconciliationData.prototype.comments = $util.emptyArray;

            /**
             * Creates a new ReconciliationData instance using the specified properties.
             * @function create
             * @memberof core.money.ReconciliationData
             * @static
             * @param {core.money.IReconciliationData=} [properties] Properties to set
             * @returns {core.money.ReconciliationData} ReconciliationData instance
             */
            ReconciliationData.create = function create(properties) {
                return new ReconciliationData(properties);
            };

            /**
             * Encodes the specified ReconciliationData message. Does not implicitly {@link core.money.ReconciliationData.verify|verify} messages.
             * @function encode
             * @memberof core.money.ReconciliationData
             * @static
             * @param {core.money.IReconciliationData} message ReconciliationData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReconciliationData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.date != null && message.hasOwnProperty("date"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.date);
                if (message.transaction_count != null && message.hasOwnProperty("transaction_count"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.transaction_count);
                if (message.aud_value != null && message.hasOwnProperty("aud_value"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.aud_value);
                if (message.debits != null && message.hasOwnProperty("debits"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.debits);
                if (message.credits != null && message.hasOwnProperty("credits"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.credits);
                if (message.opening_balance != null && message.hasOwnProperty("opening_balance"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.opening_balance);
                if (message.closing_balance != null && message.hasOwnProperty("closing_balance"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.closing_balance);
                if (message.status != null && message.hasOwnProperty("status"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
                if (message.comments != null && message.comments.length)
                    for (let i = 0; i < message.comments.length; ++i)
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.comments[i]);
                if (message.zepto_closing_balance != null && message.hasOwnProperty("zepto_closing_balance"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.zepto_closing_balance);
                return writer;
            };

            /**
             * Encodes the specified ReconciliationData message, length delimited. Does not implicitly {@link core.money.ReconciliationData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.ReconciliationData
             * @static
             * @param {core.money.IReconciliationData} message ReconciliationData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReconciliationData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReconciliationData message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.ReconciliationData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.ReconciliationData} ReconciliationData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReconciliationData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.ReconciliationData();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.date = reader.string();
                        break;
                    case 2:
                        message.transaction_count = reader.int64();
                        break;
                    case 3:
                        message.aud_value = reader.string();
                        break;
                    case 4:
                        message.debits = reader.string();
                        break;
                    case 5:
                        message.credits = reader.string();
                        break;
                    case 6:
                        message.opening_balance = reader.string();
                        break;
                    case 7:
                        message.closing_balance = reader.string();
                        break;
                    case 10:
                        message.zepto_closing_balance = reader.string();
                        break;
                    case 8:
                        message.status = reader.int32();
                        break;
                    case 9:
                        if (!(message.comments && message.comments.length))
                            message.comments = [];
                        message.comments.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReconciliationData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.ReconciliationData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.ReconciliationData} ReconciliationData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReconciliationData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReconciliationData message.
             * @function verify
             * @memberof core.money.ReconciliationData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReconciliationData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.transaction_count != null && message.hasOwnProperty("transaction_count"))
                    if (!$util.isInteger(message.transaction_count) && !(message.transaction_count && $util.isInteger(message.transaction_count.low) && $util.isInteger(message.transaction_count.high)))
                        return "transaction_count: integer|Long expected";
                if (message.aud_value != null && message.hasOwnProperty("aud_value"))
                    if (!$util.isString(message.aud_value))
                        return "aud_value: string expected";
                if (message.debits != null && message.hasOwnProperty("debits"))
                    if (!$util.isString(message.debits))
                        return "debits: string expected";
                if (message.credits != null && message.hasOwnProperty("credits"))
                    if (!$util.isString(message.credits))
                        return "credits: string expected";
                if (message.opening_balance != null && message.hasOwnProperty("opening_balance"))
                    if (!$util.isString(message.opening_balance))
                        return "opening_balance: string expected";
                if (message.closing_balance != null && message.hasOwnProperty("closing_balance"))
                    if (!$util.isString(message.closing_balance))
                        return "closing_balance: string expected";
                if (message.zepto_closing_balance != null && message.hasOwnProperty("zepto_closing_balance"))
                    if (!$util.isString(message.zepto_closing_balance))
                        return "zepto_closing_balance: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.comments != null && message.hasOwnProperty("comments")) {
                    if (!Array.isArray(message.comments))
                        return "comments: array expected";
                    for (let i = 0; i < message.comments.length; ++i)
                        if (!$util.isString(message.comments[i]))
                            return "comments: string[] expected";
                }
                return null;
            };

            /**
             * Creates a ReconciliationData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.ReconciliationData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.ReconciliationData} ReconciliationData
             */
            ReconciliationData.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.ReconciliationData)
                    return object;
                let message = new $root.core.money.ReconciliationData();
                if (object.date != null)
                    message.date = String(object.date);
                if (object.transaction_count != null)
                    if ($util.Long)
                        (message.transaction_count = $util.Long.fromValue(object.transaction_count)).unsigned = false;
                    else if (typeof object.transaction_count === "string")
                        message.transaction_count = parseInt(object.transaction_count, 10);
                    else if (typeof object.transaction_count === "number")
                        message.transaction_count = object.transaction_count;
                    else if (typeof object.transaction_count === "object")
                        message.transaction_count = new $util.LongBits(object.transaction_count.low >>> 0, object.transaction_count.high >>> 0).toNumber();
                if (object.aud_value != null)
                    message.aud_value = String(object.aud_value);
                if (object.debits != null)
                    message.debits = String(object.debits);
                if (object.credits != null)
                    message.credits = String(object.credits);
                if (object.opening_balance != null)
                    message.opening_balance = String(object.opening_balance);
                if (object.closing_balance != null)
                    message.closing_balance = String(object.closing_balance);
                if (object.zepto_closing_balance != null)
                    message.zepto_closing_balance = String(object.zepto_closing_balance);
                switch (object.status) {
                case "UNKNOWN":
                case 0:
                    message.status = 0;
                    break;
                case "PENDING":
                case 1:
                    message.status = 1;
                    break;
                case "SUCCEEDED":
                case 2:
                    message.status = 2;
                    break;
                case "FAILED":
                case 3:
                    message.status = 3;
                    break;
                }
                if (object.comments) {
                    if (!Array.isArray(object.comments))
                        throw TypeError(".core.money.ReconciliationData.comments: array expected");
                    message.comments = [];
                    for (let i = 0; i < object.comments.length; ++i)
                        message.comments[i] = String(object.comments[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a ReconciliationData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.ReconciliationData
             * @static
             * @param {core.money.ReconciliationData} message ReconciliationData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReconciliationData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.comments = [];
                if (options.defaults) {
                    object.date = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.transaction_count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.transaction_count = options.longs === String ? "0" : 0;
                    object.aud_value = "";
                    object.debits = "";
                    object.credits = "";
                    object.opening_balance = "";
                    object.closing_balance = "";
                    object.status = options.enums === String ? "UNKNOWN" : 0;
                    object.zepto_closing_balance = "";
                }
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.transaction_count != null && message.hasOwnProperty("transaction_count"))
                    if (typeof message.transaction_count === "number")
                        object.transaction_count = options.longs === String ? String(message.transaction_count) : message.transaction_count;
                    else
                        object.transaction_count = options.longs === String ? $util.Long.prototype.toString.call(message.transaction_count) : options.longs === Number ? new $util.LongBits(message.transaction_count.low >>> 0, message.transaction_count.high >>> 0).toNumber() : message.transaction_count;
                if (message.aud_value != null && message.hasOwnProperty("aud_value"))
                    object.aud_value = message.aud_value;
                if (message.debits != null && message.hasOwnProperty("debits"))
                    object.debits = message.debits;
                if (message.credits != null && message.hasOwnProperty("credits"))
                    object.credits = message.credits;
                if (message.opening_balance != null && message.hasOwnProperty("opening_balance"))
                    object.opening_balance = message.opening_balance;
                if (message.closing_balance != null && message.hasOwnProperty("closing_balance"))
                    object.closing_balance = message.closing_balance;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.core.money.ReconciliationStatus.Enum[message.status] : message.status;
                if (message.comments && message.comments.length) {
                    object.comments = [];
                    for (let j = 0; j < message.comments.length; ++j)
                        object.comments[j] = message.comments[j];
                }
                if (message.zepto_closing_balance != null && message.hasOwnProperty("zepto_closing_balance"))
                    object.zepto_closing_balance = message.zepto_closing_balance;
                return object;
            };

            /**
             * Converts this ReconciliationData to JSON.
             * @function toJSON
             * @memberof core.money.ReconciliationData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReconciliationData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReconciliationData;
        })();

        money.GetReconciliationDataByAccountIDResponse = (function() {

            /**
             * Properties of a GetReconciliationDataByAccountIDResponse.
             * @memberof core.money
             * @interface IGetReconciliationDataByAccountIDResponse
             * @property {Array.<core.money.IReconciliationData>|null} [reconciliation_data] GetReconciliationDataByAccountIDResponse reconciliation_data
             */

            /**
             * Constructs a new GetReconciliationDataByAccountIDResponse.
             * @memberof core.money
             * @classdesc Represents a GetReconciliationDataByAccountIDResponse.
             * @implements IGetReconciliationDataByAccountIDResponse
             * @constructor
             * @param {core.money.IGetReconciliationDataByAccountIDResponse=} [properties] Properties to set
             */
            function GetReconciliationDataByAccountIDResponse(properties) {
                this.reconciliation_data = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetReconciliationDataByAccountIDResponse reconciliation_data.
             * @member {Array.<core.money.IReconciliationData>} reconciliation_data
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @instance
             */
            GetReconciliationDataByAccountIDResponse.prototype.reconciliation_data = $util.emptyArray;

            /**
             * Creates a new GetReconciliationDataByAccountIDResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @static
             * @param {core.money.IGetReconciliationDataByAccountIDResponse=} [properties] Properties to set
             * @returns {core.money.GetReconciliationDataByAccountIDResponse} GetReconciliationDataByAccountIDResponse instance
             */
            GetReconciliationDataByAccountIDResponse.create = function create(properties) {
                return new GetReconciliationDataByAccountIDResponse(properties);
            };

            /**
             * Encodes the specified GetReconciliationDataByAccountIDResponse message. Does not implicitly {@link core.money.GetReconciliationDataByAccountIDResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @static
             * @param {core.money.IGetReconciliationDataByAccountIDResponse} message GetReconciliationDataByAccountIDResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReconciliationDataByAccountIDResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.reconciliation_data != null && message.reconciliation_data.length)
                    for (let i = 0; i < message.reconciliation_data.length; ++i)
                        $root.core.money.ReconciliationData.encode(message.reconciliation_data[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetReconciliationDataByAccountIDResponse message, length delimited. Does not implicitly {@link core.money.GetReconciliationDataByAccountIDResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @static
             * @param {core.money.IGetReconciliationDataByAccountIDResponse} message GetReconciliationDataByAccountIDResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReconciliationDataByAccountIDResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetReconciliationDataByAccountIDResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetReconciliationDataByAccountIDResponse} GetReconciliationDataByAccountIDResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReconciliationDataByAccountIDResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetReconciliationDataByAccountIDResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.reconciliation_data && message.reconciliation_data.length))
                            message.reconciliation_data = [];
                        message.reconciliation_data.push($root.core.money.ReconciliationData.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetReconciliationDataByAccountIDResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetReconciliationDataByAccountIDResponse} GetReconciliationDataByAccountIDResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReconciliationDataByAccountIDResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetReconciliationDataByAccountIDResponse message.
             * @function verify
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetReconciliationDataByAccountIDResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.reconciliation_data != null && message.hasOwnProperty("reconciliation_data")) {
                    if (!Array.isArray(message.reconciliation_data))
                        return "reconciliation_data: array expected";
                    for (let i = 0; i < message.reconciliation_data.length; ++i) {
                        let error = $root.core.money.ReconciliationData.verify(message.reconciliation_data[i]);
                        if (error)
                            return "reconciliation_data." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetReconciliationDataByAccountIDResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetReconciliationDataByAccountIDResponse} GetReconciliationDataByAccountIDResponse
             */
            GetReconciliationDataByAccountIDResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetReconciliationDataByAccountIDResponse)
                    return object;
                let message = new $root.core.money.GetReconciliationDataByAccountIDResponse();
                if (object.reconciliation_data) {
                    if (!Array.isArray(object.reconciliation_data))
                        throw TypeError(".core.money.GetReconciliationDataByAccountIDResponse.reconciliation_data: array expected");
                    message.reconciliation_data = [];
                    for (let i = 0; i < object.reconciliation_data.length; ++i) {
                        if (typeof object.reconciliation_data[i] !== "object")
                            throw TypeError(".core.money.GetReconciliationDataByAccountIDResponse.reconciliation_data: object expected");
                        message.reconciliation_data[i] = $root.core.money.ReconciliationData.fromObject(object.reconciliation_data[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetReconciliationDataByAccountIDResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @static
             * @param {core.money.GetReconciliationDataByAccountIDResponse} message GetReconciliationDataByAccountIDResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetReconciliationDataByAccountIDResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.reconciliation_data = [];
                if (message.reconciliation_data && message.reconciliation_data.length) {
                    object.reconciliation_data = [];
                    for (let j = 0; j < message.reconciliation_data.length; ++j)
                        object.reconciliation_data[j] = $root.core.money.ReconciliationData.toObject(message.reconciliation_data[j], options);
                }
                return object;
            };

            /**
             * Converts this GetReconciliationDataByAccountIDResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetReconciliationDataByAccountIDResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetReconciliationDataByAccountIDResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetReconciliationDataByAccountIDResponse;
        })();

        money.ReconciliationStatus = (function() {

            /**
             * Properties of a ReconciliationStatus.
             * @memberof core.money
             * @interface IReconciliationStatus
             */

            /**
             * Constructs a new ReconciliationStatus.
             * @memberof core.money
             * @classdesc Represents a ReconciliationStatus.
             * @implements IReconciliationStatus
             * @constructor
             * @param {core.money.IReconciliationStatus=} [properties] Properties to set
             */
            function ReconciliationStatus(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ReconciliationStatus instance using the specified properties.
             * @function create
             * @memberof core.money.ReconciliationStatus
             * @static
             * @param {core.money.IReconciliationStatus=} [properties] Properties to set
             * @returns {core.money.ReconciliationStatus} ReconciliationStatus instance
             */
            ReconciliationStatus.create = function create(properties) {
                return new ReconciliationStatus(properties);
            };

            /**
             * Encodes the specified ReconciliationStatus message. Does not implicitly {@link core.money.ReconciliationStatus.verify|verify} messages.
             * @function encode
             * @memberof core.money.ReconciliationStatus
             * @static
             * @param {core.money.IReconciliationStatus} message ReconciliationStatus message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReconciliationStatus.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ReconciliationStatus message, length delimited. Does not implicitly {@link core.money.ReconciliationStatus.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.ReconciliationStatus
             * @static
             * @param {core.money.IReconciliationStatus} message ReconciliationStatus message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReconciliationStatus.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReconciliationStatus message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.ReconciliationStatus
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.ReconciliationStatus} ReconciliationStatus
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReconciliationStatus.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.ReconciliationStatus();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReconciliationStatus message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.ReconciliationStatus
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.ReconciliationStatus} ReconciliationStatus
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReconciliationStatus.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReconciliationStatus message.
             * @function verify
             * @memberof core.money.ReconciliationStatus
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReconciliationStatus.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a ReconciliationStatus message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.ReconciliationStatus
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.ReconciliationStatus} ReconciliationStatus
             */
            ReconciliationStatus.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.ReconciliationStatus)
                    return object;
                return new $root.core.money.ReconciliationStatus();
            };

            /**
             * Creates a plain object from a ReconciliationStatus message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.ReconciliationStatus
             * @static
             * @param {core.money.ReconciliationStatus} message ReconciliationStatus
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReconciliationStatus.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ReconciliationStatus to JSON.
             * @function toJSON
             * @memberof core.money.ReconciliationStatus
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReconciliationStatus.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Enum enum.
             * @name core.money.ReconciliationStatus.Enum
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} PENDING=1 PENDING value
             * @property {number} SUCCEEDED=2 SUCCEEDED value
             * @property {number} FAILED=3 FAILED value
             */
            ReconciliationStatus.Enum = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "PENDING"] = 1;
                values[valuesById[2] = "SUCCEEDED"] = 2;
                values[valuesById[3] = "FAILED"] = 3;
                return values;
            })();

            return ReconciliationStatus;
        })();

        money.GetReconciliationDataRequest = (function() {

            /**
             * Properties of a GetReconciliationDataRequest.
             * @memberof core.money
             * @interface IGetReconciliationDataRequest
             * @property {IDateFilter|null} [date_filter] GetReconciliationDataRequest date_filter
             */

            /**
             * Constructs a new GetReconciliationDataRequest.
             * @memberof core.money
             * @classdesc Represents a GetReconciliationDataRequest.
             * @implements IGetReconciliationDataRequest
             * @constructor
             * @param {core.money.IGetReconciliationDataRequest=} [properties] Properties to set
             */
            function GetReconciliationDataRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetReconciliationDataRequest date_filter.
             * @member {IDateFilter|null|undefined} date_filter
             * @memberof core.money.GetReconciliationDataRequest
             * @instance
             */
            GetReconciliationDataRequest.prototype.date_filter = null;

            /**
             * Creates a new GetReconciliationDataRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetReconciliationDataRequest
             * @static
             * @param {core.money.IGetReconciliationDataRequest=} [properties] Properties to set
             * @returns {core.money.GetReconciliationDataRequest} GetReconciliationDataRequest instance
             */
            GetReconciliationDataRequest.create = function create(properties) {
                return new GetReconciliationDataRequest(properties);
            };

            /**
             * Encodes the specified GetReconciliationDataRequest message. Does not implicitly {@link core.money.GetReconciliationDataRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetReconciliationDataRequest
             * @static
             * @param {core.money.IGetReconciliationDataRequest} message GetReconciliationDataRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReconciliationDataRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.date_filter != null && message.hasOwnProperty("date_filter"))
                    $root.DateFilter.encode(message.date_filter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetReconciliationDataRequest message, length delimited. Does not implicitly {@link core.money.GetReconciliationDataRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetReconciliationDataRequest
             * @static
             * @param {core.money.IGetReconciliationDataRequest} message GetReconciliationDataRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReconciliationDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetReconciliationDataRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetReconciliationDataRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetReconciliationDataRequest} GetReconciliationDataRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReconciliationDataRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetReconciliationDataRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.date_filter = $root.DateFilter.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetReconciliationDataRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetReconciliationDataRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetReconciliationDataRequest} GetReconciliationDataRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReconciliationDataRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetReconciliationDataRequest message.
             * @function verify
             * @memberof core.money.GetReconciliationDataRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetReconciliationDataRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.date_filter != null && message.hasOwnProperty("date_filter")) {
                    let error = $root.DateFilter.verify(message.date_filter);
                    if (error)
                        return "date_filter." + error;
                }
                return null;
            };

            /**
             * Creates a GetReconciliationDataRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetReconciliationDataRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetReconciliationDataRequest} GetReconciliationDataRequest
             */
            GetReconciliationDataRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetReconciliationDataRequest)
                    return object;
                let message = new $root.core.money.GetReconciliationDataRequest();
                if (object.date_filter != null) {
                    if (typeof object.date_filter !== "object")
                        throw TypeError(".core.money.GetReconciliationDataRequest.date_filter: object expected");
                    message.date_filter = $root.DateFilter.fromObject(object.date_filter);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetReconciliationDataRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetReconciliationDataRequest
             * @static
             * @param {core.money.GetReconciliationDataRequest} message GetReconciliationDataRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetReconciliationDataRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.date_filter = null;
                if (message.date_filter != null && message.hasOwnProperty("date_filter"))
                    object.date_filter = $root.DateFilter.toObject(message.date_filter, options);
                return object;
            };

            /**
             * Converts this GetReconciliationDataRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetReconciliationDataRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetReconciliationDataRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetReconciliationDataRequest;
        })();

        money.GetReconciliationDataResponse = (function() {

            /**
             * Properties of a GetReconciliationDataResponse.
             * @memberof core.money
             * @interface IGetReconciliationDataResponse
             * @property {Array.<core.money.IReconciliationData>|null} [reconciliation_data] GetReconciliationDataResponse reconciliation_data
             */

            /**
             * Constructs a new GetReconciliationDataResponse.
             * @memberof core.money
             * @classdesc Represents a GetReconciliationDataResponse.
             * @implements IGetReconciliationDataResponse
             * @constructor
             * @param {core.money.IGetReconciliationDataResponse=} [properties] Properties to set
             */
            function GetReconciliationDataResponse(properties) {
                this.reconciliation_data = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetReconciliationDataResponse reconciliation_data.
             * @member {Array.<core.money.IReconciliationData>} reconciliation_data
             * @memberof core.money.GetReconciliationDataResponse
             * @instance
             */
            GetReconciliationDataResponse.prototype.reconciliation_data = $util.emptyArray;

            /**
             * Creates a new GetReconciliationDataResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetReconciliationDataResponse
             * @static
             * @param {core.money.IGetReconciliationDataResponse=} [properties] Properties to set
             * @returns {core.money.GetReconciliationDataResponse} GetReconciliationDataResponse instance
             */
            GetReconciliationDataResponse.create = function create(properties) {
                return new GetReconciliationDataResponse(properties);
            };

            /**
             * Encodes the specified GetReconciliationDataResponse message. Does not implicitly {@link core.money.GetReconciliationDataResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetReconciliationDataResponse
             * @static
             * @param {core.money.IGetReconciliationDataResponse} message GetReconciliationDataResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReconciliationDataResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.reconciliation_data != null && message.reconciliation_data.length)
                    for (let i = 0; i < message.reconciliation_data.length; ++i)
                        $root.core.money.ReconciliationData.encode(message.reconciliation_data[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetReconciliationDataResponse message, length delimited. Does not implicitly {@link core.money.GetReconciliationDataResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetReconciliationDataResponse
             * @static
             * @param {core.money.IGetReconciliationDataResponse} message GetReconciliationDataResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetReconciliationDataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetReconciliationDataResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetReconciliationDataResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetReconciliationDataResponse} GetReconciliationDataResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReconciliationDataResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetReconciliationDataResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.reconciliation_data && message.reconciliation_data.length))
                            message.reconciliation_data = [];
                        message.reconciliation_data.push($root.core.money.ReconciliationData.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetReconciliationDataResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetReconciliationDataResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetReconciliationDataResponse} GetReconciliationDataResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetReconciliationDataResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetReconciliationDataResponse message.
             * @function verify
             * @memberof core.money.GetReconciliationDataResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetReconciliationDataResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.reconciliation_data != null && message.hasOwnProperty("reconciliation_data")) {
                    if (!Array.isArray(message.reconciliation_data))
                        return "reconciliation_data: array expected";
                    for (let i = 0; i < message.reconciliation_data.length; ++i) {
                        let error = $root.core.money.ReconciliationData.verify(message.reconciliation_data[i]);
                        if (error)
                            return "reconciliation_data." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetReconciliationDataResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetReconciliationDataResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetReconciliationDataResponse} GetReconciliationDataResponse
             */
            GetReconciliationDataResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetReconciliationDataResponse)
                    return object;
                let message = new $root.core.money.GetReconciliationDataResponse();
                if (object.reconciliation_data) {
                    if (!Array.isArray(object.reconciliation_data))
                        throw TypeError(".core.money.GetReconciliationDataResponse.reconciliation_data: array expected");
                    message.reconciliation_data = [];
                    for (let i = 0; i < object.reconciliation_data.length; ++i) {
                        if (typeof object.reconciliation_data[i] !== "object")
                            throw TypeError(".core.money.GetReconciliationDataResponse.reconciliation_data: object expected");
                        message.reconciliation_data[i] = $root.core.money.ReconciliationData.fromObject(object.reconciliation_data[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetReconciliationDataResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetReconciliationDataResponse
             * @static
             * @param {core.money.GetReconciliationDataResponse} message GetReconciliationDataResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetReconciliationDataResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.reconciliation_data = [];
                if (message.reconciliation_data && message.reconciliation_data.length) {
                    object.reconciliation_data = [];
                    for (let j = 0; j < message.reconciliation_data.length; ++j)
                        object.reconciliation_data[j] = $root.core.money.ReconciliationData.toObject(message.reconciliation_data[j], options);
                }
                return object;
            };

            /**
             * Converts this GetReconciliationDataResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetReconciliationDataResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetReconciliationDataResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetReconciliationDataResponse;
        })();

        money.AddReconciliationCommentRequest = (function() {

            /**
             * Properties of an AddReconciliationCommentRequest.
             * @memberof core.money
             * @interface IAddReconciliationCommentRequest
             * @property {string|null} [date] AddReconciliationCommentRequest date
             * @property {string|null} [account_id] AddReconciliationCommentRequest account_id
             * @property {string|null} [comment] AddReconciliationCommentRequest comment
             */

            /**
             * Constructs a new AddReconciliationCommentRequest.
             * @memberof core.money
             * @classdesc Represents an AddReconciliationCommentRequest.
             * @implements IAddReconciliationCommentRequest
             * @constructor
             * @param {core.money.IAddReconciliationCommentRequest=} [properties] Properties to set
             */
            function AddReconciliationCommentRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AddReconciliationCommentRequest date.
             * @member {string} date
             * @memberof core.money.AddReconciliationCommentRequest
             * @instance
             */
            AddReconciliationCommentRequest.prototype.date = "";

            /**
             * AddReconciliationCommentRequest account_id.
             * @member {string} account_id
             * @memberof core.money.AddReconciliationCommentRequest
             * @instance
             */
            AddReconciliationCommentRequest.prototype.account_id = "";

            /**
             * AddReconciliationCommentRequest comment.
             * @member {string} comment
             * @memberof core.money.AddReconciliationCommentRequest
             * @instance
             */
            AddReconciliationCommentRequest.prototype.comment = "";

            /**
             * Creates a new AddReconciliationCommentRequest instance using the specified properties.
             * @function create
             * @memberof core.money.AddReconciliationCommentRequest
             * @static
             * @param {core.money.IAddReconciliationCommentRequest=} [properties] Properties to set
             * @returns {core.money.AddReconciliationCommentRequest} AddReconciliationCommentRequest instance
             */
            AddReconciliationCommentRequest.create = function create(properties) {
                return new AddReconciliationCommentRequest(properties);
            };

            /**
             * Encodes the specified AddReconciliationCommentRequest message. Does not implicitly {@link core.money.AddReconciliationCommentRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.AddReconciliationCommentRequest
             * @static
             * @param {core.money.IAddReconciliationCommentRequest} message AddReconciliationCommentRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddReconciliationCommentRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.date != null && message.hasOwnProperty("date"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.date);
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_id);
                if (message.comment != null && message.hasOwnProperty("comment"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.comment);
                return writer;
            };

            /**
             * Encodes the specified AddReconciliationCommentRequest message, length delimited. Does not implicitly {@link core.money.AddReconciliationCommentRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.AddReconciliationCommentRequest
             * @static
             * @param {core.money.IAddReconciliationCommentRequest} message AddReconciliationCommentRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AddReconciliationCommentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AddReconciliationCommentRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.AddReconciliationCommentRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.AddReconciliationCommentRequest} AddReconciliationCommentRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddReconciliationCommentRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.AddReconciliationCommentRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.date = reader.string();
                        break;
                    case 2:
                        message.account_id = reader.string();
                        break;
                    case 3:
                        message.comment = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AddReconciliationCommentRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.AddReconciliationCommentRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.AddReconciliationCommentRequest} AddReconciliationCommentRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AddReconciliationCommentRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AddReconciliationCommentRequest message.
             * @function verify
             * @memberof core.money.AddReconciliationCommentRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AddReconciliationCommentRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                if (message.comment != null && message.hasOwnProperty("comment"))
                    if (!$util.isString(message.comment))
                        return "comment: string expected";
                return null;
            };

            /**
             * Creates an AddReconciliationCommentRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.AddReconciliationCommentRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.AddReconciliationCommentRequest} AddReconciliationCommentRequest
             */
            AddReconciliationCommentRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.AddReconciliationCommentRequest)
                    return object;
                let message = new $root.core.money.AddReconciliationCommentRequest();
                if (object.date != null)
                    message.date = String(object.date);
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                if (object.comment != null)
                    message.comment = String(object.comment);
                return message;
            };

            /**
             * Creates a plain object from an AddReconciliationCommentRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.AddReconciliationCommentRequest
             * @static
             * @param {core.money.AddReconciliationCommentRequest} message AddReconciliationCommentRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AddReconciliationCommentRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.date = "";
                    object.account_id = "";
                    object.comment = "";
                }
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                if (message.comment != null && message.hasOwnProperty("comment"))
                    object.comment = message.comment;
                return object;
            };

            /**
             * Converts this AddReconciliationCommentRequest to JSON.
             * @function toJSON
             * @memberof core.money.AddReconciliationCommentRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AddReconciliationCommentRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AddReconciliationCommentRequest;
        })();

        money.MoneyInstance = (function() {

            /**
             * Properties of a MoneyInstance.
             * @memberof core.money
             * @interface IMoneyInstance
             * @property {string|null} [account_id] MoneyInstance account_id
             * @property {google.protobuf.IBoolValue|null} [deposits_allowed] MoneyInstance deposits_allowed
             * @property {google.protobuf.IBoolValue|null} [withdrawals_allowed] MoneyInstance withdrawals_allowed
             */

            /**
             * Constructs a new MoneyInstance.
             * @memberof core.money
             * @classdesc Represents a MoneyInstance.
             * @implements IMoneyInstance
             * @constructor
             * @param {core.money.IMoneyInstance=} [properties] Properties to set
             */
            function MoneyInstance(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MoneyInstance account_id.
             * @member {string} account_id
             * @memberof core.money.MoneyInstance
             * @instance
             */
            MoneyInstance.prototype.account_id = "";

            /**
             * MoneyInstance deposits_allowed.
             * @member {google.protobuf.IBoolValue|null|undefined} deposits_allowed
             * @memberof core.money.MoneyInstance
             * @instance
             */
            MoneyInstance.prototype.deposits_allowed = null;

            /**
             * MoneyInstance withdrawals_allowed.
             * @member {google.protobuf.IBoolValue|null|undefined} withdrawals_allowed
             * @memberof core.money.MoneyInstance
             * @instance
             */
            MoneyInstance.prototype.withdrawals_allowed = null;

            /**
             * Creates a new MoneyInstance instance using the specified properties.
             * @function create
             * @memberof core.money.MoneyInstance
             * @static
             * @param {core.money.IMoneyInstance=} [properties] Properties to set
             * @returns {core.money.MoneyInstance} MoneyInstance instance
             */
            MoneyInstance.create = function create(properties) {
                return new MoneyInstance(properties);
            };

            /**
             * Encodes the specified MoneyInstance message. Does not implicitly {@link core.money.MoneyInstance.verify|verify} messages.
             * @function encode
             * @memberof core.money.MoneyInstance
             * @static
             * @param {core.money.IMoneyInstance} message MoneyInstance message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MoneyInstance.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.account_id);
                if (message.deposits_allowed != null && message.hasOwnProperty("deposits_allowed"))
                    $root.google.protobuf.BoolValue.encode(message.deposits_allowed, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.withdrawals_allowed != null && message.hasOwnProperty("withdrawals_allowed"))
                    $root.google.protobuf.BoolValue.encode(message.withdrawals_allowed, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MoneyInstance message, length delimited. Does not implicitly {@link core.money.MoneyInstance.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.MoneyInstance
             * @static
             * @param {core.money.IMoneyInstance} message MoneyInstance message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MoneyInstance.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MoneyInstance message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.MoneyInstance
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.MoneyInstance} MoneyInstance
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MoneyInstance.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.MoneyInstance();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.account_id = reader.string();
                        break;
                    case 2:
                        message.deposits_allowed = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.withdrawals_allowed = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MoneyInstance message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.MoneyInstance
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.MoneyInstance} MoneyInstance
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MoneyInstance.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MoneyInstance message.
             * @function verify
             * @memberof core.money.MoneyInstance
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MoneyInstance.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    if (!$util.isString(message.account_id))
                        return "account_id: string expected";
                if (message.deposits_allowed != null && message.hasOwnProperty("deposits_allowed")) {
                    let error = $root.google.protobuf.BoolValue.verify(message.deposits_allowed);
                    if (error)
                        return "deposits_allowed." + error;
                }
                if (message.withdrawals_allowed != null && message.hasOwnProperty("withdrawals_allowed")) {
                    let error = $root.google.protobuf.BoolValue.verify(message.withdrawals_allowed);
                    if (error)
                        return "withdrawals_allowed." + error;
                }
                return null;
            };

            /**
             * Creates a MoneyInstance message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.MoneyInstance
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.MoneyInstance} MoneyInstance
             */
            MoneyInstance.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.MoneyInstance)
                    return object;
                let message = new $root.core.money.MoneyInstance();
                if (object.account_id != null)
                    message.account_id = String(object.account_id);
                if (object.deposits_allowed != null) {
                    if (typeof object.deposits_allowed !== "object")
                        throw TypeError(".core.money.MoneyInstance.deposits_allowed: object expected");
                    message.deposits_allowed = $root.google.protobuf.BoolValue.fromObject(object.deposits_allowed);
                }
                if (object.withdrawals_allowed != null) {
                    if (typeof object.withdrawals_allowed !== "object")
                        throw TypeError(".core.money.MoneyInstance.withdrawals_allowed: object expected");
                    message.withdrawals_allowed = $root.google.protobuf.BoolValue.fromObject(object.withdrawals_allowed);
                }
                return message;
            };

            /**
             * Creates a plain object from a MoneyInstance message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.MoneyInstance
             * @static
             * @param {core.money.MoneyInstance} message MoneyInstance
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MoneyInstance.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.account_id = "";
                    object.deposits_allowed = null;
                    object.withdrawals_allowed = null;
                }
                if (message.account_id != null && message.hasOwnProperty("account_id"))
                    object.account_id = message.account_id;
                if (message.deposits_allowed != null && message.hasOwnProperty("deposits_allowed"))
                    object.deposits_allowed = $root.google.protobuf.BoolValue.toObject(message.deposits_allowed, options);
                if (message.withdrawals_allowed != null && message.hasOwnProperty("withdrawals_allowed"))
                    object.withdrawals_allowed = $root.google.protobuf.BoolValue.toObject(message.withdrawals_allowed, options);
                return object;
            };

            /**
             * Converts this MoneyInstance to JSON.
             * @function toJSON
             * @memberof core.money.MoneyInstance
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MoneyInstance.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MoneyInstance;
        })();

        money.CreateMoneyInstanceRequest = (function() {

            /**
             * Properties of a CreateMoneyInstanceRequest.
             * @memberof core.money
             * @interface ICreateMoneyInstanceRequest
             * @property {core.money.IMoneyInstance|null} [money_instance] CreateMoneyInstanceRequest money_instance
             */

            /**
             * Constructs a new CreateMoneyInstanceRequest.
             * @memberof core.money
             * @classdesc Represents a CreateMoneyInstanceRequest.
             * @implements ICreateMoneyInstanceRequest
             * @constructor
             * @param {core.money.ICreateMoneyInstanceRequest=} [properties] Properties to set
             */
            function CreateMoneyInstanceRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CreateMoneyInstanceRequest money_instance.
             * @member {core.money.IMoneyInstance|null|undefined} money_instance
             * @memberof core.money.CreateMoneyInstanceRequest
             * @instance
             */
            CreateMoneyInstanceRequest.prototype.money_instance = null;

            /**
             * Creates a new CreateMoneyInstanceRequest instance using the specified properties.
             * @function create
             * @memberof core.money.CreateMoneyInstanceRequest
             * @static
             * @param {core.money.ICreateMoneyInstanceRequest=} [properties] Properties to set
             * @returns {core.money.CreateMoneyInstanceRequest} CreateMoneyInstanceRequest instance
             */
            CreateMoneyInstanceRequest.create = function create(properties) {
                return new CreateMoneyInstanceRequest(properties);
            };

            /**
             * Encodes the specified CreateMoneyInstanceRequest message. Does not implicitly {@link core.money.CreateMoneyInstanceRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.CreateMoneyInstanceRequest
             * @static
             * @param {core.money.ICreateMoneyInstanceRequest} message CreateMoneyInstanceRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateMoneyInstanceRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.money_instance != null && message.hasOwnProperty("money_instance"))
                    $root.core.money.MoneyInstance.encode(message.money_instance, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CreateMoneyInstanceRequest message, length delimited. Does not implicitly {@link core.money.CreateMoneyInstanceRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.CreateMoneyInstanceRequest
             * @static
             * @param {core.money.ICreateMoneyInstanceRequest} message CreateMoneyInstanceRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CreateMoneyInstanceRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CreateMoneyInstanceRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.CreateMoneyInstanceRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.CreateMoneyInstanceRequest} CreateMoneyInstanceRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateMoneyInstanceRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.CreateMoneyInstanceRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.money_instance = $root.core.money.MoneyInstance.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CreateMoneyInstanceRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.CreateMoneyInstanceRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.CreateMoneyInstanceRequest} CreateMoneyInstanceRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CreateMoneyInstanceRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CreateMoneyInstanceRequest message.
             * @function verify
             * @memberof core.money.CreateMoneyInstanceRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CreateMoneyInstanceRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.money_instance != null && message.hasOwnProperty("money_instance")) {
                    let error = $root.core.money.MoneyInstance.verify(message.money_instance);
                    if (error)
                        return "money_instance." + error;
                }
                return null;
            };

            /**
             * Creates a CreateMoneyInstanceRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.CreateMoneyInstanceRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.CreateMoneyInstanceRequest} CreateMoneyInstanceRequest
             */
            CreateMoneyInstanceRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.CreateMoneyInstanceRequest)
                    return object;
                let message = new $root.core.money.CreateMoneyInstanceRequest();
                if (object.money_instance != null) {
                    if (typeof object.money_instance !== "object")
                        throw TypeError(".core.money.CreateMoneyInstanceRequest.money_instance: object expected");
                    message.money_instance = $root.core.money.MoneyInstance.fromObject(object.money_instance);
                }
                return message;
            };

            /**
             * Creates a plain object from a CreateMoneyInstanceRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.CreateMoneyInstanceRequest
             * @static
             * @param {core.money.CreateMoneyInstanceRequest} message CreateMoneyInstanceRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CreateMoneyInstanceRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.money_instance = null;
                if (message.money_instance != null && message.hasOwnProperty("money_instance"))
                    object.money_instance = $root.core.money.MoneyInstance.toObject(message.money_instance, options);
                return object;
            };

            /**
             * Converts this CreateMoneyInstanceRequest to JSON.
             * @function toJSON
             * @memberof core.money.CreateMoneyInstanceRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CreateMoneyInstanceRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CreateMoneyInstanceRequest;
        })();

        money.UpdateMoneyInstanceRequest = (function() {

            /**
             * Properties of an UpdateMoneyInstanceRequest.
             * @memberof core.money
             * @interface IUpdateMoneyInstanceRequest
             * @property {core.money.IMoneyInstance|null} [money_instance] UpdateMoneyInstanceRequest money_instance
             */

            /**
             * Constructs a new UpdateMoneyInstanceRequest.
             * @memberof core.money
             * @classdesc Represents an UpdateMoneyInstanceRequest.
             * @implements IUpdateMoneyInstanceRequest
             * @constructor
             * @param {core.money.IUpdateMoneyInstanceRequest=} [properties] Properties to set
             */
            function UpdateMoneyInstanceRequest(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdateMoneyInstanceRequest money_instance.
             * @member {core.money.IMoneyInstance|null|undefined} money_instance
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @instance
             */
            UpdateMoneyInstanceRequest.prototype.money_instance = null;

            /**
             * Creates a new UpdateMoneyInstanceRequest instance using the specified properties.
             * @function create
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @static
             * @param {core.money.IUpdateMoneyInstanceRequest=} [properties] Properties to set
             * @returns {core.money.UpdateMoneyInstanceRequest} UpdateMoneyInstanceRequest instance
             */
            UpdateMoneyInstanceRequest.create = function create(properties) {
                return new UpdateMoneyInstanceRequest(properties);
            };

            /**
             * Encodes the specified UpdateMoneyInstanceRequest message. Does not implicitly {@link core.money.UpdateMoneyInstanceRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @static
             * @param {core.money.IUpdateMoneyInstanceRequest} message UpdateMoneyInstanceRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateMoneyInstanceRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.money_instance != null && message.hasOwnProperty("money_instance"))
                    $root.core.money.MoneyInstance.encode(message.money_instance, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified UpdateMoneyInstanceRequest message, length delimited. Does not implicitly {@link core.money.UpdateMoneyInstanceRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @static
             * @param {core.money.IUpdateMoneyInstanceRequest} message UpdateMoneyInstanceRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateMoneyInstanceRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateMoneyInstanceRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.UpdateMoneyInstanceRequest} UpdateMoneyInstanceRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateMoneyInstanceRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.UpdateMoneyInstanceRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.money_instance = $root.core.money.MoneyInstance.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateMoneyInstanceRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.UpdateMoneyInstanceRequest} UpdateMoneyInstanceRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateMoneyInstanceRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateMoneyInstanceRequest message.
             * @function verify
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateMoneyInstanceRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.money_instance != null && message.hasOwnProperty("money_instance")) {
                    let error = $root.core.money.MoneyInstance.verify(message.money_instance);
                    if (error)
                        return "money_instance." + error;
                }
                return null;
            };

            /**
             * Creates an UpdateMoneyInstanceRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.UpdateMoneyInstanceRequest} UpdateMoneyInstanceRequest
             */
            UpdateMoneyInstanceRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.UpdateMoneyInstanceRequest)
                    return object;
                let message = new $root.core.money.UpdateMoneyInstanceRequest();
                if (object.money_instance != null) {
                    if (typeof object.money_instance !== "object")
                        throw TypeError(".core.money.UpdateMoneyInstanceRequest.money_instance: object expected");
                    message.money_instance = $root.core.money.MoneyInstance.fromObject(object.money_instance);
                }
                return message;
            };

            /**
             * Creates a plain object from an UpdateMoneyInstanceRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @static
             * @param {core.money.UpdateMoneyInstanceRequest} message UpdateMoneyInstanceRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateMoneyInstanceRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.money_instance = null;
                if (message.money_instance != null && message.hasOwnProperty("money_instance"))
                    object.money_instance = $root.core.money.MoneyInstance.toObject(message.money_instance, options);
                return object;
            };

            /**
             * Converts this UpdateMoneyInstanceRequest to JSON.
             * @function toJSON
             * @memberof core.money.UpdateMoneyInstanceRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateMoneyInstanceRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateMoneyInstanceRequest;
        })();

        money.GetMoneyInstancesByAccountIDsRequest = (function() {

            /**
             * Properties of a GetMoneyInstancesByAccountIDsRequest.
             * @memberof core.money
             * @interface IGetMoneyInstancesByAccountIDsRequest
             * @property {Array.<string>|null} [account_ids] GetMoneyInstancesByAccountIDsRequest account_ids
             */

            /**
             * Constructs a new GetMoneyInstancesByAccountIDsRequest.
             * @memberof core.money
             * @classdesc Represents a GetMoneyInstancesByAccountIDsRequest.
             * @implements IGetMoneyInstancesByAccountIDsRequest
             * @constructor
             * @param {core.money.IGetMoneyInstancesByAccountIDsRequest=} [properties] Properties to set
             */
            function GetMoneyInstancesByAccountIDsRequest(properties) {
                this.account_ids = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetMoneyInstancesByAccountIDsRequest account_ids.
             * @member {Array.<string>} account_ids
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @instance
             */
            GetMoneyInstancesByAccountIDsRequest.prototype.account_ids = $util.emptyArray;

            /**
             * Creates a new GetMoneyInstancesByAccountIDsRequest instance using the specified properties.
             * @function create
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @static
             * @param {core.money.IGetMoneyInstancesByAccountIDsRequest=} [properties] Properties to set
             * @returns {core.money.GetMoneyInstancesByAccountIDsRequest} GetMoneyInstancesByAccountIDsRequest instance
             */
            GetMoneyInstancesByAccountIDsRequest.create = function create(properties) {
                return new GetMoneyInstancesByAccountIDsRequest(properties);
            };

            /**
             * Encodes the specified GetMoneyInstancesByAccountIDsRequest message. Does not implicitly {@link core.money.GetMoneyInstancesByAccountIDsRequest.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @static
             * @param {core.money.IGetMoneyInstancesByAccountIDsRequest} message GetMoneyInstancesByAccountIDsRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMoneyInstancesByAccountIDsRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account_ids != null && message.account_ids.length)
                    for (let i = 0; i < message.account_ids.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.account_ids[i]);
                return writer;
            };

            /**
             * Encodes the specified GetMoneyInstancesByAccountIDsRequest message, length delimited. Does not implicitly {@link core.money.GetMoneyInstancesByAccountIDsRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @static
             * @param {core.money.IGetMoneyInstancesByAccountIDsRequest} message GetMoneyInstancesByAccountIDsRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMoneyInstancesByAccountIDsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetMoneyInstancesByAccountIDsRequest message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetMoneyInstancesByAccountIDsRequest} GetMoneyInstancesByAccountIDsRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMoneyInstancesByAccountIDsRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetMoneyInstancesByAccountIDsRequest();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.account_ids && message.account_ids.length))
                            message.account_ids = [];
                        message.account_ids.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetMoneyInstancesByAccountIDsRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetMoneyInstancesByAccountIDsRequest} GetMoneyInstancesByAccountIDsRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMoneyInstancesByAccountIDsRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetMoneyInstancesByAccountIDsRequest message.
             * @function verify
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetMoneyInstancesByAccountIDsRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account_ids != null && message.hasOwnProperty("account_ids")) {
                    if (!Array.isArray(message.account_ids))
                        return "account_ids: array expected";
                    for (let i = 0; i < message.account_ids.length; ++i)
                        if (!$util.isString(message.account_ids[i]))
                            return "account_ids: string[] expected";
                }
                return null;
            };

            /**
             * Creates a GetMoneyInstancesByAccountIDsRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetMoneyInstancesByAccountIDsRequest} GetMoneyInstancesByAccountIDsRequest
             */
            GetMoneyInstancesByAccountIDsRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetMoneyInstancesByAccountIDsRequest)
                    return object;
                let message = new $root.core.money.GetMoneyInstancesByAccountIDsRequest();
                if (object.account_ids) {
                    if (!Array.isArray(object.account_ids))
                        throw TypeError(".core.money.GetMoneyInstancesByAccountIDsRequest.account_ids: array expected");
                    message.account_ids = [];
                    for (let i = 0; i < object.account_ids.length; ++i)
                        message.account_ids[i] = String(object.account_ids[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a GetMoneyInstancesByAccountIDsRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @static
             * @param {core.money.GetMoneyInstancesByAccountIDsRequest} message GetMoneyInstancesByAccountIDsRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetMoneyInstancesByAccountIDsRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.account_ids = [];
                if (message.account_ids && message.account_ids.length) {
                    object.account_ids = [];
                    for (let j = 0; j < message.account_ids.length; ++j)
                        object.account_ids[j] = message.account_ids[j];
                }
                return object;
            };

            /**
             * Converts this GetMoneyInstancesByAccountIDsRequest to JSON.
             * @function toJSON
             * @memberof core.money.GetMoneyInstancesByAccountIDsRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetMoneyInstancesByAccountIDsRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetMoneyInstancesByAccountIDsRequest;
        })();

        money.GetMoneyInstancesByAccountIDsResponse = (function() {

            /**
             * Properties of a GetMoneyInstancesByAccountIDsResponse.
             * @memberof core.money
             * @interface IGetMoneyInstancesByAccountIDsResponse
             * @property {Array.<core.money.IMoneyInstance>|null} [money_instances] GetMoneyInstancesByAccountIDsResponse money_instances
             */

            /**
             * Constructs a new GetMoneyInstancesByAccountIDsResponse.
             * @memberof core.money
             * @classdesc Represents a GetMoneyInstancesByAccountIDsResponse.
             * @implements IGetMoneyInstancesByAccountIDsResponse
             * @constructor
             * @param {core.money.IGetMoneyInstancesByAccountIDsResponse=} [properties] Properties to set
             */
            function GetMoneyInstancesByAccountIDsResponse(properties) {
                this.money_instances = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetMoneyInstancesByAccountIDsResponse money_instances.
             * @member {Array.<core.money.IMoneyInstance>} money_instances
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @instance
             */
            GetMoneyInstancesByAccountIDsResponse.prototype.money_instances = $util.emptyArray;

            /**
             * Creates a new GetMoneyInstancesByAccountIDsResponse instance using the specified properties.
             * @function create
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @static
             * @param {core.money.IGetMoneyInstancesByAccountIDsResponse=} [properties] Properties to set
             * @returns {core.money.GetMoneyInstancesByAccountIDsResponse} GetMoneyInstancesByAccountIDsResponse instance
             */
            GetMoneyInstancesByAccountIDsResponse.create = function create(properties) {
                return new GetMoneyInstancesByAccountIDsResponse(properties);
            };

            /**
             * Encodes the specified GetMoneyInstancesByAccountIDsResponse message. Does not implicitly {@link core.money.GetMoneyInstancesByAccountIDsResponse.verify|verify} messages.
             * @function encode
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @static
             * @param {core.money.IGetMoneyInstancesByAccountIDsResponse} message GetMoneyInstancesByAccountIDsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMoneyInstancesByAccountIDsResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.money_instances != null && message.money_instances.length)
                    for (let i = 0; i < message.money_instances.length; ++i)
                        $root.core.money.MoneyInstance.encode(message.money_instances[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GetMoneyInstancesByAccountIDsResponse message, length delimited. Does not implicitly {@link core.money.GetMoneyInstancesByAccountIDsResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @static
             * @param {core.money.IGetMoneyInstancesByAccountIDsResponse} message GetMoneyInstancesByAccountIDsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetMoneyInstancesByAccountIDsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetMoneyInstancesByAccountIDsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {core.money.GetMoneyInstancesByAccountIDsResponse} GetMoneyInstancesByAccountIDsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMoneyInstancesByAccountIDsResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.core.money.GetMoneyInstancesByAccountIDsResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.money_instances && message.money_instances.length))
                            message.money_instances = [];
                        message.money_instances.push($root.core.money.MoneyInstance.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetMoneyInstancesByAccountIDsResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {core.money.GetMoneyInstancesByAccountIDsResponse} GetMoneyInstancesByAccountIDsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetMoneyInstancesByAccountIDsResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetMoneyInstancesByAccountIDsResponse message.
             * @function verify
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetMoneyInstancesByAccountIDsResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.money_instances != null && message.hasOwnProperty("money_instances")) {
                    if (!Array.isArray(message.money_instances))
                        return "money_instances: array expected";
                    for (let i = 0; i < message.money_instances.length; ++i) {
                        let error = $root.core.money.MoneyInstance.verify(message.money_instances[i]);
                        if (error)
                            return "money_instances." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GetMoneyInstancesByAccountIDsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {core.money.GetMoneyInstancesByAccountIDsResponse} GetMoneyInstancesByAccountIDsResponse
             */
            GetMoneyInstancesByAccountIDsResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.core.money.GetMoneyInstancesByAccountIDsResponse)
                    return object;
                let message = new $root.core.money.GetMoneyInstancesByAccountIDsResponse();
                if (object.money_instances) {
                    if (!Array.isArray(object.money_instances))
                        throw TypeError(".core.money.GetMoneyInstancesByAccountIDsResponse.money_instances: array expected");
                    message.money_instances = [];
                    for (let i = 0; i < object.money_instances.length; ++i) {
                        if (typeof object.money_instances[i] !== "object")
                            throw TypeError(".core.money.GetMoneyInstancesByAccountIDsResponse.money_instances: object expected");
                        message.money_instances[i] = $root.core.money.MoneyInstance.fromObject(object.money_instances[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GetMoneyInstancesByAccountIDsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @static
             * @param {core.money.GetMoneyInstancesByAccountIDsResponse} message GetMoneyInstancesByAccountIDsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetMoneyInstancesByAccountIDsResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.money_instances = [];
                if (message.money_instances && message.money_instances.length) {
                    object.money_instances = [];
                    for (let j = 0; j < message.money_instances.length; ++j)
                        object.money_instances[j] = $root.core.money.MoneyInstance.toObject(message.money_instances[j], options);
                }
                return object;
            };

            /**
             * Converts this GetMoneyInstancesByAccountIDsResponse to JSON.
             * @function toJSON
             * @memberof core.money.GetMoneyInstancesByAccountIDsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetMoneyInstancesByAccountIDsResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetMoneyInstancesByAccountIDsResponse;
        })();

        return money;
    })();

    return core;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             */
            function Timestamp(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.seconds = reader.int64();
                        break;
                    case 2:
                        message.nanos = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Timestamp message.
             * @function verify
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Timestamp.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                let message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Timestamp;
        })();

        protobuf.DoubleValue = (function() {

            /**
             * Properties of a DoubleValue.
             * @memberof google.protobuf
             * @interface IDoubleValue
             * @property {number|null} [value] DoubleValue value
             */

            /**
             * Constructs a new DoubleValue.
             * @memberof google.protobuf
             * @classdesc Represents a DoubleValue.
             * @implements IDoubleValue
             * @constructor
             * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
             */
            function DoubleValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DoubleValue value.
             * @member {number} value
             * @memberof google.protobuf.DoubleValue
             * @instance
             */
            DoubleValue.prototype.value = 0;

            /**
             * Creates a new DoubleValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
             * @returns {google.protobuf.DoubleValue} DoubleValue instance
             */
            DoubleValue.create = function create(properties) {
                return new DoubleValue(properties);
            };

            /**
             * Encodes the specified DoubleValue message. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoubleValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 1 =*/9).double(message.value);
                return writer;
            };

            /**
             * Encodes the specified DoubleValue message, length delimited. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoubleValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DoubleValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.DoubleValue} DoubleValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoubleValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DoubleValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DoubleValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.DoubleValue} DoubleValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoubleValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DoubleValue message.
             * @function verify
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DoubleValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "number")
                        return "value: number expected";
                return null;
            };

            /**
             * Creates a DoubleValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.DoubleValue} DoubleValue
             */
            DoubleValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.DoubleValue)
                    return object;
                let message = new $root.google.protobuf.DoubleValue();
                if (object.value != null)
                    message.value = Number(object.value);
                return message;
            };

            /**
             * Creates a plain object from a DoubleValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.DoubleValue} message DoubleValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DoubleValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                return object;
            };

            /**
             * Converts this DoubleValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.DoubleValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DoubleValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DoubleValue;
        })();

        protobuf.FloatValue = (function() {

            /**
             * Properties of a FloatValue.
             * @memberof google.protobuf
             * @interface IFloatValue
             * @property {number|null} [value] FloatValue value
             */

            /**
             * Constructs a new FloatValue.
             * @memberof google.protobuf
             * @classdesc Represents a FloatValue.
             * @implements IFloatValue
             * @constructor
             * @param {google.protobuf.IFloatValue=} [properties] Properties to set
             */
            function FloatValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FloatValue value.
             * @member {number} value
             * @memberof google.protobuf.FloatValue
             * @instance
             */
            FloatValue.prototype.value = 0;

            /**
             * Creates a new FloatValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue=} [properties] Properties to set
             * @returns {google.protobuf.FloatValue} FloatValue instance
             */
            FloatValue.create = function create(properties) {
                return new FloatValue(properties);
            };

            /**
             * Encodes the specified FloatValue message. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FloatValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.value);
                return writer;
            };

            /**
             * Encodes the specified FloatValue message, length delimited. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FloatValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FloatValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.FloatValue} FloatValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FloatValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FloatValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.float();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FloatValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.FloatValue} FloatValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FloatValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FloatValue message.
             * @function verify
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FloatValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "number")
                        return "value: number expected";
                return null;
            };

            /**
             * Creates a FloatValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.FloatValue} FloatValue
             */
            FloatValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FloatValue)
                    return object;
                let message = new $root.google.protobuf.FloatValue();
                if (object.value != null)
                    message.value = Number(object.value);
                return message;
            };

            /**
             * Creates a plain object from a FloatValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.FloatValue} message FloatValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FloatValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                return object;
            };

            /**
             * Converts this FloatValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.FloatValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FloatValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FloatValue;
        })();

        protobuf.Int64Value = (function() {

            /**
             * Properties of an Int64Value.
             * @memberof google.protobuf
             * @interface IInt64Value
             * @property {number|Long|null} [value] Int64Value value
             */

            /**
             * Constructs a new Int64Value.
             * @memberof google.protobuf
             * @classdesc Represents an Int64Value.
             * @implements IInt64Value
             * @constructor
             * @param {google.protobuf.IInt64Value=} [properties] Properties to set
             */
            function Int64Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Int64Value value.
             * @member {number|Long} value
             * @memberof google.protobuf.Int64Value
             * @instance
             */
            Int64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Int64Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value=} [properties] Properties to set
             * @returns {google.protobuf.Int64Value} Int64Value instance
             */
            Int64Value.create = function create(properties) {
                return new Int64Value(properties);
            };

            /**
             * Encodes the specified Int64Value message. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int64Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.value);
                return writer;
            };

            /**
             * Encodes the specified Int64Value message, length delimited. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int64Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Int64Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Int64Value} Int64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int64Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Int64Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Int64Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Int64Value} Int64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int64Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Int64Value message.
             * @function verify
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Int64Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                        return "value: integer|Long expected";
                return null;
            };

            /**
             * Creates an Int64Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Int64Value} Int64Value
             */
            Int64Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Int64Value)
                    return object;
                let message = new $root.google.protobuf.Int64Value();
                if (object.value != null)
                    if ($util.Long)
                        (message.value = $util.Long.fromValue(object.value)).unsigned = false;
                    else if (typeof object.value === "string")
                        message.value = parseInt(object.value, 10);
                    else if (typeof object.value === "number")
                        message.value = object.value;
                    else if (typeof object.value === "object")
                        message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an Int64Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.Int64Value} message Int64Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Int64Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.value = options.longs === String ? "0" : 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value === "number")
                        object.value = options.longs === String ? String(message.value) : message.value;
                    else
                        object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber() : message.value;
                return object;
            };

            /**
             * Converts this Int64Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.Int64Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Int64Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Int64Value;
        })();

        protobuf.UInt64Value = (function() {

            /**
             * Properties of a UInt64Value.
             * @memberof google.protobuf
             * @interface IUInt64Value
             * @property {number|Long|null} [value] UInt64Value value
             */

            /**
             * Constructs a new UInt64Value.
             * @memberof google.protobuf
             * @classdesc Represents a UInt64Value.
             * @implements IUInt64Value
             * @constructor
             * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
             */
            function UInt64Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UInt64Value value.
             * @member {number|Long} value
             * @memberof google.protobuf.UInt64Value
             * @instance
             */
            UInt64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new UInt64Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
             * @returns {google.protobuf.UInt64Value} UInt64Value instance
             */
            UInt64Value.create = function create(properties) {
                return new UInt64Value(properties);
            };

            /**
             * Encodes the specified UInt64Value message. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt64Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.value);
                return writer;
            };

            /**
             * Encodes the specified UInt64Value message, length delimited. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt64Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UInt64Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.UInt64Value} UInt64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt64Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UInt64Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UInt64Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.UInt64Value} UInt64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt64Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UInt64Value message.
             * @function verify
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UInt64Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                        return "value: integer|Long expected";
                return null;
            };

            /**
             * Creates a UInt64Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.UInt64Value} UInt64Value
             */
            UInt64Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UInt64Value)
                    return object;
                let message = new $root.google.protobuf.UInt64Value();
                if (object.value != null)
                    if ($util.Long)
                        (message.value = $util.Long.fromValue(object.value)).unsigned = true;
                    else if (typeof object.value === "string")
                        message.value = parseInt(object.value, 10);
                    else if (typeof object.value === "number")
                        message.value = object.value;
                    else if (typeof object.value === "object")
                        message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a UInt64Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.UInt64Value} message UInt64Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UInt64Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.value = options.longs === String ? "0" : 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value === "number")
                        object.value = options.longs === String ? String(message.value) : message.value;
                    else
                        object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber(true) : message.value;
                return object;
            };

            /**
             * Converts this UInt64Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.UInt64Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UInt64Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UInt64Value;
        })();

        protobuf.Int32Value = (function() {

            /**
             * Properties of an Int32Value.
             * @memberof google.protobuf
             * @interface IInt32Value
             * @property {number|null} [value] Int32Value value
             */

            /**
             * Constructs a new Int32Value.
             * @memberof google.protobuf
             * @classdesc Represents an Int32Value.
             * @implements IInt32Value
             * @constructor
             * @param {google.protobuf.IInt32Value=} [properties] Properties to set
             */
            function Int32Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Int32Value value.
             * @member {number} value
             * @memberof google.protobuf.Int32Value
             * @instance
             */
            Int32Value.prototype.value = 0;

            /**
             * Creates a new Int32Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value=} [properties] Properties to set
             * @returns {google.protobuf.Int32Value} Int32Value instance
             */
            Int32Value.create = function create(properties) {
                return new Int32Value(properties);
            };

            /**
             * Encodes the specified Int32Value message. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int32Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
                return writer;
            };

            /**
             * Encodes the specified Int32Value message, length delimited. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int32Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Int32Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Int32Value} Int32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int32Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Int32Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Int32Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Int32Value} Int32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int32Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Int32Value message.
             * @function verify
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Int32Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value))
                        return "value: integer expected";
                return null;
            };

            /**
             * Creates an Int32Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Int32Value} Int32Value
             */
            Int32Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Int32Value)
                    return object;
                let message = new $root.google.protobuf.Int32Value();
                if (object.value != null)
                    message.value = object.value | 0;
                return message;
            };

            /**
             * Creates a plain object from an Int32Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.Int32Value} message Int32Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Int32Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this Int32Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.Int32Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Int32Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Int32Value;
        })();

        protobuf.UInt32Value = (function() {

            /**
             * Properties of a UInt32Value.
             * @memberof google.protobuf
             * @interface IUInt32Value
             * @property {number|null} [value] UInt32Value value
             */

            /**
             * Constructs a new UInt32Value.
             * @memberof google.protobuf
             * @classdesc Represents a UInt32Value.
             * @implements IUInt32Value
             * @constructor
             * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
             */
            function UInt32Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UInt32Value value.
             * @member {number} value
             * @memberof google.protobuf.UInt32Value
             * @instance
             */
            UInt32Value.prototype.value = 0;

            /**
             * Creates a new UInt32Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
             * @returns {google.protobuf.UInt32Value} UInt32Value instance
             */
            UInt32Value.create = function create(properties) {
                return new UInt32Value(properties);
            };

            /**
             * Encodes the specified UInt32Value message. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt32Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.value);
                return writer;
            };

            /**
             * Encodes the specified UInt32Value message, length delimited. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt32Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UInt32Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.UInt32Value} UInt32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt32Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UInt32Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UInt32Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.UInt32Value} UInt32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt32Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UInt32Value message.
             * @function verify
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UInt32Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value))
                        return "value: integer expected";
                return null;
            };

            /**
             * Creates a UInt32Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.UInt32Value} UInt32Value
             */
            UInt32Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UInt32Value)
                    return object;
                let message = new $root.google.protobuf.UInt32Value();
                if (object.value != null)
                    message.value = object.value >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a UInt32Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.UInt32Value} message UInt32Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UInt32Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this UInt32Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.UInt32Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UInt32Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UInt32Value;
        })();

        protobuf.BoolValue = (function() {

            /**
             * Properties of a BoolValue.
             * @memberof google.protobuf
             * @interface IBoolValue
             * @property {boolean|null} [value] BoolValue value
             */

            /**
             * Constructs a new BoolValue.
             * @memberof google.protobuf
             * @classdesc Represents a BoolValue.
             * @implements IBoolValue
             * @constructor
             * @param {google.protobuf.IBoolValue=} [properties] Properties to set
             */
            function BoolValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BoolValue value.
             * @member {boolean} value
             * @memberof google.protobuf.BoolValue
             * @instance
             */
            BoolValue.prototype.value = false;

            /**
             * Creates a new BoolValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue=} [properties] Properties to set
             * @returns {google.protobuf.BoolValue} BoolValue instance
             */
            BoolValue.create = function create(properties) {
                return new BoolValue(properties);
            };

            /**
             * Encodes the specified BoolValue message. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BoolValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.value);
                return writer;
            };

            /**
             * Encodes the specified BoolValue message, length delimited. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BoolValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BoolValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.BoolValue} BoolValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BoolValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.BoolValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BoolValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.BoolValue} BoolValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BoolValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BoolValue message.
             * @function verify
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BoolValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "boolean")
                        return "value: boolean expected";
                return null;
            };

            /**
             * Creates a BoolValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.BoolValue} BoolValue
             */
            BoolValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.BoolValue)
                    return object;
                let message = new $root.google.protobuf.BoolValue();
                if (object.value != null)
                    message.value = Boolean(object.value);
                return message;
            };

            /**
             * Creates a plain object from a BoolValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.BoolValue} message BoolValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BoolValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = false;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this BoolValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.BoolValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BoolValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BoolValue;
        })();

        protobuf.StringValue = (function() {

            /**
             * Properties of a StringValue.
             * @memberof google.protobuf
             * @interface IStringValue
             * @property {string|null} [value] StringValue value
             */

            /**
             * Constructs a new StringValue.
             * @memberof google.protobuf
             * @classdesc Represents a StringValue.
             * @implements IStringValue
             * @constructor
             * @param {google.protobuf.IStringValue=} [properties] Properties to set
             */
            function StringValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StringValue value.
             * @member {string} value
             * @memberof google.protobuf.StringValue
             * @instance
             */
            StringValue.prototype.value = "";

            /**
             * Creates a new StringValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue=} [properties] Properties to set
             * @returns {google.protobuf.StringValue} StringValue instance
             */
            StringValue.create = function create(properties) {
                return new StringValue(properties);
            };

            /**
             * Encodes the specified StringValue message. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StringValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.value);
                return writer;
            };

            /**
             * Encodes the specified StringValue message, length delimited. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StringValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StringValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.StringValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.StringValue} StringValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StringValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.StringValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StringValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.StringValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.StringValue} StringValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StringValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StringValue message.
             * @function verify
             * @memberof google.protobuf.StringValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StringValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isString(message.value))
                        return "value: string expected";
                return null;
            };

            /**
             * Creates a StringValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.StringValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.StringValue} StringValue
             */
            StringValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.StringValue)
                    return object;
                let message = new $root.google.protobuf.StringValue();
                if (object.value != null)
                    message.value = String(object.value);
                return message;
            };

            /**
             * Creates a plain object from a StringValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.StringValue} message StringValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StringValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = "";
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this StringValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.StringValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StringValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StringValue;
        })();

        protobuf.BytesValue = (function() {

            /**
             * Properties of a BytesValue.
             * @memberof google.protobuf
             * @interface IBytesValue
             * @property {Uint8Array|null} [value] BytesValue value
             */

            /**
             * Constructs a new BytesValue.
             * @memberof google.protobuf
             * @classdesc Represents a BytesValue.
             * @implements IBytesValue
             * @constructor
             * @param {google.protobuf.IBytesValue=} [properties] Properties to set
             */
            function BytesValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BytesValue value.
             * @member {Uint8Array} value
             * @memberof google.protobuf.BytesValue
             * @instance
             */
            BytesValue.prototype.value = $util.newBuffer([]);

            /**
             * Creates a new BytesValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue=} [properties] Properties to set
             * @returns {google.protobuf.BytesValue} BytesValue instance
             */
            BytesValue.create = function create(properties) {
                return new BytesValue(properties);
            };

            /**
             * Encodes the specified BytesValue message. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BytesValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && message.hasOwnProperty("value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
                return writer;
            };

            /**
             * Encodes the specified BytesValue message, length delimited. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BytesValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BytesValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.BytesValue} BytesValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BytesValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.BytesValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BytesValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.BytesValue} BytesValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BytesValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BytesValue message.
             * @function verify
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BytesValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                        return "value: buffer expected";
                return null;
            };

            /**
             * Creates a BytesValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.BytesValue} BytesValue
             */
            BytesValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.BytesValue)
                    return object;
                let message = new $root.google.protobuf.BytesValue();
                if (object.value != null)
                    if (typeof object.value === "string")
                        $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                    else if (object.value.length)
                        message.value = object.value;
                return message;
            };

            /**
             * Creates a plain object from a BytesValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.BytesValue} message BytesValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BytesValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if (options.bytes === String)
                        object.value = "";
                    else {
                        object.value = [];
                        if (options.bytes !== Array)
                            object.value = $util.newBuffer(object.value);
                    }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                return object;
            };

            /**
             * Converts this BytesValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.BytesValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BytesValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BytesValue;
        })();

        protobuf.Empty = (function() {

            /**
             * Properties of an Empty.
             * @memberof google.protobuf
             * @interface IEmpty
             */

            /**
             * Constructs a new Empty.
             * @memberof google.protobuf
             * @classdesc Represents an Empty.
             * @implements IEmpty
             * @constructor
             * @param {google.protobuf.IEmpty=} [properties] Properties to set
             */
            function Empty(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Empty instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty=} [properties] Properties to set
             * @returns {google.protobuf.Empty} Empty instance
             */
            Empty.create = function create(properties) {
                return new Empty(properties);
            };

            /**
             * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Empty.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Empty message, length delimited. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Empty.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Empty message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Empty
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Empty} Empty
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Empty.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Empty();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Empty message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Empty
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Empty} Empty
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Empty.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Empty message.
             * @function verify
             * @memberof google.protobuf.Empty
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Empty.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an Empty message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Empty
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Empty} Empty
             */
            Empty.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Empty)
                    return object;
                return new $root.google.protobuf.Empty();
            };

            /**
             * Creates a plain object from an Empty message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.Empty} message Empty
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Empty.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Empty to JSON.
             * @function toJSON
             * @memberof google.protobuf.Empty
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Empty.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Empty;
        })();

        return protobuf;
    })();

    return google;
})();

export const SuperPortfolio = $root.SuperPortfolio = (() => {

    /**
     * Properties of a SuperPortfolio.
     * @exports ISuperPortfolio
     * @interface ISuperPortfolio
     */

    /**
     * Constructs a new SuperPortfolio.
     * @exports SuperPortfolio
     * @classdesc Represents a SuperPortfolio.
     * @implements ISuperPortfolio
     * @constructor
     * @param {ISuperPortfolio=} [properties] Properties to set
     */
    function SuperPortfolio(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SuperPortfolio instance using the specified properties.
     * @function create
     * @memberof SuperPortfolio
     * @static
     * @param {ISuperPortfolio=} [properties] Properties to set
     * @returns {SuperPortfolio} SuperPortfolio instance
     */
    SuperPortfolio.create = function create(properties) {
        return new SuperPortfolio(properties);
    };

    /**
     * Encodes the specified SuperPortfolio message. Does not implicitly {@link SuperPortfolio.verify|verify} messages.
     * @function encode
     * @memberof SuperPortfolio
     * @static
     * @param {ISuperPortfolio} message SuperPortfolio message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperPortfolio.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified SuperPortfolio message, length delimited. Does not implicitly {@link SuperPortfolio.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuperPortfolio
     * @static
     * @param {ISuperPortfolio} message SuperPortfolio message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperPortfolio.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuperPortfolio message from the specified reader or buffer.
     * @function decode
     * @memberof SuperPortfolio
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuperPortfolio} SuperPortfolio
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperPortfolio.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperPortfolio();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuperPortfolio message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuperPortfolio
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuperPortfolio} SuperPortfolio
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperPortfolio.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuperPortfolio message.
     * @function verify
     * @memberof SuperPortfolio
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuperPortfolio.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a SuperPortfolio message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuperPortfolio
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuperPortfolio} SuperPortfolio
     */
    SuperPortfolio.fromObject = function fromObject(object) {
        if (object instanceof $root.SuperPortfolio)
            return object;
        return new $root.SuperPortfolio();
    };

    /**
     * Creates a plain object from a SuperPortfolio message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuperPortfolio
     * @static
     * @param {SuperPortfolio} message SuperPortfolio
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuperPortfolio.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this SuperPortfolio to JSON.
     * @function toJSON
     * @memberof SuperPortfolio
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuperPortfolio.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Enum enum.
     * @name SuperPortfolio.Enum
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} GLOBAL_INDEX=1 GLOBAL_INDEX value
     * @property {number} GROWTHX=2 GROWTHX value
     * @property {number} BALANCED=3 BALANCED value
     * @property {number} MODERATE=4 MODERATE value
     */
    SuperPortfolio.Enum = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "GLOBAL_INDEX"] = 1;
        values[valuesById[2] = "GROWTHX"] = 2;
        values[valuesById[3] = "BALANCED"] = 3;
        values[valuesById[4] = "MODERATE"] = 4;
        return values;
    })();

    return SuperPortfolio;
})();

export const SuperProductInstance = $root.SuperProductInstance = (() => {

    /**
     * Properties of a SuperProductInstance.
     * @exports ISuperProductInstance
     * @interface ISuperProductInstance
     * @property {string|null} [id] SuperProductInstance id
     * @property {string|null} [account_id] SuperProductInstance account_id
     * @property {string|null} [impact_id] SuperProductInstance impact_id
     * @property {SuperProductInstance.JoinType.Enum|null} [join_type] SuperProductInstance join_type
     * @property {SuperProductInstance.Status.Enum|null} [status] SuperProductInstance status
     * @property {string|null} [sargon_member_id] SuperProductInstance sargon_member_id
     * @property {string|null} [referral_code] SuperProductInstance referral_code
     * @property {string|null} [external_id] SuperProductInstance external_id
     * @property {SuperProductInstance.FHSSStatus.Enum|null} [fhss_status] SuperProductInstance fhss_status
     * @property {google.protobuf.ITimestamp|null} [created_at] SuperProductInstance created_at
     * @property {google.protobuf.ITimestamp|null} [last_updated_at] SuperProductInstance last_updated_at
     */

    /**
     * Constructs a new SuperProductInstance.
     * @exports SuperProductInstance
     * @classdesc Represents a SuperProductInstance.
     * @implements ISuperProductInstance
     * @constructor
     * @param {ISuperProductInstance=} [properties] Properties to set
     */
    function SuperProductInstance(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuperProductInstance id.
     * @member {string} id
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.id = "";

    /**
     * SuperProductInstance account_id.
     * @member {string} account_id
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.account_id = "";

    /**
     * SuperProductInstance impact_id.
     * @member {string} impact_id
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.impact_id = "";

    /**
     * SuperProductInstance join_type.
     * @member {SuperProductInstance.JoinType.Enum} join_type
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.join_type = 0;

    /**
     * SuperProductInstance status.
     * @member {SuperProductInstance.Status.Enum} status
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.status = 0;

    /**
     * SuperProductInstance sargon_member_id.
     * @member {string} sargon_member_id
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.sargon_member_id = "";

    /**
     * SuperProductInstance referral_code.
     * @member {string} referral_code
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.referral_code = "";

    /**
     * SuperProductInstance external_id.
     * @member {string} external_id
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.external_id = "";

    /**
     * SuperProductInstance fhss_status.
     * @member {SuperProductInstance.FHSSStatus.Enum} fhss_status
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.fhss_status = 0;

    /**
     * SuperProductInstance created_at.
     * @member {google.protobuf.ITimestamp|null|undefined} created_at
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.created_at = null;

    /**
     * SuperProductInstance last_updated_at.
     * @member {google.protobuf.ITimestamp|null|undefined} last_updated_at
     * @memberof SuperProductInstance
     * @instance
     */
    SuperProductInstance.prototype.last_updated_at = null;

    /**
     * Creates a new SuperProductInstance instance using the specified properties.
     * @function create
     * @memberof SuperProductInstance
     * @static
     * @param {ISuperProductInstance=} [properties] Properties to set
     * @returns {SuperProductInstance} SuperProductInstance instance
     */
    SuperProductInstance.create = function create(properties) {
        return new SuperProductInstance(properties);
    };

    /**
     * Encodes the specified SuperProductInstance message. Does not implicitly {@link SuperProductInstance.verify|verify} messages.
     * @function encode
     * @memberof SuperProductInstance
     * @static
     * @param {ISuperProductInstance} message SuperProductInstance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperProductInstance.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty("id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.account_id);
        if (message.impact_id != null && message.hasOwnProperty("impact_id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.impact_id);
        if (message.join_type != null && message.hasOwnProperty("join_type"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.join_type);
        if (message.status != null && message.hasOwnProperty("status"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.status);
        if (message.sargon_member_id != null && message.hasOwnProperty("sargon_member_id"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.sargon_member_id);
        if (message.referral_code != null && message.hasOwnProperty("referral_code"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.referral_code);
        if (message.external_id != null && message.hasOwnProperty("external_id"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.external_id);
        if (message.fhss_status != null && message.hasOwnProperty("fhss_status"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.fhss_status);
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            $root.google.protobuf.Timestamp.encode(message.last_updated_at, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SuperProductInstance message, length delimited. Does not implicitly {@link SuperProductInstance.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuperProductInstance
     * @static
     * @param {ISuperProductInstance} message SuperProductInstance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperProductInstance.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuperProductInstance message from the specified reader or buffer.
     * @function decode
     * @memberof SuperProductInstance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuperProductInstance} SuperProductInstance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperProductInstance.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperProductInstance();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.account_id = reader.string();
                break;
            case 3:
                message.impact_id = reader.string();
                break;
            case 4:
                message.join_type = reader.int32();
                break;
            case 5:
                message.status = reader.int32();
                break;
            case 6:
                message.sargon_member_id = reader.string();
                break;
            case 7:
                message.referral_code = reader.string();
                break;
            case 8:
                message.external_id = reader.string();
                break;
            case 9:
                message.fhss_status = reader.int32();
                break;
            case 98:
                message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            case 99:
                message.last_updated_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuperProductInstance message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuperProductInstance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuperProductInstance} SuperProductInstance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperProductInstance.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuperProductInstance message.
     * @function verify
     * @memberof SuperProductInstance
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuperProductInstance.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            if (!$util.isString(message.account_id))
                return "account_id: string expected";
        if (message.impact_id != null && message.hasOwnProperty("impact_id"))
            if (!$util.isString(message.impact_id))
                return "impact_id: string expected";
        if (message.join_type != null && message.hasOwnProperty("join_type"))
            switch (message.join_type) {
            default:
                return "join_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                break;
            }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.sargon_member_id != null && message.hasOwnProperty("sargon_member_id"))
            if (!$util.isString(message.sargon_member_id))
                return "sargon_member_id: string expected";
        if (message.referral_code != null && message.hasOwnProperty("referral_code"))
            if (!$util.isString(message.referral_code))
                return "referral_code: string expected";
        if (message.external_id != null && message.hasOwnProperty("external_id"))
            if (!$util.isString(message.external_id))
                return "external_id: string expected";
        if (message.fhss_status != null && message.hasOwnProperty("fhss_status"))
            switch (message.fhss_status) {
            default:
                return "fhss_status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.created_at != null && message.hasOwnProperty("created_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.created_at);
            if (error)
                return "created_at." + error;
        }
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at")) {
            let error = $root.google.protobuf.Timestamp.verify(message.last_updated_at);
            if (error)
                return "last_updated_at." + error;
        }
        return null;
    };

    /**
     * Creates a SuperProductInstance message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuperProductInstance
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuperProductInstance} SuperProductInstance
     */
    SuperProductInstance.fromObject = function fromObject(object) {
        if (object instanceof $root.SuperProductInstance)
            return object;
        let message = new $root.SuperProductInstance();
        if (object.id != null)
            message.id = String(object.id);
        if (object.account_id != null)
            message.account_id = String(object.account_id);
        if (object.impact_id != null)
            message.impact_id = String(object.impact_id);
        switch (object.join_type) {
        case "UNKNOWN":
        case 0:
            message.join_type = 0;
            break;
        case "SIGN_UP":
        case 1:
            message.join_type = 1;
            break;
        case "SOFT_LINK":
        case 2:
            message.join_type = 2;
            break;
        case "HARD_LINK":
        case 3:
            message.join_type = 3;
            break;
        case "MIGRATED_FROM_WEB":
        case 4:
            message.join_type = 4;
            break;
        case "SIGN_UP_WEB":
        case 5:
            message.join_type = 5;
            break;
        case "HARD_LINK_WEB":
        case 6:
            message.join_type = 6;
            break;
        case "EMPLOYMENT_HERO":
        case 7:
            message.join_type = 7;
            break;
        case "BOOKIPI":
        case 8:
            message.join_type = 8;
            break;
        case "FOUNDU":
        case 9:
            message.join_type = 9;
            break;
        case "FLARE":
        case 10:
            message.join_type = 10;
            break;
        }
        switch (object.status) {
        case "UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "ACTIVE":
        case 1:
            message.status = 1;
            break;
        case "INACTIVE":
        case 2:
            message.status = 2;
            break;
        case "PENDING_VERIFICATION":
        case 3:
            message.status = 3;
            break;
        }
        if (object.sargon_member_id != null)
            message.sargon_member_id = String(object.sargon_member_id);
        if (object.referral_code != null)
            message.referral_code = String(object.referral_code);
        if (object.external_id != null)
            message.external_id = String(object.external_id);
        switch (object.fhss_status) {
        case "UNKNOWN":
        case 0:
            message.fhss_status = 0;
            break;
        case "NOT_SPECIFIED":
        case 1:
            message.fhss_status = 1;
            break;
        case "OPTED_IN":
        case 2:
            message.fhss_status = 2;
            break;
        case "OPTED_OUT":
        case 3:
            message.fhss_status = 3;
            break;
        }
        if (object.created_at != null) {
            if (typeof object.created_at !== "object")
                throw TypeError(".SuperProductInstance.created_at: object expected");
            message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
        }
        if (object.last_updated_at != null) {
            if (typeof object.last_updated_at !== "object")
                throw TypeError(".SuperProductInstance.last_updated_at: object expected");
            message.last_updated_at = $root.google.protobuf.Timestamp.fromObject(object.last_updated_at);
        }
        return message;
    };

    /**
     * Creates a plain object from a SuperProductInstance message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuperProductInstance
     * @static
     * @param {SuperProductInstance} message SuperProductInstance
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuperProductInstance.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.account_id = "";
            object.impact_id = "";
            object.join_type = options.enums === String ? "UNKNOWN" : 0;
            object.status = options.enums === String ? "UNKNOWN" : 0;
            object.sargon_member_id = "";
            object.referral_code = "";
            object.external_id = "";
            object.fhss_status = options.enums === String ? "UNKNOWN" : 0;
            object.created_at = null;
            object.last_updated_at = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.account_id != null && message.hasOwnProperty("account_id"))
            object.account_id = message.account_id;
        if (message.impact_id != null && message.hasOwnProperty("impact_id"))
            object.impact_id = message.impact_id;
        if (message.join_type != null && message.hasOwnProperty("join_type"))
            object.join_type = options.enums === String ? $root.SuperProductInstance.JoinType.Enum[message.join_type] : message.join_type;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.SuperProductInstance.Status.Enum[message.status] : message.status;
        if (message.sargon_member_id != null && message.hasOwnProperty("sargon_member_id"))
            object.sargon_member_id = message.sargon_member_id;
        if (message.referral_code != null && message.hasOwnProperty("referral_code"))
            object.referral_code = message.referral_code;
        if (message.external_id != null && message.hasOwnProperty("external_id"))
            object.external_id = message.external_id;
        if (message.fhss_status != null && message.hasOwnProperty("fhss_status"))
            object.fhss_status = options.enums === String ? $root.SuperProductInstance.FHSSStatus.Enum[message.fhss_status] : message.fhss_status;
        if (message.created_at != null && message.hasOwnProperty("created_at"))
            object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
        if (message.last_updated_at != null && message.hasOwnProperty("last_updated_at"))
            object.last_updated_at = $root.google.protobuf.Timestamp.toObject(message.last_updated_at, options);
        return object;
    };

    /**
     * Converts this SuperProductInstance to JSON.
     * @function toJSON
     * @memberof SuperProductInstance
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuperProductInstance.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SuperProductInstance.JoinType = (function() {

        /**
         * Properties of a JoinType.
         * @memberof SuperProductInstance
         * @interface IJoinType
         */

        /**
         * Constructs a new JoinType.
         * @memberof SuperProductInstance
         * @classdesc Represents a JoinType.
         * @implements IJoinType
         * @constructor
         * @param {SuperProductInstance.IJoinType=} [properties] Properties to set
         */
        function JoinType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new JoinType instance using the specified properties.
         * @function create
         * @memberof SuperProductInstance.JoinType
         * @static
         * @param {SuperProductInstance.IJoinType=} [properties] Properties to set
         * @returns {SuperProductInstance.JoinType} JoinType instance
         */
        JoinType.create = function create(properties) {
            return new JoinType(properties);
        };

        /**
         * Encodes the specified JoinType message. Does not implicitly {@link SuperProductInstance.JoinType.verify|verify} messages.
         * @function encode
         * @memberof SuperProductInstance.JoinType
         * @static
         * @param {SuperProductInstance.IJoinType} message JoinType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JoinType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified JoinType message, length delimited. Does not implicitly {@link SuperProductInstance.JoinType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SuperProductInstance.JoinType
         * @static
         * @param {SuperProductInstance.IJoinType} message JoinType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JoinType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JoinType message from the specified reader or buffer.
         * @function decode
         * @memberof SuperProductInstance.JoinType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SuperProductInstance.JoinType} JoinType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JoinType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperProductInstance.JoinType();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JoinType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SuperProductInstance.JoinType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SuperProductInstance.JoinType} JoinType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JoinType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JoinType message.
         * @function verify
         * @memberof SuperProductInstance.JoinType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JoinType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a JoinType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SuperProductInstance.JoinType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SuperProductInstance.JoinType} JoinType
         */
        JoinType.fromObject = function fromObject(object) {
            if (object instanceof $root.SuperProductInstance.JoinType)
                return object;
            return new $root.SuperProductInstance.JoinType();
        };

        /**
         * Creates a plain object from a JoinType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SuperProductInstance.JoinType
         * @static
         * @param {SuperProductInstance.JoinType} message JoinType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JoinType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this JoinType to JSON.
         * @function toJSON
         * @memberof SuperProductInstance.JoinType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JoinType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name SuperProductInstance.JoinType.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} SIGN_UP=1 SIGN_UP value
         * @property {number} SOFT_LINK=2 SOFT_LINK value
         * @property {number} HARD_LINK=3 HARD_LINK value
         * @property {number} MIGRATED_FROM_WEB=4 MIGRATED_FROM_WEB value
         * @property {number} SIGN_UP_WEB=5 SIGN_UP_WEB value
         * @property {number} HARD_LINK_WEB=6 HARD_LINK_WEB value
         * @property {number} EMPLOYMENT_HERO=7 EMPLOYMENT_HERO value
         * @property {number} BOOKIPI=8 BOOKIPI value
         * @property {number} FOUNDU=9 FOUNDU value
         * @property {number} FLARE=10 FLARE value
         */
        JoinType.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "SIGN_UP"] = 1;
            values[valuesById[2] = "SOFT_LINK"] = 2;
            values[valuesById[3] = "HARD_LINK"] = 3;
            values[valuesById[4] = "MIGRATED_FROM_WEB"] = 4;
            values[valuesById[5] = "SIGN_UP_WEB"] = 5;
            values[valuesById[6] = "HARD_LINK_WEB"] = 6;
            values[valuesById[7] = "EMPLOYMENT_HERO"] = 7;
            values[valuesById[8] = "BOOKIPI"] = 8;
            values[valuesById[9] = "FOUNDU"] = 9;
            values[valuesById[10] = "FLARE"] = 10;
            return values;
        })();

        return JoinType;
    })();

    SuperProductInstance.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof SuperProductInstance
         * @interface IStatus
         */

        /**
         * Constructs a new Status.
         * @memberof SuperProductInstance
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {SuperProductInstance.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof SuperProductInstance.Status
         * @static
         * @param {SuperProductInstance.IStatus=} [properties] Properties to set
         * @returns {SuperProductInstance.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link SuperProductInstance.Status.verify|verify} messages.
         * @function encode
         * @memberof SuperProductInstance.Status
         * @static
         * @param {SuperProductInstance.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Status message, length delimited. Does not implicitly {@link SuperProductInstance.Status.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SuperProductInstance.Status
         * @static
         * @param {SuperProductInstance.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof SuperProductInstance.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SuperProductInstance.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperProductInstance.Status();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Status message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SuperProductInstance.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SuperProductInstance.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Status message.
         * @function verify
         * @memberof SuperProductInstance.Status
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Status.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SuperProductInstance.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SuperProductInstance.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.SuperProductInstance.Status)
                return object;
            return new $root.SuperProductInstance.Status();
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SuperProductInstance.Status
         * @static
         * @param {SuperProductInstance.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof SuperProductInstance.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name SuperProductInstance.Status.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} ACTIVE=1 ACTIVE value
         * @property {number} INACTIVE=2 INACTIVE value
         * @property {number} PENDING_VERIFICATION=3 PENDING_VERIFICATION value
         */
        Status.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "ACTIVE"] = 1;
            values[valuesById[2] = "INACTIVE"] = 2;
            values[valuesById[3] = "PENDING_VERIFICATION"] = 3;
            return values;
        })();

        return Status;
    })();

    SuperProductInstance.FHSSStatus = (function() {

        /**
         * Properties of a FHSSStatus.
         * @memberof SuperProductInstance
         * @interface IFHSSStatus
         */

        /**
         * Constructs a new FHSSStatus.
         * @memberof SuperProductInstance
         * @classdesc Represents a FHSSStatus.
         * @implements IFHSSStatus
         * @constructor
         * @param {SuperProductInstance.IFHSSStatus=} [properties] Properties to set
         */
        function FHSSStatus(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new FHSSStatus instance using the specified properties.
         * @function create
         * @memberof SuperProductInstance.FHSSStatus
         * @static
         * @param {SuperProductInstance.IFHSSStatus=} [properties] Properties to set
         * @returns {SuperProductInstance.FHSSStatus} FHSSStatus instance
         */
        FHSSStatus.create = function create(properties) {
            return new FHSSStatus(properties);
        };

        /**
         * Encodes the specified FHSSStatus message. Does not implicitly {@link SuperProductInstance.FHSSStatus.verify|verify} messages.
         * @function encode
         * @memberof SuperProductInstance.FHSSStatus
         * @static
         * @param {SuperProductInstance.IFHSSStatus} message FHSSStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FHSSStatus.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified FHSSStatus message, length delimited. Does not implicitly {@link SuperProductInstance.FHSSStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SuperProductInstance.FHSSStatus
         * @static
         * @param {SuperProductInstance.IFHSSStatus} message FHSSStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FHSSStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FHSSStatus message from the specified reader or buffer.
         * @function decode
         * @memberof SuperProductInstance.FHSSStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SuperProductInstance.FHSSStatus} FHSSStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FHSSStatus.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperProductInstance.FHSSStatus();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FHSSStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SuperProductInstance.FHSSStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SuperProductInstance.FHSSStatus} FHSSStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FHSSStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FHSSStatus message.
         * @function verify
         * @memberof SuperProductInstance.FHSSStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FHSSStatus.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a FHSSStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SuperProductInstance.FHSSStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SuperProductInstance.FHSSStatus} FHSSStatus
         */
        FHSSStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.SuperProductInstance.FHSSStatus)
                return object;
            return new $root.SuperProductInstance.FHSSStatus();
        };

        /**
         * Creates a plain object from a FHSSStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SuperProductInstance.FHSSStatus
         * @static
         * @param {SuperProductInstance.FHSSStatus} message FHSSStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FHSSStatus.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this FHSSStatus to JSON.
         * @function toJSON
         * @memberof SuperProductInstance.FHSSStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FHSSStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Enum enum.
         * @name SuperProductInstance.FHSSStatus.Enum
         * @enum {string}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} NOT_SPECIFIED=1 NOT_SPECIFIED value
         * @property {number} OPTED_IN=2 OPTED_IN value
         * @property {number} OPTED_OUT=3 OPTED_OUT value
         */
        FHSSStatus.Enum = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "NOT_SPECIFIED"] = 1;
            values[valuesById[2] = "OPTED_IN"] = 2;
            values[valuesById[3] = "OPTED_OUT"] = 3;
            return values;
        })();

        return FHSSStatus;
    })();

    return SuperProductInstance;
})();

export const SuperProductInstanceHistory = $root.SuperProductInstanceHistory = (() => {

    /**
     * Properties of a SuperProductInstanceHistory.
     * @exports ISuperProductInstanceHistory
     * @interface ISuperProductInstanceHistory
     * @property {Array.<SuperProductInstanceHistory.IRecord>|null} [records] SuperProductInstanceHistory records
     */

    /**
     * Constructs a new SuperProductInstanceHistory.
     * @exports SuperProductInstanceHistory
     * @classdesc Represents a SuperProductInstanceHistory.
     * @implements ISuperProductInstanceHistory
     * @constructor
     * @param {ISuperProductInstanceHistory=} [properties] Properties to set
     */
    function SuperProductInstanceHistory(properties) {
        this.records = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuperProductInstanceHistory records.
     * @member {Array.<SuperProductInstanceHistory.IRecord>} records
     * @memberof SuperProductInstanceHistory
     * @instance
     */
    SuperProductInstanceHistory.prototype.records = $util.emptyArray;

    /**
     * Creates a new SuperProductInstanceHistory instance using the specified properties.
     * @function create
     * @memberof SuperProductInstanceHistory
     * @static
     * @param {ISuperProductInstanceHistory=} [properties] Properties to set
     * @returns {SuperProductInstanceHistory} SuperProductInstanceHistory instance
     */
    SuperProductInstanceHistory.create = function create(properties) {
        return new SuperProductInstanceHistory(properties);
    };

    /**
     * Encodes the specified SuperProductInstanceHistory message. Does not implicitly {@link SuperProductInstanceHistory.verify|verify} messages.
     * @function encode
     * @memberof SuperProductInstanceHistory
     * @static
     * @param {ISuperProductInstanceHistory} message SuperProductInstanceHistory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperProductInstanceHistory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.records != null && message.records.length)
            for (let i = 0; i < message.records.length; ++i)
                $root.SuperProductInstanceHistory.Record.encode(message.records[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SuperProductInstanceHistory message, length delimited. Does not implicitly {@link SuperProductInstanceHistory.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuperProductInstanceHistory
     * @static
     * @param {ISuperProductInstanceHistory} message SuperProductInstanceHistory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperProductInstanceHistory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuperProductInstanceHistory message from the specified reader or buffer.
     * @function decode
     * @memberof SuperProductInstanceHistory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuperProductInstanceHistory} SuperProductInstanceHistory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperProductInstanceHistory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperProductInstanceHistory();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.records && message.records.length))
                    message.records = [];
                message.records.push($root.SuperProductInstanceHistory.Record.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuperProductInstanceHistory message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuperProductInstanceHistory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuperProductInstanceHistory} SuperProductInstanceHistory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperProductInstanceHistory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuperProductInstanceHistory message.
     * @function verify
     * @memberof SuperProductInstanceHistory
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuperProductInstanceHistory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.records != null && message.hasOwnProperty("records")) {
            if (!Array.isArray(message.records))
                return "records: array expected";
            for (let i = 0; i < message.records.length; ++i) {
                let error = $root.SuperProductInstanceHistory.Record.verify(message.records[i]);
                if (error)
                    return "records." + error;
            }
        }
        return null;
    };

    /**
     * Creates a SuperProductInstanceHistory message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuperProductInstanceHistory
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuperProductInstanceHistory} SuperProductInstanceHistory
     */
    SuperProductInstanceHistory.fromObject = function fromObject(object) {
        if (object instanceof $root.SuperProductInstanceHistory)
            return object;
        let message = new $root.SuperProductInstanceHistory();
        if (object.records) {
            if (!Array.isArray(object.records))
                throw TypeError(".SuperProductInstanceHistory.records: array expected");
            message.records = [];
            for (let i = 0; i < object.records.length; ++i) {
                if (typeof object.records[i] !== "object")
                    throw TypeError(".SuperProductInstanceHistory.records: object expected");
                message.records[i] = $root.SuperProductInstanceHistory.Record.fromObject(object.records[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SuperProductInstanceHistory message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuperProductInstanceHistory
     * @static
     * @param {SuperProductInstanceHistory} message SuperProductInstanceHistory
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuperProductInstanceHistory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.records = [];
        if (message.records && message.records.length) {
            object.records = [];
            for (let j = 0; j < message.records.length; ++j)
                object.records[j] = $root.SuperProductInstanceHistory.Record.toObject(message.records[j], options);
        }
        return object;
    };

    /**
     * Converts this SuperProductInstanceHistory to JSON.
     * @function toJSON
     * @memberof SuperProductInstanceHistory
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuperProductInstanceHistory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SuperProductInstanceHistory.Record = (function() {

        /**
         * Properties of a Record.
         * @memberof SuperProductInstanceHistory
         * @interface IRecord
         * @property {ISuperProductInstance|null} [instance] Record instance
         * @property {google.protobuf.ITimestamp|null} [created_at] Record created_at
         */

        /**
         * Constructs a new Record.
         * @memberof SuperProductInstanceHistory
         * @classdesc Represents a Record.
         * @implements IRecord
         * @constructor
         * @param {SuperProductInstanceHistory.IRecord=} [properties] Properties to set
         */
        function Record(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Record instance.
         * @member {ISuperProductInstance|null|undefined} instance
         * @memberof SuperProductInstanceHistory.Record
         * @instance
         */
        Record.prototype.instance = null;

        /**
         * Record created_at.
         * @member {google.protobuf.ITimestamp|null|undefined} created_at
         * @memberof SuperProductInstanceHistory.Record
         * @instance
         */
        Record.prototype.created_at = null;

        /**
         * Creates a new Record instance using the specified properties.
         * @function create
         * @memberof SuperProductInstanceHistory.Record
         * @static
         * @param {SuperProductInstanceHistory.IRecord=} [properties] Properties to set
         * @returns {SuperProductInstanceHistory.Record} Record instance
         */
        Record.create = function create(properties) {
            return new Record(properties);
        };

        /**
         * Encodes the specified Record message. Does not implicitly {@link SuperProductInstanceHistory.Record.verify|verify} messages.
         * @function encode
         * @memberof SuperProductInstanceHistory.Record
         * @static
         * @param {SuperProductInstanceHistory.IRecord} message Record message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Record.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.instance != null && message.hasOwnProperty("instance"))
                $root.SuperProductInstance.encode(message.instance, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                $root.google.protobuf.Timestamp.encode(message.created_at, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Record message, length delimited. Does not implicitly {@link SuperProductInstanceHistory.Record.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SuperProductInstanceHistory.Record
         * @static
         * @param {SuperProductInstanceHistory.IRecord} message Record message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Record.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Record message from the specified reader or buffer.
         * @function decode
         * @memberof SuperProductInstanceHistory.Record
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SuperProductInstanceHistory.Record} Record
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Record.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperProductInstanceHistory.Record();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.instance = $root.SuperProductInstance.decode(reader, reader.uint32());
                    break;
                case 98:
                    message.created_at = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Record message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SuperProductInstanceHistory.Record
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SuperProductInstanceHistory.Record} Record
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Record.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Record message.
         * @function verify
         * @memberof SuperProductInstanceHistory.Record
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Record.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.instance != null && message.hasOwnProperty("instance")) {
                let error = $root.SuperProductInstance.verify(message.instance);
                if (error)
                    return "instance." + error;
            }
            if (message.created_at != null && message.hasOwnProperty("created_at")) {
                let error = $root.google.protobuf.Timestamp.verify(message.created_at);
                if (error)
                    return "created_at." + error;
            }
            return null;
        };

        /**
         * Creates a Record message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SuperProductInstanceHistory.Record
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SuperProductInstanceHistory.Record} Record
         */
        Record.fromObject = function fromObject(object) {
            if (object instanceof $root.SuperProductInstanceHistory.Record)
                return object;
            let message = new $root.SuperProductInstanceHistory.Record();
            if (object.instance != null) {
                if (typeof object.instance !== "object")
                    throw TypeError(".SuperProductInstanceHistory.Record.instance: object expected");
                message.instance = $root.SuperProductInstance.fromObject(object.instance);
            }
            if (object.created_at != null) {
                if (typeof object.created_at !== "object")
                    throw TypeError(".SuperProductInstanceHistory.Record.created_at: object expected");
                message.created_at = $root.google.protobuf.Timestamp.fromObject(object.created_at);
            }
            return message;
        };

        /**
         * Creates a plain object from a Record message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SuperProductInstanceHistory.Record
         * @static
         * @param {SuperProductInstanceHistory.Record} message Record
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Record.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.instance = null;
                object.created_at = null;
            }
            if (message.instance != null && message.hasOwnProperty("instance"))
                object.instance = $root.SuperProductInstance.toObject(message.instance, options);
            if (message.created_at != null && message.hasOwnProperty("created_at"))
                object.created_at = $root.google.protobuf.Timestamp.toObject(message.created_at, options);
            return object;
        };

        /**
         * Converts this Record to JSON.
         * @function toJSON
         * @memberof SuperProductInstanceHistory.Record
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Record.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Record;
    })();

    return SuperProductInstanceHistory;
})();

export const SuperPortfolioCompany = $root.SuperPortfolioCompany = (() => {

    /**
     * Properties of a SuperPortfolioCompany.
     * @exports ISuperPortfolioCompany
     * @interface ISuperPortfolioCompany
     * @property {string|null} [country] SuperPortfolioCompany country
     * @property {string|null} [name] SuperPortfolioCompany name
     * @property {string|null} [sector] SuperPortfolioCompany sector
     * @property {string|null} [allocation] SuperPortfolioCompany allocation
     */

    /**
     * Constructs a new SuperPortfolioCompany.
     * @exports SuperPortfolioCompany
     * @classdesc Represents a SuperPortfolioCompany.
     * @implements ISuperPortfolioCompany
     * @constructor
     * @param {ISuperPortfolioCompany=} [properties] Properties to set
     */
    function SuperPortfolioCompany(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuperPortfolioCompany country.
     * @member {string} country
     * @memberof SuperPortfolioCompany
     * @instance
     */
    SuperPortfolioCompany.prototype.country = "";

    /**
     * SuperPortfolioCompany name.
     * @member {string} name
     * @memberof SuperPortfolioCompany
     * @instance
     */
    SuperPortfolioCompany.prototype.name = "";

    /**
     * SuperPortfolioCompany sector.
     * @member {string} sector
     * @memberof SuperPortfolioCompany
     * @instance
     */
    SuperPortfolioCompany.prototype.sector = "";

    /**
     * SuperPortfolioCompany allocation.
     * @member {string} allocation
     * @memberof SuperPortfolioCompany
     * @instance
     */
    SuperPortfolioCompany.prototype.allocation = "";

    /**
     * Creates a new SuperPortfolioCompany instance using the specified properties.
     * @function create
     * @memberof SuperPortfolioCompany
     * @static
     * @param {ISuperPortfolioCompany=} [properties] Properties to set
     * @returns {SuperPortfolioCompany} SuperPortfolioCompany instance
     */
    SuperPortfolioCompany.create = function create(properties) {
        return new SuperPortfolioCompany(properties);
    };

    /**
     * Encodes the specified SuperPortfolioCompany message. Does not implicitly {@link SuperPortfolioCompany.verify|verify} messages.
     * @function encode
     * @memberof SuperPortfolioCompany
     * @static
     * @param {ISuperPortfolioCompany} message SuperPortfolioCompany message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperPortfolioCompany.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.country != null && message.hasOwnProperty("country"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.country);
        if (message.name != null && message.hasOwnProperty("name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
        if (message.sector != null && message.hasOwnProperty("sector"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.sector);
        if (message.allocation != null && message.hasOwnProperty("allocation"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.allocation);
        return writer;
    };

    /**
     * Encodes the specified SuperPortfolioCompany message, length delimited. Does not implicitly {@link SuperPortfolioCompany.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuperPortfolioCompany
     * @static
     * @param {ISuperPortfolioCompany} message SuperPortfolioCompany message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperPortfolioCompany.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuperPortfolioCompany message from the specified reader or buffer.
     * @function decode
     * @memberof SuperPortfolioCompany
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuperPortfolioCompany} SuperPortfolioCompany
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperPortfolioCompany.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperPortfolioCompany();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.country = reader.string();
                break;
            case 2:
                message.name = reader.string();
                break;
            case 3:
                message.sector = reader.string();
                break;
            case 4:
                message.allocation = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuperPortfolioCompany message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuperPortfolioCompany
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuperPortfolioCompany} SuperPortfolioCompany
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperPortfolioCompany.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuperPortfolioCompany message.
     * @function verify
     * @memberof SuperPortfolioCompany
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuperPortfolioCompany.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.country != null && message.hasOwnProperty("country"))
            if (!$util.isString(message.country))
                return "country: string expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.sector != null && message.hasOwnProperty("sector"))
            if (!$util.isString(message.sector))
                return "sector: string expected";
        if (message.allocation != null && message.hasOwnProperty("allocation"))
            if (!$util.isString(message.allocation))
                return "allocation: string expected";
        return null;
    };

    /**
     * Creates a SuperPortfolioCompany message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuperPortfolioCompany
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuperPortfolioCompany} SuperPortfolioCompany
     */
    SuperPortfolioCompany.fromObject = function fromObject(object) {
        if (object instanceof $root.SuperPortfolioCompany)
            return object;
        let message = new $root.SuperPortfolioCompany();
        if (object.country != null)
            message.country = String(object.country);
        if (object.name != null)
            message.name = String(object.name);
        if (object.sector != null)
            message.sector = String(object.sector);
        if (object.allocation != null)
            message.allocation = String(object.allocation);
        return message;
    };

    /**
     * Creates a plain object from a SuperPortfolioCompany message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuperPortfolioCompany
     * @static
     * @param {SuperPortfolioCompany} message SuperPortfolioCompany
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuperPortfolioCompany.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.country = "";
            object.name = "";
            object.sector = "";
            object.allocation = "";
        }
        if (message.country != null && message.hasOwnProperty("country"))
            object.country = message.country;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
        if (message.allocation != null && message.hasOwnProperty("allocation"))
            object.allocation = message.allocation;
        return object;
    };

    /**
     * Converts this SuperPortfolioCompany to JSON.
     * @function toJSON
     * @memberof SuperPortfolioCompany
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuperPortfolioCompany.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuperPortfolioCompany;
})();

export const SuperAllocation = $root.SuperAllocation = (() => {

    /**
     * Properties of a SuperAllocation.
     * @exports ISuperAllocation
     * @interface ISuperAllocation
     * @property {string|null} [name] SuperAllocation name
     * @property {string|null} [percentage] SuperAllocation percentage
     */

    /**
     * Constructs a new SuperAllocation.
     * @exports SuperAllocation
     * @classdesc Represents a SuperAllocation.
     * @implements ISuperAllocation
     * @constructor
     * @param {ISuperAllocation=} [properties] Properties to set
     */
    function SuperAllocation(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SuperAllocation name.
     * @member {string} name
     * @memberof SuperAllocation
     * @instance
     */
    SuperAllocation.prototype.name = "";

    /**
     * SuperAllocation percentage.
     * @member {string} percentage
     * @memberof SuperAllocation
     * @instance
     */
    SuperAllocation.prototype.percentage = "";

    /**
     * Creates a new SuperAllocation instance using the specified properties.
     * @function create
     * @memberof SuperAllocation
     * @static
     * @param {ISuperAllocation=} [properties] Properties to set
     * @returns {SuperAllocation} SuperAllocation instance
     */
    SuperAllocation.create = function create(properties) {
        return new SuperAllocation(properties);
    };

    /**
     * Encodes the specified SuperAllocation message. Does not implicitly {@link SuperAllocation.verify|verify} messages.
     * @function encode
     * @memberof SuperAllocation
     * @static
     * @param {ISuperAllocation} message SuperAllocation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperAllocation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.name != null && message.hasOwnProperty("name"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
        if (message.percentage != null && message.hasOwnProperty("percentage"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.percentage);
        return writer;
    };

    /**
     * Encodes the specified SuperAllocation message, length delimited. Does not implicitly {@link SuperAllocation.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SuperAllocation
     * @static
     * @param {ISuperAllocation} message SuperAllocation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SuperAllocation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SuperAllocation message from the specified reader or buffer.
     * @function decode
     * @memberof SuperAllocation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SuperAllocation} SuperAllocation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperAllocation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuperAllocation();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.name = reader.string();
                break;
            case 2:
                message.percentage = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SuperAllocation message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SuperAllocation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SuperAllocation} SuperAllocation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SuperAllocation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SuperAllocation message.
     * @function verify
     * @memberof SuperAllocation
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SuperAllocation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.percentage != null && message.hasOwnProperty("percentage"))
            if (!$util.isString(message.percentage))
                return "percentage: string expected";
        return null;
    };

    /**
     * Creates a SuperAllocation message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SuperAllocation
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SuperAllocation} SuperAllocation
     */
    SuperAllocation.fromObject = function fromObject(object) {
        if (object instanceof $root.SuperAllocation)
            return object;
        let message = new $root.SuperAllocation();
        if (object.name != null)
            message.name = String(object.name);
        if (object.percentage != null)
            message.percentage = String(object.percentage);
        return message;
    };

    /**
     * Creates a plain object from a SuperAllocation message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SuperAllocation
     * @static
     * @param {SuperAllocation} message SuperAllocation
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SuperAllocation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.name = "";
            object.percentage = "";
        }
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.percentage != null && message.hasOwnProperty("percentage"))
            object.percentage = message.percentage;
        return object;
    };

    /**
     * Converts this SuperAllocation to JSON.
     * @function toJSON
     * @memberof SuperAllocation
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SuperAllocation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuperAllocation;
})();

export const ContactMatches = $root.ContactMatches = (() => {

    /**
     * Properties of a ContactMatches.
     * @exports IContactMatches
     * @interface IContactMatches
     * @property {boolean|null} [first_name] ContactMatches first_name
     * @property {boolean|null} [last_name] ContactMatches last_name
     * @property {boolean|null} [date_of_birth] ContactMatches date_of_birth
     * @property {boolean|null} [email_address] ContactMatches email_address
     * @property {boolean|null} [phone_number] ContactMatches phone_number
     * @property {boolean|null} [address] ContactMatches address
     */

    /**
     * Constructs a new ContactMatches.
     * @exports ContactMatches
     * @classdesc Represents a ContactMatches.
     * @implements IContactMatches
     * @constructor
     * @param {IContactMatches=} [properties] Properties to set
     */
    function ContactMatches(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContactMatches first_name.
     * @member {boolean} first_name
     * @memberof ContactMatches
     * @instance
     */
    ContactMatches.prototype.first_name = false;

    /**
     * ContactMatches last_name.
     * @member {boolean} last_name
     * @memberof ContactMatches
     * @instance
     */
    ContactMatches.prototype.last_name = false;

    /**
     * ContactMatches date_of_birth.
     * @member {boolean} date_of_birth
     * @memberof ContactMatches
     * @instance
     */
    ContactMatches.prototype.date_of_birth = false;

    /**
     * ContactMatches email_address.
     * @member {boolean} email_address
     * @memberof ContactMatches
     * @instance
     */
    ContactMatches.prototype.email_address = false;

    /**
     * ContactMatches phone_number.
     * @member {boolean} phone_number
     * @memberof ContactMatches
     * @instance
     */
    ContactMatches.prototype.phone_number = false;

    /**
     * ContactMatches address.
     * @member {boolean} address
     * @memberof ContactMatches
     * @instance
     */
    ContactMatches.prototype.address = false;

    /**
     * Creates a new ContactMatches instance using the specified properties.
     * @function create
     * @memberof ContactMatches
     * @static
     * @param {IContactMatches=} [properties] Properties to set
     * @returns {ContactMatches} ContactMatches instance
     */
    ContactMatches.create = function create(properties) {
        return new ContactMatches(properties);
    };

    /**
     * Encodes the specified ContactMatches message. Does not implicitly {@link ContactMatches.verify|verify} messages.
     * @function encode
     * @memberof ContactMatches
     * @static
     * @param {IContactMatches} message ContactMatches message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContactMatches.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.first_name);
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.last_name);
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.date_of_birth);
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.email_address);
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.phone_number);
        if (message.address != null && message.hasOwnProperty("address"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.address);
        return writer;
    };

    /**
     * Encodes the specified ContactMatches message, length delimited. Does not implicitly {@link ContactMatches.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ContactMatches
     * @static
     * @param {IContactMatches} message ContactMatches message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContactMatches.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ContactMatches message from the specified reader or buffer.
     * @function decode
     * @memberof ContactMatches
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContactMatches} ContactMatches
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContactMatches.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ContactMatches();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.first_name = reader.bool();
                break;
            case 2:
                message.last_name = reader.bool();
                break;
            case 3:
                message.date_of_birth = reader.bool();
                break;
            case 4:
                message.email_address = reader.bool();
                break;
            case 5:
                message.phone_number = reader.bool();
                break;
            case 6:
                message.address = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ContactMatches message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ContactMatches
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ContactMatches} ContactMatches
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContactMatches.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ContactMatches message.
     * @function verify
     * @memberof ContactMatches
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ContactMatches.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            if (typeof message.first_name !== "boolean")
                return "first_name: boolean expected";
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            if (typeof message.last_name !== "boolean")
                return "last_name: boolean expected";
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            if (typeof message.date_of_birth !== "boolean")
                return "date_of_birth: boolean expected";
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            if (typeof message.email_address !== "boolean")
                return "email_address: boolean expected";
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            if (typeof message.phone_number !== "boolean")
                return "phone_number: boolean expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (typeof message.address !== "boolean")
                return "address: boolean expected";
        return null;
    };

    /**
     * Creates a ContactMatches message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ContactMatches
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ContactMatches} ContactMatches
     */
    ContactMatches.fromObject = function fromObject(object) {
        if (object instanceof $root.ContactMatches)
            return object;
        let message = new $root.ContactMatches();
        if (object.first_name != null)
            message.first_name = Boolean(object.first_name);
        if (object.last_name != null)
            message.last_name = Boolean(object.last_name);
        if (object.date_of_birth != null)
            message.date_of_birth = Boolean(object.date_of_birth);
        if (object.email_address != null)
            message.email_address = Boolean(object.email_address);
        if (object.phone_number != null)
            message.phone_number = Boolean(object.phone_number);
        if (object.address != null)
            message.address = Boolean(object.address);
        return message;
    };

    /**
     * Creates a plain object from a ContactMatches message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ContactMatches
     * @static
     * @param {ContactMatches} message ContactMatches
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContactMatches.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.first_name = false;
            object.last_name = false;
            object.date_of_birth = false;
            object.email_address = false;
            object.phone_number = false;
            object.address = false;
        }
        if (message.first_name != null && message.hasOwnProperty("first_name"))
            object.first_name = message.first_name;
        if (message.last_name != null && message.hasOwnProperty("last_name"))
            object.last_name = message.last_name;
        if (message.date_of_birth != null && message.hasOwnProperty("date_of_birth"))
            object.date_of_birth = message.date_of_birth;
        if (message.email_address != null && message.hasOwnProperty("email_address"))
            object.email_address = message.email_address;
        if (message.phone_number != null && message.hasOwnProperty("phone_number"))
            object.phone_number = message.phone_number;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    /**
     * Converts this ContactMatches to JSON.
     * @function toJSON
     * @memberof ContactMatches
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContactMatches.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ContactMatches;
})();

export const SargonAuth = $root.SargonAuth = (() => {

    /**
     * Properties of a SargonAuth.
     * @exports ISargonAuth
     * @interface ISargonAuth
     * @property {string|null} [access_token] SargonAuth access_token
     */

    /**
     * Constructs a new SargonAuth.
     * @exports SargonAuth
     * @classdesc Represents a SargonAuth.
     * @implements ISargonAuth
     * @constructor
     * @param {ISargonAuth=} [properties] Properties to set
     */
    function SargonAuth(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SargonAuth access_token.
     * @member {string} access_token
     * @memberof SargonAuth
     * @instance
     */
    SargonAuth.prototype.access_token = "";

    /**
     * Creates a new SargonAuth instance using the specified properties.
     * @function create
     * @memberof SargonAuth
     * @static
     * @param {ISargonAuth=} [properties] Properties to set
     * @returns {SargonAuth} SargonAuth instance
     */
    SargonAuth.create = function create(properties) {
        return new SargonAuth(properties);
    };

    /**
     * Encodes the specified SargonAuth message. Does not implicitly {@link SargonAuth.verify|verify} messages.
     * @function encode
     * @memberof SargonAuth
     * @static
     * @param {ISargonAuth} message SargonAuth message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SargonAuth.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.access_token != null && message.hasOwnProperty("access_token"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.access_token);
        return writer;
    };

    /**
     * Encodes the specified SargonAuth message, length delimited. Does not implicitly {@link SargonAuth.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SargonAuth
     * @static
     * @param {ISargonAuth} message SargonAuth message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SargonAuth.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SargonAuth message from the specified reader or buffer.
     * @function decode
     * @memberof SargonAuth
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SargonAuth} SargonAuth
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SargonAuth.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SargonAuth();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.access_token = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SargonAuth message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SargonAuth
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SargonAuth} SargonAuth
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SargonAuth.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SargonAuth message.
     * @function verify
     * @memberof SargonAuth
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SargonAuth.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.access_token != null && message.hasOwnProperty("access_token"))
            if (!$util.isString(message.access_token))
                return "access_token: string expected";
        return null;
    };

    /**
     * Creates a SargonAuth message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SargonAuth
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SargonAuth} SargonAuth
     */
    SargonAuth.fromObject = function fromObject(object) {
        if (object instanceof $root.SargonAuth)
            return object;
        let message = new $root.SargonAuth();
        if (object.access_token != null)
            message.access_token = String(object.access_token);
        return message;
    };

    /**
     * Creates a plain object from a SargonAuth message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SargonAuth
     * @static
     * @param {SargonAuth} message SargonAuth
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SargonAuth.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.access_token = "";
        if (message.access_token != null && message.hasOwnProperty("access_token"))
            object.access_token = message.access_token;
        return object;
    };

    /**
     * Converts this SargonAuth to JSON.
     * @function toJSON
     * @memberof SargonAuth
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SargonAuth.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SargonAuth;
})();

export { $root as default };
